/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(431);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(188);


/***/ },
/* 2 */
/***/ function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule reactProdInvariant
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  warning = function warning(condition, format) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // --- Welcome to debugging React ---
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch (x) {}
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentTree
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentFlags = __webpack_require__(192);
	
	var invariant = __webpack_require__(3);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID == null) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (childNode.nodeType === 1 && childNode.getAttribute(ATTR_NAME) === String(childID) || childNode.nodeType === 8 && childNode.nodeValue === ' react-text: ' + childID + ' ' || childNode.nodeType === 8 && childNode.nodeValue === ' react-empty: ' + childID + ' ') {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(269);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(399);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(33);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _createHelper = __webpack_require__(164);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = (0, _shouldUpdate2.default)(function (props, nextProps) {
	  return !(0, _shallowEqual2.default)(props, nextProps);
	});
	
	exports.default = (0, _createHelper2.default)(pure, 'pure', true, true);

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(494);


/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 14 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 16 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactElement
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactCurrentOwner = __webpack_require__(37);
	
	var warning = __webpack_require__(5);
	var canDefineProperty = __webpack_require__(205);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.createElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	
	    // Create dummy `key` and `ref` property to `props` to warn users against its use
	    var warnAboutAccessingKey = function () {
	      if (!specialPropKeyWarningShown) {
	        specialPropKeyWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingKey.isReactWarning = true;
	
	    var warnAboutAccessingRef = function () {
	      if (!specialPropRefWarningShown) {
	        specialPropRefWarningShown = true;
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	      }
	      return undefined;
	    };
	    warnAboutAccessingRef.isReactWarning = true;
	
	    if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	      if (!props.hasOwnProperty('key')) {
	        Object.defineProperty(props, 'key', {
	          get: warnAboutAccessingKey,
	          configurable: true
	        });
	      }
	      if (!props.hasOwnProperty('ref')) {
	        Object.defineProperty(props, 'ref', {
	          get: warnAboutAccessingRef,
	          configurable: true
	        });
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(
	      /* eslint-disable no-proto */
	      config.__proto__ == null || config.__proto__ === Object.prototype,
	      /* eslint-enable no-proto */
	      'React.cloneElement(...): Expected props argument to be a plain object. ' + 'Properties defined in its prototype chain will be ignored.') : void 0;
	    }
	
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	ReactElement.REACT_ELEMENT_TYPE = REACT_ELEMENT_TYPE;
	
	module.exports = ReactElement;

/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var checkGlobal = __webpack_require__(334);
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 20 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.userActions = exports.videoActions = exports.roomActions = undefined;
	
	var _room = __webpack_require__(424);
	
	var _roomActions = _interopRequireWildcard(_room);
	
	var _video = __webpack_require__(168);
	
	var _videoActions = _interopRequireWildcard(_video);
	
	var _user = __webpack_require__(425);
	
	var _userActions = _interopRequireWildcard(_user);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.roomActions = _roomActions;
	exports.videoActions = _videoActions;
	exports.userActions = _userActions;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventConstants
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(84);
	
	var PropagationPhases = keyMirror({ bubbled: null, captured: null });
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = keyMirror({
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	});
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes,
	  PropagationPhases: PropagationPhases
	};
	
	module.exports = EventConstants;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdates
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(186);
	var PooledClass = __webpack_require__(30);
	var ReactFeatureFlags = __webpack_require__(195);
	var ReactReconciler = __webpack_require__(49);
	var Transaction = __webpack_require__(58);
	
	var invariant = __webpack_require__(3);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.Mixin.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.props === component._renderedComponent._currentElement) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  !batchingStrategy.isBatchingUpdates ?  false ? invariant(false, 'ReactUpdates.asap: Can\'t enqueue an asap callback in a context whereupdates are not being batched.') : _prodInvariant('125') : void 0;
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(255);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticEvent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(30);
	
	var emptyFunction = __webpack_require__(16);
	var warning = __webpack_require__(5);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	    } else {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	    } else {
	      event.cancelBubble = true;
	    }
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), 'This synthetic event is reused for performance reasons. If you\'re ' + 'seeing this, you\'re adding a new property in the synthetic event object. ' + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, 'This synthetic event is reused for performance reasons. If you\'re seeing this, ' + 'you\'re %s `%s` on a released/nullified synthetic event. %s. ' + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 26 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (prefixedValue, value, keepUnprefixed) {
	  return keepUnprefixed ? [prefixedValue, value] : prefixedValue;
	};
	
	module.exports = exports["default"];

/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var horizontal = _react.PropTypes.oneOf(['left', 'middle', 'right']);
	var vertical = _react.PropTypes.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _react.PropTypes.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _react.PropTypes.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _react.PropTypes.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number]),
	
	  zDepth: _react.PropTypes.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule PooledClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var fiveArgumentPooler = function (a1, a2, a3, a4, a5) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4, a5);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4, a5);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler,
	  fiveArgumentPooler: fiveArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ },
/* 31 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var checkGlobal = __webpack_require__(577);
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = checkGlobal(typeof global == 'object' && global);
	
	/** Detect free variable `self`. */
	var freeSelf = checkGlobal(typeof self == 'object' && self);
	
	/** Detect `this` as the global object. */
	var thisGlobal = checkGlobal(typeof this == 'object' && this);
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
	module.exports = root;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(398);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ },
/* 34 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type;
	  var values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length <= 1 || arguments[1] === undefined ? 0.15 : arguments[1];
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _react = __webpack_require__(1);
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var arrayOf = _react.PropTypes.arrayOf;
	var oneOfType = _react.PropTypes.oneOfType;
	var element = _react.PropTypes.element;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = shape({
	  listen: func.isRequired,
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired
	});
	
	var component = exports.component = oneOfType([func, string]);
	var components = exports.components = oneOfType([component, object]);
	var route = exports.route = oneOfType([object, element]);
	var routes = exports.routes = oneOfType([route, arrayOf(route)]);

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.extractPath = extractPath;
	exports.parsePath = parsePath;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function extractPath(string) {
	  var match = string.match(/^https?:\/\/[^\/]*/);
	
	  if (match == null) return string;
	
	  return string.substring(match[0].length);
	}
	
	function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? _warning2['default'](path === pathname, 'A path must be pathname + search + hash only, not a fully qualified URL like "%s"', path) : undefined;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	}

/***/ },
/* 37 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCurrentOwner
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	
	var ReactCurrentOwner = {
	
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(227);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(623);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(622);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(621);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(226);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(228);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2["default"])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2["default"];
	exports.combineReducers = _combineReducers2["default"];
	exports.bindActionCreators = _bindActionCreators2["default"];
	exports.applyMiddleware = _applyMiddleware2["default"];
	exports.compose = _compose2["default"];

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(327),
	    getValue = __webpack_require__(348);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 40 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(436);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connect = __webpack_require__(437);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	exports.Provider = _Provider2["default"];
	exports.connect = _connect2["default"];

/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = {};
	
	function compilePattern(pattern) {
	  if (!(pattern in CompiledPatternsCache)) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern);
	
	  var regexpSource = _compilePattern2.regexpSource;
	  var paramNames = _compilePattern2.paramNames;
	  var tokens = _compilePattern2.tokens;
	
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames;
	  var paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern);
	
	  var tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0;
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenCount += 1;
	    } else if (token === ')') {
	      parenCount -= 1;
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURIComponent(paramValue);
	    } else {
	      pathname += token;
	    }
	  }
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 43 */
/***/ function(module, exports) {

	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	'use strict';
	
	exports.__esModule = true;
	var PUSH = 'PUSH';
	
	exports.PUSH = PUSH;
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = 'REPLACE';
	
	exports.REPLACE = REPLACE;
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = 'POP';
	
	exports.POP = POP;
	exports['default'] = {
	  PUSH: PUSH,
	  REPLACE: REPLACE,
	  POP: POP
	};

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMLazyTree
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(113);
	var setInnerHTML = __webpack_require__(82);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(124);
	var setTextContent = __webpack_require__(213);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMProperty
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(3);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? {} : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginHub
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var EventPluginRegistry = __webpack_require__(114);
	var EventPluginUtils = __webpack_require__(78);
	var ReactErrorUtils = __webpack_require__(119);
	
	var accumulateInto = __webpack_require__(204);
	var forEachAccumulated = __webpack_require__(207);
	var invariant = __webpack_require__(3);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][id]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[inst._rootNodeID] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    var bankForRegistrationName = listenerBank[registrationName];
	    return bankForRegistrationName && bankForRegistrationName[inst._rootNodeID];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      delete bankForRegistrationName[inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][inst._rootNodeID]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][inst._rootNodeID];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPropagators
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(22);
	var EventPluginHub = __webpack_require__(46);
	var EventPluginUtils = __webpack_require__(78);
	
	var accumulateInto = __webpack_require__(204);
	var forEachAccumulated = __webpack_require__(207);
	var warning = __webpack_require__(5);
	
	var PropagationPhases = EventConstants.PropagationPhases;
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, upwards, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var phase = upwards ? PropagationPhases.bubbled : PropagationPhases.captured;
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 48 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInstanceMap
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconciler
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactRef = __webpack_require__(519);
	var ReactInstrumentation = __webpack_require__(15);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'mountComponent');
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'mountComponent');
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'unmountComponent');
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'receiveComponent');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	      !(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1) ?  false ? invariant(false, 'performUpdateIfNecessary: Unexpected batch number (current %s, pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : _prodInvariant('121', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndReconcilerTimer(internalInstance._debugID, 'performUpdateIfNecessary');
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticUIEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	var getEventTarget = __webpack_require__(127);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(573),
	    getValue = __webpack_require__(584);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _childUtils = __webpack_require__(69);
	
	var _events = __webpack_require__(167);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(53);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(145);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(284);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _deprecatedPropType = __webpack_require__(57);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  _inherits(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(EnhancedButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = { isKeyboardFocused: false }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.props.onClick(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var disabled = _props.disabled;
	      var disableKeyboardFocus = _props.disableKeyboardFocus;
	      var keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.refs.enhancedButton.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.focusTimeout);
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props;
	      var centerRipple = _props2.centerRipple;
	      var children = _props2.children;
	      var disabled = _props2.disabled;
	      var disableFocusRipple = _props2.disableFocusRipple;
	      var disableKeyboardFocus = _props2.disableKeyboardFocus;
	      var disableTouchRipple = _props2.disableTouchRipple;
	      var focusRippleColor = _props2.focusRippleColor;
	      var focusRippleOpacity = _props2.focusRippleOpacity;
	      var touchRippleColor = _props2.touchRippleColor;
	      var touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity
	        },
	        children
	      ) : undefined;
	
	      return (0, _childUtils.createChildFragment)({
	        focusRipple: focusRipple,
	        touchRipple: touchRipple,
	        children: touchRipple ? undefined : children
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var centerRipple = _props3.centerRipple;
	      var children = _props3.children;
	      var containerElement = _props3.containerElement;
	      var disabled = _props3.disabled;
	      var disableFocusRipple = _props3.disableFocusRipple;
	      var disableKeyboardFocus = _props3.disableKeyboardFocus;
	      var disableTouchRipple = _props3.disableTouchRipple;
	      var focusRippleColor = _props3.focusRippleColor;
	      var focusRippleOpacity = _props3.focusRippleOpacity;
	      var href = _props3.href;
	      var keyboardFocused = _props3.keyboardFocused;
	      var linkButton = _props3.linkButton;
	      var touchRippleColor = _props3.touchRippleColor;
	      var touchRippleOpacity = _props3.touchRippleOpacity;
	      var onBlur = _props3.onBlur;
	      var onClick = _props3.onClick;
	      var onFocus = _props3.onFocus;
	      var onKeyUp = _props3.onKeyUp;
	      var onKeyDown = _props3.onKeyDown;
	      var onKeyboardFocus = _props3.onKeyboardFocus;
	      var onTouchTap = _props3.onTouchTap;
	      var style = _props3.style;
	      var tabIndex = _props3.tabIndex;
	      var type = _props3.type;
	
	      var other = _objectWithoutProperties(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'linkButton', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'onTouchTap', 'style', 'tabIndex', 'type']);
	
	      var _context$muiTheme = this.context.muiTheme;
	      var prepareStyles = _context$muiTheme.prepareStyles;
	      var enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        /**
	         * This is needed so that ripples do not bleed
	         * past border radius.
	         * See: http://stackoverflow.com/questions/17298739/
	         * css-overflow-hidden-not-working-in-chrome-when-parent-has-border-radius-and-chil
	         */
	        transform: disableTouchRipple && disableFocusRipple ? null : 'translate3d(0, 0, 0)',
	        verticalAlign: href ? 'middle' : null
	      }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          _extends({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = _extends({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: 'enhancedButton',
	        disabled: disabled,
	        href: href,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onTouchTap: this.handleTouchTap,
	        tabIndex: tabIndex,
	        type: type
	      });
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.propTypes = {
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  containerElement: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.element]),
	  disableFocusRipple: _react.PropTypes.bool,
	  disableKeyboardFocus: _react.PropTypes.bool,
	  disableTouchRipple: _react.PropTypes.bool,
	  disabled: _react.PropTypes.bool,
	  focusRippleColor: _react.PropTypes.string,
	  focusRippleOpacity: _react.PropTypes.number,
	  href: _react.PropTypes.string,
	  keyboardFocused: _react.PropTypes.bool,
	  linkButton: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'LinkButton is no longer required when the `href` property is provided.\n      It will be removed with v0.16.0.'),
	  onBlur: _react.PropTypes.func,
	  onClick: _react.PropTypes.func,
	  onFocus: _react.PropTypes.func,
	  onKeyDown: _react.PropTypes.func,
	  onKeyUp: _react.PropTypes.func,
	  onKeyboardFocus: _react.PropTypes.func,
	  onMouseDown: _react.PropTypes.func,
	  onMouseEnter: _react.PropTypes.func,
	  onMouseLeave: _react.PropTypes.func,
	  onMouseUp: _react.PropTypes.func,
	  onTouchEnd: _react.PropTypes.func,
	  onTouchStart: _react.PropTypes.func,
	  onTouchTap: _react.PropTypes.func,
	  style: _react.PropTypes.object,
	  tabIndex: _react.PropTypes.number,
	  touchRippleColor: _react.PropTypes.string,
	  touchRippleOpacity: _react.PropTypes.number,
	  type: _react.PropTypes.string
	};
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  onTouchTap: function onTouchTap() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = EnhancedButton;

/***/ },
/* 53 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 54 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 55 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ },
/* 56 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(27);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function deprecated(propType, explanation) {
	  return function validate(props, propName, componentName) {
	    if (props[propName] != null) {
	       false ? (0, _warning2.default)(false, '"' + propName + '" property of "' + componentName + '" has been deprecated.\n' + explanation) : void 0;
	    }
	
	    return propType(props, propName, componentName);
	  };
	}

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Transaction
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var Mixin = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = Transaction.OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === Transaction.OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== Transaction.OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	var Transaction = {
	
	  Mixin: Mixin,
	
	  /**
	   * Token to look for to determine if an error occurred.
	   */
	  OBSERVED_ERROR: {}
	
	};
	
	module.exports = Transaction;

/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(245);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ },
/* 60 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	// helper to capitalize strings
	
	exports.default = function (str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	};
	
	module.exports = exports["default"];

/***/ },
/* 61 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// returns a style object with a single concated prefixed value string
	
	exports.default = function (property, value) {
	  var replacer = arguments.length <= 2 || arguments[2] === undefined ? function (prefix, value) {
	    return prefix + value;
	  } : arguments[2];
	  return _defineProperty({}, property, ['-webkit-', '-moz-', ''].map(function (prefix) {
	    return replacer(prefix, value);
	  }));
	};
	
	module.exports = exports['default'];

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(361),
	    listCacheDelete = __webpack_require__(362),
	    listCacheGet = __webpack_require__(363),
	    listCacheHas = __webpack_require__(364),
	    listCacheSet = __webpack_require__(365);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(66);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(358);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(39);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 66 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(523);

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createChildFragment = createChildFragment;
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(392);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createChildFragment(fragments) {
	  var newFragments = {};
	  var validChildrenCount = 0;
	  var firstKey = void 0;
	
	  // Only create non-empty key fragments
	  for (var key in fragments) {
	    var currentChild = fragments[key];
	
	    if (currentChild) {
	      if (validChildrenCount === 0) firstKey = key;
	      newFragments[key] = currentChild;
	      validChildrenCount++;
	    }
	  }
	
	  if (validChildrenCount === 0) return undefined;
	  if (validChildrenCount === 1) return newFragments[firstKey];
	  return (0, _reactAddonsCreateFragment2.default)(newFragments);
	}
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.isValidElement(children) ? _react2.default.Children.map(children, function (child) {
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  }) : children;
	}

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.computeColor = exports.CHAT = exports.TORRENTS_UPDATE = exports.VIDEO_UPDATE = exports.LEAVE_ROOM = exports.JOIN_ROOM = undefined;
	exports.init = init;
	exports.quit = quit;
	exports.getViewersCount = getViewersCount;
	exports.updateViewersCount = updateViewersCount;
	exports.broadcast = broadcast;
	
	var _store = __webpack_require__(105);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _room = __webpack_require__(71);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _actions = __webpack_require__(21);
	
	var _config = __webpack_require__(170);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _colors = __webpack_require__(55);
	
	var colors = _interopRequireWildcard(_colors);
	
	var _realtime = __webpack_require__(237);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var realtime = new _realtime.Realtime(Object.assign({
		noBinary: true
	}, _config2.default.leancloud));
	
	var _client = void 0,
	    _conversation = void 0,
	    _timer = void 0;
	
	var EventMessage = function (_TypedMessage) {
		_inherits(EventMessage, _TypedMessage);
	
		function EventMessage() {
			_classCallCheck(this, EventMessage);
	
			return _possibleConstructorReturn(this, Object.getPrototypeOf(EventMessage).apply(this, arguments));
		}
	
		return EventMessage;
	}(_realtime.TypedMessage);
	var EVENT_MESSAGE_TYPE = 1;
	(0, _realtime.messageType)(EVENT_MESSAGE_TYPE)(EventMessage);
	(0, _realtime.messageField)('event')(EventMessage);
	(0, _realtime.messageField)('data')(EventMessage);
	(0, _realtime.messageField)('user')(EventMessage);
	realtime.register(EventMessage);
	
	function init() {
		return new Promise(function (resolve) {
			if (_client) {
				resolve(_client);
			} else {
				realtime.createIMClient(_store2.default.getState().user.id).then(function (client) {
					client.on('message', onMessage);
					_client = client;
					resolve(client);
				});
			}
		}).then(function (client) {
			var conversationId = _store2.default.getState().room.conversationId;
			if (!conversationId) {
				return client.createConversation({
					name: 'AvTogether',
					transient: true
				}).then(function (conversation) {
					_room2.default.updateRemote({
						conversationId: conversation.id
					});
					return Promise.resolve(conversation);
				});
			} else {
				return client.getConversation(conversationId).then(function (conversation) {
					return conversation.join();
				});
			}
		}).then(function (conversation) {
			if (_timer) {
				clearInterval(_timer);
			}
			_timer = setInterval(updateViewersCount, 5000);
			_conversation = conversation;
			return Promise.resolve(conversation);
		});
	}
	
	function quit() {
		clearInterval(_timer);
		if (!_conversation) {
			return Promise.reject();
		} else {
			var temp = _conversation;
	
			_conversation = null;
			return temp.quit();
		}
	}
	
	var JOIN_ROOM = exports.JOIN_ROOM = 'JOIN_ROOM';
	var LEAVE_ROOM = exports.LEAVE_ROOM = 'LEAVE_ROOM';
	var VIDEO_UPDATE = exports.VIDEO_UPDATE = 'VIDEO_UPDATE';
	var TORRENTS_UPDATE = exports.TORRENTS_UPDATE = 'TORRENTS_UPDATE';
	var CHAT = exports.CHAT = 'CHAT';
	
	function onMessage(message) {
		var data = JSON.parse(message.data);
		var user = JSON.parse(message.user);
	
		console.log(message);
	
		switch (message.event) {
			case VIDEO_UPDATE:
				if (user.id !== _store2.default.getState().user.id) {
					_store2.default.dispatch(_actions.videoActions.setWithoutBroadcast(data));
				}
				break;
			case TORRENTS_UPDATE:
				if (user.id !== _store2.default.getState().user.id) {
					_store2.default.dispatch(_actions.roomActions.setTorrents(data.torrents));
				}
				break;
			case JOIN_ROOM:
				updateViewersCount();
				_store2.default.dispatch(_actions.roomActions.addMessage({
					user: user,
					type: JOIN_ROOM,
					text: ' joined this room'
				}));
				break;
			case LEAVE_ROOM:
				if (user.id !== _store2.default.getState().user.id) {
					updateViewersCount();
					_store2.default.dispatch(_actions.roomActions.addMessage({
						user: user,
						type: LEAVE_ROOM,
						text: ' leaved this room'
					}));
				} else {
					_store2.default.dispatch(_actions.roomActions.clearMessages());
				}
				break;
			case CHAT:
				_store2.default.dispatch(_actions.roomActions.addMessage({
					user: user,
					type: CHAT,
					text: ': ' + data
				}));
				break;
		}
	}
	
	var palette = [];
	Object.keys(colors).forEach(function (color) {
		if (/500$/.test(color)) {
			palette.push(color);
		}
	});
	var colorCount = palette.length;
	var computeColor = exports.computeColor = function computeColor(seed) {
		var seedNum = seed.split('').reduce(function (previous, current) {
			return previous + parseInt(current, 36);
		}, 0);
		return colors[palette[parseInt(seedNum, 36) % colorCount]];
	};
	
	function getViewersCount() {
		if (!_conversation) {
			return Promise.reject();
		} else {
			return _conversation.count();
		}
	}
	
	function updateViewersCount() {
		getViewersCount().then(function (count) {
			return _store2.default.dispatch(_actions.roomActions.setViewersCount(count));
		});
	}
	
	function broadcast(event) {
		var data = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
		if (!_conversation) {
			return Promise.reject();
		} else {
			var message = new EventMessage();
			message.setTransient(true);
			message.event = event;
			message.data = JSON.stringify(data);
			message.user = JSON.stringify(_store2.default.getState().user);
			onMessage(message);
			return _conversation.send(message);
		}
	}
	
	exports.default = { broadcast: broadcast };
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "messages.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _config = __webpack_require__(170);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _store = __webpack_require__(105);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _actions = __webpack_require__(21);
	
	var _messages = __webpack_require__(70);
	
	var Messages = _interopRequireWildcard(_messages);
	
	var _av = __webpack_require__(238);
	
	var _av2 = _interopRequireDefault(_av);
	
	var _webtorrent = __webpack_require__(631);
	
	var _webtorrent2 = _interopRequireDefault(_webtorrent);
	
	var _reactRouter = __webpack_require__(74);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	_av2.default.init(_config2.default.leancloud);
	
	var client = new _webtorrent2.default();
	client.on('error', function (e) {
		console.log(e);
	});
	
	var trackers = _config2.default.torrent && _config2.default.torrent.trackers;
	
	exports.default = { create: create, goto: goto, join: join, leave: leave, seed: seed, addTorrent: addTorrent, loadTorrent: loadTorrent, updateRemote: updateRemote };
	
	
	function create() {
		var RoomObject = _av2.default.Object.extend('Room');
		var room = new RoomObject();
		return room.save({}).then(function (res) {
			goto(res.id);
		});
	}
	
	function goto(id) {
		_reactRouter.browserHistory.push('/room/' + id);
	}
	
	function join(id) {
		var rooms = new _av2.default.Query('Room');
	
		_store2.default.dispatch(_actions.roomActions.setId(id));
		_store2.default.dispatch(_actions.userActions.joinRoom(id));
		return rooms.get(id).then(function (data) {
			console.log('Room info:', data.attributes);
			_store2.default.dispatch(_actions.roomActions.setConversationId(data.attributes.conversationId));
			_store2.default.dispatch(_actions.roomActions.setTorrents(data.attributes.torrents));
			_store2.default.dispatch(_actions.videoActions.set({
				paused: data.attributes.paused,
				currentTime: data.attributes.currentTime
			}));
		}).then(function () {
			return Messages.init();
		}).then(function () {
			return Messages.broadcast(Messages.JOIN_ROOM, _store2.default.getState().user);
		});
	}
	
	function leave() {
		return new Promise(function (resolve) {
			var torrents = _store2.default.getState().room.torrents;
			if (torrents.length > 0) {
				client.remove(torrents[0].id, function () {
					return resolve();
				});
				_store2.default.dispatch(_actions.roomActions.setTorrents([]));
			} else {
				resolve();
			}
		}).then(function () {
			return Messages.broadcast(Messages.LEAVE_ROOM);
		}).then(function () {
			return Messages.quit();
		});
	}
	
	function seed(file) {
		return new Promise(function (resolve) {
			client.seed(file, {
				announce: trackers
			}, function (torrent) {
				resolve(torrent);
			});
		});
	}
	
	function addTorrent(torrent) {
		var prevTorrent = _store2.default.getState().room.torrents[0];
		_store2.default.dispatch(_actions.roomActions.setTorrents([{
			name: torrent.name,
			id: torrent.magnetURI
		}]));
		var torrents = [{
			name: torrent.name,
			id: torrent.magnetURI
		}];
		return new Promise(function (resolve) {
			if (prevTorrent) {
				client.remove(prevTorrent.id, function () {
					return resolve();
				});
			} else {
				resolve();
			}
		}).then(function () {
			return updateRemote({ torrents: torrents });
		}).then(function () {
			return Messages.broadcast(Messages.TORRENTS_UPDATE, { torrents: torrents });
		}).then(function () {
			return Promise.resolve(torrent);
		});
	}
	
	function loadTorrent() {
		_store2.default.dispatch(_actions.videoActions.pushStatus('finding peers...'));
		return new Promise(function (resolve) {
			client.add(_store2.default.getState().room.torrents[0].id, function (torrent) {
				console.log('add torrent: ', torrent.name);
				console.log('peers number: ', torrent.numPeers);
				torrent.on('wire', function (wire, addr) {
					console.log('new peer: ', addr);
					console.log('peers number: ', torrent.numPeers);
				});
				torrent.on('noPeers', function (announceType) {
					console.log(announceType);
				});
				_store2.default.dispatch(_actions.videoActions.pushStatus('peers found.'));
				resolve(torrent);
			});
		});
	}
	
	function updateRemote(state) {
		var roomId = _store2.default.getState().room.id;
		var room = _av2.default.Object.createWithoutData('Room', roomId);
		Object.keys(state).forEach(function (key) {
			console.log('updateRemote { ' + key + ': ' + JSON.stringify(state[key]) + ' }');
			room.set(key, state[key]);
		});
		return room.save();
	}
	
	/**
	 * Watch video states and update server data
	 */
	_store.watcher.watch(['video', 'videoReady'], videoReadyListener);
	
	var videoUpdateTimer = void 0;
	function videoReadyListener(_ref) {
		var videoReady = _ref.currentValue;
	
		var method = videoReady ? 'watch' : 'off';
		_store.watcher[method](['video', 'currentTime'], videoListener);
		_store.watcher[method](['video', 'paused'], videoListener);
		if (videoReady) {
			(function () {
				var latestTime = _store2.default.getState().video.realTime;
				videoUpdateTimer = setInterval(function () {
					var currentTime = _store2.default.getState().video.realTime;
					if (currentTime !== latestTime) {
						latestTime = currentTime;
						updateRemote({ currentTime: currentTime });
					}
				}, 2000);
			})();
		} else {
			clearInterval(videoUpdateTimer);
			videoUpdateTimer = null;
		}
	}
	
	function videoListener(_ref2) {
		var selector = _ref2.selector;
		var currentState = _ref2.currentState;
		var currentValue = _ref2.currentValue;
	
		var stateName = selector[selector.length - 1];
		updateRemote(_defineProperty({}, stateName, currentValue)).then(function () {
			if (!currentState.video.disableBroadcast) {
				Messages.broadcast(Messages.VIDEO_UPDATE, _defineProperty({}, stateName, currentValue));
			}
		});
	}
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "room.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _deprecateObjectProperties = __webpack_require__(73);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _getRouteParams = __webpack_require__(460);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _RouteUtils = __webpack_require__(29);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var array = _React$PropTypes.array;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	
	var RouterContext = _react2.default.createClass({
	  displayName: 'RouterContext',
	
	
	  propTypes: {
	    history: object,
	    router: object.isRequired,
	    location: object.isRequired,
	    routes: array.isRequired,
	    params: object.isRequired,
	    components: array.isRequired,
	    createElement: func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    history: object,
	    location: object.isRequired,
	    router: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    var _props = this.props;
	    var router = _props.router;
	    var history = _props.history;
	    var location = _props.location;
	
	    if (!router) {
	       false ? (0, _routerWarning2.default)(false, '`<RouterContext>` expects a `router` rather than a `history`') : void 0;
	
	      router = _extends({}, history, {
	        setRouteLeaveHook: history.listenBeforeLeavingRoute
	      });
	      delete router.listenBeforeLeavingRoute;
	    }
	
	    if (false) {
	      location = (0, _deprecateObjectProperties2.default)(location, '`context.location` is deprecated, please use a route component\'s `props.location` instead. http://tiny.cc/router-accessinglocation');
	    }
	
	    return { history: history, location: location, router: router };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props2 = this.props;
	    var history = _props2.history;
	    var location = _props2.location;
	    var routes = _props2.routes;
	    var params = _props2.params;
	    var components = _props2.components;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          history: history,
	          location: location,
	          params: params,
	          route: route,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object') {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 73 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.canUseMembrane = undefined;
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseMembrane = exports.canUseMembrane = false;
	
	// No-op by default.
	var deprecateObjectProperties = function deprecateObjectProperties(object) {
	  return object;
	};
	
	if (false) {
	  try {
	    if (Object.defineProperty({}, 'x', {
	      get: function get() {
	        return true;
	      }
	    }).x) {
	      exports.canUseMembrane = canUseMembrane = true;
	    }
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	  if (canUseMembrane) {
	    deprecateObjectProperties = function deprecateObjectProperties(object, message) {
	      // Wrap the deprecated object in a membrane to warn on property access.
	      var membrane = {};
	
	      var _loop = function _loop(prop) {
	        if (!Object.prototype.hasOwnProperty.call(object, prop)) {
	          return 'continue';
	        }
	
	        if (typeof object[prop] === 'function') {
	          // Can't use fat arrow here because of use of arguments below.
	          membrane[prop] = function () {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop].apply(object, arguments);
	          };
	          return 'continue';
	        }
	
	        // These properties are non-enumerable to prevent React dev tools from
	        // seeing them and causing spurious warnings when accessing them. In
	        // principle this could be done with a proxy, but support for the
	        // ownKeys trap on proxies is not universal, even among browsers that
	        // otherwise support proxies.
	        Object.defineProperty(membrane, prop, {
	          get: function get() {
	            process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	            return object[prop];
	          }
	        });
	      };
	
	      for (var prop in object) {
	        var _ret = _loop(prop);
	
	        if (_ret === 'continue') continue;
	      }
	
	      return membrane;
	    };
	  }
	}
	
	exports.default = deprecateObjectProperties;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.PropTypes = exports.RoutingContext = exports.RouterContext = exports.createRoutes = exports.useRoutes = exports.RouteContext = exports.Lifecycle = exports.History = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(29);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes2 = __webpack_require__(107);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes2.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(42);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(453);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(173);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(447);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(466);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(448);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(449);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(174);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(451);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _History2 = __webpack_require__(446);
	
	var _History3 = _interopRequireDefault(_History2);
	
	var _Lifecycle2 = __webpack_require__(450);
	
	var _Lifecycle3 = _interopRequireDefault(_Lifecycle2);
	
	var _RouteContext2 = __webpack_require__(452);
	
	var _RouteContext3 = _interopRequireDefault(_RouteContext2);
	
	var _useRoutes2 = __webpack_require__(465);
	
	var _useRoutes3 = _interopRequireDefault(_useRoutes2);
	
	var _RouterContext2 = __webpack_require__(72);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _RoutingContext2 = __webpack_require__(454);
	
	var _RoutingContext3 = _interopRequireDefault(_RoutingContext2);
	
	var _PropTypes3 = _interopRequireDefault(_PropTypes2);
	
	var _match2 = __webpack_require__(463);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(179);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(456);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(457);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(461);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(176);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* mixins */
	
	exports.History = _History3.default;
	exports.Lifecycle = _Lifecycle3.default;
	exports.RouteContext = _RouteContext3.default;
	
	/* utils */
	
	exports.useRoutes = _useRoutes3.default;
	exports.RouterContext = _RouterContext3.default;
	exports.RoutingContext = _RoutingContext3.default;
	exports.PropTypes = _PropTypes3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 75 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.canUseDOM = canUseDOM;

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _queryString = __webpack_require__(474);
	
	var _runTransitionHook = __webpack_require__(111);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(36);
	
	var _deprecate = __webpack_require__(110);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	var SEARCH_BASE_KEY = '$searchBase';
	
	function defaultStringifyQuery(query) {
	  return _queryString.stringify(query).replace(/%20/g, '+');
	}
	
	var defaultParseQueryString = _queryString.parse;
	
	function isNestedObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p) && typeof object[p] === 'object' && !Array.isArray(object[p]) && object[p] !== null) return true;
	  }return false;
	}
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var stringifyQuery = options.stringifyQuery;
	    var parseQueryString = options.parseQueryString;
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    function addQuery(location) {
	      if (location.query == null) {
	        var search = location.search;
	
	        location.query = parseQueryString(search.substring(1));
	        location[SEARCH_BASE_KEY] = { search: search, searchBase: '' };
	      }
	
	      // TODO: Instead of all the book-keeping here, this should just strip the
	      // stringified query from the search.
	
	      return location;
	    }
	
	    function appendQuery(location, query) {
	      var _extends2;
	
	      var searchBaseSpec = location[SEARCH_BASE_KEY];
	      var queryString = query ? stringifyQuery(query) : '';
	      if (!searchBaseSpec && !queryString) {
	        return location;
	      }
	
	       false ? _warning2['default'](stringifyQuery !== defaultStringifyQuery || !isNestedObject(query), 'useQueries does not stringify nested query objects by default; ' + 'use a custom stringifyQuery function') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var searchBase = undefined;
	      if (searchBaseSpec && location.search === searchBaseSpec.search) {
	        searchBase = searchBaseSpec.searchBase;
	      } else {
	        searchBase = location.search || '';
	      }
	
	      var search = searchBase;
	      if (queryString) {
	        search += (search ? '&' : '?') + queryString;
	      }
	
	      return _extends({}, location, (_extends2 = {
	        search: search
	      }, _extends2[SEARCH_BASE_KEY] = { search: search, searchBase: searchBase }, _extends2));
	    }
	
	    // Override all read methods with query-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addQuery(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addQuery(location));
	      });
	    }
	
	    // Override all write methods with query-aware versions.
	    function push(location) {
	      history.push(appendQuery(location, location.query));
	    }
	
	    function replace(location) {
	      history.replace(appendQuery(location, location.query));
	    }
	
	    function createPath(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createPath is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createPath(appendQuery(location, query || location.query));
	    }
	
	    function createHref(location, query) {
	       false ? _warning2['default'](!query, 'the query argument to createHref is deprecated; use a location descriptor instead') : undefined;
	
	      return history.createHref(appendQuery(location, query || location.query));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var fullLocation = history.createLocation.apply(history, [appendQuery(location, location.query)].concat(args));
	      if (location.query) {
	        fullLocation.query = location.query;
	      }
	      return addQuery(fullLocation);
	    }
	
	    // deprecated
	    function pushState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path, { query: query }));
	    }
	
	    // deprecated
	    function replaceState(state, path, query) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path, { query: query }));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useQueries;
	module.exports = exports['default'];

/***/ },
/* 77 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DisabledInputUtils
	 */
	
	'use strict';
	
	var disableableMouseListenerNames = {
	  onClick: true,
	  onDoubleClick: true,
	  onMouseDown: true,
	  onMouseMove: true,
	  onMouseUp: true,
	
	  onClickCapture: true,
	  onDoubleClickCapture: true,
	  onMouseDownCapture: true,
	  onMouseMoveCapture: true,
	  onMouseUpCapture: true
	};
	
	/**
	 * Implements a host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var DisabledInputUtils = {
	  getHostProps: function (inst, props) {
	    if (!props.disabled) {
	      return props;
	    }
	
	    // Copy the props, except the mouse listeners
	    var hostProps = {};
	    for (var key in props) {
	      if (!disableableMouseListenerNames[key] && props.hasOwnProperty(key)) {
	        hostProps[key] = props[key];
	      }
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = DisabledInputUtils;

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var EventConstants = __webpack_require__(22);
	var ReactErrorUtils = __webpack_require__(119);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	function isEndish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseUp || topLevelType === topLevelTypes.topTouchEnd || topLevelType === topLevelTypes.topTouchCancel;
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseMove || topLevelType === topLevelTypes.topTouchMove;
	}
	function isStartish(topLevelType) {
	  return topLevelType === topLevelTypes.topMouseDown || topLevelType === topLevelTypes.topTouchStart;
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactBrowserEventEmitter
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventConstants = __webpack_require__(22);
	var EventPluginRegistry = __webpack_require__(114);
	var ReactEventEmitterMixin = __webpack_require__(511);
	var ViewportMetrics = __webpack_require__(123);
	
	var getVendorPrefixedEventName = __webpack_require__(543);
	var isEventSupported = __webpack_require__(128);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    var topLevelTypes = EventConstants.topLevelTypes;
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === topLevelTypes.topWheel) {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topWheel, 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === topLevelTypes.topScroll) {
	
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topScroll, 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topScroll, 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === topLevelTypes.topFocus || dependency === topLevelTypes.topBlur) {
	
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topFocus, 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelTypes.topBlur, 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topFocus, 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelTypes.topBlur, 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening[topLevelTypes.topBlur] = true;
	          isListening[topLevelTypes.topFocus] = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = document.createEvent && 'pageX' in document.createEvent('MouseEvent');
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticMouseEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(50);
	var ViewportMetrics = __webpack_require__(123);
	
	var getEventModifierState = __webpack_require__(126);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 81 */
/***/ function(module, exports) {

	/**
	 * Copyright 2016-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 * @providesModule escapeTextContentForBrowser
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setInnerHTML
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	var DOMNamespaces = __webpack_require__(113);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(124);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var newNodes = reusableSVGContainer.firstChild.childNodes;
	    for (var i = 0; i < newNodes.length; i++) {
	      node.appendChild(newNodes[i]);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xFEFF) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Constructs an enumeration with keys equal to their value.
	 *
	 * For example:
	 *
	 *   var COLORS = keyMirror({blue: null, red: null});
	 *   var myColor = COLORS.blue;
	 *   var isColorValid = !!COLORS[myColor];
	 *
	 * The last line could not be performed if the values of the generated enum were
	 * not equal to their keys.
	 *
	 *   Input:  {key1: val1, key2: val2}
	 *   Output: {key1: key1, key2: key2}
	 *
	 * @param {object} obj
	 * @return {object}
	 */
	var keyMirror = function keyMirror(obj) {
	  var ret = {};
	  var key;
	  !(obj instanceof Object && !Array.isArray(obj)) ?  false ? invariant(false, 'keyMirror(...): Argument must be an object.') : invariant(false) : void 0;
	  for (key in obj) {
	    if (!obj.hasOwnProperty(key)) {
	      continue;
	    }
	    ret[key] = key;
	  }
	  return ret;
	};
	
	module.exports = keyMirror;

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(595),
	    listCacheDelete = __webpack_require__(596),
	    listCacheGet = __webpack_require__(597),
	    listCacheHas = __webpack_require__(598),
	    listCacheSet = __webpack_require__(599);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(614);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to search.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(592);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(51);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 89 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(243);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(248);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Subheader = __webpack_require__(268);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	var _deprecatedPropType = __webpack_require__(57);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	var _warning = __webpack_require__(27);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var List = function (_Component) {
	  _inherits(List, _Component);
	
	  function List() {
	    _classCallCheck(this, List);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(List).apply(this, arguments));
	  }
	
	  _createClass(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var _props$insetSubheader = _props.insetSubheader;
	      var insetSubheader = _props$insetSubheader === undefined ? false : _props$insetSubheader;
	      var style = _props.style;
	      var subheader = _props.subheader;
	      var subheaderStyle = _props.subheaderStyle;
	      var zDepth = _props.zDepth;
	
	      var other = _objectWithoutProperties(_props, ['children', 'insetSubheader', 'style', 'subheader', 'subheaderStyle', 'zDepth']);
	
	       false ? (0, _warning2.default)(typeof zDepth === 'undefined', 'List no longer supports `zDepth`. Instead, wrap it in `Paper` ' + 'or another component that provides zDepth. It will be removed with v0.16.0.') : void 0;
	
	      var hasSubheader = false;
	
	      if (subheader) {
	        hasSubheader = true;
	      } else {
	        var firstChild = _react2.default.Children.toArray(children)[0];
	        if (_react2.default.isValidElement(firstChild) && firstChild.type === _Subheader2.default) {
	          hasSubheader = true;
	        }
	      }
	
	      var styles = {
	        root: {
	          padding: 0,
	          paddingBottom: 8,
	          paddingTop: hasSubheader ? 0 : 8
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }),
	        subheader && _react2.default.createElement(
	          _Subheader2.default,
	          { inset: insetSubheader, style: subheaderStyle },
	          subheader
	        ),
	        children
	      );
	    }
	  }]);
	
	  return List;
	}(_react.Component);
	
	List.propTypes = {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the subheader will be indented by 72px.
	   */
	  insetSubheader: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'Refer to the `subheader` property. It will be removed with v0.16.0.'),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The subheader string that will be displayed at the top of the list.
	   */
	  subheader: (0, _deprecatedPropType2.default)(_react.PropTypes.node, 'Instead, nest the `Subheader` component directly inside the `List`. It will be removed with v0.16.0.'),
	  /**
	   * Override the inline-styles of the subheader element.
	   */
	  subheaderStyle: (0, _deprecatedPropType2.default)(_react.PropTypes.object, 'Refer to the `subheader` property. It will be removed with v0.16.0.'),
	  /**
	   * @ignore
	   * ** Breaking change ** List no longer supports `zDepth`. Instead, wrap it in `Paper`
	   * or another component that provides zDepth.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	List.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = List;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(271);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ },
/* 94 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (value) {
	  if (Array.isArray(value)) value = value.join(',');
	
	  return value.match(/-webkit-|-moz-|-ms-/) !== null;
	};
	
	module.exports = exports['default'];

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(316);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(154);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : source[key];
	
	    assignValue(object, key, newValue);
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 97 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	module.exports = getPrototype;


/***/ },
/* 98 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 99 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 100 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(346),
	    isFunction = __webpack_require__(67),
	    isLength = __webpack_require__(102);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 102 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(326),
	    baseKeys = __webpack_require__(328),
	    indexKeys = __webpack_require__(157),
	    isArrayLike = __webpack_require__(101),
	    isIndex = __webpack_require__(99),
	    isPrototype = __webpack_require__(100);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowEqual = __webpack_require__(393);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function on(target, eventName, callback, capture) {
	  if (target.addEventListener) {
	    target.addEventListener(eventName, callback, capture);
	  } else if (target.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	function off(target, eventName, callback, capture) {
	  if (target.removeEventListener) {
	    target.removeEventListener(eventName, callback, capture);
	  } else if (target.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  for (var name in props) {
	    if (name.substring(0, 2) === 'on' && props[name] instanceof Function) {
	      var _eventName = name.substring(2).toLowerCase();
	      iteratee(_eventName, props[name]);
	    }
	  }
	}
	
	var EventListener = function (_Component) {
	  _inherits(EventListener, _Component);
	
	  function EventListener() {
	    _classCallCheck(this, EventListener);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(EventListener).apply(this, arguments));
	  }
	
	  _createClass(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var capture = _props.capture;
	      var target = _props.target;
	
	
	      if (target) {
	        (function () {
	          var element = target;
	
	          if (typeof target === 'string') {
	            element = window[target];
	          }
	
	          forEachListener(_this2.props, function (eventName, listener) {
	            return on(element, eventName, listener, capture);
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      var _this3 = this;
	
	      var _props2 = this.props;
	      var capture = _props2.capture;
	      var target = _props2.target;
	
	
	      if (target) {
	        (function () {
	          var element = target;
	
	          if (typeof target === 'string') {
	            element = window[target];
	          }
	
	          forEachListener(_this3.props, function (eventName, listener) {
	            return off(element, eventName, listener, capture);
	          });
	        })();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	
	  return EventListener;
	}(_react.Component);
	
	EventListener.propTypes = {
	  /**
	   * Whether to use capturing listeners.
	   */
	  capture: _react.PropTypes.bool.isRequired,
	  /**
	   * You can provide a children too.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.object, _react2.default.PropTypes.string])
	};
	EventListener.defaultProps = {
	  capture: false
	};
	exports.default = EventListener;

/***/ },
/* 105 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.watcher = undefined;
	
	var _redux = __webpack_require__(38);
	
	var _reducers = __webpack_require__(432);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _reduxWatcher = __webpack_require__(560);
	
	var _reduxWatcher2 = _interopRequireDefault(_reduxWatcher);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var store = (0, _redux.createStore)(_reducers2.default);
	
	if (false) {
		// Enable Webpack hot module replacement for reducers
		module.hot.accept('../reducers', function () {
			var nextRootReducer = require('../reducers').default;
			store.replaceReducer(nextRootReducer);
		});
	}
	
	var watcher = exports.watcher = new _reduxWatcher2.default(store);
	exports.default = store;
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 106 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.router = exports.routes = exports.route = exports.components = exports.component = exports.location = exports.history = exports.falsy = exports.locationShape = exports.routerShape = undefined;
	
	var _react = __webpack_require__(1);
	
	var _deprecateObjectProperties = __webpack_require__(73);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	var _InternalPropTypes = __webpack_require__(35);
	
	var InternalPropTypes = _interopRequireWildcard(_InternalPropTypes);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react.PropTypes.func;
	var object = _react.PropTypes.object;
	var shape = _react.PropTypes.shape;
	var string = _react.PropTypes.string;
	var routerShape = exports.routerShape = shape({
	  push: func.isRequired,
	  replace: func.isRequired,
	  go: func.isRequired,
	  goBack: func.isRequired,
	  goForward: func.isRequired,
	  setRouteLeaveHook: func.isRequired,
	  isActive: func.isRequired
	});
	
	var locationShape = exports.locationShape = shape({
	  pathname: string.isRequired,
	  search: string.isRequired,
	  state: object,
	  action: string.isRequired,
	  key: string
	});
	
	// Deprecated stuff below:
	
	var falsy = exports.falsy = InternalPropTypes.falsy;
	var history = exports.history = InternalPropTypes.history;
	var location = exports.location = locationShape;
	var component = exports.component = InternalPropTypes.component;
	var components = exports.components = InternalPropTypes.components;
	var route = exports.route = InternalPropTypes.route;
	var routes = exports.routes = InternalPropTypes.routes;
	var router = exports.router = routerShape;
	
	if (false) {
	  (function () {
	    var deprecatePropType = function deprecatePropType(propType, message) {
	      return function () {
	        process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, message) : void 0;
	        return propType.apply(undefined, arguments);
	      };
	    };
	
	    var deprecateInternalPropType = function deprecateInternalPropType(propType) {
	      return deprecatePropType(propType, 'This prop type is not intended for external use, and was previously exported by mistake. These internal prop types are deprecated for external use, and will be removed in a later version.');
	    };
	
	    var deprecateRenamedPropType = function deprecateRenamedPropType(propType, name) {
	      return deprecatePropType(propType, 'The `' + name + '` prop type is now exported as `' + name + 'Shape` to avoid name conflicts. This export is deprecated and will be removed in a later version.');
	    };
	
	    exports.falsy = falsy = deprecateInternalPropType(falsy);
	    exports.history = history = deprecateInternalPropType(history);
	    exports.component = component = deprecateInternalPropType(component);
	    exports.components = components = deprecateInternalPropType(components);
	    exports.route = route = deprecateInternalPropType(route);
	    exports.routes = routes = deprecateInternalPropType(routes);
	
	    exports.location = location = deprecateRenamedPropType(location, 'location');
	    exports.router = router = deprecateRenamedPropType(router, 'router');
	  })();
	}
	
	var defaultExport = {
	  falsy: falsy,
	  history: history,
	  location: location,
	  component: component,
	  components: components,
	  route: route,
	  // For some reason, routes was never here.
	  router: router
	};
	
	if (false) {
	  defaultExport = (0, _deprecateObjectProperties2.default)(defaultExport, 'The default export from `react-router/lib/PropTypes` is deprecated. Please use the named exports instead.');
	}
	
	exports.default = defaultExport;

/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _Actions = __webpack_require__(43);
	
	var _computeChangedRoutes2 = __webpack_require__(458);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(455);
	
	var _isActive2 = __webpack_require__(462);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(459);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(464);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	  function isActive(location) {
	    var indexOnlyOrDeprecatedQuery = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	    var deprecatedIndexOnly = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	    var indexOnly = void 0;
	    if (indexOnlyOrDeprecatedQuery && indexOnlyOrDeprecatedQuery !== true || deprecatedIndexOnly !== null) {
	       false ? (0, _routerWarning2.default)(false, '`isActive(pathname, query, indexOnly) is deprecated; use `isActive(location, indexOnly)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      location = { pathname: location, query: indexOnlyOrDeprecatedQuery };
	      indexOnly = deprecatedIndexOnly || false;
	    } else {
	      location = history.createLocation(location);
	      indexOnly = indexOnlyOrDeprecatedQuery;
	    }
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  function createLocationFromRedirectInfo(location) {
	    return history.createLocation(location, _Actions.REPLACE);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState);
	
	    var leaveRoutes = _computeChangedRoutes.leaveRoutes;
	    var changeRoutes = _computeChangedRoutes.changeRoutes;
	    var enterRoutes = _computeChangedRoutes.enterRoutes;
	
	
	    (0, _TransitionUtils.runLeaveHooks)(leaveRoutes);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    (0, _TransitionUtils.runChangeHooks)(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      (0, _TransitionUtils.runEnterHooks)(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, createLocationFromRedirectInfo(redirectInfo));
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.reduce(function (hooks, route) {
	      hooks.push.apply(hooks, RouteHooks[getRouteID(route)]);
	      return hooks;
	    }, []);
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route, false);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    // TODO: Warn if they register for a route that isn't currently
	    // active. They're probably doing something wrong, like re-creating
	    // route objects on every location change.
	    var routeID = getRouteID(route);
	    var hooks = RouteHooks[routeID];
	
	    if (!hooks) {
	      var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	
	      RouteHooks[routeID] = [hook];
	
	      if (thereWereNoRouteHooks) {
	        // setup transition & beforeunload hooks
	        unlistenBefore = history.listenBefore(transitionHook);
	
	        if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	      }
	    } else {
	      if (hooks.indexOf(hook) === -1) {
	         false ? (0, _routerWarning2.default)(false, 'adding multiple leave hooks for the same route is deprecated; manage multiple confirmations in your own code instead') : void 0;
	
	        hooks.push(hook);
	      }
	    }
	
	    return function () {
	      var hooks = RouteHooks[routeID];
	
	      if (hooks) {
	        var newHooks = hooks.filter(function (item) {
	          return item !== hook;
	        });
	
	        if (newHooks.length === 0) {
	          removeListenBeforeHooksForRoute(route);
	        } else {
	          RouteHooks[routeID] = newHooks;
	        }
	      }
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    // TODO: Only use a single history listener. Otherwise we'll
	    // end up with multiple concurrent calls to match.
	    return history.listen(function (location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.transitionTo(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    });
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	
	//export default useRoutes
	module.exports = exports['default'];

/***/ },
/* 109 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.getHashPath = getHashPath;
	exports.replaceHashPath = replaceHashPath;
	exports.getWindowPath = getWindowPath;
	exports.go = go;
	exports.getUserConfirmation = getUserConfirmation;
	exports.supportsHistory = supportsHistory;
	exports.supportsGoWithoutReloadUsingHash = supportsGoWithoutReloadUsingHash;
	
	function addEventListener(node, event, listener) {
	  if (node.addEventListener) {
	    node.addEventListener(event, listener, false);
	  } else {
	    node.attachEvent('on' + event, listener);
	  }
	}
	
	function removeEventListener(node, event, listener) {
	  if (node.removeEventListener) {
	    node.removeEventListener(event, listener, false);
	  } else {
	    node.detachEvent('on' + event, listener);
	  }
	}
	
	function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  return window.location.href.split('#')[1] || '';
	}
	
	function replaceHashPath(path) {
	  window.location.replace(window.location.pathname + window.location.search + '#' + path);
	}
	
	function getWindowPath() {
	  return window.location.pathname + window.location.search + window.location.hash;
	}
	
	function go(n) {
	  if (n) window.history.go(n);
	}
	
	function getUserConfirmation(message, callback) {
	  callback(window.confirm(message));
	}
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/rackt/react-router/issues/586
	 */
	
	function supportsHistory() {
	  var ua = navigator.userAgent;
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) {
	    return false;
	  }
	  return window.history && 'pushState' in window.history;
	}
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	
	function supportsGoWithoutReloadUsingHash() {
	  var ua = navigator.userAgent;
	  return ua.indexOf('Firefox') === -1;
	}

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function deprecate(fn, message) {
	  return function () {
	     false ? _warning2['default'](false, '[history] ' + message) : undefined;
	    return fn.apply(this, arguments);
	  };
	}
	
	exports['default'] = deprecate;
	module.exports = exports['default'];

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? _warning2['default'](result === undefined, 'You should not "return" in a transition hook with a callback argument; call the callback instead') : undefined;
	  }
	}
	
	exports['default'] = runTransitionHook;
	module.exports = exports['default'];

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMChildrenOperations
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(44);
	var Danger = __webpack_require__(487);
	var ReactMultiChildUpdateTypes = __webpack_require__(199);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(15);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(124);
	var setInnerHTML = __webpack_require__(82);
	var setTextContent = __webpack_require__(213);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID, 'replace text', stringText);
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation(prevInstance._debugID, 'replace with', markup.toString());
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(nextInstance._debugID, 'mount', markup.toString());
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case ReactMultiChildUpdateTypes.INSERT_MARKUP:
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'insert child', { toIndex: update.toIndex, content: update.content.toString() });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.MOVE_EXISTING:
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'move child', { fromIndex: update.fromIndex, toIndex: update.toIndex });
	          }
	          break;
	        case ReactMultiChildUpdateTypes.SET_MARKUP:
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace children', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.TEXT_CONTENT:
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'replace text', update.content.toString());
	          }
	          break;
	        case ReactMultiChildUpdateTypes.REMOVE_NODE:
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation(parentNodeDebugID, 'remove child', { fromIndex: update.fromIndex });
	          }
	          break;
	      }
	    }
	  }
	
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 113 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMNamespaces
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EventPluginRegistry
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var EventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!EventPluginOrder) {
	    // Wait until an `EventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var PluginModule = namesToPlugins[pluginName];
	    var pluginIndex = EventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !PluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = PluginModule;
	    var publishedEvents = PluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], PluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, PluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, PluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, PluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, PluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = PluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = PluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (InjectedEventPluginOrder) {
	    !!EventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    EventPluginOrder = Array.prototype.slice.call(InjectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var PluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== PluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = PluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    for (var phase in dispatchConfig.phasedRegistrationNames) {
	      if (!dispatchConfig.phasedRegistrationNames.hasOwnProperty(phase)) {
	        continue;
	      }
	      var PluginModule = EventPluginRegistry.registrationNameModules[dispatchConfig.phasedRegistrationNames[phase]];
	      if (PluginModule) {
	        return PluginModule;
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    EventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 115 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyEscapeUtils
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule LinkedValueUtils
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactPropTypes = __webpack_require__(202);
	var ReactPropTypeLocations = __webpack_require__(121);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var hasReadOnlyValue = {
	  'button': true,
	  'checkbox': true,
	  'image': true,
	  'hidden': true,
	  'radio': true,
	  'reset': true,
	  'submit': true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: ReactPropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, ReactPropTypeLocations.prop);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildren
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(30);
	var ReactElement = __webpack_require__(18);
	
	var emptyFunction = __webpack_require__(16);
	var traverseAllChildren = __webpack_require__(130);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentEnvironment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(3);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	
	  /**
	   * Optionally injectable environment dependent cleanup hook. (server vs.
	   * browser etc). Example: A browser system caches DOM nodes based on component
	   * ID and must remove that cache entry when this instance is unmounted.
	   */
	  unmountIDFromEnvironment: null,
	
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.unmountIDFromEnvironment = environment.unmountIDFromEnvironment;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactErrorUtils
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {?String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a, b) {
	  try {
	    return func(a, b);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	    return undefined;
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a, b) {
	      var boundFunc = func.bind(null, a, b);
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocationNames
	 */
	
	'use strict';
	
	var ReactPropTypeLocationNames = {};
	
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	}
	
	module.exports = ReactPropTypeLocationNames;

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypeLocations
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(84);
	
	var ReactPropTypeLocations = keyMirror({
	  prop: null,
	  context: null,
	  childContext: null
	});
	
	module.exports = ReactPropTypeLocations;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactUpdateQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(15);
	var ReactUpdates = __webpack_require__(23);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, publicInstance.constructor.displayName) : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + 'within `render` or another component\'s constructor). Render methods ' + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 123 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ViewportMetrics
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 124 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createMicrosoftUnsafeLocalFunction
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 125 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventCharCode
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 126 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventModifierState
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  'Alt': 'altKey',
	  'Control': 'ctrlKey',
	  'Meta': 'metaKey',
	  'Shift': 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 127 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventTarget
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventSupported
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 129 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule shouldUpdateReactComponent
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule traverseAllChildren
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactElement = __webpack_require__(18);
	
	var getIteratorFn = __webpack_require__(209);
	var invariant = __webpack_require__(3);
	var KeyEscapeUtils = __webpack_require__(115);
	var warning = __webpack_require__(5);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' || ReactElement.isValidElement(children)) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.') : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule validateDOMNesting
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var emptyFunction = __webpack_require__(16);
	var warning = __webpack_require__(5);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	
	      case 'pre':
	      case 'listing':
	
	      case 'table':
	
	      case 'hr':
	
	      case 'xmp':
	
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      if (childTag !== '#text') {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>. ' + 'See %s.%s', tagDisplayName, ancestorTag, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 132 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @type {Function}
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 133 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This function is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length,
	 *  else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 134 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate, clearImmediate) {var nextTick = __webpack_require__(630).nextTick;
	var apply = Function.prototype.apply;
	var slice = Array.prototype.slice;
	var immediateIds = {};
	var nextImmediateId = 0;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) { timeout.close(); };
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// That's not how node.js implements it but the exposed api is the same.
	exports.setImmediate = typeof setImmediate === "function" ? setImmediate : function(fn) {
	  var id = nextImmediateId++;
	  var args = arguments.length < 2 ? false : slice.call(arguments, 1);
	
	  immediateIds[id] = true;
	
	  nextTick(function onNextTick() {
	    if (immediateIds[id]) {
	      // fn.call() is faster so we optimize for the common use-case
	      // @see http://jsperf.com/call-apply-segu
	      if (args) {
	        fn.apply(null, args);
	      } else {
	        fn.call(null);
	      }
	      // Prevent ids from leaking
	      exports.clearImmediate(id);
	    }
	  });
	
	  return id;
	};
	
	exports.clearImmediate = typeof clearImmediate === "function" ? clearImmediate : function(id) {
	  delete immediateIds[id];
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(135).setImmediate, __webpack_require__(135).clearImmediate))

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(244);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(247);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(33);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(34);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(52);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(91);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(414);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(415);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(250);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var insetChildren = props.insetChildren;
	  var leftAvatar = props.leftAvatar;
	  var leftCheckbox = props.leftCheckbox;
	  var leftIcon = props.leftIcon;
	  var nestedLevel = props.nestedLevel;
	  var rightAvatar = props.rightAvatar;
	  var rightIcon = props.rightIcon;
	  var rightIconButton = props.rightIconButton;
	  var rightToggle = props.rightToggle;
	  var secondaryText = props.secondaryText;
	  var secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var styles = {
	    root: {
	      backgroundColor: (state.isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  _inherits(ListItem, _Component);
	
	  function ListItem() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ListItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleNestedListToggle = function (event) {
	      event.stopPropagation();
	      _this.setState({ open: !_this.state.open });
	      _this.props.onNestedListToggle(_this);
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.initiallyOpen) {
	        this.setState({ open: true });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      var button = this.refs.enhancedButton;
	
	      if (button) {
	        var buttonEl = _reactDom2.default.findDOMNode(button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props;
	      var innerDivStyle = _props.innerDivStyle;
	      var style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props;
	      var innerDivStyle = _props2.innerDivStyle;
	      var style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        _extends({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, _extends({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator;
	      var children = _props3.children;
	      var disabled = _props3.disabled;
	      var disableKeyboardFocus = _props3.disableKeyboardFocus;
	      var initiallyOpen = _props3.initiallyOpen;
	      var innerDivStyle = _props3.innerDivStyle;
	      var insetChildren = _props3.insetChildren;
	      var leftAvatar = _props3.leftAvatar;
	      var leftCheckbox = _props3.leftCheckbox;
	      var leftIcon = _props3.leftIcon;
	      var nestedItems = _props3.nestedItems;
	      var nestedLevel = _props3.nestedLevel;
	      var nestedListStyle = _props3.nestedListStyle;
	      var onKeyboardFocus = _props3.onKeyboardFocus;
	      var onMouseEnter = _props3.onMouseEnter;
	      var onMouseLeave = _props3.onMouseLeave;
	      var onNestedListToggle = _props3.onNestedListToggle;
	      var onTouchStart = _props3.onTouchStart;
	      var onTouchTap = _props3.onTouchTap;
	      var rightAvatar = _props3.rightAvatar;
	      var rightIcon = _props3.rightIcon;
	      var rightIconButton = _props3.rightIconButton;
	      var rightToggle = _props3.rightToggle;
	      var primaryText = _props3.primaryText;
	      var primaryTogglesNestedList = _props3.primaryTogglesNestedList;
	      var secondaryText = _props3.secondaryText;
	      var secondaryTextLines = _props3.secondaryTextLines;
	      var style = _props3.style;
	
	      var other = _objectWithoutProperties(_props3, ['autoGenerateNestedIndicator', 'children', 'disabled', 'disableKeyboardFocus', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onTouchTap: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onTouchTap = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel + 1, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var hasCheckbox = leftCheckbox || rightToggle;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        hasCheckbox ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          _extends({
	            containerElement: 'span'
	          }, other, {
	            disabled: disabled,
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchTap: primaryTogglesNestedList ? this.handleNestedListToggle : onTouchTap,
	            ref: 'enhancedButton',
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.propTypes = {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _react.PropTypes.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _react.PropTypes.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _react.PropTypes.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Callbak function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /** @ignore */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _react.PropTypes.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _react.PropTypes.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _react.PropTypes.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _react.PropTypes.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _react.PropTypes.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchStart: function onTouchStart() {},
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ListItem;

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(33);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(277);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _autoPrefix = __webpack_require__(56);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _keycode = __webpack_require__(53);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(92);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _deprecatedPropType = __webpack_require__(57);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	var _warning = __webpack_require__(27);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _menuUtils = __webpack_require__(253);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var animated = props.animated;
	  var desktop = props.desktop;
	  var maxHeight = props.maxHeight;
	  var _props$openDirection = props.openDirection;
	  var openDirection = _props$openDirection === undefined ? 'bottom-left' : _props$openDirection;
	  var width = props.width;
	
	
	  var openDown = openDirection.split('-')[0] === 'bottom';
	  var openLeft = openDirection.split('-')[1] === 'left';
	
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div bacause the List scales x faster than it scales y
	      transition: animated ? _transitions2.default.easeOut('250ms', 'transform') : null,
	      zIndex: muiTheme.zIndex.menu,
	      top: openDown ? 0 : null,
	      bottom: !openDown ? 0 : null,
	      left: !openLeft ? 0 : null,
	      right: openLeft ? 0 : null,
	      transform: animated ? 'scaleX(0)' : null,
	      transformOrigin: openLeft ? 'right' : 'left',
	      opacity: 0,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    menuItemContainer: {
	      transition: animated ? _transitions2.default.easeOut(null, 'opacity') : null,
	      opacity: 0
	    },
	    selectedMenuItem: {
	      color: muiTheme.baseTheme.palette.accent1Color
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  _inherits(Menu, _Component);
	
	  function Menu(props, context) {
	    _classCallCheck(this, Menu);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Menu).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getSelectedIndex(props, filteredChildren);
	
	    _this.state = {
	      focusIndex: props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (!this.props.animated) {
	        this.animateOpen();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	      var selectedIndex = this.getSelectedIndex(nextProps, filteredChildren);
	
	      this.setState({
	        focusIndex: nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'animateOpen',
	    value: function animateOpen() {
	      var rootStyle = _reactDom2.default.findDOMNode(this).style;
	      var scrollContainerStyle = _reactDom2.default.findDOMNode(this.refs.scrollContainer).style;
	      var menuContainers = _reactDom2.default.findDOMNode(this.refs.list).childNodes;
	
	      _autoPrefix2.default.set(rootStyle, 'transform', 'scaleX(1)');
	      _autoPrefix2.default.set(scrollContainerStyle, 'transform', 'scaleY(1)');
	      scrollContainerStyle.opacity = 1;
	
	      for (var i = 0; i < menuContainers.length; ++i) {
	        menuContainers[i].style.opacity = 1;
	      }
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var _props = this.props;
	      var desktop = _props.desktop;
	      var selectedMenuItemStyle = _props.selectedMenuItemStyle;
	
	
	      var selected = this.isChildSelected(child, this.props);
	      var selectedChildrenStyles = {};
	
	      if (selected) {
	        selectedChildrenStyles = (0, _simpleAssign2.default)(styles.selectedMenuItem, selectedMenuItemStyle);
	      }
	
	      var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	      var isFocused = childIndex === this.state.focusIndex;
	      var focusState = 'none';
	      if (isFocused) {
	        focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	      }
	
	      return _react2.default.cloneElement(child, {
	        desktop: desktop,
	        focusState: focusState,
	        onTouchTap: function onTouchTap(event) {
	          _this2.handleMenuItemTouchTap(event, child, index);
	          if (child.props.onTouchTap) child.props.onTouchTap(event);
	        },
	        ref: isFocused ? 'focusedMenuItem' : null,
	        style: mergedChildrenStyles
	      });
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex() {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(index, true);
	    }
	  }, {
	    key: 'getCascadeChildrenCount',
	    value: function getCascadeChildrenCount(filteredChildren) {
	      var _props2 = this.props;
	      var desktop = _props2.desktop;
	      var maxHeight = _props2.maxHeight;
	
	      var count = 1;
	      var currentHeight = desktop ? 16 : 8;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      // MaxHeight isn't set - cascade all of the children
	      if (!maxHeight) return filteredChildren.length;
	
	      // Count all the children that will fit inside the max menu height
	      filteredChildren.forEach(function (child) {
	        if (currentHeight < maxHeight) {
	          var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	          currentHeight += childIsADivider ? 16 : menuItemHeight;
	          count++;
	        }
	      });
	
	      return count;
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && new RegExp('^' + keys, 'i').test(primaryText)) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(focusIndex, false);
	
	      if (multiple) {
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = _toArray(menuValue);
	
	        var newMenuValue = _menuValue;
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(newIndex, isKeyboardFocused) {
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props;
	      var animated = _props3.animated;
	      var autoWidth = _props3.autoWidth;
	      var children = _props3.children;
	      var desktop = _props3.desktop;
	      var disableAutoFocus = _props3.disableAutoFocus;
	      var initiallyKeyboardFocused = _props3.initiallyKeyboardFocused;
	      var listStyle = _props3.listStyle;
	      var maxHeight = _props3.maxHeight;
	      var multiple = _props3.multiple;
	      var _props3$openDirection = _props3.openDirection;
	      var openDirection = _props3$openDirection === undefined ? 'bottom-left' : _props3$openDirection;
	      var onItemTouchTap = _props3.onItemTouchTap;
	      var onEscKeyDown = _props3.onEscKeyDown;
	      var selectedMenuItemStyle = _props3.selectedMenuItemStyle;
	      var style = _props3.style;
	      var value = _props3.value;
	      var valueLink = _props3.valueLink;
	      var width = _props3.width;
	      var zDepth = _props3.zDepth;
	
	      var other = _objectWithoutProperties(_props3, ['animated', 'autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'openDirection', 'onItemTouchTap', 'onEscKeyDown', 'selectedMenuItemStyle', 'style', 'value', 'valueLink', 'width', 'zDepth']);
	
	       false ? (0, _warning2.default)(typeof zDepth === 'undefined', 'Menu no longer supports `zDepth`. Instead, wrap it in `Paper` ' + 'or another component that provides `zDepth`. It will be removed with v0.16.0.') : void 0;
	
	      var focusIndex = this.state.focusIndex;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var openDown = openDirection.split('-')[0] === 'bottom';
	      var filteredChildren = this.getFilteredChildren(children);
	
	      // Cascade children opacity
	      var cumulativeDelay = openDown ? 175 : 325;
	      var cascadeChildrenCount = this.getCascadeChildrenCount(filteredChildren);
	      var cumulativeDelayIncrement = Math.ceil(150 / cascadeChildrenCount);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        var childrenContainerStyles = {};
	
	        if (animated) {
	          var transitionDelay = 0;
	
	          // Only cascade the visible menu items
	          if (menuItemIndex >= focusIndex - 1 && menuItemIndex <= focusIndex + cascadeChildrenCount - 1) {
	            cumulativeDelay = openDown ? cumulativeDelay + cumulativeDelayIncrement : cumulativeDelay - cumulativeDelayIncrement;
	            transitionDelay = cumulativeDelay;
	          }
	
	          childrenContainerStyles = (0, _simpleAssign2.default)({}, styles.menuItemContainer, {
	            transitionDelay: transitionDelay + 'ms'
	          });
	        }
	
	        var clonedChild = childIsADivider ? _react2.default.cloneElement(child, { style: styles.divider }) : childIsDisabled ? _react2.default.cloneElement(child, { desktop: desktop }) : _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	
	        if (!childIsADivider && !childIsDisabled) menuItemIndex++;
	
	        return animated ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(childrenContainerStyles) },
	          clonedChild
	        ) : clonedChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            _extends({}, other, {
	              ref: 'list',
	              style: mergedListStyles
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	
	  return Menu;
	}(_react.Component);
	
	Menu.propTypes = {
	  /**
	   * If true, the menu will apply transitions when it
	   * is added to the DOM. In order for transitions to
	   * work, wrap the menu inside a `ReactTransitionGroup`.
	   */
	  animated: (0, _deprecatedPropType2.default)(_react.PropTypes.bool, 'Instead, use a [Popover](/#/components/popover).\n      It will be removed with v0.16.0.'),
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _react.PropTypes.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _react.PropTypes.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _react.PropTypes.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _react.PropTypes.number,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _react.PropTypes.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _react.PropTypes.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * This is the placement of the menu relative to the `IconButton`.
	   */
	  openDirection: (0, _deprecatedPropType2.default)(_propTypes2.default.corners, 'Instead, use a [Popover](/#/components/popover).\n      It will be removed with v0.16.0.'),
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _react.PropTypes.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _react.PropTypes.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes2.default.stringOrNumber,
	  /**
	   * @ignore
	   * Menu no longer supports `zDepth`. Instead, wrap it in `Paper`
	   * or another component that provides zDepth.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    _this5.setFocusIndex(-1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex();
	        } else {
	          _this5.incrementKeyboardFocusIndex(filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex();
	        break;
	      default:
	        if (key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	};
	
	exports.default = Menu;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(254);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(104);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(146);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(24);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _throttle = __webpack_require__(388);
	
	var _throttle2 = _interopRequireDefault(_throttle);
	
	var _PopoverAnimationDefault = __webpack_require__(256);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Popover = function (_Component) {
	  _inherits(Popover, _Component);
	
	  function Popover(props, context) {
	    _classCallCheck(this, Popover);
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Popover).call(this, props, context));
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props;
	      var animated = _this$props.animated;
	      var animation = _this$props.animation;
	      var children = _this$props.children;
	      var style = _this$props.style;
	
	      var other = _objectWithoutProperties(_this$props, ['animated', 'animation', 'children', 'style']);
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	      var styleRoot = style;
	
	      if (!Animation) {
	        Animation = _Paper2.default;
	        styleRoot = {
	          position: 'fixed'
	        };
	        if (!_this.state.open) {
	          return null;
	        }
	      }
	
	      return _react2.default.createElement(
	        Animation,
	        _extends({}, other, { style: styleRoot, open: _this.state.open && !_this.state.closing }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function () {
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      if (!_this.refs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.refs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props;
	      var targetOrigin = _this$props2.targetOrigin;
	      var anchorOrigin = _this$props2.anchorOrigin;
	
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = Math.max(0, targetPosition.top) + 'px';
	      targetEl.style.left = Math.max(0, targetPosition.left) + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _throttle2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _throttle2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  _createClass(Popover, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open !== this.state.open) {
	        if (nextProps.open) {
	          this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	          this.setState({
	            open: true,
	            closing: false
	          });
	        } else {
	          if (nextProps.animated) {
	            this.setState({ closing: true });
	            this.timeout = setTimeout(function () {
	              _this2.setState({
	                open: false
	              });
	            }, 500);
	          } else {
	            this.setState({
	              open: false
	            });
	          }
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: '_resizeAutoPosition',
	    value: function _resizeAutoPosition() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	      a.bottom = rect.bottom || a.top + a.height;
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = _extends({}, anchor);
	      var t = _extends({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin);
	
	      var positions = _getPositions.positions;
	      var anchorPos = _getPositions.anchorPos;
	
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) targetPosition.top = Math.max(0, newTop);else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) targetPosition.top = Math.max(0, newTop);
	        }
	      }
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) targetPosition.left = Math.max(0, newLeft);else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) targetPosition.left = Math.max(0, newLeft);
	        }
	      }
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'none' } },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: 'layer',
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	
	  return Popover;
	}(_react.Component);
	
	Popover.propTypes = {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _react.PropTypes.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, middle, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _react.PropTypes.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _react.PropTypes.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _react.PropTypes.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _react.PropTypes.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, middle, bottom];
	   * horizontal: [left, center, right].
	   */
	  targetOrigin: _propTypes2.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _react.PropTypes.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Popover;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;
	
	var _Popover2 = __webpack_require__(141);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _PopoverAnimationVertical2 = __webpack_require__(257);
	
	var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Popover = _Popover3.default;
	exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
	exports.default = _Popover3.default;

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(258);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _checkCircle = __webpack_require__(406);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active;
	  var completed = _ref.completed;
	  var disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme;
	  var stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper;
	  var textColor = _muiTheme$stepper.textColor;
	  var disabledTextColor = _muiTheme$stepper.disabledTextColor;
	  var iconColor = _muiTheme$stepper.iconColor;
	  var inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      display: 'flex',
	      alignItems: 'center',
	      paddingRight: 8,
	      width: 24
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'not-allowed';
	  }
	
	  return styles;
	};
	
	var StepLabel = function (_Component) {
	  _inherits(StepLabel, _Component);
	
	  function StepLabel() {
	    _classCallCheck(this, StepLabel);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StepLabel).apply(this, arguments));
	  }
	
	  _createClass(StepLabel, [{
	    key: 'renderIcon',
	    value: function renderIcon(completed, icon, styles) {
	      var iconType = typeof icon === 'undefined' ? 'undefined' : _typeof(icon);
	
	      if (iconType === 'number' || iconType === 'string') {
	        if (completed) {
	          return _react2.default.createElement(_checkCircle2.default, {
	            color: styles.icon.color,
	            style: styles.icon
	          });
	        }
	
	        return _react2.default.createElement(
	          _SvgIcon2.default,
	          { color: styles.icon.color, style: styles.icon },
	          _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	          _react2.default.createElement(
	            'text',
	            {
	              x: '12',
	              y: '16',
	              textAnchor: 'middle',
	              fontSize: '12',
	              fill: '#fff'
	            },
	            icon
	          )
	        );
	      }
	
	      return icon;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active = _props.active;
	      var children = _props.children;
	      var completed = _props.completed;
	      var userIcon = _props.icon;
	      var last = _props.last;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['active', 'children', 'completed', 'icon', 'last', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var icon = this.renderIcon(completed, userIcon, styles);
	
	      return _react2.default.createElement(
	        'span',
	        _extends({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        icon && _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.iconContainer) },
	          icon
	        ),
	        children
	      );
	    }
	  }]);
	
	  return StepLabel;
	}(_react.Component);
	
	StepLabel.muiName = 'StepLabel';
	StepLabel.propTypes = {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * The label text node
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	StepLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	exports.default = StepLabel;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(33);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(56);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(281);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  _inherits(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FocusRipple)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color;
	      var innerStyle = props.innerStyle;
	      var opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme;
	      var prepareStyles = _context$muiTheme.prepareStyles;
	      var ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var show = _props.show;
	      var style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.propTypes = {
	  color: _react.PropTypes.string,
	  innerStyle: _react.PropTypes.object,
	  opacity: _react.PropTypes.number,
	  show: _react.PropTypes.bool,
	  style: _react.PropTypes.object
	};
	FocusRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = FocusRipple;

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _dom = __webpack_require__(166);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _MuiThemeProvider = __webpack_require__(165);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	
	var RenderToLayer = function (_Component) {
	  _inherits(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(RenderToLayer)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props;
	      var open = _props.open;
	      var render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        /**
	         * We use the <MuiThemeProvider /> component as a work around for
	         * https://github.com/facebook/react/issues/6599.
	         */
	        var layerElement = _react2.default.createElement(
	          _MuiThemeProvider2.default,
	          { muiTheme: this.context.muiTheme },
	          render()
	        );
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.propTypes = {
	  componentClickAway: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  render: _react.PropTypes.func.isRequired,
	  useLayerForClickAway: _react.PropTypes.bool
	};
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = RenderToLayer;

/***/ },
/* 147 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "Webkit": { "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "backfaceVisibility": true, "perspective": true, "perspectiveOrigin": true, "transformStyle": true, "transformOriginZ": true, "animation": true, "animationDelay": true, "animationDirection": true, "animationFillMode": true, "animationDuration": true, "animationIterationCount": true, "animationName": true, "animationPlayState": true, "animationTimingFunction": true, "appearance": true, "userSelect": true, "fontKerning": true, "textEmphasisPosition": true, "textEmphasis": true, "textEmphasisStyle": true, "textEmphasisColor": true, "boxDecorationBreak": true, "clipPath": true, "maskImage": true, "maskMode": true, "maskRepeat": true, "maskPosition": true, "maskClip": true, "maskOrigin": true, "maskSize": true, "maskComposite": true, "mask": true, "maskBorderSource": true, "maskBorderMode": true, "maskBorderSlice": true, "maskBorderWidth": true, "maskBorderOutset": true, "maskBorderRepeat": true, "maskBorder": true, "maskType": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "filter": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true, "flex": true, "flexBasis": true, "flexDirection": true, "flexGrow": true, "flexFlow": true, "flexShrink": true, "flexWrap": true, "alignContent": true, "alignItems": true, "alignSelf": true, "justifyContent": true, "order": true, "transition": true, "transitionDelay": true, "transitionDuration": true, "transitionProperty": true, "transitionTimingFunction": true, "backdropFilter": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "shapeImageThreshold": true, "shapeImageMargin": true, "shapeImageOutside": true, "hyphens": true, "flowInto": true, "flowFrom": true, "regionFragment": true, "textSizeAdjust": true, "borderImage": true, "borderImageOutset": true, "borderImageRepeat": true, "borderImageSlice": true, "borderImageSource": true, "borderImageWidth": true, "tabSize": true, "objectFit": true, "objectPosition": true }, "Moz": { "appearance": true, "userSelect": true, "boxSizing": true, "textAlignLast": true, "textDecorationStyle": true, "textDecorationSkip": true, "textDecorationLine": true, "textDecorationColor": true, "tabSize": true, "hyphens": true, "fontFeatureSettings": true, "breakAfter": true, "breakBefore": true, "breakInside": true, "columnCount": true, "columnFill": true, "columnGap": true, "columnRule": true, "columnRuleColor": true, "columnRuleStyle": true, "columnRuleWidth": true, "columns": true, "columnSpan": true, "columnWidth": true }, "ms": { "flex": true, "flexBasis": false, "flexDirection": true, "flexGrow": false, "flexFlow": true, "flexShrink": false, "flexWrap": true, "alignContent": false, "alignItems": false, "alignSelf": false, "justifyContent": false, "order": false, "transform": true, "transformOrigin": true, "transformOriginX": true, "transformOriginY": true, "userSelect": true, "wrapFlow": true, "wrapThrough": true, "wrapMargin": true, "scrollSnapType": true, "scrollSnapPointsX": true, "scrollSnapPointsY": true, "scrollSnapDestination": true, "scrollSnapCoordinate": true, "touchAction": true, "hyphens": true, "flowInto": true, "flowFrom": true, "breakBefore": true, "breakAfter": true, "breakInside": true, "regionFragment": true, "gridTemplateColumns": true, "gridTemplateRows": true, "gridTemplateAreas": true, "gridTemplate": true, "gridAutoColumns": true, "gridAutoRows": true, "gridAutoFlow": true, "grid": true, "gridRowStart": true, "gridColumnStart": true, "gridRowEnd": true, "gridRow": true, "gridColumn": true, "gridColumnEnd": true, "gridColumnGap": true, "gridRowGap": true, "gridArea": true, "gridGap": true, "textSizeAdjust": true } };
	module.exports = exports["default"];

/***/ },
/* 148 */
/***/ function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	
	function hyphenateStyleName(string) {
	    return string
	        .replace(uppercasePattern, '-$&')
	        .toLowerCase()
	        .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(39),
	    root = __webpack_require__(19);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(62),
	    stackClear = __webpack_require__(373),
	    stackDelete = __webpack_require__(374),
	    stackGet = __webpack_require__(375),
	    stackHas = __webpack_require__(376),
	    stackSet = __webpack_require__(377);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 151 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 152 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(66);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(66);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 155 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var stubArray = __webpack_require__(386);
	
	/** Built-in value references. */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	function getSymbols(object) {
	  // Coerce `object` to an object to avoid non-object errors in V8.
	  // See https://bugs.chromium.org/p/v8/issues/detail?id=3443 for more details.
	  return getOwnPropertySymbols(Object(object));
	}
	
	// Fallback for IE < 11.
	if (!getOwnPropertySymbols) {
	  getSymbols = stubArray;
	}
	
	module.exports = getSymbols;


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(333),
	    isArguments = __webpack_require__(159),
	    isArray = __webpack_require__(40),
	    isLength = __webpack_require__(102),
	    isString = __webpack_require__(381);
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	module.exports = indexKeys;


/***/ },
/* 158 */
/***/ function(module, exports) {

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(160);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(101),
	    isObjectLike = __webpack_require__(54);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(102),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	var baseKeysIn = __webpack_require__(329),
	    indexKeys = __webpack_require__(157),
	    isIndex = __webpack_require__(99),
	    isPrototype = __webpack_require__(100);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  var index = -1,
	      isProto = isPrototype(object),
	      props = baseKeysIn(object),
	      propsLength = props.length,
	      indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  while (++index < propsLength) {
	    var key = props[index];
	    if (!(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keysIn;


/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(67),
	    isObject = __webpack_require__(20),
	    isSymbol = __webpack_require__(382);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = isFunction(value.valueOf) ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	var createHelper = function createHelper(func, helperName) {
	  var setDisplayName = arguments.length <= 2 || arguments[2] === undefined ? true : arguments[2];
	  var noArgs = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
	  if (false) {
	    var _ret = function () {
	      /* eslint-disable global-require */
	      var wrapDisplayName = require('./wrapDisplayName').default;
	      /* eslint-enable global-require */
	
	      if (noArgs) {
	        return {
	          v: function v(BaseComponent) {
	            var Component = func(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          }
	        };
	      }
	
	      return {
	        v: function v() {
	          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	            args[_key] = arguments[_key];
	          }
	
	          if (args.length > func.length) {
	            /* eslint-disable */
	            console.error(
	            /* eslint-enable */
	            'Too many arguments passed to ' + helperName + '(). It should called ' + ('like so: ' + helperName + '(...args)(BaseComponent).'));
	          }
	
	          return function (BaseComponent) {
	            var Component = func.apply(undefined, args)(BaseComponent);
	            Component.displayName = wrapDisplayName(BaseComponent, helperName);
	            return Component;
	          };
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	
	  return func;
	};
	
	exports.default = createHelper;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _getMuiTheme = __webpack_require__(402);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MuiThemeProvider = function (_Component) {
	  _inherits(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    _classCallCheck(this, MuiThemeProvider);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(MuiThemeProvider).apply(this, arguments));
	  }
	
	  _createClass(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.propTypes = {
	  children: _react.PropTypes.element,
	  muiTheme: _react.PropTypes.object
	};
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = MuiThemeProvider;

/***/ },
/* 166 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ },
/* 167 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET = exports.SET = 'VIDEO_SET';
	var SET_WITHOUT_BROADCAST = exports.SET_WITHOUT_BROADCAST = 'VIDEO_SET_WITHOUT_BROADCAST';
	var PUSH_STATUS = exports.PUSH_STATUS = 'VIDEO_PUSH_STATUS';
	var CLEAR_STATUS = exports.CLEAR_STATUS = 'VIDEO_CLEAR_STATUS';
	var RESET = exports.RESET = 'VIDEO_RESET';
	
	var set = exports.set = function set(data) {
	  return { type: SET, data: data };
	};
	var setWithoutBroadcast = exports.setWithoutBroadcast = function setWithoutBroadcast(data) {
	  return { type: SET_WITHOUT_BROADCAST, data: data };
	};
	var pushStatus = exports.pushStatus = function pushStatus(status) {
	  return { type: PUSH_STATUS, status: status };
	};
	var clearStatus = exports.clearStatus = function clearStatus() {
	  return { type: CLEAR_STATUS };
	};
	var reset = exports.reset = function reset() {
	  return { type: RESET };
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "video.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.GitHubIcon = exports.LogoIcon = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LogoIcon = exports.LogoIcon = function LogoIcon(props) {
		return _react2.default.createElement(
			_SvgIcon2.default,
			_extends({ viewBox: '0 0 450 300' }, props),
			_react2.default.createElement('path', { fill: '#157BBA', d: 'M155,6l144,288L439,42c0,0-84,108-140,108S155,6,155,6z' }),
			_react2.default.createElement('path', { fill: '#125E84', d: 'M299,294L155,6L11,258c0,0,88-108,144-108S299,294,299,294z' })
		);
	};
	
	var GitHubIcon = exports.GitHubIcon = function GitHubIcon(props) {
		return _react2.default.createElement(
			_SvgIcon2.default,
			_extends({ viewBox: '0 0 16 16' }, props),
			_react2.default.createElement('path', { d: 'M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0 0 16 8c0-4.42-3.58-8-8-8z' })
		);
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		torrent: {
			trackers: ['wss://avt.leanapp.cn/', 'udp://tracker.openbittorrent.com:80', 'udp://tracker.internetwarriors.net:1337', 'udp://tracker.leechers-paradise.org:6969', 'udp://tracker.coppersurfer.tk:6969', 'udp://exodus.desync.com:6969', 'wss://tracker.webtorrent.io', 'wss://tracker.btorrent.xyz', 'wss://tracker.openwebtorrent.com', 'wss://tracker.fastcast.nz']
		},
		leancloud: {
			appId: 'A1uxil2WxTsUUtUf2gSBi6iy-gzGzoHsz',
			appKey: 'JJraYYRy6Nkn3AvrSYsvJKzr',
			region: 'cn'
		}
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "config.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	exports["default"] = _react.PropTypes.shape({
	  subscribe: _react.PropTypes.func.isRequired,
	  dispatch: _react.PropTypes.func.isRequired,
	  getState: _react.PropTypes.func.isRequired
	});

/***/ },
/* 172 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that you can use this stack
	    // to find the callsite that caused this warning to fire.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var bool = _React$PropTypes.bool;
	var object = _React$PropTypes.object;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	var oneOfType = _React$PropTypes.oneOfType;
	
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function createLocationDescriptor(to, _ref) {
	  var query = _ref.query;
	  var hash = _ref.hash;
	  var state = _ref.state;
	
	  if (query || hash || state) {
	    return { pathname: to, query: query, hash: hash, state: state };
	  }
	
	  return to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 *
	 * Links may pass along location state and/or query string parameters
	 * in the state/query props, respectively.
	 *
	 *   <Link ... query={{ show: true }} state={{ the: 'state' }} />
	 */
	var Link = _react2.default.createClass({
	  displayName: 'Link',
	
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: oneOfType([string, object]).isRequired,
	    query: object,
	    hash: string,
	    state: object,
	    activeStyle: object,
	    activeClassName: string,
	    onlyActiveOnIndex: bool.isRequired,
	    onClick: func,
	    target: string
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    !this.context.router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot handle clicks.') : (0, _invariant2.default)(false) : void 0;
	
	    var allowTransition = true;
	
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    if (event.defaultPrevented === true) allowTransition = false;
	
	    // If target prop is set (e.g. to "_blank") let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) {
	      if (!allowTransition) event.preventDefault();
	
	      return;
	    }
	
	    event.preventDefault();
	
	    if (allowTransition) {
	      var _props = this.props;
	      var to = _props.to;
	      var query = _props.query;
	      var hash = _props.hash;
	      var state = _props.state;
	
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	
	      this.context.router.push(location);
	    }
	  },
	  render: function render() {
	    var _props2 = this.props;
	    var to = _props2.to;
	    var query = _props2.query;
	    var hash = _props2.hash;
	    var state = _props2.state;
	    var activeClassName = _props2.activeClassName;
	    var activeStyle = _props2.activeStyle;
	    var onlyActiveOnIndex = _props2.onlyActiveOnIndex;
	
	    var props = _objectWithoutProperties(_props2, ['to', 'query', 'hash', 'state', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex']);
	
	     false ? (0, _routerWarning2.default)(!(query || hash || state), 'the `query`, `hash`, and `state` props on `<Link>` are deprecated, use `<Link to={{ pathname, query, hash, state }}/>. http://tiny.cc/router-isActivedeprecated') : void 0;
	
	    // Ignore if rendered outside the context of router, simplifies unit testing.
	    var router = this.context.router;
	
	
	    if (router) {
	      var location = createLocationDescriptor(to, { query: query, hash: hash, state: state });
	      props.href = router.createHref(location);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(location, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(29);
	
	var _PatternUtils = __webpack_require__(42);
	
	var _InternalPropTypes = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	
	var Redirect = _react2.default.createClass({
	  displayName: 'Redirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location;
	        var params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: string,
	    from: string, // Alias for path
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.createRoutingHistory = createRoutingHistory;
	
	var _deprecateObjectProperties = __webpack_require__(73);
	
	var _deprecateObjectProperties2 = _interopRequireDefault(_deprecateObjectProperties);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createRouterObject(history, transitionManager) {
	  return _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	}
	
	// deprecated
	function createRoutingHistory(history, transitionManager) {
	  history = _extends({}, history, transitionManager);
	
	  if (false) {
	    history = (0, _deprecateObjectProperties2.default)(history, '`props.history` and `context.history` are deprecated. Please use `context.router`. http://tiny.cc/router-contextchanges');
	  }
	
	  return history;
	}

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(76);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(184);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(470);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useRoutes` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  history.__v2_compatible__ = true;
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	};
	
	var _useRouterHistory = __webpack_require__(179);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	module.exports = exports['default'];

/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = makeStateWithLocation;
	
	var _deprecateObjectProperties = __webpack_require__(73);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function makeStateWithLocation(state, location) {
	  if (false) {
	    var stateWithLocation = _extends({}, state);
	
	    // I don't use deprecateObjectProperties here because I want to keep the
	    // same code path between development and production, in that we just
	    // assign extra properties to the copy of the state object in both cases.
	
	    var _loop = function _loop(prop) {
	      if (!Object.prototype.hasOwnProperty.call(location, prop)) {
	        return 'continue';
	      }
	
	      Object.defineProperty(stateWithLocation, prop, {
	        get: function get() {
	          process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(false, 'Accessing location properties directly from the first argument to `getComponent`, `getComponents`, `getChildRoutes`, and `getIndexRoute` is deprecated. That argument is now the router state (`nextState` or `partialNextState`) rather than the location. To access the location, use `nextState.location` or `partialNextState.location`.') : void 0;
	          return location[prop];
	        }
	      });
	    };
	
	    for (var prop in location) {
	      var _ret = _loop(prop);
	
	      if (_ret === 'continue') continue;
	    }
	
	    return stateWithLocation;
	  }
	
	  return _extends({}, state, location);
	}
	module.exports = exports['default'];

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(76);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(184);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    history.__v2_compatible__ = true;
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	/*eslint-disable no-empty */
	'use strict';
	
	exports.__esModule = true;
	exports.saveState = saveState;
	exports.readState = readState;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var KeyPrefix = '@@History/';
	var QuotaExceededErrors = ['QuotaExceededError', 'QUOTA_EXCEEDED_ERR'];
	
	var SecurityError = 'SecurityError';
	
	function createKey(key) {
	  return KeyPrefix + key;
	}
	
	function saveState(key, state) {
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available due to security settings') : undefined;
	
	      return;
	    }
	
	    if (QuotaExceededErrors.indexOf(error.name) >= 0 && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? _warning2['default'](false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : undefined;
	
	      return;
	    }
	
	    throw error;
	  }
	}
	
	function readState(key) {
	  var json = undefined;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (error.name === SecurityError) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? _warning2['default'](false, '[history] Unable to read state; sessionStorage is not available due to security settings') : undefined;
	
	      return null;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return null;
	}

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(75);
	
	var _DOMUtils = __webpack_require__(109);
	
	var _createHistory = __webpack_require__(183);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createDOMHistory(options) {
	  var history = _createHistory2['default'](_extends({
	    getUserConfirmation: _DOMUtils.getUserConfirmation
	  }, options, {
	    go: _DOMUtils.go
	  }));
	
	  function listen(listener) {
	    !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'DOM history needs a DOM') : _invariant2['default'](false) : undefined;
	
	    return history.listen(listener);
	  }
	
	  return _extends({}, history, {
	    listen: listen
	  });
	}
	
	exports['default'] = createDOMHistory;
	module.exports = exports['default'];

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(43);
	
	var _PathUtils = __webpack_require__(36);
	
	var _ExecutionEnvironment = __webpack_require__(75);
	
	var _DOMUtils = __webpack_require__(109);
	
	var _DOMStateStorage = __webpack_require__(180);
	
	var _createDOMHistory = __webpack_require__(181);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	function isAbsolutePath(path) {
	  return typeof path === 'string' && path.charAt(0) === '/';
	}
	
	function ensureSlash() {
	  var path = _DOMUtils.getHashPath();
	
	  if (isAbsolutePath(path)) return true;
	
	  _DOMUtils.replaceHashPath('/' + path);
	
	  return false;
	}
	
	function addQueryStringValueToPath(path, key, value) {
	  return path + (path.indexOf('?') === -1 ? '?' : '&') + (key + '=' + value);
	}
	
	function stripQueryStringValueFromPath(path, key) {
	  return path.replace(new RegExp('[?&]?' + key + '=[a-zA-Z0-9]+'), '');
	}
	
	function getQueryStringValueFromPath(path, key) {
	  var match = path.match(new RegExp('\\?.*?\\b' + key + '=(.+?)\\b'));
	  return match && match[1];
	}
	
	var DefaultQueryKey = '_k';
	
	function createHashHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Hash history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var queryKey = options.queryKey;
	
	  if (queryKey === undefined || !!queryKey) queryKey = typeof queryKey === 'string' ? queryKey : DefaultQueryKey;
	
	  function getCurrentLocation() {
	    var path = _DOMUtils.getHashPath();
	
	    var key = undefined,
	        state = undefined;
	    if (queryKey) {
	      key = getQueryStringValueFromPath(path, queryKey);
	      path = stripQueryStringValueFromPath(path, queryKey);
	
	      if (key) {
	        state = _DOMStateStorage.readState(key);
	      } else {
	        state = null;
	        key = history.createKey();
	        _DOMUtils.replaceHashPath(addQueryStringValueToPath(path, queryKey, key));
	      }
	    } else {
	      key = state = null;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startHashChangeListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function hashChangeListener() {
	      if (!ensureSlash()) return; // Always make sure hashes are preceeded with a /.
	
	      transitionTo(getCurrentLocation());
	    }
	
	    ensureSlash();
	    _DOMUtils.addEventListener(window, 'hashchange', hashChangeListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'hashchange', hashChangeListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    var path = (basename || '') + pathname + search;
	
	    if (queryKey) {
	      path = addQueryStringValueToPath(path, queryKey, key);
	      _DOMStateStorage.saveState(key, state);
	    } else {
	      // Drop key and state.
	      location.key = location.state = null;
	    }
	
	    var currentHash = _DOMUtils.getHashPath();
	
	    if (action === _Actions.PUSH) {
	      if (currentHash !== path) {
	        window.location.hash = path;
	      } else {
	         false ? _warning2['default'](false, 'You cannot PUSH the same path using hash history') : undefined;
	      }
	    } else if (currentHash !== path) {
	      // REPLACE
	      _DOMUtils.replaceHashPath(path);
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopHashChangeListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopHashChangeListener();
	    };
	  }
	
	  function push(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.push(location);
	  }
	
	  function replace(location) {
	     false ? _warning2['default'](queryKey || location.state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replace(location);
	  }
	
	  var goIsSupportedWithoutReload = _DOMUtils.supportsGoWithoutReloadUsingHash();
	
	  function go(n) {
	     false ? _warning2['default'](goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : undefined;
	
	    history.go(n);
	  }
	
	  function createHref(path) {
	    return '#' + history.createHref(path);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopHashChangeListener = startHashChangeListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopHashChangeListener();
	  }
	
	  // deprecated
	  function pushState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.pushState(state, path);
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	     false ? _warning2['default'](queryKey || state == null, 'You cannot use state without a queryKey it will be dropped') : undefined;
	
	    history.replaceState(state, path);
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    push: push,
	    replace: replace,
	    go: go,
	    createHref: createHref,
	
	    registerTransitionHook: registerTransitionHook, // deprecated - warning is in createHistory
	    unregisterTransitionHook: unregisterTransitionHook, // deprecated - warning is in createHistory
	    pushState: pushState, // deprecated - warning is in createHistory
	    replaceState: replaceState // deprecated - warning is in createHistory
	  });
	}
	
	exports['default'] = createHashHistory;
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _deepEqual = __webpack_require__(471);
	
	var _deepEqual2 = _interopRequireDefault(_deepEqual);
	
	var _PathUtils = __webpack_require__(36);
	
	var _AsyncUtils = __webpack_require__(467);
	
	var _Actions = __webpack_require__(43);
	
	var _createLocation2 = __webpack_require__(469);
	
	var _createLocation3 = _interopRequireDefault(_createLocation2);
	
	var _runTransitionHook = __webpack_require__(111);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(110);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function createRandomKey(length) {
	  return Math.random().toString(36).substr(2, length);
	}
	
	function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search &&
	  //a.action === b.action && // Different action !== location change.
	  a.key === b.key && _deepEqual2['default'](a.state, b.state);
	}
	
	var DefaultKeyLength = 6;
	
	function createHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	  var getCurrentLocation = options.getCurrentLocation;
	  var finishTransition = options.finishTransition;
	  var saveState = options.saveState;
	  var go = options.go;
	  var getUserConfirmation = options.getUserConfirmation;
	  var keyLength = options.keyLength;
	
	  if (typeof keyLength !== 'number') keyLength = DefaultKeyLength;
	
	  var transitionHooks = [];
	
	  function listenBefore(hook) {
	    transitionHooks.push(hook);
	
	    return function () {
	      transitionHooks = transitionHooks.filter(function (item) {
	        return item !== hook;
	      });
	    };
	  }
	
	  var allKeys = [];
	  var changeListeners = [];
	  var location = undefined;
	
	  function getCurrent() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) {
	      return allKeys.indexOf(pendingLocation.key);
	    } else if (location) {
	      return allKeys.indexOf(location.key);
	    } else {
	      return -1;
	    }
	  }
	
	  function updateLocation(newLocation) {
	    var current = getCurrent();
	
	    location = newLocation;
	
	    if (location.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, current + 1), [location.key]);
	    } else if (location.action === _Actions.REPLACE) {
	      allKeys[current] = location.key;
	    }
	
	    changeListeners.forEach(function (listener) {
	      listener(location);
	    });
	  }
	
	  function listen(listener) {
	    changeListeners.push(listener);
	
	    if (location) {
	      listener(location);
	    } else {
	      var _location = getCurrentLocation();
	      allKeys = [_location.key];
	      updateLocation(_location);
	    }
	
	    return function () {
	      changeListeners = changeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }
	
	  function confirmTransitionTo(location, callback) {
	    _AsyncUtils.loopAsync(transitionHooks.length, function (index, next, done) {
	      _runTransitionHook2['default'](transitionHooks[index], location, function (result) {
	        if (result != null) {
	          done(result);
	        } else {
	          next();
	        }
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  }
	
	  var pendingLocation = undefined;
	
	  function transitionTo(nextLocation) {
	    if (location && locationsAreEqual(location, nextLocation)) return; // Nothing to do.
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted.
	
	      if (ok) {
	        // treat PUSH to current path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = createPath(location);
	          var nextPath = createPath(nextLocation);
	
	          if (nextPath === prevPath && _deepEqual2['default'](location.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (finishTransition(nextLocation) !== false) updateLocation(nextLocation);
	      } else if (location && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(location.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL.
	      }
	    });
	  }
	
	  function push(location) {
	    transitionTo(createLocation(location, _Actions.PUSH, createKey()));
	  }
	
	  function replace(location) {
	    transitionTo(createLocation(location, _Actions.REPLACE, createKey()));
	  }
	
	  function goBack() {
	    go(-1);
	  }
	
	  function goForward() {
	    go(1);
	  }
	
	  function createKey() {
	    return createRandomKey(keyLength);
	  }
	
	  function createPath(location) {
	    if (location == null || typeof location === 'string') return location;
	
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	
	    var result = pathname;
	
	    if (search) result += search;
	
	    if (hash) result += hash;
	
	    return result;
	  }
	
	  function createHref(location) {
	    return createPath(location);
	  }
	
	  function createLocation(location, action) {
	    var key = arguments.length <= 2 || arguments[2] === undefined ? createKey() : arguments[2];
	
	    if (typeof action === 'object') {
	       false ? _warning2['default'](false, 'The state (2nd) argument to history.createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      location = _extends({}, location, { state: action });
	
	      action = key;
	      key = arguments[3] || createKey();
	    }
	
	    return _createLocation3['default'](location, action, key);
	  }
	
	  // deprecated
	  function setState(state) {
	    if (location) {
	      updateLocationState(location, state);
	      updateLocation(location);
	    } else {
	      updateLocationState(getCurrentLocation(), state);
	    }
	  }
	
	  function updateLocationState(location, state) {
	    location.state = _extends({}, location.state, state);
	    saveState(location.key, location.state);
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (transitionHooks.indexOf(hook) === -1) transitionHooks.push(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    transitionHooks = transitionHooks.filter(function (item) {
	      return item !== hook;
	    });
	  }
	
	  // deprecated
	  function pushState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    push(_extends({ state: state }, path));
	  }
	
	  // deprecated
	  function replaceState(state, path) {
	    if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	    replace(_extends({ state: state }, path));
	  }
	
	  return {
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: createPath,
	    createHref: createHref,
	    createLocation: createLocation,
	
	    setState: _deprecate2['default'](setState, 'setState is deprecated; use location.key to save state instead'),
	    registerTransitionHook: _deprecate2['default'](registerTransitionHook, 'registerTransitionHook is deprecated; use listenBefore instead'),
	    unregisterTransitionHook: _deprecate2['default'](unregisterTransitionHook, 'unregisterTransitionHook is deprecated; use the callback returned from listenBefore instead'),
	    pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	    replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	  };
	}
	
	exports['default'] = createHistory;
	module.exports = exports['default'];

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ExecutionEnvironment = __webpack_require__(75);
	
	var _PathUtils = __webpack_require__(36);
	
	var _runTransitionHook = __webpack_require__(111);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _deprecate = __webpack_require__(110);
	
	var _deprecate2 = _interopRequireDefault(_deprecate);
	
	function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var history = createHistory(options);
	
	    var basename = options.basename;
	
	    var checkedBaseHref = false;
	
	    function checkBaseHref() {
	      if (checkedBaseHref) {
	        return;
	      }
	
	      // Automatically use the value of <base href> in HTML
	      // documents as basename if it's not explicitly given.
	      if (basename == null && _ExecutionEnvironment.canUseDOM) {
	        var base = document.getElementsByTagName('base')[0];
	        var baseHref = base && base.getAttribute('href');
	
	        if (baseHref != null) {
	          basename = baseHref;
	
	           false ? _warning2['default'](false, 'Automatically setting basename using <base href> is deprecated and will ' + 'be removed in the next major release. The semantics of <base href> are ' + 'subtly different from basename. Please pass the basename explicitly in ' + 'the options to createHistory') : undefined;
	        }
	      }
	
	      checkedBaseHref = true;
	    }
	
	    function addBasename(location) {
	      checkBaseHref();
	
	      if (basename && location.basename == null) {
	        if (location.pathname.indexOf(basename) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    }
	
	    function prependBasename(location) {
	      checkBaseHref();
	
	      if (!basename) return location;
	
	      if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	      var pname = location.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, location, {
	        pathname: pathname
	      });
	    }
	
	    // Override all read methods with basename-aware versions.
	    function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        _runTransitionHook2['default'](hook, addBasename(location), callback);
	      });
	    }
	
	    function listen(listener) {
	      return history.listen(function (location) {
	        listener(addBasename(location));
	      });
	    }
	
	    // Override all write methods with basename-aware versions.
	    function push(location) {
	      history.push(prependBasename(location));
	    }
	
	    function replace(location) {
	      history.replace(prependBasename(location));
	    }
	
	    function createPath(location) {
	      return history.createPath(prependBasename(location));
	    }
	
	    function createHref(location) {
	      return history.createHref(prependBasename(location));
	    }
	
	    function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    }
	
	    // deprecated
	    function pushState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      push(_extends({ state: state }, path));
	    }
	
	    // deprecated
	    function replaceState(state, path) {
	      if (typeof path === 'string') path = _PathUtils.parsePath(path);
	
	      replace(_extends({ state: state }, path));
	    }
	
	    return _extends({}, history, {
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation,
	
	      pushState: _deprecate2['default'](pushState, 'pushState is deprecated; use push instead'),
	      replaceState: _deprecate2['default'](replaceState, 'replaceState is deprecated; use replace instead')
	    });
	  };
	}
	
	exports['default'] = useBasename;
	module.exports = exports['default'];

/***/ },
/* 185 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSProperty
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridColumn: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CallbackQueue
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(30);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	function CallbackQueue() {
	  this._callbacks = null;
	  this._contexts = null;
	}
	
	_assign(CallbackQueue.prototype, {
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	  enqueue: function (callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._contexts = this._contexts || [];
	    this._callbacks.push(callback);
	    this._contexts.push(context);
	  },
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	  notifyAll: function () {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    if (callbacks) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i]);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  },
	
	  checkpoint: function () {
	    return this._callbacks ? this._callbacks.length : 0;
	  },
	
	  rollback: function (len) {
	    if (this._callbacks) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  },
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	  reset: function () {
	    this._callbacks = null;
	    this._contexts = null;
	  },
	
	  /**
	   * `PooledClass` looks for this.
	   */
	  destructor: function () {
	    this.reset();
	  }
	
	});
	
	PooledClass.addPoolingTo(CallbackQueue);
	
	module.exports = CallbackQueue;

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DOMPropertyOperations
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMInstrumentation = __webpack_require__(503);
	var ReactInstrumentation = __webpack_require__(15);
	
	var quoteAttributeValueForBrowser = __webpack_require__(545);
	var warning = __webpack_require__(5);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onCreateMarkupForProperty(name, value);
	    }
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onSetValueForProperty(node, name, value);
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'update attribute', payload);
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactDOMInstrumentation.debugTool.onDeleteValueForProperty(node, name);
	      ReactInstrumentation.debugTool.onHostOperation(ReactDOMComponentTree.getInstanceFromNode(node)._debugID, 'remove attribute', name);
	    }
	  }
	
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule React
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactChildren = __webpack_require__(117);
	var ReactComponent = __webpack_require__(190);
	var ReactClass = __webpack_require__(189);
	var ReactDOMFactories = __webpack_require__(499);
	var ReactElement = __webpack_require__(18);
	var ReactPropTypes = __webpack_require__(202);
	var ReactVersion = __webpack_require__(203);
	
	var onlyChild = __webpack_require__(544);
	var warning = __webpack_require__(5);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	
	if (false) {
	  var warned = false;
	  __spread = function () {
	    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
	    warned = true;
	    return _assign.apply(null, arguments);
	  };
	}
	
	var React = {
	
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: ReactClass.createClass,
	  createFactory: createFactory,
	  createMixin: function (mixin) {
	    // Currently a noop. Will be used to validate and trace mixins.
	    return mixin;
	  },
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	module.exports = React;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactClass
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var ReactComponent = __webpack_require__(190);
	var ReactElement = __webpack_require__(18);
	var ReactPropTypeLocations = __webpack_require__(121);
	var ReactPropTypeLocationNames = __webpack_require__(120);
	var ReactNoopUpdateQueue = __webpack_require__(201);
	
	var emptyObject = __webpack_require__(83);
	var invariant = __webpack_require__(3);
	var keyMirror = __webpack_require__(84);
	var keyOf = __webpack_require__(31);
	var warning = __webpack_require__(5);
	
	var MIXINS_KEY = keyOf({ mixins: null });
	
	/**
	 * Policies that describe methods in `ReactClassInterface`.
	 */
	var SpecPolicy = keyMirror({
	  /**
	   * These methods may be defined only once by the class specification or mixin.
	   */
	  DEFINE_ONCE: null,
	  /**
	   * These methods may be defined by both the class specification and mixins.
	   * Subsequent definitions will be chained. These methods must return void.
	   */
	  DEFINE_MANY: null,
	  /**
	   * These methods are overriding the base class.
	   */
	  OVERRIDE_BASE: null,
	  /**
	   * These methods are similar to DEFINE_MANY, except we assume they return
	   * objects. We try to merge the keys of the return values of all the mixed in
	   * functions. If there is a key conflict we throw.
	   */
	  DEFINE_MANY_MERGED: null
	});
	
	var injectedMixins = [];
	
	/**
	 * Composite components are higher-level components that compose other composite
	 * or host components.
	 *
	 * To create a new type of `ReactClass`, pass a specification of
	 * your new class to `React.createClass`. The only requirement of your class
	 * specification is that you implement a `render` method.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return <div>Hello World</div>;
	 *     }
	 *   });
	 *
	 * The class specification supports a specific protocol of methods that have
	 * special meaning (e.g. `render`). See `ReactClassInterface` for
	 * more the comprehensive protocol. Any other properties and methods in the
	 * class specification will be available on the prototype.
	 *
	 * @interface ReactClassInterface
	 * @internal
	 */
	var ReactClassInterface = {
	
	  /**
	   * An array of Mixin objects to include when defining your component.
	   *
	   * @type {array}
	   * @optional
	   */
	  mixins: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * An object containing properties and methods that should be defined on
	   * the component's constructor instead of its prototype (static methods).
	   *
	   * @type {object}
	   * @optional
	   */
	  statics: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of prop types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  propTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types for this component.
	   *
	   * @type {object}
	   * @optional
	   */
	  contextTypes: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Definition of context types this component sets for its children.
	   *
	   * @type {object}
	   * @optional
	   */
	  childContextTypes: SpecPolicy.DEFINE_MANY,
	
	  // ==== Definition methods ====
	
	  /**
	   * Invoked when the component is mounted. Values in the mapping will be set on
	   * `this.props` if that prop is not specified (i.e. using an `in` check).
	   *
	   * This method is invoked before `getInitialState` and therefore cannot rely
	   * on `this.state` or use `this.setState`.
	   *
	   * @return {object}
	   * @optional
	   */
	  getDefaultProps: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Invoked once before the component is mounted. The return value will be used
	   * as the initial value of `this.state`.
	   *
	   *   getInitialState: function() {
	   *     return {
	   *       isOn: false,
	   *       fooBaz: new BazFoo()
	   *     }
	   *   }
	   *
	   * @return {object}
	   * @optional
	   */
	  getInitialState: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * @return {object}
	   * @optional
	   */
	  getChildContext: SpecPolicy.DEFINE_MANY_MERGED,
	
	  /**
	   * Uses props from `this.props` and state from `this.state` to render the
	   * structure of the component.
	   *
	   * No guarantees are made about when or how often this method is invoked, so
	   * it must not have side effects.
	   *
	   *   render: function() {
	   *     var name = this.props.name;
	   *     return <div>Hello, {name}!</div>;
	   *   }
	   *
	   * @return {ReactComponent}
	   * @nosideeffects
	   * @required
	   */
	  render: SpecPolicy.DEFINE_ONCE,
	
	  // ==== Delegate methods ====
	
	  /**
	   * Invoked when the component is initially created and about to be mounted.
	   * This may have side effects, but any external subscriptions or data created
	   * by this method must be cleaned up in `componentWillUnmount`.
	   *
	   * @optional
	   */
	  componentWillMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component has been mounted and has a DOM representation.
	   * However, there is no guarantee that the DOM node is in the document.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been mounted (initialized and rendered) for the first time.
	   *
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidMount: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked before the component receives new props.
	   *
	   * Use this as an opportunity to react to a prop transition by updating the
	   * state using `this.setState`. Current props are accessed via `this.props`.
	   *
	   *   componentWillReceiveProps: function(nextProps, nextContext) {
	   *     this.setState({
	   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	   *     });
	   *   }
	   *
	   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	   * transition may cause a state change, but the opposite is not true. If you
	   * need it, you are probably looking for `componentWillUpdate`.
	   *
	   * @param {object} nextProps
	   * @optional
	   */
	  componentWillReceiveProps: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked while deciding if the component should be updated as a result of
	   * receiving new props, state and/or context.
	   *
	   * Use this as an opportunity to `return false` when you're certain that the
	   * transition to the new props/state/context will not require a component
	   * update.
	   *
	   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	   *     return !equal(nextProps, this.props) ||
	   *       !equal(nextState, this.state) ||
	   *       !equal(nextContext, this.context);
	   *   }
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @return {boolean} True if the component should update.
	   * @optional
	   */
	  shouldComponentUpdate: SpecPolicy.DEFINE_ONCE,
	
	  /**
	   * Invoked when the component is about to update due to a transition from
	   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	   * and `nextContext`.
	   *
	   * Use this as an opportunity to perform preparation before an update occurs.
	   *
	   * NOTE: You **cannot** use `this.setState()` in this method.
	   *
	   * @param {object} nextProps
	   * @param {?object} nextState
	   * @param {?object} nextContext
	   * @param {ReactReconcileTransaction} transaction
	   * @optional
	   */
	  componentWillUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component's DOM representation has been updated.
	   *
	   * Use this as an opportunity to operate on the DOM when the component has
	   * been updated.
	   *
	   * @param {object} prevProps
	   * @param {?object} prevState
	   * @param {?object} prevContext
	   * @param {DOMElement} rootNode DOM element representing the component.
	   * @optional
	   */
	  componentDidUpdate: SpecPolicy.DEFINE_MANY,
	
	  /**
	   * Invoked when the component is about to be removed from its parent and have
	   * its DOM representation destroyed.
	   *
	   * Use this as an opportunity to deallocate any external resources.
	   *
	   * NOTE: There is no `componentDidUnmount` since your component will have been
	   * destroyed by that point.
	   *
	   * @optional
	   */
	  componentWillUnmount: SpecPolicy.DEFINE_MANY,
	
	  // ==== Advanced methods ====
	
	  /**
	   * Updates the component's currently mounted DOM representation.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   * @overridable
	   */
	  updateComponent: SpecPolicy.OVERRIDE_BASE
	
	};
	
	/**
	 * Mapping from class specification keys to special processing functions.
	 *
	 * Although these are declared like instance properties in the specification
	 * when defining classes using `React.createClass`, they are actually static
	 * and are accessible on the constructor instead of the prototype. Despite
	 * being static, they must be defined outside of the "statics" key under
	 * which all other static methods are defined.
	 */
	var RESERVED_SPEC_KEYS = {
	  displayName: function (Constructor, displayName) {
	    Constructor.displayName = displayName;
	  },
	  mixins: function (Constructor, mixins) {
	    if (mixins) {
	      for (var i = 0; i < mixins.length; i++) {
	        mixSpecIntoComponent(Constructor, mixins[i]);
	      }
	    }
	  },
	  childContextTypes: function (Constructor, childContextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, childContextTypes, ReactPropTypeLocations.childContext);
	    }
	    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
	  },
	  contextTypes: function (Constructor, contextTypes) {
	    if (false) {
	      validateTypeDef(Constructor, contextTypes, ReactPropTypeLocations.context);
	    }
	    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
	  },
	  /**
	   * Special case getDefaultProps which should move into statics but requires
	   * automatic merging.
	   */
	  getDefaultProps: function (Constructor, getDefaultProps) {
	    if (Constructor.getDefaultProps) {
	      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
	    } else {
	      Constructor.getDefaultProps = getDefaultProps;
	    }
	  },
	  propTypes: function (Constructor, propTypes) {
	    if (false) {
	      validateTypeDef(Constructor, propTypes, ReactPropTypeLocations.prop);
	    }
	    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	  },
	  statics: function (Constructor, statics) {
	    mixStaticSpecIntoComponent(Constructor, statics);
	  },
	  autobind: function () {} };
	
	// noop
	function validateTypeDef(Constructor, typeDef, location) {
	  for (var propName in typeDef) {
	    if (typeDef.hasOwnProperty(propName)) {
	      // use a warning instead of an invariant so components
	      // don't show up in prod but only in __DEV__
	       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
	    }
	  }
	}
	
	function validateMethodOverride(isAlreadyDefined, name) {
	  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
	
	  // Disallow overriding of base class methods unless explicitly allowed.
	  if (ReactClassMixin.hasOwnProperty(name)) {
	    !(specPolicy === SpecPolicy.OVERRIDE_BASE) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
	  }
	
	  // Disallow defining methods more than once unless explicitly allowed.
	  if (isAlreadyDefined) {
	    !(specPolicy === SpecPolicy.DEFINE_MANY || specPolicy === SpecPolicy.DEFINE_MANY_MERGED) ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
	  }
	}
	
	/**
	 * Mixin helper which handles policy validation and reserved
	 * specification keys when building React classes.
	 */
	function mixSpecIntoComponent(Constructor, spec) {
	  if (!spec) {
	    return;
	  }
	
	  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
	  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;
	
	  var proto = Constructor.prototype;
	  var autoBindPairs = proto.__reactAutoBindPairs;
	
	  // By handling mixins before any other properties, we ensure the same
	  // chaining order is applied to methods with DEFINE_MANY policy, whether
	  // mixins are listed before or after these methods in the spec.
	  if (spec.hasOwnProperty(MIXINS_KEY)) {
	    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	  }
	
	  for (var name in spec) {
	    if (!spec.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (name === MIXINS_KEY) {
	      // We have already handled mixins in a special case above.
	      continue;
	    }
	
	    var property = spec[name];
	    var isAlreadyDefined = proto.hasOwnProperty(name);
	    validateMethodOverride(isAlreadyDefined, name);
	
	    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	      RESERVED_SPEC_KEYS[name](Constructor, property);
	    } else {
	      // Setup methods on prototype:
	      // The following member methods should not be automatically bound:
	      // 1. Expected ReactClass methods (in the "interface").
	      // 2. Overridden methods (that were mixed in).
	      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	      var isFunction = typeof property === 'function';
	      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
	
	      if (shouldAutoBind) {
	        autoBindPairs.push(name, property);
	        proto[name] = property;
	      } else {
	        if (isAlreadyDefined) {
	          var specPolicy = ReactClassInterface[name];
	
	          // These cases should already be caught by validateMethodOverride.
	          !(isReactClassMethod && (specPolicy === SpecPolicy.DEFINE_MANY_MERGED || specPolicy === SpecPolicy.DEFINE_MANY)) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;
	
	          // For methods which are defined more than once, call the existing
	          // methods before calling the new property, merging if appropriate.
	          if (specPolicy === SpecPolicy.DEFINE_MANY_MERGED) {
	            proto[name] = createMergedResultFunction(proto[name], property);
	          } else if (specPolicy === SpecPolicy.DEFINE_MANY) {
	            proto[name] = createChainedFunction(proto[name], property);
	          }
	        } else {
	          proto[name] = property;
	          if (false) {
	            // Add verbose displayName to the function, which helps when looking
	            // at profiling tools.
	            if (typeof property === 'function' && spec.displayName) {
	              proto[name].displayName = spec.displayName + '_' + name;
	            }
	          }
	        }
	      }
	    }
	  }
	}
	
	function mixStaticSpecIntoComponent(Constructor, statics) {
	  if (!statics) {
	    return;
	  }
	  for (var name in statics) {
	    var property = statics[name];
	    if (!statics.hasOwnProperty(name)) {
	      continue;
	    }
	
	    var isReserved = name in RESERVED_SPEC_KEYS;
	    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;
	
	    var isInherited = name in Constructor;
	    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
	    Constructor[name] = property;
	  }
	}
	
	/**
	 * Merge two objects, but throw if both contain the same key.
	 *
	 * @param {object} one The first object, which is mutated.
	 * @param {object} two The second object
	 * @return {object} one after it has been mutated to contain everything in two.
	 */
	function mergeIntoWithNoDuplicateKeys(one, two) {
	  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;
	
	  for (var key in two) {
	    if (two.hasOwnProperty(key)) {
	      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
	      one[key] = two[key];
	    }
	  }
	  return one;
	}
	
	/**
	 * Creates a function that invokes two functions and merges their return values.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createMergedResultFunction(one, two) {
	  return function mergedResult() {
	    var a = one.apply(this, arguments);
	    var b = two.apply(this, arguments);
	    if (a == null) {
	      return b;
	    } else if (b == null) {
	      return a;
	    }
	    var c = {};
	    mergeIntoWithNoDuplicateKeys(c, a);
	    mergeIntoWithNoDuplicateKeys(c, b);
	    return c;
	  };
	}
	
	/**
	 * Creates a function that invokes two functions and ignores their return vales.
	 *
	 * @param {function} one Function to invoke first.
	 * @param {function} two Function to invoke second.
	 * @return {function} Function that invokes the two argument functions.
	 * @private
	 */
	function createChainedFunction(one, two) {
	  return function chainedFunction() {
	    one.apply(this, arguments);
	    two.apply(this, arguments);
	  };
	}
	
	/**
	 * Binds a method to the component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 * @param {function} method Method to be bound.
	 * @return {function} The bound method.
	 */
	function bindAutoBindMethod(component, method) {
	  var boundMethod = method.bind(component);
	  if (false) {
	    boundMethod.__reactBoundContext = component;
	    boundMethod.__reactBoundMethod = method;
	    boundMethod.__reactBoundArguments = null;
	    var componentName = component.constructor.displayName;
	    var _bind = boundMethod.bind;
	    boundMethod.bind = function (newThis) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      // User is trying to bind() an autobound method; we effectively will
	      // ignore the value of "this" that the user is trying to use, so
	      // let's warn.
	      if (newThis !== component && newThis !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
	      } else if (!args.length) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
	        return boundMethod;
	      }
	      var reboundMethod = _bind.apply(boundMethod, arguments);
	      reboundMethod.__reactBoundContext = component;
	      reboundMethod.__reactBoundMethod = method;
	      reboundMethod.__reactBoundArguments = args;
	      return reboundMethod;
	    };
	  }
	  return boundMethod;
	}
	
	/**
	 * Binds all auto-bound methods in a component.
	 *
	 * @param {object} component Component whose method is going to be bound.
	 */
	function bindAutoBindMethods(component) {
	  var pairs = component.__reactAutoBindPairs;
	  for (var i = 0; i < pairs.length; i += 2) {
	    var autoBindKey = pairs[i];
	    var method = pairs[i + 1];
	    component[autoBindKey] = bindAutoBindMethod(component, method);
	  }
	}
	
	/**
	 * Add more to the ReactClass base class. These are all legacy features and
	 * therefore not already part of the modern ReactComponent.
	 */
	var ReactClassMixin = {
	
	  /**
	   * TODO: This will be deprecated because state should always keep a consistent
	   * type signature and the only use case for this, is to avoid that.
	   */
	  replaceState: function (newState, callback) {
	    this.updater.enqueueReplaceState(this, newState);
	    if (callback) {
	      this.updater.enqueueCallback(this, callback, 'replaceState');
	    }
	  },
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function () {
	    return this.updater.isMounted(this);
	  }
	};
	
	var ReactClassComponent = function () {};
	_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
	
	/**
	 * Module for creating composite components.
	 *
	 * @class ReactClass
	 */
	var ReactClass = {
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  createClass: function (spec) {
	    var Constructor = function (props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (initialState === undefined && this.getInitialState._isMockFunction) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;
	
	      this.state = initialState;
	    };
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, spec);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  },
	
	  injection: {
	    injectMixin: function (mixin) {
	      injectedMixins.push(mixin);
	    }
	  }
	
	};
	
	module.exports = ReactClass;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactNoopUpdateQueue = __webpack_require__(201);
	
	var canDefineProperty = __webpack_require__(205);
	var emptyObject = __webpack_require__(83);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	module.exports = ReactComponent;

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentBrowserEnvironment
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(112);
	var ReactDOMIDOperations = __webpack_require__(501);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup,
	
	  /**
	   * If a particular environment requires that some resources be cleaned up,
	   * specify this in the injected Mixin. In the DOM, we would likely want to
	   * purge any cached node ID lookups.
	   *
	   * @private
	   */
	  unmountIDFromEnvironment: function (rootNodeID) {}
	
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 192 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponentFlags
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelect
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var DisabledInputUtils = __webpack_require__(77);
	var LinkedValueUtils = __webpack_require__(116);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(23);
	
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    if (props.multiple) {
	       false ? warning(Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else {
	       false ? warning(!Array.isArray(props[propName]), 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 194 */
/***/ function(module, exports) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEmptyComponent
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 195 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFeatureFlags
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactHostComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var invariant = __webpack_require__(3);
	
	var genericComponentClass = null;
	// This registry keeps track of wrapper classes around host tags.
	var tagToComponentClass = {};
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  },
	  // This accepts a keyed object with classes as values. Each key represents a
	  // tag. That particular tag will use this class instead of the generic one.
	  injectComponentClasses: function (componentClasses) {
	    _assign(tagToComponentClass, componentClasses);
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInputSelection
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(505);
	
	var containsNode = __webpack_require__(549);
	var focusNode = __webpack_require__(215);
	var getActiveElement = __webpack_require__(216);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMount
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(44);
	var DOMProperty = __webpack_require__(45);
	var ReactBrowserEventEmitter = __webpack_require__(79);
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMContainerInfo = __webpack_require__(497);
	var ReactDOMFeatureFlags = __webpack_require__(500);
	var ReactElement = __webpack_require__(18);
	var ReactFeatureFlags = __webpack_require__(195);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(15);
	var ReactMarkupChecksum = __webpack_require__(515);
	var ReactReconciler = __webpack_require__(49);
	var ReactUpdateQueue = __webpack_require__(122);
	var ReactUpdates = __webpack_require__(23);
	
	var emptyObject = __webpack_require__(83);
	var instantiateReactComponent = __webpack_require__(211);
	var invariant = __webpack_require__(3);
	var setInnerHTML = __webpack_require__(82);
	var shouldUpdateReactComponent = __webpack_require__(129);
	var warning = __webpack_require__(5);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context);
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  // this.props is actually a ReactElement
	  return this.props;
	};
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by devtools!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    if (false) {
	      // The instance here is TopLevelWrapper so we report mount for its child.
	      ReactInstrumentation.debugTool.onMountRootComponent(componentInstance._renderedComponent._debugID);
	    }
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !ReactElement.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' :
	    // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? ' Instead of passing a string like \'div\', pass ' + 'React.createElement(\'div\') or <div />.' : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = ReactElement(TopLevelWrapper, null, null, null, null, null, nextElement);
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'unmountComponentAtNode(): The node you\'re attempting to unmount ' + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !(container && (container.nodeType === ELEMENT_NODE_TYPE || container.nodeType === DOC_NODE_TYPE || container.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE)) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation(hostNode._debugID, 'mount', markup.toString());
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChildUpdateTypes
	 */
	
	'use strict';
	
	var keyMirror = __webpack_require__(84);
	
	/**
	 * When a component's children are updated, a series of update configuration
	 * objects are created in order to batch and serialize the required changes.
	 *
	 * Enumerates all the possible types of update configurations.
	 *
	 * @internal
	 */
	var ReactMultiChildUpdateTypes = keyMirror({
	  INSERT_MARKUP: null,
	  MOVE_EXISTING: null,
	  REMOVE_NODE: null,
	  SET_MARKUP: null,
	  TEXT_CONTENT: null
	});
	
	module.exports = ReactMultiChildUpdateTypes;

/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNodeTypes
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactElement = __webpack_require__(18);
	
	var invariant = __webpack_require__(3);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (ReactElement.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactNoopUpdateQueue
	 */
	
	'use strict';
	
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactPropTypes
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(18);
	var ReactPropTypeLocationNames = __webpack_require__(120);
	
	var emptyFunction = __webpack_require__(16);
	var getIteratorFn = __webpack_require__(209);
	
	/**
	 * Collection of methods that allow declaration and validation of props that are
	 * supplied to React components. Example usage:
	 *
	 *   var Props = require('ReactPropTypes');
	 *   var MyArticle = React.createClass({
	 *     propTypes: {
	 *       // An optional string prop named "description".
	 *       description: Props.string,
	 *
	 *       // A required enum prop named "category".
	 *       category: Props.oneOf(['News','Photos']).isRequired,
	 *
	 *       // A prop named "dialog" that requires an instance of Dialog.
	 *       dialog: Props.instanceOf(Dialog).isRequired
	 *     },
	 *     render: function() { ... }
	 *   });
	 *
	 * A more formal specification of how these methods are used:
	 *
	 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	 *   decl := ReactPropTypes.{type}(.isRequired)?
	 *
	 * Each and every declaration produces a function with the same signature. This
	 * allows the creation of custom validation functions. For example:
	 *
	 *  var MyLink = React.createClass({
	 *    propTypes: {
	 *      // An optional string or URI prop named "href".
	 *      href: function(props, propName, componentName) {
	 *        var propValue = props[propName];
	 *        if (propValue != null && typeof propValue !== 'string' &&
	 *            !(propValue instanceof URI)) {
	 *          return new Error(
	 *            'Expected a string or an URI for ' + propName + ' in ' +
	 *            componentName
	 *          );
	 *        }
	 *      }
	 *    },
	 *    render: function() {...}
	 *  });
	 *
	 * @internal
	 */
	
	var ANONYMOUS = '<<anonymous>>';
	
	var ReactPropTypes = {
	  array: createPrimitiveTypeChecker('array'),
	  bool: createPrimitiveTypeChecker('boolean'),
	  func: createPrimitiveTypeChecker('function'),
	  number: createPrimitiveTypeChecker('number'),
	  object: createPrimitiveTypeChecker('object'),
	  string: createPrimitiveTypeChecker('string'),
	  symbol: createPrimitiveTypeChecker('symbol'),
	
	  any: createAnyTypeChecker(),
	  arrayOf: createArrayOfTypeChecker,
	  element: createElementTypeChecker(),
	  instanceOf: createInstanceTypeChecker,
	  node: createNodeChecker(),
	  objectOf: createObjectOfTypeChecker,
	  oneOf: createEnumTypeChecker,
	  oneOfType: createUnionTypeChecker,
	  shape: createShapeTypeChecker
	};
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	/*eslint-disable no-self-compare*/
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	/*eslint-enable no-self-compare*/
	
	function createChainableTypeChecker(validate) {
	  function checkType(isRequired, props, propName, componentName, location, propFullName) {
	    componentName = componentName || ANONYMOUS;
	    propFullName = propFullName || propName;
	    if (props[propName] == null) {
	      var locationName = ReactPropTypeLocationNames[location];
	      if (isRequired) {
	        return new Error('Required ' + locationName + ' `' + propFullName + '` was not specified in ' + ('`' + componentName + '`.'));
	      }
	      return null;
	    } else {
	      return validate(props, propName, componentName, location, propFullName);
	    }
	  }
	
	  var chainedCheckType = checkType.bind(null, false);
	  chainedCheckType.isRequired = checkType.bind(null, true);
	
	  return chainedCheckType;
	}
	
	function createPrimitiveTypeChecker(expectedType) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== expectedType) {
	      var locationName = ReactPropTypeLocationNames[location];
	      // `propValue` being instance of, say, date/regexp, pass the 'object'
	      // check, but we can offer a more precise error message here rather than
	      // 'of type `object`'.
	      var preciseType = getPreciseType(propValue);
	
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createAnyTypeChecker() {
	  return createChainableTypeChecker(emptyFunction.thatReturns(null));
	}
	
	function createArrayOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	    }
	    var propValue = props[propName];
	    if (!Array.isArray(propValue)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var propType = getPropType(propValue);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	    }
	    for (var i = 0; i < propValue.length; i++) {
	      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']');
	      if (error instanceof Error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createElementTypeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!ReactElement.isValidElement(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a single ReactElement.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createInstanceTypeChecker(expectedClass) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!(props[propName] instanceof expectedClass)) {
	      var locationName = ReactPropTypeLocationNames[location];
	      var expectedClassName = expectedClass.name || ANONYMOUS;
	      var actualClassName = getClassName(props[propName]);
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createEnumTypeChecker(expectedValues) {
	  if (!Array.isArray(expectedValues)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOf, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    for (var i = 0; i < expectedValues.length; i++) {
	      if (is(propValue, expectedValues[i])) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    var valuesString = JSON.stringify(expectedValues);
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createObjectOfTypeChecker(typeChecker) {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (typeof typeChecker !== 'function') {
	      return new Error('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	    }
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	    }
	    for (var key in propValue) {
	      if (propValue.hasOwnProperty(key)) {
	        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createUnionTypeChecker(arrayOfTypeCheckers) {
	  if (!Array.isArray(arrayOfTypeCheckers)) {
	    return createChainableTypeChecker(function () {
	      return new Error('Invalid argument supplied to oneOfType, expected an instance of array.');
	    });
	  }
	
	  function validate(props, propName, componentName, location, propFullName) {
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (checker(props, propName, componentName, location, propFullName) == null) {
	        return null;
	      }
	    }
	
	    var locationName = ReactPropTypeLocationNames[location];
	    return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createNodeChecker() {
	  function validate(props, propName, componentName, location, propFullName) {
	    if (!isNode(props[propName])) {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function createShapeTypeChecker(shapeTypes) {
	  function validate(props, propName, componentName, location, propFullName) {
	    var propValue = props[propName];
	    var propType = getPropType(propValue);
	    if (propType !== 'object') {
	      var locationName = ReactPropTypeLocationNames[location];
	      return new Error('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	    }
	    for (var key in shapeTypes) {
	      var checker = shapeTypes[key];
	      if (!checker) {
	        continue;
	      }
	      var error = checker(propValue, key, componentName, location, propFullName + '.' + key);
	      if (error) {
	        return error;
	      }
	    }
	    return null;
	  }
	  return createChainableTypeChecker(validate);
	}
	
	function isNode(propValue) {
	  switch (typeof propValue) {
	    case 'number':
	    case 'string':
	    case 'undefined':
	      return true;
	    case 'boolean':
	      return !propValue;
	    case 'object':
	      if (Array.isArray(propValue)) {
	        return propValue.every(isNode);
	      }
	      if (propValue === null || ReactElement.isValidElement(propValue)) {
	        return true;
	      }
	
	      var iteratorFn = getIteratorFn(propValue);
	      if (iteratorFn) {
	        var iterator = iteratorFn.call(propValue);
	        var step;
	        if (iteratorFn !== propValue.entries) {
	          while (!(step = iterator.next()).done) {
	            if (!isNode(step.value)) {
	              return false;
	            }
	          }
	        } else {
	          // Iterator will provide entry [k,v] tuples rather than values.
	          while (!(step = iterator.next()).done) {
	            var entry = step.value;
	            if (entry) {
	              if (!isNode(entry[1])) {
	                return false;
	              }
	            }
	          }
	        }
	      } else {
	        return false;
	      }
	
	      return true;
	    default:
	      return false;
	  }
	}
	
	function isSymbol(propType, propValue) {
	  // Native Symbol.
	  if (propType === 'symbol') {
	    return true;
	  }
	
	  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	  if (propValue['@@toStringTag'] === 'Symbol') {
	    return true;
	  }
	
	  // Fallback for non-spec compliant Symbols which are polyfilled.
	  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	    return true;
	  }
	
	  return false;
	}
	
	// Equivalent of `typeof` but with special handling for array and regexp.
	function getPropType(propValue) {
	  var propType = typeof propValue;
	  if (Array.isArray(propValue)) {
	    return 'array';
	  }
	  if (propValue instanceof RegExp) {
	    // Old webkits (at least until Android 4.0) return 'function' rather than
	    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	    // passes PropTypes.object.
	    return 'object';
	  }
	  if (isSymbol(propType, propValue)) {
	    return 'symbol';
	  }
	  return propType;
	}
	
	// This handles more types than `getPropType`. Only used for error messages.
	// See `createPrimitiveTypeChecker`.
	function getPreciseType(propValue) {
	  var propType = getPropType(propValue);
	  if (propType === 'object') {
	    if (propValue instanceof Date) {
	      return 'date';
	    } else if (propValue instanceof RegExp) {
	      return 'regexp';
	    }
	  }
	  return propType;
	}
	
	// Returns class name of the object, if any.
	function getClassName(propValue) {
	  if (!propValue.constructor || !propValue.constructor.name) {
	    return ANONYMOUS;
	  }
	  return propValue.constructor.name;
	}
	
	module.exports = ReactPropTypes;

/***/ },
/* 203 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactVersion
	 */
	
	'use strict';
	
	module.exports = '15.2.1';

/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule accumulateInto
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule canDefineProperty
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule flattenChildren
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(115);
	var traverseAllChildren = __webpack_require__(130);
	var warning = __webpack_require__(5);
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      var ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	      process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;

/***/ },
/* 207 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule forEachAccumulated
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getHostComponentFromComposite
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(200);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 209 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getIteratorFn
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentAccessor
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule instantiateReactComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var ReactCompositeComponent = __webpack_require__(493);
	var ReactEmptyComponent = __webpack_require__(194);
	var ReactHostComponent = __webpack_require__(196);
	var ReactInstrumentation = __webpack_require__(15);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent.Mixin, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	function getDisplayName(instance) {
	  var element = instance._currentElement;
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else if (instance.getName) {
	    return instance.getName() || 'Unknown';
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	var nextDebugID = 1;
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    !(element && (typeof element.type === 'function' || typeof element.type === 'string')) ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : _prodInvariant('130', element.type == null ? element.type : typeof element.type, getDeclarationErrorAddendum(element._owner)) : void 0;
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    if (shouldHaveDebugID) {
	      var debugID = nextDebugID++;
	      instance._debugID = debugID;
	      var displayName = getDisplayName(instance);
	      ReactInstrumentation.debugTool.onSetDisplayName(debugID, displayName);
	      var owner = node && node._owner;
	      if (owner) {
	        ReactInstrumentation.debugTool.onSetOwner(debugID, owner._debugID);
	      }
	    } else {
	      instance._debugID = 0;
	    }
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	module.exports = instantiateReactComponent;

/***/ },
/* 212 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isTextInputElement
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  'color': true,
	  'date': true,
	  'datetime': true,
	  'datetime-local': true,
	  'email': true,
	  'month': true,
	  'number': true,
	  'password': true,
	  'range': true,
	  'search': true,
	  'tel': true,
	  'text': true,
	  'time': true,
	  'url': true,
	  'week': true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setTextContent
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	var escapeTextContentForBrowser = __webpack_require__(81);
	var setInnerHTML = __webpack_require__(82);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 215 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 216 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 */
	function getActiveElement() /*?DOMElement*/{
	  if (typeof document === 'undefined') {
	    return null;
	  }
	  try {
	    return document.activeElement || document.body;
	  } catch (e) {
	    return document.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 217 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(51),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(600),
	    mapCacheDelete = __webpack_require__(601),
	    mapCacheGet = __webpack_require__(602),
	    mapCacheHas = __webpack_require__(603),
	    mapCacheSet = __webpack_require__(604);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(582);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return object != null &&
	    (hasOwnProperty.call(object, key) ||
	      (typeof object == 'object' && key in object && getPrototype(object) === null));
	}
	
	module.exports = baseHas;


/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(565),
	    arraySome = __webpack_require__(570);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 222 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 223 */
/***/ function(module, exports) {

	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var getLength = __webpack_require__(581),
	    isFunction = __webpack_require__(225),
	    isLength = __webpack_require__(133);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(getLength(value)) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(134);
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8 which returns 'object' for typed array and weak map constructors,
	  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 226 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  } else {
	    var _ret = function () {
	      var last = funcs[funcs.length - 1];
	      var rest = funcs.slice(0, -1);
	      return {
	        v: function v() {
	          return rest.reduceRight(function (composed, f) {
	            return f(composed);
	          }, last.apply(undefined, arguments));
	        }
	      };
	    }();
	
	    if (typeof _ret === "object") return _ret.v;
	  }
	}

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports["default"] = createStore;
	
	var _isPlainObject = __webpack_require__(229);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(627);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	};
	
	/**
	 * Creates a Redux store that holds the state tree.
	 * The only way to change the data in the store is to call `dispatch()` on it.
	 *
	 * There should only be a single store in your app. To specify how different
	 * parts of the state tree respond to actions, you may combine several reducers
	 * into a single reducer function by using `combineReducers`.
	 *
	 * @param {Function} reducer A function that returns the next state tree, given
	 * the current state tree and the action to handle.
	 *
	 * @param {any} [initialState] The initial state. You may optionally specify it
	 * to hydrate the state from the server in universal apps, or to restore a
	 * previously serialized user session.
	 * If you use `combineReducers` to produce the root reducer function, this must be
	 * an object with the same shape as `combineReducers` keys.
	 *
	 * @param {Function} enhancer The store enhancer. You may optionally specify it
	 * to enhance the store with third-party capabilities such as middleware,
	 * time travel, persistence, etc. The only store enhancer that ships with Redux
	 * is `applyMiddleware()`.
	 *
	 * @returns {Store} A Redux store that lets you read the state, dispatch actions
	 * and subscribe to changes.
	 */
	function createStore(reducer, initialState, enhancer) {
	  var _ref2;
	
	  if (typeof initialState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = initialState;
	    initialState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, initialState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = initialState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/zenparsing/es-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2["default"]] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2["default"]] = observable, _ref2;
	}

/***/ },
/* 228 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(624),
	    isHostObject = __webpack_require__(625),
	    isObjectLike = __webpack_require__(626);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object,
	 *  else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 231 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 232 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 233 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 234 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 235 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 236 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define('leancloud-realtime', ['exports'], factory) :
		(factory((global.AV = global.AV || {})));
	}(this, function (exports) { 'use strict';
	
		var global = typeof window !== 'undefined' ? window :
		             typeof global !== 'undefined' ? global :
		             this;
		var define = undefined;
		var require = require || function(id) {throw new Error('Unexpected required ' + id)};
	
	
	
		var process = window.process || {};
		process.env = process.env || {};
		var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}
	
		function createCommonjsModule(fn, module) {
			return module = { exports: {} }, fn(module, module.exports), module.exports;
		}
	
		var _core = createCommonjsModule(function (module) {
		var core = module.exports = {version: '2.4.0'};
		if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef
		});
	
		var require$$0$1 = (_core && typeof _core === 'object' && 'default' in _core ? _core['default'] : _core);
	
		var _enumBugKeys = createCommonjsModule(function (module) {
		// IE 8- don't enum bug keys
		module.exports = (
		  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
		).split(',');
		});
	
		var require$$0$2 = (_enumBugKeys && typeof _enumBugKeys === 'object' && 'default' in _enumBugKeys ? _enumBugKeys['default'] : _enumBugKeys);
	
		var _uid = createCommonjsModule(function (module) {
		var id = 0
		  , px = Math.random();
		module.exports = function(key){
		  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
		};
		});
	
		var require$$4$1 = (_uid && typeof _uid === 'object' && 'default' in _uid ? _uid['default'] : _uid);
	
		var _global = createCommonjsModule(function (module) {
		// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
		var global = module.exports = typeof window != 'undefined' && window.Math == Math
		  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
		if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef
		});
	
		var require$$12 = (_global && typeof _global === 'object' && 'default' in _global ? _global['default'] : _global);
	
		var _shared = createCommonjsModule(function (module) {
		var global = require$$12
		  , SHARED = '__core-js_shared__'
		  , store  = global[SHARED] || (global[SHARED] = {});
		module.exports = function(key){
		  return store[key] || (store[key] = {});
		};
		});
	
		var require$$22 = (_shared && typeof _shared === 'object' && 'default' in _shared ? _shared['default'] : _shared);
	
		var _sharedKey = createCommonjsModule(function (module) {
		var shared = require$$22('keys')
		  , uid    = require$$4$1;
		module.exports = function(key){
		  return shared[key] || (shared[key] = uid(key));
		};
		});
	
		var require$$2 = (_sharedKey && typeof _sharedKey === 'object' && 'default' in _sharedKey ? _sharedKey['default'] : _sharedKey);
	
		var _toInteger = createCommonjsModule(function (module) {
		// 7.1.4 ToInteger
		var ceil  = Math.ceil
		  , floor = Math.floor;
		module.exports = function(it){
		  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
		};
		});
	
		var require$$1$2 = (_toInteger && typeof _toInteger === 'object' && 'default' in _toInteger ? _toInteger['default'] : _toInteger);
	
		var _toIndex = createCommonjsModule(function (module) {
		var toInteger = require$$1$2
		  , max       = Math.max
		  , min       = Math.min;
		module.exports = function(index, length){
		  index = toInteger(index);
		  return index < 0 ? max(index + length, 0) : min(index, length);
		};
		});
	
		var require$$0$3 = (_toIndex && typeof _toIndex === 'object' && 'default' in _toIndex ? _toIndex['default'] : _toIndex);
	
		var _toLength = createCommonjsModule(function (module) {
		// 7.1.15 ToLength
		var toInteger = require$$1$2
		  , min       = Math.min;
		module.exports = function(it){
		  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
		};
		});
	
		var require$$3 = (_toLength && typeof _toLength === 'object' && 'default' in _toLength ? _toLength['default'] : _toLength);
	
		var _defined = createCommonjsModule(function (module) {
		// 7.2.1 RequireObjectCoercible(argument)
		module.exports = function(it){
		  if(it == undefined)throw TypeError("Can't call method on  " + it);
		  return it;
		};
		});
	
		var require$$6 = (_defined && typeof _defined === 'object' && 'default' in _defined ? _defined['default'] : _defined);
	
		var _cof = createCommonjsModule(function (module) {
		var toString = {}.toString;
	
		module.exports = function(it){
		  return toString.call(it).slice(8, -1);
		};
		});
	
		var require$$1$4 = (_cof && typeof _cof === 'object' && 'default' in _cof ? _cof['default'] : _cof);
	
		var _iobject = createCommonjsModule(function (module) {
		// fallback for non-array-like ES3 and non-enumerable old V8 strings
		var cof = require$$1$4;
		module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
		  return cof(it) == 'String' ? it.split('') : Object(it);
		};
		});
	
		var require$$1$3 = (_iobject && typeof _iobject === 'object' && 'default' in _iobject ? _iobject['default'] : _iobject);
	
		var _toIobject = createCommonjsModule(function (module) {
		// to indexed object, toObject with fallback for non-array-like ES3 strings
		var IObject = require$$1$3
		  , defined = require$$6;
		module.exports = function(it){
		  return IObject(defined(it));
		};
		});
	
		var require$$2$1 = (_toIobject && typeof _toIobject === 'object' && 'default' in _toIobject ? _toIobject['default'] : _toIobject);
	
		var _arrayIncludes = createCommonjsModule(function (module) {
		// false -> Array#indexOf
		// true  -> Array#includes
		var toIObject = require$$2$1
		  , toLength  = require$$3
		  , toIndex   = require$$0$3;
		module.exports = function(IS_INCLUDES){
		  return function($this, el, fromIndex){
		    var O      = toIObject($this)
		      , length = toLength(O.length)
		      , index  = toIndex(fromIndex, length)
		      , value;
		    // Array#includes uses SameValueZero equality algorithm
		    if(IS_INCLUDES && el != el)while(length > index){
		      value = O[index++];
		      if(value != value)return true;
		    // Array#toIndex ignores holes, Array#includes - not
		    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
		      if(O[index] === el)return IS_INCLUDES || index || 0;
		    } return !IS_INCLUDES && -1;
		  };
		};
		});
	
		var require$$1$1 = (_arrayIncludes && typeof _arrayIncludes === 'object' && 'default' in _arrayIncludes ? _arrayIncludes['default'] : _arrayIncludes);
	
		var _has = createCommonjsModule(function (module) {
		var hasOwnProperty = {}.hasOwnProperty;
		module.exports = function(it, key){
		  return hasOwnProperty.call(it, key);
		};
		});
	
		var require$$0$4 = (_has && typeof _has === 'object' && 'default' in _has ? _has['default'] : _has);
	
		var _objectKeysInternal = createCommonjsModule(function (module) {
		var has          = require$$0$4
		  , toIObject    = require$$2$1
		  , arrayIndexOf = require$$1$1(false)
		  , IE_PROTO     = require$$2('IE_PROTO');
	
		module.exports = function(object, names){
		  var O      = toIObject(object)
		    , i      = 0
		    , result = []
		    , key;
		  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
		  // Don't enum bug & hidden keys
		  while(names.length > i)if(has(O, key = names[i++])){
		    ~arrayIndexOf(result, key) || result.push(key);
		  }
		  return result;
		};
		});
	
		var require$$1 = (_objectKeysInternal && typeof _objectKeysInternal === 'object' && 'default' in _objectKeysInternal ? _objectKeysInternal['default'] : _objectKeysInternal);
	
		var _objectGopn = createCommonjsModule(function (module, exports) {
		// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
		var $keys      = require$$1
		  , hiddenKeys = require$$0$2.concat('length', 'prototype');
	
		exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
		  return $keys(O, hiddenKeys);
		};
		});
	
		var require$$4 = (_objectGopn && typeof _objectGopn === 'object' && 'default' in _objectGopn ? _objectGopn['default'] : _objectGopn);
	
		var _objectGopnExt = createCommonjsModule(function (module) {
		// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
		var toIObject = require$$2$1
		  , gOPN      = require$$4.f
		  , toString  = {}.toString;
	
		var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
		  ? Object.getOwnPropertyNames(window) : [];
	
		var getWindowNames = function(it){
		  try {
		    return gOPN(it);
		  } catch(e){
		    return windowNames.slice();
		  }
		};
	
		module.exports.f = function getOwnPropertyNames(it){
		  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
		};
		});
	
		var require$$8 = (_objectGopnExt && typeof _objectGopnExt === 'object' && 'default' in _objectGopnExt ? _objectGopnExt['default'] : _objectGopnExt);
	
		var _fails = createCommonjsModule(function (module) {
		module.exports = function(exec){
		  try {
		    return !!exec();
		  } catch(e){
		    return true;
		  }
		};
		});
	
		var require$$9 = (_fails && typeof _fails === 'object' && 'default' in _fails ? _fails['default'] : _fails);
	
		var _descriptors = createCommonjsModule(function (module) {
		// Thank's IE8 for his funny defineProperty
		module.exports = !require$$9(function(){
		  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
		});
		});
	
		var require$$1$5 = (_descriptors && typeof _descriptors === 'object' && 'default' in _descriptors ? _descriptors['default'] : _descriptors);
	
		var _propertyDesc = createCommonjsModule(function (module) {
		module.exports = function(bitmap, value){
		  return {
		    enumerable  : !(bitmap & 1),
		    configurable: !(bitmap & 2),
		    writable    : !(bitmap & 4),
		    value       : value
		  };
		};
		});
	
		var require$$0$6 = (_propertyDesc && typeof _propertyDesc === 'object' && 'default' in _propertyDesc ? _propertyDesc['default'] : _propertyDesc);
	
		var _isObject = createCommonjsModule(function (module) {
		module.exports = function(it){
		  return typeof it === 'object' ? it !== null : typeof it === 'function';
		};
		});
	
		var require$$4$2 = (_isObject && typeof _isObject === 'object' && 'default' in _isObject ? _isObject['default'] : _isObject);
	
		var _toPrimitive = createCommonjsModule(function (module) {
		// 7.1.1 ToPrimitive(input [, PreferredType])
		var isObject = require$$4$2;
		// instead of the ES6 spec version, we didn't implement @@toPrimitive case
		// and the second argument - flag - preferred type is a string
		module.exports = function(it, S){
		  if(!isObject(it))return it;
		  var fn, val;
		  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
		  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
		  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
		  throw TypeError("Can't convert object to primitive value");
		};
		});
	
		var require$$11 = (_toPrimitive && typeof _toPrimitive === 'object' && 'default' in _toPrimitive ? _toPrimitive['default'] : _toPrimitive);
	
		var _domCreate = createCommonjsModule(function (module) {
		var isObject = require$$4$2
		  , document = require$$12.document
		  // in old IE typeof document.createElement is 'object'
		  , is = isObject(document) && isObject(document.createElement);
		module.exports = function(it){
		  return is ? document.createElement(it) : {};
		};
		});
	
		var require$$1$7 = (_domCreate && typeof _domCreate === 'object' && 'default' in _domCreate ? _domCreate['default'] : _domCreate);
	
		var _ie8DomDefine = createCommonjsModule(function (module) {
		module.exports = !require$$1$5 && !require$$9(function(){
		  return Object.defineProperty(require$$1$7('div'), 'a', {get: function(){ return 7; }}).a != 7;
		});
		});
	
		var require$$1$6 = (_ie8DomDefine && typeof _ie8DomDefine === 'object' && 'default' in _ie8DomDefine ? _ie8DomDefine['default'] : _ie8DomDefine);
	
		var _anObject = createCommonjsModule(function (module) {
		var isObject = require$$4$2;
		module.exports = function(it){
		  if(!isObject(it))throw TypeError(it + ' is not an object!');
		  return it;
		};
		});
	
		var require$$2$3 = (_anObject && typeof _anObject === 'object' && 'default' in _anObject ? _anObject['default'] : _anObject);
	
		var _objectDp = createCommonjsModule(function (module, exports) {
		var anObject       = require$$2$3
		  , IE8_DOM_DEFINE = require$$1$6
		  , toPrimitive    = require$$11
		  , dP             = Object.defineProperty;
	
		exports.f = require$$1$5 ? Object.defineProperty : function defineProperty(O, P, Attributes){
		  anObject(O);
		  P = toPrimitive(P, true);
		  anObject(Attributes);
		  if(IE8_DOM_DEFINE)try {
		    return dP(O, P, Attributes);
		  } catch(e){ /* empty */ }
		  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
		  if('value' in Attributes)O[P] = Attributes.value;
		  return O;
		};
		});
	
		var require$$0$7 = (_objectDp && typeof _objectDp === 'object' && 'default' in _objectDp ? _objectDp['default'] : _objectDp);
	
		var _hide = createCommonjsModule(function (module) {
		var dP         = require$$0$7
		  , createDesc = require$$0$6;
		module.exports = require$$1$5 ? function(object, key, value){
		  return dP.f(object, key, createDesc(1, value));
		} : function(object, key, value){
		  object[key] = value;
		  return object;
		};
		});
	
		var require$$10 = (_hide && typeof _hide === 'object' && 'default' in _hide ? _hide['default'] : _hide);
	
		var _aFunction = createCommonjsModule(function (module) {
		module.exports = function(it){
		  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
		  return it;
		};
		});
	
		var require$$1$8 = (_aFunction && typeof _aFunction === 'object' && 'default' in _aFunction ? _aFunction['default'] : _aFunction);
	
		var _ctx = createCommonjsModule(function (module) {
		// optional / simple context binding
		var aFunction = require$$1$8;
		module.exports = function(fn, that, length){
		  aFunction(fn);
		  if(that === undefined)return fn;
		  switch(length){
		    case 1: return function(a){
		      return fn.call(that, a);
		    };
		    case 2: return function(a, b){
		      return fn.call(that, a, b);
		    };
		    case 3: return function(a, b, c){
		      return fn.call(that, a, b, c);
		    };
		  }
		  return function(/* ...args */){
		    return fn.apply(that, arguments);
		  };
		};
		});
	
		var require$$8$1 = (_ctx && typeof _ctx === 'object' && 'default' in _ctx ? _ctx['default'] : _ctx);
	
		var _export = createCommonjsModule(function (module) {
		var global    = require$$12
		  , core      = require$$0$1
		  , ctx       = require$$8$1
		  , hide      = require$$10
		  , PROTOTYPE = 'prototype';
	
		var $export = function(type, name, source){
		  var IS_FORCED = type & $export.F
		    , IS_GLOBAL = type & $export.G
		    , IS_STATIC = type & $export.S
		    , IS_PROTO  = type & $export.P
		    , IS_BIND   = type & $export.B
		    , IS_WRAP   = type & $export.W
		    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
		    , expProto  = exports[PROTOTYPE]
		    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
		    , key, own, out;
		  if(IS_GLOBAL)source = name;
		  for(key in source){
		    // contains in native
		    own = !IS_FORCED && target && target[key] !== undefined;
		    if(own && key in exports)continue;
		    // export native or passed
		    out = own ? target[key] : source[key];
		    // prevent global pollution for namespaces
		    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
		    // bind timers to global for call from export context
		    : IS_BIND && own ? ctx(out, global)
		    // wrap global constructors for prevent change them in library
		    : IS_WRAP && target[key] == out ? (function(C){
		      var F = function(a, b, c){
		        if(this instanceof C){
		          switch(arguments.length){
		            case 0: return new C;
		            case 1: return new C(a);
		            case 2: return new C(a, b);
		          } return new C(a, b, c);
		        } return C.apply(this, arguments);
		      };
		      F[PROTOTYPE] = C[PROTOTYPE];
		      return F;
		    // make static versions for prototype methods
		    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
		    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
		    if(IS_PROTO){
		      (exports.virtual || (exports.virtual = {}))[key] = out;
		      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
		      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
		    }
		  }
		};
		// type bitmap
		$export.F = 1;   // forced
		$export.G = 2;   // global
		$export.S = 4;   // static
		$export.P = 8;   // proto
		$export.B = 16;  // bind
		$export.W = 32;  // wrap
		$export.U = 64;  // safe
		$export.R = 128; // real proto method for `library` 
		module.exports = $export;
		});
	
		var require$$2$2 = (_export && typeof _export === 'object' && 'default' in _export ? _export['default'] : _export);
	
		var _objectSap = createCommonjsModule(function (module) {
		// most Object methods by ES6 should accept primitives
		var $export = require$$2$2
		  , core    = require$$0$1
		  , fails   = require$$9;
		module.exports = function(KEY, exec){
		  var fn  = (core.Object || {})[KEY] || Object[KEY]
		    , exp = {};
		  exp[KEY] = exec(fn);
		  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
		};
		});
	
		var require$$0$5 = (_objectSap && typeof _objectSap === 'object' && 'default' in _objectSap ? _objectSap['default'] : _objectSap);
	
		var es6_object_getOwnPropertyNames = createCommonjsModule(function (module) {
		// 19.1.2.7 Object.getOwnPropertyNames(O)
		require$$0$5('getOwnPropertyNames', function(){
		  return require$$8.f;
		});
		});
	
		var getOwnPropertyNames$1 = createCommonjsModule(function (module) {
		var $Object = require$$0$1.Object;
		module.exports = function getOwnPropertyNames(it){
		  return $Object.getOwnPropertyNames(it);
		};
		});
	
		var require$$0 = (getOwnPropertyNames$1 && typeof getOwnPropertyNames$1 === 'object' && 'default' in getOwnPropertyNames$1 ? getOwnPropertyNames$1['default'] : getOwnPropertyNames$1);
	
		var getOwnPropertyNames = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0, __esModule: true };
		});
	
		var _Object$getOwnPropertyNames = (getOwnPropertyNames && typeof getOwnPropertyNames === 'object' && 'default' in getOwnPropertyNames ? getOwnPropertyNames['default'] : getOwnPropertyNames);
	
		var _addToUnscopables = createCommonjsModule(function (module) {
		module.exports = function(){ /* empty */ };
		});
	
		var require$$4$3 = (_addToUnscopables && typeof _addToUnscopables === 'object' && 'default' in _addToUnscopables ? _addToUnscopables['default'] : _addToUnscopables);
	
		var _wks = createCommonjsModule(function (module) {
		var store      = require$$22('wks')
		  , uid        = require$$4$1
		  , Symbol     = require$$12.Symbol
		  , USE_SYMBOL = typeof Symbol == 'function';
	
		var $exports = module.exports = function(name){
		  return store[name] || (store[name] =
		    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
		};
	
		$exports.store = store;
		});
	
		var require$$19 = (_wks && typeof _wks === 'object' && 'default' in _wks ? _wks['default'] : _wks);
	
		var _isArray = createCommonjsModule(function (module) {
		// 7.2.2 IsArray(argument)
		var cof = require$$1$4;
		module.exports = Array.isArray || function isArray(arg){
		  return cof(arg) == 'Array';
		};
		});
	
		var require$$14 = (_isArray && typeof _isArray === 'object' && 'default' in _isArray ? _isArray['default'] : _isArray);
	
		var _arraySpeciesConstructor = createCommonjsModule(function (module) {
		var isObject = require$$4$2
		  , isArray  = require$$14
		  , SPECIES  = require$$19('species');
	
		module.exports = function(original){
		  var C;
		  if(isArray(original)){
		    C = original.constructor;
		    // cross-realm fallback
		    if(typeof C == 'function' && (C === Array || isArray(C.prototype)))C = undefined;
		    if(isObject(C)){
		      C = C[SPECIES];
		      if(C === null)C = undefined;
		    }
		  } return C === undefined ? Array : C;
		};
		});
	
		var require$$0$10 = (_arraySpeciesConstructor && typeof _arraySpeciesConstructor === 'object' && 'default' in _arraySpeciesConstructor ? _arraySpeciesConstructor['default'] : _arraySpeciesConstructor);
	
		var _arraySpeciesCreate = createCommonjsModule(function (module) {
		// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
		var speciesConstructor = require$$0$10;
	
		module.exports = function(original, length){
		  return new (speciesConstructor(original))(length);
		};
		});
	
		var require$$0$9 = (_arraySpeciesCreate && typeof _arraySpeciesCreate === 'object' && 'default' in _arraySpeciesCreate ? _arraySpeciesCreate['default'] : _arraySpeciesCreate);
	
		var _toObject = createCommonjsModule(function (module) {
		// 7.1.13 ToObject(argument)
		var defined = require$$6;
		module.exports = function(it){
		  return Object(defined(it));
		};
		});
	
		var require$$2$4 = (_toObject && typeof _toObject === 'object' && 'default' in _toObject ? _toObject['default'] : _toObject);
	
		var _arrayMethods = createCommonjsModule(function (module) {
		// 0 -> Array#forEach
		// 1 -> Array#map
		// 2 -> Array#filter
		// 3 -> Array#some
		// 4 -> Array#every
		// 5 -> Array#find
		// 6 -> Array#findIndex
		var ctx      = require$$8$1
		  , IObject  = require$$1$3
		  , toObject = require$$2$4
		  , toLength = require$$3
		  , asc      = require$$0$9;
		module.exports = function(TYPE, $create){
		  var IS_MAP        = TYPE == 1
		    , IS_FILTER     = TYPE == 2
		    , IS_SOME       = TYPE == 3
		    , IS_EVERY      = TYPE == 4
		    , IS_FIND_INDEX = TYPE == 6
		    , NO_HOLES      = TYPE == 5 || IS_FIND_INDEX
		    , create        = $create || asc;
		  return function($this, callbackfn, that){
		    var O      = toObject($this)
		      , self   = IObject(O)
		      , f      = ctx(callbackfn, that, 3)
		      , length = toLength(self.length)
		      , index  = 0
		      , result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined
		      , val, res;
		    for(;length > index; index++)if(NO_HOLES || index in self){
		      val = self[index];
		      res = f(val, index, O);
		      if(TYPE){
		        if(IS_MAP)result[index] = res;            // map
		        else if(res)switch(TYPE){
		          case 3: return true;                    // some
		          case 5: return val;                     // find
		          case 6: return index;                   // findIndex
		          case 2: result.push(val);               // filter
		        } else if(IS_EVERY)return false;          // every
		      }
		    }
		    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
		  };
		};
		});
	
		var require$$1$9 = (_arrayMethods && typeof _arrayMethods === 'object' && 'default' in _arrayMethods ? _arrayMethods['default'] : _arrayMethods);
	
		var es6_array_find = createCommonjsModule(function (module) {
		'use strict';
		// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
		var $export = require$$2$2
		  , $find   = require$$1$9(5)
		  , KEY     = 'find'
		  , forced  = true;
		// Shouldn't skip holes
		if(KEY in [])Array(1)[KEY](function(){ forced = false; });
		$export($export.P + $export.F * forced, 'Array', {
		  find: function find(callbackfn/*, that = undefined */){
		    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
		  }
		});
		require$$4$3(KEY);
		});
	
		var find$1 = createCommonjsModule(function (module) {
		module.exports = require$$0$1.Array.find;
		});
	
		var require$$0$8 = (find$1 && typeof find$1 === 'object' && 'default' in find$1 ? find$1['default'] : find$1);
	
		var find = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$8, __esModule: true };
		});
	
		var _Array$find = (find && typeof find === 'object' && 'default' in find ? find['default'] : find);
	
		var _iterDetect = createCommonjsModule(function (module) {
		var ITERATOR     = require$$19('iterator')
		  , SAFE_CLOSING = false;
	
		try {
		  var riter = [7][ITERATOR]();
		  riter['return'] = function(){ SAFE_CLOSING = true; };
		  Array.from(riter, function(){ throw 2; });
		} catch(e){ /* empty */ }
	
		module.exports = function(exec, skipClosing){
		  if(!skipClosing && !SAFE_CLOSING)return false;
		  var safe = false;
		  try {
		    var arr  = [7]
		      , iter = arr[ITERATOR]();
		    iter.next = function(){ return {done: safe = true}; };
		    arr[ITERATOR] = function(){ return iter; };
		    exec(arr);
		  } catch(e){ /* empty */ }
		  return safe;
		};
		});
	
		var require$$0$12 = (_iterDetect && typeof _iterDetect === 'object' && 'default' in _iterDetect ? _iterDetect['default'] : _iterDetect);
	
		var _setSpecies = createCommonjsModule(function (module) {
		'use strict';
		var global      = require$$12
		  , core        = require$$0$1
		  , dP          = require$$0$7
		  , DESCRIPTORS = require$$1$5
		  , SPECIES     = require$$19('species');
	
		module.exports = function(KEY){
		  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
		  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
		    configurable: true,
		    get: function(){ return this; }
		  });
		};
		});
	
		var require$$2$5 = (_setSpecies && typeof _setSpecies === 'object' && 'default' in _setSpecies ? _setSpecies['default'] : _setSpecies);
	
		var _setToStringTag = createCommonjsModule(function (module) {
		var def = require$$0$7.f
		  , has = require$$0$4
		  , TAG = require$$19('toStringTag');
	
		module.exports = function(it, tag, stat){
		  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
		};
		});
	
		var require$$3$1 = (_setToStringTag && typeof _setToStringTag === 'object' && 'default' in _setToStringTag ? _setToStringTag['default'] : _setToStringTag);
	
		var _redefineAll = createCommonjsModule(function (module) {
		var hide = require$$10;
		module.exports = function(target, src, safe){
		  for(var key in src){
		    if(safe && target[key])target[key] = src[key];
		    else hide(target, key, src[key]);
		  } return target;
		};
		});
	
		var require$$9$1 = (_redefineAll && typeof _redefineAll === 'object' && 'default' in _redefineAll ? _redefineAll['default'] : _redefineAll);
	
		var _html = createCommonjsModule(function (module) {
		module.exports = require$$12.document && document.documentElement;
		});
	
		var require$$0$13 = (_html && typeof _html === 'object' && 'default' in _html ? _html['default'] : _html);
	
		var _invoke = createCommonjsModule(function (module) {
		// fast apply, http://jsperf.lnkit.com/fast-apply/5
		module.exports = function(fn, args, that){
		  var un = that === undefined;
		  switch(args.length){
		    case 0: return un ? fn()
		                      : fn.call(that);
		    case 1: return un ? fn(args[0])
		                      : fn.call(that, args[0]);
		    case 2: return un ? fn(args[0], args[1])
		                      : fn.call(that, args[0], args[1]);
		    case 3: return un ? fn(args[0], args[1], args[2])
		                      : fn.call(that, args[0], args[1], args[2]);
		    case 4: return un ? fn(args[0], args[1], args[2], args[3])
		                      : fn.call(that, args[0], args[1], args[2], args[3]);
		  } return              fn.apply(that, args);
		};
		});
	
		var require$$4$4 = (_invoke && typeof _invoke === 'object' && 'default' in _invoke ? _invoke['default'] : _invoke);
	
		var _task = createCommonjsModule(function (module) {
		var ctx                = require$$8$1
		  , invoke             = require$$4$4
		  , html               = require$$0$13
		  , cel                = require$$1$7
		  , global             = require$$12
		  , process            = global.process
		  , setTask            = global.setImmediate
		  , clearTask          = global.clearImmediate
		  , MessageChannel     = global.MessageChannel
		  , counter            = 0
		  , queue              = {}
		  , ONREADYSTATECHANGE = 'onreadystatechange'
		  , defer, channel, port;
		var run = function(){
		  var id = +this;
		  if(queue.hasOwnProperty(id)){
		    var fn = queue[id];
		    delete queue[id];
		    fn();
		  }
		};
		var listener = function(event){
		  run.call(event.data);
		};
		// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
		if(!setTask || !clearTask){
		  setTask = function setImmediate(fn){
		    var args = [], i = 1;
		    while(arguments.length > i)args.push(arguments[i++]);
		    queue[++counter] = function(){
		      invoke(typeof fn == 'function' ? fn : Function(fn), args);
		    };
		    defer(counter);
		    return counter;
		  };
		  clearTask = function clearImmediate(id){
		    delete queue[id];
		  };
		  // Node.js 0.8-
		  if(require$$1$4(process) == 'process'){
		    defer = function(id){
		      process.nextTick(ctx(run, id, 1));
		    };
		  // Browsers with MessageChannel, includes WebWorkers
		  } else if(MessageChannel){
		    channel = new MessageChannel;
		    port    = channel.port2;
		    channel.port1.onmessage = listener;
		    defer = ctx(port.postMessage, port, 1);
		  // Browsers with postMessage, skip WebWorkers
		  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
		  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
		    defer = function(id){
		      global.postMessage(id + '', '*');
		    };
		    global.addEventListener('message', listener, false);
		  // IE8-
		  } else if(ONREADYSTATECHANGE in cel('script')){
		    defer = function(id){
		      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
		        html.removeChild(this);
		        run.call(id);
		      };
		    };
		  // Rest old browsers
		  } else {
		    defer = function(id){
		      setTimeout(ctx(run, id, 1), 0);
		    };
		  }
		}
		module.exports = {
		  set:   setTask,
		  clear: clearTask
		};
		});
	
		var require$$1$10 = (_task && typeof _task === 'object' && 'default' in _task ? _task['default'] : _task);
	
		var _microtask = createCommonjsModule(function (module) {
		var global    = require$$12
		  , macrotask = require$$1$10.set
		  , Observer  = global.MutationObserver || global.WebKitMutationObserver
		  , process   = global.process
		  , Promise   = global.Promise
		  , isNode    = require$$1$4(process) == 'process';
	
		module.exports = function(){
		  var head, last, notify;
	
		  var flush = function(){
		    var parent, fn;
		    if(isNode && (parent = process.domain))parent.exit();
		    while(head){
		      fn   = head.fn;
		      head = head.next;
		      try {
		        fn();
		      } catch(e){
		        if(head)notify();
		        else last = undefined;
		        throw e;
		      }
		    } last = undefined;
		    if(parent)parent.enter();
		  };
	
		  // Node.js
		  if(isNode){
		    notify = function(){
		      process.nextTick(flush);
		    };
		  // browsers with MutationObserver
		  } else if(Observer){
		    var toggle = true
		      , node   = document.createTextNode('');
		    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
		    notify = function(){
		      node.data = toggle = !toggle;
		    };
		  // environments with maybe non-completely correct, but existent Promise
		  } else if(Promise && Promise.resolve){
		    var promise = Promise.resolve();
		    notify = function(){
		      promise.then(flush);
		    };
		  // for other environments - macrotask based on:
		  // - setImmediate
		  // - MessageChannel
		  // - window.postMessag
		  // - onreadystatechange
		  // - setTimeout
		  } else {
		    notify = function(){
		      // strange IE + webpack dev server bug - use .call(global)
		      macrotask.call(global, flush);
		    };
		  }
	
		  return function(fn){
		    var task = {fn: fn, next: undefined};
		    if(last)last.next = task;
		    if(!head){
		      head = task;
		      notify();
		    } last = task;
		  };
		};
		});
	
		var require$$6$1 = (_microtask && typeof _microtask === 'object' && 'default' in _microtask ? _microtask['default'] : _microtask);
	
		var _speciesConstructor = createCommonjsModule(function (module) {
		// 7.3.20 SpeciesConstructor(O, defaultConstructor)
		var anObject  = require$$2$3
		  , aFunction = require$$1$8
		  , SPECIES   = require$$19('species');
		module.exports = function(O, D){
		  var C = anObject(O).constructor, S;
		  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
		};
		});
	
		var require$$8$2 = (_speciesConstructor && typeof _speciesConstructor === 'object' && 'default' in _speciesConstructor ? _speciesConstructor['default'] : _speciesConstructor);
	
		var _objectPie = createCommonjsModule(function (module, exports) {
		exports.f = {}.propertyIsEnumerable;
		});
	
		var require$$0$15 = (_objectPie && typeof _objectPie === 'object' && 'default' in _objectPie ? _objectPie['default'] : _objectPie);
	
		var _objectGopd = createCommonjsModule(function (module, exports) {
		var pIE            = require$$0$15
		  , createDesc     = require$$0$6
		  , toIObject      = require$$2$1
		  , toPrimitive    = require$$11
		  , has            = require$$0$4
		  , IE8_DOM_DEFINE = require$$1$6
		  , gOPD           = Object.getOwnPropertyDescriptor;
	
		exports.f = require$$1$5 ? gOPD : function getOwnPropertyDescriptor(O, P){
		  O = toIObject(O);
		  P = toPrimitive(P, true);
		  if(IE8_DOM_DEFINE)try {
		    return gOPD(O, P);
		  } catch(e){ /* empty */ }
		  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
		};
		});
	
		var require$$1$11 = (_objectGopd && typeof _objectGopd === 'object' && 'default' in _objectGopd ? _objectGopd['default'] : _objectGopd);
	
		var _setProto = createCommonjsModule(function (module) {
		// Works with __proto__ only. Old v8 can't work with null proto objects.
		/* eslint-disable no-proto */
		var isObject = require$$4$2
		  , anObject = require$$2$3;
		var check = function(O, proto){
		  anObject(O);
		  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
		};
		module.exports = {
		  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
		    function(test, buggy, set){
		      try {
		        set = require$$8$1(Function.call, require$$1$11.f(Object.prototype, '__proto__').set, 2);
		        set(test, []);
		        buggy = !(test instanceof Array);
		      } catch(e){ buggy = true; }
		      return function setPrototypeOf(O, proto){
		        check(O, proto);
		        if(buggy)O.__proto__ = proto;
		        else set(O, proto);
		        return O;
		      };
		    }({}, false) : undefined),
		  check: check
		};
		});
	
		var require$$0$14 = (_setProto && typeof _setProto === 'object' && 'default' in _setProto ? _setProto['default'] : _setProto);
	
		var _iterators = createCommonjsModule(function (module) {
		module.exports = {};
		});
	
		var require$$4$5 = (_iterators && typeof _iterators === 'object' && 'default' in _iterators ? _iterators['default'] : _iterators);
	
		var _classof = createCommonjsModule(function (module) {
		// getting tag from 19.1.3.6 Object.prototype.toString()
		var cof = require$$1$4
		  , TAG = require$$19('toStringTag')
		  // ES3 wrong here
		  , ARG = cof(function(){ return arguments; }()) == 'Arguments';
	
		// fallback for IE11 Script Access Denied error
		var tryGet = function(it, key){
		  try {
		    return it[key];
		  } catch(e){ /* empty */ }
		};
	
		module.exports = function(it){
		  var O, T, B;
		  return it === undefined ? 'Undefined' : it === null ? 'Null'
		    // @@toStringTag case
		    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
		    // builtinTag case
		    : ARG ? cof(O)
		    // ES3 arguments fallback
		    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
		};
		});
	
		var require$$1$13 = (_classof && typeof _classof === 'object' && 'default' in _classof ? _classof['default'] : _classof);
	
		var core_getIteratorMethod = createCommonjsModule(function (module) {
		var classof   = require$$1$13
		  , ITERATOR  = require$$19('iterator')
		  , Iterators = require$$4$5;
		module.exports = require$$0$1.getIteratorMethod = function(it){
		  if(it != undefined)return it[ITERATOR]
		    || it['@@iterator']
		    || Iterators[classof(it)];
		};
		});
	
		var require$$1$12 = (core_getIteratorMethod && typeof core_getIteratorMethod === 'object' && 'default' in core_getIteratorMethod ? core_getIteratorMethod['default'] : core_getIteratorMethod);
	
		var _isArrayIter = createCommonjsModule(function (module) {
		// check on default Array iterator
		var Iterators  = require$$4$5
		  , ITERATOR   = require$$19('iterator')
		  , ArrayProto = Array.prototype;
	
		module.exports = function(it){
		  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
		};
		});
	
		var require$$4$6 = (_isArrayIter && typeof _isArrayIter === 'object' && 'default' in _isArrayIter ? _isArrayIter['default'] : _isArrayIter);
	
		var _iterCall = createCommonjsModule(function (module) {
		// call something on iterator step with safe closing on error
		var anObject = require$$2$3;
		module.exports = function(iterator, fn, value, entries){
		  try {
		    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
		  // 7.4.6 IteratorClose(iterator, completion)
		  } catch(e){
		    var ret = iterator['return'];
		    if(ret !== undefined)anObject(ret.call(iterator));
		    throw e;
		  }
		};
		});
	
		var require$$5$1 = (_iterCall && typeof _iterCall === 'object' && 'default' in _iterCall ? _iterCall['default'] : _iterCall);
	
		var _forOf = createCommonjsModule(function (module) {
		var ctx         = require$$8$1
		  , call        = require$$5$1
		  , isArrayIter = require$$4$6
		  , anObject    = require$$2$3
		  , toLength    = require$$3
		  , getIterFn   = require$$1$12
		  , BREAK       = {}
		  , RETURN      = {};
		var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
		  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
		    , f      = ctx(fn, that, entries ? 2 : 1)
		    , index  = 0
		    , length, step, iterator, result;
		  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
		  // fast case for arrays with default iterator
		  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
		    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
		    if(result === BREAK || result === RETURN)return result;
		  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
		    result = call(iterator, f, step.value, entries);
		    if(result === BREAK || result === RETURN)return result;
		  }
		};
		exports.BREAK  = BREAK;
		exports.RETURN = RETURN;
		});
	
		var require$$5 = (_forOf && typeof _forOf === 'object' && 'default' in _forOf ? _forOf['default'] : _forOf);
	
		var _anInstance = createCommonjsModule(function (module) {
		module.exports = function(it, Constructor, name, forbiddenField){
		  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
		    throw TypeError(name + ': incorrect invocation!');
		  } return it;
		};
		});
	
		var require$$7 = (_anInstance && typeof _anInstance === 'object' && 'default' in _anInstance ? _anInstance['default'] : _anInstance);
	
		var _library = createCommonjsModule(function (module) {
		module.exports = true;
		});
	
		var require$$1$14 = (_library && typeof _library === 'object' && 'default' in _library ? _library['default'] : _library);
	
		var es6_promise = createCommonjsModule(function (module) {
		'use strict';
		var LIBRARY            = require$$1$14
		  , global             = require$$12
		  , ctx                = require$$8$1
		  , classof            = require$$1$13
		  , $export            = require$$2$2
		  , isObject           = require$$4$2
		  , anObject           = require$$2$3
		  , aFunction          = require$$1$8
		  , anInstance         = require$$7
		  , forOf              = require$$5
		  , setProto           = require$$0$14.set
		  , speciesConstructor = require$$8$2
		  , task               = require$$1$10.set
		  , microtask          = require$$6$1()
		  , PROMISE            = 'Promise'
		  , TypeError          = global.TypeError
		  , process            = global.process
		  , $Promise           = global[PROMISE]
		  , process            = global.process
		  , isNode             = classof(process) == 'process'
		  , empty              = function(){ /* empty */ }
		  , Internal, GenericPromiseCapability, Wrapper;
	
		var USE_NATIVE = !!function(){
		  try {
		    // correct subclassing with @@species support
		    var promise     = $Promise.resolve(1)
		      , FakePromise = (promise.constructor = {})[require$$19('species')] = function(exec){ exec(empty, empty); };
		    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
		    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
		  } catch(e){ /* empty */ }
		}();
	
		// helpers
		var sameConstructor = function(a, b){
		  // with library wrapper special case
		  return a === b || a === $Promise && b === Wrapper;
		};
		var isThenable = function(it){
		  var then;
		  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
		};
		var newPromiseCapability = function(C){
		  return sameConstructor($Promise, C)
		    ? new PromiseCapability(C)
		    : new GenericPromiseCapability(C);
		};
		var PromiseCapability = GenericPromiseCapability = function(C){
		  var resolve, reject;
		  this.promise = new C(function($$resolve, $$reject){
		    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
		    resolve = $$resolve;
		    reject  = $$reject;
		  });
		  this.resolve = aFunction(resolve);
		  this.reject  = aFunction(reject);
		};
		var perform = function(exec){
		  try {
		    exec();
		  } catch(e){
		    return {error: e};
		  }
		};
		var notify = function(promise, isReject){
		  if(promise._n)return;
		  promise._n = true;
		  var chain = promise._c;
		  microtask(function(){
		    var value = promise._v
		      , ok    = promise._s == 1
		      , i     = 0;
		    var run = function(reaction){
		      var handler = ok ? reaction.ok : reaction.fail
		        , resolve = reaction.resolve
		        , reject  = reaction.reject
		        , domain  = reaction.domain
		        , result, then;
		      try {
		        if(handler){
		          if(!ok){
		            if(promise._h == 2)onHandleUnhandled(promise);
		            promise._h = 1;
		          }
		          if(handler === true)result = value;
		          else {
		            if(domain)domain.enter();
		            result = handler(value);
		            if(domain)domain.exit();
		          }
		          if(result === reaction.promise){
		            reject(TypeError('Promise-chain cycle'));
		          } else if(then = isThenable(result)){
		            then.call(result, resolve, reject);
		          } else resolve(result);
		        } else reject(value);
		      } catch(e){
		        reject(e);
		      }
		    };
		    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
		    promise._c = [];
		    promise._n = false;
		    if(isReject && !promise._h)onUnhandled(promise);
		  });
		};
		var onUnhandled = function(promise){
		  task.call(global, function(){
		    var value = promise._v
		      , abrupt, handler, console;
		    if(isUnhandled(promise)){
		      abrupt = perform(function(){
		        if(isNode){
		          process.emit('unhandledRejection', value, promise);
		        } else if(handler = global.onunhandledrejection){
		          handler({promise: promise, reason: value});
		        } else if((console = global.console) && console.error){
		          console.error('Unhandled promise rejection', value);
		        }
		      });
		      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
		      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
		    } promise._a = undefined;
		    if(abrupt)throw abrupt.error;
		  });
		};
		var isUnhandled = function(promise){
		  if(promise._h == 1)return false;
		  var chain = promise._a || promise._c
		    , i     = 0
		    , reaction;
		  while(chain.length > i){
		    reaction = chain[i++];
		    if(reaction.fail || !isUnhandled(reaction.promise))return false;
		  } return true;
		};
		var onHandleUnhandled = function(promise){
		  task.call(global, function(){
		    var handler;
		    if(isNode){
		      process.emit('rejectionHandled', promise);
		    } else if(handler = global.onrejectionhandled){
		      handler({promise: promise, reason: promise._v});
		    }
		  });
		};
		var $reject = function(value){
		  var promise = this;
		  if(promise._d)return;
		  promise._d = true;
		  promise = promise._w || promise; // unwrap
		  promise._v = value;
		  promise._s = 2;
		  if(!promise._a)promise._a = promise._c.slice();
		  notify(promise, true);
		};
		var $resolve = function(value){
		  var promise = this
		    , then;
		  if(promise._d)return;
		  promise._d = true;
		  promise = promise._w || promise; // unwrap
		  try {
		    if(promise === value)throw TypeError("Promise can't be resolved itself");
		    if(then = isThenable(value)){
		      microtask(function(){
		        var wrapper = {_w: promise, _d: false}; // wrap
		        try {
		          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
		        } catch(e){
		          $reject.call(wrapper, e);
		        }
		      });
		    } else {
		      promise._v = value;
		      promise._s = 1;
		      notify(promise, false);
		    }
		  } catch(e){
		    $reject.call({_w: promise, _d: false}, e); // wrap
		  }
		};
	
		// constructor polyfill
		if(!USE_NATIVE){
		  // 25.4.3.1 Promise(executor)
		  $Promise = function Promise(executor){
		    anInstance(this, $Promise, PROMISE, '_h');
		    aFunction(executor);
		    Internal.call(this);
		    try {
		      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
		    } catch(err){
		      $reject.call(this, err);
		    }
		  };
		  Internal = function Promise(executor){
		    this._c = [];             // <- awaiting reactions
		    this._a = undefined;      // <- checked in isUnhandled reactions
		    this._s = 0;              // <- state
		    this._d = false;          // <- done
		    this._v = undefined;      // <- value
		    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
		    this._n = false;          // <- notify
		  };
		  Internal.prototype = require$$9$1($Promise.prototype, {
		    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
		    then: function then(onFulfilled, onRejected){
		      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
		      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
		      reaction.fail   = typeof onRejected == 'function' && onRejected;
		      reaction.domain = isNode ? process.domain : undefined;
		      this._c.push(reaction);
		      if(this._a)this._a.push(reaction);
		      if(this._s)notify(this, false);
		      return reaction.promise;
		    },
		    // 25.4.5.1 Promise.prototype.catch(onRejected)
		    'catch': function(onRejected){
		      return this.then(undefined, onRejected);
		    }
		  });
		  PromiseCapability = function(){
		    var promise  = new Internal;
		    this.promise = promise;
		    this.resolve = ctx($resolve, promise, 1);
		    this.reject  = ctx($reject, promise, 1);
		  };
		}
	
		$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
		require$$3$1($Promise, PROMISE);
		require$$2$5(PROMISE);
		Wrapper = require$$0$1[PROMISE];
	
		// statics
		$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
		  // 25.4.4.5 Promise.reject(r)
		  reject: function reject(r){
		    var capability = newPromiseCapability(this)
		      , $$reject   = capability.reject;
		    $$reject(r);
		    return capability.promise;
		  }
		});
		$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
		  // 25.4.4.6 Promise.resolve(x)
		  resolve: function resolve(x){
		    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
		    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
		    var capability = newPromiseCapability(this)
		      , $$resolve  = capability.resolve;
		    $$resolve(x);
		    return capability.promise;
		  }
		});
		$export($export.S + $export.F * !(USE_NATIVE && require$$0$12(function(iter){
		  $Promise.all(iter)['catch'](empty);
		})), PROMISE, {
		  // 25.4.4.1 Promise.all(iterable)
		  all: function all(iterable){
		    var C          = this
		      , capability = newPromiseCapability(C)
		      , resolve    = capability.resolve
		      , reject     = capability.reject;
		    var abrupt = perform(function(){
		      var values    = []
		        , index     = 0
		        , remaining = 1;
		      forOf(iterable, false, function(promise){
		        var $index        = index++
		          , alreadyCalled = false;
		        values.push(undefined);
		        remaining++;
		        C.resolve(promise).then(function(value){
		          if(alreadyCalled)return;
		          alreadyCalled  = true;
		          values[$index] = value;
		          --remaining || resolve(values);
		        }, reject);
		      });
		      --remaining || resolve(values);
		    });
		    if(abrupt)reject(abrupt.error);
		    return capability.promise;
		  },
		  // 25.4.4.4 Promise.race(iterable)
		  race: function race(iterable){
		    var C          = this
		      , capability = newPromiseCapability(C)
		      , reject     = capability.reject;
		    var abrupt = perform(function(){
		      forOf(iterable, false, function(promise){
		        C.resolve(promise).then(capability.resolve, reject);
		      });
		    });
		    if(abrupt)reject(abrupt.error);
		    return capability.promise;
		  }
		});
		});
	
		var _objectGpo = createCommonjsModule(function (module) {
		// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
		var has         = require$$0$4
		  , toObject    = require$$2$4
		  , IE_PROTO    = require$$2('IE_PROTO')
		  , ObjectProto = Object.prototype;
	
		module.exports = Object.getPrototypeOf || function(O){
		  O = toObject(O);
		  if(has(O, IE_PROTO))return O[IE_PROTO];
		  if(typeof O.constructor == 'function' && O instanceof O.constructor){
		    return O.constructor.prototype;
		  } return O instanceof Object ? ObjectProto : null;
		};
		});
	
		var require$$1$15 = (_objectGpo && typeof _objectGpo === 'object' && 'default' in _objectGpo ? _objectGpo['default'] : _objectGpo);
	
		var _objectKeys = createCommonjsModule(function (module) {
		// 19.1.2.14 / 15.2.3.14 Object.keys(O)
		var $keys       = require$$1
		  , enumBugKeys = require$$0$2;
	
		module.exports = Object.keys || function keys(O){
		  return $keys(O, enumBugKeys);
		};
		});
	
		var require$$1$16 = (_objectKeys && typeof _objectKeys === 'object' && 'default' in _objectKeys ? _objectKeys['default'] : _objectKeys);
	
		var _objectDps = createCommonjsModule(function (module) {
		var dP       = require$$0$7
		  , anObject = require$$2$3
		  , getKeys  = require$$1$16;
	
		module.exports = require$$1$5 ? Object.defineProperties : function defineProperties(O, Properties){
		  anObject(O);
		  var keys   = getKeys(Properties)
		    , length = keys.length
		    , i = 0
		    , P;
		  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
		  return O;
		};
		});
	
		var require$$4$8 = (_objectDps && typeof _objectDps === 'object' && 'default' in _objectDps ? _objectDps['default'] : _objectDps);
	
		var _objectCreate = createCommonjsModule(function (module) {
		// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
		var anObject    = require$$2$3
		  , dPs         = require$$4$8
		  , enumBugKeys = require$$0$2
		  , IE_PROTO    = require$$2('IE_PROTO')
		  , Empty       = function(){ /* empty */ }
		  , PROTOTYPE   = 'prototype';
	
		// Create object with fake `null` prototype: use iframe Object with cleared prototype
		var createDict = function(){
		  // Thrash, waste and sodomy: IE GC bug
		  var iframe = require$$1$7('iframe')
		    , i      = enumBugKeys.length
		    , gt     = '>'
		    , iframeDocument;
		  iframe.style.display = 'none';
		  require$$0$13.appendChild(iframe);
		  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
		  // createDict = iframe.contentWindow.Object;
		  // html.removeChild(iframe);
		  iframeDocument = iframe.contentWindow.document;
		  iframeDocument.open();
		  iframeDocument.write('<script>document.F=Object</script' + gt);
		  iframeDocument.close();
		  createDict = iframeDocument.F;
		  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
		  return createDict();
		};
	
		module.exports = Object.create || function create(O, Properties){
		  var result;
		  if(O !== null){
		    Empty[PROTOTYPE] = anObject(O);
		    result = new Empty;
		    Empty[PROTOTYPE] = null;
		    // add "__proto__" for Object.getPrototypeOf polyfill
		    result[IE_PROTO] = O;
		  } else result = createDict();
		  return Properties === undefined ? result : dPs(result, Properties);
		};
		});
	
		var require$$11$1 = (_objectCreate && typeof _objectCreate === 'object' && 'default' in _objectCreate ? _objectCreate['default'] : _objectCreate);
	
		var _iterCreate = createCommonjsModule(function (module) {
		'use strict';
		var create         = require$$11$1
		  , descriptor     = require$$0$6
		  , setToStringTag = require$$3$1
		  , IteratorPrototype = {};
	
		// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
		require$$10(IteratorPrototype, require$$19('iterator'), function(){ return this; });
	
		module.exports = function(Constructor, NAME, next){
		  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
		  setToStringTag(Constructor, NAME + ' Iterator');
		};
		});
	
		var require$$3$2 = (_iterCreate && typeof _iterCreate === 'object' && 'default' in _iterCreate ? _iterCreate['default'] : _iterCreate);
	
		var _redefine = createCommonjsModule(function (module) {
		module.exports = require$$10;
		});
	
		var require$$6$2 = (_redefine && typeof _redefine === 'object' && 'default' in _redefine ? _redefine['default'] : _redefine);
	
		var _iterDefine = createCommonjsModule(function (module) {
		'use strict';
		var LIBRARY        = require$$1$14
		  , $export        = require$$2$2
		  , redefine       = require$$6$2
		  , hide           = require$$10
		  , has            = require$$0$4
		  , Iterators      = require$$4$5
		  , $iterCreate    = require$$3$2
		  , setToStringTag = require$$3$1
		  , getPrototypeOf = require$$1$15
		  , ITERATOR       = require$$19('iterator')
		  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
		  , FF_ITERATOR    = '@@iterator'
		  , KEYS           = 'keys'
		  , VALUES         = 'values';
	
		var returnThis = function(){ return this; };
	
		module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
		  $iterCreate(Constructor, NAME, next);
		  var getMethod = function(kind){
		    if(!BUGGY && kind in proto)return proto[kind];
		    switch(kind){
		      case KEYS: return function keys(){ return new Constructor(this, kind); };
		      case VALUES: return function values(){ return new Constructor(this, kind); };
		    } return function entries(){ return new Constructor(this, kind); };
		  };
		  var TAG        = NAME + ' Iterator'
		    , DEF_VALUES = DEFAULT == VALUES
		    , VALUES_BUG = false
		    , proto      = Base.prototype
		    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
		    , $default   = $native || getMethod(DEFAULT)
		    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
		    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
		    , methods, key, IteratorPrototype;
		  // Fix native
		  if($anyNative){
		    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
		    if(IteratorPrototype !== Object.prototype){
		      // Set @@toStringTag to native iterators
		      setToStringTag(IteratorPrototype, TAG, true);
		      // fix for some old engines
		      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
		    }
		  }
		  // fix Array#{values, @@iterator}.name in V8 / FF
		  if(DEF_VALUES && $native && $native.name !== VALUES){
		    VALUES_BUG = true;
		    $default = function values(){ return $native.call(this); };
		  }
		  // Define iterator
		  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
		    hide(proto, ITERATOR, $default);
		  }
		  // Plug for library
		  Iterators[NAME] = $default;
		  Iterators[TAG]  = returnThis;
		  if(DEFAULT){
		    methods = {
		      values:  DEF_VALUES ? $default : getMethod(VALUES),
		      keys:    IS_SET     ? $default : getMethod(KEYS),
		      entries: $entries
		    };
		    if(FORCED)for(key in methods){
		      if(!(key in proto))redefine(proto, key, methods[key]);
		    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
		  }
		  return methods;
		};
		});
	
		var require$$4$7 = (_iterDefine && typeof _iterDefine === 'object' && 'default' in _iterDefine ? _iterDefine['default'] : _iterDefine);
	
		var _iterStep = createCommonjsModule(function (module) {
		module.exports = function(done, value){
		  return {value: value, done: !!done};
		};
		});
	
		var require$$3$3 = (_iterStep && typeof _iterStep === 'object' && 'default' in _iterStep ? _iterStep['default'] : _iterStep);
	
		var es6_array_iterator = createCommonjsModule(function (module) {
		'use strict';
		var addToUnscopables = require$$4$3
		  , step             = require$$3$3
		  , Iterators        = require$$4$5
		  , toIObject        = require$$2$1;
	
		// 22.1.3.4 Array.prototype.entries()
		// 22.1.3.13 Array.prototype.keys()
		// 22.1.3.29 Array.prototype.values()
		// 22.1.3.30 Array.prototype[@@iterator]()
		module.exports = require$$4$7(Array, 'Array', function(iterated, kind){
		  this._t = toIObject(iterated); // target
		  this._i = 0;                   // next index
		  this._k = kind;                // kind
		// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
		}, function(){
		  var O     = this._t
		    , kind  = this._k
		    , index = this._i++;
		  if(!O || index >= O.length){
		    this._t = undefined;
		    return step(1);
		  }
		  if(kind == 'keys'  )return step(0, index);
		  if(kind == 'values')return step(0, O[index]);
		  return step(0, [index, O[index]]);
		}, 'values');
	
		// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
		Iterators.Arguments = Iterators.Array;
	
		addToUnscopables('keys');
		addToUnscopables('values');
		addToUnscopables('entries');
		});
	
		var web_dom_iterable = createCommonjsModule(function (module) {
		var global        = require$$12
		  , hide          = require$$10
		  , Iterators     = require$$4$5
		  , TO_STRING_TAG = require$$19('toStringTag');
	
		for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
		  var NAME       = collections[i]
		    , Collection = global[NAME]
		    , proto      = Collection && Collection.prototype;
		  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
		  Iterators[NAME] = Iterators.Array;
		}
		});
	
		var _stringAt = createCommonjsModule(function (module) {
		var toInteger = require$$1$2
		  , defined   = require$$6;
		// true  -> String#at
		// false -> String#codePointAt
		module.exports = function(TO_STRING){
		  return function(that, pos){
		    var s = String(defined(that))
		      , i = toInteger(pos)
		      , l = s.length
		      , a, b;
		    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
		    a = s.charCodeAt(i);
		    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
		      ? TO_STRING ? s.charAt(i) : a
		      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
		  };
		};
		});
	
		var require$$1$17 = (_stringAt && typeof _stringAt === 'object' && 'default' in _stringAt ? _stringAt['default'] : _stringAt);
	
		var es6_string_iterator = createCommonjsModule(function (module) {
		'use strict';
		var $at  = require$$1$17(true);
	
		// 21.1.3.27 String.prototype[@@iterator]()
		require$$4$7(String, 'String', function(iterated){
		  this._t = String(iterated); // target
		  this._i = 0;                // next index
		// 21.1.5.2.1 %StringIteratorPrototype%.next()
		}, function(){
		  var O     = this._t
		    , index = this._i
		    , point;
		  if(index >= O.length)return {value: undefined, done: true};
		  point = $at(O, index);
		  this._i += point.length;
		  return {value: point, done: false};
		});
		});
	
		var promise$1 = createCommonjsModule(function (module) {
		module.exports = require$$0$1.Promise;
		});
	
		var require$$0$11 = (promise$1 && typeof promise$1 === 'object' && 'default' in promise$1 ? promise$1['default'] : promise$1);
	
		var promise = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$11, __esModule: true };
		});
	
		var _Promise = (promise && typeof promise === 'object' && 'default' in promise ? promise['default'] : promise);
	
		var _objectGops = createCommonjsModule(function (module, exports) {
		exports.f = Object.getOwnPropertySymbols;
		});
	
		var require$$1$18 = (_objectGops && typeof _objectGops === 'object' && 'default' in _objectGops ? _objectGops['default'] : _objectGops);
	
		var _objectAssign = createCommonjsModule(function (module) {
		'use strict';
		// 19.1.2.1 Object.assign(target, source, ...)
		var getKeys  = require$$1$16
		  , gOPS     = require$$1$18
		  , pIE      = require$$0$15
		  , toObject = require$$2$4
		  , IObject  = require$$1$3
		  , $assign  = Object.assign;
	
		// should work with symbols and should have deterministic property order (V8 bug)
		module.exports = !$assign || require$$9(function(){
		  var A = {}
		    , B = {}
		    , S = Symbol()
		    , K = 'abcdefghijklmnopqrst';
		  A[S] = 7;
		  K.split('').forEach(function(k){ B[k] = k; });
		  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
		}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
		  var T     = toObject(target)
		    , aLen  = arguments.length
		    , index = 1
		    , getSymbols = gOPS.f
		    , isEnum     = pIE.f;
		  while(aLen > index){
		    var S      = IObject(arguments[index++])
		      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
		      , length = keys.length
		      , j      = 0
		      , key;
		    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
		  } return T;
		} : $assign;
		});
	
		var require$$4$9 = (_objectAssign && typeof _objectAssign === 'object' && 'default' in _objectAssign ? _objectAssign['default'] : _objectAssign);
	
		var es6_object_assign = createCommonjsModule(function (module) {
		// 19.1.3.1 Object.assign(target, source)
		var $export = require$$2$2;
	
		$export($export.S + $export.F, 'Object', {assign: require$$4$9});
		});
	
		var assign$1 = createCommonjsModule(function (module) {
		module.exports = require$$0$1.Object.assign;
		});
	
		var require$$0$16 = (assign$1 && typeof assign$1 === 'object' && 'default' in assign$1 ? assign$1['default'] : assign$1);
	
		var assign = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$16, __esModule: true };
		});
	
		var _Object$assign = (assign && typeof assign === 'object' && 'default' in assign ? assign['default'] : assign);
	
		var classCallCheck = createCommonjsModule(function (module, exports) {
		"use strict";
	
		exports.__esModule = true;
	
		exports.default = function (instance, Constructor) {
		  if (!(instance instanceof Constructor)) {
		    throw new TypeError("Cannot call a class as a function");
		  }
		};
		});
	
		var _classCallCheck = (classCallCheck && typeof classCallCheck === 'object' && 'default' in classCallCheck ? classCallCheck['default'] : classCallCheck);
	
		var _wksExt = createCommonjsModule(function (module, exports) {
		exports.f = require$$19;
		});
	
		var require$$0$19 = (_wksExt && typeof _wksExt === 'object' && 'default' in _wksExt ? _wksExt['default'] : _wksExt);
	
		var _wksDefine = createCommonjsModule(function (module) {
		var global         = require$$12
		  , core           = require$$0$1
		  , LIBRARY        = require$$1$14
		  , wksExt         = require$$0$19
		  , defineProperty = require$$0$7.f;
		module.exports = function(name){
		  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
		  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
		};
		});
	
		var require$$17 = (_wksDefine && typeof _wksDefine === 'object' && 'default' in _wksDefine ? _wksDefine['default'] : _wksDefine);
	
		var es7_symbol_observable = createCommonjsModule(function (module) {
		require$$17('observable');
		});
	
		var es7_symbol_asyncIterator = createCommonjsModule(function (module) {
		require$$17('asyncIterator');
		});
	
		var _enumKeys = createCommonjsModule(function (module) {
		// all enumerable object keys, includes symbols
		var getKeys = require$$1$16
		  , gOPS    = require$$1$18
		  , pIE     = require$$0$15;
		module.exports = function(it){
		  var result     = getKeys(it)
		    , getSymbols = gOPS.f;
		  if(getSymbols){
		    var symbols = getSymbols(it)
		      , isEnum  = pIE.f
		      , i       = 0
		      , key;
		    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
		  } return result;
		};
		});
	
		var require$$15 = (_enumKeys && typeof _enumKeys === 'object' && 'default' in _enumKeys ? _enumKeys['default'] : _enumKeys);
	
		var _keyof = createCommonjsModule(function (module) {
		var getKeys   = require$$1$16
		  , toIObject = require$$2$1;
		module.exports = function(object, el){
		  var O      = toIObject(object)
		    , keys   = getKeys(O)
		    , length = keys.length
		    , index  = 0
		    , key;
		  while(length > index)if(O[key = keys[index++]] === el)return key;
		};
		});
	
		var require$$16 = (_keyof && typeof _keyof === 'object' && 'default' in _keyof ? _keyof['default'] : _keyof);
	
		var _meta = createCommonjsModule(function (module) {
		var META     = require$$4$1('meta')
		  , isObject = require$$4$2
		  , has      = require$$0$4
		  , setDesc  = require$$0$7.f
		  , id       = 0;
		var isExtensible = Object.isExtensible || function(){
		  return true;
		};
		var FREEZE = !require$$9(function(){
		  return isExtensible(Object.preventExtensions({}));
		});
		var setMeta = function(it){
		  setDesc(it, META, {value: {
		    i: 'O' + ++id, // object ID
		    w: {}          // weak collections IDs
		  }});
		};
		var fastKey = function(it, create){
		  // return primitive with prefix
		  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
		  if(!has(it, META)){
		    // can't set metadata to uncaught frozen object
		    if(!isExtensible(it))return 'F';
		    // not necessary to add metadata
		    if(!create)return 'E';
		    // add missing metadata
		    setMeta(it);
		  // return object ID
		  } return it[META].i;
		};
		var getWeak = function(it, create){
		  if(!has(it, META)){
		    // can't set metadata to uncaught frozen object
		    if(!isExtensible(it))return true;
		    // not necessary to add metadata
		    if(!create)return false;
		    // add missing metadata
		    setMeta(it);
		  // return hash weak collections IDs
		  } return it[META].w;
		};
		// add metadata on freeze-family methods calling
		var onFreeze = function(it){
		  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
		  return it;
		};
		var meta = module.exports = {
		  KEY:      META,
		  NEED:     false,
		  fastKey:  fastKey,
		  getWeak:  getWeak,
		  onFreeze: onFreeze
		};
		});
	
		var require$$0$20 = (_meta && typeof _meta === 'object' && 'default' in _meta ? _meta['default'] : _meta);
	
		var es6_symbol = createCommonjsModule(function (module) {
		'use strict';
		// ECMAScript 6 symbols shim
		var global         = require$$12
		  , has            = require$$0$4
		  , DESCRIPTORS    = require$$1$5
		  , $export        = require$$2$2
		  , redefine       = require$$6$2
		  , META           = require$$0$20.KEY
		  , $fails         = require$$9
		  , shared         = require$$22
		  , setToStringTag = require$$3$1
		  , uid            = require$$4$1
		  , wks            = require$$19
		  , wksExt         = require$$0$19
		  , wksDefine      = require$$17
		  , keyOf          = require$$16
		  , enumKeys       = require$$15
		  , isArray        = require$$14
		  , anObject       = require$$2$3
		  , toIObject      = require$$2$1
		  , toPrimitive    = require$$11
		  , createDesc     = require$$0$6
		  , _create        = require$$11$1
		  , gOPNExt        = require$$8
		  , $GOPD          = require$$1$11
		  , $DP            = require$$0$7
		  , $keys          = require$$1$16
		  , gOPD           = $GOPD.f
		  , dP             = $DP.f
		  , gOPN           = gOPNExt.f
		  , $Symbol        = global.Symbol
		  , $JSON          = global.JSON
		  , _stringify     = $JSON && $JSON.stringify
		  , PROTOTYPE      = 'prototype'
		  , HIDDEN         = wks('_hidden')
		  , TO_PRIMITIVE   = wks('toPrimitive')
		  , isEnum         = {}.propertyIsEnumerable
		  , SymbolRegistry = shared('symbol-registry')
		  , AllSymbols     = shared('symbols')
		  , OPSymbols      = shared('op-symbols')
		  , ObjectProto    = Object[PROTOTYPE]
		  , USE_NATIVE     = typeof $Symbol == 'function'
		  , QObject        = global.QObject;
		// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
		var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
		// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
		var setSymbolDesc = DESCRIPTORS && $fails(function(){
		  return _create(dP({}, 'a', {
		    get: function(){ return dP(this, 'a', {value: 7}).a; }
		  })).a != 7;
		}) ? function(it, key, D){
		  var protoDesc = gOPD(ObjectProto, key);
		  if(protoDesc)delete ObjectProto[key];
		  dP(it, key, D);
		  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
		} : dP;
	
		var wrap = function(tag){
		  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
		  sym._k = tag;
		  return sym;
		};
	
		var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
		  return typeof it == 'symbol';
		} : function(it){
		  return it instanceof $Symbol;
		};
	
		var $defineProperty = function defineProperty(it, key, D){
		  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
		  anObject(it);
		  key = toPrimitive(key, true);
		  anObject(D);
		  if(has(AllSymbols, key)){
		    if(!D.enumerable){
		      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
		      it[HIDDEN][key] = true;
		    } else {
		      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
		      D = _create(D, {enumerable: createDesc(0, false)});
		    } return setSymbolDesc(it, key, D);
		  } return dP(it, key, D);
		};
		var $defineProperties = function defineProperties(it, P){
		  anObject(it);
		  var keys = enumKeys(P = toIObject(P))
		    , i    = 0
		    , l = keys.length
		    , key;
		  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
		  return it;
		};
		var $create = function create(it, P){
		  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
		};
		var $propertyIsEnumerable = function propertyIsEnumerable(key){
		  var E = isEnum.call(this, key = toPrimitive(key, true));
		  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
		  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
		};
		var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
		  it  = toIObject(it);
		  key = toPrimitive(key, true);
		  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
		  var D = gOPD(it, key);
		  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
		  return D;
		};
		var $getOwnPropertyNames = function getOwnPropertyNames(it){
		  var names  = gOPN(toIObject(it))
		    , result = []
		    , i      = 0
		    , key;
		  while(names.length > i){
		    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
		  } return result;
		};
		var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
		  var IS_OP  = it === ObjectProto
		    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
		    , result = []
		    , i      = 0
		    , key;
		  while(names.length > i){
		    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
		  } return result;
		};
	
		// 19.4.1.1 Symbol([description])
		if(!USE_NATIVE){
		  $Symbol = function Symbol(){
		    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
		    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
		    var $set = function(value){
		      if(this === ObjectProto)$set.call(OPSymbols, value);
		      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
		      setSymbolDesc(this, tag, createDesc(1, value));
		    };
		    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
		    return wrap(tag);
		  };
		  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
		    return this._k;
		  });
	
		  $GOPD.f = $getOwnPropertyDescriptor;
		  $DP.f   = $defineProperty;
		  require$$4.f = gOPNExt.f = $getOwnPropertyNames;
		  require$$0$15.f  = $propertyIsEnumerable;
		  require$$1$18.f = $getOwnPropertySymbols;
	
		  if(DESCRIPTORS && !require$$1$14){
		    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
		  }
	
		  wksExt.f = function(name){
		    return wrap(wks(name));
		  }
		}
	
		$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});
	
		for(var symbols = (
		  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
		  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
		).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);
	
		for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);
	
		$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
		  // 19.4.2.1 Symbol.for(key)
		  'for': function(key){
		    return has(SymbolRegistry, key += '')
		      ? SymbolRegistry[key]
		      : SymbolRegistry[key] = $Symbol(key);
		  },
		  // 19.4.2.5 Symbol.keyFor(sym)
		  keyFor: function keyFor(key){
		    if(isSymbol(key))return keyOf(SymbolRegistry, key);
		    throw TypeError(key + ' is not a symbol!');
		  },
		  useSetter: function(){ setter = true; },
		  useSimple: function(){ setter = false; }
		});
	
		$export($export.S + $export.F * !USE_NATIVE, 'Object', {
		  // 19.1.2.2 Object.create(O [, Properties])
		  create: $create,
		  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
		  defineProperty: $defineProperty,
		  // 19.1.2.3 Object.defineProperties(O, Properties)
		  defineProperties: $defineProperties,
		  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
		  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
		  // 19.1.2.7 Object.getOwnPropertyNames(O)
		  getOwnPropertyNames: $getOwnPropertyNames,
		  // 19.1.2.8 Object.getOwnPropertySymbols(O)
		  getOwnPropertySymbols: $getOwnPropertySymbols
		});
	
		// 24.3.2 JSON.stringify(value [, replacer [, space]])
		$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
		  var S = $Symbol();
		  // MS Edge converts symbol values to JSON as {}
		  // WebKit converts symbol values to JSON as null
		  // V8 throws on boxed symbols
		  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
		})), 'JSON', {
		  stringify: function stringify(it){
		    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
		    var args = [it]
		      , i    = 1
		      , replacer, $replacer;
		    while(arguments.length > i)args.push(arguments[i++]);
		    replacer = args[1];
		    if(typeof replacer == 'function')$replacer = replacer;
		    if($replacer || !isArray(replacer))replacer = function(key, value){
		      if($replacer)value = $replacer.call(this, key, value);
		      if(!isSymbol(value))return value;
		    };
		    args[1] = replacer;
		    return _stringify.apply($JSON, args);
		  }
		});
	
		// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
		$Symbol[PROTOTYPE][TO_PRIMITIVE] || require$$10($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
		// 19.4.3.5 Symbol.prototype[@@toStringTag]
		setToStringTag($Symbol, 'Symbol');
		// 20.2.1.9 Math[@@toStringTag]
		setToStringTag(Math, 'Math', true);
		// 24.3.3 JSON[@@toStringTag]
		setToStringTag(global.JSON, 'JSON', true);
		});
	
		var index = createCommonjsModule(function (module) {
		module.exports = require$$0$1.Symbol;
		});
	
		var require$$0$18 = (index && typeof index === 'object' && 'default' in index ? index['default'] : index);
	
		var symbol = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$18, __esModule: true };
		});
	
		var require$$0$17 = (symbol && typeof symbol === 'object' && 'default' in symbol ? symbol['default'] : symbol);
	
		var iterator$1 = createCommonjsModule(function (module) {
		module.exports = require$$0$19.f('iterator');
		});
	
		var require$$0$21 = (iterator$1 && typeof iterator$1 === 'object' && 'default' in iterator$1 ? iterator$1['default'] : iterator$1);
	
		var iterator = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$21, __esModule: true };
		});
	
		var require$$1$19 = (iterator && typeof iterator === 'object' && 'default' in iterator ? iterator['default'] : iterator);
	
		var _typeof = createCommonjsModule(function (module, exports) {
		"use strict";
	
		exports.__esModule = true;
	
		var _iterator = require$$1$19;
	
		var _iterator2 = _interopRequireDefault(_iterator);
	
		var _symbol = require$$0$17;
	
		var _symbol2 = _interopRequireDefault(_symbol);
	
		var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj; };
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
		  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
		} : function (obj) {
		  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
		};
		});
	
		var _typeof$1 = (_typeof && typeof _typeof === 'object' && 'default' in _typeof ? _typeof['default'] : _typeof);
	
		var possibleConstructorReturn = createCommonjsModule(function (module, exports) {
		"use strict";
	
		exports.__esModule = true;
	
		var _typeof2 = _typeof$1;
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = function (self, call) {
		  if (!self) {
		    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		  }
	
		  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
		};
		});
	
		var _possibleConstructorReturn = (possibleConstructorReturn && typeof possibleConstructorReturn === 'object' && 'default' in possibleConstructorReturn ? possibleConstructorReturn['default'] : possibleConstructorReturn);
	
		var es6_object_create = createCommonjsModule(function (module) {
		var $export = require$$2$2
		// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
		$export($export.S, 'Object', {create: require$$11$1});
		});
	
		var create$1 = createCommonjsModule(function (module) {
		var $Object = require$$0$1.Object;
		module.exports = function create(P, D){
		  return $Object.create(P, D);
		};
		});
	
		var require$$0$22 = (create$1 && typeof create$1 === 'object' && 'default' in create$1 ? create$1['default'] : create$1);
	
		var create = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$22, __esModule: true };
		});
	
		var require$$1$20 = (create && typeof create === 'object' && 'default' in create ? create['default'] : create);
	
		var es6_object_setPrototypeOf = createCommonjsModule(function (module) {
		// 19.1.3.19 Object.setPrototypeOf(O, proto)
		var $export = require$$2$2;
		$export($export.S, 'Object', {setPrototypeOf: require$$0$14.set});
		});
	
		var setPrototypeOf$1 = createCommonjsModule(function (module) {
		module.exports = require$$0$1.Object.setPrototypeOf;
		});
	
		var require$$0$23 = (setPrototypeOf$1 && typeof setPrototypeOf$1 === 'object' && 'default' in setPrototypeOf$1 ? setPrototypeOf$1['default'] : setPrototypeOf$1);
	
		var setPrototypeOf = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$23, __esModule: true };
		});
	
		var require$$2$6 = (setPrototypeOf && typeof setPrototypeOf === 'object' && 'default' in setPrototypeOf ? setPrototypeOf['default'] : setPrototypeOf);
	
		var inherits = createCommonjsModule(function (module, exports) {
		"use strict";
	
		exports.__esModule = true;
	
		var _setPrototypeOf = require$$2$6;
	
		var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
		var _create = require$$1$20;
	
		var _create2 = _interopRequireDefault(_create);
	
		var _typeof2 = _typeof$1;
	
		var _typeof3 = _interopRequireDefault(_typeof2);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = function (subClass, superClass) {
		  if (typeof superClass !== "function" && superClass !== null) {
		    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
		  }
	
		  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
		    constructor: {
		      value: subClass,
		      enumerable: false,
		      writable: true,
		      configurable: true
		    }
		  });
		  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
		};
		});
	
		var _inherits = (inherits && typeof inherits === 'object' && 'default' in inherits ? inherits['default'] : inherits);
	
		var es6_object_getOwnPropertyDescriptor = createCommonjsModule(function (module) {
		// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
		var toIObject                 = require$$2$1
		  , $getOwnPropertyDescriptor = require$$1$11.f;
	
		require$$0$5('getOwnPropertyDescriptor', function(){
		  return function getOwnPropertyDescriptor(it, key){
		    return $getOwnPropertyDescriptor(toIObject(it), key);
		  };
		});
		});
	
		var getOwnPropertyDescriptor$1 = createCommonjsModule(function (module) {
		var $Object = require$$0$1.Object;
		module.exports = function getOwnPropertyDescriptor(it, key){
		  return $Object.getOwnPropertyDescriptor(it, key);
		};
		});
	
		var require$$0$24 = (getOwnPropertyDescriptor$1 && typeof getOwnPropertyDescriptor$1 === 'object' && 'default' in getOwnPropertyDescriptor$1 ? getOwnPropertyDescriptor$1['default'] : getOwnPropertyDescriptor$1);
	
		var getOwnPropertyDescriptor = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$24, __esModule: true };
		});
	
		var _Object$getOwnPropertyDescriptor = (getOwnPropertyDescriptor && typeof getOwnPropertyDescriptor === 'object' && 'default' in getOwnPropertyDescriptor ? getOwnPropertyDescriptor['default'] : getOwnPropertyDescriptor);
	
		var stringify$1 = createCommonjsModule(function (module) {
		var core  = require$$0$1
		  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
		module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
		  return $JSON.stringify.apply($JSON, arguments);
		};
		});
	
		var require$$0$25 = (stringify$1 && typeof stringify$1 === 'object' && 'default' in stringify$1 ? stringify$1['default'] : stringify$1);
	
		var stringify = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$25, __esModule: true };
		});
	
		var _JSON$stringify = (stringify && typeof stringify === 'object' && 'default' in stringify ? stringify['default'] : stringify);
	
		var _collection = createCommonjsModule(function (module) {
		'use strict';
		var global         = require$$12
		  , $export        = require$$2$2
		  , meta           = require$$0$20
		  , fails          = require$$9
		  , hide           = require$$10
		  , redefineAll    = require$$9$1
		  , forOf          = require$$5
		  , anInstance     = require$$7
		  , isObject       = require$$4$2
		  , setToStringTag = require$$3$1
		  , dP             = require$$0$7.f
		  , each           = require$$1$9(0)
		  , DESCRIPTORS    = require$$1$5;
	
		module.exports = function(NAME, wrapper, methods, common, IS_MAP, IS_WEAK){
		  var Base  = global[NAME]
		    , C     = Base
		    , ADDER = IS_MAP ? 'set' : 'add'
		    , proto = C && C.prototype
		    , O     = {};
		  if(!DESCRIPTORS || typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function(){
		    new C().entries().next();
		  }))){
		    // create collection constructor
		    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
		    redefineAll(C.prototype, methods);
		    meta.NEED = true;
		  } else {
		    C = wrapper(function(target, iterable){
		      anInstance(target, C, NAME, '_c');
		      target._c = new Base;
		      if(iterable != undefined)forOf(iterable, IS_MAP, target[ADDER], target);
		    });
		    each('add,clear,delete,forEach,get,has,set,keys,values,entries,toJSON'.split(','),function(KEY){
		      var IS_ADDER = KEY == 'add' || KEY == 'set';
		      if(KEY in proto && !(IS_WEAK && KEY == 'clear'))hide(C.prototype, KEY, function(a, b){
		        anInstance(this, C, KEY);
		        if(!IS_ADDER && IS_WEAK && !isObject(a))return KEY == 'get' ? undefined : false;
		        var result = this._c[KEY](a === 0 ? 0 : a, b);
		        return IS_ADDER ? this : result;
		      });
		    });
		    if('size' in proto)dP(C.prototype, 'size', {
		      get: function(){
		        return this._c.size;
		      }
		    });
		  }
	
		  setToStringTag(C, NAME);
	
		  O[NAME] = C;
		  $export($export.G + $export.W + $export.F, O);
	
		  if(!IS_WEAK)common.setStrong(C, NAME, IS_MAP);
	
		  return C;
		};
		});
	
		var require$$0$27 = (_collection && typeof _collection === 'object' && 'default' in _collection ? _collection['default'] : _collection);
	
		var _collectionWeak = createCommonjsModule(function (module) {
		'use strict';
		var redefineAll       = require$$9$1
		  , getWeak           = require$$0$20.getWeak
		  , anObject          = require$$2$3
		  , isObject          = require$$4$2
		  , anInstance        = require$$7
		  , forOf             = require$$5
		  , createArrayMethod = require$$1$9
		  , $has              = require$$0$4
		  , arrayFind         = createArrayMethod(5)
		  , arrayFindIndex    = createArrayMethod(6)
		  , id                = 0;
	
		// fallback for uncaught frozen keys
		var uncaughtFrozenStore = function(that){
		  return that._l || (that._l = new UncaughtFrozenStore);
		};
		var UncaughtFrozenStore = function(){
		  this.a = [];
		};
		var findUncaughtFrozen = function(store, key){
		  return arrayFind(store.a, function(it){
		    return it[0] === key;
		  });
		};
		UncaughtFrozenStore.prototype = {
		  get: function(key){
		    var entry = findUncaughtFrozen(this, key);
		    if(entry)return entry[1];
		  },
		  has: function(key){
		    return !!findUncaughtFrozen(this, key);
		  },
		  set: function(key, value){
		    var entry = findUncaughtFrozen(this, key);
		    if(entry)entry[1] = value;
		    else this.a.push([key, value]);
		  },
		  'delete': function(key){
		    var index = arrayFindIndex(this.a, function(it){
		      return it[0] === key;
		    });
		    if(~index)this.a.splice(index, 1);
		    return !!~index;
		  }
		};
	
		module.exports = {
		  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
		    var C = wrapper(function(that, iterable){
		      anInstance(that, C, NAME, '_i');
		      that._i = id++;      // collection id
		      that._l = undefined; // leak store for uncaught frozen objects
		      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
		    });
		    redefineAll(C.prototype, {
		      // 23.3.3.2 WeakMap.prototype.delete(key)
		      // 23.4.3.3 WeakSet.prototype.delete(value)
		      'delete': function(key){
		        if(!isObject(key))return false;
		        var data = getWeak(key);
		        if(data === true)return uncaughtFrozenStore(this)['delete'](key);
		        return data && $has(data, this._i) && delete data[this._i];
		      },
		      // 23.3.3.4 WeakMap.prototype.has(key)
		      // 23.4.3.4 WeakSet.prototype.has(value)
		      has: function has(key){
		        if(!isObject(key))return false;
		        var data = getWeak(key);
		        if(data === true)return uncaughtFrozenStore(this).has(key);
		        return data && $has(data, this._i);
		      }
		    });
		    return C;
		  },
		  def: function(that, key, value){
		    var data = getWeak(anObject(key), true);
		    if(data === true)uncaughtFrozenStore(that).set(key, value);
		    else data[that._i] = value;
		    return that;
		  },
		  ufstore: uncaughtFrozenStore
		};
		});
	
		var require$$3$4 = (_collectionWeak && typeof _collectionWeak === 'object' && 'default' in _collectionWeak ? _collectionWeak['default'] : _collectionWeak);
	
		var es6_weakMap = createCommonjsModule(function (module) {
		'use strict';
		var each         = require$$1$9(0)
		  , redefine     = require$$6$2
		  , meta         = require$$0$20
		  , assign       = require$$4$9
		  , weak         = require$$3$4
		  , isObject     = require$$4$2
		  , has          = require$$0$4
		  , getWeak      = meta.getWeak
		  , isExtensible = Object.isExtensible
		  , uncaughtFrozenStore = weak.ufstore
		  , tmp          = {}
		  , InternalMap;
	
		var wrapper = function(get){
		  return function WeakMap(){
		    return get(this, arguments.length > 0 ? arguments[0] : undefined);
		  };
		};
	
		var methods = {
		  // 23.3.3.3 WeakMap.prototype.get(key)
		  get: function get(key){
		    if(isObject(key)){
		      var data = getWeak(key);
		      if(data === true)return uncaughtFrozenStore(this).get(key);
		      return data ? data[this._i] : undefined;
		    }
		  },
		  // 23.3.3.5 WeakMap.prototype.set(key, value)
		  set: function set(key, value){
		    return weak.def(this, key, value);
		  }
		};
	
		// 23.3 WeakMap Objects
		var $WeakMap = module.exports = require$$0$27('WeakMap', wrapper, methods, weak, true, true);
	
		// IE11 WeakMap frozen keys fix
		if(new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7){
		  InternalMap = weak.getConstructor(wrapper);
		  assign(InternalMap.prototype, methods);
		  meta.NEED = true;
		  each(['delete', 'has', 'get', 'set'], function(key){
		    var proto  = $WeakMap.prototype
		      , method = proto[key];
		    redefine(proto, key, function(a, b){
		      // store frozen objects on internal weakmap shim
		      if(isObject(a) && !isExtensible(a)){
		        if(!this._f)this._f = new InternalMap;
		        var result = this._f[key](a, b);
		        return key == 'set' ? this : result;
		      // store all the rest on native weakmap
		      } return method.call(this, a, b);
		    });
		  });
		}
		});
	
		var weakMap$1 = createCommonjsModule(function (module) {
		module.exports = require$$0$1.WeakMap;
		});
	
		var require$$0$26 = (weakMap$1 && typeof weakMap$1 === 'object' && 'default' in weakMap$1 ? weakMap$1['default'] : weakMap$1);
	
		var weakMap = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$26, __esModule: true };
		});
	
		var _WeakMap = (weakMap && typeof weakMap === 'object' && 'default' in weakMap ? weakMap['default'] : weakMap);
	
		var _createProperty = createCommonjsModule(function (module) {
		'use strict';
		var $defineProperty = require$$0$7
		  , createDesc      = require$$0$6;
	
		module.exports = function(object, index, value){
		  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
		  else object[index] = value;
		};
		});
	
		var require$$2$7 = (_createProperty && typeof _createProperty === 'object' && 'default' in _createProperty ? _createProperty['default'] : _createProperty);
	
		var es6_array_from = createCommonjsModule(function (module) {
		'use strict';
		var ctx            = require$$8$1
		  , $export        = require$$2$2
		  , toObject       = require$$2$4
		  , call           = require$$5$1
		  , isArrayIter    = require$$4$6
		  , toLength       = require$$3
		  , createProperty = require$$2$7
		  , getIterFn      = require$$1$12;
	
		$export($export.S + $export.F * !require$$0$12(function(iter){ Array.from(iter); }), 'Array', {
		  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
		  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
		    var O       = toObject(arrayLike)
		      , C       = typeof this == 'function' ? this : Array
		      , aLen    = arguments.length
		      , mapfn   = aLen > 1 ? arguments[1] : undefined
		      , mapping = mapfn !== undefined
		      , index   = 0
		      , iterFn  = getIterFn(O)
		      , length, result, step, iterator;
		    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
		    // if object isn't iterable or it's array with default iterator - use simple case
		    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
		      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
		        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
		      }
		    } else {
		      length = toLength(O.length);
		      for(result = new C(length); length > index; index++){
		        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
		      }
		    }
		    result.length = index;
		    return result;
		  }
		});
		});
	
		var from$1 = createCommonjsModule(function (module) {
		module.exports = require$$0$1.Array.from;
		});
	
		var require$$0$28 = (from$1 && typeof from$1 === 'object' && 'default' in from$1 ? from$1['default'] : from$1);
	
		var from = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$28, __esModule: true };
		});
	
		var _Array$from = (from && typeof from === 'object' && 'default' in from ? from['default'] : from);
	
		var toConsumableArray = createCommonjsModule(function (module, exports) {
		"use strict";
	
		exports.__esModule = true;
	
		var _from = _Array$from;
	
		var _from2 = _interopRequireDefault(_from);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = function (arr) {
		  if (Array.isArray(arr)) {
		    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
		      arr2[i] = arr[i];
		    }
	
		    return arr2;
		  } else {
		    return (0, _from2.default)(arr);
		  }
		};
		});
	
		var _toConsumableArray = (toConsumableArray && typeof toConsumableArray === 'object' && 'default' in toConsumableArray ? toConsumableArray['default'] : toConsumableArray);
	
		var _arrayFromIterable = createCommonjsModule(function (module) {
		var forOf = require$$5;
	
		module.exports = function(iter, ITERATOR){
		  var result = [];
		  forOf(iter, false, result.push, result, ITERATOR);
		  return result;
		};
		});
	
		var require$$0$31 = (_arrayFromIterable && typeof _arrayFromIterable === 'object' && 'default' in _arrayFromIterable ? _arrayFromIterable['default'] : _arrayFromIterable);
	
		var _collectionToJson = createCommonjsModule(function (module) {
		// https://github.com/DavidBruant/Map-Set.prototype.toJSON
		var classof = require$$1$13
		  , from    = require$$0$31;
		module.exports = function(NAME){
		  return function toJSON(){
		    if(classof(this) != NAME)throw TypeError(NAME + "#toJSON isn't generic");
		    return from(this);
		  };
		};
		});
	
		var require$$0$30 = (_collectionToJson && typeof _collectionToJson === 'object' && 'default' in _collectionToJson ? _collectionToJson['default'] : _collectionToJson);
	
		var es7_set_toJson = createCommonjsModule(function (module) {
		// https://github.com/DavidBruant/Map-Set.prototype.toJSON
		var $export  = require$$2$2;
	
		$export($export.P + $export.R, 'Set', {toJSON: require$$0$30('Set')});
		});
	
		var _collectionStrong = createCommonjsModule(function (module) {
		'use strict';
		var dP          = require$$0$7.f
		  , create      = require$$11$1
		  , hide        = require$$10
		  , redefineAll = require$$9$1
		  , ctx         = require$$8$1
		  , anInstance  = require$$7
		  , defined     = require$$6
		  , forOf       = require$$5
		  , $iterDefine = require$$4$7
		  , step        = require$$3$3
		  , setSpecies  = require$$2$5
		  , DESCRIPTORS = require$$1$5
		  , fastKey     = require$$0$20.fastKey
		  , SIZE        = DESCRIPTORS ? '_s' : 'size';
	
		var getEntry = function(that, key){
		  // fast case
		  var index = fastKey(key), entry;
		  if(index !== 'F')return that._i[index];
		  // frozen object case
		  for(entry = that._f; entry; entry = entry.n){
		    if(entry.k == key)return entry;
		  }
		};
	
		module.exports = {
		  getConstructor: function(wrapper, NAME, IS_MAP, ADDER){
		    var C = wrapper(function(that, iterable){
		      anInstance(that, C, NAME, '_i');
		      that._i = create(null); // index
		      that._f = undefined;    // first entry
		      that._l = undefined;    // last entry
		      that[SIZE] = 0;         // size
		      if(iterable != undefined)forOf(iterable, IS_MAP, that[ADDER], that);
		    });
		    redefineAll(C.prototype, {
		      // 23.1.3.1 Map.prototype.clear()
		      // 23.2.3.2 Set.prototype.clear()
		      clear: function clear(){
		        for(var that = this, data = that._i, entry = that._f; entry; entry = entry.n){
		          entry.r = true;
		          if(entry.p)entry.p = entry.p.n = undefined;
		          delete data[entry.i];
		        }
		        that._f = that._l = undefined;
		        that[SIZE] = 0;
		      },
		      // 23.1.3.3 Map.prototype.delete(key)
		      // 23.2.3.4 Set.prototype.delete(value)
		      'delete': function(key){
		        var that  = this
		          , entry = getEntry(that, key);
		        if(entry){
		          var next = entry.n
		            , prev = entry.p;
		          delete that._i[entry.i];
		          entry.r = true;
		          if(prev)prev.n = next;
		          if(next)next.p = prev;
		          if(that._f == entry)that._f = next;
		          if(that._l == entry)that._l = prev;
		          that[SIZE]--;
		        } return !!entry;
		      },
		      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
		      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
		      forEach: function forEach(callbackfn /*, that = undefined */){
		        anInstance(this, C, 'forEach');
		        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3)
		          , entry;
		        while(entry = entry ? entry.n : this._f){
		          f(entry.v, entry.k, this);
		          // revert to the last existing entry
		          while(entry && entry.r)entry = entry.p;
		        }
		      },
		      // 23.1.3.7 Map.prototype.has(key)
		      // 23.2.3.7 Set.prototype.has(value)
		      has: function has(key){
		        return !!getEntry(this, key);
		      }
		    });
		    if(DESCRIPTORS)dP(C.prototype, 'size', {
		      get: function(){
		        return defined(this[SIZE]);
		      }
		    });
		    return C;
		  },
		  def: function(that, key, value){
		    var entry = getEntry(that, key)
		      , prev, index;
		    // change existing entry
		    if(entry){
		      entry.v = value;
		    // create new entry
		    } else {
		      that._l = entry = {
		        i: index = fastKey(key, true), // <- index
		        k: key,                        // <- key
		        v: value,                      // <- value
		        p: prev = that._l,             // <- previous entry
		        n: undefined,                  // <- next entry
		        r: false                       // <- removed
		      };
		      if(!that._f)that._f = entry;
		      if(prev)prev.n = entry;
		      that[SIZE]++;
		      // add to index
		      if(index !== 'F')that._i[index] = entry;
		    } return that;
		  },
		  getEntry: getEntry,
		  setStrong: function(C, NAME, IS_MAP){
		    // add .keys, .values, .entries, [@@iterator]
		    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
		    $iterDefine(C, NAME, function(iterated, kind){
		      this._t = iterated;  // target
		      this._k = kind;      // kind
		      this._l = undefined; // previous
		    }, function(){
		      var that  = this
		        , kind  = that._k
		        , entry = that._l;
		      // revert to the last existing entry
		      while(entry && entry.r)entry = entry.p;
		      // get next entry
		      if(!that._t || !(that._l = entry = entry ? entry.n : that._t._f)){
		        // or finish the iteration
		        that._t = undefined;
		        return step(1);
		      }
		      // return step by kind
		      if(kind == 'keys'  )return step(0, entry.k);
		      if(kind == 'values')return step(0, entry.v);
		      return step(0, [entry.k, entry.v]);
		    }, IS_MAP ? 'entries' : 'values' , !IS_MAP, true);
	
		    // add [@@species], 23.1.2.2, 23.2.2.2
		    setSpecies(NAME);
		  }
		};
		});
	
		var require$$1$21 = (_collectionStrong && typeof _collectionStrong === 'object' && 'default' in _collectionStrong ? _collectionStrong['default'] : _collectionStrong);
	
		var es6_set = createCommonjsModule(function (module) {
		'use strict';
		var strong = require$$1$21;
	
		// 23.2 Set Objects
		module.exports = require$$0$27('Set', function(get){
		  return function Set(){ return get(this, arguments.length > 0 ? arguments[0] : undefined); };
		}, {
		  // 23.2.3.1 Set.prototype.add(value)
		  add: function add(value){
		    return strong.def(this, value = value === 0 ? 0 : value, value);
		  }
		}, strong);
		});
	
		var set$3 = createCommonjsModule(function (module) {
		module.exports = require$$0$1.Set;
		});
	
		var require$$0$29 = (set$3 && typeof set$3 === 'object' && 'default' in set$3 ? set$3['default'] : set$3);
	
		var set$2 = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$29, __esModule: true };
		});
	
		var _Set = (set$2 && typeof set$2 === 'object' && 'default' in set$2 ? set$2['default'] : set$2);
	
		var es6_object_defineProperty = createCommonjsModule(function (module) {
		var $export = require$$2$2;
		// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
		$export($export.S + $export.F * !require$$1$5, 'Object', {defineProperty: require$$0$7.f});
		});
	
		var defineProperty$2 = createCommonjsModule(function (module) {
		var $Object = require$$0$1.Object;
		module.exports = function defineProperty(it, key, desc){
		  return $Object.defineProperty(it, key, desc);
		};
		});
	
		var require$$0$33 = (defineProperty$2 && typeof defineProperty$2 === 'object' && 'default' in defineProperty$2 ? defineProperty$2['default'] : defineProperty$2);
	
		var defineProperty$1 = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$33, __esModule: true };
		});
	
		var require$$0$32 = (defineProperty$1 && typeof defineProperty$1 === 'object' && 'default' in defineProperty$1 ? defineProperty$1['default'] : defineProperty$1);
	
		var defineProperty = createCommonjsModule(function (module, exports) {
		"use strict";
	
		exports.__esModule = true;
	
		var _defineProperty = require$$0$32;
	
		var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = function (obj, key, value) {
		  if (key in obj) {
		    (0, _defineProperty2.default)(obj, key, {
		      value: value,
		      enumerable: true,
		      configurable: true,
		      writable: true
		    });
		  } else {
		    obj[key] = value;
		  }
	
		  return obj;
		};
		});
	
		var _defineProperty = (defineProperty && typeof defineProperty === 'object' && 'default' in defineProperty ? defineProperty['default'] : defineProperty);
	
		var es6_object_keys = createCommonjsModule(function (module) {
		// 19.1.2.14 Object.keys(O)
		var toObject = require$$2$4
		  , $keys    = require$$1$16;
	
		require$$0$5('keys', function(){
		  return function keys(it){
		    return $keys(toObject(it));
		  };
		});
		});
	
		var keys$1 = createCommonjsModule(function (module) {
		module.exports = require$$0$1.Object.keys;
		});
	
		var require$$0$34 = (keys$1 && typeof keys$1 === 'object' && 'default' in keys$1 ? keys$1['default'] : keys$1);
	
		var keys = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$34, __esModule: true };
		});
	
		var _Object$keys = (keys && typeof keys === 'object' && 'default' in keys ? keys['default'] : keys);
	
		var isObjectLike = createCommonjsModule(function (module) {
		/**
		 * Checks if `value` is object-like. A value is object-like if it's not `null`
		 * and has a `typeof` result of "object".
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
		 * @example
		 *
		 * _.isObjectLike({});
		 * // => true
		 *
		 * _.isObjectLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isObjectLike(_.noop);
		 * // => false
		 *
		 * _.isObjectLike(null);
		 * // => false
		 */
		function isObjectLike(value) {
		  return !!value && typeof value == 'object';
		}
	
		module.exports = isObjectLike;
		});
	
		var require$$0$35 = (isObjectLike && typeof isObjectLike === 'object' && 'default' in isObjectLike ? isObjectLike['default'] : isObjectLike);
	
		var _isHostObject = createCommonjsModule(function (module) {
		/**
		 * Checks if `value` is a host object in IE < 9.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
		 */
		function isHostObject(value) {
		  // Many host objects are `Object` objects that can coerce to strings
		  // despite having improperly defined `toString` methods.
		  var result = false;
		  if (value != null && typeof value.toString != 'function') {
		    try {
		      result = !!(value + '');
		    } catch (e) {}
		  }
		  return result;
		}
	
		module.exports = isHostObject;
		});
	
		var require$$3$5 = (_isHostObject && typeof _isHostObject === 'object' && 'default' in _isHostObject ? _isHostObject['default'] : _isHostObject);
	
		var _getPrototype = createCommonjsModule(function (module) {
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeGetPrototype = Object.getPrototypeOf;
	
		/**
		 * Gets the `[[Prototype]]` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {null|Object} Returns the `[[Prototype]]`.
		 */
		function getPrototype(value) {
		  return nativeGetPrototype(Object(value));
		}
	
		module.exports = getPrototype;
		});
	
		var require$$0$36 = (_getPrototype && typeof _getPrototype === 'object' && 'default' in _getPrototype ? _getPrototype['default'] : _getPrototype);
	
		var isPlainObject = createCommonjsModule(function (module) {
		var getPrototype = require$$0$36,
		    isHostObject = require$$3$5,
		    isObjectLike = require$$0$35;
	
		/** `Object#toString` result references. */
		var objectTag = '[object Object]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = Function.prototype.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to infer the `Object` constructor. */
		var objectCtorString = funcToString.call(Object);
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/**
		 * Checks if `value` is a plain object, that is, an object created by the
		 * `Object` constructor or one with a `[[Prototype]]` of `null`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.8.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a plain object,
		 *  else `false`.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 * }
		 *
		 * _.isPlainObject(new Foo);
		 * // => false
		 *
		 * _.isPlainObject([1, 2, 3]);
		 * // => false
		 *
		 * _.isPlainObject({ 'x': 0, 'y': 0 });
		 * // => true
		 *
		 * _.isPlainObject(Object.create(null));
		 * // => true
		 */
		function isPlainObject(value) {
		  if (!isObjectLike(value) ||
		      objectToString.call(value) != objectTag || isHostObject(value)) {
		    return false;
		  }
		  var proto = getPrototype(value);
		  if (proto === null) {
		    return true;
		  }
		  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
		  return (typeof Ctor == 'function' &&
		    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
		}
	
		module.exports = isPlainObject;
		});
	
		var isPlainObject$1 = (isPlainObject && typeof isPlainObject === 'object' && 'default' in isPlainObject ? isPlainObject['default'] : isPlainObject);
	
		var index$1 = createCommonjsModule(function (module) {
		/**
		 * Helpers.
		 */
	
		var s = 1000;
		var m = s * 60;
		var h = m * 60;
		var d = h * 24;
		var y = d * 365.25;
	
		/**
		 * Parse or format the given `val`.
		 *
		 * Options:
		 *
		 *  - `long` verbose formatting [false]
		 *
		 * @param {String|Number} val
		 * @param {Object} options
		 * @return {String|Number}
		 * @api public
		 */
	
		module.exports = function(val, options){
		  options = options || {};
		  if ('string' == typeof val) return parse(val);
		  return options.long
		    ? long(val)
		    : short(val);
		};
	
		/**
		 * Parse the given `str` and return milliseconds.
		 *
		 * @param {String} str
		 * @return {Number}
		 * @api private
		 */
	
		function parse(str) {
		  str = '' + str;
		  if (str.length > 10000) return;
		  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
		  if (!match) return;
		  var n = parseFloat(match[1]);
		  var type = (match[2] || 'ms').toLowerCase();
		  switch (type) {
		    case 'years':
		    case 'year':
		    case 'yrs':
		    case 'yr':
		    case 'y':
		      return n * y;
		    case 'days':
		    case 'day':
		    case 'd':
		      return n * d;
		    case 'hours':
		    case 'hour':
		    case 'hrs':
		    case 'hr':
		    case 'h':
		      return n * h;
		    case 'minutes':
		    case 'minute':
		    case 'mins':
		    case 'min':
		    case 'm':
		      return n * m;
		    case 'seconds':
		    case 'second':
		    case 'secs':
		    case 'sec':
		    case 's':
		      return n * s;
		    case 'milliseconds':
		    case 'millisecond':
		    case 'msecs':
		    case 'msec':
		    case 'ms':
		      return n;
		  }
		}
	
		/**
		 * Short format for `ms`.
		 *
		 * @param {Number} ms
		 * @return {String}
		 * @api private
		 */
	
		function short(ms) {
		  if (ms >= d) return Math.round(ms / d) + 'd';
		  if (ms >= h) return Math.round(ms / h) + 'h';
		  if (ms >= m) return Math.round(ms / m) + 'm';
		  if (ms >= s) return Math.round(ms / s) + 's';
		  return ms + 'ms';
		}
	
		/**
		 * Long format for `ms`.
		 *
		 * @param {Number} ms
		 * @return {String}
		 * @api private
		 */
	
		function long(ms) {
		  return plural(ms, d, 'day')
		    || plural(ms, h, 'hour')
		    || plural(ms, m, 'minute')
		    || plural(ms, s, 'second')
		    || ms + ' ms';
		}
	
		/**
		 * Pluralization helper.
		 */
	
		function plural(ms, n, name) {
		  if (ms < n) return;
		  if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
		  return Math.ceil(ms / n) + ' ' + name + 's';
		}
		});
	
		var require$$0$38 = (index$1 && typeof index$1 === 'object' && 'default' in index$1 ? index$1['default'] : index$1);
	
		var debug$4 = createCommonjsModule(function (module, exports) {
		/**
		 * This is the common logic for both the Node.js and web browser
		 * implementations of `debug()`.
		 *
		 * Expose `debug()` as the module.
		 */
	
		exports = module.exports = debug;
		exports.coerce = coerce;
		exports.disable = disable;
		exports.enable = enable;
		exports.enabled = enabled;
		exports.humanize = require$$0$38;
	
		/**
		 * The currently active debug mode names, and names to skip.
		 */
	
		exports.names = [];
		exports.skips = [];
	
		/**
		 * Map of special "%n" handling functions, for the debug "format" argument.
		 *
		 * Valid key names are a single, lowercased letter, i.e. "n".
		 */
	
		exports.formatters = {};
	
		/**
		 * Previously assigned color.
		 */
	
		var prevColor = 0;
	
		/**
		 * Previous log timestamp.
		 */
	
		var prevTime;
	
		/**
		 * Select a color.
		 *
		 * @return {Number}
		 * @api private
		 */
	
		function selectColor() {
		  return exports.colors[prevColor++ % exports.colors.length];
		}
	
		/**
		 * Create a debugger with the given `namespace`.
		 *
		 * @param {String} namespace
		 * @return {Function}
		 * @api public
		 */
	
		function debug(namespace) {
	
		  // define the `disabled` version
		  function disabled() {
		  }
		  disabled.enabled = false;
	
		  // define the `enabled` version
		  function enabled() {
	
		    var self = enabled;
	
		    // set `diff` timestamp
		    var curr = +new Date();
		    var ms = curr - (prevTime || curr);
		    self.diff = ms;
		    self.prev = prevTime;
		    self.curr = curr;
		    prevTime = curr;
	
		    // add the `color` if not set
		    if (null == self.useColors) self.useColors = exports.useColors();
		    if (null == self.color && self.useColors) self.color = selectColor();
	
		    var args = Array.prototype.slice.call(arguments);
	
		    args[0] = exports.coerce(args[0]);
	
		    if ('string' !== typeof args[0]) {
		      // anything else let's inspect with %o
		      args = ['%o'].concat(args);
		    }
	
		    // apply any `formatters` transformations
		    var index = 0;
		    args[0] = args[0].replace(/%([a-z%])/g, function(match, format) {
		      // if we encounter an escaped % then don't increase the array index
		      if (match === '%%') return match;
		      index++;
		      var formatter = exports.formatters[format];
		      if ('function' === typeof formatter) {
		        var val = args[index];
		        match = formatter.call(self, val);
	
		        // now we need to remove `args[index]` since it's inlined in the `format`
		        args.splice(index, 1);
		        index--;
		      }
		      return match;
		    });
	
		    if ('function' === typeof exports.formatArgs) {
		      args = exports.formatArgs.apply(self, args);
		    }
		    var logFn = enabled.log || exports.log || console.log.bind(console);
		    logFn.apply(self, args);
		  }
		  enabled.enabled = true;
	
		  var fn = exports.enabled(namespace) ? enabled : disabled;
	
		  fn.namespace = namespace;
	
		  return fn;
		}
	
		/**
		 * Enables a debug mode by namespaces. This can include modes
		 * separated by a colon and wildcards.
		 *
		 * @param {String} namespaces
		 * @api public
		 */
	
		function enable(namespaces) {
		  exports.save(namespaces);
	
		  var split = (namespaces || '').split(/[\s,]+/);
		  var len = split.length;
	
		  for (var i = 0; i < len; i++) {
		    if (!split[i]) continue; // ignore empty strings
		    namespaces = split[i].replace(/\*/g, '.*?');
		    if (namespaces[0] === '-') {
		      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
		    } else {
		      exports.names.push(new RegExp('^' + namespaces + '$'));
		    }
		  }
		}
	
		/**
		 * Disable debug output.
		 *
		 * @api public
		 */
	
		function disable() {
		  exports.enable('');
		}
	
		/**
		 * Returns true if the given mode name is enabled, false otherwise.
		 *
		 * @param {String} name
		 * @return {Boolean}
		 * @api public
		 */
	
		function enabled(name) {
		  var i, len;
		  for (i = 0, len = exports.skips.length; i < len; i++) {
		    if (exports.skips[i].test(name)) {
		      return false;
		    }
		  }
		  for (i = 0, len = exports.names.length; i < len; i++) {
		    if (exports.names[i].test(name)) {
		      return true;
		    }
		  }
		  return false;
		}
	
		/**
		 * Coerce `val`.
		 *
		 * @param {Mixed} val
		 * @return {Mixed}
		 * @api private
		 */
	
		function coerce(val) {
		  if (val instanceof Error) return val.stack || val.message;
		  return val;
		}
		});
	
		var require$$0$37 = (debug$4 && typeof debug$4 === 'object' && 'default' in debug$4 ? debug$4['default'] : debug$4);
	
		var browser = createCommonjsModule(function (module, exports) {
		/**
		 * This is the web browser implementation of `debug()`.
		 *
		 * Expose `debug()` as the module.
		 */
	
		exports = module.exports = require$$0$37;
		exports.log = log;
		exports.formatArgs = formatArgs;
		exports.save = save;
		exports.load = load;
		exports.useColors = useColors;
		exports.storage = 'undefined' != typeof chrome
		               && 'undefined' != typeof chrome.storage
		                  ? chrome.storage.local
		                  : localstorage();
	
		/**
		 * Colors.
		 */
	
		exports.colors = [
		  'lightseagreen',
		  'forestgreen',
		  'goldenrod',
		  'dodgerblue',
		  'darkorchid',
		  'crimson'
		];
	
		/**
		 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
		 * and the Firebug extension (any Firefox version) are known
		 * to support "%c" CSS customizations.
		 *
		 * TODO: add a `localStorage` variable to explicitly enable/disable colors
		 */
	
		function useColors() {
		  // is webkit? http://stackoverflow.com/a/16459606/376773
		  return ('WebkitAppearance' in document.documentElement.style) ||
		    // is firebug? http://stackoverflow.com/a/398120/376773
		    (window.console && (console.firebug || (console.exception && console.table))) ||
		    // is firefox >= v31?
		    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		    (navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31);
		}
	
		/**
		 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
		 */
	
		exports.formatters.j = function(v) {
		  return JSON.stringify(v);
		};
	
	
		/**
		 * Colorize log arguments if enabled.
		 *
		 * @api public
		 */
	
		function formatArgs() {
		  var args = arguments;
		  var useColors = this.useColors;
	
		  args[0] = (useColors ? '%c' : '')
		    + this.namespace
		    + (useColors ? ' %c' : ' ')
		    + args[0]
		    + (useColors ? '%c ' : ' ')
		    + '+' + exports.humanize(this.diff);
	
		  if (!useColors) return args;
	
		  var c = 'color: ' + this.color;
		  args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
		  // the final "%c" is somewhat tricky, because there could be other
		  // arguments passed either before or after the %c, so we need to
		  // figure out the correct index to insert the CSS into
		  var index = 0;
		  var lastC = 0;
		  args[0].replace(/%[a-z%]/g, function(match) {
		    if ('%%' === match) return;
		    index++;
		    if ('%c' === match) {
		      // we only are interested in the *last* %c
		      // (the user may have provided their own)
		      lastC = index;
		    }
		  });
	
		  args.splice(lastC, 0, c);
		  return args;
		}
	
		/**
		 * Invokes `console.log()` when available.
		 * No-op when `console.log` is not a "function".
		 *
		 * @api public
		 */
	
		function log() {
		  // this hackery is required for IE8/9, where
		  // the `console.log` function doesn't have 'apply'
		  return 'object' === typeof console
		    && console.log
		    && Function.prototype.apply.call(console.log, console, arguments);
		}
	
		/**
		 * Save `namespaces`.
		 *
		 * @param {String} namespaces
		 * @api private
		 */
	
		function save(namespaces) {
		  try {
		    if (null == namespaces) {
		      exports.storage.removeItem('debug');
		    } else {
		      exports.storage.debug = namespaces;
		    }
		  } catch(e) {}
		}
	
		/**
		 * Load `namespaces`.
		 *
		 * @return {String} returns the previously persisted debug modes
		 * @api private
		 */
	
		function load() {
		  var r;
		  try {
		    r = exports.storage.debug;
		  } catch(e) {}
		  return r;
		}
	
		/**
		 * Enable namespaces listed in `localStorage.debug` initially.
		 */
	
		exports.enable(load());
	
		/**
		 * Localstorage attempts to return the localstorage.
		 *
		 * This is necessary because safari throws
		 * when a user disables cookies/localstorage
		 * and you attempt to access it.
		 *
		 * @return {LocalStorage}
		 * @api private
		 */
	
		function localstorage(){
		  try {
		    return window.localStorage;
		  } catch (e) {}
		}
		});
	
		var d = (browser && typeof browser === 'object' && 'default' in browser ? browser['default'] : browser);
	
		var tryAll = function tryAll(promiseConstructors) {
		  var promise = new _Promise(promiseConstructors[0]);
		  if (promiseConstructors.length === 1) {
		    return promise;
		  }
		  return promise.catch(function () {
		    return tryAll(promiseConstructors.slice(1));
		  });
		};
	
		var tap = function tap(interceptor) {
		  return function (value) {
		    return interceptor(value), value;
		  };
		};
	
		var debug$3 = d('LC:Cache');
		var Cache = function () {
		  function Cache() {
		    var name = arguments.length <= 0 || arguments[0] === undefined ? 'anonymous' : arguments[0];
	
		    _classCallCheck(this, Cache);
	
		    this.name = name;
		    this._map = {};
		  }
	
		  Cache.prototype.get = function get(key) {
		    var cache = this._map[key];
		    if (cache) {
		      var expired = cache.expiredAt && cache.expiredAt < Date.now();
		      if (!expired) {
		        debug$3('[' + this.name + '] hit: ' + key + ' ' + cache.value);
		        return cache.value;
		      }
		      debug$3('[' + this.name + '] expired: ' + key);
		      delete this._map[key];
		    }
		    debug$3('[' + this.name + '] missed: ' + key);
		    return null;
		  };
	
		  Cache.prototype.set = function set(key, value, ttl) {
		    debug$3('[' + this.name + '] set: ' + key + ' ' + value + ' ' + ttl);
		    var cache = this._map[key] = {
		      value: value
		    };
		    if (typeof ttl === 'number') {
		      cache.expiredAt = Date.now() + ttl;
		    }
		  };
	
		  return Cache;
		}();
	
		var decodeDate = function decodeDate(date) {
		  if (!date) return date;
		  if (typeof date === 'string') {
		    return new Date(date);
		  }
		  if (date.__type === 'Date' && date.iso) {
		    return new Date(date.iso);
		  }
		  return date;
		};
	
		var keyRemap = function keyRemap(keymap, obj) {
		  return _Object$keys(obj).reduce(function (newObj, key) {
		    var newKey = keymap[key] || key;
		    return _Object$assign(newObj, _defineProperty({}, newKey, obj[key]));
		  }, {});
		};
	
		var isIE10 = global.navigator && global.navigator.userAgent && global.navigator.userAgent.indexOf('MSIE 10.') !== -1;
	
		/* eslint-disable no-proto */
		var getStaticProperty = function getStaticProperty(klass, property) {
		  return klass[property] || (klass.__proto__ ? getStaticProperty(klass.__proto__, property) : undefined);
		};
		/* eslint-enable no-proto */
	
		var union = function union(a, b) {
		  return _Array$from(new _Set([].concat(_toConsumableArray(a), _toConsumableArray(b))));
		};
		var difference = function difference(a, b) {
		  return _Array$from(function (bSet) {
		    return new _Set(a.filter(function (x) {
		      return !bSet.has(x);
		    }));
		  }(new _Set(b)));
		};
	
		var map = new _WeakMap();
	
		// protected property helper
		var internal = function internal(object) {
		  if (!map.has(object)) {
		    map.set(object, {});
		  }
		  return map.get(object);
		};
	
		// debug utility
		var removeNull = function removeNull(obj) {
		  if (!isPlainObject$1(obj)) return obj;
		  var object = _Object$assign({}, obj);
		  // eslint-disable-next-line no-restricted-syntax
		  for (var prop in object) {
		    if (object.hasOwnProperty(prop)) {
		      var value = object[prop];
		      if (value === null) {
		        delete object[prop];
		      } else {
		        object[prop] = removeNull(value);
		      }
		    }
		  }
		  return object;
		};
		var trim = function trim(message) {
		  return removeNull(JSON.parse(_JSON$stringify(message)));
		};
	
		var index$2 = createCommonjsModule(function (module) {
		'use strict';
	
		var has = Object.prototype.hasOwnProperty;
	
		//
		// We store our EE objects in a plain object whose properties are event names.
		// If `Object.create(null)` is not supported we prefix the event names with a
		// `~` to make sure that the built-in object properties are not overridden or
		// used as an attack vector.
		// We also assume that `Object.create(null)` is available when the event name
		// is an ES6 Symbol.
		//
		var prefix = typeof Object.create !== 'function' ? '~' : false;
	
		/**
		 * Representation of a single EventEmitter function.
		 *
		 * @param {Function} fn Event handler to be called.
		 * @param {Mixed} context Context for function execution.
		 * @param {Boolean} [once=false] Only emit once
		 * @api private
		 */
		function EE(fn, context, once) {
		  this.fn = fn;
		  this.context = context;
		  this.once = once || false;
		}
	
		/**
		 * Minimal EventEmitter interface that is molded against the Node.js
		 * EventEmitter interface.
		 *
		 * @constructor
		 * @api public
		 */
		function EventEmitter() { /* Nothing to set */ }
	
		/**
		 * Hold the assigned EventEmitters by name.
		 *
		 * @type {Object}
		 * @private
		 */
		EventEmitter.prototype._events = undefined;
	
		/**
		 * Return an array listing the events for which the emitter has registered
		 * listeners.
		 *
		 * @returns {Array}
		 * @api public
		 */
		EventEmitter.prototype.eventNames = function eventNames() {
		  var events = this._events
		    , names = []
		    , name;
	
		  if (!events) return names;
	
		  for (name in events) {
		    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
		  }
	
		  if (Object.getOwnPropertySymbols) {
		    return names.concat(Object.getOwnPropertySymbols(events));
		  }
	
		  return names;
		};
	
		/**
		 * Return a list of assigned event listeners.
		 *
		 * @param {String} event The events that should be listed.
		 * @param {Boolean} exists We only need to know if there are listeners.
		 * @returns {Array|Boolean}
		 * @api public
		 */
		EventEmitter.prototype.listeners = function listeners(event, exists) {
		  var evt = prefix ? prefix + event : event
		    , available = this._events && this._events[evt];
	
		  if (exists) return !!available;
		  if (!available) return [];
		  if (available.fn) return [available.fn];
	
		  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
		    ee[i] = available[i].fn;
		  }
	
		  return ee;
		};
	
		/**
		 * Emit an event to all registered event listeners.
		 *
		 * @param {String} event The name of the event.
		 * @returns {Boolean} Indication if we've emitted an event.
		 * @api public
		 */
		EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
		  var evt = prefix ? prefix + event : event;
	
		  if (!this._events || !this._events[evt]) return false;
	
		  var listeners = this._events[evt]
		    , len = arguments.length
		    , args
		    , i;
	
		  if ('function' === typeof listeners.fn) {
		    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
		    switch (len) {
		      case 1: return listeners.fn.call(listeners.context), true;
		      case 2: return listeners.fn.call(listeners.context, a1), true;
		      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
		      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
		      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
		      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
		    }
	
		    for (i = 1, args = new Array(len -1); i < len; i++) {
		      args[i - 1] = arguments[i];
		    }
	
		    listeners.fn.apply(listeners.context, args);
		  } else {
		    var length = listeners.length
		      , j;
	
		    for (i = 0; i < length; i++) {
		      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
		      switch (len) {
		        case 1: listeners[i].fn.call(listeners[i].context); break;
		        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
		        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
		        default:
		          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
		            args[j - 1] = arguments[j];
		          }
	
		          listeners[i].fn.apply(listeners[i].context, args);
		      }
		    }
		  }
	
		  return true;
		};
	
		/**
		 * Register a new EventListener for the given event.
		 *
		 * @param {String} event Name of the event.
		 * @param {Function} fn Callback function.
		 * @param {Mixed} [context=this] The context of the function.
		 * @api public
		 */
		EventEmitter.prototype.on = function on(event, fn, context) {
		  var listener = new EE(fn, context || this)
		    , evt = prefix ? prefix + event : event;
	
		  if (!this._events) this._events = prefix ? {} : Object.create(null);
		  if (!this._events[evt]) this._events[evt] = listener;
		  else {
		    if (!this._events[evt].fn) this._events[evt].push(listener);
		    else this._events[evt] = [
		      this._events[evt], listener
		    ];
		  }
	
		  return this;
		};
	
		/**
		 * Add an EventListener that's only called once.
		 *
		 * @param {String} event Name of the event.
		 * @param {Function} fn Callback function.
		 * @param {Mixed} [context=this] The context of the function.
		 * @api public
		 */
		EventEmitter.prototype.once = function once(event, fn, context) {
		  var listener = new EE(fn, context || this, true)
		    , evt = prefix ? prefix + event : event;
	
		  if (!this._events) this._events = prefix ? {} : Object.create(null);
		  if (!this._events[evt]) this._events[evt] = listener;
		  else {
		    if (!this._events[evt].fn) this._events[evt].push(listener);
		    else this._events[evt] = [
		      this._events[evt], listener
		    ];
		  }
	
		  return this;
		};
	
		/**
		 * Remove event listeners.
		 *
		 * @param {String} event The event we want to remove.
		 * @param {Function} fn The listener that we need to find.
		 * @param {Mixed} context Only remove listeners matching this context.
		 * @param {Boolean} once Only remove once listeners.
		 * @api public
		 */
		EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
		  var evt = prefix ? prefix + event : event;
	
		  if (!this._events || !this._events[evt]) return this;
	
		  var listeners = this._events[evt]
		    , events = [];
	
		  if (fn) {
		    if (listeners.fn) {
		      if (
		           listeners.fn !== fn
		        || (once && !listeners.once)
		        || (context && listeners.context !== context)
		      ) {
		        events.push(listeners);
		      }
		    } else {
		      for (var i = 0, length = listeners.length; i < length; i++) {
		        if (
		             listeners[i].fn !== fn
		          || (once && !listeners[i].once)
		          || (context && listeners[i].context !== context)
		        ) {
		          events.push(listeners[i]);
		        }
		      }
		    }
		  }
	
		  //
		  // Reset the array, or remove it completely if we have no more listeners.
		  //
		  if (events.length) {
		    this._events[evt] = events.length === 1 ? events[0] : events;
		  } else {
		    delete this._events[evt];
		  }
	
		  return this;
		};
	
		/**
		 * Remove all listeners or only the listeners for the specified event.
		 *
		 * @param {String} event The event want to remove all listeners for.
		 * @api public
		 */
		EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
		  if (!this._events) return this;
	
		  if (event) delete this._events[prefix ? prefix + event : event];
		  else this._events = prefix ? {} : Object.create(null);
	
		  return this;
		};
	
		//
		// Alias methods names because people roll like that.
		//
		EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
		EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
		//
		// This function doesn't apply anymore.
		//
		EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
		  return this;
		};
	
		//
		// Expose the prefix.
		//
		EventEmitter.prefixed = prefix;
	
		//
		// Expose the module.
		//
		if ('undefined' !== typeof module) {
		  module.exports = EventEmitter;
		}
		});
	
		var EventEmitter = (index$2 && typeof index$2 === 'object' && 'default' in index$2 ? index$2['default'] : index$2);
	
		var stateMachine = createCommonjsModule(function (module, exports) {
		/*
	
		  Javascript State Machine Library - https://github.com/jakesgordon/javascript-state-machine
	
		  Copyright (c) 2012, 2013, 2014, 2015, Jake Gordon and contributors
		  Released under the MIT license - https://github.com/jakesgordon/javascript-state-machine/blob/master/LICENSE
	
		*/
	
		(function () {
	
		  var StateMachine = {
	
		    //---------------------------------------------------------------------------
	
		    VERSION: "2.3.5",
	
		    //---------------------------------------------------------------------------
	
		    Result: {
		      SUCCEEDED:    1, // the event transitioned successfully from one state to another
		      NOTRANSITION: 2, // the event was successfull but no state transition was necessary
		      CANCELLED:    3, // the event was cancelled by the caller in a beforeEvent callback
		      PENDING:      4  // the event is asynchronous and the caller is in control of when the transition occurs
		    },
	
		    Error: {
		      INVALID_TRANSITION: 100, // caller tried to fire an event that was innapropriate in the current state
		      PENDING_TRANSITION: 200, // caller tried to fire an event while an async transition was still pending
		      INVALID_CALLBACK:   300 // caller provided callback function threw an exception
		    },
	
		    WILDCARD: '*',
		    ASYNC: 'async',
	
		    //---------------------------------------------------------------------------
	
		    create: function(cfg, target) {
	
		      var initial      = (typeof cfg.initial == 'string') ? { state: cfg.initial } : cfg.initial; // allow for a simple string, or an object with { state: 'foo', event: 'setup', defer: true|false }
		      var terminal     = cfg.terminal || cfg['final'];
		      var fsm          = target || cfg.target  || {};
		      var events       = cfg.events || [];
		      var callbacks    = cfg.callbacks || {};
		      var map          = {}; // track state transitions allowed for an event { event: { from: [ to ] } }
		      var transitions  = {}; // track events allowed from a state            { state: [ event ] }
	
		      var add = function(e) {
		        var from = (e.from instanceof Array) ? e.from : (e.from ? [e.from] : [StateMachine.WILDCARD]); // allow 'wildcard' transition if 'from' is not specified
		        map[e.name] = map[e.name] || {};
		        for (var n = 0 ; n < from.length ; n++) {
		          transitions[from[n]] = transitions[from[n]] || [];
		          transitions[from[n]].push(e.name);
	
		          map[e.name][from[n]] = e.to || from[n]; // allow no-op transition if 'to' is not specified
		        }
		      };
	
		      if (initial) {
		        initial.event = initial.event || 'startup';
		        add({ name: initial.event, from: 'none', to: initial.state });
		      }
	
		      for(var n = 0 ; n < events.length ; n++)
		        add(events[n]);
	
		      for(var name in map) {
		        if (map.hasOwnProperty(name))
		          fsm[name] = StateMachine.buildEvent(name, map[name]);
		      }
	
		      for(var name in callbacks) {
		        if (callbacks.hasOwnProperty(name))
		          fsm[name] = callbacks[name]
		      }
	
		      fsm.current     = 'none';
		      fsm.is          = function(state) { return (state instanceof Array) ? (state.indexOf(this.current) >= 0) : (this.current === state); };
		      fsm.can         = function(event) { return !this.transition && (map[event].hasOwnProperty(this.current) || map[event].hasOwnProperty(StateMachine.WILDCARD)); }
		      fsm.cannot      = function(event) { return !this.can(event); };
		      fsm.transitions = function()      { return transitions[this.current]; };
		      fsm.isFinished  = function()      { return this.is(terminal); };
		      fsm.error       = cfg.error || function(name, from, to, args, error, msg, e) { throw e || msg; }; // default behavior when something unexpected happens is to throw an exception, but caller can override this behavior if desired (see github issue #3 and #17)
	
		      if (initial && !initial.defer)
		        fsm[initial.event]();
	
		      return fsm;
	
		    },
	
		    //===========================================================================
	
		    doCallback: function(fsm, func, name, from, to, args) {
		      if (func) {
		        try {
		          return func.apply(fsm, [name, from, to].concat(args));
		        }
		        catch(e) {
		          return fsm.error(name, from, to, args, StateMachine.Error.INVALID_CALLBACK, "an exception occurred in a caller-provided callback function", e);
		        }
		      }
		    },
	
		    beforeAnyEvent:  function(fsm, name, from, to, args) { return StateMachine.doCallback(fsm, fsm['onbeforeevent'],                       name, from, to, args); },
		    afterAnyEvent:   function(fsm, name, from, to, args) { return StateMachine.doCallback(fsm, fsm['onafterevent'] || fsm['onevent'],      name, from, to, args); },
		    leaveAnyState:   function(fsm, name, from, to, args) { return StateMachine.doCallback(fsm, fsm['onleavestate'],                        name, from, to, args); },
		    enterAnyState:   function(fsm, name, from, to, args) { return StateMachine.doCallback(fsm, fsm['onenterstate'] || fsm['onstate'],      name, from, to, args); },
		    changeState:     function(fsm, name, from, to, args) { return StateMachine.doCallback(fsm, fsm['onchangestate'],                       name, from, to, args); },
	
		    beforeThisEvent: function(fsm, name, from, to, args) { return StateMachine.doCallback(fsm, fsm['onbefore' + name],                     name, from, to, args); },
		    afterThisEvent:  function(fsm, name, from, to, args) { return StateMachine.doCallback(fsm, fsm['onafter'  + name] || fsm['on' + name], name, from, to, args); },
		    leaveThisState:  function(fsm, name, from, to, args) { return StateMachine.doCallback(fsm, fsm['onleave'  + from],                     name, from, to, args); },
		    enterThisState:  function(fsm, name, from, to, args) { return StateMachine.doCallback(fsm, fsm['onenter'  + to]   || fsm['on' + to],   name, from, to, args); },
	
		    beforeEvent: function(fsm, name, from, to, args) {
		      if ((false === StateMachine.beforeThisEvent(fsm, name, from, to, args)) ||
		          (false === StateMachine.beforeAnyEvent( fsm, name, from, to, args)))
		        return false;
		    },
	
		    afterEvent: function(fsm, name, from, to, args) {
		      StateMachine.afterThisEvent(fsm, name, from, to, args);
		      StateMachine.afterAnyEvent( fsm, name, from, to, args);
		    },
	
		    leaveState: function(fsm, name, from, to, args) {
		      var specific = StateMachine.leaveThisState(fsm, name, from, to, args),
		          general  = StateMachine.leaveAnyState( fsm, name, from, to, args);
		      if ((false === specific) || (false === general))
		        return false;
		      else if ((StateMachine.ASYNC === specific) || (StateMachine.ASYNC === general))
		        return StateMachine.ASYNC;
		    },
	
		    enterState: function(fsm, name, from, to, args) {
		      StateMachine.enterThisState(fsm, name, from, to, args);
		      StateMachine.enterAnyState( fsm, name, from, to, args);
		    },
	
		    //===========================================================================
	
		    buildEvent: function(name, map) {
		      return function() {
	
		        var from  = this.current;
		        var to    = map[from] || map[StateMachine.WILDCARD] || from;
		        var args  = Array.prototype.slice.call(arguments); // turn arguments into pure array
	
		        if (this.transition)
		          return this.error(name, from, to, args, StateMachine.Error.PENDING_TRANSITION, "event " + name + " inappropriate because previous transition did not complete");
	
		        if (this.cannot(name))
		          return this.error(name, from, to, args, StateMachine.Error.INVALID_TRANSITION, "event " + name + " inappropriate in current state " + this.current);
	
		        if (false === StateMachine.beforeEvent(this, name, from, to, args))
		          return StateMachine.Result.CANCELLED;
	
		        if (from === to) {
		          StateMachine.afterEvent(this, name, from, to, args);
		          return StateMachine.Result.NOTRANSITION;
		        }
	
		        // prepare a transition method for use EITHER lower down, or by caller if they want an async transition (indicated by an ASYNC return value from leaveState)
		        var fsm = this;
		        this.transition = function() {
		          fsm.transition = null; // this method should only ever be called once
		          fsm.current = to;
		          StateMachine.enterState( fsm, name, from, to, args);
		          StateMachine.changeState(fsm, name, from, to, args);
		          StateMachine.afterEvent( fsm, name, from, to, args);
		          return StateMachine.Result.SUCCEEDED;
		        };
		        this.transition.cancel = function() { // provide a way for caller to cancel async transition if desired (issue #22)
		          fsm.transition = null;
		          StateMachine.afterEvent(fsm, name, from, to, args);
		        }
	
		        var leave = StateMachine.leaveState(this, name, from, to, args);
		        if (false === leave) {
		          this.transition = null;
		          return StateMachine.Result.CANCELLED;
		        }
		        else if (StateMachine.ASYNC === leave) {
		          return StateMachine.Result.PENDING;
		        }
		        else {
		          if (this.transition) // need to check in case user manually called transition() but forgot to return StateMachine.ASYNC
		            return this.transition();
		        }
	
		      };
		    }
	
		  }; // StateMachine
	
		  //===========================================================================
	
		  //======
		  // NODE
		  //======
		  if (typeof exports !== 'undefined') {
		    if (typeof module !== 'undefined' && module.exports) {
		      exports = module.exports = StateMachine;
		    }
		    exports.StateMachine = StateMachine;
		  }
		  //============
		  // AMD/REQUIRE
		  //============
		  else if (typeof define === 'function' && define.amd) {
		    define(function(require) { return StateMachine; });
		  }
		  //========
		  // BROWSER
		  //========
		  else if (typeof window !== 'undefined') {
		    window.StateMachine = StateMachine;
		  }
		  //===========
		  // WEB WORKER
		  //===========
		  else if (typeof self !== 'undefined') {
		    self.StateMachine = StateMachine;
		  }
	
		}());
		});
	
		var StateMachine = (stateMachine && typeof stateMachine === 'object' && 'default' in stateMachine ? stateMachine['default'] : stateMachine);
	
		var WebSocket = global.WebSocket || global.MozWebSocket;
	
		var _class;
		function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
		  var desc = {};
		  Object['ke' + 'ys'](descriptor).forEach(function (key) {
		    desc[key] = descriptor[key];
		  });
		  desc.enumerable = !!desc.enumerable;
		  desc.configurable = !!desc.configurable;
	
		  if ('value' in desc || desc.initializer) {
		    desc.writable = true;
		  }
	
		  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
		    return decorator(target, property, desc) || desc;
		  }, desc);
	
		  if (context && desc.initializer !== void 0) {
		    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
		    desc.initializer = undefined;
		  }
	
		  if (desc.initializer === void 0) {
		    Object['define' + 'Property'](target, property, desc);
		    desc = null;
		  }
	
		  return desc;
		}
	
		var debug$2 = d('LC:WebSocketPlus');
	
		var HEARTBEAT_TIME = 60000;
		var TIMEOUT_TIME = 180000;
	
		var DEFAULT_RETRY_STRATEGY = function DEFAULT_RETRY_STRATEGY(attempt) {
		  return Math.min(1000 << attempt, 300000);
		};
	
		var requireConnected = function requireConnected(target, name, descriptor) {
		  return _Object$assign({}, descriptor, {
		    value: function requireConnectedWrapper() {
		      var _descriptor$value;
	
		      if (!this.is('connected')) {
		        var currentState = this.current;
		        console.warn(name + ' should not be called when the connection is ' + currentState);
		        if (this.is('offline') || this.is('reconnecting')) {
		          console.warn('disconnect and reconnect event should be handled to avoid such calls.');
		        }
		        throw new Error('Connection unavailable');
		      }
	
		      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		        args[_key] = arguments[_key];
		      }
	
		      return (_descriptor$value = descriptor.value).call.apply(_descriptor$value, [this].concat(args));
		    }
		  });
		};
	
		var WebSocketPlus = (_class = function (_EventEmitter) {
		  _inherits(WebSocketPlus, _EventEmitter);
	
		  function WebSocketPlus(getUrls, protocol) {
		    _classCallCheck(this, WebSocketPlus);
	
		    debug$2('initializing WebSocketPlus');
		    if (typeof WebSocket === 'undefined') {
		      throw new Error('WebSocket is undefined. Polyfill is required in this runtime.');
		    }
	
		    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
		    if (typeof getUrls !== 'function') {
		      _this._getUrls = function () {
		        return _Promise.resolve(getUrls);
		      };
		    } else {
		      _this._getUrls = getUrls;
		    }
		    _this._protocol = protocol;
		    _this.init();
		    _this._createWs(_this._getUrls, _this._protocol).then(function () {
		      return _this.open();
		    }, function (error) {
		      return _this.throw(error);
		    }).catch(_this.throw.bind(_this));
		    _this.__postponeTimers = _this._postponeTimers.bind(_this);
		    return _this;
		  }
	
		  WebSocketPlus.prototype._createWs = function _createWs(getUrls, protocol) {
		    var _this2 = this;
	
		    return getUrls().then(function (wsUrls) {
		      var urls = wsUrls;
		      if (!(urls instanceof Array)) {
		        urls = [urls];
		      }
		      return tryAll(urls.map(function (url) {
		        return function (resolve, reject) {
		          debug$2('connect [' + url + '] ' + protocol);
		          var ws = protocol ? new WebSocket(url, protocol) : new WebSocket(url);
		          ws.binaryType = _this2.binaryType || 'arraybuffer';
		          ws.onopen = function () {
		            return resolve(ws);
		          };
		          ws.onerror = function (error) {
		            if (error instanceof Error) {
		              return reject(error);
		            }
		            // in browser, error event is useless
		            return reject(new Error('Failed to connect [' + url + ']'));
		          };
		        };
		      })).then(function (ws) {
		        _this2._ws = ws;
		        _this2._ws.onclose = _this2._handleClose.bind(_this2);
		        _this2._ws.onmessage = _this2._handleMessage.bind(_this2);
		        return ws;
		      });
		    });
		  };
	
		  WebSocketPlus.prototype._destroyWs = function _destroyWs() {
		    var ws = this._ws;
		    if (!ws) return;
		    ws.onopen = ws.onclose = ws.onerror = ws.onmessage = null;
		    this._ws = null;
		    ws.close();
		  };
	
		  WebSocketPlus.prototype.onopen = function onopen() {
		    debug$2('open');
		    this.emit('open');
		  };
	
		  WebSocketPlus.prototype.onconnected = function onconnected() {
		    this._startConnectionKeeper();
		  };
	
		  WebSocketPlus.prototype.onleaveconnected = function onleaveconnected() {
		    this._stopConnectionKeeper();
		  };
	
		  WebSocketPlus.prototype.onbeforedisconnect = function onbeforedisconnect() {
		    debug$2('disconnect');
		    this.emit('disconnect');
		  };
	
		  WebSocketPlus.prototype.ondisconnect = function ondisconnect() {
		    this._destroyWs();
		  };
	
		  WebSocketPlus.prototype.onreconnect = function onreconnect() {
		    debug$2('reconnect');
		    this.emit('reconnect');
		  };
	
		  WebSocketPlus.prototype.onoffline = function onoffline(event, from, to) {
		    var _this3 = this;
	
		    var attempt = arguments.length <= 3 || arguments[3] === undefined ? 0 : arguments[3];
	
		    var delay = DEFAULT_RETRY_STRATEGY.call(null, attempt);
		    debug$2('schedule attempt=' + attempt + ' delay=' + delay);
		    this.emit('schedule', attempt, delay);
		    if (this.__scheduledRetry) {
		      clearTimeout(this.__scheduledRetry);
		    }
		    this.__scheduledRetry = setTimeout(function () {
		      if (_this3.is('offline')) {
		        _this3.retry(attempt);
		      }
		    }, delay);
		  };
	
		  WebSocketPlus.prototype.onretry = function onretry(event, from, to) {
		    var _this4 = this;
	
		    var attempt = arguments.length <= 3 || arguments[3] === undefined ? 0 : arguments[3];
	
		    debug$2('retry attempt=' + attempt);
		    this.emit('retry', attempt);
		    this._createWs(this._getUrls, this._protocol).then(function () {
		      return _this4.reconnect();
		    }, function () {
		      return _this4.fail(attempt + 1);
		    });
		  };
	
		  WebSocketPlus.prototype.onclose = function onclose() {
		    debug$2('close');
		    if (this._ws) {
		      this._ws.close();
		    }
		  };
	
		  WebSocketPlus.prototype.onerror = function onerror(event, from, to, error) {
		    debug$2('error', error);
		    this.emit('error', error);
		  };
	
		  // jsdoc-ignore-start
	
	
		  // jsdoc-ignore-end
	
		  WebSocketPlus.prototype._ping = function _ping() {
		    debug$2('ping');
		    try {
		      this.ping();
		    } catch (error) {
		      console.warn('websocket ping error: ' + error.message);
		    }
		  };
	
		  WebSocketPlus.prototype.ping = function ping() {
		    if (this._ws.ping) {
		      this._ws.ping();
		    } else {
		      console.warn('The WebSocket implement does not support sending ping frame.\n        Override ping method to use application defined ping/pong mechanism.');
		    }
		  };
	
		  WebSocketPlus.prototype._postponeTimers = function _postponeTimers() {
		    var _this5 = this;
	
		    debug$2('_postponeTimers');
		    this._clearTimers();
		    this._heartbeatTimer = setInterval(this._ping.bind(this), HEARTBEAT_TIME);
		    this._timeoutTimer = setTimeout(function () {
		      debug$2('timeout');
		      _this5.disconnect();
		    }, TIMEOUT_TIME);
		  };
	
		  WebSocketPlus.prototype._clearTimers = function _clearTimers() {
		    if (this._heartbeatTimer) {
		      clearInterval(this._heartbeatTimer);
		    }
		    if (this._timeoutTimer) {
		      clearTimeout(this._timeoutTimer);
		    }
		  };
	
		  WebSocketPlus.prototype._startConnectionKeeper = function _startConnectionKeeper() {
		    debug$2('start connection keeper');
		    var addListener = this._ws.addListener || this._ws.addEventListener;
		    addListener.call(this._ws, 'message', this.__postponeTimers);
		    this._postponeTimers();
		  };
	
		  WebSocketPlus.prototype._stopConnectionKeeper = function _stopConnectionKeeper() {
		    debug$2('stop connection keeper');
		    // websockets/ws#489
		    var removeListener = this._ws.removeListener || this._ws.removeEventListener;
		    removeListener.call(this._ws, 'message', this.__postponeTimers);
		    this._clearTimers();
		  };
	
		  WebSocketPlus.prototype._handleClose = function _handleClose(event) {
		    debug$2('ws closed [' + event.code + '] ' + event.reason);
		    // socket closed manually, ignore close event.
		    if (this.isFinished()) return;
		    this.handleClose(event);
		  };
	
		  WebSocketPlus.prototype.handleClose = function handleClose() {
		    // reconnect
		    this.disconnect();
		  };
	
		  // jsdoc-ignore-start
	
	
		  // jsdoc-ignore-end
	
		  WebSocketPlus.prototype.send = function send(data) {
		    debug$2('send', data);
		    this._ws.send(data);
		  };
	
		  WebSocketPlus.prototype._handleMessage = function _handleMessage(event) {
		    debug$2('message', event.data);
		    this.handleMessage(event.data);
		  };
	
		  WebSocketPlus.prototype.handleMessage = function handleMessage(message) {
		    this.emit('message', message);
		  };
	
		  return WebSocketPlus;
		}(EventEmitter), (_applyDecoratedDescriptor(_class.prototype, '_ping', [requireConnected], _Object$getOwnPropertyDescriptor(_class.prototype, '_ping'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'send', [requireConnected], _Object$getOwnPropertyDescriptor(_class.prototype, 'send'), _class.prototype)), _class);
	
	
		StateMachine.create({
		  target: WebSocketPlus.prototype,
		  initial: {
		    state: 'initialized',
		    event: 'init',
		    defer: true
		  },
		  terminal: 'closed',
		  events: [{
		    name: 'open',
		    from: 'initialized',
		    to: 'connected'
		  }, {
		    name: 'disconnect',
		    from: 'connected',
		    to: 'offline'
		  }, {
		    name: 'retry',
		    from: 'offline',
		    to: 'reconnecting'
		  }, {
		    name: 'fail',
		    from: 'reconnecting',
		    to: 'offline'
		  }, {
		    name: 'reconnect',
		    from: 'reconnecting',
		    to: 'connected'
		  }, {
		    name: 'close',
		    from: ['connected', 'offline', 'reconnecting'],
		    to: 'closed'
		  }, {
		    name: 'throw',
		    from: '*',
		    to: 'error'
		  }]
		});
	
		var APP_NOT_AVAILABLE = {
		  code: 4100,
		  message: 'App not exists or realtime message service is disabled.'
		};
		var INVALID_LOGIN = {
		  code: 4103,
		  message: 'Malformed clientId.'
		};
		var INVALID_ORIGIN = {
		  code: 4110,
		  message: 'Access denied by domain whitelist.'
		};
		var SESSION_CONFLICT = {
		  code: 4111
		};
		var createError = function createError(errorMessage) {
		  var code = errorMessage.code;
		  var reason = errorMessage.reason;
		  var appCode = errorMessage.appCode;
		  var detail = errorMessage.detail;
	
		  var error = new Error(reason || detail);
		  return _Object$assign(error, {
		    code: code, appCode: appCode, detail: detail
		  });
		};
	
		var require$$1$22 = {};
	
		var long = createCommonjsModule(function (module) {
		/*
		 Copyright 2013 Daniel Wirtz <dcode@dcode.io>
		 Copyright 2009 The Closure Library Authors. All Rights Reserved.
	
		 Licensed under the Apache License, Version 2.0 (the "License");
		 you may not use this file except in compliance with the License.
		 You may obtain a copy of the License at
	
		 http://www.apache.org/licenses/LICENSE-2.0
	
		 Unless required by applicable law or agreed to in writing, software
		 distributed under the License is distributed on an "AS-IS" BASIS,
		 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
		 See the License for the specific language governing permissions and
		 limitations under the License.
		 */
	
		/**
		 * @license long.js (c) 2013 Daniel Wirtz <dcode@dcode.io>
		 * Released under the Apache License, Version 2.0
		 * see: https://github.com/dcodeIO/long.js for details
		 */
		(function(global, factory) {
	
		    /* AMD */ if (typeof define === 'function' && define["amd"])
		        define([], factory);
		    /* CommonJS */ else if ('function' === 'function' && typeof module === "object" && module && module["exports"])
		        module["exports"] = factory();
		    /* Global */ else
		        (global["dcodeIO"] = global["dcodeIO"] || {})["Long"] = factory();
	
		})(commonjsGlobal, function() {
		    "use strict";
	
		    /**
		     * Constructs a 64 bit two's-complement integer, given its low and high 32 bit values as *signed* integers.
		     *  See the from* functions below for more convenient ways of constructing Longs.
		     * @exports Long
		     * @class A Long class for representing a 64 bit two's-complement integer value.
		     * @param {number} low The low (signed) 32 bits of the long
		     * @param {number} high The high (signed) 32 bits of the long
		     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
		     * @constructor
		     */
		    function Long(low, high, unsigned) {
	
		        /**
		         * The low 32 bits as a signed value.
		         * @type {number}
		         * @expose
		         */
		        this.low = low | 0;
	
		        /**
		         * The high 32 bits as a signed value.
		         * @type {number}
		         * @expose
		         */
		        this.high = high | 0;
	
		        /**
		         * Whether unsigned or not.
		         * @type {boolean}
		         * @expose
		         */
		        this.unsigned = !!unsigned;
		    }
	
		    // The internal representation of a long is the two given signed, 32-bit values.
		    // We use 32-bit pieces because these are the size of integers on which
		    // Javascript performs bit-operations.  For operations like addition and
		    // multiplication, we split each number into 16 bit pieces, which can easily be
		    // multiplied within Javascript's floating-point representation without overflow
		    // or change in sign.
		    //
		    // In the algorithms below, we frequently reduce the negative case to the
		    // positive case by negating the input(s) and then post-processing the result.
		    // Note that we must ALWAYS check specially whether those values are MIN_VALUE
		    // (-2^63) because -MIN_VALUE == MIN_VALUE (since 2^63 cannot be represented as
		    // a positive number, it overflows back into a negative).  Not handling this
		    // case would often result in infinite recursion.
		    //
		    // Common constant values ZERO, ONE, NEG_ONE, etc. are defined below the from*
		    // methods on which they depend.
	
		    /**
		     * An indicator used to reliably determine if an object is a Long or not.
		     * @type {boolean}
		     * @const
		     * @expose
		     * @private
		     */
		    Long.__isLong__;
	
		    Object.defineProperty(Long.prototype, "__isLong__", {
		        value: true,
		        enumerable: false,
		        configurable: false
		    });
	
		    /**
		     * @function
		     * @param {*} obj Object
		     * @returns {boolean}
		     * @inner
		     */
		    function isLong(obj) {
		        return (obj && obj["__isLong__"]) === true;
		    }
	
		    /**
		     * Tests if the specified object is a Long.
		     * @function
		     * @param {*} obj Object
		     * @returns {boolean}
		     * @expose
		     */
		    Long.isLong = isLong;
	
		    /**
		     * A cache of the Long representations of small integer values.
		     * @type {!Object}
		     * @inner
		     */
		    var INT_CACHE = {};
	
		    /**
		     * A cache of the Long representations of small unsigned integer values.
		     * @type {!Object}
		     * @inner
		     */
		    var UINT_CACHE = {};
	
		    /**
		     * @param {number} value
		     * @param {boolean=} unsigned
		     * @returns {!Long}
		     * @inner
		     */
		    function fromInt(value, unsigned) {
		        var obj, cachedObj, cache;
		        if (unsigned) {
		            value >>>= 0;
		            if (cache = (0 <= value && value < 256)) {
		                cachedObj = UINT_CACHE[value];
		                if (cachedObj)
		                    return cachedObj;
		            }
		            obj = fromBits(value, (value | 0) < 0 ? -1 : 0, true);
		            if (cache)
		                UINT_CACHE[value] = obj;
		            return obj;
		        } else {
		            value |= 0;
		            if (cache = (-128 <= value && value < 128)) {
		                cachedObj = INT_CACHE[value];
		                if (cachedObj)
		                    return cachedObj;
		            }
		            obj = fromBits(value, value < 0 ? -1 : 0, false);
		            if (cache)
		                INT_CACHE[value] = obj;
		            return obj;
		        }
		    }
	
		    /**
		     * Returns a Long representing the given 32 bit integer value.
		     * @function
		     * @param {number} value The 32 bit integer in question
		     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
		     * @returns {!Long} The corresponding Long value
		     * @expose
		     */
		    Long.fromInt = fromInt;
	
		    /**
		     * @param {number} value
		     * @param {boolean=} unsigned
		     * @returns {!Long}
		     * @inner
		     */
		    function fromNumber(value, unsigned) {
		        if (isNaN(value) || !isFinite(value))
		            return unsigned ? UZERO : ZERO;
		        if (unsigned) {
		            if (value < 0)
		                return UZERO;
		            if (value >= TWO_PWR_64_DBL)
		                return MAX_UNSIGNED_VALUE;
		        } else {
		            if (value <= -TWO_PWR_63_DBL)
		                return MIN_VALUE;
		            if (value + 1 >= TWO_PWR_63_DBL)
		                return MAX_VALUE;
		        }
		        if (value < 0)
		            return fromNumber(-value, unsigned).neg();
		        return fromBits((value % TWO_PWR_32_DBL) | 0, (value / TWO_PWR_32_DBL) | 0, unsigned);
		    }
	
		    /**
		     * Returns a Long representing the given value, provided that it is a finite number. Otherwise, zero is returned.
		     * @function
		     * @param {number} value The number in question
		     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
		     * @returns {!Long} The corresponding Long value
		     * @expose
		     */
		    Long.fromNumber = fromNumber;
	
		    /**
		     * @param {number} lowBits
		     * @param {number} highBits
		     * @param {boolean=} unsigned
		     * @returns {!Long}
		     * @inner
		     */
		    function fromBits(lowBits, highBits, unsigned) {
		        return new Long(lowBits, highBits, unsigned);
		    }
	
		    /**
		     * Returns a Long representing the 64 bit integer that comes by concatenating the given low and high bits. Each is
		     *  assumed to use 32 bits.
		     * @function
		     * @param {number} lowBits The low 32 bits
		     * @param {number} highBits The high 32 bits
		     * @param {boolean=} unsigned Whether unsigned or not, defaults to `false` for signed
		     * @returns {!Long} The corresponding Long value
		     * @expose
		     */
		    Long.fromBits = fromBits;
	
		    /**
		     * @function
		     * @param {number} base
		     * @param {number} exponent
		     * @returns {number}
		     * @inner
		     */
		    var pow_dbl = Math.pow; // Used 4 times (4*8 to 15+4)
	
		    /**
		     * @param {string} str
		     * @param {(boolean|number)=} unsigned
		     * @param {number=} radix
		     * @returns {!Long}
		     * @inner
		     */
		    function fromString(str, unsigned, radix) {
		        if (str.length === 0)
		            throw Error('empty string');
		        if (str === "NaN" || str === "Infinity" || str === "+Infinity" || str === "-Infinity")
		            return ZERO;
		        if (typeof unsigned === 'number') {
		            // For goog.math.long compatibility
		            radix = unsigned,
		            unsigned = false;
		        } else {
		            unsigned = !! unsigned;
		        }
		        radix = radix || 10;
		        if (radix < 2 || 36 < radix)
		            throw RangeError('radix');
	
		        var p;
		        if ((p = str.indexOf('-')) > 0)
		            throw Error('interior hyphen');
		        else if (p === 0) {
		            return fromString(str.substring(1), unsigned, radix).neg();
		        }
	
		        // Do several (8) digits each time through the loop, so as to
		        // minimize the calls to the very expensive emulated div.
		        var radixToPower = fromNumber(pow_dbl(radix, 8));
	
		        var result = ZERO;
		        for (var i = 0; i < str.length; i += 8) {
		            var size = Math.min(8, str.length - i),
		                value = parseInt(str.substring(i, i + size), radix);
		            if (size < 8) {
		                var power = fromNumber(pow_dbl(radix, size));
		                result = result.mul(power).add(fromNumber(value));
		            } else {
		                result = result.mul(radixToPower);
		                result = result.add(fromNumber(value));
		            }
		        }
		        result.unsigned = unsigned;
		        return result;
		    }
	
		    /**
		     * Returns a Long representation of the given string, written using the specified radix.
		     * @function
		     * @param {string} str The textual representation of the Long
		     * @param {(boolean|number)=} unsigned Whether unsigned or not, defaults to `false` for signed
		     * @param {number=} radix The radix in which the text is written (2-36), defaults to 10
		     * @returns {!Long} The corresponding Long value
		     * @expose
		     */
		    Long.fromString = fromString;
	
		    /**
		     * @function
		     * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val
		     * @returns {!Long}
		     * @inner
		     */
		    function fromValue(val) {
		        if (val /* is compatible */ instanceof Long)
		            return val;
		        if (typeof val === 'number')
		            return fromNumber(val);
		        if (typeof val === 'string')
		            return fromString(val);
		        // Throws for non-objects, converts non-instanceof Long:
		        return fromBits(val.low, val.high, val.unsigned);
		    }
	
		    /**
		     * Converts the specified value to a Long.
		     * @function
		     * @param {!Long|number|string|!{low: number, high: number, unsigned: boolean}} val Value
		     * @returns {!Long}
		     * @expose
		     */
		    Long.fromValue = fromValue;
	
		    // NOTE: the compiler should inline these constant values below and then remove these variables, so there should be
		    // no runtime penalty for these.
	
		    /**
		     * @type {number}
		     * @const
		     * @inner
		     */
		    var TWO_PWR_16_DBL = 1 << 16;
	
		    /**
		     * @type {number}
		     * @const
		     * @inner
		     */
		    var TWO_PWR_24_DBL = 1 << 24;
	
		    /**
		     * @type {number}
		     * @const
		     * @inner
		     */
		    var TWO_PWR_32_DBL = TWO_PWR_16_DBL * TWO_PWR_16_DBL;
	
		    /**
		     * @type {number}
		     * @const
		     * @inner
		     */
		    var TWO_PWR_64_DBL = TWO_PWR_32_DBL * TWO_PWR_32_DBL;
	
		    /**
		     * @type {number}
		     * @const
		     * @inner
		     */
		    var TWO_PWR_63_DBL = TWO_PWR_64_DBL / 2;
	
		    /**
		     * @type {!Long}
		     * @const
		     * @inner
		     */
		    var TWO_PWR_24 = fromInt(TWO_PWR_24_DBL);
	
		    /**
		     * @type {!Long}
		     * @inner
		     */
		    var ZERO = fromInt(0);
	
		    /**
		     * Signed zero.
		     * @type {!Long}
		     * @expose
		     */
		    Long.ZERO = ZERO;
	
		    /**
		     * @type {!Long}
		     * @inner
		     */
		    var UZERO = fromInt(0, true);
	
		    /**
		     * Unsigned zero.
		     * @type {!Long}
		     * @expose
		     */
		    Long.UZERO = UZERO;
	
		    /**
		     * @type {!Long}
		     * @inner
		     */
		    var ONE = fromInt(1);
	
		    /**
		     * Signed one.
		     * @type {!Long}
		     * @expose
		     */
		    Long.ONE = ONE;
	
		    /**
		     * @type {!Long}
		     * @inner
		     */
		    var UONE = fromInt(1, true);
	
		    /**
		     * Unsigned one.
		     * @type {!Long}
		     * @expose
		     */
		    Long.UONE = UONE;
	
		    /**
		     * @type {!Long}
		     * @inner
		     */
		    var NEG_ONE = fromInt(-1);
	
		    /**
		     * Signed negative one.
		     * @type {!Long}
		     * @expose
		     */
		    Long.NEG_ONE = NEG_ONE;
	
		    /**
		     * @type {!Long}
		     * @inner
		     */
		    var MAX_VALUE = fromBits(0xFFFFFFFF|0, 0x7FFFFFFF|0, false);
	
		    /**
		     * Maximum signed value.
		     * @type {!Long}
		     * @expose
		     */
		    Long.MAX_VALUE = MAX_VALUE;
	
		    /**
		     * @type {!Long}
		     * @inner
		     */
		    var MAX_UNSIGNED_VALUE = fromBits(0xFFFFFFFF|0, 0xFFFFFFFF|0, true);
	
		    /**
		     * Maximum unsigned value.
		     * @type {!Long}
		     * @expose
		     */
		    Long.MAX_UNSIGNED_VALUE = MAX_UNSIGNED_VALUE;
	
		    /**
		     * @type {!Long}
		     * @inner
		     */
		    var MIN_VALUE = fromBits(0, 0x80000000|0, false);
	
		    /**
		     * Minimum signed value.
		     * @type {!Long}
		     * @expose
		     */
		    Long.MIN_VALUE = MIN_VALUE;
	
		    /**
		     * @alias Long.prototype
		     * @inner
		     */
		    var LongPrototype = Long.prototype;
	
		    /**
		     * Converts the Long to a 32 bit integer, assuming it is a 32 bit integer.
		     * @returns {number}
		     * @expose
		     */
		    LongPrototype.toInt = function toInt() {
		        return this.unsigned ? this.low >>> 0 : this.low;
		    };
	
		    /**
		     * Converts the Long to a the nearest floating-point representation of this value (double, 53 bit mantissa).
		     * @returns {number}
		     * @expose
		     */
		    LongPrototype.toNumber = function toNumber() {
		        if (this.unsigned)
		            return ((this.high >>> 0) * TWO_PWR_32_DBL) + (this.low >>> 0);
		        return this.high * TWO_PWR_32_DBL + (this.low >>> 0);
		    };
	
		    /**
		     * Converts the Long to a string written in the specified radix.
		     * @param {number=} radix Radix (2-36), defaults to 10
		     * @returns {string}
		     * @override
		     * @throws {RangeError} If `radix` is out of range
		     * @expose
		     */
		    LongPrototype.toString = function toString(radix) {
		        radix = radix || 10;
		        if (radix < 2 || 36 < radix)
		            throw RangeError('radix');
		        if (this.isZero())
		            return '0';
		        if (this.isNegative()) { // Unsigned Longs are never negative
		            if (this.eq(MIN_VALUE)) {
		                // We need to change the Long value before it can be negated, so we remove
		                // the bottom-most digit in this base and then recurse to do the rest.
		                var radixLong = fromNumber(radix),
		                    div = this.div(radixLong),
		                    rem1 = div.mul(radixLong).sub(this);
		                return div.toString(radix) + rem1.toInt().toString(radix);
		            } else
		                return '-' + this.neg().toString(radix);
		        }
	
		        // Do several (6) digits each time through the loop, so as to
		        // minimize the calls to the very expensive emulated div.
		        var radixToPower = fromNumber(pow_dbl(radix, 6), this.unsigned),
		            rem = this;
		        var result = '';
		        while (true) {
		            var remDiv = rem.div(radixToPower),
		                intval = rem.sub(remDiv.mul(radixToPower)).toInt() >>> 0,
		                digits = intval.toString(radix);
		            rem = remDiv;
		            if (rem.isZero())
		                return digits + result;
		            else {
		                while (digits.length < 6)
		                    digits = '0' + digits;
		                result = '' + digits + result;
		            }
		        }
		    };
	
		    /**
		     * Gets the high 32 bits as a signed integer.
		     * @returns {number} Signed high bits
		     * @expose
		     */
		    LongPrototype.getHighBits = function getHighBits() {
		        return this.high;
		    };
	
		    /**
		     * Gets the high 32 bits as an unsigned integer.
		     * @returns {number} Unsigned high bits
		     * @expose
		     */
		    LongPrototype.getHighBitsUnsigned = function getHighBitsUnsigned() {
		        return this.high >>> 0;
		    };
	
		    /**
		     * Gets the low 32 bits as a signed integer.
		     * @returns {number} Signed low bits
		     * @expose
		     */
		    LongPrototype.getLowBits = function getLowBits() {
		        return this.low;
		    };
	
		    /**
		     * Gets the low 32 bits as an unsigned integer.
		     * @returns {number} Unsigned low bits
		     * @expose
		     */
		    LongPrototype.getLowBitsUnsigned = function getLowBitsUnsigned() {
		        return this.low >>> 0;
		    };
	
		    /**
		     * Gets the number of bits needed to represent the absolute value of this Long.
		     * @returns {number}
		     * @expose
		     */
		    LongPrototype.getNumBitsAbs = function getNumBitsAbs() {
		        if (this.isNegative()) // Unsigned Longs are never negative
		            return this.eq(MIN_VALUE) ? 64 : this.neg().getNumBitsAbs();
		        var val = this.high != 0 ? this.high : this.low;
		        for (var bit = 31; bit > 0; bit--)
		            if ((val & (1 << bit)) != 0)
		                break;
		        return this.high != 0 ? bit + 33 : bit + 1;
		    };
	
		    /**
		     * Tests if this Long's value equals zero.
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.isZero = function isZero() {
		        return this.high === 0 && this.low === 0;
		    };
	
		    /**
		     * Tests if this Long's value is negative.
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.isNegative = function isNegative() {
		        return !this.unsigned && this.high < 0;
		    };
	
		    /**
		     * Tests if this Long's value is positive.
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.isPositive = function isPositive() {
		        return this.unsigned || this.high >= 0;
		    };
	
		    /**
		     * Tests if this Long's value is odd.
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.isOdd = function isOdd() {
		        return (this.low & 1) === 1;
		    };
	
		    /**
		     * Tests if this Long's value is even.
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.isEven = function isEven() {
		        return (this.low & 1) === 0;
		    };
	
		    /**
		     * Tests if this Long's value equals the specified's.
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.equals = function equals(other) {
		        if (!isLong(other))
		            other = fromValue(other);
		        if (this.unsigned !== other.unsigned && (this.high >>> 31) === 1 && (other.high >>> 31) === 1)
		            return false;
		        return this.high === other.high && this.low === other.low;
		    };
	
		    /**
		     * Tests if this Long's value equals the specified's. This is an alias of {@link Long#equals}.
		     * @function
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.eq = LongPrototype.equals;
	
		    /**
		     * Tests if this Long's value differs from the specified's.
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.notEquals = function notEquals(other) {
		        return !this.eq(/* validates */ other);
		    };
	
		    /**
		     * Tests if this Long's value differs from the specified's. This is an alias of {@link Long#notEquals}.
		     * @function
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.neq = LongPrototype.notEquals;
	
		    /**
		     * Tests if this Long's value is less than the specified's.
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.lessThan = function lessThan(other) {
		        return this.comp(/* validates */ other) < 0;
		    };
	
		    /**
		     * Tests if this Long's value is less than the specified's. This is an alias of {@link Long#lessThan}.
		     * @function
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.lt = LongPrototype.lessThan;
	
		    /**
		     * Tests if this Long's value is less than or equal the specified's.
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.lessThanOrEqual = function lessThanOrEqual(other) {
		        return this.comp(/* validates */ other) <= 0;
		    };
	
		    /**
		     * Tests if this Long's value is less than or equal the specified's. This is an alias of {@link Long#lessThanOrEqual}.
		     * @function
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.lte = LongPrototype.lessThanOrEqual;
	
		    /**
		     * Tests if this Long's value is greater than the specified's.
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.greaterThan = function greaterThan(other) {
		        return this.comp(/* validates */ other) > 0;
		    };
	
		    /**
		     * Tests if this Long's value is greater than the specified's. This is an alias of {@link Long#greaterThan}.
		     * @function
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.gt = LongPrototype.greaterThan;
	
		    /**
		     * Tests if this Long's value is greater than or equal the specified's.
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.greaterThanOrEqual = function greaterThanOrEqual(other) {
		        return this.comp(/* validates */ other) >= 0;
		    };
	
		    /**
		     * Tests if this Long's value is greater than or equal the specified's. This is an alias of {@link Long#greaterThanOrEqual}.
		     * @function
		     * @param {!Long|number|string} other Other value
		     * @returns {boolean}
		     * @expose
		     */
		    LongPrototype.gte = LongPrototype.greaterThanOrEqual;
	
		    /**
		     * Compares this Long's value with the specified's.
		     * @param {!Long|number|string} other Other value
		     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
		     *  if the given one is greater
		     * @expose
		     */
		    LongPrototype.compare = function compare(other) {
		        if (!isLong(other))
		            other = fromValue(other);
		        if (this.eq(other))
		            return 0;
		        var thisNeg = this.isNegative(),
		            otherNeg = other.isNegative();
		        if (thisNeg && !otherNeg)
		            return -1;
		        if (!thisNeg && otherNeg)
		            return 1;
		        // At this point the sign bits are the same
		        if (!this.unsigned)
		            return this.sub(other).isNegative() ? -1 : 1;
		        // Both are positive if at least one is unsigned
		        return (other.high >>> 0) > (this.high >>> 0) || (other.high === this.high && (other.low >>> 0) > (this.low >>> 0)) ? -1 : 1;
		    };
	
		    /**
		     * Compares this Long's value with the specified's. This is an alias of {@link Long#compare}.
		     * @function
		     * @param {!Long|number|string} other Other value
		     * @returns {number} 0 if they are the same, 1 if the this is greater and -1
		     *  if the given one is greater
		     * @expose
		     */
		    LongPrototype.comp = LongPrototype.compare;
	
		    /**
		     * Negates this Long's value.
		     * @returns {!Long} Negated Long
		     * @expose
		     */
		    LongPrototype.negate = function negate() {
		        if (!this.unsigned && this.eq(MIN_VALUE))
		            return MIN_VALUE;
		        return this.not().add(ONE);
		    };
	
		    /**
		     * Negates this Long's value. This is an alias of {@link Long#negate}.
		     * @function
		     * @returns {!Long} Negated Long
		     * @expose
		     */
		    LongPrototype.neg = LongPrototype.negate;
	
		    /**
		     * Returns the sum of this and the specified Long.
		     * @param {!Long|number|string} addend Addend
		     * @returns {!Long} Sum
		     * @expose
		     */
		    LongPrototype.add = function add(addend) {
		        if (!isLong(addend))
		            addend = fromValue(addend);
	
		        // Divide each number into 4 chunks of 16 bits, and then sum the chunks.
	
		        var a48 = this.high >>> 16;
		        var a32 = this.high & 0xFFFF;
		        var a16 = this.low >>> 16;
		        var a00 = this.low & 0xFFFF;
	
		        var b48 = addend.high >>> 16;
		        var b32 = addend.high & 0xFFFF;
		        var b16 = addend.low >>> 16;
		        var b00 = addend.low & 0xFFFF;
	
		        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
		        c00 += a00 + b00;
		        c16 += c00 >>> 16;
		        c00 &= 0xFFFF;
		        c16 += a16 + b16;
		        c32 += c16 >>> 16;
		        c16 &= 0xFFFF;
		        c32 += a32 + b32;
		        c48 += c32 >>> 16;
		        c32 &= 0xFFFF;
		        c48 += a48 + b48;
		        c48 &= 0xFFFF;
		        return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
		    };
	
		    /**
		     * Returns the difference of this and the specified Long.
		     * @param {!Long|number|string} subtrahend Subtrahend
		     * @returns {!Long} Difference
		     * @expose
		     */
		    LongPrototype.subtract = function subtract(subtrahend) {
		        if (!isLong(subtrahend))
		            subtrahend = fromValue(subtrahend);
		        return this.add(subtrahend.neg());
		    };
	
		    /**
		     * Returns the difference of this and the specified Long. This is an alias of {@link Long#subtract}.
		     * @function
		     * @param {!Long|number|string} subtrahend Subtrahend
		     * @returns {!Long} Difference
		     * @expose
		     */
		    LongPrototype.sub = LongPrototype.subtract;
	
		    /**
		     * Returns the product of this and the specified Long.
		     * @param {!Long|number|string} multiplier Multiplier
		     * @returns {!Long} Product
		     * @expose
		     */
		    LongPrototype.multiply = function multiply(multiplier) {
		        if (this.isZero())
		            return ZERO;
		        if (!isLong(multiplier))
		            multiplier = fromValue(multiplier);
		        if (multiplier.isZero())
		            return ZERO;
		        if (this.eq(MIN_VALUE))
		            return multiplier.isOdd() ? MIN_VALUE : ZERO;
		        if (multiplier.eq(MIN_VALUE))
		            return this.isOdd() ? MIN_VALUE : ZERO;
	
		        if (this.isNegative()) {
		            if (multiplier.isNegative())
		                return this.neg().mul(multiplier.neg());
		            else
		                return this.neg().mul(multiplier).neg();
		        } else if (multiplier.isNegative())
		            return this.mul(multiplier.neg()).neg();
	
		        // If both longs are small, use float multiplication
		        if (this.lt(TWO_PWR_24) && multiplier.lt(TWO_PWR_24))
		            return fromNumber(this.toNumber() * multiplier.toNumber(), this.unsigned);
	
		        // Divide each long into 4 chunks of 16 bits, and then add up 4x4 products.
		        // We can skip products that would overflow.
	
		        var a48 = this.high >>> 16;
		        var a32 = this.high & 0xFFFF;
		        var a16 = this.low >>> 16;
		        var a00 = this.low & 0xFFFF;
	
		        var b48 = multiplier.high >>> 16;
		        var b32 = multiplier.high & 0xFFFF;
		        var b16 = multiplier.low >>> 16;
		        var b00 = multiplier.low & 0xFFFF;
	
		        var c48 = 0, c32 = 0, c16 = 0, c00 = 0;
		        c00 += a00 * b00;
		        c16 += c00 >>> 16;
		        c00 &= 0xFFFF;
		        c16 += a16 * b00;
		        c32 += c16 >>> 16;
		        c16 &= 0xFFFF;
		        c16 += a00 * b16;
		        c32 += c16 >>> 16;
		        c16 &= 0xFFFF;
		        c32 += a32 * b00;
		        c48 += c32 >>> 16;
		        c32 &= 0xFFFF;
		        c32 += a16 * b16;
		        c48 += c32 >>> 16;
		        c32 &= 0xFFFF;
		        c32 += a00 * b32;
		        c48 += c32 >>> 16;
		        c32 &= 0xFFFF;
		        c48 += a48 * b00 + a32 * b16 + a16 * b32 + a00 * b48;
		        c48 &= 0xFFFF;
		        return fromBits((c16 << 16) | c00, (c48 << 16) | c32, this.unsigned);
		    };
	
		    /**
		     * Returns the product of this and the specified Long. This is an alias of {@link Long#multiply}.
		     * @function
		     * @param {!Long|number|string} multiplier Multiplier
		     * @returns {!Long} Product
		     * @expose
		     */
		    LongPrototype.mul = LongPrototype.multiply;
	
		    /**
		     * Returns this Long divided by the specified. The result is signed if this Long is signed or
		     *  unsigned if this Long is unsigned.
		     * @param {!Long|number|string} divisor Divisor
		     * @returns {!Long} Quotient
		     * @expose
		     */
		    LongPrototype.divide = function divide(divisor) {
		        if (!isLong(divisor))
		            divisor = fromValue(divisor);
		        if (divisor.isZero())
		            throw Error('division by zero');
		        if (this.isZero())
		            return this.unsigned ? UZERO : ZERO;
		        var approx, rem, res;
		        if (!this.unsigned) {
		            if (this.eq(MIN_VALUE)) {
		                if (divisor.eq(ONE) || divisor.eq(NEG_ONE))
		                    return MIN_VALUE;  // recall that -MIN_VALUE == MIN_VALUE
		                else if (divisor.eq(MIN_VALUE))
		                    return ONE;
		                else {
		                    // At this point, we have |other| >= 2, so |this/other| < |MIN_VALUE|.
		                    var halfThis = this.shr(1);
		                    approx = halfThis.div(divisor).shl(1);
		                    if (approx.eq(ZERO)) {
		                        return divisor.isNegative() ? ONE : NEG_ONE;
		                    } else {
		                        rem = this.sub(divisor.mul(approx));
		                        res = approx.add(rem.div(divisor));
		                        return res;
		                    }
		                }
		            } else if (divisor.eq(MIN_VALUE))
		                return this.unsigned ? UZERO : ZERO;
		            if (this.isNegative()) {
		                if (divisor.isNegative())
		                    return this.neg().div(divisor.neg());
		                return this.neg().div(divisor).neg();
		            } else if (divisor.isNegative())
		                return this.div(divisor.neg()).neg();
		        } else if (!divisor.unsigned)
		            divisor = divisor.toUnsigned();
	
		        // The algorithm below has not been made for unsigned longs. It's therefore
		        // required to take special care of the MSB prior to running it.
		        if (this.unsigned) {
		            if (divisor.gt(this))
		                return UZERO;
		            if (divisor.gt(this.shru(1))) // 15 >>> 1 = 7 ; with divisor = 8 ; true
		                return UONE;
		            res = UZERO;
		        } else
		            res = ZERO;
	
		        // Repeat the following until the remainder is less than other:  find a
		        // floating-point that approximates remainder / other *from below*, add this
		        // into the result, and subtract it from the remainder.  It is critical that
		        // the approximate value is less than or equal to the real value so that the
		        // remainder never becomes negative.
		        rem = this;
		        while (rem.gte(divisor)) {
		            // Approximate the result of division. This may be a little greater or
		            // smaller than the actual value.
		            approx = Math.max(1, Math.floor(rem.toNumber() / divisor.toNumber()));
	
		            // We will tweak the approximate result by changing it in the 48-th digit or
		            // the smallest non-fractional digit, whichever is larger.
		            var log2 = Math.ceil(Math.log(approx) / Math.LN2),
		                delta = (log2 <= 48) ? 1 : pow_dbl(2, log2 - 48),
	
		            // Decrease the approximation until it is smaller than the remainder.  Note
		            // that if it is too large, the product overflows and is negative.
		                approxRes = fromNumber(approx),
		                approxRem = approxRes.mul(divisor);
		            while (approxRem.isNegative() || approxRem.gt(rem)) {
		                approx -= delta;
		                approxRes = fromNumber(approx, this.unsigned);
		                approxRem = approxRes.mul(divisor);
		            }
	
		            // We know the answer can't be zero... and actually, zero would cause
		            // infinite recursion since we would make no progress.
		            if (approxRes.isZero())
		                approxRes = ONE;
	
		            res = res.add(approxRes);
		            rem = rem.sub(approxRem);
		        }
		        return res;
		    };
	
		    /**
		     * Returns this Long divided by the specified. This is an alias of {@link Long#divide}.
		     * @function
		     * @param {!Long|number|string} divisor Divisor
		     * @returns {!Long} Quotient
		     * @expose
		     */
		    LongPrototype.div = LongPrototype.divide;
	
		    /**
		     * Returns this Long modulo the specified.
		     * @param {!Long|number|string} divisor Divisor
		     * @returns {!Long} Remainder
		     * @expose
		     */
		    LongPrototype.modulo = function modulo(divisor) {
		        if (!isLong(divisor))
		            divisor = fromValue(divisor);
		        return this.sub(this.div(divisor).mul(divisor));
		    };
	
		    /**
		     * Returns this Long modulo the specified. This is an alias of {@link Long#modulo}.
		     * @function
		     * @param {!Long|number|string} divisor Divisor
		     * @returns {!Long} Remainder
		     * @expose
		     */
		    LongPrototype.mod = LongPrototype.modulo;
	
		    /**
		     * Returns the bitwise NOT of this Long.
		     * @returns {!Long}
		     * @expose
		     */
		    LongPrototype.not = function not() {
		        return fromBits(~this.low, ~this.high, this.unsigned);
		    };
	
		    /**
		     * Returns the bitwise AND of this Long and the specified.
		     * @param {!Long|number|string} other Other Long
		     * @returns {!Long}
		     * @expose
		     */
		    LongPrototype.and = function and(other) {
		        if (!isLong(other))
		            other = fromValue(other);
		        return fromBits(this.low & other.low, this.high & other.high, this.unsigned);
		    };
	
		    /**
		     * Returns the bitwise OR of this Long and the specified.
		     * @param {!Long|number|string} other Other Long
		     * @returns {!Long}
		     * @expose
		     */
		    LongPrototype.or = function or(other) {
		        if (!isLong(other))
		            other = fromValue(other);
		        return fromBits(this.low | other.low, this.high | other.high, this.unsigned);
		    };
	
		    /**
		     * Returns the bitwise XOR of this Long and the given one.
		     * @param {!Long|number|string} other Other Long
		     * @returns {!Long}
		     * @expose
		     */
		    LongPrototype.xor = function xor(other) {
		        if (!isLong(other))
		            other = fromValue(other);
		        return fromBits(this.low ^ other.low, this.high ^ other.high, this.unsigned);
		    };
	
		    /**
		     * Returns this Long with bits shifted to the left by the given amount.
		     * @param {number|!Long} numBits Number of bits
		     * @returns {!Long} Shifted Long
		     * @expose
		     */
		    LongPrototype.shiftLeft = function shiftLeft(numBits) {
		        if (isLong(numBits))
		            numBits = numBits.toInt();
		        if ((numBits &= 63) === 0)
		            return this;
		        else if (numBits < 32)
		            return fromBits(this.low << numBits, (this.high << numBits) | (this.low >>> (32 - numBits)), this.unsigned);
		        else
		            return fromBits(0, this.low << (numBits - 32), this.unsigned);
		    };
	
		    /**
		     * Returns this Long with bits shifted to the left by the given amount. This is an alias of {@link Long#shiftLeft}.
		     * @function
		     * @param {number|!Long} numBits Number of bits
		     * @returns {!Long} Shifted Long
		     * @expose
		     */
		    LongPrototype.shl = LongPrototype.shiftLeft;
	
		    /**
		     * Returns this Long with bits arithmetically shifted to the right by the given amount.
		     * @param {number|!Long} numBits Number of bits
		     * @returns {!Long} Shifted Long
		     * @expose
		     */
		    LongPrototype.shiftRight = function shiftRight(numBits) {
		        if (isLong(numBits))
		            numBits = numBits.toInt();
		        if ((numBits &= 63) === 0)
		            return this;
		        else if (numBits < 32)
		            return fromBits((this.low >>> numBits) | (this.high << (32 - numBits)), this.high >> numBits, this.unsigned);
		        else
		            return fromBits(this.high >> (numBits - 32), this.high >= 0 ? 0 : -1, this.unsigned);
		    };
	
		    /**
		     * Returns this Long with bits arithmetically shifted to the right by the given amount. This is an alias of {@link Long#shiftRight}.
		     * @function
		     * @param {number|!Long} numBits Number of bits
		     * @returns {!Long} Shifted Long
		     * @expose
		     */
		    LongPrototype.shr = LongPrototype.shiftRight;
	
		    /**
		     * Returns this Long with bits logically shifted to the right by the given amount.
		     * @param {number|!Long} numBits Number of bits
		     * @returns {!Long} Shifted Long
		     * @expose
		     */
		    LongPrototype.shiftRightUnsigned = function shiftRightUnsigned(numBits) {
		        if (isLong(numBits))
		            numBits = numBits.toInt();
		        numBits &= 63;
		        if (numBits === 0)
		            return this;
		        else {
		            var high = this.high;
		            if (numBits < 32) {
		                var low = this.low;
		                return fromBits((low >>> numBits) | (high << (32 - numBits)), high >>> numBits, this.unsigned);
		            } else if (numBits === 32)
		                return fromBits(high, 0, this.unsigned);
		            else
		                return fromBits(high >>> (numBits - 32), 0, this.unsigned);
		        }
		    };
	
		    /**
		     * Returns this Long with bits logically shifted to the right by the given amount. This is an alias of {@link Long#shiftRightUnsigned}.
		     * @function
		     * @param {number|!Long} numBits Number of bits
		     * @returns {!Long} Shifted Long
		     * @expose
		     */
		    LongPrototype.shru = LongPrototype.shiftRightUnsigned;
	
		    /**
		     * Converts this Long to signed.
		     * @returns {!Long} Signed long
		     * @expose
		     */
		    LongPrototype.toSigned = function toSigned() {
		        if (!this.unsigned)
		            return this;
		        return fromBits(this.low, this.high, false);
		    };
	
		    /**
		     * Converts this Long to unsigned.
		     * @returns {!Long} Unsigned long
		     * @expose
		     */
		    LongPrototype.toUnsigned = function toUnsigned() {
		        if (this.unsigned)
		            return this;
		        return fromBits(this.low, this.high, true);
		    };
	
		    return Long;
		});
		});
	
		var require$$0$40 = (long && typeof long === 'object' && 'default' in long ? long['default'] : long);
	
		var bytebuffer = createCommonjsModule(function (module) {
		/*
		 Copyright 2013-2014 Daniel Wirtz <dcode@dcode.io>
	
		 Licensed under the Apache License, Version 2.0 (the "License");
		 you may not use this file except in compliance with the License.
		 You may obtain a copy of the License at
	
		 http://www.apache.org/licenses/LICENSE-2.0
	
		 Unless required by applicable law or agreed to in writing, software
		 distributed under the License is distributed on an "AS IS" BASIS,
		 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
		 See the License for the specific language governing permissions and
		 limitations under the License.
		 */
	
		/**
		 * @license bytebuffer.js (c) 2015 Daniel Wirtz <dcode@dcode.io>
		 * Backing buffer: ArrayBuffer, Accessor: Uint8Array
		 * Released under the Apache License, Version 2.0
		 * see: https://github.com/dcodeIO/bytebuffer.js for details
		 */
		(function(global, factory) {
	
		    /* AMD */ if (typeof define === 'function' && define["amd"])
		        define(["long"], factory);
		    /* CommonJS */ else if ('function' === 'function' && typeof module === "object" && module && module["exports"])
		        module['exports'] = (function() {
		            var Long; try { Long = require$$0$40; } catch (e) {}
		            return factory(Long);
		        })();
		    /* Global */ else
		        (global["dcodeIO"] = global["dcodeIO"] || {})["ByteBuffer"] = factory(global["dcodeIO"]["Long"]);
	
		})(commonjsGlobal, function(Long) {
		    "use strict";
	
		    /**
		     * Constructs a new ByteBuffer.
		     * @class The swiss army knife for binary data in JavaScript.
		     * @exports ByteBuffer
		     * @constructor
		     * @param {number=} capacity Initial capacity. Defaults to {@link ByteBuffer.DEFAULT_CAPACITY}.
		     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
		     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
		     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
		     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
		     * @expose
		     */
		    var ByteBuffer = function(capacity, littleEndian, noAssert) {
		        if (typeof capacity === 'undefined')
		            capacity = ByteBuffer.DEFAULT_CAPACITY;
		        if (typeof littleEndian === 'undefined')
		            littleEndian = ByteBuffer.DEFAULT_ENDIAN;
		        if (typeof noAssert === 'undefined')
		            noAssert = ByteBuffer.DEFAULT_NOASSERT;
		        if (!noAssert) {
		            capacity = capacity | 0;
		            if (capacity < 0)
		                throw RangeError("Illegal capacity");
		            littleEndian = !!littleEndian;
		            noAssert = !!noAssert;
		        }
	
		        /**
		         * Backing ArrayBuffer.
		         * @type {!ArrayBuffer}
		         * @expose
		         */
		        this.buffer = capacity === 0 ? EMPTY_BUFFER : new ArrayBuffer(capacity);
	
		        /**
		         * Uint8Array utilized to manipulate the backing buffer. Becomes `null` if the backing buffer has a capacity of `0`.
		         * @type {?Uint8Array}
		         * @expose
		         */
		        this.view = capacity === 0 ? null : new Uint8Array(this.buffer);
	
		        /**
		         * Absolute read/write offset.
		         * @type {number}
		         * @expose
		         * @see ByteBuffer#flip
		         * @see ByteBuffer#clear
		         */
		        this.offset = 0;
	
		        /**
		         * Marked offset.
		         * @type {number}
		         * @expose
		         * @see ByteBuffer#mark
		         * @see ByteBuffer#reset
		         */
		        this.markedOffset = -1;
	
		        /**
		         * Absolute limit of the contained data. Set to the backing buffer's capacity upon allocation.
		         * @type {number}
		         * @expose
		         * @see ByteBuffer#flip
		         * @see ByteBuffer#clear
		         */
		        this.limit = capacity;
	
		        /**
		         * Whether to use little endian byte order, defaults to `false` for big endian.
		         * @type {boolean}
		         * @expose
		         */
		        this.littleEndian = littleEndian;
	
		        /**
		         * Whether to skip assertions of offsets and values, defaults to `false`.
		         * @type {boolean}
		         * @expose
		         */
		        this.noAssert = noAssert;
		    };
	
		    /**
		     * ByteBuffer version.
		     * @type {string}
		     * @const
		     * @expose
		     */
		    ByteBuffer.VERSION = "5.0.1";
	
		    /**
		     * Little endian constant that can be used instead of its boolean value. Evaluates to `true`.
		     * @type {boolean}
		     * @const
		     * @expose
		     */
		    ByteBuffer.LITTLE_ENDIAN = true;
	
		    /**
		     * Big endian constant that can be used instead of its boolean value. Evaluates to `false`.
		     * @type {boolean}
		     * @const
		     * @expose
		     */
		    ByteBuffer.BIG_ENDIAN = false;
	
		    /**
		     * Default initial capacity of `16`.
		     * @type {number}
		     * @expose
		     */
		    ByteBuffer.DEFAULT_CAPACITY = 16;
	
		    /**
		     * Default endianess of `false` for big endian.
		     * @type {boolean}
		     * @expose
		     */
		    ByteBuffer.DEFAULT_ENDIAN = ByteBuffer.BIG_ENDIAN;
	
		    /**
		     * Default no assertions flag of `false`.
		     * @type {boolean}
		     * @expose
		     */
		    ByteBuffer.DEFAULT_NOASSERT = false;
	
		    /**
		     * A `Long` class for representing a 64-bit two's-complement integer value. May be `null` if Long.js has not been loaded
		     *  and int64 support is not available.
		     * @type {?Long}
		     * @const
		     * @see https://github.com/dcodeIO/long.js
		     * @expose
		     */
		    ByteBuffer.Long = Long || null;
	
		    /**
		     * @alias ByteBuffer.prototype
		     * @inner
		     */
		    var ByteBufferPrototype = ByteBuffer.prototype;
	
		    /**
		     * An indicator used to reliably determine if an object is a ByteBuffer or not.
		     * @type {boolean}
		     * @const
		     * @expose
		     * @private
		     */
		    ByteBufferPrototype.__isByteBuffer__;
	
		    Object.defineProperty(ByteBufferPrototype, "__isByteBuffer__", {
		        value: true,
		        enumerable: false,
		        configurable: false
		    });
	
		    // helpers
	
		    /**
		     * @type {!ArrayBuffer}
		     * @inner
		     */
		    var EMPTY_BUFFER = new ArrayBuffer(0);
	
		    /**
		     * String.fromCharCode reference for compile-time renaming.
		     * @type {function(...number):string}
		     * @inner
		     */
		    var stringFromCharCode = String.fromCharCode;
	
		    /**
		     * Creates a source function for a string.
		     * @param {string} s String to read from
		     * @returns {function():number|null} Source function returning the next char code respectively `null` if there are
		     *  no more characters left.
		     * @throws {TypeError} If the argument is invalid
		     * @inner
		     */
		    function stringSource(s) {
		        var i=0; return function() {
		            return i < s.length ? s.charCodeAt(i++) : null;
		        };
		    }
	
		    /**
		     * Creates a destination function for a string.
		     * @returns {function(number=):undefined|string} Destination function successively called with the next char code.
		     *  Returns the final string when called without arguments.
		     * @inner
		     */
		    function stringDestination() {
		        var cs = [], ps = []; return function() {
		            if (arguments.length === 0)
		                return ps.join('')+stringFromCharCode.apply(String, cs);
		            if (cs.length + arguments.length > 1024)
		                ps.push(stringFromCharCode.apply(String, cs)),
		                    cs.length = 0;
		            Array.prototype.push.apply(cs, arguments);
		        };
		    }
	
		    /**
		     * Gets the accessor type.
		     * @returns {Function} `Buffer` under node.js, `Uint8Array` respectively `DataView` in the browser (classes)
		     * @expose
		     */
		    ByteBuffer.accessor = function() {
		        return Uint8Array;
		    };
		    /**
		     * Allocates a new ByteBuffer backed by a buffer of the specified capacity.
		     * @param {number=} capacity Initial capacity. Defaults to {@link ByteBuffer.DEFAULT_CAPACITY}.
		     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
		     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
		     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
		     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
		     * @returns {!ByteBuffer}
		     * @expose
		     */
		    ByteBuffer.allocate = function(capacity, littleEndian, noAssert) {
		        return new ByteBuffer(capacity, littleEndian, noAssert);
		    };
	
		    /**
		     * Concatenates multiple ByteBuffers into one.
		     * @param {!Array.<!ByteBuffer|!ArrayBuffer|!Uint8Array|string>} buffers Buffers to concatenate
		     * @param {(string|boolean)=} encoding String encoding if `buffers` contains a string ("base64", "hex", "binary",
		     *  defaults to "utf8")
		     * @param {boolean=} littleEndian Whether to use little or big endian byte order for the resulting ByteBuffer. Defaults
		     *  to {@link ByteBuffer.DEFAULT_ENDIAN}.
		     * @param {boolean=} noAssert Whether to skip assertions of offsets and values for the resulting ByteBuffer. Defaults to
		     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
		     * @returns {!ByteBuffer} Concatenated ByteBuffer
		     * @expose
		     */
		    ByteBuffer.concat = function(buffers, encoding, littleEndian, noAssert) {
		        if (typeof encoding === 'boolean' || typeof encoding !== 'string') {
		            noAssert = littleEndian;
		            littleEndian = encoding;
		            encoding = undefined;
		        }
		        var capacity = 0;
		        for (var i=0, k=buffers.length, length; i<k; ++i) {
		            if (!ByteBuffer.isByteBuffer(buffers[i]))
		                buffers[i] = ByteBuffer.wrap(buffers[i], encoding);
		            length = buffers[i].limit - buffers[i].offset;
		            if (length > 0) capacity += length;
		        }
		        if (capacity === 0)
		            return new ByteBuffer(0, littleEndian, noAssert);
		        var bb = new ByteBuffer(capacity, littleEndian, noAssert),
		            bi;
		        i=0; while (i<k) {
		            bi = buffers[i++];
		            length = bi.limit - bi.offset;
		            if (length <= 0) continue;
		            bb.view.set(bi.view.subarray(bi.offset, bi.limit), bb.offset);
		            bb.offset += length;
		        }
		        bb.limit = bb.offset;
		        bb.offset = 0;
		        return bb;
		    };
	
		    /**
		     * Tests if the specified type is a ByteBuffer.
		     * @param {*} bb ByteBuffer to test
		     * @returns {boolean} `true` if it is a ByteBuffer, otherwise `false`
		     * @expose
		     */
		    ByteBuffer.isByteBuffer = function(bb) {
		        return (bb && bb["__isByteBuffer__"]) === true;
		    };
		    /**
		     * Gets the backing buffer type.
		     * @returns {Function} `Buffer` under node.js, `ArrayBuffer` in the browser (classes)
		     * @expose
		     */
		    ByteBuffer.type = function() {
		        return ArrayBuffer;
		    };
		    /**
		     * Wraps a buffer or a string. Sets the allocated ByteBuffer's {@link ByteBuffer#offset} to `0` and its
		     *  {@link ByteBuffer#limit} to the length of the wrapped data.
		     * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string|!Array.<number>} buffer Anything that can be wrapped
		     * @param {(string|boolean)=} encoding String encoding if `buffer` is a string ("base64", "hex", "binary", defaults to
		     *  "utf8")
		     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
		     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
		     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
		     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
		     * @returns {!ByteBuffer} A ByteBuffer wrapping `buffer`
		     * @expose
		     */
		    ByteBuffer.wrap = function(buffer, encoding, littleEndian, noAssert) {
		        if (typeof encoding !== 'string') {
		            noAssert = littleEndian;
		            littleEndian = encoding;
		            encoding = undefined;
		        }
		        if (typeof buffer === 'string') {
		            if (typeof encoding === 'undefined')
		                encoding = "utf8";
		            switch (encoding) {
		                case "base64":
		                    return ByteBuffer.fromBase64(buffer, littleEndian);
		                case "hex":
		                    return ByteBuffer.fromHex(buffer, littleEndian);
		                case "binary":
		                    return ByteBuffer.fromBinary(buffer, littleEndian);
		                case "utf8":
		                    return ByteBuffer.fromUTF8(buffer, littleEndian);
		                case "debug":
		                    return ByteBuffer.fromDebug(buffer, littleEndian);
		                default:
		                    throw Error("Unsupported encoding: "+encoding);
		            }
		        }
		        if (buffer === null || typeof buffer !== 'object')
		            throw TypeError("Illegal buffer");
		        var bb;
		        if (ByteBuffer.isByteBuffer(buffer)) {
		            bb = ByteBufferPrototype.clone.call(buffer);
		            bb.markedOffset = -1;
		            return bb;
		        }
		        if (buffer instanceof Uint8Array) { // Extract ArrayBuffer from Uint8Array
		            bb = new ByteBuffer(0, littleEndian, noAssert);
		            if (buffer.length > 0) { // Avoid references to more than one EMPTY_BUFFER
		                bb.buffer = buffer.buffer;
		                bb.offset = buffer.byteOffset;
		                bb.limit = buffer.byteOffset + buffer.byteLength;
		                bb.view = new Uint8Array(buffer.buffer);
		            }
		        } else if (buffer instanceof ArrayBuffer) { // Reuse ArrayBuffer
		            bb = new ByteBuffer(0, littleEndian, noAssert);
		            if (buffer.byteLength > 0) {
		                bb.buffer = buffer;
		                bb.offset = 0;
		                bb.limit = buffer.byteLength;
		                bb.view = buffer.byteLength > 0 ? new Uint8Array(buffer) : null;
		            }
		        } else if (Object.prototype.toString.call(buffer) === "[object Array]") { // Create from octets
		            bb = new ByteBuffer(buffer.length, littleEndian, noAssert);
		            bb.limit = buffer.length;
		            for (var i=0; i<buffer.length; ++i)
		                bb.view[i] = buffer[i];
		        } else
		            throw TypeError("Illegal buffer"); // Otherwise fail
		        return bb;
		    };
	
		    /**
		     * Writes the array as a bitset.
		     * @param {Array<boolean>} value Array of booleans to write
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `length` if omitted.
		     * @returns {!ByteBuffer}
		     * @expose
		     */
		    ByteBufferPrototype.writeBitSet = function(value, offset) {
		      var relative = typeof offset === 'undefined';
		      if (relative) offset = this.offset;
		      if (!this.noAssert) {
		        if (!(value instanceof Array))
		          throw TypeError("Illegal BitSet: Not an array");
		        if (typeof offset !== 'number' || offset % 1 !== 0)
		            throw TypeError("Illegal offset: "+offset+" (not an integer)");
		        offset >>>= 0;
		        if (offset < 0 || offset + 0 > this.buffer.byteLength)
		            throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		      }
	
		      var start = offset,
		          bits = value.length,
		          bytes = (bits >> 3),
		          bit = 0,
		          k;
	
		      offset += this.writeVarint32(bits,offset);
	
		      while(bytes--) {
		        k = (!!value[bit++] & 1) |
		            ((!!value[bit++] & 1) << 1) |
		            ((!!value[bit++] & 1) << 2) |
		            ((!!value[bit++] & 1) << 3) |
		            ((!!value[bit++] & 1) << 4) |
		            ((!!value[bit++] & 1) << 5) |
		            ((!!value[bit++] & 1) << 6) |
		            ((!!value[bit++] & 1) << 7);
		        this.writeByte(k,offset++);
		      }
	
		      if(bit < bits) {
		        var m = 0; k = 0;
		        while(bit < bits) k = k | ((!!value[bit++] & 1) << (m++));
		        this.writeByte(k,offset++);
		      }
	
		      if (relative) {
		        this.offset = offset;
		        return this;
		      }
		      return offset - start;
		    }
	
		    /**
		     * Reads a BitSet as an array of booleans.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `length` if omitted.
		     * @returns {Array<boolean>
		     * @expose
		     */
		    ByteBufferPrototype.readBitSet = function(offset) {
		      var relative = typeof offset === 'undefined';
		      if (relative) offset = this.offset;
	
		      var ret = this.readVarint32(offset),
		          bits = ret.value,
		          bytes = (bits >> 3),
		          bit = 0,
		          value = [],
		          k;
	
		      offset += ret.length;
	
		      while(bytes--) {
		        k = this.readByte(offset++);
		        value[bit++] = !!(k & 0x01);
		        value[bit++] = !!(k & 0x02);
		        value[bit++] = !!(k & 0x04);
		        value[bit++] = !!(k & 0x08);
		        value[bit++] = !!(k & 0x10);
		        value[bit++] = !!(k & 0x20);
		        value[bit++] = !!(k & 0x40);
		        value[bit++] = !!(k & 0x80);
		      }
	
		      if(bit < bits) {
		        var m = 0;
		        k = this.readByte(offset++);
		        while(bit < bits) value[bit++] = !!((k >> (m++)) & 1);
		      }
	
		      if (relative) {
		        this.offset = offset;
		      }
		      return value;
		    }
		    /**
		     * Reads the specified number of bytes.
		     * @param {number} length Number of bytes to read
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `length` if omitted.
		     * @returns {!ByteBuffer}
		     * @expose
		     */
		    ByteBufferPrototype.readBytes = function(length, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + length > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+length+") <= "+this.buffer.byteLength);
		        }
		        var slice = this.slice(offset, offset + length);
		        if (relative) this.offset += length;
		        return slice;
		    };
	
		    /**
		     * Writes a payload of bytes. This is an alias of {@link ByteBuffer#append}.
		     * @function
		     * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string} source Data to write. If `source` is a ByteBuffer, its offsets
		     *  will be modified according to the performed read operation.
		     * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  written if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.writeBytes = ByteBufferPrototype.append;
	
		    // types/ints/int8
	
		    /**
		     * Writes an 8bit signed integer.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.writeInt8 = function(value, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof value !== 'number' || value % 1 !== 0)
		                throw TypeError("Illegal value: "+value+" (not an integer)");
		            value |= 0;
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        offset += 1;
		        var capacity0 = this.buffer.byteLength;
		        if (offset > capacity0)
		            this.resize((capacity0 *= 2) > offset ? capacity0 : offset);
		        offset -= 1;
		        this.view[offset] = value;
		        if (relative) this.offset += 1;
		        return this;
		    };
	
		    /**
		     * Writes an 8bit signed integer. This is an alias of {@link ByteBuffer#writeInt8}.
		     * @function
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.writeByte = ByteBufferPrototype.writeInt8;
	
		    /**
		     * Reads an 8bit signed integer.
		     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
		     * @returns {number} Value read
		     * @expose
		     */
		    ByteBufferPrototype.readInt8 = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 1 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
		        }
		        var value = this.view[offset];
		        if ((value & 0x80) === 0x80) value = -(0xFF - value + 1); // Cast to signed
		        if (relative) this.offset += 1;
		        return value;
		    };
	
		    /**
		     * Reads an 8bit signed integer. This is an alias of {@link ByteBuffer#readInt8}.
		     * @function
		     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
		     * @returns {number} Value read
		     * @expose
		     */
		    ByteBufferPrototype.readByte = ByteBufferPrototype.readInt8;
	
		    /**
		     * Writes an 8bit unsigned integer.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.writeUint8 = function(value, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof value !== 'number' || value % 1 !== 0)
		                throw TypeError("Illegal value: "+value+" (not an integer)");
		            value >>>= 0;
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        offset += 1;
		        var capacity1 = this.buffer.byteLength;
		        if (offset > capacity1)
		            this.resize((capacity1 *= 2) > offset ? capacity1 : offset);
		        offset -= 1;
		        this.view[offset] = value;
		        if (relative) this.offset += 1;
		        return this;
		    };
	
		    /**
		     * Writes an 8bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint8}.
		     * @function
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.writeUInt8 = ByteBufferPrototype.writeUint8;
	
		    /**
		     * Reads an 8bit unsigned integer.
		     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
		     * @returns {number} Value read
		     * @expose
		     */
		    ByteBufferPrototype.readUint8 = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 1 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
		        }
		        var value = this.view[offset];
		        if (relative) this.offset += 1;
		        return value;
		    };
	
		    /**
		     * Reads an 8bit unsigned integer. This is an alias of {@link ByteBuffer#readUint8}.
		     * @function
		     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `1` if omitted.
		     * @returns {number} Value read
		     * @expose
		     */
		    ByteBufferPrototype.readUInt8 = ByteBufferPrototype.readUint8;
	
		    // types/ints/int16
	
		    /**
		     * Writes a 16bit signed integer.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
		     * @throws {TypeError} If `offset` or `value` is not a valid number
		     * @throws {RangeError} If `offset` is out of bounds
		     * @expose
		     */
		    ByteBufferPrototype.writeInt16 = function(value, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof value !== 'number' || value % 1 !== 0)
		                throw TypeError("Illegal value: "+value+" (not an integer)");
		            value |= 0;
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        offset += 2;
		        var capacity2 = this.buffer.byteLength;
		        if (offset > capacity2)
		            this.resize((capacity2 *= 2) > offset ? capacity2 : offset);
		        offset -= 2;
		        if (this.littleEndian) {
		            this.view[offset+1] = (value & 0xFF00) >>> 8;
		            this.view[offset  ] =  value & 0x00FF;
		        } else {
		            this.view[offset]   = (value & 0xFF00) >>> 8;
		            this.view[offset+1] =  value & 0x00FF;
		        }
		        if (relative) this.offset += 2;
		        return this;
		    };
	
		    /**
		     * Writes a 16bit signed integer. This is an alias of {@link ByteBuffer#writeInt16}.
		     * @function
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
		     * @throws {TypeError} If `offset` or `value` is not a valid number
		     * @throws {RangeError} If `offset` is out of bounds
		     * @expose
		     */
		    ByteBufferPrototype.writeShort = ByteBufferPrototype.writeInt16;
	
		    /**
		     * Reads a 16bit signed integer.
		     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
		     * @returns {number} Value read
		     * @throws {TypeError} If `offset` is not a valid number
		     * @throws {RangeError} If `offset` is out of bounds
		     * @expose
		     */
		    ByteBufferPrototype.readInt16 = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 2 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+2+") <= "+this.buffer.byteLength);
		        }
		        var value = 0;
		        if (this.littleEndian) {
		            value  = this.view[offset  ];
		            value |= this.view[offset+1] << 8;
		        } else {
		            value  = this.view[offset  ] << 8;
		            value |= this.view[offset+1];
		        }
		        if ((value & 0x8000) === 0x8000) value = -(0xFFFF - value + 1); // Cast to signed
		        if (relative) this.offset += 2;
		        return value;
		    };
	
		    /**
		     * Reads a 16bit signed integer. This is an alias of {@link ByteBuffer#readInt16}.
		     * @function
		     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
		     * @returns {number} Value read
		     * @throws {TypeError} If `offset` is not a valid number
		     * @throws {RangeError} If `offset` is out of bounds
		     * @expose
		     */
		    ByteBufferPrototype.readShort = ByteBufferPrototype.readInt16;
	
		    /**
		     * Writes a 16bit unsigned integer.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
		     * @throws {TypeError} If `offset` or `value` is not a valid number
		     * @throws {RangeError} If `offset` is out of bounds
		     * @expose
		     */
		    ByteBufferPrototype.writeUint16 = function(value, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof value !== 'number' || value % 1 !== 0)
		                throw TypeError("Illegal value: "+value+" (not an integer)");
		            value >>>= 0;
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        offset += 2;
		        var capacity3 = this.buffer.byteLength;
		        if (offset > capacity3)
		            this.resize((capacity3 *= 2) > offset ? capacity3 : offset);
		        offset -= 2;
		        if (this.littleEndian) {
		            this.view[offset+1] = (value & 0xFF00) >>> 8;
		            this.view[offset  ] =  value & 0x00FF;
		        } else {
		            this.view[offset]   = (value & 0xFF00) >>> 8;
		            this.view[offset+1] =  value & 0x00FF;
		        }
		        if (relative) this.offset += 2;
		        return this;
		    };
	
		    /**
		     * Writes a 16bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint16}.
		     * @function
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
		     * @throws {TypeError} If `offset` or `value` is not a valid number
		     * @throws {RangeError} If `offset` is out of bounds
		     * @expose
		     */
		    ByteBufferPrototype.writeUInt16 = ByteBufferPrototype.writeUint16;
	
		    /**
		     * Reads a 16bit unsigned integer.
		     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
		     * @returns {number} Value read
		     * @throws {TypeError} If `offset` is not a valid number
		     * @throws {RangeError} If `offset` is out of bounds
		     * @expose
		     */
		    ByteBufferPrototype.readUint16 = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 2 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+2+") <= "+this.buffer.byteLength);
		        }
		        var value = 0;
		        if (this.littleEndian) {
		            value  = this.view[offset  ];
		            value |= this.view[offset+1] << 8;
		        } else {
		            value  = this.view[offset  ] << 8;
		            value |= this.view[offset+1];
		        }
		        if (relative) this.offset += 2;
		        return value;
		    };
	
		    /**
		     * Reads a 16bit unsigned integer. This is an alias of {@link ByteBuffer#readUint16}.
		     * @function
		     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `2` if omitted.
		     * @returns {number} Value read
		     * @throws {TypeError} If `offset` is not a valid number
		     * @throws {RangeError} If `offset` is out of bounds
		     * @expose
		     */
		    ByteBufferPrototype.readUInt16 = ByteBufferPrototype.readUint16;
	
		    // types/ints/int32
	
		    /**
		     * Writes a 32bit signed integer.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @expose
		     */
		    ByteBufferPrototype.writeInt32 = function(value, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof value !== 'number' || value % 1 !== 0)
		                throw TypeError("Illegal value: "+value+" (not an integer)");
		            value |= 0;
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        offset += 4;
		        var capacity4 = this.buffer.byteLength;
		        if (offset > capacity4)
		            this.resize((capacity4 *= 2) > offset ? capacity4 : offset);
		        offset -= 4;
		        if (this.littleEndian) {
		            this.view[offset+3] = (value >>> 24) & 0xFF;
		            this.view[offset+2] = (value >>> 16) & 0xFF;
		            this.view[offset+1] = (value >>>  8) & 0xFF;
		            this.view[offset  ] =  value         & 0xFF;
		        } else {
		            this.view[offset  ] = (value >>> 24) & 0xFF;
		            this.view[offset+1] = (value >>> 16) & 0xFF;
		            this.view[offset+2] = (value >>>  8) & 0xFF;
		            this.view[offset+3] =  value         & 0xFF;
		        }
		        if (relative) this.offset += 4;
		        return this;
		    };
	
		    /**
		     * Writes a 32bit signed integer. This is an alias of {@link ByteBuffer#writeInt32}.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @expose
		     */
		    ByteBufferPrototype.writeInt = ByteBufferPrototype.writeInt32;
	
		    /**
		     * Reads a 32bit signed integer.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @returns {number} Value read
		     * @expose
		     */
		    ByteBufferPrototype.readInt32 = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 4 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
		        }
		        var value = 0;
		        if (this.littleEndian) {
		            value  = this.view[offset+2] << 16;
		            value |= this.view[offset+1] <<  8;
		            value |= this.view[offset  ];
		            value += this.view[offset+3] << 24 >>> 0;
		        } else {
		            value  = this.view[offset+1] << 16;
		            value |= this.view[offset+2] <<  8;
		            value |= this.view[offset+3];
		            value += this.view[offset  ] << 24 >>> 0;
		        }
		        value |= 0; // Cast to signed
		        if (relative) this.offset += 4;
		        return value;
		    };
	
		    /**
		     * Reads a 32bit signed integer. This is an alias of {@link ByteBuffer#readInt32}.
		     * @param {number=} offset Offset to read from. Will use and advance {@link ByteBuffer#offset} by `4` if omitted.
		     * @returns {number} Value read
		     * @expose
		     */
		    ByteBufferPrototype.readInt = ByteBufferPrototype.readInt32;
	
		    /**
		     * Writes a 32bit unsigned integer.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @expose
		     */
		    ByteBufferPrototype.writeUint32 = function(value, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof value !== 'number' || value % 1 !== 0)
		                throw TypeError("Illegal value: "+value+" (not an integer)");
		            value >>>= 0;
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        offset += 4;
		        var capacity5 = this.buffer.byteLength;
		        if (offset > capacity5)
		            this.resize((capacity5 *= 2) > offset ? capacity5 : offset);
		        offset -= 4;
		        if (this.littleEndian) {
		            this.view[offset+3] = (value >>> 24) & 0xFF;
		            this.view[offset+2] = (value >>> 16) & 0xFF;
		            this.view[offset+1] = (value >>>  8) & 0xFF;
		            this.view[offset  ] =  value         & 0xFF;
		        } else {
		            this.view[offset  ] = (value >>> 24) & 0xFF;
		            this.view[offset+1] = (value >>> 16) & 0xFF;
		            this.view[offset+2] = (value >>>  8) & 0xFF;
		            this.view[offset+3] =  value         & 0xFF;
		        }
		        if (relative) this.offset += 4;
		        return this;
		    };
	
		    /**
		     * Writes a 32bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint32}.
		     * @function
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @expose
		     */
		    ByteBufferPrototype.writeUInt32 = ByteBufferPrototype.writeUint32;
	
		    /**
		     * Reads a 32bit unsigned integer.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @returns {number} Value read
		     * @expose
		     */
		    ByteBufferPrototype.readUint32 = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 4 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
		        }
		        var value = 0;
		        if (this.littleEndian) {
		            value  = this.view[offset+2] << 16;
		            value |= this.view[offset+1] <<  8;
		            value |= this.view[offset  ];
		            value += this.view[offset+3] << 24 >>> 0;
		        } else {
		            value  = this.view[offset+1] << 16;
		            value |= this.view[offset+2] <<  8;
		            value |= this.view[offset+3];
		            value += this.view[offset  ] << 24 >>> 0;
		        }
		        if (relative) this.offset += 4;
		        return value;
		    };
	
		    /**
		     * Reads a 32bit unsigned integer. This is an alias of {@link ByteBuffer#readUint32}.
		     * @function
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @returns {number} Value read
		     * @expose
		     */
		    ByteBufferPrototype.readUInt32 = ByteBufferPrototype.readUint32;
	
		    // types/ints/int64
	
		    if (Long) {
	
		        /**
		         * Writes a 64bit signed integer.
		         * @param {number|!Long} value Value to write
		         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		         * @returns {!ByteBuffer} this
		         * @expose
		         */
		        ByteBufferPrototype.writeInt64 = function(value, offset) {
		            var relative = typeof offset === 'undefined';
		            if (relative) offset = this.offset;
		            if (!this.noAssert) {
		                if (typeof value === 'number')
		                    value = Long.fromNumber(value);
		                else if (typeof value === 'string')
		                    value = Long.fromString(value);
		                else if (!(value && value instanceof Long))
		                    throw TypeError("Illegal value: "+value+" (not an integer or Long)");
		                if (typeof offset !== 'number' || offset % 1 !== 0)
		                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
		                offset >>>= 0;
		                if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		            }
		            if (typeof value === 'number')
		                value = Long.fromNumber(value);
		            else if (typeof value === 'string')
		                value = Long.fromString(value);
		            offset += 8;
		            var capacity6 = this.buffer.byteLength;
		            if (offset > capacity6)
		                this.resize((capacity6 *= 2) > offset ? capacity6 : offset);
		            offset -= 8;
		            var lo = value.low,
		                hi = value.high;
		            if (this.littleEndian) {
		                this.view[offset+3] = (lo >>> 24) & 0xFF;
		                this.view[offset+2] = (lo >>> 16) & 0xFF;
		                this.view[offset+1] = (lo >>>  8) & 0xFF;
		                this.view[offset  ] =  lo         & 0xFF;
		                offset += 4;
		                this.view[offset+3] = (hi >>> 24) & 0xFF;
		                this.view[offset+2] = (hi >>> 16) & 0xFF;
		                this.view[offset+1] = (hi >>>  8) & 0xFF;
		                this.view[offset  ] =  hi         & 0xFF;
		            } else {
		                this.view[offset  ] = (hi >>> 24) & 0xFF;
		                this.view[offset+1] = (hi >>> 16) & 0xFF;
		                this.view[offset+2] = (hi >>>  8) & 0xFF;
		                this.view[offset+3] =  hi         & 0xFF;
		                offset += 4;
		                this.view[offset  ] = (lo >>> 24) & 0xFF;
		                this.view[offset+1] = (lo >>> 16) & 0xFF;
		                this.view[offset+2] = (lo >>>  8) & 0xFF;
		                this.view[offset+3] =  lo         & 0xFF;
		            }
		            if (relative) this.offset += 8;
		            return this;
		        };
	
		        /**
		         * Writes a 64bit signed integer. This is an alias of {@link ByteBuffer#writeInt64}.
		         * @param {number|!Long} value Value to write
		         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		         * @returns {!ByteBuffer} this
		         * @expose
		         */
		        ByteBufferPrototype.writeLong = ByteBufferPrototype.writeInt64;
	
		        /**
		         * Reads a 64bit signed integer.
		         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		         * @returns {!Long}
		         * @expose
		         */
		        ByteBufferPrototype.readInt64 = function(offset) {
		            var relative = typeof offset === 'undefined';
		            if (relative) offset = this.offset;
		            if (!this.noAssert) {
		                if (typeof offset !== 'number' || offset % 1 !== 0)
		                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
		                offset >>>= 0;
		                if (offset < 0 || offset + 8 > this.buffer.byteLength)
		                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+8+") <= "+this.buffer.byteLength);
		            }
		            var lo = 0,
		                hi = 0;
		            if (this.littleEndian) {
		                lo  = this.view[offset+2] << 16;
		                lo |= this.view[offset+1] <<  8;
		                lo |= this.view[offset  ];
		                lo += this.view[offset+3] << 24 >>> 0;
		                offset += 4;
		                hi  = this.view[offset+2] << 16;
		                hi |= this.view[offset+1] <<  8;
		                hi |= this.view[offset  ];
		                hi += this.view[offset+3] << 24 >>> 0;
		            } else {
		                hi  = this.view[offset+1] << 16;
		                hi |= this.view[offset+2] <<  8;
		                hi |= this.view[offset+3];
		                hi += this.view[offset  ] << 24 >>> 0;
		                offset += 4;
		                lo  = this.view[offset+1] << 16;
		                lo |= this.view[offset+2] <<  8;
		                lo |= this.view[offset+3];
		                lo += this.view[offset  ] << 24 >>> 0;
		            }
		            var value = new Long(lo, hi, false);
		            if (relative) this.offset += 8;
		            return value;
		        };
	
		        /**
		         * Reads a 64bit signed integer. This is an alias of {@link ByteBuffer#readInt64}.
		         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		         * @returns {!Long}
		         * @expose
		         */
		        ByteBufferPrototype.readLong = ByteBufferPrototype.readInt64;
	
		        /**
		         * Writes a 64bit unsigned integer.
		         * @param {number|!Long} value Value to write
		         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		         * @returns {!ByteBuffer} this
		         * @expose
		         */
		        ByteBufferPrototype.writeUint64 = function(value, offset) {
		            var relative = typeof offset === 'undefined';
		            if (relative) offset = this.offset;
		            if (!this.noAssert) {
		                if (typeof value === 'number')
		                    value = Long.fromNumber(value);
		                else if (typeof value === 'string')
		                    value = Long.fromString(value);
		                else if (!(value && value instanceof Long))
		                    throw TypeError("Illegal value: "+value+" (not an integer or Long)");
		                if (typeof offset !== 'number' || offset % 1 !== 0)
		                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
		                offset >>>= 0;
		                if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		            }
		            if (typeof value === 'number')
		                value = Long.fromNumber(value);
		            else if (typeof value === 'string')
		                value = Long.fromString(value);
		            offset += 8;
		            var capacity7 = this.buffer.byteLength;
		            if (offset > capacity7)
		                this.resize((capacity7 *= 2) > offset ? capacity7 : offset);
		            offset -= 8;
		            var lo = value.low,
		                hi = value.high;
		            if (this.littleEndian) {
		                this.view[offset+3] = (lo >>> 24) & 0xFF;
		                this.view[offset+2] = (lo >>> 16) & 0xFF;
		                this.view[offset+1] = (lo >>>  8) & 0xFF;
		                this.view[offset  ] =  lo         & 0xFF;
		                offset += 4;
		                this.view[offset+3] = (hi >>> 24) & 0xFF;
		                this.view[offset+2] = (hi >>> 16) & 0xFF;
		                this.view[offset+1] = (hi >>>  8) & 0xFF;
		                this.view[offset  ] =  hi         & 0xFF;
		            } else {
		                this.view[offset  ] = (hi >>> 24) & 0xFF;
		                this.view[offset+1] = (hi >>> 16) & 0xFF;
		                this.view[offset+2] = (hi >>>  8) & 0xFF;
		                this.view[offset+3] =  hi         & 0xFF;
		                offset += 4;
		                this.view[offset  ] = (lo >>> 24) & 0xFF;
		                this.view[offset+1] = (lo >>> 16) & 0xFF;
		                this.view[offset+2] = (lo >>>  8) & 0xFF;
		                this.view[offset+3] =  lo         & 0xFF;
		            }
		            if (relative) this.offset += 8;
		            return this;
		        };
	
		        /**
		         * Writes a 64bit unsigned integer. This is an alias of {@link ByteBuffer#writeUint64}.
		         * @function
		         * @param {number|!Long} value Value to write
		         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		         * @returns {!ByteBuffer} this
		         * @expose
		         */
		        ByteBufferPrototype.writeUInt64 = ByteBufferPrototype.writeUint64;
	
		        /**
		         * Reads a 64bit unsigned integer.
		         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		         * @returns {!Long}
		         * @expose
		         */
		        ByteBufferPrototype.readUint64 = function(offset) {
		            var relative = typeof offset === 'undefined';
		            if (relative) offset = this.offset;
		            if (!this.noAssert) {
		                if (typeof offset !== 'number' || offset % 1 !== 0)
		                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
		                offset >>>= 0;
		                if (offset < 0 || offset + 8 > this.buffer.byteLength)
		                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+8+") <= "+this.buffer.byteLength);
		            }
		            var lo = 0,
		                hi = 0;
		            if (this.littleEndian) {
		                lo  = this.view[offset+2] << 16;
		                lo |= this.view[offset+1] <<  8;
		                lo |= this.view[offset  ];
		                lo += this.view[offset+3] << 24 >>> 0;
		                offset += 4;
		                hi  = this.view[offset+2] << 16;
		                hi |= this.view[offset+1] <<  8;
		                hi |= this.view[offset  ];
		                hi += this.view[offset+3] << 24 >>> 0;
		            } else {
		                hi  = this.view[offset+1] << 16;
		                hi |= this.view[offset+2] <<  8;
		                hi |= this.view[offset+3];
		                hi += this.view[offset  ] << 24 >>> 0;
		                offset += 4;
		                lo  = this.view[offset+1] << 16;
		                lo |= this.view[offset+2] <<  8;
		                lo |= this.view[offset+3];
		                lo += this.view[offset  ] << 24 >>> 0;
		            }
		            var value = new Long(lo, hi, true);
		            if (relative) this.offset += 8;
		            return value;
		        };
	
		        /**
		         * Reads a 64bit unsigned integer. This is an alias of {@link ByteBuffer#readUint64}.
		         * @function
		         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		         * @returns {!Long}
		         * @expose
		         */
		        ByteBufferPrototype.readUInt64 = ByteBufferPrototype.readUint64;
	
		    } // Long
	
	
		    // types/floats/float32
	
		    /*
		     ieee754 - https://github.com/feross/ieee754
	
		     The MIT License (MIT)
	
		     Copyright (c) Feross Aboukhadijeh
	
		     Permission is hereby granted, free of charge, to any person obtaining a copy
		     of this software and associated documentation files (the "Software"), to deal
		     in the Software without restriction, including without limitation the rights
		     to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
		     copies of the Software, and to permit persons to whom the Software is
		     furnished to do so, subject to the following conditions:
	
		     The above copyright notice and this permission notice shall be included in
		     all copies or substantial portions of the Software.
	
		     THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
		     IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
		     FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
		     AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
		     LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
		     OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
		     THE SOFTWARE.
		    */
	
		    /**
		     * Reads an IEEE754 float from a byte array.
		     * @param {!Array} buffer
		     * @param {number} offset
		     * @param {boolean} isLE
		     * @param {number} mLen
		     * @param {number} nBytes
		     * @returns {number}
		     * @inner
		     */
		    function ieee754_read(buffer, offset, isLE, mLen, nBytes) {
		        var e, m,
		            eLen = nBytes * 8 - mLen - 1,
		            eMax = (1 << eLen) - 1,
		            eBias = eMax >> 1,
		            nBits = -7,
		            i = isLE ? (nBytes - 1) : 0,
		            d = isLE ? -1 : 1,
		            s = buffer[offset + i];
	
		        i += d;
	
		        e = s & ((1 << (-nBits)) - 1);
		        s >>= (-nBits);
		        nBits += eLen;
		        for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
		        m = e & ((1 << (-nBits)) - 1);
		        e >>= (-nBits);
		        nBits += mLen;
		        for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
		        if (e === 0) {
		            e = 1 - eBias;
		        } else if (e === eMax) {
		            return m ? NaN : ((s ? -1 : 1) * Infinity);
		        } else {
		            m = m + Math.pow(2, mLen);
		            e = e - eBias;
		        }
		        return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
		    }
	
		    /**
		     * Writes an IEEE754 float to a byte array.
		     * @param {!Array} buffer
		     * @param {number} value
		     * @param {number} offset
		     * @param {boolean} isLE
		     * @param {number} mLen
		     * @param {number} nBytes
		     * @inner
		     */
		    function ieee754_write(buffer, value, offset, isLE, mLen, nBytes) {
		        var e, m, c,
		            eLen = nBytes * 8 - mLen - 1,
		            eMax = (1 << eLen) - 1,
		            eBias = eMax >> 1,
		            rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0),
		            i = isLE ? 0 : (nBytes - 1),
		            d = isLE ? 1 : -1,
		            s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0;
	
		        value = Math.abs(value);
	
		        if (isNaN(value) || value === Infinity) {
		            m = isNaN(value) ? 1 : 0;
		            e = eMax;
		        } else {
		            e = Math.floor(Math.log(value) / Math.LN2);
		            if (value * (c = Math.pow(2, -e)) < 1) {
		                e--;
		                c *= 2;
		            }
		            if (e + eBias >= 1) {
		                value += rt / c;
		            } else {
		                value += rt * Math.pow(2, 1 - eBias);
		            }
		            if (value * c >= 2) {
		                e++;
		                c /= 2;
		            }
	
		            if (e + eBias >= eMax) {
		                m = 0;
		                e = eMax;
		            } else if (e + eBias >= 1) {
		                m = (value * c - 1) * Math.pow(2, mLen);
		                e = e + eBias;
		            } else {
		                m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
		                e = 0;
		            }
		        }
	
		        for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
		        e = (e << mLen) | m;
		        eLen += mLen;
		        for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
		        buffer[offset + i - d] |= s * 128;
		    }
	
		    /**
		     * Writes a 32bit float.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.writeFloat32 = function(value, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof value !== 'number')
		                throw TypeError("Illegal value: "+value+" (not a number)");
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        offset += 4;
		        var capacity8 = this.buffer.byteLength;
		        if (offset > capacity8)
		            this.resize((capacity8 *= 2) > offset ? capacity8 : offset);
		        offset -= 4;
		        ieee754_write(this.view, value, offset, this.littleEndian, 23, 4);
		        if (relative) this.offset += 4;
		        return this;
		    };
	
		    /**
		     * Writes a 32bit float. This is an alias of {@link ByteBuffer#writeFloat32}.
		     * @function
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.writeFloat = ByteBufferPrototype.writeFloat32;
	
		    /**
		     * Reads a 32bit float.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @returns {number}
		     * @expose
		     */
		    ByteBufferPrototype.readFloat32 = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 4 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
		        }
		        var value = ieee754_read(this.view, offset, this.littleEndian, 23, 4);
		        if (relative) this.offset += 4;
		        return value;
		    };
	
		    /**
		     * Reads a 32bit float. This is an alias of {@link ByteBuffer#readFloat32}.
		     * @function
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `4` if omitted.
		     * @returns {number}
		     * @expose
		     */
		    ByteBufferPrototype.readFloat = ByteBufferPrototype.readFloat32;
	
		    // types/floats/float64
	
		    /**
		     * Writes a 64bit float.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.writeFloat64 = function(value, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof value !== 'number')
		                throw TypeError("Illegal value: "+value+" (not a number)");
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        offset += 8;
		        var capacity9 = this.buffer.byteLength;
		        if (offset > capacity9)
		            this.resize((capacity9 *= 2) > offset ? capacity9 : offset);
		        offset -= 8;
		        ieee754_write(this.view, value, offset, this.littleEndian, 52, 8);
		        if (relative) this.offset += 8;
		        return this;
		    };
	
		    /**
		     * Writes a 64bit float. This is an alias of {@link ByteBuffer#writeFloat64}.
		     * @function
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.writeDouble = ByteBufferPrototype.writeFloat64;
	
		    /**
		     * Reads a 64bit float.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		     * @returns {number}
		     * @expose
		     */
		    ByteBufferPrototype.readFloat64 = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 8 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+8+") <= "+this.buffer.byteLength);
		        }
		        var value = ieee754_read(this.view, offset, this.littleEndian, 52, 8);
		        if (relative) this.offset += 8;
		        return value;
		    };
	
		    /**
		     * Reads a 64bit float. This is an alias of {@link ByteBuffer#readFloat64}.
		     * @function
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by `8` if omitted.
		     * @returns {number}
		     * @expose
		     */
		    ByteBufferPrototype.readDouble = ByteBufferPrototype.readFloat64;
	
	
		    // types/varints/varint32
	
		    /**
		     * Maximum number of bytes required to store a 32bit base 128 variable-length integer.
		     * @type {number}
		     * @const
		     * @expose
		     */
		    ByteBuffer.MAX_VARINT32_BYTES = 5;
	
		    /**
		     * Calculates the actual number of bytes required to store a 32bit base 128 variable-length integer.
		     * @param {number} value Value to encode
		     * @returns {number} Number of bytes required. Capped to {@link ByteBuffer.MAX_VARINT32_BYTES}
		     * @expose
		     */
		    ByteBuffer.calculateVarint32 = function(value) {
		        // ref: src/google/protobuf/io/coded_stream.cc
		        value = value >>> 0;
		             if (value < 1 << 7 ) return 1;
		        else if (value < 1 << 14) return 2;
		        else if (value < 1 << 21) return 3;
		        else if (value < 1 << 28) return 4;
		        else                      return 5;
		    };
	
		    /**
		     * Zigzag encodes a signed 32bit integer so that it can be effectively used with varint encoding.
		     * @param {number} n Signed 32bit integer
		     * @returns {number} Unsigned zigzag encoded 32bit integer
		     * @expose
		     */
		    ByteBuffer.zigZagEncode32 = function(n) {
		        return (((n |= 0) << 1) ^ (n >> 31)) >>> 0; // ref: src/google/protobuf/wire_format_lite.h
		    };
	
		    /**
		     * Decodes a zigzag encoded signed 32bit integer.
		     * @param {number} n Unsigned zigzag encoded 32bit integer
		     * @returns {number} Signed 32bit integer
		     * @expose
		     */
		    ByteBuffer.zigZagDecode32 = function(n) {
		        return ((n >>> 1) ^ -(n & 1)) | 0; // // ref: src/google/protobuf/wire_format_lite.h
		    };
	
		    /**
		     * Writes a 32bit base 128 variable-length integer.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  written if omitted.
		     * @returns {!ByteBuffer|number} this if `offset` is omitted, else the actual number of bytes written
		     * @expose
		     */
		    ByteBufferPrototype.writeVarint32 = function(value, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof value !== 'number' || value % 1 !== 0)
		                throw TypeError("Illegal value: "+value+" (not an integer)");
		            value |= 0;
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        var size = ByteBuffer.calculateVarint32(value),
		            b;
		        offset += size;
		        var capacity10 = this.buffer.byteLength;
		        if (offset > capacity10)
		            this.resize((capacity10 *= 2) > offset ? capacity10 : offset);
		        offset -= size;
		        value >>>= 0;
		        while (value >= 0x80) {
		            b = (value & 0x7f) | 0x80;
		            this.view[offset++] = b;
		            value >>>= 7;
		        }
		        this.view[offset++] = value;
		        if (relative) {
		            this.offset = offset;
		            return this;
		        }
		        return size;
		    };
	
		    /**
		     * Writes a zig-zag encoded (signed) 32bit base 128 variable-length integer.
		     * @param {number} value Value to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  written if omitted.
		     * @returns {!ByteBuffer|number} this if `offset` is omitted, else the actual number of bytes written
		     * @expose
		     */
		    ByteBufferPrototype.writeVarint32ZigZag = function(value, offset) {
		        return this.writeVarint32(ByteBuffer.zigZagEncode32(value), offset);
		    };
	
		    /**
		     * Reads a 32bit base 128 variable-length integer.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  written if omitted.
		     * @returns {number|!{value: number, length: number}} The value read if offset is omitted, else the value read
		     *  and the actual number of bytes read.
		     * @throws {Error} If it's not a valid varint. Has a property `truncated = true` if there is not enough data available
		     *  to fully decode the varint.
		     * @expose
		     */
		    ByteBufferPrototype.readVarint32 = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 1 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
		        }
		        var c = 0,
		            value = 0 >>> 0,
		            b;
		        do {
		            if (!this.noAssert && offset > this.limit) {
		                var err = Error("Truncated");
		                err['truncated'] = true;
		                throw err;
		            }
		            b = this.view[offset++];
		            if (c < 5)
		                value |= (b & 0x7f) << (7*c);
		            ++c;
		        } while ((b & 0x80) !== 0);
		        value |= 0;
		        if (relative) {
		            this.offset = offset;
		            return value;
		        }
		        return {
		            "value": value,
		            "length": c
		        };
		    };
	
		    /**
		     * Reads a zig-zag encoded (signed) 32bit base 128 variable-length integer.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  written if omitted.
		     * @returns {number|!{value: number, length: number}} The value read if offset is omitted, else the value read
		     *  and the actual number of bytes read.
		     * @throws {Error} If it's not a valid varint
		     * @expose
		     */
		    ByteBufferPrototype.readVarint32ZigZag = function(offset) {
		        var val = this.readVarint32(offset);
		        if (typeof val === 'object')
		            val["value"] = ByteBuffer.zigZagDecode32(val["value"]);
		        else
		            val = ByteBuffer.zigZagDecode32(val);
		        return val;
		    };
	
		    // types/varints/varint64
	
		    if (Long) {
	
		        /**
		         * Maximum number of bytes required to store a 64bit base 128 variable-length integer.
		         * @type {number}
		         * @const
		         * @expose
		         */
		        ByteBuffer.MAX_VARINT64_BYTES = 10;
	
		        /**
		         * Calculates the actual number of bytes required to store a 64bit base 128 variable-length integer.
		         * @param {number|!Long} value Value to encode
		         * @returns {number} Number of bytes required. Capped to {@link ByteBuffer.MAX_VARINT64_BYTES}
		         * @expose
		         */
		        ByteBuffer.calculateVarint64 = function(value) {
		            if (typeof value === 'number')
		                value = Long.fromNumber(value);
		            else if (typeof value === 'string')
		                value = Long.fromString(value);
		            // ref: src/google/protobuf/io/coded_stream.cc
		            var part0 = value.toInt() >>> 0,
		                part1 = value.shiftRightUnsigned(28).toInt() >>> 0,
		                part2 = value.shiftRightUnsigned(56).toInt() >>> 0;
		            if (part2 == 0) {
		                if (part1 == 0) {
		                    if (part0 < 1 << 14)
		                        return part0 < 1 << 7 ? 1 : 2;
		                    else
		                        return part0 < 1 << 21 ? 3 : 4;
		                } else {
		                    if (part1 < 1 << 14)
		                        return part1 < 1 << 7 ? 5 : 6;
		                    else
		                        return part1 < 1 << 21 ? 7 : 8;
		                }
		            } else
		                return part2 < 1 << 7 ? 9 : 10;
		        };
	
		        /**
		         * Zigzag encodes a signed 64bit integer so that it can be effectively used with varint encoding.
		         * @param {number|!Long} value Signed long
		         * @returns {!Long} Unsigned zigzag encoded long
		         * @expose
		         */
		        ByteBuffer.zigZagEncode64 = function(value) {
		            if (typeof value === 'number')
		                value = Long.fromNumber(value, false);
		            else if (typeof value === 'string')
		                value = Long.fromString(value, false);
		            else if (value.unsigned !== false) value = value.toSigned();
		            // ref: src/google/protobuf/wire_format_lite.h
		            return value.shiftLeft(1).xor(value.shiftRight(63)).toUnsigned();
		        };
	
		        /**
		         * Decodes a zigzag encoded signed 64bit integer.
		         * @param {!Long|number} value Unsigned zigzag encoded long or JavaScript number
		         * @returns {!Long} Signed long
		         * @expose
		         */
		        ByteBuffer.zigZagDecode64 = function(value) {
		            if (typeof value === 'number')
		                value = Long.fromNumber(value, false);
		            else if (typeof value === 'string')
		                value = Long.fromString(value, false);
		            else if (value.unsigned !== false) value = value.toSigned();
		            // ref: src/google/protobuf/wire_format_lite.h
		            return value.shiftRightUnsigned(1).xor(value.and(Long.ONE).toSigned().negate()).toSigned();
		        };
	
		        /**
		         * Writes a 64bit base 128 variable-length integer.
		         * @param {number|Long} value Value to write
		         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		         *  written if omitted.
		         * @returns {!ByteBuffer|number} `this` if offset is omitted, else the actual number of bytes written.
		         * @expose
		         */
		        ByteBufferPrototype.writeVarint64 = function(value, offset) {
		            var relative = typeof offset === 'undefined';
		            if (relative) offset = this.offset;
		            if (!this.noAssert) {
		                if (typeof value === 'number')
		                    value = Long.fromNumber(value);
		                else if (typeof value === 'string')
		                    value = Long.fromString(value);
		                else if (!(value && value instanceof Long))
		                    throw TypeError("Illegal value: "+value+" (not an integer or Long)");
		                if (typeof offset !== 'number' || offset % 1 !== 0)
		                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
		                offset >>>= 0;
		                if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		            }
		            if (typeof value === 'number')
		                value = Long.fromNumber(value, false);
		            else if (typeof value === 'string')
		                value = Long.fromString(value, false);
		            else if (value.unsigned !== false) value = value.toSigned();
		            var size = ByteBuffer.calculateVarint64(value),
		                part0 = value.toInt() >>> 0,
		                part1 = value.shiftRightUnsigned(28).toInt() >>> 0,
		                part2 = value.shiftRightUnsigned(56).toInt() >>> 0;
		            offset += size;
		            var capacity11 = this.buffer.byteLength;
		            if (offset > capacity11)
		                this.resize((capacity11 *= 2) > offset ? capacity11 : offset);
		            offset -= size;
		            switch (size) {
		                case 10: this.view[offset+9] = (part2 >>>  7) & 0x01;
		                case 9 : this.view[offset+8] = size !== 9 ? (part2       ) | 0x80 : (part2       ) & 0x7F;
		                case 8 : this.view[offset+7] = size !== 8 ? (part1 >>> 21) | 0x80 : (part1 >>> 21) & 0x7F;
		                case 7 : this.view[offset+6] = size !== 7 ? (part1 >>> 14) | 0x80 : (part1 >>> 14) & 0x7F;
		                case 6 : this.view[offset+5] = size !== 6 ? (part1 >>>  7) | 0x80 : (part1 >>>  7) & 0x7F;
		                case 5 : this.view[offset+4] = size !== 5 ? (part1       ) | 0x80 : (part1       ) & 0x7F;
		                case 4 : this.view[offset+3] = size !== 4 ? (part0 >>> 21) | 0x80 : (part0 >>> 21) & 0x7F;
		                case 3 : this.view[offset+2] = size !== 3 ? (part0 >>> 14) | 0x80 : (part0 >>> 14) & 0x7F;
		                case 2 : this.view[offset+1] = size !== 2 ? (part0 >>>  7) | 0x80 : (part0 >>>  7) & 0x7F;
		                case 1 : this.view[offset  ] = size !== 1 ? (part0       ) | 0x80 : (part0       ) & 0x7F;
		            }
		            if (relative) {
		                this.offset += size;
		                return this;
		            } else {
		                return size;
		            }
		        };
	
		        /**
		         * Writes a zig-zag encoded 64bit base 128 variable-length integer.
		         * @param {number|Long} value Value to write
		         * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		         *  written if omitted.
		         * @returns {!ByteBuffer|number} `this` if offset is omitted, else the actual number of bytes written.
		         * @expose
		         */
		        ByteBufferPrototype.writeVarint64ZigZag = function(value, offset) {
		            return this.writeVarint64(ByteBuffer.zigZagEncode64(value), offset);
		        };
	
		        /**
		         * Reads a 64bit base 128 variable-length integer. Requires Long.js.
		         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		         *  read if omitted.
		         * @returns {!Long|!{value: Long, length: number}} The value read if offset is omitted, else the value read and
		         *  the actual number of bytes read.
		         * @throws {Error} If it's not a valid varint
		         * @expose
		         */
		        ByteBufferPrototype.readVarint64 = function(offset) {
		            var relative = typeof offset === 'undefined';
		            if (relative) offset = this.offset;
		            if (!this.noAssert) {
		                if (typeof offset !== 'number' || offset % 1 !== 0)
		                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
		                offset >>>= 0;
		                if (offset < 0 || offset + 1 > this.buffer.byteLength)
		                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
		            }
		            // ref: src/google/protobuf/io/coded_stream.cc
		            var start = offset,
		                part0 = 0,
		                part1 = 0,
		                part2 = 0,
		                b  = 0;
		            b = this.view[offset++]; part0  = (b & 0x7F)      ; if ( b & 0x80                                                   ) {
		            b = this.view[offset++]; part0 |= (b & 0x7F) <<  7; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
		            b = this.view[offset++]; part0 |= (b & 0x7F) << 14; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
		            b = this.view[offset++]; part0 |= (b & 0x7F) << 21; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
		            b = this.view[offset++]; part1  = (b & 0x7F)      ; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
		            b = this.view[offset++]; part1 |= (b & 0x7F) <<  7; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
		            b = this.view[offset++]; part1 |= (b & 0x7F) << 14; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
		            b = this.view[offset++]; part1 |= (b & 0x7F) << 21; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
		            b = this.view[offset++]; part2  = (b & 0x7F)      ; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
		            b = this.view[offset++]; part2 |= (b & 0x7F) <<  7; if ((b & 0x80) || (this.noAssert && typeof b === 'undefined')) {
		            throw Error("Buffer overrun"); }}}}}}}}}}
		            var value = Long.fromBits(part0 | (part1 << 28), (part1 >>> 4) | (part2) << 24, false);
		            if (relative) {
		                this.offset = offset;
		                return value;
		            } else {
		                return {
		                    'value': value,
		                    'length': offset-start
		                };
		            }
		        };
	
		        /**
		         * Reads a zig-zag encoded 64bit base 128 variable-length integer. Requires Long.js.
		         * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		         *  read if omitted.
		         * @returns {!Long|!{value: Long, length: number}} The value read if offset is omitted, else the value read and
		         *  the actual number of bytes read.
		         * @throws {Error} If it's not a valid varint
		         * @expose
		         */
		        ByteBufferPrototype.readVarint64ZigZag = function(offset) {
		            var val = this.readVarint64(offset);
		            if (val && val['value'] instanceof Long)
		                val["value"] = ByteBuffer.zigZagDecode64(val["value"]);
		            else
		                val = ByteBuffer.zigZagDecode64(val);
		            return val;
		        };
	
		    } // Long
	
	
		    // types/strings/cstring
	
		    /**
		     * Writes a NULL-terminated UTF8 encoded string. For this to work the specified string must not contain any NULL
		     *  characters itself.
		     * @param {string} str String to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  contained in `str` + 1 if omitted.
		     * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written
		     * @expose
		     */
		    ByteBufferPrototype.writeCString = function(str, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        var i,
		            k = str.length;
		        if (!this.noAssert) {
		            if (typeof str !== 'string')
		                throw TypeError("Illegal str: Not a string");
		            for (i=0; i<k; ++i) {
		                if (str.charCodeAt(i) === 0)
		                    throw RangeError("Illegal str: Contains NULL-characters");
		            }
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        // UTF8 strings do not contain zero bytes in between except for the zero character, so:
		        k = utfx.calculateUTF16asUTF8(stringSource(str))[1];
		        offset += k+1;
		        var capacity12 = this.buffer.byteLength;
		        if (offset > capacity12)
		            this.resize((capacity12 *= 2) > offset ? capacity12 : offset);
		        offset -= k+1;
		        utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
		            this.view[offset++] = b;
		        }.bind(this));
		        this.view[offset++] = 0;
		        if (relative) {
		            this.offset = offset;
		            return this;
		        }
		        return k;
		    };
	
		    /**
		     * Reads a NULL-terminated UTF8 encoded string. For this to work the string read must not contain any NULL characters
		     *  itself.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  read if omitted.
		     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
		     *  read and the actual number of bytes read.
		     * @expose
		     */
		    ByteBufferPrototype.readCString = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 1 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
		        }
		        var start = offset,
		            temp;
		        // UTF8 strings do not contain zero bytes in between except for the zero character itself, so:
		        var sd, b = -1;
		        utfx.decodeUTF8toUTF16(function() {
		            if (b === 0) return null;
		            if (offset >= this.limit)
		                throw RangeError("Illegal range: Truncated data, "+offset+" < "+this.limit);
		            b = this.view[offset++];
		            return b === 0 ? null : b;
		        }.bind(this), sd = stringDestination(), true);
		        if (relative) {
		            this.offset = offset;
		            return sd();
		        } else {
		            return {
		                "string": sd(),
		                "length": offset - start
		            };
		        }
		    };
	
		    // types/strings/istring
	
		    /**
		     * Writes a length as uint32 prefixed UTF8 encoded string.
		     * @param {string} str String to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  written if omitted.
		     * @returns {!ByteBuffer|number} `this` if `offset` is omitted, else the actual number of bytes written
		     * @expose
		     * @see ByteBuffer#writeVarint32
		     */
		    ByteBufferPrototype.writeIString = function(str, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof str !== 'string')
		                throw TypeError("Illegal str: Not a string");
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        var start = offset,
		            k;
		        k = utfx.calculateUTF16asUTF8(stringSource(str), this.noAssert)[1];
		        offset += 4+k;
		        var capacity13 = this.buffer.byteLength;
		        if (offset > capacity13)
		            this.resize((capacity13 *= 2) > offset ? capacity13 : offset);
		        offset -= 4+k;
		        if (this.littleEndian) {
		            this.view[offset+3] = (k >>> 24) & 0xFF;
		            this.view[offset+2] = (k >>> 16) & 0xFF;
		            this.view[offset+1] = (k >>>  8) & 0xFF;
		            this.view[offset  ] =  k         & 0xFF;
		        } else {
		            this.view[offset  ] = (k >>> 24) & 0xFF;
		            this.view[offset+1] = (k >>> 16) & 0xFF;
		            this.view[offset+2] = (k >>>  8) & 0xFF;
		            this.view[offset+3] =  k         & 0xFF;
		        }
		        offset += 4;
		        utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
		            this.view[offset++] = b;
		        }.bind(this));
		        if (offset !== start + 4 + k)
		            throw RangeError("Illegal range: Truncated data, "+offset+" == "+(offset+4+k));
		        if (relative) {
		            this.offset = offset;
		            return this;
		        }
		        return offset - start;
		    };
	
		    /**
		     * Reads a length as uint32 prefixed UTF8 encoded string.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  read if omitted.
		     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
		     *  read and the actual number of bytes read.
		     * @expose
		     * @see ByteBuffer#readVarint32
		     */
		    ByteBufferPrototype.readIString = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 4 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+4+") <= "+this.buffer.byteLength);
		        }
		        var start = offset;
		        var len = this.readUint32(offset);
		        var str = this.readUTF8String(len, ByteBuffer.METRICS_BYTES, offset += 4);
		        offset += str['length'];
		        if (relative) {
		            this.offset = offset;
		            return str['string'];
		        } else {
		            return {
		                'string': str['string'],
		                'length': offset - start
		            };
		        }
		    };
	
		    // types/strings/utf8string
	
		    /**
		     * Metrics representing number of UTF8 characters. Evaluates to `c`.
		     * @type {string}
		     * @const
		     * @expose
		     */
		    ByteBuffer.METRICS_CHARS = 'c';
	
		    /**
		     * Metrics representing number of bytes. Evaluates to `b`.
		     * @type {string}
		     * @const
		     * @expose
		     */
		    ByteBuffer.METRICS_BYTES = 'b';
	
		    /**
		     * Writes an UTF8 encoded string.
		     * @param {string} str String to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} if omitted.
		     * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written.
		     * @expose
		     */
		    ByteBufferPrototype.writeUTF8String = function(str, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        var k;
		        var start = offset;
		        k = utfx.calculateUTF16asUTF8(stringSource(str))[1];
		        offset += k;
		        var capacity14 = this.buffer.byteLength;
		        if (offset > capacity14)
		            this.resize((capacity14 *= 2) > offset ? capacity14 : offset);
		        offset -= k;
		        utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
		            this.view[offset++] = b;
		        }.bind(this));
		        if (relative) {
		            this.offset = offset;
		            return this;
		        }
		        return offset - start;
		    };
	
		    /**
		     * Writes an UTF8 encoded string. This is an alias of {@link ByteBuffer#writeUTF8String}.
		     * @function
		     * @param {string} str String to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} if omitted.
		     * @returns {!ByteBuffer|number} this if offset is omitted, else the actual number of bytes written.
		     * @expose
		     */
		    ByteBufferPrototype.writeString = ByteBufferPrototype.writeUTF8String;
	
		    /**
		     * Calculates the number of UTF8 characters of a string. JavaScript itself uses UTF-16, so that a string's
		     *  `length` property does not reflect its actual UTF8 size if it contains code points larger than 0xFFFF.
		     * @param {string} str String to calculate
		     * @returns {number} Number of UTF8 characters
		     * @expose
		     */
		    ByteBuffer.calculateUTF8Chars = function(str) {
		        return utfx.calculateUTF16asUTF8(stringSource(str))[0];
		    };
	
		    /**
		     * Calculates the number of UTF8 bytes of a string.
		     * @param {string} str String to calculate
		     * @returns {number} Number of UTF8 bytes
		     * @expose
		     */
		    ByteBuffer.calculateUTF8Bytes = function(str) {
		        return utfx.calculateUTF16asUTF8(stringSource(str))[1];
		    };
	
		    /**
		     * Calculates the number of UTF8 bytes of a string. This is an alias of {@link ByteBuffer.calculateUTF8Bytes}.
		     * @function
		     * @param {string} str String to calculate
		     * @returns {number} Number of UTF8 bytes
		     * @expose
		     */
		    ByteBuffer.calculateString = ByteBuffer.calculateUTF8Bytes;
	
		    /**
		     * Reads an UTF8 encoded string.
		     * @param {number} length Number of characters or bytes to read.
		     * @param {string=} metrics Metrics specifying what `length` is meant to count. Defaults to
		     *  {@link ByteBuffer.METRICS_CHARS}.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  read if omitted.
		     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
		     *  read and the actual number of bytes read.
		     * @expose
		     */
		    ByteBufferPrototype.readUTF8String = function(length, metrics, offset) {
		        if (typeof metrics === 'number') {
		            offset = metrics;
		            metrics = undefined;
		        }
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (typeof metrics === 'undefined') metrics = ByteBuffer.METRICS_CHARS;
		        if (!this.noAssert) {
		            if (typeof length !== 'number' || length % 1 !== 0)
		                throw TypeError("Illegal length: "+length+" (not an integer)");
		            length |= 0;
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        var i = 0,
		            start = offset,
		            sd;
		        if (metrics === ByteBuffer.METRICS_CHARS) { // The same for node and the browser
		            sd = stringDestination();
		            utfx.decodeUTF8(function() {
		                return i < length && offset < this.limit ? this.view[offset++] : null;
		            }.bind(this), function(cp) {
		                ++i; utfx.UTF8toUTF16(cp, sd);
		            });
		            if (i !== length)
		                throw RangeError("Illegal range: Truncated data, "+i+" == "+length);
		            if (relative) {
		                this.offset = offset;
		                return sd();
		            } else {
		                return {
		                    "string": sd(),
		                    "length": offset - start
		                };
		            }
		        } else if (metrics === ByteBuffer.METRICS_BYTES) {
		            if (!this.noAssert) {
		                if (typeof offset !== 'number' || offset % 1 !== 0)
		                    throw TypeError("Illegal offset: "+offset+" (not an integer)");
		                offset >>>= 0;
		                if (offset < 0 || offset + length > this.buffer.byteLength)
		                    throw RangeError("Illegal offset: 0 <= "+offset+" (+"+length+") <= "+this.buffer.byteLength);
		            }
		            var k = offset + length;
		            utfx.decodeUTF8toUTF16(function() {
		                return offset < k ? this.view[offset++] : null;
		            }.bind(this), sd = stringDestination(), this.noAssert);
		            if (offset !== k)
		                throw RangeError("Illegal range: Truncated data, "+offset+" == "+k);
		            if (relative) {
		                this.offset = offset;
		                return sd();
		            } else {
		                return {
		                    'string': sd(),
		                    'length': offset - start
		                };
		            }
		        } else
		            throw TypeError("Unsupported metrics: "+metrics);
		    };
	
		    /**
		     * Reads an UTF8 encoded string. This is an alias of {@link ByteBuffer#readUTF8String}.
		     * @function
		     * @param {number} length Number of characters or bytes to read
		     * @param {number=} metrics Metrics specifying what `n` is meant to count. Defaults to
		     *  {@link ByteBuffer.METRICS_CHARS}.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  read if omitted.
		     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
		     *  read and the actual number of bytes read.
		     * @expose
		     */
		    ByteBufferPrototype.readString = ByteBufferPrototype.readUTF8String;
	
		    // types/strings/vstring
	
		    /**
		     * Writes a length as varint32 prefixed UTF8 encoded string.
		     * @param {string} str String to write
		     * @param {number=} offset Offset to write to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  written if omitted.
		     * @returns {!ByteBuffer|number} `this` if `offset` is omitted, else the actual number of bytes written
		     * @expose
		     * @see ByteBuffer#writeVarint32
		     */
		    ByteBufferPrototype.writeVString = function(str, offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof str !== 'string')
		                throw TypeError("Illegal str: Not a string");
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        var start = offset,
		            k, l;
		        k = utfx.calculateUTF16asUTF8(stringSource(str), this.noAssert)[1];
		        l = ByteBuffer.calculateVarint32(k);
		        offset += l+k;
		        var capacity15 = this.buffer.byteLength;
		        if (offset > capacity15)
		            this.resize((capacity15 *= 2) > offset ? capacity15 : offset);
		        offset -= l+k;
		        offset += this.writeVarint32(k, offset);
		        utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
		            this.view[offset++] = b;
		        }.bind(this));
		        if (offset !== start+k+l)
		            throw RangeError("Illegal range: Truncated data, "+offset+" == "+(offset+k+l));
		        if (relative) {
		            this.offset = offset;
		            return this;
		        }
		        return offset - start;
		    };
	
		    /**
		     * Reads a length as varint32 prefixed UTF8 encoded string.
		     * @param {number=} offset Offset to read from. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  read if omitted.
		     * @returns {string|!{string: string, length: number}} The string read if offset is omitted, else the string
		     *  read and the actual number of bytes read.
		     * @expose
		     * @see ByteBuffer#readVarint32
		     */
		    ByteBufferPrototype.readVString = function(offset) {
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 1 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+1+") <= "+this.buffer.byteLength);
		        }
		        var start = offset;
		        var len = this.readVarint32(offset);
		        var str = this.readUTF8String(len['value'], ByteBuffer.METRICS_BYTES, offset += len['length']);
		        offset += str['length'];
		        if (relative) {
		            this.offset = offset;
		            return str['string'];
		        } else {
		            return {
		                'string': str['string'],
		                'length': offset - start
		            };
		        }
		    };
	
	
		    /**
		     * Appends some data to this ByteBuffer. This will overwrite any contents behind the specified offset up to the appended
		     *  data's length.
		     * @param {!ByteBuffer|!ArrayBuffer|!Uint8Array|string} source Data to append. If `source` is a ByteBuffer, its offsets
		     *  will be modified according to the performed read operation.
		     * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
		     * @param {number=} offset Offset to append at. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  written if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     * @example A relative `<01 02>03.append(<04 05>)` will result in `<01 02 04 05>, 04 05|`
		     * @example An absolute `<01 02>03.append(04 05>, 1)` will result in `<01 04>05, 04 05|`
		     */
		    ByteBufferPrototype.append = function(source, encoding, offset) {
		        if (typeof encoding === 'number' || typeof encoding !== 'string') {
		            offset = encoding;
		            encoding = undefined;
		        }
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        if (!(source instanceof ByteBuffer))
		            source = ByteBuffer.wrap(source, encoding);
		        var length = source.limit - source.offset;
		        if (length <= 0) return this; // Nothing to append
		        offset += length;
		        var capacity16 = this.buffer.byteLength;
		        if (offset > capacity16)
		            this.resize((capacity16 *= 2) > offset ? capacity16 : offset);
		        offset -= length;
		        this.view.set(source.view.subarray(source.offset, source.limit), offset);
		        source.offset += length;
		        if (relative) this.offset += length;
		        return this;
		    };
	
		    /**
		     * Appends this ByteBuffer's contents to another ByteBuffer. This will overwrite any contents at and after the
		        specified offset up to the length of this ByteBuffer's data.
		     * @param {!ByteBuffer} target Target ByteBuffer
		     * @param {number=} offset Offset to append to. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  read if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     * @see ByteBuffer#append
		     */
		    ByteBufferPrototype.appendTo = function(target, offset) {
		        target.append(this, offset);
		        return this;
		    };
	
		    /**
		     * Enables or disables assertions of argument types and offsets. Assertions are enabled by default but you can opt to
		     *  disable them if your code already makes sure that everything is valid.
		     * @param {boolean} assert `true` to enable assertions, otherwise `false`
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.assert = function(assert) {
		        this.noAssert = !assert;
		        return this;
		    };
	
		    /**
		     * Gets the capacity of this ByteBuffer's backing buffer.
		     * @returns {number} Capacity of the backing buffer
		     * @expose
		     */
		    ByteBufferPrototype.capacity = function() {
		        return this.buffer.byteLength;
		    };
		    /**
		     * Clears this ByteBuffer's offsets by setting {@link ByteBuffer#offset} to `0` and {@link ByteBuffer#limit} to the
		     *  backing buffer's capacity. Discards {@link ByteBuffer#markedOffset}.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.clear = function() {
		        this.offset = 0;
		        this.limit = this.buffer.byteLength;
		        this.markedOffset = -1;
		        return this;
		    };
	
		    /**
		     * Creates a cloned instance of this ByteBuffer, preset with this ByteBuffer's values for {@link ByteBuffer#offset},
		     *  {@link ByteBuffer#markedOffset} and {@link ByteBuffer#limit}.
		     * @param {boolean=} copy Whether to copy the backing buffer or to return another view on the same, defaults to `false`
		     * @returns {!ByteBuffer} Cloned instance
		     * @expose
		     */
		    ByteBufferPrototype.clone = function(copy) {
		        var bb = new ByteBuffer(0, this.littleEndian, this.noAssert);
		        if (copy) {
		            bb.buffer = new ArrayBuffer(this.buffer.byteLength);
		            bb.view = new Uint8Array(bb.buffer);
		        } else {
		            bb.buffer = this.buffer;
		            bb.view = this.view;
		        }
		        bb.offset = this.offset;
		        bb.markedOffset = this.markedOffset;
		        bb.limit = this.limit;
		        return bb;
		    };
	
		    /**
		     * Compacts this ByteBuffer to be backed by a {@link ByteBuffer#buffer} of its contents' length. Contents are the bytes
		     *  between {@link ByteBuffer#offset} and {@link ByteBuffer#limit}. Will set `offset = 0` and `limit = capacity` and
		     *  adapt {@link ByteBuffer#markedOffset} to the same relative position if set.
		     * @param {number=} begin Offset to start at, defaults to {@link ByteBuffer#offset}
		     * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.compact = function(begin, end) {
		        if (typeof begin === 'undefined') begin = this.offset;
		        if (typeof end === 'undefined') end = this.limit;
		        if (!this.noAssert) {
		            if (typeof begin !== 'number' || begin % 1 !== 0)
		                throw TypeError("Illegal begin: Not an integer");
		            begin >>>= 0;
		            if (typeof end !== 'number' || end % 1 !== 0)
		                throw TypeError("Illegal end: Not an integer");
		            end >>>= 0;
		            if (begin < 0 || begin > end || end > this.buffer.byteLength)
		                throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
		        }
		        if (begin === 0 && end === this.buffer.byteLength)
		            return this; // Already compacted
		        var len = end - begin;
		        if (len === 0) {
		            this.buffer = EMPTY_BUFFER;
		            this.view = null;
		            if (this.markedOffset >= 0) this.markedOffset -= begin;
		            this.offset = 0;
		            this.limit = 0;
		            return this;
		        }
		        var buffer = new ArrayBuffer(len);
		        var view = new Uint8Array(buffer);
		        view.set(this.view.subarray(begin, end));
		        this.buffer = buffer;
		        this.view = view;
		        if (this.markedOffset >= 0) this.markedOffset -= begin;
		        this.offset = 0;
		        this.limit = len;
		        return this;
		    };
	
		    /**
		     * Creates a copy of this ByteBuffer's contents. Contents are the bytes between {@link ByteBuffer#offset} and
		     *  {@link ByteBuffer#limit}.
		     * @param {number=} begin Begin offset, defaults to {@link ByteBuffer#offset}.
		     * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
		     * @returns {!ByteBuffer} Copy
		     * @expose
		     */
		    ByteBufferPrototype.copy = function(begin, end) {
		        if (typeof begin === 'undefined') begin = this.offset;
		        if (typeof end === 'undefined') end = this.limit;
		        if (!this.noAssert) {
		            if (typeof begin !== 'number' || begin % 1 !== 0)
		                throw TypeError("Illegal begin: Not an integer");
		            begin >>>= 0;
		            if (typeof end !== 'number' || end % 1 !== 0)
		                throw TypeError("Illegal end: Not an integer");
		            end >>>= 0;
		            if (begin < 0 || begin > end || end > this.buffer.byteLength)
		                throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
		        }
		        if (begin === end)
		            return new ByteBuffer(0, this.littleEndian, this.noAssert);
		        var capacity = end - begin,
		            bb = new ByteBuffer(capacity, this.littleEndian, this.noAssert);
		        bb.offset = 0;
		        bb.limit = capacity;
		        if (bb.markedOffset >= 0) bb.markedOffset -= begin;
		        this.copyTo(bb, 0, begin, end);
		        return bb;
		    };
	
		    /**
		     * Copies this ByteBuffer's contents to another ByteBuffer. Contents are the bytes between {@link ByteBuffer#offset} and
		     *  {@link ByteBuffer#limit}.
		     * @param {!ByteBuffer} target Target ByteBuffer
		     * @param {number=} targetOffset Offset to copy to. Will use and increase the target's {@link ByteBuffer#offset}
		     *  by the number of bytes copied if omitted.
		     * @param {number=} sourceOffset Offset to start copying from. Will use and increase {@link ByteBuffer#offset} by the
		     *  number of bytes copied if omitted.
		     * @param {number=} sourceLimit Offset to end copying from, defaults to {@link ByteBuffer#limit}
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.copyTo = function(target, targetOffset, sourceOffset, sourceLimit) {
		        var relative,
		            targetRelative;
		        if (!this.noAssert) {
		            if (!ByteBuffer.isByteBuffer(target))
		                throw TypeError("Illegal target: Not a ByteBuffer");
		        }
		        targetOffset = (targetRelative = typeof targetOffset === 'undefined') ? target.offset : targetOffset | 0;
		        sourceOffset = (relative = typeof sourceOffset === 'undefined') ? this.offset : sourceOffset | 0;
		        sourceLimit = typeof sourceLimit === 'undefined' ? this.limit : sourceLimit | 0;
	
		        if (targetOffset < 0 || targetOffset > target.buffer.byteLength)
		            throw RangeError("Illegal target range: 0 <= "+targetOffset+" <= "+target.buffer.byteLength);
		        if (sourceOffset < 0 || sourceLimit > this.buffer.byteLength)
		            throw RangeError("Illegal source range: 0 <= "+sourceOffset+" <= "+this.buffer.byteLength);
	
		        var len = sourceLimit - sourceOffset;
		        if (len === 0)
		            return target; // Nothing to copy
	
		        target.ensureCapacity(targetOffset + len);
	
		        target.view.set(this.view.subarray(sourceOffset, sourceLimit), targetOffset);
	
		        if (relative) this.offset += len;
		        if (targetRelative) target.offset += len;
	
		        return this;
		    };
	
		    /**
		     * Makes sure that this ByteBuffer is backed by a {@link ByteBuffer#buffer} of at least the specified capacity. If the
		     *  current capacity is exceeded, it will be doubled. If double the current capacity is less than the required capacity,
		     *  the required capacity will be used instead.
		     * @param {number} capacity Required capacity
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.ensureCapacity = function(capacity) {
		        var current = this.buffer.byteLength;
		        if (current < capacity)
		            return this.resize((current *= 2) > capacity ? current : capacity);
		        return this;
		    };
	
		    /**
		     * Overwrites this ByteBuffer's contents with the specified value. Contents are the bytes between
		     *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}.
		     * @param {number|string} value Byte value to fill with. If given as a string, the first character is used.
		     * @param {number=} begin Begin offset. Will use and increase {@link ByteBuffer#offset} by the number of bytes
		     *  written if omitted. defaults to {@link ByteBuffer#offset}.
		     * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
		     * @returns {!ByteBuffer} this
		     * @expose
		     * @example `someByteBuffer.clear().fill(0)` fills the entire backing buffer with zeroes
		     */
		    ByteBufferPrototype.fill = function(value, begin, end) {
		        var relative = typeof begin === 'undefined';
		        if (relative) begin = this.offset;
		        if (typeof value === 'string' && value.length > 0)
		            value = value.charCodeAt(0);
		        if (typeof begin === 'undefined') begin = this.offset;
		        if (typeof end === 'undefined') end = this.limit;
		        if (!this.noAssert) {
		            if (typeof value !== 'number' || value % 1 !== 0)
		                throw TypeError("Illegal value: "+value+" (not an integer)");
		            value |= 0;
		            if (typeof begin !== 'number' || begin % 1 !== 0)
		                throw TypeError("Illegal begin: Not an integer");
		            begin >>>= 0;
		            if (typeof end !== 'number' || end % 1 !== 0)
		                throw TypeError("Illegal end: Not an integer");
		            end >>>= 0;
		            if (begin < 0 || begin > end || end > this.buffer.byteLength)
		                throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
		        }
		        if (begin >= end)
		            return this; // Nothing to fill
		        while (begin < end) this.view[begin++] = value;
		        if (relative) this.offset = begin;
		        return this;
		    };
	
		    /**
		     * Makes this ByteBuffer ready for a new sequence of write or relative read operations. Sets `limit = offset` and
		     *  `offset = 0`. Make sure always to flip a ByteBuffer when all relative read or write operations are complete.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.flip = function() {
		        this.limit = this.offset;
		        this.offset = 0;
		        return this;
		    };
		    /**
		     * Marks an offset on this ByteBuffer to be used later.
		     * @param {number=} offset Offset to mark. Defaults to {@link ByteBuffer#offset}.
		     * @returns {!ByteBuffer} this
		     * @throws {TypeError} If `offset` is not a valid number
		     * @throws {RangeError} If `offset` is out of bounds
		     * @see ByteBuffer#reset
		     * @expose
		     */
		    ByteBufferPrototype.mark = function(offset) {
		        offset = typeof offset === 'undefined' ? this.offset : offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        this.markedOffset = offset;
		        return this;
		    };
		    /**
		     * Sets the byte order.
		     * @param {boolean} littleEndian `true` for little endian byte order, `false` for big endian
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.order = function(littleEndian) {
		        if (!this.noAssert) {
		            if (typeof littleEndian !== 'boolean')
		                throw TypeError("Illegal littleEndian: Not a boolean");
		        }
		        this.littleEndian = !!littleEndian;
		        return this;
		    };
	
		    /**
		     * Switches (to) little endian byte order.
		     * @param {boolean=} littleEndian Defaults to `true`, otherwise uses big endian
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.LE = function(littleEndian) {
		        this.littleEndian = typeof littleEndian !== 'undefined' ? !!littleEndian : true;
		        return this;
		    };
	
		    /**
		     * Switches (to) big endian byte order.
		     * @param {boolean=} bigEndian Defaults to `true`, otherwise uses little endian
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.BE = function(bigEndian) {
		        this.littleEndian = typeof bigEndian !== 'undefined' ? !bigEndian : false;
		        return this;
		    };
		    /**
		     * Prepends some data to this ByteBuffer. This will overwrite any contents before the specified offset up to the
		     *  prepended data's length. If there is not enough space available before the specified `offset`, the backing buffer
		     *  will be resized and its contents moved accordingly.
		     * @param {!ByteBuffer|string|!ArrayBuffer} source Data to prepend. If `source` is a ByteBuffer, its offset will be
		     *  modified according to the performed read operation.
		     * @param {(string|number)=} encoding Encoding if `data` is a string ("base64", "hex", "binary", defaults to "utf8")
		     * @param {number=} offset Offset to prepend at. Will use and decrease {@link ByteBuffer#offset} by the number of bytes
		     *  prepended if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     * @example A relative `00<01 02 03>.prepend(<04 05>)` results in `<04 05 01 02 03>, 04 05|`
		     * @example An absolute `00<01 02 03>.prepend(<04 05>, 2)` results in `04<05 02 03>, 04 05|`
		     */
		    ByteBufferPrototype.prepend = function(source, encoding, offset) {
		        if (typeof encoding === 'number' || typeof encoding !== 'string') {
		            offset = encoding;
		            encoding = undefined;
		        }
		        var relative = typeof offset === 'undefined';
		        if (relative) offset = this.offset;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: "+offset+" (not an integer)");
		            offset >>>= 0;
		            if (offset < 0 || offset + 0 > this.buffer.byteLength)
		                throw RangeError("Illegal offset: 0 <= "+offset+" (+"+0+") <= "+this.buffer.byteLength);
		        }
		        if (!(source instanceof ByteBuffer))
		            source = ByteBuffer.wrap(source, encoding);
		        var len = source.limit - source.offset;
		        if (len <= 0) return this; // Nothing to prepend
		        var diff = len - offset;
		        if (diff > 0) { // Not enough space before offset, so resize + move
		            var buffer = new ArrayBuffer(this.buffer.byteLength + diff);
		            var view = new Uint8Array(buffer);
		            view.set(this.view.subarray(offset, this.buffer.byteLength), len);
		            this.buffer = buffer;
		            this.view = view;
		            this.offset += diff;
		            if (this.markedOffset >= 0) this.markedOffset += diff;
		            this.limit += diff;
		            offset += diff;
		        } else {
		            var arrayView = new Uint8Array(this.buffer);
		        }
		        this.view.set(source.view.subarray(source.offset, source.limit), offset - len);
	
		        source.offset = source.limit;
		        if (relative)
		            this.offset -= len;
		        return this;
		    };
	
		    /**
		     * Prepends this ByteBuffer to another ByteBuffer. This will overwrite any contents before the specified offset up to the
		     *  prepended data's length. If there is not enough space available before the specified `offset`, the backing buffer
		     *  will be resized and its contents moved accordingly.
		     * @param {!ByteBuffer} target Target ByteBuffer
		     * @param {number=} offset Offset to prepend at. Will use and decrease {@link ByteBuffer#offset} by the number of bytes
		     *  prepended if omitted.
		     * @returns {!ByteBuffer} this
		     * @expose
		     * @see ByteBuffer#prepend
		     */
		    ByteBufferPrototype.prependTo = function(target, offset) {
		        target.prepend(this, offset);
		        return this;
		    };
		    /**
		     * Prints debug information about this ByteBuffer's contents.
		     * @param {function(string)=} out Output function to call, defaults to console.log
		     * @expose
		     */
		    ByteBufferPrototype.printDebug = function(out) {
		        if (typeof out !== 'function') out = console.log.bind(console);
		        out(
		            this.toString()+"\n"+
		            "-------------------------------------------------------------------\n"+
		            this.toDebug(/* columns */ true)
		        );
		    };
	
		    /**
		     * Gets the number of remaining readable bytes. Contents are the bytes between {@link ByteBuffer#offset} and
		     *  {@link ByteBuffer#limit}, so this returns `limit - offset`.
		     * @returns {number} Remaining readable bytes. May be negative if `offset > limit`.
		     * @expose
		     */
		    ByteBufferPrototype.remaining = function() {
		        return this.limit - this.offset;
		    };
		    /**
		     * Resets this ByteBuffer's {@link ByteBuffer#offset}. If an offset has been marked through {@link ByteBuffer#mark}
		     *  before, `offset` will be set to {@link ByteBuffer#markedOffset}, which will then be discarded. If no offset has been
		     *  marked, sets `offset = 0`.
		     * @returns {!ByteBuffer} this
		     * @see ByteBuffer#mark
		     * @expose
		     */
		    ByteBufferPrototype.reset = function() {
		        if (this.markedOffset >= 0) {
		            this.offset = this.markedOffset;
		            this.markedOffset = -1;
		        } else {
		            this.offset = 0;
		        }
		        return this;
		    };
		    /**
		     * Resizes this ByteBuffer to be backed by a buffer of at least the given capacity. Will do nothing if already that
		     *  large or larger.
		     * @param {number} capacity Capacity required
		     * @returns {!ByteBuffer} this
		     * @throws {TypeError} If `capacity` is not a number
		     * @throws {RangeError} If `capacity < 0`
		     * @expose
		     */
		    ByteBufferPrototype.resize = function(capacity) {
		        if (!this.noAssert) {
		            if (typeof capacity !== 'number' || capacity % 1 !== 0)
		                throw TypeError("Illegal capacity: "+capacity+" (not an integer)");
		            capacity |= 0;
		            if (capacity < 0)
		                throw RangeError("Illegal capacity: 0 <= "+capacity);
		        }
		        if (this.buffer.byteLength < capacity) {
		            var buffer = new ArrayBuffer(capacity);
		            var view = new Uint8Array(buffer);
		            view.set(this.view);
		            this.buffer = buffer;
		            this.view = view;
		        }
		        return this;
		    };
		    /**
		     * Reverses this ByteBuffer's contents.
		     * @param {number=} begin Offset to start at, defaults to {@link ByteBuffer#offset}
		     * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.reverse = function(begin, end) {
		        if (typeof begin === 'undefined') begin = this.offset;
		        if (typeof end === 'undefined') end = this.limit;
		        if (!this.noAssert) {
		            if (typeof begin !== 'number' || begin % 1 !== 0)
		                throw TypeError("Illegal begin: Not an integer");
		            begin >>>= 0;
		            if (typeof end !== 'number' || end % 1 !== 0)
		                throw TypeError("Illegal end: Not an integer");
		            end >>>= 0;
		            if (begin < 0 || begin > end || end > this.buffer.byteLength)
		                throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
		        }
		        if (begin === end)
		            return this; // Nothing to reverse
		        Array.prototype.reverse.call(this.view.subarray(begin, end));
		        return this;
		    };
		    /**
		     * Skips the next `length` bytes. This will just advance
		     * @param {number} length Number of bytes to skip. May also be negative to move the offset back.
		     * @returns {!ByteBuffer} this
		     * @expose
		     */
		    ByteBufferPrototype.skip = function(length) {
		        if (!this.noAssert) {
		            if (typeof length !== 'number' || length % 1 !== 0)
		                throw TypeError("Illegal length: "+length+" (not an integer)");
		            length |= 0;
		        }
		        var offset = this.offset + length;
		        if (!this.noAssert) {
		            if (offset < 0 || offset > this.buffer.byteLength)
		                throw RangeError("Illegal length: 0 <= "+this.offset+" + "+length+" <= "+this.buffer.byteLength);
		        }
		        this.offset = offset;
		        return this;
		    };
	
		    /**
		     * Slices this ByteBuffer by creating a cloned instance with `offset = begin` and `limit = end`.
		     * @param {number=} begin Begin offset, defaults to {@link ByteBuffer#offset}.
		     * @param {number=} end End offset, defaults to {@link ByteBuffer#limit}.
		     * @returns {!ByteBuffer} Clone of this ByteBuffer with slicing applied, backed by the same {@link ByteBuffer#buffer}
		     * @expose
		     */
		    ByteBufferPrototype.slice = function(begin, end) {
		        if (typeof begin === 'undefined') begin = this.offset;
		        if (typeof end === 'undefined') end = this.limit;
		        if (!this.noAssert) {
		            if (typeof begin !== 'number' || begin % 1 !== 0)
		                throw TypeError("Illegal begin: Not an integer");
		            begin >>>= 0;
		            if (typeof end !== 'number' || end % 1 !== 0)
		                throw TypeError("Illegal end: Not an integer");
		            end >>>= 0;
		            if (begin < 0 || begin > end || end > this.buffer.byteLength)
		                throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
		        }
		        var bb = this.clone();
		        bb.offset = begin;
		        bb.limit = end;
		        return bb;
		    };
		    /**
		     * Returns a copy of the backing buffer that contains this ByteBuffer's contents. Contents are the bytes between
		     *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}.
		     * @param {boolean=} forceCopy If `true` returns a copy, otherwise returns a view referencing the same memory if
		     *  possible. Defaults to `false`
		     * @returns {!ArrayBuffer} Contents as an ArrayBuffer
		     * @expose
		     */
		    ByteBufferPrototype.toBuffer = function(forceCopy) {
		        var offset = this.offset,
		            limit = this.limit;
		        if (!this.noAssert) {
		            if (typeof offset !== 'number' || offset % 1 !== 0)
		                throw TypeError("Illegal offset: Not an integer");
		            offset >>>= 0;
		            if (typeof limit !== 'number' || limit % 1 !== 0)
		                throw TypeError("Illegal limit: Not an integer");
		            limit >>>= 0;
		            if (offset < 0 || offset > limit || limit > this.buffer.byteLength)
		                throw RangeError("Illegal range: 0 <= "+offset+" <= "+limit+" <= "+this.buffer.byteLength);
		        }
		        // NOTE: It's not possible to have another ArrayBuffer reference the same memory as the backing buffer. This is
		        // possible with Uint8Array#subarray only, but we have to return an ArrayBuffer by contract. So:
		        if (!forceCopy && offset === 0 && limit === this.buffer.byteLength)
		            return this.buffer;
		        if (offset === limit)
		            return EMPTY_BUFFER;
		        var buffer = new ArrayBuffer(limit - offset);
		        new Uint8Array(buffer).set(new Uint8Array(this.buffer).subarray(offset, limit), 0);
		        return buffer;
		    };
	
		    /**
		     * Returns a raw buffer compacted to contain this ByteBuffer's contents. Contents are the bytes between
		     *  {@link ByteBuffer#offset} and {@link ByteBuffer#limit}. This is an alias of {@link ByteBuffer#toBuffer}.
		     * @function
		     * @param {boolean=} forceCopy If `true` returns a copy, otherwise returns a view referencing the same memory.
		     *  Defaults to `false`
		     * @returns {!ArrayBuffer} Contents as an ArrayBuffer
		     * @expose
		     */
		    ByteBufferPrototype.toArrayBuffer = ByteBufferPrototype.toBuffer;
	
		    /**
		     * Converts the ByteBuffer's contents to a string.
		     * @param {string=} encoding Output encoding. Returns an informative string representation if omitted but also allows
		     *  direct conversion to "utf8", "hex", "base64" and "binary" encoding. "debug" returns a hex representation with
		     *  highlighted offsets.
		     * @param {number=} begin Offset to begin at, defaults to {@link ByteBuffer#offset}
		     * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}
		     * @returns {string} String representation
		     * @throws {Error} If `encoding` is invalid
		     * @expose
		     */
		    ByteBufferPrototype.toString = function(encoding, begin, end) {
		        if (typeof encoding === 'undefined')
		            return "ByteBufferAB(offset="+this.offset+",markedOffset="+this.markedOffset+",limit="+this.limit+",capacity="+this.capacity()+")";
		        if (typeof encoding === 'number')
		            encoding = "utf8",
		            begin = encoding,
		            end = begin;
		        switch (encoding) {
		            case "utf8":
		                return this.toUTF8(begin, end);
		            case "base64":
		                return this.toBase64(begin, end);
		            case "hex":
		                return this.toHex(begin, end);
		            case "binary":
		                return this.toBinary(begin, end);
		            case "debug":
		                return this.toDebug();
		            case "columns":
		                return this.toColumns();
		            default:
		                throw Error("Unsupported encoding: "+encoding);
		        }
		    };
	
		    // lxiv-embeddable
	
		    /**
		     * lxiv-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
		     * Released under the Apache License, Version 2.0
		     * see: https://github.com/dcodeIO/lxiv for details
		     */
		    var lxiv = function() {
		        "use strict";
	
		        /**
		         * lxiv namespace.
		         * @type {!Object.<string,*>}
		         * @exports lxiv
		         */
		        var lxiv = {};
	
		        /**
		         * Character codes for output.
		         * @type {!Array.<number>}
		         * @inner
		         */
		        var aout = [
		            65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80,
		            81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 97, 98, 99, 100, 101, 102,
		            103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118,
		            119, 120, 121, 122, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 43, 47
		        ];
	
		        /**
		         * Character codes for input.
		         * @type {!Array.<number>}
		         * @inner
		         */
		        var ain = [];
		        for (var i=0, k=aout.length; i<k; ++i)
		            ain[aout[i]] = i;
	
		        /**
		         * Encodes bytes to base64 char codes.
		         * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if
		         *  there are no more bytes left.
		         * @param {!function(number)} dst Characters destination as a function successively called with each encoded char
		         *  code.
		         */
		        lxiv.encode = function(src, dst) {
		            var b, t;
		            while ((b = src()) !== null) {
		                dst(aout[(b>>2)&0x3f]);
		                t = (b&0x3)<<4;
		                if ((b = src()) !== null) {
		                    t |= (b>>4)&0xf;
		                    dst(aout[(t|((b>>4)&0xf))&0x3f]);
		                    t = (b&0xf)<<2;
		                    if ((b = src()) !== null)
		                        dst(aout[(t|((b>>6)&0x3))&0x3f]),
		                        dst(aout[b&0x3f]);
		                    else
		                        dst(aout[t&0x3f]),
		                        dst(61);
		                } else
		                    dst(aout[t&0x3f]),
		                    dst(61),
		                    dst(61);
		            }
		        };
	
		        /**
		         * Decodes base64 char codes to bytes.
		         * @param {!function():number|null} src Characters source as a function returning the next char code respectively
		         *  `null` if there are no more characters left.
		         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
		         * @throws {Error} If a character code is invalid
		         */
		        lxiv.decode = function(src, dst) {
		            var c, t1, t2;
		            function fail(c) {
		                throw Error("Illegal character code: "+c);
		            }
		            while ((c = src()) !== null) {
		                t1 = ain[c];
		                if (typeof t1 === 'undefined') fail(c);
		                if ((c = src()) !== null) {
		                    t2 = ain[c];
		                    if (typeof t2 === 'undefined') fail(c);
		                    dst((t1<<2)>>>0|(t2&0x30)>>4);
		                    if ((c = src()) !== null) {
		                        t1 = ain[c];
		                        if (typeof t1 === 'undefined')
		                            if (c === 61) break; else fail(c);
		                        dst(((t2&0xf)<<4)>>>0|(t1&0x3c)>>2);
		                        if ((c = src()) !== null) {
		                            t2 = ain[c];
		                            if (typeof t2 === 'undefined')
		                                if (c === 61) break; else fail(c);
		                            dst(((t1&0x3)<<6)>>>0|t2);
		                        }
		                    }
		                }
		            }
		        };
	
		        /**
		         * Tests if a string is valid base64.
		         * @param {string} str String to test
		         * @returns {boolean} `true` if valid, otherwise `false`
		         */
		        lxiv.test = function(str) {
		            return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(str);
		        };
	
		        return lxiv;
		    }();
	
		    // encodings/base64
	
		    /**
		     * Encodes this ByteBuffer's contents to a base64 encoded string.
		     * @param {number=} begin Offset to begin at, defaults to {@link ByteBuffer#offset}.
		     * @param {number=} end Offset to end at, defaults to {@link ByteBuffer#limit}.
		     * @returns {string} Base64 encoded string
		     * @throws {RangeError} If `begin` or `end` is out of bounds
		     * @expose
		     */
		    ByteBufferPrototype.toBase64 = function(begin, end) {
		        if (typeof begin === 'undefined')
		            begin = this.offset;
		        if (typeof end === 'undefined')
		            end = this.limit;
		        begin = begin | 0; end = end | 0;
		        if (begin < 0 || end > this.capacity || begin > end)
		            throw RangeError("begin, end");
		        var sd; lxiv.encode(function() {
		            return begin < end ? this.view[begin++] : null;
		        }.bind(this), sd = stringDestination());
		        return sd();
		    };
	
		    /**
		     * Decodes a base64 encoded string to a ByteBuffer.
		     * @param {string} str String to decode
		     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
		     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
		     * @returns {!ByteBuffer} ByteBuffer
		     * @expose
		     */
		    ByteBuffer.fromBase64 = function(str, littleEndian) {
		        if (typeof str !== 'string')
		            throw TypeError("str");
		        var bb = new ByteBuffer(str.length/4*3, littleEndian),
		            i = 0;
		        lxiv.decode(stringSource(str), function(b) {
		            bb.view[i++] = b;
		        });
		        bb.limit = i;
		        return bb;
		    };
	
		    /**
		     * Encodes a binary string to base64 like `window.btoa` does.
		     * @param {string} str Binary string
		     * @returns {string} Base64 encoded string
		     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.btoa
		     * @expose
		     */
		    ByteBuffer.btoa = function(str) {
		        return ByteBuffer.fromBinary(str).toBase64();
		    };
	
		    /**
		     * Decodes a base64 encoded string to binary like `window.atob` does.
		     * @param {string} b64 Base64 encoded string
		     * @returns {string} Binary string
		     * @see https://developer.mozilla.org/en-US/docs/Web/API/Window.atob
		     * @expose
		     */
		    ByteBuffer.atob = function(b64) {
		        return ByteBuffer.fromBase64(b64).toBinary();
		    };
	
		    // encodings/binary
	
		    /**
		     * Encodes this ByteBuffer to a binary encoded string, that is using only characters 0x00-0xFF as bytes.
		     * @param {number=} begin Offset to begin at. Defaults to {@link ByteBuffer#offset}.
		     * @param {number=} end Offset to end at. Defaults to {@link ByteBuffer#limit}.
		     * @returns {string} Binary encoded string
		     * @throws {RangeError} If `offset > limit`
		     * @expose
		     */
		    ByteBufferPrototype.toBinary = function(begin, end) {
		        if (typeof begin === 'undefined')
		            begin = this.offset;
		        if (typeof end === 'undefined')
		            end = this.limit;
		        begin |= 0; end |= 0;
		        if (begin < 0 || end > this.capacity() || begin > end)
		            throw RangeError("begin, end");
		        if (begin === end)
		            return "";
		        var chars = [],
		            parts = [];
		        while (begin < end) {
		            chars.push(this.view[begin++]);
		            if (chars.length >= 1024)
		                parts.push(String.fromCharCode.apply(String, chars)),
		                chars = [];
		        }
		        return parts.join('') + String.fromCharCode.apply(String, chars);
		    };
	
		    /**
		     * Decodes a binary encoded string, that is using only characters 0x00-0xFF as bytes, to a ByteBuffer.
		     * @param {string} str String to decode
		     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
		     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
		     * @returns {!ByteBuffer} ByteBuffer
		     * @expose
		     */
		    ByteBuffer.fromBinary = function(str, littleEndian) {
		        if (typeof str !== 'string')
		            throw TypeError("str");
		        var i = 0,
		            k = str.length,
		            charCode,
		            bb = new ByteBuffer(k, littleEndian);
		        while (i<k) {
		            charCode = str.charCodeAt(i);
		            if (charCode > 0xff)
		                throw RangeError("illegal char code: "+charCode);
		            bb.view[i++] = charCode;
		        }
		        bb.limit = k;
		        return bb;
		    };
	
		    // encodings/debug
	
		    /**
		     * Encodes this ByteBuffer to a hex encoded string with marked offsets. Offset symbols are:
		     * * `<` : offset,
		     * * `'` : markedOffset,
		     * * `>` : limit,
		     * * `|` : offset and limit,
		     * * `[` : offset and markedOffset,
		     * * `]` : markedOffset and limit,
		     * * `!` : offset, markedOffset and limit
		     * @param {boolean=} columns If `true` returns two columns hex + ascii, defaults to `false`
		     * @returns {string|!Array.<string>} Debug string or array of lines if `asArray = true`
		     * @expose
		     * @example `>00'01 02<03` contains four bytes with `limit=0, markedOffset=1, offset=3`
		     * @example `00[01 02 03>` contains four bytes with `offset=markedOffset=1, limit=4`
		     * @example `00|01 02 03` contains four bytes with `offset=limit=1, markedOffset=-1`
		     * @example `|` contains zero bytes with `offset=limit=0, markedOffset=-1`
		     */
		    ByteBufferPrototype.toDebug = function(columns) {
		        var i = -1,
		            k = this.buffer.byteLength,
		            b,
		            hex = "",
		            asc = "",
		            out = "";
		        while (i<k) {
		            if (i !== -1) {
		                b = this.view[i];
		                if (b < 0x10) hex += "0"+b.toString(16).toUpperCase();
		                else hex += b.toString(16).toUpperCase();
		                if (columns)
		                    asc += b > 32 && b < 127 ? String.fromCharCode(b) : '.';
		            }
		            ++i;
		            if (columns) {
		                if (i > 0 && i % 16 === 0 && i !== k) {
		                    while (hex.length < 3*16+3) hex += " ";
		                    out += hex+asc+"\n";
		                    hex = asc = "";
		                }
		            }
		            if (i === this.offset && i === this.limit)
		                hex += i === this.markedOffset ? "!" : "|";
		            else if (i === this.offset)
		                hex += i === this.markedOffset ? "[" : "<";
		            else if (i === this.limit)
		                hex += i === this.markedOffset ? "]" : ">";
		            else
		                hex += i === this.markedOffset ? "'" : (columns || (i !== 0 && i !== k) ? " " : "");
		        }
		        if (columns && hex !== " ") {
		            while (hex.length < 3*16+3)
		                hex += " ";
		            out += hex + asc + "\n";
		        }
		        return columns ? out : hex;
		    };
	
		    /**
		     * Decodes a hex encoded string with marked offsets to a ByteBuffer.
		     * @param {string} str Debug string to decode (not be generated with `columns = true`)
		     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
		     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
		     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
		     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
		     * @returns {!ByteBuffer} ByteBuffer
		     * @expose
		     * @see ByteBuffer#toDebug
		     */
		    ByteBuffer.fromDebug = function(str, littleEndian, noAssert) {
		        var k = str.length,
		            bb = new ByteBuffer(((k+1)/3)|0, littleEndian, noAssert);
		        var i = 0, j = 0, ch, b,
		            rs = false, // Require symbol next
		            ho = false, hm = false, hl = false, // Already has offset (ho), markedOffset (hm), limit (hl)?
		            fail = false;
		        while (i<k) {
		            switch (ch = str.charAt(i++)) {
		                case '!':
		                    if (!noAssert) {
		                        if (ho || hm || hl) {
		                            fail = true;
		                            break;
		                        }
		                        ho = hm = hl = true;
		                    }
		                    bb.offset = bb.markedOffset = bb.limit = j;
		                    rs = false;
		                    break;
		                case '|':
		                    if (!noAssert) {
		                        if (ho || hl) {
		                            fail = true;
		                            break;
		                        }
		                        ho = hl = true;
		                    }
		                    bb.offset = bb.limit = j;
		                    rs = false;
		                    break;
		                case '[':
		                    if (!noAssert) {
		                        if (ho || hm) {
		                            fail = true;
		                            break;
		                        }
		                        ho = hm = true;
		                    }
		                    bb.offset = bb.markedOffset = j;
		                    rs = false;
		                    break;
		                case '<':
		                    if (!noAssert) {
		                        if (ho) {
		                            fail = true;
		                            break;
		                        }
		                        ho = true;
		                    }
		                    bb.offset = j;
		                    rs = false;
		                    break;
		                case ']':
		                    if (!noAssert) {
		                        if (hl || hm) {
		                            fail = true;
		                            break;
		                        }
		                        hl = hm = true;
		                    }
		                    bb.limit = bb.markedOffset = j;
		                    rs = false;
		                    break;
		                case '>':
		                    if (!noAssert) {
		                        if (hl) {
		                            fail = true;
		                            break;
		                        }
		                        hl = true;
		                    }
		                    bb.limit = j;
		                    rs = false;
		                    break;
		                case "'":
		                    if (!noAssert) {
		                        if (hm) {
		                            fail = true;
		                            break;
		                        }
		                        hm = true;
		                    }
		                    bb.markedOffset = j;
		                    rs = false;
		                    break;
		                case ' ':
		                    rs = false;
		                    break;
		                default:
		                    if (!noAssert) {
		                        if (rs) {
		                            fail = true;
		                            break;
		                        }
		                    }
		                    b = parseInt(ch+str.charAt(i++), 16);
		                    if (!noAssert) {
		                        if (isNaN(b) || b < 0 || b > 255)
		                            throw TypeError("Illegal str: Not a debug encoded string");
		                    }
		                    bb.view[j++] = b;
		                    rs = true;
		            }
		            if (fail)
		                throw TypeError("Illegal str: Invalid symbol at "+i);
		        }
		        if (!noAssert) {
		            if (!ho || !hl)
		                throw TypeError("Illegal str: Missing offset or limit");
		            if (j<bb.buffer.byteLength)
		                throw TypeError("Illegal str: Not a debug encoded string (is it hex?) "+j+" < "+k);
		        }
		        return bb;
		    };
	
		    // encodings/hex
	
		    /**
		     * Encodes this ByteBuffer's contents to a hex encoded string.
		     * @param {number=} begin Offset to begin at. Defaults to {@link ByteBuffer#offset}.
		     * @param {number=} end Offset to end at. Defaults to {@link ByteBuffer#limit}.
		     * @returns {string} Hex encoded string
		     * @expose
		     */
		    ByteBufferPrototype.toHex = function(begin, end) {
		        begin = typeof begin === 'undefined' ? this.offset : begin;
		        end = typeof end === 'undefined' ? this.limit : end;
		        if (!this.noAssert) {
		            if (typeof begin !== 'number' || begin % 1 !== 0)
		                throw TypeError("Illegal begin: Not an integer");
		            begin >>>= 0;
		            if (typeof end !== 'number' || end % 1 !== 0)
		                throw TypeError("Illegal end: Not an integer");
		            end >>>= 0;
		            if (begin < 0 || begin > end || end > this.buffer.byteLength)
		                throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
		        }
		        var out = new Array(end - begin),
		            b;
		        while (begin < end) {
		            b = this.view[begin++];
		            if (b < 0x10)
		                out.push("0", b.toString(16));
		            else out.push(b.toString(16));
		        }
		        return out.join('');
		    };
	
		    /**
		     * Decodes a hex encoded string to a ByteBuffer.
		     * @param {string} str String to decode
		     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
		     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
		     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
		     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
		     * @returns {!ByteBuffer} ByteBuffer
		     * @expose
		     */
		    ByteBuffer.fromHex = function(str, littleEndian, noAssert) {
		        if (!noAssert) {
		            if (typeof str !== 'string')
		                throw TypeError("Illegal str: Not a string");
		            if (str.length % 2 !== 0)
		                throw TypeError("Illegal str: Length not a multiple of 2");
		        }
		        var k = str.length,
		            bb = new ByteBuffer((k / 2) | 0, littleEndian),
		            b;
		        for (var i=0, j=0; i<k; i+=2) {
		            b = parseInt(str.substring(i, i+2), 16);
		            if (!noAssert)
		                if (!isFinite(b) || b < 0 || b > 255)
		                    throw TypeError("Illegal str: Contains non-hex characters");
		            bb.view[j++] = b;
		        }
		        bb.limit = j;
		        return bb;
		    };
	
		    // utfx-embeddable
	
		    /**
		     * utfx-embeddable (c) 2014 Daniel Wirtz <dcode@dcode.io>
		     * Released under the Apache License, Version 2.0
		     * see: https://github.com/dcodeIO/utfx for details
		     */
		    var utfx = function() {
		        "use strict";
	
		        /**
		         * utfx namespace.
		         * @inner
		         * @type {!Object.<string,*>}
		         */
		        var utfx = {};
	
		        /**
		         * Maximum valid code point.
		         * @type {number}
		         * @const
		         */
		        utfx.MAX_CODEPOINT = 0x10FFFF;
	
		        /**
		         * Encodes UTF8 code points to UTF8 bytes.
		         * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
		         *  respectively `null` if there are no more code points left or a single numeric code point.
		         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte
		         */
		        utfx.encodeUTF8 = function(src, dst) {
		            var cp = null;
		            if (typeof src === 'number')
		                cp = src,
		                src = function() { return null; };
		            while (cp !== null || (cp = src()) !== null) {
		                if (cp < 0x80)
		                    dst(cp&0x7F);
		                else if (cp < 0x800)
		                    dst(((cp>>6)&0x1F)|0xC0),
		                    dst((cp&0x3F)|0x80);
		                else if (cp < 0x10000)
		                    dst(((cp>>12)&0x0F)|0xE0),
		                    dst(((cp>>6)&0x3F)|0x80),
		                    dst((cp&0x3F)|0x80);
		                else
		                    dst(((cp>>18)&0x07)|0xF0),
		                    dst(((cp>>12)&0x3F)|0x80),
		                    dst(((cp>>6)&0x3F)|0x80),
		                    dst((cp&0x3F)|0x80);
		                cp = null;
		            }
		        };
	
		        /**
		         * Decodes UTF8 bytes to UTF8 code points.
		         * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
		         *  are no more bytes left.
		         * @param {!function(number)} dst Code points destination as a function successively called with each decoded code point.
		         * @throws {RangeError} If a starting byte is invalid in UTF8
		         * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the
		         *  remaining bytes.
		         */
		        utfx.decodeUTF8 = function(src, dst) {
		            var a, b, c, d, fail = function(b) {
		                b = b.slice(0, b.indexOf(null));
		                var err = Error(b.toString());
		                err.name = "TruncatedError";
		                err['bytes'] = b;
		                throw err;
		            };
		            while ((a = src()) !== null) {
		                if ((a&0x80) === 0)
		                    dst(a);
		                else if ((a&0xE0) === 0xC0)
		                    ((b = src()) === null) && fail([a, b]),
		                    dst(((a&0x1F)<<6) | (b&0x3F));
		                else if ((a&0xF0) === 0xE0)
		                    ((b=src()) === null || (c=src()) === null) && fail([a, b, c]),
		                    dst(((a&0x0F)<<12) | ((b&0x3F)<<6) | (c&0x3F));
		                else if ((a&0xF8) === 0xF0)
		                    ((b=src()) === null || (c=src()) === null || (d=src()) === null) && fail([a, b, c ,d]),
		                    dst(((a&0x07)<<18) | ((b&0x3F)<<12) | ((c&0x3F)<<6) | (d&0x3F));
		                else throw RangeError("Illegal starting byte: "+a);
		            }
		        };
	
		        /**
		         * Converts UTF16 characters to UTF8 code points.
		         * @param {!function():number|null} src Characters source as a function returning the next char code respectively
		         *  `null` if there are no more characters left.
		         * @param {!function(number)} dst Code points destination as a function successively called with each converted code
		         *  point.
		         */
		        utfx.UTF16toUTF8 = function(src, dst) {
		            var c1, c2 = null;
		            while (true) {
		                if ((c1 = c2 !== null ? c2 : src()) === null)
		                    break;
		                if (c1 >= 0xD800 && c1 <= 0xDFFF) {
		                    if ((c2 = src()) !== null) {
		                        if (c2 >= 0xDC00 && c2 <= 0xDFFF) {
		                            dst((c1-0xD800)*0x400+c2-0xDC00+0x10000);
		                            c2 = null; continue;
		                        }
		                    }
		                }
		                dst(c1);
		            }
		            if (c2 !== null) dst(c2);
		        };
	
		        /**
		         * Converts UTF8 code points to UTF16 characters.
		         * @param {(!function():number|null) | number} src Code points source, either as a function returning the next code point
		         *  respectively `null` if there are no more code points left or a single numeric code point.
		         * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
		         * @throws {RangeError} If a code point is out of range
		         */
		        utfx.UTF8toUTF16 = function(src, dst) {
		            var cp = null;
		            if (typeof src === 'number')
		                cp = src, src = function() { return null; };
		            while (cp !== null || (cp = src()) !== null) {
		                if (cp <= 0xFFFF)
		                    dst(cp);
		                else
		                    cp -= 0x10000,
		                    dst((cp>>10)+0xD800),
		                    dst((cp%0x400)+0xDC00);
		                cp = null;
		            }
		        };
	
		        /**
		         * Converts and encodes UTF16 characters to UTF8 bytes.
		         * @param {!function():number|null} src Characters source as a function returning the next char code respectively `null`
		         *  if there are no more characters left.
		         * @param {!function(number)} dst Bytes destination as a function successively called with the next byte.
		         */
		        utfx.encodeUTF16toUTF8 = function(src, dst) {
		            utfx.UTF16toUTF8(src, function(cp) {
		                utfx.encodeUTF8(cp, dst);
		            });
		        };
	
		        /**
		         * Decodes and converts UTF8 bytes to UTF16 characters.
		         * @param {!function():number|null} src Bytes source as a function returning the next byte respectively `null` if there
		         *  are no more bytes left.
		         * @param {!function(number)} dst Characters destination as a function successively called with each converted char code.
		         * @throws {RangeError} If a starting byte is invalid in UTF8
		         * @throws {Error} If the last sequence is truncated. Has an array property `bytes` holding the remaining bytes.
		         */
		        utfx.decodeUTF8toUTF16 = function(src, dst) {
		            utfx.decodeUTF8(src, function(cp) {
		                utfx.UTF8toUTF16(cp, dst);
		            });
		        };
	
		        /**
		         * Calculates the byte length of an UTF8 code point.
		         * @param {number} cp UTF8 code point
		         * @returns {number} Byte length
		         */
		        utfx.calculateCodePoint = function(cp) {
		            return (cp < 0x80) ? 1 : (cp < 0x800) ? 2 : (cp < 0x10000) ? 3 : 4;
		        };
	
		        /**
		         * Calculates the number of UTF8 bytes required to store UTF8 code points.
		         * @param {(!function():number|null)} src Code points source as a function returning the next code point respectively
		         *  `null` if there are no more code points left.
		         * @returns {number} The number of UTF8 bytes required
		         */
		        utfx.calculateUTF8 = function(src) {
		            var cp, l=0;
		            while ((cp = src()) !== null)
		                l += (cp < 0x80) ? 1 : (cp < 0x800) ? 2 : (cp < 0x10000) ? 3 : 4;
		            return l;
		        };
	
		        /**
		         * Calculates the number of UTF8 code points respectively UTF8 bytes required to store UTF16 char codes.
		         * @param {(!function():number|null)} src Characters source as a function returning the next char code respectively
		         *  `null` if there are no more characters left.
		         * @returns {!Array.<number>} The number of UTF8 code points at index 0 and the number of UTF8 bytes required at index 1.
		         */
		        utfx.calculateUTF16asUTF8 = function(src) {
		            var n=0, l=0;
		            utfx.UTF16toUTF8(src, function(cp) {
		                ++n; l += (cp < 0x80) ? 1 : (cp < 0x800) ? 2 : (cp < 0x10000) ? 3 : 4;
		            });
		            return [n,l];
		        };
	
		        return utfx;
		    }();
	
		    // encodings/utf8
	
		    /**
		     * Encodes this ByteBuffer's contents between {@link ByteBuffer#offset} and {@link ByteBuffer#limit} to an UTF8 encoded
		     *  string.
		     * @returns {string} Hex encoded string
		     * @throws {RangeError} If `offset > limit`
		     * @expose
		     */
		    ByteBufferPrototype.toUTF8 = function(begin, end) {
		        if (typeof begin === 'undefined') begin = this.offset;
		        if (typeof end === 'undefined') end = this.limit;
		        if (!this.noAssert) {
		            if (typeof begin !== 'number' || begin % 1 !== 0)
		                throw TypeError("Illegal begin: Not an integer");
		            begin >>>= 0;
		            if (typeof end !== 'number' || end % 1 !== 0)
		                throw TypeError("Illegal end: Not an integer");
		            end >>>= 0;
		            if (begin < 0 || begin > end || end > this.buffer.byteLength)
		                throw RangeError("Illegal range: 0 <= "+begin+" <= "+end+" <= "+this.buffer.byteLength);
		        }
		        var sd; try {
		            utfx.decodeUTF8toUTF16(function() {
		                return begin < end ? this.view[begin++] : null;
		            }.bind(this), sd = stringDestination());
		        } catch (e) {
		            if (begin !== end)
		                throw RangeError("Illegal range: Truncated data, "+begin+" != "+end);
		        }
		        return sd();
		    };
	
		    /**
		     * Decodes an UTF8 encoded string to a ByteBuffer.
		     * @param {string} str String to decode
		     * @param {boolean=} littleEndian Whether to use little or big endian byte order. Defaults to
		     *  {@link ByteBuffer.DEFAULT_ENDIAN}.
		     * @param {boolean=} noAssert Whether to skip assertions of offsets and values. Defaults to
		     *  {@link ByteBuffer.DEFAULT_NOASSERT}.
		     * @returns {!ByteBuffer} ByteBuffer
		     * @expose
		     */
		    ByteBuffer.fromUTF8 = function(str, littleEndian, noAssert) {
		        if (!noAssert)
		            if (typeof str !== 'string')
		                throw TypeError("Illegal str: Not a string");
		        var bb = new ByteBuffer(utfx.calculateUTF16asUTF8(stringSource(str), true)[1], littleEndian, noAssert),
		            i = 0;
		        utfx.encodeUTF16toUTF8(stringSource(str), function(b) {
		            bb.view[i++] = b;
		        });
		        bb.limit = i;
		        return bb;
		    };
	
		    return ByteBuffer;
		});
		});
	
		var require$$2$8 = (bytebuffer && typeof bytebuffer === 'object' && 'default' in bytebuffer ? bytebuffer['default'] : bytebuffer);
	
		var protobufLight = createCommonjsModule(function (module) {
		/*
		 Copyright 2013 Daniel Wirtz <dcode@dcode.io>
	
		 Licensed under the Apache License, Version 2.0 (the "License");
		 you may not use this file except in compliance with the License.
		 You may obtain a copy of the License at
	
		 http://www.apache.org/licenses/LICENSE-2.0
	
		 Unless required by applicable law or agreed to in writing, software
		 distributed under the License is distributed on an "AS IS" BASIS,
		 WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
		 See the License for the specific language governing permissions and
		 limitations under the License.
		 */
	
		/**
		 * @license protobuf.js (c) 2013 Daniel Wirtz <dcode@dcode.io>
		 * Released under the Apache License, Version 2.0
		 * see: https://github.com/dcodeIO/protobuf.js for details
		 */
		(function(global, factory) {
	
		    /* AMD */ if (typeof define === 'function' && define["amd"])
		        define(["bytebuffer"], factory);
		    /* CommonJS */ else if ('function' === "function" && typeof module === "object" && module && module["exports"])
		        module["exports"] = factory(require$$2$8, true);
		    /* Global */ else
		        (global["dcodeIO"] = global["dcodeIO"] || {})["ProtoBuf"] = factory(global["dcodeIO"]["ByteBuffer"]);
	
		})(commonjsGlobal, function(ByteBuffer, isCommonJS) {
		    "use strict";
	
		    /**
		     * The ProtoBuf namespace.
		     * @exports ProtoBuf
		     * @namespace
		     * @expose
		     */
		    var ProtoBuf = {};
	
		    /**
		     * @type {!function(new: ByteBuffer, ...[*])}
		     * @expose
		     */
		    ProtoBuf.ByteBuffer = ByteBuffer;
	
		    /**
		     * @type {?function(new: Long, ...[*])}
		     * @expose
		     */
		    ProtoBuf.Long = ByteBuffer.Long || null;
	
		    /**
		     * ProtoBuf.js version.
		     * @type {string}
		     * @const
		     * @expose
		     */
		    ProtoBuf.VERSION = "5.0.1";
	
		    /**
		     * Wire types.
		     * @type {Object.<string,number>}
		     * @const
		     * @expose
		     */
		    ProtoBuf.WIRE_TYPES = {};
	
		    /**
		     * Varint wire type.
		     * @type {number}
		     * @expose
		     */
		    ProtoBuf.WIRE_TYPES.VARINT = 0;
	
		    /**
		     * Fixed 64 bits wire type.
		     * @type {number}
		     * @const
		     * @expose
		     */
		    ProtoBuf.WIRE_TYPES.BITS64 = 1;
	
		    /**
		     * Length delimited wire type.
		     * @type {number}
		     * @const
		     * @expose
		     */
		    ProtoBuf.WIRE_TYPES.LDELIM = 2;
	
		    /**
		     * Start group wire type.
		     * @type {number}
		     * @const
		     * @expose
		     */
		    ProtoBuf.WIRE_TYPES.STARTGROUP = 3;
	
		    /**
		     * End group wire type.
		     * @type {number}
		     * @const
		     * @expose
		     */
		    ProtoBuf.WIRE_TYPES.ENDGROUP = 4;
	
		    /**
		     * Fixed 32 bits wire type.
		     * @type {number}
		     * @const
		     * @expose
		     */
		    ProtoBuf.WIRE_TYPES.BITS32 = 5;
	
		    /**
		     * Packable wire types.
		     * @type {!Array.<number>}
		     * @const
		     * @expose
		     */
		    ProtoBuf.PACKABLE_WIRE_TYPES = [
		        ProtoBuf.WIRE_TYPES.VARINT,
		        ProtoBuf.WIRE_TYPES.BITS64,
		        ProtoBuf.WIRE_TYPES.BITS32
		    ];
	
		    /**
		     * Types.
		     * @dict
		     * @type {!Object.<string,{name: string, wireType: number, defaultValue: *}>}
		     * @const
		     * @expose
		     */
		    ProtoBuf.TYPES = {
		        // According to the protobuf spec.
		        "int32": {
		            name: "int32",
		            wireType: ProtoBuf.WIRE_TYPES.VARINT,
		            defaultValue: 0
		        },
		        "uint32": {
		            name: "uint32",
		            wireType: ProtoBuf.WIRE_TYPES.VARINT,
		            defaultValue: 0
		        },
		        "sint32": {
		            name: "sint32",
		            wireType: ProtoBuf.WIRE_TYPES.VARINT,
		            defaultValue: 0
		        },
		        "int64": {
		            name: "int64",
		            wireType: ProtoBuf.WIRE_TYPES.VARINT,
		            defaultValue: ProtoBuf.Long ? ProtoBuf.Long.ZERO : undefined
		        },
		        "uint64": {
		            name: "uint64",
		            wireType: ProtoBuf.WIRE_TYPES.VARINT,
		            defaultValue: ProtoBuf.Long ? ProtoBuf.Long.UZERO : undefined
		        },
		        "sint64": {
		            name: "sint64",
		            wireType: ProtoBuf.WIRE_TYPES.VARINT,
		            defaultValue: ProtoBuf.Long ? ProtoBuf.Long.ZERO : undefined
		        },
		        "bool": {
		            name: "bool",
		            wireType: ProtoBuf.WIRE_TYPES.VARINT,
		            defaultValue: false
		        },
		        "double": {
		            name: "double",
		            wireType: ProtoBuf.WIRE_TYPES.BITS64,
		            defaultValue: 0
		        },
		        "string": {
		            name: "string",
		            wireType: ProtoBuf.WIRE_TYPES.LDELIM,
		            defaultValue: ""
		        },
		        "bytes": {
		            name: "bytes",
		            wireType: ProtoBuf.WIRE_TYPES.LDELIM,
		            defaultValue: null // overridden in the code, must be a unique instance
		        },
		        "fixed32": {
		            name: "fixed32",
		            wireType: ProtoBuf.WIRE_TYPES.BITS32,
		            defaultValue: 0
		        },
		        "sfixed32": {
		            name: "sfixed32",
		            wireType: ProtoBuf.WIRE_TYPES.BITS32,
		            defaultValue: 0
		        },
		        "fixed64": {
		            name: "fixed64",
		            wireType: ProtoBuf.WIRE_TYPES.BITS64,
		            defaultValue:  ProtoBuf.Long ? ProtoBuf.Long.UZERO : undefined
		        },
		        "sfixed64": {
		            name: "sfixed64",
		            wireType: ProtoBuf.WIRE_TYPES.BITS64,
		            defaultValue: ProtoBuf.Long ? ProtoBuf.Long.ZERO : undefined
		        },
		        "float": {
		            name: "float",
		            wireType: ProtoBuf.WIRE_TYPES.BITS32,
		            defaultValue: 0
		        },
		        "enum": {
		            name: "enum",
		            wireType: ProtoBuf.WIRE_TYPES.VARINT,
		            defaultValue: 0
		        },
		        "message": {
		            name: "message",
		            wireType: ProtoBuf.WIRE_TYPES.LDELIM,
		            defaultValue: null
		        },
		        "group": {
		            name: "group",
		            wireType: ProtoBuf.WIRE_TYPES.STARTGROUP,
		            defaultValue: null
		        }
		    };
	
		    /**
		     * Valid map key types.
		     * @type {!Array.<!Object.<string,{name: string, wireType: number, defaultValue: *}>>}
		     * @const
		     * @expose
		     */
		    ProtoBuf.MAP_KEY_TYPES = [
		        ProtoBuf.TYPES["int32"],
		        ProtoBuf.TYPES["sint32"],
		        ProtoBuf.TYPES["sfixed32"],
		        ProtoBuf.TYPES["uint32"],
		        ProtoBuf.TYPES["fixed32"],
		        ProtoBuf.TYPES["int64"],
		        ProtoBuf.TYPES["sint64"],
		        ProtoBuf.TYPES["sfixed64"],
		        ProtoBuf.TYPES["uint64"],
		        ProtoBuf.TYPES["fixed64"],
		        ProtoBuf.TYPES["bool"],
		        ProtoBuf.TYPES["string"],
		        ProtoBuf.TYPES["bytes"]
		    ];
	
		    /**
		     * Minimum field id.
		     * @type {number}
		     * @const
		     * @expose
		     */
		    ProtoBuf.ID_MIN = 1;
	
		    /**
		     * Maximum field id.
		     * @type {number}
		     * @const
		     * @expose
		     */
		    ProtoBuf.ID_MAX = 0x1FFFFFFF;
	
		    /**
		     * If set to `true`, field names will be converted from underscore notation to camel case. Defaults to `false`.
		     *  Must be set prior to parsing.
		     * @type {boolean}
		     * @expose
		     */
		    ProtoBuf.convertFieldsToCamelCase = false;
	
		    /**
		     * By default, messages are populated with (setX, set_x) accessors for each field. This can be disabled by
		     *  setting this to `false` prior to building messages.
		     * @type {boolean}
		     * @expose
		     */
		    ProtoBuf.populateAccessors = true;
	
		    /**
		     * By default, messages are populated with default values if a field is not present on the wire. To disable
		     *  this behavior, set this setting to `false`.
		     * @type {boolean}
		     * @expose
		     */
		    ProtoBuf.populateDefaults = true;
	
		    /**
		     * @alias ProtoBuf.Util
		     * @expose
		     */
		    ProtoBuf.Util = (function() {
		        "use strict";
	
		        /**
		         * ProtoBuf utilities.
		         * @exports ProtoBuf.Util
		         * @namespace
		         */
		        var Util = {};
	
		        /**
		         * Flag if running in node or not.
		         * @type {boolean}
		         * @const
		         * @expose
		         */
		        Util.IS_NODE = !!(
		            typeof process === 'object' && process+'' === '[object process]' && !process['browser']
		        );
	
		        /**
		         * Constructs a XMLHttpRequest object.
		         * @return {XMLHttpRequest}
		         * @throws {Error} If XMLHttpRequest is not supported
		         * @expose
		         */
		        Util.XHR = function() {
		            // No dependencies please, ref: http://www.quirksmode.org/js/xmlhttp.html
		            var XMLHttpFactories = [
		                function () {return new XMLHttpRequest()},
		                function () {return new ActiveXObject("Msxml2.XMLHTTP")},
		                function () {return new ActiveXObject("Msxml3.XMLHTTP")},
		                function () {return new ActiveXObject("Microsoft.XMLHTTP")}
		            ];
		            /** @type {?XMLHttpRequest} */
		            var xhr = null;
		            for (var i=0;i<XMLHttpFactories.length;i++) {
		                try { xhr = XMLHttpFactories[i](); }
		                catch (e) { continue; }
		                break;
		            }
		            if (!xhr)
		                throw Error("XMLHttpRequest is not supported");
		            return xhr;
		        };
	
		        /**
		         * Fetches a resource.
		         * @param {string} path Resource path
		         * @param {function(?string)=} callback Callback receiving the resource's contents. If omitted the resource will
		         *   be fetched synchronously. If the request failed, contents will be null.
		         * @return {?string|undefined} Resource contents if callback is omitted (null if the request failed), else undefined.
		         * @expose
		         */
		        Util.fetch = function(path, callback) {
		            if (callback && typeof callback != 'function')
		                callback = null;
		            if (Util.IS_NODE) {
		                var fs = require$$1$22;
		                if (callback) {
		                    fs.readFile(path, function(err, data) {
		                        if (err)
		                            callback(null);
		                        else
		                            callback(""+data);
		                    });
		                } else
		                    try {
		                        return fs.readFileSync(path);
		                    } catch (e) {
		                        return null;
		                    }
		            } else {
		                var xhr = Util.XHR();
		                xhr.open('GET', path, callback ? true : false);
		                // xhr.setRequestHeader('User-Agent', 'XMLHTTP/1.0');
		                xhr.setRequestHeader('Accept', 'text/plain');
		                if (typeof xhr.overrideMimeType === 'function') xhr.overrideMimeType('text/plain');
		                if (callback) {
		                    xhr.onreadystatechange = function() {
		                        if (xhr.readyState != 4) return;
		                        if (/* remote */ xhr.status == 200 || /* local */ (xhr.status == 0 && typeof xhr.responseText === 'string'))
		                            callback(xhr.responseText);
		                        else
		                            callback(null);
		                    };
		                    if (xhr.readyState == 4)
		                        return;
		                    xhr.send(null);
		                } else {
		                    xhr.send(null);
		                    if (/* remote */ xhr.status == 200 || /* local */ (xhr.status == 0 && typeof xhr.responseText === 'string'))
		                        return xhr.responseText;
		                    return null;
		                }
		            }
		        };
	
		        /**
		         * Converts a string to camel case.
		         * @param {string} str
		         * @returns {string}
		         * @expose
		         */
		        Util.toCamelCase = function(str) {
		            return str.replace(/_([a-zA-Z])/g, function ($0, $1) {
		                return $1.toUpperCase();
		            });
		        };
	
		        return Util;
		    })();
	
		    /**
		     * Language expressions.
		     * @type {!Object.<string,!RegExp>}
		     * @expose
		     */
		    ProtoBuf.Lang = {
	
		        // Characters always ending a statement
		        DELIM: /[\s\{\}=;:\[\],'"\(\)<>]/g,
	
		        // Field rules
		        RULE: /^(?:required|optional|repeated|map)$/,
	
		        // Field types
		        TYPE: /^(?:double|float|int32|uint32|sint32|int64|uint64|sint64|fixed32|sfixed32|fixed64|sfixed64|bool|string|bytes)$/,
	
		        // Names
		        NAME: /^[a-zA-Z_][a-zA-Z_0-9]*$/,
	
		        // Type definitions
		        TYPEDEF: /^[a-zA-Z][a-zA-Z_0-9]*$/,
	
		        // Type references
		        TYPEREF: /^(?:\.?[a-zA-Z_][a-zA-Z_0-9]*)+$/,
	
		        // Fully qualified type references
		        FQTYPEREF: /^(?:\.[a-zA-Z][a-zA-Z_0-9]*)+$/,
	
		        // All numbers
		        NUMBER: /^-?(?:[1-9][0-9]*|0|0[xX][0-9a-fA-F]+|0[0-7]+|([0-9]*(\.[0-9]*)?([Ee][+-]?[0-9]+)?)|inf|nan)$/,
	
		        // Decimal numbers
		        NUMBER_DEC: /^(?:[1-9][0-9]*|0)$/,
	
		        // Hexadecimal numbers
		        NUMBER_HEX: /^0[xX][0-9a-fA-F]+$/,
	
		        // Octal numbers
		        NUMBER_OCT: /^0[0-7]+$/,
	
		        // Floating point numbers
		        NUMBER_FLT: /^([0-9]*(\.[0-9]*)?([Ee][+-]?[0-9]+)?|inf|nan)$/,
	
		        // Booleans
		        BOOL: /^(?:true|false)$/i,
	
		        // Id numbers
		        ID: /^(?:[1-9][0-9]*|0|0[xX][0-9a-fA-F]+|0[0-7]+)$/,
	
		        // Negative id numbers (enum values)
		        NEGID: /^\-?(?:[1-9][0-9]*|0|0[xX][0-9a-fA-F]+|0[0-7]+)$/,
	
		        // Whitespaces
		        WHITESPACE: /\s/,
	
		        // All strings
		        STRING: /(?:"([^"\\]*(?:\\.[^"\\]*)*)")|(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g,
	
		        // Double quoted strings
		        STRING_DQ: /(?:"([^"\\]*(?:\\.[^"\\]*)*)")/g,
	
		        // Single quoted strings
		        STRING_SQ: /(?:'([^'\\]*(?:\\.[^'\\]*)*)')/g
		    };
	
	
		    /**
		     * @alias ProtoBuf.Reflect
		     * @expose
		     */
		    ProtoBuf.Reflect = (function(ProtoBuf) {
		        "use strict";
	
		        /**
		         * Reflection types.
		         * @exports ProtoBuf.Reflect
		         * @namespace
		         */
		        var Reflect = {};
	
		        /**
		         * Constructs a Reflect base class.
		         * @exports ProtoBuf.Reflect.T
		         * @constructor
		         * @abstract
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {?ProtoBuf.Reflect.T} parent Parent object
		         * @param {string} name Object name
		         */
		        var T = function(builder, parent, name) {
	
		            /**
		             * Builder reference.
		             * @type {!ProtoBuf.Builder}
		             * @expose
		             */
		            this.builder = builder;
	
		            /**
		             * Parent object.
		             * @type {?ProtoBuf.Reflect.T}
		             * @expose
		             */
		            this.parent = parent;
	
		            /**
		             * Object name in namespace.
		             * @type {string}
		             * @expose
		             */
		            this.name = name;
	
		            /**
		             * Fully qualified class name
		             * @type {string}
		             * @expose
		             */
		            this.className;
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.T.prototype
		         * @inner
		         */
		        var TPrototype = T.prototype;
	
		        /**
		         * Returns the fully qualified name of this object.
		         * @returns {string} Fully qualified name as of ".PATH.TO.THIS"
		         * @expose
		         */
		        TPrototype.fqn = function() {
		            var name = this.name,
		                ptr = this;
		            do {
		                ptr = ptr.parent;
		                if (ptr == null)
		                    break;
		                name = ptr.name+"."+name;
		            } while (true);
		            return name;
		        };
	
		        /**
		         * Returns a string representation of this Reflect object (its fully qualified name).
		         * @param {boolean=} includeClass Set to true to include the class name. Defaults to false.
		         * @return String representation
		         * @expose
		         */
		        TPrototype.toString = function(includeClass) {
		            return (includeClass ? this.className + " " : "") + this.fqn();
		        };
	
		        /**
		         * Builds this type.
		         * @throws {Error} If this type cannot be built directly
		         * @expose
		         */
		        TPrototype.build = function() {
		            throw Error(this.toString(true)+" cannot be built directly");
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.T
		         * @expose
		         */
		        Reflect.T = T;
	
		        /**
		         * Constructs a new Namespace.
		         * @exports ProtoBuf.Reflect.Namespace
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {?ProtoBuf.Reflect.Namespace} parent Namespace parent
		         * @param {string} name Namespace name
		         * @param {Object.<string,*>=} options Namespace options
		         * @param {string?} syntax The syntax level of this definition (e.g., proto3)
		         * @constructor
		         * @extends ProtoBuf.Reflect.T
		         */
		        var Namespace = function(builder, parent, name, options, syntax) {
		            T.call(this, builder, parent, name);
	
		            /**
		             * @override
		             */
		            this.className = "Namespace";
	
		            /**
		             * Children inside the namespace.
		             * @type {!Array.<ProtoBuf.Reflect.T>}
		             */
		            this.children = [];
	
		            /**
		             * Options.
		             * @type {!Object.<string, *>}
		             */
		            this.options = options || {};
	
		            /**
		             * Syntax level (e.g., proto2 or proto3).
		             * @type {!string}
		             */
		            this.syntax = syntax || "proto2";
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Namespace.prototype
		         * @inner
		         */
		        var NamespacePrototype = Namespace.prototype = Object.create(T.prototype);
	
		        /**
		         * Returns an array of the namespace's children.
		         * @param {ProtoBuf.Reflect.T=} type Filter type (returns instances of this type only). Defaults to null (all children).
		         * @return {Array.<ProtoBuf.Reflect.T>}
		         * @expose
		         */
		        NamespacePrototype.getChildren = function(type) {
		            type = type || null;
		            if (type == null)
		                return this.children.slice();
		            var children = [];
		            for (var i=0, k=this.children.length; i<k; ++i)
		                if (this.children[i] instanceof type)
		                    children.push(this.children[i]);
		            return children;
		        };
	
		        /**
		         * Adds a child to the namespace.
		         * @param {ProtoBuf.Reflect.T} child Child
		         * @throws {Error} If the child cannot be added (duplicate)
		         * @expose
		         */
		        NamespacePrototype.addChild = function(child) {
		            var other;
		            if (other = this.getChild(child.name)) {
		                // Try to revert camelcase transformation on collision
		                if (other instanceof Message.Field && other.name !== other.originalName && this.getChild(other.originalName) === null)
		                    other.name = other.originalName; // Revert previous first (effectively keeps both originals)
		                else if (child instanceof Message.Field && child.name !== child.originalName && this.getChild(child.originalName) === null)
		                    child.name = child.originalName;
		                else
		                    throw Error("Duplicate name in namespace "+this.toString(true)+": "+child.name);
		            }
		            this.children.push(child);
		        };
	
		        /**
		         * Gets a child by its name or id.
		         * @param {string|number} nameOrId Child name or id
		         * @return {?ProtoBuf.Reflect.T} The child or null if not found
		         * @expose
		         */
		        NamespacePrototype.getChild = function(nameOrId) {
		            var key = typeof nameOrId === 'number' ? 'id' : 'name';
		            for (var i=0, k=this.children.length; i<k; ++i)
		                if (this.children[i][key] === nameOrId)
		                    return this.children[i];
		            return null;
		        };
	
		        /**
		         * Resolves a reflect object inside of this namespace.
		         * @param {string|!Array.<string>} qn Qualified name to resolve
		         * @param {boolean=} excludeNonNamespace Excludes non-namespace types, defaults to `false`
		         * @return {?ProtoBuf.Reflect.Namespace} The resolved type or null if not found
		         * @expose
		         */
		        NamespacePrototype.resolve = function(qn, excludeNonNamespace) {
		            var part = typeof qn === 'string' ? qn.split(".") : qn,
		                ptr = this,
		                i = 0;
		            if (part[i] === "") { // Fully qualified name, e.g. ".My.Message'
		                while (ptr.parent !== null)
		                    ptr = ptr.parent;
		                i++;
		            }
		            var child;
		            do {
		                do {
		                    if (!(ptr instanceof Reflect.Namespace)) {
		                        ptr = null;
		                        break;
		                    }
		                    child = ptr.getChild(part[i]);
		                    if (!child || !(child instanceof Reflect.T) || (excludeNonNamespace && !(child instanceof Reflect.Namespace))) {
		                        ptr = null;
		                        break;
		                    }
		                    ptr = child; i++;
		                } while (i < part.length);
		                if (ptr != null)
		                    break; // Found
		                // Else search the parent
		                if (this.parent !== null)
		                    return this.parent.resolve(qn, excludeNonNamespace);
		            } while (ptr != null);
		            return ptr;
		        };
	
		        /**
		         * Determines the shortest qualified name of the specified type, if any, relative to this namespace.
		         * @param {!ProtoBuf.Reflect.T} t Reflection type
		         * @returns {string} The shortest qualified name or, if there is none, the fqn
		         * @expose
		         */
		        NamespacePrototype.qn = function(t) {
		            var part = [], ptr = t;
		            do {
		                part.unshift(ptr.name);
		                ptr = ptr.parent;
		            } while (ptr !== null);
		            for (var len=1; len <= part.length; len++) {
		                var qn = part.slice(part.length-len);
		                if (t === this.resolve(qn, t instanceof Reflect.Namespace))
		                    return qn.join(".");
		            }
		            return t.fqn();
		        };
	
		        /**
		         * Builds the namespace and returns the runtime counterpart.
		         * @return {Object.<string,Function|Object>} Runtime namespace
		         * @expose
		         */
		        NamespacePrototype.build = function() {
		            /** @dict */
		            var ns = {};
		            var children = this.children;
		            for (var i=0, k=children.length, child; i<k; ++i) {
		                child = children[i];
		                if (child instanceof Namespace)
		                    ns[child.name] = child.build();
		            }
		            if (Object.defineProperty)
		                Object.defineProperty(ns, "$options", { "value": this.buildOpt() });
		            return ns;
		        };
	
		        /**
		         * Builds the namespace's '$options' property.
		         * @return {Object.<string,*>}
		         */
		        NamespacePrototype.buildOpt = function() {
		            var opt = {},
		                keys = Object.keys(this.options);
		            for (var i=0, k=keys.length; i<k; ++i) {
		                var key = keys[i],
		                    val = this.options[keys[i]];
		                // TODO: Options are not resolved, yet.
		                // if (val instanceof Namespace) {
		                //     opt[key] = val.build();
		                // } else {
		                opt[key] = val;
		                // }
		            }
		            return opt;
		        };
	
		        /**
		         * Gets the value assigned to the option with the specified name.
		         * @param {string=} name Returns the option value if specified, otherwise all options are returned.
		         * @return {*|Object.<string,*>}null} Option value or NULL if there is no such option
		         */
		        NamespacePrototype.getOption = function(name) {
		            if (typeof name === 'undefined')
		                return this.options;
		            return typeof this.options[name] !== 'undefined' ? this.options[name] : null;
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Namespace
		         * @expose
		         */
		        Reflect.Namespace = Namespace;
	
		        /**
		         * Constructs a new Element implementation that checks and converts values for a
		         * particular field type, as appropriate.
		         *
		         * An Element represents a single value: either the value of a singular field,
		         * or a value contained in one entry of a repeated field or map field. This
		         * class does not implement these higher-level concepts; it only encapsulates
		         * the low-level typechecking and conversion.
		         *
		         * @exports ProtoBuf.Reflect.Element
		         * @param {{name: string, wireType: number}} type Resolved data type
		         * @param {ProtoBuf.Reflect.T|null} resolvedType Resolved type, if relevant
		         * (e.g. submessage field).
		         * @param {boolean} isMapKey Is this element a Map key? The value will be
		         * converted to string form if so.
		         * @param {string} syntax Syntax level of defining message type, e.g.,
		         * proto2 or proto3.
		         * @constructor
		         */
		        var Element = function(type, resolvedType, isMapKey, syntax) {
	
		            /**
		             * Element type, as a string (e.g., int32).
		             * @type {{name: string, wireType: number}}
		             */
		            this.type = type;
	
		            /**
		             * Element type reference to submessage or enum definition, if needed.
		             * @type {ProtoBuf.Reflect.T|null}
		             */
		            this.resolvedType = resolvedType;
	
		            /**
		             * Element is a map key.
		             * @type {boolean}
		             */
		            this.isMapKey = isMapKey;
	
		            /**
		             * Syntax level of defining message type, e.g., proto2 or proto3.
		             * @type {string}
		             */
		            this.syntax = syntax;
	
		            if (isMapKey && ProtoBuf.MAP_KEY_TYPES.indexOf(type) < 0)
		                throw Error("Invalid map key type: " + type.name);
		        };
	
		        var ElementPrototype = Element.prototype;
	
		        /**
		         * Obtains a (new) default value for the specified type.
		         * @param type {string|{name: string, wireType: number}} Field type
		         * @returns {*} Default value
		         * @inner
		         */
		        function mkDefault(type) {
		            if (typeof type === 'string')
		                type = ProtoBuf.TYPES[type];
		            if (typeof type.defaultValue === 'undefined')
		                throw Error("default value for type "+type.name+" is not supported");
		            if (type == ProtoBuf.TYPES["bytes"])
		                return new ByteBuffer(0);
		            return type.defaultValue;
		        }
	
		        /**
		         * Returns the default value for this field in proto3.
		         * @function
		         * @param type {string|{name: string, wireType: number}} the field type
		         * @returns {*} Default value
		         */
		        Element.defaultFieldValue = mkDefault;
	
		        /**
		         * Makes a Long from a value.
		         * @param {{low: number, high: number, unsigned: boolean}|string|number} value Value
		         * @param {boolean=} unsigned Whether unsigned or not, defaults to reuse it from Long-like objects or to signed for
		         *  strings and numbers
		         * @returns {!Long}
		         * @throws {Error} If the value cannot be converted to a Long
		         * @inner
		         */
		        function mkLong(value, unsigned) {
		            if (value && typeof value.low === 'number' && typeof value.high === 'number' && typeof value.unsigned === 'boolean'
		                && value.low === value.low && value.high === value.high)
		                return new ProtoBuf.Long(value.low, value.high, typeof unsigned === 'undefined' ? value.unsigned : unsigned);
		            if (typeof value === 'string')
		                return ProtoBuf.Long.fromString(value, unsigned || false, 10);
		            if (typeof value === 'number')
		                return ProtoBuf.Long.fromNumber(value, unsigned || false);
		            throw Error("not convertible to Long");
		        }
	
		        /**
		         * Checks if the given value can be set for an element of this type (singular
		         * field or one element of a repeated field or map).
		         * @param {*} value Value to check
		         * @return {*} Verified, maybe adjusted, value
		         * @throws {Error} If the value cannot be verified for this element slot
		         * @expose
		         */
		        ElementPrototype.verifyValue = function(value) {
		            var self = this;
		            function fail(val, msg) {
		                throw Error("Illegal value for "+self.toString(true)+" of type "+self.type.name+": "+val+" ("+msg+")");
		            }
		            switch (this.type) {
		                // Signed 32bit
		                case ProtoBuf.TYPES["int32"]:
		                case ProtoBuf.TYPES["sint32"]:
		                case ProtoBuf.TYPES["sfixed32"]:
		                    // Account for !NaN: value === value
		                    if (typeof value !== 'number' || (value === value && value % 1 !== 0))
		                        fail(typeof value, "not an integer");
		                    return value > 4294967295 ? value | 0 : value;
	
		                // Unsigned 32bit
		                case ProtoBuf.TYPES["uint32"]:
		                case ProtoBuf.TYPES["fixed32"]:
		                    if (typeof value !== 'number' || (value === value && value % 1 !== 0))
		                        fail(typeof value, "not an integer");
		                    return value < 0 ? value >>> 0 : value;
	
		                // Signed 64bit
		                case ProtoBuf.TYPES["int64"]:
		                case ProtoBuf.TYPES["sint64"]:
		                case ProtoBuf.TYPES["sfixed64"]: {
		                    if (ProtoBuf.Long)
		                        try {
		                            return mkLong(value, false);
		                        } catch (e) {
		                            fail(typeof value, e.message);
		                        }
		                    else
		                        fail(typeof value, "requires Long.js");
		                }
	
		                // Unsigned 64bit
		                case ProtoBuf.TYPES["uint64"]:
		                case ProtoBuf.TYPES["fixed64"]: {
		                    if (ProtoBuf.Long)
		                        try {
		                            return mkLong(value, true);
		                        } catch (e) {
		                            fail(typeof value, e.message);
		                        }
		                    else
		                        fail(typeof value, "requires Long.js");
		                }
	
		                // Bool
		                case ProtoBuf.TYPES["bool"]:
		                    if (typeof value !== 'boolean')
		                        fail(typeof value, "not a boolean");
		                    return value;
	
		                // Float
		                case ProtoBuf.TYPES["float"]:
		                case ProtoBuf.TYPES["double"]:
		                    if (typeof value !== 'number')
		                        fail(typeof value, "not a number");
		                    return value;
	
		                // Length-delimited string
		                case ProtoBuf.TYPES["string"]:
		                    if (typeof value !== 'string' && !(value && value instanceof String))
		                        fail(typeof value, "not a string");
		                    return ""+value; // Convert String object to string
	
		                // Length-delimited bytes
		                case ProtoBuf.TYPES["bytes"]:
		                    if (ByteBuffer.isByteBuffer(value))
		                        return value;
		                    return ByteBuffer.wrap(value, "base64");
	
		                // Constant enum value
		                case ProtoBuf.TYPES["enum"]: {
		                    var values = this.resolvedType.getChildren(ProtoBuf.Reflect.Enum.Value);
		                    for (i=0; i<values.length; i++)
		                        if (values[i].name == value)
		                            return values[i].id;
		                        else if (values[i].id == value)
		                            return values[i].id;
	
		                    if (this.syntax === 'proto3') {
		                        // proto3: just make sure it's an integer.
		                        if (typeof value !== 'number' || (value === value && value % 1 !== 0))
		                            fail(typeof value, "not an integer");
		                        if (value > 4294967295 || value < 0)
		                            fail(typeof value, "not in range for uint32")
		                        return value;
		                    } else {
		                        // proto2 requires enum values to be valid.
		                        fail(value, "not a valid enum value");
		                    }
		                }
		                // Embedded message
		                case ProtoBuf.TYPES["group"]:
		                case ProtoBuf.TYPES["message"]: {
		                    if (!value || typeof value !== 'object')
		                        fail(typeof value, "object expected");
		                    if (value instanceof this.resolvedType.clazz)
		                        return value;
		                    if (value instanceof ProtoBuf.Builder.Message) {
		                        // Mismatched type: Convert to object (see: https://github.com/dcodeIO/ProtoBuf.js/issues/180)
		                        var obj = {};
		                        for (var i in value)
		                            if (value.hasOwnProperty(i))
		                                obj[i] = value[i];
		                        value = obj;
		                    }
		                    // Else let's try to construct one from a key-value object
		                    return new (this.resolvedType.clazz)(value); // May throw for a hundred of reasons
		                }
		            }
	
		            // We should never end here
		            throw Error("[INTERNAL] Illegal value for "+this.toString(true)+": "+value+" (undefined type "+this.type+")");
		        };
	
		        /**
		         * Calculates the byte length of an element on the wire.
		         * @param {number} id Field number
		         * @param {*} value Field value
		         * @returns {number} Byte length
		         * @throws {Error} If the value cannot be calculated
		         * @expose
		         */
		        ElementPrototype.calculateLength = function(id, value) {
		            if (value === null) return 0; // Nothing to encode
		            // Tag has already been written
		            var n;
		            switch (this.type) {
		                case ProtoBuf.TYPES["int32"]:
		                    return value < 0 ? ByteBuffer.calculateVarint64(value) : ByteBuffer.calculateVarint32(value);
		                case ProtoBuf.TYPES["uint32"]:
		                    return ByteBuffer.calculateVarint32(value);
		                case ProtoBuf.TYPES["sint32"]:
		                    return ByteBuffer.calculateVarint32(ByteBuffer.zigZagEncode32(value));
		                case ProtoBuf.TYPES["fixed32"]:
		                case ProtoBuf.TYPES["sfixed32"]:
		                case ProtoBuf.TYPES["float"]:
		                    return 4;
		                case ProtoBuf.TYPES["int64"]:
		                case ProtoBuf.TYPES["uint64"]:
		                    return ByteBuffer.calculateVarint64(value);
		                case ProtoBuf.TYPES["sint64"]:
		                    return ByteBuffer.calculateVarint64(ByteBuffer.zigZagEncode64(value));
		                case ProtoBuf.TYPES["fixed64"]:
		                case ProtoBuf.TYPES["sfixed64"]:
		                    return 8;
		                case ProtoBuf.TYPES["bool"]:
		                    return 1;
		                case ProtoBuf.TYPES["enum"]:
		                    return ByteBuffer.calculateVarint32(value);
		                case ProtoBuf.TYPES["double"]:
		                    return 8;
		                case ProtoBuf.TYPES["string"]:
		                    n = ByteBuffer.calculateUTF8Bytes(value);
		                    return ByteBuffer.calculateVarint32(n) + n;
		                case ProtoBuf.TYPES["bytes"]:
		                    if (value.remaining() < 0)
		                        throw Error("Illegal value for "+this.toString(true)+": "+value.remaining()+" bytes remaining");
		                    return ByteBuffer.calculateVarint32(value.remaining()) + value.remaining();
		                case ProtoBuf.TYPES["message"]:
		                    n = this.resolvedType.calculate(value);
		                    return ByteBuffer.calculateVarint32(n) + n;
		                case ProtoBuf.TYPES["group"]:
		                    n = this.resolvedType.calculate(value);
		                    return n + ByteBuffer.calculateVarint32((id << 3) | ProtoBuf.WIRE_TYPES.ENDGROUP);
		            }
		            // We should never end here
		            throw Error("[INTERNAL] Illegal value to encode in "+this.toString(true)+": "+value+" (unknown type)");
		        };
	
		        /**
		         * Encodes a value to the specified buffer. Does not encode the key.
		         * @param {number} id Field number
		         * @param {*} value Field value
		         * @param {ByteBuffer} buffer ByteBuffer to encode to
		         * @return {ByteBuffer} The ByteBuffer for chaining
		         * @throws {Error} If the value cannot be encoded
		         * @expose
		         */
		        ElementPrototype.encodeValue = function(id, value, buffer) {
		            if (value === null) return buffer; // Nothing to encode
		            // Tag has already been written
	
		            switch (this.type) {
		                // 32bit signed varint
		                case ProtoBuf.TYPES["int32"]:
		                    // "If you use int32 or int64 as the type for a negative number, the resulting varint is always ten bytes
		                    // long – it is, effectively, treated like a very large unsigned integer." (see #122)
		                    if (value < 0)
		                        buffer.writeVarint64(value);
		                    else
		                        buffer.writeVarint32(value);
		                    break;
	
		                // 32bit unsigned varint
		                case ProtoBuf.TYPES["uint32"]:
		                    buffer.writeVarint32(value);
		                    break;
	
		                // 32bit varint zig-zag
		                case ProtoBuf.TYPES["sint32"]:
		                    buffer.writeVarint32ZigZag(value);
		                    break;
	
		                // Fixed unsigned 32bit
		                case ProtoBuf.TYPES["fixed32"]:
		                    buffer.writeUint32(value);
		                    break;
	
		                // Fixed signed 32bit
		                case ProtoBuf.TYPES["sfixed32"]:
		                    buffer.writeInt32(value);
		                    break;
	
		                // 64bit varint as-is
		                case ProtoBuf.TYPES["int64"]:
		                case ProtoBuf.TYPES["uint64"]:
		                    buffer.writeVarint64(value); // throws
		                    break;
	
		                // 64bit varint zig-zag
		                case ProtoBuf.TYPES["sint64"]:
		                    buffer.writeVarint64ZigZag(value); // throws
		                    break;
	
		                // Fixed unsigned 64bit
		                case ProtoBuf.TYPES["fixed64"]:
		                    buffer.writeUint64(value); // throws
		                    break;
	
		                // Fixed signed 64bit
		                case ProtoBuf.TYPES["sfixed64"]:
		                    buffer.writeInt64(value); // throws
		                    break;
	
		                // Bool
		                case ProtoBuf.TYPES["bool"]:
		                    if (typeof value === 'string')
		                        buffer.writeVarint32(value.toLowerCase() === 'false' ? 0 : !!value);
		                    else
		                        buffer.writeVarint32(value ? 1 : 0);
		                    break;
	
		                // Constant enum value
		                case ProtoBuf.TYPES["enum"]:
		                    buffer.writeVarint32(value);
		                    break;
	
		                // 32bit float
		                case ProtoBuf.TYPES["float"]:
		                    buffer.writeFloat32(value);
		                    break;
	
		                // 64bit float
		                case ProtoBuf.TYPES["double"]:
		                    buffer.writeFloat64(value);
		                    break;
	
		                // Length-delimited string
		                case ProtoBuf.TYPES["string"]:
		                    buffer.writeVString(value);
		                    break;
	
		                // Length-delimited bytes
		                case ProtoBuf.TYPES["bytes"]:
		                    if (value.remaining() < 0)
		                        throw Error("Illegal value for "+this.toString(true)+": "+value.remaining()+" bytes remaining");
		                    var prevOffset = value.offset;
		                    buffer.writeVarint32(value.remaining());
		                    buffer.append(value);
		                    value.offset = prevOffset;
		                    break;
	
		                // Embedded message
		                case ProtoBuf.TYPES["message"]:
		                    var bb = new ByteBuffer().LE();
		                    this.resolvedType.encode(value, bb);
		                    buffer.writeVarint32(bb.offset);
		                    buffer.append(bb.flip());
		                    break;
	
		                // Legacy group
		                case ProtoBuf.TYPES["group"]:
		                    this.resolvedType.encode(value, buffer);
		                    buffer.writeVarint32((id << 3) | ProtoBuf.WIRE_TYPES.ENDGROUP);
		                    break;
	
		                default:
		                    // We should never end here
		                    throw Error("[INTERNAL] Illegal value to encode in "+this.toString(true)+": "+value+" (unknown type)");
		            }
		            return buffer;
		        };
	
		        /**
		         * Decode one element value from the specified buffer.
		         * @param {ByteBuffer} buffer ByteBuffer to decode from
		         * @param {number} wireType The field wire type
		         * @param {number} id The field number
		         * @return {*} Decoded value
		         * @throws {Error} If the field cannot be decoded
		         * @expose
		         */
		        ElementPrototype.decode = function(buffer, wireType, id) {
		            if (wireType != this.type.wireType)
		                throw Error("Unexpected wire type for element");
	
		            var value, nBytes;
		            switch (this.type) {
		                // 32bit signed varint
		                case ProtoBuf.TYPES["int32"]:
		                    return buffer.readVarint32() | 0;
	
		                // 32bit unsigned varint
		                case ProtoBuf.TYPES["uint32"]:
		                    return buffer.readVarint32() >>> 0;
	
		                // 32bit signed varint zig-zag
		                case ProtoBuf.TYPES["sint32"]:
		                    return buffer.readVarint32ZigZag() | 0;
	
		                // Fixed 32bit unsigned
		                case ProtoBuf.TYPES["fixed32"]:
		                    return buffer.readUint32() >>> 0;
	
		                case ProtoBuf.TYPES["sfixed32"]:
		                    return buffer.readInt32() | 0;
	
		                // 64bit signed varint
		                case ProtoBuf.TYPES["int64"]:
		                    return buffer.readVarint64();
	
		                // 64bit unsigned varint
		                case ProtoBuf.TYPES["uint64"]:
		                    return buffer.readVarint64().toUnsigned();
	
		                // 64bit signed varint zig-zag
		                case ProtoBuf.TYPES["sint64"]:
		                    return buffer.readVarint64ZigZag();
	
		                // Fixed 64bit unsigned
		                case ProtoBuf.TYPES["fixed64"]:
		                    return buffer.readUint64();
	
		                // Fixed 64bit signed
		                case ProtoBuf.TYPES["sfixed64"]:
		                    return buffer.readInt64();
	
		                // Bool varint
		                case ProtoBuf.TYPES["bool"]:
		                    return !!buffer.readVarint32();
	
		                // Constant enum value (varint)
		                case ProtoBuf.TYPES["enum"]:
		                    // The following Builder.Message#set will already throw
		                    return buffer.readVarint32();
	
		                // 32bit float
		                case ProtoBuf.TYPES["float"]:
		                    return buffer.readFloat();
	
		                // 64bit float
		                case ProtoBuf.TYPES["double"]:
		                    return buffer.readDouble();
	
		                // Length-delimited string
		                case ProtoBuf.TYPES["string"]:
		                    return buffer.readVString();
	
		                // Length-delimited bytes
		                case ProtoBuf.TYPES["bytes"]: {
		                    nBytes = buffer.readVarint32();
		                    if (buffer.remaining() < nBytes)
		                        throw Error("Illegal number of bytes for "+this.toString(true)+": "+nBytes+" required but got only "+buffer.remaining());
		                    value = buffer.clone(); // Offset already set
		                    value.limit = value.offset+nBytes;
		                    buffer.offset += nBytes;
		                    return value;
		                }
	
		                // Length-delimited embedded message
		                case ProtoBuf.TYPES["message"]: {
		                    nBytes = buffer.readVarint32();
		                    return this.resolvedType.decode(buffer, nBytes);
		                }
	
		                // Legacy group
		                case ProtoBuf.TYPES["group"]:
		                    return this.resolvedType.decode(buffer, -1, id);
		            }
	
		            // We should never end here
		            throw Error("[INTERNAL] Illegal decode type");
		        };
	
		        /**
		         * Converts a value from a string to the canonical element type.
		         *
		         * Legal only when isMapKey is true.
		         *
		         * @param {string} str The string value
		         * @returns {*} The value
		         */
		        ElementPrototype.valueFromString = function(str) {
		            if (!this.isMapKey) {
		                throw Error("valueFromString() called on non-map-key element");
		            }
	
		            switch (this.type) {
		                case ProtoBuf.TYPES["int32"]:
		                case ProtoBuf.TYPES["sint32"]:
		                case ProtoBuf.TYPES["sfixed32"]:
		                case ProtoBuf.TYPES["uint32"]:
		                case ProtoBuf.TYPES["fixed32"]:
		                    return this.verifyValue(parseInt(str));
	
		                case ProtoBuf.TYPES["int64"]:
		                case ProtoBuf.TYPES["sint64"]:
		                case ProtoBuf.TYPES["sfixed64"]:
		                case ProtoBuf.TYPES["uint64"]:
		                case ProtoBuf.TYPES["fixed64"]:
		                      // Long-based fields support conversions from string already.
		                      return this.verifyValue(str);
	
		                case ProtoBuf.TYPES["bool"]:
		                      return str === "true";
	
		                case ProtoBuf.TYPES["string"]:
		                      return this.verifyValue(str);
	
		                case ProtoBuf.TYPES["bytes"]:
		                      return ByteBuffer.fromBinary(str);
		            }
		        };
	
		        /**
		         * Converts a value from the canonical element type to a string.
		         *
		         * It should be the case that `valueFromString(valueToString(val))` returns
		         * a value equivalent to `verifyValue(val)` for every legal value of `val`
		         * according to this element type.
		         *
		         * This may be used when the element must be stored or used as a string,
		         * e.g., as a map key on an Object.
		         *
		         * Legal only when isMapKey is true.
		         *
		         * @param {*} val The value
		         * @returns {string} The string form of the value.
		         */
		        ElementPrototype.valueToString = function(value) {
		            if (!this.isMapKey) {
		                throw Error("valueToString() called on non-map-key element");
		            }
	
		            if (this.type === ProtoBuf.TYPES["bytes"]) {
		                return value.toString("binary");
		            } else {
		                return value.toString();
		            }
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Element
		         * @expose
		         */
		        Reflect.Element = Element;
	
		        /**
		         * Constructs a new Message.
		         * @exports ProtoBuf.Reflect.Message
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.Namespace} parent Parent message or namespace
		         * @param {string} name Message name
		         * @param {Object.<string,*>=} options Message options
		         * @param {boolean=} isGroup `true` if this is a legacy group
		         * @param {string?} syntax The syntax level of this definition (e.g., proto3)
		         * @constructor
		         * @extends ProtoBuf.Reflect.Namespace
		         */
		        var Message = function(builder, parent, name, options, isGroup, syntax) {
		            Namespace.call(this, builder, parent, name, options, syntax);
	
		            /**
		             * @override
		             */
		            this.className = "Message";
	
		            /**
		             * Extensions range.
		             * @type {!Array.<number>|undefined}
		             * @expose
		             */
		            this.extensions = undefined;
	
		            /**
		             * Runtime message class.
		             * @type {?function(new:ProtoBuf.Builder.Message)}
		             * @expose
		             */
		            this.clazz = null;
	
		            /**
		             * Whether this is a legacy group or not.
		             * @type {boolean}
		             * @expose
		             */
		            this.isGroup = !!isGroup;
	
		            // The following cached collections are used to efficiently iterate over or look up fields when decoding.
	
		            /**
		             * Cached fields.
		             * @type {?Array.<!ProtoBuf.Reflect.Message.Field>}
		             * @private
		             */
		            this._fields = null;
	
		            /**
		             * Cached fields by id.
		             * @type {?Object.<number,!ProtoBuf.Reflect.Message.Field>}
		             * @private
		             */
		            this._fieldsById = null;
	
		            /**
		             * Cached fields by name.
		             * @type {?Object.<string,!ProtoBuf.Reflect.Message.Field>}
		             * @private
		             */
		            this._fieldsByName = null;
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Message.prototype
		         * @inner
		         */
		        var MessagePrototype = Message.prototype = Object.create(Namespace.prototype);
	
		        /**
		         * Builds the message and returns the runtime counterpart, which is a fully functional class.
		         * @see ProtoBuf.Builder.Message
		         * @param {boolean=} rebuild Whether to rebuild or not, defaults to false
		         * @return {ProtoBuf.Reflect.Message} Message class
		         * @throws {Error} If the message cannot be built
		         * @expose
		         */
		        MessagePrototype.build = function(rebuild) {
		            if (this.clazz && !rebuild)
		                return this.clazz;
	
		            // Create the runtime Message class in its own scope
		            var clazz = (function(ProtoBuf, T) {
	
		                var fields = T.getChildren(ProtoBuf.Reflect.Message.Field),
		                    oneofs = T.getChildren(ProtoBuf.Reflect.Message.OneOf);
	
		                /**
		                 * Constructs a new runtime Message.
		                 * @name ProtoBuf.Builder.Message
		                 * @class Barebone of all runtime messages.
		                 * @param {!Object.<string,*>|string} values Preset values
		                 * @param {...string} var_args
		                 * @constructor
		                 * @throws {Error} If the message cannot be created
		                 */
		                var Message = function(values, var_args) {
		                    ProtoBuf.Builder.Message.call(this);
	
		                    // Create virtual oneof properties
		                    for (var i=0, k=oneofs.length; i<k; ++i)
		                        this[oneofs[i].name] = null;
		                    // Create fields and set default values
		                    for (i=0, k=fields.length; i<k; ++i) {
		                        var field = fields[i];
		                        this[field.name] =
		                            field.repeated ? [] :
		                            (field.map ? new ProtoBuf.Map(field) : null);
		                        if ((field.required || T.syntax === 'proto3') &&
		                            field.defaultValue !== null)
		                            this[field.name] = field.defaultValue;
		                    }
	
		                    if (arguments.length > 0) {
		                        var value;
		                        // Set field values from a values object
		                        if (arguments.length === 1 && values !== null && typeof values === 'object' &&
		                            /* not _another_ Message */ (typeof values.encode !== 'function' || values instanceof Message) &&
		                            /* not a repeated field */ !Array.isArray(values) &&
		                            /* not a Map */ !(values instanceof ProtoBuf.Map) &&
		                            /* not a ByteBuffer */ !ByteBuffer.isByteBuffer(values) &&
		                            /* not an ArrayBuffer */ !(values instanceof ArrayBuffer) &&
		                            /* not a Long */ !(ProtoBuf.Long && values instanceof ProtoBuf.Long)) {
		                            this.$set(values);
		                        } else // Set field values from arguments, in declaration order
		                            for (i=0, k=arguments.length; i<k; ++i)
		                                if (typeof (value = arguments[i]) !== 'undefined')
		                                    this.$set(fields[i].name, value); // May throw
		                    }
		                };
	
		                /**
		                 * @alias ProtoBuf.Builder.Message.prototype
		                 * @inner
		                 */
		                var MessagePrototype = Message.prototype = Object.create(ProtoBuf.Builder.Message.prototype);
	
		                /**
		                 * Adds a value to a repeated field.
		                 * @name ProtoBuf.Builder.Message#add
		                 * @function
		                 * @param {string} key Field name
		                 * @param {*} value Value to add
		                 * @param {boolean=} noAssert Whether to assert the value or not (asserts by default)
		                 * @returns {!ProtoBuf.Builder.Message} this
		                 * @throws {Error} If the value cannot be added
		                 * @expose
		                 */
		                MessagePrototype.add = function(key, value, noAssert) {
		                    var field = T._fieldsByName[key];
		                    if (!noAssert) {
		                        if (!field)
		                            throw Error(this+"#"+key+" is undefined");
		                        if (!(field instanceof ProtoBuf.Reflect.Message.Field))
		                            throw Error(this+"#"+key+" is not a field: "+field.toString(true)); // May throw if it's an enum or embedded message
		                        if (!field.repeated)
		                            throw Error(this+"#"+key+" is not a repeated field");
		                        value = field.verifyValue(value, true);
		                    }
		                    if (this[key] === null)
		                        this[key] = [];
		                    this[key].push(value);
		                    return this;
		                };
	
		                /**
		                 * Adds a value to a repeated field. This is an alias for {@link ProtoBuf.Builder.Message#add}.
		                 * @name ProtoBuf.Builder.Message#$add
		                 * @function
		                 * @param {string} key Field name
		                 * @param {*} value Value to add
		                 * @param {boolean=} noAssert Whether to assert the value or not (asserts by default)
		                 * @returns {!ProtoBuf.Builder.Message} this
		                 * @throws {Error} If the value cannot be added
		                 * @expose
		                 */
		                MessagePrototype.$add = MessagePrototype.add;
	
		                /**
		                 * Sets a field's value.
		                 * @name ProtoBuf.Builder.Message#set
		                 * @function
		                 * @param {string|!Object.<string,*>} keyOrObj String key or plain object holding multiple values
		                 * @param {(*|boolean)=} value Value to set if key is a string, otherwise omitted
		                 * @param {boolean=} noAssert Whether to not assert for an actual field / proper value type, defaults to `false`
		                 * @returns {!ProtoBuf.Builder.Message} this
		                 * @throws {Error} If the value cannot be set
		                 * @expose
		                 */
		                MessagePrototype.set = function(keyOrObj, value, noAssert) {
		                    if (keyOrObj && typeof keyOrObj === 'object') {
		                        noAssert = value;
		                        for (var ikey in keyOrObj)
		                            if (keyOrObj.hasOwnProperty(ikey) && typeof (value = keyOrObj[ikey]) !== 'undefined')
		                                this.$set(ikey, value, noAssert);
		                        return this;
		                    }
		                    var field = T._fieldsByName[keyOrObj];
		                    if (!noAssert) {
		                        if (!field)
		                            throw Error(this+"#"+keyOrObj+" is not a field: undefined");
		                        if (!(field instanceof ProtoBuf.Reflect.Message.Field))
		                            throw Error(this+"#"+keyOrObj+" is not a field: "+field.toString(true));
		                        this[field.name] = (value = field.verifyValue(value)); // May throw
		                    } else
		                        this[keyOrObj] = value;
		                    if (field && field.oneof) { // Field is part of an OneOf (not a virtual OneOf field)
		                        var currentField = this[field.oneof.name]; // Virtual field references currently set field
		                        if (value !== null) {
		                            if (currentField !== null && currentField !== field.name)
		                                this[currentField] = null; // Clear currently set field
		                            this[field.oneof.name] = field.name; // Point virtual field at this field
		                        } else if (/* value === null && */currentField === keyOrObj)
		                            this[field.oneof.name] = null; // Clear virtual field (current field explicitly cleared)
		                    }
		                    return this;
		                };
	
		                /**
		                 * Sets a field's value. This is an alias for [@link ProtoBuf.Builder.Message#set}.
		                 * @name ProtoBuf.Builder.Message#$set
		                 * @function
		                 * @param {string|!Object.<string,*>} keyOrObj String key or plain object holding multiple values
		                 * @param {(*|boolean)=} value Value to set if key is a string, otherwise omitted
		                 * @param {boolean=} noAssert Whether to not assert the value, defaults to `false`
		                 * @throws {Error} If the value cannot be set
		                 * @expose
		                 */
		                MessagePrototype.$set = MessagePrototype.set;
	
		                /**
		                 * Gets a field's value.
		                 * @name ProtoBuf.Builder.Message#get
		                 * @function
		                 * @param {string} key Key
		                 * @param {boolean=} noAssert Whether to not assert for an actual field, defaults to `false`
		                 * @return {*} Value
		                 * @throws {Error} If there is no such field
		                 * @expose
		                 */
		                MessagePrototype.get = function(key, noAssert) {
		                    if (noAssert)
		                        return this[key];
		                    var field = T._fieldsByName[key];
		                    if (!field || !(field instanceof ProtoBuf.Reflect.Message.Field))
		                        throw Error(this+"#"+key+" is not a field: undefined");
		                    if (!(field instanceof ProtoBuf.Reflect.Message.Field))
		                        throw Error(this+"#"+key+" is not a field: "+field.toString(true));
		                    return this[field.name];
		                };
	
		                /**
		                 * Gets a field's value. This is an alias for {@link ProtoBuf.Builder.Message#$get}.
		                 * @name ProtoBuf.Builder.Message#$get
		                 * @function
		                 * @param {string} key Key
		                 * @return {*} Value
		                 * @throws {Error} If there is no such field
		                 * @expose
		                 */
		                MessagePrototype.$get = MessagePrototype.get;
	
		                // Getters and setters
	
		                for (var i=0; i<fields.length; i++) {
		                    var field = fields[i];
		                    // no setters for extension fields as these are named by their fqn
		                    if (field instanceof ProtoBuf.Reflect.Message.ExtensionField)
		                        continue;
	
		                    if (T.builder.options['populateAccessors'])
		                        (function(field) {
		                            // set/get[SomeValue]
		                            var Name = field.originalName.replace(/(_[a-zA-Z])/g, function(match) {
		                                return match.toUpperCase().replace('_','');
		                            });
		                            Name = Name.substring(0,1).toUpperCase() + Name.substring(1);
	
		                            // set/get_[some_value] FIXME: Do we really need these?
		                            var name = field.originalName.replace(/([A-Z])/g, function(match) {
		                                return "_"+match;
		                            });
	
		                            /**
		                             * The current field's unbound setter function.
		                             * @function
		                             * @param {*} value
		                             * @param {boolean=} noAssert
		                             * @returns {!ProtoBuf.Builder.Message}
		                             * @inner
		                             */
		                            var setter = function(value, noAssert) {
		                                this[field.name] = noAssert ? value : field.verifyValue(value);
		                                return this;
		                            };
	
		                            /**
		                             * The current field's unbound getter function.
		                             * @function
		                             * @returns {*}
		                             * @inner
		                             */
		                            var getter = function() {
		                                return this[field.name];
		                            };
	
		                            if (T.getChild("set"+Name) === null)
		                                /**
		                                 * Sets a value. This method is present for each field, but only if there is no name conflict with
		                                 *  another field.
		                                 * @name ProtoBuf.Builder.Message#set[SomeField]
		                                 * @function
		                                 * @param {*} value Value to set
		                                 * @param {boolean=} noAssert Whether to not assert the value, defaults to `false`
		                                 * @returns {!ProtoBuf.Builder.Message} this
		                                 * @abstract
		                                 * @throws {Error} If the value cannot be set
		                                 */
		                                MessagePrototype["set"+Name] = setter;
	
		                            if (T.getChild("set_"+name) === null)
		                                /**
		                                 * Sets a value. This method is present for each field, but only if there is no name conflict with
		                                 *  another field.
		                                 * @name ProtoBuf.Builder.Message#set_[some_field]
		                                 * @function
		                                 * @param {*} value Value to set
		                                 * @param {boolean=} noAssert Whether to not assert the value, defaults to `false`
		                                 * @returns {!ProtoBuf.Builder.Message} this
		                                 * @abstract
		                                 * @throws {Error} If the value cannot be set
		                                 */
		                                MessagePrototype["set_"+name] = setter;
	
		                            if (T.getChild("get"+Name) === null)
		                                /**
		                                 * Gets a value. This method is present for each field, but only if there is no name conflict with
		                                 *  another field.
		                                 * @name ProtoBuf.Builder.Message#get[SomeField]
		                                 * @function
		                                 * @abstract
		                                 * @return {*} The value
		                                 */
		                                MessagePrototype["get"+Name] = getter;
	
		                            if (T.getChild("get_"+name) === null)
		                                /**
		                                 * Gets a value. This method is present for each field, but only if there is no name conflict with
		                                 *  another field.
		                                 * @name ProtoBuf.Builder.Message#get_[some_field]
		                                 * @function
		                                 * @return {*} The value
		                                 * @abstract
		                                 */
		                                MessagePrototype["get_"+name] = getter;
	
		                        })(field);
		                }
	
		                // En-/decoding
	
		                /**
		                 * Encodes the message.
		                 * @name ProtoBuf.Builder.Message#$encode
		                 * @function
		                 * @param {(!ByteBuffer|boolean)=} buffer ByteBuffer to encode to. Will create a new one and flip it if omitted.
		                 * @param {boolean=} noVerify Whether to not verify field values, defaults to `false`
		                 * @return {!ByteBuffer} Encoded message as a ByteBuffer
		                 * @throws {Error} If the message cannot be encoded or if required fields are missing. The later still
		                 *  returns the encoded ByteBuffer in the `encoded` property on the error.
		                 * @expose
		                 * @see ProtoBuf.Builder.Message#encode64
		                 * @see ProtoBuf.Builder.Message#encodeHex
		                 * @see ProtoBuf.Builder.Message#encodeAB
		                 */
		                MessagePrototype.encode = function(buffer, noVerify) {
		                    if (typeof buffer === 'boolean')
		                        noVerify = buffer,
		                        buffer = undefined;
		                    var isNew = false;
		                    if (!buffer)
		                        buffer = new ByteBuffer(),
		                        isNew = true;
		                    var le = buffer.littleEndian;
		                    try {
		                        T.encode(this, buffer.LE(), noVerify);
		                        return (isNew ? buffer.flip() : buffer).LE(le);
		                    } catch (e) {
		                        buffer.LE(le);
		                        throw(e);
		                    }
		                };
	
		                /**
		                 * Encodes a message using the specified data payload.
		                 * @param {!Object.<string,*>} data Data payload
		                 * @param {(!ByteBuffer|boolean)=} buffer ByteBuffer to encode to. Will create a new one and flip it if omitted.
		                 * @param {boolean=} noVerify Whether to not verify field values, defaults to `false`
		                 * @return {!ByteBuffer} Encoded message as a ByteBuffer
		                 * @expose
		                 */
		                Message.encode = function(data, buffer, noVerify) {
		                    return new Message(data).encode(buffer, noVerify);
		                };
	
		                /**
		                 * Calculates the byte length of the message.
		                 * @name ProtoBuf.Builder.Message#calculate
		                 * @function
		                 * @returns {number} Byte length
		                 * @throws {Error} If the message cannot be calculated or if required fields are missing.
		                 * @expose
		                 */
		                MessagePrototype.calculate = function() {
		                    return T.calculate(this);
		                };
	
		                /**
		                 * Encodes the varint32 length-delimited message.
		                 * @name ProtoBuf.Builder.Message#encodeDelimited
		                 * @function
		                 * @param {(!ByteBuffer|boolean)=} buffer ByteBuffer to encode to. Will create a new one and flip it if omitted.
		                 * @param {boolean=} noVerify Whether to not verify field values, defaults to `false`
		                 * @return {!ByteBuffer} Encoded message as a ByteBuffer
		                 * @throws {Error} If the message cannot be encoded or if required fields are missing. The later still
		                 *  returns the encoded ByteBuffer in the `encoded` property on the error.
		                 * @expose
		                 */
		                MessagePrototype.encodeDelimited = function(buffer, noVerify) {
		                    var isNew = false;
		                    if (!buffer)
		                        buffer = new ByteBuffer(),
		                        isNew = true;
		                    var enc = new ByteBuffer().LE();
		                    T.encode(this, enc, noVerify).flip();
		                    buffer.writeVarint32(enc.remaining());
		                    buffer.append(enc);
		                    return isNew ? buffer.flip() : buffer;
		                };
	
		                /**
		                 * Directly encodes the message to an ArrayBuffer.
		                 * @name ProtoBuf.Builder.Message#encodeAB
		                 * @function
		                 * @return {ArrayBuffer} Encoded message as ArrayBuffer
		                 * @throws {Error} If the message cannot be encoded or if required fields are missing. The later still
		                 *  returns the encoded ArrayBuffer in the `encoded` property on the error.
		                 * @expose
		                 */
		                MessagePrototype.encodeAB = function() {
		                    try {
		                        return this.encode().toArrayBuffer();
		                    } catch (e) {
		                        if (e["encoded"]) e["encoded"] = e["encoded"].toArrayBuffer();
		                        throw(e);
		                    }
		                };
	
		                /**
		                 * Returns the message as an ArrayBuffer. This is an alias for {@link ProtoBuf.Builder.Message#encodeAB}.
		                 * @name ProtoBuf.Builder.Message#toArrayBuffer
		                 * @function
		                 * @return {ArrayBuffer} Encoded message as ArrayBuffer
		                 * @throws {Error} If the message cannot be encoded or if required fields are missing. The later still
		                 *  returns the encoded ArrayBuffer in the `encoded` property on the error.
		                 * @expose
		                 */
		                MessagePrototype.toArrayBuffer = MessagePrototype.encodeAB;
	
		                /**
		                 * Directly encodes the message to a node Buffer.
		                 * @name ProtoBuf.Builder.Message#encodeNB
		                 * @function
		                 * @return {!Buffer}
		                 * @throws {Error} If the message cannot be encoded, not running under node.js or if required fields are
		                 *  missing. The later still returns the encoded node Buffer in the `encoded` property on the error.
		                 * @expose
		                 */
		                MessagePrototype.encodeNB = function() {
		                    try {
		                        return this.encode().toBuffer();
		                    } catch (e) {
		                        if (e["encoded"]) e["encoded"] = e["encoded"].toBuffer();
		                        throw(e);
		                    }
		                };
	
		                /**
		                 * Returns the message as a node Buffer. This is an alias for {@link ProtoBuf.Builder.Message#encodeNB}.
		                 * @name ProtoBuf.Builder.Message#toBuffer
		                 * @function
		                 * @return {!Buffer}
		                 * @throws {Error} If the message cannot be encoded or if required fields are missing. The later still
		                 *  returns the encoded node Buffer in the `encoded` property on the error.
		                 * @expose
		                 */
		                MessagePrototype.toBuffer = MessagePrototype.encodeNB;
	
		                /**
		                 * Directly encodes the message to a base64 encoded string.
		                 * @name ProtoBuf.Builder.Message#encode64
		                 * @function
		                 * @return {string} Base64 encoded string
		                 * @throws {Error} If the underlying buffer cannot be encoded or if required fields are missing. The later
		                 *  still returns the encoded base64 string in the `encoded` property on the error.
		                 * @expose
		                 */
		                MessagePrototype.encode64 = function() {
		                    try {
		                        return this.encode().toBase64();
		                    } catch (e) {
		                        if (e["encoded"]) e["encoded"] = e["encoded"].toBase64();
		                        throw(e);
		                    }
		                };
	
		                /**
		                 * Returns the message as a base64 encoded string. This is an alias for {@link ProtoBuf.Builder.Message#encode64}.
		                 * @name ProtoBuf.Builder.Message#toBase64
		                 * @function
		                 * @return {string} Base64 encoded string
		                 * @throws {Error} If the message cannot be encoded or if required fields are missing. The later still
		                 *  returns the encoded base64 string in the `encoded` property on the error.
		                 * @expose
		                 */
		                MessagePrototype.toBase64 = MessagePrototype.encode64;
	
		                /**
		                 * Directly encodes the message to a hex encoded string.
		                 * @name ProtoBuf.Builder.Message#encodeHex
		                 * @function
		                 * @return {string} Hex encoded string
		                 * @throws {Error} If the underlying buffer cannot be encoded or if required fields are missing. The later
		                 *  still returns the encoded hex string in the `encoded` property on the error.
		                 * @expose
		                 */
		                MessagePrototype.encodeHex = function() {
		                    try {
		                        return this.encode().toHex();
		                    } catch (e) {
		                        if (e["encoded"]) e["encoded"] = e["encoded"].toHex();
		                        throw(e);
		                    }
		                };
	
		                /**
		                 * Returns the message as a hex encoded string. This is an alias for {@link ProtoBuf.Builder.Message#encodeHex}.
		                 * @name ProtoBuf.Builder.Message#toHex
		                 * @function
		                 * @return {string} Hex encoded string
		                 * @throws {Error} If the message cannot be encoded or if required fields are missing. The later still
		                 *  returns the encoded hex string in the `encoded` property on the error.
		                 * @expose
		                 */
		                MessagePrototype.toHex = MessagePrototype.encodeHex;
	
		                /**
		                 * Clones a message object or field value to a raw object.
		                 * @param {*} obj Object to clone
		                 * @param {boolean} binaryAsBase64 Whether to include binary data as base64 strings or as a buffer otherwise
		                 * @param {boolean} longsAsStrings Whether to encode longs as strings
		                 * @param {!ProtoBuf.Reflect.T=} resolvedType The resolved field type if a field
		                 * @returns {*} Cloned object
		                 * @inner
		                 */
		                function cloneRaw(obj, binaryAsBase64, longsAsStrings, resolvedType) {
		                    if (obj === null || typeof obj !== 'object') {
		                        // Convert enum values to their respective names
		                        if (resolvedType && resolvedType instanceof ProtoBuf.Reflect.Enum) {
		                            var name = ProtoBuf.Reflect.Enum.getName(resolvedType.object, obj);
		                            if (name !== null)
		                                return name;
		                        }
		                        // Pass-through string, number, boolean, null...
		                        return obj;
		                    }
		                    // Convert ByteBuffers to raw buffer or strings
		                    if (ByteBuffer.isByteBuffer(obj))
		                        return binaryAsBase64 ? obj.toBase64() : obj.toBuffer();
		                    // Convert Longs to proper objects or strings
		                    if (ProtoBuf.Long.isLong(obj))
		                        return longsAsStrings ? obj.toString() : ProtoBuf.Long.fromValue(obj);
		                    var clone;
		                    // Clone arrays
		                    if (Array.isArray(obj)) {
		                        clone = [];
		                        obj.forEach(function(v, k) {
		                            clone[k] = cloneRaw(v, binaryAsBase64, longsAsStrings, resolvedType);
		                        });
		                        return clone;
		                    }
		                    clone = {};
		                    // Convert maps to objects
		                    if (obj instanceof ProtoBuf.Map) {
		                        var it = obj.entries();
		                        for (var e = it.next(); !e.done; e = it.next())
		                            clone[obj.keyElem.valueToString(e.value[0])] = cloneRaw(e.value[1], binaryAsBase64, longsAsStrings, obj.valueElem.resolvedType);
		                        return clone;
		                    }
		                    // Everything else is a non-null object
		                    var type = obj.$type,
		                        field = undefined;
		                    for (var i in obj)
		                        if (obj.hasOwnProperty(i)) {
		                            if (type && (field = type.getChild(i)))
		                                clone[i] = cloneRaw(obj[i], binaryAsBase64, longsAsStrings, field.resolvedType);
		                            else
		                                clone[i] = cloneRaw(obj[i], binaryAsBase64, longsAsStrings);
		                        }
		                    return clone;
		                }
	
		                /**
		                 * Returns the message's raw payload.
		                 * @param {boolean=} binaryAsBase64 Whether to include binary data as base64 strings instead of Buffers, defaults to `false`
		                 * @param {boolean} longsAsStrings Whether to encode longs as strings
		                 * @returns {Object.<string,*>} Raw payload
		                 * @expose
		                 */
		                MessagePrototype.toRaw = function(binaryAsBase64, longsAsStrings) {
		                    return cloneRaw(this, !!binaryAsBase64, !!longsAsStrings, this.$type);
		                };
	
		                /**
		                 * Encodes a message to JSON.
		                 * @returns {string} JSON string
		                 * @expose
		                 */
		                MessagePrototype.encodeJSON = function() {
		                    return JSON.stringify(
		                        cloneRaw(this,
		                             /* binary-as-base64 */ true,
		                             /* longs-as-strings */ true,
		                             this.$type
		                        )
		                    );
		                };
	
		                /**
		                 * Decodes a message from the specified buffer or string.
		                 * @name ProtoBuf.Builder.Message.decode
		                 * @function
		                 * @param {!ByteBuffer|!ArrayBuffer|!Buffer|string} buffer Buffer to decode from
		                 * @param {(number|string)=} length Message length. Defaults to decode all the remainig data.
		                 * @param {string=} enc Encoding if buffer is a string: hex, utf8 (not recommended), defaults to base64
		                 * @return {!ProtoBuf.Builder.Message} Decoded message
		                 * @throws {Error} If the message cannot be decoded or if required fields are missing. The later still
		                 *  returns the decoded message with missing fields in the `decoded` property on the error.
		                 * @expose
		                 * @see ProtoBuf.Builder.Message.decode64
		                 * @see ProtoBuf.Builder.Message.decodeHex
		                 */
		                Message.decode = function(buffer, length, enc) {
		                    if (typeof length === 'string')
		                        enc = length,
		                        length = -1;
		                    if (typeof buffer === 'string')
		                        buffer = ByteBuffer.wrap(buffer, enc ? enc : "base64");
		                    buffer = ByteBuffer.isByteBuffer(buffer) ? buffer : ByteBuffer.wrap(buffer); // May throw
		                    var le = buffer.littleEndian;
		                    try {
		                        var msg = T.decode(buffer.LE());
		                        buffer.LE(le);
		                        return msg;
		                    } catch (e) {
		                        buffer.LE(le);
		                        throw(e);
		                    }
		                };
	
		                /**
		                 * Decodes a varint32 length-delimited message from the specified buffer or string.
		                 * @name ProtoBuf.Builder.Message.decodeDelimited
		                 * @function
		                 * @param {!ByteBuffer|!ArrayBuffer|!Buffer|string} buffer Buffer to decode from
		                 * @param {string=} enc Encoding if buffer is a string: hex, utf8 (not recommended), defaults to base64
		                 * @return {ProtoBuf.Builder.Message} Decoded message or `null` if not enough bytes are available yet
		                 * @throws {Error} If the message cannot be decoded or if required fields are missing. The later still
		                 *  returns the decoded message with missing fields in the `decoded` property on the error.
		                 * @expose
		                 */
		                Message.decodeDelimited = function(buffer, enc) {
		                    if (typeof buffer === 'string')
		                        buffer = ByteBuffer.wrap(buffer, enc ? enc : "base64");
		                    buffer = ByteBuffer.isByteBuffer(buffer) ? buffer : ByteBuffer.wrap(buffer); // May throw
		                    if (buffer.remaining() < 1)
		                        return null;
		                    var off = buffer.offset,
		                        len = buffer.readVarint32();
		                    if (buffer.remaining() < len) {
		                        buffer.offset = off;
		                        return null;
		                    }
		                    try {
		                        var msg = T.decode(buffer.slice(buffer.offset, buffer.offset + len).LE());
		                        buffer.offset += len;
		                        return msg;
		                    } catch (err) {
		                        buffer.offset += len;
		                        throw err;
		                    }
		                };
	
		                /**
		                 * Decodes the message from the specified base64 encoded string.
		                 * @name ProtoBuf.Builder.Message.decode64
		                 * @function
		                 * @param {string} str String to decode from
		                 * @return {!ProtoBuf.Builder.Message} Decoded message
		                 * @throws {Error} If the message cannot be decoded or if required fields are missing. The later still
		                 *  returns the decoded message with missing fields in the `decoded` property on the error.
		                 * @expose
		                 */
		                Message.decode64 = function(str) {
		                    return Message.decode(str, "base64");
		                };
	
		                /**
		                 * Decodes the message from the specified hex encoded string.
		                 * @name ProtoBuf.Builder.Message.decodeHex
		                 * @function
		                 * @param {string} str String to decode from
		                 * @return {!ProtoBuf.Builder.Message} Decoded message
		                 * @throws {Error} If the message cannot be decoded or if required fields are missing. The later still
		                 *  returns the decoded message with missing fields in the `decoded` property on the error.
		                 * @expose
		                 */
		                Message.decodeHex = function(str) {
		                    return Message.decode(str, "hex");
		                };
	
		                /**
		                 * Decodes the message from a JSON string.
		                 * @name ProtoBuf.Builder.Message.decodeJSON
		                 * @function
		                 * @param {string} str String to decode from
		                 * @return {!ProtoBuf.Builder.Message} Decoded message
		                 * @throws {Error} If the message cannot be decoded or if required fields are
		                 * missing.
		                 * @expose
		                 */
		                Message.decodeJSON = function(str) {
		                    return new Message(JSON.parse(str));
		                };
	
		                // Utility
	
		                /**
		                 * Returns a string representation of this Message.
		                 * @name ProtoBuf.Builder.Message#toString
		                 * @function
		                 * @return {string} String representation as of ".Fully.Qualified.MessageName"
		                 * @expose
		                 */
		                MessagePrototype.toString = function() {
		                    return T.toString();
		                };
	
		                // Properties
	
		                /**
		                 * Message options.
		                 * @name ProtoBuf.Builder.Message.$options
		                 * @type {Object.<string,*>}
		                 * @expose
		                 */
		                var $optionsS; // cc needs this
	
		                /**
		                 * Message options.
		                 * @name ProtoBuf.Builder.Message#$options
		                 * @type {Object.<string,*>}
		                 * @expose
		                 */
		                var $options;
	
		                /**
		                 * Reflection type.
		                 * @name ProtoBuf.Builder.Message.$type
		                 * @type {!ProtoBuf.Reflect.Message}
		                 * @expose
		                 */
		                var $typeS;
	
		                /**
		                 * Reflection type.
		                 * @name ProtoBuf.Builder.Message#$type
		                 * @type {!ProtoBuf.Reflect.Message}
		                 * @expose
		                 */
		                var $type;
	
		                if (Object.defineProperty)
		                    Object.defineProperty(Message, '$options', { "value": T.buildOpt() }),
		                    Object.defineProperty(MessagePrototype, "$options", { "value": Message["$options"] }),
		                    Object.defineProperty(Message, "$type", { "value": T }),
		                    Object.defineProperty(MessagePrototype, "$type", { "value": T });
	
		                return Message;
	
		            })(ProtoBuf, this);
	
		            // Static enums and prototyped sub-messages / cached collections
		            this._fields = [];
		            this._fieldsById = {};
		            this._fieldsByName = {};
		            for (var i=0, k=this.children.length, child; i<k; i++) {
		                child = this.children[i];
		                if (child instanceof Enum || child instanceof Message || child instanceof Service) {
		                    if (clazz.hasOwnProperty(child.name))
		                        throw Error("Illegal reflect child of "+this.toString(true)+": "+child.toString(true)+" cannot override static property '"+child.name+"'");
		                    clazz[child.name] = child.build();
		                } else if (child instanceof Message.Field)
		                    child.build(),
		                    this._fields.push(child),
		                    this._fieldsById[child.id] = child,
		                    this._fieldsByName[child.name] = child;
		                else if (!(child instanceof Message.OneOf) && !(child instanceof Extension)) // Not built
		                    throw Error("Illegal reflect child of "+this.toString(true)+": "+this.children[i].toString(true));
		            }
	
		            return this.clazz = clazz;
		        };
	
		        /**
		         * Encodes a runtime message's contents to the specified buffer.
		         * @param {!ProtoBuf.Builder.Message} message Runtime message to encode
		         * @param {ByteBuffer} buffer ByteBuffer to write to
		         * @param {boolean=} noVerify Whether to not verify field values, defaults to `false`
		         * @return {ByteBuffer} The ByteBuffer for chaining
		         * @throws {Error} If required fields are missing or the message cannot be encoded for another reason
		         * @expose
		         */
		        MessagePrototype.encode = function(message, buffer, noVerify) {
		            var fieldMissing = null,
		                field;
		            for (var i=0, k=this._fields.length, val; i<k; ++i) {
		                field = this._fields[i];
		                val = message[field.name];
		                if (field.required && val === null) {
		                    if (fieldMissing === null)
		                        fieldMissing = field;
		                } else
		                    field.encode(noVerify ? val : field.verifyValue(val), buffer, message);
		            }
		            if (fieldMissing !== null) {
		                var err = Error("Missing at least one required field for "+this.toString(true)+": "+fieldMissing);
		                err["encoded"] = buffer; // Still expose what we got
		                throw(err);
		            }
		            return buffer;
		        };
	
		        /**
		         * Calculates a runtime message's byte length.
		         * @param {!ProtoBuf.Builder.Message} message Runtime message to encode
		         * @returns {number} Byte length
		         * @throws {Error} If required fields are missing or the message cannot be calculated for another reason
		         * @expose
		         */
		        MessagePrototype.calculate = function(message) {
		            for (var n=0, i=0, k=this._fields.length, field, val; i<k; ++i) {
		                field = this._fields[i];
		                val = message[field.name];
		                if (field.required && val === null)
		                   throw Error("Missing at least one required field for "+this.toString(true)+": "+field);
		                else
		                    n += field.calculate(val, message);
		            }
		            return n;
		        };
	
		        /**
		         * Skips all data until the end of the specified group has been reached.
		         * @param {number} expectedId Expected GROUPEND id
		         * @param {!ByteBuffer} buf ByteBuffer
		         * @returns {boolean} `true` if a value as been skipped, `false` if the end has been reached
		         * @throws {Error} If it wasn't possible to find the end of the group (buffer overrun or end tag mismatch)
		         * @inner
		         */
		        function skipTillGroupEnd(expectedId, buf) {
		            var tag = buf.readVarint32(), // Throws on OOB
		                wireType = tag & 0x07,
		                id = tag >>> 3;
		            switch (wireType) {
		                case ProtoBuf.WIRE_TYPES.VARINT:
		                    do tag = buf.readUint8();
		                    while ((tag & 0x80) === 0x80);
		                    break;
		                case ProtoBuf.WIRE_TYPES.BITS64:
		                    buf.offset += 8;
		                    break;
		                case ProtoBuf.WIRE_TYPES.LDELIM:
		                    tag = buf.readVarint32(); // reads the varint
		                    buf.offset += tag;        // skips n bytes
		                    break;
		                case ProtoBuf.WIRE_TYPES.STARTGROUP:
		                    skipTillGroupEnd(id, buf);
		                    break;
		                case ProtoBuf.WIRE_TYPES.ENDGROUP:
		                    if (id === expectedId)
		                        return false;
		                    else
		                        throw Error("Illegal GROUPEND after unknown group: "+id+" ("+expectedId+" expected)");
		                case ProtoBuf.WIRE_TYPES.BITS32:
		                    buf.offset += 4;
		                    break;
		                default:
		                    throw Error("Illegal wire type in unknown group "+expectedId+": "+wireType);
		            }
		            return true;
		        }
	
		        /**
		         * Decodes an encoded message and returns the decoded message.
		         * @param {ByteBuffer} buffer ByteBuffer to decode from
		         * @param {number=} length Message length. Defaults to decode all remaining data.
		         * @param {number=} expectedGroupEndId Expected GROUPEND id if this is a legacy group
		         * @return {ProtoBuf.Builder.Message} Decoded message
		         * @throws {Error} If the message cannot be decoded
		         * @expose
		         */
		        MessagePrototype.decode = function(buffer, length, expectedGroupEndId) {
		            length = typeof length === 'number' ? length : -1;
		            var start = buffer.offset,
		                msg = new (this.clazz)(),
		                tag, wireType, id, field;
		            while (buffer.offset < start+length || (length === -1 && buffer.remaining() > 0)) {
		                tag = buffer.readVarint32();
		                wireType = tag & 0x07;
		                id = tag >>> 3;
		                if (wireType === ProtoBuf.WIRE_TYPES.ENDGROUP) {
		                    if (id !== expectedGroupEndId)
		                        throw Error("Illegal group end indicator for "+this.toString(true)+": "+id+" ("+(expectedGroupEndId ? expectedGroupEndId+" expected" : "not a group")+")");
		                    break;
		                }
		                if (!(field = this._fieldsById[id])) {
		                    // "messages created by your new code can be parsed by your old code: old binaries simply ignore the new field when parsing."
		                    switch (wireType) {
		                        case ProtoBuf.WIRE_TYPES.VARINT:
		                            buffer.readVarint32();
		                            break;
		                        case ProtoBuf.WIRE_TYPES.BITS32:
		                            buffer.offset += 4;
		                            break;
		                        case ProtoBuf.WIRE_TYPES.BITS64:
		                            buffer.offset += 8;
		                            break;
		                        case ProtoBuf.WIRE_TYPES.LDELIM:
		                            var len = buffer.readVarint32();
		                            buffer.offset += len;
		                            break;
		                        case ProtoBuf.WIRE_TYPES.STARTGROUP:
		                            while (skipTillGroupEnd(id, buffer)) {}
		                            break;
		                        default:
		                            throw Error("Illegal wire type for unknown field "+id+" in "+this.toString(true)+"#decode: "+wireType);
		                    }
		                    continue;
		                }
		                if (field.repeated && !field.options["packed"]) {
		                    msg[field.name].push(field.decode(wireType, buffer));
		                } else if (field.map) {
		                    var keyval = field.decode(wireType, buffer);
		                    msg[field.name].set(keyval[0], keyval[1]);
		                } else {
		                    msg[field.name] = field.decode(wireType, buffer);
		                    if (field.oneof) { // Field is part of an OneOf (not a virtual OneOf field)
		                        var currentField = msg[field.oneof.name]; // Virtual field references currently set field
		                        if (currentField !== null && currentField !== field.name)
		                            msg[currentField] = null; // Clear currently set field
		                        msg[field.oneof.name] = field.name; // Point virtual field at this field
		                    }
		                }
		            }
	
		            // Check if all required fields are present and set default values for optional fields that are not
		            for (var i=0, k=this._fields.length; i<k; ++i) {
		                field = this._fields[i];
		                if (msg[field.name] === null) {
		                    if (this.syntax === "proto3") { // Proto3 sets default values by specification
		                        msg[field.name] = field.defaultValue;
		                    } else if (field.required) {
		                        var err = Error("Missing at least one required field for " + this.toString(true) + ": " + field.name);
		                        err["decoded"] = msg; // Still expose what we got
		                        throw(err);
		                    } else if (ProtoBuf.populateDefaults && field.defaultValue !== null)
		                        msg[field.name] = field.defaultValue;
		                }
		            }
		            return msg;
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Message
		         * @expose
		         */
		        Reflect.Message = Message;
	
		        /**
		         * Constructs a new Message Field.
		         * @exports ProtoBuf.Reflect.Message.Field
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.Message} message Message reference
		         * @param {string} rule Rule, one of requried, optional, repeated
		         * @param {string?} keytype Key data type, if any.
		         * @param {string} type Data type, e.g. int32
		         * @param {string} name Field name
		         * @param {number} id Unique field id
		         * @param {Object.<string,*>=} options Options
		         * @param {!ProtoBuf.Reflect.Message.OneOf=} oneof Enclosing OneOf
		         * @param {string?} syntax The syntax level of this definition (e.g., proto3)
		         * @constructor
		         * @extends ProtoBuf.Reflect.T
		         */
		        var Field = function(builder, message, rule, keytype, type, name, id, options, oneof, syntax) {
		            T.call(this, builder, message, name);
	
		            /**
		             * @override
		             */
		            this.className = "Message.Field";
	
		            /**
		             * Message field required flag.
		             * @type {boolean}
		             * @expose
		             */
		            this.required = rule === "required";
	
		            /**
		             * Message field repeated flag.
		             * @type {boolean}
		             * @expose
		             */
		            this.repeated = rule === "repeated";
	
		            /**
		             * Message field map flag.
		             * @type {boolean}
		             * @expose
		             */
		            this.map = rule === "map";
	
		            /**
		             * Message field key type. Type reference string if unresolved, protobuf
		             * type if resolved. Valid only if this.map === true, null otherwise.
		             * @type {string|{name: string, wireType: number}|null}
		             * @expose
		             */
		            this.keyType = keytype || null;
	
		            /**
		             * Message field type. Type reference string if unresolved, protobuf type if
		             * resolved. In a map field, this is the value type.
		             * @type {string|{name: string, wireType: number}}
		             * @expose
		             */
		            this.type = type;
	
		            /**
		             * Resolved type reference inside the global namespace.
		             * @type {ProtoBuf.Reflect.T|null}
		             * @expose
		             */
		            this.resolvedType = null;
	
		            /**
		             * Unique message field id.
		             * @type {number}
		             * @expose
		             */
		            this.id = id;
	
		            /**
		             * Message field options.
		             * @type {!Object.<string,*>}
		             * @dict
		             * @expose
		             */
		            this.options = options || {};
	
		            /**
		             * Default value.
		             * @type {*}
		             * @expose
		             */
		            this.defaultValue = null;
	
		            /**
		             * Enclosing OneOf.
		             * @type {?ProtoBuf.Reflect.Message.OneOf}
		             * @expose
		             */
		            this.oneof = oneof || null;
	
		            /**
		             * Syntax level of this definition (e.g., proto3).
		             * @type {string}
		             * @expose
		             */
		            this.syntax = syntax || 'proto2';
	
		            /**
		             * Original field name.
		             * @type {string}
		             * @expose
		             */
		            this.originalName = this.name; // Used to revert camelcase transformation on naming collisions
	
		            /**
		             * Element implementation. Created in build() after types are resolved.
		             * @type {ProtoBuf.Element}
		             * @expose
		             */
		            this.element = null;
	
		            /**
		             * Key element implementation, for map fields. Created in build() after
		             * types are resolved.
		             * @type {ProtoBuf.Element}
		             * @expose
		             */
		            this.keyElement = null;
	
		            // Convert field names to camel case notation if the override is set
		            if (this.builder.options['convertFieldsToCamelCase'] && !(this instanceof Message.ExtensionField))
		                this.name = ProtoBuf.Util.toCamelCase(this.name);
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Message.Field.prototype
		         * @inner
		         */
		        var FieldPrototype = Field.prototype = Object.create(T.prototype);
	
		        /**
		         * Builds the field.
		         * @override
		         * @expose
		         */
		        FieldPrototype.build = function() {
		            this.element = new Element(this.type, this.resolvedType, false, this.syntax);
		            if (this.map)
		                this.keyElement = new Element(this.keyType, undefined, true, this.syntax);
	
		            // In proto3, fields do not have field presence, and every field is set to
		            // its type's default value ("", 0, 0.0, or false).
		            if (this.syntax === 'proto3' && !this.repeated && !this.map)
		                this.defaultValue = Element.defaultFieldValue(this.type);
	
		            // Otherwise, default values are present when explicitly specified
		            else if (typeof this.options['default'] !== 'undefined')
		                this.defaultValue = this.verifyValue(this.options['default']);
		        };
	
		        /**
		         * Checks if the given value can be set for this field.
		         * @param {*} value Value to check
		         * @param {boolean=} skipRepeated Whether to skip the repeated value check or not. Defaults to false.
		         * @return {*} Verified, maybe adjusted, value
		         * @throws {Error} If the value cannot be set for this field
		         * @expose
		         */
		        FieldPrototype.verifyValue = function(value, skipRepeated) {
		            skipRepeated = skipRepeated || false;
		            var self = this;
		            function fail(val, msg) {
		                throw Error("Illegal value for "+self.toString(true)+" of type "+self.type.name+": "+val+" ("+msg+")");
		            }
		            if (value === null) { // NULL values for optional fields
		                if (this.required)
		                    fail(typeof value, "required");
		                if (this.syntax === 'proto3' && this.type !== ProtoBuf.TYPES["message"])
		                    fail(typeof value, "proto3 field without field presence cannot be null");
		                return null;
		            }
		            var i;
		            if (this.repeated && !skipRepeated) { // Repeated values as arrays
		                if (!Array.isArray(value))
		                    value = [value];
		                var res = [];
		                for (i=0; i<value.length; i++)
		                    res.push(this.element.verifyValue(value[i]));
		                return res;
		            }
		            if (this.map && !skipRepeated) { // Map values as objects
		                if (!(value instanceof ProtoBuf.Map)) {
		                    // If not already a Map, attempt to convert.
		                    if (!(value instanceof Object)) {
		                        fail(typeof value,
		                             "expected ProtoBuf.Map or raw object for map field");
		                    }
		                    return new ProtoBuf.Map(this, value);
		                } else {
		                    return value;
		                }
		            }
		            // All non-repeated fields expect no array
		            if (!this.repeated && Array.isArray(value))
		                fail(typeof value, "no array expected");
	
		            return this.element.verifyValue(value);
		        };
	
		        /**
		         * Determines whether the field will have a presence on the wire given its
		         * value.
		         * @param {*} value Verified field value
		         * @param {!ProtoBuf.Builder.Message} message Runtime message
		         * @return {boolean} Whether the field will be present on the wire
		         */
		        FieldPrototype.hasWirePresence = function(value, message) {
		            if (this.syntax !== 'proto3')
		                return (value !== null);
		            if (this.oneof && message[this.oneof.name] === this.name)
		                return true;
		            switch (this.type) {
		                case ProtoBuf.TYPES["int32"]:
		                case ProtoBuf.TYPES["sint32"]:
		                case ProtoBuf.TYPES["sfixed32"]:
		                case ProtoBuf.TYPES["uint32"]:
		                case ProtoBuf.TYPES["fixed32"]:
		                    return value !== 0;
	
		                case ProtoBuf.TYPES["int64"]:
		                case ProtoBuf.TYPES["sint64"]:
		                case ProtoBuf.TYPES["sfixed64"]:
		                case ProtoBuf.TYPES["uint64"]:
		                case ProtoBuf.TYPES["fixed64"]:
		                    return value.low !== 0 || value.high !== 0;
	
		                case ProtoBuf.TYPES["bool"]:
		                    return value;
	
		                case ProtoBuf.TYPES["float"]:
		                case ProtoBuf.TYPES["double"]:
		                    return value !== 0.0;
	
		                case ProtoBuf.TYPES["string"]:
		                    return value.length > 0;
	
		                case ProtoBuf.TYPES["bytes"]:
		                    return value.remaining() > 0;
	
		                case ProtoBuf.TYPES["enum"]:
		                    return value !== 0;
	
		                case ProtoBuf.TYPES["message"]:
		                    return value !== null;
		                default:
		                    return true;
		            }
		        };
	
		        /**
		         * Encodes the specified field value to the specified buffer.
		         * @param {*} value Verified field value
		         * @param {ByteBuffer} buffer ByteBuffer to encode to
		         * @param {!ProtoBuf.Builder.Message} message Runtime message
		         * @return {ByteBuffer} The ByteBuffer for chaining
		         * @throws {Error} If the field cannot be encoded
		         * @expose
		         */
		        FieldPrototype.encode = function(value, buffer, message) {
		            if (this.type === null || typeof this.type !== 'object')
		                throw Error("[INTERNAL] Unresolved type in "+this.toString(true)+": "+this.type);
		            if (value === null || (this.repeated && value.length == 0))
		                return buffer; // Optional omitted
		            try {
		                if (this.repeated) {
		                    var i;
		                    // "Only repeated fields of primitive numeric types (types which use the varint, 32-bit, or 64-bit wire
		                    // types) can be declared 'packed'."
		                    if (this.options["packed"] && ProtoBuf.PACKABLE_WIRE_TYPES.indexOf(this.type.wireType) >= 0) {
		                        // "All of the elements of the field are packed into a single key-value pair with wire type 2
		                        // (length-delimited). Each element is encoded the same way it would be normally, except without a
		                        // tag preceding it."
		                        buffer.writeVarint32((this.id << 3) | ProtoBuf.WIRE_TYPES.LDELIM);
		                        buffer.ensureCapacity(buffer.offset += 1); // We do not know the length yet, so let's assume a varint of length 1
		                        var start = buffer.offset; // Remember where the contents begin
		                        for (i=0; i<value.length; i++)
		                            this.element.encodeValue(this.id, value[i], buffer);
		                        var len = buffer.offset-start,
		                            varintLen = ByteBuffer.calculateVarint32(len);
		                        if (varintLen > 1) { // We need to move the contents
		                            var contents = buffer.slice(start, buffer.offset);
		                            start += varintLen-1;
		                            buffer.offset = start;
		                            buffer.append(contents);
		                        }
		                        buffer.writeVarint32(len, start-varintLen);
		                    } else {
		                        // "If your message definition has repeated elements (without the [packed=true] option), the encoded
		                        // message has zero or more key-value pairs with the same tag number"
		                        for (i=0; i<value.length; i++)
		                            buffer.writeVarint32((this.id << 3) | this.type.wireType),
		                            this.element.encodeValue(this.id, value[i], buffer);
		                    }
		                } else if (this.map) {
		                    // Write out each map entry as a submessage.
		                    value.forEach(function(val, key, m) {
		                        // Compute the length of the submessage (key, val) pair.
		                        var length =
		                            ByteBuffer.calculateVarint32((1 << 3) | this.keyType.wireType) +
		                            this.keyElement.calculateLength(1, key) +
		                            ByteBuffer.calculateVarint32((2 << 3) | this.type.wireType) +
		                            this.element.calculateLength(2, val);
	
		                        // Submessage with wire type of length-delimited.
		                        buffer.writeVarint32((this.id << 3) | ProtoBuf.WIRE_TYPES.LDELIM);
		                        buffer.writeVarint32(length);
	
		                        // Write out the key and val.
		                        buffer.writeVarint32((1 << 3) | this.keyType.wireType);
		                        this.keyElement.encodeValue(1, key, buffer);
		                        buffer.writeVarint32((2 << 3) | this.type.wireType);
		                        this.element.encodeValue(2, val, buffer);
		                    }, this);
		                } else {
		                    if (this.hasWirePresence(value, message)) {
		                        buffer.writeVarint32((this.id << 3) | this.type.wireType);
		                        this.element.encodeValue(this.id, value, buffer);
		                    }
		                }
		            } catch (e) {
		                throw Error("Illegal value for "+this.toString(true)+": "+value+" ("+e+")");
		            }
		            return buffer;
		        };
	
		        /**
		         * Calculates the length of this field's value on the network level.
		         * @param {*} value Field value
		         * @param {!ProtoBuf.Builder.Message} message Runtime message
		         * @returns {number} Byte length
		         * @expose
		         */
		        FieldPrototype.calculate = function(value, message) {
		            value = this.verifyValue(value); // May throw
		            if (this.type === null || typeof this.type !== 'object')
		                throw Error("[INTERNAL] Unresolved type in "+this.toString(true)+": "+this.type);
		            if (value === null || (this.repeated && value.length == 0))
		                return 0; // Optional omitted
		            var n = 0;
		            try {
		                if (this.repeated) {
		                    var i, ni;
		                    if (this.options["packed"] && ProtoBuf.PACKABLE_WIRE_TYPES.indexOf(this.type.wireType) >= 0) {
		                        n += ByteBuffer.calculateVarint32((this.id << 3) | ProtoBuf.WIRE_TYPES.LDELIM);
		                        ni = 0;
		                        for (i=0; i<value.length; i++)
		                            ni += this.element.calculateLength(this.id, value[i]);
		                        n += ByteBuffer.calculateVarint32(ni);
		                        n += ni;
		                    } else {
		                        for (i=0; i<value.length; i++)
		                            n += ByteBuffer.calculateVarint32((this.id << 3) | this.type.wireType),
		                            n += this.element.calculateLength(this.id, value[i]);
		                    }
		                } else if (this.map) {
		                    // Each map entry becomes a submessage.
		                    value.forEach(function(val, key, m) {
		                        // Compute the length of the submessage (key, val) pair.
		                        var length =
		                            ByteBuffer.calculateVarint32((1 << 3) | this.keyType.wireType) +
		                            this.keyElement.calculateLength(1, key) +
		                            ByteBuffer.calculateVarint32((2 << 3) | this.type.wireType) +
		                            this.element.calculateLength(2, val);
	
		                        n += ByteBuffer.calculateVarint32((this.id << 3) | ProtoBuf.WIRE_TYPES.LDELIM);
		                        n += ByteBuffer.calculateVarint32(length);
		                        n += length;
		                    }, this);
		                } else {
		                    if (this.hasWirePresence(value, message)) {
		                        n += ByteBuffer.calculateVarint32((this.id << 3) | this.type.wireType);
		                        n += this.element.calculateLength(this.id, value);
		                    }
		                }
		            } catch (e) {
		                throw Error("Illegal value for "+this.toString(true)+": "+value+" ("+e+")");
		            }
		            return n;
		        };
	
		        /**
		         * Decode the field value from the specified buffer.
		         * @param {number} wireType Leading wire type
		         * @param {ByteBuffer} buffer ByteBuffer to decode from
		         * @param {boolean=} skipRepeated Whether to skip the repeated check or not. Defaults to false.
		         * @return {*} Decoded value: array for packed repeated fields, [key, value] for
		         *             map fields, or an individual value otherwise.
		         * @throws {Error} If the field cannot be decoded
		         * @expose
		         */
		        FieldPrototype.decode = function(wireType, buffer, skipRepeated) {
		            var value, nBytes;
	
		            // We expect wireType to match the underlying type's wireType unless we see
		            // a packed repeated field, or unless this is a map field.
		            var wireTypeOK =
		                (!this.map && wireType == this.type.wireType) ||
		                (!skipRepeated && this.repeated && this.options["packed"] &&
		                 wireType == ProtoBuf.WIRE_TYPES.LDELIM) ||
		                (this.map && wireType == ProtoBuf.WIRE_TYPES.LDELIM);
		            if (!wireTypeOK)
		                throw Error("Illegal wire type for field "+this.toString(true)+": "+wireType+" ("+this.type.wireType+" expected)");
	
		            // Handle packed repeated fields.
		            if (wireType == ProtoBuf.WIRE_TYPES.LDELIM && this.repeated && this.options["packed"] && ProtoBuf.PACKABLE_WIRE_TYPES.indexOf(this.type.wireType) >= 0) {
		                if (!skipRepeated) {
		                    nBytes = buffer.readVarint32();
		                    nBytes = buffer.offset + nBytes; // Limit
		                    var values = [];
		                    while (buffer.offset < nBytes)
		                        values.push(this.decode(this.type.wireType, buffer, true));
		                    return values;
		                }
		                // Read the next value otherwise...
		            }
	
		            // Handle maps.
		            if (this.map) {
		                // Read one (key, value) submessage, and return [key, value]
		                var key = Element.defaultFieldValue(this.keyType);
		                value = Element.defaultFieldValue(this.type);
	
		                // Read the length
		                nBytes = buffer.readVarint32();
		                if (buffer.remaining() < nBytes)
		                    throw Error("Illegal number of bytes for "+this.toString(true)+": "+nBytes+" required but got only "+buffer.remaining());
	
		                // Get a sub-buffer of this key/value submessage
		                var msgbuf = buffer.clone();
		                msgbuf.limit = msgbuf.offset + nBytes;
		                buffer.offset += nBytes;
	
		                while (msgbuf.remaining() > 0) {
		                    var tag = msgbuf.readVarint32();
		                    wireType = tag & 0x07;
		                    var id = tag >>> 3;
		                    if (id === 1) {
		                        key = this.keyElement.decode(msgbuf, wireType, id);
		                    } else if (id === 2) {
		                        value = this.element.decode(msgbuf, wireType, id);
		                    } else {
		                        throw Error("Unexpected tag in map field key/value submessage");
		                    }
		                }
	
		                return [key, value];
		            }
	
		            // Handle singular and non-packed repeated field values.
		            return this.element.decode(buffer, wireType, this.id);
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Message.Field
		         * @expose
		         */
		        Reflect.Message.Field = Field;
	
		        /**
		         * Constructs a new Message ExtensionField.
		         * @exports ProtoBuf.Reflect.Message.ExtensionField
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.Message} message Message reference
		         * @param {string} rule Rule, one of requried, optional, repeated
		         * @param {string} type Data type, e.g. int32
		         * @param {string} name Field name
		         * @param {number} id Unique field id
		         * @param {!Object.<string,*>=} options Options
		         * @constructor
		         * @extends ProtoBuf.Reflect.Message.Field
		         */
		        var ExtensionField = function(builder, message, rule, type, name, id, options) {
		            Field.call(this, builder, message, rule, /* keytype = */ null, type, name, id, options);
	
		            /**
		             * Extension reference.
		             * @type {!ProtoBuf.Reflect.Extension}
		             * @expose
		             */
		            this.extension;
		        };
	
		        // Extends Field
		        ExtensionField.prototype = Object.create(Field.prototype);
	
		        /**
		         * @alias ProtoBuf.Reflect.Message.ExtensionField
		         * @expose
		         */
		        Reflect.Message.ExtensionField = ExtensionField;
	
		        /**
		         * Constructs a new Message OneOf.
		         * @exports ProtoBuf.Reflect.Message.OneOf
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.Message} message Message reference
		         * @param {string} name OneOf name
		         * @constructor
		         * @extends ProtoBuf.Reflect.T
		         */
		        var OneOf = function(builder, message, name) {
		            T.call(this, builder, message, name);
	
		            /**
		             * Enclosed fields.
		             * @type {!Array.<!ProtoBuf.Reflect.Message.Field>}
		             * @expose
		             */
		            this.fields = [];
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Message.OneOf
		         * @expose
		         */
		        Reflect.Message.OneOf = OneOf;
	
		        /**
		         * Constructs a new Enum.
		         * @exports ProtoBuf.Reflect.Enum
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.T} parent Parent Reflect object
		         * @param {string} name Enum name
		         * @param {Object.<string,*>=} options Enum options
		         * @param {string?} syntax The syntax level (e.g., proto3)
		         * @constructor
		         * @extends ProtoBuf.Reflect.Namespace
		         */
		        var Enum = function(builder, parent, name, options, syntax) {
		            Namespace.call(this, builder, parent, name, options, syntax);
	
		            /**
		             * @override
		             */
		            this.className = "Enum";
	
		            /**
		             * Runtime enum object.
		             * @type {Object.<string,number>|null}
		             * @expose
		             */
		            this.object = null;
		        };
	
		        /**
		         * Gets the string name of an enum value.
		         * @param {!ProtoBuf.Builder.Enum} enm Runtime enum
		         * @param {number} value Enum value
		         * @returns {?string} Name or `null` if not present
		         * @expose
		         */
		        Enum.getName = function(enm, value) {
		            var keys = Object.keys(enm);
		            for (var i=0, key; i<keys.length; ++i)
		                if (enm[key = keys[i]] === value)
		                    return key;
		            return null;
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Enum.prototype
		         * @inner
		         */
		        var EnumPrototype = Enum.prototype = Object.create(Namespace.prototype);
	
		        /**
		         * Builds this enum and returns the runtime counterpart.
		         * @param {boolean} rebuild Whether to rebuild or not, defaults to false
		         * @returns {!Object.<string,number>}
		         * @expose
		         */
		        EnumPrototype.build = function(rebuild) {
		            if (this.object && !rebuild)
		                return this.object;
		            var enm = new ProtoBuf.Builder.Enum(),
		                values = this.getChildren(Enum.Value);
		            for (var i=0, k=values.length; i<k; ++i)
		                enm[values[i]['name']] = values[i]['id'];
		            if (Object.defineProperty)
		                Object.defineProperty(enm, '$options', {
		                    "value": this.buildOpt(),
		                    "enumerable": false
		                });
		            return this.object = enm;
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Enum
		         * @expose
		         */
		        Reflect.Enum = Enum;
	
		        /**
		         * Constructs a new Enum Value.
		         * @exports ProtoBuf.Reflect.Enum.Value
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.Enum} enm Enum reference
		         * @param {string} name Field name
		         * @param {number} id Unique field id
		         * @constructor
		         * @extends ProtoBuf.Reflect.T
		         */
		        var Value = function(builder, enm, name, id) {
		            T.call(this, builder, enm, name);
	
		            /**
		             * @override
		             */
		            this.className = "Enum.Value";
	
		            /**
		             * Unique enum value id.
		             * @type {number}
		             * @expose
		             */
		            this.id = id;
		        };
	
		        // Extends T
		        Value.prototype = Object.create(T.prototype);
	
		        /**
		         * @alias ProtoBuf.Reflect.Enum.Value
		         * @expose
		         */
		        Reflect.Enum.Value = Value;
	
		        /**
		         * An extension (field).
		         * @exports ProtoBuf.Reflect.Extension
		         * @constructor
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.T} parent Parent object
		         * @param {string} name Object name
		         * @param {!ProtoBuf.Reflect.Message.Field} field Extension field
		         */
		        var Extension = function(builder, parent, name, field) {
		            T.call(this, builder, parent, name);
	
		            /**
		             * Extended message field.
		             * @type {!ProtoBuf.Reflect.Message.Field}
		             * @expose
		             */
		            this.field = field;
		        };
	
		        // Extends T
		        Extension.prototype = Object.create(T.prototype);
	
		        /**
		         * @alias ProtoBuf.Reflect.Extension
		         * @expose
		         */
		        Reflect.Extension = Extension;
	
		        /**
		         * Constructs a new Service.
		         * @exports ProtoBuf.Reflect.Service
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.Namespace} root Root
		         * @param {string} name Service name
		         * @param {Object.<string,*>=} options Options
		         * @constructor
		         * @extends ProtoBuf.Reflect.Namespace
		         */
		        var Service = function(builder, root, name, options) {
		            Namespace.call(this, builder, root, name, options);
	
		            /**
		             * @override
		             */
		            this.className = "Service";
	
		            /**
		             * Built runtime service class.
		             * @type {?function(new:ProtoBuf.Builder.Service)}
		             */
		            this.clazz = null;
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Service.prototype
		         * @inner
		         */
		        var ServicePrototype = Service.prototype = Object.create(Namespace.prototype);
	
		        /**
		         * Builds the service and returns the runtime counterpart, which is a fully functional class.
		         * @see ProtoBuf.Builder.Service
		         * @param {boolean=} rebuild Whether to rebuild or not
		         * @return {Function} Service class
		         * @throws {Error} If the message cannot be built
		         * @expose
		         */
		        ServicePrototype.build = function(rebuild) {
		            if (this.clazz && !rebuild)
		                return this.clazz;
	
		            // Create the runtime Service class in its own scope
		            return this.clazz = (function(ProtoBuf, T) {
	
		                /**
		                 * Constructs a new runtime Service.
		                 * @name ProtoBuf.Builder.Service
		                 * @param {function(string, ProtoBuf.Builder.Message, function(Error, ProtoBuf.Builder.Message=))=} rpcImpl RPC implementation receiving the method name and the message
		                 * @class Barebone of all runtime services.
		                 * @constructor
		                 * @throws {Error} If the service cannot be created
		                 */
		                var Service = function(rpcImpl) {
		                    ProtoBuf.Builder.Service.call(this);
	
		                    /**
		                     * Service implementation.
		                     * @name ProtoBuf.Builder.Service#rpcImpl
		                     * @type {!function(string, ProtoBuf.Builder.Message, function(Error, ProtoBuf.Builder.Message=))}
		                     * @expose
		                     */
		                    this.rpcImpl = rpcImpl || function(name, msg, callback) {
		                        // This is what a user has to implement: A function receiving the method name, the actual message to
		                        // send (type checked) and the callback that's either provided with the error as its first
		                        // argument or null and the actual response message.
		                        setTimeout(callback.bind(this, Error("Not implemented, see: https://github.com/dcodeIO/ProtoBuf.js/wiki/Services")), 0); // Must be async!
		                    };
		                };
	
		                /**
		                 * @alias ProtoBuf.Builder.Service.prototype
		                 * @inner
		                 */
		                var ServicePrototype = Service.prototype = Object.create(ProtoBuf.Builder.Service.prototype);
	
		                /**
		                 * Asynchronously performs an RPC call using the given RPC implementation.
		                 * @name ProtoBuf.Builder.Service.[Method]
		                 * @function
		                 * @param {!function(string, ProtoBuf.Builder.Message, function(Error, ProtoBuf.Builder.Message=))} rpcImpl RPC implementation
		                 * @param {ProtoBuf.Builder.Message} req Request
		                 * @param {function(Error, (ProtoBuf.Builder.Message|ByteBuffer|Buffer|string)=)} callback Callback receiving
		                 *  the error if any and the response either as a pre-parsed message or as its raw bytes
		                 * @abstract
		                 */
	
		                /**
		                 * Asynchronously performs an RPC call using the instance's RPC implementation.
		                 * @name ProtoBuf.Builder.Service#[Method]
		                 * @function
		                 * @param {ProtoBuf.Builder.Message} req Request
		                 * @param {function(Error, (ProtoBuf.Builder.Message|ByteBuffer|Buffer|string)=)} callback Callback receiving
		                 *  the error if any and the response either as a pre-parsed message or as its raw bytes
		                 * @abstract
		                 */
	
		                var rpc = T.getChildren(ProtoBuf.Reflect.Service.RPCMethod);
		                for (var i=0; i<rpc.length; i++) {
		                    (function(method) {
	
		                        // service#Method(message, callback)
		                        ServicePrototype[method.name] = function(req, callback) {
		                            try {
		                                try {
		                                    // If given as a buffer, decode the request. Will throw a TypeError if not a valid buffer.
		                                    req = method.resolvedRequestType.clazz.decode(ByteBuffer.wrap(req));
		                                } catch (err) {
		                                    if (!(err instanceof TypeError))
		                                        throw err;
		                                }
		                                if (req === null || typeof req !== 'object')
		                                    throw Error("Illegal arguments");
		                                if (!(req instanceof method.resolvedRequestType.clazz))
		                                    req = new method.resolvedRequestType.clazz(req);
		                                this.rpcImpl(method.fqn(), req, function(err, res) { // Assumes that this is properly async
		                                    if (err) {
		                                        callback(err);
		                                        return;
		                                    }
		                                    // Coalesce to empty string when service response has empty content
		                                    if (res === null)
		                                        res = ''
		                                    try { res = method.resolvedResponseType.clazz.decode(res); } catch (notABuffer) {}
		                                    if (!res || !(res instanceof method.resolvedResponseType.clazz)) {
		                                        callback(Error("Illegal response type received in service method "+ T.name+"#"+method.name));
		                                        return;
		                                    }
		                                    callback(null, res);
		                                });
		                            } catch (err) {
		                                setTimeout(callback.bind(this, err), 0);
		                            }
		                        };
	
		                        // Service.Method(rpcImpl, message, callback)
		                        Service[method.name] = function(rpcImpl, req, callback) {
		                            new Service(rpcImpl)[method.name](req, callback);
		                        };
	
		                        if (Object.defineProperty)
		                            Object.defineProperty(Service[method.name], "$options", { "value": method.buildOpt() }),
		                            Object.defineProperty(ServicePrototype[method.name], "$options", { "value": Service[method.name]["$options"] });
		                    })(rpc[i]);
		                }
	
		                // Properties
	
		                /**
		                 * Service options.
		                 * @name ProtoBuf.Builder.Service.$options
		                 * @type {Object.<string,*>}
		                 * @expose
		                 */
		                var $optionsS; // cc needs this
	
		                /**
		                 * Service options.
		                 * @name ProtoBuf.Builder.Service#$options
		                 * @type {Object.<string,*>}
		                 * @expose
		                 */
		                var $options;
	
		                /**
		                 * Reflection type.
		                 * @name ProtoBuf.Builder.Service.$type
		                 * @type {!ProtoBuf.Reflect.Service}
		                 * @expose
		                 */
		                var $typeS;
	
		                /**
		                 * Reflection type.
		                 * @name ProtoBuf.Builder.Service#$type
		                 * @type {!ProtoBuf.Reflect.Service}
		                 * @expose
		                 */
		                var $type;
	
		                if (Object.defineProperty)
		                    Object.defineProperty(Service, "$options", { "value": T.buildOpt() }),
		                    Object.defineProperty(ServicePrototype, "$options", { "value": Service["$options"] }),
		                    Object.defineProperty(Service, "$type", { "value": T }),
		                    Object.defineProperty(ServicePrototype, "$type", { "value": T });
	
		                return Service;
	
		            })(ProtoBuf, this);
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Service
		         * @expose
		         */
		        Reflect.Service = Service;
	
		        /**
		         * Abstract service method.
		         * @exports ProtoBuf.Reflect.Service.Method
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.Service} svc Service
		         * @param {string} name Method name
		         * @param {Object.<string,*>=} options Options
		         * @constructor
		         * @extends ProtoBuf.Reflect.T
		         */
		        var Method = function(builder, svc, name, options) {
		            T.call(this, builder, svc, name);
	
		            /**
		             * @override
		             */
		            this.className = "Service.Method";
	
		            /**
		             * Options.
		             * @type {Object.<string, *>}
		             * @expose
		             */
		            this.options = options || {};
		        };
	
		        /**
		         * @alias ProtoBuf.Reflect.Service.Method.prototype
		         * @inner
		         */
		        var MethodPrototype = Method.prototype = Object.create(T.prototype);
	
		        /**
		         * Builds the method's '$options' property.
		         * @name ProtoBuf.Reflect.Service.Method#buildOpt
		         * @function
		         * @return {Object.<string,*>}
		         */
		        MethodPrototype.buildOpt = NamespacePrototype.buildOpt;
	
		        /**
		         * @alias ProtoBuf.Reflect.Service.Method
		         * @expose
		         */
		        Reflect.Service.Method = Method;
	
		        /**
		         * RPC service method.
		         * @exports ProtoBuf.Reflect.Service.RPCMethod
		         * @param {!ProtoBuf.Builder} builder Builder reference
		         * @param {!ProtoBuf.Reflect.Service} svc Service
		         * @param {string} name Method name
		         * @param {string} request Request message name
		         * @param {string} response Response message name
		         * @param {boolean} request_stream Whether requests are streamed
		         * @param {boolean} response_stream Whether responses are streamed
		         * @param {Object.<string,*>=} options Options
		         * @constructor
		         * @extends ProtoBuf.Reflect.Service.Method
		         */
		        var RPCMethod = function(builder, svc, name, request, response, request_stream, response_stream, options) {
		            Method.call(this, builder, svc, name, options);
	
		            /**
		             * @override
		             */
		            this.className = "Service.RPCMethod";
	
		            /**
		             * Request message name.
		             * @type {string}
		             * @expose
		             */
		            this.requestName = request;
	
		            /**
		             * Response message name.
		             * @type {string}
		             * @expose
		             */
		            this.responseName = response;
	
		            /**
		             * Whether requests are streamed
		             * @type {bool}
		             * @expose
		             */
		            this.requestStream = request_stream;
	
		            /**
		             * Whether responses are streamed
		             * @type {bool}
		             * @expose
		             */
		            this.responseStream = response_stream;
	
		            /**
		             * Resolved request message type.
		             * @type {ProtoBuf.Reflect.Message}
		             * @expose
		             */
		            this.resolvedRequestType = null;
	
		            /**
		             * Resolved response message type.
		             * @type {ProtoBuf.Reflect.Message}
		             * @expose
		             */
		            this.resolvedResponseType = null;
		        };
	
		        // Extends Method
		        RPCMethod.prototype = Object.create(Method.prototype);
	
		        /**
		         * @alias ProtoBuf.Reflect.Service.RPCMethod
		         * @expose
		         */
		        Reflect.Service.RPCMethod = RPCMethod;
	
		        return Reflect;
	
		    })(ProtoBuf);
	
		    /**
		     * @alias ProtoBuf.Builder
		     * @expose
		     */
		    ProtoBuf.Builder = (function(ProtoBuf, Lang, Reflect) {
		        "use strict";
	
		        /**
		         * Constructs a new Builder.
		         * @exports ProtoBuf.Builder
		         * @class Provides the functionality to build protocol messages.
		         * @param {Object.<string,*>=} options Options
		         * @constructor
		         */
		        var Builder = function(options) {
	
		            /**
		             * Namespace.
		             * @type {ProtoBuf.Reflect.Namespace}
		             * @expose
		             */
		            this.ns = new Reflect.Namespace(this, null, ""); // Global namespace
	
		            /**
		             * Namespace pointer.
		             * @type {ProtoBuf.Reflect.T}
		             * @expose
		             */
		            this.ptr = this.ns;
	
		            /**
		             * Resolved flag.
		             * @type {boolean}
		             * @expose
		             */
		            this.resolved = false;
	
		            /**
		             * The current building result.
		             * @type {Object.<string,ProtoBuf.Builder.Message|Object>|null}
		             * @expose
		             */
		            this.result = null;
	
		            /**
		             * Imported files.
		             * @type {Array.<string>}
		             * @expose
		             */
		            this.files = {};
	
		            /**
		             * Import root override.
		             * @type {?string}
		             * @expose
		             */
		            this.importRoot = null;
	
		            /**
		             * Options.
		             * @type {!Object.<string, *>}
		             * @expose
		             */
		            this.options = options || {};
		        };
	
		        /**
		         * @alias ProtoBuf.Builder.prototype
		         * @inner
		         */
		        var BuilderPrototype = Builder.prototype;
	
		        // ----- Definition tests -----
	
		        /**
		         * Tests if a definition most likely describes a message.
		         * @param {!Object} def
		         * @returns {boolean}
		         * @expose
		         */
		        Builder.isMessage = function(def) {
		            // Messages require a string name
		            if (typeof def["name"] !== 'string')
		                return false;
		            // Messages do not contain values (enum) or rpc methods (service)
		            if (typeof def["values"] !== 'undefined' || typeof def["rpc"] !== 'undefined')
		                return false;
		            return true;
		        };
	
		        /**
		         * Tests if a definition most likely describes a message field.
		         * @param {!Object} def
		         * @returns {boolean}
		         * @expose
		         */
		        Builder.isMessageField = function(def) {
		            // Message fields require a string rule, name and type and an id
		            if (typeof def["rule"] !== 'string' || typeof def["name"] !== 'string' || typeof def["type"] !== 'string' || typeof def["id"] === 'undefined')
		                return false;
		            return true;
		        };
	
		        /**
		         * Tests if a definition most likely describes an enum.
		         * @param {!Object} def
		         * @returns {boolean}
		         * @expose
		         */
		        Builder.isEnum = function(def) {
		            // Enums require a string name
		            if (typeof def["name"] !== 'string')
		                return false;
		            // Enums require at least one value
		            if (typeof def["values"] === 'undefined' || !Array.isArray(def["values"]) || def["values"].length === 0)
		                return false;
		            return true;
		        };
	
		        /**
		         * Tests if a definition most likely describes a service.
		         * @param {!Object} def
		         * @returns {boolean}
		         * @expose
		         */
		        Builder.isService = function(def) {
		            // Services require a string name and an rpc object
		            if (typeof def["name"] !== 'string' || typeof def["rpc"] !== 'object' || !def["rpc"])
		                return false;
		            return true;
		        };
	
		        /**
		         * Tests if a definition most likely describes an extended message
		         * @param {!Object} def
		         * @returns {boolean}
		         * @expose
		         */
		        Builder.isExtend = function(def) {
		            // Extends rquire a string ref
		            if (typeof def["ref"] !== 'string')
		                return false;
		            return true;
		        };
	
		        // ----- Building -----
	
		        /**
		         * Resets the pointer to the root namespace.
		         * @returns {!ProtoBuf.Builder} this
		         * @expose
		         */
		        BuilderPrototype.reset = function() {
		            this.ptr = this.ns;
		            return this;
		        };
	
		        /**
		         * Defines a namespace on top of the current pointer position and places the pointer on it.
		         * @param {string} namespace
		         * @return {!ProtoBuf.Builder} this
		         * @expose
		         */
		        BuilderPrototype.define = function(namespace) {
		            if (typeof namespace !== 'string' || !Lang.TYPEREF.test(namespace))
		                throw Error("illegal namespace: "+namespace);
		            namespace.split(".").forEach(function(part) {
		                var ns = this.ptr.getChild(part);
		                if (ns === null) // Keep existing
		                    this.ptr.addChild(ns = new Reflect.Namespace(this, this.ptr, part));
		                this.ptr = ns;
		            }, this);
		            return this;
		        };
	
		        /**
		         * Creates the specified definitions at the current pointer position.
		         * @param {!Array.<!Object>} defs Messages, enums or services to create
		         * @returns {!ProtoBuf.Builder} this
		         * @throws {Error} If a message definition is invalid
		         * @expose
		         */
		        BuilderPrototype.create = function(defs) {
		            if (!defs)
		                return this; // Nothing to create
		            if (!Array.isArray(defs))
		                defs = [defs];
		            else {
		                if (defs.length === 0)
		                    return this;
		                defs = defs.slice();
		            }
	
		            // It's quite hard to keep track of scopes and memory here, so let's do this iteratively.
		            var stack = [defs];
		            while (stack.length > 0) {
		                defs = stack.pop();
	
		                if (!Array.isArray(defs)) // Stack always contains entire namespaces
		                    throw Error("not a valid namespace: "+JSON.stringify(defs));
	
		                while (defs.length > 0) {
		                    var def = defs.shift(); // Namespaces always contain an array of messages, enums and services
	
		                    if (Builder.isMessage(def)) {
		                        var obj = new Reflect.Message(this, this.ptr, def["name"], def["options"], def["isGroup"], def["syntax"]);
	
		                        // Create OneOfs
		                        var oneofs = {};
		                        if (def["oneofs"])
		                            Object.keys(def["oneofs"]).forEach(function(name) {
		                                obj.addChild(oneofs[name] = new Reflect.Message.OneOf(this, obj, name));
		                            }, this);
	
		                        // Create fields
		                        if (def["fields"])
		                            def["fields"].forEach(function(fld) {
		                                if (obj.getChild(fld["id"]|0) !== null)
		                                    throw Error("duplicate or invalid field id in "+obj.name+": "+fld['id']);
		                                if (fld["options"] && typeof fld["options"] !== 'object')
		                                    throw Error("illegal field options in "+obj.name+"#"+fld["name"]);
		                                var oneof = null;
		                                if (typeof fld["oneof"] === 'string' && !(oneof = oneofs[fld["oneof"]]))
		                                    throw Error("illegal oneof in "+obj.name+"#"+fld["name"]+": "+fld["oneof"]);
		                                fld = new Reflect.Message.Field(this, obj, fld["rule"], fld["keytype"], fld["type"], fld["name"], fld["id"], fld["options"], oneof, def["syntax"]);
		                                if (oneof)
		                                    oneof.fields.push(fld);
		                                obj.addChild(fld);
		                            }, this);
	
		                        // Push children to stack
		                        var subObj = [];
		                        if (def["enums"])
		                            def["enums"].forEach(function(enm) {
		                                subObj.push(enm);
		                            });
		                        if (def["messages"])
		                            def["messages"].forEach(function(msg) {
		                                subObj.push(msg);
		                            });
		                        if (def["services"])
		                            def["services"].forEach(function(svc) {
		                                subObj.push(svc);
		                            });
	
		                        // Set extension ranges
		                        if (def["extensions"]) {
		                            if (typeof def["extensions"][0] === 'number') // pre 5.0.1
		                                obj.extensions = [ def["extensions"] ];
		                            else
		                                obj.extensions = def["extensions"];
		                        }
	
		                        // Create on top of current namespace
		                        this.ptr.addChild(obj);
		                        if (subObj.length > 0) {
		                            stack.push(defs); // Push the current level back
		                            defs = subObj; // Continue processing sub level
		                            subObj = null;
		                            this.ptr = obj; // And move the pointer to this namespace
		                            obj = null;
		                            continue;
		                        }
		                        subObj = null;
	
		                    } else if (Builder.isEnum(def)) {
	
		                        obj = new Reflect.Enum(this, this.ptr, def["name"], def["options"], def["syntax"]);
		                        def["values"].forEach(function(val) {
		                            obj.addChild(new Reflect.Enum.Value(this, obj, val["name"], val["id"]));
		                        }, this);
		                        this.ptr.addChild(obj);
	
		                    } else if (Builder.isService(def)) {
	
		                        obj = new Reflect.Service(this, this.ptr, def["name"], def["options"]);
		                        Object.keys(def["rpc"]).forEach(function(name) {
		                            var mtd = def["rpc"][name];
		                            obj.addChild(new Reflect.Service.RPCMethod(this, obj, name, mtd["request"], mtd["response"], !!mtd["request_stream"], !!mtd["response_stream"], mtd["options"]));
		                        }, this);
		                        this.ptr.addChild(obj);
	
		                    } else if (Builder.isExtend(def)) {
	
		                        obj = this.ptr.resolve(def["ref"], true);
		                        if (obj) {
		                            def["fields"].forEach(function(fld) {
		                                if (obj.getChild(fld['id']|0) !== null)
		                                    throw Error("duplicate extended field id in "+obj.name+": "+fld['id']);
		                                // Check if field id is allowed to be extended
		                                if (obj.extensions) {
		                                    var valid = false;
		                                    obj.extensions.forEach(function(range) {
		                                        if (fld["id"] >= range[0] && fld["id"] <= range[1])
		                                            valid = true;
		                                    });
		                                    if (!valid)
		                                        throw Error("illegal extended field id in "+obj.name+": "+fld['id']+" (not within valid ranges)");
		                                }
		                                // Convert extension field names to camel case notation if the override is set
		                                var name = fld["name"];
		                                if (this.options['convertFieldsToCamelCase'])
		                                    name = ProtoBuf.Util.toCamelCase(name);
		                                // see #161: Extensions use their fully qualified name as their runtime key and...
		                                var field = new Reflect.Message.ExtensionField(this, obj, fld["rule"], fld["type"], this.ptr.fqn()+'.'+name, fld["id"], fld["options"]);
		                                // ...are added on top of the current namespace as an extension which is used for
		                                // resolving their type later on (the extension always keeps the original name to
		                                // prevent naming collisions)
		                                var ext = new Reflect.Extension(this, this.ptr, fld["name"], field);
		                                field.extension = ext;
		                                this.ptr.addChild(ext);
		                                obj.addChild(field);
		                            }, this);
	
		                        } else if (!/\.?google\.protobuf\./.test(def["ref"])) // Silently skip internal extensions
		                            throw Error("extended message "+def["ref"]+" is not defined");
	
		                    } else
		                        throw Error("not a valid definition: "+JSON.stringify(def));
	
		                    def = null;
		                    obj = null;
		                }
		                // Break goes here
		                defs = null;
		                this.ptr = this.ptr.parent; // Namespace done, continue at parent
		            }
		            this.resolved = false; // Require re-resolve
		            this.result = null; // Require re-build
		            return this;
		        };
	
		        /**
		         * Propagates syntax to all children.
		         * @param {!Object} parent
		         * @inner
		         */
		        function propagateSyntax(parent) {
		            if (parent['messages']) {
		                parent['messages'].forEach(function(child) {
		                    child["syntax"] = parent["syntax"];
		                    propagateSyntax(child);
		                });
		            }
		            if (parent['enums']) {
		                parent['enums'].forEach(function(child) {
		                    child["syntax"] = parent["syntax"];
		                });
		            }
		        }
	
		        /**
		         * Imports another definition into this builder.
		         * @param {Object.<string,*>} json Parsed import
		         * @param {(string|{root: string, file: string})=} filename Imported file name
		         * @returns {!ProtoBuf.Builder} this
		         * @throws {Error} If the definition or file cannot be imported
		         * @expose
		         */
		        BuilderPrototype["import"] = function(json, filename) {
		            var delim = '/';
	
		            // Make sure to skip duplicate imports
	
		            if (typeof filename === 'string') {
	
		                if (ProtoBuf.Util.IS_NODE)
		                    filename = require$$1$22['resolve'](filename);
		                if (this.files[filename] === true)
		                    return this.reset();
		                this.files[filename] = true;
	
		            } else if (typeof filename === 'object') { // Object with root, file.
	
		                var root = filename.root;
		                if (ProtoBuf.Util.IS_NODE)
		                    root = require$$1$22['resolve'](root);
		                if (root.indexOf("\\") >= 0 || filename.file.indexOf("\\") >= 0)
		                    delim = '\\';
		                var fname = root + delim + filename.file;
		                if (this.files[fname] === true)
		                    return this.reset();
		                this.files[fname] = true;
		            }
	
		            // Import imports
	
		            if (json['imports'] && json['imports'].length > 0) {
		                var importRoot,
		                    resetRoot = false;
	
		                if (typeof filename === 'object') { // If an import root is specified, override
	
		                    this.importRoot = filename["root"]; resetRoot = true; // ... and reset afterwards
		                    importRoot = this.importRoot;
		                    filename = filename["file"];
		                    if (importRoot.indexOf("\\") >= 0 || filename.indexOf("\\") >= 0)
		                        delim = '\\';
	
		                } else if (typeof filename === 'string') {
	
		                    if (this.importRoot) // If import root is overridden, use it
		                        importRoot = this.importRoot;
		                    else { // Otherwise compute from filename
		                        if (filename.indexOf("/") >= 0) { // Unix
		                            importRoot = filename.replace(/\/[^\/]*$/, "");
		                            if (/* /file.proto */ importRoot === "")
		                                importRoot = "/";
		                        } else if (filename.indexOf("\\") >= 0) { // Windows
		                            importRoot = filename.replace(/\\[^\\]*$/, "");
		                            delim = '\\';
		                        } else
		                            importRoot = ".";
		                    }
	
		                } else
		                    importRoot = null;
	
		                for (var i=0; i<json['imports'].length; i++) {
		                    if (typeof json['imports'][i] === 'string') { // Import file
		                        if (!importRoot)
		                            throw Error("cannot determine import root");
		                        var importFilename = json['imports'][i];
		                        if (importFilename === "google/protobuf/descriptor.proto")
		                            continue; // Not needed and therefore not used
		                        importFilename = importRoot + delim + importFilename;
		                        if (this.files[importFilename] === true)
		                            continue; // Already imported
		                        if (/\.proto$/i.test(importFilename) && !ProtoBuf.DotProto)       // If this is a light build
		                            importFilename = importFilename.replace(/\.proto$/, ".json"); // always load the JSON file
		                        var contents = ProtoBuf.Util.fetch(importFilename);
		                        if (contents === null)
		                            throw Error("failed to import '"+importFilename+"' in '"+filename+"': file not found");
		                        if (/\.json$/i.test(importFilename)) // Always possible
		                            this["import"](JSON.parse(contents+""), importFilename); // May throw
		                        else
		                            this["import"](ProtoBuf.DotProto.Parser.parse(contents), importFilename); // May throw
		                    } else // Import structure
		                        if (!filename)
		                            this["import"](json['imports'][i]);
		                        else if (/\.(\w+)$/.test(filename)) // With extension: Append _importN to the name portion to make it unique
		                            this["import"](json['imports'][i], filename.replace(/^(.+)\.(\w+)$/, function($0, $1, $2) { return $1+"_import"+i+"."+$2; }));
		                        else // Without extension: Append _importN to make it unique
		                            this["import"](json['imports'][i], filename+"_import"+i);
		                }
		                if (resetRoot) // Reset import root override when all imports are done
		                    this.importRoot = null;
		            }
	
		            // Import structures
	
		            if (json['package'])
		                this.define(json['package']);
		            if (json['syntax'])
		                propagateSyntax(json);
		            var base = this.ptr;
		            if (json['options'])
		                Object.keys(json['options']).forEach(function(key) {
		                    base.options[key] = json['options'][key];
		                });
		            if (json['messages'])
		                this.create(json['messages']),
		                this.ptr = base;
		            if (json['enums'])
		                this.create(json['enums']),
		                this.ptr = base;
		            if (json['services'])
		                this.create(json['services']),
		                this.ptr = base;
		            if (json['extends'])
		                this.create(json['extends']);
	
		            return this.reset();
		        };
	
		        /**
		         * Resolves all namespace objects.
		         * @throws {Error} If a type cannot be resolved
		         * @returns {!ProtoBuf.Builder} this
		         * @expose
		         */
		        BuilderPrototype.resolveAll = function() {
		            // Resolve all reflected objects
		            var res;
		            if (this.ptr == null || typeof this.ptr.type === 'object')
		                return this; // Done (already resolved)
	
		            if (this.ptr instanceof Reflect.Namespace) { // Resolve children
	
		                this.ptr.children.forEach(function(child) {
		                    this.ptr = child;
		                    this.resolveAll();
		                }, this);
	
		            } else if (this.ptr instanceof Reflect.Message.Field) { // Resolve type
	
		                if (!Lang.TYPE.test(this.ptr.type)) {
		                    if (!Lang.TYPEREF.test(this.ptr.type))
		                        throw Error("illegal type reference in "+this.ptr.toString(true)+": "+this.ptr.type);
		                    res = (this.ptr instanceof Reflect.Message.ExtensionField ? this.ptr.extension.parent : this.ptr.parent).resolve(this.ptr.type, true);
		                    if (!res)
		                        throw Error("unresolvable type reference in "+this.ptr.toString(true)+": "+this.ptr.type);
		                    this.ptr.resolvedType = res;
		                    if (res instanceof Reflect.Enum) {
		                        this.ptr.type = ProtoBuf.TYPES["enum"];
		                        if (this.ptr.syntax === 'proto3' && res.syntax !== 'proto3')
		                            throw Error("proto3 message cannot reference proto2 enum");
		                    }
		                    else if (res instanceof Reflect.Message)
		                        this.ptr.type = res.isGroup ? ProtoBuf.TYPES["group"] : ProtoBuf.TYPES["message"];
		                    else
		                        throw Error("illegal type reference in "+this.ptr.toString(true)+": "+this.ptr.type);
		                } else
		                    this.ptr.type = ProtoBuf.TYPES[this.ptr.type];
	
		                // If it's a map field, also resolve the key type. The key type can be only a numeric, string, or bool type
		                // (i.e., no enums or messages), so we don't need to resolve against the current namespace.
		                if (this.ptr.map) {
		                    if (!Lang.TYPE.test(this.ptr.keyType))
		                        throw Error("illegal key type for map field in "+this.ptr.toString(true)+": "+this.ptr.keyType);
		                    this.ptr.keyType = ProtoBuf.TYPES[this.ptr.keyType];
		                }
	
		            } else if (this.ptr instanceof ProtoBuf.Reflect.Service.Method) {
	
		                if (this.ptr instanceof ProtoBuf.Reflect.Service.RPCMethod) {
		                    res = this.ptr.parent.resolve(this.ptr.requestName, true);
		                    if (!res || !(res instanceof ProtoBuf.Reflect.Message))
		                        throw Error("Illegal type reference in "+this.ptr.toString(true)+": "+this.ptr.requestName);
		                    this.ptr.resolvedRequestType = res;
		                    res = this.ptr.parent.resolve(this.ptr.responseName, true);
		                    if (!res || !(res instanceof ProtoBuf.Reflect.Message))
		                        throw Error("Illegal type reference in "+this.ptr.toString(true)+": "+this.ptr.responseName);
		                    this.ptr.resolvedResponseType = res;
		                } else // Should not happen as nothing else is implemented
		                    throw Error("illegal service type in "+this.ptr.toString(true));
	
		            } else if (
		                !(this.ptr instanceof ProtoBuf.Reflect.Message.OneOf) && // Not built
		                !(this.ptr instanceof ProtoBuf.Reflect.Extension) && // Not built
		                !(this.ptr instanceof ProtoBuf.Reflect.Enum.Value) // Built in enum
		            )
		                throw Error("illegal object in namespace: "+typeof(this.ptr)+": "+this.ptr);
	
		            return this.reset();
		        };
	
		        /**
		         * Builds the protocol. This will first try to resolve all definitions and, if this has been successful,
		         * return the built package.
		         * @param {(string|Array.<string>)=} path Specifies what to return. If omitted, the entire namespace will be returned.
		         * @returns {!ProtoBuf.Builder.Message|!Object.<string,*>}
		         * @throws {Error} If a type could not be resolved
		         * @expose
		         */
		        BuilderPrototype.build = function(path) {
		            this.reset();
		            if (!this.resolved)
		                this.resolveAll(),
		                this.resolved = true,
		                this.result = null; // Require re-build
		            if (this.result === null) // (Re-)Build
		                this.result = this.ns.build();
		            if (!path)
		                return this.result;
		            var part = typeof path === 'string' ? path.split(".") : path,
		                ptr = this.result; // Build namespace pointer (no hasChild etc.)
		            for (var i=0; i<part.length; i++)
		                if (ptr[part[i]])
		                    ptr = ptr[part[i]];
		                else {
		                    ptr = null;
		                    break;
		                }
		            return ptr;
		        };
	
		        /**
		         * Similar to {@link ProtoBuf.Builder#build}, but looks up the internal reflection descriptor.
		         * @param {string=} path Specifies what to return. If omitted, the entire namespace wiil be returned.
		         * @param {boolean=} excludeNonNamespace Excludes non-namespace types like fields, defaults to `false`
		         * @returns {?ProtoBuf.Reflect.T} Reflection descriptor or `null` if not found
		         */
		        BuilderPrototype.lookup = function(path, excludeNonNamespace) {
		            return path ? this.ns.resolve(path, excludeNonNamespace) : this.ns;
		        };
	
		        /**
		         * Returns a string representation of this object.
		         * @return {string} String representation as of "Builder"
		         * @expose
		         */
		        BuilderPrototype.toString = function() {
		            return "Builder";
		        };
	
		        // ----- Base classes -----
		        // Exist for the sole purpose of being able to "... instanceof ProtoBuf.Builder.Message" etc.
	
		        /**
		         * @alias ProtoBuf.Builder.Message
		         */
		        Builder.Message = function() {};
	
		        /**
		         * @alias ProtoBuf.Builder.Enum
		         */
		        Builder.Enum = function() {};
	
		        /**
		         * @alias ProtoBuf.Builder.Message
		         */
		        Builder.Service = function() {};
	
		        return Builder;
	
		    })(ProtoBuf, ProtoBuf.Lang, ProtoBuf.Reflect);
	
		    /**
		     * @alias ProtoBuf.Map
		     * @expose
		     */
		    ProtoBuf.Map = (function(ProtoBuf, Reflect) {
		        "use strict";
	
		        /**
		         * Constructs a new Map. A Map is a container that is used to implement map
		         * fields on message objects. It closely follows the ES6 Map API; however,
		         * it is distinct because we do not want to depend on external polyfills or
		         * on ES6 itself.
		         *
		         * @exports ProtoBuf.Map
		         * @param {!ProtoBuf.Reflect.Field} field Map field
		         * @param {Object.<string,*>=} contents Initial contents
		         * @constructor
		         */
		        var Map = function(field, contents) {
		            if (!field.map)
		                throw Error("field is not a map");
	
		            /**
		             * The field corresponding to this map.
		             * @type {!ProtoBuf.Reflect.Field}
		             */
		            this.field = field;
	
		            /**
		             * Element instance corresponding to key type.
		             * @type {!ProtoBuf.Reflect.Element}
		             */
		            this.keyElem = new Reflect.Element(field.keyType, null, true, field.syntax);
	
		            /**
		             * Element instance corresponding to value type.
		             * @type {!ProtoBuf.Reflect.Element}
		             */
		            this.valueElem = new Reflect.Element(field.type, field.resolvedType, false, field.syntax);
	
		            /**
		             * Internal map: stores mapping of (string form of key) -> (key, value)
		             * pair.
		             *
		             * We provide map semantics for arbitrary key types, but we build on top
		             * of an Object, which has only string keys. In order to avoid the need
		             * to convert a string key back to its native type in many situations,
		             * we store the native key value alongside the value. Thus, we only need
		             * a one-way mapping from a key type to its string form that guarantees
		             * uniqueness and equality (i.e., str(K1) === str(K2) if and only if K1
		             * === K2).
		             *
		             * @type {!Object<string, {key: *, value: *}>}
		             */
		            this.map = {};
	
		            /**
		             * Returns the number of elements in the map.
		             */
		            Object.defineProperty(this, "size", {
		                get: function() { return Object.keys(this.map).length; }
		            });
	
		            // Fill initial contents from a raw object.
		            if (contents) {
		                var keys = Object.keys(contents);
		                for (var i = 0; i < keys.length; i++) {
		                    var key = this.keyElem.valueFromString(keys[i]);
		                    var val = this.valueElem.verifyValue(contents[keys[i]]);
		                    this.map[this.keyElem.valueToString(key)] =
		                        { key: key, value: val };
		                }
		            }
		        };
	
		        var MapPrototype = Map.prototype;
	
		        /**
		         * Helper: return an iterator over an array.
		         * @param {!Array<*>} arr the array
		         * @returns {!Object} an iterator
		         * @inner
		         */
		        function arrayIterator(arr) {
		            var idx = 0;
		            return {
		                next: function() {
		                    if (idx < arr.length)
		                        return { done: false, value: arr[idx++] };
		                    return { done: true };
		                }
		            }
		        }
	
		        /**
		         * Clears the map.
		         */
		        MapPrototype.clear = function() {
		            this.map = {};
		        };
	
		        /**
		         * Deletes a particular key from the map.
		         * @returns {boolean} Whether any entry with this key was deleted.
		         */
		        MapPrototype["delete"] = function(key) {
		            var keyValue = this.keyElem.valueToString(this.keyElem.verifyValue(key));
		            var hadKey = keyValue in this.map;
		            delete this.map[keyValue];
		            return hadKey;
		        };
	
		        /**
		         * Returns an iterator over [key, value] pairs in the map.
		         * @returns {Object} The iterator
		         */
		        MapPrototype.entries = function() {
		            var entries = [];
		            var strKeys = Object.keys(this.map);
		            for (var i = 0, entry; i < strKeys.length; i++)
		                entries.push([(entry=this.map[strKeys[i]]).key, entry.value]);
		            return arrayIterator(entries);
		        };
	
		        /**
		         * Returns an iterator over keys in the map.
		         * @returns {Object} The iterator
		         */
		        MapPrototype.keys = function() {
		            var keys = [];
		            var strKeys = Object.keys(this.map);
		            for (var i = 0; i < strKeys.length; i++)
		                keys.push(this.map[strKeys[i]].key);
		            return arrayIterator(keys);
		        };
	
		        /**
		         * Returns an iterator over values in the map.
		         * @returns {!Object} The iterator
		         */
		        MapPrototype.values = function() {
		            var values = [];
		            var strKeys = Object.keys(this.map);
		            for (var i = 0; i < strKeys.length; i++)
		                values.push(this.map[strKeys[i]].value);
		            return arrayIterator(values);
		        };
	
		        /**
		         * Iterates over entries in the map, calling a function on each.
		         * @param {function(this:*, *, *, *)} cb The callback to invoke with value, key, and map arguments.
		         * @param {Object=} thisArg The `this` value for the callback
		         */
		        MapPrototype.forEach = function(cb, thisArg) {
		            var strKeys = Object.keys(this.map);
		            for (var i = 0, entry; i < strKeys.length; i++)
		                cb.call(thisArg, (entry=this.map[strKeys[i]]).value, entry.key, this);
		        };
	
		        /**
		         * Sets a key in the map to the given value.
		         * @param {*} key The key
		         * @param {*} value The value
		         * @returns {!ProtoBuf.Map} The map instance
		         */
		        MapPrototype.set = function(key, value) {
		            var keyValue = this.keyElem.verifyValue(key);
		            var valValue = this.valueElem.verifyValue(value);
		            this.map[this.keyElem.valueToString(keyValue)] =
		                { key: keyValue, value: valValue };
		            return this;
		        };
	
		        /**
		         * Gets the value corresponding to a key in the map.
		         * @param {*} key The key
		         * @returns {*|undefined} The value, or `undefined` if key not present
		         */
		        MapPrototype.get = function(key) {
		            var keyValue = this.keyElem.valueToString(this.keyElem.verifyValue(key));
		            if (!(keyValue in this.map))
		                return undefined;
		            return this.map[keyValue].value;
		        };
	
		        /**
		         * Determines whether the given key is present in the map.
		         * @param {*} key The key
		         * @returns {boolean} `true` if the key is present
		         */
		        MapPrototype.has = function(key) {
		            var keyValue = this.keyElem.valueToString(this.keyElem.verifyValue(key));
		            return (keyValue in this.map);
		        };
	
		        return Map;
		    })(ProtoBuf, ProtoBuf.Reflect);
	
	
		    /**
		     * Constructs a new empty Builder.
		     * @param {Object.<string,*>=} options Builder options, defaults to global options set on ProtoBuf
		     * @return {!ProtoBuf.Builder} Builder
		     * @expose
		     */
		    ProtoBuf.newBuilder = function(options) {
		        options = options || {};
		        if (typeof options['convertFieldsToCamelCase'] === 'undefined')
		            options['convertFieldsToCamelCase'] = ProtoBuf.convertFieldsToCamelCase;
		        if (typeof options['populateAccessors'] === 'undefined')
		            options['populateAccessors'] = ProtoBuf.populateAccessors;
		        return new ProtoBuf.Builder(options);
		    };
	
		    /**
		     * Loads a .json definition and returns the Builder.
		     * @param {!*|string} json JSON definition
		     * @param {(ProtoBuf.Builder|string|{root: string, file: string})=} builder Builder to append to. Will create a new one if omitted.
		     * @param {(string|{root: string, file: string})=} filename The corresponding file name if known. Must be specified for imports.
		     * @return {ProtoBuf.Builder} Builder to create new messages
		     * @throws {Error} If the definition cannot be parsed or built
		     * @expose
		     */
		    ProtoBuf.loadJson = function(json, builder, filename) {
		        if (typeof builder === 'string' || (builder && typeof builder["file"] === 'string' && typeof builder["root"] === 'string'))
		            filename = builder,
		            builder = null;
		        if (!builder || typeof builder !== 'object')
		            builder = ProtoBuf.newBuilder();
		        if (typeof json === 'string')
		            json = JSON.parse(json);
		        builder["import"](json, filename);
		        builder.resolveAll();
		        return builder;
		    };
	
		    /**
		     * Loads a .json file and returns the Builder.
		     * @param {string|!{root: string, file: string}} filename Path to json file or an object specifying 'file' with
		     *  an overridden 'root' path for all imported files.
		     * @param {function(?Error, !ProtoBuf.Builder=)=} callback Callback that will receive `null` as the first and
		     *  the Builder as its second argument on success, otherwise the error as its first argument. If omitted, the
		     *  file will be read synchronously and this function will return the Builder.
		     * @param {ProtoBuf.Builder=} builder Builder to append to. Will create a new one if omitted.
		     * @return {?ProtoBuf.Builder|undefined} The Builder if synchronous (no callback specified, will be NULL if the
		     *   request has failed), else undefined
		     * @expose
		     */
		    ProtoBuf.loadJsonFile = function(filename, callback, builder) {
		        if (callback && typeof callback === 'object')
		            builder = callback,
		            callback = null;
		        else if (!callback || typeof callback !== 'function')
		            callback = null;
		        if (callback)
		            return ProtoBuf.Util.fetch(typeof filename === 'string' ? filename : filename["root"]+"/"+filename["file"], function(contents) {
		                if (contents === null) {
		                    callback(Error("Failed to fetch file"));
		                    return;
		                }
		                try {
		                    callback(null, ProtoBuf.loadJson(JSON.parse(contents), builder, filename));
		                } catch (e) {
		                    callback(e);
		                }
		            });
		        var contents = ProtoBuf.Util.fetch(typeof filename === 'object' ? filename["root"]+"/"+filename["file"] : filename);
		        return contents === null ? null : ProtoBuf.loadJson(JSON.parse(contents), builder, filename);
		    };
	
		    return ProtoBuf;
		});
		});
	
		var require$$0$39 = (protobufLight && typeof protobufLight === 'object' && 'default' in protobufLight ? protobufLight['default'] : protobufLight);
	
		var messageCompiled = createCommonjsModule(function (module) {
		    module.exports = require$$0$39.newBuilder({})['import']({
		        "package": "push_server.messages",
		        "options": {
		            "objc_class_prefix": "AVIM"
		        },
		        "messages": [{
		            "name": "JsonObjectMessage",
		            "fields": [{
		                "rule": "required",
		                "type": "string",
		                "name": "data",
		                "id": 1
		            }]
		        }, {
		            "name": "UnreadTuple",
		            "fields": [{
		                "rule": "required",
		                "type": "string",
		                "name": "cid",
		                "id": 1
		            }, {
		                "rule": "required",
		                "type": "int32",
		                "name": "unread",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "mid",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "timestamp",
		                "id": 4
		            }]
		        }, {
		            "name": "LogItem",
		            "fields": [{
		                "rule": "optional",
		                "type": "string",
		                "name": "from",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "data",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "timestamp",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "msgId",
		                "id": 4
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "ackAt",
		                "id": 5
		            }]
		        }, {
		            "name": "LoginCommand",
		            "fields": []
		        }, {
		            "name": "DataCommand",
		            "fields": [{
		                "rule": "repeated",
		                "type": "string",
		                "name": "ids",
		                "id": 1
		            }, {
		                "rule": "repeated",
		                "type": "JsonObjectMessage",
		                "name": "msg",
		                "id": 2
		            }]
		        }, {
		            "name": "SessionCommand",
		            "fields": [{
		                "rule": "optional",
		                "type": "int64",
		                "name": "t",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "n",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "s",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "ua",
		                "id": 4
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "r",
		                "id": 5
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "tag",
		                "id": 6
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "deviceId",
		                "id": 7
		            }, {
		                "rule": "repeated",
		                "type": "string",
		                "name": "sessionPeerIds",
		                "id": 8
		            }, {
		                "rule": "repeated",
		                "type": "string",
		                "name": "onlineSessionPeerIds",
		                "id": 9
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "st",
		                "id": 10
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "stTtl",
		                "id": 11
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "code",
		                "id": 12
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "reason",
		                "id": 13
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "deviceToken",
		                "id": 14
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "sp",
		                "id": 15
		            }]
		        }, {
		            "name": "ErrorCommand",
		            "fields": [{
		                "rule": "required",
		                "type": "int32",
		                "name": "code",
		                "id": 1
		            }, {
		                "rule": "required",
		                "type": "string",
		                "name": "reason",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "appCode",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "detail",
		                "id": 4
		            }]
		        }, {
		            "name": "DirectCommand",
		            "fields": [{
		                "rule": "optional",
		                "type": "string",
		                "name": "msg",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "uid",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "fromPeerId",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "timestamp",
		                "id": 4
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "offline",
		                "id": 5
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "hasMore",
		                "id": 6
		            }, {
		                "rule": "repeated",
		                "type": "string",
		                "name": "toPeerIds",
		                "id": 7
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "r",
		                "id": 10
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "cid",
		                "id": 11
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "id",
		                "id": 12
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "transient",
		                "id": 13
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "dt",
		                "id": 14
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "roomId",
		                "id": 15
		            }]
		        }, {
		            "name": "AckCommand",
		            "fields": [{
		                "rule": "optional",
		                "type": "int32",
		                "name": "code",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "reason",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "mid",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "cid",
		                "id": 4
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "t",
		                "id": 5
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "uid",
		                "id": 6
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "fromts",
		                "id": 7
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "tots",
		                "id": 8
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "type",
		                "id": 9
		            }, {
		                "rule": "repeated",
		                "type": "string",
		                "name": "ids",
		                "id": 10
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "appCode",
		                "id": 11
		            }]
		        }, {
		            "name": "UnreadCommand",
		            "fields": [{
		                "rule": "repeated",
		                "type": "UnreadTuple",
		                "name": "convs",
		                "id": 1
		            }]
		        }, {
		            "name": "ConvCommand",
		            "fields": [{
		                "rule": "repeated",
		                "type": "string",
		                "name": "m",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "transient",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "unique",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "cid",
		                "id": 4
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "cdate",
		                "id": 5
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "initBy",
		                "id": 6
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "sort",
		                "id": 7
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "limit",
		                "id": 8
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "skip",
		                "id": 9
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "flag",
		                "id": 10
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "count",
		                "id": 11
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "udate",
		                "id": 12
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "t",
		                "id": 13
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "n",
		                "id": 14
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "s",
		                "id": 15
		            }, {
		                "rule": "optional",
		                "type": "JsonObjectMessage",
		                "name": "results",
		                "id": 100
		            }, {
		                "rule": "optional",
		                "type": "JsonObjectMessage",
		                "name": "where",
		                "id": 101
		            }, {
		                "rule": "optional",
		                "type": "JsonObjectMessage",
		                "name": "attr",
		                "id": 103
		            }]
		        }, {
		            "name": "RoomCommand",
		            "fields": [{
		                "rule": "optional",
		                "type": "string",
		                "name": "roomId",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "s",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "t",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "n",
		                "id": 4
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "transient",
		                "id": 5
		            }, {
		                "rule": "repeated",
		                "type": "string",
		                "name": "roomPeerIds",
		                "id": 6
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "byPeerId",
		                "id": 7
		            }]
		        }, {
		            "name": "LogsCommand",
		            "fields": [{
		                "rule": "optional",
		                "type": "string",
		                "name": "cid",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "l",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "limit",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "t",
		                "id": 4
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "tt",
		                "id": 5
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "tmid",
		                "id": 6
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "mid",
		                "id": 7
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "checksum",
		                "id": 8
		            }, {
		                "rule": "optional",
		                "type": "bool",
		                "name": "stored",
		                "id": 9
		            }, {
		                "rule": "repeated",
		                "type": "LogItem",
		                "name": "logs",
		                "id": 105
		            }]
		        }, {
		            "name": "RcpCommand",
		            "fields": [{
		                "rule": "optional",
		                "type": "string",
		                "name": "id",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "cid",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "t",
		                "id": 3
		            }]
		        }, {
		            "name": "ReadTuple",
		            "fields": [{
		                "rule": "required",
		                "type": "string",
		                "name": "cid",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "int64",
		                "name": "timestamp",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "mid",
		                "id": 3
		            }]
		        }, {
		            "name": "ReadCommand",
		            "fields": [{
		                "rule": "optional",
		                "type": "string",
		                "name": "cid",
		                "id": 1
		            }, {
		                "rule": "repeated",
		                "type": "string",
		                "name": "cids",
		                "id": 2
		            }, {
		                "rule": "repeated",
		                "type": "ReadTuple",
		                "name": "convs",
		                "id": 3
		            }]
		        }, {
		            "name": "PresenceCommand",
		            "fields": [{
		                "rule": "optional",
		                "type": "StatusType",
		                "name": "status",
		                "id": 1
		            }, {
		                "rule": "repeated",
		                "type": "string",
		                "name": "sessionPeerIds",
		                "id": 2
		            }]
		        }, {
		            "name": "ReportCommand",
		            "fields": [{
		                "rule": "optional",
		                "type": "bool",
		                "name": "initiative",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "type",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "data",
		                "id": 3
		            }]
		        }, {
		            "name": "GenericCommand",
		            "fields": [{
		                "rule": "required",
		                "type": "CommandType",
		                "name": "cmd",
		                "id": 1
		            }, {
		                "rule": "optional",
		                "type": "OpType",
		                "name": "op",
		                "id": 2
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "appId",
		                "id": 3
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "peerId",
		                "id": 4
		            }, {
		                "rule": "optional",
		                "type": "int32",
		                "name": "i",
		                "id": 5
		            }, {
		                "rule": "optional",
		                "type": "string",
		                "name": "installationId",
		                "id": 6
		            }, {
		                "rule": "optional",
		                "type": "LoginCommand",
		                "name": "loginMessage",
		                "id": 100
		            }, {
		                "rule": "optional",
		                "type": "DataCommand",
		                "name": "dataMessage",
		                "id": 101
		            }, {
		                "rule": "optional",
		                "type": "SessionCommand",
		                "name": "sessionMessage",
		                "id": 102
		            }, {
		                "rule": "optional",
		                "type": "ErrorCommand",
		                "name": "errorMessage",
		                "id": 103
		            }, {
		                "rule": "optional",
		                "type": "DirectCommand",
		                "name": "directMessage",
		                "id": 104
		            }, {
		                "rule": "optional",
		                "type": "AckCommand",
		                "name": "ackMessage",
		                "id": 105
		            }, {
		                "rule": "optional",
		                "type": "UnreadCommand",
		                "name": "unreadMessage",
		                "id": 106
		            }, {
		                "rule": "optional",
		                "type": "ReadCommand",
		                "name": "readMessage",
		                "id": 107
		            }, {
		                "rule": "optional",
		                "type": "RcpCommand",
		                "name": "rcpMessage",
		                "id": 108
		            }, {
		                "rule": "optional",
		                "type": "LogsCommand",
		                "name": "logsMessage",
		                "id": 109
		            }, {
		                "rule": "optional",
		                "type": "ConvCommand",
		                "name": "convMessage",
		                "id": 110
		            }, {
		                "rule": "optional",
		                "type": "RoomCommand",
		                "name": "roomMessage",
		                "id": 111
		            }, {
		                "rule": "optional",
		                "type": "PresenceCommand",
		                "name": "presenceMessage",
		                "id": 112
		            }, {
		                "rule": "optional",
		                "type": "ReportCommand",
		                "name": "reportMessage",
		                "id": 113
		            }]
		        }],
		        "enums": [{
		            "name": "CommandType",
		            "values": [{
		                "name": "session",
		                "id": 0
		            }, {
		                "name": "conv",
		                "id": 1
		            }, {
		                "name": "direct",
		                "id": 2
		            }, {
		                "name": "ack",
		                "id": 3
		            }, {
		                "name": "rcp",
		                "id": 4
		            }, {
		                "name": "unread",
		                "id": 5
		            }, {
		                "name": "logs",
		                "id": 6
		            }, {
		                "name": "error",
		                "id": 7
		            }, {
		                "name": "login",
		                "id": 8
		            }, {
		                "name": "data",
		                "id": 9
		            }, {
		                "name": "room",
		                "id": 10
		            }, {
		                "name": "read",
		                "id": 11
		            }, {
		                "name": "presence",
		                "id": 12
		            }, {
		                "name": "report",
		                "id": 13
		            }, {
		                "name": "echo",
		                "id": 14
		            }]
		        }, {
		            "name": "OpType",
		            "values": [{
		                "name": "open",
		                "id": 1
		            }, {
		                "name": "add",
		                "id": 2
		            }, {
		                "name": "remove",
		                "id": 3
		            }, {
		                "name": "close",
		                "id": 4
		            }, {
		                "name": "opened",
		                "id": 5
		            }, {
		                "name": "closed",
		                "id": 6
		            }, {
		                "name": "query",
		                "id": 7
		            }, {
		                "name": "query_result",
		                "id": 8
		            }, {
		                "name": "conflict",
		                "id": 9
		            }, {
		                "name": "added",
		                "id": 10
		            }, {
		                "name": "removed",
		                "id": 11
		            }, {
		                "name": "start",
		                "id": 30
		            }, {
		                "name": "started",
		                "id": 31
		            }, {
		                "name": "joined",
		                "id": 32
		            }, {
		                "name": "members_joined",
		                "id": 33
		            }, {
		                "name": "left",
		                "id": 39
		            }, {
		                "name": "members_left",
		                "id": 40
		            }, {
		                "name": "results",
		                "id": 42
		            }, {
		                "name": "count",
		                "id": 43
		            }, {
		                "name": "result",
		                "id": 44
		            }, {
		                "name": "update",
		                "id": 45
		            }, {
		                "name": "updated",
		                "id": 46
		            }, {
		                "name": "mute",
		                "id": 47
		            }, {
		                "name": "unmute",
		                "id": 48
		            }, {
		                "name": "join",
		                "id": 80
		            }, {
		                "name": "invite",
		                "id": 81
		            }, {
		                "name": "leave",
		                "id": 82
		            }, {
		                "name": "kick",
		                "id": 83
		            }, {
		                "name": "reject",
		                "id": 84
		            }, {
		                "name": "invited",
		                "id": 85
		            }, {
		                "name": "kicked",
		                "id": 86
		            }, {
		                "name": "upload",
		                "id": 100
		            }, {
		                "name": "uploaded",
		                "id": 101
		            }]
		        }, {
		            "name": "StatusType",
		            "values": [{
		                "name": "on",
		                "id": 1
		            }, {
		                "name": "off",
		                "id": 2
		            }]
		        }]
		    }).build();
		});
	
		var messages = messageCompiled && (typeof messageCompiled === 'undefined' ? 'undefined' : _typeof$1(messageCompiled)) === 'object' && 'default' in messageCompiled ? messageCompiled['default'] : messageCompiled;
	
		var _messages$push_server = messages.push_server.messages;
		var JsonObjectMessage = _messages$push_server.JsonObjectMessage;
		var UnreadTuple = _messages$push_server.UnreadTuple;
		var LogItem = _messages$push_server.LogItem;
		var LoginCommand = _messages$push_server.LoginCommand;
		var DataCommand = _messages$push_server.DataCommand;
		var SessionCommand = _messages$push_server.SessionCommand;
		var ErrorCommand = _messages$push_server.ErrorCommand;
		var DirectCommand = _messages$push_server.DirectCommand;
		var AckCommand = _messages$push_server.AckCommand;
		var UnreadCommand = _messages$push_server.UnreadCommand;
		var ConvCommand = _messages$push_server.ConvCommand;
		var RoomCommand = _messages$push_server.RoomCommand;
		var LogsCommand = _messages$push_server.LogsCommand;
		var RcpCommand = _messages$push_server.RcpCommand;
		var ReadTuple = _messages$push_server.ReadTuple;
		var ReadCommand = _messages$push_server.ReadCommand;
		var PresenceCommand = _messages$push_server.PresenceCommand;
		var ReportCommand = _messages$push_server.ReportCommand;
		var GenericCommand = _messages$push_server.GenericCommand;
		var CommandType = _messages$push_server.CommandType;
		var OpType = _messages$push_server.OpType;
		var StatusType = _messages$push_server.StatusType;
	
		var debug$1 = d('LC:Connection');
	
		var COMMAND_TIMEOUT = 20000;
	
		var Connection = function (_WebSocketPlus) {
		  _inherits(Connection, _WebSocketPlus);
	
		  function Connection(getUrl, _ref) {
		    var format = _ref.format;
		    var version = _ref.version;
	
		    _classCallCheck(this, Connection);
	
		    debug$1('initializing Connection');
		    var protocolString = 'lc.' + format + '.' + version;
	
		    var _this = _possibleConstructorReturn(this, _WebSocketPlus.call(this, getUrl, protocolString));
	
		    _this._protocalFormat = format;
		    _this._commands = {};
		    _this._serialId = 0;
		    return _this;
		  }
	
		  Connection.prototype.send = function send(command) {
		    var _this2 = this;
	
		    var waitingForRespond = arguments.length <= 1 || arguments[1] === undefined ? true : arguments[1];
	
		    var serialId = void 0;
		    if (waitingForRespond) {
		      serialId = ++this._serialId;
		      command.i = serialId; // eslint-disable-line no-param-reassign
		    }
		    debug$1('↑', trim(command), 'sent');
	
		    var message = void 0;
		    if (this._protocalFormat === 'protobase64') {
		      message = command.toBase64();
		    } else {
		      if (command.toBuffer) {
		        message = command.toBuffer();
		      } else if (command.toArrayBuffer) {
		        message = command.toArrayBuffer();
		      }
		    }
		    if (!message) {
		      throw new TypeError(command + ' is not a GenericCommand');
		    }
	
		    _WebSocketPlus.prototype.send.call(this, message);
	
		    if (!waitingForRespond) {
		      return _Promise.resolve();
		    }
		    return new _Promise(function (resolve, reject) {
		      _this2._commands[serialId] = {
		        resolve: resolve,
		        reject: reject
		      };
		      setTimeout(function () {
		        if (_this2._commands[serialId]) {
		          debug$1('✗', trim(command), 'timeout');
		          reject(new Error('Command Timeout.'));
		          delete _this2._commands[serialId];
		        }
		      }, COMMAND_TIMEOUT);
		    });
		  };
	
		  Connection.prototype.handleMessage = function handleMessage(msg) {
		    var message = void 0;
		    try {
		      message = GenericCommand.decode(msg);
		      debug$1('↓', trim(message), 'received');
		    } catch (e) {
		      console.warn('Decode message failed', msg);
		    }
		    this.emit('allmessage', message);
		    var serialId = message.i;
		    if (serialId) {
		      if (this._commands[serialId]) {
		        if (message.cmd === CommandType.error) {
		          this._commands[serialId].reject(createError(message.errorMessage));
		        } else {
		          this._commands[serialId].resolve(message);
		        }
		        delete this._commands[serialId];
		      } else {
		        console.warn('Unexpected command received with serialId [' + serialId + '],\n         which have timed out or never been requested.');
		      }
		    } else {
		      if (message.cmd === CommandType.error) {
		        this.emit('error', createError(message.errorMessage));
		      } else {
		        this.emit('message', message);
		      }
		    }
		  };
	
		  Connection.prototype.ping = function ping() {
		    return this.send(new GenericCommand({
		      cmd: 'echo'
		    })).catch(function (error) {
		      return console.warn('ping failed:', error);
		    });
		  };
	
		  return Connection;
		}(WebSocketPlus);
	
		var spread = createCommonjsModule(function (module) {
		  'use strict';
	
		  /**
		   * Syntactic sugar for invoking a function and expanding an array for arguments.
		   *
		   * Common use case would be to use `Function.prototype.apply`.
		   *
		   *  ```js
		   *  function f(x, y, z) {}
		   *  var args = [1, 2, 3];
		   *  f.apply(null, args);
		   *  ```
		   *
		   * With `spread` this example can be re-written.
		   *
		   *  ```js
		   *  spread(function(x, y, z) {})([1, 2, 3]);
		   *  ```
		   *
		   * @param {Function} callback
		   * @returns {Function}
		   */
	
		  module.exports = function spread(callback) {
		    return function wrap(arr) {
		      return callback.apply(null, arr);
		    };
		  };
		});
	
		var require$$0$42 = spread && (typeof spread === 'undefined' ? 'undefined' : _typeof$1(spread)) === 'object' && 'default' in spread ? spread['default'] : spread;
	
		var utils = createCommonjsModule(function (module) {
		  'use strict';
	
		  /*global toString:true*/
	
		  // utils is a library of generic helper functions non-specific to axios
	
		  var toString = Object.prototype.toString;
	
		  /**
		   * Determine if a value is an Array
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is an Array, otherwise false
		   */
		  function isArray(val) {
		    return toString.call(val) === '[object Array]';
		  }
	
		  /**
		   * Determine if a value is an ArrayBuffer
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is an ArrayBuffer, otherwise false
		   */
		  function isArrayBuffer(val) {
		    return toString.call(val) === '[object ArrayBuffer]';
		  }
	
		  /**
		   * Determine if a value is a FormData
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is an FormData, otherwise false
		   */
		  function isFormData(val) {
		    return typeof FormData !== 'undefined' && val instanceof FormData;
		  }
	
		  /**
		   * Determine if a value is a view on an ArrayBuffer
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
		   */
		  function isArrayBufferView(val) {
		    var result;
		    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) {
		      result = ArrayBuffer.isView(val);
		    } else {
		      result = val && val.buffer && val.buffer instanceof ArrayBuffer;
		    }
		    return result;
		  }
	
		  /**
		   * Determine if a value is a String
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is a String, otherwise false
		   */
		  function isString(val) {
		    return typeof val === 'string';
		  }
	
		  /**
		   * Determine if a value is a Number
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is a Number, otherwise false
		   */
		  function isNumber(val) {
		    return typeof val === 'number';
		  }
	
		  /**
		   * Determine if a value is undefined
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if the value is undefined, otherwise false
		   */
		  function isUndefined(val) {
		    return typeof val === 'undefined';
		  }
	
		  /**
		   * Determine if a value is an Object
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is an Object, otherwise false
		   */
		  function isObject(val) {
		    return val !== null && (typeof val === 'undefined' ? 'undefined' : _typeof$1(val)) === 'object';
		  }
	
		  /**
		   * Determine if a value is a Date
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is a Date, otherwise false
		   */
		  function isDate(val) {
		    return toString.call(val) === '[object Date]';
		  }
	
		  /**
		   * Determine if a value is a File
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is a File, otherwise false
		   */
		  function isFile(val) {
		    return toString.call(val) === '[object File]';
		  }
	
		  /**
		   * Determine if a value is a Blob
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is a Blob, otherwise false
		   */
		  function isBlob(val) {
		    return toString.call(val) === '[object Blob]';
		  }
	
		  /**
		   * Determine if a value is a Function
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is a Function, otherwise false
		   */
		  function isFunction(val) {
		    return toString.call(val) === '[object Function]';
		  }
	
		  /**
		   * Determine if a value is a Stream
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is a Stream, otherwise false
		   */
		  function isStream(val) {
		    return isObject(val) && isFunction(val.pipe);
		  }
	
		  /**
		   * Determine if a value is a URLSearchParams object
		   *
		   * @param {Object} val The value to test
		   * @returns {boolean} True if value is a URLSearchParams object, otherwise false
		   */
		  function isURLSearchParams(val) {
		    return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
		  }
	
		  /**
		   * Trim excess whitespace off the beginning and end of a string
		   *
		   * @param {String} str The String to trim
		   * @returns {String} The String freed of excess whitespace
		   */
		  function trim(str) {
		    return str.replace(/^\s*/, '').replace(/\s*$/, '');
		  }
	
		  /**
		   * Determine if we're running in a standard browser environment
		   *
		   * This allows axios to run in a web worker, and react-native.
		   * Both environments support XMLHttpRequest, but not fully standard globals.
		   *
		   * web workers:
		   *  typeof window -> undefined
		   *  typeof document -> undefined
		   *
		   * react-native:
		   *  typeof document.createElement -> undefined
		   */
		  function isStandardBrowserEnv() {
		    return typeof window !== 'undefined' && typeof document !== 'undefined' && typeof document.createElement === 'function';
		  }
	
		  /**
		   * Iterate over an Array or an Object invoking a function for each item.
		   *
		   * If `obj` is an Array callback will be called passing
		   * the value, index, and complete array for each item.
		   *
		   * If 'obj' is an Object callback will be called passing
		   * the value, key, and complete object for each property.
		   *
		   * @param {Object|Array} obj The object to iterate
		   * @param {Function} fn The callback to invoke for each item
		   */
		  function forEach(obj, fn) {
		    // Don't bother if no value provided
		    if (obj === null || typeof obj === 'undefined') {
		      return;
		    }
	
		    // Force an array if not already something iterable
		    if ((typeof obj === 'undefined' ? 'undefined' : _typeof$1(obj)) !== 'object' && !isArray(obj)) {
		      /*eslint no-param-reassign:0*/
		      obj = [obj];
		    }
	
		    if (isArray(obj)) {
		      // Iterate over array values
		      for (var i = 0, l = obj.length; i < l; i++) {
		        fn.call(null, obj[i], i, obj);
		      }
		    } else {
		      // Iterate over object keys
		      for (var key in obj) {
		        if (obj.hasOwnProperty(key)) {
		          fn.call(null, obj[key], key, obj);
		        }
		      }
		    }
		  }
	
		  /**
		   * Accepts varargs expecting each argument to be an object, then
		   * immutably merges the properties of each object and returns result.
		   *
		   * When multiple objects contain the same key the later object in
		   * the arguments list will take precedence.
		   *
		   * Example:
		   *
		   * ```js
		   * var result = merge({foo: 123}, {foo: 456});
		   * console.log(result.foo); // outputs 456
		   * ```
		   *
		   * @param {Object} obj1 Object to merge
		   * @returns {Object} Result of all merge properties
		   */
		  function merge() /* obj1, obj2, obj3, ... */{
		    var result = {};
		    function assignValue(val, key) {
		      if (_typeof$1(result[key]) === 'object' && (typeof val === 'undefined' ? 'undefined' : _typeof$1(val)) === 'object') {
		        result[key] = merge(result[key], val);
		      } else {
		        result[key] = val;
		      }
		    }
	
		    for (var i = 0, l = arguments.length; i < l; i++) {
		      forEach(arguments[i], assignValue);
		    }
		    return result;
		  }
	
		  module.exports = {
		    isArray: isArray,
		    isArrayBuffer: isArrayBuffer,
		    isFormData: isFormData,
		    isArrayBufferView: isArrayBufferView,
		    isString: isString,
		    isNumber: isNumber,
		    isObject: isObject,
		    isUndefined: isUndefined,
		    isDate: isDate,
		    isFile: isFile,
		    isBlob: isBlob,
		    isFunction: isFunction,
		    isStream: isStream,
		    isURLSearchParams: isURLSearchParams,
		    isStandardBrowserEnv: isStandardBrowserEnv,
		    forEach: forEach,
		    merge: merge,
		    trim: trim
		  };
		});
	
		var require$$0$43 = utils && (typeof utils === 'undefined' ? 'undefined' : _typeof$1(utils)) === 'object' && 'default' in utils ? utils['default'] : utils;
	
		var transformData = createCommonjsModule(function (module) {
		  'use strict';
	
		  var utils = require$$0$43;
	
		  /**
		   * Transform the data for a request or a response
		   *
		   * @param {Object|String} data The data to be transformed
		   * @param {Array} headers The headers for the request or response
		   * @param {Array|Function} fns A single function or Array of functions
		   * @returns {*} The resulting transformed data
		   */
		  module.exports = function transformData(data, headers, fns) {
		    /*eslint no-param-reassign:0*/
		    utils.forEach(fns, function transform(fn) {
		      data = fn(data, headers);
		    });
	
		    return data;
		  };
		});
	
		var require$$4$10 = transformData && (typeof transformData === 'undefined' ? 'undefined' : _typeof$1(transformData)) === 'object' && 'default' in transformData ? transformData['default'] : transformData;
	
		var bind = createCommonjsModule(function (module) {
		  'use strict';
	
		  module.exports = function bind(fn, thisArg) {
		    return function wrap() {
		      var args = new Array(arguments.length);
		      for (var i = 0; i < args.length; i++) {
		        args[i] = arguments[i];
		      }
		      return fn.apply(thisArg, args);
		    };
		  };
		});
	
		var require$$2$9 = bind && (typeof bind === 'undefined' ? 'undefined' : _typeof$1(bind)) === 'object' && 'default' in bind ? bind['default'] : bind;
	
		var combineURLs = createCommonjsModule(function (module) {
		  'use strict';
	
		  /**
		   * Creates a new URL by combining the specified URLs
		   *
		   * @param {string} baseURL The base URL
		   * @param {string} relativeURL The relative URL
		   * @returns {string} The combined URL
		   */
	
		  module.exports = function combineURLs(baseURL, relativeURL) {
		    return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
		  };
		});
	
		var require$$3$6 = combineURLs && (typeof combineURLs === 'undefined' ? 'undefined' : _typeof$1(combineURLs)) === 'object' && 'default' in combineURLs ? combineURLs['default'] : combineURLs;
	
		var isAbsoluteURL = createCommonjsModule(function (module) {
		  'use strict';
	
		  /**
		   * Determines whether the specified URL is absolute
		   *
		   * @param {string} url The URL to test
		   * @returns {boolean} True if the specified URL is absolute, otherwise false
		   */
	
		  module.exports = function isAbsoluteURL(url) {
		    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
		    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
		    // by any combination of letters, digits, plus, period, or hyphen.
		    return (/^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url)
		    );
		  };
		});
	
		var require$$4$11 = isAbsoluteURL && (typeof isAbsoluteURL === 'undefined' ? 'undefined' : _typeof$1(isAbsoluteURL)) === 'object' && 'default' in isAbsoluteURL ? isAbsoluteURL['default'] : isAbsoluteURL;
	
		var InterceptorManager = createCommonjsModule(function (module) {
		  'use strict';
	
		  var utils = require$$0$43;
	
		  function InterceptorManager() {
		    this.handlers = [];
		  }
	
		  /**
		   * Add a new interceptor to the stack
		   *
		   * @param {Function} fulfilled The function to handle `then` for a `Promise`
		   * @param {Function} rejected The function to handle `reject` for a `Promise`
		   *
		   * @return {Number} An ID used to remove interceptor later
		   */
		  InterceptorManager.prototype.use = function use(fulfilled, rejected) {
		    this.handlers.push({
		      fulfilled: fulfilled,
		      rejected: rejected
		    });
		    return this.handlers.length - 1;
		  };
	
		  /**
		   * Remove an interceptor from the stack
		   *
		   * @param {Number} id The ID that was returned by `use`
		   */
		  InterceptorManager.prototype.eject = function eject(id) {
		    if (this.handlers[id]) {
		      this.handlers[id] = null;
		    }
		  };
	
		  /**
		   * Iterate over all the registered interceptors
		   *
		   * This method is particularly useful for skipping over any
		   * interceptors that may have become `null` calling `eject`.
		   *
		   * @param {Function} fn The function to call for each interceptor
		   */
		  InterceptorManager.prototype.forEach = function forEach(fn) {
		    utils.forEach(this.handlers, function forEachHandler(h) {
		      if (h !== null) {
		        fn(h);
		      }
		    });
		  };
	
		  module.exports = InterceptorManager;
		});
	
		var require$$5$2 = InterceptorManager && (typeof InterceptorManager === 'undefined' ? 'undefined' : _typeof$1(InterceptorManager)) === 'object' && 'default' in InterceptorManager ? InterceptorManager['default'] : InterceptorManager;
	
		var cookies = createCommonjsModule(function (module) {
		  'use strict';
	
		  var utils = require$$0$43;
	
		  module.exports = utils.isStandardBrowserEnv() ?
	
		  // Standard browser envs support document.cookie
		  function standardBrowserEnv() {
		    return {
		      write: function write(name, value, expires, path, domain, secure) {
		        var cookie = [];
		        cookie.push(name + '=' + encodeURIComponent(value));
	
		        if (utils.isNumber(expires)) {
		          cookie.push('expires=' + new Date(expires).toGMTString());
		        }
	
		        if (utils.isString(path)) {
		          cookie.push('path=' + path);
		        }
	
		        if (utils.isString(domain)) {
		          cookie.push('domain=' + domain);
		        }
	
		        if (secure === true) {
		          cookie.push('secure');
		        }
	
		        document.cookie = cookie.join('; ');
		      },
	
		      read: function read(name) {
		        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
		        return match ? decodeURIComponent(match[3]) : null;
		      },
	
		      remove: function remove(name) {
		        this.write(name, '', Date.now() - 86400000);
		      }
		    };
		  }() :
	
		  // Non standard browser env (web workers, react-native) lack needed support.
		  function nonStandardBrowserEnv() {
		    return {
		      write: function write() {},
		      read: function read() {
		        return null;
		      },
		      remove: function remove() {}
		    };
		  }();
		});
	
		var require$$0$44 = cookies && (typeof cookies === 'undefined' ? 'undefined' : _typeof$1(cookies)) === 'object' && 'default' in cookies ? cookies['default'] : cookies;
	
		var settle = createCommonjsModule(function (module) {
		  'use strict';
	
		  /**
		   * Resolve or reject a Promise based on response status.
		   *
		   * @param {Function} resolve A function that resolves the promise.
		   * @param {Function} reject A function that rejects the promise.
		   * @param {object} response The response.
		   */
	
		  module.exports = function settle(resolve, reject, response) {
		    var validateStatus = response.config.validateStatus;
		    // Note: status is not exposed by XDomainRequest
		    if (!response.status || !validateStatus || validateStatus(response.status)) {
		      resolve(response);
		    } else {
		      reject(response);
		    }
		  };
		});
	
		var require$$1$24 = settle && (typeof settle === 'undefined' ? 'undefined' : _typeof$1(settle)) === 'object' && 'default' in settle ? settle['default'] : settle;
	
		var btoa = createCommonjsModule(function (module) {
		  'use strict';
	
		  // btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js
	
		  var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
	
		  function E() {
		    this.message = 'String contains an invalid character';
		  }
		  E.prototype = new Error();
		  E.prototype.code = 5;
		  E.prototype.name = 'InvalidCharacterError';
	
		  function btoa(input) {
		    var str = String(input);
		    var output = '';
		    for (
		    // initialize result and counter
		    var block, charCode, idx = 0, map = chars;
		    // if the next str index does not exist:
		    //   change the mapping table to "="
		    //   check if d has no fractional digits
		    str.charAt(idx | 0) || (map = '=', idx % 1);
		    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
		    output += map.charAt(63 & block >> 8 - idx % 1 * 8)) {
		      charCode = str.charCodeAt(idx += 3 / 4);
		      if (charCode > 0xFF) {
		        throw new E();
		      }
		      block = block << 8 | charCode;
		    }
		    return output;
		  }
	
		  module.exports = btoa;
		});
	
		var require$$2$10 = btoa && (typeof btoa === 'undefined' ? 'undefined' : _typeof$1(btoa)) === 'object' && 'default' in btoa ? btoa['default'] : btoa;
	
		var isURLSameOrigin = createCommonjsModule(function (module) {
		  'use strict';
	
		  var utils = require$$0$43;
	
		  module.exports = utils.isStandardBrowserEnv() ?
	
		  // Standard browser envs have full support of the APIs needed to test
		  // whether the request URL is of the same origin as current location.
		  function standardBrowserEnv() {
		    var msie = /(msie|trident)/i.test(navigator.userAgent);
		    var urlParsingNode = document.createElement('a');
		    var originURL;
	
		    /**
		    * Parse a URL to discover it's components
		    *
		    * @param {String} url The URL to be parsed
		    * @returns {Object}
		    */
		    function resolveURL(url) {
		      var href = url;
	
		      if (msie) {
		        // IE needs attribute set twice to normalize properties
		        urlParsingNode.setAttribute('href', href);
		        href = urlParsingNode.href;
		      }
	
		      urlParsingNode.setAttribute('href', href);
	
		      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
		      return {
		        href: urlParsingNode.href,
		        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
		        host: urlParsingNode.host,
		        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
		        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
		        hostname: urlParsingNode.hostname,
		        port: urlParsingNode.port,
		        pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
		      };
		    }
	
		    originURL = resolveURL(window.location.href);
	
		    /**
		    * Determine if a URL shares the same origin as the current location
		    *
		    * @param {String} requestURL The URL to test
		    * @returns {boolean} True if URL shares the same origin, otherwise false
		    */
		    return function isURLSameOrigin(requestURL) {
		      var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
		      return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
		    };
		  }() :
	
		  // Non standard browser envs (web workers, react-native) lack needed support.
		  function nonStandardBrowserEnv() {
		    return function isURLSameOrigin() {
		      return true;
		    };
		  }();
		});
	
		var require$$3$7 = isURLSameOrigin && (typeof isURLSameOrigin === 'undefined' ? 'undefined' : _typeof$1(isURLSameOrigin)) === 'object' && 'default' in isURLSameOrigin ? isURLSameOrigin['default'] : isURLSameOrigin;
	
		var parseHeaders = createCommonjsModule(function (module) {
		  'use strict';
	
		  var utils = require$$0$43;
	
		  /**
		   * Parse headers into an object
		   *
		   * ```
		   * Date: Wed, 27 Aug 2014 08:58:49 GMT
		   * Content-Type: application/json
		   * Connection: keep-alive
		   * Transfer-Encoding: chunked
		   * ```
		   *
		   * @param {String} headers Headers needing to be parsed
		   * @returns {Object} Headers parsed into an object
		   */
		  module.exports = function parseHeaders(headers) {
		    var parsed = {};
		    var key;
		    var val;
		    var i;
	
		    if (!headers) {
		      return parsed;
		    }
	
		    utils.forEach(headers.split('\n'), function parser(line) {
		      i = line.indexOf(':');
		      key = utils.trim(line.substr(0, i)).toLowerCase();
		      val = utils.trim(line.substr(i + 1));
	
		      if (key) {
		        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
		      }
		    });
	
		    return parsed;
		  };
		});
	
		var require$$5$3 = parseHeaders && (typeof parseHeaders === 'undefined' ? 'undefined' : _typeof$1(parseHeaders)) === 'object' && 'default' in parseHeaders ? parseHeaders['default'] : parseHeaders;
	
		var buildURL = createCommonjsModule(function (module) {
		  'use strict';
	
		  var utils = require$$0$43;
	
		  function encode(val) {
		    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%20/g, '+').replace(/%5B/gi, '[').replace(/%5D/gi, ']');
		  }
	
		  /**
		   * Build a URL by appending params to the end
		   *
		   * @param {string} url The base of the url (e.g., http://www.google.com)
		   * @param {object} [params] The params to be appended
		   * @returns {string} The formatted url
		   */
		  module.exports = function buildURL(url, params, paramsSerializer) {
		    /*eslint no-param-reassign:0*/
		    if (!params) {
		      return url;
		    }
	
		    var serializedParams;
		    if (paramsSerializer) {
		      serializedParams = paramsSerializer(params);
		    } else if (utils.isURLSearchParams(params)) {
		      serializedParams = params.toString();
		    } else {
		      var parts = [];
	
		      utils.forEach(params, function serialize(val, key) {
		        if (val === null || typeof val === 'undefined') {
		          return;
		        }
	
		        if (utils.isArray(val)) {
		          key = key + '[]';
		        }
	
		        if (!utils.isArray(val)) {
		          val = [val];
		        }
	
		        utils.forEach(val, function parseValue(v) {
		          if (utils.isDate(v)) {
		            v = v.toISOString();
		          } else if (utils.isObject(v)) {
		            v = _JSON$stringify(v);
		          }
		          parts.push(encode(key) + '=' + encode(v));
		        });
		      });
	
		      serializedParams = parts.join('&');
		    }
	
		    if (serializedParams) {
		      url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
		    }
	
		    return url;
		  };
		});
	
		var require$$6$4 = buildURL && (typeof buildURL === 'undefined' ? 'undefined' : _typeof$1(buildURL)) === 'object' && 'default' in buildURL ? buildURL['default'] : buildURL;
	
		var xhr = createCommonjsModule(function (module) {
		  'use strict';
	
		  var utils = require$$0$43;
		  var buildURL = require$$6$4;
		  var parseHeaders = require$$5$3;
		  var transformData = require$$4$10;
		  var isURLSameOrigin = require$$3$7;
		  var btoa = typeof window !== 'undefined' && window.btoa || require$$2$10;
		  var settle = require$$1$24;
	
		  module.exports = function xhrAdapter(resolve, reject, config) {
		    var requestData = config.data;
		    var requestHeaders = config.headers;
	
		    if (utils.isFormData(requestData)) {
		      delete requestHeaders['Content-Type']; // Let the browser set it
		    }
	
		    var request = new XMLHttpRequest();
		    var loadEvent = 'onreadystatechange';
		    var xDomain = false;
	
		    // For IE 8/9 CORS support
		    // Only supports POST and GET calls and doesn't returns the response headers.
		    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
		    if (process.env.NODE_ENV !== 'test' && typeof window !== 'undefined' && window.XDomainRequest && !('withCredentials' in request) && !isURLSameOrigin(config.url)) {
		      request = new window.XDomainRequest();
		      loadEvent = 'onload';
		      xDomain = true;
		      request.onprogress = function handleProgress() {};
		      request.ontimeout = function handleTimeout() {};
		    }
	
		    // HTTP basic authentication
		    if (config.auth) {
		      var username = config.auth.username || '';
		      var password = config.auth.password || '';
		      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
		    }
	
		    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);
	
		    // Set the request timeout in MS
		    request.timeout = config.timeout;
	
		    // Listen for ready state
		    request[loadEvent] = function handleLoad() {
		      if (!request || request.readyState !== 4 && !xDomain) {
		        return;
		      }
	
		      // The request errored out and we didn't get a response, this will be
		      // handled by onerror instead
		      if (request.status === 0) {
		        return;
		      }
	
		      // Prepare the response
		      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
		      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
		      var response = {
		        data: transformData(responseData, responseHeaders, config.transformResponse),
		        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
		        status: request.status === 1223 ? 204 : request.status,
		        statusText: request.status === 1223 ? 'No Content' : request.statusText,
		        headers: responseHeaders,
		        config: config,
		        request: request
		      };
	
		      settle(resolve, reject, response);
	
		      // Clean up request
		      request = null;
		    };
	
		    // Handle low level network errors
		    request.onerror = function handleError() {
		      // Real errors are hidden from us by the browser
		      // onerror should only fire if it's a network error
		      reject(new Error('Network Error'));
	
		      // Clean up request
		      request = null;
		    };
	
		    // Handle timeout
		    request.ontimeout = function handleTimeout() {
		      var err = new Error('timeout of ' + config.timeout + 'ms exceeded');
		      err.timeout = config.timeout;
		      err.code = 'ECONNABORTED';
		      reject(err);
	
		      // Clean up request
		      request = null;
		    };
	
		    // Add xsrf header
		    // This is only done if running in a standard browser environment.
		    // Specifically not if we're in a web worker, or react-native.
		    if (utils.isStandardBrowserEnv()) {
		      var cookies = require$$0$44;
	
		      // Add xsrf header
		      var xsrfValue = config.withCredentials || isURLSameOrigin(config.url) ? cookies.read(config.xsrfCookieName) : undefined;
	
		      if (xsrfValue) {
		        requestHeaders[config.xsrfHeaderName] = xsrfValue;
		      }
		    }
	
		    // Add headers to the request
		    if ('setRequestHeader' in request) {
		      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
		        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
		          // Remove Content-Type if data is undefined
		          delete requestHeaders[key];
		        } else {
		          // Otherwise add header to the request
		          request.setRequestHeader(key, val);
		        }
		      });
		    }
	
		    // Add withCredentials to request if needed
		    if (config.withCredentials) {
		      request.withCredentials = true;
		    }
	
		    // Add responseType to request if needed
		    if (config.responseType) {
		      try {
		        request.responseType = config.responseType;
		      } catch (e) {
		        if (request.responseType !== 'json') {
		          throw e;
		        }
		      }
		    }
	
		    // Handle progress if needed
		    if (config.progress) {
		      if (config.method === 'post' || config.method === 'put') {
		        request.upload.addEventListener('progress', config.progress);
		      } else if (config.method === 'get') {
		        request.addEventListener('progress', config.progress);
		      }
		    }
	
		    if (requestData === undefined) {
		      requestData = null;
		    }
	
		    // Send the request
		    request.send(requestData);
		  };
		});
	
		var require$$1$23 = xhr && (typeof xhr === 'undefined' ? 'undefined' : _typeof$1(xhr)) === 'object' && 'default' in xhr ? xhr['default'] : xhr;
	
		var dispatchRequest = createCommonjsModule(function (module) {
		  'use strict';
	
		  /**
		   * Dispatch a request to the server using whichever adapter
		   * is supported by the current environment.
		   *
		   * @param {object} config The config that is to be used for the request
		   * @returns {Promise} The Promise to be fulfilled
		   */
	
		  module.exports = function dispatchRequest(config) {
		    return new _Promise(function executor(resolve, reject) {
		      try {
		        var adapter;
	
		        if (typeof config.adapter === 'function') {
		          // For custom adapter support
		          adapter = config.adapter;
		        } else if (typeof XMLHttpRequest !== 'undefined') {
		          // For browsers use XHR adapter
		          adapter = require$$1$23;
		        } else if (typeof process !== 'undefined') {
		          // For node use HTTP adapter
		          adapter = require$$1$23;
		        }
	
		        if (typeof adapter === 'function') {
		          adapter(resolve, reject, config);
		        }
		      } catch (e) {
		        reject(e);
		      }
		    });
		  };
		});
	
		var require$$6$3 = dispatchRequest && (typeof dispatchRequest === 'undefined' ? 'undefined' : _typeof$1(dispatchRequest)) === 'object' && 'default' in dispatchRequest ? dispatchRequest['default'] : dispatchRequest;
	
		var normalizeHeaderName = createCommonjsModule(function (module) {
		  'use strict';
	
		  var utils = require$$0$43;
	
		  module.exports = function normalizeHeaderName(headers, normalizedName) {
		    utils.forEach(headers, function processHeader(value, name) {
		      if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
		        headers[normalizedName] = value;
		        delete headers[name];
		      }
		    });
		  };
		});
	
		var require$$0$45 = normalizeHeaderName && (typeof normalizeHeaderName === 'undefined' ? 'undefined' : _typeof$1(normalizeHeaderName)) === 'object' && 'default' in normalizeHeaderName ? normalizeHeaderName['default'] : normalizeHeaderName;
	
		var defaults = createCommonjsModule(function (module) {
		  'use strict';
	
		  var utils = require$$0$43;
		  var normalizeHeaderName = require$$0$45;
	
		  var PROTECTION_PREFIX = /^\)\]\}',?\n/;
		  var DEFAULT_CONTENT_TYPE = {
		    'Content-Type': 'application/x-www-form-urlencoded'
		  };
	
		  function setContentTypeIfUnset(headers, value) {
		    if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
		      headers['Content-Type'] = value;
		    }
		  }
	
		  module.exports = {
		    transformRequest: [function transformRequest(data, headers) {
		      normalizeHeaderName(headers, 'Content-Type');
		      if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
		        return data;
		      }
		      if (utils.isArrayBufferView(data)) {
		        return data.buffer;
		      }
		      if (utils.isURLSearchParams(data)) {
		        setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
		        return data.toString();
		      }
		      if (utils.isObject(data)) {
		        setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
		        return _JSON$stringify(data);
		      }
		      return data;
		    }],
	
		    transformResponse: [function transformResponse(data) {
		      /*eslint no-param-reassign:0*/
		      if (typeof data === 'string') {
		        data = data.replace(PROTECTION_PREFIX, '');
		        try {
		          data = JSON.parse(data);
		        } catch (e) {/* Ignore */}
		      }
		      return data;
		    }],
	
		    headers: {
		      common: {
		        'Accept': 'application/json, text/plain, */*'
		      },
		      patch: utils.merge(DEFAULT_CONTENT_TYPE),
		      post: utils.merge(DEFAULT_CONTENT_TYPE),
		      put: utils.merge(DEFAULT_CONTENT_TYPE)
		    },
	
		    timeout: 0,
	
		    xsrfCookieName: 'XSRF-TOKEN',
		    xsrfHeaderName: 'X-XSRF-TOKEN',
	
		    maxContentLength: -1,
	
		    validateStatus: function validateStatus(status) {
		      return status >= 200 && status < 300;
		    }
		  };
		});
	
		var require$$8$3 = defaults && (typeof defaults === 'undefined' ? 'undefined' : _typeof$1(defaults)) === 'object' && 'default' in defaults ? defaults['default'] : defaults;
	
		var axios$1 = createCommonjsModule(function (module) {
		  'use strict';
	
		  var defaults = require$$8$3;
		  var utils = require$$0$43;
		  var dispatchRequest = require$$6$3;
		  var InterceptorManager = require$$5$2;
		  var isAbsoluteURL = require$$4$11;
		  var combineURLs = require$$3$6;
		  var bind = require$$2$9;
		  var transformData = require$$4$10;
	
		  function Axios(defaultConfig) {
		    this.defaults = utils.merge({}, defaultConfig);
		    this.interceptors = {
		      request: new InterceptorManager(),
		      response: new InterceptorManager()
		    };
		  }
	
		  Axios.prototype.request = function request(config) {
		    /*eslint no-param-reassign:0*/
		    // Allow for axios('example/url'[, config]) a la fetch API
		    if (typeof config === 'string') {
		      config = utils.merge({
		        url: arguments[0]
		      }, arguments[1]);
		    }
	
		    config = utils.merge(defaults, this.defaults, { method: 'get' }, config);
	
		    // Support baseURL config
		    if (config.baseURL && !isAbsoluteURL(config.url)) {
		      config.url = combineURLs(config.baseURL, config.url);
		    }
	
		    // Don't allow overriding defaults.withCredentials
		    config.withCredentials = config.withCredentials || this.defaults.withCredentials;
	
		    // Transform request data
		    config.data = transformData(config.data, config.headers, config.transformRequest);
	
		    // Flatten headers
		    config.headers = utils.merge(config.headers.common || {}, config.headers[config.method] || {}, config.headers || {});
	
		    utils.forEach(['delete', 'get', 'head', 'post', 'put', 'patch', 'common'], function cleanHeaderConfig(method) {
		      delete config.headers[method];
		    });
	
		    // Hook up interceptors middleware
		    var chain = [dispatchRequest, undefined];
		    var promise = _Promise.resolve(config);
	
		    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
		      chain.unshift(interceptor.fulfilled, interceptor.rejected);
		    });
	
		    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
		      chain.push(interceptor.fulfilled, interceptor.rejected);
		    });
	
		    while (chain.length) {
		      promise = promise.then(chain.shift(), chain.shift());
		    }
	
		    return promise;
		  };
	
		  var defaultInstance = new Axios(defaults);
		  var axios = module.exports = bind(Axios.prototype.request, defaultInstance);
		  axios.request = bind(Axios.prototype.request, defaultInstance);
	
		  // Expose Axios class to allow class inheritance
		  axios.Axios = Axios;
	
		  // Expose properties from defaultInstance
		  axios.defaults = defaultInstance.defaults;
		  axios.interceptors = defaultInstance.interceptors;
	
		  // Factory for creating new instances
		  axios.create = function create(defaultConfig) {
		    return new Axios(defaultConfig);
		  };
	
		  // Expose all/spread
		  axios.all = function all(promises) {
		    return _Promise.all(promises);
		  };
		  axios.spread = require$$0$42;
	
		  // Provide aliases for supported request methods
		  utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
		    /*eslint func-names:0*/
		    Axios.prototype[method] = function (url, config) {
		      return this.request(utils.merge(config || {}, {
		        method: method,
		        url: url
		      }));
		    };
		    axios[method] = bind(Axios.prototype[method], defaultInstance);
		  });
	
		  utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
		    /*eslint func-names:0*/
		    Axios.prototype[method] = function (url, data, config) {
		      return this.request(utils.merge(config || {}, {
		        method: method,
		        url: url,
		        data: data
		      }));
		    };
		    axios[method] = bind(Axios.prototype[method], defaultInstance);
		  });
		});
	
		var require$$0$41 = axios$1 && (typeof axios$1 === 'undefined' ? 'undefined' : _typeof$1(axios$1)) === 'object' && 'default' in axios$1 ? axios$1['default'] : axios$1;
	
		var index$3 = createCommonjsModule(function (module) {
		  module.exports = require$$0$41;
		});
	
		var axios = index$3 && (typeof index$3 === 'undefined' ? 'undefined' : _typeof$1(index$3)) === 'object' && 'default' in index$3 ? index$3['default'] : index$3;
	
		var rngBrowser = createCommonjsModule(function (module) {
		var rng;
	
		if (commonjsGlobal.crypto && crypto.getRandomValues) {
		  // WHATWG crypto-based RNG - http://wiki.whatwg.org/wiki/Crypto
		  // Moderately fast, high quality
		  var _rnds8 = new Uint8Array(16);
		  rng = function whatwgRNG() {
		    crypto.getRandomValues(_rnds8);
		    return _rnds8;
		  };
		}
	
		if (!rng) {
		  // Math.random()-based (RNG)
		  //
		  // If all else fails, use Math.random().  It's fast, but is of unspecified
		  // quality.
		  var  _rnds = new Array(16);
		  rng = function() {
		    for (var i = 0, r; i < 16; i++) {
		      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
		      _rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
		    }
	
		    return _rnds;
		  };
		}
	
		module.exports = rng;
		});
	
		var require$$0$46 = (rngBrowser && typeof rngBrowser === 'object' && 'default' in rngBrowser ? rngBrowser['default'] : rngBrowser);
	
		var uuid = createCommonjsModule(function (module) {
		//     uuid.js
		//
		//     Copyright (c) 2010-2012 Robert Kieffer
		//     MIT License - http://opensource.org/licenses/mit-license.php
	
		// Unique ID creation requires a high quality random # generator.  We feature
		// detect to determine the best RNG source, normalizing to a function that
		// returns 128-bits of randomness, since that's what's usually required
		var _rng = require$$0$46;
	
		// Maps for number <-> hex string conversion
		var _byteToHex = [];
		var _hexToByte = {};
		for (var i = 0; i < 256; i++) {
		  _byteToHex[i] = (i + 0x100).toString(16).substr(1);
		  _hexToByte[_byteToHex[i]] = i;
		}
	
		// **`parse()` - Parse a UUID into it's component bytes**
		function parse(s, buf, offset) {
		  var i = (buf && offset) || 0, ii = 0;
	
		  buf = buf || [];
		  s.toLowerCase().replace(/[0-9a-f]{2}/g, function(oct) {
		    if (ii < 16) { // Don't overflow!
		      buf[i + ii++] = _hexToByte[oct];
		    }
		  });
	
		  // Zero out remaining bytes if string was short
		  while (ii < 16) {
		    buf[i + ii++] = 0;
		  }
	
		  return buf;
		}
	
		// **`unparse()` - Convert UUID byte array (ala parse()) into a string**
		function unparse(buf, offset) {
		  var i = offset || 0, bth = _byteToHex;
		  return  bth[buf[i++]] + bth[buf[i++]] +
		          bth[buf[i++]] + bth[buf[i++]] + '-' +
		          bth[buf[i++]] + bth[buf[i++]] + '-' +
		          bth[buf[i++]] + bth[buf[i++]] + '-' +
		          bth[buf[i++]] + bth[buf[i++]] + '-' +
		          bth[buf[i++]] + bth[buf[i++]] +
		          bth[buf[i++]] + bth[buf[i++]] +
		          bth[buf[i++]] + bth[buf[i++]];
		}
	
		// **`v1()` - Generate time-based UUID**
		//
		// Inspired by https://github.com/LiosK/UUID.js
		// and http://docs.python.org/library/uuid.html
	
		// random #'s we need to init node and clockseq
		var _seedBytes = _rng();
	
		// Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
		var _nodeId = [
		  _seedBytes[0] | 0x01,
		  _seedBytes[1], _seedBytes[2], _seedBytes[3], _seedBytes[4], _seedBytes[5]
		];
	
		// Per 4.2.2, randomize (14 bit) clockseq
		var _clockseq = (_seedBytes[6] << 8 | _seedBytes[7]) & 0x3fff;
	
		// Previous uuid creation time
		var _lastMSecs = 0, _lastNSecs = 0;
	
		// See https://github.com/broofa/node-uuid for API details
		function v1(options, buf, offset) {
		  var i = buf && offset || 0;
		  var b = buf || [];
	
		  options = options || {};
	
		  var clockseq = options.clockseq !== undefined ? options.clockseq : _clockseq;
	
		  // UUID timestamps are 100 nano-second units since the Gregorian epoch,
		  // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
		  // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
		  // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
		  var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
	
		  // Per 4.2.1.2, use count of uuid's generated during the current clock
		  // cycle to simulate higher resolution clock
		  var nsecs = options.nsecs !== undefined ? options.nsecs : _lastNSecs + 1;
	
		  // Time since last uuid creation (in msecs)
		  var dt = (msecs - _lastMSecs) + (nsecs - _lastNSecs)/10000;
	
		  // Per 4.2.1.2, Bump clockseq on clock regression
		  if (dt < 0 && options.clockseq === undefined) {
		    clockseq = clockseq + 1 & 0x3fff;
		  }
	
		  // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
		  // time interval
		  if ((dt < 0 || msecs > _lastMSecs) && options.nsecs === undefined) {
		    nsecs = 0;
		  }
	
		  // Per 4.2.1.2 Throw error if too many uuids are requested
		  if (nsecs >= 10000) {
		    throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
		  }
	
		  _lastMSecs = msecs;
		  _lastNSecs = nsecs;
		  _clockseq = clockseq;
	
		  // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
		  msecs += 12219292800000;
	
		  // `time_low`
		  var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
		  b[i++] = tl >>> 24 & 0xff;
		  b[i++] = tl >>> 16 & 0xff;
		  b[i++] = tl >>> 8 & 0xff;
		  b[i++] = tl & 0xff;
	
		  // `time_mid`
		  var tmh = (msecs / 0x100000000 * 10000) & 0xfffffff;
		  b[i++] = tmh >>> 8 & 0xff;
		  b[i++] = tmh & 0xff;
	
		  // `time_high_and_version`
		  b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
		  b[i++] = tmh >>> 16 & 0xff;
	
		  // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
		  b[i++] = clockseq >>> 8 | 0x80;
	
		  // `clock_seq_low`
		  b[i++] = clockseq & 0xff;
	
		  // `node`
		  var node = options.node || _nodeId;
		  for (var n = 0; n < 6; n++) {
		    b[i + n] = node[n];
		  }
	
		  return buf ? buf : unparse(b);
		}
	
		// **`v4()` - Generate random UUID**
	
		// See https://github.com/broofa/node-uuid for API details
		function v4(options, buf, offset) {
		  // Deprecated - 'format' argument, as supported in v1.2
		  var i = buf && offset || 0;
	
		  if (typeof(options) == 'string') {
		    buf = options == 'binary' ? new Array(16) : null;
		    options = null;
		  }
		  options = options || {};
	
		  var rnds = options.random || (options.rng || _rng)();
	
		  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
		  rnds[6] = (rnds[6] & 0x0f) | 0x40;
		  rnds[8] = (rnds[8] & 0x3f) | 0x80;
	
		  // Copy bytes to buffer, if provided
		  if (buf) {
		    for (var ii = 0; ii < 16; ii++) {
		      buf[i + ii] = rnds[ii];
		    }
		  }
	
		  return buf || unparse(rnds);
		}
	
		// Export public API
		var uuid = v4;
		uuid.v1 = v1;
		uuid.v4 = v4;
		uuid.parse = parse;
		uuid.unparse = unparse;
	
		module.exports = uuid;
		});
	
		var uuid$1 = (uuid && typeof uuid === 'object' && 'default' in uuid ? uuid['default'] : uuid);
	
		var Client = function (_EventEmitter) {
		  _inherits(Client, _EventEmitter);
	
		  function Client(id) {
		    var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
		    var connection = arguments[2];
		    var props = arguments[3];
	
		    _classCallCheck(this, Client);
	
		    if (!(id === undefined || typeof id === 'string')) {
		      throw new TypeError('Client id [' + id + '] is not a String');
		    }
	
		    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
		    _Object$assign(_this, {
		      id: id,
		      _connection: connection,
		      options: options
		    }, props);
		    return _this;
		  }
	
		  /**
		   * @abstract
		   */
	
	
		  Client.prototype._dispatchMessage = function _dispatchMessage(message) {
		    this.emit('message', message);
		  };
	
		  return Client;
		}(EventEmitter);
	
		var createClass = createCommonjsModule(function (module, exports) {
		"use strict";
	
		exports.__esModule = true;
	
		var _defineProperty = require$$0$32;
	
		var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
		function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
		exports.default = function () {
		  function defineProperties(target, props) {
		    for (var i = 0; i < props.length; i++) {
		      var descriptor = props[i];
		      descriptor.enumerable = descriptor.enumerable || false;
		      descriptor.configurable = true;
		      if ("value" in descriptor) descriptor.writable = true;
		      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
		    }
		  }
	
		  return function (Constructor, protoProps, staticProps) {
		    if (protoProps) defineProperties(Constructor.prototype, protoProps);
		    if (staticProps) defineProperties(Constructor, staticProps);
		    return Constructor;
		  };
		}();
		});
	
		var _createClass = (createClass && typeof createClass === 'object' && 'default' in createClass ? createClass['default'] : createClass);
	
		var debug$7 = d('LC:SignatureFactoryRunner');
	
		function _validateSignature() {
		  var signatureResult = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
		  var signature = signatureResult.signature;
		  var timestamp = signatureResult.timestamp;
		  var nonce = signatureResult.nonce;
	
		  if (typeof signature !== 'string' || typeof timestamp !== 'number' || typeof nonce !== 'string') {
		    throw new Error('malformed signature');
		  }
		  return {
		    signature: signature,
		    timestamp: timestamp,
		    nonce: nonce
		  };
		}
	
		var run = function run(signatureFactory, params) {
		  return _Promise.resolve().then(function () {
		    debug$7('call signatureFactory with ' + params);
		    return signatureFactory.apply(null, params);
		  }).then(tap(function (signatureResult) {
		    return debug$7('sign result', signatureResult);
		  }), function (error) {
		    // eslint-disable-next-line no-param-reassign
		    error.message = 'sign error: ' + error.message;
		    debug$7(error);
		    throw error;
		  }).then(_validateSignature);
		};
	
		var Message = function () {
		  /**
		   * @implements AVMessage
		   * @param  {Object|String} content 消息内容
		   */
	
		  function Message(content) {
		    _classCallCheck(this, Message);
	
		    _Object$assign(this, { content: content }, {
		      /**
		       * @type {String}
		       * @memberof Message#
		       */
		      id: uuid$1.v4(),
		      /**
		       * 消息所在的 conversation id
		       * @memberof Message#
		       * @type {String?}
		       */
		      cid: null,
		      /**
		       * 时间戳
		       * @memberof Message#
		       * @type {Date}
		       */
		      timestamp: new Date(),
		      /**
		       * 消息发送者
		       * @memberof Message#
		       * @type {String}
		       */
		      from: undefined,
		      /**
		       * 标记需要回执
		       * @memberof Message#
		       * @type {Boolean}
		       */
		      needReceipt: false,
		      /**
		       * 标记暂态消息
		       * @memberof Message#
		       * @type {Boolean}
		       */
		      transient: false
		    });
		  }
	
		  /**
		   * 设置是否需要回执
		   * @param {Boolean} needReceipt
		   * @return {Message} self
		   */
	
	
		  Message.prototype.setNeedReceipt = function setNeedReceipt(needReceipt) {
		    this.needReceipt = needReceipt;
		    return this;
		  };
	
		  /**
		   * 设置是否是暂态消息
		   * @param {Boolean} transient
		   * @return {Message} self
		   */
	
	
		  Message.prototype.setTransient = function setTransient(transient) {
		    this.transient = transient;
		    return this;
		  };
	
		  /**
		   * 将当前消息序列化为 JSON 对象
		   * @protected
		   * @return {Object}
		   */
	
	
		  Message.prototype.toJSON = function toJSON() {
		    return this.content;
		  };
	
		  /**
		   * 判断给定的内容是否是有效的 Message，
		   * 该方法始终返回 true
		   * @protected
		   * @returns {Boolean}
		   * @implements AVMessage.validate
		   */
	
	
		  Message.validate = function validate() {
		    return true;
		  };
	
		  /**
		   * 解析处理消息内容
		   * <pre>
		   * 如果子类提供了 message，返回该 message
		   * 如果没有提供，将 json 作为 content 实例化一个 Message
		   * @protected
		   * @param  {Object}  json    json 格式的消息内容
		   * @param  {Message} message 子类提供的 message
		   * @return {Message}
		   * @implements AVMessage.parse
		   */
	
	
		  Message.parse = function parse(json, message) {
		    return message || new this(json);
		  };
	
		  return Message;
		}();
	
		var _isPrototype = createCommonjsModule(function (module) {
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Checks if `value` is likely a prototype object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
		 */
		function isPrototype(value) {
		  var Ctor = value && value.constructor,
		      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
		  return value === proto;
		}
	
		module.exports = isPrototype;
		});
	
		var require$$0$48 = (_isPrototype && typeof _isPrototype === 'object' && 'default' in _isPrototype ? _isPrototype['default'] : _isPrototype);
	
		var _isIndex = createCommonjsModule(function (module) {
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/** Used to detect unsigned integer values. */
		var reIsUint = /^(?:0|[1-9]\d*)$/;
	
		/**
		 * Checks if `value` is a valid array-like index.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
		 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
		 */
		function isIndex(value, length) {
		  length = length == null ? MAX_SAFE_INTEGER : length;
		  return !!length &&
		    (typeof value == 'number' || reIsUint.test(value)) &&
		    (value > -1 && value % 1 == 0 && value < length);
		}
	
		module.exports = isIndex;
		});
	
		var require$$1$25 = (_isIndex && typeof _isIndex === 'object' && 'default' in _isIndex ? _isIndex['default'] : _isIndex);
	
		var isLength = createCommonjsModule(function (module) {
		/** Used as references for various `Number` constants. */
		var MAX_SAFE_INTEGER = 9007199254740991;
	
		/**
		 * Checks if `value` is a valid array-like length.
		 *
		 * **Note:** This function is loosely based on
		 * [`ToLength`](http://ecma-international.org/ecma-262/6.0/#sec-tolength).
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a valid length,
		 *  else `false`.
		 * @example
		 *
		 * _.isLength(3);
		 * // => true
		 *
		 * _.isLength(Number.MIN_VALUE);
		 * // => false
		 *
		 * _.isLength(Infinity);
		 * // => false
		 *
		 * _.isLength('3');
		 * // => false
		 */
		function isLength(value) {
		  return typeof value == 'number' &&
		    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
		}
	
		module.exports = isLength;
		});
	
		var require$$1$27 = (isLength && typeof isLength === 'object' && 'default' in isLength ? isLength['default'] : isLength);
	
		var isObject$1 = createCommonjsModule(function (module) {
		/**
		 * Checks if `value` is the
		 * [language type](http://www.ecma-international.org/ecma-262/6.0/#sec-ecmascript-language-types)
		 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
		 * @example
		 *
		 * _.isObject({});
		 * // => true
		 *
		 * _.isObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isObject(_.noop);
		 * // => true
		 *
		 * _.isObject(null);
		 * // => false
		 */
		function isObject(value) {
		  var type = typeof value;
		  return !!value && (type == 'object' || type == 'function');
		}
	
		module.exports = isObject;
		});
	
		var require$$1$28 = (isObject$1 && typeof isObject$1 === 'object' && 'default' in isObject$1 ? isObject$1['default'] : isObject$1);
	
		var isFunction$1 = createCommonjsModule(function (module) {
		var isObject = require$$1$28;
	
		/** `Object#toString` result references. */
		var funcTag = '[object Function]',
		    genTag = '[object GeneratorFunction]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/**
		 * Checks if `value` is classified as a `Function` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isFunction(_);
		 * // => true
		 *
		 * _.isFunction(/abc/);
		 * // => false
		 */
		function isFunction(value) {
		  // The use of `Object#toString` avoids issues with the `typeof` operator
		  // in Safari 8 which returns 'object' for typed array and weak map constructors,
		  // and PhantomJS 1.9 which returns 'function' for `NodeList` instances.
		  var tag = isObject(value) ? objectToString.call(value) : '';
		  return tag == funcTag || tag == genTag;
		}
	
		module.exports = isFunction;
		});
	
		var require$$2$11 = (isFunction$1 && typeof isFunction$1 === 'object' && 'default' in isFunction$1 ? isFunction$1['default'] : isFunction$1);
	
		var _baseProperty = createCommonjsModule(function (module) {
		/**
		 * The base implementation of `_.property` without support for deep paths.
		 *
		 * @private
		 * @param {string} key The key of the property to get.
		 * @returns {Function} Returns the new accessor function.
		 */
		function baseProperty(key) {
		  return function(object) {
		    return object == null ? undefined : object[key];
		  };
		}
	
		module.exports = baseProperty;
		});
	
		var require$$0$49 = (_baseProperty && typeof _baseProperty === 'object' && 'default' in _baseProperty ? _baseProperty['default'] : _baseProperty);
	
		var _getLength = createCommonjsModule(function (module) {
		var baseProperty = require$$0$49;
	
		/**
		 * Gets the "length" property value of `object`.
		 *
		 * **Note:** This function is used to avoid a
		 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
		 * Safari on at least iOS 8.1-8.3 ARM64.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {*} Returns the "length" value.
		 */
		var getLength = baseProperty('length');
	
		module.exports = getLength;
		});
	
		var require$$2$12 = (_getLength && typeof _getLength === 'object' && 'default' in _getLength ? _getLength['default'] : _getLength);
	
		var isArrayLike = createCommonjsModule(function (module) {
		var getLength = require$$2$12,
		    isFunction = require$$2$11,
		    isLength = require$$1$27;
	
		/**
		 * Checks if `value` is array-like. A value is considered array-like if it's
		 * not a function and has a `value.length` that's an integer greater than or
		 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
		 * @example
		 *
		 * _.isArrayLike([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLike(document.body.children);
		 * // => true
		 *
		 * _.isArrayLike('abc');
		 * // => true
		 *
		 * _.isArrayLike(_.noop);
		 * // => false
		 */
		function isArrayLike(value) {
		  return value != null && isLength(getLength(value)) && !isFunction(value);
		}
	
		module.exports = isArrayLike;
		});
	
		var require$$1$26 = (isArrayLike && typeof isArrayLike === 'object' && 'default' in isArrayLike ? isArrayLike['default'] : isArrayLike);
	
		var isArray$1 = createCommonjsModule(function (module) {
		/**
		 * Checks if `value` is classified as an `Array` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @type {Function}
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isArray([1, 2, 3]);
		 * // => true
		 *
		 * _.isArray(document.body.children);
		 * // => false
		 *
		 * _.isArray('abc');
		 * // => false
		 *
		 * _.isArray(_.noop);
		 * // => false
		 */
		var isArray = Array.isArray;
	
		module.exports = isArray;
		});
	
		var require$$1$29 = (isArray$1 && typeof isArray$1 === 'object' && 'default' in isArray$1 ? isArray$1['default'] : isArray$1);
	
		var isString$1 = createCommonjsModule(function (module) {
		var isArray = require$$1$29,
		    isObjectLike = require$$0$35;
	
		/** `Object#toString` result references. */
		var stringTag = '[object String]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/**
		 * Checks if `value` is classified as a `String` primitive or object.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isString('abc');
		 * // => true
		 *
		 * _.isString(1);
		 * // => false
		 */
		function isString(value) {
		  return typeof value == 'string' ||
		    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
		}
	
		module.exports = isString;
		});
	
		var require$$0$50 = (isString$1 && typeof isString$1 === 'object' && 'default' in isString$1 ? isString$1['default'] : isString$1);
	
		var isArrayLikeObject = createCommonjsModule(function (module) {
		var isArrayLike = require$$1$26,
		    isObjectLike = require$$0$35;
	
		/**
		 * This method is like `_.isArrayLike` except that it also checks if `value`
		 * is an object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is an array-like object,
		 *  else `false`.
		 * @example
		 *
		 * _.isArrayLikeObject([1, 2, 3]);
		 * // => true
		 *
		 * _.isArrayLikeObject(document.body.children);
		 * // => true
		 *
		 * _.isArrayLikeObject('abc');
		 * // => false
		 *
		 * _.isArrayLikeObject(_.noop);
		 * // => false
		 */
		function isArrayLikeObject(value) {
		  return isObjectLike(value) && isArrayLike(value);
		}
	
		module.exports = isArrayLikeObject;
		});
	
		var require$$0$51 = (isArrayLikeObject && typeof isArrayLikeObject === 'object' && 'default' in isArrayLikeObject ? isArrayLikeObject['default'] : isArrayLikeObject);
	
		var isArguments = createCommonjsModule(function (module) {
		var isArrayLikeObject = require$$0$51;
	
		/** `Object#toString` result references. */
		var argsTag = '[object Arguments]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/**
		 * Checks if `value` is likely an `arguments` object.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isArguments(function() { return arguments; }());
		 * // => true
		 *
		 * _.isArguments([1, 2, 3]);
		 * // => false
		 */
		function isArguments(value) {
		  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
		  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
		    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
		}
	
		module.exports = isArguments;
		});
	
		var require$$3$9 = (isArguments && typeof isArguments === 'object' && 'default' in isArguments ? isArguments['default'] : isArguments);
	
		var _baseTimes = createCommonjsModule(function (module) {
		/**
		 * The base implementation of `_.times` without support for iteratee shorthands
		 * or max array length checks.
		 *
		 * @private
		 * @param {number} n The number of times to invoke `iteratee`.
		 * @param {Function} iteratee The function invoked per iteration.
		 * @returns {Array} Returns the array of results.
		 */
		function baseTimes(n, iteratee) {
		  var index = -1,
		      result = Array(n);
	
		  while (++index < n) {
		    result[index] = iteratee(index);
		  }
		  return result;
		}
	
		module.exports = baseTimes;
		});
	
		var require$$4$12 = (_baseTimes && typeof _baseTimes === 'object' && 'default' in _baseTimes ? _baseTimes['default'] : _baseTimes);
	
		var _indexKeys = createCommonjsModule(function (module) {
		var baseTimes = require$$4$12,
		    isArguments = require$$3$9,
		    isArray = require$$1$29,
		    isLength = require$$1$27,
		    isString = require$$0$50;
	
		/**
		 * Creates an array of index keys for `object` values of arrays,
		 * `arguments` objects, and strings, otherwise `null` is returned.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array|null} Returns index keys, else `null`.
		 */
		function indexKeys(object) {
		  var length = object ? object.length : undefined;
		  if (isLength(length) &&
		      (isArray(object) || isString(object) || isArguments(object))) {
		    return baseTimes(length, String);
		  }
		  return null;
		}
	
		module.exports = indexKeys;
		});
	
		var require$$3$8 = (_indexKeys && typeof _indexKeys === 'object' && 'default' in _indexKeys ? _indexKeys['default'] : _indexKeys);
	
		var _baseKeys = createCommonjsModule(function (module) {
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeKeys = Object.keys;
	
		/**
		 * The base implementation of `_.keys` which doesn't skip the constructor
		 * property of prototypes or treat sparse arrays as dense.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 */
		function baseKeys(object) {
		  return nativeKeys(Object(object));
		}
	
		module.exports = baseKeys;
		});
	
		var require$$4$13 = (_baseKeys && typeof _baseKeys === 'object' && 'default' in _baseKeys ? _baseKeys['default'] : _baseKeys);
	
		var _baseHas = createCommonjsModule(function (module) {
		var getPrototype = require$$0$36;
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/**
		 * The base implementation of `_.has` without support for deep paths.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {Array|string} key The key to check.
		 * @returns {boolean} Returns `true` if `key` exists, else `false`.
		 */
		function baseHas(object, key) {
		  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
		  // that are composed entirely of index properties, return `false` for
		  // `hasOwnProperty` checks of them.
		  return object != null &&
		    (hasOwnProperty.call(object, key) ||
		      (typeof object == 'object' && key in object && getPrototype(object) === null));
		}
	
		module.exports = baseHas;
		});
	
		var require$$5$4 = (_baseHas && typeof _baseHas === 'object' && 'default' in _baseHas ? _baseHas['default'] : _baseHas);
	
		var keys$2 = createCommonjsModule(function (module) {
		var baseHas = require$$5$4,
		    baseKeys = require$$4$13,
		    indexKeys = require$$3$8,
		    isArrayLike = require$$1$26,
		    isIndex = require$$1$25,
		    isPrototype = require$$0$48;
	
		/**
		 * Creates an array of the own enumerable property names of `object`.
		 *
		 * **Note:** Non-object values are coerced to objects. See the
		 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
		 * for more details.
		 *
		 * @static
		 * @since 0.1.0
		 * @memberOf _
		 * @category Object
		 * @param {Object} object The object to query.
		 * @returns {Array} Returns the array of property names.
		 * @example
		 *
		 * function Foo() {
		 *   this.a = 1;
		 *   this.b = 2;
		 * }
		 *
		 * Foo.prototype.c = 3;
		 *
		 * _.keys(new Foo);
		 * // => ['a', 'b'] (iteration order is not guaranteed)
		 *
		 * _.keys('hi');
		 * // => ['0', '1']
		 */
		function keys(object) {
		  var isProto = isPrototype(object);
		  if (!(isProto || isArrayLike(object))) {
		    return baseKeys(object);
		  }
		  var indexes = indexKeys(object),
		      skipIndexes = !!indexes,
		      result = indexes || [],
		      length = result.length;
	
		  for (var key in object) {
		    if (baseHas(object, key) &&
		        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
		        !(isProto && key == 'constructor')) {
		      result.push(key);
		    }
		  }
		  return result;
		}
	
		module.exports = keys;
		});
	
		var require$$0$47 = (keys$2 && typeof keys$2 === 'object' && 'default' in keys$2 ? keys$2['default'] : keys$2);
	
		var stubFalse = createCommonjsModule(function (module) {
		/**
		 * A method that returns `false`.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.13.0
		 * @category Util
		 * @returns {boolean} Returns `false`.
		 * @example
		 *
		 * _.times(2, _.stubFalse);
		 * // => [false, false]
		 */
		function stubFalse() {
		  return false;
		}
	
		module.exports = stubFalse;
		});
	
		var require$$0$52 = (stubFalse && typeof stubFalse === 'object' && 'default' in stubFalse ? stubFalse['default'] : stubFalse);
	
		var _checkGlobal = createCommonjsModule(function (module) {
		/**
		 * Checks if `value` is a global object.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
		 */
		function checkGlobal(value) {
		  return (value && value.Object === Object) ? value : null;
		}
	
		module.exports = checkGlobal;
		});
	
		var require$$0$54 = (_checkGlobal && typeof _checkGlobal === 'object' && 'default' in _checkGlobal ? _checkGlobal['default'] : _checkGlobal);
	
		var _root = createCommonjsModule(function (module) {
		var checkGlobal = require$$0$54;
	
		/** Detect free variable `global` from Node.js. */
		var freeGlobal = checkGlobal(typeof commonjsGlobal == 'object' && commonjsGlobal);
	
		/** Detect free variable `self`. */
		var freeSelf = checkGlobal(typeof self == 'object' && self);
	
		/** Detect `this` as the global object. */
		var thisGlobal = checkGlobal(typeof commonjsGlobal == 'object' && commonjsGlobal);
	
		/** Used as a reference to the global object. */
		var root = freeGlobal || freeSelf || thisGlobal || Function('return this')();
	
		module.exports = root;
		});
	
		var require$$0$53 = (_root && typeof _root === 'object' && 'default' in _root ? _root['default'] : _root);
	
		var isBuffer = createCommonjsModule(function (module, exports) {
		var root = require$$0$53,
		    stubFalse = require$$0$52;
	
		/** Detect free variable `exports`. */
		var freeExports = typeof exports == 'object' && exports;
	
		/** Detect free variable `module`. */
		var freeModule = freeExports && typeof module == 'object' && module;
	
		/** Detect the popular CommonJS extension `module.exports`. */
		var moduleExports = freeModule && freeModule.exports === freeExports;
	
		/** Built-in value references. */
		var Buffer = moduleExports ? root.Buffer : undefined;
	
		/**
		 * Checks if `value` is a buffer.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.3.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
		 * @example
		 *
		 * _.isBuffer(new Buffer(2));
		 * // => true
		 *
		 * _.isBuffer(new Uint8Array(2));
		 * // => false
		 */
		var isBuffer = !Buffer ? stubFalse : function(value) {
		  return value instanceof Buffer;
		};
	
		module.exports = isBuffer;
		});
	
		var require$$4$14 = (isBuffer && typeof isBuffer === 'object' && 'default' in isBuffer ? isBuffer['default'] : isBuffer);
	
		var _toSource = createCommonjsModule(function (module) {
		/** Used to resolve the decompiled source of functions. */
		var funcToString = Function.prototype.toString;
	
		/**
		 * Converts `func` to its source code.
		 *
		 * @private
		 * @param {Function} func The function to process.
		 * @returns {string} Returns the source code.
		 */
		function toSource(func) {
		  if (func != null) {
		    try {
		      return funcToString.call(func);
		    } catch (e) {}
		    try {
		      return (func + '');
		    } catch (e) {}
		  }
		  return '';
		}
	
		module.exports = toSource;
		});
	
		var require$$0$55 = (_toSource && typeof _toSource === 'object' && 'default' in _toSource ? _toSource['default'] : _toSource);
	
		var _getValue = createCommonjsModule(function (module) {
		/**
		 * Gets the value at `key` of `object`.
		 *
		 * @private
		 * @param {Object} [object] The object to query.
		 * @param {string} key The key of the property to get.
		 * @returns {*} Returns the property value.
		 */
		function getValue(object, key) {
		  return object == null ? undefined : object[key];
		}
	
		module.exports = getValue;
		});
	
		var require$$0$56 = (_getValue && typeof _getValue === 'object' && 'default' in _getValue ? _getValue['default'] : _getValue);
	
		var _coreJsData = createCommonjsModule(function (module) {
		var root = require$$0$53;
	
		/** Used to detect overreaching core-js shims. */
		var coreJsData = root['__core-js_shared__'];
	
		module.exports = coreJsData;
		});
	
		var require$$0$57 = (_coreJsData && typeof _coreJsData === 'object' && 'default' in _coreJsData ? _coreJsData['default'] : _coreJsData);
	
		var _isMasked = createCommonjsModule(function (module) {
		var coreJsData = require$$0$57;
	
		/** Used to detect methods masquerading as native. */
		var maskSrcKey = (function() {
		  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
		  return uid ? ('Symbol(src)_1.' + uid) : '';
		}());
	
		/**
		 * Checks if `func` has its source masked.
		 *
		 * @private
		 * @param {Function} func The function to check.
		 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
		 */
		function isMasked(func) {
		  return !!maskSrcKey && (maskSrcKey in func);
		}
	
		module.exports = isMasked;
		});
	
		var require$$2$13 = (_isMasked && typeof _isMasked === 'object' && 'default' in _isMasked ? _isMasked['default'] : _isMasked);
	
		var _baseIsNative = createCommonjsModule(function (module) {
		var isFunction = require$$2$11,
		    isHostObject = require$$3$5,
		    isMasked = require$$2$13,
		    isObject = require$$1$28,
		    toSource = require$$0$55;
	
		/**
		 * Used to match `RegExp`
		 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
		 */
		var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
		/** Used to detect host constructors (Safari). */
		var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to resolve the decompiled source of functions. */
		var funcToString = Function.prototype.toString;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Used to detect if a method is native. */
		var reIsNative = RegExp('^' +
		  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
		  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
		);
	
		/**
		 * The base implementation of `_.isNative` without bad shim checks.
		 *
		 * @private
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is a native function,
		 *  else `false`.
		 */
		function baseIsNative(value) {
		  if (!isObject(value) || isMasked(value)) {
		    return false;
		  }
		  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
		  return pattern.test(toSource(value));
		}
	
		module.exports = baseIsNative;
		});
	
		var require$$1$32 = (_baseIsNative && typeof _baseIsNative === 'object' && 'default' in _baseIsNative ? _baseIsNative['default'] : _baseIsNative);
	
		var _getNative = createCommonjsModule(function (module) {
		var baseIsNative = require$$1$32,
		    getValue = require$$0$56;
	
		/**
		 * Gets the native function at `key` of `object`.
		 *
		 * @private
		 * @param {Object} object The object to query.
		 * @param {string} key The key of the method to get.
		 * @returns {*} Returns the function if it's native, else `undefined`.
		 */
		function getNative(object, key) {
		  var value = getValue(object, key);
		  return baseIsNative(value) ? value : undefined;
		}
	
		module.exports = getNative;
		});
	
		var require$$1$31 = (_getNative && typeof _getNative === 'object' && 'default' in _getNative ? _getNative['default'] : _getNative);
	
		var _WeakMap$1 = createCommonjsModule(function (module) {
		var getNative = require$$1$31,
		    root = require$$0$53;
	
		/* Built-in method references that are verified to be native. */
		var WeakMap = getNative(root, 'WeakMap');
	
		module.exports = WeakMap;
		});
	
		var require$$1$30 = (_WeakMap$1 && typeof _WeakMap$1 === 'object' && 'default' in _WeakMap$1 ? _WeakMap$1['default'] : _WeakMap$1);
	
		var _Set$1 = createCommonjsModule(function (module) {
		var getNative = require$$1$31,
		    root = require$$0$53;
	
		/* Built-in method references that are verified to be native. */
		var Set = getNative(root, 'Set');
	
		module.exports = Set;
		});
	
		var require$$2$14 = (_Set$1 && typeof _Set$1 === 'object' && 'default' in _Set$1 ? _Set$1['default'] : _Set$1);
	
		var _Promise$1 = createCommonjsModule(function (module) {
		var getNative = require$$1$31,
		    root = require$$0$53;
	
		/* Built-in method references that are verified to be native. */
		var Promise = getNative(root, 'Promise');
	
		module.exports = Promise;
		});
	
		var require$$3$10 = (_Promise$1 && typeof _Promise$1 === 'object' && 'default' in _Promise$1 ? _Promise$1['default'] : _Promise$1);
	
		var _Map = createCommonjsModule(function (module) {
		var getNative = require$$1$31,
		    root = require$$0$53;
	
		/* Built-in method references that are verified to be native. */
		var Map = getNative(root, 'Map');
	
		module.exports = Map;
		});
	
		var require$$4$15 = (_Map && typeof _Map === 'object' && 'default' in _Map ? _Map['default'] : _Map);
	
		var _DataView = createCommonjsModule(function (module) {
		var getNative = require$$1$31,
		    root = require$$0$53;
	
		/* Built-in method references that are verified to be native. */
		var DataView = getNative(root, 'DataView');
	
		module.exports = DataView;
		});
	
		var require$$5$5 = (_DataView && typeof _DataView === 'object' && 'default' in _DataView ? _DataView['default'] : _DataView);
	
		var _getTag = createCommonjsModule(function (module) {
		var DataView = require$$5$5,
		    Map = require$$4$15,
		    Promise = require$$3$10,
		    Set = require$$2$14,
		    WeakMap = require$$1$30,
		    toSource = require$$0$55;
	
		/** `Object#toString` result references. */
		var mapTag = '[object Map]',
		    objectTag = '[object Object]',
		    promiseTag = '[object Promise]',
		    setTag = '[object Set]',
		    weakMapTag = '[object WeakMap]';
	
		var dataViewTag = '[object DataView]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/** Used to detect maps, sets, and weakmaps. */
		var dataViewCtorString = toSource(DataView),
		    mapCtorString = toSource(Map),
		    promiseCtorString = toSource(Promise),
		    setCtorString = toSource(Set),
		    weakMapCtorString = toSource(WeakMap);
	
		/**
		 * Gets the `toStringTag` of `value`.
		 *
		 * @private
		 * @param {*} value The value to query.
		 * @returns {string} Returns the `toStringTag`.
		 */
		function getTag(value) {
		  return objectToString.call(value);
		}
	
		// Fallback for data views, maps, sets, and weak maps in IE 11,
		// for data views in Edge, and promises in Node.js.
		if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
		    (Map && getTag(new Map) != mapTag) ||
		    (Promise && getTag(Promise.resolve()) != promiseTag) ||
		    (Set && getTag(new Set) != setTag) ||
		    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
		  getTag = function(value) {
		    var result = objectToString.call(value),
		        Ctor = result == objectTag ? value.constructor : undefined,
		        ctorString = Ctor ? toSource(Ctor) : undefined;
	
		    if (ctorString) {
		      switch (ctorString) {
		        case dataViewCtorString: return dataViewTag;
		        case mapCtorString: return mapTag;
		        case promiseCtorString: return promiseTag;
		        case setCtorString: return setTag;
		        case weakMapCtorString: return weakMapTag;
		      }
		    }
		    return result;
		  };
		}
	
		module.exports = getTag;
		});
	
		var require$$8$4 = (_getTag && typeof _getTag === 'object' && 'default' in _getTag ? _getTag['default'] : _getTag);
	
		var isEmpty = createCommonjsModule(function (module) {
		var getTag = require$$8$4,
		    isArguments = require$$3$9,
		    isArray = require$$1$29,
		    isArrayLike = require$$1$26,
		    isBuffer = require$$4$14,
		    isFunction = require$$2$11,
		    isObjectLike = require$$0$35,
		    isString = require$$0$50,
		    keys = require$$0$47;
	
		/** `Object#toString` result references. */
		var mapTag = '[object Map]',
		    setTag = '[object Set]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/** Used to check objects for own properties. */
		var hasOwnProperty = objectProto.hasOwnProperty;
	
		/** Built-in value references. */
		var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
		/** Detect if properties shadowing those on `Object.prototype` are non-enumerable. */
		var nonEnumShadows = !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf');
	
		/**
		 * Checks if `value` is an empty object, collection, map, or set.
		 *
		 * Objects are considered empty if they have no own enumerable string keyed
		 * properties.
		 *
		 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
		 * jQuery-like collections are considered empty if they have a `length` of `0`.
		 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
		 * @example
		 *
		 * _.isEmpty(null);
		 * // => true
		 *
		 * _.isEmpty(true);
		 * // => true
		 *
		 * _.isEmpty(1);
		 * // => true
		 *
		 * _.isEmpty([1, 2, 3]);
		 * // => false
		 *
		 * _.isEmpty({ 'a': 1 });
		 * // => false
		 */
		function isEmpty(value) {
		  if (isArrayLike(value) &&
		      (isArray(value) || isString(value) || isFunction(value.splice) ||
		        isArguments(value) || isBuffer(value))) {
		    return !value.length;
		  }
		  if (isObjectLike(value)) {
		    var tag = getTag(value);
		    if (tag == mapTag || tag == setTag) {
		      return !value.size;
		    }
		  }
		  for (var key in value) {
		    if (hasOwnProperty.call(value, key)) {
		      return false;
		    }
		  }
		  return !(nonEnumShadows && keys(value).length);
		}
	
		module.exports = isEmpty;
		});
	
		var isEmpty$1 = (isEmpty && typeof isEmpty === 'object' && 'default' in isEmpty ? isEmpty['default'] : isEmpty);
	
		var debug$6 = d('LC:Conversation');
	
		var Conversation = function (_EventEmitter) {
		  _inherits(Conversation, _EventEmitter);
	
		  /**
		   * 无法直接实例化，请使用 {@link IMClient#createConversation} 创建新的对话
		   */
	
		  function Conversation(data, client) {
		    _classCallCheck(this, Conversation);
	
		    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
		    _Object$assign(_this, {
		      /**
		       * @var id {String} 对话 id，对应 _Conversation 表中的 objectId
		       * @memberof Conversation#
		       */
		      // id,
		      /**
		       * @var creator {String} 对话创建者
		       * @memberof Conversation#
		       */
		      // creator,
		      /**
		       * @var createdAt {Date} 对话创建时间
		       * @memberof Conversation#
		       */
		      // createdAt,
		      /**
		       * @var updatedAt {Date} 对话更新时间
		       * @memberof Conversation#
		       */
		      // updatedAt,
		      /**
		       * @var lastMessageAt {Date} 最后一条消息时间
		       * @memberof Conversation#
		       */
		      // lastMessageAt,
		      /**
		       * @var lastMessage {?Message} 最后一条消息
		       * @memberof Conversation#
		       */
		      // lastMessage,
		      /**
		       * 对该对话设置了静音的用户列表
		       * @memberof Conversation#
		       * @type {?String[]}
		       */
		      mutedMembers: [],
		      /**
		       * 参与该对话的用户列表
		       * @memberof Conversation#
		       * @type {String[]}
		       */
		      members: [],
		      _attributes: {},
		      /**
		       * 暂态对话标记
		       * @memberof Conversation#
		       * @type {Boolean}
		       */
		      transient: false,
		      /**
		       * 当前用户静音该对话标记
		       * @memberof Conversation#
		       * @type {Boolean}
		       */
		      muted: false,
		      /**
		       * 当前用户在该对话的未读消息数
		       * @memberof Conversation#
		       * @type {Number}
		       */
		      unreadMessagesCount: 0
		    }, keyRemap({
		      attributes: '_attributes',
		      name: '_name'
		    }, data));
		    _this.members = _Array$from(new _Set(_this.members));
		    if (client instanceof IMClient) {
		      _this._client = client;
		    } else {
		      throw new TypeError('Conversation must be initialized with a client');
		    }
		    ['kicked', 'membersjoined', 'membersleft', 'message'].forEach(function (event) {
		      return _this.on(event, function (payload) {
		        return _this._debug(event + ' event emitted.', payload);
		      });
		    });
		    return _this;
		  }
	
		  /**
		   * 设置对话额外属性
		   * @param {Object} map    key-value 对
		   * @param {assign} [assign=false] 使用 Object.assign 更新属性，而不是替换整个 attributes
		   * @return {Conversation} self
		   */
	
		  Conversation.prototype.setAttributes = function setAttributes(map) {
		    var assign = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
		    this._debug('set attributes: value=' + _JSON$stringify(map) + ', assign=' + assign);
		    if (!isPlainObject$1(map)) {
		      throw new TypeError('attributes must be a plain object');
		    }
		    if (!assign) {
		      this._pendingAttributes = map;
		    } else {
		      this._pendingAttributes = _Object$assign({}, this.attributes, map);
		    }
		    return this;
		  };
		  /**
		   * 设置对话额外属性
		   * @param {String} key
		   * @param {*} value
		   * @return {Conversation} self
		   */
	
	
		  Conversation.prototype.setAttribute = function setAttribute(key, value) {
		    if (typeof this._pendingAttributes === 'undefined') {
		      this._pendingAttributes = {};
		    }
		    this._pendingAttributes[key] = value;
		    return this;
		  };
		  /**
		   * 对话名字
		   * @type {String}
		   */
	
	
		  /**
		   * 设置对话名字
		   * @param {String} value
		   * @return {Conversation} self
		   */
	
		  Conversation.prototype.setName = function setName(value) {
		    this._debug('set name: ' + value);
		    this._pendingName = value;
		    return this;
		  };
	
		  Conversation.prototype._debug = function _debug() {
		    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
		      params[_key] = arguments[_key];
		    }
	
		    debug$6.apply(undefined, params.concat(['[' + this.id + ']']));
		  };
	
		  Conversation.prototype._send = function _send(command) {
		    var _client;
	
		    /* eslint-disable no-param-reassign */
		    if (command.cmd === null) {
		      command.cmd = 'conv';
		    }
		    if (command.cmd === 'conv' && command.convMessage === null) {
		      command.convMessage = new ConvCommand();
		    }
		    if (command.convMessage && command.convMessage.cid === null) {
		      command.convMessage.cid = this.id;
		    }
		    /* eslint-enable no-param-reassign */
	
		    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
		      args[_key2 - 1] = arguments[_key2];
		    }
	
		    return (_client = this._client)._send.apply(_client, [command].concat(args));
		  };
		  /**
		   * 保存当前对话的属性至服务器
		   * @return {Promise.<Conversation>} self
		   */
	
	
		  Conversation.prototype.save = function save() {
		    var _this2 = this;
	
		    this._debug('save');
		    var attr = {};
		    if (typeof this._pendingAttributes !== 'undefined') {
		      attr.attr = this._pendingAttributes;
		    }
		    if (typeof this._pendingName !== 'undefined') {
		      attr.name = this._pendingName;
		    }
		    if (isEmpty$1(attr)) {
		      this._debug('nothing touched, resolve with self');
		      return _Promise.resolve(this);
		    }
		    this._debug('attr: ' + _JSON$stringify(attr));
		    var convMessage = new ConvCommand({
		      attr: new JsonObjectMessage({
		        data: _JSON$stringify(attr)
		      })
		    });
		    return this._send(new GenericCommand({
		      op: 'update',
		      convMessage: convMessage
		    })).then(function (resCommand) {
		      _this2.updatedAt = resCommand.convMessage.udate;
		      if (typeof _this2._pendingAttributes !== 'undefined') {
		        _this2._attributes = _this2._pendingAttributes;
		        delete _this2._pendingAttributes;
		      }
		      if (typeof _this2._pendingName !== 'undefined') {
		        _this2._name = _this2._pendingName;
		        delete _this2._pendingName;
		      }
		      return _this2;
		    });
		  };
	
		  /**
		   * 从服务器更新对话的属性
		   * @return {Promise.<Conversation>} self
		   */
	
	
		  Conversation.prototype.fetch = function fetch() {
		    var _this3 = this;
	
		    return this._client.getQuery().equalTo('objectId', this.id).find().then(function () {
		      return _this3;
		    });
		  };
	
		  /**
		   * 静音，客户端拒绝收到服务器端的离线推送通知
		   * @return {Promise.<Conversation>} self
		   */
	
	
		  Conversation.prototype.mute = function mute() {
		    var _this4 = this;
	
		    this._debug('mute');
		    return this._send(new GenericCommand({
		      op: 'mute'
		    })).then(function () {
		      if (!_this4.transient) {
		        _this4.muted = true;
		        _this4.mutedMembers = union(_this4.mutedMembers, [_this4._client.id]);
		      }
		      return _this4;
		    });
		  };
	
		  /**
		   * 取消静音
		   * @return {Promise.<Conversation>} self
		   */
	
	
		  Conversation.prototype.unmute = function unmute() {
		    var _this5 = this;
	
		    this._debug('unmute');
		    return this._send(new GenericCommand({
		      op: 'unmute'
		    })).then(function () {
		      if (!_this5.transient) {
		        _this5.muted = false;
		        _this5.mutedMembers = difference(_this5.mutedMembers, [_this5._client.id]);
		      }
		      return _this5;
		    });
		  };
	
		  /**
		   * 获取对话人数，或暂态对话的在线人数
		   * @return {Promise.<Number>}
		   */
	
	
		  Conversation.prototype.count = function count() {
		    this._debug('unmute');
		    return this._send(new GenericCommand({
		      op: 'count'
		    })).then(function (resCommand) {
		      return resCommand.convMessage.count;
		    });
		  };
	
		  /**
		   * 增加成员
		   * @param {String|String[]} clientIds 新增成员 client id
		   * @return {Promise.<Conversation>} self
		   */
	
	
		  Conversation.prototype.add = function add(clientIds) {
		    var _this6 = this;
	
		    this._debug('add', clientIds);
		    if (typeof clientIds === 'string') {
		      clientIds = [clientIds]; // eslint-disable-line no-param-reassign
		    }
		    var convMessage = new ConvCommand({
		      m: clientIds
		    });
		    return _Promise.resolve(new GenericCommand({
		      op: 'add',
		      convMessage: convMessage
		    })).then(function (command) {
		      if (_this6._client.options.conversationSignatureFactory) {
		        var _params = [_this6.id, _this6._client.id, clientIds.sort(), 'add'];
		        return run(_this6._client.options.conversationSignatureFactory, _params).then(function (signatureResult) {
		          _Object$assign(command.convMessage, keyRemap({
		            signature: 's',
		            timestamp: 't',
		            nonce: 'n'
		          }, signatureResult));
		          return command;
		        });
		      }
		      return command;
		    }).then(this._send.bind(this)).then(function () {
		      if (!_this6.transient) {
		        _this6.members = union(_this6.members, clientIds);
		      }
		      return _this6;
		    });
		  };
	
		  /**
		   * 剔除成员
		   * @param {String|String[]} clientIds 成员 client id
		   * @return {Promise.<Conversation>} self
		   */
	
	
		  Conversation.prototype.remove = function remove(clientIds) {
		    var _this7 = this;
	
		    this._debug('remove', clientIds);
		    if (typeof clientIds === 'string') {
		      clientIds = [clientIds]; // eslint-disable-line no-param-reassign
		    }
		    var convMessage = new ConvCommand({
		      m: clientIds
		    });
		    return _Promise.resolve(new GenericCommand({
		      op: 'remove',
		      convMessage: convMessage
		    })).then(function (command) {
		      if (_this7._client.options.conversationSignatureFactory) {
		        var _params2 = [_this7.id, _this7._client.id, clientIds.sort(), 'remove'];
		        return run(_this7._client.options.conversationSignatureFactory, _params2).then(function (signatureResult) {
		          _Object$assign(command.convMessage, keyRemap({
		            signature: 's',
		            timestamp: 't',
		            nonce: 'n'
		          }, signatureResult));
		          return command;
		        });
		      }
		      return command;
		    }).then(this._send.bind(this)).then(function () {
		      if (!_this7.transient) {
		        _this7.members = difference(_this7.members, clientIds);
		      }
		      return _this7;
		    });
		  };
	
		  /**
		   * （当前用户）加入该对话
		   * @return {Promise.<Conversation>} self
		   */
	
	
		  Conversation.prototype.join = function join() {
		    this._debug('join');
		    return this.add(this._client.id);
		  };
	
		  /**
		   * （当前用户）退出该对话
		   * @return {Promise.<Conversation>} self
		   */
	
	
		  Conversation.prototype.quit = function quit() {
		    this._debug('quit');
		    return this.remove(this._client.id);
		  };
	
		  /**
		   * 发送消息
		   * @param  {Message} message 消息，Message 及其子类的实例
		   * @return {Promise.<Message>} 发送的消息
		   */
	
	
		  Conversation.prototype.send = function send(message) {
		    var _this8 = this;
	
		    this._debug(message, 'send');
		    if (!(message instanceof Message)) {
		      throw new TypeError(message + ' is not a Message');
		    }
		    _Object$assign(message, {
		      cid: this.id,
		      from: this._client.id
		    });
		    var msg = message.toJSON();
		    if (typeof msg !== 'string') {
		      msg = _JSON$stringify(msg);
		    }
		    var sendPromise = this._send(new GenericCommand({
		      cmd: 'direct',
		      directMessage: new DirectCommand({
		        msg: msg,
		        cid: this.id,
		        r: message.needReceipt,
		        transient: message.transient,
		        dt: message.id
		      })
		    }), !message.transient);
		    if (!message.transient) {
		      sendPromise = sendPromise.then(function (resCommand) {
		        var _resCommand$ackMessag = resCommand.ackMessage;
		        var uid = _resCommand$ackMessag.uid;
		        var t = _resCommand$ackMessag.t;
		        var code = _resCommand$ackMessag.code;
		        var reason = _resCommand$ackMessag.reason;
		        var appCode = _resCommand$ackMessag.appCode;
	
		        if (code !== null) {
		          throw createError({
		            code: code, reason: reason, appCode: appCode
		          });
		        }
		        _Object$assign(message, {
		          id: uid,
		          timestamp: new Date(t.toNumber())
		        });
		        _this8.lastMessage = message;
		        _this8.lastMessageAt = message.timestamp;
		        return message;
		      });
		    }
		    return sendPromise;
		  };
	
		  /**
		   * 查询消息记录
		   * 如果仅需实现消息记录翻页查询需求，建议使用 {@link Conversation#createMessagesIterator}
		   * @param  {Object} [options]
		   * @param  {Date}   [options.beforeTime] 限制查询结果为小于这个该时间之前的消息，不传则为当前时间
		   * @param  {String} [options.beforeMessageId] 限制查询结果为该消息之前的消息，需要与 beforeTime 同时使用，为防止某时刻有重复消息
		   * @param  {Date}   [options.afterTime] 限制查询结果为大于这个该时间之前的消息
		   * @param  {String} [options.afterMessageId] 限制查询结果为该消息之后的消息，需要与 afterTime 同时使用，为防止某时刻有重复消息
		   * @param  {Number} [options.limit] 限制查询结果的数量，目前服务端默认为 20
		   * @return {Promise.<Message[]>} 消息列表
		   */
	
	
		  Conversation.prototype.queryMessages = function queryMessages() {
		    var _this9 = this;
	
		    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		    this._debug('query messages', options);
		    if (options.beforeMessageId && !options.beforeTime) {
		      throw new Error('query option beforeMessageId must be used with option beforeTime');
		    }
		    if (options.afterMessageId && !options.afterTime) {
		      throw new Error('query option afterMessageId must be used with option afterTime');
		    }
		    var conditions = keyRemap({
		      beforeTime: 't',
		      beforeMessageId: 'mid',
		      afterTime: 'tt',
		      afterMessageId: 'tmid',
		      limit: 'l'
		    }, options);
		    if (conditions.t instanceof Date) {
		      conditions.t = conditions.t.getTime();
		    }
		    if (conditions.tt instanceof Date) {
		      conditions.tt = conditions.tt.getTime();
		    }
		    return this._send(new GenericCommand({
		      cmd: 'logs',
		      logsMessage: new LogsCommand(_Object$assign(conditions, {
		        cid: this.id
		      }))
		    })).then(function (resCommand) {
		      return resCommand.logsMessage.logs.map(function (log) {
		        var messageProps = {
		          id: log.msgId,
		          cid: _this9.id,
		          timestamp: new Date(log.timestamp.toNumber()),
		          from: log.from
		        };
		        var message = _this9._client._messageParser.parse(log.data);
		        _Object$assign(message, messageProps);
		        return message;
		      });
		    });
		  };
	
		  /**
		   * 获取消息翻页迭代器
		   * @param  {Object} [options]
		   * @param  {Date}   [options.beforeTime] 限制起始查询结果为小于这个该时间之前的消息，不传则为当前时间
		   * @param  {String} [options.beforeMessageId] 限制起始查询结果为该消息之前的消息，需要与 beforeTime 同时使用，为防止某时刻有重复消息
		   * @param  {Number} [options.limit] 限制每页查询结果的数量，目前服务端默认为 20
		   * @return {AsyncIterater.<Promise.<IteratorResult<Message[]>>>} [AsyncIterator]{@link https://github.com/tc39/proposal-async-iteration}，调用其 next 方法返回获取下一页消息的 Promise
		   * @example
		   * var messageIterator = conversation.createMessagesIterator({ limit: 10 });
		   * messageIterator.next().then(function(result) {
		   *   // result: {
		   *   //   value: [message1, ..., message10],
		   *   //   done: false,
		   *   // }
		   * });
		   * messageIterator.next().then(function(result) {
		   *   // result: {
		   *   //   value: [message11, ..., message20],
		   *   //   done: false,
		   *   // }
		   * });
		   * messageIterator.next().then(function(result) {
		   *   // No more messages
		   *   // result: { value: [], done: true }
		   * });
		   */
	
	
		  Conversation.prototype.createMessagesIterator = function createMessagesIterator() {
		    var _this10 = this;
	
		    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		    var beforeTime = _ref.beforeTime;
		    var beforeMessageId = _ref.beforeMessageId;
		    var limit = _ref.limit;
	
		    var promise = void 0;
		    return {
		      next: function next() {
		        if (promise === undefined) {
		          // first call
		          promise = _this10.queryMessages({
		            limit: limit,
		            beforeTime: beforeTime,
		            beforeMessageId: beforeMessageId
		          });
		        } else {
		          promise = promise.then(function (prevMessages) {
		            if (prevMessages.length === 0 || prevMessages.length < limit) {
		              // no more messages
		              return [];
		            }
		            return _this10.queryMessages({
		              beforeTime: prevMessages[0].timestamp,
		              beforeMessageId: prevMessages[0].id,
		              limit: limit
		            });
		          });
		        }
		        return promise.then(function (value) {
		          return {
		            value: _Array$from(value),
		            done: value.length === 0 || value.length < limit
		          };
		        });
		      }
		    };
		  };
	
		  /**
		   * 将该会话标记为已读
		   * @return {Promise.<Conversation>} self
		   */
	
	
		  Conversation.prototype.markAsRead = function markAsRead() {
		    var _this11 = this;
	
		    return this._client.markAllAsRead([this]).then(function () {
		      return _this11;
		    });
		  };
	
		  _createClass(Conversation, [{
		    key: 'createdAt',
		    set: function set(value) {
		      this._createdAt = decodeDate(value);
		    },
		    get: function get() {
		      return this._createdAt;
		    }
		  }, {
		    key: 'updatedAt',
		    set: function set(value) {
		      this._updatedAt = decodeDate(value);
		    },
		    get: function get() {
		      return this._updatedAt;
		    }
		  }, {
		    key: 'lastMessageAt',
		    set: function set(value) {
		      this._lastMessageAt = decodeDate(value);
		    },
		    get: function get() {
		      return this._lastMessageAt;
		    }
	
		    /**
		     * 对话额外属性
		     * @type {Object}
		     */
	
		  }, {
		    key: 'attributes',
		    get: function get() {
		      if (typeof this._pendingAttributes !== 'undefined') {
		        return this._pendingAttributes;
		      }
		      return this._attributes;
		    },
		    set: function set(value) {
		      this.setAttributes(value);
		    }
		  }, {
		    key: 'name',
		    get: function get() {
		      if (typeof this._pendingName !== 'undefined') {
		        return this._pendingName;
		      }
		      return this._name;
		    },
		    set: function set(value) {
		      this.setName(value);
		    }
		  }]);
	
		  return Conversation;
		}(EventEmitter);
	
		var debug$8 = d('LC:ConversationQuery');
	
		var ConversationQuery = function () {
		  ConversationQuery._encode = function _encode(value) {
		    if (value instanceof Date) {
		      return { __type: 'Date', iso: value.toJSON() };
		    }
		    if (value instanceof RegExp) {
		      return value.source;
		    }
		    return value;
		  };
	
		  ConversationQuery._quote = function _quote(s) {
		    return '\\Q' + s.replace('\\E', '\\E\\\\E\\Q') + '\\E';
		  };
	
		  ConversationQuery._calculateFlag = function _calculateFlag(options) {
		    return ['withLastMessagesRefreshed', 'compact'].reduce(function (prev, key) {
		      return (prev << 1) + Boolean(options[key]);
		    }, 0);
		  };
	
		  /**
		   * Create a ConversationQuery
		   * @param  {IMClient} client
		   */
	
	
		  function ConversationQuery(client) {
		    _classCallCheck(this, ConversationQuery);
	
		    this._client = client;
		    this._where = {};
		    this._extraOptions = {};
		  }
	
		  ConversationQuery.prototype._addCondition = function _addCondition(key, condition, value) {
		    // Check if we already have a condition
		    if (!this._where[key]) {
		      this._where[key] = {};
		    }
		    this._where[key][condition] = this.constructor._encode(value);
		    return this;
		  };
	
		  ConversationQuery.prototype.toJSON = function toJSON() {
		    var json = {
		      where: this._where,
		      flag: this.constructor._calculateFlag(this._extraOptions)
		    };
		    if (typeof this._skip !== 'undefined') json.skip = this._skip;
		    if (typeof this._limit !== 'undefined') json.limit = this._limit;
		    debug$8(json);
		    return json;
		  };
	
		  /**
		   * 增加查询条件，指定聊天室的组员包含某些成员即可返回
		   * @param {string[]} peerIds - 成员 ID 列表
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.containsMembers = function containsMembers(peerIds) {
		    return this.containsAll('m', peerIds);
		  };
	
		  /**
		   * 增加查询条件，指定聊天室的组员条件满足条件的才返回
		   *
		   * @param {string[]} - 成员 ID 列表
		   * @param {Boolean} includeSelf - 是否包含自己
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.withMembers = function withMembers(peerIds, includeSelf) {
		    var peerIdsSet = new _Set(peerIds);
		    if (includeSelf) {
		      peerIdsSet.add(this._client.id);
		    }
		    this.sizeEqualTo('m', peerIdsSet.size);
		    return this.containsMembers(_Array$from(peerIdsSet));
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段满足等于条件时即可返回
		   *
		   * @param {string} key
		   * @param value
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.equalTo = function equalTo(key, value) {
		    this._where[key] = this.constructor._encode(value);
		    return this;
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段满足小于条件时即可返回
		   * @param {string} key
		   * @param value
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.lessThan = function lessThan(key, value) {
		    return this._addCondition(key, '$lt', value);
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段满足小于等于条件时即可返回
		    * @param {string} key
		   * @param value
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.lessThanOrEqualTo = function lessThanOrEqualTo(key, value) {
		    return this._addCondition(key, '$lte', value);
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段满足大于条件时即可返回
		   *
		   * @param {string} key
		   * @param value
		   * @return {ConversationQuery} self
		   */
	
		  ConversationQuery.prototype.greaterThan = function greaterThan(key, value) {
		    return this._addCondition(key, '$gt', value);
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段满足大于等于条件时即可返回
		   *
		   * @param {string} key
		   * @param value
		   * @return {ConversationQuery} self
		   */
	
		  ConversationQuery.prototype.greaterThanOrEqualTo = function greaterThanOrEqualTo(key, value) {
		    return this._addCondition(key, '$gte', value);
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段满足不等于条件时即可返回
		   *
		   * @param {string} key
		   * @param value
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.notEqualTo = function notEqualTo(key, value) {
		    return this._addCondition(key, '$ne', value);
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段对应的值包含在指定值中时即可返回
		   *
		   * @param {string} key
		   * @param values
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.containedIn = function containedIn(key, values) {
		    return this._addCondition(key, '$in', values);
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段对应的值不包含在指定值中时即可返回
		   *
		   * @param {string} key
		   * @param values
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.notContainsIn = function notContainsIn(key, values) {
		    return this._addCondition(key, '$nin', values);
		  };
		  /**
		   * 增加查询条件，当conversation的属性中对应的字段中的元素包含所有的值才可返回
		   *
		   * @param {string} key
		   * @param values
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.containsAll = function containsAll(key, values) {
		    return this._addCondition(key, '$all', values);
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段对应的值包含此字符串即可返回
		   *
		   * @param {string} key
		   * @param {string} subString
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.contains = function contains(key, subString) {
		    return this._addCondition(key, '$regex', ConversationQuery._quote(subString));
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段对应的值以此字符串起始即可返回
		   *
		   * @param {string} key
		   * @param {string} prefix
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.startsWith = function startsWith(key, prefix) {
		    return this._addCondition(key, '$regex', '^' + ConversationQuery._quote(prefix));
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段对应的值以此字符串结束即可返回
		   *
		   * @param {string} key
		   * @param {string} suffix
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.endsWith = function endsWith(key, suffix) {
		    return this._addCondition(key, '$regex', ConversationQuery._quote(suffix) + '$');
		  };
	
		  /**
		   * 增加查询条件，当 conversation 的属性中对应的字段对应的值满足提供的正则表达式即可返回
		   *
		   * @param {string} key
		   * @param {RegExp} regex
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.matches = function matches(key, regex) {
		    this._addCondition(key, '$regex', regex);
		    // Javascript regex options support mig as inline options but store them
		    // as properties of the object. We support mi & should migrate them to
		    // modifiers
		    var _modifiers = '';
		    if (regex.ignoreCase) {
		      _modifiers += 'i';
		    }
		    if (regex.multiline) {
		      _modifiers += 'm';
		    }
	
		    if (_modifiers && _modifiers.length) {
		      this._addCondition(key, '$options', _modifiers);
		    }
		    return this;
		  };
	
		  /**
		   * 添加查询约束条件，查找 key 类型是数组，该数组的长度匹配提供的数值
		   *
		   * @param {string} key
		   * @param {Number} length
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.sizeEqualTo = function sizeEqualTo(key, length) {
		    return this._addCondition(key, '$size', length);
		  };
	
		  /**
		   * 设置返回集合的大小上限
		   *
		   * @param {Number} limit - 上限
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.limit = function limit(_limit) {
		    this._limit = _limit;
		    return this;
		  };
	
		  /**
		   * 设置返回集合的起始位置，一般用于分页
		   *
		   * @param {Number} skip - 起始位置跳过几个对象
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.skip = function skip(_skip) {
		    this._skip = _skip;
		    return this;
		  };
	
		  /**
		   * 设置返回集合按照指定key进行增序排列
		   *
		   * @param {string} key
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.ascending = function ascending(key) {
		    this._order = key;
		    return this;
		  };
	
		  /**
		   * 设置返回集合按照指定key进行增序排列，如果已设置其他排序，原排序的优先级较高
		   *
		   * @param {string} key
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.addAscending = function addAscending(key) {
		    if (this._order) {
		      this._order += ',' + key;
		    } else {
		      this._order = key;
		    }
		    return this;
		  };
	
		  /**
		   * 设置返回集合按照指定 key 进行降序排列
		   *
		   * @param {string} key
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.descending = function descending(key) {
		    this._order = '-' + key;
		    return this;
		  };
	
		  /**
		   * 设置返回集合按照指定 key 进行降序排列，如果已设置其他排序，原排序的优先级较高
		   *
		   * @param {string} key
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.addDescending = function addDescending(key) {
		    if (this._order) {
		      this._order += ',-' + key;
		    } else {
		      this._order = '-' + key;
		    }
		    return key;
		  };
	
		  /**
		   * 设置返回的 conversations 刷新最后一条消息
		   * @param  {Boolean} [enabled=true]
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.withLastMessagesRefreshed = function withLastMessagesRefreshed() {
		    var enabled = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
		    this._extraOptions.withLastMessagesRefreshed = enabled;
		    return this;
		  };
	
		  /**
		   * @deprecated 请替换为 {@link ConversationQuery#withLastMessagesRefreshed}
		   * @param  {Boolean} [enabled=true]
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.withLastMessages = function withLastMessages(enabled) {
		    console.warn('DEPRECATION ConversationQuery#withLastMessages: ' + 'Use ConversationQuery#withLastMessagesRefreshed instead.');
		    return this.withLastMessagesRefreshed(enabled);
		  };
	
		  /**
		   * 设置返回的 conversations 为精简模式，即不含成员列表
		   * @param  {Boolean} [enabled=true]
		   * @return {ConversationQuery} self
		   */
	
	
		  ConversationQuery.prototype.compact = function compact() {
		    var enabled = arguments.length <= 0 || arguments[0] === undefined ? true : arguments[0];
	
		    this._extraOptions.compact = enabled;
		    return this;
		  };
	
		  /**
		   * 执行查询
		   * @return {Promise.<Conversation[]>}
		   */
	
	
		  ConversationQuery.prototype.find = function find() {
		    return this._client._executeQuery(this);
		  };
	
		  return ConversationQuery;
		}();
	
		var isSymbol = createCommonjsModule(function (module) {
		var isObjectLike = require$$0$35;
	
		/** `Object#toString` result references. */
		var symbolTag = '[object Symbol]';
	
		/** Used for built-in method references. */
		var objectProto = Object.prototype;
	
		/**
		 * Used to resolve the
		 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
		 * of values.
		 */
		var objectToString = objectProto.toString;
	
		/**
		 * Checks if `value` is classified as a `Symbol` primitive or object.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to check.
		 * @returns {boolean} Returns `true` if `value` is correctly classified,
		 *  else `false`.
		 * @example
		 *
		 * _.isSymbol(Symbol.iterator);
		 * // => true
		 *
		 * _.isSymbol('abc');
		 * // => false
		 */
		function isSymbol(value) {
		  return typeof value == 'symbol' ||
		    (isObjectLike(value) && objectToString.call(value) == symbolTag);
		}
	
		module.exports = isSymbol;
		});
	
		var require$$0$59 = (isSymbol && typeof isSymbol === 'object' && 'default' in isSymbol ? isSymbol['default'] : isSymbol);
	
		var toNumber = createCommonjsModule(function (module) {
		var isFunction = require$$2$11,
		    isObject = require$$1$28,
		    isSymbol = require$$0$59;
	
		/** Used as references for various `Number` constants. */
		var NAN = 0 / 0;
	
		/** Used to match leading and trailing whitespace. */
		var reTrim = /^\s+|\s+$/g;
	
		/** Used to detect bad signed hexadecimal string values. */
		var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
		/** Used to detect binary string values. */
		var reIsBinary = /^0b[01]+$/i;
	
		/** Used to detect octal string values. */
		var reIsOctal = /^0o[0-7]+$/i;
	
		/** Built-in method references without a dependency on `root`. */
		var freeParseInt = parseInt;
	
		/**
		 * Converts `value` to a number.
		 *
		 * @static
		 * @memberOf _
		 * @since 4.0.0
		 * @category Lang
		 * @param {*} value The value to process.
		 * @returns {number} Returns the number.
		 * @example
		 *
		 * _.toNumber(3.2);
		 * // => 3.2
		 *
		 * _.toNumber(Number.MIN_VALUE);
		 * // => 5e-324
		 *
		 * _.toNumber(Infinity);
		 * // => Infinity
		 *
		 * _.toNumber('3.2');
		 * // => 3.2
		 */
		function toNumber(value) {
		  if (typeof value == 'number') {
		    return value;
		  }
		  if (isSymbol(value)) {
		    return NAN;
		  }
		  if (isObject(value)) {
		    var other = isFunction(value.valueOf) ? value.valueOf() : value;
		    value = isObject(other) ? (other + '') : other;
		  }
		  if (typeof value != 'string') {
		    return value === 0 ? value : +value;
		  }
		  value = value.replace(reTrim, '');
		  var isBinary = reIsBinary.test(value);
		  return (isBinary || reIsOctal.test(value))
		    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
		    : (reIsBadHex.test(value) ? NAN : +value);
		}
	
		module.exports = toNumber;
		});
	
		var require$$0$58 = (toNumber && typeof toNumber === 'object' && 'default' in toNumber ? toNumber['default'] : toNumber);
	
		var now = createCommonjsModule(function (module) {
		/**
		 * Gets the timestamp of the number of milliseconds that have elapsed since
		 * the Unix epoch (1 January 1970 00:00:00 UTC).
		 *
		 * @static
		 * @memberOf _
		 * @since 2.4.0
		 * @category Date
		 * @returns {number} Returns the timestamp.
		 * @example
		 *
		 * _.defer(function(stamp) {
		 *   console.log(_.now() - stamp);
		 * }, _.now());
		 * // => Logs the number of milliseconds it took for the deferred invocation.
		 */
		function now() {
		  return Date.now();
		}
	
		module.exports = now;
		});
	
		var require$$1$34 = (now && typeof now === 'object' && 'default' in now ? now['default'] : now);
	
		var debounce = createCommonjsModule(function (module) {
		var isObject = require$$1$28,
		    now = require$$1$34,
		    toNumber = require$$0$58;
	
		/** Used as the `TypeError` message for "Functions" methods. */
		var FUNC_ERROR_TEXT = 'Expected a function';
	
		/* Built-in method references for those with the same name as other `lodash` methods. */
		var nativeMax = Math.max,
		    nativeMin = Math.min;
	
		/**
		 * Creates a debounced function that delays invoking `func` until after `wait`
		 * milliseconds have elapsed since the last time the debounced function was
		 * invoked. The debounced function comes with a `cancel` method to cancel
		 * delayed `func` invocations and a `flush` method to immediately invoke them.
		 * Provide an options object to indicate whether `func` should be invoked on
		 * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
		 * with the last arguments provided to the debounced function. Subsequent calls
		 * to the debounced function return the result of the last `func` invocation.
		 *
		 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
		 * on the trailing edge of the timeout only if the debounced function is
		 * invoked more than once during the `wait` timeout.
		 *
		 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
		 * for details over the differences between `_.debounce` and `_.throttle`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to debounce.
		 * @param {number} [wait=0] The number of milliseconds to delay.
		 * @param {Object} [options={}] The options object.
		 * @param {boolean} [options.leading=false]
		 *  Specify invoking on the leading edge of the timeout.
		 * @param {number} [options.maxWait]
		 *  The maximum time `func` is allowed to be delayed before it's invoked.
		 * @param {boolean} [options.trailing=true]
		 *  Specify invoking on the trailing edge of the timeout.
		 * @returns {Function} Returns the new debounced function.
		 * @example
		 *
		 * // Avoid costly calculations while the window size is in flux.
		 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
		 *
		 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
		 * jQuery(element).on('click', _.debounce(sendMail, 300, {
		 *   'leading': true,
		 *   'trailing': false
		 * }));
		 *
		 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
		 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
		 * var source = new EventSource('/stream');
		 * jQuery(source).on('message', debounced);
		 *
		 * // Cancel the trailing debounced invocation.
		 * jQuery(window).on('popstate', debounced.cancel);
		 */
		function debounce(func, wait, options) {
		  var lastArgs,
		      lastThis,
		      maxWait,
		      result,
		      timerId,
		      lastCallTime,
		      lastInvokeTime = 0,
		      leading = false,
		      maxing = false,
		      trailing = true;
	
		  if (typeof func != 'function') {
		    throw new TypeError(FUNC_ERROR_TEXT);
		  }
		  wait = toNumber(wait) || 0;
		  if (isObject(options)) {
		    leading = !!options.leading;
		    maxing = 'maxWait' in options;
		    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
		    trailing = 'trailing' in options ? !!options.trailing : trailing;
		  }
	
		  function invokeFunc(time) {
		    var args = lastArgs,
		        thisArg = lastThis;
	
		    lastArgs = lastThis = undefined;
		    lastInvokeTime = time;
		    result = func.apply(thisArg, args);
		    return result;
		  }
	
		  function leadingEdge(time) {
		    // Reset any `maxWait` timer.
		    lastInvokeTime = time;
		    // Start the timer for the trailing edge.
		    timerId = setTimeout(timerExpired, wait);
		    // Invoke the leading edge.
		    return leading ? invokeFunc(time) : result;
		  }
	
		  function remainingWait(time) {
		    var timeSinceLastCall = time - lastCallTime,
		        timeSinceLastInvoke = time - lastInvokeTime,
		        result = wait - timeSinceLastCall;
	
		    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
		  }
	
		  function shouldInvoke(time) {
		    var timeSinceLastCall = time - lastCallTime,
		        timeSinceLastInvoke = time - lastInvokeTime;
	
		    // Either this is the first call, activity has stopped and we're at the
		    // trailing edge, the system time has gone backwards and we're treating
		    // it as the trailing edge, or we've hit the `maxWait` limit.
		    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
		      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
		  }
	
		  function timerExpired() {
		    var time = now();
		    if (shouldInvoke(time)) {
		      return trailingEdge(time);
		    }
		    // Restart the timer.
		    timerId = setTimeout(timerExpired, remainingWait(time));
		  }
	
		  function trailingEdge(time) {
		    timerId = undefined;
	
		    // Only invoke if we have `lastArgs` which means `func` has been
		    // debounced at least once.
		    if (trailing && lastArgs) {
		      return invokeFunc(time);
		    }
		    lastArgs = lastThis = undefined;
		    return result;
		  }
	
		  function cancel() {
		    lastInvokeTime = 0;
		    lastArgs = lastCallTime = lastThis = timerId = undefined;
		  }
	
		  function flush() {
		    return timerId === undefined ? result : trailingEdge(now());
		  }
	
		  function debounced() {
		    var time = now(),
		        isInvoking = shouldInvoke(time);
	
		    lastArgs = arguments;
		    lastThis = this;
		    lastCallTime = time;
	
		    if (isInvoking) {
		      if (timerId === undefined) {
		        return leadingEdge(lastCallTime);
		      }
		      if (maxing) {
		        // Handle invocations in a tight loop.
		        timerId = setTimeout(timerExpired, wait);
		        return invokeFunc(lastCallTime);
		      }
		    }
		    if (timerId === undefined) {
		      timerId = setTimeout(timerExpired, wait);
		    }
		    return result;
		  }
		  debounced.cancel = cancel;
		  debounced.flush = flush;
		  return debounced;
		}
	
		module.exports = debounce;
		});
	
		var require$$1$33 = (debounce && typeof debounce === 'object' && 'default' in debounce ? debounce['default'] : debounce);
	
		var throttle = createCommonjsModule(function (module) {
		var debounce = require$$1$33,
		    isObject = require$$1$28;
	
		/** Used as the `TypeError` message for "Functions" methods. */
		var FUNC_ERROR_TEXT = 'Expected a function';
	
		/**
		 * Creates a throttled function that only invokes `func` at most once per
		 * every `wait` milliseconds. The throttled function comes with a `cancel`
		 * method to cancel delayed `func` invocations and a `flush` method to
		 * immediately invoke them. Provide an options object to indicate whether
		 * `func` should be invoked on the leading and/or trailing edge of the `wait`
		 * timeout. The `func` is invoked with the last arguments provided to the
		 * throttled function. Subsequent calls to the throttled function return the
		 * result of the last `func` invocation.
		 *
		 * **Note:** If `leading` and `trailing` options are `true`, `func` is
		 * invoked on the trailing edge of the timeout only if the throttled function
		 * is invoked more than once during the `wait` timeout.
		 *
		 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
		 * for details over the differences between `_.throttle` and `_.debounce`.
		 *
		 * @static
		 * @memberOf _
		 * @since 0.1.0
		 * @category Function
		 * @param {Function} func The function to throttle.
		 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
		 * @param {Object} [options={}] The options object.
		 * @param {boolean} [options.leading=true]
		 *  Specify invoking on the leading edge of the timeout.
		 * @param {boolean} [options.trailing=true]
		 *  Specify invoking on the trailing edge of the timeout.
		 * @returns {Function} Returns the new throttled function.
		 * @example
		 *
		 * // Avoid excessively updating the position while scrolling.
		 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
		 *
		 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
		 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
		 * jQuery(element).on('click', throttled);
		 *
		 * // Cancel the trailing throttled invocation.
		 * jQuery(window).on('popstate', throttled.cancel);
		 */
		function throttle(func, wait, options) {
		  var leading = true,
		      trailing = true;
	
		  if (typeof func != 'function') {
		    throw new TypeError(FUNC_ERROR_TEXT);
		  }
		  if (isObject(options)) {
		    leading = 'leading' in options ? !!options.leading : leading;
		    trailing = 'trailing' in options ? !!options.trailing : trailing;
		  }
		  return debounce(func, wait, {
		    'leading': leading,
		    'maxWait': wait,
		    'trailing': trailing
		  });
		}
	
		module.exports = throttle;
		});
	
		var throttle$1 = (throttle && typeof throttle === 'object' && 'default' in throttle ? throttle['default'] : throttle);
	
		var version$1 = "3.0.2";
	
		var debug$5 = d('LC:IMClient');
	
		var IMClient = function (_Client) {
		  _inherits(IMClient, _Client);
	
		  /**
		   * 无法直接实例化，请使用 {@link Realtime#createIMClient} 创建新的 IMClient。
		   *
		   * @param  {String} [id] 客户端 id
		   * @param  {Object} [options]
		   * @param  {Function} [options.signatureFactory] open session 时的签名方法 // TODO need details
		   * @param  {Function} [options.conversationSignatureFactory] 对话创建、增减成员操作时的签名方法
		   */
	
		  function IMClient() {
		    _classCallCheck(this, IMClient);
	
		    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
		      args[_key] = arguments[_key];
		    }
	
		    var _this = _possibleConstructorReturn(this, _Client.call.apply(_Client, [this].concat(args)));
		    /**
		     * @var id {String} 客户端 id
		     * @memberof IMClient#
		     */
	
	
		    if (!_this._messageParser) {
		      throw new Error('IMClient must be initialized with a MessageParser');
		    }
		    _this._conversationCache = new Cache('client:' + _this.id);
		    _this._ackMessageBuffer = {};
		    ['invited', 'kicked', 'membersjoined', 'membersleft', 'message', 'unreadmessages', 'close', 'conflict', 'unhandledmessage'].forEach(function (event) {
		      return _this.on(event, function (payload) {
		        return _this._debug(event + ' event emitted.', payload);
		      });
		    });
		    return _this;
		  }
	
		  IMClient.prototype._debug = function _debug() {
		    for (var _len2 = arguments.length, params = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
		      params[_key2] = arguments[_key2];
		    }
	
		    debug$5.apply(undefined, params.concat(['[' + this.id + ']']));
		  };
	
		  /**
		   * @override
		   * @private
		   */
	
	
		  IMClient.prototype._dispatchMessage = function _dispatchMessage(message) {
		    this._debug(trim(message), 'received');
		    switch (message.cmd) {
		      case CommandType.conv:
		        return this._dispatchConvMessage(message);
		      case CommandType.direct:
		        return this._dispatchDirectMessage(message);
		      case CommandType.session:
		        return this._dispatchSessionMessage(message);
		      case CommandType.unread:
		        return this._dispatchUnreadMessage(message);
		      default:
		        this.emit('unhandledmessage', message);
		        return _Promise.resolve();
		    }
		  };
	
		  IMClient.prototype._dispatchSessionMessage = function _dispatchSessionMessage(message) {
		    var _message$sessionMessa = message.sessionMessage;
		    var code = _message$sessionMessa.code;
		    var reason = _message$sessionMessa.reason;
	
		    switch (message.op) {
		      case OpType.closed:
		        {
		          if (code === SESSION_CONFLICT.code) {
		            /**
		             * 用户在其他客户端登录，当前客户端被服务端强行下线。详见文档「单点登录」章节。
		             * @event IMClient#conflict
		             */
		            return this.emit('conflict', {
		              reason: reason
		            });
		          }
		          /**
		           * 当前客户端被服务端强行下线
		           * @event IMClient#close
		           * @param {Object} payload
		           * @param {Number} payload.code 错误码
		           * @param {String} payload.reason 原因
		           */
		          return this.emit('close', {
		            code: code, reason: reason
		          });
		        }
		      default:
		        this.emit('unhandledmessage', message);
		        return _Promise.reject(new Error('Unrecognized session command'));
		    }
		  };
	
		  IMClient.prototype._dispatchUnreadMessage = function _dispatchUnreadMessage(message) {
		    var _this2 = this;
	
		    var convs = message.unreadMessage.convs;
		    return _Promise.all(convs.map(function (conv) {
		      return _this2.getConversation(conv.cid).then(function (conversation) {
		        var timestamp = void 0;
		        if (conv.timestamp) {
		          timestamp = new Date(conv.timestamp.toNumber());
		        }
		        conversation.unreadMessagesCount = conv.unread; // eslint-disable-line no-param-reassign
		        /**
		         * 未读消息数目更新
		         * @event IMClient#unreadmessages
		         * @param {Object} payload
		         * @param {Number} payload.count 未读消息数
		         * @param {String} [payload.lastMessageId] 最新一条未读消息 id
		         * @param {String} [payload.lastMessageTimestamp] 最新一条未读消息时间戳
		         * @param {Conversation} conversation 未读消息数目有更新的对话
		         */
		        _this2.emit('unreadmessages', {
		          count: conv.unread,
		          lastMessageId: conv.mid,
		          lastMessageTimestamp: timestamp
		        }, conversation);
		      });
		    }));
		  };
	
		  IMClient.prototype._dispatchConvMessage = function _dispatchConvMessage(message) {
		    var _this3 = this;
	
		    var convMessage = message.convMessage;
		    var _message$convMessage = message.convMessage;
		    var initBy = _message$convMessage.initBy;
		    var m = _message$convMessage.m;
	
		    switch (message.op) {
		      case OpType.joined:
		        {
		          return this.getConversation(convMessage.cid).then(function (conversation) {
		            if (!conversation.transient) {
		              // eslint-disable-next-line no-param-reassign
		              conversation.members = union(conversation.members, [_this3.id]);
		            }
		            var payload = {
		              invitedBy: initBy
		            };
		            /**
		             * 当前用户被添加至某个对话
		             * @event IMClient#invited
		             * @param {Object} payload
		             * @param {String} payload.invitedBy 邀请者 id
		             * @param {Conversation} conversation
		             */
		            _this3.emit('invited', payload, conversation);
		            /**
		             * 当前用户被添加至当前对话
		             * @event Conversation#invited
		             * @param {Object} payload
		             * @param {String} payload.invitedBy 该移除操作的发起者 id
		             */
		            conversation.emit('invited', payload);
		          });
		        }
		      case OpType.left:
		        {
		          return this.getConversation(convMessage.cid).then(function (conversation) {
		            if (!conversation.transient) {
		              // eslint-disable-next-line no-param-reassign
		              conversation.members = difference(conversation.members, [_this3.id]);
		            }
		            var payload = {
		              kickedBy: initBy
		            };
		            /**
		             * 当前用户被从某个对话中移除
		             * @event IMClient#kicked
		             * @param {Object} payload
		             * @param {String} payload.kickedBy 该移除操作的发起者 id
		             * @param {Conversation} conversation
		             */
		            _this3.emit('kicked', payload, conversation);
		            /**
		             * 当前用户被从当前对话中移除
		             * @event Conversation#kicked
		             * @param {Object} payload
		             * @param {String} payload.kickedBy 该移除操作的发起者 id
		             */
		            conversation.emit('kicked', payload);
		          });
		        }
		      case OpType.members_joined:
		        {
		          return this.getConversation(convMessage.cid).then(function (conversation) {
		            if (!conversation.transient) {
		              // eslint-disable-next-line no-param-reassign
		              conversation.members = union(conversation.members, convMessage.m);
		            }
		            var payload = {
		              invitedBy: initBy,
		              members: m
		            };
		            /**
		             * 有用户被添加至某个对话
		             * @event IMClient#memberjoined
		             * @param {Object} payload
		             * @param {String[]} payload.members 被添加的用户 id 列表
		             * @param {String} payload.invitedBy 邀请者 id
		             * @param {Conversation} conversation
		             */
		            _this3.emit('membersjoined', payload, conversation);
		            /**
		             * 有成员被添加至当前对话
		             * @event Conversation#memberjoined
		             * @param {Object} payload
		             * @param {String[]} payload.members 被添加的成员 id 列表
		             * @param {String} payload.invitedBy 邀请者 id
		             */
		            conversation.emit('membersjoined', payload);
		          });
		        }
		      case OpType.members_left:
		        {
		          return this.getConversation(convMessage.cid).then(function (conversation) {
		            if (!conversation.transient) {
		              // eslint-disable-next-line no-param-reassign
		              conversation.members = difference(conversation.members, convMessage.m);
		            }
		            var payload = {
		              kickedBy: initBy,
		              members: m
		            };
		            /**
		             * 有成员被从某个对话中移除
		             * @event IMClient#memberleft
		             * @param {Object} payload
		             * @param {String[]} payload.members 被移除的成员 id 列表
		             * @param {String} payload.kickedBy 该移除操作的发起者 id
		             * @param {Conversation} conversation
		             */
		            _this3.emit('membersleft', payload, conversation);
		            /**
		             * 有成员被从当前对话中移除
		             * @event Conversation#memberleft
		             * @param {Object} payload
		             * @param {String[]} payload.members 被移除的成员 id 列表
		             * @param {String} payload.kickedBy 该移除操作的发起者 id
		             */
		            conversation.emit('membersleft', payload);
		          });
		        }
		      default:
		        this.emit('unhandledmessage', message);
		        return _Promise.reject(new Error('Unrecognized conversation command'));
		    }
		  };
	
		  IMClient.prototype._dispatchDirectMessage = function _dispatchDirectMessage(originalMessage) {
		    var _this4 = this;
	
		    var directMessage = originalMessage.directMessage;
		    var _originalMessage$dire = originalMessage.directMessage;
		    var id = _originalMessage$dire.id;
		    var cid = _originalMessage$dire.cid;
		    var fromPeerId = _originalMessage$dire.fromPeerId;
		    var timestamp = _originalMessage$dire.timestamp;
		    var transient = _originalMessage$dire.transient;
	
		    return this.getConversation(directMessage.cid).then(function (conversation) {
		      var messageProps = {
		        id: id,
		        cid: cid,
		        timestamp: new Date(timestamp.toNumber()),
		        from: fromPeerId,
		        transient: transient
		      };
		      var message = _this4._messageParser.parse(directMessage.msg);
		      _Object$assign(message, messageProps);
		      conversation.lastMessage = message; // eslint-disable-line no-param-reassign
		      conversation.lastMessageAt = message.timestamp; // eslint-disable-line no-param-reassign
		      conversation.unreadMessagesCount++; // eslint-disable-line no-param-reassign
		      /**
		       * 当前用户收到消息
		       * @event IMClient#message
		       * @param {Message} message
		       * @param {Conversation} conversation 收到消息的对话
		       */
		      _this4.emit('message', message, conversation);
		      /**
		       * 当前对话收到消息
		       * @event Conversation#message
		       * @param {Message} message
		       */
		      conversation.emit('message', message);
		      if (!(transient || conversation.transient)) {
		        _this4._sendAck(message);
		      }
		    });
		  };
	
		  IMClient.prototype._sendAck = function _sendAck(message) {
		    this._debug('send ack for', message);
		    var cid = message.cid;
	
		    if (!cid) {
		      return _Promise.reject(new Error('missing cid'));
		    }
		    if (!this._ackMessageBuffer[cid]) {
		      this._ackMessageBuffer[cid] = [];
		    }
		    this._ackMessageBuffer[cid].push(message);
		    if (!this._doSendAckThrottled) {
		      this._doSendAckThrottled = throttle$1(this._doSendAck.bind(this), 1000);
		    }
		    return this._doSendAckThrottled();
		  };
	
		  IMClient.prototype._doSendAck = function _doSendAck() {
		    var _this5 = this;
	
		    if (!this._connection.is('connected')) {
		      // if not connected, just skip everything
		      return _Promise.resolve();
		    }
		    debug$5('do send ack', this._ackMessageBuffer);
		    return _Promise.all(_Object$keys(this._ackMessageBuffer).map(function (cid) {
		      var convAckMessages = _this5._ackMessageBuffer[cid];
		      var timestamps = convAckMessages.map(function (message) {
		        return message.timestamp;
		      });
		      var command = new GenericCommand({
		        cmd: 'ack',
		        ackMessage: new AckCommand({
		          cid: cid,
		          fromts: Math.min.apply(null, timestamps),
		          tots: Math.max.apply(null, timestamps)
		        })
		      });
		      return _this5._send(command, false).then(function () {
		        return delete _this5._ackMessageBuffer[cid];
		      }).catch(function (error) {
		        return console.warn('send ack failed:', error);
		      });
		    }));
		  };
	
		  IMClient.prototype._send = function _send(cmd) {
		    var _connection;
	
		    var command = cmd;
		    if (this.id) {
		      command.peerId = this.id;
		    }
	
		    for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
		      args[_key3 - 1] = arguments[_key3];
		    }
	
		    return (_connection = this._connection).send.apply(_connection, [command].concat(args));
		  };
	
		  IMClient.prototype._open = function _open(appId, tag, deviceId) {
		    var _this6 = this;
	
		    var isReconnect = arguments.length <= 3 || arguments[3] === undefined ? false : arguments[3];
	
		    this._debug('open session');
		    return _Promise.resolve(new GenericCommand({
		      cmd: 'session',
		      op: 'open',
		      appId: appId,
		      sessionMessage: new SessionCommand({
		        ua: 'js/' + version$1,
		        r: isReconnect,
		        tag: tag,
		        deviceId: deviceId
		      })
		    })).then(function (command) {
		      if (_this6.options.signatureFactory) {
		        return run(_this6.options.signatureFactory, [_this6.id]).then(function (signatureResult) {
		          _Object$assign(command.sessionMessage, keyRemap({
		            signature: 's',
		            timestamp: 't',
		            nonce: 'n'
		          }, signatureResult));
		          return command;
		        });
		      }
		      return command;
		    }).then(this._send.bind(this)).then(function (resCommand) {
		      var peerId = resCommand.peerId;
		      if (!peerId) {
		        console.warn('Unexpected session opened without peerId.');
		        return;
		      }
		      _this6.id = peerId;
		    });
		  };
	
		  /**
		   * 关闭客户端
		   * @return {Promise}
		   */
	
	
		  IMClient.prototype.close = function close() {
		    var _this7 = this;
	
		    this._debug('close session');
		    var command = new GenericCommand({
		      cmd: 'session',
		      op: 'close'
		    });
		    return this._send(command).then(function () {
		      _this7.emit('close', {
		        code: 0
		      });
		    });
		  };
		  /**
		   * 获取 client 列表中在线的 client，每次查询最多 20 个 clientId，超出部分会被忽略
		   * @param  {String[]} clientIds 要查询的 client ids
		   * @return {Primse.<String[]>} 在线的 client ids
		   */
	
	
		  IMClient.prototype.ping = function ping(clientIds) {
		    this._debug('ping');
		    if (!(clientIds instanceof Array)) {
		      throw new TypeError('clientIds ' + clientIds + ' is not an Array');
		    }
		    if (!clientIds.length) {
		      return _Promise.resolve([]);
		    }
		    var command = new GenericCommand({
		      cmd: 'session',
		      op: 'query',
		      sessionMessage: new SessionCommand({
		        sessionPeerIds: clientIds
		      })
		    });
		    return this._send(command).then(function (resCommand) {
		      return resCommand.sessionMessage.onlineSessionPeerIds;
		    });
		  };
	
		  /**
		   * 获取某个特定的 conversation
		   * @param  {String} id 对话 id，对应 _Conversation 表中的 objectId
		   * @param  {Boolean} [noCache=false] 强制不从缓存中获取
		   * @return {Promise.<Conversation>}
		   */
	
	
		  IMClient.prototype.getConversation = function getConversation(id) {
		    var noCache = arguments.length <= 1 || arguments[1] === undefined ? false : arguments[1];
	
		    if (typeof id !== 'string') {
		      throw new TypeError(id + ' is not a String');
		    }
		    if (!noCache) {
		      var cachedConversation = this._conversationCache.get(id);
		      if (cachedConversation) {
		        return _Promise.resolve(cachedConversation);
		      }
		    }
		    return this.getQuery().equalTo('objectId', id).find().then(function (conversations) {
		      return conversations[0] || null;
		    });
		  };
	
		  /**
		   * 构造一个 ConversationQuery 来查询对话
		   * @return {ConversationQuery}
		   */
	
	
		  IMClient.prototype.getQuery = function getQuery() {
		    return new ConversationQuery(this);
		  };
	
		  IMClient.prototype._executeQuery = function _executeQuery(query) {
		    var _this8 = this;
	
		    var queryJSON = query.toJSON();
		    queryJSON.where = new JsonObjectMessage({
		      data: _JSON$stringify(queryJSON.where)
		    });
		    var command = new GenericCommand({
		      cmd: 'conv',
		      op: 'query',
		      convMessage: new ConvCommand(queryJSON)
		    });
		    return this._send(command).then(function (resCommand) {
		      try {
		        return JSON.parse(resCommand.convMessage.results.data);
		      } catch (error) {
		        var commandString = _JSON$stringify(trim(resCommand));
		        throw new Error('Parse query result failed: ' + error.message + '. Command: ' + commandString);
		      }
		    }).then(function (conversations) {
		      return conversations.map(_this8._parseConversationFromRawData.bind(_this8));
		    }).then(function (conversations) {
		      return conversations.map(function (fetchedConversation) {
		        var conversation = _this8._conversationCache.get(fetchedConversation.id);
		        if (!conversation) {
		          conversation = fetchedConversation;
		          _this8._debug('no match, set cache');
		          _this8._conversationCache.set(fetchedConversation.id, fetchedConversation);
		        } else {
		          _this8._debug('update cached conversation');
		          ['_name', 'creator', 'createdAt', 'updatedAt', 'lastMessageAt', 'lastMessage', 'mutedMembers', 'members', '_attributes', 'transient', 'muted'].forEach(function (key) {
		            var value = fetchedConversation[key];
		            if (value !== undefined) conversation[key] = value;
		          });
		          delete conversation._pendingAttributes;
		          delete conversation._pendingName;
		        }
		        return conversation;
		      });
		    });
		  };
	
		  IMClient.prototype._parseConversationFromRawData = function _parseConversationFromRawData(rawData) {
		    var data = keyRemap({
		      objectId: 'id',
		      lm: 'lastMessageAt',
		      msg: 'lastMessage',
		      msg_from: 'lastMessageFrom',
		      msg_mid: 'lastMessageId',
		      msg_timestamp: 'lastMessageTimestamp',
		      m: 'members',
		      attr: 'attributes',
		      tr: 'transient',
		      c: 'creator',
		      mu: 'mutedMembers'
		    }, rawData);
		    if (data.lastMessage) {
		      data.lastMessage = this._messageParser.parse(data.lastMessage);
		      data.lastMessage.from = data.lastMessageFrom;
		      data.lastMessage.id = data.lastMessageId;
		      data.lastMessage.timestamp = new Date(data.lastMessageTimestamp);
		      delete data.lastMessageFrom;
		      delete data.lastMessageId;
		      delete data.lastMessageTimestamp;
		    }
		    return new Conversation(data, this);
		  };
	
		  /**
		   * 创建一个 conversation
		   * @param {Object} options
		   * @param {String[]} options.members 对话的初始成员列表，默认包含当前 client
		   * @param {String} [options.name] 对话的名字
		   * @param {Object} [options.attributes] 额外属性
		   * @param {Boolean} [options.transient=false] 暂态会话
		   * @param {Boolean} [options.unique=false] 唯一对话，当其为 true 时，如果当前已经有相同成员的对话存在则返回该对话，否则会创建新的对话
		   * @return {Promise.<Conversation>}
		   */
	
	
		  IMClient.prototype.createConversation = function createConversation() {
		    var _this9 = this;
	
		    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
		    var attr = {};
		    var members = options.members;
		    var name = options.name;
		    var attributes = options.attributes;
		    var transient = options.transient;
		    var unique = options.unique;
	
		    if (!(transient || Array.isArray(members))) {
		      throw new TypeError('conversation members ' + members + ' is not an array');
		    }
		    members = new _Set(members);
		    members.add(this.id);
		    members = _Array$from(members).sort();
		    if (name) {
		      if (typeof name !== 'string') {
		        throw new TypeError('conversation name ' + name + ' is not a string');
		      }
		      attr.name = name;
		    }
		    if (attributes) {
		      attr.attr = attributes;
		    }
		    attr = new JsonObjectMessage({
		      data: _JSON$stringify(attr)
		    });
	
		    var startCommandJson = {
		      m: members,
		      attr: attr,
		      transient: transient,
		      unique: unique
		    };
	
		    return _Promise.resolve(new GenericCommand({
		      cmd: 'conv',
		      op: 'start',
		      convMessage: new ConvCommand(startCommandJson)
		    })).then(function (command) {
		      if (_this9.options.conversationSignatureFactory) {
		        var _params = [null, _this9.id, members, 'create'];
		        return run(_this9.options.conversationSignatureFactory, _params).then(function (signatureResult) {
		          _Object$assign(command.convMessage, keyRemap({
		            signature: 's',
		            timestamp: 't',
		            nonce: 'n'
		          }, signatureResult));
		          return command;
		        });
		      }
		      return command;
		    }).then(this._send.bind(this)).then(function (resCommand) {
		      return new Conversation(_Object$assign({}, options, {
		        id: resCommand.convMessage.cid,
		        createdAt: resCommand.convMessage.cdate,
		        updatedAt: resCommand.convMessage.cdate,
		        lastMessageAt: null,
		        creator: _this9.id,
		        members: transient ? [] : members
		      }), _this9);
		    }).then(tap(function (conversation) {
		      return _this9._conversationCache.set(conversation.id, conversation);
		    }));
		  };
	
		  /**
		   * 将指定的所有会话标记为已读
		   *
		   * @param {Conversation[]} conversations 指定的会话列表
		   * @return {Promise.<Conversation[]>} conversations 返回输入的会话列表
		   */
	
	
		  IMClient.prototype.markAllAsRead = function markAllAsRead(conversations) {
		    if (!Array.isArray(conversations)) {
		      throw new TypeError(conversations + ' is not an Array');
		    }
		    var ids = conversations.map(function (conversation) {
		      if (!(conversation instanceof Conversation)) {
		        throw new TypeError(conversation + ' is not a Conversation');
		      }
		      return conversation.id;
		    });
		    this._debug('mark [' + ids + '] as read');
		    if (!conversations.length) {
		      return _Promise.resolve([]);
		    }
		    return this._send(new GenericCommand({
		      cmd: 'read',
		      readMessage: new ReadCommand({
		        convs: conversations.map(function (conversation) {
		          return new ReadTuple({
		            cid: conversation.id,
		            timestamp: (conversation.lastMessageAt || new Date()).getTime()
		          });
		        })
		      })
		    }), false).then(function () {
		      // eslint-disable-next-line no-param-reassign
		      conversations.forEach(function (conversation) {
		        return conversation.unreadMessagesCount = 0;
		      });
		      return conversations;
		    });
		  };
	
		  return IMClient;
		}(Client);
	
		var core_getIterator = createCommonjsModule(function (module) {
		var anObject = require$$2$3
		  , get      = require$$1$12;
		module.exports = require$$0$1.getIterator = function(it){
		  var iterFn = get(it);
		  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
		  return anObject(iterFn.call(it));
		};
		});
	
		var require$$0$61 = (core_getIterator && typeof core_getIterator === 'object' && 'default' in core_getIterator ? core_getIterator['default'] : core_getIterator);
	
		var getIterator$1 = createCommonjsModule(function (module) {
		module.exports = require$$0$61;
		});
	
		var require$$0$60 = (getIterator$1 && typeof getIterator$1 === 'object' && 'default' in getIterator$1 ? getIterator$1['default'] : getIterator$1);
	
		var getIterator = createCommonjsModule(function (module) {
		module.exports = { "default": require$$0$60, __esModule: true };
		});
	
		var _getIterator = (getIterator && typeof getIterator === 'object' && 'default' in getIterator ? getIterator['default'] : getIterator);
	
		var debug$9 = d('LC:MessageParser');
	
		var MessageParser = function () {
		  function MessageParser() {
		    _classCallCheck(this, MessageParser);
	
		    this._messageClasses = [];
		  }
	
		  MessageParser.prototype.register = function register(messageClass) {
		    if (messageClass && messageClass.parse && messageClass.prototype && messageClass.prototype.toJSON) {
		      this._messageClasses.unshift(messageClass);
		    } else {
		      throw new TypeError('Invalid messageClass');
		    }
		  };
	
		  MessageParser.prototype.parse = function parse(text) {
		    debug$9('parsing message:', text);
		    var content = void 0;
		    try {
		      content = JSON.parse(text);
		    } catch (error) {
		      content = text;
		    }
		    var _iteratorNormalCompletion = true;
		    var _didIteratorError = false;
		    var _iteratorError = undefined;
	
		    try {
		      for (var _iterator = _getIterator(this._messageClasses), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
		        var Klass = _step.value;
	
		        var contentCopy = isPlainObject$1(content) ? _Object$assign({}, content) : content;
		        var valid = void 0;
		        var result = void 0;
		        try {
		          valid = Klass.validate(contentCopy);
		        } catch (error) {
		          // eslint-disable-line no-empty
		        }
		        if (valid) {
		          try {
		            result = Klass.parse(contentCopy);
		          } catch (error) {
		            console.warn('parsing a valid message content error', {
		              error: error,
		              Klass: Klass,
		              content: contentCopy
		            });
		          }
		          if (result !== undefined) {
		            debug$9('parse result:', result);
		            return result;
		          }
		        }
		      }
		    } catch (err) {
		      _didIteratorError = true;
		      _iteratorError = err;
		    } finally {
		      try {
		        if (!_iteratorNormalCompletion && _iterator.return) {
		          _iterator.return();
		        }
		      } finally {
		        if (_didIteratorError) {
		          throw _iteratorError;
		        }
		      }
		    }
	
		    throw new Error('No Message Class matched');
		  };
	
		  return MessageParser;
		}();
	
		/**
		 * @namespace MessageHelper
		 * @example
		 * // 这是一个虚拟的 namespace，以下所有 members 请直接 import from 'leancloud-realtime'
		import { messageType } from 'leancloud-realtime';
		 */
	
		/**
		 * decorator，定义消息类的类型常量
		 * @function
		 * @memberof MessageHelper
		 * @param {Number} type 自定义类型请使用正整数
		 * @example @messageType(1)
		 * class CustomMessage extends TypedMessage {}
		 *
		 * // 不支持 decorator 的情况下可以这样使用
		 * class CustomMessage extends TypedMessage {
		 *   //...
		 * }
		 * messageType(1)(CustomMessage);
		 */
		var messageType = function messageType(type) {
		  if (typeof type !== 'number') {
		    throw new TypeError(type + ' is not a Number');
		  }
		  return function (target) {
		    target.TYPE = type;
		    target.validate = function (json) {
		      return json._lctype === type;
		    };
		    target.prototype._getType = function () {
		      return { _lctype: type };
		    };
		  };
		};
	
		/**
		 * decorator，定义消息类的自定义字段
		 * @function
		 * @memberof MessageHelper
		 * @param {String[]} fields 自定义字段
		 * @example @messageField(['foo'])
		 * class CustomMessage extends TypedMessage {
		 *   constructor(foo) {
		 *     super();
		 *     this.foo = foo;
		 *   }
		 * }
		 *
		 * // 不支持 decorator 的情况下可以这样使用
		 * class CustomMessage extends TypedMessage {
		 *   constructor(foo) {
		 *     super();
		 *     this.foo = foo;
		 *   }
		 *   //...
		 * }
		 * messageField(['foo'])(CustomMessage);
		 */
		var messageField = function messageField(fields) {
		  if (typeof fields !== 'string') {
		    if (!Array.isArray(fields)) {
		      throw new TypeError(fields + ' is not an Array');
		    } else {
		      if (fields.some(function (value) {
		        return typeof value !== 'string';
		      })) {
		        throw new TypeError('fields contains non-string typed member');
		      }
		    }
		  }
		  return function (target) {
		    // IE10 Hack:
		    // static properties in IE10 will not be inherited from super
		    // search for parse method and assign it manually
		    var originalCustomFields = isIE10 ? getStaticProperty(target, '_customFields') : target._customFields;
		    originalCustomFields = Array.isArray(originalCustomFields) ? originalCustomFields : [];
		    target._customFields = originalCustomFields.concat(fields);
		  };
		};
	
		// IE10 Hack:
		// static properties in IE10 will not be inherited from super
		// search for parse method and assign it manually
	
		var IE10Compatible = function IE10Compatible(target) {
		  if (isIE10) {
		    target.parse = getStaticProperty(target, 'parse');
		  }
		};
	
	var 	_dec$1;
	var 	_class$2;
		// jsdoc-ignore-start
	
		// jsdoc-ignore-end
		var TypedMessage = (_dec$1 = messageField(['_lctext', '_lcattrs']), _dec$1(_class$2 = function (_Message) {
		  _inherits(TypedMessage, _Message);
	
		  /**
		   * 所有内置的富媒体消息均继承自本类
		   * @extends Message
		   */
	
		  function TypedMessage() {
		    _classCallCheck(this, TypedMessage);
	
		    var _this = _possibleConstructorReturn(this, _Message.call(this));
	
		    _this._ = {};
		    return _this;
		  }
	
		  /**
		   * @type {Number}
		   * @readonly
		   */
	
	
		  /**
		   * @param {String} text
		   * @return {TypedMessage} self
		   */
	
		  TypedMessage.prototype.setText = function setText(text) {
		    this._lctext = text;
		    return this;
		  };
		  /**
		   * @return {String}
		   */
	
	
		  TypedMessage.prototype.getText = function getText() {
		    return this._lctext;
		  };
	
		  /**
		   * @param {Object} attributes
		   * @return {TypedMessage} self
		   */
	
	
		  TypedMessage.prototype.setAttributes = function setAttributes(attributes) {
		    this._lcattrs = attributes;
		    return this;
		  };
		  /**
		   * @return {Object}
		   */
	
	
		  TypedMessage.prototype.getAttributes = function getAttributes() {
		    return this._lcattrs;
		  };
	
		  TypedMessage.prototype._getCustomFields = function _getCustomFields() {
		    var _this2 = this;
	
		    var fields = Array.isArray(this.constructor._customFields) ? this.constructor._customFields : [];
		    return fields.reduce(function (result, field) {
		      if (typeof field !== 'string') return result;
		      result[field] = _this2[field]; // eslint-disable-line no-param-reassign
		      return result;
		    }, {});
		  };
	
		  TypedMessage.prototype._getType = function _getType() {
		    throw new Error('not implemented');
		  };
	
		  TypedMessage.prototype.toJSON = function toJSON() {
		    return _Object$assign({
		      _lctext: this.getText(),
		      _lcattrs: this.getAttributes()
		    }, this._getCustomFields(), this._getType());
		  };
	
		  /**
		   * 解析处理消息内容
		   * <pre>
		   * 为给定的 message 设置 text 与 attributes 属性，返回该 message
		   * 如果子类没有提供 message，new this()
		   * @protected
		   * @param  {Object}  json    json 格式的消息内容
		   * @param  {TypedMessage} message 子类提供的 message
		   * @return {TypedMessage}
		   * @implements AVMessage.parse
		   */
	
	
		  TypedMessage.parse = function parse(json) {
		    var message = arguments.length <= 1 || arguments[1] === undefined ? new this() : arguments[1];
	
		    message.content = json; // eslint-disable-line no-param-reassign
		    var customFields = isIE10 ? getStaticProperty(message.constructor, '_customFields') : message.constructor._customFields;
		    var fields = Array.isArray(customFields) ? customFields : [];
		    fields = fields.reduce(function (result, field) {
		      if (typeof field !== 'string') return result;
		      result[field] = json[field]; // eslint-disable-line no-param-reassign
		      return result;
		    }, {});
		    _Object$assign(message, fields);
		    return _Message.parse.call(this, json, message);
		  };
	
		  _createClass(TypedMessage, [{
		    key: 'type',
		    get: function get() {
		      return this.constructor.TYPE;
		    }
	
		    /** @type {String} */
	
		  }, {
		    key: 'text',
		    set: function set(text) {
		      return this.setText(text);
		    },
		    get: function get() {
		      return this.getText();
		    }
	
		    /** @type {Object} */
	
		  }, {
		    key: 'attributes',
		    set: function set(attributes) {
		      return this.setAttributes(attributes);
		    },
		    get: function get() {
		      return this.getAttributes();
		    }
		  }]);
	
		  return TypedMessage;
		}(Message)) || _class$2);
	
		var _dec;
	var 	_class$1;
		// jsdoc-ignore-start
	
		// jsdoc-ignore-end
		var TextMessage = (_dec = messageType(-1), _dec(_class$1 = IE10Compatible(_class$1 = function (_TypedMessage) {
		  _inherits(TextMessage, _TypedMessage);
	
		  /**
		   * 文类类型消息
		   * @extends TypedMessage
		   * @param  {String} [text='']
		   * @throws {TypeError} text 不是 String 类型
		   */
	
		  function TextMessage() {
		    var text = arguments.length <= 0 || arguments[0] === undefined ? '' : arguments[0];
	
		    _classCallCheck(this, TextMessage);
	
		    if (typeof text !== 'string') {
		      throw new TypeError(text + ' is not a string');
		    }
	
		    var _this = _possibleConstructorReturn(this, _TypedMessage.call(this));
	
		    _this.setText(text);
		    return _this;
		  }
	
		  return TextMessage;
		}(TypedMessage)) || _class$1) || _class$1);
	
		var debug = d('LC:Realtime');
	
		var pushRouterCache = new Cache('push-router');
	
		var Realtime = function (_EventEmitter) {
		  _inherits(Realtime, _EventEmitter);
	
		  /**
		   * @param  {Object} options
		   * @param  {String} options.appId
		   * @param  {String} [options.region='cn'] 节点 id
		   * @param  {Boolean} [options.pushOfflineMessages=false] 启用推送离线消息模式（默认为发送未读消息通知模式）
		   * @param  {Boolean} [options.noBinary=false] 设置 WebSocket 使用字符串格式收发消息（默认为二进制格式）。
		   *                                            适用于 WebSocket 实现不支持二进制数据格式的情况（如 React Native）
		   * @param  {Boolean} [options.ssl=true] 使用 wss 进行连接
		   */
	
		  function Realtime(options) {
		    _classCallCheck(this, Realtime);
	
		    debug('initializing Realtime');
	
		    var _this = _possibleConstructorReturn(this, _EventEmitter.call(this));
	
		    if (typeof options.appId !== 'string') {
		      throw new TypeError('appId [' + options.appId + '] is not a string');
		    }
		    _this._options = _Object$assign({
		      appId: undefined,
		      region: 'cn',
		      pushOfflineMessages: false,
		      ssl: true
		    }, options);
		    _this._id = uuid$1.v4();
		    _this._cache = new Cache('endpoints');
		    _this._clients = {};
		    _this._messageParser = new MessageParser();
		    _this.register([Message, TextMessage]);
		    return _this;
		  }
	
		  Realtime.prototype._open = function _open() {
		    var _this2 = this;
	
		    if (this._openPromise) return this._openPromise;
	
		    var format = 'protobuf';
		    if (this._options.noBinary) {
		      // 不发送 binary data，fallback to base64 string
		      format = 'protobase64';
		    }
		    var version = 3;
		    if (this._options.pushOfflineMessages) {
		      // 不推送离线消息，而是发送对话的未读通知
		      version = 1;
		    }
		    var protocol = {
		      format: format,
		      version: version
		    };
		    this._openPromise = new _Promise(function (resolve, reject) {
		      debug('No connection established, create a new one.');
		      var connection = new Connection(function () {
		        return _this2._getEndpoints(_this2._options);
		      }, protocol);
		      connection.binaryType = 'arraybuffer';
		      connection.on('open', function () {
		        return resolve(connection);
		      });
		      connection.on('error', reject);
		      connection.on('message', _this2._dispatchMessage.bind(_this2));
		      /**
		       * 网络连接断开
		       * @event Realtime#disconnect
		       */
		      /**
		       * 计划在一段时间后尝试重新连接
		       * @event Realtime#retry
		       * @param {Number} attempt 尝试重连的次数
		       * @param {Number} delay 延迟的毫秒数
		       */
		      /**
		       * 正在尝试重新连接
		       * @event Realtime#retry
		       * @param {Number} attempt 尝试重连的次数
		       */
		      /**
		       * 网络连接恢复正常
		       * @event Realtime#reconnect
		       */
		      // event proxy
		      ['disconnect', 'reconnect', 'retry', 'schedule'].forEach(function (event) {
		        return connection.on(event, function () {
		          for (var _len = arguments.length, payload = Array(_len), _key = 0; _key < _len; _key++) {
		            payload[_key] = arguments[_key];
		          }
	
		          debug.apply(undefined, [event + ' event emitted.'].concat(payload));
		          _this2.emit.apply(_this2, [event].concat(payload));
		        });
		      });
		      // override handleClose
		      connection.handleClose = function handleClose(event) {
		        // CAUTION: non-standard API, provided by core-js
		        var fatalError = _Array$find([APP_NOT_AVAILABLE, INVALID_LOGIN, INVALID_ORIGIN], function (error) {
		          return error.code === event.code;
		        });
		        if (fatalError) {
		          // in these cases, SDK should throw.
		          var error = new Error('' + (fatalError.message || event.reason));
		          error.code = event.code;
		          this.throw(error);
		        } else {
		          // reconnect
		          this.disconnect();
		        }
		      };
		      internal(_this2).connection = connection;
		    });
	
		    return this._openPromise;
		  };
	
		  Realtime.prototype._getEndpoints = function _getEndpoints(options) {
		    var _this3 = this;
	
		    return _Promise.resolve(this._cache.get('endpoints') || this.constructor._fetchEndpointsInfo(options).then(tap(function (info) {
		      return _this3._cache.set('endpoints', info, info.ttl * 1000);
		    }))).then(function (info) {
		      debug('endpoint info:', info);
		      return [info.server, info.secondary];
		    });
		  };
	
		  Realtime._fetchPushRouter = function _fetchPushRouter(_ref) {
		    var appId = _ref.appId;
		    var region = _ref.region;
	
		    debug('fetch router');
		    switch (region) {
		      case 'cn':
		        {
		          var cachedPushRouter = pushRouterCache.get(appId);
		          if (cachedPushRouter) {
		            return _Promise.resolve(cachedPushRouter);
		          }
		          return axios.get('https://app-router.leancloud.cn/1/route', {
		            params: {
		              appId: appId
		            },
		            timeout: 20000
		          }).then(function (res) {
		            return res.data;
		          }).then(tap(debug)).then(function (route) {
		            var pushRouter = route.push_router_server;
		            if (!pushRouter) {
		              throw new Error('push router not exists');
		            }
		            var ttl = route.ttl;
		            if (typeof ttl !== 'number') {
		              ttl = 3600;
		            }
		            pushRouterCache.set(appId, pushRouter, ttl * 1000);
		            return pushRouter;
		          }).catch(function () {
		            return 'router-g0-push.leancloud.cn';
		          });
		        }
		      case 'us':
		        return _Promise.resolve('router-a0-push.leancloud.cn');
		      default:
		        throw new Error('Region [' + region + '] is not supported.');
		    }
		  };
	
		  Realtime._fetchEndpointsInfo = function _fetchEndpointsInfo(_ref2) {
		    var appId = _ref2.appId;
		    var region = _ref2.region;
		    var ssl = _ref2.ssl;
		    var _debug = _ref2._debug;
	
		    debug('fetch endpoint info');
		    return this._fetchPushRouter({ appId: appId, region: region }).then(tap(debug)).then(function (router) {
		      return axios.get('https://' + router + '/v1/route', {
		        params: {
		          appId: appId,
		          secure: ssl,
		          debug: _debug,
		          _t: Date.now()
		        },
		        timeout: 20000
		      }).then(function (res) {
		        return res.data;
		      }).then(tap(debug));
		    });
		  };
	
		  Realtime.prototype._close = function _close() {
		    if (this._openPromise) {
		      this._openPromise.then(function (connection) {
		        return connection.close();
		      });
		    }
		    delete this._openPromise;
		  };
	
		  /**
		   * 手动进行重连。
		   * SDK 在网络出现异常时会自动按照一定的时间间隔尝试重连，调用该方法会立即尝试重连并重置重连尝试计数器。
		   * 只能在 `schedule` 事件之后，`retry` 事件之前调用，如果当前网络正常或者正在进行重连，调用该方法会抛异常。
		   */
	
	
		  Realtime.prototype.retry = function retry() {
		    var connection = internal(this).connection;
		    if (!connection) {
		      throw new Error('no connection established');
		    }
		    if (connection.cannot('retry')) {
		      throw new Error('retrying not allowed when not offline. the connection is now ' + connection.current);
		    }
		    return connection.retry();
		  };
	
		  Realtime.prototype._register = function _register(client) {
		    if (!(client instanceof Client)) {
		      throw new TypeError(client + ' is not a Client');
		    }
		    if (!client.id) {
		      throw new Error('Client must have an id to be registered');
		    }
		    this._clients[client.id] = client;
		  };
	
		  Realtime.prototype._deregister = function _deregister(client) {
		    if (!(client instanceof Client)) {
		      throw new TypeError(client + ' is not a Client');
		    }
		    if (!client.id) {
		      throw new Error('Client must have an id to be deregistered');
		    }
		    delete this._clients[client.id];
		    if (_Object$getOwnPropertyNames(this._clients).length === 0) {
		      this._close();
		    }
		  };
	
		  Realtime.prototype._dispatchMessage = function _dispatchMessage(message) {
		    if (message.peerId !== null) {
		      var targetClient = this._clients[message.peerId];
		      if (targetClient) {
		        return _Promise.resolve(targetClient).then(function (client) {
		          return client._dispatchMessage(message);
		        }).catch(debug);
		      }
		      return debug('[WARN] Unexpected message received without any live client match', trim(message));
		    }
		    return debug('[WARN] Unexpected message received without peerId', trim(message));
		  };
	
		  /**
		   * 创建一个即时通讯客户端，多次创建相同 id 的客户端会返回同一个实例
		   * @param  {String} [id] 客户端 id，如果不指定，服务端会随机生成一个
		   * @param  {Object} [clientOptions] 详细参数 @see {@link IMClient}
		   * @param  {String} [tag] 客户端类型标记，以支持单点登录功能
		   * @return {Promise.<IMClient>}
		   */
	
	
		  Realtime.prototype.createIMClient = function createIMClient(id, clientOptions, tag) {
		    var _this4 = this;
	
		    var idIsString = typeof id === 'string';
		    if (idIsString && this._clients[id] !== undefined) {
		      return _Promise.resolve(this._clients[id]);
		    }
		    var promise = this._open().then(function (connection) {
		      var client = new IMClient(id, clientOptions, connection, {
		        _messageParser: _this4._messageParser
		      });
		      connection.on('reconnect', function () {
		        return client._open(_this4._options.appId, tag, _this4._id, true);
		      });
		      client.on('close', function () {
		        return _this4._deregister(client);
		      }, _this4);
		      return client._open(_this4._options.appId, tag, _this4._id).then(function () {
		        _this4._register(client);
		        return client;
		      });
		    });
		    if (idIsString) {
		      this._clients[id] = promise;
		    }
		    return promise;
		  };
	
		  Realtime.prototype.createPushClient = function createPushClient() {
		    return this._open();
		  };
	
		  /**
		   * 注册消息类
		   *
		   * 在接收消息、查询消息时，会按照消息类注册顺序的逆序依次尝试解析消息内容
		   *
		   * @param  {Function | Function[]} messageClass 消息类，需要实现 {@link AVMessage} 接口，
		   *                     													建议继承自 {@link TypedMessage}
		   * @throws {TypeError} 如果 messageClass 没有实现 {@link AVMessage} 接口则抛出异常
		   */
	
	
		  Realtime.prototype.register = function register(messageClass) {
		    var messageClasses = [].concat(messageClass);
		    return messageClasses.map(this._messageParser.register.bind(this._messageParser));
		  };
	
		  return Realtime;
		}(EventEmitter);
	
		exports.Realtime = Realtime;
		exports.Message = Message;
		exports.TypedMessage = TypedMessage;
		exports.TextMessage = TextMessage;
		exports.messageType = messageType;
		exports.messageField = messageField;
		exports.IE10Compatible = IE10Compatible;
	
		Object.defineProperty(exports, '__esModule', { value: true });
	
	}));
	//# sourceMappingURL=realtime.browser.js.map

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;var require;var require;/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	(function (f) {
	  if (( false ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
	    module.exports = f();
	  } else if (true) {
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (f), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else {
	    var g;if (typeof window !== "undefined") {
	      g = window;
	    } else if (typeof global !== "undefined") {
	      g = global;
	    } else if (typeof self !== "undefined") {
	      g = self;
	    } else {
	      g = this;
	    }g.AV = f();
	  }
	})(function () {
	  var define, module, exports;return function e(t, n, r) {
	    function s(o, u) {
	      if (!n[o]) {
	        if (!t[o]) {
	          var a = typeof require == "function" && require;if (!u && a) return require(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
	        }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
	          var n = t[o][1][e];return s(n ? n : e);
	        }, l, l.exports, e, t, n, r);
	      }return n[o].exports;
	    }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
	      s(r[o]);
	    }return s;
	  }({ 1: [function (require, module, exports) {}, {}], 2: [function (require, module, exports) {
	      var charenc = {
	        // UTF-8 encoding
	        utf8: {
	          // Convert a string to a byte array
	          stringToBytes: function stringToBytes(str) {
	            return charenc.bin.stringToBytes(unescape(encodeURIComponent(str)));
	          },
	
	          // Convert a byte array to a string
	          bytesToString: function bytesToString(bytes) {
	            return decodeURIComponent(escape(charenc.bin.bytesToString(bytes)));
	          }
	        },
	
	        // Binary encoding
	        bin: {
	          // Convert a string to a byte array
	          stringToBytes: function stringToBytes(str) {
	            for (var bytes = [], i = 0; i < str.length; i++) {
	              bytes.push(str.charCodeAt(i) & 0xFF);
	            }return bytes;
	          },
	
	          // Convert a byte array to a string
	          bytesToString: function bytesToString(bytes) {
	            for (var str = [], i = 0; i < bytes.length; i++) {
	              str.push(String.fromCharCode(bytes[i]));
	            }return str.join('');
	          }
	        }
	      };
	
	      module.exports = charenc;
	    }, {}], 3: [function (require, module, exports) {
	      (function () {
	        var base64map = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/',
	            crypt = {
	          // Bit-wise rotation left
	          rotl: function rotl(n, b) {
	            return n << b | n >>> 32 - b;
	          },
	
	          // Bit-wise rotation right
	          rotr: function rotr(n, b) {
	            return n << 32 - b | n >>> b;
	          },
	
	          // Swap big-endian to little-endian and vice versa
	          endian: function endian(n) {
	            // If number given, swap endian
	            if (n.constructor == Number) {
	              return crypt.rotl(n, 8) & 0x00FF00FF | crypt.rotl(n, 24) & 0xFF00FF00;
	            }
	
	            // Else, assume array and swap all items
	            for (var i = 0; i < n.length; i++) {
	              n[i] = crypt.endian(n[i]);
	            }return n;
	          },
	
	          // Generate an array of any length of random bytes
	          randomBytes: function randomBytes(n) {
	            for (var bytes = []; n > 0; n--) {
	              bytes.push(Math.floor(Math.random() * 256));
	            }return bytes;
	          },
	
	          // Convert a byte array to big-endian 32-bit words
	          bytesToWords: function bytesToWords(bytes) {
	            for (var words = [], i = 0, b = 0; i < bytes.length; i++, b += 8) {
	              words[b >>> 5] |= bytes[i] << 24 - b % 32;
	            }return words;
	          },
	
	          // Convert big-endian 32-bit words to a byte array
	          wordsToBytes: function wordsToBytes(words) {
	            for (var bytes = [], b = 0; b < words.length * 32; b += 8) {
	              bytes.push(words[b >>> 5] >>> 24 - b % 32 & 0xFF);
	            }return bytes;
	          },
	
	          // Convert a byte array to a hex string
	          bytesToHex: function bytesToHex(bytes) {
	            for (var hex = [], i = 0; i < bytes.length; i++) {
	              hex.push((bytes[i] >>> 4).toString(16));
	              hex.push((bytes[i] & 0xF).toString(16));
	            }
	            return hex.join('');
	          },
	
	          // Convert a hex string to a byte array
	          hexToBytes: function hexToBytes(hex) {
	            for (var bytes = [], c = 0; c < hex.length; c += 2) {
	              bytes.push(parseInt(hex.substr(c, 2), 16));
	            }return bytes;
	          },
	
	          // Convert a byte array to a base-64 string
	          bytesToBase64: function bytesToBase64(bytes) {
	            for (var base64 = [], i = 0; i < bytes.length; i += 3) {
	              var triplet = bytes[i] << 16 | bytes[i + 1] << 8 | bytes[i + 2];
	              for (var j = 0; j < 4; j++) {
	                if (i * 8 + j * 6 <= bytes.length * 8) base64.push(base64map.charAt(triplet >>> 6 * (3 - j) & 0x3F));else base64.push('=');
	              }
	            }
	            return base64.join('');
	          },
	
	          // Convert a base-64 string to a byte array
	          base64ToBytes: function base64ToBytes(base64) {
	            // Remove non-base-64 characters
	            base64 = base64.replace(/[^A-Z0-9+\/]/ig, '');
	
	            for (var bytes = [], i = 0, imod4 = 0; i < base64.length; imod4 = ++i % 4) {
	              if (imod4 == 0) continue;
	              bytes.push((base64map.indexOf(base64.charAt(i - 1)) & Math.pow(2, -2 * imod4 + 8) - 1) << imod4 * 2 | base64map.indexOf(base64.charAt(i)) >>> 6 - imod4 * 2);
	            }
	            return bytes;
	          }
	        };
	
	        module.exports = crypt;
	      })();
	    }, {}], 4: [function (require, module, exports) {
	
	      /**
	       * This is the web browser implementation of `debug()`.
	       *
	       * Expose `debug()` as the module.
	       */
	
	      exports = module.exports = require('./debug');
	      exports.log = log;
	      exports.formatArgs = formatArgs;
	      exports.save = save;
	      exports.load = load;
	      exports.useColors = useColors;
	      exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
	
	      /**
	       * Colors.
	       */
	
	      exports.colors = ['lightseagreen', 'forestgreen', 'goldenrod', 'dodgerblue', 'darkorchid', 'crimson'];
	
	      /**
	       * Currently only WebKit-based Web Inspectors, Firefox >= v31,
	       * and the Firebug extension (any Firefox version) are known
	       * to support "%c" CSS customizations.
	       *
	       * TODO: add a `localStorage` variable to explicitly enable/disable colors
	       */
	
	      function useColors() {
	        // is webkit? http://stackoverflow.com/a/16459606/376773
	        return 'WebkitAppearance' in document.documentElement.style ||
	        // is firebug? http://stackoverflow.com/a/398120/376773
	        window.console && (console.firebug || console.exception && console.table) ||
	        // is firefox >= v31?
	        // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
	        navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31;
	      }
	
	      /**
	       * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
	       */
	
	      exports.formatters.j = function (v) {
	        return JSON.stringify(v);
	      };
	
	      /**
	       * Colorize log arguments if enabled.
	       *
	       * @api public
	       */
	
	      function formatArgs() {
	        var args = arguments;
	        var useColors = this.useColors;
	
	        args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
	
	        if (!useColors) return args;
	
	        var c = 'color: ' + this.color;
	        args = [args[0], c, 'color: inherit'].concat(Array.prototype.slice.call(args, 1));
	
	        // the final "%c" is somewhat tricky, because there could be other
	        // arguments passed either before or after the %c, so we need to
	        // figure out the correct index to insert the CSS into
	        var index = 0;
	        var lastC = 0;
	        args[0].replace(/%[a-z%]/g, function (match) {
	          if ('%%' === match) return;
	          index++;
	          if ('%c' === match) {
	            // we only are interested in the *last* %c
	            // (the user may have provided their own)
	            lastC = index;
	          }
	        });
	
	        args.splice(lastC, 0, c);
	        return args;
	      }
	
	      /**
	       * Invokes `console.log()` when available.
	       * No-op when `console.log` is not a "function".
	       *
	       * @api public
	       */
	
	      function log() {
	        // this hackery is required for IE8/9, where
	        // the `console.log` function doesn't have 'apply'
	        return 'object' === (typeof console === "undefined" ? "undefined" : _typeof(console)) && console.log && Function.prototype.apply.call(console.log, console, arguments);
	      }
	
	      /**
	       * Save `namespaces`.
	       *
	       * @param {String} namespaces
	       * @api private
	       */
	
	      function save(namespaces) {
	        try {
	          if (null == namespaces) {
	            exports.storage.removeItem('debug');
	          } else {
	            exports.storage.debug = namespaces;
	          }
	        } catch (e) {}
	      }
	
	      /**
	       * Load `namespaces`.
	       *
	       * @return {String} returns the previously persisted debug modes
	       * @api private
	       */
	
	      function load() {
	        var r;
	        try {
	          r = exports.storage.debug;
	        } catch (e) {}
	        return r;
	      }
	
	      /**
	       * Enable namespaces listed in `localStorage.debug` initially.
	       */
	
	      exports.enable(load());
	
	      /**
	       * Localstorage attempts to return the localstorage.
	       *
	       * This is necessary because safari throws
	       * when a user disables cookies/localstorage
	       * and you attempt to access it.
	       *
	       * @return {LocalStorage}
	       * @api private
	       */
	
	      function localstorage() {
	        try {
	          return window.localStorage;
	        } catch (e) {}
	      }
	    }, { "./debug": 5 }], 5: [function (require, module, exports) {
	
	      /**
	       * This is the common logic for both the Node.js and web browser
	       * implementations of `debug()`.
	       *
	       * Expose `debug()` as the module.
	       */
	
	      exports = module.exports = debug;
	      exports.coerce = coerce;
	      exports.disable = disable;
	      exports.enable = enable;
	      exports.enabled = enabled;
	      exports.humanize = require('ms');
	
	      /**
	       * The currently active debug mode names, and names to skip.
	       */
	
	      exports.names = [];
	      exports.skips = [];
	
	      /**
	       * Map of special "%n" handling functions, for the debug "format" argument.
	       *
	       * Valid key names are a single, lowercased letter, i.e. "n".
	       */
	
	      exports.formatters = {};
	
	      /**
	       * Previously assigned color.
	       */
	
	      var prevColor = 0;
	
	      /**
	       * Previous log timestamp.
	       */
	
	      var prevTime;
	
	      /**
	       * Select a color.
	       *
	       * @return {Number}
	       * @api private
	       */
	
	      function selectColor() {
	        return exports.colors[prevColor++ % exports.colors.length];
	      }
	
	      /**
	       * Create a debugger with the given `namespace`.
	       *
	       * @param {String} namespace
	       * @return {Function}
	       * @api public
	       */
	
	      function debug(namespace) {
	
	        // define the `disabled` version
	        function disabled() {}
	        disabled.enabled = false;
	
	        // define the `enabled` version
	        function enabled() {
	
	          var self = enabled;
	
	          // set `diff` timestamp
	          var curr = +new Date();
	          var ms = curr - (prevTime || curr);
	          self.diff = ms;
	          self.prev = prevTime;
	          self.curr = curr;
	          prevTime = curr;
	
	          // add the `color` if not set
	          if (null == self.useColors) self.useColors = exports.useColors();
	          if (null == self.color && self.useColors) self.color = selectColor();
	
	          var args = Array.prototype.slice.call(arguments);
	
	          args[0] = exports.coerce(args[0]);
	
	          if ('string' !== typeof args[0]) {
	            // anything else let's inspect with %o
	            args = ['%o'].concat(args);
	          }
	
	          // apply any `formatters` transformations
	          var index = 0;
	          args[0] = args[0].replace(/%([a-z%])/g, function (match, format) {
	            // if we encounter an escaped % then don't increase the array index
	            if (match === '%%') return match;
	            index++;
	            var formatter = exports.formatters[format];
	            if ('function' === typeof formatter) {
	              var val = args[index];
	              match = formatter.call(self, val);
	
	              // now we need to remove `args[index]` since it's inlined in the `format`
	              args.splice(index, 1);
	              index--;
	            }
	            return match;
	          });
	
	          if ('function' === typeof exports.formatArgs) {
	            args = exports.formatArgs.apply(self, args);
	          }
	          var logFn = enabled.log || exports.log || console.log.bind(console);
	          logFn.apply(self, args);
	        }
	        enabled.enabled = true;
	
	        var fn = exports.enabled(namespace) ? enabled : disabled;
	
	        fn.namespace = namespace;
	
	        return fn;
	      }
	
	      /**
	       * Enables a debug mode by namespaces. This can include modes
	       * separated by a colon and wildcards.
	       *
	       * @param {String} namespaces
	       * @api public
	       */
	
	      function enable(namespaces) {
	        exports.save(namespaces);
	
	        var split = (namespaces || '').split(/[\s,]+/);
	        var len = split.length;
	
	        for (var i = 0; i < len; i++) {
	          if (!split[i]) continue; // ignore empty strings
	          namespaces = split[i].replace(/\*/g, '.*?');
	          if (namespaces[0] === '-') {
	            exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
	          } else {
	            exports.names.push(new RegExp('^' + namespaces + '$'));
	          }
	        }
	      }
	
	      /**
	       * Disable debug output.
	       *
	       * @api public
	       */
	
	      function disable() {
	        exports.enable('');
	      }
	
	      /**
	       * Returns true if the given mode name is enabled, false otherwise.
	       *
	       * @param {String} name
	       * @return {Boolean}
	       * @api public
	       */
	
	      function enabled(name) {
	        var i, len;
	        for (i = 0, len = exports.skips.length; i < len; i++) {
	          if (exports.skips[i].test(name)) {
	            return false;
	          }
	        }
	        for (i = 0, len = exports.names.length; i < len; i++) {
	          if (exports.names[i].test(name)) {
	            return true;
	          }
	        }
	        return false;
	      }
	
	      /**
	       * Coerce `val`.
	       *
	       * @param {Mixed} val
	       * @return {Mixed}
	       * @api private
	       */
	
	      function coerce(val) {
	        if (val instanceof Error) return val.stack || val.message;
	        return val;
	      }
	    }, { "ms": 9 }], 6: [function (require, module, exports) {
	      /**
	       * Determine if an object is Buffer
	       *
	       * Author:   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	       * License:  MIT
	       *
	       * `npm install is-buffer`
	       */
	
	      module.exports = function (obj) {
	        return !!(obj != null && (obj._isBuffer || // For Safari 5-7 (missing Object.prototype.constructor)
	        obj.constructor && typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)));
	      };
	    }, {}], 7: [function (require, module, exports) {
	      (function (root) {
	        var localStorageMemory = {};
	        var cache = {};
	
	        /**
	         * number of stored items.
	         */
	        localStorageMemory.length = 0;
	
	        /**
	         * returns item for passed key, or null
	         *
	         * @para {String} key
	         *       name of item to be returned
	         * @returns {String|null}
	         */
	        localStorageMemory.getItem = function (key) {
	          return cache[key] || null;
	        };
	
	        /**
	         * sets item for key to passed value, as String
	         *
	         * @para {String} key
	         *       name of item to be set
	         * @para {String} value
	         *       value, will always be turned into a String
	         * @returns {undefined}
	         */
	        localStorageMemory.setItem = function (key, value) {
	          if (typeof value === 'undefined') {
	            localStorageMemory.removeItem(key);
	          } else {
	            if (!cache.hasOwnProperty(key)) {
	              localStorageMemory.length++;
	            }
	
	            cache[key] = '' + value;
	          }
	        };
	
	        /**
	         * removes item for passed key
	         *
	         * @para {String} key
	         *       name of item to be removed
	         * @returns {undefined}
	         */
	        localStorageMemory.removeItem = function (key) {
	          if (cache.hasOwnProperty(key)) {
	            delete cache[key];
	            localStorageMemory.length--;
	          }
	        };
	
	        /**
	         * returns name of key at passed index
	         *
	         * @para {Number} index
	         *       Position for key to be returned (starts at 0)
	         * @returns {String|null}
	         */
	        localStorageMemory.key = function (index) {
	          return Object.keys(cache)[index] || null;
	        };
	
	        /**
	         * removes all stored items and sets length to 0
	         *
	         * @returns {undefined}
	         */
	        localStorageMemory.clear = function () {
	          cache = {};
	          localStorageMemory.length = 0;
	        };
	
	        if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
	          module.exports = localStorageMemory;
	        } else {
	          root.localStorageMemory = localStorageMemory;
	        }
	      })(this);
	    }, {}], 8: [function (require, module, exports) {
	      (function () {
	        var crypt = require('crypt'),
	            utf8 = require('charenc').utf8,
	            isBuffer = require('is-buffer'),
	            bin = require('charenc').bin,
	
	
	        // The core
	        md5 = function md5(message, options) {
	          // Convert to byte array
	          if (message.constructor == String) {
	            if (options && options.encoding === 'binary') message = bin.stringToBytes(message);else message = utf8.stringToBytes(message);
	          } else if (isBuffer(message)) message = Array.prototype.slice.call(message, 0);else if (!Array.isArray(message)) message = message.toString();
	          // else, assume byte array already
	
	          var m = crypt.bytesToWords(message),
	              l = message.length * 8,
	              a = 1732584193,
	              b = -271733879,
	              c = -1732584194,
	              d = 271733878;
	
	          // Swap endian
	          for (var i = 0; i < m.length; i++) {
	            m[i] = (m[i] << 8 | m[i] >>> 24) & 0x00FF00FF | (m[i] << 24 | m[i] >>> 8) & 0xFF00FF00;
	          }
	
	          // Padding
	          m[l >>> 5] |= 0x80 << l % 32;
	          m[(l + 64 >>> 9 << 4) + 14] = l;
	
	          // Method shortcuts
	          var FF = md5._ff,
	              GG = md5._gg,
	              HH = md5._hh,
	              II = md5._ii;
	
	          for (var i = 0; i < m.length; i += 16) {
	
	            var aa = a,
	                bb = b,
	                cc = c,
	                dd = d;
	
	            a = FF(a, b, c, d, m[i + 0], 7, -680876936);
	            d = FF(d, a, b, c, m[i + 1], 12, -389564586);
	            c = FF(c, d, a, b, m[i + 2], 17, 606105819);
	            b = FF(b, c, d, a, m[i + 3], 22, -1044525330);
	            a = FF(a, b, c, d, m[i + 4], 7, -176418897);
	            d = FF(d, a, b, c, m[i + 5], 12, 1200080426);
	            c = FF(c, d, a, b, m[i + 6], 17, -1473231341);
	            b = FF(b, c, d, a, m[i + 7], 22, -45705983);
	            a = FF(a, b, c, d, m[i + 8], 7, 1770035416);
	            d = FF(d, a, b, c, m[i + 9], 12, -1958414417);
	            c = FF(c, d, a, b, m[i + 10], 17, -42063);
	            b = FF(b, c, d, a, m[i + 11], 22, -1990404162);
	            a = FF(a, b, c, d, m[i + 12], 7, 1804603682);
	            d = FF(d, a, b, c, m[i + 13], 12, -40341101);
	            c = FF(c, d, a, b, m[i + 14], 17, -1502002290);
	            b = FF(b, c, d, a, m[i + 15], 22, 1236535329);
	
	            a = GG(a, b, c, d, m[i + 1], 5, -165796510);
	            d = GG(d, a, b, c, m[i + 6], 9, -1069501632);
	            c = GG(c, d, a, b, m[i + 11], 14, 643717713);
	            b = GG(b, c, d, a, m[i + 0], 20, -373897302);
	            a = GG(a, b, c, d, m[i + 5], 5, -701558691);
	            d = GG(d, a, b, c, m[i + 10], 9, 38016083);
	            c = GG(c, d, a, b, m[i + 15], 14, -660478335);
	            b = GG(b, c, d, a, m[i + 4], 20, -405537848);
	            a = GG(a, b, c, d, m[i + 9], 5, 568446438);
	            d = GG(d, a, b, c, m[i + 14], 9, -1019803690);
	            c = GG(c, d, a, b, m[i + 3], 14, -187363961);
	            b = GG(b, c, d, a, m[i + 8], 20, 1163531501);
	            a = GG(a, b, c, d, m[i + 13], 5, -1444681467);
	            d = GG(d, a, b, c, m[i + 2], 9, -51403784);
	            c = GG(c, d, a, b, m[i + 7], 14, 1735328473);
	            b = GG(b, c, d, a, m[i + 12], 20, -1926607734);
	
	            a = HH(a, b, c, d, m[i + 5], 4, -378558);
	            d = HH(d, a, b, c, m[i + 8], 11, -2022574463);
	            c = HH(c, d, a, b, m[i + 11], 16, 1839030562);
	            b = HH(b, c, d, a, m[i + 14], 23, -35309556);
	            a = HH(a, b, c, d, m[i + 1], 4, -1530992060);
	            d = HH(d, a, b, c, m[i + 4], 11, 1272893353);
	            c = HH(c, d, a, b, m[i + 7], 16, -155497632);
	            b = HH(b, c, d, a, m[i + 10], 23, -1094730640);
	            a = HH(a, b, c, d, m[i + 13], 4, 681279174);
	            d = HH(d, a, b, c, m[i + 0], 11, -358537222);
	            c = HH(c, d, a, b, m[i + 3], 16, -722521979);
	            b = HH(b, c, d, a, m[i + 6], 23, 76029189);
	            a = HH(a, b, c, d, m[i + 9], 4, -640364487);
	            d = HH(d, a, b, c, m[i + 12], 11, -421815835);
	            c = HH(c, d, a, b, m[i + 15], 16, 530742520);
	            b = HH(b, c, d, a, m[i + 2], 23, -995338651);
	
	            a = II(a, b, c, d, m[i + 0], 6, -198630844);
	            d = II(d, a, b, c, m[i + 7], 10, 1126891415);
	            c = II(c, d, a, b, m[i + 14], 15, -1416354905);
	            b = II(b, c, d, a, m[i + 5], 21, -57434055);
	            a = II(a, b, c, d, m[i + 12], 6, 1700485571);
	            d = II(d, a, b, c, m[i + 3], 10, -1894986606);
	            c = II(c, d, a, b, m[i + 10], 15, -1051523);
	            b = II(b, c, d, a, m[i + 1], 21, -2054922799);
	            a = II(a, b, c, d, m[i + 8], 6, 1873313359);
	            d = II(d, a, b, c, m[i + 15], 10, -30611744);
	            c = II(c, d, a, b, m[i + 6], 15, -1560198380);
	            b = II(b, c, d, a, m[i + 13], 21, 1309151649);
	            a = II(a, b, c, d, m[i + 4], 6, -145523070);
	            d = II(d, a, b, c, m[i + 11], 10, -1120210379);
	            c = II(c, d, a, b, m[i + 2], 15, 718787259);
	            b = II(b, c, d, a, m[i + 9], 21, -343485551);
	
	            a = a + aa >>> 0;
	            b = b + bb >>> 0;
	            c = c + cc >>> 0;
	            d = d + dd >>> 0;
	          }
	
	          return crypt.endian([a, b, c, d]);
	        };
	
	        // Auxiliary functions
	        md5._ff = function (a, b, c, d, x, s, t) {
	          var n = a + (b & c | ~b & d) + (x >>> 0) + t;
	          return (n << s | n >>> 32 - s) + b;
	        };
	        md5._gg = function (a, b, c, d, x, s, t) {
	          var n = a + (b & d | c & ~d) + (x >>> 0) + t;
	          return (n << s | n >>> 32 - s) + b;
	        };
	        md5._hh = function (a, b, c, d, x, s, t) {
	          var n = a + (b ^ c ^ d) + (x >>> 0) + t;
	          return (n << s | n >>> 32 - s) + b;
	        };
	        md5._ii = function (a, b, c, d, x, s, t) {
	          var n = a + (c ^ (b | ~d)) + (x >>> 0) + t;
	          return (n << s | n >>> 32 - s) + b;
	        };
	
	        // Package private blocksize
	        md5._blocksize = 16;
	        md5._digestsize = 16;
	
	        module.exports = function (message, options) {
	          if (typeof message == 'undefined') return;
	
	          var digestbytes = crypt.wordsToBytes(md5(message, options));
	          return options && options.asBytes ? digestbytes : options && options.asString ? bin.bytesToString(digestbytes) : crypt.bytesToHex(digestbytes);
	        };
	      })();
	    }, { "charenc": 2, "crypt": 3, "is-buffer": 6 }], 9: [function (require, module, exports) {
	      /**
	       * Helpers.
	       */
	
	      var s = 1000;
	      var m = s * 60;
	      var h = m * 60;
	      var d = h * 24;
	      var y = d * 365.25;
	
	      /**
	       * Parse or format the given `val`.
	       *
	       * Options:
	       *
	       *  - `long` verbose formatting [false]
	       *
	       * @param {String|Number} val
	       * @param {Object} options
	       * @return {String|Number}
	       * @api public
	       */
	
	      module.exports = function (val, options) {
	        options = options || {};
	        if ('string' == typeof val) return parse(val);
	        return options.long ? long(val) : short(val);
	      };
	
	      /**
	       * Parse the given `str` and return milliseconds.
	       *
	       * @param {String} str
	       * @return {Number}
	       * @api private
	       */
	
	      function parse(str) {
	        str = '' + str;
	        if (str.length > 10000) return;
	        var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
	        if (!match) return;
	        var n = parseFloat(match[1]);
	        var type = (match[2] || 'ms').toLowerCase();
	        switch (type) {
	          case 'years':
	          case 'year':
	          case 'yrs':
	          case 'yr':
	          case 'y':
	            return n * y;
	          case 'days':
	          case 'day':
	          case 'd':
	            return n * d;
	          case 'hours':
	          case 'hour':
	          case 'hrs':
	          case 'hr':
	          case 'h':
	            return n * h;
	          case 'minutes':
	          case 'minute':
	          case 'mins':
	          case 'min':
	          case 'm':
	            return n * m;
	          case 'seconds':
	          case 'second':
	          case 'secs':
	          case 'sec':
	          case 's':
	            return n * s;
	          case 'milliseconds':
	          case 'millisecond':
	          case 'msecs':
	          case 'msec':
	          case 'ms':
	            return n;
	        }
	      }
	
	      /**
	       * Short format for `ms`.
	       *
	       * @param {Number} ms
	       * @return {String}
	       * @api private
	       */
	
	      function short(ms) {
	        if (ms >= d) return Math.round(ms / d) + 'd';
	        if (ms >= h) return Math.round(ms / h) + 'h';
	        if (ms >= m) return Math.round(ms / m) + 'm';
	        if (ms >= s) return Math.round(ms / s) + 's';
	        return ms + 'ms';
	      }
	
	      /**
	       * Long format for `ms`.
	       *
	       * @param {Number} ms
	       * @return {String}
	       * @api private
	       */
	
	      function long(ms) {
	        return plural(ms, d, 'day') || plural(ms, h, 'hour') || plural(ms, m, 'minute') || plural(ms, s, 'second') || ms + ' ms';
	      }
	
	      /**
	       * Pluralization helper.
	       */
	
	      function plural(ms, n, name) {
	        if (ms < n) return;
	        if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
	        return Math.ceil(ms / n) + ' ' + name + 's';
	      }
	    }, {}], 10: [function (require, module, exports) {
	      // shim for using process in browser
	
	      var process = module.exports = {};
	      var queue = [];
	      var draining = false;
	      var currentQueue;
	      var queueIndex = -1;
	
	      function cleanUpNextTick() {
	        if (!draining || !currentQueue) {
	          return;
	        }
	        draining = false;
	        if (currentQueue.length) {
	          queue = currentQueue.concat(queue);
	        } else {
	          queueIndex = -1;
	        }
	        if (queue.length) {
	          drainQueue();
	        }
	      }
	
	      function drainQueue() {
	        if (draining) {
	          return;
	        }
	        var timeout = setTimeout(cleanUpNextTick);
	        draining = true;
	
	        var len = queue.length;
	        while (len) {
	          currentQueue = queue;
	          queue = [];
	          while (++queueIndex < len) {
	            if (currentQueue) {
	              currentQueue[queueIndex].run();
	            }
	          }
	          queueIndex = -1;
	          len = queue.length;
	        }
	        currentQueue = null;
	        draining = false;
	        clearTimeout(timeout);
	      }
	
	      process.nextTick = function (fun) {
	        var args = new Array(arguments.length - 1);
	        if (arguments.length > 1) {
	          for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	          }
	        }
	        queue.push(new Item(fun, args));
	        if (queue.length === 1 && !draining) {
	          setTimeout(drainQueue, 0);
	        }
	      };
	
	      // v8 likes predictible objects
	      function Item(fun, array) {
	        this.fun = fun;
	        this.array = array;
	      }
	      Item.prototype.run = function () {
	        this.fun.apply(null, this.array);
	      };
	      process.title = 'browser';
	      process.browser = true;
	      process.env = {};
	      process.argv = [];
	      process.version = ''; // empty string to avoid regexp issues
	      process.versions = {};
	
	      function noop() {}
	
	      process.on = noop;
	      process.addListener = noop;
	      process.once = noop;
	      process.off = noop;
	      process.removeListener = noop;
	      process.removeAllListeners = noop;
	      process.emit = noop;
	
	      process.binding = function (name) {
	        throw new Error('process.binding is not supported');
	      };
	
	      process.cwd = function () {
	        return '/';
	      };
	      process.chdir = function (dir) {
	        throw new Error('process.chdir is not supported');
	      };
	      process.umask = function () {
	        return 0;
	      };
	    }, {}], 11: [function (require, module, exports) {
	
	      /**
	       * Reduce `arr` with `fn`.
	       *
	       * @param {Array} arr
	       * @param {Function} fn
	       * @param {Mixed} initial
	       *
	       * TODO: combatible error handling?
	       */
	
	      module.exports = function (arr, fn, initial) {
	        var idx = 0;
	        var len = arr.length;
	        var curr = arguments.length == 3 ? initial : arr[idx++];
	
	        while (idx < len) {
	          curr = fn.call(null, curr, arr[idx], ++idx, arr);
	        }
	
	        return curr;
	      };
	    }, {}], 12: [function (require, module, exports) {
	      /**
	       * Module dependencies.
	       */
	
	      var Emitter = require('emitter');
	      var reduce = require('reduce');
	      var requestBase = require('./request-base');
	      var isObject = require('./is-object');
	
	      /**
	       * Root reference for iframes.
	       */
	
	      var root;
	      if (typeof window !== 'undefined') {
	        // Browser window
	        root = window;
	      } else if (typeof self !== 'undefined') {
	        // Web Worker
	        root = self;
	      } else {
	        // Other environments
	        root = this;
	      }
	
	      /**
	       * Noop.
	       */
	
	      function noop() {};
	
	      /**
	       * Expose `request`.
	       */
	
	      var request = module.exports = require('./request').bind(null, Request);
	
	      /**
	       * Determine XHR.
	       */
	
	      request.getXHR = function () {
	        if (root.XMLHttpRequest && (!root.location || 'file:' != root.location.protocol || !root.ActiveXObject)) {
	          return new XMLHttpRequest();
	        } else {
	          try {
	            return new ActiveXObject('Microsoft.XMLHTTP');
	          } catch (e) {}
	          try {
	            return new ActiveXObject('Msxml2.XMLHTTP.6.0');
	          } catch (e) {}
	          try {
	            return new ActiveXObject('Msxml2.XMLHTTP.3.0');
	          } catch (e) {}
	          try {
	            return new ActiveXObject('Msxml2.XMLHTTP');
	          } catch (e) {}
	        }
	        return false;
	      };
	
	      /**
	       * Removes leading and trailing whitespace, added to support IE.
	       *
	       * @param {String} s
	       * @return {String}
	       * @api private
	       */
	
	      var trim = ''.trim ? function (s) {
	        return s.trim();
	      } : function (s) {
	        return s.replace(/(^\s*|\s*$)/g, '');
	      };
	
	      /**
	       * Serialize the given `obj`.
	       *
	       * @param {Object} obj
	       * @return {String}
	       * @api private
	       */
	
	      function serialize(obj) {
	        if (!isObject(obj)) return obj;
	        var pairs = [];
	        for (var key in obj) {
	          if (null != obj[key]) {
	            pushEncodedKeyValuePair(pairs, key, obj[key]);
	          }
	        }
	        return pairs.join('&');
	      }
	
	      /**
	       * Helps 'serialize' with serializing arrays.
	       * Mutates the pairs array.
	       *
	       * @param {Array} pairs
	       * @param {String} key
	       * @param {Mixed} val
	       */
	
	      function pushEncodedKeyValuePair(pairs, key, val) {
	        if (Array.isArray(val)) {
	          return val.forEach(function (v) {
	            pushEncodedKeyValuePair(pairs, key, v);
	          });
	        } else if (isObject(val)) {
	          for (var subkey in val) {
	            pushEncodedKeyValuePair(pairs, key + '[' + subkey + ']', val[subkey]);
	          }
	          return;
	        }
	        pairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(val));
	      }
	
	      /**
	       * Expose serialization method.
	       */
	
	      request.serializeObject = serialize;
	
	      /**
	       * Parse the given x-www-form-urlencoded `str`.
	       *
	       * @param {String} str
	       * @return {Object}
	       * @api private
	       */
	
	      function parseString(str) {
	        var obj = {};
	        var pairs = str.split('&');
	        var pair;
	        var pos;
	
	        for (var i = 0, len = pairs.length; i < len; ++i) {
	          pair = pairs[i];
	          pos = pair.indexOf('=');
	          if (pos == -1) {
	            obj[decodeURIComponent(pair)] = '';
	          } else {
	            obj[decodeURIComponent(pair.slice(0, pos))] = decodeURIComponent(pair.slice(pos + 1));
	          }
	        }
	
	        return obj;
	      }
	
	      /**
	       * Expose parser.
	       */
	
	      request.parseString = parseString;
	
	      /**
	       * Default MIME type map.
	       *
	       *     superagent.types.xml = 'application/xml';
	       *
	       */
	
	      request.types = {
	        html: 'text/html',
	        json: 'application/json',
	        xml: 'application/xml',
	        urlencoded: 'application/x-www-form-urlencoded',
	        'form': 'application/x-www-form-urlencoded',
	        'form-data': 'application/x-www-form-urlencoded'
	      };
	
	      /**
	       * Default serialization map.
	       *
	       *     superagent.serialize['application/xml'] = function(obj){
	       *       return 'generated xml here';
	       *     };
	       *
	       */
	
	      request.serialize = {
	        'application/x-www-form-urlencoded': serialize,
	        'application/json': JSON.stringify
	      };
	
	      /**
	       * Default parsers.
	       *
	       *     superagent.parse['application/xml'] = function(str){
	       *       return { object parsed from str };
	       *     };
	       *
	       */
	
	      request.parse = {
	        'application/x-www-form-urlencoded': parseString,
	        'application/json': JSON.parse
	      };
	
	      /**
	       * Parse the given header `str` into
	       * an object containing the mapped fields.
	       *
	       * @param {String} str
	       * @return {Object}
	       * @api private
	       */
	
	      function parseHeader(str) {
	        var lines = str.split(/\r?\n/);
	        var fields = {};
	        var index;
	        var line;
	        var field;
	        var val;
	
	        lines.pop(); // trailing CRLF
	
	        for (var i = 0, len = lines.length; i < len; ++i) {
	          line = lines[i];
	          index = line.indexOf(':');
	          field = line.slice(0, index).toLowerCase();
	          val = trim(line.slice(index + 1));
	          fields[field] = val;
	        }
	
	        return fields;
	      }
	
	      /**
	       * Check if `mime` is json or has +json structured syntax suffix.
	       *
	       * @param {String} mime
	       * @return {Boolean}
	       * @api private
	       */
	
	      function isJSON(mime) {
	        return (/[\/+]json\b/.test(mime)
	        );
	      }
	
	      /**
	       * Return the mime type for the given `str`.
	       *
	       * @param {String} str
	       * @return {String}
	       * @api private
	       */
	
	      function type(str) {
	        return str.split(/ *; */).shift();
	      };
	
	      /**
	       * Return header field parameters.
	       *
	       * @param {String} str
	       * @return {Object}
	       * @api private
	       */
	
	      function params(str) {
	        return reduce(str.split(/ *; */), function (obj, str) {
	          var parts = str.split(/ *= */),
	              key = parts.shift(),
	              val = parts.shift();
	
	          if (key && val) obj[key] = val;
	          return obj;
	        }, {});
	      };
	
	      /**
	       * Initialize a new `Response` with the given `xhr`.
	       *
	       *  - set flags (.ok, .error, etc)
	       *  - parse header
	       *
	       * Examples:
	       *
	       *  Aliasing `superagent` as `request` is nice:
	       *
	       *      request = superagent;
	       *
	       *  We can use the promise-like API, or pass callbacks:
	       *
	       *      request.get('/').end(function(res){});
	       *      request.get('/', function(res){});
	       *
	       *  Sending data can be chained:
	       *
	       *      request
	       *        .post('/user')
	       *        .send({ name: 'tj' })
	       *        .end(function(res){});
	       *
	       *  Or passed to `.send()`:
	       *
	       *      request
	       *        .post('/user')
	       *        .send({ name: 'tj' }, function(res){});
	       *
	       *  Or passed to `.post()`:
	       *
	       *      request
	       *        .post('/user', { name: 'tj' })
	       *        .end(function(res){});
	       *
	       * Or further reduced to a single call for simple cases:
	       *
	       *      request
	       *        .post('/user', { name: 'tj' }, function(res){});
	       *
	       * @param {XMLHTTPRequest} xhr
	       * @param {Object} options
	       * @api private
	       */
	
	      function Response(req, options) {
	        options = options || {};
	        this.req = req;
	        this.xhr = this.req.xhr;
	        // responseText is accessible only if responseType is '' or 'text' and on older browsers
	        this.text = this.req.method != 'HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text') || typeof this.xhr.responseType === 'undefined' ? this.xhr.responseText : null;
	        this.statusText = this.req.xhr.statusText;
	        this._setStatusProperties(this.xhr.status);
	        this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	        // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	        // getResponseHeader still works. so we get content-type even if getting
	        // other headers fails.
	        this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	        this._setHeaderProperties(this.header);
	        this.body = this.req.method != 'HEAD' ? this._parseBody(this.text ? this.text : this.xhr.response) : null;
	      }
	
	      /**
	       * Get case-insensitive `field` value.
	       *
	       * @param {String} field
	       * @return {String}
	       * @api public
	       */
	
	      Response.prototype.get = function (field) {
	        return this.header[field.toLowerCase()];
	      };
	
	      /**
	       * Set header related properties:
	       *
	       *   - `.type` the content type without params
	       *
	       * A response of "Content-Type: text/plain; charset=utf-8"
	       * will provide you with a `.type` of "text/plain".
	       *
	       * @param {Object} header
	       * @api private
	       */
	
	      Response.prototype._setHeaderProperties = function (header) {
	        // content-type
	        var ct = this.header['content-type'] || '';
	        this.type = type(ct);
	
	        // params
	        var obj = params(ct);
	        for (var key in obj) {
	          this[key] = obj[key];
	        }
	      };
	
	      /**
	       * Parse the given body `str`.
	       *
	       * Used for auto-parsing of bodies. Parsers
	       * are defined on the `superagent.parse` object.
	       *
	       * @param {String} str
	       * @return {Mixed}
	       * @api private
	       */
	
	      Response.prototype._parseBody = function (str) {
	        var parse = request.parse[this.type];
	        if (!parse && isJSON(this.type)) {
	          parse = request.parse['application/json'];
	        }
	        return parse && str && (str.length || str instanceof Object) ? parse(str) : null;
	      };
	
	      /**
	       * Set flags such as `.ok` based on `status`.
	       *
	       * For example a 2xx response will give you a `.ok` of __true__
	       * whereas 5xx will be __false__ and `.error` will be __true__. The
	       * `.clientError` and `.serverError` are also available to be more
	       * specific, and `.statusType` is the class of error ranging from 1..5
	       * sometimes useful for mapping respond colors etc.
	       *
	       * "sugar" properties are also defined for common cases. Currently providing:
	       *
	       *   - .noContent
	       *   - .badRequest
	       *   - .unauthorized
	       *   - .notAcceptable
	       *   - .notFound
	       *
	       * @param {Number} status
	       * @api private
	       */
	
	      Response.prototype._setStatusProperties = function (status) {
	        // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	        if (status === 1223) {
	          status = 204;
	        }
	
	        var type = status / 100 | 0;
	
	        // status / class
	        this.status = this.statusCode = status;
	        this.statusType = type;
	
	        // basics
	        this.info = 1 == type;
	        this.ok = 2 == type;
	        this.clientError = 4 == type;
	        this.serverError = 5 == type;
	        this.error = 4 == type || 5 == type ? this.toError() : false;
	
	        // sugar
	        this.accepted = 202 == status;
	        this.noContent = 204 == status;
	        this.badRequest = 400 == status;
	        this.unauthorized = 401 == status;
	        this.notAcceptable = 406 == status;
	        this.notFound = 404 == status;
	        this.forbidden = 403 == status;
	      };
	
	      /**
	       * Return an `Error` representative of this response.
	       *
	       * @return {Error}
	       * @api public
	       */
	
	      Response.prototype.toError = function () {
	        var req = this.req;
	        var method = req.method;
	        var url = req.url;
	
	        var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	        var err = new Error(msg);
	        err.status = this.status;
	        err.method = method;
	        err.url = url;
	
	        return err;
	      };
	
	      /**
	       * Expose `Response`.
	       */
	
	      request.Response = Response;
	
	      /**
	       * Initialize a new `Request` with the given `method` and `url`.
	       *
	       * @param {String} method
	       * @param {String} url
	       * @api public
	       */
	
	      function Request(method, url) {
	        var self = this;
	        this._query = this._query || [];
	        this.method = method;
	        this.url = url;
	        this.header = {}; // preserves header name case
	        this._header = {}; // coerces header names to lowercase
	        this.on('end', function () {
	          var err = null;
	          var res = null;
	
	          try {
	            res = new Response(self);
	          } catch (e) {
	            err = new Error('Parser is unable to parse the response');
	            err.parse = true;
	            err.original = e;
	            // issue #675: return the raw response if the response parsing fails
	            err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	            // issue #876: return the http status code if the response parsing fails
	            err.statusCode = self.xhr && self.xhr.status ? self.xhr.status : null;
	            return self.callback(err);
	          }
	
	          self.emit('response', res);
	
	          if (err) {
	            return self.callback(err, res);
	          }
	
	          if (res.status >= 200 && res.status < 300) {
	            return self.callback(err, res);
	          }
	
	          var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	          new_err.original = err;
	          new_err.response = res;
	          new_err.status = res.status;
	
	          self.callback(new_err, res);
	        });
	      }
	
	      /**
	       * Mixin `Emitter` and `requestBase`.
	       */
	
	      Emitter(Request.prototype);
	      for (var key in requestBase) {
	        Request.prototype[key] = requestBase[key];
	      }
	
	      /**
	       * Set Content-Type to `type`, mapping values from `request.types`.
	       *
	       * Examples:
	       *
	       *      superagent.types.xml = 'application/xml';
	       *
	       *      request.post('/')
	       *        .type('xml')
	       *        .send(xmlstring)
	       *        .end(callback);
	       *
	       *      request.post('/')
	       *        .type('application/xml')
	       *        .send(xmlstring)
	       *        .end(callback);
	       *
	       * @param {String} type
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      Request.prototype.type = function (type) {
	        this.set('Content-Type', request.types[type] || type);
	        return this;
	      };
	
	      /**
	       * Set responseType to `val`. Presently valid responseTypes are 'blob' and
	       * 'arraybuffer'.
	       *
	       * Examples:
	       *
	       *      req.get('/')
	       *        .responseType('blob')
	       *        .end(callback);
	       *
	       * @param {String} val
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      Request.prototype.responseType = function (val) {
	        this._responseType = val;
	        return this;
	      };
	
	      /**
	       * Set Accept to `type`, mapping values from `request.types`.
	       *
	       * Examples:
	       *
	       *      superagent.types.json = 'application/json';
	       *
	       *      request.get('/agent')
	       *        .accept('json')
	       *        .end(callback);
	       *
	       *      request.get('/agent')
	       *        .accept('application/json')
	       *        .end(callback);
	       *
	       * @param {String} accept
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      Request.prototype.accept = function (type) {
	        this.set('Accept', request.types[type] || type);
	        return this;
	      };
	
	      /**
	       * Set Authorization field value with `user` and `pass`.
	       *
	       * @param {String} user
	       * @param {String} pass
	       * @param {Object} options with 'type' property 'auto' or 'basic' (default 'basic')
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      Request.prototype.auth = function (user, pass, options) {
	        if (!options) {
	          options = {
	            type: 'basic'
	          };
	        }
	
	        switch (options.type) {
	          case 'basic':
	            var str = btoa(user + ':' + pass);
	            this.set('Authorization', 'Basic ' + str);
	            break;
	
	          case 'auto':
	            this.username = user;
	            this.password = pass;
	            break;
	        }
	        return this;
	      };
	
	      /**
	      * Add query-string `val`.
	      *
	      * Examples:
	      *
	      *   request.get('/shoes')
	      *     .query('size=10')
	      *     .query({ color: 'blue' })
	      *
	      * @param {Object|String} val
	      * @return {Request} for chaining
	      * @api public
	      */
	
	      Request.prototype.query = function (val) {
	        if ('string' != typeof val) val = serialize(val);
	        if (val) this._query.push(val);
	        return this;
	      };
	
	      /**
	       * Queue the given `file` as an attachment to the specified `field`,
	       * with optional `filename`.
	       *
	       * ``` js
	       * request.post('/upload')
	       *   .attach('content', new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	       *   .end(callback);
	       * ```
	       *
	       * @param {String} field
	       * @param {Blob|File} file
	       * @param {String} filename
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      Request.prototype.attach = function (field, file, filename) {
	        this._getFormData().append(field, file, filename || file.name);
	        return this;
	      };
	
	      Request.prototype._getFormData = function () {
	        if (!this._formData) {
	          this._formData = new root.FormData();
	        }
	        return this._formData;
	      };
	
	      /**
	       * Invoke the callback with `err` and `res`
	       * and handle arity check.
	       *
	       * @param {Error} err
	       * @param {Response} res
	       * @api private
	       */
	
	      Request.prototype.callback = function (err, res) {
	        var fn = this._callback;
	        this.clearTimeout();
	        fn(err, res);
	      };
	
	      /**
	       * Invoke callback with x-domain error.
	       *
	       * @api private
	       */
	
	      Request.prototype.crossDomainError = function () {
	        var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	        err.crossDomain = true;
	
	        err.status = this.status;
	        err.method = this.method;
	        err.url = this.url;
	
	        this.callback(err);
	      };
	
	      /**
	       * Invoke callback with timeout error.
	       *
	       * @api private
	       */
	
	      Request.prototype._timeoutError = function () {
	        var timeout = this._timeout;
	        var err = new Error('timeout of ' + timeout + 'ms exceeded');
	        err.timeout = timeout;
	        this.callback(err);
	      };
	
	      /**
	       * Compose querystring to append to req.url
	       *
	       * @api private
	       */
	
	      Request.prototype._appendQueryString = function () {
	        var query = this._query.join('&');
	        if (query) {
	          this.url += ~this.url.indexOf('?') ? '&' + query : '?' + query;
	        }
	      };
	
	      /**
	       * Initiate request, invoking callback `fn(res)`
	       * with an instanceof `Response`.
	       *
	       * @param {Function} fn
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      Request.prototype.end = function (fn) {
	        var self = this;
	        var xhr = this.xhr = request.getXHR();
	        var timeout = this._timeout;
	        var data = this._formData || this._data;
	
	        // store callback
	        this._callback = fn || noop;
	
	        // state change
	        xhr.onreadystatechange = function () {
	          if (4 != xhr.readyState) return;
	
	          // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	          // result in the error "Could not complete the operation due to error c00c023f"
	          var status;
	          try {
	            status = xhr.status;
	          } catch (e) {
	            status = 0;
	          }
	
	          if (0 == status) {
	            if (self.timedout) return self._timeoutError();
	            if (self._aborted) return;
	            return self.crossDomainError();
	          }
	          self.emit('end');
	        };
	
	        // progress
	        var handleProgress = function handleProgress(e) {
	          if (e.total > 0) {
	            e.percent = e.loaded / e.total * 100;
	          }
	          e.direction = 'download';
	          self.emit('progress', e);
	        };
	        if (this.hasListeners('progress')) {
	          xhr.onprogress = handleProgress;
	        }
	        try {
	          if (xhr.upload && this.hasListeners('progress')) {
	            xhr.upload.onprogress = handleProgress;
	          }
	        } catch (e) {}
	        // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	        // Reported here:
	        // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	
	
	        // timeout
	        if (timeout && !this._timer) {
	          this._timer = setTimeout(function () {
	            self.timedout = true;
	            self.abort();
	          }, timeout);
	        }
	
	        // querystring
	        this._appendQueryString();
	
	        // initiate request
	        if (this.username && this.password) {
	          xhr.open(this.method, this.url, true, this.username, this.password);
	        } else {
	          xhr.open(this.method, this.url, true);
	        }
	
	        // CORS
	        if (this._withCredentials) xhr.withCredentials = true;
	
	        // body
	        if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !this._isHost(data)) {
	          // serialize stuff
	          var contentType = this._header['content-type'];
	          var serialize = this._serializer || request.serialize[contentType ? contentType.split(';')[0] : ''];
	          if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	          if (serialize) data = serialize(data);
	        }
	
	        // set header fields
	        for (var field in this.header) {
	          if (null == this.header[field]) continue;
	          xhr.setRequestHeader(field, this.header[field]);
	        }
	
	        if (this._responseType) {
	          xhr.responseType = this._responseType;
	        }
	
	        // send stuff
	        this.emit('request', this);
	
	        // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	        // We need null here if data is undefined
	        xhr.send(typeof data !== 'undefined' ? data : null);
	        return this;
	      };
	
	      /**
	       * Expose `Request`.
	       */
	
	      request.Request = Request;
	
	      /**
	       * GET `url` with optional callback `fn(res)`.
	       *
	       * @param {String} url
	       * @param {Mixed|Function} data or fn
	       * @param {Function} fn
	       * @return {Request}
	       * @api public
	       */
	
	      request.get = function (url, data, fn) {
	        var req = request('GET', url);
	        if ('function' == typeof data) fn = data, data = null;
	        if (data) req.query(data);
	        if (fn) req.end(fn);
	        return req;
	      };
	
	      /**
	       * HEAD `url` with optional callback `fn(res)`.
	       *
	       * @param {String} url
	       * @param {Mixed|Function} data or fn
	       * @param {Function} fn
	       * @return {Request}
	       * @api public
	       */
	
	      request.head = function (url, data, fn) {
	        var req = request('HEAD', url);
	        if ('function' == typeof data) fn = data, data = null;
	        if (data) req.send(data);
	        if (fn) req.end(fn);
	        return req;
	      };
	
	      /**
	       * OPTIONS query to `url` with optional callback `fn(res)`.
	       *
	       * @param {String} url
	       * @param {Mixed|Function} data or fn
	       * @param {Function} fn
	       * @return {Request}
	       * @api public
	       */
	
	      request.options = function (url, data, fn) {
	        var req = request('OPTIONS', url);
	        if ('function' == typeof data) fn = data, data = null;
	        if (data) req.send(data);
	        if (fn) req.end(fn);
	        return req;
	      };
	
	      /**
	       * DELETE `url` with optional callback `fn(res)`.
	       *
	       * @param {String} url
	       * @param {Function} fn
	       * @return {Request}
	       * @api public
	       */
	
	      function del(url, fn) {
	        var req = request('DELETE', url);
	        if (fn) req.end(fn);
	        return req;
	      };
	
	      request['del'] = del;
	      request['delete'] = del;
	
	      /**
	       * PATCH `url` with optional `data` and callback `fn(res)`.
	       *
	       * @param {String} url
	       * @param {Mixed} data
	       * @param {Function} fn
	       * @return {Request}
	       * @api public
	       */
	
	      request.patch = function (url, data, fn) {
	        var req = request('PATCH', url);
	        if ('function' == typeof data) fn = data, data = null;
	        if (data) req.send(data);
	        if (fn) req.end(fn);
	        return req;
	      };
	
	      /**
	       * POST `url` with optional `data` and callback `fn(res)`.
	       *
	       * @param {String} url
	       * @param {Mixed} data
	       * @param {Function} fn
	       * @return {Request}
	       * @api public
	       */
	
	      request.post = function (url, data, fn) {
	        var req = request('POST', url);
	        if ('function' == typeof data) fn = data, data = null;
	        if (data) req.send(data);
	        if (fn) req.end(fn);
	        return req;
	      };
	
	      /**
	       * PUT `url` with optional `data` and callback `fn(res)`.
	       *
	       * @param {String} url
	       * @param {Mixed|Function} data or fn
	       * @param {Function} fn
	       * @return {Request}
	       * @api public
	       */
	
	      request.put = function (url, data, fn) {
	        var req = request('PUT', url);
	        if ('function' == typeof data) fn = data, data = null;
	        if (data) req.send(data);
	        if (fn) req.end(fn);
	        return req;
	      };
	    }, { "./is-object": 13, "./request": 15, "./request-base": 14, "emitter": 16, "reduce": 11 }], 13: [function (require, module, exports) {
	      /**
	       * Check if `obj` is an object.
	       *
	       * @param {Object} obj
	       * @return {Boolean}
	       * @api private
	       */
	
	      function isObject(obj) {
	        return null !== obj && 'object' === (typeof obj === "undefined" ? "undefined" : _typeof(obj));
	      }
	
	      module.exports = isObject;
	    }, {}], 14: [function (require, module, exports) {
	      /**
	       * Module of mixed-in functions shared between node and client code
	       */
	      var isObject = require('./is-object');
	
	      /**
	       * Clear previous timeout.
	       *
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      exports.clearTimeout = function _clearTimeout() {
	        this._timeout = 0;
	        clearTimeout(this._timer);
	        return this;
	      };
	
	      /**
	       * Override default response body parser
	       *
	       * This function will be called to convert incoming data into request.body
	       *
	       * @param {Function}
	       * @api public
	       */
	
	      exports.parse = function parse(fn) {
	        this._parser = fn;
	        return this;
	      };
	
	      /**
	       * Override default request body serializer
	       *
	       * This function will be called to convert data set via .send or .attach into payload to send
	       *
	       * @param {Function}
	       * @api public
	       */
	
	      exports.serialize = function serialize(fn) {
	        this._serializer = fn;
	        return this;
	      };
	
	      /**
	       * Set timeout to `ms`.
	       *
	       * @param {Number} ms
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      exports.timeout = function timeout(ms) {
	        this._timeout = ms;
	        return this;
	      };
	
	      /**
	       * Promise support
	       *
	       * @param {Function} resolve
	       * @param {Function} reject
	       * @return {Request}
	       */
	
	      exports.then = function then(resolve, reject) {
	        if (!this._fullfilledPromise) {
	          var self = this;
	          this._fullfilledPromise = new Promise(function (innerResolve, innerReject) {
	            self.end(function (err, res) {
	              if (err) innerReject(err);else innerResolve(res);
	            });
	          });
	        }
	        return this._fullfilledPromise.then(resolve, reject);
	      };
	
	      /**
	       * Allow for extension
	       */
	
	      exports.use = function use(fn) {
	        fn(this);
	        return this;
	      };
	
	      /**
	       * Get request header `field`.
	       * Case-insensitive.
	       *
	       * @param {String} field
	       * @return {String}
	       * @api public
	       */
	
	      exports.get = function (field) {
	        return this._header[field.toLowerCase()];
	      };
	
	      /**
	       * Get case-insensitive header `field` value.
	       * This is a deprecated internal API. Use `.get(field)` instead.
	       *
	       * (getHeader is no longer used internally by the superagent code base)
	       *
	       * @param {String} field
	       * @return {String}
	       * @api private
	       * @deprecated
	       */
	
	      exports.getHeader = exports.get;
	
	      /**
	       * Set header `field` to `val`, or multiple fields with one object.
	       * Case-insensitive.
	       *
	       * Examples:
	       *
	       *      req.get('/')
	       *        .set('Accept', 'application/json')
	       *        .set('X-API-Key', 'foobar')
	       *        .end(callback);
	       *
	       *      req.get('/')
	       *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	       *        .end(callback);
	       *
	       * @param {String|Object} field
	       * @param {String} val
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      exports.set = function (field, val) {
	        if (isObject(field)) {
	          for (var key in field) {
	            this.set(key, field[key]);
	          }
	          return this;
	        }
	        this._header[field.toLowerCase()] = val;
	        this.header[field] = val;
	        return this;
	      };
	
	      /**
	       * Remove header `field`.
	       * Case-insensitive.
	       *
	       * Example:
	       *
	       *      req.get('/')
	       *        .unset('User-Agent')
	       *        .end(callback);
	       *
	       * @param {String} field
	       */
	      exports.unset = function (field) {
	        delete this._header[field.toLowerCase()];
	        delete this.header[field];
	        return this;
	      };
	
	      /**
	       * Write the field `name` and `val` for "multipart/form-data"
	       * request bodies.
	       *
	       * ``` js
	       * request.post('/upload')
	       *   .field('foo', 'bar')
	       *   .end(callback);
	       * ```
	       *
	       * @param {String} name
	       * @param {String|Blob|File|Buffer|fs.ReadStream} val
	       * @return {Request} for chaining
	       * @api public
	       */
	      exports.field = function (name, val) {
	        this._getFormData().append(name, val);
	        return this;
	      };
	
	      /**
	       * Abort the request, and clear potential timeout.
	       *
	       * @return {Request}
	       * @api public
	       */
	      exports.abort = function () {
	        if (this._aborted) {
	          return this;
	        }
	        this._aborted = true;
	        this.xhr && this.xhr.abort(); // browser
	        this.req && this.req.abort(); // node
	        this.clearTimeout();
	        this.emit('abort');
	        return this;
	      };
	
	      /**
	       * Enable transmission of cookies with x-domain requests.
	       *
	       * Note that for this to work the origin must not be
	       * using "Access-Control-Allow-Origin" with a wildcard,
	       * and also must set "Access-Control-Allow-Credentials"
	       * to "true".
	       *
	       * @api public
	       */
	
	      exports.withCredentials = function () {
	        // This is browser-only functionality. Node side is no-op.
	        this._withCredentials = true;
	        return this;
	      };
	
	      /**
	       * Set the max redirects to `n`. Does noting in browser XHR implementation.
	       *
	       * @param {Number} n
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      exports.redirects = function (n) {
	        this._maxRedirects = n;
	        return this;
	      };
	
	      /**
	       * Convert to a plain javascript object (not JSON string) of scalar properties.
	       * Note as this method is designed to return a useful non-this value,
	       * it cannot be chained.
	       *
	       * @return {Object} describing method, url, and data of this request
	       * @api public
	       */
	
	      exports.toJSON = function () {
	        return {
	          method: this.method,
	          url: this.url,
	          data: this._data
	        };
	      };
	
	      /**
	       * Check if `obj` is a host object,
	       * we don't want to serialize these :)
	       *
	       * TODO: future proof, move to compoent land
	       *
	       * @param {Object} obj
	       * @return {Boolean}
	       * @api private
	       */
	
	      exports._isHost = function _isHost(obj) {
	        var str = {}.toString.call(obj);
	
	        switch (str) {
	          case '[object File]':
	          case '[object Blob]':
	          case '[object FormData]':
	            return true;
	          default:
	            return false;
	        }
	      };
	
	      /**
	       * Send `data` as the request body, defaulting the `.type()` to "json" when
	       * an object is given.
	       *
	       * Examples:
	       *
	       *       // manual json
	       *       request.post('/user')
	       *         .type('json')
	       *         .send('{"name":"tj"}')
	       *         .end(callback)
	       *
	       *       // auto json
	       *       request.post('/user')
	       *         .send({ name: 'tj' })
	       *         .end(callback)
	       *
	       *       // manual x-www-form-urlencoded
	       *       request.post('/user')
	       *         .type('form')
	       *         .send('name=tj')
	       *         .end(callback)
	       *
	       *       // auto x-www-form-urlencoded
	       *       request.post('/user')
	       *         .type('form')
	       *         .send({ name: 'tj' })
	       *         .end(callback)
	       *
	       *       // defaults to x-www-form-urlencoded
	       *      request.post('/user')
	       *        .send('name=tobi')
	       *        .send('species=ferret')
	       *        .end(callback)
	       *
	       * @param {String|Object} data
	       * @return {Request} for chaining
	       * @api public
	       */
	
	      exports.send = function (data) {
	        var obj = isObject(data);
	        var type = this._header['content-type'];
	
	        // merge
	        if (obj && isObject(this._data)) {
	          for (var key in data) {
	            this._data[key] = data[key];
	          }
	        } else if ('string' == typeof data) {
	          // default to x-www-form-urlencoded
	          if (!type) this.type('form');
	          type = this._header['content-type'];
	          if ('application/x-www-form-urlencoded' == type) {
	            this._data = this._data ? this._data + '&' + data : data;
	          } else {
	            this._data = (this._data || '') + data;
	          }
	        } else {
	          this._data = data;
	        }
	
	        if (!obj || this._isHost(data)) return this;
	
	        // default to json
	        if (!type) this.type('json');
	        return this;
	      };
	    }, { "./is-object": 13 }], 15: [function (require, module, exports) {
	      // The node and browser modules expose versions of this with the
	      // appropriate constructor function bound as first argument
	      /**
	       * Issue a request:
	       *
	       * Examples:
	       *
	       *    request('GET', '/users').end(callback)
	       *    request('/users').end(callback)
	       *    request('/users', callback)
	       *
	       * @param {String} method
	       * @param {String|Function} url or callback
	       * @return {Request}
	       * @api public
	       */
	
	      function request(RequestConstructor, method, url) {
	        // callback
	        if ('function' == typeof url) {
	          return new RequestConstructor('GET', method).end(url);
	        }
	
	        // url first
	        if (2 == arguments.length) {
	          return new RequestConstructor('GET', method);
	        }
	
	        return new RequestConstructor(method, url);
	      }
	
	      module.exports = request;
	    }, {}], 16: [function (require, module, exports) {
	
	      /**
	       * Expose `Emitter`.
	       */
	
	      if (typeof module !== 'undefined') {
	        module.exports = Emitter;
	      }
	
	      /**
	       * Initialize a new `Emitter`.
	       *
	       * @api public
	       */
	
	      function Emitter(obj) {
	        if (obj) return mixin(obj);
	      };
	
	      /**
	       * Mixin the emitter properties.
	       *
	       * @param {Object} obj
	       * @return {Object}
	       * @api private
	       */
	
	      function mixin(obj) {
	        for (var key in Emitter.prototype) {
	          obj[key] = Emitter.prototype[key];
	        }
	        return obj;
	      }
	
	      /**
	       * Listen on the given `event` with `fn`.
	       *
	       * @param {String} event
	       * @param {Function} fn
	       * @return {Emitter}
	       * @api public
	       */
	
	      Emitter.prototype.on = Emitter.prototype.addEventListener = function (event, fn) {
	        this._callbacks = this._callbacks || {};
	        (this._callbacks['$' + event] = this._callbacks['$' + event] || []).push(fn);
	        return this;
	      };
	
	      /**
	       * Adds an `event` listener that will be invoked a single
	       * time then automatically removed.
	       *
	       * @param {String} event
	       * @param {Function} fn
	       * @return {Emitter}
	       * @api public
	       */
	
	      Emitter.prototype.once = function (event, fn) {
	        function on() {
	          this.off(event, on);
	          fn.apply(this, arguments);
	        }
	
	        on.fn = fn;
	        this.on(event, on);
	        return this;
	      };
	
	      /**
	       * Remove the given callback for `event` or all
	       * registered callbacks.
	       *
	       * @param {String} event
	       * @param {Function} fn
	       * @return {Emitter}
	       * @api public
	       */
	
	      Emitter.prototype.off = Emitter.prototype.removeListener = Emitter.prototype.removeAllListeners = Emitter.prototype.removeEventListener = function (event, fn) {
	        this._callbacks = this._callbacks || {};
	
	        // all
	        if (0 == arguments.length) {
	          this._callbacks = {};
	          return this;
	        }
	
	        // specific event
	        var callbacks = this._callbacks['$' + event];
	        if (!callbacks) return this;
	
	        // remove all handlers
	        if (1 == arguments.length) {
	          delete this._callbacks['$' + event];
	          return this;
	        }
	
	        // remove specific handler
	        var cb;
	        for (var i = 0; i < callbacks.length; i++) {
	          cb = callbacks[i];
	          if (cb === fn || cb.fn === fn) {
	            callbacks.splice(i, 1);
	            break;
	          }
	        }
	        return this;
	      };
	
	      /**
	       * Emit `event` with the given args.
	       *
	       * @param {String} event
	       * @param {Mixed} ...
	       * @return {Emitter}
	       */
	
	      Emitter.prototype.emit = function (event) {
	        this._callbacks = this._callbacks || {};
	        var args = [].slice.call(arguments, 1),
	            callbacks = this._callbacks['$' + event];
	
	        if (callbacks) {
	          callbacks = callbacks.slice(0);
	          for (var i = 0, len = callbacks.length; i < len; ++i) {
	            callbacks[i].apply(this, args);
	          }
	        }
	
	        return this;
	      };
	
	      /**
	       * Return array of callbacks for `event`.
	       *
	       * @param {String} event
	       * @return {Array}
	       * @api public
	       */
	
	      Emitter.prototype.listeners = function (event) {
	        this._callbacks = this._callbacks || {};
	        return this._callbacks['$' + event] || [];
	      };
	
	      /**
	       * Check if this emitter has `event` handlers.
	       *
	       * @param {String} event
	       * @return {Boolean}
	       * @api public
	       */
	
	      Emitter.prototype.hasListeners = function (event) {
	        return !!this.listeners(event).length;
	      };
	    }, {}], 17: [function (require, module, exports) {
	      //     Underscore.js 1.8.3
	      //     http://underscorejs.org
	      //     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	      //     Underscore may be freely distributed under the MIT license.
	
	      (function () {
	
	        // Baseline setup
	        // --------------
	
	        // Establish the root object, `window` in the browser, or `exports` on the server.
	        var root = this;
	
	        // Save the previous value of the `_` variable.
	        var previousUnderscore = root._;
	
	        // Save bytes in the minified (but not gzipped) version:
	        var ArrayProto = Array.prototype,
	            ObjProto = Object.prototype,
	            FuncProto = Function.prototype;
	
	        // Create quick reference variables for speed access to core prototypes.
	        var push = ArrayProto.push,
	            slice = ArrayProto.slice,
	            toString = ObjProto.toString,
	            hasOwnProperty = ObjProto.hasOwnProperty;
	
	        // All **ECMAScript 5** native function implementations that we hope to use
	        // are declared here.
	        var nativeIsArray = Array.isArray,
	            nativeKeys = Object.keys,
	            nativeBind = FuncProto.bind,
	            nativeCreate = Object.create;
	
	        // Naked function reference for surrogate-prototype-swapping.
	        var Ctor = function Ctor() {};
	
	        // Create a safe reference to the Underscore object for use below.
	        var _ = function _(obj) {
	          if (obj instanceof _) return obj;
	          if (!(this instanceof _)) return new _(obj);
	          this._wrapped = obj;
	        };
	
	        // Export the Underscore object for **Node.js**, with
	        // backwards-compatibility for the old `require()` API. If we're in
	        // the browser, add `_` as a global object.
	        if (typeof exports !== 'undefined') {
	          if (typeof module !== 'undefined' && module.exports) {
	            exports = module.exports = _;
	          }
	          exports._ = _;
	        } else {
	          root._ = _;
	        }
	
	        // Current version.
	        _.VERSION = '1.8.3';
	
	        // Internal function that returns an efficient (for current engines) version
	        // of the passed-in callback, to be repeatedly applied in other Underscore
	        // functions.
	        var optimizeCb = function optimizeCb(func, context, argCount) {
	          if (context === void 0) return func;
	          switch (argCount == null ? 3 : argCount) {
	            case 1:
	              return function (value) {
	                return func.call(context, value);
	              };
	            case 2:
	              return function (value, other) {
	                return func.call(context, value, other);
	              };
	            case 3:
	              return function (value, index, collection) {
	                return func.call(context, value, index, collection);
	              };
	            case 4:
	              return function (accumulator, value, index, collection) {
	                return func.call(context, accumulator, value, index, collection);
	              };
	          }
	          return function () {
	            return func.apply(context, arguments);
	          };
	        };
	
	        // A mostly-internal function to generate callbacks that can be applied
	        // to each element in a collection, returning the desired result — either
	        // identity, an arbitrary callback, a property matcher, or a property accessor.
	        var cb = function cb(value, context, argCount) {
	          if (value == null) return _.identity;
	          if (_.isFunction(value)) return optimizeCb(value, context, argCount);
	          if (_.isObject(value)) return _.matcher(value);
	          return _.property(value);
	        };
	        _.iteratee = function (value, context) {
	          return cb(value, context, Infinity);
	        };
	
	        // An internal function for creating assigner functions.
	        var createAssigner = function createAssigner(keysFunc, undefinedOnly) {
	          return function (obj) {
	            var length = arguments.length;
	            if (length < 2 || obj == null) return obj;
	            for (var index = 1; index < length; index++) {
	              var source = arguments[index],
	                  keys = keysFunc(source),
	                  l = keys.length;
	              for (var i = 0; i < l; i++) {
	                var key = keys[i];
	                if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
	              }
	            }
	            return obj;
	          };
	        };
	
	        // An internal function for creating a new object that inherits from another.
	        var baseCreate = function baseCreate(prototype) {
	          if (!_.isObject(prototype)) return {};
	          if (nativeCreate) return nativeCreate(prototype);
	          Ctor.prototype = prototype;
	          var result = new Ctor();
	          Ctor.prototype = null;
	          return result;
	        };
	
	        var property = function property(key) {
	          return function (obj) {
	            return obj == null ? void 0 : obj[key];
	          };
	        };
	
	        // Helper for collection methods to determine whether a collection
	        // should be iterated as an array or as an object
	        // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
	        // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
	        var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
	        var getLength = property('length');
	        var isArrayLike = function isArrayLike(collection) {
	          var length = getLength(collection);
	          return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
	        };
	
	        // Collection Functions
	        // --------------------
	
	        // The cornerstone, an `each` implementation, aka `forEach`.
	        // Handles raw objects in addition to array-likes. Treats all
	        // sparse array-likes as if they were dense.
	        _.each = _.forEach = function (obj, iteratee, context) {
	          iteratee = optimizeCb(iteratee, context);
	          var i, length;
	          if (isArrayLike(obj)) {
	            for (i = 0, length = obj.length; i < length; i++) {
	              iteratee(obj[i], i, obj);
	            }
	          } else {
	            var keys = _.keys(obj);
	            for (i = 0, length = keys.length; i < length; i++) {
	              iteratee(obj[keys[i]], keys[i], obj);
	            }
	          }
	          return obj;
	        };
	
	        // Return the results of applying the iteratee to each element.
	        _.map = _.collect = function (obj, iteratee, context) {
	          iteratee = cb(iteratee, context);
	          var keys = !isArrayLike(obj) && _.keys(obj),
	              length = (keys || obj).length,
	              results = Array(length);
	          for (var index = 0; index < length; index++) {
	            var currentKey = keys ? keys[index] : index;
	            results[index] = iteratee(obj[currentKey], currentKey, obj);
	          }
	          return results;
	        };
	
	        // Create a reducing function iterating left or right.
	        function createReduce(dir) {
	          // Optimized iterator function as using arguments.length
	          // in the main function will deoptimize the, see #1991.
	          function iterator(obj, iteratee, memo, keys, index, length) {
	            for (; index >= 0 && index < length; index += dir) {
	              var currentKey = keys ? keys[index] : index;
	              memo = iteratee(memo, obj[currentKey], currentKey, obj);
	            }
	            return memo;
	          }
	
	          return function (obj, iteratee, memo, context) {
	            iteratee = optimizeCb(iteratee, context, 4);
	            var keys = !isArrayLike(obj) && _.keys(obj),
	                length = (keys || obj).length,
	                index = dir > 0 ? 0 : length - 1;
	            // Determine the initial value if none is provided.
	            if (arguments.length < 3) {
	              memo = obj[keys ? keys[index] : index];
	              index += dir;
	            }
	            return iterator(obj, iteratee, memo, keys, index, length);
	          };
	        }
	
	        // **Reduce** builds up a single result from a list of values, aka `inject`,
	        // or `foldl`.
	        _.reduce = _.foldl = _.inject = createReduce(1);
	
	        // The right-associative version of reduce, also known as `foldr`.
	        _.reduceRight = _.foldr = createReduce(-1);
	
	        // Return the first value which passes a truth test. Aliased as `detect`.
	        _.find = _.detect = function (obj, predicate, context) {
	          var key;
	          if (isArrayLike(obj)) {
	            key = _.findIndex(obj, predicate, context);
	          } else {
	            key = _.findKey(obj, predicate, context);
	          }
	          if (key !== void 0 && key !== -1) return obj[key];
	        };
	
	        // Return all the elements that pass a truth test.
	        // Aliased as `select`.
	        _.filter = _.select = function (obj, predicate, context) {
	          var results = [];
	          predicate = cb(predicate, context);
	          _.each(obj, function (value, index, list) {
	            if (predicate(value, index, list)) results.push(value);
	          });
	          return results;
	        };
	
	        // Return all the elements for which a truth test fails.
	        _.reject = function (obj, predicate, context) {
	          return _.filter(obj, _.negate(cb(predicate)), context);
	        };
	
	        // Determine whether all of the elements match a truth test.
	        // Aliased as `all`.
	        _.every = _.all = function (obj, predicate, context) {
	          predicate = cb(predicate, context);
	          var keys = !isArrayLike(obj) && _.keys(obj),
	              length = (keys || obj).length;
	          for (var index = 0; index < length; index++) {
	            var currentKey = keys ? keys[index] : index;
	            if (!predicate(obj[currentKey], currentKey, obj)) return false;
	          }
	          return true;
	        };
	
	        // Determine if at least one element in the object matches a truth test.
	        // Aliased as `any`.
	        _.some = _.any = function (obj, predicate, context) {
	          predicate = cb(predicate, context);
	          var keys = !isArrayLike(obj) && _.keys(obj),
	              length = (keys || obj).length;
	          for (var index = 0; index < length; index++) {
	            var currentKey = keys ? keys[index] : index;
	            if (predicate(obj[currentKey], currentKey, obj)) return true;
	          }
	          return false;
	        };
	
	        // Determine if the array or object contains a given item (using `===`).
	        // Aliased as `includes` and `include`.
	        _.contains = _.includes = _.include = function (obj, item, fromIndex, guard) {
	          if (!isArrayLike(obj)) obj = _.values(obj);
	          if (typeof fromIndex != 'number' || guard) fromIndex = 0;
	          return _.indexOf(obj, item, fromIndex) >= 0;
	        };
	
	        // Invoke a method (with arguments) on every item in a collection.
	        _.invoke = function (obj, method) {
	          var args = slice.call(arguments, 2);
	          var isFunc = _.isFunction(method);
	          return _.map(obj, function (value) {
	            var func = isFunc ? method : value[method];
	            return func == null ? func : func.apply(value, args);
	          });
	        };
	
	        // Convenience version of a common use case of `map`: fetching a property.
	        _.pluck = function (obj, key) {
	          return _.map(obj, _.property(key));
	        };
	
	        // Convenience version of a common use case of `filter`: selecting only objects
	        // containing specific `key:value` pairs.
	        _.where = function (obj, attrs) {
	          return _.filter(obj, _.matcher(attrs));
	        };
	
	        // Convenience version of a common use case of `find`: getting the first object
	        // containing specific `key:value` pairs.
	        _.findWhere = function (obj, attrs) {
	          return _.find(obj, _.matcher(attrs));
	        };
	
	        // Return the maximum element (or element-based computation).
	        _.max = function (obj, iteratee, context) {
	          var result = -Infinity,
	              lastComputed = -Infinity,
	              value,
	              computed;
	          if (iteratee == null && obj != null) {
	            obj = isArrayLike(obj) ? obj : _.values(obj);
	            for (var i = 0, length = obj.length; i < length; i++) {
	              value = obj[i];
	              if (value > result) {
	                result = value;
	              }
	            }
	          } else {
	            iteratee = cb(iteratee, context);
	            _.each(obj, function (value, index, list) {
	              computed = iteratee(value, index, list);
	              if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
	                result = value;
	                lastComputed = computed;
	              }
	            });
	          }
	          return result;
	        };
	
	        // Return the minimum element (or element-based computation).
	        _.min = function (obj, iteratee, context) {
	          var result = Infinity,
	              lastComputed = Infinity,
	              value,
	              computed;
	          if (iteratee == null && obj != null) {
	            obj = isArrayLike(obj) ? obj : _.values(obj);
	            for (var i = 0, length = obj.length; i < length; i++) {
	              value = obj[i];
	              if (value < result) {
	                result = value;
	              }
	            }
	          } else {
	            iteratee = cb(iteratee, context);
	            _.each(obj, function (value, index, list) {
	              computed = iteratee(value, index, list);
	              if (computed < lastComputed || computed === Infinity && result === Infinity) {
	                result = value;
	                lastComputed = computed;
	              }
	            });
	          }
	          return result;
	        };
	
	        // Shuffle a collection, using the modern version of the
	        // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
	        _.shuffle = function (obj) {
	          var set = isArrayLike(obj) ? obj : _.values(obj);
	          var length = set.length;
	          var shuffled = Array(length);
	          for (var index = 0, rand; index < length; index++) {
	            rand = _.random(0, index);
	            if (rand !== index) shuffled[index] = shuffled[rand];
	            shuffled[rand] = set[index];
	          }
	          return shuffled;
	        };
	
	        // Sample **n** random values from a collection.
	        // If **n** is not specified, returns a single random element.
	        // The internal `guard` argument allows it to work with `map`.
	        _.sample = function (obj, n, guard) {
	          if (n == null || guard) {
	            if (!isArrayLike(obj)) obj = _.values(obj);
	            return obj[_.random(obj.length - 1)];
	          }
	          return _.shuffle(obj).slice(0, Math.max(0, n));
	        };
	
	        // Sort the object's values by a criterion produced by an iteratee.
	        _.sortBy = function (obj, iteratee, context) {
	          iteratee = cb(iteratee, context);
	          return _.pluck(_.map(obj, function (value, index, list) {
	            return {
	              value: value,
	              index: index,
	              criteria: iteratee(value, index, list)
	            };
	          }).sort(function (left, right) {
	            var a = left.criteria;
	            var b = right.criteria;
	            if (a !== b) {
	              if (a > b || a === void 0) return 1;
	              if (a < b || b === void 0) return -1;
	            }
	            return left.index - right.index;
	          }), 'value');
	        };
	
	        // An internal function used for aggregate "group by" operations.
	        var group = function group(behavior) {
	          return function (obj, iteratee, context) {
	            var result = {};
	            iteratee = cb(iteratee, context);
	            _.each(obj, function (value, index) {
	              var key = iteratee(value, index, obj);
	              behavior(result, value, key);
	            });
	            return result;
	          };
	        };
	
	        // Groups the object's values by a criterion. Pass either a string attribute
	        // to group by, or a function that returns the criterion.
	        _.groupBy = group(function (result, value, key) {
	          if (_.has(result, key)) result[key].push(value);else result[key] = [value];
	        });
	
	        // Indexes the object's values by a criterion, similar to `groupBy`, but for
	        // when you know that your index values will be unique.
	        _.indexBy = group(function (result, value, key) {
	          result[key] = value;
	        });
	
	        // Counts instances of an object that group by a certain criterion. Pass
	        // either a string attribute to count by, or a function that returns the
	        // criterion.
	        _.countBy = group(function (result, value, key) {
	          if (_.has(result, key)) result[key]++;else result[key] = 1;
	        });
	
	        // Safely create a real, live array from anything iterable.
	        _.toArray = function (obj) {
	          if (!obj) return [];
	          if (_.isArray(obj)) return slice.call(obj);
	          if (isArrayLike(obj)) return _.map(obj, _.identity);
	          return _.values(obj);
	        };
	
	        // Return the number of elements in an object.
	        _.size = function (obj) {
	          if (obj == null) return 0;
	          return isArrayLike(obj) ? obj.length : _.keys(obj).length;
	        };
	
	        // Split a collection into two arrays: one whose elements all satisfy the given
	        // predicate, and one whose elements all do not satisfy the predicate.
	        _.partition = function (obj, predicate, context) {
	          predicate = cb(predicate, context);
	          var pass = [],
	              fail = [];
	          _.each(obj, function (value, key, obj) {
	            (predicate(value, key, obj) ? pass : fail).push(value);
	          });
	          return [pass, fail];
	        };
	
	        // Array Functions
	        // ---------------
	
	        // Get the first element of an array. Passing **n** will return the first N
	        // values in the array. Aliased as `head` and `take`. The **guard** check
	        // allows it to work with `_.map`.
	        _.first = _.head = _.take = function (array, n, guard) {
	          if (array == null) return void 0;
	          if (n == null || guard) return array[0];
	          return _.initial(array, array.length - n);
	        };
	
	        // Returns everything but the last entry of the array. Especially useful on
	        // the arguments object. Passing **n** will return all the values in
	        // the array, excluding the last N.
	        _.initial = function (array, n, guard) {
	          return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
	        };
	
	        // Get the last element of an array. Passing **n** will return the last N
	        // values in the array.
	        _.last = function (array, n, guard) {
	          if (array == null) return void 0;
	          if (n == null || guard) return array[array.length - 1];
	          return _.rest(array, Math.max(0, array.length - n));
	        };
	
	        // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
	        // Especially useful on the arguments object. Passing an **n** will return
	        // the rest N values in the array.
	        _.rest = _.tail = _.drop = function (array, n, guard) {
	          return slice.call(array, n == null || guard ? 1 : n);
	        };
	
	        // Trim out all falsy values from an array.
	        _.compact = function (array) {
	          return _.filter(array, _.identity);
	        };
	
	        // Internal implementation of a recursive `flatten` function.
	        var flatten = function flatten(input, shallow, strict, startIndex) {
	          var output = [],
	              idx = 0;
	          for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
	            var value = input[i];
	            if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
	              //flatten current level of array or arguments object
	              if (!shallow) value = flatten(value, shallow, strict);
	              var j = 0,
	                  len = value.length;
	              output.length += len;
	              while (j < len) {
	                output[idx++] = value[j++];
	              }
	            } else if (!strict) {
	              output[idx++] = value;
	            }
	          }
	          return output;
	        };
	
	        // Flatten out an array, either recursively (by default), or just one level.
	        _.flatten = function (array, shallow) {
	          return flatten(array, shallow, false);
	        };
	
	        // Return a version of the array that does not contain the specified value(s).
	        _.without = function (array) {
	          return _.difference(array, slice.call(arguments, 1));
	        };
	
	        // Produce a duplicate-free version of the array. If the array has already
	        // been sorted, you have the option of using a faster algorithm.
	        // Aliased as `unique`.
	        _.uniq = _.unique = function (array, isSorted, iteratee, context) {
	          if (!_.isBoolean(isSorted)) {
	            context = iteratee;
	            iteratee = isSorted;
	            isSorted = false;
	          }
	          if (iteratee != null) iteratee = cb(iteratee, context);
	          var result = [];
	          var seen = [];
	          for (var i = 0, length = getLength(array); i < length; i++) {
	            var value = array[i],
	                computed = iteratee ? iteratee(value, i, array) : value;
	            if (isSorted) {
	              if (!i || seen !== computed) result.push(value);
	              seen = computed;
	            } else if (iteratee) {
	              if (!_.contains(seen, computed)) {
	                seen.push(computed);
	                result.push(value);
	              }
	            } else if (!_.contains(result, value)) {
	              result.push(value);
	            }
	          }
	          return result;
	        };
	
	        // Produce an array that contains the union: each distinct element from all of
	        // the passed-in arrays.
	        _.union = function () {
	          return _.uniq(flatten(arguments, true, true));
	        };
	
	        // Produce an array that contains every item shared between all the
	        // passed-in arrays.
	        _.intersection = function (array) {
	          var result = [];
	          var argsLength = arguments.length;
	          for (var i = 0, length = getLength(array); i < length; i++) {
	            var item = array[i];
	            if (_.contains(result, item)) continue;
	            for (var j = 1; j < argsLength; j++) {
	              if (!_.contains(arguments[j], item)) break;
	            }
	            if (j === argsLength) result.push(item);
	          }
	          return result;
	        };
	
	        // Take the difference between one array and a number of other arrays.
	        // Only the elements present in just the first array will remain.
	        _.difference = function (array) {
	          var rest = flatten(arguments, true, true, 1);
	          return _.filter(array, function (value) {
	            return !_.contains(rest, value);
	          });
	        };
	
	        // Zip together multiple lists into a single array -- elements that share
	        // an index go together.
	        _.zip = function () {
	          return _.unzip(arguments);
	        };
	
	        // Complement of _.zip. Unzip accepts an array of arrays and groups
	        // each array's elements on shared indices
	        _.unzip = function (array) {
	          var length = array && _.max(array, getLength).length || 0;
	          var result = Array(length);
	
	          for (var index = 0; index < length; index++) {
	            result[index] = _.pluck(array, index);
	          }
	          return result;
	        };
	
	        // Converts lists into objects. Pass either a single array of `[key, value]`
	        // pairs, or two parallel arrays of the same length -- one of keys, and one of
	        // the corresponding values.
	        _.object = function (list, values) {
	          var result = {};
	          for (var i = 0, length = getLength(list); i < length; i++) {
	            if (values) {
	              result[list[i]] = values[i];
	            } else {
	              result[list[i][0]] = list[i][1];
	            }
	          }
	          return result;
	        };
	
	        // Generator function to create the findIndex and findLastIndex functions
	        function createPredicateIndexFinder(dir) {
	          return function (array, predicate, context) {
	            predicate = cb(predicate, context);
	            var length = getLength(array);
	            var index = dir > 0 ? 0 : length - 1;
	            for (; index >= 0 && index < length; index += dir) {
	              if (predicate(array[index], index, array)) return index;
	            }
	            return -1;
	          };
	        }
	
	        // Returns the first index on an array-like that passes a predicate test
	        _.findIndex = createPredicateIndexFinder(1);
	        _.findLastIndex = createPredicateIndexFinder(-1);
	
	        // Use a comparator function to figure out the smallest index at which
	        // an object should be inserted so as to maintain order. Uses binary search.
	        _.sortedIndex = function (array, obj, iteratee, context) {
	          iteratee = cb(iteratee, context, 1);
	          var value = iteratee(obj);
	          var low = 0,
	              high = getLength(array);
	          while (low < high) {
	            var mid = Math.floor((low + high) / 2);
	            if (iteratee(array[mid]) < value) low = mid + 1;else high = mid;
	          }
	          return low;
	        };
	
	        // Generator function to create the indexOf and lastIndexOf functions
	        function createIndexFinder(dir, predicateFind, sortedIndex) {
	          return function (array, item, idx) {
	            var i = 0,
	                length = getLength(array);
	            if (typeof idx == 'number') {
	              if (dir > 0) {
	                i = idx >= 0 ? idx : Math.max(idx + length, i);
	              } else {
	                length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
	              }
	            } else if (sortedIndex && idx && length) {
	              idx = sortedIndex(array, item);
	              return array[idx] === item ? idx : -1;
	            }
	            if (item !== item) {
	              idx = predicateFind(slice.call(array, i, length), _.isNaN);
	              return idx >= 0 ? idx + i : -1;
	            }
	            for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
	              if (array[idx] === item) return idx;
	            }
	            return -1;
	          };
	        }
	
	        // Return the position of the first occurrence of an item in an array,
	        // or -1 if the item is not included in the array.
	        // If the array is large and already in sort order, pass `true`
	        // for **isSorted** to use binary search.
	        _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
	        _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);
	
	        // Generate an integer Array containing an arithmetic progression. A port of
	        // the native Python `range()` function. See
	        // [the Python documentation](http://docs.python.org/library/functions.html#range).
	        _.range = function (start, stop, step) {
	          if (stop == null) {
	            stop = start || 0;
	            start = 0;
	          }
	          step = step || 1;
	
	          var length = Math.max(Math.ceil((stop - start) / step), 0);
	          var range = Array(length);
	
	          for (var idx = 0; idx < length; idx++, start += step) {
	            range[idx] = start;
	          }
	
	          return range;
	        };
	
	        // Function (ahem) Functions
	        // ------------------
	
	        // Determines whether to execute a function as a constructor
	        // or a normal function with the provided arguments
	        var executeBound = function executeBound(sourceFunc, boundFunc, context, callingContext, args) {
	          if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
	          var self = baseCreate(sourceFunc.prototype);
	          var result = sourceFunc.apply(self, args);
	          if (_.isObject(result)) return result;
	          return self;
	        };
	
	        // Create a function bound to a given object (assigning `this`, and arguments,
	        // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
	        // available.
	        _.bind = function (func, context) {
	          if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
	          if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
	          var args = slice.call(arguments, 2);
	          var bound = function bound() {
	            return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
	          };
	          return bound;
	        };
	
	        // Partially apply a function by creating a version that has had some of its
	        // arguments pre-filled, without changing its dynamic `this` context. _ acts
	        // as a placeholder, allowing any combination of arguments to be pre-filled.
	        _.partial = function (func) {
	          var boundArgs = slice.call(arguments, 1);
	          var bound = function bound() {
	            var position = 0,
	                length = boundArgs.length;
	            var args = Array(length);
	            for (var i = 0; i < length; i++) {
	              args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
	            }
	            while (position < arguments.length) {
	              args.push(arguments[position++]);
	            }return executeBound(func, bound, this, this, args);
	          };
	          return bound;
	        };
	
	        // Bind a number of an object's methods to that object. Remaining arguments
	        // are the method names to be bound. Useful for ensuring that all callbacks
	        // defined on an object belong to it.
	        _.bindAll = function (obj) {
	          var i,
	              length = arguments.length,
	              key;
	          if (length <= 1) throw new Error('bindAll must be passed function names');
	          for (i = 1; i < length; i++) {
	            key = arguments[i];
	            obj[key] = _.bind(obj[key], obj);
	          }
	          return obj;
	        };
	
	        // Memoize an expensive function by storing its results.
	        _.memoize = function (func, hasher) {
	          var memoize = function memoize(key) {
	            var cache = memoize.cache;
	            var address = '' + (hasher ? hasher.apply(this, arguments) : key);
	            if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
	            return cache[address];
	          };
	          memoize.cache = {};
	          return memoize;
	        };
	
	        // Delays a function for the given number of milliseconds, and then calls
	        // it with the arguments supplied.
	        _.delay = function (func, wait) {
	          var args = slice.call(arguments, 2);
	          return setTimeout(function () {
	            return func.apply(null, args);
	          }, wait);
	        };
	
	        // Defers a function, scheduling it to run after the current call stack has
	        // cleared.
	        _.defer = _.partial(_.delay, _, 1);
	
	        // Returns a function, that, when invoked, will only be triggered at most once
	        // during a given window of time. Normally, the throttled function will run
	        // as much as it can, without ever going more than once per `wait` duration;
	        // but if you'd like to disable the execution on the leading edge, pass
	        // `{leading: false}`. To disable execution on the trailing edge, ditto.
	        _.throttle = function (func, wait, options) {
	          var context, args, result;
	          var timeout = null;
	          var previous = 0;
	          if (!options) options = {};
	          var later = function later() {
	            previous = options.leading === false ? 0 : _.now();
	            timeout = null;
	            result = func.apply(context, args);
	            if (!timeout) context = args = null;
	          };
	          return function () {
	            var now = _.now();
	            if (!previous && options.leading === false) previous = now;
	            var remaining = wait - (now - previous);
	            context = this;
	            args = arguments;
	            if (remaining <= 0 || remaining > wait) {
	              if (timeout) {
	                clearTimeout(timeout);
	                timeout = null;
	              }
	              previous = now;
	              result = func.apply(context, args);
	              if (!timeout) context = args = null;
	            } else if (!timeout && options.trailing !== false) {
	              timeout = setTimeout(later, remaining);
	            }
	            return result;
	          };
	        };
	
	        // Returns a function, that, as long as it continues to be invoked, will not
	        // be triggered. The function will be called after it stops being called for
	        // N milliseconds. If `immediate` is passed, trigger the function on the
	        // leading edge, instead of the trailing.
	        _.debounce = function (func, wait, immediate) {
	          var timeout, args, context, timestamp, result;
	
	          var later = function later() {
	            var last = _.now() - timestamp;
	
	            if (last < wait && last >= 0) {
	              timeout = setTimeout(later, wait - last);
	            } else {
	              timeout = null;
	              if (!immediate) {
	                result = func.apply(context, args);
	                if (!timeout) context = args = null;
	              }
	            }
	          };
	
	          return function () {
	            context = this;
	            args = arguments;
	            timestamp = _.now();
	            var callNow = immediate && !timeout;
	            if (!timeout) timeout = setTimeout(later, wait);
	            if (callNow) {
	              result = func.apply(context, args);
	              context = args = null;
	            }
	
	            return result;
	          };
	        };
	
	        // Returns the first function passed as an argument to the second,
	        // allowing you to adjust arguments, run code before and after, and
	        // conditionally execute the original function.
	        _.wrap = function (func, wrapper) {
	          return _.partial(wrapper, func);
	        };
	
	        // Returns a negated version of the passed-in predicate.
	        _.negate = function (predicate) {
	          return function () {
	            return !predicate.apply(this, arguments);
	          };
	        };
	
	        // Returns a function that is the composition of a list of functions, each
	        // consuming the return value of the function that follows.
	        _.compose = function () {
	          var args = arguments;
	          var start = args.length - 1;
	          return function () {
	            var i = start;
	            var result = args[start].apply(this, arguments);
	            while (i--) {
	              result = args[i].call(this, result);
	            }return result;
	          };
	        };
	
	        // Returns a function that will only be executed on and after the Nth call.
	        _.after = function (times, func) {
	          return function () {
	            if (--times < 1) {
	              return func.apply(this, arguments);
	            }
	          };
	        };
	
	        // Returns a function that will only be executed up to (but not including) the Nth call.
	        _.before = function (times, func) {
	          var memo;
	          return function () {
	            if (--times > 0) {
	              memo = func.apply(this, arguments);
	            }
	            if (times <= 1) func = null;
	            return memo;
	          };
	        };
	
	        // Returns a function that will be executed at most one time, no matter how
	        // often you call it. Useful for lazy initialization.
	        _.once = _.partial(_.before, 2);
	
	        // Object Functions
	        // ----------------
	
	        // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
	        var hasEnumBug = !{ toString: null }.propertyIsEnumerable('toString');
	        var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];
	
	        function collectNonEnumProps(obj, keys) {
	          var nonEnumIdx = nonEnumerableProps.length;
	          var constructor = obj.constructor;
	          var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;
	
	          // Constructor is a special case.
	          var prop = 'constructor';
	          if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);
	
	          while (nonEnumIdx--) {
	            prop = nonEnumerableProps[nonEnumIdx];
	            if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
	              keys.push(prop);
	            }
	          }
	        }
	
	        // Retrieve the names of an object's own properties.
	        // Delegates to **ECMAScript 5**'s native `Object.keys`
	        _.keys = function (obj) {
	          if (!_.isObject(obj)) return [];
	          if (nativeKeys) return nativeKeys(obj);
	          var keys = [];
	          for (var key in obj) {
	            if (_.has(obj, key)) keys.push(key);
	          } // Ahem, IE < 9.
	          if (hasEnumBug) collectNonEnumProps(obj, keys);
	          return keys;
	        };
	
	        // Retrieve all the property names of an object.
	        _.allKeys = function (obj) {
	          if (!_.isObject(obj)) return [];
	          var keys = [];
	          for (var key in obj) {
	            keys.push(key);
	          } // Ahem, IE < 9.
	          if (hasEnumBug) collectNonEnumProps(obj, keys);
	          return keys;
	        };
	
	        // Retrieve the values of an object's properties.
	        _.values = function (obj) {
	          var keys = _.keys(obj);
	          var length = keys.length;
	          var values = Array(length);
	          for (var i = 0; i < length; i++) {
	            values[i] = obj[keys[i]];
	          }
	          return values;
	        };
	
	        // Returns the results of applying the iteratee to each element of the object
	        // In contrast to _.map it returns an object
	        _.mapObject = function (obj, iteratee, context) {
	          iteratee = cb(iteratee, context);
	          var keys = _.keys(obj),
	              length = keys.length,
	              results = {},
	              currentKey;
	          for (var index = 0; index < length; index++) {
	            currentKey = keys[index];
	            results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
	          }
	          return results;
	        };
	
	        // Convert an object into a list of `[key, value]` pairs.
	        _.pairs = function (obj) {
	          var keys = _.keys(obj);
	          var length = keys.length;
	          var pairs = Array(length);
	          for (var i = 0; i < length; i++) {
	            pairs[i] = [keys[i], obj[keys[i]]];
	          }
	          return pairs;
	        };
	
	        // Invert the keys and values of an object. The values must be serializable.
	        _.invert = function (obj) {
	          var result = {};
	          var keys = _.keys(obj);
	          for (var i = 0, length = keys.length; i < length; i++) {
	            result[obj[keys[i]]] = keys[i];
	          }
	          return result;
	        };
	
	        // Return a sorted list of the function names available on the object.
	        // Aliased as `methods`
	        _.functions = _.methods = function (obj) {
	          var names = [];
	          for (var key in obj) {
	            if (_.isFunction(obj[key])) names.push(key);
	          }
	          return names.sort();
	        };
	
	        // Extend a given object with all the properties in passed-in object(s).
	        _.extend = createAssigner(_.allKeys);
	
	        // Assigns a given object with all the own properties in the passed-in object(s)
	        // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
	        _.extendOwn = _.assign = createAssigner(_.keys);
	
	        // Returns the first key on an object that passes a predicate test
	        _.findKey = function (obj, predicate, context) {
	          predicate = cb(predicate, context);
	          var keys = _.keys(obj),
	              key;
	          for (var i = 0, length = keys.length; i < length; i++) {
	            key = keys[i];
	            if (predicate(obj[key], key, obj)) return key;
	          }
	        };
	
	        // Return a copy of the object only containing the whitelisted properties.
	        _.pick = function (object, oiteratee, context) {
	          var result = {},
	              obj = object,
	              iteratee,
	              keys;
	          if (obj == null) return result;
	          if (_.isFunction(oiteratee)) {
	            keys = _.allKeys(obj);
	            iteratee = optimizeCb(oiteratee, context);
	          } else {
	            keys = flatten(arguments, false, false, 1);
	            iteratee = function iteratee(value, key, obj) {
	              return key in obj;
	            };
	            obj = Object(obj);
	          }
	          for (var i = 0, length = keys.length; i < length; i++) {
	            var key = keys[i];
	            var value = obj[key];
	            if (iteratee(value, key, obj)) result[key] = value;
	          }
	          return result;
	        };
	
	        // Return a copy of the object without the blacklisted properties.
	        _.omit = function (obj, iteratee, context) {
	          if (_.isFunction(iteratee)) {
	            iteratee = _.negate(iteratee);
	          } else {
	            var keys = _.map(flatten(arguments, false, false, 1), String);
	            iteratee = function iteratee(value, key) {
	              return !_.contains(keys, key);
	            };
	          }
	          return _.pick(obj, iteratee, context);
	        };
	
	        // Fill in a given object with default properties.
	        _.defaults = createAssigner(_.allKeys, true);
	
	        // Creates an object that inherits from the given prototype object.
	        // If additional properties are provided then they will be added to the
	        // created object.
	        _.create = function (prototype, props) {
	          var result = baseCreate(prototype);
	          if (props) _.extendOwn(result, props);
	          return result;
	        };
	
	        // Create a (shallow-cloned) duplicate of an object.
	        _.clone = function (obj) {
	          if (!_.isObject(obj)) return obj;
	          return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
	        };
	
	        // Invokes interceptor with the obj, and then returns obj.
	        // The primary purpose of this method is to "tap into" a method chain, in
	        // order to perform operations on intermediate results within the chain.
	        _.tap = function (obj, interceptor) {
	          interceptor(obj);
	          return obj;
	        };
	
	        // Returns whether an object has a given set of `key:value` pairs.
	        _.isMatch = function (object, attrs) {
	          var keys = _.keys(attrs),
	              length = keys.length;
	          if (object == null) return !length;
	          var obj = Object(object);
	          for (var i = 0; i < length; i++) {
	            var key = keys[i];
	            if (attrs[key] !== obj[key] || !(key in obj)) return false;
	          }
	          return true;
	        };
	
	        // Internal recursive comparison function for `isEqual`.
	        var eq = function eq(a, b, aStack, bStack) {
	          // Identical objects are equal. `0 === -0`, but they aren't identical.
	          // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
	          if (a === b) return a !== 0 || 1 / a === 1 / b;
	          // A strict comparison is necessary because `null == undefined`.
	          if (a == null || b == null) return a === b;
	          // Unwrap any wrapped objects.
	          if (a instanceof _) a = a._wrapped;
	          if (b instanceof _) b = b._wrapped;
	          // Compare `[[Class]]` names.
	          var className = toString.call(a);
	          if (className !== toString.call(b)) return false;
	          switch (className) {
	            // Strings, numbers, regular expressions, dates, and booleans are compared by value.
	            case '[object RegExp]':
	            // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
	            case '[object String]':
	              // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
	              // equivalent to `new String("5")`.
	              return '' + a === '' + b;
	            case '[object Number]':
	              // `NaN`s are equivalent, but non-reflexive.
	              // Object(NaN) is equivalent to NaN
	              if (+a !== +a) return +b !== +b;
	              // An `egal` comparison is performed for other numeric values.
	              return +a === 0 ? 1 / +a === 1 / b : +a === +b;
	            case '[object Date]':
	            case '[object Boolean]':
	              // Coerce dates and booleans to numeric primitive values. Dates are compared by their
	              // millisecond representations. Note that invalid dates with millisecond representations
	              // of `NaN` are not equivalent.
	              return +a === +b;
	          }
	
	          var areArrays = className === '[object Array]';
	          if (!areArrays) {
	            if ((typeof a === "undefined" ? "undefined" : _typeof(a)) != 'object' || (typeof b === "undefined" ? "undefined" : _typeof(b)) != 'object') return false;
	
	            // Objects with different constructors are not equivalent, but `Object`s or `Array`s
	            // from different frames are.
	            var aCtor = a.constructor,
	                bCtor = b.constructor;
	            if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor && _.isFunction(bCtor) && bCtor instanceof bCtor) && 'constructor' in a && 'constructor' in b) {
	              return false;
	            }
	          }
	          // Assume equality for cyclic structures. The algorithm for detecting cyclic
	          // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.
	
	          // Initializing stack of traversed objects.
	          // It's done here since we only need them for objects and arrays comparison.
	          aStack = aStack || [];
	          bStack = bStack || [];
	          var length = aStack.length;
	          while (length--) {
	            // Linear search. Performance is inversely proportional to the number of
	            // unique nested structures.
	            if (aStack[length] === a) return bStack[length] === b;
	          }
	
	          // Add the first object to the stack of traversed objects.
	          aStack.push(a);
	          bStack.push(b);
	
	          // Recursively compare objects and arrays.
	          if (areArrays) {
	            // Compare array lengths to determine if a deep comparison is necessary.
	            length = a.length;
	            if (length !== b.length) return false;
	            // Deep compare the contents, ignoring non-numeric properties.
	            while (length--) {
	              if (!eq(a[length], b[length], aStack, bStack)) return false;
	            }
	          } else {
	            // Deep compare objects.
	            var keys = _.keys(a),
	                key;
	            length = keys.length;
	            // Ensure that both objects contain the same number of properties before comparing deep equality.
	            if (_.keys(b).length !== length) return false;
	            while (length--) {
	              // Deep compare each member
	              key = keys[length];
	              if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
	            }
	          }
	          // Remove the first object from the stack of traversed objects.
	          aStack.pop();
	          bStack.pop();
	          return true;
	        };
	
	        // Perform a deep comparison to check if two objects are equal.
	        _.isEqual = function (a, b) {
	          return eq(a, b);
	        };
	
	        // Is a given array, string, or object empty?
	        // An "empty" object has no enumerable own-properties.
	        _.isEmpty = function (obj) {
	          if (obj == null) return true;
	          if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
	          return _.keys(obj).length === 0;
	        };
	
	        // Is a given value a DOM element?
	        _.isElement = function (obj) {
	          return !!(obj && obj.nodeType === 1);
	        };
	
	        // Is a given value an array?
	        // Delegates to ECMA5's native Array.isArray
	        _.isArray = nativeIsArray || function (obj) {
	          return toString.call(obj) === '[object Array]';
	        };
	
	        // Is a given variable an object?
	        _.isObject = function (obj) {
	          var type = typeof obj === "undefined" ? "undefined" : _typeof(obj);
	          return type === 'function' || type === 'object' && !!obj;
	        };
	
	        // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
	        _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function (name) {
	          _['is' + name] = function (obj) {
	            return toString.call(obj) === '[object ' + name + ']';
	          };
	        });
	
	        // Define a fallback version of the method in browsers (ahem, IE < 9), where
	        // there isn't any inspectable "Arguments" type.
	        if (!_.isArguments(arguments)) {
	          _.isArguments = function (obj) {
	            return _.has(obj, 'callee');
	          };
	        }
	
	        // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
	        // IE 11 (#1621), and in Safari 8 (#1929).
	        if (typeof /./ != 'function' && (typeof Int8Array === "undefined" ? "undefined" : _typeof(Int8Array)) != 'object') {
	          _.isFunction = function (obj) {
	            return typeof obj == 'function' || false;
	          };
	        }
	
	        // Is a given object a finite number?
	        _.isFinite = function (obj) {
	          return isFinite(obj) && !isNaN(parseFloat(obj));
	        };
	
	        // Is the given value `NaN`? (NaN is the only number which does not equal itself).
	        _.isNaN = function (obj) {
	          return _.isNumber(obj) && obj !== +obj;
	        };
	
	        // Is a given value a boolean?
	        _.isBoolean = function (obj) {
	          return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
	        };
	
	        // Is a given value equal to null?
	        _.isNull = function (obj) {
	          return obj === null;
	        };
	
	        // Is a given variable undefined?
	        _.isUndefined = function (obj) {
	          return obj === void 0;
	        };
	
	        // Shortcut function for checking if an object has a given property directly
	        // on itself (in other words, not on a prototype).
	        _.has = function (obj, key) {
	          return obj != null && hasOwnProperty.call(obj, key);
	        };
	
	        // Utility Functions
	        // -----------------
	
	        // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
	        // previous owner. Returns a reference to the Underscore object.
	        _.noConflict = function () {
	          root._ = previousUnderscore;
	          return this;
	        };
	
	        // Keep the identity function around for default iteratees.
	        _.identity = function (value) {
	          return value;
	        };
	
	        // Predicate-generating functions. Often useful outside of Underscore.
	        _.constant = function (value) {
	          return function () {
	            return value;
	          };
	        };
	
	        _.noop = function () {};
	
	        _.property = property;
	
	        // Generates a function for a given object that returns a given property.
	        _.propertyOf = function (obj) {
	          return obj == null ? function () {} : function (key) {
	            return obj[key];
	          };
	        };
	
	        // Returns a predicate for checking whether an object has a given set of
	        // `key:value` pairs.
	        _.matcher = _.matches = function (attrs) {
	          attrs = _.extendOwn({}, attrs);
	          return function (obj) {
	            return _.isMatch(obj, attrs);
	          };
	        };
	
	        // Run a function **n** times.
	        _.times = function (n, iteratee, context) {
	          var accum = Array(Math.max(0, n));
	          iteratee = optimizeCb(iteratee, context, 1);
	          for (var i = 0; i < n; i++) {
	            accum[i] = iteratee(i);
	          }return accum;
	        };
	
	        // Return a random integer between min and max (inclusive).
	        _.random = function (min, max) {
	          if (max == null) {
	            max = min;
	            min = 0;
	          }
	          return min + Math.floor(Math.random() * (max - min + 1));
	        };
	
	        // A (possibly faster) way to get the current timestamp as an integer.
	        _.now = Date.now || function () {
	          return new Date().getTime();
	        };
	
	        // List of HTML entities for escaping.
	        var escapeMap = {
	          '&': '&amp;',
	          '<': '&lt;',
	          '>': '&gt;',
	          '"': '&quot;',
	          "'": '&#x27;',
	          '`': '&#x60;'
	        };
	        var unescapeMap = _.invert(escapeMap);
	
	        // Functions for escaping and unescaping strings to/from HTML interpolation.
	        var createEscaper = function createEscaper(map) {
	          var escaper = function escaper(match) {
	            return map[match];
	          };
	          // Regexes for identifying a key that needs to be escaped
	          var source = '(?:' + _.keys(map).join('|') + ')';
	          var testRegexp = RegExp(source);
	          var replaceRegexp = RegExp(source, 'g');
	          return function (string) {
	            string = string == null ? '' : '' + string;
	            return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
	          };
	        };
	        _.escape = createEscaper(escapeMap);
	        _.unescape = createEscaper(unescapeMap);
	
	        // If the value of the named `property` is a function then invoke it with the
	        // `object` as context; otherwise, return it.
	        _.result = function (object, property, fallback) {
	          var value = object == null ? void 0 : object[property];
	          if (value === void 0) {
	            value = fallback;
	          }
	          return _.isFunction(value) ? value.call(object) : value;
	        };
	
	        // Generate a unique integer id (unique within the entire client session).
	        // Useful for temporary DOM ids.
	        var idCounter = 0;
	        _.uniqueId = function (prefix) {
	          var id = ++idCounter + '';
	          return prefix ? prefix + id : id;
	        };
	
	        // By default, Underscore uses ERB-style template delimiters, change the
	        // following template settings to use alternative delimiters.
	        _.templateSettings = {
	          evaluate: /<%([\s\S]+?)%>/g,
	          interpolate: /<%=([\s\S]+?)%>/g,
	          escape: /<%-([\s\S]+?)%>/g
	        };
	
	        // When customizing `templateSettings`, if you don't want to define an
	        // interpolation, evaluation or escaping regex, we need one that is
	        // guaranteed not to match.
	        var noMatch = /(.)^/;
	
	        // Certain characters need to be escaped so that they can be put into a
	        // string literal.
	        var escapes = {
	          "'": "'",
	          '\\': '\\',
	          '\r': 'r',
	          '\n': 'n',
	          "\u2028": 'u2028',
	          "\u2029": 'u2029'
	        };
	
	        var escaper = /\\|'|\r|\n|\u2028|\u2029/g;
	
	        var escapeChar = function escapeChar(match) {
	          return '\\' + escapes[match];
	        };
	
	        // JavaScript micro-templating, similar to John Resig's implementation.
	        // Underscore templating handles arbitrary delimiters, preserves whitespace,
	        // and correctly escapes quotes within interpolated code.
	        // NB: `oldSettings` only exists for backwards compatibility.
	        _.template = function (text, settings, oldSettings) {
	          if (!settings && oldSettings) settings = oldSettings;
	          settings = _.defaults({}, settings, _.templateSettings);
	
	          // Combine delimiters into one regular expression via alternation.
	          var matcher = RegExp([(settings.escape || noMatch).source, (settings.interpolate || noMatch).source, (settings.evaluate || noMatch).source].join('|') + '|$', 'g');
	
	          // Compile the template source, escaping string literals appropriately.
	          var index = 0;
	          var source = "__p+='";
	          text.replace(matcher, function (match, escape, interpolate, evaluate, offset) {
	            source += text.slice(index, offset).replace(escaper, escapeChar);
	            index = offset + match.length;
	
	            if (escape) {
	              source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
	            } else if (interpolate) {
	              source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
	            } else if (evaluate) {
	              source += "';\n" + evaluate + "\n__p+='";
	            }
	
	            // Adobe VMs need the match returned to produce the correct offest.
	            return match;
	          });
	          source += "';\n";
	
	          // If a variable is not specified, place data values in local scope.
	          if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';
	
	          source = "var __t,__p='',__j=Array.prototype.join," + "print=function(){__p+=__j.call(arguments,'');};\n" + source + 'return __p;\n';
	
	          try {
	            var render = new Function(settings.variable || 'obj', '_', source);
	          } catch (e) {
	            e.source = source;
	            throw e;
	          }
	
	          var template = function template(data) {
	            return render.call(this, data, _);
	          };
	
	          // Provide the compiled source as a convenience for precompilation.
	          var argument = settings.variable || 'obj';
	          template.source = 'function(' + argument + '){\n' + source + '}';
	
	          return template;
	        };
	
	        // Add a "chain" function. Start chaining a wrapped Underscore object.
	        _.chain = function (obj) {
	          var instance = _(obj);
	          instance._chain = true;
	          return instance;
	        };
	
	        // OOP
	        // ---------------
	        // If Underscore is called as a function, it returns a wrapped object that
	        // can be used OO-style. This wrapper holds altered versions of all the
	        // underscore functions. Wrapped objects may be chained.
	
	        // Helper function to continue chaining intermediate results.
	        var result = function result(instance, obj) {
	          return instance._chain ? _(obj).chain() : obj;
	        };
	
	        // Add your own custom functions to the Underscore object.
	        _.mixin = function (obj) {
	          _.each(_.functions(obj), function (name) {
	            var func = _[name] = obj[name];
	            _.prototype[name] = function () {
	              var args = [this._wrapped];
	              push.apply(args, arguments);
	              return result(this, func.apply(_, args));
	            };
	          });
	        };
	
	        // Add all of the Underscore functions to the wrapper object.
	        _.mixin(_);
	
	        // Add all mutator Array functions to the wrapper.
	        _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function (name) {
	          var method = ArrayProto[name];
	          _.prototype[name] = function () {
	            var obj = this._wrapped;
	            method.apply(obj, arguments);
	            if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
	            return result(this, obj);
	          };
	        });
	
	        // Add all accessor Array functions to the wrapper.
	        _.each(['concat', 'join', 'slice'], function (name) {
	          var method = ArrayProto[name];
	          _.prototype[name] = function () {
	            return result(this, method.apply(this._wrapped, arguments));
	          };
	        });
	
	        // Extracts the result from a wrapped and chained object.
	        _.prototype.value = function () {
	          return this._wrapped;
	        };
	
	        // Provide unwrapping proxy for some methods used in engine operations
	        // such as arithmetic and JSON stringification.
	        _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;
	
	        _.prototype.toString = function () {
	          return '' + this._wrapped;
	        };
	
	        // AMD registration happens at the end for compatibility with AMD loaders
	        // that may not enforce next-turn semantics on modules. Even though general
	        // practice for AMD registration is to be anonymous, underscore registers
	        // as a named module because, like jQuery, it is a base library that is
	        // popular enough to be bundled in a third party lib, but not be part of
	        // an AMD load request. Those cases could generate an error when an
	        // anonymous define() is called outside of a loader request.
	        if (typeof define === 'function' && define.amd) {
	          define('underscore', [], function () {
	            return _;
	          });
	        }
	      }).call(this);
	    }, {}], 18: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      'use strict';
	
	      var _ = require('underscore');
	
	      /*global navigator: false */
	      module.exports = function (AV) {
	        var PUBLIC_KEY = "*";
	
	        /**
	         * Creates a new ACL.
	         * If no argument is given, the ACL has no permissions for anyone.
	         * If the argument is a AV.User, the ACL will have read and write
	         *   permission for only that user.
	         * If the argument is any other JSON object, that object will be interpretted
	         *   as a serialized ACL created with toJSON().
	         * @see AV.Object#setACL
	         * @class
	         *
	         * <p>An ACL, or Access Control List can be added to any
	         * <code>AV.Object</code> to restrict access to only a subset of users
	         * of your application.</p>
	         */
	        AV.ACL = function (arg1) {
	          var self = this;
	          self.permissionsById = {};
	          if (_.isObject(arg1)) {
	            if (arg1 instanceof AV.User) {
	              self.setReadAccess(arg1, true);
	              self.setWriteAccess(arg1, true);
	            } else {
	              if (_.isFunction(arg1)) {
	                throw "AV.ACL() called with a function.  Did you forget ()?";
	              }
	              AV._objectEach(arg1, function (accessList, userId) {
	                if (!_.isString(userId)) {
	                  throw "Tried to create an ACL with an invalid userId.";
	                }
	                self.permissionsById[userId] = {};
	                AV._objectEach(accessList, function (allowed, permission) {
	                  if (permission !== "read" && permission !== "write") {
	                    throw "Tried to create an ACL with an invalid permission type.";
	                  }
	                  if (!_.isBoolean(allowed)) {
	                    throw "Tried to create an ACL with an invalid permission value.";
	                  }
	                  self.permissionsById[userId][permission] = allowed;
	                });
	              });
	            }
	          }
	        };
	
	        /**
	         * Returns a JSON-encoded version of the ACL.
	         * @return {Object}
	         */
	        AV.ACL.prototype.toJSON = function () {
	          return _.clone(this.permissionsById);
	        };
	
	        AV.ACL.prototype._setAccess = function (accessType, userId, allowed) {
	          if (userId instanceof AV.User) {
	            userId = userId.id;
	          } else if (userId instanceof AV.Role) {
	            userId = "role:" + userId.getName();
	          }
	          if (!_.isString(userId)) {
	            throw "userId must be a string.";
	          }
	          if (!_.isBoolean(allowed)) {
	            throw "allowed must be either true or false.";
	          }
	          var permissions = this.permissionsById[userId];
	          if (!permissions) {
	            if (!allowed) {
	              // The user already doesn't have this permission, so no action needed.
	              return;
	            } else {
	              permissions = {};
	              this.permissionsById[userId] = permissions;
	            }
	          }
	
	          if (allowed) {
	            this.permissionsById[userId][accessType] = true;
	          } else {
	            delete permissions[accessType];
	            if (_.isEmpty(permissions)) {
	              delete permissions[userId];
	            }
	          }
	        };
	
	        AV.ACL.prototype._getAccess = function (accessType, userId) {
	          if (userId instanceof AV.User) {
	            userId = userId.id;
	          } else if (userId instanceof AV.Role) {
	            userId = "role:" + userId.getName();
	          }
	          var permissions = this.permissionsById[userId];
	          if (!permissions) {
	            return false;
	          }
	          return permissions[accessType] ? true : false;
	        };
	
	        /**
	         * Set whether the given user is allowed to read this object.
	         * @param userId An instance of AV.User or its objectId.
	         * @param {Boolean} allowed Whether that user should have read access.
	         */
	        AV.ACL.prototype.setReadAccess = function (userId, allowed) {
	          this._setAccess("read", userId, allowed);
	        };
	
	        /**
	         * Get whether the given user id is *explicitly* allowed to read this object.
	         * Even if this returns false, the user may still be able to access it if
	         * getPublicReadAccess returns true or a role that the user belongs to has
	         * write access.
	         * @param userId An instance of AV.User or its objectId, or a AV.Role.
	         * @return {Boolean}
	         */
	        AV.ACL.prototype.getReadAccess = function (userId) {
	          return this._getAccess("read", userId);
	        };
	
	        /**
	         * Set whether the given user id is allowed to write this object.
	         * @param userId An instance of AV.User or its objectId, or a AV.Role..
	         * @param {Boolean} allowed Whether that user should have write access.
	         */
	        AV.ACL.prototype.setWriteAccess = function (userId, allowed) {
	          this._setAccess("write", userId, allowed);
	        };
	
	        /**
	         * Get whether the given user id is *explicitly* allowed to write this object.
	         * Even if this returns false, the user may still be able to write it if
	         * getPublicWriteAccess returns true or a role that the user belongs to has
	         * write access.
	         * @param userId An instance of AV.User or its objectId, or a AV.Role.
	         * @return {Boolean}
	         */
	        AV.ACL.prototype.getWriteAccess = function (userId) {
	          return this._getAccess("write", userId);
	        };
	
	        /**
	         * Set whether the public is allowed to read this object.
	         * @param {Boolean} allowed
	         */
	        AV.ACL.prototype.setPublicReadAccess = function (allowed) {
	          this.setReadAccess(PUBLIC_KEY, allowed);
	        };
	
	        /**
	         * Get whether the public is allowed to read this object.
	         * @return {Boolean}
	         */
	        AV.ACL.prototype.getPublicReadAccess = function () {
	          return this.getReadAccess(PUBLIC_KEY);
	        };
	
	        /**
	         * Set whether the public is allowed to write this object.
	         * @param {Boolean} allowed
	         */
	        AV.ACL.prototype.setPublicWriteAccess = function (allowed) {
	          this.setWriteAccess(PUBLIC_KEY, allowed);
	        };
	
	        /**
	         * Get whether the public is allowed to write this object.
	         * @return {Boolean}
	         */
	        AV.ACL.prototype.getPublicWriteAccess = function () {
	          return this.getWriteAccess(PUBLIC_KEY);
	        };
	
	        /**
	         * Get whether users belonging to the given role are allowed
	         * to read this object. Even if this returns false, the role may
	         * still be able to write it if a parent role has read access.
	         *
	         * @param role The name of the role, or a AV.Role object.
	         * @return {Boolean} true if the role has read access. false otherwise.
	         * @throws {String} If role is neither a AV.Role nor a String.
	         */
	        AV.ACL.prototype.getRoleReadAccess = function (role) {
	          if (role instanceof AV.Role) {
	            // Normalize to the String name
	            role = role.getName();
	          }
	          if (_.isString(role)) {
	            return this.getReadAccess("role:" + role);
	          }
	          throw "role must be a AV.Role or a String";
	        };
	
	        /**
	         * Get whether users belonging to the given role are allowed
	         * to write this object. Even if this returns false, the role may
	         * still be able to write it if a parent role has write access.
	         *
	         * @param role The name of the role, or a AV.Role object.
	         * @return {Boolean} true if the role has write access. false otherwise.
	         * @throws {String} If role is neither a AV.Role nor a String.
	         */
	        AV.ACL.prototype.getRoleWriteAccess = function (role) {
	          if (role instanceof AV.Role) {
	            // Normalize to the String name
	            role = role.getName();
	          }
	          if (_.isString(role)) {
	            return this.getWriteAccess("role:" + role);
	          }
	          throw "role must be a AV.Role or a String";
	        };
	
	        /**
	         * Set whether users belonging to the given role are allowed
	         * to read this object.
	         *
	         * @param role The name of the role, or a AV.Role object.
	         * @param {Boolean} allowed Whether the given role can read this object.
	         * @throws {String} If role is neither a AV.Role nor a String.
	         */
	        AV.ACL.prototype.setRoleReadAccess = function (role, allowed) {
	          if (role instanceof AV.Role) {
	            // Normalize to the String name
	            role = role.getName();
	          }
	          if (_.isString(role)) {
	            this.setReadAccess("role:" + role, allowed);
	            return;
	          }
	          throw "role must be a AV.Role or a String";
	        };
	
	        /**
	         * Set whether users belonging to the given role are allowed
	         * to write this object.
	         *
	         * @param role The name of the role, or a AV.Role object.
	         * @param {Boolean} allowed Whether the given role can write this object.
	         * @throws {String} If role is neither a AV.Role nor a String.
	         */
	        AV.ACL.prototype.setRoleWriteAccess = function (role, allowed) {
	          if (role instanceof AV.Role) {
	            // Normalize to the String name
	            role = role.getName();
	          }
	          if (_.isString(role)) {
	            this.setWriteAccess("role:" + role, allowed);
	            return;
	          }
	          throw "role must be a AV.Role or a String";
	        };
	      };
	    }, { "underscore": 17 }], 19: [function (require, module, exports) {
	      (function (global) {
	        module.exports = global.AV || {};
	      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, {}], 20: [function (require, module, exports) {
	      (function (global) {
	        /**
	         * 每位工程师都有保持代码优雅的义务
	         * Each engineer has a duty to keep the code elegant
	        **/
	
	        'use strict';
	
	        var _ = require('underscore');
	        var Promise = require('../promise');
	
	        // interface Storage {
	        //   readonly attribute boolean async;
	        //   string getItem(string key);
	        //   void setItem(string key, string value);
	        //   void removeItem(string key);
	        //   void clear();
	        //   Promise getItemAsync(string key);
	        //   Promise setItemAsync(string key, string value);
	        //   Promise removeItemAsync(string key);
	        //   Promise clearAsync();
	        // }
	        var Storage = {};
	        var apiNames = ['getItem', 'setItem', 'removeItem', 'clear'];
	
	        if (global.localStorage) {
	
	          var localStorage = global.localStorage;
	
	          try {
	            var testKey = '__storejs__';
	            localStorage.setItem(testKey, testKey);
	            if (localStorage.getItem(testKey) != testKey) {
	              throw new Error();
	            }
	            localStorage.removeItem(testKey);
	          } catch (e) {
	            localStorage = require('localstorage-memory');
	          }
	
	          // in browser, `localStorage.async = false` will excute `localStorage.setItem('async', false)`
	          _(apiNames).each(function (apiName) {
	            Storage[apiName] = function () {
	              return global.localStorage[apiName].apply(global.localStorage, arguments);
	            };
	          });
	          Storage.async = false;
	        } else {
	          var AsyncStorage = require('react-native').AsyncStorage;
	          _(apiNames).each(function (apiName) {
	            Storage[apiName + 'Async'] = function () {
	              return Promise.as(AsyncStorage[apiName].apply(AsyncStorage, arguments));
	            };
	          });
	          Storage.async = true;
	        }
	
	        module.exports = Storage;
	      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, { "../promise": 33, "localstorage-memory": 7, "react-native": 1, "underscore": 17 }], 21: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      'use strict';
	
	      var dataURItoBlob = function dataURItoBlob(dataURI, type) {
	        var byteString;
	
	        // 传入的 base64，不是 dataURL
	        if (dataURI.indexOf('base64') < 0) {
	          byteString = atob(dataURI);
	        } else if (dataURI.split(',')[0].indexOf('base64') >= 0) {
	          byteString = atob(dataURI.split(',')[1]);
	        } else {
	          byteString = unescape(dataURI.split(',')[1]);
	        }
	        // separate out the mime component
	        var mimeString = type || dataURI.split(',')[0].split(':')[1].split(';')[0];
	        var ia = new Uint8Array(byteString.length);
	        for (var i = 0; i < byteString.length; i++) {
	          ia[i] = byteString.charCodeAt(i);
	        }
	        return new Blob([ia], { type: mimeString });
	      };
	
	      module.exports = dataURItoBlob;
	    }, {}], 22: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var storage = require('./localstorage');
	      var AV = require('./av');
	
	      var removeAsync = exports.removeAsync = storage.removeItemAsync.bind(storage);
	
	      var getCacheData = function getCacheData(cacheData, key) {
	        try {
	          cacheData = JSON.parse(cacheData);
	        } catch (e) {
	          return null;
	        }
	        if (cacheData) {
	          var expired = cacheData.expiredAt && cacheData.expiredAt < Date.now();
	          if (!expired) {
	            return cacheData.value;
	          }
	          return removeAsync(key).then(function () {
	            return null;
	          });
	        }
	        return null;
	      };
	
	      exports.getAsync = function (key) {
	        key = AV.applicationId + "/" + key;
	        return storage.getItemAsync(key).then(function (cache) {
	          return getCacheData(cache, key);
	        });
	      };
	
	      exports.setAsync = function (key, value, ttl) {
	        var cache = { value: value };
	        if (typeof ttl === 'number') {
	          cache.expiredAt = Date.now() + ttl;
	        }
	        return storage.setItemAsync(AV.applicationId + "/" + key, JSON.stringify(cache));
	      };
	    }, { "./av": 19, "./localstorage": 30 }], 23: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	      var AVRequest = require('./request').request;
	
	      module.exports = function (AV) {
	        /**
	         * @namespace Contains functions for calling and declaring
	         * <a href="/docs/cloud_code_guide#functions">cloud functions</a>.
	         * <p><strong><em>
	         *   Some functions are only available from Cloud Code.
	         * </em></strong></p>
	         */
	        AV.Cloud = AV.Cloud || {};
	
	        _.extend(AV.Cloud, /** @lends AV.Cloud */{
	          /**
	           * Makes a call to a cloud function.
	           * @param {String} name The function name.
	           * @param {Object} data The parameters to send to the cloud function.
	           * @param {Object} options A Backbone-style options object
	           * options.success, if set, should be a function to handle a successful
	           * call to a cloud function.  options.error should be a function that
	           * handles an error running the cloud function.  Both functions are
	           * optional.  Both functions take a single argument.
	           * @return {AV.Promise} A promise that will be resolved with the result
	           * of the function.
	           */
	          run: function run(name, data, options) {
	            var request = AVRequest('functions', name, null, 'POST', AV._encode(data, null, true), options && options.sessionToken);
	
	            return request.then(function (resp) {
	              return AV._decode(null, resp).result;
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Makes a call to a cloud function, you can send {AV.Object} as param or a field of param; the response
	           * from server will also be parsed as an {AV.Object}, array of {AV.Object}, or object includes {AV.Object}
	           * @param {String} name The function name.
	           * @param {Object} data The parameters to send to the cloud function.
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that will be resolved with the result of the function.
	           */
	          rpc: function rpc(name, data, options) {
	            if (_.isArray(data)) {
	              return AV.Promise.error(new Error('Can\'t pass Array as the param of rpc function in JavaScript SDK.'))._thenRunCallbacks(options);
	            }
	
	            return AVRequest('call', name, null, 'POST', AV._encodeObjectOrArray(data), options && options.sessionToken).then(function (resp) {
	              return AV._decode('', resp).result;
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Make a call to request server date time.
	           * @param {Object} options A Backbone-style options object
	           * options.success, if set, should be a function to handle a successful
	           * call to a cloud function.  options.error should be a function that
	           * handles an error running the cloud function.  Both functions are
	           * optional.  Both functions take a single argument.
	           * @return {AV.Promise} A promise that will be resolved with the result
	           * of the function.
	           * @since 0.5.9
	           */
	          getServerDate: function getServerDate(options) {
	            var request = AVRequest("date", null, null, 'GET');
	
	            return request.then(function (resp) {
	              return AV._decode(null, resp);
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Makes a call to request a sms code for operation verification.
	           * @param {Object} data The mobile phone number string or a JSON
	           *    object that contains mobilePhoneNumber,template,op,ttl,name etc.
	           * @param {Object} options A Backbone-style options object
	           * @return {AV.Promise} A promise that will be resolved with the result
	           * of the function.
	           */
	          requestSmsCode: function requestSmsCode(data, options) {
	            if (_.isString(data)) {
	              data = { mobilePhoneNumber: data };
	            }
	            if (!data.mobilePhoneNumber) {
	              throw "Missing mobilePhoneNumber.";
	            }
	            var request = AVRequest("requestSmsCode", null, null, 'POST', data);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * Makes a call to verify sms code that sent by AV.Cloud.requestSmsCode
	           * @param {String} code The sms code sent by AV.Cloud.requestSmsCode
	           * @param {phone} phone The mobile phoner number(optional).
	           * @param {Object} options A Backbone-style options object
	           * @return {AV.Promise} A promise that will be resolved with the result
	           * of the function.
	           */
	          verifySmsCode: function verifySmsCode(code, phone, options) {
	            if (!code) throw "Missing sms code.";
	            var params = {};
	            if (_.isString(phone)) {
	              params['mobilePhoneNumber'] = phone;
	            } else {
	              // To be compatible with old versions.
	              options = phone;
	            }
	
	            var request = AVRequest("verifySmsCode", code, null, 'POST', params);
	            return request._thenRunCallbacks(options);
	          }
	        });
	      };
	    }, { "./request": 37, "underscore": 17 }], 24: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	
	      // Class used for all objects passed to error callbacks
	      function AVError(code, message) {
	        this.code = code;
	        this.message = message;
	      }
	
	      _.extend(AVError, {
	        /**
	         * Error code indicating some error other than those enumerated here.
	         * @constant
	         */
	        OTHER_CAUSE: -1,
	
	        /**
	         * Error code indicating that something has gone wrong with the server.
	         * If you get this error code, it is AV's fault. Contact us at
	         * https://avoscloud.com/help
	         * @constant
	         */
	        INTERNAL_SERVER_ERROR: 1,
	
	        /**
	         * Error code indicating the connection to the AV servers failed.
	         * @constant
	         */
	        CONNECTION_FAILED: 100,
	
	        /**
	         * Error code indicating the specified object doesn't exist.
	         * @constant
	         */
	        OBJECT_NOT_FOUND: 101,
	
	        /**
	         * Error code indicating you tried to query with a datatype that doesn't
	         * support it, like exact matching an array or object.
	         * @constant
	         */
	        INVALID_QUERY: 102,
	
	        /**
	         * Error code indicating a missing or invalid classname. Classnames are
	         * case-sensitive. They must start with a letter, and a-zA-Z0-9_ are the
	         * only valid characters.
	         * @constant
	         */
	        INVALID_CLASS_NAME: 103,
	
	        /**
	         * Error code indicating an unspecified object id.
	         * @constant
	         */
	        MISSING_OBJECT_ID: 104,
	
	        /**
	         * Error code indicating an invalid key name. Keys are case-sensitive. They
	         * must start with a letter, and a-zA-Z0-9_ are the only valid characters.
	         * @constant
	         */
	        INVALID_KEY_NAME: 105,
	
	        /**
	         * Error code indicating a malformed pointer. You should not see this unless
	         * you have been mucking about changing internal AV code.
	         * @constant
	         */
	        INVALID_POINTER: 106,
	
	        /**
	         * Error code indicating that badly formed JSON was received upstream. This
	         * either indicates you have done something unusual with modifying how
	         * things encode to JSON, or the network is failing badly.
	         * @constant
	         */
	        INVALID_JSON: 107,
	
	        /**
	         * Error code indicating that the feature you tried to access is only
	         * available internally for testing purposes.
	         * @constant
	         */
	        COMMAND_UNAVAILABLE: 108,
	
	        /**
	         * You must call AV.initialize before using the AV library.
	         * @constant
	         */
	        NOT_INITIALIZED: 109,
	
	        /**
	         * Error code indicating that a field was set to an inconsistent type.
	         * @constant
	         */
	        INCORRECT_TYPE: 111,
	
	        /**
	         * Error code indicating an invalid channel name. A channel name is either
	         * an empty string (the broadcast channel) or contains only a-zA-Z0-9_
	         * characters.
	         * @constant
	         */
	        INVALID_CHANNEL_NAME: 112,
	
	        /**
	         * Error code indicating that push is misconfigured.
	         * @constant
	         */
	        PUSH_MISCONFIGURED: 115,
	
	        /**
	         * Error code indicating that the object is too large.
	         * @constant
	         */
	        OBJECT_TOO_LARGE: 116,
	
	        /**
	         * Error code indicating that the operation isn't allowed for clients.
	         * @constant
	         */
	        OPERATION_FORBIDDEN: 119,
	
	        /**
	         * Error code indicating the result was not found in the cache.
	         * @constant
	         */
	        CACHE_MISS: 120,
	
	        /**
	         * Error code indicating that an invalid key was used in a nested
	         * JSONObject.
	         * @constant
	         */
	        INVALID_NESTED_KEY: 121,
	
	        /**
	         * Error code indicating that an invalid filename was used for AVFile.
	         * A valid file name contains only a-zA-Z0-9_. characters and is between 1
	         * and 128 characters.
	         * @constant
	         */
	        INVALID_FILE_NAME: 122,
	
	        /**
	         * Error code indicating an invalid ACL was provided.
	         * @constant
	         */
	        INVALID_ACL: 123,
	
	        /**
	         * Error code indicating that the request timed out on the server. Typically
	         * this indicates that the request is too expensive to run.
	         * @constant
	         */
	        TIMEOUT: 124,
	
	        /**
	         * Error code indicating that the email address was invalid.
	         * @constant
	         */
	        INVALID_EMAIL_ADDRESS: 125,
	
	        /**
	         * Error code indicating a missing content type.
	         * @constant
	         */
	        MISSING_CONTENT_TYPE: 126,
	
	        /**
	         * Error code indicating a missing content length.
	         * @constant
	         */
	        MISSING_CONTENT_LENGTH: 127,
	
	        /**
	         * Error code indicating an invalid content length.
	         * @constant
	         */
	        INVALID_CONTENT_LENGTH: 128,
	
	        /**
	         * Error code indicating a file that was too large.
	         * @constant
	         */
	        FILE_TOO_LARGE: 129,
	
	        /**
	         * Error code indicating an error saving a file.
	         * @constant
	         */
	        FILE_SAVE_ERROR: 130,
	
	        /**
	         * Error code indicating an error deleting a file.
	         * @constant
	         */
	        FILE_DELETE_ERROR: 153,
	
	        /**
	         * Error code indicating that a unique field was given a value that is
	         * already taken.
	         * @constant
	         */
	        DUPLICATE_VALUE: 137,
	
	        /**
	         * Error code indicating that a role's name is invalid.
	         * @constant
	         */
	        INVALID_ROLE_NAME: 139,
	
	        /**
	         * Error code indicating that an application quota was exceeded.  Upgrade to
	         * resolve.
	         * @constant
	         */
	        EXCEEDED_QUOTA: 140,
	
	        /**
	         * Error code indicating that a Cloud Code script failed.
	         * @constant
	         */
	        SCRIPT_FAILED: 141,
	
	        /**
	         * Error code indicating that a Cloud Code validation failed.
	         * @constant
	         */
	        VALIDATION_ERROR: 142,
	
	        /**
	         * Error code indicating that invalid image data was provided.
	         * @constant
	         */
	        INVALID_IMAGE_DATA: 150,
	
	        /**
	         * Error code indicating an unsaved file.
	         * @constant
	         */
	        UNSAVED_FILE_ERROR: 151,
	
	        /**
	         * Error code indicating an invalid push time.
	         */
	        INVALID_PUSH_TIME_ERROR: 152,
	
	        /**
	         * Error code indicating that the username is missing or empty.
	         * @constant
	         */
	        USERNAME_MISSING: 200,
	
	        /**
	         * Error code indicating that the password is missing or empty.
	         * @constant
	         */
	        PASSWORD_MISSING: 201,
	
	        /**
	         * Error code indicating that the username has already been taken.
	         * @constant
	         */
	        USERNAME_TAKEN: 202,
	
	        /**
	         * Error code indicating that the email has already been taken.
	         * @constant
	         */
	        EMAIL_TAKEN: 203,
	
	        /**
	         * Error code indicating that the email is missing, but must be specified.
	         * @constant
	         */
	        EMAIL_MISSING: 204,
	
	        /**
	         * Error code indicating that a user with the specified email was not found.
	         * @constant
	         */
	        EMAIL_NOT_FOUND: 205,
	
	        /**
	         * Error code indicating that a user object without a valid session could
	         * not be altered.
	         * @constant
	         */
	        SESSION_MISSING: 206,
	
	        /**
	         * Error code indicating that a user can only be created through signup.
	         * @constant
	         */
	        MUST_CREATE_USER_THROUGH_SIGNUP: 207,
	
	        /**
	         * Error code indicating that an an account being linked is already linked
	         * to another user.
	         * @constant
	         */
	        ACCOUNT_ALREADY_LINKED: 208,
	
	        /**
	         * Error code indicating that a user cannot be linked to an account because
	         * that account's id could not be found.
	         * @constant
	         */
	        LINKED_ID_MISSING: 250,
	
	        /**
	         * Error code indicating that a user with a linked (e.g. Facebook) account
	         * has an invalid session.
	         * @constant
	         */
	        INVALID_LINKED_SESSION: 251,
	
	        /**
	         * Error code indicating that a service being linked (e.g. Facebook or
	         * Twitter) is unsupported.
	         * @constant
	         */
	        UNSUPPORTED_SERVICE: 252,
	        /**
	         * Error code indicating a real error code is unavailable because
	         * we had to use an XDomainRequest object to allow CORS requests in
	         * Internet Explorer, which strips the body from HTTP responses that have
	         * a non-2XX status code.
	         * @constant
	         */
	        X_DOMAIN_REQUEST: 602
	      });
	
	      module.exports = AVError;
	    }, { "underscore": 17 }], 25: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      /*global _: false */
	      module.exports = function (AV) {
	        var eventSplitter = /\s+/;
	        var slice = Array.prototype.slice;
	
	        /**
	         * @class
	         *
	         * <p>AV.Events is a fork of Backbone's Events module, provided for your
	         * convenience.</p>
	         *
	         * <p>A module that can be mixed in to any object in order to provide
	         * it with custom events. You may bind callback functions to an event
	         * with `on`, or remove these functions with `off`.
	         * Triggering an event fires all callbacks in the order that `on` was
	         * called.
	         *
	         * <pre>
	         *     var object = {};
	         *     _.extend(object, AV.Events);
	         *     object.on('expand', function(){ alert('expanded'); });
	         *     object.trigger('expand');</pre></p>
	         *
	         * <p>For more information, see the
	         * <a href="http://documentcloud.github.com/backbone/#Events">Backbone
	         * documentation</a>.</p>
	         */
	        AV.Events = {
	          /**
	           * Bind one or more space separated events, `events`, to a `callback`
	           * function. Passing `"all"` will bind the callback to all events fired.
	           */
	          on: function on(events, callback, context) {
	
	            var calls, event, node, tail, list;
	            if (!callback) {
	              return this;
	            }
	            events = events.split(eventSplitter);
	            calls = this._callbacks || (this._callbacks = {});
	
	            // Create an immutable callback list, allowing traversal during
	            // modification.  The tail is an empty object that will always be used
	            // as the next node.
	            event = events.shift();
	            while (event) {
	              list = calls[event];
	              node = list ? list.tail : {};
	              node.next = tail = {};
	              node.context = context;
	              node.callback = callback;
	              calls[event] = { tail: tail, next: list ? list.next : node };
	              event = events.shift();
	            }
	
	            return this;
	          },
	
	          /**
	           * Remove one or many callbacks. If `context` is null, removes all callbacks
	           * with that function. If `callback` is null, removes all callbacks for the
	           * event. If `events` is null, removes all bound callbacks for all events.
	           */
	          off: function off(events, callback, context) {
	            var event, calls, node, tail, cb, ctx;
	
	            // No events, or removing *all* events.
	            if (!(calls = this._callbacks)) {
	              return;
	            }
	            if (!(events || callback || context)) {
	              delete this._callbacks;
	              return this;
	            }
	
	            // Loop through the listed events and contexts, splicing them out of the
	            // linked list of callbacks if appropriate.
	            events = events ? events.split(eventSplitter) : _.keys(calls);
	            event = events.shift();
	            while (event) {
	              node = calls[event];
	              delete calls[event];
	              if (!node || !(callback || context)) {
	                continue;
	              }
	              // Create a new list, omitting the indicated callbacks.
	              tail = node.tail;
	              node = node.next;
	              while (node !== tail) {
	                cb = node.callback;
	                ctx = node.context;
	                if (callback && cb !== callback || context && ctx !== context) {
	                  this.on(event, cb, ctx);
	                }
	                node = node.next;
	              }
	              event = events.shift();
	            }
	
	            return this;
	          },
	
	          /**
	           * Trigger one or many events, firing all bound callbacks. Callbacks are
	           * passed the same arguments as `trigger` is, apart from the event name
	           * (unless you're listening on `"all"`, which will cause your callback to
	           * receive the true name of the event as the first argument).
	           */
	          trigger: function trigger(events) {
	            var event, node, calls, tail, args, all, rest;
	            if (!(calls = this._callbacks)) {
	              return this;
	            }
	            all = calls.all;
	            events = events.split(eventSplitter);
	            rest = slice.call(arguments, 1);
	
	            // For each event, walk through the linked list of callbacks twice,
	            // first to trigger the event, then to trigger any `"all"` callbacks.
	            event = events.shift();
	            while (event) {
	              node = calls[event];
	              if (node) {
	                tail = node.tail;
	                while ((node = node.next) !== tail) {
	                  node.callback.apply(node.context || this, rest);
	                }
	              }
	              node = all;
	              if (node) {
	                tail = node.tail;
	                args = [event].concat(rest);
	                while ((node = node.next) !== tail) {
	                  node.callback.apply(node.context || this, args);
	                }
	              }
	              event = events.shift();
	            }
	
	            return this;
	          }
	        };
	
	        /**
	         * @function
	         */
	        AV.Events.bind = AV.Events.on;
	
	        /**
	         * @function
	         */
	        AV.Events.unbind = AV.Events.off;
	      };
	    }, {}], 26: [function (require, module, exports) {
	      (function (global) {
	        /**
	         * 每位工程师都有保持代码优雅的义务
	         * Each engineer has a duty to keep the code elegant
	        **/
	
	        var _ = require('underscore');
	        var cos = require('./uploader/cos');
	        var qiniu = require('./uploader/qiniu');
	        var s3 = require('./uploader/s3');
	        var AVError = require('./error');
	        var AVRequest = require('./request').request;
	
	        module.exports = function (AV) {
	
	          // 挂载一些配置
	          var avConfig = AV._config;
	
	          // port from browserify path module
	          // since react-native packager won't shim node modules.
	          var extname = function extname(path) {
	            return path.match(/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/)[4];
	          };
	
	          var b64Digit = function b64Digit(number) {
	            if (number < 26) {
	              return String.fromCharCode(65 + number);
	            }
	            if (number < 52) {
	              return String.fromCharCode(97 + (number - 26));
	            }
	            if (number < 62) {
	              return String.fromCharCode(48 + (number - 52));
	            }
	            if (number === 62) {
	              return '+';
	            }
	            if (number === 63) {
	              return '/';
	            }
	            throw new Error('Tried to encode large digit ' + number + ' in base64.');
	          };
	
	          var encodeBase64 = function encodeBase64(array) {
	            var chunks = [];
	            chunks.length = Math.ceil(array.length / 3);
	            _.times(chunks.length, function (i) {
	              var b1 = array[i * 3];
	              var b2 = array[i * 3 + 1] || 0;
	              var b3 = array[i * 3 + 2] || 0;
	
	              var has2 = i * 3 + 1 < array.length;
	              var has3 = i * 3 + 2 < array.length;
	
	              chunks[i] = [b64Digit(b1 >> 2 & 0x3F), b64Digit(b1 << 4 & 0x30 | b2 >> 4 & 0x0F), has2 ? b64Digit(b2 << 2 & 0x3C | b3 >> 6 & 0x03) : "=", has3 ? b64Digit(b3 & 0x3F) : "="].join("");
	            });
	            return chunks.join("");
	          };
	
	          // 取出 dataURL 中 base64 的部分
	          var dataURLToBase64 = function dataURLToBase64(base64) {
	            if (base64.split(',')[0] && base64.split(',')[0].indexOf('base64') >= 0) {
	              base64 = base64.split(',')[1];
	            }
	            return base64;
	          };
	
	          // 判断是否是国内节点
	          var isCnNode = function isCnNode() {
	            return avConfig.region === 'cn';
	          };
	
	          // A list of file extensions to mime types as found here:
	          // http://stackoverflow.com/questions/58510/using-net-how-can-you-find-the-
	          //     mime-type-of-a-file-based-on-the-file-signature
	          var mimeTypes = {
	            ai: "application/postscript",
	            aif: "audio/x-aiff",
	            aifc: "audio/x-aiff",
	            aiff: "audio/x-aiff",
	            asc: "text/plain",
	            atom: "application/atom+xml",
	            au: "audio/basic",
	            avi: "video/x-msvideo",
	            bcpio: "application/x-bcpio",
	            bin: "application/octet-stream",
	            bmp: "image/bmp",
	            cdf: "application/x-netcdf",
	            cgm: "image/cgm",
	            "class": "application/octet-stream",
	            cpio: "application/x-cpio",
	            cpt: "application/mac-compactpro",
	            csh: "application/x-csh",
	            css: "text/css",
	            dcr: "application/x-director",
	            dif: "video/x-dv",
	            dir: "application/x-director",
	            djv: "image/vnd.djvu",
	            djvu: "image/vnd.djvu",
	            dll: "application/octet-stream",
	            dmg: "application/octet-stream",
	            dms: "application/octet-stream",
	            doc: "application/msword",
	            docx: "application/vnd.openxmlformats-officedocument.wordprocessingml." + "document",
	            dotx: "application/vnd.openxmlformats-officedocument.wordprocessingml." + "template",
	            docm: "application/vnd.ms-word.document.macroEnabled.12",
	            dotm: "application/vnd.ms-word.template.macroEnabled.12",
	            dtd: "application/xml-dtd",
	            dv: "video/x-dv",
	            dvi: "application/x-dvi",
	            dxr: "application/x-director",
	            eps: "application/postscript",
	            etx: "text/x-setext",
	            exe: "application/octet-stream",
	            ez: "application/andrew-inset",
	            gif: "image/gif",
	            gram: "application/srgs",
	            grxml: "application/srgs+xml",
	            gtar: "application/x-gtar",
	            hdf: "application/x-hdf",
	            hqx: "application/mac-binhex40",
	            htm: "text/html",
	            html: "text/html",
	            ice: "x-conference/x-cooltalk",
	            ico: "image/x-icon",
	            ics: "text/calendar",
	            ief: "image/ief",
	            ifb: "text/calendar",
	            iges: "model/iges",
	            igs: "model/iges",
	            jnlp: "application/x-java-jnlp-file",
	            jp2: "image/jp2",
	            jpe: "image/jpeg",
	            jpeg: "image/jpeg",
	            jpg: "image/jpeg",
	            js: "application/x-javascript",
	            kar: "audio/midi",
	            latex: "application/x-latex",
	            lha: "application/octet-stream",
	            lzh: "application/octet-stream",
	            m3u: "audio/x-mpegurl",
	            m4a: "audio/mp4a-latm",
	            m4b: "audio/mp4a-latm",
	            m4p: "audio/mp4a-latm",
	            m4u: "video/vnd.mpegurl",
	            m4v: "video/x-m4v",
	            mac: "image/x-macpaint",
	            man: "application/x-troff-man",
	            mathml: "application/mathml+xml",
	            me: "application/x-troff-me",
	            mesh: "model/mesh",
	            mid: "audio/midi",
	            midi: "audio/midi",
	            mif: "application/vnd.mif",
	            mov: "video/quicktime",
	            movie: "video/x-sgi-movie",
	            mp2: "audio/mpeg",
	            mp3: "audio/mpeg",
	            mp4: "video/mp4",
	            mpe: "video/mpeg",
	            mpeg: "video/mpeg",
	            mpg: "video/mpeg",
	            mpga: "audio/mpeg",
	            ms: "application/x-troff-ms",
	            msh: "model/mesh",
	            mxu: "video/vnd.mpegurl",
	            nc: "application/x-netcdf",
	            oda: "application/oda",
	            ogg: "application/ogg",
	            pbm: "image/x-portable-bitmap",
	            pct: "image/pict",
	            pdb: "chemical/x-pdb",
	            pdf: "application/pdf",
	            pgm: "image/x-portable-graymap",
	            pgn: "application/x-chess-pgn",
	            pic: "image/pict",
	            pict: "image/pict",
	            png: "image/png",
	            pnm: "image/x-portable-anymap",
	            pnt: "image/x-macpaint",
	            pntg: "image/x-macpaint",
	            ppm: "image/x-portable-pixmap",
	            ppt: "application/vnd.ms-powerpoint",
	            pptx: "application/vnd.openxmlformats-officedocument.presentationml." + "presentation",
	            potx: "application/vnd.openxmlformats-officedocument.presentationml." + "template",
	            ppsx: "application/vnd.openxmlformats-officedocument.presentationml." + "slideshow",
	            ppam: "application/vnd.ms-powerpoint.addin.macroEnabled.12",
	            pptm: "application/vnd.ms-powerpoint.presentation.macroEnabled.12",
	            potm: "application/vnd.ms-powerpoint.template.macroEnabled.12",
	            ppsm: "application/vnd.ms-powerpoint.slideshow.macroEnabled.12",
	            ps: "application/postscript",
	            qt: "video/quicktime",
	            qti: "image/x-quicktime",
	            qtif: "image/x-quicktime",
	            ra: "audio/x-pn-realaudio",
	            ram: "audio/x-pn-realaudio",
	            ras: "image/x-cmu-raster",
	            rdf: "application/rdf+xml",
	            rgb: "image/x-rgb",
	            rm: "application/vnd.rn-realmedia",
	            roff: "application/x-troff",
	            rtf: "text/rtf",
	            rtx: "text/richtext",
	            sgm: "text/sgml",
	            sgml: "text/sgml",
	            sh: "application/x-sh",
	            shar: "application/x-shar",
	            silo: "model/mesh",
	            sit: "application/x-stuffit",
	            skd: "application/x-koan",
	            skm: "application/x-koan",
	            skp: "application/x-koan",
	            skt: "application/x-koan",
	            smi: "application/smil",
	            smil: "application/smil",
	            snd: "audio/basic",
	            so: "application/octet-stream",
	            spl: "application/x-futuresplash",
	            src: "application/x-wais-source",
	            sv4cpio: "application/x-sv4cpio",
	            sv4crc: "application/x-sv4crc",
	            svg: "image/svg+xml",
	            swf: "application/x-shockwave-flash",
	            t: "application/x-troff",
	            tar: "application/x-tar",
	            tcl: "application/x-tcl",
	            tex: "application/x-tex",
	            texi: "application/x-texinfo",
	            texinfo: "application/x-texinfo",
	            tif: "image/tiff",
	            tiff: "image/tiff",
	            tr: "application/x-troff",
	            tsv: "text/tab-separated-values",
	            txt: "text/plain",
	            ustar: "application/x-ustar",
	            vcd: "application/x-cdlink",
	            vrml: "model/vrml",
	            vxml: "application/voicexml+xml",
	            wav: "audio/x-wav",
	            wbmp: "image/vnd.wap.wbmp",
	            wbmxl: "application/vnd.wap.wbxml",
	            wml: "text/vnd.wap.wml",
	            wmlc: "application/vnd.wap.wmlc",
	            wmls: "text/vnd.wap.wmlscript",
	            wmlsc: "application/vnd.wap.wmlscriptc",
	            wrl: "model/vrml",
	            xbm: "image/x-xbitmap",
	            xht: "application/xhtml+xml",
	            xhtml: "application/xhtml+xml",
	            xls: "application/vnd.ms-excel",
	            xml: "application/xml",
	            xpm: "image/x-xpixmap",
	            xsl: "application/xml",
	            xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
	            xltx: "application/vnd.openxmlformats-officedocument.spreadsheetml." + "template",
	            xlsm: "application/vnd.ms-excel.sheet.macroEnabled.12",
	            xltm: "application/vnd.ms-excel.template.macroEnabled.12",
	            xlam: "application/vnd.ms-excel.addin.macroEnabled.12",
	            xlsb: "application/vnd.ms-excel.sheet.binary.macroEnabled.12",
	            xslt: "application/xslt+xml",
	            xul: "application/vnd.mozilla.xul+xml",
	            xwd: "image/x-xwindowdump",
	            xyz: "chemical/x-xyz",
	            zip: "application/zip"
	          };
	
	          /**
	           * Reads a File using a FileReader.
	           * @param file {File} the File to read.
	           * @param type {String} (optional) the mimetype to override with.
	           * @return {AV.Promise} A Promise that will be fulfilled with a
	           *     base64-encoded string of the data and its mime type.
	           */
	          var readAsync = function readAsync(file, type) {
	            var promise = new AV.Promise();
	
	            if (typeof FileReader === "undefined") {
	              return AV.Promise.error(new AVError(-1, "Attempted to use a FileReader on an unsupported browser."));
	            }
	
	            var reader = new global.FileReader();
	            reader.onloadend = function () {
	              if (reader.readyState !== 2) {
	                promise.reject(new AVError(-1, "Error reading file."));
	                return;
	              }
	
	              var dataURL = reader.result;
	              var matches = /^data:([^;]*);base64,(.*)$/.exec(dataURL);
	              if (!matches) {
	                promise.reject(new AVError(-1, "Unable to interpret data URL: " + dataURL));
	                return;
	              }
	
	              promise.resolve(matches[2], type || matches[1]);
	            };
	            reader.readAsDataURL(file);
	            return promise;
	          };
	
	          /**
	           * A AV.File is a local representation of a file that is saved to the AV
	           * cloud.
	           * @param name {String} The file's name. This will change to a unique value
	           *     once the file has finished saving.
	           * @param data {Array} The data for the file, as either:
	           *     1. an Array of byte value Numbers, or
	           *     2. an Object like { base64: "..." } with a base64-encoded String.
	           *     3. a File object selected with a file upload control. (3) only works
	           *        in Firefox 3.6+, Safari 6.0.2+, Chrome 7+, and IE 10+.
	           *        For example:<pre>
	           *     4.a Buffer object in Node.js runtime.
	           * var fileUploadControl = $("#profilePhotoFileUpload")[0];
	           * if (fileUploadControl.files.length > 0) {
	           *   var file = fileUploadControl.files[0];
	           *   var name = "photo.jpg";
	           *   var file = new AV.File(name, file);
	           *   file.save().then(function() {
	           *     // The file has been saved to AV.
	           *   }, function(error) {
	           *     // The file either could not be read, or could not be saved to AV.
	           *   });
	           * }</pre>
	           *
	           * @class
	           * @param type {String} Optional Content-Type header to use for the file. If
	           *     this is omitted, the content type will be inferred from the name's
	           *     extension.
	           */
	          AV.File = function (name, data, type) {
	
	            this.attributes = {
	              name: name,
	              url: '',
	              metaData: {},
	              // 用来存储转换后要上传的 base64 String
	              base64: ''
	            };
	
	            var owner = undefined;
	            if (data && data.owner) {
	              owner = data.owner;
	            } else if (!AV._config.disableCurrentUser) {
	              try {
	                owner = AV.User.current();
	              } catch (e) {
	                console.warn('Get current user failed. It seems this runtime use an async storage system, please new AV.File in the callback of AV.User.currentAsync().');
	              }
	            }
	
	            this.attributes.metaData = {
	              owner: owner ? owner.id : 'unknown'
	            };
	
	            // Guess the content type from the extension if we need to.
	            var extension = /\.([^.]*)$/.exec(name);
	            if (extension) {
	              extension = extension[1].toLowerCase();
	            }
	            var guessedType = type || mimeTypes[extension] || "text/plain";
	            this._guessedType = guessedType;
	
	            if (_.isArray(data)) {
	              this.attributes.metaData.size = data.length;
	              data = { base64: encodeBase64(data) };
	            }
	            if (data && data.base64) {
	              var parseBase64 = require('./browserify-wrapper/parse-base64');
	              var dataBase64 = parseBase64(data.base64, guessedType);
	              this.attributes.base64 = dataURLToBase64(data.base64);
	              this._source = AV.Promise.as(dataBase64, guessedType);
	            } else if (data && data.blob) {
	              if (!data.blob.type) {
	                data.blob.type = guessedType;
	              }
	              this._source = AV.Promise.as(data.blob, guessedType);
	            } else if (typeof File !== "undefined" && data instanceof global.File) {
	              this._source = AV.Promise.as(data, guessedType);
	            } else if (typeof global.Buffer !== "undefined" && global.Buffer.isBuffer(data)) {
	              // use global.Buffer to prevent browserify pack Buffer module
	              this.attributes.metaData.size = data.length;
	              this._source = AV.Promise.as(data, guessedType);
	            } else if (_.isString(data)) {
	              throw new Error("Creating a AV.File from a String is not yet supported.");
	            }
	          };
	
	          /**
	           * Creates a fresh AV.File object with exists url for saving to AVOS Cloud.
	           * @param {String} name the file name
	           * @param {String} url the file url.
	           * @param {Object} metaData the file metadata object,it's optional.
	           * @param {String} Optional Content-Type header to use for the file. If
	           *     this is omitted, the content type will be inferred from the name's
	           *     extension.
	           * @return {AV.File} the file object
	           */
	          AV.File.withURL = function (name, url, metaData, type) {
	            if (!name || !url) {
	              throw "Please provide file name and url";
	            }
	            var file = new AV.File(name, null, type);
	            //copy metaData properties to file.
	            if (metaData) {
	              for (var prop in metaData) {
	                if (!file.attributes.metaData[prop]) file.attributes.metaData[prop] = metaData[prop];
	              }
	            }
	            file.attributes.url = url;
	            //Mark the file is from external source.
	            file.attributes.metaData.__source = 'external';
	            return file;
	          };
	
	          /**
	           * Creates a file object with exists objectId.
	           * @param {String} objectId The objectId string
	           * @return {AV.File} the file object
	           */
	          AV.File.createWithoutData = function (objectId) {
	            var file = new AV.File();
	            file.id = objectId;
	            return file;
	          };
	
	          AV.File.prototype = {
	            toJSON: function toJSON() {
	              return AV._encode(this);
	            },
	
	            /**
	             * Returns the ACL for this file.
	             * @returns {AV.ACL} An instance of AV.ACL.
	             */
	            getACL: function getACL() {
	              return this._acl;
	            },
	
	            /**
	             * Sets the ACL to be used for this file.
	             * @param {AV.ACL} acl An instance of AV.ACL.
	             */
	            setACL: function setACL(acl) {
	              if (!(acl instanceof AV.ACL)) {
	                return new AVError(AVError.OTHER_CAUSE, 'ACL must be a AV.ACL.');
	              }
	              this._acl = acl;
	            },
	
	            /**
	             * Gets the name of the file. Before save is called, this is the filename
	             * given by the user. After save is called, that name gets prefixed with a
	             * unique identifier.
	             */
	            name: function name() {
	              return this.get('name');
	            },
	
	            /**
	             * Gets the url of the file. It is only available after you save the file or
	             * after you get the file from a AV.Object.
	             * @return {String}
	             */
	            url: function url() {
	              return this.get('url');
	            },
	
	            /**
	            * Gets the attributs of the file object.
	            * @param {String} The attribute name which want to get.
	            * @returns {String|Number|Array|Object}
	            */
	            get: function get(attrName) {
	              switch (attrName) {
	                case 'objectId':
	                  // 兼容 objectId
	                  return this.id;
	                default:
	                  if (this.attributes[attrName] === undefined) {
	                    return this.attributes.metaData[attrName];
	                  } else {
	                    return this.attributes[attrName];
	                  }
	              }
	            },
	
	            /**
	            * Set the metaData of the file object.
	            * @param {Object} Object is an key value Object for setting metaData.
	            * @param {String} attr is an optional metadata key.
	            * @param {Object} value is an optional metadata value.
	            * @returns {String|Number|Array|Object}
	            */
	            set: function set() {
	              var _this = this;
	
	              var set = function set(attrName, value) {
	                switch (attrName) {
	                  case 'name':
	                  case 'url':
	                  case 'base64':
	                  case 'metaData':
	                    _this.attributes[attrName] = value;
	                    break;
	                  default:
	                    // File 并非一个 AVObject，不能完全自定义其他属性，所以只能都放在 metaData 上面
	                    _this.attributes.metaData[attrName] = value;
	                    break;
	                }
	              };
	
	              switch (arguments.length) {
	                case 1:
	                  // 传入一个 Object
	                  for (var k in arguments.length <= 0 ? undefined : arguments[0]) {
	                    set(k, (arguments.length <= 0 ? undefined : arguments[0])[k]);
	                  }
	                  break;
	                case 2:
	                  set(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1]);
	                  break;
	              }
	            },
	
	            /**
	            * <p>Returns the file's metadata JSON object if no arguments is given.Returns the
	            * metadata value if a key is given.Set metadata value if key and value are both given.</p>
	            * <p><pre>
	            *  var metadata = file.metaData(); //Get metadata JSON object.
	            *  var size = file.metaData('size');  // Get the size metadata value.
	            *  file.metaData('format', 'jpeg'); //set metadata attribute and value.
	            *</pre></p>
	            * @return {Object} The file's metadata JSON object.
	            * @param {String} attr an optional metadata key.
	            * @param {Object} value an optional metadata value.
	            **/
	            metaData: function metaData(attr, value) {
	              if (attr && value) {
	                this.attributes.metaData[attr] = value;
	                return this;
	              } else if (attr && !value) {
	                return this.attributes.metaData[attr];
	              } else {
	                return this.attributes.metaData;
	              }
	            },
	
	            /**
	             * 如果文件是图片，获取图片的缩略图URL。可以传入宽度、高度、质量、格式等参数。
	             * @return {String} 缩略图URL
	             * @param {Number} width 宽度，单位：像素
	             * @param {Number} heigth 高度，单位：像素
	             * @param {Number} quality 质量，1-100的数字，默认100
	             * @param {Number} scaleToFit 是否将图片自适应大小。默认为true。
	             * @param {String} fmt 格式，默认为png，也可以为jpeg,gif等格式。
	             */
	
	            thumbnailURL: function thumbnailURL(width, height, quality, scaleToFit, fmt) {
	              var url = this.attributes.url;
	              if (!url) {
	                throw new Error('Invalid url.');
	              }
	              if (!width || !height || width <= 0 || height <= 0) {
	                throw new Error('Invalid width or height value.');
	              }
	              quality = quality || 100;
	              scaleToFit = !scaleToFit ? true : scaleToFit;
	              if (quality <= 0 || quality > 100) {
	                throw new Error('Invalid quality value.');
	              }
	              fmt = fmt || 'png';
	              var mode = scaleToFit ? 2 : 1;
	              return url + '?imageView/' + mode + '/w/' + width + '/h/' + height + '/q/' + quality + '/format/' + fmt;
	            },
	
	            /**
	            * Returns the file's size.
	            * @return {Number} The file's size in bytes.
	            **/
	            size: function size() {
	              return this.metaData().size;
	            },
	
	            /**
	             * Returns the file's owner.
	             * @return {String} The file's owner id.
	             */
	            ownerId: function ownerId() {
	              return this.metaData().owner;
	            },
	
	            /**
	            * Destroy the file.
	            * @return {AV.Promise} A promise that is fulfilled when the destroy
	            *     completes.
	            */
	            destroy: function destroy(options) {
	              if (!this.id) {
	                return AV.Promise.error('The file id is not eixsts.')._thenRunCallbacks(options);
	              }
	              var request = AVRequest("files", null, this.id, 'DELETE', options && options.sessionToken);
	              return request._thenRunCallbacks(options);
	            },
	
	            /**
	             * Request Qiniu upload token
	             * @param {string} type
	             * @return {AV.Promise} Resolved with the response
	             * @private
	             */
	            _fileToken: function _fileToken(type) {
	              var route = arguments.length <= 1 || arguments[1] === undefined ? 'fileTokens' : arguments[1];
	
	              var name = this.attributes.name;
	
	              // Create 16-bits uuid as qiniu key.
	              var extName = extname(name);
	              var hexOctet = function hexOctet() {
	                return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	              };
	              var key = hexOctet() + hexOctet() + hexOctet() + hexOctet() + hexOctet() + extName;
	              var data = {
	                key: key,
	                name: name,
	                ACL: this._acl,
	                mime_type: type,
	                metaData: this.attributes.metaData
	              };
	              if (type && !this.attributes.metaData.mime_type) {
	                this.attributes.metaData.mime_type = type;
	              }
	              this._qiniu_key = key;
	              return AVRequest(route, null, null, 'POST', data);
	            },
	
	
	            /**
	             * @callback UploadProgressCallback
	             * @param {XMLHttpRequestProgressEvent} event - The progress event with 'loaded' and 'total' attributes
	             */
	            /**
	             * Saves the file to the AV cloud.
	             * @param {Object} saveOptions
	             * @param {UploadProgressCallback} [saveOptions.onProgress]
	             * @param {Object} options A Backbone-style options object.
	             * @return {AV.Promise} Promise that is resolved when the save finishes.
	             */
	            save: function save() {
	              var _this2 = this;
	
	              if (this.id) {
	                throw new Error('File already saved. If you want to manipulate a file, use AV.Query to get it.');
	              }
	              var options = undefined;
	              var saveOptions = {};
	              switch (arguments.length) {
	                case 1:
	                  options = arguments.length <= 0 ? undefined : arguments[0];
	                  break;
	                case 2:
	                  saveOptions = arguments.length <= 0 ? undefined : arguments[0];
	                  options = arguments.length <= 1 ? undefined : arguments[1];
	                  break;
	              }
	              if (!this._previousSave) {
	                if (this._source) {
	                  this._previousSave = this._source.then(function (data, type) {
	                    return _this2._fileToken(type).then(function (uploadInfo) {
	                      var uploadPromise = undefined;
	                      switch (uploadInfo.provider) {
	                        case 's3':
	                          uploadPromise = s3(uploadInfo, data, _this2, saveOptions);
	                          break;
	                        case 'qcloud':
	                          uploadPromise = cos(uploadInfo, data, _this2, saveOptions);
	                          break;
	                        case 'qiniu':
	                        default:
	                          uploadPromise = qiniu(uploadInfo, data, _this2, saveOptions);
	                          break;
	                      }
	                      return uploadPromise.catch(function (err) {
	                        // destroy this file object when upload fails.
	                        _this2.destroy();
	                        throw err;
	                      });
	                    });
	                  });
	                } else if (this.attributes.url && this.attributes.metaData.__source === 'external') {
	                  // external link file.
	                  var data = {
	                    name: this.attributes.name,
	                    ACL: this._acl,
	                    metaData: this.attributes.metaData,
	                    mime_type: this._guessedType,
	                    url: this.attributes.url
	                  };
	                  this._previousSave = AVRequest('files', this.attributes.name, null, 'post', data).then(function (response) {
	                    _this2.attributes.name = response.name;
	                    _this2.attributes.url = response.url;
	                    _this2.id = response.objectId;
	                    if (response.size) {
	                      _this2.attributes.metaData.size = response.size;
	                    }
	                    return _this2;
	                  });
	                }
	              }
	              return this._previousSave._thenRunCallbacks(options);
	            },
	
	            /**
	            * fetch the file from server. If the server's representation of the
	            * model differs from its current attributes, they will be overriden,
	            * @param {Object} fetchOptions Optional options to set 'keys' and
	            *      'include' option.
	            * @param {Object} options Optional Backbone-like options object to be
	            *     passed in to set.
	            * @return {AV.Promise} A promise that is fulfilled when the fetch
	            *     completes.
	            */
	            fetch: function fetch() {
	              var _this3 = this;
	
	              var options = null;
	              var fetchOptions = {};
	              if (arguments.length === 1) {
	                options = arguments[0];
	              } else if (arguments.length === 2) {
	                fetchOptions = arguments[0];
	                options = arguments[1];
	              }
	
	              var request = AVRequest('files', null, this.id, 'GET', fetchOptions);
	              return request.then(function (response) {
	                var value = AV.Object.prototype.parse(response);
	                value.attributes = {
	                  name: value.name,
	                  url: value.url
	                };
	                value.attributes.metaData = value.metaData || {};
	                // clean
	                delete value.objectId;
	                delete value.metaData;
	                delete value.url;
	                delete value.name;
	                _.extend(_this3, value);
	                return _this3;
	              })._thenRunCallbacks(options);
	            }
	          };
	        };
	      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	    }, { "./browserify-wrapper/parse-base64": 21, "./error": 24, "./request": 37, "./uploader/cos": 41, "./uploader/qiniu": 42, "./uploader/s3": 43, "underscore": 17 }], 27: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	
	      /*global navigator: false */
	      module.exports = function (AV) {
	        /**
	         * Creates a new GeoPoint with any of the following forms:<br>
	         *   <pre>
	         *   new GeoPoint(otherGeoPoint)
	         *   new GeoPoint(30, 30)
	         *   new GeoPoint([30, 30])
	         *   new GeoPoint({latitude: 30, longitude: 30})
	         *   new GeoPoint()  // defaults to (0, 0)
	         *   </pre>
	         * @class
	         *
	         * <p>Represents a latitude / longitude point that may be associated
	         * with a key in a AVObject or used as a reference point for geo queries.
	         * This allows proximity-based queries on the key.</p>
	         *
	         * <p>Only one key in a class may contain a GeoPoint.</p>
	         *
	         * <p>Example:<pre>
	         *   var point = new AV.GeoPoint(30.0, -20.0);
	         *   var object = new AV.Object("PlaceObject");
	         *   object.set("location", point);
	         *   object.save();</pre></p>
	         */
	        AV.GeoPoint = function (arg1, arg2) {
	          if (_.isArray(arg1)) {
	            AV.GeoPoint._validate(arg1[0], arg1[1]);
	            this.latitude = arg1[0];
	            this.longitude = arg1[1];
	          } else if (_.isObject(arg1)) {
	            AV.GeoPoint._validate(arg1.latitude, arg1.longitude);
	            this.latitude = arg1.latitude;
	            this.longitude = arg1.longitude;
	          } else if (_.isNumber(arg1) && _.isNumber(arg2)) {
	            AV.GeoPoint._validate(arg1, arg2);
	            this.latitude = arg1;
	            this.longitude = arg2;
	          } else {
	            this.latitude = 0;
	            this.longitude = 0;
	          }
	
	          // Add properties so that anyone using Webkit or Mozilla will get an error
	          // if they try to set values that are out of bounds.
	          var self = this;
	          if (this.__defineGetter__ && this.__defineSetter__) {
	            // Use _latitude and _longitude to actually store the values, and add
	            // getters and setters for latitude and longitude.
	            this._latitude = this.latitude;
	            this._longitude = this.longitude;
	            this.__defineGetter__("latitude", function () {
	              return self._latitude;
	            });
	            this.__defineGetter__("longitude", function () {
	              return self._longitude;
	            });
	            this.__defineSetter__("latitude", function (val) {
	              AV.GeoPoint._validate(val, self.longitude);
	              self._latitude = val;
	            });
	            this.__defineSetter__("longitude", function (val) {
	              AV.GeoPoint._validate(self.latitude, val);
	              self._longitude = val;
	            });
	          }
	        };
	
	        /**
	         * @lends AV.GeoPoint.prototype
	         * @property {float} latitude North-south portion of the coordinate, in range
	         *   [-90, 90].  Throws an exception if set out of range in a modern browser.
	         * @property {float} longitude East-west portion of the coordinate, in range
	         *   [-180, 180].  Throws if set out of range in a modern browser.
	         */
	
	        /**
	         * Throws an exception if the given lat-long is out of bounds.
	         */
	        AV.GeoPoint._validate = function (latitude, longitude) {
	          if (latitude < -90.0) {
	            throw "AV.GeoPoint latitude " + latitude + " < -90.0.";
	          }
	          if (latitude > 90.0) {
	            throw "AV.GeoPoint latitude " + latitude + " > 90.0.";
	          }
	          if (longitude < -180.0) {
	            throw "AV.GeoPoint longitude " + longitude + " < -180.0.";
	          }
	          if (longitude > 180.0) {
	            throw "AV.GeoPoint longitude " + longitude + " > 180.0.";
	          }
	        };
	
	        /**
	         * Creates a GeoPoint with the user's current location, if available.
	         * Calls options.success with a new GeoPoint instance or calls options.error.
	         * @param {Object} options An object with success and error callbacks.
	         */
	        AV.GeoPoint.current = function (options) {
	          var promise = new AV.Promise();
	          navigator.geolocation.getCurrentPosition(function (location) {
	            promise.resolve(new AV.GeoPoint({
	              latitude: location.coords.latitude,
	              longitude: location.coords.longitude
	            }));
	          }, function (error) {
	            promise.reject(error);
	          });
	
	          return promise._thenRunCallbacks(options);
	        };
	
	        AV.GeoPoint.prototype = {
	          /**
	           * Returns a JSON representation of the GeoPoint, suitable for AV.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            AV.GeoPoint._validate(this.latitude, this.longitude);
	            return {
	              "__type": "GeoPoint",
	              latitude: this.latitude,
	              longitude: this.longitude
	            };
	          },
	
	          /**
	           * Returns the distance from this GeoPoint to another in radians.
	           * @param {AV.GeoPoint} point the other AV.GeoPoint.
	           * @return {Number}
	           */
	          radiansTo: function radiansTo(point) {
	            var d2r = Math.PI / 180.0;
	            var lat1rad = this.latitude * d2r;
	            var long1rad = this.longitude * d2r;
	            var lat2rad = point.latitude * d2r;
	            var long2rad = point.longitude * d2r;
	            var deltaLat = lat1rad - lat2rad;
	            var deltaLong = long1rad - long2rad;
	            var sinDeltaLatDiv2 = Math.sin(deltaLat / 2);
	            var sinDeltaLongDiv2 = Math.sin(deltaLong / 2);
	            // Square of half the straight line chord distance between both points.
	            var a = sinDeltaLatDiv2 * sinDeltaLatDiv2 + Math.cos(lat1rad) * Math.cos(lat2rad) * sinDeltaLongDiv2 * sinDeltaLongDiv2;
	            a = Math.min(1.0, a);
	            return 2 * Math.asin(Math.sqrt(a));
	          },
	
	          /**
	           * Returns the distance from this GeoPoint to another in kilometers.
	           * @param {AV.GeoPoint} point the other AV.GeoPoint.
	           * @return {Number}
	           */
	          kilometersTo: function kilometersTo(point) {
	            return this.radiansTo(point) * 6371.0;
	          },
	
	          /**
	           * Returns the distance from this GeoPoint to another in miles.
	           * @param {AV.GeoPoint} point the other AV.GeoPoint.
	           * @return {Number}
	           */
	          milesTo: function milesTo(point) {
	            return this.radiansTo(point) * 3958.8;
	          }
	        };
	      };
	    }, { "underscore": 17 }], 28: [function (require, module, exports) {
	      /*!
	       * LeanCloud JavaScript SDK
	       * https://leancloud.cn
	       *
	       * Copyright 2016 LeanCloud.cn, Inc.
	       * The LeanCloud JavaScript SDK is freely distributable under the MIT license.
	       */
	
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var AV = module.exports = require('./av');
	
	      AV._ = require('underscore');
	      AV.version = require('./version');
	      AV.Promise = require('./promise');
	      AV.localStorage = require('./localstorage');
	      AV.Cache = require('./cache');
	
	      // All internal configuration items
	      AV._config = AV._config || {};
	
	      require('./utils').init(AV);
	
	      require('./event')(AV);
	      require('./geopoint')(AV);
	      require('./acl')(AV);
	      require('./op')(AV);
	      require('./relation')(AV);
	      require('./file')(AV);
	      require('./object')(AV);
	      require('./role')(AV);
	      require('./user')(AV);
	      require('./query')(AV);
	      require('./cloudfunction')(AV);
	      require('./push')(AV);
	      require('./status')(AV);
	      require('./search')(AV);
	      require('./insight')(AV);
	
	      // TODO: deprecated AV.Error()
	      var AVError = require('./error');
	      /**
	       * @deprecated AV.Error() is deprecated, and will be removed in next release.
	       */
	      AV.Error = function () {
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        console.warn('AV.Error() is deprecated, and will be removed in next release.');
	        new (Function.prototype.bind.apply(AVError, [null].concat(args)))();
	      };
	    }, { "./acl": 18, "./av": 19, "./cache": 22, "./cloudfunction": 23, "./error": 24, "./event": 25, "./file": 26, "./geopoint": 27, "./insight": 29, "./localstorage": 30, "./object": 31, "./op": 32, "./promise": 33, "./push": 34, "./query": 35, "./relation": 36, "./role": 38, "./search": 39, "./status": 40, "./user": 44, "./utils": 45, "./version": 46, "underscore": 17 }], 29: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	      var AVError = require('./error');
	      var AVRequest = require('./request').request;
	
	      module.exports = function (AV) {
	        /**
	         * @namespace 包含了使用了 LeanCloud
	         *  <a href='/docs/leaninsight_guide.html'>离线数据分析功能</a>的函数。
	         * <p><strong><em>
	         *   部分函数仅在云引擎运行环境下有效。
	         * </em></strong></p>
	         */
	        AV.Insight = AV.Insight || {};
	
	        _.extend(AV.Insight, /** @lends AV.Insight */{
	
	          /**
	           * 开始一个 Insight 任务。结果里将返回 Job id，你可以拿得到的 id 使用
	           * AV.Insight.JobQuery 查询任务状态和结果。
	           * @param {Object} jobConfig 任务配置的 JSON 对象，例如：<code><pre>
	           *                   { "sql" : "select count(*) as c,gender from _User group by gender",
	           *                     "saveAs": {
	           *                         "className" : "UserGender",
	           *                         "limit": 1
	           *                      }
	           *                   }
	           *                  </pre></code>
	           *               sql 指定任务执行的 SQL 语句， saveAs（可选） 指定将结果保存在哪张表里，limit 最大 1000。
	           * @param {Object} options A Backbone-style options object
	           * options.success, if set, should be a function to handle a successful
	           * call to a cloud function.  options.error should be a function that
	           * handles an error running the cloud function.  Both functions are
	           * optional.  Both functions take a single argument.
	           * @return {AV.Promise} A promise that will be resolved with the result
	           * of the function.
	           */
	          startJob: function startJob(jobConfig, options) {
	            if (!jobConfig || !jobConfig.sql) {
	              throw new Error('Please provide the sql to run the job.');
	            }
	            var data = {
	              jobConfig: jobConfig,
	              appId: AV.applicationId
	            };
	            var request = AVRequest("bigquery", 'jobs', null, 'POST', AV._encode(data, null, true));
	
	            return request.then(function (resp) {
	              return AV._decode(null, resp).id;
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * 监听 Insight 任务事件，目前仅支持 end 事件，表示任务完成。
	           *  <p><strong><em>
	           *     仅在云引擎运行环境下有效。
	           *  </em></strong></p>
	           * @param {String} event 监听的事件，目前仅支持 'end' ，表示任务完成
	           * @param {Function} 监听回调函数，接收 (err, id) 两个参数，err 表示错误信息，
	           *                   id 表示任务 id。接下来你可以拿这个 id 使用AV.Insight.JobQuery 查询任务状态和结果。
	           *
	           */
	          on: function on(event, cb) {}
	        });
	
	        /**
	         * 创建一个对象，用于查询 Insight 任务状态和结果。
	         * @class
	         * @param {String} id 任务 id
	         * @since 0.5.5
	         */
	        AV.Insight.JobQuery = function (id, className) {
	          if (!id) {
	            throw new Error('Please provide the job id.');
	          }
	          this.id = id;
	          this.className = className;
	          this._skip = 0;
	          this._limit = 100;
	        };
	
	        AV.Insight.JobQuery.prototype = {
	
	          /**
	           * Sets the number of results to skip before returning any results.
	           * This is useful for pagination.
	           * Default is to skip zero results.
	           * @param {Number} n the number of results to skip.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          skip: function skip(n) {
	            this._skip = n;
	            return this;
	          },
	
	          /**
	           * Sets the limit of the number of results to return. The default limit is
	           * 100, with a maximum of 1000 results being returned at a time.
	           * @param {Number} n the number of results to limit to.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          limit: function limit(n) {
	            this._limit = n;
	            return this;
	          },
	
	          /**
	           * 查询任务状态和结果，任务结果为一个 JSON 对象，包括 status 表示任务状态， totalCount 表示总数，
	           * results 数组表示任务结果数组，previewCount 表示可以返回的结果总数，任务的开始和截止时间
	           * startTime、endTime 等信息。
	           *
	           * @param {Object} options A Backbone-style options object
	           * options.success, if set, should be a function to handle a successful
	           * call to a cloud function.  options.error should be a function that
	           * handles an error running the cloud function.  Both functions are
	           * optional.  Both functions take a single argument.
	           * @return {AV.Promise} A promise that will be resolved with the result
	           * of the function.
	           *
	           */
	          find: function find(options) {
	            var params = {
	              skip: this._skip,
	              limit: this._limit
	            };
	
	            var request = AVRequest("bigquery", 'jobs', this.id, "GET", params);
	            var self = this;
	            return request.then(function (response) {
	              if (response.error) {
	                return AV.Promise.error(new AVError(response.code, response.error));
	              }
	              return AV.Promise.as(response);
	            })._thenRunCallbacks(options);
	          }
	
	        };
	      };
	    }, { "./error": 24, "./request": 37, "underscore": 17 }], 30: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      'use strict';
	
	      var _ = require('underscore');
	      var Promise = require('./promise');
	      var localStorage = require('./browserify-wrapper/localStorage');
	
	      var syncApiNames = ['getItem', 'setItem', 'removeItem', 'clear'];
	
	      if (!localStorage.async) {
	        // wrap sync apis with async ones.
	        _(syncApiNames).each(function (apiName) {
	          if (typeof localStorage[apiName] === 'function') {
	            localStorage[apiName + 'Async'] = function () {
	              return Promise.as(localStorage[apiName].apply(localStorage, arguments));
	            };
	          }
	        });
	      } else {
	        _(syncApiNames).each(function (apiName) {
	          if (typeof localStorage[apiName] !== 'function') {
	            localStorage[apiName] = function () {
	              throw new Error('Synchronous API [' + apiName + '] is not available in this runtime.');
	            };
	          }
	        });
	      }
	
	      module.exports = localStorage;
	    }, { "./browserify-wrapper/localStorage": 20, "./promise": 33, "underscore": 17 }], 31: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	      var AVError = require('./error');
	      var AVRequest = require('./request').request;
	      var utils = require('./utils');
	
	      // AV.Object is analogous to the Java AVObject.
	      // It also implements the same interface as a Backbone model.
	
	      module.exports = function (AV) {
	        /**
	         * Creates a new model with defined attributes. A client id (cid) is
	         * automatically generated and assigned for you.
	         *
	         * <p>You won't normally call this method directly.  It is recommended that
	         * you use a subclass of <code>AV.Object</code> instead, created by calling
	         * <code>extend</code>.</p>
	         *
	         * <p>However, if you don't want to use a subclass, or aren't sure which
	         * subclass is appropriate, you can use this form:<pre>
	         *     var object = new AV.Object("ClassName");
	         * </pre>
	         * That is basically equivalent to:<pre>
	         *     var MyClass = AV.Object.extend("ClassName");
	         *     var object = new MyClass();
	         * </pre></p>
	         *
	         * @param {Object} attributes The initial set of data to store in the object.
	         * @param {Object} options A set of Backbone-like options for creating the
	         *     object.  The only option currently supported is "collection".
	         * @see AV.Object.extend
	         *
	         * @class
	         *
	         * <p>The fundamental unit of AV data, which implements the Backbone Model
	         * interface.</p>
	         */
	        AV.Object = function (attributes, options) {
	          // Allow new AV.Object("ClassName") as a shortcut to _create.
	          if (_.isString(attributes)) {
	            return AV.Object._create.apply(this, arguments);
	          }
	
	          attributes = attributes || {};
	          if (options && options.parse) {
	            attributes = this.parse(attributes);
	          }
	          var defaults = AV._getValue(this, 'defaults');
	          if (defaults) {
	            attributes = _.extend({}, defaults, attributes);
	          }
	          if (options && options.collection) {
	            this.collection = options.collection;
	          }
	
	          this._serverData = {}; // The last known data for this object from cloud.
	          this._opSetQueue = [{}]; // List of sets of changes to the data.
	          this.attributes = {}; // The best estimate of this's current data.
	
	          this._hashedJSON = {}; // Hash of values of containers at last save.
	          this._escapedAttributes = {};
	          this.cid = _.uniqueId('c');
	          this.changed = {};
	          this._silent = {};
	          this._pending = {};
	          if (!this.set(attributes, { silent: true })) {
	            throw new Error("Can't create an invalid AV.Object");
	          }
	          this.changed = {};
	          this._silent = {};
	          this._pending = {};
	          this._hasData = true;
	          this._previousAttributes = _.clone(this.attributes);
	          this.initialize.apply(this, arguments);
	        };
	
	        /**
	         * @lends AV.Object.prototype
	         * @property {String} id The objectId of the AV Object.
	         */
	
	        /**
	         * Saves the given list of AV.Object.
	         * If any error is encountered, stops and calls the error handler.
	         * There are two ways you can call this function.
	         *
	         * The Backbone way:<pre>
	         *   AV.Object.saveAll([object1, object2, ...], {
	         *     success: function(list) {
	         *       // All the objects were saved.
	         *     },
	         *     error: function(error) {
	         *       // An error occurred while saving one of the objects.
	         *     },
	         *   });
	         * </pre>
	         * A simplified syntax:<pre>
	         *   AV.Object.saveAll([object1, object2, ...], function(list, error) {
	         *     if (list) {
	         *       // All the objects were saved.
	         *     } else {
	         *       // An error occurred.
	         *     }
	         *   });
	         * </pre>
	         *
	         * @param {Array} list A list of <code>AV.Object</code>.
	         * @param {Object} options A Backbone-style callback object.
	         */
	        AV.Object.saveAll = function (list, options) {
	          return AV.Object._deepSaveAsync(list, null, options)._thenRunCallbacks(options);
	        };
	
	        // Attach all inheritable methods to the AV.Object prototype.
	        _.extend(AV.Object.prototype, AV.Events,
	        /** @lends AV.Object.prototype */{
	          _fetchWhenSave: false,
	
	          /**
	           * Initialize is an empty function by default. Override it with your own
	           * initialization logic.
	           */
	          initialize: function initialize() {},
	
	          /**
	            * Set whether to enable fetchWhenSave option when updating object.
	            * When set true, SDK would fetch the latest object after saving.
	            * Default is false.
	            *
	            * @deprecated use AV.Object#save with options.fetchWhenSave instead
	            * @param {boolean} enable  true to enable fetchWhenSave option.
	            */
	          fetchWhenSave: function fetchWhenSave(enable) {
	            console.warn('AV.Object#fetchWhenSave is deprecated, use AV.Object#save with options.fetchWhenSave instead.');
	            if (!_.isBoolean(enable)) {
	              throw "Expect boolean value for fetchWhenSave";
	            }
	            this._fetchWhenSave = enable;
	          },
	
	          /**
	           * Returns the object's objectId.
	           * @return {String} the objectId.
	           */
	          getObjectId: function getObjectId() {
	            return this.id;
	          },
	
	          /**
	           * Returns the object's createdAt attribute.
	           * @return {Date}
	           */
	          getCreatedAt: function getCreatedAt() {
	            return this.createdAt || this.get('createdAt');
	          },
	
	          /**
	           * Returns the object's updatedAt attribute.
	           * @return {Date}
	           */
	          getUpdatedAt: function getUpdatedAt() {
	            return this.updatedAt || this.get('updatedAt');
	          },
	
	          /**
	           * Returns a JSON version of the object suitable for saving to AV.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            var json = this._toFullJSON();
	            AV._arrayEach(["__type", "className"], function (key) {
	              delete json[key];
	            });
	            return json;
	          },
	
	          _toFullJSON: function _toFullJSON(seenObjects) {
	            var json = _.clone(this.attributes);
	            AV._objectEach(json, function (val, key) {
	              json[key] = AV._encode(val, seenObjects);
	            });
	            AV._objectEach(this._operations, function (val, key) {
	              json[key] = val;
	            });
	
	            if (_.has(this, "id")) {
	              json.objectId = this.id;
	            }
	            if (_.has(this, "createdAt")) {
	              if (_.isDate(this.createdAt)) {
	                json.createdAt = this.createdAt.toJSON();
	              } else {
	                json.createdAt = this.createdAt;
	              }
	            }
	
	            if (_.has(this, "updatedAt")) {
	              if (_.isDate(this.updatedAt)) {
	                json.updatedAt = this.updatedAt.toJSON();
	              } else {
	                json.updatedAt = this.updatedAt;
	              }
	            }
	            json.__type = "Object";
	            json.className = this.className;
	            return json;
	          },
	
	          /**
	           * Updates _hashedJSON to reflect the current state of this object.
	           * Adds any changed hash values to the set of pending changes.
	           */
	          _refreshCache: function _refreshCache() {
	            var self = this;
	            if (self._refreshingCache) {
	              return;
	            }
	            self._refreshingCache = true;
	            AV._objectEach(this.attributes, function (value, key) {
	              if (value instanceof AV.Object) {
	                value._refreshCache();
	              } else if (_.isObject(value)) {
	                if (self._resetCacheForKey(key)) {
	                  self.set(key, new AV.Op.Set(value), { silent: true });
	                }
	              }
	            });
	            delete self._refreshingCache;
	          },
	
	          /**
	           * Returns true if this object has been modified since its last
	           * save/refresh.  If an attribute is specified, it returns true only if that
	           * particular attribute has been modified since the last save/refresh.
	           * @param {String} attr An attribute name (optional).
	           * @return {Boolean}
	           */
	          dirty: function dirty(attr) {
	            this._refreshCache();
	
	            var currentChanges = _.last(this._opSetQueue);
	
	            if (attr) {
	              return currentChanges[attr] ? true : false;
	            }
	            if (!this.id) {
	              return true;
	            }
	            if (_.keys(currentChanges).length > 0) {
	              return true;
	            }
	            return false;
	          },
	
	          /**
	           * Gets a Pointer referencing this Object.
	           */
	          _toPointer: function _toPointer() {
	            // if (!this.id) {
	            //   throw new Error("Can't serialize an unsaved AV.Object");
	            // }
	            return { __type: "Pointer",
	              className: this.className,
	              objectId: this.id };
	          },
	
	          /**
	           * Gets the value of an attribute.
	           * @param {String} attr The string name of an attribute.
	           */
	          get: function get(attr) {
	            switch (attr) {
	              case 'objectId':
	                // 兼容 objectId
	                return this.id;
	              default:
	                // 兼容 createdAt、updatedAt
	                if (this.attributes[attr] === undefined) {
	                  return this[attr];
	                } else {
	                  return this.attributes[attr];
	                }
	            }
	          },
	
	          /**
	           * Gets a relation on the given class for the attribute.
	           * @param String attr The attribute to get the relation for.
	           */
	          relation: function relation(attr) {
	            var value = this.get(attr);
	            if (value) {
	              if (!(value instanceof AV.Relation)) {
	                throw "Called relation() on non-relation field " + attr;
	              }
	              value._ensureParentAndKey(this, attr);
	              return value;
	            } else {
	              return new AV.Relation(this, attr);
	            }
	          },
	
	          /**
	           * Gets the HTML-escaped value of an attribute.
	           */
	          escape: function escape(attr) {
	            var html = this._escapedAttributes[attr];
	            if (html) {
	              return html;
	            }
	            var val = this.attributes[attr];
	            var escaped;
	            if (utils.isNullOrUndefined(val)) {
	              escaped = '';
	            } else {
	              escaped = _.escape(val.toString());
	            }
	            this._escapedAttributes[attr] = escaped;
	            return escaped;
	          },
	
	          /**
	           * Returns <code>true</code> if the attribute contains a value that is not
	           * null or undefined.
	           * @param {String} attr The string name of the attribute.
	           * @return {Boolean}
	           */
	          has: function has(attr) {
	            return !utils.isNullOrUndefined(this.attributes[attr]);
	          },
	
	          /**
	           * Pulls "special" fields like objectId, createdAt, etc. out of attrs
	           * and puts them on "this" directly.  Removes them from attrs.
	           * @param attrs - A dictionary with the data for this AV.Object.
	           */
	          _mergeMagicFields: function _mergeMagicFields(attrs) {
	            // Check for changes of magic fields.
	            var model = this;
	            var specialFields = ["id", "objectId", "createdAt", "updatedAt"];
	            AV._arrayEach(specialFields, function (attr) {
	              if (attrs[attr]) {
	                if (attr === "objectId") {
	                  model.id = attrs[attr];
	                } else if ((attr === "createdAt" || attr === "updatedAt") && !_.isDate(attrs[attr])) {
	                  model[attr] = AV._parseDate(attrs[attr]);
	                } else {
	                  model[attr] = attrs[attr];
	                }
	                delete attrs[attr];
	              }
	            });
	          },
	
	          /**
	           * Returns the json to be sent to the server.
	           */
	          _startSave: function _startSave() {
	            this._opSetQueue.push({});
	          },
	
	          /**
	           * Called when a save fails because of an error. Any changes that were part
	           * of the save need to be merged with changes made after the save. This
	           * might throw an exception is you do conflicting operations. For example,
	           * if you do:
	           *   object.set("foo", "bar");
	           *   object.set("invalid field name", "baz");
	           *   object.save();
	           *   object.increment("foo");
	           * then this will throw when the save fails and the client tries to merge
	           * "bar" with the +1.
	           */
	          _cancelSave: function _cancelSave() {
	            var self = this;
	            var failedChanges = _.first(this._opSetQueue);
	            this._opSetQueue = _.rest(this._opSetQueue);
	            var nextChanges = _.first(this._opSetQueue);
	            AV._objectEach(failedChanges, function (op, key) {
	              var op1 = failedChanges[key];
	              var op2 = nextChanges[key];
	              if (op1 && op2) {
	                nextChanges[key] = op2._mergeWithPrevious(op1);
	              } else if (op1) {
	                nextChanges[key] = op1;
	              }
	            });
	            this._saving = this._saving - 1;
	          },
	
	          /**
	           * Called when a save completes successfully. This merges the changes that
	           * were saved into the known server data, and overrides it with any data
	           * sent directly from the server.
	           */
	          _finishSave: function _finishSave(serverData) {
	            // Grab a copy of any object referenced by this object. These instances
	            // may have already been fetched, and we don't want to lose their data.
	            // Note that doing it like this means we will unify separate copies of the
	            // same object, but that's a risk we have to take.
	            var fetchedObjects = {};
	            AV._traverse(this.attributes, function (object) {
	              if (object instanceof AV.Object && object.id && object._hasData) {
	                fetchedObjects[object.id] = object;
	              }
	            });
	
	            var savedChanges = _.first(this._opSetQueue);
	            this._opSetQueue = _.rest(this._opSetQueue);
	            this._applyOpSet(savedChanges, this._serverData);
	            this._mergeMagicFields(serverData);
	            var self = this;
	            AV._objectEach(serverData, function (value, key) {
	              self._serverData[key] = AV._decode(key, value);
	
	              // Look for any objects that might have become unfetched and fix them
	              // by replacing their values with the previously observed values.
	              var fetched = AV._traverse(self._serverData[key], function (object) {
	                if (object instanceof AV.Object && fetchedObjects[object.id]) {
	                  return fetchedObjects[object.id];
	                }
	              });
	              if (fetched) {
	                self._serverData[key] = fetched;
	              }
	            });
	            this._rebuildAllEstimatedData();
	            this._saving = this._saving - 1;
	          },
	
	          /**
	           * Called when a fetch or login is complete to set the known server data to
	           * the given object.
	           */
	          _finishFetch: function _finishFetch(serverData, hasData) {
	            // Clear out any changes the user might have made previously.
	            this._opSetQueue = [{}];
	
	            // Bring in all the new server data.
	            this._mergeMagicFields(serverData);
	            var self = this;
	            AV._objectEach(serverData, function (value, key) {
	              self._serverData[key] = AV._decode(key, value);
	            });
	
	            // Refresh the attributes.
	            this._rebuildAllEstimatedData();
	
	            // Clear out the cache of mutable containers.
	            this._refreshCache();
	            this._opSetQueue = [{}];
	
	            this._hasData = hasData;
	          },
	
	          /**
	           * Applies the set of AV.Op in opSet to the object target.
	           */
	          _applyOpSet: function _applyOpSet(opSet, target) {
	            var self = this;
	            AV._objectEach(opSet, function (change, key) {
	              target[key] = change._estimate(target[key], self, key);
	              if (target[key] === AV.Op._UNSET) {
	                delete target[key];
	              }
	            });
	          },
	
	          /**
	           * Replaces the cached value for key with the current value.
	           * Returns true if the new value is different than the old value.
	           */
	          _resetCacheForKey: function _resetCacheForKey(key) {
	            var value = this.attributes[key];
	            if (_.isObject(value) && !(value instanceof AV.Object) && !(value instanceof AV.File)) {
	
	              value = value.toJSON ? value.toJSON() : value;
	              var json = JSON.stringify(value);
	              if (this._hashedJSON[key] !== json) {
	                var wasSet = !!this._hashedJSON[key];
	                this._hashedJSON[key] = json;
	                return wasSet;
	              }
	            }
	            return false;
	          },
	
	          /**
	           * Populates attributes[key] by starting with the last known data from the
	           * server, and applying all of the local changes that have been made to that
	           * key since then.
	           */
	          _rebuildEstimatedDataForKey: function _rebuildEstimatedDataForKey(key) {
	            var self = this;
	            delete this.attributes[key];
	            if (this._serverData[key]) {
	              this.attributes[key] = this._serverData[key];
	            }
	            AV._arrayEach(this._opSetQueue, function (opSet) {
	              var op = opSet[key];
	              if (op) {
	                self.attributes[key] = op._estimate(self.attributes[key], self, key);
	                if (self.attributes[key] === AV.Op._UNSET) {
	                  delete self.attributes[key];
	                } else {
	                  self._resetCacheForKey(key);
	                }
	              }
	            });
	          },
	
	          /**
	           * Populates attributes by starting with the last known data from the
	           * server, and applying all of the local changes that have been made since
	           * then.
	           */
	          _rebuildAllEstimatedData: function _rebuildAllEstimatedData() {
	            var self = this;
	
	            var previousAttributes = _.clone(this.attributes);
	
	            this.attributes = _.clone(this._serverData);
	            AV._arrayEach(this._opSetQueue, function (opSet) {
	              self._applyOpSet(opSet, self.attributes);
	              AV._objectEach(opSet, function (op, key) {
	                self._resetCacheForKey(key);
	              });
	            });
	
	            // Trigger change events for anything that changed because of the fetch.
	            AV._objectEach(previousAttributes, function (oldValue, key) {
	              if (self.attributes[key] !== oldValue) {
	                self.trigger('change:' + key, self, self.attributes[key], {});
	              }
	            });
	            AV._objectEach(this.attributes, function (newValue, key) {
	              if (!_.has(previousAttributes, key)) {
	                self.trigger('change:' + key, self, newValue, {});
	              }
	            });
	          },
	
	          /**
	           * Sets a hash of model attributes on the object, firing
	           * <code>"change"</code> unless you choose to silence it.
	           *
	           * <p>You can call it with an object containing keys and values, or with one
	           * key and value.  For example:<pre>
	           *   gameTurn.set({
	           *     player: player1,
	           *     diceRoll: 2
	           *   }, {
	           *     error: function(gameTurnAgain, error) {
	           *       // The set failed validation.
	           *     }
	           *   });
	           *
	           *   game.set("currentPlayer", player2, {
	           *     error: function(gameTurnAgain, error) {
	           *       // The set failed validation.
	           *     }
	           *   });
	           *
	           *   game.set("finished", true);</pre></p>
	           *
	           * @param {String} key The key to set.
	           * @param {} value The value to give it.
	           * @param {Object} options A set of Backbone-like options for the set.
	           *     The only supported options are <code>silent</code>,
	           *     <code>error</code>, and <code>promise</code>.
	           * @return {Boolean} true if the set succeeded.
	           * @see AV.Object#validate
	           * @see AVError
	           */
	          set: function set(key, value, options) {
	            var attrs, attr;
	            if (_.isObject(key) || utils.isNullOrUndefined(key)) {
	              attrs = key;
	              AV._objectEach(attrs, function (v, k) {
	                attrs[k] = AV._decode(k, v);
	              });
	              options = value;
	            } else {
	              attrs = {};
	              attrs[key] = AV._decode(key, value);
	            }
	
	            // Extract attributes and options.
	            options = options || {};
	            if (!attrs) {
	              return this;
	            }
	            if (attrs instanceof AV.Object) {
	              attrs = attrs.attributes;
	            }
	
	            // If the unset option is used, every attribute should be a Unset.
	            if (options.unset) {
	              AV._objectEach(attrs, function (unused_value, key) {
	                attrs[key] = new AV.Op.Unset();
	              });
	            }
	
	            // Apply all the attributes to get the estimated values.
	            var dataToValidate = _.clone(attrs);
	            var self = this;
	            AV._objectEach(dataToValidate, function (value, key) {
	              if (value instanceof AV.Op) {
	                dataToValidate[key] = value._estimate(self.attributes[key], self, key);
	                if (dataToValidate[key] === AV.Op._UNSET) {
	                  delete dataToValidate[key];
	                }
	              }
	            });
	
	            // Run validation.
	            if (!this._validate(attrs, options)) {
	              return false;
	            }
	
	            this._mergeMagicFields(attrs);
	
	            options.changes = {};
	            var escaped = this._escapedAttributes;
	            var prev = this._previousAttributes || {};
	
	            // Update attributes.
	            AV._arrayEach(_.keys(attrs), function (attr) {
	              var val = attrs[attr];
	
	              // If this is a relation object we need to set the parent correctly,
	              // since the location where it was parsed does not have access to
	              // this object.
	              if (val instanceof AV.Relation) {
	                val.parent = self;
	              }
	
	              if (!(val instanceof AV.Op)) {
	                val = new AV.Op.Set(val);
	              }
	
	              // See if this change will actually have any effect.
	              var isRealChange = true;
	              if (val instanceof AV.Op.Set && _.isEqual(self.attributes[attr], val.value)) {
	                isRealChange = false;
	              }
	
	              if (isRealChange) {
	                delete escaped[attr];
	                if (options.silent) {
	                  self._silent[attr] = true;
	                } else {
	                  options.changes[attr] = true;
	                }
	              }
	
	              var currentChanges = _.last(self._opSetQueue);
	              currentChanges[attr] = val._mergeWithPrevious(currentChanges[attr]);
	              self._rebuildEstimatedDataForKey(attr);
	
	              if (isRealChange) {
	                self.changed[attr] = self.attributes[attr];
	                if (!options.silent) {
	                  self._pending[attr] = true;
	                }
	              } else {
	                delete self.changed[attr];
	                delete self._pending[attr];
	              }
	            });
	
	            if (!options.silent) {
	              this.change(options);
	            }
	            return this;
	          },
	
	          /**
	           * Remove an attribute from the model, firing <code>"change"</code> unless
	           * you choose to silence it. This is a noop if the attribute doesn't
	           * exist.
	           */
	          unset: function unset(attr, options) {
	            options = options || {};
	            options.unset = true;
	            return this.set(attr, null, options);
	          },
	
	          /**
	           * Atomically increments the value of the given attribute the next time the
	           * object is saved. If no amount is specified, 1 is used by default.
	           *
	           * @param attr {String} The key.
	           * @param amount {Number} The amount to increment by.
	           */
	          increment: function increment(attr, amount) {
	            if (_.isUndefined(amount) || _.isNull(amount)) {
	              amount = 1;
	            }
	            return this.set(attr, new AV.Op.Increment(amount));
	          },
	
	          /**
	           * Atomically add an object to the end of the array associated with a given
	           * key.
	           * @param attr {String} The key.
	           * @param item {} The item to add.
	           */
	          add: function add(attr, item) {
	            return this.set(attr, new AV.Op.Add(utils.ensureArray(item)));
	          },
	
	          /**
	           * Atomically add an object to the array associated with a given key, only
	           * if it is not already present in the array. The position of the insert is
	           * not guaranteed.
	           *
	           * @param attr {String} The key.
	           * @param item {} The object to add.
	           */
	          addUnique: function addUnique(attr, item) {
	            return this.set(attr, new AV.Op.AddUnique(utils.ensureArray(item)));
	          },
	
	          /**
	           * Atomically remove all instances of an object from the array associated
	           * with a given key.
	           *
	           * @param attr {String} The key.
	           * @param item {} The object to remove.
	           */
	          remove: function remove(attr, item) {
	            return this.set(attr, new AV.Op.Remove(utils.ensureArray(item)));
	          },
	
	          /**
	           * Returns an instance of a subclass of AV.Op describing what kind of
	           * modification has been performed on this field since the last time it was
	           * saved. For example, after calling object.increment("x"), calling
	           * object.op("x") would return an instance of AV.Op.Increment.
	           *
	           * @param attr {String} The key.
	           * @returns {AV.Op} The operation, or undefined if none.
	           */
	          op: function op(attr) {
	            return _.last(this._opSetQueue)[attr];
	          },
	
	          /**
	           * Clear all attributes on the model, firing <code>"change"</code> unless
	           * you choose to silence it.
	           */
	          clear: function clear(options) {
	            options = options || {};
	            options.unset = true;
	            var keysToClear = _.extend(this.attributes, this._operations);
	            return this.set(keysToClear, options);
	          },
	
	          /**
	           * Returns a JSON-encoded set of operations to be sent with the next save
	           * request.
	           */
	          _getSaveJSON: function _getSaveJSON() {
	            var json = _.clone(_.first(this._opSetQueue));
	            AV._objectEach(json, function (op, key) {
	              json[key] = op.toJSON();
	            });
	            return json;
	          },
	
	          /**
	           * Returns true if this object can be serialized for saving.
	           */
	          _canBeSerialized: function _canBeSerialized() {
	            return AV.Object._canBeSerializedAsValue(this.attributes);
	          },
	
	          /**
	           * Fetch the model from the server. If the server's representation of the
	           * model differs from its current attributes, they will be overriden,
	           * triggering a <code>"change"</code> event.
	           * @param {Object} fetchOptions Optional options to set 'keys' and
	           *      'include' option.
	           * @param {Object} options Optional Backbone-like options object to be
	           *     passed in to set.
	           * @return {AV.Promise} A promise that is fulfilled when the fetch
	           *     completes.
	           */
	          fetch: function fetch() {
	            var options = {};
	            var fetchOptions = {};
	            if (arguments.length === 1) {
	              options = arguments[0];
	            } else if (arguments.length === 2) {
	              fetchOptions = arguments[0];
	              options = arguments[1] || {};
	            }
	
	            if (fetchOptions && fetchOptions.include && _.isArray(fetchOptions.include)) {
	              fetchOptions.include = fetchOptions.include.join(',');
	            }
	
	            var self = this;
	            var request = AVRequest('classes', this.className, this.id, 'GET', fetchOptions, options.sessionToken);
	            return request.then(function (response) {
	              self._finishFetch(self.parse(response), true);
	              return self;
	            })._thenRunCallbacks(options, this);
	          },
	
	          /**
	           * Set a hash of model attributes, and save the model to the server.
	           * updatedAt will be updated when the request returns.
	           * You can either call it as:<pre>
	           *   object.save();</pre>
	           * or<pre>
	           *   object.save(null, options);</pre>
	           * or<pre>
	           *   object.save(attrs, options);</pre>
	           * or<pre>
	           *   object.save(key, value, options);</pre>
	           *
	           * For example, <pre>
	           *   gameTurn.save({
	           *     player: "Jake Cutter",
	           *     diceRoll: 2
	           *   }, {
	           *     success: function(gameTurnAgain) {
	           *       // The save was successful.
	           *     },
	           *     error: function(gameTurnAgain, error) {
	           *       // The save failed.  Error is an instance of AVError.
	           *     }
	           *   });</pre>
	           * or with promises:<pre>
	           *   gameTurn.save({
	           *     player: "Jake Cutter",
	           *     diceRoll: 2
	           *   }).then(function(gameTurnAgain) {
	           *     // The save was successful.
	           *   }, function(error) {
	           *     // The save failed.  Error is an instance of AVError.
	           *   });</pre>
	           * @param {Object} options Optional Backbone-like options object to be passed in to set.
	           * @param {Boolean} options.fetchWhenSave fetch and update object after save succeeded
	           * @param {AV.Query} options.query Save object only when it matches the query
	           * @return {AV.Promise} A promise that is fulfilled when the save
	           *     completes.
	           * @see AVError
	           */
	          save: function save(arg1, arg2, arg3) {
	            var i, attrs, current, options, saved;
	            if (_.isObject(arg1) || utils.isNullOrUndefined(arg1)) {
	              attrs = arg1;
	              options = arg2;
	            } else {
	              attrs = {};
	              attrs[arg1] = arg2;
	              options = arg3;
	            }
	
	            // Make save({ success: function() {} }) work.
	            if (!options && attrs) {
	              var extra_keys = _.reject(attrs, function (value, key) {
	                return _.include(["success", "error", "wait"], key);
	              });
	              if (extra_keys.length === 0) {
	                var all_functions = true;
	                if (_.has(attrs, "success") && !_.isFunction(attrs.success)) {
	                  all_functions = false;
	                }
	                if (_.has(attrs, "error") && !_.isFunction(attrs.error)) {
	                  all_functions = false;
	                }
	                if (all_functions) {
	                  // This attrs object looks like it's really an options object,
	                  // and there's no other options object, so let's just use it.
	                  return this.save(null, attrs);
	                }
	              }
	            }
	
	            options = _.clone(options) || {};
	            if (options.wait) {
	              current = _.clone(this.attributes);
	            }
	
	            var setOptions = _.clone(options) || {};
	            if (setOptions.wait) {
	              setOptions.silent = true;
	            }
	            var setError;
	            setOptions.error = function (model, error) {
	              setError = error;
	            };
	            if (attrs && !this.set(attrs, setOptions)) {
	              return AV.Promise.error(setError)._thenRunCallbacks(options, this);
	            }
	
	            var model = this;
	
	            // If there is any unsaved child, save it first.
	            model._refreshCache();
	
	            var unsavedChildren = [];
	            var unsavedFiles = [];
	            AV.Object._findUnsavedChildren(model.attributes, unsavedChildren, unsavedFiles);
	            if (unsavedChildren.length + unsavedFiles.length > 0) {
	              return AV.Object._deepSaveAsync(this.attributes, model, options).then(function () {
	                return model.save(null, options);
	              }, function (error) {
	                return AV.Promise.error(error)._thenRunCallbacks(options, model);
	              });
	            }
	
	            this._startSave();
	            this._saving = (this._saving || 0) + 1;
	
	            this._allPreviousSaves = this._allPreviousSaves || AV.Promise.as();
	            this._allPreviousSaves = this._allPreviousSaves._continueWith(function () {
	              var method = model.id ? 'PUT' : 'POST';
	
	              var json = model._getSaveJSON();
	
	              if (model._fetchWhenSave) {
	                //Sepcial-case fetchWhenSave when updating object.
	                json._fetchWhenSave = true;
	              }
	
	              if (options.fetchWhenSave) {
	                json._fetchWhenSave = true;
	              }
	              if (options.query) {
	                var queryJSON;
	                if (typeof options.query.toJSON === 'function') {
	                  queryJSON = options.query.toJSON();
	                  if (queryJSON) {
	                    json._where = queryJSON.where;
	                  }
	                }
	                if (!json._where) {
	                  var error = new Error('options.query is not an AV.Query');
	                  return AV.Promise.error(error)._thenRunCallbacks(options, model);
	                }
	              }
	
	              var route = "classes";
	              var className = model.className;
	              if (model.className === "_User" && !model.id) {
	                // Special-case user sign-up.
	                route = "users";
	                className = null;
	              }
	              //hook makeRequest in options.
	              var makeRequest = options._makeRequest || AVRequest;
	              var request = makeRequest(route, className, model.id, method, json, options.sessionToken);
	
	              request = request.then(function (resp) {
	                var serverAttrs = model.parse(resp);
	                if (options.wait) {
	                  serverAttrs = _.extend(attrs || {}, serverAttrs);
	                }
	                model._finishSave(serverAttrs);
	                if (options.wait) {
	                  model.set(current, setOptions);
	                }
	                return model;
	              }, function (error) {
	                model._cancelSave();
	                return AV.Promise.error(error);
	              })._thenRunCallbacks(options, model);
	
	              return request;
	            });
	            return this._allPreviousSaves;
	          },
	
	          /**
	           * Destroy this model on the server if it was already persisted.
	           * Optimistically removes the model from its collection, if it has one.
	           * If `wait: true` is passed, waits for the server to respond
	           * before removal.
	           *
	           * @return {AV.Promise} A promise that is fulfilled when the destroy
	           *     completes.
	           */
	          destroy: function destroy(options) {
	            options = options || {};
	            var model = this;
	
	            var triggerDestroy = function triggerDestroy() {
	              model.trigger('destroy', model, model.collection, options);
	            };
	
	            if (!this.id) {
	              return triggerDestroy();
	            }
	
	            if (!options.wait) {
	              triggerDestroy();
	            }
	
	            var request = AVRequest('classes', this.className, this.id, 'DELETE', null, options.sessionToken);
	            return request.then(function () {
	              if (options.wait) {
	                triggerDestroy();
	              }
	              return model;
	            })._thenRunCallbacks(options, this);
	          },
	
	          /**
	           * Converts a response into the hash of attributes to be set on the model.
	           * @ignore
	           */
	          parse: function parse(resp) {
	            var output = _.clone(resp);
	            _(["createdAt", "updatedAt"]).each(function (key) {
	              if (output[key]) {
	                output[key] = AV._parseDate(output[key]);
	              }
	            });
	            if (!output.updatedAt) {
	              output.updatedAt = output.createdAt;
	            }
	            return output;
	          },
	
	          /**
	           * Creates a new model with identical attributes to this one.
	           * @return {AV.Object}
	           */
	          clone: function clone() {
	            return new this.constructor(this.attributes);
	          },
	
	          /**
	           * Returns true if this object has never been saved to AV.
	           * @return {Boolean}
	           */
	          isNew: function isNew() {
	            return !this.id;
	          },
	
	          /**
	           * Call this method to manually fire a `"change"` event for this model and
	           * a `"change:attribute"` event for each changed attribute.
	           * Calling this will cause all objects observing the model to update.
	           */
	          change: function change(options) {
	            options = options || {};
	            var changing = this._changing;
	            this._changing = true;
	
	            // Silent changes become pending changes.
	            var self = this;
	            AV._objectEach(this._silent, function (attr) {
	              self._pending[attr] = true;
	            });
	
	            // Silent changes are triggered.
	            var changes = _.extend({}, options.changes, this._silent);
	            this._silent = {};
	            AV._objectEach(changes, function (unused_value, attr) {
	              self.trigger('change:' + attr, self, self.get(attr), options);
	            });
	            if (changing) {
	              return this;
	            }
	
	            // This is to get around lint not letting us make a function in a loop.
	            var deleteChanged = function deleteChanged(value, attr) {
	              if (!self._pending[attr] && !self._silent[attr]) {
	                delete self.changed[attr];
	              }
	            };
	
	            // Continue firing `"change"` events while there are pending changes.
	            while (!_.isEmpty(this._pending)) {
	              this._pending = {};
	              this.trigger('change', this, options);
	              // Pending and silent changes still remain.
	              AV._objectEach(this.changed, deleteChanged);
	              self._previousAttributes = _.clone(this.attributes);
	            }
	
	            this._changing = false;
	            return this;
	          },
	
	          /**
	           * (DEPRECATED) Returns true if this object was created by the AV server when the
	           * object might have already been there (e.g. in the case of a Facebook
	           * login)
	           */
	          existed: function existed() {
	            console.warn('AV.Object.prototype.existed() is deprecated.');
	            return false;
	          },
	
	          /**
	           * Determine if the model has changed since the last <code>"change"</code>
	           * event.  If you specify an attribute name, determine if that attribute
	           * has changed.
	           * @param {String} attr Optional attribute name
	           * @return {Boolean}
	           */
	          hasChanged: function hasChanged(attr) {
	            if (!arguments.length) {
	              return !_.isEmpty(this.changed);
	            }
	            return this.changed && _.has(this.changed, attr);
	          },
	
	          /**
	           * Returns an object containing all the attributes that have changed, or
	           * false if there are no changed attributes. Useful for determining what
	           * parts of a view need to be updated and/or what attributes need to be
	           * persisted to the server. Unset attributes will be set to undefined.
	           * You can also pass an attributes object to diff against the model,
	           * determining if there *would be* a change.
	           */
	          changedAttributes: function changedAttributes(diff) {
	            if (!diff) {
	              return this.hasChanged() ? _.clone(this.changed) : false;
	            }
	            var changed = {};
	            var old = this._previousAttributes;
	            AV._objectEach(diff, function (diffVal, attr) {
	              if (!_.isEqual(old[attr], diffVal)) {
	                changed[attr] = diffVal;
	              }
	            });
	            return changed;
	          },
	
	          /**
	           * Gets the previous value of an attribute, recorded at the time the last
	           * <code>"change"</code> event was fired.
	           * @param {String} attr Name of the attribute to get.
	           */
	          previous: function previous(attr) {
	            if (!arguments.length || !this._previousAttributes) {
	              return null;
	            }
	            return this._previousAttributes[attr];
	          },
	
	          /**
	           * Gets all of the attributes of the model at the time of the previous
	           * <code>"change"</code> event.
	           * @return {Object}
	           */
	          previousAttributes: function previousAttributes() {
	            return _.clone(this._previousAttributes);
	          },
	
	          /**
	           * Checks if the model is currently in a valid state. It's only possible to
	           * get into an *invalid* state if you're using silent changes.
	           * @return {Boolean}
	           */
	          isValid: function isValid() {
	            return !this.validate(this.attributes);
	          },
	
	          /**
	           * You should not call this function directly unless you subclass
	           * <code>AV.Object</code>, in which case you can override this method
	           * to provide additional validation on <code>set</code> and
	           * <code>save</code>.  Your implementation should return
	           *
	           * @param {Object} attrs The current data to validate.
	           * @param {Object} options A Backbone-like options object.
	           * @return {} False if the data is valid.  An error object otherwise.
	           * @see AV.Object#set
	           */
	          validate: function validate(attrs, options) {
	            if (_.has(attrs, "ACL") && !(attrs.ACL instanceof AV.ACL)) {
	              return new AVError(AVError.OTHER_CAUSE, "ACL must be a AV.ACL.");
	            }
	            return false;
	          },
	
	          /**
	           * Run validation against a set of incoming attributes, returning `true`
	           * if all is well. If a specific `error` callback has been passed,
	           * call that instead of firing the general `"error"` event.
	           */
	          _validate: function _validate(attrs, options) {
	            if (options.silent || !this.validate) {
	              return true;
	            }
	            attrs = _.extend({}, this.attributes, attrs);
	            var error = this.validate(attrs, options);
	            if (!error) {
	              return true;
	            }
	            if (options && options.error) {
	              options.error(this, error, options);
	            } else {
	              this.trigger('error', this, error, options);
	            }
	            return false;
	          },
	
	          /**
	           * Returns the ACL for this object.
	           * @returns {AV.ACL} An instance of AV.ACL.
	           * @see AV.Object#get
	           */
	          getACL: function getACL() {
	            return this.get("ACL");
	          },
	
	          /**
	           * Sets the ACL to be used for this object.
	           * @param {AV.ACL} acl An instance of AV.ACL.
	           * @param {Object} options Optional Backbone-like options object to be
	           *     passed in to set.
	           * @return {Boolean} Whether the set passed validation.
	           * @see AV.Object#set
	           */
	          setACL: function setACL(acl, options) {
	            return this.set("ACL", acl, options);
	          }
	
	        });
	
	        /**
	         * Creates an instance of a subclass of AV.Object for the give classname
	         * and id.
	         * @param  {String} className The name of the AV class backing this model.
	         * @param {String} id The object id of this model.
	         * @return {AV.Object} A new subclass instance of AV.Object.
	         */
	        AV.Object.createWithoutData = function (className, id, hasData) {
	          var result = new AV.Object(className);
	          result.id = id;
	          result._hasData = hasData;
	          return result;
	        };
	        /**
	         * Delete objects in batch.The objects className must be the same.
	         * @param {Array} The ParseObject array to be deleted.
	         * @param {Object} options Standard options object with success and error
	         *     callbacks.
	         * @return {AV.Promise} A promise that is fulfilled when the save
	         *     completes.
	         */
	        AV.Object.destroyAll = function (objects, options) {
	          options = options || {};
	          if (!objects || objects.length === 0) {
	            return AV.Promise.as()._thenRunCallbacks(options);
	          }
	          var className = objects[0].className;
	          var id = "";
	          var wasFirst = true;
	          objects.forEach(function (obj) {
	            if (obj.className != className) throw "AV.Object.destroyAll requires the argument object array's classNames must be the same";
	            if (!obj.id) throw "Could not delete unsaved object";
	            if (wasFirst) {
	              id = obj.id;
	              wasFirst = false;
	            } else {
	              id = id + ',' + obj.id;
	            }
	          });
	          var request = AVRequest('classes', className, id, 'DELETE', null, options.sessionToken);
	          return request._thenRunCallbacks(options);
	        };
	
	        /**
	         * Returns the appropriate subclass for making new instances of the given
	         * className string.
	         */
	        AV.Object._getSubclass = function (className) {
	          if (!_.isString(className)) {
	            throw "AV.Object._getSubclass requires a string argument.";
	          }
	          var ObjectClass = AV.Object._classMap[className];
	          if (!ObjectClass) {
	            ObjectClass = AV.Object.extend(className);
	            AV.Object._classMap[className] = ObjectClass;
	          }
	          return ObjectClass;
	        };
	
	        /**
	         * Creates an instance of a subclass of AV.Object for the given classname.
	         */
	        AV.Object._create = function (className, attributes, options) {
	          var ObjectClass = AV.Object._getSubclass(className);
	          return new ObjectClass(attributes, options);
	        };
	
	        // Set up a map of className to class so that we can create new instances of
	        // AV Objects from JSON automatically.
	        AV.Object._classMap = {};
	
	        AV.Object._extend = AV._extend;
	
	        /**
	         * Creates a new model with defined attributes,
	         * It's the same with
	         * <pre>
	         *   new AV.Object(attributes, options);
	         *  </pre>
	         * @param {Object} attributes The initial set of data to store in the object.
	         * @param {Object} options A set of Backbone-like options for creating the
	         *     object.  The only option currently supported is "collection".
	         * @return {AV.Object}
	         * @since v0.4.4
	         * @see AV.Object
	         * @see AV.Object.extend
	         */
	        AV.Object['new'] = function (attributes, options) {
	          return new AV.Object(attributes, options);
	        };
	
	        /**
	         * Creates a new subclass of AV.Object for the given AV class name.
	         *
	         * <p>Every extension of a AV class will inherit from the most recent
	         * previous extension of that class. When a AV.Object is automatically
	         * created by parsing JSON, it will use the most recent extension of that
	         * class.</p>
	         *
	         * <p>You should call either:<pre>
	         *     var MyClass = AV.Object.extend("MyClass", {
	         *         <i>Instance properties</i>
	         *     }, {
	         *         <i>Class properties</i>
	         *     });</pre>
	         * or, for Backbone compatibility:<pre>
	         *     var MyClass = AV.Object.extend({
	         *         className: "MyClass",
	         *         <i>Other instance properties</i>
	         *     }, {
	         *         <i>Class properties</i>
	         *     });</pre></p>
	         *
	         * @param {String} className The name of the AV class backing this model.
	         * @param {Object} protoProps Instance properties to add to instances of the
	         *     class returned from this method.
	         * @param {Object} classProps Class properties to add the class returned from
	         *     this method.
	         * @return {Class} A new subclass of AV.Object.
	         */
	        AV.Object.extend = function (className, protoProps, classProps) {
	          // Handle the case with only two args.
	          if (!_.isString(className)) {
	            if (className && _.has(className, "className")) {
	              return AV.Object.extend(className.className, className, protoProps);
	            } else {
	              throw new Error("AV.Object.extend's first argument should be the className.");
	            }
	          }
	
	          // If someone tries to subclass "User", coerce it to the right type.
	          if (className === "User") {
	            className = "_User";
	          }
	
	          var NewClassObject = null;
	          if (_.has(AV.Object._classMap, className)) {
	            var OldClassObject = AV.Object._classMap[className];
	            // This new subclass has been told to extend both from "this" and from
	            // OldClassObject. This is multiple inheritance, which isn't supported.
	            // For now, let's just pick one.
	            NewClassObject = OldClassObject._extend(protoProps, classProps);
	          } else {
	            protoProps = protoProps || {};
	            protoProps.className = className;
	            NewClassObject = this._extend(protoProps, classProps);
	          }
	          // Extending a subclass should reuse the classname automatically.
	          NewClassObject.extend = function (arg0) {
	            if (_.isString(arg0) || arg0 && _.has(arg0, "className")) {
	              return AV.Object.extend.apply(NewClassObject, arguments);
	            }
	            var newArguments = [className].concat(_.toArray(arguments));
	            return AV.Object.extend.apply(NewClassObject, newArguments);
	          };
	          NewClassObject['new'] = function (attributes, options) {
	            return new NewClassObject(attributes, options);
	          };
	          AV.Object._classMap[className] = NewClassObject;
	          return NewClassObject;
	        };
	
	        AV.Object._findUnsavedChildren = function (object, children, files) {
	          AV._traverse(object, function (object) {
	            if (object instanceof AV.Object) {
	              object._refreshCache();
	              if (object.dirty()) {
	                children.push(object);
	              }
	              return;
	            }
	
	            if (object instanceof AV.File) {
	              if (!object.url() && !object.id) {
	                files.push(object);
	              }
	              return;
	            }
	          });
	        };
	
	        AV.Object._canBeSerializedAsValue = function (object) {
	          var canBeSerializedAsValue = true;
	
	          if (object instanceof AV.Object || object instanceof AV.File) {
	            canBeSerializedAsValue = !!object.id;
	          } else if (_.isArray(object)) {
	            AV._arrayEach(object, function (child) {
	              if (!AV.Object._canBeSerializedAsValue(child)) {
	                canBeSerializedAsValue = false;
	              }
	            });
	          } else if (_.isObject(object)) {
	            AV._objectEach(object, function (child) {
	              if (!AV.Object._canBeSerializedAsValue(child)) {
	                canBeSerializedAsValue = false;
	              }
	            });
	          }
	
	          return canBeSerializedAsValue;
	        };
	
	        AV.Object._deepSaveAsync = function (object, model, options) {
	          var unsavedChildren = [];
	          var unsavedFiles = [];
	          AV.Object._findUnsavedChildren(object, unsavedChildren, unsavedFiles);
	          if (model) {
	            unsavedChildren = _.filter(unsavedChildren, function (object) {
	              return object != model;
	            });
	          }
	
	          var promise = AV.Promise.as();
	          _.each(unsavedFiles, function (file) {
	            promise = promise.then(function () {
	              return file.save();
	            });
	          });
	
	          var objects = _.uniq(unsavedChildren);
	          var remaining = _.uniq(objects);
	
	          return promise.then(function () {
	            return AV.Promise._continueWhile(function () {
	              return remaining.length > 0;
	            }, function () {
	
	              // Gather up all the objects that can be saved in this batch.
	              var batch = [];
	              var newRemaining = [];
	              AV._arrayEach(remaining, function (object) {
	                // Limit batches to 20 objects.
	                if (batch.length > 20) {
	                  newRemaining.push(object);
	                  return;
	                }
	
	                if (object._canBeSerialized()) {
	                  batch.push(object);
	                } else {
	                  newRemaining.push(object);
	                }
	              });
	              remaining = newRemaining;
	
	              // If we can't save any objects, there must be a circular reference.
	              if (batch.length === 0) {
	                return AV.Promise.error(new AVError(AVError.OTHER_CAUSE, "Tried to save a batch with a cycle."));
	              }
	
	              // Reserve a spot in every object's save queue.
	              var readyToStart = AV.Promise.when(_.map(batch, function (object) {
	                return object._allPreviousSaves || AV.Promise.as();
	              }));
	              var batchFinished = new AV.Promise();
	              AV._arrayEach(batch, function (object) {
	                object._allPreviousSaves = batchFinished;
	              });
	
	              // Save a single batch, whether previous saves succeeded or failed.
	              return readyToStart._continueWith(function () {
	                return AVRequest("batch", null, null, "POST", {
	                  requests: _.map(batch, function (object) {
	                    var json = object._getSaveJSON();
	                    var method = "POST";
	
	                    var path = "/1.1/classes/" + object.className;
	                    if (object.id) {
	                      path = path + "/" + object.id;
	                      method = "PUT";
	                    }
	
	                    object._startSave();
	
	                    return {
	                      method: method,
	                      path: path,
	                      body: json
	                    };
	                  })
	
	                }, options && options.sessionToken).then(function (response) {
	                  var error;
	                  AV._arrayEach(batch, function (object, i) {
	                    if (response[i].success) {
	                      object._finishSave(object.parse(response[i].success));
	                    } else {
	                      error = error || response[i].error;
	                      object._cancelSave();
	                    }
	                  });
	                  if (error) {
	                    return AV.Promise.error(new AVError(error.code, error.error));
	                  }
	                }).then(function (results) {
	                  batchFinished.resolve(results);
	                  return results;
	                }, function (error) {
	                  batchFinished.reject(error);
	                  return AV.Promise.error(error);
	                });
	              });
	            });
	          }).then(function () {
	            return object;
	          });
	        };
	      };
	    }, { "./error": 24, "./request": 37, "./utils": 45, "underscore": 17 }], 32: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      'use strict';
	
	      var _ = require('underscore');
	
	      module.exports = function (AV) {
	
	        /**
	         * @class
	         * A AV.Op is an atomic operation that can be applied to a field in a
	         * AV.Object. For example, calling <code>object.set("foo", "bar")</code>
	         * is an example of a AV.Op.Set. Calling <code>object.unset("foo")</code>
	         * is a AV.Op.Unset. These operations are stored in a AV.Object and
	         * sent to the server as part of <code>object.save()</code> operations.
	         * Instances of AV.Op should be immutable.
	         *
	         * You should not create subclasses of AV.Op or instantiate AV.Op
	         * directly.
	         */
	        AV.Op = function () {
	          this._initialize.apply(this, arguments);
	        };
	
	        AV.Op.prototype = {
	          _initialize: function _initialize() {}
	        };
	
	        _.extend(AV.Op, {
	          /**
	           * To create a new Op, call AV.Op._extend();
	           */
	          _extend: AV._extend,
	
	          // A map of __op string to decoder function.
	          _opDecoderMap: {},
	
	          /**
	           * Registers a function to convert a json object with an __op field into an
	           * instance of a subclass of AV.Op.
	           */
	          _registerDecoder: function _registerDecoder(opName, decoder) {
	            AV.Op._opDecoderMap[opName] = decoder;
	          },
	
	          /**
	           * Converts a json object into an instance of a subclass of AV.Op.
	           */
	          _decode: function _decode(json) {
	            var decoder = AV.Op._opDecoderMap[json.__op];
	            if (decoder) {
	              return decoder(json);
	            } else {
	              return undefined;
	            }
	          }
	        });
	
	        /*
	         * Add a handler for Batch ops.
	         */
	        AV.Op._registerDecoder("Batch", function (json) {
	          var op = null;
	          AV._arrayEach(json.ops, function (nextOp) {
	            nextOp = AV.Op._decode(nextOp);
	            op = nextOp._mergeWithPrevious(op);
	          });
	          return op;
	        });
	
	        /**
	         * @class
	         * A Set operation indicates that either the field was changed using
	         * AV.Object.set, or it is a mutable container that was detected as being
	         * changed.
	         */
	        AV.Op.Set = AV.Op._extend( /** @lends AV.Op.Set.prototype */{
	          _initialize: function _initialize(value) {
	            this._value = value;
	          },
	
	          /**
	           * Returns the new value of this field after the set.
	           */
	          value: function value() {
	            return this._value;
	          },
	
	          /**
	           * Returns a JSON version of the operation suitable for sending to AV.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            return AV._encode(this.value());
	          },
	
	          _mergeWithPrevious: function _mergeWithPrevious(previous) {
	            return this;
	          },
	
	          _estimate: function _estimate(oldValue) {
	            return this.value();
	          }
	        });
	
	        /**
	         * A sentinel value that is returned by AV.Op.Unset._estimate to
	         * indicate the field should be deleted. Basically, if you find _UNSET as a
	         * value in your object, you should remove that key.
	         */
	        AV.Op._UNSET = {};
	
	        /**
	         * @class
	         * An Unset operation indicates that this field has been deleted from the
	         * object.
	         */
	        AV.Op.Unset = AV.Op._extend( /** @lends AV.Op.Unset.prototype */{
	          /**
	           * Returns a JSON version of the operation suitable for sending to AV.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            return { __op: "Delete" };
	          },
	
	          _mergeWithPrevious: function _mergeWithPrevious(previous) {
	            return this;
	          },
	
	          _estimate: function _estimate(oldValue) {
	            return AV.Op._UNSET;
	          }
	        });
	
	        AV.Op._registerDecoder("Delete", function (json) {
	          return new AV.Op.Unset();
	        });
	
	        /**
	         * @class
	         * An Increment is an atomic operation where the numeric value for the field
	         * will be increased by a given amount.
	         */
	        AV.Op.Increment = AV.Op._extend(
	        /** @lends AV.Op.Increment.prototype */{
	
	          _initialize: function _initialize(amount) {
	            this._amount = amount;
	          },
	
	          /**
	           * Returns the amount to increment by.
	           * @return {Number} the amount to increment by.
	           */
	          amount: function amount() {
	            return this._amount;
	          },
	
	          /**
	           * Returns a JSON version of the operation suitable for sending to AV.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            return { __op: "Increment", amount: this._amount };
	          },
	
	          _mergeWithPrevious: function _mergeWithPrevious(previous) {
	            if (!previous) {
	              return this;
	            } else if (previous instanceof AV.Op.Unset) {
	              return new AV.Op.Set(this.amount());
	            } else if (previous instanceof AV.Op.Set) {
	              return new AV.Op.Set(previous.value() + this.amount());
	            } else if (previous instanceof AV.Op.Increment) {
	              return new AV.Op.Increment(this.amount() + previous.amount());
	            } else {
	              throw "Op is invalid after previous op.";
	            }
	          },
	
	          _estimate: function _estimate(oldValue) {
	            if (!oldValue) {
	              return this.amount();
	            }
	            return oldValue + this.amount();
	          }
	        });
	
	        AV.Op._registerDecoder("Increment", function (json) {
	          return new AV.Op.Increment(json.amount);
	        });
	
	        /**
	         * @class
	         * Add is an atomic operation where the given objects will be appended to the
	         * array that is stored in this field.
	         */
	        AV.Op.Add = AV.Op._extend( /** @lends AV.Op.Add.prototype */{
	          _initialize: function _initialize(objects) {
	            this._objects = objects;
	          },
	
	          /**
	           * Returns the objects to be added to the array.
	           * @return {Array} The objects to be added to the array.
	           */
	          objects: function objects() {
	            return this._objects;
	          },
	
	          /**
	           * Returns a JSON version of the operation suitable for sending to AV.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            return { __op: "Add", objects: AV._encode(this.objects()) };
	          },
	
	          _mergeWithPrevious: function _mergeWithPrevious(previous) {
	            if (!previous) {
	              return this;
	            } else if (previous instanceof AV.Op.Unset) {
	              return new AV.Op.Set(this.objects());
	            } else if (previous instanceof AV.Op.Set) {
	              return new AV.Op.Set(this._estimate(previous.value()));
	            } else if (previous instanceof AV.Op.Add) {
	              return new AV.Op.Add(previous.objects().concat(this.objects()));
	            } else {
	              throw "Op is invalid after previous op.";
	            }
	          },
	
	          _estimate: function _estimate(oldValue) {
	            if (!oldValue) {
	              return _.clone(this.objects());
	            } else {
	              return oldValue.concat(this.objects());
	            }
	          }
	        });
	
	        AV.Op._registerDecoder("Add", function (json) {
	          return new AV.Op.Add(AV._decode(undefined, json.objects));
	        });
	
	        /**
	         * @class
	         * AddUnique is an atomic operation where the given items will be appended to
	         * the array that is stored in this field only if they were not already
	         * present in the array.
	         */
	        AV.Op.AddUnique = AV.Op._extend(
	        /** @lends AV.Op.AddUnique.prototype */{
	
	          _initialize: function _initialize(objects) {
	            this._objects = _.uniq(objects);
	          },
	
	          /**
	           * Returns the objects to be added to the array.
	           * @return {Array} The objects to be added to the array.
	           */
	          objects: function objects() {
	            return this._objects;
	          },
	
	          /**
	           * Returns a JSON version of the operation suitable for sending to AV.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            return { __op: "AddUnique", objects: AV._encode(this.objects()) };
	          },
	
	          _mergeWithPrevious: function _mergeWithPrevious(previous) {
	            if (!previous) {
	              return this;
	            } else if (previous instanceof AV.Op.Unset) {
	              return new AV.Op.Set(this.objects());
	            } else if (previous instanceof AV.Op.Set) {
	              return new AV.Op.Set(this._estimate(previous.value()));
	            } else if (previous instanceof AV.Op.AddUnique) {
	              return new AV.Op.AddUnique(this._estimate(previous.objects()));
	            } else {
	              throw "Op is invalid after previous op.";
	            }
	          },
	
	          _estimate: function _estimate(oldValue) {
	            if (!oldValue) {
	              return _.clone(this.objects());
	            } else {
	              // We can't just take the _.uniq(_.union(...)) of oldValue and
	              // this.objects, because the uniqueness may not apply to oldValue
	              // (especially if the oldValue was set via .set())
	              var newValue = _.clone(oldValue);
	              AV._arrayEach(this.objects(), function (obj) {
	                if (obj instanceof AV.Object && obj.id) {
	                  var matchingObj = _.find(newValue, function (anObj) {
	                    return anObj instanceof AV.Object && anObj.id === obj.id;
	                  });
	                  if (!matchingObj) {
	                    newValue.push(obj);
	                  } else {
	                    var index = _.indexOf(newValue, matchingObj);
	                    newValue[index] = obj;
	                  }
	                } else if (!_.contains(newValue, obj)) {
	                  newValue.push(obj);
	                }
	              });
	              return newValue;
	            }
	          }
	        });
	
	        AV.Op._registerDecoder("AddUnique", function (json) {
	          return new AV.Op.AddUnique(AV._decode(undefined, json.objects));
	        });
	
	        /**
	         * @class
	         * Remove is an atomic operation where the given objects will be removed from
	         * the array that is stored in this field.
	         */
	        AV.Op.Remove = AV.Op._extend( /** @lends AV.Op.Remove.prototype */{
	          _initialize: function _initialize(objects) {
	            this._objects = _.uniq(objects);
	          },
	
	          /**
	           * Returns the objects to be removed from the array.
	           * @return {Array} The objects to be removed from the array.
	           */
	          objects: function objects() {
	            return this._objects;
	          },
	
	          /**
	           * Returns a JSON version of the operation suitable for sending to AV.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            return { __op: "Remove", objects: AV._encode(this.objects()) };
	          },
	
	          _mergeWithPrevious: function _mergeWithPrevious(previous) {
	            if (!previous) {
	              return this;
	            } else if (previous instanceof AV.Op.Unset) {
	              return previous;
	            } else if (previous instanceof AV.Op.Set) {
	              return new AV.Op.Set(this._estimate(previous.value()));
	            } else if (previous instanceof AV.Op.Remove) {
	              return new AV.Op.Remove(_.union(previous.objects(), this.objects()));
	            } else {
	              throw "Op is invalid after previous op.";
	            }
	          },
	
	          _estimate: function _estimate(oldValue) {
	            if (!oldValue) {
	              return [];
	            } else {
	              var newValue = _.difference(oldValue, this.objects());
	              // If there are saved AV Objects being removed, also remove them.
	              AV._arrayEach(this.objects(), function (obj) {
	                if (obj instanceof AV.Object && obj.id) {
	                  newValue = _.reject(newValue, function (other) {
	                    return other instanceof AV.Object && other.id === obj.id;
	                  });
	                }
	              });
	              return newValue;
	            }
	          }
	        });
	
	        AV.Op._registerDecoder("Remove", function (json) {
	          return new AV.Op.Remove(AV._decode(undefined, json.objects));
	        });
	
	        /**
	         * @class
	         * A Relation operation indicates that the field is an instance of
	         * AV.Relation, and objects are being added to, or removed from, that
	         * relation.
	         */
	        AV.Op.Relation = AV.Op._extend(
	        /** @lends AV.Op.Relation.prototype */{
	
	          _initialize: function _initialize(adds, removes) {
	            this._targetClassName = null;
	
	            var self = this;
	
	            var pointerToId = function pointerToId(object) {
	              if (object instanceof AV.Object) {
	                if (!object.id) {
	                  throw "You can't add an unsaved AV.Object to a relation.";
	                }
	                if (!self._targetClassName) {
	                  self._targetClassName = object.className;
	                }
	                if (self._targetClassName !== object.className) {
	                  throw "Tried to create a AV.Relation with 2 different types: " + self._targetClassName + " and " + object.className + ".";
	                }
	                return object.id;
	              }
	              return object;
	            };
	
	            this.relationsToAdd = _.uniq(_.map(adds, pointerToId));
	            this.relationsToRemove = _.uniq(_.map(removes, pointerToId));
	          },
	
	          /**
	           * Returns an array of unfetched AV.Object that are being added to the
	           * relation.
	           * @return {Array}
	           */
	          added: function added() {
	            var self = this;
	            return _.map(this.relationsToAdd, function (objectId) {
	              var object = AV.Object._create(self._targetClassName);
	              object.id = objectId;
	              return object;
	            });
	          },
	
	          /**
	           * Returns an array of unfetched AV.Object that are being removed from
	           * the relation.
	           * @return {Array}
	           */
	          removed: function removed() {
	            var self = this;
	            return _.map(this.relationsToRemove, function (objectId) {
	              var object = AV.Object._create(self._targetClassName);
	              object.id = objectId;
	              return object;
	            });
	          },
	
	          /**
	           * Returns a JSON version of the operation suitable for sending to AV.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            var adds = null;
	            var removes = null;
	            var self = this;
	            var idToPointer = function idToPointer(id) {
	              return { __type: 'Pointer',
	                className: self._targetClassName,
	                objectId: id };
	            };
	            var pointers = null;
	            if (this.relationsToAdd.length > 0) {
	              pointers = _.map(this.relationsToAdd, idToPointer);
	              adds = { "__op": "AddRelation", "objects": pointers };
	            }
	
	            if (this.relationsToRemove.length > 0) {
	              pointers = _.map(this.relationsToRemove, idToPointer);
	              removes = { "__op": "RemoveRelation", "objects": pointers };
	            }
	
	            if (adds && removes) {
	              return { "__op": "Batch", "ops": [adds, removes] };
	            }
	
	            return adds || removes || {};
	          },
	
	          _mergeWithPrevious: function _mergeWithPrevious(previous) {
	            if (!previous) {
	              return this;
	            } else if (previous instanceof AV.Op.Unset) {
	              throw "You can't modify a relation after deleting it.";
	            } else if (previous instanceof AV.Op.Relation) {
	              if (previous._targetClassName && previous._targetClassName !== this._targetClassName) {
	                throw "Related object must be of class " + previous._targetClassName + ", but " + this._targetClassName + " was passed in.";
	              }
	              var newAdd = _.union(_.difference(previous.relationsToAdd, this.relationsToRemove), this.relationsToAdd);
	              var newRemove = _.union(_.difference(previous.relationsToRemove, this.relationsToAdd), this.relationsToRemove);
	
	              var newRelation = new AV.Op.Relation(newAdd, newRemove);
	              newRelation._targetClassName = this._targetClassName;
	              return newRelation;
	            } else {
	              throw "Op is invalid after previous op.";
	            }
	          },
	
	          _estimate: function _estimate(oldValue, object, key) {
	            if (!oldValue) {
	              var relation = new AV.Relation(object, key);
	              relation.targetClassName = this._targetClassName;
	            } else if (oldValue instanceof AV.Relation) {
	              if (this._targetClassName) {
	                if (oldValue.targetClassName) {
	                  if (oldValue.targetClassName !== this._targetClassName) {
	                    throw "Related object must be a " + oldValue.targetClassName + ", but a " + this._targetClassName + " was passed in.";
	                  }
	                } else {
	                  oldValue.targetClassName = this._targetClassName;
	                }
	              }
	              return oldValue;
	            } else {
	              throw "Op is invalid after previous op.";
	            }
	          }
	        });
	
	        AV.Op._registerDecoder("AddRelation", function (json) {
	          return new AV.Op.Relation(AV._decode(undefined, json.objects), []);
	        });
	        AV.Op._registerDecoder("RemoveRelation", function (json) {
	          return new AV.Op.Relation([], AV._decode(undefined, json.objects));
	        });
	      };
	    }, { "underscore": 17 }], 33: [function (require, module, exports) {
	      (function (process) {
	        /**
	         * 每位工程师都有保持代码优雅的义务
	         * Each engineer has a duty to keep the code elegant
	        **/
	
	        'use strict';
	
	        var _ = require('underscore');
	
	        var Promise = module.exports = function Promise(fn) {
	          /**
	           * A Promise is returned by async methods as a hook to provide callbacks to be
	           * called when the async task is fulfilled.
	           *
	           * <p>Typical usage would be like:<pre>
	           *    query.find().then(function(results) {
	           *      results[0].set("foo", "bar");
	           *      return results[0].saveAsync();
	           *    }).then(function(result) {
	           *      console.log("Updated " + result.id);
	           *    });
	           * </pre></p>
	           * <p>Another example:<pre>
	           *    var promise = new AV.Promise(function(resolve, reject) {
	           *      resolve(42);
	           *    });
	           *    promise.then(function(value){
	           *      console.log(value);
	           *    }).catch(function(error){
	           *      console.error(error);
	           *    });
	           * </pre></p>
	           * @param {Function} fn An optional function with two arguments resolve
	           *                   and reject.The first argument fulfills the promise,
	           *                   the second argument rejects it. We can call these
	            *                  functions, once our operation is completed.
	           * @see AV.Promise.prototype.then
	           * @class
	           */
	          this._resolved = false;
	          this._rejected = false;
	          this._resolvedCallbacks = [];
	          this._rejectedCallbacks = [];
	
	          this.doResolve(fn);
	        };
	
	        var _isNullOrUndefined = function _isNullOrUndefined(x) {
	          return _.isNull(x) || _.isUndefined(x);
	        };
	
	        var _isNode = false;
	
	        if (typeof process !== "undefined" && process.versions && process.versions.node) {
	          _isNode = true;
	        }
	
	        _.extend(Promise, /** @lends AV.Promise */{
	
	          _isPromisesAPlusCompliant: !_isNode,
	          _debugError: false,
	
	          setPromisesAPlusCompliant: function setPromisesAPlusCompliant(isCompliant) {
	            Promise._isPromisesAPlusCompliant = isCompliant;
	          },
	
	          setDebugError: function setDebugError(enable) {
	            Promise._debugError = enable;
	          },
	
	          /**
	           * Returns true iff the given object fulfils the Promise interface.
	           * @return {Boolean}
	           */
	          is: function is(promise) {
	            return promise && promise.then && _.isFunction(promise.then);
	          },
	
	          /**
	           * Returns a new promise that is resolved with a given value.
	           * @return {AV.Promise} the new promise.
	           */
	          as: function as() {
	            var promise = new Promise();
	            if (arguments[0] && _.isFunction(arguments[0].then)) {
	              arguments[0].then(function (data) {
	                promise.resolve.call(promise, data);
	              }, function (err) {
	                promise.reject.call(promise, err);
	              });
	            } else {
	              promise.resolve.apply(promise, arguments);
	            }
	            return promise;
	          },
	
	          /**
	           * Returns a new promise that is rejected with a given error.
	           * @return {AV.Promise} the new promise.
	           */
	          error: function error() {
	            var promise = new Promise();
	            promise.reject.apply(promise, arguments);
	            return promise;
	          },
	
	          /**
	           * Returns a new promise that is fulfilled when all of the input promises
	           * are resolved. If any promise in the list fails, then the returned promise
	           * will fail with the last error. If they all succeed, then the returned
	           * promise will succeed, with the results being the results of all the input
	           * promises. For example: <pre>
	           *   var p1 = AV.Promise.as(1);
	           *   var p2 = AV.Promise.as(2);
	           *   var p3 = AV.Promise.as(3);
	           *
	           *   AV.Promise.when(p1, p2, p3).then(function(r1, r2, r3) {
	           *     console.log(r1);  // prints 1
	           *     console.log(r2);  // prints 2
	           *     console.log(r3);  // prints 3
	           *   });</pre>
	           *
	           * The input promises can also be specified as an array: <pre>
	           *   var promises = [p1, p2, p3];
	           *   AV.Promise.when(promises).then(function(r1, r2, r3) {
	           *     console.log(r1);  // prints 1
	           *     console.log(r2);  // prints 2
	           *     console.log(r3);  // prints 3
	           *   });
	           * </pre>
	           * @param {Array} promises a list of promises to wait for.
	           * @return {AV.Promise} the new promise.
	           */
	          when: function when(promises) {
	            // Allow passing in Promises as separate arguments instead of an Array.
	            var objects;
	            if (promises && _isNullOrUndefined(promises.length)) {
	              objects = arguments;
	            } else {
	              objects = promises;
	            }
	            var isAll = _.last(arguments);
	            isAll = _.isBoolean(isAll) ? isAll : false;
	
	            var total = objects.length;
	            var hadError = false;
	            var results = [];
	            var errors = [];
	            results.length = objects.length;
	            errors.length = objects.length;
	
	            if (total === 0) {
	              if (isAll) {
	                return Promise.as.call(this, results);
	              } else {
	                return Promise.as.apply(this, results);
	              }
	            }
	
	            var promise = new Promise();
	
	            var resolveOne = function resolveOne(i) {
	              total = total - 1;
	              if (hadError && !promise._rejected && isAll) {
	                promise.reject.call(promise, errors[i]);
	                return;
	              }
	
	              if (total === 0) {
	                if (hadError && !promise._rejected) {
	                  promise.reject.call(promise, errors);
	                } else {
	                  if (isAll) {
	                    if (!promise._rejected) {
	                      promise.resolve.call(promise, results);
	                    } else {
	                      //It's rejected already, so we ignore it.
	                    }
	                  } else {
	                      promise.resolve.apply(promise, results);
	                    }
	                }
	              }
	            };
	
	            _.each(objects, function (object, i) {
	              if (Promise.is(object)) {
	                object.then(function (result) {
	                  results[i] = result;
	                  resolveOne(i);
	                }, function (error) {
	                  errors[i] = error;
	                  hadError = true;
	                  resolveOne(i);
	                });
	              } else {
	                results[i] = object;
	                resolveOne(i);
	              }
	            });
	
	            return promise;
	          },
	
	          /**
	           * Returns a promise that resolves or rejects as soon as one
	           * of the promises in the iterable resolves or rejects, with
	           * the value or reason from that promise.Returns a new promise
	           * that is fulfilled when one of the input promises.
	           * For example: <pre>
	           *   var p1 = AV.Promise.as(1);
	           *   var p2 = AV.Promise.as(2);
	           *   var p3 = AV.Promise.as(3);
	           *
	           *   AV.Promise.race(p1, p2, p3).then(function(result) {
	           *     console.log(result);  // prints 1
	           *   });</pre>
	           *
	           * The input promises can also be specified as an array: <pre>
	           *   var promises = [p1, p2, p3];
	           *   AV.Promise.when(promises).then(function(result) {
	           *     console.log(result);  // prints 1
	           *   });
	           * </pre>
	           * @param {Array} promises a list of promises to wait for.
	           * @return {AV.Promise} the new promise.
	           */
	          race: function race(promises) {
	            // Allow passing in Promises as separate arguments instead of an Array.
	            var objects;
	            if (promises && _isNullOrUndefined(promises.length)) {
	              objects = arguments;
	            } else {
	              objects = promises;
	            }
	
	            var total = objects.length;
	            var hadError = false;
	            var results = [];
	            var errors = [];
	
	            results.length = errors.length = objects.length;
	
	            if (total === 0) {
	              return Promise.as.call(this);
	            }
	
	            var promise = new Promise();
	
	            var resolveOne = function resolveOne(i) {
	              if (!promise._resolved && !promise._rejected) {
	                if (hadError) {
	                  promise.reject.call(promise, errors[i]);
	                } else {
	                  promise.resolve.call(promise, results[i]);
	                }
	              }
	            };
	
	            _.each(objects, function (object, i) {
	              if (Promise.is(object)) {
	                object.then(function (result) {
	                  results[i] = result;
	                  resolveOne(i);
	                }, function (error) {
	                  errors[i] = error;
	                  hadError = true;
	                  resolveOne(i);
	                });
	              } else {
	                results[i] = object;
	                resolveOne(i);
	              }
	            });
	
	            return promise;
	          },
	
	          /**
	           * Runs the given asyncFunction repeatedly, as long as the predicate
	           * function returns a truthy value. Stops repeating if asyncFunction returns
	           * a rejected promise.
	           * @param {Function} predicate should return false when ready to stop.
	           * @param {Function} asyncFunction should return a Promise.
	           */
	          _continueWhile: function _continueWhile(predicate, asyncFunction) {
	            if (predicate()) {
	              return asyncFunction().then(function () {
	                return Promise._continueWhile(predicate, asyncFunction);
	              });
	            }
	            return Promise.as();
	          }
	        });
	
	        /**
	         * Just like AV.Promise.when, but it calls resolveCallbck function
	         * with one results array and calls rejectCallback function as soon as any one
	         * of the input promises rejects.
	         * @see AV.Promise.when
	         */
	        Promise.all = function (promises) {
	          return Promise.when(promises, true);
	        };
	
	        _.extend(Promise.prototype, /** @lends AV.Promise.prototype */{
	
	          /**
	           * Marks this promise as fulfilled, firing any callbacks waiting on it.
	           * @param {Object} result the result to pass to the callbacks.
	           */
	          resolve: function resolve(result) {
	            if (this._resolved || this._rejected) {
	              throw "A promise was resolved even though it had already been " + (this._resolved ? "resolved" : "rejected") + ".";
	            }
	            this._resolved = true;
	            this._result = arguments;
	            var results = arguments;
	            _.each(this._resolvedCallbacks, function (resolvedCallback) {
	              resolvedCallback.apply(this, results);
	            });
	            this._resolvedCallbacks = [];
	            this._rejectedCallbacks = [];
	          },
	
	          doResolve: function doResolve(fn) {
	            if (!fn) return;
	            var done = false;
	            var self = this;
	            try {
	              fn(function (value) {
	                if (done) return;
	                done = true;
	                self.resolve.call(self, value);
	              }, function (reason) {
	                if (done) return;
	                done = true;
	                self.reject.call(self, reason);
	              });
	            } catch (ex) {
	              if (done) return;
	              done = true;
	              self.reject.call(self, ex);
	            }
	          },
	
	          /**
	           * Marks this promise as fulfilled, firing any callbacks waiting on it.
	           * @param {Object} error the error to pass to the callbacks.
	           */
	          reject: function reject(error) {
	            if (this._resolved || this._rejected) {
	              throw "A promise was rejected even though it had already been " + (this._resolved ? "resolved" : "rejected") + ".";
	            }
	            this._rejected = true;
	            this._error = error;
	            _.each(this._rejectedCallbacks, function (rejectedCallback) {
	              rejectedCallback(error);
	            });
	            this._resolvedCallbacks = [];
	            this._rejectedCallbacks = [];
	          },
	
	          /**
	           * Adds callbacks to be called when this promise is fulfilled. Returns a new
	           * Promise that will be fulfilled when the callback is complete. It allows
	           * chaining. If the callback itself returns a Promise, then the one returned
	           * by "then" will not be fulfilled until that one returned by the callback
	           * is fulfilled.
	           * @param {Function} resolvedCallback Function that is called when this
	           * Promise is resolved. Once the callback is complete, then the Promise
	           * returned by "then" will also be fulfilled.
	           * @param {Function} rejectedCallback Function that is called when this
	           * Promise is rejected with an error. Once the callback is complete, then
	           * the promise returned by "then" with be resolved successfully. If
	           * rejectedCallback is null, or it returns a rejected Promise, then the
	           * Promise returned by "then" will be rejected with that error.
	           * @return {AV.Promise} A new Promise that will be fulfilled after this
	           * Promise is fulfilled and either callback has completed. If the callback
	           * returned a Promise, then this Promise will not be fulfilled until that
	           * one is.
	           */
	          then: function then(resolvedCallback, rejectedCallback) {
	            var promise = new Promise();
	
	            var wrappedResolvedCallback = function wrappedResolvedCallback() {
	              var result = arguments;
	              if (resolvedCallback) {
	                if (Promise._isPromisesAPlusCompliant) {
	                  try {
	                    result = [resolvedCallback.apply(this, result)];
	                  } catch (e) {
	                    if (Promise._debugError && e) {
	                      console.error('Error occurred in promise resolve callback.', e.stack || e);
	                    }
	                    result = [Promise.error(e)];
	                  }
	                } else {
	                  result = [resolvedCallback.apply(this, result)];
	                }
	              }
	              if (result.length === 1 && Promise.is(result[0])) {
	                result[0].then(function () {
	                  promise.resolve.apply(promise, arguments);
	                }, function (error) {
	                  promise.reject(error);
	                });
	              } else {
	                promise.resolve.apply(promise, result);
	              }
	            };
	
	            var wrappedRejectedCallback = function wrappedRejectedCallback(error) {
	              var result = [];
	              if (rejectedCallback) {
	                if (Promise._isPromisesAPlusCompliant) {
	                  try {
	                    result = [rejectedCallback(error)];
	                  } catch (e) {
	                    if (Promise._debugError && e) {
	                      console.error('Error occurred in promise reject callback.', e.stack || e);
	                    }
	                    result = [Promise.error(e)];
	                  }
	                } else {
	                  result = [rejectedCallback(error)];
	                }
	                if (result.length === 1 && Promise.is(result[0])) {
	                  result[0].then(function () {
	                    promise.resolve.apply(promise, arguments);
	                  }, function (error) {
	                    promise.reject(error);
	                  });
	                } else {
	                  if (Promise._isPromisesAPlusCompliant) {
	                    promise.resolve.apply(promise, result);
	                  } else {
	                    promise.reject(result[0]);
	                  }
	                }
	              } else {
	                promise.reject(error);
	              }
	            };
	
	            var runLater = function runLater(func) {
	              func.call();
	            };
	            if (Promise._isPromisesAPlusCompliant) {
	              if (typeof window !== 'undefined' && _.isFunction(window.setImmediate)) {
	                runLater = function runLater(func) {
	                  window.setImmediate(func);
	                };
	              } else if (typeof process !== 'undefined' && process.nextTick) {
	                runLater = function runLater(func) {
	                  process.nextTick(func);
	                };
	              } else if (typeof setTimeout !== 'undefined' && _.isFunction(setTimeout)) {
	                runLater = function runLater(func) {
	                  setTimeout(func, 0);
	                };
	              }
	            }
	
	            var self = this;
	            if (this._resolved) {
	              runLater(function () {
	                wrappedResolvedCallback.apply(self, self._result);
	              });
	            } else if (this._rejected) {
	              runLater(function () {
	                wrappedRejectedCallback.apply(self, [self._error]);
	              });
	            } else {
	              this._resolvedCallbacks.push(wrappedResolvedCallback);
	              this._rejectedCallbacks.push(wrappedRejectedCallback);
	            }
	
	            return promise;
	          },
	
	          /**
	           * Add handlers to be called when the Promise object is rejected.
	           *
	           * @param {Function} rejectedCallback Function that is called when this
	           *                   Promise is rejected with an error.
	           * @return {AV.Promise} A new Promise that will be fulfilled after this
	           *                   Promise is fulfilled and either callback has completed. If the callback
	           * returned a Promise, then this Promise will not be fulfilled until that
	           *                   one is.
	           * @function
	           */
	          catch: function _catch(onRejected) {
	            return this.then(undefined, onRejected);
	          },
	
	          /**
	           * Add handlers to be called when the promise
	           * is either resolved or rejected
	           */
	          always: function always(callback) {
	            return this.then(callback, callback);
	          },
	
	          /**
	           * Add handlers to be called when the Promise object is resolved
	           */
	          done: function done(callback) {
	            return this.then(callback);
	          },
	
	          /**
	           * Add handlers to be called when the Promise object is rejected
	           */
	          fail: function fail(callback) {
	            return this.then(null, callback);
	          },
	
	          /**
	           * Run the given callbacks after this promise is fulfilled.
	           * @param optionsOrCallback {} A Backbone-style options callback, or a
	           * callback function. If this is an options object and contains a "model"
	           * attributes, that will be passed to error callbacks as the first argument.
	           * @param model {} If truthy, this will be passed as the first result of
	           * error callbacks. This is for Backbone-compatability.
	           * @return {AV.Promise} A promise that will be resolved after the
	           * callbacks are run, with the same result as this.
	           */
	          _thenRunCallbacks: function _thenRunCallbacks(optionsOrCallback, model) {
	            var options;
	            if (_.isFunction(optionsOrCallback)) {
	              var callback = optionsOrCallback;
	              options = {
	                success: function success(result) {
	                  callback(result, null);
	                },
	                error: function error(_error) {
	                  callback(null, _error);
	                }
	              };
	            } else {
	              options = _.clone(optionsOrCallback);
	            }
	            options = options || {};
	
	            return this.then(function (result) {
	              if (options.success) {
	                options.success.apply(this, arguments);
	              } else if (model) {
	                // When there's no callback, a sync event should be triggered.
	                model.trigger('sync', model, result, options);
	              }
	              return Promise.as.apply(Promise, arguments);
	            }, function (error) {
	              if (options.error) {
	                if (!_.isUndefined(model)) {
	                  options.error(model, error);
	                } else {
	                  options.error(error);
	                }
	              } else if (model) {
	                // When there's no error callback, an error event should be triggered.
	                model.trigger('error', model, error, options);
	              }
	              // By explicitly returning a rejected Promise, this will work with
	              // either jQuery or Promises/A semantics.
	              return Promise.error(error);
	            });
	          },
	
	          /**
	           * Adds a callback function that should be called regardless of whether
	           * this promise failed or succeeded. The callback will be given either the
	           * array of results for its first argument, or the error as its second,
	           * depending on whether this Promise was rejected or resolved. Returns a
	           * new Promise, like "then" would.
	           * @param {Function} continuation the callback.
	           */
	          _continueWith: function _continueWith(continuation) {
	            return this.then(function () {
	              return continuation(arguments, null);
	            }, function (error) {
	              return continuation(null, error);
	            });
	          }
	
	        });
	
	        /**
	         * Alias of AV.Promise.prototype.always
	         * @function
	         * @see AV.Promise#always
	         */
	        Promise.prototype.finally = Promise.prototype.always;
	
	        /**
	         * Alias of AV.Promise.prototype.done
	         * @function
	         * @see AV.Promise#done
	         */
	        Promise.prototype.try = Promise.prototype.done;
	      }).call(this, require('_process'));
	    }, { "_process": 10, "underscore": 17 }], 34: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var AVRequest = require('./request').request;
	
	      module.exports = function (AV) {
	        AV.Installation = AV.Object.extend("_Installation");
	
	        /**
	         * Contains functions to deal with Push in AV
	         * @name AV.Push
	         * @namespace
	         */
	        AV.Push = AV.Push || {};
	
	        /**
	         * Sends a push notification.
	         * @param {Object} data -  The data of the push notification.  Valid fields
	         * are:
	         *   <ol>
	         *     <li>channels - An Array of channels to push to.</li>
	         *     <li>push_time - A Date object for when to send the push.</li>
	         *     <li>expiration_time -  A Date object for when to expire
	         *         the push.</li>
	         *     <li>expiration_interval - The seconds from now to expire the push.</li>
	         *     <li>where - A AV.Query over AV.Installation that is used to match
	         *         a set of installations to push to.</li>
	         *     <li>cql - A CQL statement over AV.Installation that is used to match
	         *         a set of installations to push to.</li>
	         *     <li>data - The data to send as part of the push</li>
	         *   <ol>
	         * @param {Object} options An object that has an optional success function,
	         * that takes no arguments and will be called on a successful push, and
	         * an error function that takes a AVError and will be called if the push
	         * failed.
	         */
	        AV.Push.send = function (data, options) {
	          if (data.where) {
	            data.where = data.where.toJSON().where;
	          }
	
	          if (data.where && data.cql) {
	            throw "Both where and cql can't be set";
	          }
	
	          if (data.push_time) {
	            data.push_time = data.push_time.toJSON();
	          }
	
	          if (data.expiration_time) {
	            data.expiration_time = data.expiration_time.toJSON();
	          }
	
	          if (data.expiration_time && data.expiration_time_interval) {
	            throw "Both expiration_time and expiration_time_interval can't be set";
	          }
	
	          var request = AVRequest('push', null, null, 'POST', data);
	          return request._thenRunCallbacks(options);
	        };
	      };
	    }, { "./request": 37 }], 35: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	      var AVError = require('./error');
	      var AVRequest = require('./request').request;
	
	      // AV.Query is a way to create a list of AV.Objects.
	      module.exports = function (AV) {
	        /**
	         * Creates a new avoscloud AV.Query for the given AV.Object subclass.
	         * @param objectClass -
	         *   An instance of a subclass of AV.Object, or a AV className string.
	         * @class
	         *
	         * <p>AV.Query defines a query that is used to fetch AV.Objects. The
	         * most common use case is finding all objects that match a query through the
	         * <code>find</code> method. For example, this sample code fetches all objects
	         * of class <code>MyClass</code>. It calls a different function depending on
	         * whether the fetch succeeded or not.
	         *
	         * <pre>
	         * var query = new AV.Query(MyClass);
	         * query.find({
	         *   success: function(results) {
	         *     // results is an array of AV.Object.
	         *   },
	         *
	         *   error: function(error) {
	         *     // error is an instance of AVError.
	         *   }
	         * });</pre></p>
	         *
	         * <p>A AV.Query can also be used to retrieve a single object whose id is
	         * known, through the get method. For example, this sample code fetches an
	         * object of class <code>MyClass</code> and id <code>myId</code>. It calls a
	         * different function depending on whether the fetch succeeded or not.
	         *
	         * <pre>
	         * var query = new AV.Query(MyClass);
	         * query.get(myId, {
	         *   success: function(object) {
	         *     // object is an instance of AV.Object.
	         *   },
	         *
	         *   error: function(object, error) {
	         *     // error is an instance of AVError.
	         *   }
	         * });</pre></p>
	         *
	         * <p>A AV.Query can also be used to count the number of objects that match
	         * the query without retrieving all of those objects. For example, this
	         * sample code counts the number of objects of the class <code>MyClass</code>
	         * <pre>
	         * var query = new AV.Query(MyClass);
	         * query.count({
	         *   success: function(number) {
	         *     // There are number instances of MyClass.
	         *   },
	         *
	         *   error: function(error) {
	         *     // error is an instance of AVError.
	         *   }
	         * });</pre></p>
	         */
	        AV.Query = function (objectClass) {
	          if (_.isString(objectClass)) {
	            objectClass = AV.Object._getSubclass(objectClass);
	          }
	
	          this.objectClass = objectClass;
	
	          this.className = objectClass.prototype.className;
	
	          this._where = {};
	          this._include = [];
	          this._limit = -1; // negative limit means, do not send a limit
	          this._skip = 0;
	          this._extraOptions = {};
	        };
	
	        /**
	         * Constructs a AV.Query that is the OR of the passed in queries.  For
	         * example:
	         * <pre>var compoundQuery = AV.Query.or(query1, query2, query3);</pre>
	         *
	         * will create a compoundQuery that is an or of the query1, query2, and
	         * query3.
	         * @param {...AV.Query} var_args The list of queries to OR.
	         * @return {AV.Query} The query that is the OR of the passed in queries.
	         */
	        AV.Query.or = function () {
	          var queries = _.toArray(arguments);
	          var className = null;
	          AV._arrayEach(queries, function (q) {
	            if (_.isNull(className)) {
	              className = q.className;
	            }
	
	            if (className !== q.className) {
	              throw "All queries must be for the same class";
	            }
	          });
	          var query = new AV.Query(className);
	          query._orQuery(queries);
	          return query;
	        };
	
	        /**
	         * Constructs a AV.Query that is the AND of the passed in queries.  For
	         * example:
	         * <pre>var compoundQuery = AV.Query.and(query1, query2, query3);</pre>
	         *
	         * will create a compoundQuery that is an 'and' of the query1, query2, and
	         * query3.
	         * @param {...AV.Query} var_args The list of queries to AND.
	         * @return {AV.Query} The query that is the AND of the passed in queries.
	         */
	        AV.Query.and = function () {
	          var queries = _.toArray(arguments);
	          var className = null;
	          AV._arrayEach(queries, function (q) {
	            if (_.isNull(className)) {
	              className = q.className;
	            }
	
	            if (className !== q.className) {
	              throw "All queries must be for the same class";
	            }
	          });
	          var query = new AV.Query(className);
	          query._andQuery(queries);
	          return query;
	        };
	
	        /**
	         * Retrieves a list of AVObjects that satisfy the CQL.
	         * CQL syntax please see <a href='https://cn.avoscloud.com/docs/cql_guide.html'>CQL Guide.</a>
	         * Either options.success or options.error is called when the find
	         * completes.
	         *
	         * @param {String} cql,  A CQL string, see <a href='https://cn.avoscloud.com/docs/cql_guide.html'>CQL Guide.</a>
	         * @param {Array} pvalues, An array contains placeholder values.
	         * @param {Object} options A Backbone-style options object,it's optional.
	         * @return {AV.Promise} A promise that is resolved with the results when
	         * the query completes,it's optional.
	         */
	        AV.Query.doCloudQuery = function (cql, pvalues, options) {
	          var params = { cql: cql };
	          if (_.isArray(pvalues)) {
	            params.pvalues = pvalues;
	          } else {
	            options = pvalues;
	          }
	
	          var request = AVRequest('cloudQuery', null, null, 'GET', params, options && options.sessionToken);
	          return request.then(function (response) {
	            //query to process results.
	            var query = new AV.Query(response.className);
	            var results = _.map(response.results, function (json) {
	              var obj = query._newObject(response);
	              obj._finishFetch(query._processResult(json), true);
	              return obj;
	            });
	            return {
	              results: results,
	              count: response.count,
	              className: response.className
	            };
	          })._thenRunCallbacks(options);
	        };
	
	        AV.Query._extend = AV._extend;
	
	        AV.Query.prototype = {
	          //hook to iterate result. Added by dennis<xzhuang@avoscloud.com>.
	          _processResult: function _processResult(obj) {
	            return obj;
	          },
	
	          /**
	           * Constructs a AV.Object whose id is already known by fetching data from
	           * the server.  Either options.success or options.error is called when the
	           * find completes.
	           *
	           * @param {} objectId The id of the object to be fetched.
	           * @param {Object} options A Backbone-style options object.
	           */
	          get: function get(objectId, options) {
	            if (!objectId) {
	              var errorObject = new AVError(AVError.OBJECT_NOT_FOUND, "Object not found.");
	              throw errorObject;
	            }
	
	            var self = this;
	            self.equalTo('objectId', objectId);
	
	            return self.first().then(function (response) {
	              if (!_.isEmpty(response)) {
	                return response;
	              }
	
	              var errorObject = new AVError(AVError.OBJECT_NOT_FOUND, "Object not found.");
	              return AV.Promise.error(errorObject);
	            })._thenRunCallbacks(options, null);
	          },
	
	          /**
	           * Returns a JSON representation of this query.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            var params = {
	              where: this._where
	            };
	
	            if (this._include.length > 0) {
	              params.include = this._include.join(",");
	            }
	            if (this._select) {
	              params.keys = this._select.join(",");
	            }
	            if (this._limit >= 0) {
	              params.limit = this._limit;
	            }
	            if (this._skip > 0) {
	              params.skip = this._skip;
	            }
	            if (this._order !== undefined) {
	              params.order = this._order;
	            }
	
	            AV._objectEach(this._extraOptions, function (v, k) {
	              params[k] = v;
	            });
	
	            return params;
	          },
	
	          _newObject: function _newObject(response) {
	            var obj;
	            if (response && response.className) {
	              obj = new AV.Object(response.className);
	            } else {
	              obj = new this.objectClass();
	            }
	            return obj;
	          },
	          _createRequest: function _createRequest(params, options) {
	            return AVRequest('classes', this.className, null, "GET", params || this.toJSON(), options && options.sessionToken);
	          },
	
	          /**
	           * Retrieves a list of AVObjects that satisfy this query.
	           * Either options.success or options.error is called when the find
	           * completes.
	           *
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is resolved with the results when
	           * the query completes.
	           */
	          find: function find(options) {
	            var self = this;
	
	            var request = this._createRequest(null, options);
	
	            return request.then(function (response) {
	              return _.map(response.results, function (json) {
	                var obj = self._newObject(response);
	                obj._finishFetch(self._processResult(json), true);
	                return obj;
	              });
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Delete objects retrieved by this query.
	           * @param {Object} options Standard options object with success and error
	           *     callbacks.
	           * @return {AV.Promise} A promise that is fulfilled when the save
	           *     completes.
	           */
	          destroyAll: function destroyAll(options) {
	            var self = this;
	            return self.find().then(function (objects) {
	              return AV.Object.destroyAll(objects);
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Counts the number of objects that match this query.
	           * Either options.success or options.error is called when the count
	           * completes.
	           *
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is resolved with the count when
	           * the query completes.
	           */
	          count: function count(options) {
	            var params = this.toJSON();
	            params.limit = 0;
	            params.count = 1;
	            var request = this._createRequest(params, options);
	
	            return request.then(function (response) {
	              return response.count;
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Retrieves at most one AV.Object that satisfies this query.
	           *
	           * Either options.success or options.error is called when it completes.
	           * success is passed the object if there is one. otherwise, undefined.
	           *
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is resolved with the object when
	           * the query completes.
	           */
	          first: function first(options) {
	            var self = this;
	
	            var params = this.toJSON();
	            params.limit = 1;
	            var request = this._createRequest(params, options);
	
	            return request.then(function (response) {
	              return _.map(response.results, function (json) {
	                var obj = self._newObject();
	                obj._finishFetch(self._processResult(json), true);
	                return obj;
	              })[0];
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Returns a new instance of AV.Collection backed by this query.
	           * @return {AV.Collection}
	           */
	          collection: function collection(items, options) {
	            options = options || {};
	            return new AV.Collection(items, _.extend(options, {
	              model: this._objectClass || this.objectClass,
	              query: this
	            }));
	          },
	
	          /**
	           * Sets the number of results to skip before returning any results.
	           * This is useful for pagination.
	           * Default is to skip zero results.
	           * @param {Number} n the number of results to skip.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          skip: function skip(n) {
	            this._skip = n;
	            return this;
	          },
	
	          /**
	           * Sets the limit of the number of results to return. The default limit is
	           * 100, with a maximum of 1000 results being returned at a time.
	           * @param {Number} n the number of results to limit to.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          limit: function limit(n) {
	            this._limit = n;
	            return this;
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's value to
	           * be equal to the provided value.
	           * @param {String} key The key to check.
	           * @param value The value that the AV.Object must contain.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          equalTo: function equalTo(key, value) {
	            this._where[key] = AV._encode(value);
	            return this;
	          },
	
	          /**
	           * Helper for condition queries
	           */
	          _addCondition: function _addCondition(key, condition, value) {
	            // Check if we already have a condition
	            if (!this._where[key]) {
	              this._where[key] = {};
	            }
	            this._where[key][condition] = AV._encode(value);
	            return this;
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular
	           * <strong>array</strong> key's length to be equal to the provided value.
	           * @param {String} key The array key to check.
	           * @param value The length value.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          sizeEqualTo: function sizeEqualTo(key, value) {
	            this._addCondition(key, "$size", value);
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's value to
	           * be not equal to the provided value.
	           * @param {String} key The key to check.
	           * @param value The value that must not be equalled.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          notEqualTo: function notEqualTo(key, value) {
	            this._addCondition(key, "$ne", value);
	            return this;
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's value to
	           * be less than the provided value.
	           * @param {String} key The key to check.
	           * @param value The value that provides an upper bound.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          lessThan: function lessThan(key, value) {
	            this._addCondition(key, "$lt", value);
	            return this;
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's value to
	           * be greater than the provided value.
	           * @param {String} key The key to check.
	           * @param value The value that provides an lower bound.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          greaterThan: function greaterThan(key, value) {
	            this._addCondition(key, "$gt", value);
	            return this;
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's value to
	           * be less than or equal to the provided value.
	           * @param {String} key The key to check.
	           * @param value The value that provides an upper bound.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          lessThanOrEqualTo: function lessThanOrEqualTo(key, value) {
	            this._addCondition(key, "$lte", value);
	            return this;
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's value to
	           * be greater than or equal to the provided value.
	           * @param {String} key The key to check.
	           * @param value The value that provides an lower bound.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          greaterThanOrEqualTo: function greaterThanOrEqualTo(key, value) {
	            this._addCondition(key, "$gte", value);
	            return this;
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's value to
	           * be contained in the provided list of values.
	           * @param {String} key The key to check.
	           * @param {Array} values The values that will match.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          containedIn: function containedIn(key, values) {
	            this._addCondition(key, "$in", values);
	            return this;
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's value to
	           * not be contained in the provided list of values.
	           * @param {String} key The key to check.
	           * @param {Array} values The values that will not match.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          notContainedIn: function notContainedIn(key, values) {
	            this._addCondition(key, "$nin", values);
	            return this;
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's value to
	           * contain each one of the provided list of values.
	           * @param {String} key The key to check.  This key's value must be an array.
	           * @param {Array} values The values that will match.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          containsAll: function containsAll(key, values) {
	            this._addCondition(key, "$all", values);
	            return this;
	          },
	
	          /**
	           * Add a constraint for finding objects that contain the given key.
	           * @param {String} key The key that should exist.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          exists: function exists(key) {
	            this._addCondition(key, "$exists", true);
	            return this;
	          },
	
	          /**
	           * Add a constraint for finding objects that do not contain a given key.
	           * @param {String} key The key that should not exist
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          doesNotExist: function doesNotExist(key) {
	            this._addCondition(key, "$exists", false);
	            return this;
	          },
	
	          /**
	           * Add a regular expression constraint for finding string values that match
	           * the provided regular expression.
	           * This may be slow for large datasets.
	           * @param {String} key The key that the string to match is stored in.
	           * @param {RegExp} regex The regular expression pattern to match.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          matches: function matches(key, regex, modifiers) {
	            this._addCondition(key, "$regex", regex);
	            if (!modifiers) {
	              modifiers = "";
	            }
	            // Javascript regex options support mig as inline options but store them
	            // as properties of the object. We support mi & should migrate them to
	            // modifiers
	            if (regex.ignoreCase) {
	              modifiers += 'i';
	            }
	            if (regex.multiline) {
	              modifiers += 'm';
	            }
	
	            if (modifiers && modifiers.length) {
	              this._addCondition(key, "$options", modifiers);
	            }
	            return this;
	          },
	
	          /**
	           * Add a constraint that requires that a key's value matches a AV.Query
	           * constraint.
	           * @param {String} key The key that the contains the object to match the
	           *                     query.
	           * @param {AV.Query} query The query that should match.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          matchesQuery: function matchesQuery(key, query) {
	            var queryJSON = query.toJSON();
	            queryJSON.className = query.className;
	            this._addCondition(key, "$inQuery", queryJSON);
	            return this;
	          },
	
	          /**
	            * Add a constraint that requires that a key's value not matches a
	            * AV.Query constraint.
	            * @param {String} key The key that the contains the object to match the
	            *                     query.
	            * @param {AV.Query} query The query that should not match.
	            * @return {AV.Query} Returns the query, so you can chain this call.
	            */
	          doesNotMatchQuery: function doesNotMatchQuery(key, query) {
	            var queryJSON = query.toJSON();
	            queryJSON.className = query.className;
	            this._addCondition(key, "$notInQuery", queryJSON);
	            return this;
	          },
	
	          /**
	           * Add a constraint that requires that a key's value matches a value in
	           * an object returned by a different AV.Query.
	           * @param {String} key The key that contains the value that is being
	           *                     matched.
	           * @param {String} queryKey The key in the objects returned by the query to
	           *                          match against.
	           * @param {AV.Query} query The query to run.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          matchesKeyInQuery: function matchesKeyInQuery(key, queryKey, query) {
	            var queryJSON = query.toJSON();
	            queryJSON.className = query.className;
	            this._addCondition(key, "$select", { key: queryKey, query: queryJSON });
	            return this;
	          },
	
	          /**
	           * Add a constraint that requires that a key's value not match a value in
	           * an object returned by a different AV.Query.
	           * @param {String} key The key that contains the value that is being
	           *                     excluded.
	           * @param {String} queryKey The key in the objects returned by the query to
	           *                          match against.
	           * @param {AV.Query} query The query to run.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          doesNotMatchKeyInQuery: function doesNotMatchKeyInQuery(key, queryKey, query) {
	            var queryJSON = query.toJSON();
	            queryJSON.className = query.className;
	            this._addCondition(key, "$dontSelect", { key: queryKey, query: queryJSON });
	            return this;
	          },
	
	          /**
	           * Add constraint that at least one of the passed in queries matches.
	           * @param {Array} queries
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          _orQuery: function _orQuery(queries) {
	            var queryJSON = _.map(queries, function (q) {
	              return q.toJSON().where;
	            });
	
	            this._where.$or = queryJSON;
	            return this;
	          },
	
	          /**
	           * Add constraint that both of the passed in queries matches.
	           * @param {Array} queries
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          _andQuery: function _andQuery(queries) {
	            var queryJSON = _.map(queries, function (q) {
	              return q.toJSON().where;
	            });
	
	            this._where.$and = queryJSON;
	            return this;
	          },
	
	          /**
	           * Converts a string into a regex that matches it.
	           * Surrounding with \Q .. \E does this, we just need to escape \E's in
	           * the text separately.
	           */
	          _quote: function _quote(s) {
	            return "\\Q" + s.replace("\\E", "\\E\\\\E\\Q") + "\\E";
	          },
	
	          /**
	           * Add a constraint for finding string values that contain a provided
	           * string.  This may be slow for large datasets.
	           * @param {String} key The key that the string to match is stored in.
	           * @param {String} substring The substring that the value must contain.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          contains: function contains(key, value) {
	            this._addCondition(key, "$regex", this._quote(value));
	            return this;
	          },
	
	          /**
	           * Add a constraint for finding string values that start with a provided
	           * string.  This query will use the backend index, so it will be fast even
	           * for large datasets.
	           * @param {String} key The key that the string to match is stored in.
	           * @param {String} prefix The substring that the value must start with.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          startsWith: function startsWith(key, value) {
	            this._addCondition(key, "$regex", "^" + this._quote(value));
	            return this;
	          },
	
	          /**
	           * Add a constraint for finding string values that end with a provided
	           * string.  This will be slow for large datasets.
	           * @param {String} key The key that the string to match is stored in.
	           * @param {String} suffix The substring that the value must end with.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          endsWith: function endsWith(key, value) {
	            this._addCondition(key, "$regex", this._quote(value) + "$");
	            return this;
	          },
	
	          /**
	           * Sorts the results in ascending order by the given key.
	           *
	           * @param {String} key The key to order by.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          ascending: function ascending(key) {
	            this._order = key;
	            return this;
	          },
	
	          /**
	           * Also sorts the results in ascending order by the given key. The previous sort keys have
	           * precedence over this key.
	           *
	           * @param {String} key The key to order by
	           * @return {AV.Query} Returns the query so you can chain this call.
	           */
	          addAscending: function addAscending(key) {
	            if (this._order) this._order += ',' + key;else this._order = key;
	            return this;
	          },
	
	          /**
	           * Sorts the results in descending order by the given key.
	           *
	           * @param {String} key The key to order by.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          descending: function descending(key) {
	            this._order = "-" + key;
	            return this;
	          },
	
	          /**
	          * Also sorts the results in descending order by the given key. The previous sort keys have
	          * precedence over this key.
	          *
	          * @param {String} key The key to order by
	          * @return {AV.Query} Returns the query so you can chain this call.
	          */
	          addDescending: function addDescending(key) {
	            if (this._order) this._order += ',-' + key;else this._order = '-' + key;
	            return key;
	          },
	
	          /**
	           * Add a proximity based constraint for finding objects with key point
	           * values near the point given.
	           * @param {String} key The key that the AV.GeoPoint is stored in.
	           * @param {AV.GeoPoint} point The reference AV.GeoPoint that is used.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          near: function near(key, point) {
	            if (!(point instanceof AV.GeoPoint)) {
	              // Try to cast it to a GeoPoint, so that near("loc", [20,30]) works.
	              point = new AV.GeoPoint(point);
	            }
	            this._addCondition(key, "$nearSphere", point);
	            return this;
	          },
	
	          /**
	           * Add a proximity based constraint for finding objects with key point
	           * values near the point given and within the maximum distance given.
	           * @param {String} key The key that the AV.GeoPoint is stored in.
	           * @param {AV.GeoPoint} point The reference AV.GeoPoint that is used.
	           * @param maxDistance Maximum distance (in radians) of results to return.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          withinRadians: function withinRadians(key, point, distance) {
	            this.near(key, point);
	            this._addCondition(key, "$maxDistance", distance);
	            return this;
	          },
	
	          /**
	           * Add a proximity based constraint for finding objects with key point
	           * values near the point given and within the maximum distance given.
	           * Radius of earth used is 3958.8 miles.
	           * @param {String} key The key that the AV.GeoPoint is stored in.
	           * @param {AV.GeoPoint} point The reference AV.GeoPoint that is used.
	           * @param {Number} maxDistance Maximum distance (in miles) of results to
	           *     return.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          withinMiles: function withinMiles(key, point, distance) {
	            return this.withinRadians(key, point, distance / 3958.8);
	          },
	
	          /**
	           * Add a proximity based constraint for finding objects with key point
	           * values near the point given and within the maximum distance given.
	           * Radius of earth used is 6371.0 kilometers.
	           * @param {String} key The key that the AV.GeoPoint is stored in.
	           * @param {AV.GeoPoint} point The reference AV.GeoPoint that is used.
	           * @param {Number} maxDistance Maximum distance (in kilometers) of results
	           *     to return.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          withinKilometers: function withinKilometers(key, point, distance) {
	            return this.withinRadians(key, point, distance / 6371.0);
	          },
	
	          /**
	           * Add a constraint to the query that requires a particular key's
	           * coordinates be contained within a given rectangular geographic bounding
	           * box.
	           * @param {String} key The key to be constrained.
	           * @param {AV.GeoPoint} southwest
	           *     The lower-left inclusive corner of the box.
	           * @param {AV.GeoPoint} northeast
	           *     The upper-right inclusive corner of the box.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          withinGeoBox: function withinGeoBox(key, southwest, northeast) {
	            if (!(southwest instanceof AV.GeoPoint)) {
	              southwest = new AV.GeoPoint(southwest);
	            }
	            if (!(northeast instanceof AV.GeoPoint)) {
	              northeast = new AV.GeoPoint(northeast);
	            }
	            this._addCondition(key, '$within', { '$box': [southwest, northeast] });
	            return this;
	          },
	
	          /**
	           * Include nested AV.Objects for the provided key.  You can use dot
	           * notation to specify which fields in the included object are also fetch.
	           * @param {String} key The name of the key to include.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          include: function include() {
	            var self = this;
	            AV._arrayEach(arguments, function (key) {
	              if (_.isArray(key)) {
	                self._include = self._include.concat(key);
	              } else {
	                self._include.push(key);
	              }
	            });
	            return this;
	          },
	
	          /**
	           * Restrict the fields of the returned AV.Objects to include only the
	           * provided keys.  If this is called multiple times, then all of the keys
	           * specified in each of the calls will be included.
	           * @param {Array} keys The names of the keys to include.
	           * @return {AV.Query} Returns the query, so you can chain this call.
	           */
	          select: function select() {
	            var self = this;
	            this._select = this._select || [];
	            AV._arrayEach(arguments, function (key) {
	              if (_.isArray(key)) {
	                self._select = self._select.concat(key);
	              } else {
	                self._select.push(key);
	              }
	            });
	            return this;
	          },
	
	          /**
	           * Iterates over each result of a query, calling a callback for each one. If
	           * the callback returns a promise, the iteration will not continue until
	           * that promise has been fulfilled. If the callback returns a rejected
	           * promise, then iteration will stop with that error. The items are
	           * processed in an unspecified order. The query may not have any sort order,
	           * and may not use limit or skip.
	           * @param callback {Function} Callback that will be called with each result
	           *     of the query.
	           * @param options {Object} An optional Backbone-like options object with
	           *     success and error callbacks that will be invoked once the iteration
	           *     has finished.
	           * @return {AV.Promise} A promise that will be fulfilled once the
	           *     iteration has completed.
	           */
	          each: function each(callback, options) {
	            options = options || {};
	
	            if (this._order || this._skip || this._limit >= 0) {
	              var error = "Cannot iterate on a query with sort, skip, or limit.";
	              return AV.Promise.error(error)._thenRunCallbacks(options);
	            }
	
	            var promise = new AV.Promise();
	
	            var query = new AV.Query(this.objectClass);
	            // We can override the batch size from the options.
	            // This is undocumented, but useful for testing.
	            query._limit = options.batchSize || 100;
	            query._where = _.clone(this._where);
	            query._include = _.clone(this._include);
	
	            query.ascending('objectId');
	
	            var finished = false;
	            return AV.Promise._continueWhile(function () {
	              return !finished;
	            }, function () {
	              return query.find().then(function (results) {
	                var callbacksDone = AV.Promise.as();
	                _.each(results, function (result) {
	                  callbacksDone = callbacksDone.then(function () {
	                    return callback(result);
	                  });
	                });
	
	                return callbacksDone.then(function () {
	                  if (results.length >= query._limit) {
	                    query.greaterThan("objectId", results[results.length - 1].id);
	                  } else {
	                    finished = true;
	                  }
	                });
	              });
	            })._thenRunCallbacks(options);
	          }
	        };
	
	        AV.FriendShipQuery = AV.Query._extend({
	          _objectClass: AV.User,
	          _newObject: function _newObject() {
	            return new AV.User();
	          },
	          _processResult: function _processResult(json) {
	            if (json && json[this._friendshipTag]) {
	              var user = json[this._friendshipTag];
	              if (user.__type === 'Pointer' && user.className === '_User') {
	                delete user.__type;
	                delete user.className;
	              }
	              return user;
	            } else {
	              return null;
	            }
	          }
	        });
	      };
	    }, { "./error": 24, "./request": 37, "underscore": 17 }], 36: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      'use strict';
	
	      var _ = require('underscore');
	
	      module.exports = function (AV) {
	        /**
	         * Creates a new Relation for the given parent object and key. This
	         * constructor should rarely be used directly, but rather created by
	         * AV.Object.relation.
	         * @param {AV.Object} parent The parent of this relation.
	         * @param {String} key The key for this relation on the parent.
	         * @see AV.Object#relation
	         * @class
	         *
	         * <p>
	         * A class that is used to access all of the children of a many-to-many
	         * relationship.  Each instance of AV.Relation is associated with a
	         * particular parent object and key.
	         * </p>
	         */
	        AV.Relation = function (parent, key) {
	          if (!_.isString(key)) {
	            throw new TypeError('key must be a string');
	          }
	          this.parent = parent;
	          this.key = key;
	          this.targetClassName = null;
	        };
	
	        /**
	         * Creates a query that can be used to query the parent objects in this relation.
	         * @param {String} parentClass The parent class or name.
	         * @param {String} relationKey The relation field key in parent.
	         * @param {AV.Object} child The child object.
	         * @return {AV.Query}
	         */
	        AV.Relation.reverseQuery = function (parentClass, relationKey, child) {
	          var query = new AV.Query(parentClass);
	          query.equalTo(relationKey, child._toPointer());
	          return query;
	        };
	
	        AV.Relation.prototype = {
	          /**
	           * Makes sure that this relation has the right parent and key.
	           */
	          _ensureParentAndKey: function _ensureParentAndKey(parent, key) {
	            this.parent = this.parent || parent;
	            this.key = this.key || key;
	            if (this.parent !== parent) {
	              throw "Internal Error. Relation retrieved from two different Objects.";
	            }
	            if (this.key !== key) {
	              throw "Internal Error. Relation retrieved from two different keys.";
	            }
	          },
	
	          /**
	           * Adds a AV.Object or an array of AV.Objects to the relation.
	           * @param {} objects The item or items to add.
	           */
	          add: function add(objects) {
	            if (!_.isArray(objects)) {
	              objects = [objects];
	            }
	
	            var change = new AV.Op.Relation(objects, []);
	            this.parent.set(this.key, change);
	            this.targetClassName = change._targetClassName;
	          },
	
	          /**
	           * Removes a AV.Object or an array of AV.Objects from this relation.
	           * @param {} objects The item or items to remove.
	           */
	          remove: function remove(objects) {
	            if (!_.isArray(objects)) {
	              objects = [objects];
	            }
	
	            var change = new AV.Op.Relation([], objects);
	            this.parent.set(this.key, change);
	            this.targetClassName = change._targetClassName;
	          },
	
	          /**
	           * Returns a JSON version of the object suitable for saving to disk.
	           * @return {Object}
	           */
	          toJSON: function toJSON() {
	            return { "__type": "Relation", "className": this.targetClassName };
	          },
	
	          /**
	           * Returns a AV.Query that is limited to objects in this
	           * relation.
	           * @return {AV.Query}
	           */
	          query: function query() {
	            var targetClass;
	            var query;
	            if (!this.targetClassName) {
	              targetClass = AV.Object._getSubclass(this.parent.className);
	              query = new AV.Query(targetClass);
	              query._extraOptions.redirectClassNameForKey = this.key;
	            } else {
	              targetClass = AV.Object._getSubclass(this.targetClassName);
	              query = new AV.Query(targetClass);
	            }
	            query._addCondition("$relatedTo", "object", this.parent._toPointer());
	            query._addCondition("$relatedTo", "key", this.key);
	
	            return query;
	          }
	        };
	      };
	    }, { "underscore": 17 }], 37: [function (require, module, exports) {
	      (function (process) {
	        /**
	         * 每位工程师都有保持代码优雅的义务
	         * Each engineer has a duty to keep the code elegant
	        **/
	
	        var request = require('superagent');
	        var debug = require('debug')('request');
	        var md5 = require('md5');
	        var AVPromise = require('./promise');
	        var Cache = require('./cache');
	        var AVError = require('./error');
	        var AV = require('./av');
	        var _ = require('underscore');
	
	        var getServerURLPromise = new AVPromise();
	
	        // 服务器请求的节点 host
	        var API_HOST = {
	          cn: 'https://api.leancloud.cn',
	          us: 'https://us-api.leancloud.cn'
	        };
	
	        // 计算 X-LC-Sign 的签名方法
	        var sign = function sign(key, isMasterKey) {
	          var now = new Date().getTime();
	          var signature = md5(now + key);
	          if (isMasterKey) {
	            return signature + "," + now + ",master";
	          }
	          return signature + "," + now;
	        };
	
	        var checkRouter = function checkRouter(router) {
	          var routerList = ['batch', 'classes', 'files', 'date', 'functions', 'call', 'login', 'push', 'search/select', 'requestPasswordReset', 'requestEmailVerify', 'requestPasswordResetBySmsCode', 'resetPasswordBySmsCode', 'requestMobilePhoneVerify', 'requestLoginSmsCode', 'verifyMobilePhone', 'requestSmsCode', 'verifySmsCode', 'users', 'usersByMobilePhone', 'cloudQuery', 'qiniu', 'fileTokens', 'statuses', 'bigquery', 'search/select', 'subscribe/statuses/count', 'subscribe/statuses', 'installations'];
	
	          if (routerList.indexOf(router) === -1 && !/users\/[^\/]+\/updatePassword/.test(router) && !/users\/[^\/]+\/friendship\/[^\/]+/.test(router)) {
	            throw new Error("Bad router: " + router + ".");
	          }
	        };
	
	        var ajax = function ajax(method, resourceUrl, data) {
	          var headers = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	          var onprogress = arguments[4];
	
	          debug(method, resourceUrl, data, headers);
	
	          var promise = new AVPromise();
	          var req = request(method, resourceUrl).set(headers).send(data).end(function (err, res) {
	            if (res) {
	              debug(res.status, res.body, res.text);
	            }
	            if (err) {
	              if (res) {
	                err.statusCode = res.status;
	                err.responseText = res.text;
	                err.response = res.body;
	              }
	              return promise.reject(err);
	            }
	            return promise.resolve(res.body, res.status, res);
	          });
	          if (onprogress) {
	            req.on('progress', onprogress);
	          }
	          return promise;
	        };
	
	        var setHeaders = function setHeaders(sessionToken) {
	          var headers = {
	            'X-LC-Id': AV.applicationId,
	            'Content-Type': 'application/json;charset=UTF-8'
	          };
	          if (AV.masterKey && AV._useMasterKey) {
	            headers['X-LC-Sign'] = sign(AV.masterKey, true);
	          } else {
	            headers['X-LC-Sign'] = sign(AV.applicationKey);
	          }
	          if (AV._config.applicationProduction !== null) {
	            headers['X-LC-Prod'] = AV._config.applicationProduction;
	          }
	          if (!AV._config.isNode) {
	            headers['X-LC-UA'] = "AV/" + AV.version;
	          } else {
	            // LeanEngine need use AV._config.userAgent
	            headers['User-Agent'] = AV._config.userAgent || "AV/" + AV.version + "; Node.js/" + process.version;
	          }
	
	          var promise = new AVPromise();
	
	          // Pass the session token
	          if (sessionToken) {
	            headers['X-LC-Session'] = sessionToken;
	            promise.resolve(headers);
	          } else if (!AV._config.disableCurrentUser) {
	            AV.User.currentAsync().then(function (currentUser) {
	              if (currentUser && currentUser._sessionToken) {
	                headers['X-LC-Session'] = currentUser._sessionToken;
	              }
	              promise.resolve(headers);
	            });
	          } else {
	            promise.resolve(headers);
	          }
	
	          return promise;
	        };
	
	        var createApiUrl = function createApiUrl(route, className, objectId, method, dataObject) {
	          // TODO: 兼容 AV.serverURL 旧方式设置 API Host，后续去掉
	          if (AV.serverURL) {
	            AV._config.APIServerURL = AV.serverURL;
	            console.warn('Please use AV._config.APIServerURL to replace AV.serverURL, and it is an internal interface.');
	          }
	
	          var apiURL = AV._config.APIServerURL;
	
	          if (apiURL.charAt(apiURL.length - 1) !== '/') {
	            apiURL += '/';
	          }
	          apiURL += "1.1/" + route;
	          if (className) {
	            apiURL += "/" + className;
	          }
	          if (objectId) {
	            apiURL += "/" + objectId;
	          }
	          if ((route === 'users' || route === 'classes') && dataObject) {
	            apiURL += '?';
	            if (dataObject._fetchWhenSave) {
	              delete dataObject._fetchWhenSave;
	              apiURL += '&new=true';
	            }
	            if (dataObject._where) {
	              apiURL += "&where=" + encodeURIComponent(JSON.stringify(dataObject._where));
	              delete dataObject._where;
	            }
	          }
	
	          if (method.toLowerCase() === 'get') {
	            if (apiURL.indexOf('?') === -1) {
	              apiURL += '?';
	            }
	            for (var k in dataObject) {
	              if (_typeof(dataObject[k]) === 'object') {
	                dataObject[k] = JSON.stringify(dataObject[k]);
	              }
	              apiURL += "&" + k + "=" + encodeURIComponent(dataObject[k]);
	            }
	          }
	
	          return apiURL;
	        };
	
	        var cacheServerURL = function cacheServerURL(serverURL, ttl) {
	          if (typeof ttl !== 'number') {
	            ttl = 3600;
	          }
	          return Cache.setAsync('APIServerURL', serverURL, ttl * 1000);
	        };
	
	        // handle AV._request Error
	        var handleError = function handleError(res) {
	          var promise = new AVPromise();
	          /**
	            When API request need to redirect to the right location,
	            can't use browser redirect by http status 307, as the reason of CORS,
	            so API server response http status 410 and the param "location" for this case.
	          */
	          if (res.statusCode === 410) {
	            cacheServerURL(res.response.api_server, res.response.ttl).then(function () {
	              promise.resolve(res.response.location);
	            }).catch(function (error) {
	              promise.reject(error);
	            });
	          } else {
	            var errorJSON = { code: -1, error: res.responseText };
	            if (res.response && res.response.code) {
	              errorJSON = res.response;
	            } else if (res.responseText) {
	              try {
	                errorJSON = JSON.parse(res.responseText);
	              } catch (e) {
	                // If we fail to parse the error text, that's okay.
	              }
	            }
	
	            // Transform the error into an instance of AVError by trying to parse
	            // the error string as JSON.
	            var error = new AVError(errorJSON.code, errorJSON.error);
	            promise.reject(error);
	          }
	          return promise;
	        };
	
	        var setServerUrl = function setServerUrl(serverURL) {
	          AV._config.APIServerURL = "https://" + serverURL;
	
	          // 根据新 URL 重新设置区域
	          var newRegion = _.findKey(API_HOST, function (item) {
	            return item === AV._config.APIServerURL;
	          });
	          if (newRegion) {
	            AV._config.region = newRegion;
	          }
	        };
	
	        var refreshServerUrlByRouter = function refreshServerUrlByRouter() {
	          var url = "https://app-router.leancloud.cn/1/route?appId=" + AV.applicationId;
	          return ajax('get', url).then(function (servers) {
	            if (servers.api_server) {
	              setServerUrl(servers.api_server);
	              return cacheServerURL(servers.api_server, servers.ttl);
	            }
	          });
	        };
	
	        var setServerUrlByRegion = function setServerUrlByRegion() {
	          var region = arguments.length <= 0 || arguments[0] === undefined ? 'cn' : arguments[0];
	
	          // 如果用户在 init 之前设置了 APIServerURL，则跳过请求 router
	          if (AV._config.APIServerURL) {
	            getServerURLPromise.resolve();
	            return;
	          }
	          // if not china server region, do not use router
	          if (region === 'cn') {
	            Cache.getAsync('APIServerURL').then(function (serverURL) {
	              if (serverURL) {
	                setServerUrl(serverURL);
	                getServerURLPromise.resolve();
	              } else {
	                return refreshServerUrlByRouter();
	              }
	            }).then(function () {
	              getServerURLPromise.resolve();
	            }).catch(function () {
	              getServerURLPromise.reject();
	            });
	          } else {
	            AV._config.region = region;
	            AV._config.APIServerURL = API_HOST[region];
	            getServerURLPromise.resolve();
	          }
	        };
	
	        /**
	         * route is classes, users, login, etc.
	         * objectId is null if there is no associated objectId.
	         * method is the http method for the REST API.
	         * dataObject is the payload as an object, or null if there is none.
	         * @ignore
	         */
	        var AVRequest = function AVRequest(route, className, objectId, method) {
	          var dataObject = arguments.length <= 4 || arguments[4] === undefined ? {} : arguments[4];
	          var sessionToken = arguments[5];
	
	          if (!AV.applicationId) {
	            throw new Error('You must specify your applicationId using AV.init()');
	          }
	
	          if (!AV.applicationKey && !AV.masterKey) {
	            throw new Error('You must specify a AppKey using AV.init()');
	          }
	
	          checkRouter(route);
	
	          return getServerURLPromise.always(function () {
	            var apiURL = createApiUrl(route, className, objectId, method, dataObject);
	            return setHeaders(sessionToken).then(function (headers) {
	              return ajax(method, apiURL, dataObject, headers).then(null, function (res) {
	                return handleError(res).then(function (location) {
	                  return ajax(method, location, dataObject, headers);
	                });
	              });
	            });
	          });
	        };
	
	        module.exports = {
	          ajax: ajax,
	          request: AVRequest,
	          setServerUrlByRegion: setServerUrlByRegion
	        };
	      }).call(this, require('_process'));
	    }, { "./av": 19, "./cache": 22, "./error": 24, "./promise": 33, "_process": 10, "debug": 4, "md5": 8, "superagent": 12, "underscore": 17 }], 38: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	      var AVError = require('./error');
	
	      module.exports = function (AV) {
	        /**
	         * Represents a Role on the AV server. Roles represent groupings of
	         * Users for the purposes of granting permissions (e.g. specifying an ACL
	         * for an Object). Roles are specified by their sets of child users and
	         * child roles, all of which are granted any permissions that the parent
	         * role has.
	         *
	         * <p>Roles must have a name (which cannot be changed after creation of the
	         * role), and must specify an ACL.</p>
	         * @class
	         * A AV.Role is a local representation of a role persisted to the AV
	         * cloud.
	         */
	        AV.Role = AV.Object.extend("_Role", /** @lends AV.Role.prototype */{
	          // Instance Methods
	
	          /**
	           * Constructs a new AVRole with the given name and ACL.
	           *
	           * @param {String} name The name of the Role to create.
	           * @param {AV.ACL} [acl] The ACL for this role. if absent, the default ACL
	           *    `{'*': { read: true }}` will be used.
	           */
	          constructor: function constructor(name, acl) {
	            if (_.isString(name)) {
	              AV.Object.prototype.constructor.call(this, null, null);
	              this.setName(name);
	            } else {
	              AV.Object.prototype.constructor.call(this, name, acl);
	            }
	            if (acl === undefined) {
	              var defaultAcl = new AV.ACL();
	              defaultAcl.setPublicReadAccess(true);
	              if (!this.getACL()) {
	                this.setACL(defaultAcl);
	              }
	            } else if (!(acl instanceof AV.ACL)) {
	              throw new TypeError('acl must be an instance of AV.ACL');
	            } else {
	              this.setACL(acl);
	            }
	          },
	
	          /**
	           * Gets the name of the role.  You can alternatively call role.get("name")
	           *
	           * @return {String} the name of the role.
	           */
	          getName: function getName() {
	            return this.get("name");
	          },
	
	          /**
	           * Sets the name for a role. This value must be set before the role has
	           * been saved to the server, and cannot be set once the role has been
	           * saved.
	           *
	           * <p>
	           *   A role's name can only contain alphanumeric characters, _, -, and
	           *   spaces.
	           * </p>
	           *
	           * <p>This is equivalent to calling role.set("name", name)</p>
	           *
	           * @param {String} name The name of the role.
	           * @param {Object} options Standard options object with success and error
	           *     callbacks.
	           */
	          setName: function setName(name, options) {
	            return this.set("name", name, options);
	          },
	
	          /**
	           * Gets the AV.Relation for the AV.Users that are direct
	           * children of this role. These users are granted any privileges that this
	           * role has been granted (e.g. read or write access through ACLs). You can
	           * add or remove users from the role through this relation.
	           *
	           * <p>This is equivalent to calling role.relation("users")</p>
	           *
	           * @return {AV.Relation} the relation for the users belonging to this
	           *     role.
	           */
	          getUsers: function getUsers() {
	            return this.relation("users");
	          },
	
	          /**
	           * Gets the AV.Relation for the AV.Roles that are direct
	           * children of this role. These roles' users are granted any privileges that
	           * this role has been granted (e.g. read or write access through ACLs). You
	           * can add or remove child roles from this role through this relation.
	           *
	           * <p>This is equivalent to calling role.relation("roles")</p>
	           *
	           * @return {AV.Relation} the relation for the roles belonging to this
	           *     role.
	           */
	          getRoles: function getRoles() {
	            return this.relation("roles");
	          },
	
	          /**
	           * @ignore
	           */
	          validate: function validate(attrs, options) {
	            if ("name" in attrs && attrs.name !== this.getName()) {
	              var newName = attrs.name;
	              if (this.id && this.id !== attrs.objectId) {
	                // Check to see if the objectId being set matches this.id.
	                // This happens during a fetch -- the id is set before calling fetch.
	                // Let the name be set in this case.
	                return new AVError(AVError.OTHER_CAUSE, "A role's name can only be set before it has been saved.");
	              }
	              if (!_.isString(newName)) {
	                return new AVError(AVError.OTHER_CAUSE, "A role's name must be a String.");
	              }
	              if (!/^[0-9a-zA-Z\-_ ]+$/.test(newName)) {
	                return new AVError(AVError.OTHER_CAUSE, "A role's name can only contain alphanumeric characters, _," + " -, and spaces.");
	              }
	            }
	            if (AV.Object.prototype.validate) {
	              return AV.Object.prototype.validate.call(this, attrs, options);
	            }
	            return false;
	          }
	        });
	      };
	    }, { "./error": 24, "underscore": 17 }], 39: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	      var AVRequest = require('./request').request;
	
	      module.exports = function (AV) {
	        /**
	         * A builder to generate sort string for app searching.For example:
	         * <pre><code>
	         *   var builder = new AV.SearchSortBuilder();
	         *   builder.ascending('key1').descending('key2','max');
	         *   var query = new AV.SearchQuery('Player');
	         *   query.sortBy(builder);
	         *   query.find().then ...
	         * </code></pre>
	         * @class
	         * @since 0.5.1
	         */
	        AV.SearchSortBuilder = function () {
	          this._sortFields = [];
	        };
	
	        AV.SearchSortBuilder.prototype = {
	          _addField: function _addField(key, order, mode, missing) {
	            var field = {};
	            field[key] = {
	              order: order || 'asc',
	              mode: mode || 'avg',
	              missing: '_' + (missing || 'last')
	            };
	            this._sortFields.push(field);
	            return this;
	          },
	
	          /**
	           * Sorts the results in ascending order by the given key and options.
	           *
	           * @param {String} key The key to order by.
	           * @param {String} mode The sort mode, default is 'avg', you can choose
	           *                  'max' or 'min' too.
	           * @param {String} missing The missing key behaviour, default is 'last',
	           *                  you can choose 'first' too.
	           * @return {AV.SearchSortBuilder} Returns the builder, so you can chain this call.
	           */
	          ascending: function ascending(key, mode, missing) {
	            return this._addField(key, 'asc', mode, missing);
	          },
	
	          /**
	           * Sorts the results in descending order by the given key and options.
	           *
	           * @param {String} key The key to order by.
	           * @param {String} mode The sort mode, default is 'avg', you can choose
	           *                  'max' or 'min' too.
	           * @param {String} missing The missing key behaviour, default is 'last',
	           *                  you can choose 'first' too.
	           * @return {AV.SearchSortBuilder} Returns the builder, so you can chain this call.
	           */
	          descending: function descending(key, mode, missing) {
	            return this._addField(key, 'desc', mode, missing);
	          },
	
	          /**
	           * Add a proximity based constraint for finding objects with key point
	           * values near the point given.
	           * @param {String} key The key that the AV.GeoPoint is stored in.
	           * @param {AV.GeoPoint} point The reference AV.GeoPoint that is used.
	           * @param {Object} options The other options such as mode,order, unit etc.
	           * @return {AV.SearchSortBuilder} Returns the builder, so you can chain this call.
	           */
	          whereNear: function whereNear(key, point, options) {
	            options = options || {};
	            var field = {};
	            var geo = {
	              lat: point.latitude,
	              lon: point.longitude
	            };
	            var m = {
	              order: options.order || 'asc',
	              mode: options.mode || 'avg',
	              unit: options.unit || 'km'
	            };
	            m[key] = geo;
	            field['_geo_distance'] = m;
	
	            this._sortFields.push(field);
	            return this;
	          },
	
	          /**
	           * Build a sort string by configuration.
	           * @return {String} the sort string.
	           */
	          build: function build() {
	            return JSON.stringify(AV._encode(this._sortFields));
	          }
	        };
	
	        /**
	         * App searching query.Use just like AV.Query:
	         * <pre><code>
	         *   var query = new AV.SearchQuery('Player');
	         *   query.queryString('*');
	         *   query.find().then(function(results) {
	         *     console.log('Found %d objects', query.hits());
	         *     //Process results
	         *   });
	         *
	         * </code></pre>
	         * Visite <a href='https://leancloud.cn/docs/app_search_guide.html'>App Searching Guide</a>
	         * for more details.
	         * @class
	         * @since 0.5.1
	         *
	         */
	        AV.SearchQuery = AV.Query._extend( /** @lends AV.SearchQuery.prototype */{
	          _sid: null,
	          _hits: 0,
	          _queryString: null,
	          _highlights: null,
	          _sortBuilder: null,
	          _createRequest: function _createRequest(params, options) {
	            return AVRequest('search/select', null, null, 'GET', params || this.toJSON(), options && options.sessionToken);
	          },
	
	          /**
	           * Sets the sid of app searching query.Default is null.
	           * @param {String} sid  Scroll id for searching.
	           * @return {AV.SearchQuery} Returns the query, so you can chain this call.
	           */
	          sid: function sid(_sid) {
	            this._sid = _sid;
	            return this;
	          },
	
	          /**
	           * Sets the query string of app searching.
	           * @param {String} q  The query string.
	           * @return {AV.SearchQuery} Returns the query, so you can chain this call.
	           */
	          queryString: function queryString(q) {
	            this._queryString = q;
	            return this;
	          },
	
	          /**
	           * Sets the highlight fields. Such as
	           * <pre><code>
	           *   query.highlights('title');
	           *   //or pass an array.
	           *   query.highlights(['title', 'content'])
	           * </code></pre>
	           * @param {Array} highlights a list of fields.
	           * @return {AV.SearchQuery} Returns the query, so you can chain this call.
	           */
	          highlights: function highlights(_highlights) {
	            var objects;
	            if (_highlights && _.isString(_highlights)) {
	              objects = arguments;
	            } else {
	              objects = _highlights;
	            }
	            this._highlights = objects;
	            return this;
	          },
	
	          /**
	           * Sets the sort builder for this query.
	           * @see AV.SearchSortBuilder
	           * @param { AV.SearchSortBuilder} builder The sort builder.
	           * @return {AV.SearchQuery} Returns the query, so you can chain this call.
	           *
	           */
	          sortBy: function sortBy(builder) {
	            this._sortBuilder = builder;
	            return this;
	          },
	
	          /**
	           * Returns the number of objects that match this query.
	           * @return {Number}
	           */
	          hits: function hits() {
	            if (!this._hits) {
	              this._hits = 0;
	            }
	            return this._hits;
	          },
	
	          _processResult: function _processResult(json) {
	            delete json['className'];
	            delete json['_app_url'];
	            delete json['_deeplink'];
	            return json;
	          },
	
	          /**
	           * Returns true when there are more documents can be retrieved by this
	           * query instance, you can call find function to get more results.
	           * @see AV.SearchQuery#find
	           * @return {Boolean}
	           */
	          hasMore: function hasMore() {
	            return !this._hitEnd;
	          },
	
	          /**
	           * Reset current query instance state(such as sid, hits etc) except params
	           * for a new searching. After resetting, hasMore() will return true.
	           */
	          reset: function reset() {
	            this._hitEnd = false;
	            this._sid = null;
	            this._hits = 0;
	          },
	
	          /**
	           * Retrieves a list of AVObjects that satisfy this query.
	           * Either options.success or options.error is called when the find
	           * completes.
	           *
	           * @see AV.Query#find
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is resolved with the results when
	           * the query completes.
	           */
	          find: function find(options) {
	            var self = this;
	
	            var request = this._createRequest();
	
	            return request.then(function (response) {
	              //update sid for next querying.
	              if (response.sid) {
	                self._oldSid = self._sid;
	                self._sid = response.sid;
	              } else {
	                self._sid = null;
	                self._hitEnd = true;
	              }
	              self._hits = response.hits || 0;
	
	              return _.map(response.results, function (json) {
	                if (json.className) {
	                  response.className = json.className;
	                }
	                var obj = self._newObject(response);
	                obj.appURL = json['_app_url'];
	                obj._finishFetch(self._processResult(json), true);
	                return obj;
	              });
	            })._thenRunCallbacks(options);
	          },
	
	          toJSON: function toJSON() {
	            var params = AV.SearchQuery.__super__.toJSON.call(this);
	            delete params.where;
	            if (this.className) {
	              params.clazz = this.className;
	            }
	            if (this._sid) {
	              params.sid = this._sid;
	            }
	            if (!this._queryString) {
	              throw 'Please set query string.';
	            } else {
	              params.q = this._queryString;
	            }
	            if (this._highlights) {
	              params.highlights = this._highlights.join(',');
	            }
	            if (this._sortBuilder && params.order) {
	              throw 'sort and order can not be set at same time.';
	            }
	            if (this._sortBuilder) {
	              params.sort = this._sortBuilder.build();
	            }
	
	            return params;
	          }
	        });
	      };
	    }, { "./request": 37, "underscore": 17 }], 40: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	      var AVRequest = require('./request').request;
	
	      module.exports = function (AV) {
	        /**
	         * Contains functions to deal with Status in AVOS Cloud.
	         * @name AV.Status
	         * @namespace
	         */
	        AV.Status = function (imageUrl, message) {
	          this.data = {};
	          this.inboxType = 'default';
	          this.query = null;
	          if (imageUrl && (typeof imageUrl === "undefined" ? "undefined" : _typeof(imageUrl)) === 'object') {
	            this.data = imageUrl;
	          } else {
	            if (imageUrl) {
	              this.data.image = imageUrl;
	            }
	            if (message) {
	              this.data.message = message;
	            }
	          }
	          return this;
	        };
	
	        AV.Status.prototype = {
	          /**
	           * Gets the value of an attribute in status data.
	           * @param {String} attr The string name of an attribute.
	           */
	          get: function get(attr) {
	            return this.data[attr];
	          },
	          /**
	           * Sets a hash of model attributes on the status data.
	           * @param {String} key The key to set.
	           * @param {} value The value to give it.
	           */
	          set: function set(key, value) {
	            this.data[key] = value;
	            return this;
	          },
	          /**
	           * Destroy this status,then it will not be avaiable in other user's inboxes.
	           * @param {Object} options An optional Backbone-like options object with
	           *     success and error callbacks that will be invoked once the iteration
	           *     has finished.
	           * @return {AV.Promise} A promise that is fulfilled when the destroy
	           *     completes.
	           */
	          destroy: function destroy(options) {
	            if (!this.id) return AV.Promise.error('The status id is not exists.')._thenRunCallbacks(options);
	            var request = AVRequest('statuses', null, this.id, 'DELETE', options && options.sessionToken);
	            return request._thenRunCallbacks(options);
	          },
	          /**
	            * Cast the AV.Status object to an AV.Object pointer.
	            * @return {AV.Object} A AV.Object pointer.
	            */
	          toObject: function toObject() {
	            if (!this.id) return null;
	            return AV.Object.createWithoutData('_Status', this.id);
	          },
	          _getDataJSON: function _getDataJSON() {
	            var json = _.clone(this.data);
	            return AV._encode(json);
	          },
	          /**
	           * Send  a status by a AV.Query object.
	           * <p>For example,send a status to male users:<br/><pre>
	           *     var status = new AVStatus('image url', 'a message');
	           *     status.query = new AV.Query('_User');
	           *     status.query.equalTo('gender', 'male');
	           *     status.send().then(function(){
	           *              //send status successfully.
	           *      }, function(err){
	           *             //an error threw.
	           *             console.dir(err);
	           *      });
	           * </pre></p>
	           * @since 0.3.0
	           * @param {Object} options An optional Backbone-like options object with
	           *     success and error callbacks that will be invoked once the iteration
	           *     has finished.
	           * @return {AV.Promise} A promise that is fulfilled when the send
	           *     completes.
	           */
	          send: function send(options) {
	            if (!AV.User.current()) {
	              throw 'Please signin an user.';
	            }
	            if (!this.query) {
	              return AV.Status.sendStatusToFollowers(this, options);
	            }
	
	            var query = this.query.toJSON();
	            query.className = this.query.className;
	            var data = {};
	            data.query = query;
	            this.data = this.data || {};
	            var currUser = AV.Object.createWithoutData('_User', AV.User.current().id)._toPointer();
	            this.data.source = this.data.source || currUser;
	            data.data = this._getDataJSON();
	            data.inboxType = this.inboxType || 'default';
	
	            var request = AVRequest('statuses', null, null, 'POST', data, options && options.sessionToken);
	            var self = this;
	            return request.then(function (response) {
	              self.id = response.objectId;
	              self.createdAt = AV._parseDate(response.createdAt);
	              return self;
	            })._thenRunCallbacks(options);
	          },
	
	          _finishFetch: function _finishFetch(serverData) {
	            this.id = serverData.objectId;
	            this.createdAt = AV._parseDate(serverData.createdAt);
	            this.updatedAt = AV._parseDate(serverData.updatedAt);
	            this.messageId = serverData.messageId;
	            delete serverData.messageId;
	            delete serverData.objectId;
	            delete serverData.createdAt;
	            delete serverData.updatedAt;
	            this.data = AV._decode(undefined, serverData);
	          }
	        };
	
	        /**
	         * Send  a status to current signined user's followers.For example:
	         * <p><pre>
	         *     var status = new AVStatus('image url', 'a message');
	         *     AV.Status.sendStatusToFollowers(status).then(function(){
	         *              //send status successfully.
	         *      }, function(err){
	         *             //an error threw.
	         *             console.dir(err);
	         *      });
	         * </pre></p>
	         * @since 0.3.0
	         * @param {AV.Status} status  A status object to be send to followers.
	         * @param {Object} options An optional Backbone-like options object with
	         *     success and error callbacks that will be invoked once the iteration
	         *     has finished.
	         * @return {AV.Promise} A promise that is fulfilled when the send
	         *     completes.
	         */
	        AV.Status.sendStatusToFollowers = function (status, options) {
	          if (!AV.User.current()) {
	            throw 'Please signin an user.';
	          }
	          var query = {};
	          query.className = '_Follower';
	          query.keys = 'follower';
	          var currUser = AV.Object.createWithoutData('_User', AV.User.current().id)._toPointer();
	          query.where = { user: currUser };
	          var data = {};
	          data.query = query;
	          status.data = status.data || {};
	          status.data.source = status.data.source || currUser;
	          data.data = status._getDataJSON();
	          data.inboxType = status.inboxType || 'default';
	
	          var request = AVRequest('statuses', null, null, 'POST', data, options && options.sessionToken);
	          return request.then(function (response) {
	            status.id = response.objectId;
	            status.createdAt = AV._parseDate(response.createdAt);
	            return status;
	          })._thenRunCallbacks(options);
	        };
	
	        /**
	         * <p>Send  a status from current signined user to other user's private status inbox.</p>
	         * <p>For example,send a private status to user '52e84e47e4b0f8de283b079b':<br/>
	         * <pre>
	         *    var status = new AVStatus('image url', 'a message');
	         *     AV.Status.sendPrivateStatus(status, '52e84e47e4b0f8de283b079b').then(function(){
	         *              //send status successfully.
	         *      }, function(err){
	         *             //an error threw.
	         *             console.dir(err);
	         *      });
	         * </pre></p>
	         * @since 0.3.0
	         * @param {AV.Status} status  A status object to be send to followers.
	         * @param {} target The target user or user's objectId.
	         * @param {Object} options An optional Backbone-like options object with
	         *     success and error callbacks that will be invoked once the iteration
	         *     has finished.
	         * @return {AV.Promise} A promise that is fulfilled when the send
	         *     completes.
	         */
	        AV.Status.sendPrivateStatus = function (status, target, options) {
	          if (!AV.User.current()) {
	            throw 'Please signin an user.';
	          }
	          if (!target) {
	            throw "Invalid target user.";
	          }
	          var userObjectId = _.isString(target) ? target : target.id;
	          if (!userObjectId) {
	            throw "Invalid target user.";
	          }
	
	          var query = {};
	          query.className = '_User';
	          var currUser = AV.Object.createWithoutData('_User', AV.User.current().id)._toPointer();
	          query.where = { objectId: userObjectId };
	          var data = {};
	          data.query = query;
	          status.data = status.data || {};
	          status.data.source = status.data.source || currUser;
	          data.data = status._getDataJSON();
	          data.inboxType = 'private';
	          status.inboxType = 'private';
	
	          var request = AVRequest('statuses', null, null, 'POST', data, options && options.sessionToken);
	          return request.then(function (response) {
	            status.id = response.objectId;
	            status.createdAt = AV._parseDate(response.createdAt);
	            return status;
	          })._thenRunCallbacks(options);
	        };
	
	        /**
	         * Count unread statuses in someone's inbox.For example:<br/>
	         * <p><pre>
	         *  AV.Status.countUnreadStatuses(AV.User.current()).then(function(response){
	         *    console.log(response.unread); //unread statuses number.
	         *    console.log(response.total);  //total statuses number.
	         *  });
	         * </pre></p>
	         * @since 0.3.0
	         * @param {Object} source The status source.
	         * @return {AV.Query} The query object for status.
	         * @return {AV.Promise} A promise that is fulfilled when the count
	         *     completes.
	         */
	        AV.Status.countUnreadStatuses = function (owner) {
	          if (!AV.User.current() && owner == null) {
	            throw 'Please signin an user or pass the owner objectId.';
	          }
	          owner = owner || AV.User.current();
	          var options = !_.isString(arguments[1]) ? arguments[1] : arguments[2];
	          var inboxType = !_.isString(arguments[1]) ? 'default' : arguments[1];
	          var params = {};
	          params.inboxType = AV._encode(inboxType);
	          params.owner = AV._encode(owner);
	          var request = AVRequest('subscribe/statuses/count', null, null, 'GET', params, options && options.sessionToken);
	          return request._thenRunCallbacks(options);
	        };
	
	        /**
	         * Create a status query to find someone's published statuses.For example:<br/>
	         * <p><pre>
	         *   //Find current user's published statuses.
	         *   var query = AV.Status.statusQuery(AV.User.current());
	         *   query.find().then(function(statuses){
	         *      //process statuses
	         *   });
	         * </pre></p>
	         * @since 0.3.0
	         * @param {Object} source The status source.
	         * @return {AV.Query} The query object for status.
	         */
	        AV.Status.statusQuery = function (source) {
	          var query = new AV.Query('_Status');
	          if (source) {
	            query.equalTo('source', source);
	          }
	          return query;
	        };
	
	        /**
	         * <p>AV.InboxQuery defines a query that is used to fetch somebody's inbox statuses.</p>
	         * @see AV.Status#inboxQuery
	         * @class
	         */
	        AV.InboxQuery = AV.Query._extend( /** @lends AV.InboxQuery.prototype */{
	          _objectClass: AV.Status,
	          _sinceId: 0,
	          _maxId: 0,
	          _inboxType: 'default',
	          _owner: null,
	          _newObject: function _newObject() {
	            return new AV.Status();
	          },
	          _createRequest: function _createRequest(params, options) {
	            return AVRequest('subscribe/statuses', null, null, 'GET', params || this.toJSON(), options && options.sessionToken);
	          },
	
	          /**
	           * Sets the messageId of results to skip before returning any results.
	           * This is useful for pagination.
	           * Default is zero.
	           * @param {Number} n the mesage id.
	           * @return {AV.InboxQuery} Returns the query, so you can chain this call.
	           */
	          sinceId: function sinceId(id) {
	            this._sinceId = id;
	            return this;
	          },
	          /**
	           * Sets the maximal messageId of results。
	           * This is useful for pagination.
	           * Default is zero that is no limition.
	           * @param {Number} n the mesage id.
	           * @return {AV.InboxQuery} Returns the query, so you can chain this call.
	           */
	          maxId: function maxId(id) {
	            this._maxId = id;
	            return this;
	          },
	          /**
	           * Sets the owner of the querying inbox.
	           * @param {Object} owner The inbox owner.
	           * @return {AV.InboxQuery} Returns the query, so you can chain this call.
	           */
	          owner: function owner(_owner) {
	            this._owner = _owner;
	            return this;
	          },
	          /**
	           * Sets the querying inbox type.default is 'default'.
	           * @param {Object} owner The inbox type.
	           * @return {AV.InboxQuery} Returns the query, so you can chain this call.
	           */
	          inboxType: function inboxType(type) {
	            this._inboxType = type;
	            return this;
	          },
	          toJSON: function toJSON() {
	            var params = AV.InboxQuery.__super__.toJSON.call(this);
	            params.owner = AV._encode(this._owner);
	            params.inboxType = AV._encode(this._inboxType);
	            params.sinceId = AV._encode(this._sinceId);
	            params.maxId = AV._encode(this._maxId);
	            return params;
	          }
	        });
	
	        /**
	         * Create a inbox status query to find someone's inbox statuses.For example:<br/>
	         * <p><pre>
	         *   //Find current user's default inbox statuses.
	         *   var query = AV.Status.inboxQuery(AV.User.current());
	         *   //find the statuses after the last message id
	         *   query.sinceId(lastMessageId);
	         *   query.find().then(function(statuses){
	         *      //process statuses
	         *   });
	         * </pre></p>
	         * @since 0.3.0
	         * @param {Object} owner The inbox's owner
	         * @param {String} inboxType The inbox type,'default' by default.
	         * @return {AV.InboxQuery} The inbox query object.
	         * @see AV.InboxQuery
	         */
	        AV.Status.inboxQuery = function (owner, inboxType) {
	          var query = new AV.InboxQuery(AV.Status);
	          if (owner) {
	            query._owner = owner;
	          }
	          if (inboxType) {
	            query._inboxType = inboxType;
	          }
	          return query;
	        };
	      };
	    }, { "./request": 37, "underscore": 17 }], 41: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	       **/
	
	      'use strict';
	
	      var request = require('superagent');
	      var debug = require('debug')('cos');
	      var Promise = require('../promise');
	
	      module.exports = function upload(uploadInfo, data, file) {
	        var saveOptions = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	        file.attributes.url = uploadInfo.url;
	        file._bucket = uploadInfo.bucket;
	        file.id = uploadInfo.objectId;
	        var uploadUrl = uploadInfo.upload_url + "?sign=" + encodeURIComponent(uploadInfo.token);
	
	        var promise = new Promise();
	
	        var req = request('POST', uploadUrl).field('fileContent', data).field('op', 'upload').end(function (err, res) {
	          if (res) {
	            debug(res.status, res.body, res.text);
	          }
	          if (err) {
	            if (res) {
	              err.statusCode = res.status;
	              err.responseText = res.text;
	              err.response = res.body;
	            }
	            return promise.reject(err);
	          }
	          promise.resolve(file);
	        });
	        if (saveOptions.onprogress) {
	          req.on('progress', saveOptions.onprogress);
	        }
	        return promise;
	      };
	    }, { "../promise": 33, "debug": 4, "superagent": 12 }], 42: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      'use strict';
	
	      var request = require('superagent');
	      var Promise = require('../promise');
	      var debug = require('debug')('qiniu');
	
	      module.exports = function upload(uploadInfo, data, file) {
	        var saveOptions = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	        file.attributes.url = uploadInfo.url;
	        file._bucket = uploadInfo.bucket;
	        file.id = uploadInfo.objectId;
	        //Get the uptoken to upload files to qiniu.
	        var uptoken = uploadInfo.token;
	
	        var promise = new Promise();
	
	        var req = request('POST', 'https://up.qbox.me').field('file', data).field('name', file.attributes.name).field('key', file._qiniu_key).field('token', uptoken).end(function (err, res) {
	          if (res) {
	            debug(res.status, res.body, res.text);
	          }
	          if (err) {
	            if (res) {
	              err.statusCode = res.status;
	              err.responseText = res.text;
	              err.response = res.body;
	            }
	            return promise.reject(err);
	          }
	          promise.resolve(file);
	        });
	        if (saveOptions.onprogress) {
	          req.on('progress', saveOptions.onprogress);
	        }
	        return promise;
	      };
	    }, { "../promise": 33, "debug": 4, "superagent": 12 }], 43: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	       **/
	
	      var request = require('superagent');
	      var AVPromise = require('../promise');
	
	      module.exports = function upload(uploadInfo, data, file) {
	        var saveOptions = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	        file.attributes.url = uploadInfo.url;
	        file._bucket = uploadInfo.bucket;
	        file.id = uploadInfo.objectId;
	        var promise = new AVPromise();
	        // 海外节点，针对 S3 才会返回 upload_url
	        var req = request('PUT', uploadInfo.upload_url).set('Content-Type', file.attributes.metaData.mime_type).send(data).end(function (err, res) {
	          if (err) {
	            if (res) {
	              err.statusCode = res.status;
	              err.responseText = res.text;
	              err.response = res.body;
	            }
	            return promise.reject(err);
	          }
	          promise.resolve(file);
	        });
	        if (saveOptions.onprogress) {
	          req.on('progress', saveOptions.onprogress);
	        }
	        return promise;
	      };
	    }, { "../promise": 33, "superagent": 12 }], 44: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      var _ = require('underscore');
	      var AVError = require('./error');
	      var AVRequest = require('./request').request;
	
	      module.exports = function (AV) {
	        /**
	         * @class
	         *
	         * <p>A AV.User object is a local representation of a user persisted to the
	         * AV cloud. This class is a subclass of a AV.Object, and retains the
	         * same functionality of a AV.Object, but also extends it with various
	         * user specific methods, like authentication, signing up, and validation of
	         * uniqueness.</p>
	         */
	        AV.User = AV.Object.extend("_User", /** @lends AV.User.prototype */{
	          // Instance Variables
	          _isCurrentUser: false,
	
	          // Instance Methods
	
	          /**
	           * Internal method to handle special fields in a _User response.
	           */
	          _mergeMagicFields: function _mergeMagicFields(attrs) {
	            if (attrs.sessionToken) {
	              this._sessionToken = attrs.sessionToken;
	              delete attrs.sessionToken;
	            }
	            AV.User.__super__._mergeMagicFields.call(this, attrs);
	          },
	
	          /**
	           * Removes null values from authData (which exist temporarily for
	           * unlinking)
	           */
	          _cleanupAuthData: function _cleanupAuthData() {
	            if (!this.isCurrent()) {
	              return;
	            }
	            var authData = this.get('authData');
	            if (!authData) {
	              return;
	            }
	            AV._objectEach(this.get('authData'), function (value, key) {
	              if (!authData[key]) {
	                delete authData[key];
	              }
	            });
	          },
	
	          /**
	           * Synchronizes authData for all providers.
	           */
	          _synchronizeAllAuthData: function _synchronizeAllAuthData() {
	            var authData = this.get('authData');
	            if (!authData) {
	              return;
	            }
	
	            var self = this;
	            AV._objectEach(this.get('authData'), function (value, key) {
	              self._synchronizeAuthData(key);
	            });
	          },
	
	          /**
	           * Synchronizes auth data for a provider (e.g. puts the access token in the
	           * right place to be used by the Facebook SDK).
	           */
	          _synchronizeAuthData: function _synchronizeAuthData(provider) {
	            if (!this.isCurrent()) {
	              return;
	            }
	            var authType;
	            if (_.isString(provider)) {
	              authType = provider;
	              provider = AV.User._authProviders[authType];
	            } else {
	              authType = provider.getAuthType();
	            }
	            var authData = this.get('authData');
	            if (!authData || !provider) {
	              return;
	            }
	            var success = provider.restoreAuthentication(authData[authType]);
	            if (!success) {
	              this._unlinkFrom(provider);
	            }
	          },
	
	          _handleSaveResult: function _handleSaveResult(makeCurrent) {
	            // Clean up and synchronize the authData object, removing any unset values
	            if (makeCurrent && !AV._config.disableCurrentUser) {
	              this._isCurrentUser = true;
	            }
	            this._cleanupAuthData();
	            this._synchronizeAllAuthData();
	            // Don't keep the password around.
	            delete this._serverData.password;
	            this._rebuildEstimatedDataForKey("password");
	            this._refreshCache();
	            if ((makeCurrent || this.isCurrent()) && !AV._config.disableCurrentUser) {
	              // Some old version of leanengine-node-sdk will overwrite
	              // AV.User._saveCurrentUser which returns no Promise.
	              // So we need a Promise wrapper.
	              return AV.Promise.as(AV.User._saveCurrentUser(this));
	            } else {
	              return AV.Promise.as();
	            }
	          },
	
	          /**
	           * Unlike in the Android/iOS SDKs, logInWith is unnecessary, since you can
	           * call linkWith on the user (even if it doesn't exist yet on the server).
	           */
	          _linkWith: function _linkWith(provider, options) {
	            var authType;
	            if (_.isString(provider)) {
	              authType = provider;
	              provider = AV.User._authProviders[provider];
	            } else {
	              authType = provider.getAuthType();
	            }
	            if (_.has(options, 'authData')) {
	              var authData = this.get('authData') || {};
	              authData[authType] = options.authData;
	              this.set('authData', authData);
	              return this.save({ 'authData': authData }, filterOutCallbacks(options)).then(function (model) {
	                return model._handleSaveResult(true).then(function () {
	                  return model;
	                });
	              })._thenRunCallbacks(options);
	            } else {
	              var self = this;
	              var promise = new AV.Promise();
	              provider.authenticate({
	                success: function success(provider, result) {
	                  self._linkWith(provider, {
	                    authData: result,
	                    success: options.success,
	                    error: options.error
	                  }).then(function () {
	                    promise.resolve(self);
	                  });
	                },
	                error: function error(provider, _error2) {
	                  if (options.error) {
	                    options.error(self, _error2);
	                  }
	                  promise.reject(_error2);
	                }
	              });
	              return promise;
	            }
	          },
	
	          /**
	           * Unlinks a user from a service.
	           */
	          _unlinkFrom: function _unlinkFrom(provider, options) {
	            var authType;
	            if (_.isString(provider)) {
	              authType = provider;
	              provider = AV.User._authProviders[provider];
	            } else {
	              authType = provider.getAuthType();
	            }
	            var newOptions = _.clone(options);
	            var self = this;
	            newOptions.authData = null;
	            newOptions.success = function (model) {
	              self._synchronizeAuthData(provider);
	              if (options.success) {
	                options.success.apply(this, arguments);
	              }
	            };
	            return this._linkWith(provider, newOptions);
	          },
	
	          /**
	           * Checks whether a user is linked to a service.
	           */
	          _isLinked: function _isLinked(provider) {
	            var authType;
	            if (_.isString(provider)) {
	              authType = provider;
	            } else {
	              authType = provider.getAuthType();
	            }
	            var authData = this.get('authData') || {};
	            return !!authData[authType];
	          },
	
	          logOut: function logOut() {
	            this._logOutWithAll();
	            this._isCurrentUser = false;
	          },
	
	          /**
	           * Deauthenticates all providers.
	           */
	          _logOutWithAll: function _logOutWithAll() {
	            var authData = this.get('authData');
	            if (!authData) {
	              return;
	            }
	            var self = this;
	            AV._objectEach(this.get('authData'), function (value, key) {
	              self._logOutWith(key);
	            });
	          },
	
	          /**
	           * Deauthenticates a single provider (e.g. removing access tokens from the
	           * Facebook SDK).
	           */
	          _logOutWith: function _logOutWith(provider) {
	            if (!this.isCurrent()) {
	              return;
	            }
	            if (_.isString(provider)) {
	              provider = AV.User._authProviders[provider];
	            }
	            if (provider && provider.deauthenticate) {
	              provider.deauthenticate();
	            }
	          },
	
	          /**
	           * Signs up a new user. You should call this instead of save for
	           * new AV.Users. This will create a new AV.User on the server, and
	           * also persist the session on disk so that you can access the user using
	           * <code>current</code>.
	           *
	           * <p>A username and password must be set before calling signUp.</p>
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {Object} attrs Extra fields to set on the new user, or null.
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is fulfilled when the signup
	           *     finishes.
	           * @see AV.User.signUp
	           */
	          signUp: function signUp(attrs, options) {
	            var error;
	            options = options || {};
	
	            var username = attrs && attrs.username || this.get("username");
	            if (!username || username === "") {
	              error = new AVError(AVError.OTHER_CAUSE, "Cannot sign up user with an empty name.");
	              if (options && options.error) {
	                options.error(this, error);
	              }
	              throw error;
	            }
	
	            var password = attrs && attrs.password || this.get("password");
	            if (!password || password === "") {
	              error = new AVError(AVError.OTHER_CAUSE, "Cannot sign up user with an empty password.");
	              if (options && options.error) {
	                options.error(this, error);
	              }
	              throw error;
	            }
	
	            return this.save(attrs, filterOutCallbacks(options)).then(function (model) {
	              return model._handleSaveResult(true).then(function () {
	                return model;
	              });
	            })._thenRunCallbacks(options, this);
	          },
	
	          /**
	           * Signs up a new user with mobile phone and sms code.
	           * You should call this instead of save for
	           * new AV.Users. This will create a new AV.User on the server, and
	           * also persist the session on disk so that you can access the user using
	           * <code>current</code>.
	           *
	           * <p>A username and password must be set before calling signUp.</p>
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {Object} attrs Extra fields to set on the new user, or null.
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is fulfilled when the signup
	           *     finishes.
	           * @see AV.User.signUpOrlogInWithMobilePhone
	           * @see AV.Cloud.requestSmsCode
	           */
	          signUpOrlogInWithMobilePhone: function signUpOrlogInWithMobilePhone(attrs, options) {
	            var error;
	            options = options || {};
	
	            var mobilePhoneNumber = attrs && attrs.mobilePhoneNumber || this.get("mobilePhoneNumber");
	            if (!mobilePhoneNumber || mobilePhoneNumber === "") {
	              error = new AVError(AVError.OTHER_CAUSE, "Cannot sign up or login user by mobilePhoneNumber " + "with an empty mobilePhoneNumber.");
	              if (options && options.error) {
	                options.error(this, error);
	              }
	              throw error;
	            }
	
	            var smsCode = attrs && attrs.smsCode || this.get("smsCode");
	            if (!smsCode || smsCode === "") {
	              error = new AVError(AVError.OTHER_CAUSE, "Cannot sign up or login user by mobilePhoneNumber  " + "with an empty smsCode.");
	              if (options && options.error) {
	                options.error(this, error);
	              }
	              throw error;
	            }
	
	            var newOptions = filterOutCallbacks(options);
	            newOptions._makeRequest = function (route, className, id, method, json) {
	              return AVRequest('usersByMobilePhone', null, null, "POST", json);
	            };
	            return this.save(attrs, newOptions).then(function (model) {
	              delete model.attributes.smsCode;
	              delete model._serverData.smsCode;
	              return model._handleSaveResult(true).then(function () {
	                return model;
	              });
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Logs in a AV.User. On success, this saves the session to localStorage,
	           * so you can retrieve the currently logged in user using
	           * <code>current</code>.
	           *
	           * <p>A username and password must be set before calling logIn.</p>
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {Object} options A Backbone-style options object.
	           * @see AV.User.logIn
	           * @return {AV.Promise} A promise that is fulfilled with the user when
	           *     the login is complete.
	           */
	          logIn: function logIn(options) {
	            var model = this;
	            var request = AVRequest("login", null, null, "GET", this.toJSON());
	            return request.then(function (resp, status, xhr) {
	              var serverAttrs = model.parse(resp, status, xhr);
	              model._finishFetch(serverAttrs);
	              return model._handleSaveResult(true).then(function () {
	                if (!serverAttrs.smsCode) delete model.attributes['smsCode'];
	                return model;
	              });
	            })._thenRunCallbacks(options, this);
	          },
	          /**
	           * @see AV.Object#save
	           */
	          save: function save(arg1, arg2, arg3) {
	            var i, attrs, current, options, saved;
	            if (_.isObject(arg1) || _.isNull(arg1) || _.isUndefined(arg1)) {
	              attrs = arg1;
	              options = arg2;
	            } else {
	              attrs = {};
	              attrs[arg1] = arg2;
	              options = arg3;
	            }
	            options = options || {};
	
	            return AV.Object.prototype.save.call(this, attrs, filterOutCallbacks(options)).then(function (model) {
	              return model._handleSaveResult(false).then(function () {
	                return model;
	              });
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Follow a user
	           * @since 0.3.0
	           * @param {} target The target user or user's objectId to follow.
	           * @param {Object} options An optional Backbone-like options object with
	           *     success and error callbacks that will be invoked once the iteration
	           *     has finished.
	           */
	          follow: function follow(target, options) {
	            if (!this.id) {
	              throw "Please signin.";
	            }
	            if (!target) {
	              throw "Invalid target user.";
	            }
	            var userObjectId = _.isString(target) ? target : target.id;
	            if (!userObjectId) {
	              throw "Invalid target user.";
	            }
	            var route = 'users/' + this.id + '/friendship/' + userObjectId;
	            var request = AVRequest(route, null, null, 'POST', null, options && options.sessionToken);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * Unfollow a user.
	           * @since 0.3.0
	           * @param {} target The target user or user's objectId to unfollow.
	           * @param options {Object} An optional Backbone-like options object with
	           *     success and error callbacks that will be invoked once the iteration
	           *     has finished.
	           */
	          unfollow: function unfollow(target, options) {
	            if (!this.id) {
	              throw "Please signin.";
	            }
	            if (!target) {
	              throw "Invalid target user.";
	            }
	            var userObjectId = _.isString(target) ? target : target.id;
	            if (!userObjectId) {
	              throw "Invalid target user.";
	            }
	            var route = 'users/' + this.id + '/friendship/' + userObjectId;
	            var request = AVRequest(route, null, null, 'DELETE', null, options && options.sessionToken);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           *Create a follower query to query the user's followers.
	           * @since 0.3.0
	           * @see AV.User#followerQuery
	           */
	          followerQuery: function followerQuery() {
	            return AV.User.followerQuery(this.id);
	          },
	
	          /**
	           *Create a followee query to query the user's followees.
	           * @since 0.3.0
	           * @see AV.User#followeeQuery
	           */
	          followeeQuery: function followeeQuery() {
	            return AV.User.followeeQuery(this.id);
	          },
	
	          /**
	           * @see AV.Object#fetch
	           */
	          fetch: function fetch() {
	            var options = null;
	            var fetchOptions = {};
	            if (arguments.length === 1) {
	              options = arguments[0];
	            } else if (arguments.length === 2) {
	              fetchOptions = arguments[0];
	              options = arguments[1];
	            }
	            return AV.Object.prototype.fetch.call(this, fetchOptions, {}).then(function (model) {
	              return model._handleSaveResult(false).then(function () {
	                return model;
	              });
	            })._thenRunCallbacks(options);
	          },
	
	          /**
	           * Update user's new password safely based on old password.
	           * @param {String} oldPassword, the old password.
	           * @param {String} newPassword, the new password.
	           * @param {Object} An optional Backbone-like options object with
	           *     success and error callbacks that will be invoked once the iteration
	           *     has finished.
	           */
	          updatePassword: function updatePassword(oldPassword, newPassword, options) {
	            var route = 'users/' + this.id + '/updatePassword';
	            var params = {
	              old_password: oldPassword,
	              new_password: newPassword
	            };
	            var request = AVRequest(route, null, null, 'PUT', params, options && options.sessionToken);
	            return request._thenRunCallbacks(options, this);
	          },
	
	          /**
	           * Returns true if <code>current</code> would return this user.
	           * @see AV.User#current
	           */
	          isCurrent: function isCurrent() {
	            return this._isCurrentUser;
	          },
	
	          /**
	           * Returns get("username").
	           * @return {String}
	           * @see AV.Object#get
	           */
	          getUsername: function getUsername() {
	            return this.get("username");
	          },
	
	          /**
	           * Returns get("mobilePhoneNumber").
	           * @return {String}
	           * @see AV.Object#get
	           */
	          getMobilePhoneNumber: function getMobilePhoneNumber() {
	            return this.get("mobilePhoneNumber");
	          },
	
	          /**
	           * Calls set("mobilePhoneNumber", phoneNumber, options) and returns the result.
	           * @param {String} mobilePhoneNumber
	           * @param {Object} options A Backbone-style options object.
	           * @return {Boolean}
	           * @see AV.Object.set
	           */
	          setMobilePhoneNumber: function setMobilePhoneNumber(phone, options) {
	            return this.set("mobilePhoneNumber", phone, options);
	          },
	
	          /**
	           * Calls set("username", username, options) and returns the result.
	           * @param {String} username
	           * @param {Object} options A Backbone-style options object.
	           * @return {Boolean}
	           * @see AV.Object.set
	           */
	          setUsername: function setUsername(username, options) {
	            return this.set("username", username, options);
	          },
	
	          /**
	           * Calls set("password", password, options) and returns the result.
	           * @param {String} password
	           * @param {Object} options A Backbone-style options object.
	           * @return {Boolean}
	           * @see AV.Object.set
	           */
	          setPassword: function setPassword(password, options) {
	            return this.set("password", password, options);
	          },
	
	          /**
	           * Returns get("email").
	           * @return {String}
	           * @see AV.Object#get
	           */
	          getEmail: function getEmail() {
	            return this.get("email");
	          },
	
	          /**
	           * Calls set("email", email, options) and returns the result.
	           * @param {String} email
	           * @param {Object} options A Backbone-style options object.
	           * @return {Boolean}
	           * @see AV.Object.set
	           */
	          setEmail: function setEmail(email, options) {
	            return this.set("email", email, options);
	          },
	
	          /**
	           * Checks whether this user is the current user and has been authenticated.
	           * @return (Boolean) whether this user is the current user and is logged in.
	           */
	          authenticated: function authenticated() {
	            return !!this._sessionToken && !AV._config.disableCurrentUser && AV.User.current() && AV.User.current().id === this.id;
	          },
	
	          getSessionToken: function getSessionToken() {
	            return this._sessionToken;
	          }
	
	        }, /** @lends AV.User */{
	          // Class Variables
	
	          // The currently logged-in user.
	          _currentUser: null,
	
	          // Whether currentUser is known to match the serialized version on disk.
	          // This is useful for saving a localstorage check if you try to load
	          // _currentUser frequently while there is none stored.
	          _currentUserMatchesDisk: false,
	
	          // The localStorage key suffix that the current user is stored under.
	          _CURRENT_USER_KEY: "currentUser",
	
	          // The mapping of auth provider names to actual providers
	          _authProviders: {},
	
	          // Class Methods
	
	          /**
	           * Signs up a new user with a username (or email) and password.
	           * This will create a new AV.User on the server, and also persist the
	           * session in localStorage so that you can access the user using
	           * {@link #current}.
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} username The username (or email) to sign up with.
	           * @param {String} password The password to sign up with.
	           * @param {Object} attrs Extra fields to set on the new user.
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is fulfilled with the user when
	           *     the signup completes.
	           * @see AV.User#signUp
	           */
	          signUp: function signUp(username, password, attrs, options) {
	            attrs = attrs || {};
	            attrs.username = username;
	            attrs.password = password;
	            var user = AV.Object._create("_User");
	            return user.signUp(attrs, options);
	          },
	
	          /**
	           * Logs in a user with a username (or email) and password. On success, this
	           * saves the session to disk, so you can retrieve the currently logged in
	           * user using <code>current</code>.
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} username The username (or email) to log in with.
	           * @param {String} password The password to log in with.
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is fulfilled with the user when
	           *     the login completes.
	           * @see AV.User#logIn
	           */
	          logIn: function logIn(username, password, options) {
	            var user = AV.Object._create("_User");
	            user._finishFetch({ username: username, password: password });
	            return user.logIn(options);
	          },
	
	          /**
	           * Logs in a user with a session token. On success, this saves the session
	           * to disk, so you can retrieve the currently logged in user using
	           * <code>current</code>.
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} sessionToken The sessionToken to log in with.
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is fulfilled with the user when
	           *     the login completes.
	           */
	          become: function become(sessionToken, options) {
	            options = options || {};
	
	            var user = AV.Object._create("_User");
	            return AVRequest("users", "me", null, "GET", {
	              useMasterKey: options.useMasterKey,
	              session_token: sessionToken
	            }).then(function (resp, status, xhr) {
	              var serverAttrs = user.parse(resp, status, xhr);
	              user._finishFetch(serverAttrs);
	              return user._handleSaveResult(true).then(function () {
	                return user;
	              });
	            })._thenRunCallbacks(options, user);
	          },
	
	          /**
	           * Logs in a user with a mobile phone number and sms code sent by
	           * AV.User.requestLoginSmsCode.On success, this
	           * saves the session to disk, so you can retrieve the currently logged in
	           * user using <code>current</code>.
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} mobilePhone The user's mobilePhoneNumber
	           * @param {String} smsCode The sms code sent by AV.User.requestLoginSmsCode
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is fulfilled with the user when
	           *     the login completes.
	           * @see AV.User#logIn
	           */
	          logInWithMobilePhoneSmsCode: function logInWithMobilePhoneSmsCode(mobilePhone, smsCode, options) {
	            var user = AV.Object._create("_User");
	            user._finishFetch({ mobilePhoneNumber: mobilePhone, smsCode: smsCode });
	            return user.logIn(options);
	          },
	
	          /**
	           * Sign up or logs in a user with a mobilePhoneNumber and smsCode.
	           * On success, this saves the session to disk, so you can retrieve the currently
	           * logged in user using <code>current</code>.
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} mobilePhoneNumber The user's mobilePhoneNumber.
	           * @param {String} smsCode The sms code sent by AV.Cloud.requestSmsCode
	           * @param {Object} attributes  The user's other attributes such as username etc.
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is fulfilled with the user when
	           *     the login completes.
	           * @see AV.User#signUpOrlogInWithMobilePhone
	           * @see AV.Cloud.requestSmsCode
	           */
	          signUpOrlogInWithMobilePhone: function signUpOrlogInWithMobilePhone(mobilePhoneNumber, smsCode, attrs, options) {
	            attrs = attrs || {};
	            attrs.mobilePhoneNumber = mobilePhoneNumber;
	            attrs.smsCode = smsCode;
	            var user = AV.Object._create("_User");
	            return user.signUpOrlogInWithMobilePhone(attrs, options);
	          },
	
	          /**
	           * Logs in a user with a mobile phone number and password. On success, this
	           * saves the session to disk, so you can retrieve the currently logged in
	           * user using <code>current</code>.
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} mobilePhone The user's mobilePhoneNumber
	           * @param {String} password The password to log in with.
	           * @param {Object} options A Backbone-style options object.
	           * @return {AV.Promise} A promise that is fulfilled with the user when
	           *     the login completes.
	           * @see AV.User#logIn
	           */
	          logInWithMobilePhone: function logInWithMobilePhone(mobilePhone, password, options) {
	            var user = AV.Object._create("_User");
	            user._finishFetch({ mobilePhoneNumber: mobilePhone, password: password });
	            return user.logIn(options);
	          },
	
	          /**
	           * Sign up or logs in a user with a third party auth data(AccessToken).
	           * On success, this saves the session to disk, so you can retrieve the currently
	           * logged in user using <code>current</code>.
	           *
	           * @param {Object} authData The response json data returned from third party token, maybe like { openid: 'abc123', access_token: '123abc', expires_in: 1382686496 }
	           * @param {string} platform Available platform for sign up.
	           * @param {Object} [callback] An object that has an optional success function, that takes no arguments and will be called on a successful puSH. and an error function that takes a AVError and will be called if the push failed.
	           * @return {AV.Promise} A promise that is fulfilled with the user when
	           *     the login completes.
	           * @example AV.User.signUpOrlogInWithAuthData(authData, platform).then(function(user) {
	           *   //Access user here
	           * }).catch(function(error) {
	           *   //console.error("error: ", error);
	           * });
	           * @see {@link https://leancloud.cn/docs/js_guide.html#绑定第三方平台账户}
	           */
	          signUpOrlogInWithAuthData: function signUpOrlogInWithAuthData(authData, platform, callback) {
	            return AV.User._logInWith(platform, { authData: authData })._thenRunCallbacks(callback);
	          },
	
	
	          /**
	           * Associate a user with a third party auth data(AccessToken).
	           *
	           * @param {AV.User} userObj A user which you want to associate.
	           * @param {string} platform Available platform for sign up.
	           * @param {Object} authData The response json data returned from third party token, maybe like { openid: 'abc123', access_token: '123abc', expires_in: 1382686496 }
	           * @return {AV.Promise} A promise that is fulfilled with the user when completed.
	           * @example AV.User.associateWithAuthData(loginUser, 'weixin', {
	           *   openid: 'abc123',
	           *   access_token: '123abc',
	           *   expires_in: 1382686496
	           * }).then(function(user) {
	           *   //Access user here
	           * }).catch(function(error) {
	           *   //console.error("error: ", error);
	           * });
	           */
	          associateWithAuthData: function associateWithAuthData(userObj, platform, authData) {
	            return userObj._linkWith(platform, { authData: authData });
	          },
	
	          /**
	           * Logs out the currently logged in user session. This will remove the
	           * session from disk, log out of linked services, and future calls to
	           * <code>current</code> will return <code>null</code>.
	           */
	          logOut: function logOut() {
	            if (AV._config.disableCurrentUser) {
	              console.warn('AV.User.current() was disabled in multi-user environment, call logOut() from user object instead https://leancloud.cn/docs/leanengine-node-sdk-upgrade-1.html');
	              return AV.Promise.as(null);
	            }
	
	            if (AV.User._currentUser !== null) {
	              AV.User._currentUser._logOutWithAll();
	              AV.User._currentUser._isCurrentUser = false;
	            }
	            AV.User._currentUserMatchesDisk = true;
	            AV.User._currentUser = null;
	            return AV.localStorage.removeItemAsync(AV._getAVPath(AV.User._CURRENT_USER_KEY));
	          },
	
	          /**
	           *Create a follower query for special user to query the user's followers.
	           * @param userObjectId {String} The user object id.
	           * @since 0.3.0
	           */
	          followerQuery: function followerQuery(userObjectId) {
	            if (!userObjectId || !_.isString(userObjectId)) {
	              throw "Invalid user object id.";
	            }
	            var query = new AV.FriendShipQuery('_Follower');
	            query._friendshipTag = 'follower';
	            query.equalTo('user', AV.Object.createWithoutData('_User', userObjectId));
	            return query;
	          },
	
	          /**
	           *Create a followee query for special user to query the user's followees.
	           * @param userObjectId {String} The user object id.
	           * @since 0.3.0
	           */
	          followeeQuery: function followeeQuery(userObjectId) {
	            if (!userObjectId || !_.isString(userObjectId)) {
	              throw "Invalid user object id.";
	            }
	            var query = new AV.FriendShipQuery('_Followee');
	            query._friendshipTag = 'followee';
	            query.equalTo('user', AV.Object.createWithoutData('_User', userObjectId));
	            return query;
	          },
	
	          /**
	           * Requests a password reset email to be sent to the specified email address
	           * associated with the user account. This email allows the user to securely
	           * reset their password on the AV site.
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} email The email address associated with the user that
	           *     forgot their password.
	           * @param {Object} options A Backbone-style options object.
	           */
	          requestPasswordReset: function requestPasswordReset(email, options) {
	            var json = { email: email };
	            var request = AVRequest("requestPasswordReset", null, null, "POST", json);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * Requests a verify email to be sent to the specified email address
	           * associated with the user account. This email allows the user to securely
	           * verify their email address on the AV site.
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} email The email address associated with the user that
	           *     doesn't verify their email address.
	           * @param {Object} options A Backbone-style options object.
	           */
	          requestEmailVerify: function requestEmailVerify(email, options) {
	            var json = { email: email };
	            var request = AVRequest("requestEmailVerify", null, null, "POST", json);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * @Deprecated typo error, please use requestEmailVerify
	           */
	          requestEmailVerfiy: function requestEmailVerfiy(email, options) {
	            var json = { email: email };
	            var request = AVRequest("requestEmailVerify", null, null, "POST", json);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * Requests a verify sms code to be sent to the specified mobile phone
	           * number associated with the user account. This sms code allows the user to
	           * verify their mobile phone number by calling AV.User.verifyMobilePhone
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} mobilePhone The mobile phone number  associated with the
	           *                  user that doesn't verify their mobile phone number.
	           * @param {Object} options A Backbone-style options object.
	           */
	          requestMobilePhoneVerify: function requestMobilePhoneVerify(mobilePhone, options) {
	            var json = { mobilePhoneNumber: mobilePhone };
	            var request = AVRequest("requestMobilePhoneVerify", null, null, "POST", json);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * Requests a reset password sms code to be sent to the specified mobile phone
	           * number associated with the user account. This sms code allows the user to
	           * reset their account's password by calling AV.User.resetPasswordBySmsCode
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} mobilePhone The mobile phone number  associated with the
	           *                  user that doesn't verify their mobile phone number.
	           * @param {Object} options A Backbone-style options object.
	           */
	          requestPasswordResetBySmsCode: function requestPasswordResetBySmsCode(mobilePhone, options) {
	            var json = { mobilePhoneNumber: mobilePhone };
	            var request = AVRequest("requestPasswordResetBySmsCode", null, null, "POST", json);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * Makes a call to reset user's account password by sms code and new password.
	          * The sms code is sent by AV.User.requestPasswordResetBySmsCode.
	           * @param {String} code The sms code sent by AV.User.Cloud.requestSmsCode
	           * @param {String} password The new password.
	           * @param {Object} options A Backbone-style options object
	           * @return {AV.Promise} A promise that will be resolved with the result
	           * of the function.
	           */
	          resetPasswordBySmsCode: function resetPasswordBySmsCode(code, password, options) {
	            var json = { password: password };
	            var request = AVRequest("resetPasswordBySmsCode", null, code, "PUT", json);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * Makes a call to verify sms code that sent by AV.User.Cloud.requestSmsCode
	           * If verify successfully,the user mobilePhoneVerified attribute will be true.
	           * @param {String} code The sms code sent by AV.User.Cloud.requestSmsCode
	           * @param {Object} options A Backbone-style options object
	           * @return {AV.Promise} A promise that will be resolved with the result
	           * of the function.
	           */
	          verifyMobilePhone: function verifyMobilePhone(code, options) {
	            var request = AVRequest("verifyMobilePhone", null, code, "POST", null);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * Requests a logIn sms code to be sent to the specified mobile phone
	           * number associated with the user account. This sms code allows the user to
	           * login by AV.User.logInWithMobilePhoneSmsCode function.
	           *
	           * <p>Calls options.success or options.error on completion.</p>
	           *
	           * @param {String} mobilePhone The mobile phone number  associated with the
	           *           user that want to login by AV.User.logInWithMobilePhoneSmsCode
	           * @param {Object} options A Backbone-style options object.
	           */
	          requestLoginSmsCode: function requestLoginSmsCode(mobilePhone, options) {
	            var json = { mobilePhoneNumber: mobilePhone };
	            var request = AVRequest("requestLoginSmsCode", null, null, "POST", json);
	            return request._thenRunCallbacks(options);
	          },
	
	          /**
	           * Retrieves the currently logged in AVUser with a valid session,
	           * either from memory or localStorage, if necessary.
	           * @return {AV.Promise} resolved with the currently logged in AV.User.
	           */
	          currentAsync: function currentAsync() {
	            if (AV._config.disableCurrentUser) {
	              console.warn('AV.User.currentAsync() was disabled in multi-user environment, access user from request instead https://leancloud.cn/docs/leanengine-node-sdk-upgrade-1.html');
	              return AV.Promise.as(null);
	            }
	
	            if (AV.User._currentUser) {
	              return AV.Promise.as(AV.User._currentUser);
	            }
	
	            if (AV.User._currentUserMatchesDisk) {
	
	              return AV.Promise.as(AV.User._currentUser);
	            }
	
	            return AV.localStorage.getItemAsync(AV._getAVPath(AV.User._CURRENT_USER_KEY)).then(function (userData) {
	              if (!userData) {
	                return null;
	              }
	
	              // Load the user from local storage.
	              AV.User._currentUserMatchesDisk = true;
	
	              AV.User._currentUser = AV.Object._create("_User");
	              AV.User._currentUser._isCurrentUser = true;
	
	              var json = JSON.parse(userData);
	              AV.User._currentUser.id = json._id;
	              delete json._id;
	              AV.User._currentUser._sessionToken = json._sessionToken;
	              delete json._sessionToken;
	              AV.User._currentUser._finishFetch(json);
	              //AV.User._currentUser.set(json);
	
	              AV.User._currentUser._synchronizeAllAuthData();
	              AV.User._currentUser._refreshCache();
	              AV.User._currentUser._opSetQueue = [{}];
	              return AV.User._currentUser;
	            });
	          },
	
	          /**
	           * Retrieves the currently logged in AVUser with a valid session,
	           * either from memory or localStorage, if necessary.
	           * @return {AV.Object} The currently logged in AV.User.
	           */
	          current: function current() {
	            if (AV._config.disableCurrentUser) {
	              console.warn('AV.User.current() was disabled in multi-user environment, access user from request instead https://leancloud.cn/docs/leanengine-node-sdk-upgrade-1.html');
	              return null;
	            }
	
	            if (AV.User._currentUser) {
	              return AV.User._currentUser;
	            }
	
	            if (AV.User._currentUserMatchesDisk) {
	
	              return AV.User._currentUser;
	            }
	
	            // Load the user from local storage.
	            AV.User._currentUserMatchesDisk = true;
	
	            var userData = AV.localStorage.getItem(AV._getAVPath(AV.User._CURRENT_USER_KEY));
	            if (!userData) {
	
	              return null;
	            }
	            AV.User._currentUser = AV.Object._create("_User");
	            AV.User._currentUser._isCurrentUser = true;
	
	            var json = JSON.parse(userData);
	            AV.User._currentUser.id = json._id;
	            delete json._id;
	            AV.User._currentUser._sessionToken = json._sessionToken;
	            delete json._sessionToken;
	            AV.User._currentUser._finishFetch(json);
	            //AV.User._currentUser.set(json);
	
	            AV.User._currentUser._synchronizeAllAuthData();
	            AV.User._currentUser._refreshCache();
	            AV.User._currentUser._opSetQueue = [{}];
	            return AV.User._currentUser;
	          },
	
	          /**
	           * Persists a user as currentUser to localStorage, and into the singleton.
	           */
	          _saveCurrentUser: function _saveCurrentUser(user) {
	            var promise;
	            if (AV.User._currentUser !== user) {
	              promise = AV.User.logOut();
	            } else {
	              promise = AV.Promise.as();
	            }
	            return promise.then(function () {
	              user._isCurrentUser = true;
	              AV.User._currentUser = user;
	
	              var json = user.toJSON();
	              json._id = user.id;
	              json._sessionToken = user._sessionToken;
	              return AV.localStorage.setItemAsync(AV._getAVPath(AV.User._CURRENT_USER_KEY), JSON.stringify(json)).then(function () {
	                AV.User._currentUserMatchesDisk = true;
	              });
	            });
	          },
	
	          _registerAuthenticationProvider: function _registerAuthenticationProvider(provider) {
	            AV.User._authProviders[provider.getAuthType()] = provider;
	            // Synchronize the current user with the auth provider.
	            if (!AV._config.disableCurrentUser && AV.User.current()) {
	              AV.User.current()._synchronizeAuthData(provider.getAuthType());
	            }
	          },
	
	          _logInWith: function _logInWith(provider, options) {
	            var user = AV.Object._create("_User");
	            return user._linkWith(provider, options);
	          }
	
	        });
	      };
	
	      function filterOutCallbacks(options) {
	        var newOptions = _.clone(options) || {};
	        delete newOptions.success;
	        delete newOptions.error;
	        return newOptions;
	      }
	    }, { "./error": 24, "./request": 37, "underscore": 17 }], 45: [function (require, module, exports) {
	      (function (process) {
	        /**
	         * 每位工程师都有保持代码优雅的义务
	         * Each engineer has a duty to keep the code elegant
	        **/
	
	        var _ = require('underscore');
	        var request = require('./request');
	
	        // Helper function to check null or undefined.
	        var isNullOrUndefined = function isNullOrUndefined(x) {
	          return _.isNull(x) || _.isUndefined(x);
	        };
	
	        var ensureArray = function ensureArray(target) {
	          if (_.isArray(target)) {
	            return target;
	          }
	          if (target === undefined || target === null) {
	            return [];
	          }
	          return [target];
	        };
	
	        var init = function init(AV) {
	          // 挂载一些配置
	          var AVConfig = AV._config;
	
	          _.extend(AVConfig, {
	
	            // 服务器节点地区，默认中国大陆
	            region: 'cn',
	
	            // 服务器的 URL，默认初始化时被设置为大陆节点地址
	            APIServerURL: AVConfig.APIServerURL || '',
	
	            // 当前是否为 nodejs 环境
	            isNode: false,
	
	            // 禁用 currentUser，通常用于多用户环境
	            disableCurrentUser: false,
	
	            // Internal config can modifie the UserAgent
	            userAgent: null,
	
	            // set production environment or test environment
	            // 1: production environment, 0: test environment, null: default environment
	            applicationProduction: null
	          });
	
	          /**
	           * Contains all AV API classes and functions.
	           * @name AV
	           * @namespace
	           *
	           * Contains all AV API classes and functions.
	           */
	
	          // Check whether we are running in Node.js.
	          if (typeof process !== 'undefined' && process.versions && process.versions.node) {
	            AVConfig.isNode = true;
	          }
	
	          // Helpers
	          // -------
	
	          // Shared empty constructor function to aid in prototype-chain creation.
	          var EmptyConstructor = function EmptyConstructor() {};
	
	          // Helper function to correctly set up the prototype chain, for subclasses.
	          // Similar to `goog.inherits`, but uses a hash of prototype properties and
	          // class properties to be extended.
	          var inherits = function inherits(parent, protoProps, staticProps) {
	            var child;
	
	            // The constructor function for the new subclass is either defined by you
	            // (the "constructor" property in your `extend` definition), or defaulted
	            // by us to simply call the parent's constructor.
	            if (protoProps && protoProps.hasOwnProperty('constructor')) {
	              child = protoProps.constructor;
	            } else {
	              /** @ignore */
	              child = function child() {
	                parent.apply(this, arguments);
	              };
	            }
	
	            // Inherit class (static) properties from parent.
	            _.extend(child, parent);
	
	            // Set the prototype chain to inherit from `parent`, without calling
	            // `parent`'s constructor function.
	            EmptyConstructor.prototype = parent.prototype;
	            child.prototype = new EmptyConstructor();
	
	            // Add prototype properties (instance properties) to the subclass,
	            // if supplied.
	            if (protoProps) {
	              _.extend(child.prototype, protoProps);
	            }
	
	            // Add static properties to the constructor function, if supplied.
	            if (staticProps) {
	              _.extend(child, staticProps);
	            }
	
	            // Correctly set child's `prototype.constructor`.
	            child.prototype.constructor = child;
	
	            // Set a convenience property in case the parent's prototype is
	            // needed later.
	            child.__super__ = parent.prototype;
	
	            return child;
	          };
	
	          /**
	           * Call this method first to set up authentication tokens for AV.
	           * This method is for AV's own private use.
	           * @param {String} applicationId Your AV Application ID.
	           * @param {String} applicationKey Your AV Application Key
	           */
	          var initialize = function initialize(appId, appKey, masterKey) {
	            if (AV.applicationId && appId !== AV.applicationId && appKey !== AV.applicationKey && masterKey !== AV.masterKey) {
	              console.warn('LeanCloud SDK is already initialized, please do not reinitialize it.');
	            }
	            AV.applicationId = appId;
	            AV.applicationKey = appKey;
	            AV.masterKey = masterKey;
	            AV._useMasterKey = false;
	          };
	
	          /**
	            * Call this method first to set up your authentication tokens for AV.
	            * You can get your app keys from the LeanCloud dashboard on http://leancloud.cn .
	            * @function AV.init
	            * @param args initialize options.
	            * @param args.appId application id
	            * @param args.appKey application key
	            * @param args.masterKey application master key
	          */
	
	          AV.init = function () {
	            var masterKeyWarn = function masterKeyWarn() {
	              console.warn('MasterKey should not be used in the browser. ' + 'The permissions of MasterKey can be across all the server permissions,' + ' including the setting of ACL .');
	            };
	
	            switch (arguments.length) {
	              case 1:
	                var options = arguments.length <= 0 ? undefined : arguments[0];
	                if ((typeof options === "undefined" ? "undefined" : _typeof(options)) === 'object') {
	                  if (!AVConfig.isNode && options.masterKey) {
	                    masterKeyWarn();
	                  }
	                  initialize(options.appId, options.appKey, options.masterKey);
	                  request.setServerUrlByRegion(options.region);
	                  AVConfig.disableCurrentUser = options.disableCurrentUser;
	                } else {
	                  throw new Error('AV.init(): Parameter is not correct.');
	                }
	                break;
	              // 兼容旧版本的初始化方法
	              case 2:
	              case 3:
	                console.warn('Please use AV.init() to replace AV.initialize(), ' + 'AV.init() need an Object param, like { appId: \'YOUR_APP_ID\', appKey: \'YOUR_APP_KEY\' } . ' + 'Docs: https://leancloud.cn/docs/sdk_setup-js.html');
	                if (!AVConfig.isNode && arguments.length === 3) {
	                  masterKeyWarn();
	                }
	                initialize.apply(undefined, arguments);
	                request.setServerUrlByRegion('cn');
	                break;
	            }
	          };
	
	          // If we're running in node.js, allow using the master key.
	          if (AVConfig.isNode) {
	            AV.Cloud = AV.Cloud || {};
	            /**
	             * Switches the LeanCloud SDK to using the Master key.  The Master key grants
	             * priveleged access to the data in LeanCloud and can be used to bypass ACLs and
	             * other restrictions that are applied to the client SDKs.
	             * <p><strong><em>Available in Cloud Code and Node.js only.</em></strong>
	             * </p>
	             */
	            AV.Cloud.useMasterKey = function () {
	              AV._useMasterKey = true;
	            };
	          }
	
	          // 兼容老版本的初始化方法
	          AV.initialize = AV.init;
	
	          /**
	           * Call this method to set production environment variable.
	           * @function AV.setProduction
	           * @param {Boolean} production True is production environment,and
	           *  it's true by default.
	           */
	          AV.setProduction = function (production) {
	            if (!isNullOrUndefined(production)) {
	              AVConfig.applicationProduction = production ? 1 : 0;
	            } else {
	              // change to default value
	              AVConfig.applicationProduction = null;
	            }
	          };
	
	          /**
	           * @deprecated Please use AV.init(), you can set the region of server .
	          **/
	          // TODO: 后续不再暴露此接口
	          AV.useAVCloudCN = function () {
	            request.setServerUrlByRegion('cn');
	            console.warn('Do not use AV.useAVCloudCN. Please use AV.init(), you can set the region of server.');
	          };
	
	          /**
	           * @deprecated Please use AV.init(), you can set the region of server .
	          **/
	          // TODO: 后续不再暴露此接口
	          AV.useAVCloudUS = function () {
	            request.setServerUrlByRegion('us');
	            console.warn('Do not use AV.useAVCloudUS. Please use AV.init(), you can set the region of server.');
	          };
	
	          /**
	           * Returns prefix for localStorage keys used by this instance of AV.
	           * @param {String} path The relative suffix to append to it.
	           *     null or undefined is treated as the empty string.
	           * @return {String} The full key name.
	           */
	          AV._getAVPath = function (path) {
	            if (!AV.applicationId) {
	              throw "You need to call AV.initialize before using AV.";
	            }
	            if (!path) {
	              path = "";
	            }
	            if (!_.isString(path)) {
	              throw "Tried to get a localStorage path that wasn't a String.";
	            }
	            if (path[0] === "/") {
	              path = path.substring(1);
	            }
	            return "AV/" + AV.applicationId + "/" + path;
	          };
	
	          /**
	           * Returns the unique string for this app on this machine.
	           * Gets reset when localStorage is cleared.
	           */
	          AV._installationId = null;
	          AV._getInstallationId = function () {
	            // See if it's cached in RAM.
	            if (AV._installationId) {
	              return AV.Promise.as(AV._installationId);
	            }
	
	            // Try to get it from localStorage.
	            var path = AV._getAVPath("installationId");
	            return AV.localStorage.getItemAsync(path).then(function (_installationId) {
	              AV._installationId = _installationId;
	              if (!AV._installationId) {
	                // It wasn't in localStorage, so create a new one.
	                var hexOctet = function hexOctet() {
	                  return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
	                };
	                AV._installationId = hexOctet() + hexOctet() + "-" + hexOctet() + "-" + hexOctet() + "-" + hexOctet() + "-" + hexOctet() + hexOctet() + hexOctet();
	                return AV.localStorage.setItemAsync(path, AV._installationId);
	              } else {
	                return _installationId;
	              }
	            });
	          };
	
	          AV._parseDate = function (iso8601) {
	            var regexp = new RegExp("^([0-9]{1,4})-([0-9]{1,2})-([0-9]{1,2})" + "T" + "([0-9]{1,2}):([0-9]{1,2}):([0-9]{1,2})" + "(.([0-9]+))?" + "Z$");
	            var match = regexp.exec(iso8601);
	            if (!match) {
	              return null;
	            }
	
	            var year = match[1] || 0;
	            var month = (match[2] || 1) - 1;
	            var day = match[3] || 0;
	            var hour = match[4] || 0;
	            var minute = match[5] || 0;
	            var second = match[6] || 0;
	            var milli = match[8] || 0;
	
	            return new Date(Date.UTC(year, month, day, hour, minute, second, milli));
	          };
	
	          // TODO: Next version remove
	          AV._ajax = function () {
	            console.warn('AV._ajax is deprecated, and will be removed in next release.');
	            request.ajax.apply(request, arguments);
	          };
	
	          // TODO: Next version remove
	          AV._request = function () {
	            console.warn('AV._request is deprecated, and will be removed in next release.');
	            request.request.apply(request, arguments);
	          };
	
	          // A self-propagating extend function.
	          AV._extend = function (protoProps, classProps) {
	            var child = inherits(this, protoProps, classProps);
	            child.extend = this.extend;
	            return child;
	          };
	
	          // Helper function to get a value from a Backbone object as a property
	          // or as a function.
	          AV._getValue = function (object, prop) {
	            if (!(object && object[prop])) {
	              return null;
	            }
	            return _.isFunction(object[prop]) ? object[prop]() : object[prop];
	          };
	
	          /**
	           * Converts a value in a AV Object into the appropriate representation.
	           * This is the JS equivalent of Java's AV.maybeReferenceAndEncode(Object)
	           * if seenObjects is falsey. Otherwise any AV.Objects not in
	           * seenObjects will be fully embedded rather than encoded
	           * as a pointer.  This array will be used to prevent going into an infinite
	           * loop because we have circular references.  If <seenObjects>
	           * is set, then none of the AV Objects that are serialized can be dirty.
	           */
	          AV._encode = function (value, seenObjects, disallowObjects) {
	            if (value instanceof AV.Object) {
	              if (disallowObjects) {
	                throw "AV.Objects not allowed here";
	              }
	              if (!seenObjects || _.include(seenObjects, value) || !value._hasData) {
	                return value._toPointer();
	              }
	              if (!value.dirty()) {
	                seenObjects = seenObjects.concat(value);
	                return AV._encode(value._toFullJSON(seenObjects), seenObjects, disallowObjects);
	              }
	              throw "Tried to save an object with a pointer to a new, unsaved object.";
	            }
	            if (value instanceof AV.ACL) {
	              return value.toJSON();
	            }
	            if (_.isDate(value)) {
	              return { "__type": "Date", "iso": value.toJSON() };
	            }
	            if (value instanceof AV.GeoPoint) {
	              return value.toJSON();
	            }
	            if (_.isArray(value)) {
	              return _.map(value, function (x) {
	                return AV._encode(x, seenObjects, disallowObjects);
	              });
	            }
	            if (_.isRegExp(value)) {
	              return value.source;
	            }
	            if (value instanceof AV.Relation) {
	              return value.toJSON();
	            }
	            if (value instanceof AV.Op) {
	              return value.toJSON();
	            }
	            if (value instanceof AV.File) {
	              if (!value.url() && !value.id) {
	                throw "Tried to save an object containing an unsaved file.";
	              }
	              return {
	                __type: "File",
	                id: value.id,
	                name: value.name(),
	                url: value.url()
	              };
	            }
	            if (_.isObject(value)) {
	              var output = {};
	              AV._objectEach(value, function (v, k) {
	                output[k] = AV._encode(v, seenObjects, disallowObjects);
	              });
	              return output;
	            }
	            return value;
	          };
	
	          /**
	           * The inverse function of AV._encode.
	           * TODO: make decode not mutate value.
	           */
	          AV._decode = function (key, value) {
	            if (!_.isObject(value)) {
	              return value;
	            }
	            if (_.isArray(value)) {
	              AV._arrayEach(value, function (v, k) {
	                value[k] = AV._decode(k, v);
	              });
	              return value;
	            }
	            if (value instanceof AV.Object) {
	              return value;
	            }
	            if (value instanceof AV.File) {
	              return value;
	            }
	            if (value instanceof AV.Op) {
	              return value;
	            }
	            if (value.__op) {
	              return AV.Op._decode(value);
	            }
	            var className;
	            if (value.__type === "Pointer") {
	              className = value.className;
	              var pointer = AV.Object._create(className);
	              if (Object.keys(value).length > 3) {
	                delete value.__type;
	                delete value.className;
	                pointer._finishFetch(value, true);
	              } else {
	                pointer._finishFetch({ objectId: value.objectId }, false);
	              }
	              return pointer;
	            }
	            if (value.__type === "Object") {
	              // It's an Object included in a query result.
	              className = value.className;
	              delete value.__type;
	              delete value.className;
	              var object = AV.Object._create(className);
	              object._finishFetch(value, true);
	              return object;
	            }
	            if (value.__type === "Date") {
	              return AV._parseDate(value.iso);
	            }
	            if (value.__type === "GeoPoint") {
	              return new AV.GeoPoint({
	                latitude: value.latitude,
	                longitude: value.longitude
	              });
	            }
	            if (key === "ACL") {
	              if (value instanceof AV.ACL) {
	                return value;
	              }
	              return new AV.ACL(value);
	            }
	            if (value.__type === "Relation") {
	              var relation = new AV.Relation(null, key);
	              relation.targetClassName = value.className;
	              return relation;
	            }
	            if (value.__type === 'File') {
	              var file = new AV.File(value.name);
	              file.attributes.metaData = value.metaData || {};
	              file.attributes.url = value.url;
	              file.id = value.objectId;
	              return file;
	            }
	            AV._objectEach(value, function (v, k) {
	              value[k] = AV._decode(k, v);
	            });
	            return value;
	          };
	
	          AV._encodeObjectOrArray = function (value) {
	            var encodeAVObject = function encodeAVObject(object) {
	              if (object && object._toFullJSON) {
	                object = object._toFullJSON([]);
	              }
	
	              return _.mapObject(object, function (value) {
	                return AV._encode(value, []);
	              });
	            };
	
	            if (_.isArray(value)) {
	              return value.map(function (object) {
	                return encodeAVObject(object);
	              });
	            } else {
	              return encodeAVObject(value);
	            }
	          };
	
	          AV._arrayEach = _.each;
	
	          /**
	           * Does a deep traversal of every item in object, calling func on every one.
	           * @param {Object} object The object or array to traverse deeply.
	           * @param {Function} func The function to call for every item. It will
	           *     be passed the item as an argument. If it returns a truthy value, that
	           *     value will replace the item in its parent container.
	           * @returns {} the result of calling func on the top-level object itself.
	           */
	          AV._traverse = function (object, func, seen) {
	            if (object instanceof AV.Object) {
	              seen = seen || [];
	              if (_.indexOf(seen, object) >= 0) {
	                // We've already visited this object in this call.
	                return;
	              }
	              seen.push(object);
	              AV._traverse(object.attributes, func, seen);
	              return func(object);
	            }
	            if (object instanceof AV.Relation || object instanceof AV.File) {
	              // Nothing needs to be done, but we don't want to recurse into the
	              // object's parent infinitely, so we catch this case.
	              return func(object);
	            }
	            if (_.isArray(object)) {
	              _.each(object, function (child, index) {
	                var newChild = AV._traverse(child, func, seen);
	                if (newChild) {
	                  object[index] = newChild;
	                }
	              });
	              return func(object);
	            }
	            if (_.isObject(object)) {
	              AV._each(object, function (child, key) {
	                var newChild = AV._traverse(child, func, seen);
	                if (newChild) {
	                  object[key] = newChild;
	                }
	              });
	              return func(object);
	            }
	            return func(object);
	          };
	
	          /**
	           * This is like _.each, except:
	           * * it doesn't work for so-called array-like objects,
	           * * it does work for dictionaries with a "length" attribute.
	           */
	          AV._objectEach = AV._each = function (obj, callback) {
	            if (_.isObject(obj)) {
	              _.each(_.keys(obj), function (key) {
	                callback(obj[key], key);
	              });
	            } else {
	              _.each(obj, callback);
	            }
	          };
	        };
	
	        module.exports = {
	          init: init,
	          isNullOrUndefined: isNullOrUndefined,
	          ensureArray: ensureArray
	        };
	      }).call(this, require('_process'));
	    }, { "./request": 37, "_process": 10, "underscore": 17 }], 46: [function (require, module, exports) {
	      /**
	       * 每位工程师都有保持代码优雅的义务
	       * Each engineer has a duty to keep the code elegant
	      **/
	
	      module.exports = 'js1.2.1';
	    }, {}] }, {}, [28])(28);
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.getStyles = getStyles;
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _IconButton = __webpack_require__(91);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _menu = __webpack_require__(418);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _Paper = __webpack_require__(24);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(27);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme;
	  var appBar = _context$muiTheme.appBar;
	  var iconButtonSize = _context$muiTheme.button.iconButtonSize;
	  var zIndex = _context$muiTheme.zIndex;
	
	
	  var flatButtonSize = 36;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      zIndex: zIndex.appBar,
	      width: '100%',
	      display: 'flex',
	      backgroundColor: appBar.color,
	      paddingLeft: appBar.padding,
	      paddingRight: appBar.padding
	    },
	    title: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      margin: 0,
	      paddingTop: 0,
	      letterSpacing: 0,
	      fontSize: 24,
	      fontWeight: appBar.titleFontWeight,
	      color: appBar.textColor,
	      height: appBar.height,
	      lineHeight: appBar.height + 'px'
	    },
	    mainElement: {
	      boxFlex: 1,
	      flex: '1'
	    },
	    iconButtonStyle: {
	      marginTop: (appBar.height - iconButtonSize) / 2,
	      marginRight: 8,
	      marginLeft: -16
	    },
	    iconButtonIconStyle: {
	      fill: appBar.textColor,
	      color: appBar.textColor
	    },
	    flatButton: {
	      color: appBar.textColor,
	      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
	    }
	  };
	
	  return styles;
	}
	
	var AppBar = function (_Component) {
	  _inherits(AppBar, _Component);
	
	  function AppBar() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(AppBar)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleTouchTapLeftIconButton = function (event) {
	      if (_this.props.onLeftIconButtonTouchTap) {
	        _this.props.onLeftIconButtonTouchTap(event);
	      }
	    }, _this.handleTouchTapRightIconButton = function (event) {
	      if (_this.props.onRightIconButtonTouchTap) {
	        _this.props.onRightIconButtonTouchTap(event);
	      }
	    }, _this.handleTitleTouchTap = function (event) {
	      if (_this.props.onTitleTouchTap) {
	        _this.props.onTitleTouchTap(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AppBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;
	
	       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var title = _props.title;
	      var titleStyle = _props.titleStyle;
	      var iconStyleLeft = _props.iconStyleLeft;
	      var iconStyleRight = _props.iconStyleRight;
	      var onTitleTouchTap = _props.onTitleTouchTap;
	      var showMenuIconButton = _props.showMenuIconButton;
	      var iconElementLeft = _props.iconElementLeft;
	      var iconElementRight = _props.iconElementRight;
	      var iconClassNameLeft = _props.iconClassNameLeft;
	      var iconClassNameRight = _props.iconClassNameRight;
	      var onLeftIconButtonTouchTap = _props.onLeftIconButtonTouchTap;
	      var className = _props.className;
	      var style = _props.style;
	      var zDepth = _props.zDepth;
	      var children = _props.children;
	
	      var other = _objectWithoutProperties(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleTouchTap', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonTouchTap', 'className', 'style', 'zDepth', 'children']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var menuElementLeft = void 0;
	      var menuElementRight = void 0;
	
	      // If the title is a string, wrap in an h1 tag.
	      // If not, wrap in a div tag.
	      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';
	
	      var titleElement = _react2.default.createElement(titleComponent, {
	        onTouchTap: this.handleTitleTouchTap,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
	      }, title);
	
	      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);
	
	      if (showMenuIconButton) {
	        var iconElementLeftNode = iconElementLeft;
	
	        if (iconElementLeft) {
	          if (iconElementLeft.type.muiName === 'IconButton') {
	            var iconElemLeftChildren = iconElementLeft.props.children;
	            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementLeftNode = _react2.default.cloneElement(iconElementLeft, {
	              iconStyle: (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle)
	            });
	          }
	
	          menuElementLeft = _react2.default.createElement(
	            'div',
	            { style: prepareStyles(iconLeftStyle) },
	            iconElementLeftNode
	          );
	        } else {
	          var child = iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) });
	          menuElementLeft = _react2.default.createElement(
	            _IconButton2.default,
	            {
	              style: iconLeftStyle,
	              iconStyle: styles.iconButtonIconStyle,
	              iconClassName: iconClassNameLeft,
	              onTouchTap: this.handleTouchTapLeftIconButton
	            },
	            child
	          );
	        }
	      }
	
	      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
	        marginRight: -16,
	        marginLeft: 'auto'
	      }, iconStyleRight);
	
	      if (iconElementRight) {
	        var iconElementRightNode = iconElementRight;
	
	        switch (iconElementRight.type.muiName) {
	          case 'IconMenu':
	          case 'IconButton':
	            var iconElemRightChildren = iconElementRight.props.children;
	            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementRightNode = _react2.default.cloneElement(iconElementRight, {
	              iconStyle: (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle)
	            });
	            break;
	
	          case 'FlatButton':
	            iconElementRightNode = _react2.default.cloneElement(iconElementRight, {
	              style: (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style)
	            });
	            break;
	
	          default:
	        }
	
	        menuElementRight = _react2.default.createElement(
	          'div',
	          { style: prepareStyles(iconRightStyle) },
	          iconElementRightNode
	        );
	      } else if (iconClassNameRight) {
	        menuElementRight = _react2.default.createElement(_IconButton2.default, {
	          style: iconRightStyle,
	          iconStyle: styles.iconButtonIconStyle,
	          iconClassName: iconClassNameRight,
	          onTouchTap: this.handleTouchTapRightIconButton
	        });
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        _extends({}, other, {
	          rounded: false,
	          className: className,
	          style: (0, _simpleAssign2.default)({}, styles.root, style),
	          zDepth: zDepth
	        }),
	        menuElementLeft,
	        titleElement,
	        menuElementRight,
	        children
	      );
	    }
	  }]);
	
	  return AppBar;
	}(_react.Component);
	
	AppBar.muiName = 'AppBar';
	AppBar.propTypes = {
	  /**
	   * Can be used to render a tab inside an app bar for instance.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Applied to the app bar's root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The classname of the icon on the left of the app bar.
	   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	   */
	  iconClassNameLeft: _react.PropTypes.string,
	  /**
	   * Similiar to the iconClassNameLeft prop except that
	   * it applies to the icon displayed on the right of the app bar.
	   */
	  iconClassNameRight: _react.PropTypes.string,
	  /**
	   * The custom element to be displayed on the left side of the
	   * app bar such as an SvgIcon.
	   */
	  iconElementLeft: _react.PropTypes.element,
	  /**
	   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	   */
	  iconElementRight: _react.PropTypes.element,
	  /**
	   * Override the inline-styles of the element displayed on the left side of the app bar.
	   */
	  iconStyleLeft: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the element displayed on the right side of the app bar.
	   */
	  iconStyleRight: _react.PropTypes.object,
	  /**
	   * Callback function for when the left icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the left `IconButton`.
	   */
	  onLeftIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the right icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the right `IconButton`.
	   */
	  onRightIconButtonTouchTap: _react.PropTypes.func,
	  /**
	   * Callback function for when the title text is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the `title` node.
	   */
	  onTitleTouchTap: _react.PropTypes.func,
	  /**
	   * Determines whether or not to display the Menu icon next to the title.
	   * Setting this prop to false will hide the icon.
	   */
	  showMenuIconButton: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the app bar.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the app bar's title element.
	   */
	  titleStyle: _react.PropTypes.object,
	  /**
	   * The zDepth of the component.
	   * The shadow of the app bar is also dependent on this property.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	AppBar.defaultProps = {
	  showMenuIconButton: true,
	  title: '',
	  zDepth: 1
	};
	AppBar.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = AppBar;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AppBar = __webpack_require__(239);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppBar2.default;

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _autoPrefix = __webpack_require__(56);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round(clampedValue / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max;
	  var min = props.min;
	  var size = props.size;
	  var value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	  var zoom = size * 1.4;
	  var baseSize = 50;
	  var margin = Math.round((50 * zoom - 50) / 2);
	
	  if (margin < 0) margin = 0;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      margin: margin,
	      display: 'inline-block',
	      width: baseSize,
	      height: baseSize
	    },
	    wrapper: {
	      width: baseSize,
	      height: baseSize,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      height: baseSize,
	      position: 'relative',
	      transform: 'scale(' + zoom + ')',
	      width: baseSize
	    },
	    path: {
	      strokeDasharray: '89, 200',
	      strokeDashoffset: 0,
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = Math.round(relVal * 1.25) + ', 200';
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  _inherits(CircularProgress, _Component);
	
	  function CircularProgress() {
	    _classCallCheck(this, CircularProgress);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CircularProgress).apply(this, arguments));
	  }
	
	  _createClass(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step = step || 0;
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = '1, 200';
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = '89, 200';
	        path.style.strokeDashoffset = -35;
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = '89, 200';
	        path.style.strokeDashoffset = -124;
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var style = _props.style;
	      var innerStyle = _props.innerStyle;
	      var size = _props.size;
	
	      var other = _objectWithoutProperties(_props, ['style', 'innerStyle', 'size']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            { style: prepareStyles(styles.svg) },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: '25',
	              cy: '25',
	              r: '20',
	              fill: 'none',
	              strokeWidth: '2.5',
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.propTypes = {
	  /**
	   * Override the progress's color.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _react.PropTypes.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _react.PropTypes.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _react.PropTypes.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _react.PropTypes.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The size of the progress.
	   */
	  size: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _react.PropTypes.number
	};
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 1
	};
	CircularProgress.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CircularProgress;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(241);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(104);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(53);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(280);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(146);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(24);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactAddonsTransitionGroup = __webpack_require__(68);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TransitionItem = function (_Component) {
	  _inherits(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TransitionItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate3d(0, ' + spacing.desktopKeylineIncrement + 'px, 0)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate3d(0, 0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var style = _props.style;
	      var children = _props.children;
	
	      var other = _objectWithoutProperties(_props, ['style', 'children']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.propTypes = {
	  children: _react.PropTypes.node,
	  style: _react.PropTypes.object
	};
	TransitionItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent;
	  var open = props.open;
	  var _context$muiTheme = context.muiTheme;
	  var _context$muiTheme$bas = _context$muiTheme.baseTheme;
	  var spacing = _context$muiTheme$bas.spacing;
	  var palette = _context$muiTheme$bas.palette;
	  var dialog = _context$muiTheme.dialog;
	  var zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0,
	      borderTop: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0,
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  _inherits(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _Object$getPrototypeO2;
	
	    var _temp2, _this2, _ret2;
	
	    _classCallCheck(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, (_Object$getPrototypeO2 = Object.getPrototypeOf(DialogInline)).call.apply(_Object$getPrototypeO2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	  }
	
	  _createClass(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props;
	      var actions = _props2.actions;
	      var autoDetectWindowHeight = _props2.autoDetectWindowHeight;
	      var autoScrollBodyContent = _props2.autoScrollBodyContent;
	      var bodyStyle = _props2.bodyStyle;
	      var open = _props2.open;
	      var repositionOnUpdate = _props2.repositionOnUpdate;
	      var title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var actions = _props3.actions;
	      var actionsContainerClassName = _props3.actionsContainerClassName;
	      var actionsContainerStyle = _props3.actionsContainerStyle;
	      var bodyClassName = _props3.bodyClassName;
	      var bodyStyle = _props3.bodyStyle;
	      var children = _props3.children;
	      var className = _props3.className;
	      var contentClassName = _props3.contentClassName;
	      var contentStyle = _props3.contentStyle;
	      var overlayClassName = _props3.overlayClassName;
	      var overlayStyle = _props3.overlayStyle;
	      var open = _props3.open;
	      var titleClassName = _props3.titleClassName;
	      var titleStyle = _props3.titleStyle;
	      var title = _props3.title;
	      var style = _props3.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { zDepth: 4 },
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onTouchTap: this.handleTouchTapOverlay
	        })
	      );
	    }
	  }]);
	
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.propTypes = {
	  actions: _react.PropTypes.node,
	  actionsContainerClassName: _react.PropTypes.string,
	  actionsContainerStyle: _react.PropTypes.object,
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  autoScrollBodyContent: _react.PropTypes.bool,
	  bodyClassName: _react.PropTypes.string,
	  bodyStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  contentClassName: _react.PropTypes.string,
	  contentStyle: _react.PropTypes.object,
	  modal: _react.PropTypes.bool,
	  onRequestClose: _react.PropTypes.func,
	  open: _react.PropTypes.bool.isRequired,
	  overlayClassName: _react.PropTypes.string,
	  overlayStyle: _react.PropTypes.object,
	  repositionOnUpdate: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  title: _react.PropTypes.node,
	  titleClassName: _react.PropTypes.string,
	  titleStyle: _react.PropTypes.object
	};
	DialogInline.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var Dialog = function (_Component3) {
	  _inherits(Dialog, _Component3);
	
	  function Dialog() {
	    var _Object$getPrototypeO3;
	
	    var _temp3, _this3, _ret3;
	
	    _classCallCheck(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = _possibleConstructorReturn(this, (_Object$getPrototypeO3 = Object.getPrototypeOf(Dialog)).call.apply(_Object$getPrototypeO3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), _possibleConstructorReturn(_this3, _ret3);
	  }
	
	  _createClass(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	
	  return Dialog;
	}(_react.Component);
	
	Dialog.propTypes = {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _react.PropTypes.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _react.PropTypes.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _react.PropTypes.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _react.PropTypes.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _react.PropTypes.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _react.PropTypes.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _react.PropTypes.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _react.PropTypes.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _react.PropTypes.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _react.PropTypes.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _react.PropTypes.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _react.PropTypes.object
	};
	Dialog.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	exports.default = Dialog;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the `Divider` will be indented `72px`.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  inset: false
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset;
	  var style = props.style;
	
	  var other = _objectWithoutProperties(props, ['inset', 'style']);
	
	  var muiTheme = context.muiTheme;
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: muiTheme.baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	Divider.propTypes = propTypes;
	Divider.defaultProps = defaultProps;
	Divider.contextTypes = contextTypes;
	
	exports.default = Divider;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _childUtils = __webpack_require__(69);
	
	var _colorManipulator = __webpack_require__(34);
	
	var _EnhancedButton = __webpack_require__(52);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(246);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  _inherits(FlatButton, _Component);
	
	  function FlatButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FlatButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled && this.state.hovered) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var disabled = _props.disabled;
	      var hoverColor = _props.hoverColor;
	      var backgroundColor = _props.backgroundColor;
	      var icon = _props.icon;
	      var label = _props.label;
	      var labelStyle = _props.labelStyle;
	      var labelPosition = _props.labelPosition;
	      var primary = _props.primary;
	      var rippleColor = _props.rippleColor;
	      var secondary = _props.secondary;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'disabled', 'hoverColor', 'backgroundColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	
	      var _context$muiTheme = this.context.muiTheme;
	      var _context$muiTheme$but = _context$muiTheme.button;
	      var buttonHeight = _context$muiTheme$but.height;
	      var buttonMinWidth = _context$muiTheme$but.minWidth;
	      var buttonTextTransform = _context$muiTheme$but.textTransform;
	      var _context$muiTheme$fla = _context$muiTheme.flatButton;
	      var buttonFilterColor = _context$muiTheme$fla.buttonFilterColor;
	      var buttonColor = _context$muiTheme$fla.color;
	      var disabledTextColor = _context$muiTheme$fla.disabledTextColor;
	      var fontSize = _context$muiTheme$fla.fontSize;
	      var fontWeight = _context$muiTheme$fla.fontWeight;
	      var primaryTextColor = _context$muiTheme$fla.primaryTextColor;
	      var secondaryTextColor = _context$muiTheme$fla.secondaryTextColor;
	      var textColor = _context$muiTheme$fla.textColor;
	      var _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform;
	      var textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: 2,
	        userSelect: 'none',
	        position: 'relative',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: {
	            verticalAlign: 'middle',
	            marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	            marginRight: label && labelPosition === 'before' ? 12 : 0
	          }
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.propTypes = {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _react.PropTypes.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _react.PropTypes.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	FlatButton.defaultProps = {
	  disabled: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = FlatButton;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  _inherits(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    _classCallCheck(this, FlatButtonLabel);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(FlatButtonLabel).apply(this, arguments));
	  }
	
	  _createClass(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var label = _props.label;
	      var style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.propTypes = {
	  label: _react.PropTypes.node,
	  style: _react.PropTypes.object
	};
	FlatButtonLabel.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = FlatButtonLabel;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var color = props.color;
	  var hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  _inherits(FontIcon, _Component);
	
	  function FontIcon() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(FontIcon)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var hoverColor = _props.hoverColor;
	      var onMouseLeave = _props.onMouseLeave;
	      var onMouseEnter = _props.onMouseEnter;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', _extends({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.propTypes = {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = FontIcon;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(52);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(137);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(283);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(69);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    overlay: {
	      position: 'relative',
	      top: 0,
	      width: '100%',
	      height: '100%',
	      background: baseTheme.palette.disabledColor
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'not-allowed'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  _inherits(IconButton, _Component);
	
	  function IconButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(IconButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) _this.props.onFocus(event);
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.button.isKeyboardFocused()) _this.hideTooltip();
	      if (_this.props.onMouseLeave) _this.props.onMouseLeave(event);
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	      if (_this.props.onMouseEnter) _this.props.onMouseEnter(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.showTooltip();
	        if (_this.props.onFocus) _this.props.onFocus(event);
	      } else if (!_this.state.hovered) {
	        _this.hideTooltip();
	        if (_this.props.onBlur) _this.props.onBlur(event);
	      }
	
	      if (_this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(IconButton, [{
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.refs.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var disabled = _props.disabled;
	      var disableTouchRipple = _props.disableTouchRipple;
	      var children = _props.children;
	      var iconClassName = _props.iconClassName;
	      var onKeyboardFocus = _props.onKeyboardFocus;
	      var tooltip = _props.tooltip;
	      var tooltipPositionProp = _props.tooltipPosition;
	      var touch = _props.touch;
	      var iconStyle = _props.iconStyle;
	
	      var other = _objectWithoutProperties(_props, ['disabled', 'disableTouchRipple', 'children', 'iconClassName', 'onKeyboardFocus', 'tooltip', 'tooltipPosition', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        ref: 'tooltip',
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, this.props.tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor;
	
	        var iconStyleFontIcon = _objectWithoutProperties(iconStyle, ['iconHoverColor']);
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({}, other, {
	          ref: 'button',
	          centerRipple: true,
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.propTypes = {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _react.PropTypes.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _react.PropTypes.object,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseOut: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _react.PropTypes.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes2.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _react.PropTypes.object,
	  /**
	   * If true, increase the tooltip element's size.  Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _react.PropTypes.bool
	};
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = IconButton;

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MakeSelectable = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _colorManipulator = __webpack_require__(34);
	
	var _deprecatedPropType = __webpack_require__(57);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MakeSelectable = exports.MakeSelectable = function MakeSelectable(Component) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    _inherits(_class, _Component);
	
	    function _class() {
	      var _Object$getPrototypeO;
	
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(_class)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
	        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
	        }
	        return previousValue || _this.isChildSelected(child, _this.props);
	      }, _this.handleItemTouchTap = function (event, item) {
	        var valueLink = _this.getValueLink(_this.props);
	        var itemValue = item.props.value;
	
	        if (itemValue !== valueLink.value) {
	          valueLink.requestChange(event, itemValue);
	        }
	      }, _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    _createClass(_class, [{
	      key: 'getValueLink',
	      value: function getValueLink(props) {
	        return props.valueLink || {
	          value: props.value,
	          requestChange: props.onChange
	        };
	      }
	    }, {
	      key: 'extendChild',
	      value: function extendChild(child, styles, selectedItemStyle) {
	        var _this2 = this;
	
	        if (child && child.type && child.type.muiName === 'ListItem') {
	          var selected = this.isChildSelected(child, this.props);
	          var selectedChildrenStyles = void 0;
	          if (selected) {
	            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
	          }
	
	          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	          this.keyIndex += 1;
	
	          return _react2.default.cloneElement(child, {
	            onTouchTap: function onTouchTap(event) {
	              _this2.handleItemTouchTap(event, child);
	              if (child.props.onTouchTap) {
	                child.props.onTouchTap(event);
	              }
	            },
	            key: this.keyIndex,
	            style: mergedChildrenStyles,
	            nestedItems: child.props.nestedItems.map(function (child) {
	              return _this2.extendChild(child, styles, selectedItemStyle);
	            }),
	            initiallyOpen: this.isInitiallyOpen(child)
	          });
	        } else {
	          return child;
	        }
	      }
	    }, {
	      key: 'isInitiallyOpen',
	      value: function isInitiallyOpen(child) {
	        if (child.props.initiallyOpen) {
	          return child.props.initiallyOpen;
	        }
	        return this.hasSelectedDescendant(false, child);
	      }
	    }, {
	      key: 'isChildSelected',
	      value: function isChildSelected(child, props) {
	        return this.getValueLink(props).value === child.props.value;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _props = this.props;
	        var children = _props.children;
	        var selectedItemStyle = _props.selectedItemStyle;
	
	
	        this.keyIndex = 0;
	        var styles = {};
	
	        if (!selectedItemStyle) {
	          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
	          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
	        }
	
	        return _react2.default.createElement(
	          Component,
	          _extends({}, this.props, this.state),
	          _react2.default.Children.map(children, function (child) {
	            return _this3.extendChild(child, styles, selectedItemStyle);
	          })
	        );
	      }
	    }]);
	
	    return _class;
	  }(Component), _class.propTypes = {
	    children: _react.PropTypes.node,
	    onChange: _react.PropTypes.func,
	    selectedItemStyle: _react.PropTypes.object,
	    value: _react.PropTypes.any,
	    valueLink: (0, _deprecatedPropType2.default)(_react.PropTypes.shape({
	      value: _react.PropTypes.any,
	      requestChange: _react.PropTypes.func
	    }), 'This property is deprecated due to his low popularity. Use the value and onChange property.\n        It will be removed with v0.16.0.')
	  }, _class.contextTypes = {
	    muiTheme: _react.PropTypes.object.isRequired
	  }, _temp2;
	};
	
	exports.default = MakeSelectable;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _List = __webpack_require__(92);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var NestedList = function (_Component) {
	  _inherits(NestedList, _Component);
	
	  function NestedList() {
	    _classCallCheck(this, NestedList);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(NestedList).apply(this, arguments));
	  }
	
	  _createClass(NestedList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var open = _props.open;
	      var nestedLevel = _props.nestedLevel;
	      var style = _props.style;
	
	
	      var styles = {
	        root: {
	          display: open ? null : 'none'
	        }
	      };
	
	      return _react2.default.createElement(
	        _List2.default,
	        { style: (0, _simpleAssign2.default)({}, styles.root, style) },
	        _react2.default.Children.map(children, function (child) {
	          return _react2.default.isValidElement(child) ? _react2.default.cloneElement(child, {
	            nestedLevel: nestedLevel + 1
	          }) : child;
	        })
	      );
	    }
	  }]);
	
	  return NestedList;
	}(_react.Component);
	
	NestedList.propTypes = {
	  children: _react.PropTypes.node,
	  nestedLevel: _react.PropTypes.number,
	  open: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	NestedList.defaultProps = {
	  nestedLevel: 1,
	  open: false
	};
	exports.default = NestedList;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MakeSelectable = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(92);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(138);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _MakeSelectable2 = __webpack_require__(249);
	
	var _MakeSelectable3 = _interopRequireDefault(_MakeSelectable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.MakeSelectable = _MakeSelectable3.default;
	exports.default = _List3.default;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(139);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(140);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _Menu3.default;

/***/ },
/* 253 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    _classCallCheck(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  _createClass(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	
	  return HotKeyHolder;
	}();

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(33);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(141);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(413);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(138);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(139);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var leftIndent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'not-allowed' : 'inherit',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? leftIndent : sidePadding,
	      paddingRight: sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  _inherits(MenuItem, _Component);
	
	  function MenuItem() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(MenuItem)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onTouchTap: function onTouchTap(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onTouchTap) {
	            item.props.onTouchTap(event);
	          }
	        },
	        onRequestClose: _this.handleRequestClose
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var checked = _props.checked;
	      var children = _props.children;
	      var desktop = _props.desktop;
	      var disabled = _props.disabled;
	      var focusState = _props.focusState;
	      var innerDivStyle = _props.innerDivStyle;
	      var insetChildren = _props.insetChildren;
	      var leftIcon = _props.leftIcon;
	      var menuItems = _props.menuItems;
	      var rightIcon = _props.rightIcon;
	      var secondaryText = _props.secondaryText;
	      var style = _props.style;
	      var value = _props.value;
	
	      var other = _objectWithoutProperties(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'value']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: { horizontal: 'right', vertical: 'top' },
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onTouchTap = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        _extends({}, other, {
	          disabled: disabled,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.propTypes = {
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _react.PropTypes.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _react.PropTypes.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _react.PropTypes.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _react.PropTypes.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _react.PropTypes.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _react.PropTypes.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _react.PropTypes.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _react.PropTypes.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _react.PropTypes.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _react.PropTypes.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the menu item.
	   */
	  value: _react.PropTypes.any
	};
	MenuItem.defaultProps = {
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false
	};
	MenuItem.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = MenuItem;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded;
	  var circle = props.circle;
	  var transitionEnabled = props.transitionEnabled;
	  var zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var paper = _context$muiTheme.paper;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? '2px' : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  _inherits(Paper, _Component);
	
	  function Paper() {
	    _classCallCheck(this, Paper);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Paper).apply(this, arguments));
	  }
	
	  _createClass(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var circle = _props.circle;
	      var rounded = _props.rounded;
	      var style = _props.style;
	      var transitionEnabled = _props.transitionEnabled;
	      var zDepth = _props.zDepth;
	
	      var other = _objectWithoutProperties(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	
	  return Paper;
	}(_react.Component);
	
	Paper.propTypes = {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Set to true to generate a circlular paper container.
	   */
	  circle: _react.PropTypes.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _react.PropTypes.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes2.default.zDepth
	};
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Paper;

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(24);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverDefaultAnimation = function (_Component) {
	  _inherits(PopoverDefaultAnimation, _Component);
	
	  function PopoverDefaultAnimation() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopoverDefaultAnimation);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PopoverDefaultAnimation)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopoverDefaultAnimation, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var style = _props.style;
	      var zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	
	  return PopoverDefaultAnimation;
	}(_react.Component);
	
	PopoverDefaultAnimation.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin,
	  zDepth: _propTypes2.default.zDepth
	};
	PopoverDefaultAnimation.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverDefaultAnimation.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = PopoverDefaultAnimation;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(24);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes = __webpack_require__(28);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  _inherits(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(PopoverAnimationVertical)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var className = _props.className;
	      var style = _props.style;
	      var zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.propTypes = {
	  children: _react.PropTypes.node,
	  className: _react.PropTypes.string,
	  open: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  targetOrigin: _propTypes2.default.origin,
	  zDepth: _propTypes2.default.zDepth
	};
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = PopoverAnimationVertical;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(34);
	
	var _childUtils = __webpack_require__(69);
	
	var _EnhancedButton = __webpack_require__(52);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(24);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var button = _context$muiTheme.button;
	  var raisedButton = _context$muiTheme.raisedButton;
	  var disabled = props.disabled;
	  var disabledBackgroundColor = props.disabledBackgroundColor;
	  var disabledLabelColor = props.disabledLabelColor;
	  var fullWidth = props.fullWidth;
	  var icon = props.icon;
	  var label = props.label;
	  var labelPosition = props.labelPosition;
	  var primary = props.primary;
	  var secondary = props.secondary;
	  var style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	  var borderRadius = 2;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      position: 'relative',
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  _inherits(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(RaisedButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled && this.state.hovered) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var backgroundColor = _props.backgroundColor;
	      var children = _props.children;
	      var className = _props.className;
	      var disabled = _props.disabled;
	      var fullWidth = _props.fullWidth;
	      var icon = _props.icon;
	      var label = _props.label;
	      var labelPosition = _props.labelPosition;
	      var labelStyle = _props.labelStyle;
	      var primary = _props.primary;
	      var rippleStyle = _props.rippleStyle;
	      var secondary = _props.secondary;
	
	      var other = _objectWithoutProperties(_props, ['backgroundColor', 'children', 'className', 'disabled', 'fullWidth', 'icon', 'label', 'labelPosition', 'labelStyle', 'primary', 'rippleStyle', 'secondary']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var iconCloned = icon && _react2.default.cloneElement(icon, {
	        color: icon.props.color || styles.label.color,
	        style: styles.icon
	      });
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          _extends({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: styles.button,
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles(styles.overlay)
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.propTypes = {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _react.PropTypes.string,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _react.PropTypes.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _react.PropTypes.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _react.PropTypes.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _react.PropTypes.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _react.PropTypes.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _react.PropTypes.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _react.PropTypes.object,
	  /** @ignore */
	  onMouseDown: _react.PropTypes.func,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onMouseUp: _react.PropTypes.func,
	  /** @ignore */
	  onTouchEnd: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _react.PropTypes.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _react.PropTypes.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = RaisedButton;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _keycode = __webpack_require__(53);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(145);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  var error = _react.PropTypes.number(props, propName, componentName);
	  if (error !== null) return error;
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  var error = _react.PropTypes.number(props, propName, componentName);
	  if (error !== null) return error;
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var slider = context.muiTheme.slider;
	
	  var fillGutter = slider.handleSize / 2;
	  var disabledGutter = slider.trackSize + slider.handleSizeDisabled / 2;
	  var calcDisabledSpacing = props.disabled ? ' - ' + disabledGutter + 'px' : '';
	  var axis = props.axis;
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, _defineProperty(_slider, crossAxisProperty[axis], slider.handleSizeActive), _defineProperty(_slider, mainAxisProperty[axis], '100%'), _defineProperty(_slider, 'position', 'relative'), _defineProperty(_slider, 'marginTop', 24), _defineProperty(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, _defineProperty(_track, crossAxisOffsetProperty[axis], (slider.handleSizeActive - slider.trackSize) / 2), _defineProperty(_track, mainAxisOffsetProperty[axis], 0), _defineProperty(_track, mainAxisProperty[axis], '100%'), _defineProperty(_track, crossAxisProperty[axis], slider.trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      position: 'absolute'
	    }, _defineProperty(_filledAndRemaining, crossAxisOffsetProperty, 0), _defineProperty(_filledAndRemaining, crossAxisProperty[axis], '100%'), _defineProperty(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, _defineProperty(_handle, crossAxisOffsetProperty[axis], 0), _defineProperty(_handle, mainAxisOffsetProperty[axis], state.percent === 0 ? '0%' : state.percent * 100 + '%'), _defineProperty(_handle, 'zIndex', 1), _defineProperty(_handle, 'margin', {
	      x: slider.trackSize / 2 + 'px 0 0 0',
	      'x-reverse': slider.trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + slider.trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + slider.trackSize / 2 + 'px'
	    }[props.axis]), _defineProperty(_handle, 'width', slider.handleSize), _defineProperty(_handle, 'height', slider.handleSize), _defineProperty(_handle, 'backgroundColor', slider.selectionColor), _defineProperty(_handle, 'backgroundClip', 'padding-box'), _defineProperty(_handle, 'border', '0px solid transparent'), _defineProperty(_handle, 'borderRadius', '50%'), _defineProperty(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[props.axis]), _defineProperty(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), _defineProperty(_handle, 'overflow', 'visible'), _defineProperty(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: slider.trackColor,
	      width: slider.handleSizeDisabled,
	      height: slider.handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: slider.trackSize + 'px solid ' + slider.handleColorZero,
	      backgroundColor: slider.handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: slider.handleSizeDisabled,
	      height: slider.handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: slider.trackSize + 'px solid ' + slider.trackColorSelected
	    },
	    handleWhenActive: {
	      width: slider.handleSizeActive,
	      height: slider.handleSizeActive
	    },
	    ripple: {
	      height: slider.handleSize,
	      width: slider.handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -slider.trackSize,
	      left: -slider.trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -slider.handleSize,
	      left: -slider.handleSize
	    },
	    rippleColor: {
	      fill: state.percent === 0 ? slider.handleColorZero : slider.rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, _defineProperty(_objectAssign2, mainAxisOffsetProperty[axis], 0), _defineProperty(_objectAssign2, 'backgroundColor', props.disabled ? slider.trackColor : slider.selectionColor), _defineProperty(_objectAssign2, mainAxisMarginFromEnd[axis], fillGutter), _defineProperty(_objectAssign2, mainAxisProperty[axis], 'calc(' + state.percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, _defineProperty(_objectAssign3, reverseMainAxisOffsetProperty[axis], 0), _defineProperty(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !props.disabled ? slider.trackColorSelected : slider.trackColor), _defineProperty(_objectAssign3, mainAxisMarginFromStart[axis], fillGutter), _defineProperty(_objectAssign3, mainAxisProperty[axis], 'calc(' + (1 - state.percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  _inherits(Slider, _Component);
	
	  function Slider() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Slider);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Slider)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      percent: 0,
	      value: 0
	    }, _this.onHandleTouchStart = function (event) {
	      if (document) {
	        document.addEventListener('touchmove', _this.dragTouchHandler, false);
	        document.addEventListener('touchup', _this.dragTouchEndHandler, false);
	        document.addEventListener('touchend', _this.dragTouchEndHandler, false);
	        document.addEventListener('touchcancel', _this.dragTouchEndHandler, false);
	      }
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.onHandleMouseDown = function (event) {
	      if (document) {
	        document.addEventListener('mousemove', _this.dragHandler, false);
	        document.addEventListener('mouseup', _this.dragEndHandler, false);
	
	        // Cancel text selection
	        event.preventDefault();
	
	        // Set focus manually since we called preventDefault()
	        _this.refs.handle.focus();
	      }
	      _this.onDragStart(event);
	    }, _this.onHandleKeyDown = function (event) {
	      var _this$props = _this.props;
	      var axis = _this$props.axis;
	      var min = _this$props.min;
	      var max = _this$props.max;
	      var step = _this$props.step;
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (axis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (axis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (axis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (axis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'home';
	          break;
	        case 'end':
	          action = 'end';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	        var newPercent = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        // When pressing home or end the handle should be taken to the
	        // beginning or end of the track respectively
	        switch (action) {
	          case 'decrease':
	            newValue = Math.max(min, _this.state.value - step);
	            newPercent = (newValue - min) / (max - min);
	            break;
	          case 'increase':
	            newValue = Math.min(max, _this.state.value + step);
	            newPercent = (newValue - min) / (max - min);
	            break;
	          case 'home':
	            newValue = min;
	            newPercent = 0;
	            break;
	          case 'end':
	            newValue = max;
	            newPercent = 1;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            percent: newPercent,
	            value: parseFloat(newValue.toFixed(5))
	          }, function () {
	            if (_this.props.onChange) _this.props.onChange(event, _this.state.value);
	          });
	        }
	      }
	    }, _this.dragHandler = function (event) {
	      if (_this.dragRunning) {
	        return;
	      }
	      _this.dragRunning = true;
	      requestAnimationFrame(function () {
	        var pos = void 0;
	        if (isMouseControlInverted(_this.props.axis)) {
	          pos = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
	        } else {
	          pos = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	        }
	        _this.onDragUpdate(event, pos);
	        _this.dragRunning = false;
	      });
	    }, _this.dragTouchHandler = function (event) {
	      if (_this.dragRunning) {
	        return;
	      }
	      _this.dragRunning = true;
	      requestAnimationFrame(function () {
	        var pos = void 0;
	        if (isMouseControlInverted(_this.props.axis)) {
	          pos = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
	        } else {
	          pos = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	        }
	        _this.onDragUpdate(event, pos);
	        _this.dragRunning = false;
	      });
	    }, _this.dragEndHandler = function (event) {
	      if (document) {
	        document.removeEventListener('mousemove', _this.dragHandler, false);
	        document.removeEventListener('mouseup', _this.dragEndHandler, false);
	      }
	
	      _this.onDragStop(event);
	    }, _this.dragTouchEndHandler = function (event) {
	      if (document) {
	        document.removeEventListener('touchmove', _this.dragTouchHandler, false);
	        document.removeEventListener('touchup', _this.dragTouchEndHandler, false);
	        document.removeEventListener('touchend', _this.dragTouchEndHandler, false);
	        document.removeEventListener('touchcancel', _this.dragTouchEndHandler, false);
	      }
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      if (!_this.props.disabled && !_this.state.dragging) {
	        var pos = void 0;
	        if (isMouseControlInverted(_this.props.axis)) {
	          pos = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
	        } else {
	          pos = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	        }
	        _this.dragTo(event, pos);
	
	        // Since the touch event fired for the track and handle is child of
	        // track, we need to manually propagate the event to the handle.
	        _this.onHandleTouchStart(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.setState({ focused: true });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      if (!_this.props.disabled && !_this.state.dragging) {
	        var pos = void 0;
	        if (isMouseControlInverted(_this.props.axis)) {
	          pos = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
	        } else {
	          pos = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	        }
	        _this.dragTo(event, pos);
	
	        // Since the click event fired for the track and handle is child of
	        // track, we need to manually propagate the event to the handle.
	        _this.onHandleMouseDown(event);
	      }
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ active: false });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hovered: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hovered: false });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var value = this.props.value;
	      if (value === undefined) {
	        value = this.props.defaultValue !== undefined ? this.props.defaultValue : this.props.min;
	      }
	      var percent = (value - this.props.min) / (this.props.max - this.props.min);
	      if (isNaN(percent)) {
	        percent = 0;
	      }
	
	      this.setState({
	        percent: percent,
	        value: value
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        this.setValue(nextProps.value);
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.value;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      // calculate percentage
	      var percent = (value - this.props.min) / (this.props.max - this.props.min);
	      if (isNaN(percent)) percent = 0;
	      // update state
	      this.setState({
	        value: value,
	        percent: percent
	      });
	    }
	  }, {
	    key: 'getPercent',
	    value: function getPercent() {
	      return this.state.percent;
	    }
	  }, {
	    key: 'setPercent',
	    value: function setPercent(percent, callback) {
	      var value = this.alignValue(this.percentToValue(percent));
	      var _props = this.props;
	      var min = _props.min;
	      var max = _props.max;
	
	      var alignedPercent = (value - min) / (max - min);
	      if (this.state.value !== value) {
	        this.setState({ value: value, percent: alignedPercent }, callback);
	      }
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setValue(this.props.min);
	    }
	  }, {
	    key: 'alignValue',
	    value: function alignValue(val) {
	      var _props2 = this.props;
	      var step = _props2.step;
	      var min = _props2.min;
	
	      var alignValue = Math.round((val - min) / step) * step + min;
	      return parseFloat(alignValue.toFixed(5));
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      return this.refs.track.getBoundingClientRect()[mainAxisOffsetProperty[this.props.axis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, pos) {
	      if (!this.state.dragging) {
	        return;
	      }
	      if (!this.props.disabled) {
	        this.dragTo(event, pos);
	      }
	    }
	  }, {
	    key: 'dragTo',
	    value: function dragTo(event, pos) {
	      var max = this.refs.track[mainAxisClientProperty[this.props.axis]];
	      if (pos < 0) {
	        pos = 0;
	      } else if (pos > max) {
	        pos = max;
	      }
	      this.updateWithChangeEvent(event, pos / max);
	    }
	  }, {
	    key: 'updateWithChangeEvent',
	    value: function updateWithChangeEvent(event, percent) {
	      var _this2 = this;
	
	      this.setPercent(percent, function () {
	        if (_this2.props.onChange) {
	          _this2.props.onChange(event, _this2.state.value);
	        }
	      });
	    }
	  }, {
	    key: 'percentToValue',
	    value: function percentToValue(percent) {
	      return percent * (this.props.max - this.props.min) + this.props.min;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var axis = _props3.axis;
	      var description = _props3.description;
	      var disabled = _props3.disabled;
	      var disableFocusRipple = _props3.disableFocusRipple;
	      var error = _props3.error;
	      var max = _props3.max;
	      var min = _props3.min;
	      var name = _props3.name;
	      var onBlur = _props3.onBlur;
	      var onChange = _props3.onChange;
	      var onDragStart = _props3.onDragStart;
	      var onDragStop = _props3.onDragStop;
	      var onFocus = _props3.onFocus;
	      var required = _props3.required;
	      var sliderStyle = _props3.sliderStyle;
	      var step = _props3.step;
	      var style = _props3.style;
	
	      var other = _objectWithoutProperties(_props3, ['axis', 'description', 'disabled', 'disableFocusRipple', 'error', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var handleStyles = {};
	      var percent = this.state.percent;
	      if (percent > 1) {
	        percent = 1;
	      } else if (percent < 0) {
	        percent = 0;
	      }
	
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, this.state.active && styles.handleWhenActive, (this.state.hovered || this.state.focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, this.state.active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      var rippleShowCondition = (this.state.hovered || this.state.focused) && !this.state.active;
	
	      var focusRipple = void 0;
	      if (!disabled && !disableFocusRipple) {
	        focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	          ref: 'focusRipple',
	          key: 'focusRipple',
	          style: rippleStyle,
	          innerStyle: styles.rippleInner,
	          show: rippleShowCondition,
	          muiTheme: this.context.muiTheme,
	          color: styles.rippleColor.fill
	        });
	      }
	
	      var handleDragProps = void 0;
	      if (!disabled) {
	        handleDragProps = {
	          onTouchStart: this.onHandleTouchStart,
	          onMouseDown: this.onHandleMouseDown,
	          onKeyDown: this.onHandleKeyDown
	        };
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'span',
	          null,
	          description
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: 'track', style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              _extends({
	                ref: 'handle',
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              }, handleDragProps),
	              focusRipple
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          ref: 'input',
	          type: 'hidden',
	          name: name,
	          value: this.state.value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	
	  return Slider;
	}(_react.Component);
	
	Slider.propTypes = {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _react.PropTypes.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Describe the slider.
	   */
	  description: _react.PropTypes.string,
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _react.PropTypes.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * An error message for the slider.
	   */
	  error: _react.PropTypes.string,
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the user changes the slider's value.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   */
	  onDragStart: _react.PropTypes.func,
	  /**
	   * Callback function that is fried when the slide has stopped moving.
	   */
	  onDragStop: _react.PropTypes.func,
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _react.PropTypes.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	};
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Slider;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(259);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  _inherits(Step, _Component);
	
	  function Step() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Step)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props;
	      var active = _this$props.active;
	      var completed = _this$props.completed;
	      var disabled = _this$props.disabled;
	      var index = _this$props.index;
	      var last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active = _props.active;
	      var completed = _props.completed;
	      var disabled = _props.disabled;
	      var index = _props.index;
	      var last = _props.last;
	      var children = _props.children;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	
	  return Step;
	}(_react.Component);
	
	Step.propTypes = {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _react.PropTypes.number,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Step.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	exports.default = Step;

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(52);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(144);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper;
	  var backgroundColor = _context$muiTheme$ste.backgroundColor;
	  var hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  _inherits(StepButton, _Component);
	
	  function StepButton() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(StepButton)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active = _props.active;
	      var children = _props.children;
	      var completed = _props.completed;
	      var disabled = _props.disabled;
	      var icon = _props.icon;
	      var last = _props.last;
	      var onMouseEnter = _props.onMouseEnter;
	      var onMouseLeave = _props.onMouseLeave;
	      var onTouchStart = _props.onTouchStart;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        _extends({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon })
	      );
	    }
	  }]);
	
	  return StepButton;
	}(_react.Component);
	
	StepButton.propTypes = {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _react.PropTypes.oneOfType([_react.PropTypes.element, _react.PropTypes.string, _react.PropTypes.number]),
	  /** @ignore */
	  last: _react.PropTypes.bool,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /** @ignore */
	  onTouchStart: _react.PropTypes.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	StepButton.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	exports.default = StepButton;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme;
	  var stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	StepConnector.propTypes = propTypes;
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExpandTransition = __webpack_require__(278);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(27);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  _inherits(StepContent, _Component);
	
	  function StepContent() {
	    _classCallCheck(this, StepContent);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(StepContent).apply(this, arguments));
	  }
	
	  _createClass(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var active = _props.active;
	      var children = _props.children;
	      var completed = _props.completed;
	      var last = _props.last;
	      var style = _props.style;
	      var transition = _props.transition;
	      var transitionDuration = _props.transitionDuration;
	
	      var other = _objectWithoutProperties(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	
	      var _context = this.context;
	      var stepper = _context.stepper;
	      var prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, '<StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        _extends({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	
	  return StepContent;
	}(_react.Component);
	
	StepContent.propTypes = {
	  /**
	   * Expands the content
	   */
	  active: _react.PropTypes.bool,
	  /**
	   * Step content
	   */
	  children: _react.PropTypes.node,
	  /**
	   * @ignore
	   */
	  completed: _react.PropTypes.bool,
	  /**
	   * @ignore
	   */
	  last: _react.PropTypes.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _react.PropTypes.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _react.PropTypes.number
	};
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired,
	  stepper: _react.PropTypes.object
	};
	exports.default = StepContent;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StepConnector = __webpack_require__(263);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  _inherits(Stepper, _Component);
	
	  function Stepper() {
	    _classCallCheck(this, Stepper);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Stepper).apply(this, arguments));
	  }
	
	  _createClass(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var activeStep = _props.activeStep;
	      var children = _props.children;
	      var linear = _props.linear;
	      var style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var steps = _react2.default.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === children.length) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && _react2.default.createElement(_StepConnector2.default, null), _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	
	  return Stepper;
	}(_react.Component);
	
	Stepper.propTypes = {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _react.PropTypes.number,
	  /**
	   * Should be two or more `<Step />` components
	   */
	  children: _react.PropTypes.arrayOf(_react.PropTypes.element),
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _react.PropTypes.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _react.PropTypes.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _react.PropTypes.object
	};
	Stepper.defaultProps = {
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _react.PropTypes.object.isRequired };
	Stepper.childContextTypes = { stepper: _react.PropTypes.object };
	exports.default = Stepper;

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = undefined;
	
	var _Step2 = __webpack_require__(261);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(262);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(264);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(144);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(265);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * If true, the `Subheader` will be indented by `72px`.
	   */
	  inset: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  inset: false
	};
	
	var contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children;
	  var inset = props.inset;
	  var style = props.style;
	
	  var other = _objectWithoutProperties(props, ['children', 'inset', 'style']);
	
	  var _context$muiTheme = context.muiTheme;
	  var prepareStyles = _context$muiTheme.prepareStyles;
	  var subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    _extends({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	Subheader.propTypes = propTypes;
	Subheader.defaultProps = defaultProps;
	Subheader.contextTypes = contextTypes;
	
	exports.default = Subheader;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(267);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SvgIcon = function (_Component) {
	  _inherits(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(SvgIcon)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var color = _props.color;
	      var hoverColor = _props.hoverColor;
	      var onMouseEnter = _props.onMouseEnter;
	      var onMouseLeave = _props.onMouseLeave;
	      var style = _props.style;
	      var viewBox = _props.viewBox;
	
	      var other = _objectWithoutProperties(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	
	      var _context$muiTheme = this.context.muiTheme;
	      var svgIcon = _context$muiTheme.svgIcon;
	      var prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        _extends({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.propTypes = {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _react.PropTypes.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _react.PropTypes.string,
	  /** @ignore */
	  onMouseEnter: _react.PropTypes.func,
	  /** @ignore */
	  onMouseLeave: _react.PropTypes.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _react.PropTypes.string
	};
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = SvgIcon;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(104);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: props.disabled ? 'not-allowed' : 'initial'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'initial'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  _inherits(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(EnhancedTextarea)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(undefined, event);
	    }, _this.handleChange = function (event) {
	      _this.syncHeightWithShadow(event.target.value);
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.syncHeightWithShadow(nextProps.value);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event) {
	      var shadow = this.refs.shadow;
	
	      if (newValue !== undefined) {
	        shadow.value = newValue;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      if (this.props.rowsMax >= this.props.rows) {
	        newHeight = Math.min(this.props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	
	        if (this.props.onHeightChange) {
	          this.props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var onChange = _props.onChange;
	      var onHeightChange = _props.onHeightChange;
	      var rows = _props.rows;
	      var rowsMax = _props.rowsMax;
	      var shadowStyle = _props.shadowStyle;
	      var style = _props.style;
	      var textareaStyle = _props.textareaStyle;
	      var valueLink = _props.valueLink;
	
	      var other = _objectWithoutProperties(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'textareaStyle', 'valueLink']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = this.props.valueLink.value;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value,
	          valueLink: this.props.valueLink
	        }),
	        _react2.default.createElement('textarea', _extends({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.propTypes = {
	  defaultValue: _react.PropTypes.any,
	  disabled: _react.PropTypes.bool,
	  onChange: _react.PropTypes.func,
	  onHeightChange: _react.PropTypes.func,
	  rows: _react.PropTypes.number,
	  rowsMax: _react.PropTypes.number,
	  shadowStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  textareaStyle: _react.PropTypes.object,
	  value: _react.PropTypes.string,
	  valueLink: _react.PropTypes.object
	};
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = EnhancedTextarea;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(53);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _shallowEqual = __webpack_require__(33);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(34);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _deprecatedPropType = __webpack_require__(57);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	var _EnhancedTextarea = __webpack_require__(270);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(272);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(273);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(274);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(27);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var _context$muiTheme$tex = _context$muiTheme.textField;
	  var floatingLabelColor = _context$muiTheme$tex.floatingLabelColor;
	  var focusColor = _context$muiTheme$tex.focusColor;
	  var textColor = _context$muiTheme$tex.textColor;
	  var disabledTextColor = _context$muiTheme$tex.disabledTextColor;
	  var backgroundColor = _context$muiTheme$tex.backgroundColor;
	  var hintColor = _context$muiTheme$tex.hintColor;
	  var errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height')
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: hintColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated style)
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: props.disabled ? 'not-allowed' : 'initial',
	      font: 'inherit'
	    },
	    textarea: {}
	  };
	
	  (0, _simpleAssign2.default)(styles.error, props.errorStyle);
	
	  (0, _simpleAssign2.default)(styles.textarea, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.hasValue) {
	    styles.floatingLabel.color = (0, _colorManipulator.fade)(props.disabled ? disabledTextColor : floatingLabelColor, 0.5);
	  }
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return Boolean(value || value === 0);
	}
	
	var TextField = function (_Component) {
	  _inherits(TextField, _Component);
	
	  function TextField() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(TextField)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false,
	      isClean: true
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) _this.props.onBlur(event);
	    }, _this.handleInputChange = function (event) {
	      _this.setState({ hasValue: isValid(event.target.value), isClean: false });
	      if (_this.props.onChange) _this.props.onChange(event, event.target.value);
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) return;
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) _this.props.onFocus(event);
	    }, _this.handleInputKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'enter' && _this.props.onEnterKeyDown) _this.props.onEnterKeyDown(event);
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props;
	      var children = _props.children;
	      var name = _props.name;
	      var hintText = _props.hintText;
	      var floatingLabelText = _props.floatingLabelText;
	      var id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value) || this.state.isClean && isValid(nextProps.defaultValue);
	
	        if (hasValue !== this.state.hasValue) {
	          this.setState({
	            hasValue: hasValue
	          });
	        }
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) this.getInputNode().blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) this.getInputNode().focus();
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) this.getInputNode().select();
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props;
	      var children = _props2.children;
	      var className = _props2.className;
	      var disabled = _props2.disabled;
	      var errorStyle = _props2.errorStyle;
	      var errorText = _props2.errorText;
	      var floatingLabelFixed = _props2.floatingLabelFixed;
	      var floatingLabelFocusStyle = _props2.floatingLabelFocusStyle;
	      var floatingLabelStyle = _props2.floatingLabelStyle;
	      var floatingLabelText = _props2.floatingLabelText;
	      var fullWidth = _props2.fullWidth;
	      var hintText = _props2.hintText;
	      var hintStyle = _props2.hintStyle;
	      var id = _props2.id;
	      var inputStyle = _props2.inputStyle;
	      var multiLine = _props2.multiLine;
	      var onBlur = _props2.onBlur;
	      var onChange = _props2.onChange;
	      var onFocus = _props2.onFocus;
	      var style = _props2.style;
	      var type = _props2.type;
	      var underlineDisabledStyle = _props2.underlineDisabledStyle;
	      var underlineFocusStyle = _props2.underlineFocusStyle;
	      var underlineShow = _props2.underlineShow;
	      var underlineStyle = _props2.underlineStyle;
	      var rows = _props2.rows;
	      var rowsMax = _props2.rowsMax;
	      var textareaStyle = _props2.textareaStyle;
	
	      var other = _objectWithoutProperties(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.error) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, this.props.floatingLabelStyle),
	          shrinkStyle: this.props.floatingLabelFocusStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus,
	        onKeyDown: this.handleInputKeyDown
	      };
	
	      var inputStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, _extends({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(inputStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, _extends({}, other, inputProps, {
	          style: inputStyleMerged,
	          rows: rows,
	          rowsMax: rowsMax,
	          onHeightChange: this.handleHeightChange,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, textareaStyle)
	        })) : _react2.default.createElement('input', _extends({}, other, inputProps, {
	          style: prepareStyles(inputStyleMerged),
	          type: type
	        }));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	
	  return TextField;
	}(_react.Component);
	
	TextField.propTypes = {
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _react.PropTypes.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _react.PropTypes.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _react.PropTypes.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _react.PropTypes.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _react.PropTypes.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _react.PropTypes.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _react.PropTypes.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _react.PropTypes.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _react.PropTypes.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _react.PropTypes.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _react.PropTypes.string,
	  /** @ignore */
	  onBlur: _react.PropTypes.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   */
	  onChange: _react.PropTypes.func,
	  /**
	   * The function to call when the user presses the Enter key.
	   */
	  onEnterKeyDown: (0, _deprecatedPropType2.default)(_react.PropTypes.func, 'Use onKeyDown and check for keycode instead. It will be removed with v0.16.0.'),
	  /** @ignore */
	  onFocus: _react.PropTypes.func,
	  /** @ignore */
	  onKeyDown: _react.PropTypes.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _react.PropTypes.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _react.PropTypes.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _react.PropTypes.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _react.PropTypes.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _react.PropTypes.object,
	  /**
	   * The value of the text field.
	   */
	  value: _react.PropTypes.any
	};
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TextField;

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor;
	  var show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles;
	  var style = props.style;
	  var text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	TextFieldHint.propTypes = {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _react.PropTypes.node
	};
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    cursor: props.disabled ? 'not-allowed' : 'text',
	    transform: 'scale(1) translate3d(0, 0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'perspective(1px) scale(0.75) translate3d(0, -28px, 0)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme;
	  var className = props.className;
	  var children = props.children;
	  var htmlFor = props.htmlFor;
	  var onTouchTap = props.onTouchTap;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onTouchTap: onTouchTap
	    },
	    children
	  );
	};
	
	TextFieldLabel.propTypes = {
	  /**
	   * The label contents.
	   */
	  children: _react.PropTypes.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _react.PropTypes.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   */
	  onTouchTap: _react.PropTypes.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element when focused.
	   */
	  shrinkStyle: _react.PropTypes.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _react.PropTypes.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _react.PropTypes.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _react.PropTypes.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled;
	  var disabledStyle = props.disabledStyle;
	  var error = props.error;
	  var errorStyle = props.errorStyle;
	  var focus = props.focus;
	  var focusStyle = props.focusStyle;
	  var muiTheme = props.muiTheme;
	  var style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles;
	  var _muiTheme$textField = muiTheme.textField;
	  var borderColor = _muiTheme$textField.borderColor;
	  var disabledTextColor = _muiTheme$textField.disabledTextColor;
	  var errorColor = _muiTheme$textField.errorColor;
	  var focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      border: 'none',
	      borderBottom: 'solid 1px',
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottom: 'dotted 2px',
	      borderColor: disabledTextColor,
	      cursor: 'not-allowed'
	    },
	    focus: {
	      borderBottom: 'solid 2px',
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { style: prepareStyles(focusedUnderline) })
	  );
	};
	
	TextFieldUnderline.propTypes = propTypes;
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  _inherits(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(AutoLockScrolling)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.locked = false, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) this.preventScrolling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) return;
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return AutoLockScrolling;
	}(_react.Component);
	
	AutoLockScrolling.propTypes = {
	  lock: _react.PropTypes.bool.isRequired
	};
	exports.default = AutoLockScrolling;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(33);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(56);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CircleRipple = function (_Component) {
	  _inherits(CircleRipple, _Component);
	
	  function CircleRipple() {
	    _classCallCheck(this, CircleRipple);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(CircleRipple).apply(this, arguments));
	  }
	
	  _createClass(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var aborted = _props.aborted;
	      var color = _props.color;
	      var opacity = _props.opacity;
	      var style = _props.style;
	      var touchGenerated = _props.touchGenerated;
	
	      var other = _objectWithoutProperties(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', _extends({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.propTypes = {
	  aborted: _react.PropTypes.bool,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  touchGenerated: _react.PropTypes.bool
	};
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = CircleRipple;

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(167);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  _inherits(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(ClickAwayListener)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return ClickAwayListener;
	}(_react.Component);
	
	ClickAwayListener.propTypes = {
	  children: _react.PropTypes.node,
	  onClickAway: _react.PropTypes.any
	};
	exports.default = ClickAwayListener;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(68);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(279);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ExpandTransition = function (_Component) {
	  _inherits(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    _classCallCheck(this, ExpandTransition);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ExpandTransition).apply(this, arguments));
	  }
	
	  _createClass(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props;
	      var enterDelay = _props.enterDelay;
	      var transitionDelay = _props.transitionDelay;
	      var transitionDuration = _props.transitionDuration;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props;
	      var children = _props2.children;
	      var enterDelay = _props2.enterDelay;
	      var loading = _props2.loading;
	      var open = _props2.open;
	      var style = _props2.style;
	      var transitionDelay = _props2.transitionDelay;
	      var transitionDuration = _props2.transitionDuration;
	
	      var other = _objectWithoutProperties(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        _extends({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  loading: _react.PropTypes.bool,
	  open: _react.PropTypes.bool,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	};
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ExpandTransition;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  _inherits(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    _classCallCheck(this, ExpandTransitionChild);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ExpandTransitionChild).apply(this, arguments));
	  }
	
	  _createClass(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props;
	      var enterDelay = _props.enterDelay;
	      var transitionDelay = _props.transitionDelay;
	      var transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props;
	      var transitionDelay = _props2.transitionDelay;
	      var transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this);
	
	      var style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props;
	      var children = _props3.children;
	      var enterDelay = _props3.enterDelay;
	      var style = _props3.style;
	      var transitionDelay = _props3.transitionDelay;
	      var transitionDuration = _props3.transitionDuration;
	
	      var other = _objectWithoutProperties(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  style: _react.PropTypes.object,
	  transitionDelay: _react.PropTypes.number,
	  transitionDuration: _react.PropTypes.number
	};
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ExpandTransitionChild;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(275);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  _inherits(Overlay, _Component);
	
	  function Overlay() {
	    _classCallCheck(this, Overlay);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(Overlay).apply(this, arguments));
	  }
	
	  _createClass(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var autoLockScrolling = _props.autoLockScrolling;
	      var show = _props.show;
	      var style = _props.style;
	      var transitionEnabled = _props.transitionEnabled;
	
	      var other = _objectWithoutProperties(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	
	  return Overlay;
	}(_react.Component);
	
	Overlay.propTypes = {
	  autoLockScrolling: _react.PropTypes.bool,
	  show: _react.PropTypes.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  transitionEnabled: _react.PropTypes.bool
	};
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Overlay;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsTransitionGroup = __webpack_require__(68);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ScaleInChild = __webpack_require__(282);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScaleIn = function (_Component) {
	  _inherits(ScaleIn, _Component);
	
	  function ScaleIn() {
	    _classCallCheck(this, ScaleIn);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ScaleIn).apply(this, arguments));
	  }
	
	  _createClass(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var childStyle = _props.childStyle;
	      var enterDelay = _props.enterDelay;
	      var maxScale = _props.maxScale;
	      var minScale = _props.minScale;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        _extends({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.propTypes = {
	  childStyle: _react.PropTypes.object,
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object
	};
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ScaleIn;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(56);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ScaleInChild = function (_Component) {
	  _inherits(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    _classCallCheck(this, ScaleInChild);
	
	    return _possibleConstructorReturn(this, Object.getPrototypeOf(ScaleInChild).apply(this, arguments));
	  }
	
	  _createClass(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var enterDelay = _props.enterDelay;
	      var maxScale = _props.maxScale;
	      var minScale = _props.minScale;
	      var style = _props.style;
	
	      var other = _objectWithoutProperties(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.propTypes = {
	  children: _react.PropTypes.node,
	  enterDelay: _react.PropTypes.number,
	  maxScale: _react.PropTypes.number,
	  minScale: _react.PropTypes.number,
	  style: _react.PropTypes.object
	};
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = ScaleInChild;

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _transitions = __webpack_require__(6);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme;
	  var baseTheme = _context$muiTheme.baseTheme;
	  var zIndex = _context$muiTheme.zIndex;
	  var tooltip = _context$muiTheme.tooltip;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: 2,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: 0.9,
	      transform: 'translate3d(0px, ' + offset + 'px, 0px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  _inherits(Tooltip, _Component);
	
	  function Tooltip() {
	    var _Object$getPrototypeO;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Tooltip)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var horizontalPosition = _props.horizontalPosition;
	      var label = _props.label;
	      var show = _props.show;
	      var touch = _props.touch;
	      var verticalPosition = _props.verticalPosition;
	
	      var other = _objectWithoutProperties(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        _extends({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _react.PropTypes.string,
	  horizontalPosition: _react.PropTypes.oneOf(['left', 'right', 'center']),
	  label: _react.PropTypes.node.isRequired,
	  show: _react.PropTypes.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _react.PropTypes.object,
	  touch: _react.PropTypes.bool,
	  verticalPosition: _react.PropTypes.oneOf(['top', 'bottom'])
	};
	Tooltip.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = Tooltip;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _simpleAssign = __webpack_require__(2);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsTransitionGroup = __webpack_require__(68);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _dom = __webpack_require__(166);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(276);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _toArray(arr) { return Array.isArray(arr) ? arr : Array.from(arr); }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = _toArray(_ref);
	
	  var newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  _inherits(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    _classCallCheck(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	
	    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(TouchRipple).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat(_toConsumableArray(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  _createClass(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat(_toConsumableArray(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var style = {};
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      style.height = rippleSize + 'px';
	      style.width = rippleSize + 'px';
	      style.top = top + 'px';
	      style.left = left + 'px';
	
	      return style;
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props;
	      var children = _props.children;
	      var style = _props.style;
	      var _state = this.state;
	      var hasRipples = _state.hasRipples;
	      var ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden'
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.propTypes = {
	  abortOnScroll: _react.PropTypes.bool,
	  centerRipple: _react.PropTypes.bool,
	  children: _react.PropTypes.node,
	  color: _react.PropTypes.string,
	  opacity: _react.PropTypes.number,
	  style: _react.PropTypes.object
	};
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _react.PropTypes.object.isRequired
	};
	exports.default = TouchRipple;

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	// special flexbox specifications
	
	
	var _prefixAll2 = __webpack_require__(304);
	
	var _prefixAll3 = _interopRequireDefault(_prefixAll2);
	
	var _getBrowserInformation = __webpack_require__(305);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(306);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(60);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _prefixProps = __webpack_require__(295);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _calc = __webpack_require__(286);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _zoomCursor = __webpack_require__(294);
	
	var _zoomCursor2 = _interopRequireDefault(_zoomCursor);
	
	var _grabCursor = __webpack_require__(290);
	
	var _grabCursor2 = _interopRequireDefault(_grabCursor);
	
	var _flex = __webpack_require__(287);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(292);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(291);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(293);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(288);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(289);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var plugins = [_calc2.default, _zoomCursor2.default, _grabCursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default,
	// this must be run AFTER the flexbox specs
	_flex2.default];
	
	var Prefixer = function () {
	  /**
	   * Instantiante a new prefixer
	   * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	   * @param {string} keepUnprefixed - keeps unprefixed properties and values
	   */
	
	  function Prefixer() {
	    var _this = this;
	
	    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    _classCallCheck(this, Prefixer);
	
	    var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	    this._userAgent = options.userAgent || defaultUserAgent;
	    this._keepUnprefixed = options.keepUnprefixed || false;
	
	    this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	
	    // Checks if the userAgent was resolved correctly
	    if (this._browserInfo && this._browserInfo.prefix) {
	      // set additional prefix information
	      this.cssPrefix = this._browserInfo.prefix.css;
	      this.jsPrefix = this._browserInfo.prefix.inline;
	      this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo);
	    } else {
	      this._usePrefixAllFallback = true;
	      return false;
	    }
	
	    var data = this._browserInfo.browser && _prefixProps2.default[this._browserInfo.browser];
	    if (data) {
	      this._requiresPrefix = Object.keys(data).filter(function (key) {
	        return data[key] >= _this._browserInfo.version;
	      }).reduce(function (result, name) {
	        result[name] = true;
	        return result;
	      }, {});
	      this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	    } else {
	      this._usePrefixAllFallback = true;
	    }
	  }
	
	  /**
	   * Returns a prefixed version of the style object
	   * @param {Object} styles - Style object that gets prefixed properties added
	   * @returns {Object} - Style object with prefixed properties and values
	   */
	
	
	  _createClass(Prefixer, [{
	    key: 'prefix',
	    value: function prefix(styles) {
	      var _this2 = this;
	
	      // use prefixAll as fallback if userAgent can not be resolved
	      if (this._usePrefixAllFallback) {
	        return (0, _prefixAll3.default)(styles);
	      }
	
	      // only add prefixes if needed
	      if (!this._hasPropsRequiringPrefix) {
	        return styles;
	      }
	
	      Object.keys(styles).forEach(function (property) {
	        var value = styles[property];
	        if (value instanceof Object && !Array.isArray(value)) {
	          // recurse through nested style objects
	          styles[property] = _this2.prefix(value);
	        } else {
	          // add prefixes if needed
	          if (_this2._requiresPrefix[property]) {
	            styles[_this2.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	            if (!_this2._keepUnprefixed) {
	              delete styles[property];
	            }
	          }
	        }
	      });
	
	      Object.keys(styles).forEach(function (property) {
	        [].concat(styles[property]).forEach(function (value) {
	          // resolve plugins
	          plugins.forEach(function (plugin) {
	            // generates a new plugin interface with current data
	            assignStyles(styles, plugin({
	              property: property,
	              value: value,
	              styles: styles,
	              browserInfo: _this2._browserInfo,
	              prefix: {
	                js: _this2.jsPrefix,
	                css: _this2.cssPrefix,
	                keyframes: _this2.prefixedKeyframes
	              },
	              keepUnprefixed: _this2._keepUnprefixed,
	              requiresPrefix: _this2._requiresPrefix
	            }), value, _this2._keepUnprefixed);
	          });
	        });
	      });
	
	      return styles;
	    }
	
	    /**
	     * Returns a prefixed version of the style object using all vendor prefixes
	     * @param {Object} styles - Style object that gets prefixed properties added
	     * @returns {Object} - Style object with prefixed properties and values
	     */
	
	  }], [{
	    key: 'prefixAll',
	    value: function prefixAll(styles) {
	      return (0, _prefixAll3.default)(styles);
	    }
	  }]);
	
	  return Prefixer;
	}();
	
	exports.default = Prefixer;
	
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	  var value = arguments[2];
	  var keepUnprefixed = arguments[3];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (val) {
	        if (base[property].indexOf(val) === -1) {
	          base[property].splice(baseValue.indexOf(value), keepUnprefixed ? 0 : 1, val);
	        }
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(26);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function calc(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browser === 'firefox' && version < 15 || browser === 'chrome' && version < 25 || browser === 'safari' && version < 6.1 || browser === 'ios_saf' && version < 7)) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, css + 'calc('), value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(26);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { flex: true, 'inline-flex': true };
	
	function flex(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browser === 'chrome' && version < 29 && version > 20 || (browser === 'safari' || browser === 'ios_saf') && version < 9 && version > 6 || browser === 'opera' && (version == 15 || version == 16))) {
	    return {
	      display: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(26);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((alternativeProps[property] || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'ie_mob' || browser === 'ie') && version == 10) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(26);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var styles = _ref.styles;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browser === 'firefox' && version < 22 || browser === 'chrome' && version < 21 || (browser === 'safari' || browser === 'ios_saf') && version <= 6.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    if (!keepUnprefixed && !Array.isArray(styles[property])) {
	      delete styles[property];
	    }
	    if (property === 'flexDirection') {
	      return {
	        WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	        WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	      };
	    }
	    if (property === 'display' && alternativeValues[value]) {
	      return {
	        display: (0, _getPrefixedValue2.default)(css + alternativeValues[value], value, keepUnprefixed)
	      };
	    }
	    if (alternativeProps[property]) {
	      return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = grabCursor;
	
	var _getPrefixedValue = __webpack_require__(26);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { grab: true, grabbing: true };
	
	function grabCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // adds prefixes for firefox, chrome, safari, and opera regardless of version until a reliable brwoser support info can be found (see: https://github.com/rofrischmann/inline-style-prefixer/issues/79)
	  if (property === 'cursor' && values[value] && (browser === 'firefox' || browser === 'chrome' || browser === 'safari' || browser === 'opera')) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(26);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.match(values) !== null && (browser === 'firefox' && version < 16 || browser === 'chrome' && version < 26 || (browser === 'safari' || browser === 'ios_saf') && version < 7 || (browser === 'opera' || browser === 'op_mini') && version < 12.1 || browser === 'android' && version < 4.4 || browser === 'and_uc')) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(26);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties[property] && values[value]) {
	    return _defineProperty({}, property, (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed));
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(148);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(60);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _unprefixProperty = __webpack_require__(307);
	
	var _unprefixProperty2 = _interopRequireDefault(_unprefixProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = { transition: true, transitionProperty: true };
	
	function transition(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var css = _ref.prefix.css;
	  var requiresPrefix = _ref.requiresPrefix;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  // also check for already prefixed transitions
	  var unprefixedProperty = (0, _unprefixProperty2.default)(property);
	
	  if (typeof value === 'string' && properties[unprefixedProperty]) {
	    var _ret = function () {
	      // TODO: memoize this array
	      var requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateStyleName2.default)(prop);
	      });
	
	      // only split multi values, not cubic beziers
	      var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	      requiresPrefixDashCased.forEach(function (prop) {
	        multipleValues.forEach(function (val, index) {
	          if (val.indexOf(prop) > -1 && prop !== 'order') {
	            multipleValues[index] = val.replace(prop, css + prop) + (keepUnprefixed ? ',' + val : '');
	          }
	        });
	      });
	
	      return {
	        v: _defineProperty({}, property, multipleValues.join(','))
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = zoomCursor;
	
	var _getPrefixedValue = __webpack_require__(26);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = { 'zoom-in': true, 'zoom-out': true };
	
	function zoomCursor(_ref) {
	  var property = _ref.property;
	  var value = _ref.value;
	  var _ref$browserInfo = _ref.browserInfo;
	  var browser = _ref$browserInfo.browser;
	  var version = _ref$browserInfo.version;
	  var css = _ref.prefix.css;
	  var keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'cursor' && values[value] && (browser === 'firefox' && version < 24 || browser === 'chrome' && version < 37 || browser === 'safari' && version < 9 || browser === 'opera' && version < 24)) {
	    return {
	      cursor: (0, _getPrefixedValue2.default)(css + value, value, keepUnprefixed)
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 295 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 54, "userSelect": 54, "fontKerning": 32, "textEmphasisPosition": 54, "textEmphasis": 54, "textEmphasisStyle": 54, "textEmphasisColor": 54, "boxDecorationBreak": 54, "clipPath": 54, "maskImage": 54, "maskMode": 54, "maskRepeat": 54, "maskPosition": 54, "maskClip": 54, "maskOrigin": 54, "maskSize": 54, "maskComposite": 54, "mask": 54, "maskBorderSource": 54, "maskBorderMode": 54, "maskBorderSlice": 54, "maskBorderWidth": 54, "maskBorderOutset": 54, "maskBorderRepeat": 54, "maskBorder": 54, "maskType": 54, "textDecorationStyle": 54, "textDecorationSkip": 54, "textDecorationLine": 54, "textDecorationColor": 54, "filter": 54, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 50, "userSelect": 50, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 50, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 50, "breakBefore": 50, "breakInside": 50, "columnCount": 50, "columnFill": 50, "columnGap": 50, "columnRule": 50, "columnRuleColor": 50, "columnRuleStyle": 50, "columnRuleWidth": 50, "columns": 50, "columnSpan": 50, "columnWidth": 50 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 40, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 40, "textEmphasis": 40, "textEmphasisStyle": 40, "textEmphasisColor": 40, "boxDecorationBreak": 40, "clipPath": 40, "maskImage": 40, "maskMode": 40, "maskRepeat": 40, "maskPosition": 40, "maskClip": 40, "maskOrigin": 40, "maskSize": 40, "maskComposite": 40, "mask": 40, "maskBorderSource": 40, "maskBorderMode": 40, "maskBorderSlice": 40, "maskBorderWidth": 40, "maskBorderOutset": 40, "maskBorderRepeat": 40, "maskBorder": 40, "maskType": 40, "textDecorationStyle": 40, "textDecorationSkip": 40, "textDecorationLine": 40, "textDecorationColor": 40, "filter": 40, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 14, "wrapFlow": 14, "wrapThrough": 14, "wrapMargin": 14, "scrollSnapType": 14, "scrollSnapPointsX": 14, "scrollSnapPointsY": 14, "scrollSnapDestination": 14, "scrollSnapCoordinate": 14, "hyphens": 14, "flowInto": 14, "flowFrom": 14, "breakBefore": 14, "breakAfter": 14, "breakInside": 14, "regionFragment": 14, "gridTemplateColumns": 14, "gridTemplateRows": 14, "gridTemplateAreas": 14, "gridTemplate": 14, "gridAutoColumns": 14, "gridAutoRows": 14, "gridAutoFlow": 14, "grid": 14, "gridRowStart": 14, "gridColumnStart": 14, "gridRowEnd": 14, "gridRow": 14, "gridColumn": 14, "gridColumnEnd": 14, "gridColumnGap": 14, "gridRowGap": 14, "gridArea": 14, "gridGap": 14 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 9.3, "userSelect": 9.3, "backdropFilter": 9.3, "fontKerning": 9.3, "scrollSnapType": 9.3, "scrollSnapPointsX": 9.3, "scrollSnapPointsY": 9.3, "scrollSnapDestination": 9.3, "scrollSnapCoordinate": 9.3, "boxDecorationBreak": 9.3, "clipPath": 9.3, "maskImage": 9.3, "maskMode": 9.3, "maskRepeat": 9.3, "maskPosition": 9.3, "maskClip": 9.3, "maskOrigin": 9.3, "maskSize": 9.3, "maskComposite": 9.3, "mask": 9.3, "maskBorderSource": 9.3, "maskBorderMode": 9.3, "maskBorderSlice": 9.3, "maskBorderWidth": 9.3, "maskBorderOutset": 9.3, "maskBorderRepeat": 9.3, "maskBorder": 9.3, "maskType": 9.3, "textSizeAdjust": 9.3, "textDecorationStyle": 9.3, "textDecorationSkip": 9.3, "textDecorationLine": 9.3, "textDecorationColor": 9.3, "shapeImageThreshold": 9.3, "shapeImageMargin": 9.3, "shapeImageOutside": 9.3, "filter": 9, "hyphens": 9.3, "flowInto": 9.3, "flowFrom": 9.3, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 9.3, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 50, "userSelect": 50, "fontKerning": 4.4, "textEmphasisPosition": 50, "textEmphasis": 50, "textEmphasisStyle": 50, "textEmphasisColor": 50, "boxDecorationBreak": 50, "clipPath": 50, "maskImage": 50, "maskMode": 50, "maskRepeat": 50, "maskPosition": 50, "maskClip": 50, "maskOrigin": 50, "maskSize": 50, "maskComposite": 50, "mask": 50, "maskBorderSource": 50, "maskBorderMode": 50, "maskBorderSlice": 50, "maskBorderWidth": 50, "maskBorderOutset": 50, "maskBorderRepeat": 50, "maskBorder": 50, "maskType": 50, "filter": 50, "fontFeatureSettings": 4.4, "breakAfter": 50, "breakBefore": 50, "breakInside": 50, "columnCount": 50, "columnFill": 50, "columnGap": 50, "columnRule": 50, "columnRuleColor": 50, "columnRuleStyle": 50, "columnRuleWidth": 50, "columns": 50, "columnSpan": 50, "columnWidth": 50 }, "and_chr": { "appearance": 50, "userSelect": 50, "textEmphasisPosition": 50, "textEmphasis": 50, "textEmphasisStyle": 50, "textEmphasisColor": 50, "boxDecorationBreak": 50, "clipPath": 50, "maskImage": 50, "maskMode": 50, "maskRepeat": 50, "maskPosition": 50, "maskClip": 50, "maskOrigin": 50, "maskSize": 50, "maskComposite": 50, "mask": 50, "maskBorderSource": 50, "maskBorderMode": 50, "maskBorderSlice": 50, "maskBorderWidth": 50, "maskBorderOutset": 50, "maskBorderRepeat": 50, "maskBorder": 50, "maskType": 50, "textDecorationStyle": 50, "textDecorationSkip": 50, "textDecorationLine": 50, "textDecorationColor": 50, "filter": 50, "fontFeatureSettings": 50 }, "and_uc": { "flex": 9.9, "flexBasis": 9.9, "flexDirection": 9.9, "flexGrow": 9.9, "flexFlow": 9.9, "flexShrink": 9.9, "flexWrap": 9.9, "alignContent": 9.9, "alignItems": 9.9, "alignSelf": 9.9, "justifyContent": 9.9, "order": 9.9, "transition": 9.9, "transitionDelay": 9.9, "transitionDuration": 9.9, "transitionProperty": 9.9, "transitionTimingFunction": 9.9, "transform": 9.9, "transformOrigin": 9.9, "transformOriginX": 9.9, "transformOriginY": 9.9, "backfaceVisibility": 9.9, "perspective": 9.9, "perspectiveOrigin": 9.9, "transformStyle": 9.9, "transformOriginZ": 9.9, "animation": 9.9, "animationDelay": 9.9, "animationDirection": 9.9, "animationFillMode": 9.9, "animationDuration": 9.9, "animationIterationCount": 9.9, "animationName": 9.9, "animationPlayState": 9.9, "animationTimingFunction": 9.9, "appearance": 9.9, "userSelect": 9.9, "fontKerning": 9.9, "textEmphasisPosition": 9.9, "textEmphasis": 9.9, "textEmphasisStyle": 9.9, "textEmphasisColor": 9.9, "maskImage": 9.9, "maskMode": 9.9, "maskRepeat": 9.9, "maskPosition": 9.9, "maskClip": 9.9, "maskOrigin": 9.9, "maskSize": 9.9, "maskComposite": 9.9, "mask": 9.9, "maskBorderSource": 9.9, "maskBorderMode": 9.9, "maskBorderSlice": 9.9, "maskBorderWidth": 9.9, "maskBorderOutset": 9.9, "maskBorderRepeat": 9.9, "maskBorder": 9.9, "maskType": 9.9, "textSizeAdjust": 9.9, "filter": 9.9, "hyphens": 9.9, "flowInto": 9.9, "flowFrom": 9.9, "breakBefore": 9.9, "breakAfter": 9.9, "breakInside": 9.9, "regionFragment": 9.9, "fontFeatureSettings": 9.9, "columnCount": 9.9, "columnFill": 9.9, "columnGap": 9.9, "columnRule": 9.9, "columnRuleColor": 9.9, "columnRuleStyle": 9.9, "columnRuleWidth": 9.9, "columns": 9.9, "columnSpan": 9.9, "columnWidth": 9.9 }, "op_mini": { "borderImage": 5, "borderImageOutset": 5, "borderImageRepeat": 5, "borderImageSlice": 5, "borderImageSource": 5, "borderImageWidth": 5, "tabSize": 5, "objectFit": 5, "objectPosition": 5 } };
	module.exports = exports["default"];

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _joinPrefixedValue = __webpack_require__(61);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(94);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return (0, _joinPrefixedValue2.default)(property, value, function (prefix, value) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = cursor;
	
	var _joinPrefixedValue = __webpack_require__(61);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  'zoom-in': true,
	  'zoom-out': true,
	  grab: true,
	  grabbing: true
	};
	
	function cursor(property, value) {
	  if (property === 'cursor' && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 298 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = { flex: true, 'inline-flex': true };
	
	function flex(property, value) {
	  if (property === 'display' && values[value]) {
	    return {
	      display: ['-webkit-box', '-moz-box', '-ms-' + value + 'box', '-webkit-' + value, value]
	    };
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 299 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msPreferredSize'
	};
	
	function flexboxIE(property, value) {
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 300 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value) {
	  if (property === 'flexDirection') {
	    return {
	      WebkitBoxOrient: value.indexOf('column') > -1 ? 'vertical' : 'horizontal',
	      WebkitBoxDirection: value.indexOf('reverse') > -1 ? 'reverse' : 'normal'
	    };
	  }
	  if (alternativeProps[property]) {
	    return _defineProperty({}, alternativeProps[property], alternativeValues[value] || value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _joinPrefixedValue = __webpack_require__(61);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	var _isPrefixedValue = __webpack_require__(94);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.match(values) !== null) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _joinPrefixedValue = __webpack_require__(61);
	
	var _joinPrefixedValue2 = _interopRequireDefault(_joinPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties[property] && values[value]) {
	    return (0, _joinPrefixedValue2.default)(property, value);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateStyleName = __webpack_require__(148);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	var _capitalizeString = __webpack_require__(60);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _isPrefixedValue = __webpack_require__(94);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _prefixProps = __webpack_require__(147);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true
	};
	
	function transition(property, value) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties[property]) {
	    var _ref2;
	
	    var outputValue = prefixValue(value);
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (value) {
	      return value.match(/-moz-|-ms-/) === null;
	    }).join(',');
	
	    // if the property is already prefixed
	    if (property.indexOf('Webkit') > -1) {
	      return _defineProperty({}, property, webkitOutput);
	    }
	
	    return _ref2 = {}, _defineProperty(_ref2, 'Webkit' + (0, _capitalizeString2.default)(property), webkitOutput), _defineProperty(_ref2, property, outputValue), _ref2;
	  }
	}
	
	function prefixValue(value) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  // iterate each single value and check for transitioned properties
	  // that need to be prefixed as well
	  multipleValues.forEach(function (val, index) {
	    multipleValues[index] = Object.keys(_prefixProps2.default).reduce(function (out, prefix) {
	      var dashCasePrefix = '-' + prefix.toLowerCase() + '-';
	
	      Object.keys(_prefixProps2.default[prefix]).forEach(function (prop) {
	        var dashCaseProperty = (0, _hyphenateStyleName2.default)(prop);
	
	        if (val.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	          // join all prefixes and create a new value
	          out = val.replace(dashCaseProperty, dashCasePrefix + dashCaseProperty) + ',' + out;
	        }
	      });
	      return out;
	    }, val);
	  });
	
	  return multipleValues.join(',');
	}
	module.exports = exports['default'];

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixAll;
	
	var _prefixProps = __webpack_require__(147);
	
	var _prefixProps2 = _interopRequireDefault(_prefixProps);
	
	var _capitalizeString = __webpack_require__(60);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _calc = __webpack_require__(296);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _cursor = __webpack_require__(297);
	
	var _cursor2 = _interopRequireDefault(_cursor);
	
	var _flex = __webpack_require__(298);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _sizing = __webpack_require__(302);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _gradient = __webpack_require__(301);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _transition = __webpack_require__(303);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	var _flexboxIE = __webpack_require__(299);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(300);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// special flexbox specifications
	
	
	var plugins = [_calc2.default, _cursor2.default, _sizing2.default, _gradient2.default, _transition2.default, _flexboxIE2.default, _flexboxOld2.default, _flex2.default];
	
	/**
	 * Returns a prefixed version of the style object using all vendor prefixes
	 * @param {Object} styles - Style object that gets prefixed properties added
	 * @returns {Object} - Style object with prefixed properties and values
	 */
	function prefixAll(styles) {
	  Object.keys(styles).forEach(function (property) {
	    var value = styles[property];
	    if (value instanceof Object && !Array.isArray(value)) {
	      // recurse through nested style objects
	      styles[property] = prefixAll(value);
	    } else {
	      Object.keys(_prefixProps2.default).forEach(function (prefix) {
	        var properties = _prefixProps2.default[prefix];
	        // add prefixes if needed
	        if (properties[property]) {
	          styles[prefix + (0, _capitalizeString2.default)(property)] = value;
	        }
	      });
	    }
	  });
	
	  Object.keys(styles).forEach(function (property) {
	    [].concat(styles[property]).forEach(function (value, index) {
	      // resolve every special plugins
	      plugins.forEach(function (plugin) {
	        return assignStyles(styles, plugin(property, value));
	      });
	    });
	  });
	
	  return styles;
	}
	
	function assignStyles(base) {
	  var extend = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];
	
	  Object.keys(extend).forEach(function (property) {
	    var baseValue = base[property];
	    if (Array.isArray(baseValue)) {
	      [].concat(extend[property]).forEach(function (value) {
	        var valueIndex = baseValue.indexOf(value);
	        if (valueIndex > -1) {
	          base[property].splice(valueIndex, 1);
	        }
	        base[property].push(value);
	      });
	    } else {
	      base[property] = extend[property];
	    }
	  });
	}
	module.exports = exports['default'];

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _bowser = __webpack_require__(308);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var vendorPrefixes = {
	  Webkit: ['chrome', 'safari', 'ios', 'android', 'phantom', 'opera', 'webos', 'blackberry', 'bada', 'tizen', 'chromium', 'vivaldi'],
	  Moz: ['firefox', 'seamonkey', 'sailfish'],
	  ms: ['msie', 'msedge']
	};
	
	var browsers = {
	  chrome: [['chrome'], ['chromium']],
	  safari: [['safari']],
	  firefox: [['firefox']],
	  ie: [['msie']],
	  edge: [['msedge']],
	  opera: [['opera'], ['vivaldi']],
	  ios_saf: [['ios', 'mobile'], ['ios', 'tablet']],
	  ie_mob: [['windowsphone', 'mobile', 'msie'], ['windowsphone', 'tablet', 'msie'], ['windowsphone', 'mobile', 'msedge'], ['windowsphone', 'tablet', 'msedge']],
	  op_mini: [['opera', 'mobile'], ['opera', 'tablet']],
	  and_uc: [['android', 'mobile'], ['android', 'tablet']],
	  android: [['android', 'mobile'], ['android', 'tablet']]
	};
	
	/**
	 * Uses bowser to get default browser information such as version and name
	 * Evaluates bowser info and adds vendorPrefix information
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	
	exports.default = function (userAgent) {
	  if (!userAgent) {
	    return false;
	  }
	
	  var info = _bowser2.default._detect(userAgent);
	
	  Object.keys(vendorPrefixes).forEach(function (prefix) {
	    vendorPrefixes[prefix].forEach(function (browser) {
	      if (info[browser]) {
	        info.prefix = {
	          inline: prefix,
	          css: '-' + prefix.toLowerCase() + '-'
	        };
	      }
	    });
	  });
	
	  var name = '';
	  Object.keys(browsers).forEach(function (browser) {
	    browsers[browser].forEach(function (condition) {
	      var match = 0;
	      condition.forEach(function (single) {
	        if (info[single]) {
	          match += 1;
	        }
	      });
	      if (condition.length === match) {
	        name = browser;
	      }
	    });
	  });
	
	  info.browser = name;
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  info.version = info.version ? parseFloat(info.version) : parseInt(parseFloat(info.osversion), 10);
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (info.browser === 'android' && info.chrome && info.version > 37) {
	    info.browser = 'and_chr';
	  }
	  info.version = parseFloat(info.version);
	  info.osversion = parseFloat(info.osversion);
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (info.browser === 'android' && info.osversion < 5) {
	    info.version = info.osversion;
	  }
	
	  return info;
	};
	
	module.exports = exports['default'];

/***/ },
/* 306 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (_ref) {
	  var browser = _ref.browser;
	  var version = _ref.version;
	  var prefix = _ref.prefix;
	
	  var prefixedKeyframes = 'keyframes';
	
	  if (browser === 'chrome' && version < 43 || (browser === 'safari' || browser === 'ios_saf') && version < 9 || browser === 'opera' && version < 30 || browser === 'android' && version <= 4.4 || browser === 'and_uc') {
	    prefixedKeyframes = prefix.css + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	};
	
	module.exports = exports['default'];

/***/ },
/* 307 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (property) {
	  var unprefixed = property.replace(/^(ms|Webkit|Moz|O)/, '');
	  return unprefixed.charAt(0).toLowerCase() + unprefixed.slice(1);
	};
	
	module.exports = exports['default'];

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) !(__WEBPACK_AMD_DEFINE_FACTORY__ = (definition), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  else this[name] = definition()
	}('bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)os/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getFirstMatch(/edge\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera|opr|opios/i.test(ua)) {
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/chrome.+? edge/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.msedge && (android || result.silk)) {
	      result.android = t
	    } else if (iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	    } else if (mac) {
	      result.mac = t
	    } else if (xbox) {
	      result.xbox = t
	    } else if (windows) {
	      result.windows = t
	    } else if (linux) {
	      result.linux = t
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result = iterator(arr[i]);
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  return bowser
	});


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(39),
	    root = __webpack_require__(19);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(349),
	    hashDelete = __webpack_require__(350),
	    hashGet = __webpack_require__(351),
	    hashHas = __webpack_require__(352),
	    hashSet = __webpack_require__(353);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(366),
	    mapCacheDelete = __webpack_require__(367),
	    mapCacheGet = __webpack_require__(368),
	    mapCacheHas = __webpack_require__(369),
	    mapCacheSet = __webpack_require__(370);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(39),
	    root = __webpack_require__(19);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(19);
	
	/** Built-in value references. */
	var Reflect = root.Reflect;
	
	module.exports = Reflect;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(39),
	    root = __webpack_require__(19);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(19);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(19);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(39),
	    root = __webpack_require__(19);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 318 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `Map#set` because it doesn't return the map instance in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 319 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 320 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  var length = args.length;
	  switch (length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 321 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(96),
	    keys = __webpack_require__(103);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(150),
	    arrayEach = __webpack_require__(151),
	    assignValue = __webpack_require__(154),
	    baseAssign = __webpack_require__(322),
	    cloneBuffer = __webpack_require__(335),
	    copyArray = __webpack_require__(155),
	    copySymbols = __webpack_require__(342),
	    getAllKeys = __webpack_require__(345),
	    getTag = __webpack_require__(347),
	    initCloneArray = __webpack_require__(354),
	    initCloneByTag = __webpack_require__(355),
	    initCloneObject = __webpack_require__(356),
	    isArray = __webpack_require__(40),
	    isBuffer = __webpack_require__(379),
	    isHostObject = __webpack_require__(98),
	    isObject = __webpack_require__(20),
	    keys = __webpack_require__(103);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  // Recursively populate clone (susceptible to call stack limits).
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	module.exports = baseCreate;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(321),
	    isArray = __webpack_require__(40);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(97);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  // Avoid a bug in IE 10-11 where objects with a [[Prototype]] of `null`,
	  // that are composed entirely of index properties, return `false` for
	  // `hasOwnProperty` checks of them.
	  return object != null &&
	    (hasOwnProperty.call(object, key) ||
	      (typeof object == 'object' && key in object && getPrototype(object) === null));
	}
	
	module.exports = baseHas;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(67),
	    isHostObject = __webpack_require__(98),
	    isMasked = __webpack_require__(359),
	    isObject = __webpack_require__(20),
	    toSource = __webpack_require__(158);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 328 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = Object.keys;
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	module.exports = baseKeys;


/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	var Reflect = __webpack_require__(313),
	    iteratorToArray = __webpack_require__(360);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var enumerate = Reflect ? Reflect.enumerate : undefined,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  object = object == null ? object : Object(object);
	
	  var result = [];
	  for (var key in object) {
	    result.push(key);
	  }
	  return result;
	}
	
	// Fallback for IE < 9 with es6-shim.
	if (enumerate && !propertyIsEnumerable.call({ 'valueOf': 1 }, 'valueOf')) {
	  baseKeysIn = function(object) {
	    return iteratorToArray(enumerate(object));
	  };
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(150),
	    arrayEach = __webpack_require__(151),
	    assignMergeValue = __webpack_require__(153),
	    baseMergeDeep = __webpack_require__(331),
	    isArray = __webpack_require__(40),
	    isObject = __webpack_require__(20),
	    isTypedArray = __webpack_require__(161),
	    keysIn = __webpack_require__(162);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = keysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	module.exports = baseMerge;


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(153),
	    baseClone = __webpack_require__(323),
	    copyArray = __webpack_require__(155),
	    isArguments = __webpack_require__(159),
	    isArray = __webpack_require__(40),
	    isArrayLikeObject = __webpack_require__(160),
	    isFunction = __webpack_require__(67),
	    isObject = __webpack_require__(20),
	    isPlainObject = __webpack_require__(380),
	    isTypedArray = __webpack_require__(161),
	    toPlainObject = __webpack_require__(391);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  stack.set(srcValue, newValue);
	
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	  }
	  stack['delete'](srcValue);
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 332 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 333 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 334 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 335 */
/***/ function(module, exports) {

	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(95);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(318),
	    arrayReduce = __webpack_require__(152),
	    mapToArray = __webpack_require__(371);
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 338 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(319),
	    arrayReduce = __webpack_require__(152),
	    setToArray = __webpack_require__(372);
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(315);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(95);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(96),
	    getSymbols = __webpack_require__(156);
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(19);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	var isIterateeCall = __webpack_require__(357),
	    rest = __webpack_require__(385);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return rest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(325),
	    getSymbols = __webpack_require__(156),
	    keys = __webpack_require__(103);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(332);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(309),
	    Map = __webpack_require__(149),
	    Promise = __webpack_require__(312),
	    Set = __webpack_require__(314),
	    WeakMap = __webpack_require__(317),
	    toSource = __webpack_require__(158);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 348 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(65);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	module.exports = hashClear;


/***/ },
/* 350 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(65);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(65);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(65);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 354 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(95),
	    cloneDataView = __webpack_require__(336),
	    cloneMap = __webpack_require__(337),
	    cloneRegExp = __webpack_require__(338),
	    cloneSet = __webpack_require__(339),
	    cloneSymbol = __webpack_require__(340),
	    cloneTypedArray = __webpack_require__(341);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(324),
	    getPrototype = __webpack_require__(97),
	    isPrototype = __webpack_require__(100);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(66),
	    isArrayLike = __webpack_require__(101),
	    isIndex = __webpack_require__(99),
	    isObject = __webpack_require__(20);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 358 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(343);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 360 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 361 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	module.exports = listCacheClear;


/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(63);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(63);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(63);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(63);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(310),
	    ListCache = __webpack_require__(62),
	    Map = __webpack_require__(149);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(64);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(64);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(64);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(64);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 371 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 372 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(62);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	module.exports = stackClear;


/***/ },
/* 374 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 375 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 376 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(62),
	    MapCache = __webpack_require__(311);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(20),
	    now = __webpack_require__(384),
	    toNumber = __webpack_require__(163);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide an options object to indicate whether `func` should be invoked on
	 * the leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent calls
	 * to the debounced function return the result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is invoked
	 * on the trailing edge of the timeout only if the debounced function is
	 * invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(19),
	    stubFalse = __webpack_require__(387);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = !Buffer ? stubFalse : function(value) {
	  return value instanceof Buffer;
	};
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(629)(module)))

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(97),
	    isHostObject = __webpack_require__(98),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object,
	 *  else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(40),
	    isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	var isObjectLike = __webpack_require__(54);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(330),
	    createAssigner = __webpack_require__(344);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var users = {
	 *   'data': [{ 'user': 'barney' }, { 'user': 'fred' }]
	 * };
	 *
	 * var ages = {
	 *   'data': [{ 'age': 36 }, { 'age': 40 }]
	 * };
	 *
	 * _.merge(users, ages);
	 * // => { 'data': [{ 'user': 'barney', 'age': 36 }, { 'user': 'fred', 'age': 40 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 384 */
/***/ function(module, exports) {

	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	function now() {
	  return Date.now();
	}
	
	module.exports = now;


/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(320),
	    toInteger = __webpack_require__(390);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of the
	 * created function and arguments from `start` and beyond provided as
	 * an array.
	 *
	 * **Note:** This method is based on the
	 * [rest parameter](https://mdn.io/rest_parameters).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Function
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 * @example
	 *
	 * var say = _.rest(function(what, names) {
	 *   return what + ' ' + _.initial(names).join(', ') +
	 *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	 * });
	 *
	 * say('hello', 'fred', 'barney', 'pebbles');
	 * // => 'hello fred, barney, & pebbles'
	 */
	function rest(func, start) {
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  start = nativeMax(start === undefined ? (func.length - 1) : toInteger(start), 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    switch (start) {
	      case 0: return func.call(this, array);
	      case 1: return func.call(this, args[0], array);
	      case 2: return func.call(this, args[0], args[1], array);
	    }
	    var otherArgs = Array(start + 1);
	    index = -1;
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = rest;


/***/ },
/* 386 */
/***/ function(module, exports) {

	/**
	 * A method that returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 387 */
/***/ function(module, exports) {

	/**
	 * A method that returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	var debounce = __webpack_require__(378),
	    isObject = __webpack_require__(20);
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide an options object to indicate whether
	 * `func` should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	module.exports = throttle;


/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(163);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(389);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/6.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(96),
	    keysIn = __webpack_require__(162);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(513).create;

/***/ },
/* 393 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 394 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  var last = funcs[funcs.length - 1];
	  return function () {
	    var result = last.apply(undefined, arguments);
	    for (var i = funcs.length - 2; i >= 0; i--) {
	      var f = funcs[i];
	      result = f(result);
	    }
	    return result;
	  };
	}

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(400);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(397);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ },
/* 396 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && typeof Component.prototype.isReactComponent === 'object');
	};
	
	exports.default = isClassComponent;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(396);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && !Component.propTypes);
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ },
/* 398 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _createHelper = __webpack_require__(164);
	
	var _createHelper2 = _interopRequireDefault(_createHelper);
	
	var _createEagerFactory = __webpack_require__(395);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	    return function (_Component) {
	      _inherits(_class, _Component);
	
	      function _class() {
	        _classCallCheck(this, _class);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      _class.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return _class;
	    }(_react.Component);
	  };
	};
	
	exports.default = (0, _createHelper2.default)(shouldUpdate, 'shouldUpdate');

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(55);
	
	var _colorManipulator = __webpack_require__(34);
	
	var _spacing = __webpack_require__(403);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getMuiTheme;
	
	var _merge = __webpack_require__(383);
	
	var _merge2 = _interopRequireDefault(_merge);
	
	var _colorManipulator = __webpack_require__(34);
	
	var _lightBaseTheme = __webpack_require__(401);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(405);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(421);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(422);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(423);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(394);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(404);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _merge2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme;
	  var spacing = _muiTheme.spacing;
	  var fontFamily = _muiTheme.fontFamily;
	  var palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _merge2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.accent1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.primary1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: _colors.white
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.035),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.textColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.accent3Color,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, _toConsumableArray(transformers));
	
	  return muiTheme;
	}

/***/ },
/* 403 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(55);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Typography = function Typography() {
	  _classCallCheck(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ },
/* 405 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapVert = function ActionSwapVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z' })
	  );
	};
	ActionSwapVert = (0, _pure2.default)(ActionSwapVert);
	ActionSwapVert.displayName = 'ActionSwapVert';
	ActionSwapVert.muiName = 'SvgIcon';
	
	exports.default = ActionSwapVert;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPause = function AvPause(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z' })
	  );
	};
	AvPause = (0, _pure2.default)(AvPause);
	AvPause.displayName = 'AvPause';
	AvPause.muiName = 'SvgIcon';
	
	exports.default = AvPause;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayArrow = function AvPlayArrow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 5v14l11-7z' })
	  );
	};
	AvPlayArrow = (0, _pure2.default)(AvPlayArrow);
	AvPlayArrow.displayName = 'AvPlayArrow';
	AvPlayArrow.muiName = 'SvgIcon';
	
	exports.default = AvPlayArrow;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeOff = function AvVolumeOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z' })
	  );
	};
	AvVolumeOff = (0, _pure2.default)(AvVolumeOff);
	AvVolumeOff.displayName = 'AvVolumeOff';
	AvVolumeOff.muiName = 'SvgIcon';
	
	exports.default = AvVolumeOff;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeUp = function AvVolumeUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' })
	  );
	};
	AvVolumeUp = (0, _pure2.default)(AvVolumeUp);
	AvVolumeUp.displayName = 'AvVolumeUp';
	AvVolumeUp.muiName = 'SvgIcon';
	
	exports.default = AvVolumeUp;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationForum = function CommunicationForum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
	  );
	};
	CommunicationForum = (0, _pure2.default)(CommunicationForum);
	CommunicationForum.displayName = 'CommunicationForum';
	CommunicationForum.muiName = 'SvgIcon';
	
	exports.default = CommunicationForum;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFullscreenExit = function NavigationFullscreenExit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z' })
	  );
	};
	NavigationFullscreenExit = (0, _pure2.default)(NavigationFullscreenExit);
	NavigationFullscreenExit.displayName = 'NavigationFullscreenExit';
	NavigationFullscreenExit.muiName = 'SvgIcon';
	
	exports.default = NavigationFullscreenExit;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFullscreen = function NavigationFullscreen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z' })
	  );
	};
	NavigationFullscreen = (0, _pure2.default)(NavigationFullscreen);
	NavigationFullscreen.displayName = 'NavigationFullscreen';
	NavigationFullscreen.muiName = 'SvgIcon';
	
	exports.default = NavigationFullscreen;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = function NavigationMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	  );
	};
	NavigationMenu = (0, _pure2.default)(NavigationMenu);
	NavigationMenu.displayName = 'NavigationMenu';
	NavigationMenu.muiName = 'SvgIcon';
	
	exports.default = NavigationMenu;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSync = function NotificationSync(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
	  );
	};
	NotificationSync = (0, _pure2.default)(NotificationSync);
	NotificationSync.displayName = 'NotificationSync';
	NotificationSync.muiName = 'SvgIcon';
	
	exports.default = NotificationSync;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(10);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(9);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialShare = function SocialShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z' })
	  );
	};
	SocialShare = (0, _pure2.default)(SocialShare);
	SocialShare.displayName = 'SocialShare';
	SocialShare.muiName = 'SvgIcon';
	
	exports.default = SocialShare;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = function (muiTheme) {
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && typeof navigator !== 'undefined') {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      return _inlineStylePrefixer2.default.prefixAll(style);
	    };
	  } else {
	    var _ret = function () {
	      var prefixer = new _inlineStylePrefixer2.default({
	        userAgent: userAgent
	      });
	
	      return {
	        v: function v(style) {
	          return prefixer.prefix(style);
	        }
	      };
	    }();
	
	    if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	  }
	};
	
	var _inlineStylePrefixer = __webpack_require__(285);
	
	var _inlineStylePrefixer2 = _interopRequireDefault(_inlineStylePrefixer);
	
	var _warning = __webpack_require__(27);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(27);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ },
/* 423 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = rtl;
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      Object.keys(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setViewersCount = exports.clearMessages = exports.addMessage = exports.setConversationId = exports.setTorrents = exports.setId = exports.SET_VIEWERS_COUNT = exports.CLEAR_MESSAGES = exports.ADD_MESSAGE = exports.SET_CONVERSATION_ID = exports.SET_TORRENTS = exports.SET_ID = undefined;
	
	var _video = __webpack_require__(168);
	
	var videoActions = _interopRequireWildcard(_video);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var SET_ID = exports.SET_ID = 'ROOM_SET_ID';
	var SET_TORRENTS = exports.SET_TORRENTS = 'ROOM_SET_TORRENTS';
	var SET_CONVERSATION_ID = exports.SET_CONVERSATION_ID = 'ROOM_SET_CONVERSATION_ID';
	var ADD_MESSAGE = exports.ADD_MESSAGE = 'ROOM_ADD_MESSAGE';
	var CLEAR_MESSAGES = exports.CLEAR_MESSAGES = 'ROOM_CLEAR_MESSAGES';
	var SET_VIEWERS_COUNT = exports.SET_VIEWERS_COUNT = 'ROOM_SET_VIWERS_COUNT';
	
	var setId = exports.setId = function setId(id) {
	  return { type: SET_ID, id: id };
	};
	var setTorrents = exports.setTorrents = function setTorrents(torrents) {
	  return { type: SET_TORRENTS, torrents: torrents };
	};
	var setConversationId = exports.setConversationId = function setConversationId(conversationId) {
	  return { type: SET_CONVERSATION_ID, conversationId: conversationId };
	};
	var addMessage = exports.addMessage = function addMessage(message) {
	  return { type: ADD_MESSAGE, message: message };
	};
	var clearMessages = exports.clearMessages = function clearMessages() {
	  return { type: CLEAR_MESSAGES };
	};
	var setViewersCount = exports.setViewersCount = function setViewersCount(viewersCount) {
	  return { type: SET_VIEWERS_COUNT, viewersCount: viewersCount };
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "room.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var SET_NAME = exports.SET_NAME = 'USER_SET_NAME';
	var OPEN_NAME_DIALOG = exports.OPEN_NAME_DIALOG = 'USER_OPEN_NAME_DIALOG';
	var CLOSE_NAME_DIALOG = exports.CLOSE_NAME_DIALOG = 'USER_CLOSE_NAME_DIALOG';
	var SET_NAME_REQUIRED = exports.SET_NAME_REQUIRED = 'USER_SET_NAME_REQUIRED';
	var JOIN_ROOM = exports.JOIN_ROOM = 'USER_JOIN_ROOM';
	var CLEAR_RECENTLY_JOINED = exports.CLEAR_RECENTLY_JOINED = 'USER_CLEAR_RECENTLY_JOINED';
	
	var setName = exports.setName = function setName(name) {
	  return { type: SET_NAME, name: name };
	};
	var openNameDialog = exports.openNameDialog = function openNameDialog() {
	  return { type: OPEN_NAME_DIALOG };
	};
	var closeNameDialog = exports.closeNameDialog = function closeNameDialog() {
	  return { type: CLOSE_NAME_DIALOG };
	};
	var setNameRequired = exports.setNameRequired = function setNameRequired(required) {
	  return { type: SET_NAME_REQUIRED, required: required };
	};
	var joinRoom = exports.joinRoom = function joinRoom(roomId) {
	  return { type: JOIN_ROOM, roomId: roomId };
	};
	var clearRecentlyJoined = exports.clearRecentlyJoined = function clearRecentlyJoined() {
	  return { type: CLEAR_RECENTLY_JOINED };
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "user.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(232);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(38);
	
	var _reactRedux = __webpack_require__(41);
	
	var _reactRouter = __webpack_require__(74);
	
	var _room = __webpack_require__(71);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _actions = __webpack_require__(21);
	
	var _AppBar = __webpack_require__(240);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	var _FlatButton = __webpack_require__(59);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _FontIcon = __webpack_require__(137);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Dialog = __webpack_require__(90);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _TextField = __webpack_require__(93);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _List = __webpack_require__(251);
	
	var _Popover = __webpack_require__(142);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _Menu = __webpack_require__(252);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(140);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(136);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _icon = __webpack_require__(169);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function backHome() {
		_reactRouter.browserHistory.push('/');
	}
	
	var App = function (_React$Component) {
		_inherits(App, _React$Component);
	
		function App(props) {
			_classCallCheck(this, App);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(App).call(this, props));
	
			_this.state = {
				userPopoverOpen: false,
				userAnchorEl: null,
				nameDialogErrorText: null,
				newName: null,
				recentlyJoinedDialogOpen: false
			};['openUserPopover', 'closeUserPopover', 'openNameDialog', 'setNewName', 'updateName', 'openRecentlyJoinedDialog', 'closeRecentlyJoinedDialog'].forEach(function (method) {
				return _this[method] = _this[method].bind(_this);
			});
			return _this;
		}
	
		_createClass(App, [{
			key: 'openUserPopover',
			value: function openUserPopover(e) {
				e.preventDefault();
				this.setState({
					userPopoverOpen: true,
					userAnchorEl: e.currentTarget
				});
			}
		}, {
			key: 'closeUserPopover',
			value: function closeUserPopover() {
				this.setState({
					userPopoverOpen: false
				});
			}
		}, {
			key: 'openNameDialog',
			value: function openNameDialog() {
				this.closeUserPopover();
				this.props.openNameDialog();
			}
		}, {
			key: 'setNewName',
			value: function setNewName(e) {
				this.setState({
					newName: e.target.value
				});
			}
		}, {
			key: 'updateName',
			value: function updateName() {
				this.props.setName(this.state.newName);
				this.props.closeNameDialog();
			}
		}, {
			key: 'openRecentlyJoinedDialog',
			value: function openRecentlyJoinedDialog() {
				this.closeUserPopover();
				this.setState({
					recentlyJoinedDialogOpen: true
				});
			}
		}, {
			key: 'closeRecentlyJoinedDialog',
			value: function closeRecentlyJoinedDialog() {
				this.setState({
					recentlyJoinedDialogOpen: false
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this2 = this;
	
				var iconRight = this.props.name ? _react2.default.createElement(_FlatButton2.default, { label: this.props.name, onTouchTap: this.openUserPopover }) : null;
	
				var cancelButton = _react2.default.createElement(_FlatButton2.default, {
					label: 'Cancel',
					primary: true,
					onTouchTap: this.props.closeNameDialog
				});
				var confirmButton = _react2.default.createElement(_FlatButton2.default, {
					label: 'Confirm',
					primary: true,
					onTouchTap: this.updateName,
					disabled: !this.state.newName || this.state.nameDialogErrorText !== null
				});
				var nameDialogActions = !this.props.nameRequired || !!this.props.name ? [cancelButton, confirmButton] : [confirmButton];
				var recentlyJoinedDialogActions = [_react2.default.createElement(_FlatButton2.default, {
					label: 'clear',
					primary: true,
					onTouchTap: this.props.clearRecentlyJoined
				}), _react2.default.createElement(_FlatButton2.default, {
					label: 'ok',
					primary: true,
					onTouchTap: this.closeRecentlyJoinedDialog
				})];
				var customContentStyle = {
					maxWidth: '400px'
				};
				return _react2.default.createElement(
					'div',
					{ className: 'container' },
					_react2.default.createElement(_AppBar2.default, {
						title: this.props.location.pathname === '/' ? null : "AvTogether",
						titleStyle: { cursor: 'pointer', flex: '' },
						iconStyleLeft: { display: 'none' },
						iconElementRight: iconRight,
						zDepth: 0,
						onTitleTouchTap: backHome
					}),
					_react2.default.createElement(
						_Popover2.default,
						{
							open: this.state.userPopoverOpen,
							anchorEl: this.state.userAnchorEl,
							anchorOrigin: { horizontal: 'right', vertical: 'bottom' },
							targetOrigin: { horizontal: 'right', vertical: 'top' },
							onRequestClose: this.closeUserPopover
						},
						_react2.default.createElement(
							_Menu2.default,
							null,
							_react2.default.createElement(_MenuItem2.default, { primaryText: 'Reset Name', onTouchTap: this.openNameDialog }),
							_react2.default.createElement(_MenuItem2.default, { primaryText: 'Recently Joined', onTouchTap: this.openRecentlyJoinedDialog })
						)
					),
					this.props.children,
					_react2.default.createElement(
						'footer',
						null,
						_react2.default.createElement(
							'a',
							{ href: 'https://github.com/imsun/AvTogether', target: '_blank' },
							_react2.default.createElement(_icon.GitHubIcon, { color: 'white' })
						),
						_react2.default.createElement(
							'p',
							null,
							_react2.default.createElement(
								'a',
								{ href: '//imsun.net', target: '_blank' },
								'imsun.net'
							)
						)
					),
					_react2.default.createElement(
						_Dialog2.default,
						{
							title: 'Set Your Name',
							actions: nameDialogActions,
							modal: false,
							open: this.props.nameDialogOpen,
							onRequestClose: this.props.closeNameDialog,
							contentStyle: customContentStyle
						},
						_react2.default.createElement(_TextField2.default, {
							hintText: 'Your Name',
							errorText: this.state.nameDialogErrorText,
							onChange: this.setNewName }),
						_react2.default.createElement('br', null)
					),
					_react2.default.createElement(
						_Dialog2.default,
						{
							title: 'Recently Joined',
							actions: recentlyJoinedDialogActions,
							modal: false,
							open: this.state.recentlyJoinedDialogOpen,
							onRequestClose: this.closeRecentlyJoinedDialog,
							contentStyle: customContentStyle
						},
						_react2.default.createElement(
							_List.List,
							null,
							_react2.default.createElement(_Divider2.default, null),
							this.props.recentlyJoined.map(function (room) {
								return [_react2.default.createElement(_List.ListItem, {
									key: room.roomId,
									primaryText: room.roomId,
									secondaryText: room.time,
									onTouchTap: function onTouchTap() {
										_this2.closeRecentlyJoinedDialog();
										_room2.default.goto(room.roomId);
									}
								}), _react2.default.createElement(_Divider2.default, null)];
							})
						)
					)
				);
			}
		}]);
	
		return App;
	}(_react2.default.Component);
	
	App.propTypes = {
		name: _react.PropTypes.string,
		recentlyJoined: _react.PropTypes.array
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
		return state.user;
	}, function (dispatch) {
		return (0, _redux.bindActionCreators)(_actions.userActions, dispatch);
	})(App);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(233);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(38);
	
	var _reactRedux = __webpack_require__(41);
	
	var _room = __webpack_require__(71);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _actions = __webpack_require__(21);
	
	var _icon = __webpack_require__(169);
	
	var _Dialog = __webpack_require__(90);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(59);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(143);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _TextField = __webpack_require__(93);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Paper = __webpack_require__(24);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Stepper = __webpack_require__(266);
	
	var _swapVert = __webpack_require__(407);
	
	var _swapVert2 = _interopRequireDefault(_swapVert);
	
	var _sync = __webpack_require__(419);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _forum = __webpack_require__(412);
	
	var _forum2 = _interopRequireDefault(_forum);
	
	var _colors = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Entry = function (_React$Component) {
		_inherits(Entry, _React$Component);
	
		function Entry(props) {
			_classCallCheck(this, Entry);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Entry).call(this, props));
	
			_this.state = {
				joinDialogOpen: false,
				joinDialogRoomId: '',
				joinDialogErrorText: null
			};['openJoinDialog', 'closeJoinDialog', 'setTargetRoom', 'joinRoom'].forEach(function (method) {
				return _this[method] = _this[method].bind(_this);
			});
			return _this;
		}
	
		_createClass(Entry, [{
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.setNameRequired(false);
			}
		}, {
			key: 'openJoinDialog',
			value: function openJoinDialog() {
				this.setState({
					joinDialogOpen: true
				});
			}
		}, {
			key: 'closeJoinDialog',
			value: function closeJoinDialog() {
				this.setState({
					joinDialogOpen: false
				});
			}
		}, {
			key: 'setTargetRoom',
			value: function setTargetRoom(e) {
				if (!e.target.value) {
					this.setState({
						joinDialogErrorText: 'Room ID is required.'
					});
				} else {
					this.setState({
						joinDialogErrorText: null
					});
				}
				this.setState({
					joinDialogRoomId: e.target.value
				});
			}
		}, {
			key: 'joinRoom',
			value: function joinRoom() {
				_room2.default.goto(this.state.joinDialogRoomId);
			}
		}, {
			key: 'render',
			value: function render() {
				var actions = [_react2.default.createElement(_FlatButton2.default, {
					label: 'Cancel',
					primary: true,
					onTouchTap: this.closeJoinDialog
				}), _react2.default.createElement(_FlatButton2.default, {
					label: 'Join',
					primary: true,
					onTouchTap: this.joinRoom,
					disabled: !this.state.joinDialogRoomId || this.state.joinDialogErrorText !== null
				})];
				var customContentStyle = {
					maxWidth: '400px'
				};
				return _react2.default.createElement(
					'div',
					{ className: 'entry-page' },
					_react2.default.createElement(
						'div',
						{ className: 'banner' },
						_react2.default.createElement(_icon.LogoIcon, { className: 'logo' }),
						_react2.default.createElement(
							'h1',
							null,
							'AvTogether'
						),
						_react2.default.createElement(
							'p',
							null,
							'Enjoy videos together with your friends.'
						),
						_react2.default.createElement(_RaisedButton2.default, {
							className: 'entry-button',
							secondary: true,
							onTouchTap: _room2.default.create,
							label: 'New Room'
						}),
						_react2.default.createElement(_RaisedButton2.default, {
							className: 'entry-button',
							labelColor: _colors.cyan500,
							onTouchTap: this.openJoinDialog,
							label: 'Join a Room'
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'steps' },
						_react2.default.createElement(
							'div',
							{ className: 'content' },
							_react2.default.createElement(
								'h2',
								null,
								'EASY TO GO'
							),
							_react2.default.createElement(
								'div',
								null,
								'AvTogether is an experimental project to share local videos with your friends via WebRTC, based on ',
								_react2.default.createElement(
									'a',
									{ href: 'https://webtorrent.io/' },
									'WebTorrent'
								),
								'.'
							),
							_react2.default.createElement(
								_Stepper.Stepper,
								null,
								_react2.default.createElement(
									_Stepper.Step,
									{ active: true },
									_react2.default.createElement(
										_Stepper.StepLabel,
										null,
										'Create a room'
									)
								),
								_react2.default.createElement(
									_Stepper.Step,
									{ active: true },
									_react2.default.createElement(
										_Stepper.StepLabel,
										null,
										'Select a local video'
									)
								),
								_react2.default.createElement(
									_Stepper.Step,
									{ active: true },
									_react2.default.createElement(
										_Stepper.StepLabel,
										null,
										'Share room to friends'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'features' },
						_react2.default.createElement(
							'h2',
							null,
							'FEATURES'
						),
						_react2.default.createElement(
							'div',
							{ className: 'cards' },
							_react2.default.createElement(
								_Paper2.default,
								{ className: 'card' },
								_react2.default.createElement(_swapVert2.default, null),
								_react2.default.createElement(
									'div',
									{ className: 'card-title' },
									'P2P Streaming'
								),
								_react2.default.createElement(
									'div',
									{ className: 'card-desc' },
									'None of video data would be uploaded'
								)
							),
							_react2.default.createElement(
								_Paper2.default,
								{ className: 'card' },
								_react2.default.createElement(_sync2.default, null),
								_react2.default.createElement(
									'div',
									{ className: 'card-title' },
									'Progress Syncing'
								),
								_react2.default.createElement(
									'div',
									{ className: 'card-desc' },
									'Operation is applied to all when anyone plays / pauses / forwards / backwards the video'
								)
							),
							_react2.default.createElement(
								_Paper2.default,
								{ className: 'card' },
								_react2.default.createElement(_forum2.default, null),
								_react2.default.createElement(
									'div',
									{ className: 'card-title' },
									'Live Chat'
								),
								_react2.default.createElement(
									'div',
									{ className: 'card-desc' },
									'Comment anytime while watching'
								)
							)
						)
					),
					_react2.default.createElement(
						_Dialog2.default,
						{
							title: 'Join a Room',
							actions: actions,
							modal: false,
							open: this.state.joinDialogOpen,
							onRequestClose: this.closeJoinDialog,
							contentStyle: customContentStyle
						},
						_react2.default.createElement(_TextField2.default, {
							hintText: 'Room ID',
							errorText: this.state.joinDialogErrorText,
							onChange: this.setTargetRoom }),
						_react2.default.createElement('br', null)
					)
				);
			}
		}]);
	
		return Entry;
	}(_react2.default.Component);
	
	exports.default = (0, _reactRedux.connect)(null, function (dispatch) {
		return (0, _redux.bindActionCreators)(_actions.userActions, dispatch);
	})(Entry);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(234);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(38);
	
	var _reactRedux = __webpack_require__(41);
	
	var _room = __webpack_require__(71);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _messages = __webpack_require__(70);
	
	var _actions = __webpack_require__(21);
	
	var _FlatButton = __webpack_require__(59);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _RaisedButton = __webpack_require__(143);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	var _video = __webpack_require__(430);
	
	var _video2 = _interopRequireDefault(_video);
	
	var _sidebar = __webpack_require__(429);
	
	var _sidebar2 = _interopRequireDefault(_sidebar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RoomComponent = function (_React$Component) {
		_inherits(RoomComponent, _React$Component);
	
		function RoomComponent(props) {
			_classCallCheck(this, RoomComponent);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(RoomComponent).call(this, props));
	
			_this.state = {
				isProcessingVideo: false
			};['seed', 'onVideoLoad'].forEach(function (method) {
				return _this[method] = _this[method].bind(_this);
			});
			return _this;
		}
	
		_createClass(RoomComponent, [{
			key: 'componentWillReceiveProps',
			value: function componentWillReceiveProps(newProps) {
				if (this.props.params.id !== newProps.params.id) {
					this.video.reset();
					_room2.default.leave().then(function () {
						return _room2.default.join(newProps.params.id);
					});
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				if (this.props.torrents.length > 0 && (prevProps.torrents.length <= 0 || prevProps.torrents[0].id !== this.props.torrents[0].id)) {
					this.load();
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				this.props.setNameRequired(true);
				_room2.default.join(this.props.params.id);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				_room2.default.leave();
			}
		}, {
			key: 'load',
			value: function load() {
				var _this2 = this;
	
				return _room2.default.loadTorrent().then(function (torrent) {
					torrent.files[0].renderTo(_this2.video.target);
				});
			}
		}, {
			key: 'seed',
			value: function seed(e) {
				var _this3 = this;
	
				if (e.target.files.length <= 0) return;
				this.setState({
					isProcessingVideo: true
				});
				_room2.default.seed(e.target.files[0]).then(function (torrent) {
					return _room2.default.addTorrent(torrent);
				}).then(function (torrent) {
					torrent.files[0].renderTo(_this3.video.target);
					_this3.video.pause(0);
					_this3.setState({
						isProcessingVideo: false
					});
				}).catch(function (e) {
					_this3.setState({
						isProcessingVideo: false
					});
				});
			}
		}, {
			key: 'onVideoLoad',
			value: function onVideoLoad(video) {
				this.video = video;
			}
		}, {
			key: 'render',
			value: function render() {
				var _this4 = this;
	
				return _react2.default.createElement(
					'div',
					{ className: 'room-page' },
					_react2.default.createElement(
						'div',
						{ className: 'video-banner' },
						_react2.default.createElement(
							'span',
							{ className: 'video-desc' },
							function () {
								if (_this4.state.isProcessingVideo) {
									return 'Processing video...';
								} else {
									return _this4.props.torrents[0] ? _react2.default.createElement(
										'span',
										null,
										'Now is playing ',
										_react2.default.createElement(
											'b',
											null,
											_this4.props.torrents[0].name
										)
									) : 'No video available';
								}
							}()
						),
						_react2.default.createElement(_RaisedButton2.default, {
							className: 'file-button',
							label: 'Choose a Video',
							labelPosition: 'before',
							onTouchTap: function onTouchTap() {
								return _this4.refs.fileInput.click();
							}
						}),
						_react2.default.createElement('input', {
							ref: 'fileInput',
							type: 'file',
							onChange: this.seed,
							accept: 'video/mp4,video/x-m4v,video/*'
						})
					),
					_react2.default.createElement(
						'div',
						{ className: 'video-container' },
						_react2.default.createElement(_video2.default, { onLoad: this.onVideoLoad }),
						_react2.default.createElement(_sidebar2.default, null)
					)
				);
			}
		}]);
	
		return RoomComponent;
	}(_react2.default.Component);
	
	RoomComponent.propTypes = {
		id: _react.PropTypes.string.isRequired,
		torrents: _react.PropTypes.array.isRequired,
		messages: _react.PropTypes.array.isRequired
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
		return state.room;
	}, function (dispatch) {
		return (0, _redux.bindActionCreators)(_actions.userActions, dispatch);
	})(RoomComponent);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(235);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(41);
	
	var _reactRouter = __webpack_require__(74);
	
	var _actions = __webpack_require__(21);
	
	var _messages = __webpack_require__(70);
	
	var _Paper = __webpack_require__(24);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Dialog = __webpack_require__(90);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(59);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	var _Divider = __webpack_require__(136);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _share = __webpack_require__(420);
	
	var _share2 = _interopRequireDefault(_share);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Sidebar = function (_React$Component) {
		_inherits(Sidebar, _React$Component);
	
		function Sidebar(props) {
			_classCallCheck(this, Sidebar);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Sidebar).call(this, props));
	
			_this.state = {
				shareDialogOpen: false
			};['toggleShareDialog'].forEach(function (method) {
				return _this[method] = _this[method].bind(_this);
			});
			return _this;
		}
	
		_createClass(Sidebar, [{
			key: 'toggleShareDialog',
			value: function toggleShareDialog() {
				this.setState({
					shareDialogOpen: !this.state.shareDialogOpen
				});
			}
		}, {
			key: 'componentWillUpdate',
			value: function componentWillUpdate(nextProps) {
				if (nextProps.messages.length !== this.props.messages.length) {
					var messageList = this.refs.messageList;
					this.shouldScrollBottom = messageList.scrollTop + messageList.offsetHeight === messageList.scrollHeight;
				}
			}
		}, {
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				if (prevProps.messages.length !== this.props.messages.length && this.shouldScrollBottom) {
					var messageList = this.refs.messageList;
					messageList.scrollTop = messageList.scrollHeight;
				}
			}
		}, {
			key: 'render',
			value: function render() {
				return _react2.default.createElement(
					_Paper2.default,
					{ className: 'sidebar' },
					_react2.default.createElement(
						'span',
						{ className: 'chat-info' },
						_react2.default.createElement(
							'span',
							{ className: 'viewers-count' },
							'Viewers: ',
							this.props.viewersCount
						),
						_react2.default.createElement(_FlatButton2.default, {
							icon: _react2.default.createElement(_share2.default, null),
							onTouchTap: this.toggleShareDialog
						})
					),
					_react2.default.createElement(_Divider2.default, null),
					_react2.default.createElement(
						'ul',
						{ ref: 'messageList', className: 'messages' },
						this.props.messages.map(function (message, index) {
							return _react2.default.createElement(
								'li',
								{ key: index },
								_react2.default.createElement(
									'span',
									{
										className: 'user-name',
										style: { color: (0, _messages.computeColor)(message.user.id) }
									},
									message.user.name
								),
								message.text
							);
						})
					),
					_react2.default.createElement(
						_Dialog2.default,
						{
							title: 'Share with Friends',
							actions: _react2.default.createElement(_FlatButton2.default, { label: 'OK', primary: true, onTouchTap: this.toggleShareDialog }),
							modal: false,
							open: this.state.shareDialogOpen,
							onRequestClose: this.toggleShareDialog
						},
						_react2.default.createElement(
							'p',
							null,
							'Share room ID ',
							_react2.default.createElement(
								'code',
								null,
								this.props.id
							)
						),
						_react2.default.createElement(
							'p',
							null,
							'or address of this page ',
							_react2.default.createElement(
								'a',
								{ href: location.href },
								location.href
							)
						),
						_react2.default.createElement(
							'p',
							null,
							'to invite your friends to join this room.'
						),
						_react2.default.createElement('br', null)
					)
				);
			}
		}]);
	
		return Sidebar;
	}(_react2.default.Component);
	
	Sidebar.propTypes = {
		id: _react.PropTypes.string.isRequired,
		messages: _react.PropTypes.array.isRequired,
		viewersCount: _react.PropTypes.number.isRequired
	};
	
	var mapStateToProps = function mapStateToProps(_ref) {
		var _ref$room = _ref.room;
		var id = _ref$room.id;
		var messages = _ref$room.messages;
		var viewersCount = _ref$room.viewersCount;
		return { id: id, messages: messages, viewersCount: viewersCount };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(Sidebar);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	__webpack_require__(236);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _redux = __webpack_require__(38);
	
	var _reactRedux = __webpack_require__(41);
	
	var _actions = __webpack_require__(21);
	
	var _messages = __webpack_require__(70);
	
	var _classnames = __webpack_require__(230);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Paper = __webpack_require__(24);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _Slider = __webpack_require__(260);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	var _Popover = __webpack_require__(142);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _IconButton = __webpack_require__(91);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _playArrow = __webpack_require__(409);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _pause = __webpack_require__(408);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _fullscreen = __webpack_require__(417);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _fullscreenExit = __webpack_require__(416);
	
	var _fullscreenExit2 = _interopRequireDefault(_fullscreenExit);
	
	var _volumeUp = __webpack_require__(411);
	
	var _volumeUp2 = _interopRequireDefault(_volumeUp);
	
	var _volumeOff = __webpack_require__(410);
	
	var _volumeOff2 = _interopRequireDefault(_volumeOff);
	
	var _TextField = __webpack_require__(93);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _CircularProgress = __webpack_require__(242);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function toHHMMSS(secNum) {
		var spliter = arguments.length <= 1 || arguments[1] === undefined ? ':' : arguments[1];
	
		if (isNaN(secNum)) {
			return '--' + spliter + '--';
		}
		var hours = Math.floor(secNum / 3600);
		var minutes = Math.floor((secNum - hours * 3600) / 60);
		var seconds = Math.floor(secNum - hours * 3600 - minutes * 60);
	
		return hours > 0 ? [hours, minutes, seconds].map(function (time) {
			return time < 10 ? '0' + time : time;
		}).join(spliter) : [minutes, seconds].map(function (time) {
			return time < 10 ? '0' + time : time;
		}).join(spliter);
	}
	
	var fullScreenEnabled = !!(document.fullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || document.webkitSupportsFullscreen || document.webkitFullscreenEnabled || document.createElement('video').webkitRequestFullScreen);
	var isFullScreen = function isFullScreen() {
		return !!(document.fullScreen || document.webkitIsFullScreen || document.mozFullScreen || document.msFullscreenElement || document.fullscreenElement);
	};
	var fullScreenChangeEvents = ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange'];
	
	var initState = {
		textToBeSent: '',
		hideVideoControl: false,
		volumeBarOpen: false
	};
	
	var Video = function (_React$Component) {
		_inherits(Video, _React$Component);
	
		function Video(props) {
			_classCallCheck(this, Video);
	
			var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(Video).call(this, props));
	
			_this.state = initState;['onTextChange', 'send', 'play', 'pause', 'togglePlay', 'handleProgressBarChange', 'updateProgress', 'handleDocumentMouseUp', 'toggleFullScreen', 'fullScreenChangeListener', 'showVideoControl', 'flashVideoControl', 'setHideVideoControlTimer', 'clearHideVideoControlTimer', 'toggleMuted', 'openVolumeBar', 'closeVolumeBar', 'handleVolumeChange'].forEach(function (method) {
				return _this[method] = _this[method].bind(_this);
			});
			_this.isSeeking = false;
			if (fullScreenEnabled) {
				fullScreenChangeEvents.forEach(function (event) {
					document.addEventListener(event, _this.fullScreenChangeListener);
				});
			}
			document.addEventListener('mouseup', _this.handleDocumentMouseUp);
			window.video = _this.props;
			return _this;
		}
	
		_createClass(Video, [{
			key: 'componentDidUpdate',
			value: function componentDidUpdate(prevProps) {
				if (this.props.paused !== prevProps.paused) {
					console.log('paused:', this.props.paused);
					if (this.props.paused) {
						this.target.pause();
					} else {
						this.target.play();
					}
				}
				if (this.props.currentTime !== prevProps.currentTime) {
					this.target.currentTime = this.props.currentTime;
					if (!this.isSeeking && this.props.videoReady) {
						if (this.target.paused) {
							// hack to force loading unloaded frames while seeking
							this.target.play();
							this.target.pause();
						}
					}
				}
				if (this.props.fullScreen !== prevProps.fullScreen) {
					if (this.props.fullScreen) {
						this.setHideVideoControlTimer();
					} else {
						this.showVideoControl();
					}
				}
				if (this.props.muted !== prevProps.muted) {
					this.target.muted = this.props.muted;
				}
				if (this.props.volume !== prevProps.volume) {
					this.target.volume = this.props.volume;
				}
			}
		}, {
			key: 'componentDidMount',
			value: function componentDidMount() {
				var _this2 = this;
	
				var target = this.target = this.refs.target;
				this.fullScreenWrapper = this.refs.fullScreenWrapper;
	
				target.addEventListener('durationchange', function () {
					console.log('duration change');
					_this2.props.set({
						duration: target.duration
					});
				});
				target.addEventListener('loadstart', function () {
					console.log('load start');
					if (target.getAttribute('src')) {
						_this2.props.pushStatus('loading video metadata...');
						// hack for firefox
						_this2.target.pause();
					}
					target.currentTime = _this2.props.currentTime;
					_this2.props.set({
						videoReady: false
					});
				});
				target.addEventListener('loadedmetadata', function () {
					_this2.props.pushStatus('video metadata loaded.');
					_this2.props.pushStatus('loading video data...');
				});
				target.addEventListener('waiting', function () {
					if (target.getAttribute('src')) {
						_this2.props.set({
							isLoading: true
						});
					}
				});
				target.addEventListener('canplay', function () {
					_this2.props.set({
						isLoading: false
					});
				});
				target.addEventListener('loadeddata', function () {
					_this2.props.clearStatus();
					_this2.props.set({
						videoReady: true,
						realTime: _this2.target.currentTime
					});
				});
				target.addEventListener('timeupdate', this.updateProgress);
				target.addEventListener('play', function () {
					if (_this2.props.paused) {
						target.pause();
					} else {
						target.play();
					}
				});
				target.addEventListener('ended', function () {
					if (!target.loop) {
						_this2.props.setWithoutBroadcast({
							currentTime: target.currentTime
						});
						_this2.props.setWithoutBroadcast({
							currentTime: 0,
							paused: true
						});
					}
				});
				this.props.onLoad && this.props.onLoad(this);
			}
		}, {
			key: 'componentWillUnmount',
			value: function componentWillUnmount() {
				var _this3 = this;
	
				this.reset();
				if (fullScreenEnabled) {
					fullScreenChangeEvents.forEach(function (event) {
						document.removeEventListener(event, _this3.fullScreenChangeListener);
					});
				}
			}
		}, {
			key: 'reset',
			value: function reset() {
				this.target.src = '';
				this.target.load();
				if (this.updateTimer) {
					clearInterval(this.updateTimer);
					this.updateTimer = null;
				}
				this.setState(initState);
				this.props.reset();
			}
		}, {
			key: 'onTextChange',
			value: function onTextChange(e, value) {
				this.setState({
					textToBeSent: value
				});
			}
		}, {
			key: 'send',
			value: function send() {
				if (this.state.textToBeSent) {
					(0, _messages.broadcast)(_messages.CHAT, this.state.textToBeSent);
					this.setState({
						textToBeSent: ''
					});
				}
			}
		}, {
			key: 'handleProgressBarChange',
			value: function handleProgressBarChange(e, currentTime) {
				this.props.set({
					realTime: currentTime
				});
				this.target.currentTime = currentTime;
			}
		}, {
			key: 'updateProgress',
			value: function updateProgress() {
				var duration = this.target.duration || this.props.duration;
				var realTime = this.target.currentTime;
				if (this.props.videoReady) {
					this.props.set({ duration: duration, realTime: realTime });
				}
			}
		}, {
			key: 'handleDocumentMouseUp',
			value: function handleDocumentMouseUp() {
				if (this.isSeeking) {
					this.isSeeking = false;
					this.props.set({
						currentTime: this.props.realTime
					});
				}
			}
		}, {
			key: 'play',
			value: function play(time) {
				this.togglePlay(true, time);
			}
		}, {
			key: 'pause',
			value: function pause(time) {
				this.togglePlay(false, time);
			}
		}, {
			key: 'togglePlay',
			value: function togglePlay() {
				var start = arguments.length <= 0 || arguments[0] === undefined ? this.target.paused : arguments[0];
				var currentTime = arguments[1];
	
				this.props.set({ paused: !start });
				if (currentTime !== undefined) {
					this.props.set({ currentTime: currentTime });
				}
			}
		}, {
			key: 'toggleFullScreen',
			value: function toggleFullScreen() {
				if (!this.props.fullScreen) {
					if (this.fullScreenWrapper.requestFullscreen) this.fullScreenWrapper.requestFullscreen();else if (this.fullScreenWrapper.mozRequestFullScreen) this.fullScreenWrapper.mozRequestFullScreen();else if (this.fullScreenWrapper.webkitRequestFullScreen) this.fullScreenWrapper.webkitRequestFullScreen();else if (this.fullScreenWrapper.msRequestFullscreen) this.fullScreenWrapper.msRequestFullscreen();
				} else {
					if (document.exitFullscreen) document.exitFullscreen();else if (document.mozCancelFullScreen) document.mozCancelFullScreen();else if (document.webkitCancelFullScreen) document.webkitCancelFullScreen();else if (document.msExitFullscreen) document.msExitFullscreen();
				}
			}
		}, {
			key: 'fullScreenChangeListener',
			value: function fullScreenChangeListener() {
				this.props.set({
					fullScreen: isFullScreen(),
					hideVideoControl: false
				});
			}
		}, {
			key: 'showVideoControl',
			value: function showVideoControl() {
				this.clearHideVideoControlTimer();
				this.setState({
					hideVideoControl: false
				});
			}
		}, {
			key: 'flashVideoControl',
			value: function flashVideoControl() {
				if (!this.props.fullScreen) {
					return;
				}
				this.setHideVideoControlTimer();
				this.setState({
					hideVideoControl: false
				});
			}
		}, {
			key: 'setHideVideoControlTimer',
			value: function setHideVideoControlTimer() {
				var _this4 = this;
	
				this.clearHideVideoControlTimer();
				if (this.props.fullScreen) {
					this.__hideVideoControlTimer = setTimeout(function () {
						if (_this4.props.fullScreen) {
							_this4.setState({
								hideVideoControl: true
							});
						}
					}, 1000);
				}
			}
		}, {
			key: 'clearHideVideoControlTimer',
			value: function clearHideVideoControlTimer() {
				if (this.__hideVideoControlTimer) {
					clearTimeout(this.__hideVideoControlTimer);
				}
			}
		}, {
			key: 'toggleMuted',
			value: function toggleMuted() {
				this.props.set({
					muted: !this.props.muted
				});
			}
		}, {
			key: 'openVolumeBar',
			value: function openVolumeBar() {
				if (!this.state.volumeBarOpen) {
					this.setState({
						volumeBarOpen: true
					});
				}
			}
		}, {
			key: 'closeVolumeBar',
			value: function closeVolumeBar() {
				this.setState({
					volumeBarOpen: false
				});
			}
		}, {
			key: 'handleVolumeChange',
			value: function handleVolumeChange(e) {
				this.props.set({
					volume: e.target.value
				});
			}
		}, {
			key: 'render',
			value: function render() {
				var _this5 = this;
	
				var smallStyle = {
					width: 30,
					height: 30,
					padding: 0
				};
				var iconLarge = {
					width: 30,
					height: 30
				};
				var iconMedium = {
					width: 24,
					height: 24
				};
				return _react2.default.createElement(
					_Paper2.default,
					{ className: (0, _classnames2.default)('video', {
							'full-screen': this.props.fullScreen,
							'hide-video-control': this.state.hideVideoControl
						}) },
					_react2.default.createElement(
						'div',
						{ ref: 'fullScreenWrapper', className: 'full-screen-wrapper' },
						_react2.default.createElement('video', {
							ref: 'target',
							onTouchTap: this.flashVideoControl,
							onMouseMove: this.flashVideoControl
						}),
						_react2.default.createElement(_CircularProgress2.default, {
							className: (0, _classnames2.default)('video-loader', {
								hidden: !this.props.isLoading
							})
						}),
						_react2.default.createElement(
							'ul',
							{ className: 'video-status' },
							this.props.statusStack.map(function (status, index) {
								return _react2.default.createElement(
									'li',
									{ key: 'status' + index },
									status
								);
							})
						),
						_react2.default.createElement(
							'div',
							{
								className: 'text-sender',
								onMouseOver: this.showVideoControl
							},
							_react2.default.createElement(_TextField2.default, {
								id: 'inputField',
								className: 'input-field',
								underlineShow: false,
								hintText: 'You can text here',
								onChange: this.onTextChange,
								value: this.state.textToBeSent,
								onKeyDown: function onKeyDown(e) {
									if (e.keyCode === 13) _this5.send();
								}
							}),
							_react2.default.createElement(
								'a',
								{ className: 'submit-button', onTouchTap: this.send },
								'SEND'
							)
						),
						_react2.default.createElement(
							'div',
							{
								className: 'control-bar',
								onMouseOver: this.showVideoControl
							},
							_react2.default.createElement(
								_IconButton2.default,
								{
									style: smallStyle,
									iconStyle: iconLarge,
									onTouchTap: function onTouchTap() {
										return _this5.togglePlay();
									},
									disabled: !this.props.videoReady
								},
								this.props.paused ? _react2.default.createElement(_playArrow2.default, null) : _react2.default.createElement(_pause2.default, null)
							),
							_react2.default.createElement(_Slider2.default, {
								className: 'progress-bar',
								min: 0,
								max: this.props.duration || 1,
								value: this.props.duration > this.props.realTime ? this.props.realTime : 0,
								onChange: this.handleProgressBarChange,
								disabled: !this.props.videoReady,
								onMouseDown: function onMouseDown() {
									return _this5.isSeeking = true;
								}
							}),
							_react2.default.createElement(
								'span',
								{ className: 'video-time' },
								toHHMMSS(this.props.realTime),
								'/',
								toHHMMSS(this.props.duration)
							),
							_react2.default.createElement(
								'div',
								null,
								_react2.default.createElement(
									_IconButton2.default,
									{
										style: smallStyle,
										iconStyle: iconMedium,
										onTouchTap: this.toggleMuted,
										onMouseOver: this.openVolumeBar,
										onMouseLeave: this.closeVolumeBar
									},
									this.props.muted ? _react2.default.createElement(_volumeOff2.default, null) : _react2.default.createElement(_volumeUp2.default, null)
								),
								_react2.default.createElement(
									_Paper2.default,
									{
										className: (0, _classnames2.default)('volume-bar', {
											hidden: !this.state.volumeBarOpen
										}),
										onMouseOver: this.openVolumeBar,
										onMouseLeave: this.closeVolumeBar
									},
									_react2.default.createElement('input', {
										className: 'volume-slider',
										type: 'range',
										min: '0',
										max: '1',
										step: '0.1',
										value: this.props.volume,
										disabled: this.props.muted,
										onChange: this.handleVolumeChange
									})
								)
							),
							fullScreenEnabled && _react2.default.createElement(
								_IconButton2.default,
								{
									style: smallStyle,
									iconStyle: iconMedium,
									onTouchTap: this.toggleFullScreen
								},
								this.props.fullScreen ? _react2.default.createElement(_fullscreenExit2.default, null) : _react2.default.createElement(_fullscreen2.default, null)
							)
						)
					)
				);
			}
		}]);
	
		return Video;
	}(_react2.default.Component);
	
	Video.propTypes = {
		paused: _react.PropTypes.bool,
		currentTime: _react.PropTypes.number,
		onLoad: _react.PropTypes.func
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
		return state.video;
	}, function (dispatch) {
		return (0, _redux.bindActionCreators)(_actions.videoActions, dispatch);
	})(Video);
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	__webpack_require__(231);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(74);
	
	var _store = __webpack_require__(105);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _reactTapEventPlugin = __webpack_require__(482);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _reactRedux = __webpack_require__(41);
	
	var _MuiThemeProvider = __webpack_require__(165);
	
	var _MuiThemeProvider2 = _interopRequireDefault(_MuiThemeProvider);
	
	var _container = __webpack_require__(426);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _entry = __webpack_require__(427);
	
	var _entry2 = _interopRequireDefault(_entry);
	
	var _room = __webpack_require__(428);
	
	var _room2 = _interopRequireDefault(_room);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactTapEventPlugin2.default)();
	
	(0, _reactDom.render)(_react2.default.createElement(
		_MuiThemeProvider2.default,
		null,
		_react2.default.createElement(
			_reactRedux.Provider,
			{ store: _store2.default },
			_react2.default.createElement(
				_reactRouter.Router,
				{ history: _reactRouter.browserHistory },
				_react2.default.createElement(
					_reactRouter.Route,
					{ path: '/', component: _container2.default },
					_react2.default.createElement(_reactRouter.IndexRoute, { component: _entry2.default }),
					_react2.default.createElement(_reactRouter.Route, { path: '/room/:id', component: _room2.default })
				)
			)
		)
	), document.querySelector('#app'));
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(38);
	
	var _room = __webpack_require__(433);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _user = __webpack_require__(434);
	
	var _user2 = _interopRequireDefault(_user);
	
	var _video = __webpack_require__(435);
	
	var _video2 = _interopRequireDefault(_video);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _redux.combineReducers)({ room: _room2.default, user: _user2.default, video: _video2.default });
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "index.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var state = arguments.length <= 0 || arguments[0] === undefined ? initState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case _actions.roomActions.SET_ID:
				return Object.assign({}, state, {
					id: action.id
				});
			case _actions.roomActions.SET_TORRENTS:
				return Object.assign({}, state, {
					torrents: action.torrents || []
				});
			case _actions.roomActions.SET_CONVERSATION_ID:
				return Object.assign({}, state, {
					conversationId: action.conversationId
				});
			case _actions.roomActions.ADD_MESSAGE:
				return Object.assign({}, state, {
					messages: [].concat(_toConsumableArray(state.messages), [action.message])
				});
			case _actions.roomActions.CLEAR_MESSAGES:
				return Object.assign({}, state, {
					messages: []
				});
			case _actions.roomActions.SET_VIEWERS_COUNT:
				return Object.assign({}, state, {
					viewersCount: action.viewersCount
				});
			default:
				return state;
		}
	};
	
	var _actions = __webpack_require__(21);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var initState = {
		id: '',
		torrents: [],
		conversationId: '',
		viewersCount: 0,
		messages: []
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "room.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = function () {
		var state = arguments.length <= 0 || arguments[0] === undefined ? initState : arguments[0];
		var action = arguments[1];
	
		var _ret = function () {
			switch (action.type) {
				case _actions.userActions.SET_NAME:
					localStorage.setItem('name', action.name);
					return {
						v: Object.assign({}, state, {
							name: action.name
						})
					};
				case _actions.userActions.OPEN_NAME_DIALOG:
					return {
						v: Object.assign({}, state, {
							nameDialogOpen: true
						})
					};
				case _actions.userActions.CLOSE_NAME_DIALOG:
					return {
						v: Object.assign({}, state, {
							nameDialogOpen: state.nameRequired && !state.name
						})
					};
				case _actions.userActions.SET_NAME_REQUIRED:
					return {
						v: Object.assign({}, state, {
							nameRequired: action.required,
							nameDialogOpen: state.nameDialogOpen || action.required && !state.name
						})
					};
				case _actions.userActions.JOIN_ROOM:
					var roomId = action.roomId;
					var roomIndex = state.recentlyJoined.findIndex(function (value) {
						return value.roomId === roomId;
					});
					var recentlyJoined = state.recentlyJoined.slice();
					if (roomIndex >= 0) {
						recentlyJoined.splice(roomIndex, 1);
					}
					recentlyJoined.unshift({
						roomId: roomId,
						time: formatTime(new Date())
					});
					localStorage.setItem('recentlyJoined', JSON.stringify(recentlyJoined));
					return {
						v: Object.assign({}, state, { recentlyJoined: recentlyJoined })
					};
				case _actions.userActions.CLEAR_RECENTLY_JOINED:
					localStorage.setItem('recentlyJoined', '[]');
					return {
						v: Object.assign({}, state, {
							recentlyJoined: []
						})
					};
				default:
					return {
						v: state
					};
			}
		}();
	
		if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	};
	
	var _actions = __webpack_require__(21);
	
	if (!localStorage.getItem('id')) {
		localStorage.setItem('id', Date.now().toString(36) + Math.random().toString(36).substring(2));
	}
	var recentlyJoined = localStorage.getItem('recentlyJoined');
	var initState = {
		id: localStorage.getItem('id'),
		name: localStorage.getItem('name') || '',
		nameDialogOpen: !localStorage.getItem('name'),
		nameRequired: false,
		recentlyJoined: recentlyJoined ? JSON.parse(recentlyJoined) : []
	};
	
	var formatTime = function formatTime(date) {
		return date.toLocaleDateString() + ' ' + date.getHours() + ':' + date.getMinutes();
	};
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "user.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	/* REACT HOT LOADER */ if (false) { (function () { var ReactHotAPI = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	exports.default = function () {
		var state = arguments.length <= 0 || arguments[0] === undefined ? initState : arguments[0];
		var action = arguments[1];
	
		switch (action.type) {
			case _actions.videoActions.SET:
				return onSet(state, action, {
					disableBroadcast: false
				});
			case _actions.videoActions.SET_WITHOUT_BROADCAST:
				return onSet(state, action, {
					disableBroadcast: true
				});
			case _actions.videoActions.PUSH_STATUS:
				return Object.assign({}, state, {
					statusStack: state.statusStack.concat([action.status])
				});
			case _actions.videoActions.CLEAR_STATUS:
				return Object.assign({}, state, {
					statusStack: []
				});
			case _actions.videoActions.RESET:
				return Object.assign({}, initState);
			default:
				return state;
		}
	};
	
	var _actions = __webpack_require__(21);
	
	if (isNaN(parseFloat(localStorage.getItem('videoVolume')))) {
		localStorage.setItem('videoVolume', 0.5);
	}
	
	var initState = {
		paused: true,
		currentTime: 0,
		fullScreen: false,
		mute: false,
		volume: parseFloat(localStorage.getItem('videoVolume')),
		muted: false,
		statusStack: [],
		isLoading: false,
		duration: 0,
		videoReady: false,
		realTime: 0,
		disableBroadcast: false
	};
	
	function onSet(state, action) {
		var extraData = arguments.length <= 2 || arguments[2] === undefined ? {} : arguments[2];
	
		var data = Object.assign({}, action.data, extraData);
		if (!isNaN(parseFloat(data.volume))) {
			localStorage.setItem('videoVolume', data.volume);
		}
		if (data.currentTime !== undefined) {
			data.realTime = data.currentTime;
		}
		return Object.assign({}, state, data);
	}
	
	/* REACT HOT LOADER */ }).call(this); } finally { if (false) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/Users/imsun/code/web/avtogether/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot not apply hot update to " + "video.js" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = undefined;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(171);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _warning = __webpack_require__(172);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2["default"])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  Provider.prototype.getChildContext = function getChildContext() {
	    return { store: this.store };
	  };
	
	  function Provider(props, context) {
	    _classCallCheck(this, Provider);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	    _this.store = props.store;
	    return _this;
	  }
	
	  Provider.prototype.render = function render() {
	    var children = this.props.children;
	
	    return _react.Children.only(children);
	  };
	
	  return Provider;
	}(_react.Component);
	
	exports["default"] = Provider;
	
	if (false) {
	  Provider.prototype.componentWillReceiveProps = function (nextProps) {
	    var store = this.store;
	    var nextStore = nextProps.store;
	
	    if (store !== nextStore) {
	      warnAboutReceivingStore();
	    }
	  };
	}
	
	Provider.propTypes = {
	  store: _storeShape2["default"].isRequired,
	  children: _react.PropTypes.element.isRequired
	};
	Provider.childContextTypes = {
	  store: _storeShape2["default"].isRequired
	};

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.__esModule = true;
	exports["default"] = connect;
	
	var _react = __webpack_require__(1);
	
	var _storeShape = __webpack_require__(171);
	
	var _storeShape2 = _interopRequireDefault(_storeShape);
	
	var _shallowEqual = __webpack_require__(438);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _wrapActionCreators = __webpack_require__(439);
	
	var _wrapActionCreators2 = _interopRequireDefault(_wrapActionCreators);
	
	var _warning = __webpack_require__(172);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _isPlainObject = __webpack_require__(445);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _hoistNonReactStatics = __webpack_require__(440);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(441);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultMapStateToProps = function defaultMapStateToProps(state) {
	  return {};
	}; // eslint-disable-line no-unused-vars
	var defaultMapDispatchToProps = function defaultMapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	};
	var defaultMergeProps = function defaultMergeProps(stateProps, dispatchProps, parentProps) {
	  return _extends({}, parentProps, stateProps, dispatchProps);
	};
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	var errorObject = { value: null };
	function tryCatch(fn, ctx) {
	  try {
	    return fn.apply(ctx);
	  } catch (e) {
	    errorObject.value = e;
	    return errorObject;
	  }
	}
	
	// Helps track hot reloading.
	var nextVersion = 0;
	
	function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	  var options = arguments.length <= 3 || arguments[3] === undefined ? {} : arguments[3];
	
	  var shouldSubscribe = Boolean(mapStateToProps);
	  var mapState = mapStateToProps || defaultMapStateToProps;
	
	  var mapDispatch = undefined;
	  if (typeof mapDispatchToProps === 'function') {
	    mapDispatch = mapDispatchToProps;
	  } else if (!mapDispatchToProps) {
	    mapDispatch = defaultMapDispatchToProps;
	  } else {
	    mapDispatch = (0, _wrapActionCreators2["default"])(mapDispatchToProps);
	  }
	
	  var finalMergeProps = mergeProps || defaultMergeProps;
	  var _options$pure = options.pure;
	  var pure = _options$pure === undefined ? true : _options$pure;
	  var _options$withRef = options.withRef;
	  var withRef = _options$withRef === undefined ? false : _options$withRef;
	
	  var checkMergedEquals = pure && finalMergeProps !== defaultMergeProps;
	
	  // Helps track hot reloading.
	  var version = nextVersion++;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var connectDisplayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	
	    function checkStateShape(props, methodName) {
	      if (!(0, _isPlainObject2["default"])(props)) {
	        (0, _warning2["default"])(methodName + '() in ' + connectDisplayName + ' must return a plain object. ' + ('Instead received ' + props + '.'));
	      }
	    }
	
	    function computeMergedProps(stateProps, dispatchProps, parentProps) {
	      var mergedProps = finalMergeProps(stateProps, dispatchProps, parentProps);
	      if (false) {
	        checkStateShape(mergedProps, 'mergeProps');
	      }
	      return mergedProps;
	    }
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return !pure || this.haveOwnPropsChanged || this.hasStoreStateChanged;
	      };
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.store = props.store || context.store;
	
	        (0, _invariant2["default"])(_this.store, 'Could not find "store" in either the context or ' + ('props of "' + connectDisplayName + '". ') + 'Either wrap the root component in a <Provider>, ' + ('or explicitly pass "store" as a prop to "' + connectDisplayName + '".'));
	
	        var storeState = _this.store.getState();
	        _this.state = { storeState: storeState };
	        _this.clearCache();
	        return _this;
	      }
	
	      Connect.prototype.computeStateProps = function computeStateProps(store, props) {
	        if (!this.finalMapStateToProps) {
	          return this.configureFinalMapState(store, props);
	        }
	
	        var state = store.getState();
	        var stateProps = this.doStatePropsDependOnOwnProps ? this.finalMapStateToProps(state, props) : this.finalMapStateToProps(state);
	
	        if (false) {
	          checkStateShape(stateProps, 'mapStateToProps');
	        }
	        return stateProps;
	      };
	
	      Connect.prototype.configureFinalMapState = function configureFinalMapState(store, props) {
	        var mappedState = mapState(store.getState(), props);
	        var isFactory = typeof mappedState === 'function';
	
	        this.finalMapStateToProps = isFactory ? mappedState : mapState;
	        this.doStatePropsDependOnOwnProps = this.finalMapStateToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeStateProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedState, 'mapStateToProps');
	        }
	        return mappedState;
	      };
	
	      Connect.prototype.computeDispatchProps = function computeDispatchProps(store, props) {
	        if (!this.finalMapDispatchToProps) {
	          return this.configureFinalMapDispatch(store, props);
	        }
	
	        var dispatch = store.dispatch;
	
	        var dispatchProps = this.doDispatchPropsDependOnOwnProps ? this.finalMapDispatchToProps(dispatch, props) : this.finalMapDispatchToProps(dispatch);
	
	        if (false) {
	          checkStateShape(dispatchProps, 'mapDispatchToProps');
	        }
	        return dispatchProps;
	      };
	
	      Connect.prototype.configureFinalMapDispatch = function configureFinalMapDispatch(store, props) {
	        var mappedDispatch = mapDispatch(store.dispatch, props);
	        var isFactory = typeof mappedDispatch === 'function';
	
	        this.finalMapDispatchToProps = isFactory ? mappedDispatch : mapDispatch;
	        this.doDispatchPropsDependOnOwnProps = this.finalMapDispatchToProps.length !== 1;
	
	        if (isFactory) {
	          return this.computeDispatchProps(store, props);
	        }
	
	        if (false) {
	          checkStateShape(mappedDispatch, 'mapDispatchToProps');
	        }
	        return mappedDispatch;
	      };
	
	      Connect.prototype.updateStatePropsIfNeeded = function updateStatePropsIfNeeded() {
	        var nextStateProps = this.computeStateProps(this.store, this.props);
	        if (this.stateProps && (0, _shallowEqual2["default"])(nextStateProps, this.stateProps)) {
	          return false;
	        }
	
	        this.stateProps = nextStateProps;
	        return true;
	      };
	
	      Connect.prototype.updateDispatchPropsIfNeeded = function updateDispatchPropsIfNeeded() {
	        var nextDispatchProps = this.computeDispatchProps(this.store, this.props);
	        if (this.dispatchProps && (0, _shallowEqual2["default"])(nextDispatchProps, this.dispatchProps)) {
	          return false;
	        }
	
	        this.dispatchProps = nextDispatchProps;
	        return true;
	      };
	
	      Connect.prototype.updateMergedPropsIfNeeded = function updateMergedPropsIfNeeded() {
	        var nextMergedProps = computeMergedProps(this.stateProps, this.dispatchProps, this.props);
	        if (this.mergedProps && checkMergedEquals && (0, _shallowEqual2["default"])(nextMergedProps, this.mergedProps)) {
	          return false;
	        }
	
	        this.mergedProps = nextMergedProps;
	        return true;
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return typeof this.unsubscribe === 'function';
	      };
	
	      Connect.prototype.trySubscribe = function trySubscribe() {
	        if (shouldSubscribe && !this.unsubscribe) {
	          this.unsubscribe = this.store.subscribe(this.handleChange.bind(this));
	          this.handleChange();
	        }
	      };
	
	      Connect.prototype.tryUnsubscribe = function tryUnsubscribe() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	          this.unsubscribe = null;
	        }
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        this.trySubscribe();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (!pure || !(0, _shallowEqual2["default"])(nextProps, this.props)) {
	          this.haveOwnPropsChanged = true;
	        }
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.tryUnsubscribe();
	        this.clearCache();
	      };
	
	      Connect.prototype.clearCache = function clearCache() {
	        this.dispatchProps = null;
	        this.stateProps = null;
	        this.mergedProps = null;
	        this.haveOwnPropsChanged = true;
	        this.hasStoreStateChanged = true;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	        this.renderedElement = null;
	        this.finalMapDispatchToProps = null;
	        this.finalMapStateToProps = null;
	      };
	
	      Connect.prototype.handleChange = function handleChange() {
	        if (!this.unsubscribe) {
	          return;
	        }
	
	        var storeState = this.store.getState();
	        var prevStoreState = this.state.storeState;
	        if (pure && prevStoreState === storeState) {
	          return;
	        }
	
	        if (pure && !this.doStatePropsDependOnOwnProps) {
	          var haveStatePropsChanged = tryCatch(this.updateStatePropsIfNeeded, this);
	          if (!haveStatePropsChanged) {
	            return;
	          }
	          if (haveStatePropsChanged === errorObject) {
	            this.statePropsPrecalculationError = errorObject.value;
	          }
	          this.haveStatePropsBeenPrecalculated = true;
	        }
	
	        this.hasStoreStateChanged = true;
	        this.setState({ storeState: storeState });
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2["default"])(withRef, 'To access the wrapped instance, you need to specify ' + '{ withRef: true } as the fourth argument of the connect() call.');
	
	        return this.refs.wrappedInstance;
	      };
	
	      Connect.prototype.render = function render() {
	        var haveOwnPropsChanged = this.haveOwnPropsChanged;
	        var hasStoreStateChanged = this.hasStoreStateChanged;
	        var haveStatePropsBeenPrecalculated = this.haveStatePropsBeenPrecalculated;
	        var statePropsPrecalculationError = this.statePropsPrecalculationError;
	        var renderedElement = this.renderedElement;
	
	        this.haveOwnPropsChanged = false;
	        this.hasStoreStateChanged = false;
	        this.haveStatePropsBeenPrecalculated = false;
	        this.statePropsPrecalculationError = null;
	
	        if (statePropsPrecalculationError) {
	          throw statePropsPrecalculationError;
	        }
	
	        var shouldUpdateStateProps = true;
	        var shouldUpdateDispatchProps = true;
	        if (pure && renderedElement) {
	          shouldUpdateStateProps = hasStoreStateChanged || haveOwnPropsChanged && this.doStatePropsDependOnOwnProps;
	          shouldUpdateDispatchProps = haveOwnPropsChanged && this.doDispatchPropsDependOnOwnProps;
	        }
	
	        var haveStatePropsChanged = false;
	        var haveDispatchPropsChanged = false;
	        if (haveStatePropsBeenPrecalculated) {
	          haveStatePropsChanged = true;
	        } else if (shouldUpdateStateProps) {
	          haveStatePropsChanged = this.updateStatePropsIfNeeded();
	        }
	        if (shouldUpdateDispatchProps) {
	          haveDispatchPropsChanged = this.updateDispatchPropsIfNeeded();
	        }
	
	        var haveMergedPropsChanged = true;
	        if (haveStatePropsChanged || haveDispatchPropsChanged || haveOwnPropsChanged) {
	          haveMergedPropsChanged = this.updateMergedPropsIfNeeded();
	        } else {
	          haveMergedPropsChanged = false;
	        }
	
	        if (!haveMergedPropsChanged && renderedElement) {
	          return renderedElement;
	        }
	
	        if (withRef) {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, _extends({}, this.mergedProps, {
	            ref: 'wrappedInstance'
	          }));
	        } else {
	          this.renderedElement = (0, _react.createElement)(WrappedComponent, this.mergedProps);
	        }
	
	        return this.renderedElement;
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = connectDisplayName;
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.contextTypes = {
	      store: _storeShape2["default"]
	    };
	    Connect.propTypes = {
	      store: _storeShape2["default"]
	    };
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        if (this.version === version) {
	          return;
	        }
	
	        // We are hot reloading!
	        this.version = version;
	        this.trySubscribe();
	        this.clearCache();
	      };
	    }
	
	    return (0, _hoistNonReactStatics2["default"])(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 438 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = shallowEqual;
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var hasOwn = Object.prototype.hasOwnProperty;
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = wrapActionCreators;
	
	var _redux = __webpack_require__(38);
	
	function wrapActionCreators(actionCreators) {
	  return function (dispatch) {
	    return (0, _redux.bindActionCreators)(actionCreators, dispatch);
	  };
	}

/***/ },
/* 440 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 442 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	module.exports = getPrototype;


/***/ },
/* 443 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 444 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	var getPrototype = __webpack_require__(442),
	    isHostObject = __webpack_require__(443),
	    isObjectLike = __webpack_require__(444);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object,
	 *  else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	module.exports = isPlainObject;


/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _InternalPropTypes = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A mixin that adds the "history" instance variable to components.
	 */
	var History = {
	
	  contextTypes: {
	    history: _InternalPropTypes.history
	  },
	
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `History` mixin is deprecated, please access `context.router` with your own `contextTypes`. http://tiny.cc/router-historymixin') : void 0;
	    this.history = this.context.history;
	  }
	};
	
	exports.default = History;
	module.exports = exports['default'];

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Link = __webpack_require__(173);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = _react2.default.createClass({
	  displayName: 'IndexLink',
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(174);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var object = _React$PropTypes.object;
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	
	var IndexRedirect = _react2.default.createClass({
	  displayName: 'IndexRedirect',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: string.isRequired,
	    query: object,
	    state: object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(29);
	
	var _InternalPropTypes = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var func = _react2.default.PropTypes.func;
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	
	var IndexRoute = _react2.default.createClass({
	  displayName: 'IndexRoute',
	
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The Lifecycle mixin adds the routerWillLeave lifecycle method to a
	 * component that may be used to cancel a transition or prompt the user
	 * for confirmation.
	 *
	 * On standard transitions, routerWillLeave receives a single argument: the
	 * location we're transitioning to. To cancel the transition, return false.
	 * To prompt the user for confirmation, return a prompt message (string).
	 *
	 * During the beforeunload event (assuming you're using the useBeforeUnload
	 * history enhancer), routerWillLeave does not receive a location object
	 * because it isn't possible for us to know the location we're transitioning
	 * to. In this case routerWillLeave must return a prompt message to prevent
	 * the user from closing the window/tab.
	 */
	
	var Lifecycle = {
	
	  contextTypes: {
	    history: object.isRequired,
	    // Nested children receive the route as context, either
	    // set by the route component using the RouteContext mixin
	    // or by some other ancestor.
	    route: object
	  },
	
	  propTypes: {
	    // Route components receive the route object as a prop.
	    route: object
	  },
	
	  componentDidMount: function componentDidMount() {
	     false ? (0, _routerWarning2.default)(false, 'the `Lifecycle` mixin is deprecated, please use `context.router.setRouteLeaveHook(route, hook)`. http://tiny.cc/router-lifecyclemixin') : void 0;
	    !this.routerWillLeave ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin requires you to define a routerWillLeave method') : (0, _invariant2.default)(false) : void 0;
	
	    var route = this.props.route || this.context.route;
	
	    !route ?  false ? (0, _invariant2.default)(false, 'The Lifecycle mixin must be used on either a) a <Route component> or ' + 'b) a descendant of a <Route component> that uses the RouteContext mixin') : (0, _invariant2.default)(false) : void 0;
	
	    this._unlistenBeforeLeavingRoute = this.context.history.listenBeforeLeavingRoute(route, this.routerWillLeave);
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlistenBeforeLeavingRoute) this._unlistenBeforeLeavingRoute();
	  }
	};
	
	exports.default = Lifecycle;
	module.exports = exports['default'];

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(29);
	
	var _InternalPropTypes = __webpack_require__(35);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _React$PropTypes = _react2.default.PropTypes;
	var string = _React$PropTypes.string;
	var func = _React$PropTypes.func;
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	
	var Route = _react2.default.createClass({
	  displayName: 'Route',
	
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: func,
	    getComponents: func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var object = _react2.default.PropTypes.object;
	
	/**
	 * The RouteContext mixin provides a convenient way for route
	 * components to set the route in context. This is needed for
	 * routes that render elements that want to use the Lifecycle
	 * mixin to prevent transitions.
	 */
	
	var RouteContext = {
	
	  propTypes: {
	    route: object.isRequired
	  },
	
	  childContextTypes: {
	    route: object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      route: this.props.route
	    };
	  },
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, 'The `RouteContext` mixin is deprecated. You can provide `this.props.route` on context with your own `contextTypes`. http://tiny.cc/router-routecontextmixin') : void 0;
	  }
	};
	
	exports.default = RouteContext;
	module.exports = exports['default'];

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createHashHistory = __webpack_require__(182);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _useQueries = __webpack_require__(76);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createTransitionManager = __webpack_require__(108);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _InternalPropTypes = __webpack_require__(35);
	
	var _RouterContext = __webpack_require__(72);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(29);
	
	var _RouterUtils = __webpack_require__(175);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isDeprecatedHistory(history) {
	  return !history || !history.__v2_compatible__;
	}
	
	/* istanbul ignore next: sanity check */
	function isUnsupportedHistory(history) {
	  // v3 histories expose getCurrentLocation, but aren't currently supported.
	  return history && history.getCurrentLocation;
	}
	
	var _React$PropTypes = _react2.default.PropTypes;
	var func = _React$PropTypes.func;
	var object = _React$PropTypes.object;
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	
	var Router = _react2.default.createClass({
	  displayName: 'Router',
	
	
	  propTypes: {
	    history: object,
	    children: _InternalPropTypes.routes,
	    routes: _InternalPropTypes.routes, // alias for children
	    render: func,
	    createElement: func,
	    onError: func,
	    onUpdate: func,
	
	    // PRIVATE: For client-side rehydration of server match.
	    matchContext: object
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    var _props = this.props;
	    var parseQueryString = _props.parseQueryString;
	    var stringifyQuery = _props.stringifyQuery;
	
	     false ? (0, _routerWarning2.default)(!(parseQueryString || stringifyQuery), '`parseQueryString` and `stringifyQuery` are deprecated. Please create a custom history. http://tiny.cc/router-customquerystring') : void 0;
	
	    var _createRouterObjects = this.createRouterObjects();
	
	    var history = _createRouterObjects.history;
	    var transitionManager = _createRouterObjects.transitionManager;
	    var router = _createRouterObjects.router;
	
	
	    this._unlisten = transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	
	    this.history = history;
	    this.router = router;
	  },
	  createRouterObjects: function createRouterObjects() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext;
	    }
	
	    var history = this.props.history;
	    var _props2 = this.props;
	    var routes = _props2.routes;
	    var children = _props2.children;
	
	
	    !!isUnsupportedHistory(history) ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v3.x. ' + 'This version of React Router is not compatible with v3 history ' + 'objects. Please use history v2.x instead.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isDeprecatedHistory(history)) {
	      history = this.wrapDeprecatedHistory(history);
	    }
	
	    var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	    var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	    var routingHistory = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	    return { history: routingHistory, transitionManager: transitionManager, router: router };
	  },
	  wrapDeprecatedHistory: function wrapDeprecatedHistory(history) {
	    var _props3 = this.props;
	    var parseQueryString = _props3.parseQueryString;
	    var stringifyQuery = _props3.stringifyQuery;
	
	
	    var createHistory = void 0;
	    if (history) {
	       false ? (0, _routerWarning2.default)(false, 'It appears you have provided a deprecated history object to `<Router/>`, please use a history provided by ' + 'React Router with `import { browserHistory } from \'react-router\'` or `import { hashHistory } from \'react-router\'`. ' + 'If you are using a custom history please create it with `useRouterHistory`, see http://tiny.cc/router-usinghistory for details.') : void 0;
	      createHistory = function createHistory() {
	        return history;
	      };
	    } else {
	       false ? (0, _routerWarning2.default)(false, '`Router` no longer defaults the history prop to hash history. Please use the `hashHistory` singleton instead. http://tiny.cc/router-defaulthistory') : void 0;
	      createHistory = _createHashHistory2.default;
	    }
	
	    return (0, _useQueries2.default)(createHistory)({ parseQueryString: parseQueryString, stringifyQuery: stringifyQuery });
	  },
	
	
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state;
	    var location = _state.location;
	    var routes = _state.routes;
	    var params = _state.params;
	    var components = _state.components;
	    var _props4 = this.props;
	    var createElement = _props4.createElement;
	    var render = _props4.render;
	
	    var props = _objectWithoutProperties(_props4, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(Router.propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      history: this.history,
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(72);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RoutingContext = _react2.default.createClass({
	  displayName: 'RoutingContext',
	  componentWillMount: function componentWillMount() {
	     false ? (0, _routerWarning2.default)(false, '`RoutingContext` has been renamed to `RouterContext`. Please use `import { RouterContext } from \'react-router\'`. http://tiny.cc/router-routercontext') : void 0;
	  },
	  render: function render() {
	    return _react2.default.createElement(_RouterContext2.default, this.props);
	  }
	});
	
	exports.default = RoutingContext;
	module.exports = exports['default'];

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.runEnterHooks = runEnterHooks;
	exports.runChangeHooks = runChangeHooks;
	exports.runLeaveHooks = runLeaveHooks;
	
	var _AsyncUtils = __webpack_require__(106);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createTransitionHook(hook, route, asyncArity) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    hook.apply(route, args);
	
	    if (hook.length < asyncArity) {
	      var callback = args[args.length - 1];
	      // Assume hook executes synchronously and
	      // automatically call the callback.
	      callback();
	    }
	  };
	}
	
	function getEnterHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3));
	
	    return hooks;
	  }, []);
	}
	
	function getChangeHooks(routes) {
	  return routes.reduce(function (hooks, route) {
	    if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4));
	    return hooks;
	  }, []);
	}
	
	function runTransitionHooks(length, iter, callback) {
	  if (!length) {
	    callback();
	    return;
	  }
	
	  var redirectInfo = void 0;
	  function replace(location, deprecatedPathname, deprecatedQuery) {
	    if (deprecatedPathname) {
	       false ? (0, _routerWarning2.default)(false, '`replaceState(state, pathname, query) is deprecated; use `replace(location)` with a location descriptor instead. http://tiny.cc/router-isActivedeprecated') : void 0;
	      redirectInfo = {
	        pathname: deprecatedPathname,
	        query: deprecatedQuery,
	        state: location
	      };
	
	      return;
	    }
	
	    redirectInfo = location;
	  }
	
	  (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	    iter(index, replace, function (error) {
	      if (error || redirectInfo) {
	        done(error, redirectInfo); // No need to continue.
	      } else {
	          next();
	        }
	    });
	  }, callback);
	}
	
	/**
	 * Runs all onEnter hooks in the given array of routes in order
	 * with onEnter(nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runEnterHooks(routes, nextState, callback) {
	  var hooks = getEnterHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onChange hooks in the given array of routes in order
	 * with onChange(prevState, nextState, replace, callback) and calls
	 * callback(error, redirectInfo) when finished. The first hook
	 * to use replace short-circuits the loop.
	 *
	 * If a hook needs to run asynchronously, it may use the callback
	 * function. However, doing so will cause the transition to pause,
	 * which could lead to a non-responsive UI if the hook is slow.
	 */
	function runChangeHooks(routes, state, nextState, callback) {
	  var hooks = getChangeHooks(routes);
	  return runTransitionHooks(hooks.length, function (index, replace, next) {
	    hooks[index](state, nextState, replace, next);
	  }, callback);
	}
	
	/**
	 * Runs all onLeave hooks in the given array of routes in order.
	 */
	function runLeaveHooks(routes) {
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    if (routes[i].onLeave) routes[i].onLeave.call(routes[i]);
	  }
	}

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(72);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  var withContext = middlewares.map(function (m) {
	    return m.renderRouterContext;
	  }).filter(function (f) {
	    return f;
	  });
	  var withComponent = middlewares.map(function (m) {
	    return m.renderRouteComponent;
	  }).filter(function (f) {
	    return f;
	  });
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length <= 0 || arguments[0] === undefined ? _react.createElement : arguments[0];
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(468);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(177);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(42);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    (function () {
	      var parentIsLeaving = false;
	      leaveRoutes = prevRoutes.filter(function (route) {
	        if (parentIsLeaving) {
	          return true;
	        } else {
	          var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	          if (isLeaving) parentIsLeaving = true;
	          return isLeaving;
	        }
	      });
	
	      // onLeave hooks start at the leaf route.
	      leaveRoutes.reverse();
	
	      enterRoutes = [];
	      changeRoutes = [];
	
	      nextRoutes.forEach(function (route) {
	        var isNew = prevRoutes.indexOf(route) === -1;
	        var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	        if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	      });
	    })();
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(106);
	
	var _makeStateWithLocation = __webpack_require__(178);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (!getComponent) {
	    callback();
	    return;
	  }
	
	  var location = nextState.location;
	
	  var nextStateWithLocation = (0, _makeStateWithLocation2.default)(nextState, location);
	
	  getComponent.call(route, nextStateWithLocation, callback);
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(42);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(182);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(177);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(42);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname;
	  var query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(176);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(108);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(29);
	
	var _RouterUtils = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history;
	  var routes = _ref.routes;
	  var location = _ref.location;
	
	  var options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  var unlisten = void 0;
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    // Pick up the location from the history via synchronous history.listen
	    // call if needed.
	    unlisten = history.listen(function (historyLocation) {
	      location = historyLocation;
	    });
	  }
	
	  var router = (0, _RouterUtils.createRouterObject)(history, transitionManager);
	  history = (0, _RouterUtils.createRoutingHistory)(history, transitionManager);
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    callback(error, redirectLocation, nextState && _extends({}, nextState, {
	      history: history,
	      router: router,
	      matchContext: { history: history, transitionManager: transitionManager, router: router }
	    }));
	
	    // Defer removing the listener to here to prevent DOM histories from having
	    // to unwind DOM event listeners unnecessarily, in case callback renders a
	    // <Router> and attaches another history listener.
	    if (unlisten) {
	      unlisten();
	    }
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(106);
	
	var _makeStateWithLocation = __webpack_require__(178);
	
	var _makeStateWithLocation2 = _interopRequireDefault(_makeStateWithLocation);
	
	var _PatternUtils = __webpack_require__(42);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(29);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	  route.getChildRoutes(partialNextStateWithLocation, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var partialNextStateWithLocation = (0, _makeStateWithLocation2.default)(partialNextState, location);
	
	    route.getIndexRoute(partialNextStateWithLocation, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	  } else if (route.childRoutes) {
	    (function () {
	      var pathless = route.childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    })();
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var _ret2 = function () {
	        var match = {
	          routes: [route],
	          params: createParams(paramNames, paramValues)
	        };
	
	        getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	          if (error) {
	            callback(error);
	          } else {
	            if (Array.isArray(indexRoute)) {
	              var _match$routes;
	
	               false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	                return !route.path;
	              }), 'Index routes should not have paths') : void 0;
	              (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	            } else if (indexRoute) {
	               false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	              match.routes.push(indexRoute);
	            }
	
	            callback(null, match);
	          }
	        });
	
	        return {
	          v: void 0
	        };
	      }();
	
	      if ((typeof _ret2 === 'undefined' ? 'undefined' : _typeof(_ret2)) === "object") return _ret2.v;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length <= 4 || arguments[4] === undefined ? [] : arguments[4];
	  var paramValues = arguments.length <= 5 || arguments[5] === undefined ? [] : arguments[5];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _useQueries = __webpack_require__(76);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _createTransitionManager = __webpack_require__(108);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _routerWarning = __webpack_require__(11);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know about routing.
	 *
	 * Enhances history objects with the following methods:
	 *
	 * - listen((error, nextState) => {})
	 * - listenBeforeLeavingRoute(route, (nextLocation) => {})
	 * - match(location, (error, redirectLocation, nextState) => {})
	 * - isActive(pathname, query, indexOnly=false)
	 */
	function useRoutes(createHistory) {
	   false ? (0, _routerWarning2.default)(false, '`useRoutes` is deprecated. Please use `createTransitionManager` instead.') : void 0;
	
	  return function () {
	    var _ref = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	    var routes = _ref.routes;
	
	    var options = _objectWithoutProperties(_ref, ['routes']);
	
	    var history = (0, _useQueries2.default)(createHistory)(options);
	    var transitionManager = (0, _createTransitionManager2.default)(history, routes);
	    return _extends({}, history, transitionManager);
	  };
	}
	
	exports.default = useRoutes;
	module.exports = exports['default'];

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _hoistNonReactStatics = __webpack_require__(476);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _PropTypes = __webpack_require__(107);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent) {
	  var WithRouter = _react2.default.createClass({
	    displayName: 'WithRouter',
	
	    contextTypes: { router: _PropTypes.routerShape },
	    render: function render() {
	      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, { router: this.context.router }));
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 467 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var _slice = Array.prototype.slice;
	exports.loopAsync = loopAsync;
	
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = undefined;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(_slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Actions = __webpack_require__(43);
	
	var _PathUtils = __webpack_require__(36);
	
	var _ExecutionEnvironment = __webpack_require__(75);
	
	var _DOMUtils = __webpack_require__(109);
	
	var _DOMStateStorage = __webpack_require__(180);
	
	var _createDOMHistory = __webpack_require__(181);
	
	var _createDOMHistory2 = _interopRequireDefault(_createDOMHistory);
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve URLs.
	 */
	function createBrowserHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? _invariant2['default'](false, 'Browser history needs a DOM') : _invariant2['default'](false) : undefined;
	
	  var forceRefresh = options.forceRefresh;
	
	  var isSupported = _DOMUtils.supportsHistory();
	  var useRefresh = !isSupported || forceRefresh;
	
	  function getCurrentLocation(historyState) {
	    try {
	      historyState = historyState || window.history.state || {};
	    } catch (e) {
	      historyState = {};
	    }
	
	    var path = _DOMUtils.getWindowPath();
	    var _historyState = historyState;
	    var key = _historyState.key;
	
	    var state = undefined;
	    if (key) {
	      state = _DOMStateStorage.readState(key);
	    } else {
	      state = null;
	      key = history.createKey();
	
	      if (isSupported) window.history.replaceState(_extends({}, historyState, { key: key }), null);
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function startPopStateListener(_ref) {
	    var transitionTo = _ref.transitionTo;
	
	    function popStateListener(event) {
	      if (event.state === undefined) return; // Ignore extraneous popstate events in WebKit.
	
	      transitionTo(getCurrentLocation(event.state));
	    }
	
	    _DOMUtils.addEventListener(window, 'popstate', popStateListener);
	
	    return function () {
	      _DOMUtils.removeEventListener(window, 'popstate', popStateListener);
	    };
	  }
	
	  function finishTransition(location) {
	    var basename = location.basename;
	    var pathname = location.pathname;
	    var search = location.search;
	    var hash = location.hash;
	    var state = location.state;
	    var action = location.action;
	    var key = location.key;
	
	    if (action === _Actions.POP) return; // Nothing to do.
	
	    _DOMStateStorage.saveState(key, state);
	
	    var path = (basename || '') + pathname + search + hash;
	    var historyState = {
	      key: key
	    };
	
	    if (action === _Actions.PUSH) {
	      if (useRefresh) {
	        window.location.href = path;
	        return false; // Prevent location update.
	      } else {
	          window.history.pushState(historyState, null, path);
	        }
	    } else {
	      // REPLACE
	      if (useRefresh) {
	        window.location.replace(path);
	        return false; // Prevent location update.
	      } else {
	          window.history.replaceState(historyState, null, path);
	        }
	    }
	  }
	
	  var history = _createDOMHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: _DOMStateStorage.saveState
	  }));
	
	  var listenerCount = 0,
	      stopPopStateListener = undefined;
	
	  function listenBefore(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listenBefore(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  function listen(listener) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    var unlisten = history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopPopStateListener();
	    };
	  }
	
	  // deprecated
	  function registerTransitionHook(hook) {
	    if (++listenerCount === 1) stopPopStateListener = startPopStateListener(history);
	
	    history.registerTransitionHook(hook);
	  }
	
	  // deprecated
	  function unregisterTransitionHook(hook) {
	    history.unregisterTransitionHook(hook);
	
	    if (--listenerCount === 0) stopPopStateListener();
	  }
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    registerTransitionHook: registerTransitionHook,
	    unregisterTransitionHook: unregisterTransitionHook
	  });
	}
	
	exports['default'] = createBrowserHistory;
	module.exports = exports['default'];

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Actions = __webpack_require__(43);
	
	var _PathUtils = __webpack_require__(36);
	
	function createLocation() {
	  var location = arguments.length <= 0 || arguments[0] === undefined ? '/' : arguments[0];
	  var action = arguments.length <= 1 || arguments[1] === undefined ? _Actions.POP : arguments[1];
	  var key = arguments.length <= 2 || arguments[2] === undefined ? null : arguments[2];
	
	  var _fourthArg = arguments.length <= 3 || arguments[3] === undefined ? null : arguments[3];
	
	  if (typeof location === 'string') location = _PathUtils.parsePath(location);
	
	  if (typeof action === 'object') {
	     false ? _warning2['default'](false, 'The state (2nd) argument to createLocation is deprecated; use a ' + 'location descriptor instead') : undefined;
	
	    location = _extends({}, location, { state: action });
	
	    action = key || _Actions.POP;
	    key = _fourthArg;
	  }
	
	  var pathname = location.pathname || '/';
	  var search = location.search || '';
	  var hash = location.hash || '';
	  var state = location.state || null;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	}
	
	exports['default'] = createLocation;
	module.exports = exports['default'];

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _warning = __webpack_require__(17);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(13);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PathUtils = __webpack_require__(36);
	
	var _Actions = __webpack_require__(43);
	
	var _createHistory = __webpack_require__(183);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	}
	
	function createMemoryHistory() {
	  var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var history = _createHistory2['default'](_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    finishTransition: finishTransition,
	    saveState: saveState,
	    go: go
	  }));
	
	  var _options = options;
	  var entries = _options.entries;
	  var current = _options.current;
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    var key = history.createKey();
	
	    if (typeof entry === 'string') return { pathname: entry, key: key };
	
	    if (typeof entry === 'object' && entry) return _extends({}, entry, { key: key });
	
	     true ?  false ? _invariant2['default'](false, 'Unable to create history entry from %s', entry) : _invariant2['default'](false) : undefined;
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? _invariant2['default'](false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : _invariant2['default'](false) : undefined;
	  }
	
	  var storage = createStateStorage(entries);
	
	  function saveState(key, state) {
	    storage[key] = state;
	  }
	
	  function readState(key) {
	    return storage[key];
	  }
	
	  function getCurrentLocation() {
	    var entry = entries[current];
	    var basename = entry.basename;
	    var pathname = entry.pathname;
	    var search = entry.search;
	
	    var path = (basename || '') + pathname + (search || '');
	
	    var key = undefined,
	        state = undefined;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    } else {
	      key = history.createKey();
	      state = null;
	      entry.key = key;
	    }
	
	    var location = _PathUtils.parsePath(path);
	
	    return history.createLocation(_extends({}, location, { state: state }), undefined, key);
	  }
	
	  function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  }
	
	  function go(n) {
	    if (n) {
	      if (!canGo(n)) {
	         false ? _warning2['default'](false, 'Cannot go(%s) there is not enough history', n) : undefined;
	        return;
	      }
	
	      current += n;
	
	      var currentLocation = getCurrentLocation();
	
	      // change action to POP
	      history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	    }
	  }
	
	  function finishTransition(location) {
	    switch (location.action) {
	      case _Actions.PUSH:
	        current += 1;
	
	        // if we are not on the top of stack
	        // remove rest and push new
	        if (current < entries.length) entries.splice(current);
	
	        entries.push(location);
	        saveState(location.key, location.state);
	        break;
	      case _Actions.REPLACE:
	        entries[current] = location;
	        saveState(location.key, location.state);
	        break;
	    }
	  }
	
	  return history;
	}
	
	exports['default'] = createMemoryHistory;
	module.exports = exports['default'];

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	var pSlice = Array.prototype.slice;
	var objectKeys = __webpack_require__(473);
	var isArguments = __webpack_require__(472);
	
	var deepEqual = module.exports = function (actual, expected, opts) {
	  if (!opts) opts = {};
	  // 7.1. All identical values are equivalent, as determined by ===.
	  if (actual === expected) {
	    return true;
	
	  } else if (actual instanceof Date && expected instanceof Date) {
	    return actual.getTime() === expected.getTime();
	
	  // 7.3. Other pairs that do not both pass typeof value == 'object',
	  // equivalence is determined by ==.
	  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
	    return opts.strict ? actual === expected : actual == expected;
	
	  // 7.4. For all other Object pairs, including Array objects, equivalence is
	  // determined by having the same number of owned properties (as verified
	  // with Object.prototype.hasOwnProperty.call), the same set of keys
	  // (although not necessarily the same order), equivalent values for every
	  // corresponding key, and an identical 'prototype' property. Note: this
	  // accounts for both named and indexed properties on Arrays.
	  } else {
	    return objEquiv(actual, expected, opts);
	  }
	}
	
	function isUndefinedOrNull(value) {
	  return value === null || value === undefined;
	}
	
	function isBuffer (x) {
	  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
	  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
	    return false;
	  }
	  if (x.length > 0 && typeof x[0] !== 'number') return false;
	  return true;
	}
	
	function objEquiv(a, b, opts) {
	  var i, key;
	  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
	    return false;
	  // an identical 'prototype' property.
	  if (a.prototype !== b.prototype) return false;
	  //~~~I've managed to break Object.keys through screwy arguments passing.
	  //   Converting to array solves the problem.
	  if (isArguments(a)) {
	    if (!isArguments(b)) {
	      return false;
	    }
	    a = pSlice.call(a);
	    b = pSlice.call(b);
	    return deepEqual(a, b, opts);
	  }
	  if (isBuffer(a)) {
	    if (!isBuffer(b)) {
	      return false;
	    }
	    if (a.length !== b.length) return false;
	    for (i = 0; i < a.length; i++) {
	      if (a[i] !== b[i]) return false;
	    }
	    return true;
	  }
	  try {
	    var ka = objectKeys(a),
	        kb = objectKeys(b);
	  } catch (e) {//happens when one is a string literal and the other isn't
	    return false;
	  }
	  // having the same number of owned properties (keys incorporates
	  // hasOwnProperty)
	  if (ka.length != kb.length)
	    return false;
	  //the same set of keys (although not necessarily the same order),
	  ka.sort();
	  kb.sort();
	  //~~~cheap key test
	  for (i = ka.length - 1; i >= 0; i--) {
	    if (ka[i] != kb[i])
	      return false;
	  }
	  //equivalent values for every corresponding key, and
	  //~~~possibly expensive deep test
	  for (i = ka.length - 1; i >= 0; i--) {
	    key = ka[i];
	    if (!deepEqual(a[key], b[key], opts)) return false;
	  }
	  return typeof a === typeof b;
	}


/***/ },
/* 472 */
/***/ function(module, exports) {

	var supportsArgumentsClass = (function(){
	  return Object.prototype.toString.call(arguments)
	})() == '[object Arguments]';
	
	exports = module.exports = supportsArgumentsClass ? supported : unsupported;
	
	exports.supported = supported;
	function supported(object) {
	  return Object.prototype.toString.call(object) == '[object Arguments]';
	};
	
	exports.unsupported = unsupported;
	function unsupported(object){
	  return object &&
	    typeof object == 'object' &&
	    typeof object.length == 'number' &&
	    Object.prototype.hasOwnProperty.call(object, 'callee') &&
	    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
	    false;
	};


/***/ },
/* 473 */
/***/ function(module, exports) {

	exports = module.exports = typeof Object.keys === 'function'
	  ? Object.keys : shim;
	
	exports.shim = shim;
	function shim (obj) {
	  var keys = [];
	  for (var key in obj) keys.push(key);
	  return keys;
	}


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(475);
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str) {
		if (typeof str !== 'string') {
			return {};
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return {};
		}
	
		return str.split('&').reduce(function (ret, param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			key = decodeURIComponent(key);
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			if (!ret.hasOwnProperty(key)) {
				ret[key] = val;
			} else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			} else {
				ret[key] = [ret[key], val];
			}
	
			return ret;
		}, {});
	};
	
	exports.stringify = function (obj) {
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return key;
			}
	
			if (Array.isArray(val)) {
				return val.slice().sort().map(function (val2) {
					return strictUriEncode(key) + '=' + strictUriEncode(val2);
				}).join('&');
			}
	
			return strictUriEncode(key) + '=' + strictUriEncode(val);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 475 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 476 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    arguments: true,
	    arity: true
	};
	
	var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	        var keys = Object.getOwnPropertyNames(sourceComponent);
	
	        /* istanbul ignore else */
	        if (isGetOwnPropertySymbolsAvailable) {
	            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
	                try {
	                    targetComponent[keys[i]] = sourceComponent[keys[i]];
	                } catch (error) {
	
	                }
	            }
	        }
	    }
	
	    return targetComponent;
	};


/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule invariant
	 */
	
	"use strict";
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function (condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error('Invariant Violation: ' + format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;

/***/ },
/* 478 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyOf
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	"use strict";
	
	var keyOf = function (oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(22);
	var EventPluginUtils = __webpack_require__(78);
	var EventPropagators = __webpack_require__(47);
	var SyntheticUIEvent = __webpack_require__(50);
	var TouchEventUtils = __webpack_require__(480);
	var ViewportMetrics = __webpack_require__(123);
	
	var keyOf = __webpack_require__(478);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    topLevelTypes.topTouchCancel,
	    topLevelTypes.topTouchEnd,
	    topLevelTypes.topTouchStart,
	    topLevelTypes.topTouchMove
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  topLevelTypes.topTouchStart,
	  topLevelTypes.topTouchCancel,
	  topLevelTypes.topTouchEnd,
	  topLevelTypes.topTouchMove,
	];
	
	var dependencies = [
	  topLevelTypes.topMouseDown,
	  topLevelTypes.topMouseMove,
	  topLevelTypes.topMouseUp,
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ },
/* 480 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ },
/* 481 */
/***/ function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(477);
	var defaultClickRejectionStrategy = __webpack_require__(481);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(46).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(479)(shouldRejectClick)
	  });
	};


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AutoFocusUtils
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var focusNode = __webpack_require__(215);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BeforeInputEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(22);
	var EventPropagators = __webpack_require__(47);
	var ExecutionEnvironment = __webpack_require__(14);
	var FallbackCompositionState = __webpack_require__(490);
	var SyntheticCompositionEvent = __webpack_require__(529);
	var SyntheticInputEvent = __webpack_require__(532);
	
	var keyOf = __webpack_require__(31);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBeforeInput: null }),
	      captured: keyOf({ onBeforeInputCapture: null })
	    },
	    dependencies: [topLevelTypes.topCompositionEnd, topLevelTypes.topKeyPress, topLevelTypes.topTextInput, topLevelTypes.topPaste]
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionEnd: null }),
	      captured: keyOf({ onCompositionEndCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionEnd, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionStart: null }),
	      captured: keyOf({ onCompositionStartCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionStart, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCompositionUpdate: null }),
	      captured: keyOf({ onCompositionUpdateCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topCompositionUpdate, topLevelTypes.topKeyDown, topLevelTypes.topKeyPress, topLevelTypes.topKeyUp, topLevelTypes.topMouseDown]
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionStart:
	      return eventTypes.compositionStart;
	    case topLevelTypes.topCompositionEnd:
	      return eventTypes.compositionEnd;
	    case topLevelTypes.topCompositionUpdate:
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === topLevelTypes.topKeyDown && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topKeyUp:
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case topLevelTypes.topKeyDown:
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case topLevelTypes.topKeyPress:
	    case topLevelTypes.topMouseDown:
	    case topLevelTypes.topBlur:
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case topLevelTypes.topCompositionEnd:
	      return getDataFromCustomEvent(nativeEvent);
	    case topLevelTypes.topKeyPress:
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case topLevelTypes.topTextInput:
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  if (currentComposition) {
	    if (topLevelType === topLevelTypes.topCompositionEnd || isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case topLevelTypes.topPaste:
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case topLevelTypes.topKeyPress:
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case topLevelTypes.topCompositionEnd:
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CSSPropertyOperations
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(185);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactInstrumentation = __webpack_require__(15);
	
	var camelizeStyleName = __webpack_require__(548);
	var dangerousStyleValue = __webpack_require__(539);
	var hyphenateStyleName = __webpack_require__(555);
	var memoizeStringOnly = __webpack_require__(559);
	var warning = __webpack_require__(5);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Style property values shouldn\'t contain a semicolon.%s ' + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var styleValue = styles[styleName];
	      if (false) {
	        warnValidStyle(styleName, styleValue, component);
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation(component._debugID, 'update styles', styles);
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      if (false) {
	        warnValidStyle(styleName, styles[styleName], component);
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ChangeEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(22);
	var EventPluginHub = __webpack_require__(46);
	var EventPropagators = __webpack_require__(47);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(23);
	var SyntheticEvent = __webpack_require__(25);
	
	var getEventTarget = __webpack_require__(127);
	var isEventSupported = __webpack_require__(128);
	var isTextInputElement = __webpack_require__(212);
	var keyOf = __webpack_require__(31);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onChange: null }),
	      captured: keyOf({ onChangeCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topChange, topLevelTypes.topClick, topLevelTypes.topFocus, topLevelTypes.topInput, topLevelTypes.topKeyDown, topLevelTypes.topKeyUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	var activeElementValue = null;
	var activeElementValueProp = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!('documentMode' in document) || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topChange) {
	    return targetInst;
	  }
	}
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	  // IE10+ fire input events to often, such when a placeholder
	  // changes or when an input with a placeholder is focused.
	  isInputEventSupported = isEventSupported('input') && (!('documentMode' in document) || document.documentMode > 11);
	}
	
	/**
	 * (For IE <=11) Replacement getter/setter for the `value` property that gets
	 * set on the active element.
	 */
	var newValueProp = {
	  get: function () {
	    return activeElementValueProp.get.call(this);
	  },
	  set: function (val) {
	    // Cast to a string so we can do equality checks.
	    activeElementValue = '' + val;
	    activeElementValueProp.set.call(this, val);
	  }
	};
	
	/**
	 * (For IE <=11) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElementValue = target.value;
	  activeElementValueProp = Object.getOwnPropertyDescriptor(target.constructor.prototype, 'value');
	
	  // Not guarded in a canDefineProperty check: IE8 supports defineProperty only
	  // on DOM elements
	  Object.defineProperty(activeElement, 'value', newValueProp);
	  if (activeElement.attachEvent) {
	    activeElement.attachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.addEventListener('propertychange', handlePropertyChange, false);
	  }
	}
	
	/**
	 * (For IE <=11) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	
	  // delete restores the original property definition
	  delete activeElement.value;
	
	  if (activeElement.detachEvent) {
	    activeElement.detachEvent('onpropertychange', handlePropertyChange);
	  } else {
	    activeElement.removeEventListener('propertychange', handlePropertyChange, false);
	  }
	
	  activeElement = null;
	  activeElementInst = null;
	  activeElementValue = null;
	  activeElementValueProp = null;
	}
	
	/**
	 * (For IE <=11) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  var value = nativeEvent.srcElement.value;
	  if (value === activeElementValue) {
	    return;
	  }
	  activeElementValue = value;
	
	  manualDispatchChangeEvent(nativeEvent);
	}
	
	/**
	 * If a `change` event should be fired, returns the target's ID.
	 */
	function getTargetInstForInputEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topInput) {
	    // In modern browsers (i.e., not IE8 or IE9), the input event is exactly
	    // what we want so fall through here and trigger an abstract event
	    return targetInst;
	  }
	}
	
	function handleEventsForInputEventIE(topLevelType, target, targetInst) {
	  if (topLevelType === topLevelTypes.topFocus) {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9-11, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === topLevelTypes.topBlur) {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventIE(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topSelectionChange || topLevelType === topLevelTypes.topKeyUp || topLevelType === topLevelTypes.topKeyDown) {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    if (activeElement && activeElement.value !== activeElementValue) {
	      activeElementValue = activeElement.value;
	      return activeElementInst;
	    }
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  return elem.nodeName && elem.nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst) {
	  if (topLevelType === topLevelTypes.topClick) {
	    return targetInst;
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventIE;
	        handleEventFunc = handleEventsForInputEventIE;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst);
	      if (inst) {
	        var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, nativeEventTarget);
	        event.type = 'change';
	        EventPropagators.accumulateTwoPhaseDispatches(event);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	  }
	
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Danger
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var DOMLazyTree = __webpack_require__(44);
	var ExecutionEnvironment = __webpack_require__(14);
	
	var createNodesFromMarkup = __webpack_require__(551);
	var emptyFunction = __webpack_require__(16);
	var invariant = __webpack_require__(3);
	
	var Danger = {
	
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	
	};
	
	module.exports = Danger;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultEventPluginOrder
	 */
	
	'use strict';
	
	var keyOf = __webpack_require__(31);
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	var DefaultEventPluginOrder = [keyOf({ ResponderEventPlugin: null }), keyOf({ SimpleEventPlugin: null }), keyOf({ TapEventPlugin: null }), keyOf({ EnterLeaveEventPlugin: null }), keyOf({ ChangeEventPlugin: null }), keyOf({ SelectEventPlugin: null }), keyOf({ BeforeInputEventPlugin: null })];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EnterLeaveEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(22);
	var EventPropagators = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticMouseEvent = __webpack_require__(80);
	
	var keyOf = __webpack_require__(31);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: keyOf({ onMouseEnter: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  },
	  mouseLeave: {
	    registrationName: keyOf({ onMouseLeave: null }),
	    dependencies: [topLevelTypes.topMouseOut, topLevelTypes.topMouseOver]
	  }
	};
	
	var EnterLeaveEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === topLevelTypes.topMouseOver && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== topLevelTypes.topMouseOut && topLevelType !== topLevelTypes.topMouseOver) {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === topLevelTypes.topMouseOut) {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule FallbackCompositionState
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(30);
	
	var getTextContentAccessor = __webpack_require__(210);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule HTMLDOMPropertyConfig
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {}
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactChildReconciler
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(49);
	
	var instantiateReactComponent = __webpack_require__(211);
	var KeyEscapeUtils = __webpack_require__(115);
	var shouldUpdateReactComponent = __webpack_require__(129);
	var traverseAllChildren = __webpack_require__(130);
	var warning = __webpack_require__(5);
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    var ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	    process.env.NODE_ENV !== 'production' ? warning(keyUnique, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeDevtool.getStackAddendumByID(selfDebugID)) : void 0;
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID // __DEV__ only
	  ) {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, removedNodes, transaction, context) {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	
	};
	
	module.exports = ReactChildReconciler;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactCompositeComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var ReactComponentEnvironment = __webpack_require__(118);
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactElement = __webpack_require__(18);
	var ReactErrorUtils = __webpack_require__(119);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(15);
	var ReactNodeTypes = __webpack_require__(200);
	var ReactPropTypeLocations = __webpack_require__(121);
	var ReactReconciler = __webpack_require__(49);
	
	var checkReactTypeSpec = __webpack_require__(538);
	
	var emptyObject = __webpack_require__(83);
	var invariant = __webpack_require__(3);
	var shouldUpdateReactComponent = __webpack_require__(129);
	var warning = __webpack_require__(5);
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || ReactElement.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function invokeComponentDidMountWithTimer() {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	  publicInstance.componentDidMount();
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidMount');
	  }
	}
	
	function invokeComponentDidUpdateWithTimer(prevProps, prevState, prevContext) {
	  var publicInstance = this._instance;
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	  publicInstance.componentDidUpdate(prevProps, prevState, prevContext);
	  if (this._debugID !== 0) {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentDidUpdate');
	  }
	}
	
	function shouldConstruct(Component) {
	  return Component.prototype && Component.prototype.isReactComponent;
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponentMixin = {
	
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var inst = this._constructComponent(publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!shouldConstruct(Component) && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || ReactElement.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + 'up the same props that your component\'s constructor was passed.', componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidMountWithTimer, this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	    var instanceOrElement;
	    if (shouldConstruct(Component)) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	      instanceOrElement = new Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'ctor');
	        }
	      }
	    } else {
	      // This can still be an instance in case of factory components
	      // but we'll count this as time spent rendering as the more common case.
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	      instanceOrElement = Component(publicProps, publicContext, updateQueue);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	        }
	      }
	    }
	    return instanceOrElement;
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onError();
	        }
	      }
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	    if (inst.componentWillMount) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      inst.componentWillMount();
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillMount');
	        }
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	    if (false) {
	      if (child._debugID !== 0 && this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	      }
	    }
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context));
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        inst.componentWillUnmount();
	      }
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUnmount');
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = null;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, ReactPropTypeLocations.context);
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    if (false) {
	      ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	    }
	    var childContext = inst.getChildContext && inst.getChildContext();
	    if (false) {
	      ReactInstrumentation.debugTool.onEndProcessingChildContext();
	    }
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, ReactPropTypeLocations.childContext);
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	    var nextProps;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	      inst.componentWillReceiveProps(nextProps, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillReceiveProps');
	        }
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate && inst.shouldComponentUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	        }
	      }
	      shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'shouldComponentUpdate');
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	      inst.componentWillUpdate(nextProps, nextState, nextContext);
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'componentWillUpdate');
	        }
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(invokeComponentDidUpdateWithTimer.bind(this, prevProps, prevState, prevContext), this);
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	      if (false) {
	        if (child._debugID !== 0 && this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetParent(child._debugID, this._debugID);
	        }
	      }
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context));
	
	      if (false) {
	        if (this._debugID !== 0) {
	          ReactInstrumentation.debugTool.onSetChildren(this._debugID, child._debugID !== 0 ? [child._debugID] : []);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeginLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	    var renderedComponent = inst.render();
	    if (false) {
	      if (this._debugID !== 0) {
	        ReactInstrumentation.debugTool.onEndLifeCycleTimer(this._debugID, 'render');
	      }
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedComponent === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedComponent = null;
	      }
	    }
	
	    return renderedComponent;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedComponent;
	    ReactCurrentOwner.current = this;
	    try {
	      renderedComponent = this._renderValidatedComponentWithoutOwnerOrContext();
	    } finally {
	      ReactCurrentOwner.current = null;
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedComponent === null || renderedComponent === false || ReactElement.isValidElement(renderedComponent)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedComponent;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (inst instanceof StatelessComponent) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	
	};
	
	var ReactCompositeComponent = {
	
	  Mixin: ReactCompositeComponentMixin
	
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOM
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDefaultInjection = __webpack_require__(510);
	var ReactMount = __webpack_require__(198);
	var ReactReconciler = __webpack_require__(49);
	var ReactUpdates = __webpack_require__(23);
	var ReactVersion = __webpack_require__(203);
	
	var findDOMNode = __webpack_require__(540);
	var getHostComponentFromComposite = __webpack_require__(208);
	var renderSubtreeIntoContainer = __webpack_require__(546);
	var warning = __webpack_require__(5);
	
	ReactDefaultInjection.inject();
	
	var React = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	/* eslint-enable camelcase */
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, 'It looks like you\'re using a minified copy of the development build ' + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.split, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	module.exports = React;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMButton
	 */
	
	'use strict';
	
	var DisabledInputUtils = __webpack_require__(77);
	
	/**
	 * Implements a <button> host component that does not receive mouse events
	 * when `disabled` is set.
	 */
	var ReactDOMButton = {
	  getHostProps: DisabledInputUtils.getHostProps
	};
	
	module.exports = ReactDOMButton;

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMComponent
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var AutoFocusUtils = __webpack_require__(483);
	var CSSPropertyOperations = __webpack_require__(485);
	var DOMLazyTree = __webpack_require__(44);
	var DOMNamespaces = __webpack_require__(113);
	var DOMProperty = __webpack_require__(45);
	var DOMPropertyOperations = __webpack_require__(187);
	var EventConstants = __webpack_require__(22);
	var EventPluginHub = __webpack_require__(46);
	var EventPluginRegistry = __webpack_require__(114);
	var ReactBrowserEventEmitter = __webpack_require__(79);
	var ReactComponentBrowserEnvironment = __webpack_require__(191);
	var ReactDOMButton = __webpack_require__(495);
	var ReactDOMComponentFlags = __webpack_require__(192);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMInput = __webpack_require__(502);
	var ReactDOMOption = __webpack_require__(504);
	var ReactDOMSelect = __webpack_require__(193);
	var ReactDOMTextarea = __webpack_require__(507);
	var ReactInstrumentation = __webpack_require__(15);
	var ReactMultiChild = __webpack_require__(516);
	var ReactServerRenderingTransaction = __webpack_require__(520);
	
	var emptyFunction = __webpack_require__(16);
	var escapeTextContentForBrowser = __webpack_require__(81);
	var invariant = __webpack_require__(3);
	var isEventSupported = __webpack_require__(128);
	var keyOf = __webpack_require__(31);
	var shallowEqual = __webpack_require__(217);
	var validateDOMNesting = __webpack_require__(131);
	var warning = __webpack_require__(5);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { 'string': true, 'number': true };
	
	var STYLE = keyOf({ style: null });
	var HTML = keyOf({ __html: null });
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), 'This browser doesn\'t support the `onScroll` event') : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setContentChildForInstrumentation = emptyFunction;
	if (false) {
	  setContentChildForInstrumentation = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    var contentDebugID = debugID + '#text';
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    this._contentDebugID = contentDebugID;
	    var text = '' + content;
	
	    ReactInstrumentation.debugTool.onSetDisplayName(contentDebugID, '#text');
	    ReactInstrumentation.debugTool.onSetParent(contentDebugID, debugID);
	    ReactInstrumentation.debugTool.onSetText(contentDebugID, text);
	
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes[event], mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topError, 'error', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topLoad, 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topReset, 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topSubmit, 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent(EventConstants.topLevelTypes.topInvalid, 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  'area': true,
	  'base': true,
	  'br': true,
	  'col': true,
	  'embed': true,
	  'hr': true,
	  'img': true,
	  'input': true,
	  'keygen': true,
	  'link': true,
	  'meta': true,
	  'param': true,
	  'source': true,
	  'track': true,
	  'wbr': true
	};
	
	// NOTE: menuitem's close tag should be omitted, but that causes problems.
	var newlineEatingTags = {
	  'listing': true,
	  'pre': true,
	  'textarea': true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  'menuitem': true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = null;
	  this._domID = null;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setContentChildForInstrumentation.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the containing DOM component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'button':
	        props = ReactDOMButton.getHostProps(this, props, hostParent);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        if (false) {
	          setContentChildForInstrumentation.call(this, contentToUse);
	        }
	        DOMLazyTree.queueText(lazyTree, contentToUse);
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'button':
	        lastProps = ReactDOMButton.getHostProps(this, lastProps);
	        nextProps = ReactDOMButton.getHostProps(this, nextProps);
	        break;
	      case 'input':
	        ReactDOMInput.updateWrapper(this);
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    if (this._tag === 'select') {
	      // <select> value update needs to occur after <option> children
	      // reconciliation
	      transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setContentChildForInstrumentation.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setContentChildForInstrumentation.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    ReactComponentBrowserEnvironment.unmountIDFromEnvironment(this._rootNodeID);
	    this._rootNodeID = null;
	    this._domID = null;
	    this._wrapperState = null;
	
	    if (false) {
	      setContentChildForInstrumentation.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMContainerInfo
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(131);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMEmptyComponent
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var DOMLazyTree = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = null;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFactories
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(18);
	
	var mapObject = __webpack_require__(558);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @param {string} tag Tag name (e.g. `div`).
	 * @private
	 */
	function createDOMFactory(tag) {
	  if (false) {
	    var ReactElementValidator = require('./ReactElementValidator');
	    return ReactElementValidator.createFactory(tag);
	  }
	  return ReactElement.createFactory(tag);
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 * This is also accessible via `React.DOM`.
	 *
	 * @public
	 */
	var ReactDOMFactories = mapObject({
	  a: 'a',
	  abbr: 'abbr',
	  address: 'address',
	  area: 'area',
	  article: 'article',
	  aside: 'aside',
	  audio: 'audio',
	  b: 'b',
	  base: 'base',
	  bdi: 'bdi',
	  bdo: 'bdo',
	  big: 'big',
	  blockquote: 'blockquote',
	  body: 'body',
	  br: 'br',
	  button: 'button',
	  canvas: 'canvas',
	  caption: 'caption',
	  cite: 'cite',
	  code: 'code',
	  col: 'col',
	  colgroup: 'colgroup',
	  data: 'data',
	  datalist: 'datalist',
	  dd: 'dd',
	  del: 'del',
	  details: 'details',
	  dfn: 'dfn',
	  dialog: 'dialog',
	  div: 'div',
	  dl: 'dl',
	  dt: 'dt',
	  em: 'em',
	  embed: 'embed',
	  fieldset: 'fieldset',
	  figcaption: 'figcaption',
	  figure: 'figure',
	  footer: 'footer',
	  form: 'form',
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  head: 'head',
	  header: 'header',
	  hgroup: 'hgroup',
	  hr: 'hr',
	  html: 'html',
	  i: 'i',
	  iframe: 'iframe',
	  img: 'img',
	  input: 'input',
	  ins: 'ins',
	  kbd: 'kbd',
	  keygen: 'keygen',
	  label: 'label',
	  legend: 'legend',
	  li: 'li',
	  link: 'link',
	  main: 'main',
	  map: 'map',
	  mark: 'mark',
	  menu: 'menu',
	  menuitem: 'menuitem',
	  meta: 'meta',
	  meter: 'meter',
	  nav: 'nav',
	  noscript: 'noscript',
	  object: 'object',
	  ol: 'ol',
	  optgroup: 'optgroup',
	  option: 'option',
	  output: 'output',
	  p: 'p',
	  param: 'param',
	  picture: 'picture',
	  pre: 'pre',
	  progress: 'progress',
	  q: 'q',
	  rp: 'rp',
	  rt: 'rt',
	  ruby: 'ruby',
	  s: 's',
	  samp: 'samp',
	  script: 'script',
	  section: 'section',
	  select: 'select',
	  small: 'small',
	  source: 'source',
	  span: 'span',
	  strong: 'strong',
	  style: 'style',
	  sub: 'sub',
	  summary: 'summary',
	  sup: 'sup',
	  table: 'table',
	  tbody: 'tbody',
	  td: 'td',
	  textarea: 'textarea',
	  tfoot: 'tfoot',
	  th: 'th',
	  thead: 'thead',
	  time: 'time',
	  title: 'title',
	  tr: 'tr',
	  track: 'track',
	  u: 'u',
	  ul: 'ul',
	  'var': 'var',
	  video: 'video',
	  wbr: 'wbr',
	
	  // SVG
	  circle: 'circle',
	  clipPath: 'clipPath',
	  defs: 'defs',
	  ellipse: 'ellipse',
	  g: 'g',
	  image: 'image',
	  line: 'line',
	  linearGradient: 'linearGradient',
	  mask: 'mask',
	  path: 'path',
	  pattern: 'pattern',
	  polygon: 'polygon',
	  polyline: 'polyline',
	  radialGradient: 'radialGradient',
	  rect: 'rect',
	  stop: 'stop',
	  svg: 'svg',
	  text: 'text',
	  tspan: 'tspan'
	
	}, createDOMFactory);
	
	module.exports = ReactDOMFactories;

/***/ },
/* 500 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMFeatureFlags
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMIDOperations
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(112);
	var ReactDOMComponentTree = __webpack_require__(8);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInput
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var DisabledInputUtils = __webpack_require__(77);
	var DOMPropertyOperations = __webpack_require__(187);
	var LinkedValueUtils = __webpack_require__(116);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(23);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked !== undefined : props.value !== undefined;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined
	    }, DisabledInputUtils.getHostProps(inst, props), {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	
	    if (false) {
	      inst._wrapperState.controlled = isControlled(props);
	    }
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        node.defaultValue = '' + props.defaultValue;
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	    if (props.type !== 'submit' && props.type !== 'reset') {
	      node.value = node.value;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMInstrumentation
	 */
	
	'use strict';
	
	var debugTool = null;
	
	if (false) {
	  var ReactDOMDebugTool = require('./ReactDOMDebugTool');
	  debugTool = ReactDOMDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMOption
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactChildren = __webpack_require__(117);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMSelect = __webpack_require__(193);
	
	var warning = __webpack_require__(5);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  ReactChildren.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMSelection
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var getNodeForCharacterOffset = __webpack_require__(542);
	var getTextContentAccessor = __webpack_require__(210);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextComponent
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var DOMChildrenOperations = __webpack_require__(112);
	var DOMLazyTree = __webpack_require__(44);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstrumentation = __webpack_require__(15);
	
	var escapeTextContentForBrowser = __webpack_require__(81);
	var invariant = __webpack_require__(3);
	var validateDOMNesting = __webpack_require__(131);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = null;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetText(this._debugID, this._stringText);
	
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting('#text', this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	
	        if (false) {
	          ReactInstrumentation.debugTool.onSetText(this._debugID, nextStringText);
	        }
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTextarea
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4),
	    _assign = __webpack_require__(7);
	
	var DisabledInputUtils = __webpack_require__(77);
	var LinkedValueUtils = __webpack_require__(116);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(23);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, DisabledInputUtils.getHostProps(inst, props), {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Warning: node.value may be the empty string at this point (IE11) if placeholder is set.
	    node.value = node.textContent; // Detach value from defaultValue
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDOMTreeTraversal
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], false, arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], true, arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], true, argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], false, argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultBatchingStrategy
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var ReactUpdates = __webpack_require__(23);
	var Transaction = __webpack_require__(58);
	
	var emptyFunction = __webpack_require__(16);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction.Mixin, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      callback(a, b, c, d, e);
	    } else {
	      transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactDefaultInjection
	 */
	
	'use strict';
	
	var BeforeInputEventPlugin = __webpack_require__(484);
	var ChangeEventPlugin = __webpack_require__(486);
	var DefaultEventPluginOrder = __webpack_require__(488);
	var EnterLeaveEventPlugin = __webpack_require__(489);
	var HTMLDOMPropertyConfig = __webpack_require__(491);
	var ReactComponentBrowserEnvironment = __webpack_require__(191);
	var ReactDOMComponent = __webpack_require__(496);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactDOMEmptyComponent = __webpack_require__(498);
	var ReactDOMTreeTraversal = __webpack_require__(508);
	var ReactDOMTextComponent = __webpack_require__(506);
	var ReactDefaultBatchingStrategy = __webpack_require__(509);
	var ReactEventListener = __webpack_require__(512);
	var ReactInjection = __webpack_require__(514);
	var ReactReconcileTransaction = __webpack_require__(518);
	var SVGDOMPropertyConfig = __webpack_require__(524);
	var SelectEventPlugin = __webpack_require__(525);
	var SimpleEventPlugin = __webpack_require__(526);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventEmitterMixin
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(46);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactEventListener
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var EventListener = __webpack_require__(214);
	var ExecutionEnvironment = __webpack_require__(14);
	var PooledClass = __webpack_require__(30);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactUpdates = __webpack_require__(23);
	
	var getEventTarget = __webpack_require__(127);
	var getUnboundedScrollPosition = __webpack_require__(553);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} handle Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    var element = handle;
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactFragment
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactChildren = __webpack_require__(117);
	var ReactElement = __webpack_require__(18);
	
	var emptyFunction = __webpack_require__(16);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * We used to allow keyed objects to serve as a collection of ReactElements,
	 * or nested sets. This allowed us a way to explicitly key a set or fragment of
	 * components. This is now being replaced with an opaque data structure.
	 * The upgrade path is to call React.addons.createFragment({ key: value }) to
	 * create a keyed fragment. The resulting data structure is an array.
	 */
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	var ReactFragment = {
	  /**
	   * Wrap a keyed object in an opaque proxy that warns you if you access any
	   * of its properties.
	   * See https://facebook.github.io/react/docs/create-fragment.html
	   */
	  create: function (object) {
	    if (typeof object !== 'object' || !object || Array.isArray(object)) {
	       false ? warning(false, 'React.addons.createFragment only accepts a single object. Got: %s', object) : void 0;
	      return object;
	    }
	    if (ReactElement.isValidElement(object)) {
	       false ? warning(false, 'React.addons.createFragment does not accept a ReactElement ' + 'without a wrapper object.') : void 0;
	      return object;
	    }
	
	    !(object.nodeType !== 1) ?  false ? invariant(false, 'React.addons.createFragment(...): Encountered an invalid child; DOM elements are not valid children of React components.') : _prodInvariant('0') : void 0;
	
	    var result = [];
	
	    for (var key in object) {
	      if (false) {
	        if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React.addons.createFragment(...): Child objects should have ' + 'non-numeric keys so ordering is preserved.') : void 0;
	          warnedAboutNumeric = true;
	        }
	      }
	      ReactChildren.mapIntoWithKeyPrefixInternal(object[key], result, key, emptyFunction.thatReturnsArgument);
	    }
	
	    return result;
	  }
	};
	
	module.exports = ReactFragment;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactInjection
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(45);
	var EventPluginHub = __webpack_require__(46);
	var EventPluginUtils = __webpack_require__(78);
	var ReactComponentEnvironment = __webpack_require__(118);
	var ReactClass = __webpack_require__(189);
	var ReactEmptyComponent = __webpack_require__(194);
	var ReactBrowserEventEmitter = __webpack_require__(79);
	var ReactHostComponent = __webpack_require__(196);
	var ReactUpdates = __webpack_require__(23);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  Class: ReactClass.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMarkupChecksum
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(537);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactMultiChild
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactComponentEnvironment = __webpack_require__(118);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactInstrumentation = __webpack_require__(15);
	var ReactMultiChildUpdateTypes = __webpack_require__(199);
	
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactReconciler = __webpack_require__(49);
	var ReactChildReconciler = __webpack_require__(492);
	
	var emptyFunction = __webpack_require__(16);
	var flattenChildren = __webpack_require__(206);
	var invariant = __webpack_require__(3);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.INSERT_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.MOVE_EXISTING,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.REMOVE_NODE,
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.SET_MARKUP,
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: ReactMultiChildUpdateTypes.TEXT_CONTENT,
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setParentForInstrumentation = emptyFunction;
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setParentForInstrumentation = function (child) {
	    if (child._debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetParent(child._debugID, getDebugID(this));
	    }
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, removedNodes, transaction, context) {
	      var nextChildren;
	      if (false) {
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, this._debugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, removedNodes, transaction, context);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          if (false) {
	            setParentForInstrumentation.call(this, child);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var lastIndex = 0;
	      var nextIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, lastPlacedNode, nextIndex, transaction, context));
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, afterNode, index, transaction, context) {
	      var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context);
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	
	  }
	
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactOwner
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	
	  /**
	   * @param {?object} object
	   * @return {boolean} True if `object` is a valid owner.
	   * @final
	   */
	  isValidOwner: function (object) {
	    return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	  },
	
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !ReactOwner.isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	
	};
	
	module.exports = ReactOwner;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactReconcileTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var CallbackQueue = __webpack_require__(186);
	var PooledClass = __webpack_require__(30);
	var ReactBrowserEventEmitter = __webpack_require__(79);
	var ReactInputSelection = __webpack_require__(197);
	var ReactInstrumentation = __webpack_require__(15);
	var Transaction = __webpack_require__(58);
	var ReactUpdateQueue = __webpack_require__(122);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactRef
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(517);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	
	  return(
	    // This has a few false positives w/r/t empty components.
	    prevEmpty || nextEmpty || nextElement._owner !== prevElement._owner || nextElement.ref !== prevElement.ref
	  );
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || element === false) {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerRenderingTransaction
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var PooledClass = __webpack_require__(30);
	var Transaction = __webpack_require__(58);
	var ReactInstrumentation = __webpack_require__(15);
	var ReactServerUpdateQueue = __webpack_require__(521);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction.Mixin, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactServerUpdateQueue
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(122);
	var Transaction = __webpack_require__(58);
	var warning = __webpack_require__(5);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  /* :: transaction: Transaction; */
	
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionChildMapping
	 */
	
	'use strict';
	
	var flattenChildren = __webpack_require__(206);
	
	var ReactTransitionChildMapping = {
	  /**
	   * Given `this.props.children`, return an object mapping key to child. Just
	   * simple syntactic sugar around flattenChildren().
	   *
	   * @param {*} children `this.props.children`
	   * @param {number=} selfDebugID Optional debugID of the current internal instance.
	   * @return {object} Mapping of key to child
	   */
	  getChildMapping: function (children, selfDebugID) {
	    if (!children) {
	      return children;
	    }
	
	    if (false) {
	      return flattenChildren(children, selfDebugID);
	    }
	
	    return flattenChildren(children);
	  },
	
	  /**
	   * When you're adding or removing children some may be added or removed in the
	   * same render pass. We want to show *both* since we want to simultaneously
	   * animate elements in and out. This function takes a previous set of keys
	   * and a new set of keys and merges them with its best guess of the correct
	   * ordering. In the future we may expose some of the utilities in
	   * ReactMultiChild to make this easy, but for now React itself does not
	   * directly have this concept of the union of prevChildren and nextChildren
	   * so we implement it here.
	   *
	   * @param {object} prev prev children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @param {object} next next children as returned from
	   * `ReactTransitionChildMapping.getChildMapping()`.
	   * @return {object} a key set that contains all keys in `prev` and all keys
	   * in `next` in a reasonable order.
	   */
	  mergeChildMappings: function (prev, next) {
	    prev = prev || {};
	    next = next || {};
	
	    function getValueForKey(key) {
	      if (next.hasOwnProperty(key)) {
	        return next[key];
	      } else {
	        return prev[key];
	      }
	    }
	
	    // For each key of `next`, the list of keys to insert before that key in
	    // the combined list
	    var nextKeysPending = {};
	
	    var pendingKeys = [];
	    for (var prevKey in prev) {
	      if (next.hasOwnProperty(prevKey)) {
	        if (pendingKeys.length) {
	          nextKeysPending[prevKey] = pendingKeys;
	          pendingKeys = [];
	        }
	      } else {
	        pendingKeys.push(prevKey);
	      }
	    }
	
	    var i;
	    var childMapping = {};
	    for (var nextKey in next) {
	      if (nextKeysPending.hasOwnProperty(nextKey)) {
	        for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	          var pendingNextKey = nextKeysPending[nextKey][i];
	          childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	        }
	      }
	      childMapping[nextKey] = getValueForKey(nextKey);
	    }
	
	    // Finally, add the keys which didn't appear before any key in `next`
	    for (i = 0; i < pendingKeys.length; i++) {
	      childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	    }
	
	    return childMapping;
	  }
	};
	
	module.exports = ReactTransitionChildMapping;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactTransitionGroup
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(7);
	
	var React = __webpack_require__(188);
	var ReactInstanceMap = __webpack_require__(48);
	var ReactTransitionChildMapping = __webpack_require__(522);
	
	var emptyFunction = __webpack_require__(16);
	
	/**
	 * A basis for animations. When children are declaratively added or removed,
	 * special lifecycle hooks are called.
	 * See https://facebook.github.io/react/docs/animation.html#low-level-api-reacttransitiongroup
	 */
	var ReactTransitionGroup = React.createClass({
	  displayName: 'ReactTransitionGroup',
	
	  propTypes: {
	    component: React.PropTypes.any,
	    childFactory: React.PropTypes.func
	  },
	
	  getDefaultProps: function () {
	    return {
	      component: 'span',
	      childFactory: emptyFunction.thatReturnsArgument
	    };
	  },
	
	  getInitialState: function () {
	    return {
	      // TODO: can we get useful debug information to show at this point?
	      children: ReactTransitionChildMapping.getChildMapping(this.props.children)
	    };
	  },
	
	  componentWillMount: function () {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  },
	
	  componentDidMount: function () {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key);
	      }
	    }
	  },
	
	  componentWillReceiveProps: function (nextProps) {
	    var nextChildMapping;
	    if (false) {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      nextChildMapping = ReactTransitionChildMapping.getChildMapping(nextProps.children);
	    }
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: ReactTransitionChildMapping.mergeChildMappings(prevChildMapping, nextChildMapping)
	    });
	
	    var key;
	
	    for (key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(key);
	      if (prevChildMapping[key] && !hasNext && !this.currentlyTransitioningKeys[key]) {
	        this.keysToLeave.push(key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  },
	
	  componentDidUpdate: function () {
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(this.performEnter);
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(this.performLeave);
	  },
	
	  performAppear: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillAppear) {
	      component.componentWillAppear(this._handleDoneAppearing.bind(this, key));
	    } else {
	      this._handleDoneAppearing(key);
	    }
	  },
	
	  _handleDoneAppearing: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidAppear) {
	      component.componentDidAppear();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully appeared. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performEnter: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	
	    if (component.componentWillEnter) {
	      component.componentWillEnter(this._handleDoneEntering.bind(this, key));
	    } else {
	      this._handleDoneEntering(key);
	    }
	  },
	
	  _handleDoneEntering: function (key) {
	    var component = this.refs[key];
	    if (component.componentDidEnter) {
	      component.componentDidEnter();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	      // This was removed before it had fully entered. Remove it.
	      this.performLeave(key);
	    }
	  },
	
	  performLeave: function (key) {
	    this.currentlyTransitioningKeys[key] = true;
	
	    var component = this.refs[key];
	    if (component.componentWillLeave) {
	      component.componentWillLeave(this._handleDoneLeaving.bind(this, key));
	    } else {
	      // Note that this is somewhat dangerous b/c it calls setState()
	      // again, effectively mutating the component before all the work
	      // is done.
	      this._handleDoneLeaving(key);
	    }
	  },
	
	  _handleDoneLeaving: function (key) {
	    var component = this.refs[key];
	
	    if (component.componentDidLeave) {
	      component.componentDidLeave();
	    }
	
	    delete this.currentlyTransitioningKeys[key];
	
	    var currentChildMapping;
	    if (false) {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children, ReactInstanceMap.get(this)._debugID);
	    } else {
	      currentChildMapping = ReactTransitionChildMapping.getChildMapping(this.props.children);
	    }
	
	    if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	      // This entered again before it fully left. Add it again.
	      this.performEnter(key);
	    } else {
	      this.setState(function (state) {
	        var newChildren = _assign({}, state.children);
	        delete newChildren[key];
	        return { children: newChildren };
	      });
	    }
	  },
	
	  render: function () {
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	    for (var key in this.state.children) {
	      var child = this.state.children[key];
	      if (child) {
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(React.cloneElement(this.props.childFactory(child), { ref: key, key: key }));
	      }
	    }
	
	    // Do not forward ReactTransitionGroup props to primitive DOM nodes
	    var props = _assign({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return React.createElement(this.props.component, props, childrenToRender);
	  }
	});
	
	module.exports = ReactTransitionGroup;

/***/ },
/* 524 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SVGDOMPropertyConfig
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectEventPlugin
	 */
	
	'use strict';
	
	var EventConstants = __webpack_require__(22);
	var EventPropagators = __webpack_require__(47);
	var ExecutionEnvironment = __webpack_require__(14);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInputSelection = __webpack_require__(197);
	var SyntheticEvent = __webpack_require__(25);
	
	var getActiveElement = __webpack_require__(216);
	var isTextInputElement = __webpack_require__(212);
	var keyOf = __webpack_require__(31);
	var shallowEqual = __webpack_require__(217);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSelect: null }),
	      captured: keyOf({ onSelectCapture: null })
	    },
	    dependencies: [topLevelTypes.topBlur, topLevelTypes.topContextMenu, topLevelTypes.topFocus, topLevelTypes.topKeyDown, topLevelTypes.topMouseDown, topLevelTypes.topMouseUp, topLevelTypes.topSelectionChange]
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	var ON_SELECT_KEY = keyOf({ onSelect: null });
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case topLevelTypes.topFocus:
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case topLevelTypes.topBlur:
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case topLevelTypes.topMouseDown:
	        mouseDown = true;
	        break;
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topMouseUp:
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case topLevelTypes.topSelectionChange:
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === ON_SELECT_KEY) {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SimpleEventPlugin
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var EventConstants = __webpack_require__(22);
	var EventListener = __webpack_require__(214);
	var EventPropagators = __webpack_require__(47);
	var ReactDOMComponentTree = __webpack_require__(8);
	var SyntheticAnimationEvent = __webpack_require__(527);
	var SyntheticClipboardEvent = __webpack_require__(528);
	var SyntheticEvent = __webpack_require__(25);
	var SyntheticFocusEvent = __webpack_require__(531);
	var SyntheticKeyboardEvent = __webpack_require__(533);
	var SyntheticMouseEvent = __webpack_require__(80);
	var SyntheticDragEvent = __webpack_require__(530);
	var SyntheticTouchEvent = __webpack_require__(534);
	var SyntheticTransitionEvent = __webpack_require__(535);
	var SyntheticUIEvent = __webpack_require__(50);
	var SyntheticWheelEvent = __webpack_require__(536);
	
	var emptyFunction = __webpack_require__(16);
	var getEventCharCode = __webpack_require__(125);
	var invariant = __webpack_require__(3);
	var keyOf = __webpack_require__(31);
	
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var eventTypes = {
	  abort: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAbort: true }),
	      captured: keyOf({ onAbortCapture: true })
	    }
	  },
	  animationEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationEnd: true }),
	      captured: keyOf({ onAnimationEndCapture: true })
	    }
	  },
	  animationIteration: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationIteration: true }),
	      captured: keyOf({ onAnimationIterationCapture: true })
	    }
	  },
	  animationStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onAnimationStart: true }),
	      captured: keyOf({ onAnimationStartCapture: true })
	    }
	  },
	  blur: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onBlur: true }),
	      captured: keyOf({ onBlurCapture: true })
	    }
	  },
	  canPlay: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlay: true }),
	      captured: keyOf({ onCanPlayCapture: true })
	    }
	  },
	  canPlayThrough: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCanPlayThrough: true }),
	      captured: keyOf({ onCanPlayThroughCapture: true })
	    }
	  },
	  click: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onClick: true }),
	      captured: keyOf({ onClickCapture: true })
	    }
	  },
	  contextMenu: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onContextMenu: true }),
	      captured: keyOf({ onContextMenuCapture: true })
	    }
	  },
	  copy: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCopy: true }),
	      captured: keyOf({ onCopyCapture: true })
	    }
	  },
	  cut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onCut: true }),
	      captured: keyOf({ onCutCapture: true })
	    }
	  },
	  doubleClick: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDoubleClick: true }),
	      captured: keyOf({ onDoubleClickCapture: true })
	    }
	  },
	  drag: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrag: true }),
	      captured: keyOf({ onDragCapture: true })
	    }
	  },
	  dragEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnd: true }),
	      captured: keyOf({ onDragEndCapture: true })
	    }
	  },
	  dragEnter: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragEnter: true }),
	      captured: keyOf({ onDragEnterCapture: true })
	    }
	  },
	  dragExit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragExit: true }),
	      captured: keyOf({ onDragExitCapture: true })
	    }
	  },
	  dragLeave: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragLeave: true }),
	      captured: keyOf({ onDragLeaveCapture: true })
	    }
	  },
	  dragOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragOver: true }),
	      captured: keyOf({ onDragOverCapture: true })
	    }
	  },
	  dragStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDragStart: true }),
	      captured: keyOf({ onDragStartCapture: true })
	    }
	  },
	  drop: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDrop: true }),
	      captured: keyOf({ onDropCapture: true })
	    }
	  },
	  durationChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onDurationChange: true }),
	      captured: keyOf({ onDurationChangeCapture: true })
	    }
	  },
	  emptied: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEmptied: true }),
	      captured: keyOf({ onEmptiedCapture: true })
	    }
	  },
	  encrypted: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEncrypted: true }),
	      captured: keyOf({ onEncryptedCapture: true })
	    }
	  },
	  ended: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onEnded: true }),
	      captured: keyOf({ onEndedCapture: true })
	    }
	  },
	  error: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onError: true }),
	      captured: keyOf({ onErrorCapture: true })
	    }
	  },
	  focus: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onFocus: true }),
	      captured: keyOf({ onFocusCapture: true })
	    }
	  },
	  input: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInput: true }),
	      captured: keyOf({ onInputCapture: true })
	    }
	  },
	  invalid: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onInvalid: true }),
	      captured: keyOf({ onInvalidCapture: true })
	    }
	  },
	  keyDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyDown: true }),
	      captured: keyOf({ onKeyDownCapture: true })
	    }
	  },
	  keyPress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyPress: true }),
	      captured: keyOf({ onKeyPressCapture: true })
	    }
	  },
	  keyUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onKeyUp: true }),
	      captured: keyOf({ onKeyUpCapture: true })
	    }
	  },
	  load: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoad: true }),
	      captured: keyOf({ onLoadCapture: true })
	    }
	  },
	  loadedData: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedData: true }),
	      captured: keyOf({ onLoadedDataCapture: true })
	    }
	  },
	  loadedMetadata: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadedMetadata: true }),
	      captured: keyOf({ onLoadedMetadataCapture: true })
	    }
	  },
	  loadStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onLoadStart: true }),
	      captured: keyOf({ onLoadStartCapture: true })
	    }
	  },
	  // Note: We do not allow listening to mouseOver events. Instead, use the
	  // onMouseEnter/onMouseLeave created by `EnterLeaveEventPlugin`.
	  mouseDown: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseDown: true }),
	      captured: keyOf({ onMouseDownCapture: true })
	    }
	  },
	  mouseMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseMove: true }),
	      captured: keyOf({ onMouseMoveCapture: true })
	    }
	  },
	  mouseOut: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOut: true }),
	      captured: keyOf({ onMouseOutCapture: true })
	    }
	  },
	  mouseOver: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseOver: true }),
	      captured: keyOf({ onMouseOverCapture: true })
	    }
	  },
	  mouseUp: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onMouseUp: true }),
	      captured: keyOf({ onMouseUpCapture: true })
	    }
	  },
	  paste: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPaste: true }),
	      captured: keyOf({ onPasteCapture: true })
	    }
	  },
	  pause: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPause: true }),
	      captured: keyOf({ onPauseCapture: true })
	    }
	  },
	  play: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlay: true }),
	      captured: keyOf({ onPlayCapture: true })
	    }
	  },
	  playing: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onPlaying: true }),
	      captured: keyOf({ onPlayingCapture: true })
	    }
	  },
	  progress: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onProgress: true }),
	      captured: keyOf({ onProgressCapture: true })
	    }
	  },
	  rateChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onRateChange: true }),
	      captured: keyOf({ onRateChangeCapture: true })
	    }
	  },
	  reset: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onReset: true }),
	      captured: keyOf({ onResetCapture: true })
	    }
	  },
	  scroll: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onScroll: true }),
	      captured: keyOf({ onScrollCapture: true })
	    }
	  },
	  seeked: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeked: true }),
	      captured: keyOf({ onSeekedCapture: true })
	    }
	  },
	  seeking: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSeeking: true }),
	      captured: keyOf({ onSeekingCapture: true })
	    }
	  },
	  stalled: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onStalled: true }),
	      captured: keyOf({ onStalledCapture: true })
	    }
	  },
	  submit: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSubmit: true }),
	      captured: keyOf({ onSubmitCapture: true })
	    }
	  },
	  suspend: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onSuspend: true }),
	      captured: keyOf({ onSuspendCapture: true })
	    }
	  },
	  timeUpdate: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTimeUpdate: true }),
	      captured: keyOf({ onTimeUpdateCapture: true })
	    }
	  },
	  touchCancel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchCancel: true }),
	      captured: keyOf({ onTouchCancelCapture: true })
	    }
	  },
	  touchEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchEnd: true }),
	      captured: keyOf({ onTouchEndCapture: true })
	    }
	  },
	  touchMove: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchMove: true }),
	      captured: keyOf({ onTouchMoveCapture: true })
	    }
	  },
	  touchStart: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTouchStart: true }),
	      captured: keyOf({ onTouchStartCapture: true })
	    }
	  },
	  transitionEnd: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onTransitionEnd: true }),
	      captured: keyOf({ onTransitionEndCapture: true })
	    }
	  },
	  volumeChange: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onVolumeChange: true }),
	      captured: keyOf({ onVolumeChangeCapture: true })
	    }
	  },
	  waiting: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWaiting: true }),
	      captured: keyOf({ onWaitingCapture: true })
	    }
	  },
	  wheel: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({ onWheel: true }),
	      captured: keyOf({ onWheelCapture: true })
	    }
	  }
	};
	
	var topLevelEventsToDispatchConfig = {
	  topAbort: eventTypes.abort,
	  topAnimationEnd: eventTypes.animationEnd,
	  topAnimationIteration: eventTypes.animationIteration,
	  topAnimationStart: eventTypes.animationStart,
	  topBlur: eventTypes.blur,
	  topCanPlay: eventTypes.canPlay,
	  topCanPlayThrough: eventTypes.canPlayThrough,
	  topClick: eventTypes.click,
	  topContextMenu: eventTypes.contextMenu,
	  topCopy: eventTypes.copy,
	  topCut: eventTypes.cut,
	  topDoubleClick: eventTypes.doubleClick,
	  topDrag: eventTypes.drag,
	  topDragEnd: eventTypes.dragEnd,
	  topDragEnter: eventTypes.dragEnter,
	  topDragExit: eventTypes.dragExit,
	  topDragLeave: eventTypes.dragLeave,
	  topDragOver: eventTypes.dragOver,
	  topDragStart: eventTypes.dragStart,
	  topDrop: eventTypes.drop,
	  topDurationChange: eventTypes.durationChange,
	  topEmptied: eventTypes.emptied,
	  topEncrypted: eventTypes.encrypted,
	  topEnded: eventTypes.ended,
	  topError: eventTypes.error,
	  topFocus: eventTypes.focus,
	  topInput: eventTypes.input,
	  topInvalid: eventTypes.invalid,
	  topKeyDown: eventTypes.keyDown,
	  topKeyPress: eventTypes.keyPress,
	  topKeyUp: eventTypes.keyUp,
	  topLoad: eventTypes.load,
	  topLoadedData: eventTypes.loadedData,
	  topLoadedMetadata: eventTypes.loadedMetadata,
	  topLoadStart: eventTypes.loadStart,
	  topMouseDown: eventTypes.mouseDown,
	  topMouseMove: eventTypes.mouseMove,
	  topMouseOut: eventTypes.mouseOut,
	  topMouseOver: eventTypes.mouseOver,
	  topMouseUp: eventTypes.mouseUp,
	  topPaste: eventTypes.paste,
	  topPause: eventTypes.pause,
	  topPlay: eventTypes.play,
	  topPlaying: eventTypes.playing,
	  topProgress: eventTypes.progress,
	  topRateChange: eventTypes.rateChange,
	  topReset: eventTypes.reset,
	  topScroll: eventTypes.scroll,
	  topSeeked: eventTypes.seeked,
	  topSeeking: eventTypes.seeking,
	  topStalled: eventTypes.stalled,
	  topSubmit: eventTypes.submit,
	  topSuspend: eventTypes.suspend,
	  topTimeUpdate: eventTypes.timeUpdate,
	  topTouchCancel: eventTypes.touchCancel,
	  topTouchEnd: eventTypes.touchEnd,
	  topTouchMove: eventTypes.touchMove,
	  topTouchStart: eventTypes.touchStart,
	  topTransitionEnd: eventTypes.transitionEnd,
	  topVolumeChange: eventTypes.volumeChange,
	  topWaiting: eventTypes.waiting,
	  topWheel: eventTypes.wheel
	};
	
	for (var type in topLevelEventsToDispatchConfig) {
	  topLevelEventsToDispatchConfig[type].dependencies = [type];
	}
	
	var ON_CLICK_KEY = keyOf({ onClick: null });
	var onClickListeners = {};
	
	var SimpleEventPlugin = {
	
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case topLevelTypes.topAbort:
	      case topLevelTypes.topCanPlay:
	      case topLevelTypes.topCanPlayThrough:
	      case topLevelTypes.topDurationChange:
	      case topLevelTypes.topEmptied:
	      case topLevelTypes.topEncrypted:
	      case topLevelTypes.topEnded:
	      case topLevelTypes.topError:
	      case topLevelTypes.topInput:
	      case topLevelTypes.topInvalid:
	      case topLevelTypes.topLoad:
	      case topLevelTypes.topLoadedData:
	      case topLevelTypes.topLoadedMetadata:
	      case topLevelTypes.topLoadStart:
	      case topLevelTypes.topPause:
	      case topLevelTypes.topPlay:
	      case topLevelTypes.topPlaying:
	      case topLevelTypes.topProgress:
	      case topLevelTypes.topRateChange:
	      case topLevelTypes.topReset:
	      case topLevelTypes.topSeeked:
	      case topLevelTypes.topSeeking:
	      case topLevelTypes.topStalled:
	      case topLevelTypes.topSubmit:
	      case topLevelTypes.topSuspend:
	      case topLevelTypes.topTimeUpdate:
	      case topLevelTypes.topVolumeChange:
	      case topLevelTypes.topWaiting:
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case topLevelTypes.topKeyPress:
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topKeyDown:
	      case topLevelTypes.topKeyUp:
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case topLevelTypes.topBlur:
	      case topLevelTypes.topFocus:
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case topLevelTypes.topClick:
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case topLevelTypes.topContextMenu:
	      case topLevelTypes.topDoubleClick:
	      case topLevelTypes.topMouseDown:
	      case topLevelTypes.topMouseMove:
	      case topLevelTypes.topMouseOut:
	      case topLevelTypes.topMouseOver:
	      case topLevelTypes.topMouseUp:
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case topLevelTypes.topDrag:
	      case topLevelTypes.topDragEnd:
	      case topLevelTypes.topDragEnter:
	      case topLevelTypes.topDragExit:
	      case topLevelTypes.topDragLeave:
	      case topLevelTypes.topDragOver:
	      case topLevelTypes.topDragStart:
	      case topLevelTypes.topDrop:
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case topLevelTypes.topTouchCancel:
	      case topLevelTypes.topTouchEnd:
	      case topLevelTypes.topTouchMove:
	      case topLevelTypes.topTouchStart:
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case topLevelTypes.topAnimationEnd:
	      case topLevelTypes.topAnimationIteration:
	      case topLevelTypes.topAnimationStart:
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case topLevelTypes.topTransitionEnd:
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case topLevelTypes.topScroll:
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case topLevelTypes.topWheel:
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case topLevelTypes.topCopy:
	      case topLevelTypes.topCut:
	      case topLevelTypes.topPaste:
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[id]) {
	        onClickListeners[id] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === ON_CLICK_KEY) {
	      var id = inst._rootNodeID;
	      onClickListeners[id].remove();
	      delete onClickListeners[id];
	    }
	  }
	
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticAnimationEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticClipboardEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticCompositionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticDragEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(80);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticFocusEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(50);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticInputEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticKeyboardEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(50);
	
	var getEventCharCode = __webpack_require__(125);
	var getEventKey = __webpack_require__(541);
	var getEventModifierState = __webpack_require__(126);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTouchEvent
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(50);
	
	var getEventModifierState = __webpack_require__(126);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticTransitionEvent
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(25);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SyntheticWheelEvent
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(80);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX :
	    // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY :
	    // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY :
	    // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 537 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adler32
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule checkReactTypeSpec
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactPropTypeLocationNames = __webpack_require__(120);
	
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	var loggedTypeFailures = {};
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?object} element The React element that is being type-checked
	 * @param {?number} debugID The React component instance that is being type-checked
	 * @private
	 */
	function checkReactTypeSpec(typeSpecs, values, location, componentName, element, debugID) {
	  for (var typeSpecName in typeSpecs) {
	    if (typeSpecs.hasOwnProperty(typeSpecName)) {
	      var error;
	      // Prop type validation may throw. In case they do, we don't want to
	      // fail the render phase where it didn't fail before. So we log it.
	      // After these have been cleaned up, we'll let them throw.
	      try {
	        // This is intentionally an invariant that gets caught. It's the same
	        // behavior as without this statement except with a better message.
	        !(typeof typeSpecs[typeSpecName] === 'function') ?  false ? invariant(false, '%s: %s type `%s` is invalid; it must be a function, usually from React.PropTypes.', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : _prodInvariant('84', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName) : void 0;
	        error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location);
	      } catch (ex) {
	        error = ex;
	      }
	       false ? warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', ReactPropTypeLocationNames[location], typeSpecName, typeof error) : void 0;
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var componentStackInfo = '';
	
	        if (false) {
	          var ReactComponentTreeDevtool = require('./ReactComponentTreeDevtool');
	          if (debugID !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getStackAddendumByID(debugID);
	          } else if (element !== null) {
	            componentStackInfo = ReactComponentTreeDevtool.getCurrentStackAddendum(element);
	          }
	        }
	
	         false ? warning(false, 'Failed %s type: %s%s', location, error.message, componentStackInfo) : void 0;
	      }
	    }
	  }
	}
	
	module.exports = checkReactTypeSpec;

/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule dangerousStyleValue
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(185);
	var warning = __webpack_require__(5);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findDOMNode
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactCurrentOwner = __webpack_require__(37);
	var ReactDOMComponentTree = __webpack_require__(8);
	var ReactInstanceMap = __webpack_require__(48);
	
	var getHostComponentFromComposite = __webpack_require__(208);
	var invariant = __webpack_require__(3);
	var warning = __webpack_require__(5);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEventKey
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(125);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  'Esc': 'Escape',
	  'Spacebar': ' ',
	  'Left': 'ArrowLeft',
	  'Up': 'ArrowUp',
	  'Right': 'ArrowRight',
	  'Down': 'ArrowDown',
	  'Del': 'Delete',
	  'Win': 'OS',
	  'Menu': 'ContextMenu',
	  'Apps': 'ContextMenu',
	  'Scroll': 'ScrollLock',
	  'MozPrintableKey': 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1', 113: 'F2', 114: 'F3', 115: 'F4', 116: 'F5', 117: 'F6',
	  118: 'F7', 119: 'F8', 120: 'F9', 121: 'F10', 122: 'F11', 123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 542 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNodeForCharacterOffset
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVendorPrefixedEventName
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule onlyChild
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(4);
	
	var ReactElement = __webpack_require__(18);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'onlyChild must be passed a children with exactly one child.') : _prodInvariant('23') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule quoteAttributeValueForBrowser
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(81);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	* @providesModule renderSubtreeIntoContainer
	*/
	
	'use strict';
	
	var ReactMount = __webpack_require__(198);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 547 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(547);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(557);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return(
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var createArrayFromMixed = __webpack_require__(550);
	var getMarkupWrap = __webpack_require__(552);
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(14);
	
	var invariant = __webpack_require__(3);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 553 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable === window) {
	    return {
	      x: window.pageXOffset || document.documentElement.scrollLeft,
	      y: window.pageYOffset || document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 554 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(554);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 556 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  return !!(object && (typeof Node === 'function' ? object instanceof Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(556);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 558 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 559 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _isEqual = __webpack_require__(617);
	
	var _isEqual2 = _interopRequireDefault(_isEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var select = function select(state, selector) {
		return selector.reduce(function (prev, current) {
			return prev[current];
		}, state);
	};
	
	var ReduxWatcher = function () {
		function ReduxWatcher(store) {
			var _this = this;
	
			_classCallCheck(this, ReduxWatcher);
	
			var watchList = this.__watchList = {};
			this.__prevState = store.getState();
			store.subscribe(function () {
				var currentState = store.getState();
				var prevState = _this.__prevState;
				Object.keys(watchList).forEach(function (key) {
					var listeners = watchList[key];
					if (!listeners) {
						return;
					}
					var selector = JSON.parse(key);
					var prevValue = select(prevState, selector);
					var currentValue = select(currentState, selector);
	
					if (!(0, _isEqual2.default)(prevValue, currentValue)) {
						listeners.forEach(function (listener) {
							return listener({
								store: store,
								selector: selector,
								prevState: prevState,
								currentState: currentState,
								prevValue: prevValue,
								currentValue: currentValue
							});
						});
					}
				});
				_this.__prevState = currentState;
			});
			this.watch = this.watch.bind(this);
		}
	
		_createClass(ReduxWatcher, [{
			key: 'watch',
			value: function watch(selector, listener) {
				var watchList = this.__watchList;
				var selectorStr = JSON.stringify(selector);
				watchList[selectorStr] = watchList[selectorStr] || [];
				watchList[selectorStr].push(listener);
			}
		}, {
			key: 'off',
			value: function off(selector, listener) {
				var selectorStr = JSON.stringify(selector);
				if (!this.__watchList[selectorStr]) {
					console.warn('No such listener for ' + selector);
					return;
				}
				var listeners = this.__watchList[selectorStr];
				var listenerIndex = listeners.indexOf(listener);
				if (listenerIndex >= 0) {
					listeners.splice(listeners.indexOf(listener));
				} else {
					console.warn('No such listener for ' + selector);
				}
				if (listeners.length === 0) {
					delete this.__watchList[selectorStr];
				}
			}
		}]);
	
		return ReduxWatcher;
	}();
	
	exports.default = ReduxWatcher;
	//# sourceMappingURL=redux-watcher.js.map


/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(51),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(585),
	    hashDelete = __webpack_require__(586),
	    hashGet = __webpack_require__(587),
	    hashHas = __webpack_require__(588),
	    hashSet = __webpack_require__(589);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(51),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(51),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(219),
	    setCacheAdd = __webpack_require__(606),
	    setCacheHas = __webpack_require__(607);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(85),
	    stackClear = __webpack_require__(609),
	    stackDelete = __webpack_require__(610),
	    stackGet = __webpack_require__(611),
	    stackHas = __webpack_require__(612),
	    stackSet = __webpack_require__(613);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(32);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(32);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(51),
	    root = __webpack_require__(32);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 570 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(572),
	    isObject = __webpack_require__(134),
	    isObjectLike = __webpack_require__(89);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(566),
	    equalArrays = __webpack_require__(221),
	    equalByTag = __webpack_require__(579),
	    equalObjects = __webpack_require__(580),
	    getTag = __webpack_require__(583),
	    isArray = __webpack_require__(132),
	    isHostObject = __webpack_require__(222),
	    isTypedArray = __webpack_require__(619);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(225),
	    isHostObject = __webpack_require__(222),
	    isMasked = __webpack_require__(593),
	    isObject = __webpack_require__(134),
	    toSource = __webpack_require__(223);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/6.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = Function.prototype.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 574 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = Object.keys;
	
	/**
	 * The base implementation of `_.keys` which doesn't skip the constructor
	 * property of prototypes or treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  return nativeKeys(Object(object));
	}
	
	module.exports = baseKeys;


/***/ },
/* 575 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 576 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 577 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a global object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {null|Object} Returns `value` if it's a global object, else `null`.
	 */
	function checkGlobal(value) {
	  return (value && value.Object === Object) ? value : null;
	}
	
	module.exports = checkGlobal;


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(32);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(567),
	    Uint8Array = __webpack_require__(568),
	    equalArrays = __webpack_require__(221),
	    mapToArray = __webpack_require__(605),
	    setToArray = __webpack_require__(608);
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	      // Coerce dates and booleans to numbers, dates to milliseconds and
	      // booleans to `1` or `0` treating invalid dates coerced to `NaN` as
	      // not equal.
	      return +object == +other;
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case numberTag:
	      // Treat `NaN` vs. `NaN` as equal.
	      return (object != +object) ? other != +other : object == +other;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/6.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	      stack.set(object, other);
	
	      // Recursively compare objects (susceptible to call stack limits).
	      return equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 580 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(220),
	    keys = __webpack_require__(620);
	
	/** Used to compose bitmasks for comparison styles. */
	var PARTIAL_COMPARE_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : baseHas(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(575);
	
	/**
	 * Gets the "length" property value of `object`.
	 *
	 * **Note:** This function is used to avoid a
	 * [JIT bug](https://bugs.webkit.org/show_bug.cgi?id=142792) that affects
	 * Safari on at least iOS 8.1-8.3 ARM64.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {*} Returns the "length" value.
	 */
	var getLength = baseProperty('length');
	
	module.exports = getLength;


/***/ },
/* 582 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	module.exports = getPrototype;


/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(561),
	    Map = __webpack_require__(218),
	    Promise = __webpack_require__(563),
	    Set = __webpack_require__(564),
	    WeakMap = __webpack_require__(569),
	    toSource = __webpack_require__(223);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function getTag(value) {
	  return objectToString.call(value);
	}
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 584 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(88);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	module.exports = hashClear;


/***/ },
/* 586 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	module.exports = hashDelete;


/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(88);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(88);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(88);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(576),
	    isArguments = __webpack_require__(615),
	    isArray = __webpack_require__(132),
	    isLength = __webpack_require__(133),
	    isString = __webpack_require__(618);
	
	/**
	 * Creates an array of index keys for `object` values of arrays,
	 * `arguments` objects, and strings, otherwise `null` is returned.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array|null} Returns index keys, else `null`.
	 */
	function indexKeys(object) {
	  var length = object ? object.length : undefined;
	  if (isLength(length) &&
	      (isArray(object) || isString(object) || isArguments(object))) {
	    return baseTimes(length, String);
	  }
	  return null;
	}
	
	module.exports = indexKeys;


/***/ },
/* 591 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 592 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(578);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 594 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 595 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	module.exports = listCacheClear;


/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(86);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(86);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(86);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(86);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(562),
	    ListCache = __webpack_require__(85),
	    Map = __webpack_require__(218);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(87);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(87);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(87);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(87);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 605 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 606 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 607 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 608 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(85);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	module.exports = stackClear;


/***/ },
/* 610 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	module.exports = stackDelete;


/***/ },
/* 611 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 612 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 613 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(85),
	    MapCache = __webpack_require__(219);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache && cache.__data__.length == LARGE_ARRAY_SIZE) {
	    cache = this.__data__ = new MapCache(cache.__data__);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 614 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/6.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLikeObject = __webpack_require__(616);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 incorrectly makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	module.exports = isArguments;


/***/ },
/* 616 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(224),
	    isObjectLike = __webpack_require__(89);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(571);
	
	/**
	 * Performs a deep comparison between two values to determine if they are
	 * equivalent.
	 *
	 * **Note:** This method supports comparing arrays, array buffers, booleans,
	 * date objects, error objects, maps, numbers, `Object` objects, regexes,
	 * sets, strings, symbols, and typed arrays. `Object` objects are compared
	 * by their own, not inherited, enumerable properties. Functions and DOM
	 * nodes are **not** supported.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent,
	 *  else `false`.
	 * @example
	 *
	 * var object = { 'user': 'fred' };
	 * var other = { 'user': 'fred' };
	 *
	 * _.isEqual(object, other);
	 * // => true
	 *
	 * object === other;
	 * // => false
	 */
	function isEqual(value, other) {
	  return baseIsEqual(value, other);
	}
	
	module.exports = isEqual;


/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(132),
	    isObjectLike = __webpack_require__(89);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	var isLength = __webpack_require__(133),
	    isObjectLike = __webpack_require__(89);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is correctly classified,
	 *  else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	function isTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	module.exports = isTypedArray;


/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(220),
	    baseKeys = __webpack_require__(574),
	    indexKeys = __webpack_require__(590),
	    isArrayLike = __webpack_require__(224),
	    isIndex = __webpack_require__(591),
	    isPrototype = __webpack_require__(594);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/6.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  var isProto = isPrototype(object);
	  if (!(isProto || isArrayLike(object))) {
	    return baseKeys(object);
	  }
	  var indexes = indexKeys(object),
	      skipIndexes = !!indexes,
	      result = indexes || [],
	      length = result.length;
	
	  for (var key in object) {
	    if (baseHas(object, key) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length))) &&
	        !(isProto && key == 'constructor')) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = keys;


/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports["default"] = applyMiddleware;
	
	var _compose = __webpack_require__(226);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState, enhancer) {
	      var store = createStore(reducer, initialState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2["default"].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 622 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports["default"] = combineReducers;
	
	var _createStore = __webpack_require__(227);
	
	var _isPlainObject = __webpack_require__(229);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(228);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2["default"])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key);
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerSanity(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var sanityError;
	  try {
	    assertReducerSanity(finalReducers);
	  } catch (e) {
	    sanityError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];
	    var action = arguments[1];
	
	    if (sanityError) {
	      throw sanityError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action);
	      if (warningMessage) {
	        (0, _warning2["default"])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var i = 0; i < finalReducerKeys.length; i++) {
	      var key = finalReducerKeys[i];
	      var reducer = finalReducers[key];
	      var previousStateForKey = state[key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 624 */
/***/ function(module, exports) {

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetPrototype = Object.getPrototypeOf;
	
	/**
	 * Gets the `[[Prototype]]` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {null|Object} Returns the `[[Prototype]]`.
	 */
	function getPrototype(value) {
	  return nativeGetPrototype(Object(value));
	}
	
	module.exports = getPrototype;


/***/ },
/* 625 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	module.exports = isHostObject;


/***/ },
/* 626 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/* global window */
	'use strict';
	
	module.exports = __webpack_require__(628)(global || window || this);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 628 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = function symbolObservablePonyfill(root) {
		var result;
		var Symbol = root.Symbol;
	
		if (typeof Symbol === 'function') {
			if (Symbol.observable) {
				result = Symbol.observable;
			} else {
				result = Symbol('observable');
				Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};


/***/ },
/* 629 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 630 */
/***/ function(module, exports) {

	// shim for using process in browser
	
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	(function () {
	  try {
	    cachedSetTimeout = setTimeout;
	  } catch (e) {
	    cachedSetTimeout = function () {
	      throw new Error('setTimeout is not defined');
	    }
	  }
	  try {
	    cachedClearTimeout = clearTimeout;
	  } catch (e) {
	    cachedClearTimeout = function () {
	      throw new Error('clearTimeout is not defined');
	    }
	  }
	} ())
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = cachedSetTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    cachedClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        cachedSetTimeout(drainQueue, 0);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global, setImmediate) {!function(e){if(true)module.exports=e();else if("function"==typeof define&&define.amd)define([],e);else{var t;t="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this,t.WebTorrent=e()}}(function(){var e;return function t(e,n,r){function o(s,a){if(!n[s]){if(!e[s]){var u="function"==typeof require&&require;if(!a&&u)return require(s,!0);if(i)return i(s,!0);var c=new Error("Cannot find module '"+s+"'");throw c.code="MODULE_NOT_FOUND",c}var f=n[s]={exports:{}};e[s][0].call(f.exports,function(t){var n=e[s][1][t];return o(n?n:t)},f,f.exports,t,e,n,r)}return n[s].exports}for(var i="function"==typeof require&&require,s=0;s<r.length;s++)o(r[s]);return o}({1:[function(e,t,n){function r(e,t){s.Readable.call(this,t),this.destroyed=!1,this._torrent=e._torrent;var n=t&&t.start||0,r=t&&t.end&&t.end<e.length?t.end:e.length-1,o=e._torrent.pieceLength;this._startPiece=(n+e.offset)/o|0,this._endPiece=(r+e.offset)/o|0,this._piece=this._startPiece,this._offset=n+e.offset-this._startPiece*o,this._missing=r-n+1,this._reading=!1,this._notifying=!1,this._criticalLength=Math.min(1048576/o|0,2)}t.exports=r;var o=e("debug")("webtorrent:file-stream"),i=e("inherits"),s=e("readable-stream");i(r,s.Readable),r.prototype._read=function(){this._reading||(this._reading=!0,this._notify())},r.prototype._notify=function(){var e=this;if(e._reading&&0!==e._missing){if(!e._torrent.bitfield.get(e._piece))return e._torrent.critical(e._piece,e._piece+e._criticalLength);if(!e._notifying){e._notifying=!0;var t=e._piece;e._torrent.store.get(t,function(n,r){if(e._notifying=!1,!e.destroyed){if(n)return e._destroy(n);o("read %s (length %s) (err %s)",t,r.length,n&&n.message),e._offset&&(r=r.slice(e._offset),e._offset=0),e._missing<r.length&&(r=r.slice(0,e._missing)),e._missing-=r.length,o("pushing buffer of length %s",r.length),e._reading=!1,e.push(r),0===e._missing&&e.push(null)}}),e._piece+=1}}},r.prototype.destroy=function(e){this._destroy(null,e)},r.prototype._destroy=function(e,t){this.destroyed||(this.destroyed=!0,this._torrent.destroyed||this._torrent.deselect(this._startPiece,this._endPiece,!0),e&&this.emit("error",e),this.emit("close"),t&&t())}},{debug:34,inherits:46,"readable-stream":88}],2:[function(e,t,n){(function(n){function r(e,t){i.call(this),this._torrent=e,this._destroyed=!1,this.name=t.name,this.path=t.path,this.length=t.length,this.offset=t.offset,this.done=!1;var n=t.offset,r=n+t.length-1;this._startPiece=n/this._torrent.pieceLength|0,this._endPiece=r/this._torrent.pieceLength|0,0===this.length&&(this.done=!0,this.emit("done"))}t.exports=r;var o=e("end-of-stream"),i=e("events").EventEmitter,s=e("./file-stream"),a=e("inherits"),u=e("path"),c=e("render-media"),f=e("readable-stream"),d=e("stream-to-blob"),h=e("stream-to-blob-url"),l=e("stream-with-known-length-to-buffer");a(r,i),r.prototype.select=function(e){0!==this.length&&this._torrent.select(this._startPiece,this._endPiece,e)},r.prototype.deselect=function(){0!==this.length&&this._torrent.deselect(this._startPiece,this._endPiece,!1)},r.prototype.createReadStream=function(e){var t=this;if(0===this.length){var r=new f.PassThrough;return n.nextTick(function(){r.end()}),r}var i=new s(t,e);return t._torrent.select(i._startPiece,i._endPiece,!0,function(){i._notify()}),o(i,function(){t._destroyed||t._torrent.destroyed||t._torrent.deselect(i._startPiece,i._endPiece,!0)}),i},r.prototype.getBuffer=function(e){l(this.createReadStream(),this.length,e)},r.prototype.getBlob=function(e){if("undefined"==typeof window)throw new Error("browser-only method");d(this.createReadStream(),this._getMimeType(),e)},r.prototype.getBlobURL=function(e){if("undefined"==typeof window)throw new Error("browser-only method");h(this.createReadStream(),this._getMimeType(),e)},r.prototype.appendTo=function(e,t){if("undefined"==typeof window)throw new Error("browser-only method");c.append(this,e,t)},r.prototype.renderTo=function(e,t){if("undefined"==typeof window)throw new Error("browser-only method");c.render(this,e,t)},r.prototype._getMimeType=function(){return c.mime[u.extname(this.name).toLowerCase()]},r.prototype._destroy=function(){this._destroyed=!0,this._torrent=null}}).call(this,e("_process"))},{"./file-stream":1,_process:75,"end-of-stream":37,events:38,inherits:46,path:72,"readable-stream":88,"render-media":89,"stream-to-blob":106,"stream-to-blob-url":105,"stream-with-known-length-to-buffer":107}],3:[function(e,t,n){function r(e,t){var n=this;n.id=e,n.type=t,s("new Peer %s",e),n.addr=null,n.conn=null,n.swarm=null,n.wire=null,n.connected=!1,n.destroyed=!1,n.timeout=null,n.retries=0,n.sentHandshake=!1}function o(){}var i=e("unordered-array-remove"),s=e("debug")("webtorrent:peer"),a=e("bittorrent-protocol"),u=e("./webconn"),c=5e3,f=25e3,d=25e3;n.createWebRTCPeer=function(e,t){var n=new r(e.id,"webrtc");return n.conn=e,n.swarm=t,n.conn.connected?n.onConnect():(n.conn.once("connect",function(){n.onConnect()}),n.conn.once("error",function(e){n.destroy(e)}),n.startConnectTimeout()),n},n.createTCPIncomingPeer=function(e){var t=e.remoteAddress+":"+e.remotePort,n=new r(t,"tcpIncoming");return n.conn=e,n.addr=t,n.onConnect(),n},n.createTCPOutgoingPeer=function(e,t){var n=new r(e,"tcpOutgoing");return n.addr=e,n.swarm=t,n},n.createWebSeedPeer=function(e,t){var n=new r(e,"webSeed");return n.swarm=t,n.conn=new u(e,t),n.onConnect(),n},r.prototype.onConnect=function(){var e=this;if(!e.destroyed){e.connected=!0,s("Peer %s connected",e.id),clearTimeout(e.connectTimeout);var t=e.conn;t.once("end",function(){e.destroy()}),t.once("close",function(){e.destroy()}),t.once("finish",function(){e.destroy()}),t.once("error",function(t){e.destroy(t)});var n=e.wire=new a;n.type=e.type,n.once("end",function(){e.destroy()}),n.once("close",function(){e.destroy()}),n.once("finish",function(){e.destroy()}),n.once("error",function(t){e.destroy(t)}),n.once("handshake",function(t,n){e.onHandshake(t,n)}),e.startHandshakeTimeout(),t.pipe(n).pipe(t),e.swarm&&!e.sentHandshake&&e.handshake()}},r.prototype.onHandshake=function(e,t){var n=this;if(n.swarm&&!n.destroyed){if(n.swarm.destroyed)return n.destroy(new Error("swarm already destroyed"));if(e!==n.swarm.infoHash)return n.destroy(new Error("unexpected handshake info hash for this swarm"));if(t===n.swarm.peerId)return n.destroy(new Error("refusing to connect to ourselves"));s("Peer %s got handshake %s",n.id,e),clearTimeout(n.handshakeTimeout),n.retries=0;var r=n.addr;!r&&n.conn.remoteAddress&&(r=n.conn.remoteAddress+":"+n.conn.remotePort),n.swarm._onWire(n.wire,r),n.swarm&&!n.swarm.destroyed&&(n.sentHandshake||n.handshake())}},r.prototype.handshake=function(){var e=this,t={dht:e.swarm["private"]?!1:!!e.swarm.client.dht};e.wire.handshake(e.swarm.infoHash,e.swarm.client.peerId,t),e.sentHandshake=!0},r.prototype.startConnectTimeout=function(){var e=this;clearTimeout(e.connectTimeout),e.connectTimeout=setTimeout(function(){e.destroy(new Error("connect timeout"))},"webrtc"===e.type?f:c),e.connectTimeout.unref&&e.connectTimeout.unref()},r.prototype.startHandshakeTimeout=function(){var e=this;clearTimeout(e.handshakeTimeout),e.handshakeTimeout=setTimeout(function(){e.destroy(new Error("handshake timeout"))},d),e.handshakeTimeout.unref&&e.handshakeTimeout.unref()},r.prototype.destroy=function(e){var t=this;if(!t.destroyed){t.destroyed=!0,t.connected=!1,s("destroy %s (error: %s)",t.id,e&&(e.message||e)),clearTimeout(t.connectTimeout),clearTimeout(t.handshakeTimeout);var n=t.swarm,r=t.conn,a=t.wire;t.swarm=null,t.conn=null,t.wire=null,n&&a&&i(n.wires,n.wires.indexOf(a)),r&&(r.on("error",o),r.destroy()),a&&a.destroy(),n&&n.removePeer(t.id)}}},{"./webconn":6,"bittorrent-protocol":14,debug:34,"unordered-array-remove":117}],4:[function(e,t,n){function r(e){var t=this;t._torrent=e,t._numPieces=e.pieces.length,t._pieces=[],t._onWire=function(e){t.recalculate(),t._initWire(e)},t._onWireHave=function(e){t._pieces[e]+=1},t._onWireBitfield=function(){t.recalculate()},t._torrent.wires.forEach(function(e){t._initWire(e)}),t._torrent.on("wire",t._onWire),t.recalculate()}function o(){return!0}t.exports=r,r.prototype.getRarestPiece=function(e){e||(e=o);for(var t=[],n=1/0,r=0;r<this._numPieces;++r)if(e(r)){var i=this._pieces[r];i===n?t.push(r):n>i&&(t=[r],n=i)}return t.length>0?t[Math.random()*t.length|0]:-1},r.prototype.destroy=function(){var e=this;e._torrent.removeListener("wire",e._onWire),e._torrent.wires.forEach(function(t){e._cleanupWireEvents(t)}),e._torrent=null,e._pieces=null,e._onWire=null,e._onWireHave=null,e._onWireBitfield=null},r.prototype._initWire=function(e){var t=this;e._onClose=function(){t._cleanupWireEvents(e);for(var n=0;n<this._numPieces;++n)t._pieces[n]-=e.peerPieces.get(n)},e.on("have",t._onWireHave),e.on("bitfield",t._onWireBitfield),e.once("close",e._onClose)},r.prototype.recalculate=function(){var e;for(e=0;e<this._numPieces;++e)this._pieces[e]=0;var t=this._torrent.wires.length;for(e=0;t>e;++e)for(var n=this._torrent.wires[e],r=0;r<this._numPieces;++r)this._pieces[r]+=n.peerPieces.get(r)},r.prototype._cleanupWireEvents=function(e){e.removeListener("have",this._onWireHave),e.removeListener("bitfield",this._onWireBitfield),e._onClose&&e.removeListener("close",e._onClose),e._onClose=null}},{}],5:[function(e,t,n){(function(n,r){function o(e,t,n){m.call(this),this.client=t,this._debugId=this.client.peerId.slice(32),this._debug("new torrent"),this.announce=n.announce,this.urlList=n.urlList,this.path=n.path,this._store=n.store||v,this._getAnnounceOpts=n.getAnnounceOpts,this.strategy=n.strategy||"sequential",this.maxWebConns=n.maxWebConns||4,this._rechokeNumSlots=n.uploads===!1||0===n.uploads?0:+n.uploads||10,this._rechokeOptimisticWire=null,this._rechokeOptimisticTime=0,this._rechokeIntervalId=null,this.ready=!1,this.destroyed=!1,this.paused=!1,this.done=!1,this.metadata=null,this.store=null,this.files=[],this.pieces=[],this._amInterested=!1,this._selections=[],this._critical=[],this.wires=[],this._queue=[],this._peers={},this._peersLength=0,this.received=0,this.uploaded=0,this._downloadSpeed=P(),this._uploadSpeed=P(),this._servers=[],this._xsRequests=[],this._fileModtimes=n.fileModtimes,null!==e&&this._onTorrentId(e)}function i(e,t){return 2+Math.ceil(t*e.downloadSpeed()/C.BLOCK_LENGTH)}function s(e,t,n){return 1+Math.ceil(t*e.downloadSpeed()/n)}function a(e){return Math.random()*e|0}function u(){}t.exports=o;var c,f=e("addr-to-ip-port"),d=e("bitfield"),h=e("chunk-store-stream/write"),l=e("debug")("webtorrent:torrent"),p=e("torrent-discovery"),m=e("events").EventEmitter,g=e("xtend"),y=e("xtend/mutable"),_=e("fs"),v=e("fs-chunk-store"),b=e("simple-get"),w=e("immediate-chunk-store"),E=e("inherits"),k=e("multistream"),x=e("net"),S=e("os"),B=e("run-parallel"),I=e("run-parallel-limit"),A=e("parse-torrent"),T=e("path"),C=e("torrent-piece"),L=e("pump"),R=e("random-iterate"),U=e("simple-sha1"),P=e("speedometer"),O=e("uniq"),M=e("ut_metadata"),j=e("ut_pex"),H=e("./file"),D=e("./peer"),q=e("./rarity-map"),N=e("./server"),W=131072,z=3e4,F=5e3,Y=3*C.BLOCK_LENGTH,V=.5,G=1,$=1e4,K=2,X=2,J=[1e3,5e3,15e3],Q=e("../package.json").version;try{c=T.join(_.statSync("/tmp")&&"/tmp","webtorrent")}catch(Z){c=T.join("function"==typeof S.tmpDir?S.tmpDir():"/","webtorrent")}E(o,m),Object.defineProperty(o.prototype,"timeRemaining",{get:function(){return this.done?0:0===this.downloadSpeed?1/0:(this.length-this.downloaded)/this.downloadSpeed*1e3}}),Object.defineProperty(o.prototype,"downloaded",{get:function(){if(!this.bitfield)return 0;for(var e=0,t=0,n=this.pieces.length;n>t;++t)if(this.bitfield.get(t))e+=t===n-1?this.lastPieceLength:this.pieceLength;else{var r=this.pieces[t];e+=r.length-r.missing}return e}}),Object.defineProperty(o.prototype,"downloadSpeed",{get:function(){return this._downloadSpeed()}}),Object.defineProperty(o.prototype,"uploadSpeed",{get:function(){return this._uploadSpeed()}}),Object.defineProperty(o.prototype,"progress",{get:function(){return this.length?this.downloaded/this.length:0}}),Object.defineProperty(o.prototype,"ratio",{get:function(){return this.uploaded/(this.received||1)}}),Object.defineProperty(o.prototype,"numPeers",{get:function(){return this.wires.length}}),Object.defineProperty(o.prototype,"torrentFileBlobURL",{get:function(){if("undefined"==typeof window)throw new Error("browser-only property");return this.torrentFile?URL.createObjectURL(new Blob([this.torrentFile],{type:"application/x-bittorrent"})):null}}),Object.defineProperty(o.prototype,"_numQueued",{get:function(){return this._queue.length+(this._peersLength-this._numConns)}}),Object.defineProperty(o.prototype,"_numConns",{get:function(){var e=this,t=0;for(var n in e._peers)e._peers[n].connected&&(t+=1);return t}}),Object.defineProperty(o.prototype,"swarm",{get:function(){return console.warn("WebTorrent: `torrent.swarm` is deprecated. Use `torrent` directly instead."),this}}),o.prototype._onTorrentId=function(e){var t=this;if(!t.destroyed){var r;try{r=A(e)}catch(o){}r?(t.infoHash=r.infoHash,n.nextTick(function(){t.destroyed||t._onParsedTorrent(r)})):A.remote(e,function(e,n){return t.destroyed?void 0:e?t._destroy(e):void t._onParsedTorrent(n)})}},o.prototype._onParsedTorrent=function(e){var t=this;if(!t.destroyed){if(t._processParsedTorrent(e),!t.infoHash)return t._destroy(new Error("Malformed torrent data: No info hash"));t.path||(t.path=T.join(c,t.infoHash)),t._rechokeIntervalId=setInterval(function(){t._rechoke()},$),t._rechokeIntervalId.unref&&t._rechokeIntervalId.unref(),t.emit("_infoHash",t.infoHash),t.destroyed||(t.emit("infoHash",t.infoHash),t.destroyed||(t.client.listening?t._onListening():t.client.once("listening",function(){t._onListening()})))}},o.prototype._processParsedTorrent=function(e){this.announce&&(e.announce=e.announce.concat(this.announce)),this.client.tracker&&r.WEBTORRENT_ANNOUNCE&&!this["private"]&&(e.announce=e.announce.concat(r.WEBTORRENT_ANNOUNCE)),this.urlList&&(e.urlList=e.urlList.concat(this.urlList)),O(e.announce),O(e.urlList),y(this,e),this.magnetURI=A.toMagnetURI(e),this.torrentFile=A.toTorrentFile(e)},o.prototype._onListening=function(){function e(e){i._destroy(e)}function t(e){"string"==typeof e&&i.done||i.addPeer(e)}function n(){i.emit("trackerAnnounce"),0===i.numPeers&&i.emit("noPeers","tracker")}function r(){i.emit("dhtAnnounce"),0===i.numPeers&&i.emit("noPeers","dht")}function o(e){i.emit("warning",e)}var i=this;if(!i.discovery&&!i.destroyed){var s=i.client.tracker;s&&(s=g(i.client.tracker,{getAnnounceOpts:function(){var e={uploaded:i.uploaded,downloaded:i.downloaded,left:Math.max(i.length-i.downloaded,0)};return i.client.tracker.getAnnounceOpts&&y(e,i.client.tracker.getAnnounceOpts()),i._getAnnounceOpts&&y(e,i._getAnnounceOpts()),e}})),i.discovery=new p({infoHash:i.infoHash,announce:i.announce,peerId:i.client.peerId,dht:!i["private"]&&i.client.dht,tracker:s,port:i.client.torrentPort}),i.discovery.on("error",e),i.discovery.on("peer",t),i.discovery.on("trackerAnnounce",n),i.discovery.on("dhtAnnounce",r),i.discovery.on("warning",o),i.info?i._onMetadata(i):i.xs&&i._getMetadataFromServer()}},o.prototype._getMetadataFromServer=function(){function e(e,n){function r(r,o,i){if(t.destroyed)return n(null);if(t.metadata)return n(null);if(r)return t._debug("http error from xs param: %s",e),n(null);if(200!==o.statusCode)return t._debug("non-200 status code %s from xs param: %s",o.statusCode,e),n(null);var s;try{s=A(i)}catch(r){}return s?s.infoHash!==t.infoHash?(t._debug("got torrent file with incorrect info hash from xs param: %s",e),n(null)):(t._onMetadata(s),void n(null)):(t._debug("got invalid torrent file from xs param: %s",e),n(null))}if(0!==e.indexOf("http://")&&0!==e.indexOf("https://"))return t._debug("skipping non-http xs param: %s",e),n(null);var o,i={url:e,method:"GET",headers:{"user-agent":"WebTorrent/"+Q+" (https://webtorrent.io)"}};try{o=b.concat(i,r)}catch(s){return t._debug("skipping invalid url xs param: %s",e),n(null)}t._xsRequests.push(o)}var t=this,n=Array.isArray(t.xs)?t.xs:[t.xs],r=n.map(function(t){return function(n){e(t,n)}});B(r)},o.prototype._onMetadata=function(e){var t=this;if(!t.metadata&&!t.destroyed){t._debug("got metadata"),t._xsRequests.forEach(function(e){e.abort()}),t._xsRequests=[];var n;if(e&&e.infoHash)n=e;else try{n=A(e)}catch(r){return t._destroy(r)}t._processParsedTorrent(n),t.metadata=t.torrentFile,t.urlList.forEach(function(e){t.addWebSeed(e)}),t._rarityMap=new q(t),t.store=new w(new t._store(t.pieceLength,{torrent:{infoHash:t.infoHash},files:t.files.map(function(e){return{path:T.join(t.path,e.path),length:e.length,offset:e.offset}}),length:t.length})),t.files=t.files.map(function(e){return new H(t,e)}),t._hashes=t.pieces,t.pieces=t.pieces.map(function(e,n){var r=n===t.pieces.length-1?t.lastPieceLength:t.pieceLength;return new C(r)}),t._reservations=t.pieces.map(function(){return[]}),t.bitfield=new d(t.pieces.length),t.wires.forEach(function(e){e.ut_metadata&&e.ut_metadata.setMetadata(t.metadata),t._onWireWithMetadata(e)}),t._debug("verifying existing torrent data"),t._fileModtimes&&t._store===v?t.getFileModtimes(function(e,n){if(e)return t._destroy(e);var r=t.files.map(function(e,r){return n[r]===t._fileModtimes[r]}).every(function(e){return e});if(r){for(var o=0;o<t.pieces.length;o++)t._markVerified(o);t._onStore()}else t._verifyPieces()}):t._verifyPieces(),t.emit("metadata")}},o.prototype.getFileModtimes=function(e){var t=this,n=[];I(t.files.map(function(e,r){return function(o){_.stat(T.join(t.path,e.path),function(e,t){return e&&"ENOENT"!==e.code?o(e):(n[r]=t&&t.mtime.getTime(),void o(null))})}}),X,function(r){t._debug("done getting file modtimes"),e(r,n)})},o.prototype._verifyPieces=function(){var e=this;I(e.pieces.map(function(t,n){return function(t){return e.destroyed?t(new Error("torrent is destroyed")):void e.store.get(n,function(r,o){return r?t(null):void U(o,function(r){if(r===e._hashes[n]){if(!e.pieces[n])return;e._debug("piece verified %s",n),e._markVerified(n)}else e._debug("piece invalid %s",n);t(null)})})}}),X,function(t){return t?e._destroy(t):(e._debug("done verifying"),void e._onStore())})},o.prototype._markVerified=function(e){this.pieces[e]=null,this._reservations[e]=null,this.bitfield.set(e,!0)},o.prototype._onStore=function(){var e=this;e.destroyed||(e._debug("on store"),0!==e.pieces.length&&e.select(0,e.pieces.length-1,!1),e.ready=!0,e.emit("ready"),e._checkDone(),e._updateSelections())},o.prototype.destroy=function(e){var t=this;t._destroy(null,e)},o.prototype._destroy=function(e,t){var n=this;if(!n.destroyed){n.destroyed=!0,n._debug("destroy"),n.client._remove(n),clearInterval(n._rechokeIntervalId),n._xsRequests.forEach(function(e){e.abort()}),n._rarityMap&&n._rarityMap.destroy();for(var r in n._peers)n.removePeer(r);n.files.forEach(function(e){e instanceof H&&e._destroy()});var o=n._servers.map(function(e){return function(t){e.destroy(t)}});n.discovery&&o.push(function(e){n.discovery.destroy(e)}),n.store&&o.push(function(e){n.store.close(e)}),B(o,t),e&&(0===n.listenerCount("error")?n.client.emit("error",e):n.emit("error",e)),n.emit("close"),n.client=null,n.files=[],n.discovery=null,n.store=null,n._rarityMap=null,n._peers=null,n._servers=null,n._xsRequests=null}},o.prototype.addPeer=function(e){var t=this;if(t.destroyed)throw new Error("torrent is destroyed");if(!t.infoHash)throw new Error("addPeer() must not be called before the `infoHash` event");if(t.client.blocked){var n;if("string"==typeof e){var r;try{r=f(e)}catch(o){return t._debug("ignoring peer: invalid %s",e),t.emit("invalidPeer",e),!1}n=r[0]}else"string"==typeof e.remoteAddress&&(n=e.remoteAddress);if(n&&t.client.blocked.contains(n))return t._debug("ignoring peer: blocked %s",e),"string"!=typeof e&&e.destroy(),t.emit("blockedPeer",e),!1}var i=!!t._addPeer(e);return i?t.emit("peer",e):t.emit("invalidPeer",e),i},o.prototype._addPeer=function(e){var t=this;if(t.destroyed)return t._debug("ignoring peer: torrent is destroyed"),"string"!=typeof e&&e.destroy(),null;if("string"==typeof e&&!t._validAddr(e))return t._debug("ignoring peer: invalid %s",e),null;var n=e&&e.id||e;if(t._peers[n])return t._debug("ignoring peer: duplicate (%s)",n),"string"!=typeof e&&e.destroy(),null;if(t.paused)return t._debug("ignoring peer: torrent is paused"),"string"!=typeof e&&e.destroy(),null;t._debug("add peer %s",n);var r;return r="string"==typeof e?D.createTCPOutgoingPeer(e,t):D.createWebRTCPeer(e,t),t._peers[r.id]=r,t._peersLength+=1,"string"==typeof e&&(t._queue.push(r),t._drain()),r},o.prototype.addWebSeed=function(e){if(this.destroyed)throw new Error("torrent is destroyed");if(!/^https?:\/\/.+/.test(e))return this._debug("ignoring invalid web seed %s",e),void this.emit("invalidPeer",e);if(this._peers[e])return this._debug("ignoring duplicate web seed %s",e),void this.emit("invalidPeer",e);this._debug("add web seed %s",e);var t=D.createWebSeedPeer(e,this);this._peers[t.id]=t,this._peersLength+=1,this.emit("peer",e)},o.prototype._addIncomingPeer=function(e){var t=this;return t.destroyed?e.destroy(new Error("torrent is destroyed")):t.paused?e.destroy(new Error("torrent is paused")):(this._debug("add incoming peer %s",e.id),t._peers[e.id]=e,void(t._peersLength+=1))},o.prototype.removePeer=function(e){var t=this,n=e&&e.id||e;e=t._peers[n],e&&(this._debug("removePeer %s",n),delete t._peers[n],t._peersLength-=1,e.destroy(),t._drain())},o.prototype.select=function(e,t,n,r){var o=this;if(o.destroyed)throw new Error("torrent is destroyed");if(0>e||e>t||o.pieces.length<=t)throw new Error("invalid selection ",e,":",t);n=Number(n)||0,o._debug("select %s-%s (priority %s)",e,t,n),o._selections.push({from:e,to:t,offset:0,priority:n,notify:r||u}),o._selections.sort(function(e,t){return t.priority-e.priority}),o._updateSelections()},o.prototype.deselect=function(e,t,n){var r=this;if(r.destroyed)throw new Error("torrent is destroyed");n=Number(n)||0,r._debug("deselect %s-%s (priority %s)",e,t,n);for(var o=0;o<r._selections.length;++o){var i=r._selections[o];if(i.from===e&&i.to===t&&i.priority===n){r._selections.splice(o--,1);break}}r._updateSelections()},o.prototype.critical=function(e,t){var n=this;if(n.destroyed)throw new Error("torrent is destroyed");n._debug("critical %s-%s",e,t);for(var r=e;t>=r;++r)n._critical[r]=!0;n._updateSelections()},o.prototype._onWire=function(e,t){var r=this;if(r._debug("got wire %s (%s)",e._debugId,t||"Unknown"),e.on("download",function(e){r.destroyed||(r.received+=e,r._downloadSpeed(e),r.client._downloadSpeed(e),r.emit("download",e),r.client.emit("download",e))}),e.on("upload",function(e){r.destroyed||(r.uploaded+=e,r._uploadSpeed(e),r.client._uploadSpeed(e),r.emit("upload",e),r.client.emit("upload",e))}),r.wires.push(e),t){var o=f(t);e.remoteAddress=o[0],e.remotePort=o[1]}r.client.dht&&r.client.dht.listening&&e.on("port",function(n){if(!r.destroyed&&!r.client.dht.destroyed){if(!e.remoteAddress)return r._debug("ignoring PORT from peer with no address");if(0===n||n>65536)return r._debug("ignoring invalid PORT from peer");r._debug("port: %s (from %s)",n,t),r.client.dht.addNode({host:e.remoteAddress,port:n})}}),e.on("timeout",function(){r._debug("wire timeout (%s)",t),e.destroy()}),e.setTimeout(z,!0),e.setKeepAlive(!0),e.use(M(r.metadata)),e.ut_metadata.on("warning",function(e){r._debug("ut_metadata warning: %s",e.message)}),r.metadata||(e.ut_metadata.on("metadata",function(e){r._debug("got metadata via ut_metadata"),r._onMetadata(e)}),e.ut_metadata.fetch()),"function"!=typeof j||r["private"]||(e.use(j()),e.ut_pex.on("peer",function(e){r.done||(r._debug("ut_pex: got peer: %s (from %s)",e,t),r.addPeer(e))}),e.ut_pex.on("dropped",function(e){var n=r._peers[e];n&&!n.connected&&(r._debug("ut_pex: dropped peer: %s (from %s)",e,t),r.removePeer(e))}),e.once("close",function(){e.ut_pex.reset()})),r.emit("wire",e,t),r.metadata&&n.nextTick(function(){r._onWireWithMetadata(e)})},o.prototype._onWireWithMetadata=function(e){function t(){r.destroyed||e.destroyed||(r._numQueued>2*(r._numConns-r.numPeers)&&e.amInterested?e.destroy():(o=setTimeout(t,F),o.unref&&o.unref()))}function n(){if(e.peerPieces.length===r.pieces.length){for(;i<r.pieces.length;++i)if(!e.peerPieces.get(i))return;e.isSeeder=!0,e.choke()}}var r=this,o=null,i=0;e.on("bitfield",function(){n(),r._update()}),e.on("have",function(){n(),r._update()}),e.once("interested",function(){e.unchoke()}),e.once("close",function(){clearTimeout(o)}),e.on("choke",function(){clearTimeout(o),o=setTimeout(t,F),o.unref&&o.unref()}),e.on("unchoke",function(){clearTimeout(o),r._update()}),e.on("request",function(t,n,o,i){return o>W?e.destroy():void(r.pieces[t]||r.store.get(t,{offset:n,length:o},i))}),e.bitfield(r.bitfield),e.interested(),e.peerExtensions.dht&&r.client.dht&&r.client.dht.listening&&e.port(r.client.dht.address().port),o=setTimeout(t,F),o.unref&&o.unref(),e.isSeeder=!1,n()},o.prototype._updateSelections=function(){var e=this;e.ready&&!e.destroyed&&(n.nextTick(function(){e._gcSelections()}),e._updateInterest(),e._update())},o.prototype._gcSelections=function(){for(var e=this,t=0;t<e._selections.length;t++){for(var n=e._selections[t],r=n.offset;e.bitfield.get(n.from+n.offset)&&n.from+n.offset<n.to;)n.offset++;r!==n.offset&&n.notify(),n.to===n.from+n.offset&&e.bitfield.get(n.from+n.offset)&&(e._selections.splice(t--,1),n.notify(),e._updateInterest())}e._selections.length||e.emit("idle")},o.prototype._updateInterest=function(){var e=this,t=e._amInterested;e._amInterested=!!e._selections.length,e.wires.forEach(function(t){e._amInterested?t.interested():t.uninterested()}),t!==e._amInterested&&(e._amInterested?e.emit("interested"):e.emit("uninterested"))},o.prototype._update=function(){var e=this;if(!e.destroyed)for(var t,n=R(e.wires);t=n();)e._updateWire(t)},o.prototype._updateWire=function(e){function t(t,n,r,o){return function(i){return i>=t&&n>=i&&!(i in r)&&e.peerPieces.get(i)&&(!o||o(i))}}function n(){if(!e.requests.length)for(var n=a._selections.length;n--;){var r,o=a._selections[n];if("rarest"===a.strategy)for(var i=o.from+o.offset,s=o.to,u=s-i+1,c={},f=0,d=t(i,s,c);u>f&&(r=a._rarityMap.getRarestPiece(d),!(0>r));){if(a._request(e,r,!1))return;c[r]=!0,f+=1}else for(r=o.to;r>=o.from+o.offset;--r)if(e.peerPieces.get(r)&&a._request(e,r,!1))return}}function r(){var t=e.downloadSpeed()||1;if(t>Y)return function(){return!0};var n=Math.max(1,e.requests.length)*C.BLOCK_LENGTH/t,r=10,o=0;return function(e){if(!r||a.bitfield.get(e))return!0;for(var i=a.pieces[e].missing;o<a.wires.length;o++){var s=a.wires[o],u=s.downloadSpeed();if(!(Y>u)&&!(t>=u)&&s.peerPieces.get(e)&&!((i-=u*n)>0))return r--,!1}return!0}}function o(e){for(var t=e,n=e;n<a._selections.length&&a._selections[n].priority;n++)t=n;var r=a._selections[e];a._selections[e]=a._selections[t],a._selections[t]=r}function s(n){if(e.requests.length>=c)return!0;for(var i=r(),s=0;s<a._selections.length;s++){var u,f=a._selections[s];if("rarest"===a.strategy)for(var d=f.from+f.offset,h=f.to,l=h-d+1,p={},m=0,g=t(d,h,p,i);l>m&&(u=a._rarityMap.getRarestPiece(g),!(0>u));){for(;a._request(e,u,a._critical[u]||n););if(!(e.requests.length<c))return f.priority&&o(s),!0;p[u]=!0,m++}else for(u=f.from+f.offset;u<=f.to;u++)if(e.peerPieces.get(u)&&i(u)){for(;a._request(e,u,a._critical[u]||n););if(!(e.requests.length<c))return f.priority&&o(s),!0}}return!1}var a=this;if(!e.peerChoking){if(!e.downloaded)return n();var u=i(e,V);if(!(e.requests.length>=u)){var c=i(e,G);s(!1)||s(!0)}}},o.prototype._rechoke=function(){function e(e,t){return e.downloadSpeed!==t.downloadSpeed?t.downloadSpeed-e.downloadSpeed:e.uploadSpeed!==t.uploadSpeed?t.uploadSpeed-e.uploadSpeed:e.wire.amChoking!==t.wire.amChoking?e.wire.amChoking?1:-1:e.salt-t.salt}var t=this;if(t.ready){t._rechokeOptimisticTime>0?t._rechokeOptimisticTime-=1:t._rechokeOptimisticWire=null;var n=[];t.wires.forEach(function(e){e.isSeeder||e===t._rechokeOptimisticWire||n.push({wire:e,downloadSpeed:e.downloadSpeed(),uploadSpeed:e.uploadSpeed(),salt:Math.random(),isChoked:!0})}),n.sort(e);for(var r=0,o=0;o<n.length&&r<t._rechokeNumSlots;++o)n[o].isChoked=!1,n[o].wire.peerInterested&&(r+=1);if(!t._rechokeOptimisticWire&&o<n.length&&t._rechokeNumSlots){var i=n.slice(o).filter(function(e){return e.wire.peerInterested}),s=i[a(i.length)];s&&(s.isChoked=!1,t._rechokeOptimisticWire=s.wire,t._rechokeOptimisticTime=K)}n.forEach(function(e){e.wire.amChoking!==e.isChoked&&(e.isChoked?e.wire.choke():e.wire.unchoke())})}},o.prototype._hotswap=function(e,t){var n=this,r=e.downloadSpeed();if(r<C.BLOCK_LENGTH)return!1;if(!n._reservations[t])return!1;var o=n._reservations[t];if(!o)return!1;var i,s,a=1/0;for(s=0;s<o.length;s++){var u=o[s];if(u&&u!==e){var c=u.downloadSpeed();c>=Y||2*c>r||c>a||(i=u,a=c)}}if(!i)return!1;for(s=0;s<o.length;s++)o[s]===i&&(o[s]=null);for(s=0;s<i.requests.length;s++){var f=i.requests[s];f.piece===t&&n.pieces[t].cancel(f.offset/C.BLOCK_LENGTH|0)}return n.emit("hotswap",i,e,t),!0},o.prototype._request=function(e,t,r){function o(){n.nextTick(function(){a._update()})}var a=this,u=e.requests.length,c="webSeed"===e.type;if(a.bitfield.get(t))return!1;var f=c?Math.min(s(e,G,a.pieceLength),a.maxWebConns):i(e,G);if(u>=f)return!1;var d=a.pieces[t],h=c?d.reserveRemaining():d.reserve();if(-1===h&&r&&a._hotswap(e,t)&&(h=c?d.reserveRemaining():d.reserve()),-1===h)return!1;var l=a._reservations[t];l||(l=a._reservations[t]=[]);var p=l.indexOf(null);-1===p&&(p=l.length),l[p]=e;var m=d.chunkOffset(h),g=c?d.chunkLengthRemaining(h):d.chunkLength(h);return e.request(t,m,g,function y(n,r){if(!a.ready)return a.once("ready",function(){y(n,r)});if(l[p]===e&&(l[p]=null),d!==a.pieces[t])return o();if(n)return a._debug("error getting piece %s (offset: %s length: %s) from %s: %s",t,m,g,e.remoteAddress+":"+e.remotePort,n.message),c?d.cancelRemaining(h):d.cancel(h),void o();if(a._debug("got piece %s (offset: %s length: %s) from %s",t,m,g,e.remoteAddress+":"+e.remotePort),!d.set(h,r,e))return o();var i=d.flush();U(i,function(e){if(e===a._hashes[t]){if(!a.pieces[t])return;a._debug("piece verified %s",t),a.pieces[t]=null,a._reservations[t]=null,a.bitfield.set(t,!0),a.store.put(t,i),a.wires.forEach(function(e){e.have(t)}),a._checkDone()}else a.pieces[t]=new C(d.length),a.emit("warning",new Error("Piece "+t+" failed verification"));o()})}),!0},o.prototype._checkDone=function(){var e=this;if(!e.destroyed){e.files.forEach(function(t){if(!t.done){for(var n=t._startPiece;n<=t._endPiece;++n)if(!e.bitfield.get(n))return;t.done=!0,t.emit("done"),e._debug("file done: "+t.name)}});for(var t=!0,n=0;n<e._selections.length;n++){for(var r=e._selections[n],o=r.from;o<=r.to;o++)if(!e.bitfield.get(o)){t=!1;break}if(!t)break}!e.done&&t&&(e.done=!0,e._debug("torrent done: "+e.infoHash),e.discovery.tracker&&e.discovery.tracker.complete(),e.emit("done")),e._gcSelections()}},o.prototype.load=function(e,t){var n=this;if(n.destroyed)throw new Error("torrent is destroyed");if(!n.ready)return n.once("ready",function(){n.load(e,t)});Array.isArray(e)||(e=[e]),t||(t=u);var r=new k(e),o=new h(n.store,n.pieceLength);L(r,o,function(e){return e?t(e):(n.pieces.forEach(function(e,t){n.pieces[t]=null,n._reservations[t]=null,n.bitfield.set(t,!0)}),n._checkDone(),void t(null))})},o.prototype.createServer=function(e){if("function"!=typeof N)throw new Error("node.js-only method");if(this.destroyed)throw new Error("torrent is destroyed");var t=new N(this,e);return this._servers.push(t),t},o.prototype.pause=function(){this.destroyed||(this._debug("pause"),this.paused=!0)},o.prototype.resume=function(){this.destroyed||(this._debug("resume"),this.paused=!1,this._drain())},o.prototype._debug=function(){var e=[].slice.call(arguments);e[0]="["+this._debugId+"] "+e[0],l.apply(null,e)},o.prototype._drain=function(){var e=this;if(this._debug("_drain numConns %s maxConns %s",e._numConns,e.client.maxConns),!("function"!=typeof x.connect||e.destroyed||e.paused||e._numConns>=e.client.maxConns)){this._debug("drain (%s queued, %s/%s peers)",e._numQueued,e.numPeers,e.client.maxConns);var t=e._queue.shift();if(t){this._debug("tcp connect attempt to %s",t.addr);
	var n=f(t.addr),r={host:n[0],port:n[1]},o=t.conn=x.connect(r);o.once("connect",function(){t.onConnect()}),o.once("error",function(e){t.destroy(e)}),t.startConnectTimeout(),o.on("close",function(){if(!e.destroyed){if(t.retries>=J.length)return void e._debug("conn %s closed: will not re-add (max %s attempts)",t.addr,J.length);var n=J[t.retries];e._debug("conn %s closed: will re-add to queue in %sms (attempt %s)",t.addr,n,t.retries+1);var r=setTimeout(function(){var n=e._addPeer(t.addr);n&&(n.retries=t.retries+1)},n);r.unref&&r.unref()}})}}},o.prototype._validAddr=function(e){var t;try{t=f(e)}catch(n){return!1}var r=t[0],o=t[1];return o>0&&65535>o&&!("127.0.0.1"===r&&o===this.client.torrentPort)}}).call(this,e("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"../package.json":128,"./file":2,"./peer":3,"./rarity-map":4,"./server":21,_process:75,"addr-to-ip-port":7,bitfield:13,"chunk-store-stream/write":26,debug:34,events:38,fs:22,"fs-chunk-store":55,"immediate-chunk-store":45,inherits:46,multistream:63,net:21,os:21,"parse-torrent":71,path:72,pump:76,"random-iterate":81,"run-parallel":92,"run-parallel-limit":91,"simple-get":96,"simple-sha1":98,speedometer:100,"torrent-discovery":112,"torrent-piece":113,uniq:116,ut_metadata:120,ut_pex:21,xtend:125,"xtend/mutable":126}],6:[function(e,t,n){function r(e,t){f.call(this),this.url=e,this.webPeerId=c.sync(e),this._torrent=t,this._init()}t.exports=r;var o=e("bitfield"),i=e("safe-buffer").Buffer,s=e("debug")("webtorrent:webconn"),a=e("simple-get"),u=e("inherits"),c=e("simple-sha1"),f=e("bittorrent-protocol"),d=e("../package.json").version;u(r,f),r.prototype._init=function(){var e=this;e.setKeepAlive(!0),e.once("handshake",function(t,n){if(!e.destroyed){e.handshake(t,e.webPeerId);for(var r=e._torrent.pieces.length,i=new o(r),s=0;r>=s;s++)i.set(s,!0);e.bitfield(i)}}),e.once("interested",function(){s("interested"),e.unchoke()}),e.on("uninterested",function(){s("uninterested")}),e.on("choke",function(){s("choke")}),e.on("unchoke",function(){s("unchoke")}),e.on("bitfield",function(){s("bitfield")}),e.on("request",function(t,n,r,o){s("request pieceIndex=%d offset=%d length=%d",t,n,r),e.httpRequest(t,n,r,o)})},r.prototype.httpRequest=function(e,t,n,r){var o,u=this,c=e*u._torrent.pieceLength,f=c+t,h=f+n-1,l=u._torrent.files;if(l.length<=1)o=[{url:u.url,start:f,end:h}];else{var p=l.filter(function(e){return e.offset<=h&&e.offset+e.length>f});if(p.length<1)return r(new Error("Could not find file corresponnding to web seed range request"));o=p.map(function(e){var t=e.offset+e.length-1,n=u.url+("/"===u.url[u.url.length-1]?"":"/")+e.path;return{url:n,fileOffsetInRange:Math.max(e.offset-f,0),start:Math.max(f-e.offset,0),end:Math.min(t,h-e.offset)}})}var m,g=0,y=!1;o.length>1&&(m=i.alloc(n)),o.forEach(function(i){var u=i.url,c=i.start,f=i.end;s("Requesting url=%s pieceIndex=%d offset=%d length=%d start=%d end=%d",u,e,t,n,c,f);var h={url:u,method:"GET",headers:{"user-agent":"WebTorrent/"+d+" (https://webtorrent.io)",range:"bytes="+c+"-"+f}};a.concat(h,function(e,t,n){if(!y){if(e)return y=!0,r(e);if(t.statusCode<200||t.statusCode>=300)return y=!0,r(new Error("Unexpected HTTP status code "+t.statusCode));s("Got data of length %d",n.length),1===o.length?r(null,n):(n.copy(m,i.fileOffsetInRange),++g===o.length&&r(null,m))}})})},r.prototype.destroy=function(){f.prototype.destroy.call(this),this._torrent=null}},{"../package.json":128,bitfield:13,"bittorrent-protocol":14,debug:34,inherits:46,"safe-buffer":94,"simple-get":96,"simple-sha1":98}],7:[function(e,t,n){var r=/^\[?([^\]]+)\]?:(\d+)$/,o={},i=0;t.exports=function(e){if(1e5===i&&t.exports.reset(),!o[e]){var n=r.exec(e);if(!n)throw new Error("invalid addr: "+e);o[e]=[n[1],Number(n[2])],i+=1}return o[e]},t.exports.reset=function(){o={},i=0}},{}],8:[function(e,t,n){"use strict";function r(){for(var e="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",t=0,n=e.length;n>t;++t)u[t]=e[t],c[e.charCodeAt(t)]=t;c["-".charCodeAt(0)]=62,c["_".charCodeAt(0)]=63}function o(e){var t,n,r,o,i,s,a=e.length;if(a%4>0)throw new Error("Invalid string. Length must be a multiple of 4");i="="===e[a-2]?2:"="===e[a-1]?1:0,s=new f(3*a/4-i),r=i>0?a-4:a;var u=0;for(t=0,n=0;r>t;t+=4,n+=3)o=c[e.charCodeAt(t)]<<18|c[e.charCodeAt(t+1)]<<12|c[e.charCodeAt(t+2)]<<6|c[e.charCodeAt(t+3)],s[u++]=o>>16&255,s[u++]=o>>8&255,s[u++]=255&o;return 2===i?(o=c[e.charCodeAt(t)]<<2|c[e.charCodeAt(t+1)]>>4,s[u++]=255&o):1===i&&(o=c[e.charCodeAt(t)]<<10|c[e.charCodeAt(t+1)]<<4|c[e.charCodeAt(t+2)]>>2,s[u++]=o>>8&255,s[u++]=255&o),s}function i(e){return u[e>>18&63]+u[e>>12&63]+u[e>>6&63]+u[63&e]}function s(e,t,n){for(var r,o=[],s=t;n>s;s+=3)r=(e[s]<<16)+(e[s+1]<<8)+e[s+2],o.push(i(r));return o.join("")}function a(e){for(var t,n=e.length,r=n%3,o="",i=[],a=16383,c=0,f=n-r;f>c;c+=a)i.push(s(e,c,c+a>f?f:c+a));return 1===r?(t=e[n-1],o+=u[t>>2],o+=u[t<<4&63],o+="=="):2===r&&(t=(e[n-2]<<8)+e[n-1],o+=u[t>>10],o+=u[t>>4&63],o+=u[t<<2&63],o+="="),i.push(o),i.join("")}n.toByteArray=o,n.fromByteArray=a;var u=[],c=[],f="undefined"!=typeof Uint8Array?Uint8Array:Array;r()},{}],9:[function(e,t,n){(function(e){function n(t,r,o,i){return"number"!=typeof r&&null==i&&(i=r,r=void 0),"number"!=typeof o&&null==i&&(i=o,o=void 0),n.position=0,n.encoding=i||null,n.data=e.isBuffer(t)?t.slice(r,o):new e(t),n.bytes=n.data.length,n.next()}n.bytes=0,n.position=0,n.data=null,n.encoding=null,n.next=function(){switch(n.data[n.position]){case 100:return n.dictionary();case 108:return n.list();case 105:return n.integer();default:return n.buffer()}},n.find=function(e){for(var t=n.position,r=n.data.length,o=n.data;r>t;){if(o[t]===e)return t;t++}throw new Error('Invalid data: Missing delimiter "'+String.fromCharCode(e)+'" [0x'+e.toString(16)+"]")},n.dictionary=function(){n.position++;for(var e={};101!==n.data[n.position];)e[n.buffer()]=n.next();return n.position++,e},n.list=function(){n.position++;for(var e=[];101!==n.data[n.position];)e.push(n.next());return n.position++,e},n.integer=function(){var e=n.find(101),t=n.data.toString("ascii",n.position+1,e);return n.position+=e+1-n.position,parseInt(t,10)},n.buffer=function(){var e=n.find(58),t=parseInt(n.data.toString("ascii",n.position,e),10),r=++e+t;return n.position=r,n.encoding?n.data.toString(n.encoding,e,r):n.data.slice(e,r)},t.exports=n}).call(this,e("buffer").Buffer)},{buffer:24}],10:[function(e,t,n){(function(e){function n(t,r,o){var i=[],s=null;return n._encode(i,t),s=e.concat(i),n.bytes=s.length,e.isBuffer(r)?(s.copy(r,o),r):s}n.bytes=-1,n._floatConversionDetected=!1,n._encode=function(t,r){if(e.isBuffer(r))return t.push(new e(r.length+":")),void t.push(r);switch(typeof r){case"string":n.buffer(t,r);break;case"number":n.number(t,r);break;case"object":r.constructor===Array?n.list(t,r):n.dict(t,r);break;case"boolean":n.number(t,r?1:0)}};var r=new e("e"),o=new e("d"),i=new e("l");n.buffer=function(t,n){t.push(new e(e.byteLength(n)+":"+n))},n.number=function(t,r){var o=2147483648,i=r/o<<0,s=r%o<<0,a=i*o+s;t.push(new e("i"+a+"e")),a===r||n._floatConversionDetected||(n._floatConversionDetected=!0,console.warn('WARNING: Possible data corruption detected with value "'+r+'":','Bencoding only defines support for integers, value was converted to "'+a+'"'),console.trace())},n.dict=function(e,t){e.push(o);for(var i,s=0,a=Object.keys(t).sort(),u=a.length;u>s;s++)i=a[s],n.buffer(e,i),n._encode(e,t[i]);e.push(r)},n.list=function(e,t){var o=0,s=t.length;for(e.push(i);s>o;o++)n._encode(e,t[o]);e.push(r)},t.exports=n}).call(this,e("buffer").Buffer)},{buffer:24}],11:[function(e,t,n){var r=t.exports;r.encode=e("./encode"),r.decode=e("./decode"),r.byteLength=r.encodingLength=function(e){return r.encode(e).length}},{"./decode":9,"./encode":10}],12:[function(e,t,n){t.exports=function(e,t,n,r,o){var i,s;if(void 0===r)r=0;else if(r=0|r,0>r||r>=e.length)throw new RangeError("invalid lower bound");if(void 0===o)o=e.length-1;else if(o=0|o,r>o||o>=e.length)throw new RangeError("invalid upper bound");for(;o>=r;)if(i=r+(o-r>>1),s=+n(e[i],t,i,e),0>s)r=i+1;else{if(!(s>0))return i;o=i-1}return~r}},{}],13:[function(e,t,n){(function(e){function n(e,t){return this instanceof n?(0===arguments.length&&(e=0),this.grow=t&&(isFinite(t.grow)&&r(t.grow)||t.grow)||0,"number"!=typeof e&&void 0!==e||(e=new o(r(e)),e.fill&&!e._isBuffer&&e.fill(0)),void(this.buffer=e)):new n(e,t)}function r(e){var t=e>>3;return e%8!==0&&t++,t}var o="undefined"!=typeof e?e:"undefined"!=typeof Int8Array?Int8Array:function(e){for(var t=new Array(e),n=0;e>n;n++)t[n]=0};n.prototype.get=function(e){var t=e>>3;return t<this.buffer.length&&!!(this.buffer[t]&128>>e%8)},n.prototype.set=function(e,t){var n=e>>3;t||1===arguments.length?(this.buffer.length<n+1&&this._grow(Math.max(n+1,Math.min(2*this.buffer.length,this.grow))),this.buffer[n]|=128>>e%8):n<this.buffer.length&&(this.buffer[n]&=~(128>>e%8))},n.prototype._grow=function(e){if(this.buffer.length<e&&e<=this.grow){var t=new o(e);if(t.fill&&t.fill(0),this.buffer.copy)this.buffer.copy(t,0);else for(var n=0;n<this.buffer.length;n++)t[n]=this.buffer[n];this.buffer=t}},"undefined"!=typeof t&&(t.exports=n)}).call(this,e("buffer").Buffer)},{buffer:24}],14:[function(e,t,n){function r(e,t,n,r){this.piece=e,this.offset=t,this.length=n,this.callback=r}function o(){return this instanceof o?(p.Duplex.call(this),this._debugId=d(32),this._debug("new wire"),this.peerId=null,this.peerIdBuffer=null,this.type=null,this.amChoking=!0,this.amInterested=!1,this.peerChoking=!0,this.peerInterested=!1,this.peerPieces=new a(0,{grow:m}),this.peerExtensions={},this.requests=[],this.peerRequests=[],this.extendedMapping={},this.peerExtendedMapping={},this.extendedHandshake={},this.peerExtendedHandshake={},this._ext={},this._nextExt=1,this.uploaded=0,this.downloaded=0,this.uploadSpeed=l(),this.downloadSpeed=l(),this._keepAliveInterval=null,this._timeout=null,this._timeoutMs=0,this.destroyed=!1,this._finished=!1,this._parserSize=0,this._parser=null,this._buffer=[],this._bufferSize=0,this.on("finish",this._onFinish),void this._parseHandshake()):new o}function i(e,t,n,r){for(var o=0;o<e.length;o++){var i=e[o];if(i.piece===t&&i.offset===n&&i.length===r)return 0===o?e.shift():e.splice(o,1),i}return null}t.exports=o;var s=e("bencode"),a=e("bitfield"),u=e("safe-buffer").Buffer,c=e("debug")("bittorrent-protocol"),f=e("xtend"),d=e("hat"),h=e("inherits"),l=e("speedometer"),p=e("readable-stream"),m=4e5,g=55e3,y=u.from("BitTorrent protocol"),_=u.from([0,0,0,0]),v=u.from([0,0,0,1,0]),b=u.from([0,0,0,1,1]),w=u.from([0,0,0,1,2]),E=u.from([0,0,0,1,3]),k=[0,0,0,0,0,0,0,0],x=[0,0,0,3,9,0,0];h(o,p.Duplex),o.prototype.setKeepAlive=function(e){var t=this;t._debug("setKeepAlive %s",e),clearInterval(t._keepAliveInterval),e!==!1&&(t._keepAliveInterval=setInterval(function(){t.keepAlive()},g))},o.prototype.setTimeout=function(e,t){this._debug("setTimeout ms=%d unref=%s",e,t),this._clearTimeout(),this._timeoutMs=e,this._timeoutUnref=!!t,this._updateTimeout()},o.prototype.destroy=function(){this.destroyed||(this.destroyed=!0,this._debug("destroy"),this.emit("close"),this.end())},o.prototype.end=function(){this._debug("end"),this._onUninterested(),this._onChoke(),p.Duplex.prototype.end.apply(this,arguments)},o.prototype.use=function(e){function t(){}var n=e.prototype.name;if(!n)throw new Error('Extension class requires a "name" property on the prototype');this._debug("use extension.name=%s",n);var r=this._nextExt,o=new e(this);"function"!=typeof o.onHandshake&&(o.onHandshake=t),"function"!=typeof o.onExtendedHandshake&&(o.onExtendedHandshake=t),"function"!=typeof o.onMessage&&(o.onMessage=t),this.extendedMapping[r]=n,this._ext[n]=o,this[n]=o,this._nextExt+=1},o.prototype.keepAlive=function(){this._debug("keep-alive"),this._push(_)},o.prototype.handshake=function(e,t,n){var r,o;if("string"==typeof e?r=u.from(e,"hex"):(r=e,e=r.toString("hex")),"string"==typeof t?o=u.from(t,"hex"):(o=t,t=o.toString("hex")),20!==r.length||20!==o.length)throw new Error("infoHash and peerId MUST have length 20");this._debug("handshake i=%s p=%s exts=%o",e,t,n);var i=u.from(k);i[5]|=16,n&&n.dht&&(i[7]|=1),this._push(u.concat([y,i,r,o])),this._handshakeSent=!0,this.peerExtensions.extended&&!this._extendedHandshakeSent&&this._sendExtendedHandshake()},o.prototype._sendExtendedHandshake=function(){var e=f(this.extendedHandshake);e.m={};for(var t in this.extendedMapping){var n=this.extendedMapping[t];e.m[n]=Number(t)}this.extended(0,s.encode(e)),this._extendedHandshakeSent=!0},o.prototype.choke=function(){this.amChoking||(this.amChoking=!0,this._debug("choke"),this.peerRequests.splice(0,this.peerRequests.length),this._push(v))},o.prototype.unchoke=function(){this.amChoking&&(this.amChoking=!1,this._debug("unchoke"),this._push(b))},o.prototype.interested=function(){this.amInterested||(this.amInterested=!0,this._debug("interested"),this._push(w))},o.prototype.uninterested=function(){this.amInterested&&(this.amInterested=!1,this._debug("uninterested"),this._push(E))},o.prototype.have=function(e){this._debug("have %d",e),this._message(4,[e],null)},o.prototype.bitfield=function(e){this._debug("bitfield"),u.isBuffer(e)||(e=e.buffer),this._message(5,[],e)},o.prototype.request=function(e,t,n,o){return o||(o=function(){}),this._finished?o(new Error("wire is closed")):this.peerChoking?o(new Error("peer is choking")):(this._debug("request index=%d offset=%d length=%d",e,t,n),this.requests.push(new r(e,t,n,o)),this._updateTimeout(),void this._message(6,[e,t,n],null))},o.prototype.piece=function(e,t,n){this._debug("piece index=%d offset=%d",e,t),this.uploaded+=n.length,this.uploadSpeed(n.length),this.emit("upload",n.length),this._message(7,[e,t],n)},o.prototype.cancel=function(e,t,n){this._debug("cancel index=%d offset=%d length=%d",e,t,n),this._callback(i(this.requests,e,t,n),new Error("request was cancelled"),null),this._message(8,[e,t,n],null)},o.prototype.port=function(e){this._debug("port %d",e);var t=u.from(x);t.writeUInt16BE(e,5),this._push(t)},o.prototype.extended=function(e,t){if(this._debug("extended ext=%s",e),"string"==typeof e&&this.peerExtendedMapping[e]&&(e=this.peerExtendedMapping[e]),"number"!=typeof e)throw new Error("Unrecognized extension: "+e);var n=u.from([e]),r=u.isBuffer(t)?t:s.encode(t);this._message(20,[],u.concat([n,r]))},o.prototype._read=function(){},o.prototype._message=function(e,t,n){var r=n?n.length:0,o=u.allocUnsafe(5+4*t.length);o.writeUInt32BE(o.length+r-4,0),o[4]=e;for(var i=0;i<t.length;i++)o.writeUInt32BE(t[i],5+4*i);this._push(o),n&&this._push(n)},o.prototype._push=function(e){return this._finished?void 0:this.push(e)},o.prototype._onKeepAlive=function(){this._debug("got keep-alive"),this.emit("keep-alive")},o.prototype._onHandshake=function(e,t,n){var r=e.toString("hex"),o=t.toString("hex");this._debug("got handshake i=%s p=%s exts=%o",r,o,n),this.peerId=o,this.peerIdBuffer=t,this.peerExtensions=n,this.emit("handshake",r,o,n);var i;for(i in this._ext)this._ext[i].onHandshake(r,o,n);n.extended&&this._handshakeSent&&!this._extendedHandshakeSent&&this._sendExtendedHandshake()},o.prototype._onChoke=function(){for(this.peerChoking=!0,this._debug("got choke"),this.emit("choke");this.requests.length;)this._callback(this.requests.shift(),new Error("peer is choking"),null)},o.prototype._onUnchoke=function(){this.peerChoking=!1,this._debug("got unchoke"),this.emit("unchoke")},o.prototype._onInterested=function(){this.peerInterested=!0,this._debug("got interested"),this.emit("interested")},o.prototype._onUninterested=function(){this.peerInterested=!1,this._debug("got uninterested"),this.emit("uninterested")},o.prototype._onHave=function(e){this.peerPieces.get(e)||(this._debug("got have %d",e),this.peerPieces.set(e,!0),this.emit("have",e))},o.prototype._onBitField=function(e){this.peerPieces=new a(e),this._debug("got bitfield"),this.emit("bitfield",this.peerPieces)},o.prototype._onRequest=function(e,t,n){var o=this;if(!o.amChoking){o._debug("got request index=%d offset=%d length=%d",e,t,n);var s=function(r,s){return a===i(o.peerRequests,e,t,n)?r?o._debug("error satisfying request index=%d offset=%d length=%d (%s)",e,t,n,r.message):void o.piece(e,t,s):void 0},a=new r(e,t,n,s);o.peerRequests.push(a),o.emit("request",e,t,n,s)}},o.prototype._onPiece=function(e,t,n){this._debug("got piece index=%d offset=%d",e,t),this._callback(i(this.requests,e,t,n.length),null,n),this.downloaded+=n.length,this.downloadSpeed(n.length),this.emit("download",n.length),this.emit("piece",e,t,n)},o.prototype._onCancel=function(e,t,n){this._debug("got cancel index=%d offset=%d length=%d",e,t,n),i(this.peerRequests,e,t,n),this.emit("cancel",e,t,n)},o.prototype._onPort=function(e){this._debug("got port %d",e),this.emit("port",e)},o.prototype._onExtended=function(e,t){if(0===e){var n;try{n=s.decode(t)}catch(r){this._debug("ignoring invalid extended handshake: %s",r.message||r)}if(!n)return;this.peerExtendedHandshake=n;var o;if("object"==typeof n.m)for(o in n.m)this.peerExtendedMapping[o]=Number(n.m[o].toString());for(o in this._ext)this.peerExtendedMapping[o]&&this._ext[o].onExtendedHandshake(this.peerExtendedHandshake);this._debug("got extended handshake"),this.emit("extended","handshake",this.peerExtendedHandshake)}else this.extendedMapping[e]&&(e=this.extendedMapping[e],this._ext[e]&&this._ext[e].onMessage(t)),this._debug("got extended message ext=%s",e),this.emit("extended",e,t)},o.prototype._onTimeout=function(){this._debug("request timed out"),this._callback(this.requests.shift(),new Error("request has timed out"),null),this.emit("timeout")},o.prototype._write=function(e,t,n){for(this._bufferSize+=e.length,this._buffer.push(e);this._bufferSize>=this._parserSize;){var r=1===this._buffer.length?this._buffer[0]:u.concat(this._buffer);this._bufferSize-=this._parserSize,this._buffer=this._bufferSize?[r.slice(this._parserSize)]:[],this._parser(r.slice(0,this._parserSize))}n(null)},o.prototype._callback=function(e,t,n){e&&(this._clearTimeout(),this.peerChoking||this._finished||this._updateTimeout(),e.callback(t,n))},o.prototype._clearTimeout=function(){this._timeout&&(clearTimeout(this._timeout),this._timeout=null)},o.prototype._updateTimeout=function(){var e=this;e._timeoutMs&&e.requests.length&&!e._timeout&&(e._timeout=setTimeout(function(){e._onTimeout()},e._timeoutMs),e._timeoutUnref&&e._timeout.unref&&e._timeout.unref())},o.prototype._parse=function(e,t){this._parserSize=e,this._parser=t},o.prototype._onMessageLength=function(e){var t=e.readUInt32BE(0);t>0?this._parse(t,this._onMessage):(this._onKeepAlive(),this._parse(4,this._onMessageLength))},o.prototype._onMessage=function(e){switch(this._parse(4,this._onMessageLength),e[0]){case 0:return this._onChoke();case 1:return this._onUnchoke();case 2:return this._onInterested();case 3:return this._onUninterested();case 4:return this._onHave(e.readUInt32BE(1));case 5:return this._onBitField(e.slice(1));case 6:return this._onRequest(e.readUInt32BE(1),e.readUInt32BE(5),e.readUInt32BE(9));case 7:return this._onPiece(e.readUInt32BE(1),e.readUInt32BE(5),e.slice(9));case 8:return this._onCancel(e.readUInt32BE(1),e.readUInt32BE(5),e.readUInt32BE(9));case 9:return this._onPort(e.readUInt16BE(1));case 20:return this._onExtended(e.readUInt8(1),e.slice(2));default:return this._debug("got unknown message"),this.emit("unknownmessage",e)}},o.prototype._parseHandshake=function(){var e=this;e._parse(1,function(t){var n=t.readUInt8(0);e._parse(n+48,function(t){var r=t.slice(0,n);return"BitTorrent protocol"!==r.toString()?(e._debug("Error: wire not speaking BitTorrent protocol (%s)",r.toString()),void e.end()):(t=t.slice(n),e._onHandshake(t.slice(8,28),t.slice(28,48),{dht:!!(1&t[7]),extended:!!(16&t[5])}),void e._parse(4,e._onMessageLength))})})},o.prototype._onFinish=function(){for(this._finished=!0,this.push(null);this.read(););for(clearInterval(this._keepAliveInterval),this._parse(Number.MAX_VALUE,function(){}),this.peerRequests=[];this.requests.length;)this._callback(this.requests.shift(),new Error("wire was closed"),null)},o.prototype._debug=function(){var e=[].slice.call(arguments);e[0]="["+this._debugId+"] "+e[0],c.apply(null,e)}},{bencode:11,bitfield:13,debug:34,hat:42,inherits:46,"readable-stream":88,"safe-buffer":94,speedometer:100,xtend:125}],15:[function(e,t,n){(function(n){function r(e){function t(e){n.nextTick(function(){a.emit("warning",e)})}var a=this;if(!(a instanceof r))return new r(e);if(s.call(a),e||(e={}),!e.peerId)throw new Error("Option `peerId` is required");if(!e.infoHash)throw new Error("Option `infoHash` is required");if(!e.announce)throw new Error("Option `announce` is required");if(!n.browser&&!e.port)throw new Error("Option `port` is required");a.peerId="string"==typeof e.peerId?e.peerId:e.peerId.toString("hex"),a._peerIdBuffer=o.from(a.peerId,"hex"),a._peerIdBinary=a._peerIdBuffer.toString("binary"),a.infoHash="string"==typeof e.infoHash?e.infoHash:e.infoHash.toString("hex"),a._infoHashBuffer=o.from(a.infoHash,"hex"),a._infoHashBinary=a._infoHashBuffer.toString("binary"),a._port=e.port,a.destroyed=!1,a._rtcConfig=e.rtcConfig,a._wrtc=e.wrtc,a._getAnnounceOpts=e.getAnnounceOpts,i("new client %s",a.infoHash);var u=a._wrtc!==!1&&(!!a._wrtc||d.WEBRTC_SUPPORT),c="string"==typeof e.announce?[e.announce]:null==e.announce?[]:e.announce;c=c.map(function(e){return e=e.toString(),"/"===e[e.length-1]&&(e=e.substring(0,e.length-1)),e}),c=h(c),a._trackers=c.map(function(e){var n=l.parse(e).protocol;return"http:"!==n&&"https:"!==n||"function"!=typeof m?"udp:"===n&&"function"==typeof g?new g(a,e):"ws:"!==n&&"wss:"!==n||!u?(t(new Error("Unsupported tracker protocol: "+e)),null):"ws:"===n&&"undefined"!=typeof window&&"https:"===window.location.protocol?(t(new Error("Unsupported tracker protocol: "+e)),null):new y(a,e):new m(a,e)}).filter(Boolean)}t.exports=r;var o=e("safe-buffer").Buffer,i=e("debug")("bittorrent-tracker"),s=e("events").EventEmitter,a=e("xtend"),u=e("inherits"),c=e("once"),f=e("run-parallel"),d=e("simple-peer"),h=e("uniq"),l=e("url"),p=e("./lib/common"),m=e("./lib/client/http-tracker"),g=e("./lib/client/udp-tracker"),y=e("./lib/client/websocket-tracker");u(r,s),r.scrape=function(e,t){if(t=c(t),!e.infoHash)throw new Error("Option `infoHash` is required");if(!e.announce)throw new Error("Option `announce` is required");var n=a(e,{infoHash:Array.isArray(e.infoHash)?e.infoHash[0]:e.infoHash,peerId:o.from("01234567890123456789"),port:6881}),i=new r(n);i.once("error",t);var s=Array.isArray(e.infoHash)?e.infoHash.length:1,u={};return i.on("scrape",function(e){if(s-=1,u[e.infoHash]=e,0===s){i.destroy();var n=Object.keys(u);1===n.length?t(null,u[n[0]]):t(null,u)}}),e.infoHash=Array.isArray(e.infoHash)?e.infoHash.map(function(e){return o.from(e,"hex")}):o.from(e.infoHash,"hex"),i.scrape({infoHash:e.infoHash}),i},r.prototype.start=function(e){var t=this;i("send `start`"),e=t._defaultAnnounceOpts(e),e.event="started",t._announce(e),t._trackers.forEach(function(e){e.setInterval()})},r.prototype.stop=function(e){var t=this;i("send `stop`"),e=t._defaultAnnounceOpts(e),e.event="stopped",t._announce(e)},r.prototype.complete=function(e){var t=this;i("send `complete`"),e||(e={}),e=t._defaultAnnounceOpts(e),e.event="completed",t._announce(e)},r.prototype.update=function(e){var t=this;i("send `update`"),e=t._defaultAnnounceOpts(e),e.event&&delete e.event,t._announce(e)},r.prototype._announce=function(e){var t=this;t._trackers.forEach(function(t){t.announce(e)})},r.prototype.scrape=function(e){var t=this;i("send `scrape`"),e||(e={}),t._trackers.forEach(function(t){t.scrape(e)})},r.prototype.setInterval=function(e){var t=this;i("setInterval %d",e),t._trackers.forEach(function(t){t.setInterval(e)})},r.prototype.destroy=function(e){var t=this;if(!t.destroyed){t.destroyed=!0,i("destroy");var n=t._trackers.map(function(e){return function(t){e.destroy(t)}});f(n,e),t._trackers=[],t._getAnnounceOpts=null}},r.prototype._defaultAnnounceOpts=function(e){var t=this;return e||(e={}),null==e.numwant&&(e.numwant=p.DEFAULT_ANNOUNCE_PEERS),null==e.uploaded&&(e.uploaded=0),null==e.downloaded&&(e.downloaded=0),t._getAnnounceOpts&&(e=a(e,t._getAnnounceOpts())),e}}).call(this,e("_process"))},{"./lib/client/http-tracker":21,"./lib/client/udp-tracker":21,"./lib/client/websocket-tracker":17,"./lib/common":18,_process:75,debug:34,events:38,inherits:46,once:65,"run-parallel":92,"safe-buffer":94,"simple-peer":97,uniq:116,url:118,xtend:125}],16:[function(e,t,n){function r(e,t){var n=this;o.call(n),n.client=e,n.announceUrl=t,n.interval=null,n.destroyed=!1}t.exports=r;var o=e("events").EventEmitter,i=e("inherits");i(r,o),r.prototype.setInterval=function(e){var t=this;null==e&&(e=t.DEFAULT_ANNOUNCE_INTERVAL),clearInterval(t.interval),e&&(t.interval=setInterval(function(){t.announce(t.client._defaultAnnounceOpts())},e),t.interval.unref&&t.interval.unref())}},{events:38,inherits:46}],17:[function(e,t,n){function r(e,t,n){var r=this;h.call(r,e,t),i("new websocket tracker %s",t),r.peers={},r.socket=null,r.reconnecting=!1,r.retries=0,r.reconnectTimer=null,r._openSocket()}function o(){}t.exports=r;var i=e("debug")("bittorrent-tracker:websocket-tracker"),s=e("xtend"),a=e("hat"),u=e("inherits"),c=e("simple-peer"),f=e("simple-websocket"),d=e("../common"),h=e("./tracker"),l={},p=15e3,m=18e5,g=3e4,y=5e4;u(r,h),r.prototype.DEFAULT_ANNOUNCE_INTERVAL=3e4,r.prototype.announce=function(e){var t=this;if(!t.destroyed&&!t.reconnecting){if(!t.socket.connected)return void t.socket.once("connect",function(){t.announce(e)});var n=s(e,{action:"announce",info_hash:t.client._infoHashBinary,peer_id:t.client._peerIdBinary});if(t._trackerId&&(n.trackerid=t._trackerId),"stopped"===e.event)t._send(n);else{var r=Math.min(e.numwant,5);t._generateOffers(r,function(e){n.numwant=r,n.offers=e,t._send(n)})}}},r.prototype.scrape=function(e){var t=this;if(!t.destroyed&&!t.reconnecting){if(!t.socket.connected)return void t.socket.once("connect",function(){t.scrape(e)});var n=Array.isArray(e.infoHash)&&e.infoHash.length>0?e.infoHash.map(function(e){return e.toString("binary")}):e.infoHash&&e.infoHash.toString("binary")||t.client._infoHashBinary,r={action:"scrape",info_hash:n};t._send(r)}},r.prototype.destroy=function(e){var t=this;if(e||(e=o),t.destroyed)return e(null);t.destroyed=!0,clearInterval(t.interval),clearTimeout(t.reconnectTimer),t.socket&&(t.socket.removeListener("connect",t._onSocketConnectBound),t.socket.removeListener("data",t._onSocketDataBound),t.socket.removeListener("close",t._onSocketCloseBound),t.socket.removeListener("error",t._onSocketErrorBound)),t._onSocketConnectBound=null,t._onSocketErrorBound=null,t._onSocketDataBound=null,t._onSocketCloseBound=null;for(var n in t.peers){var r=t.peers[n];clearTimeout(r.trackerTimeout),r.destroy()}if(t.peers=null,l[t.announceUrl]&&(l[t.announceUrl].consumers-=1),0===l[t.announceUrl].consumers){delete l[t.announceUrl];try{t.socket.on("error",o),t.socket.destroy(e)}catch(i){e(null)}}else e(null);t.socket=null},r.prototype._openSocket=function(){var e=this;e.destroyed=!1,e.peers||(e.peers={}),e._onSocketConnectBound=function(){e._onSocketConnect()},e._onSocketErrorBound=function(t){e._onSocketError(t)},e._onSocketDataBound=function(t){e._onSocketData(t)},e._onSocketCloseBound=function(){e._onSocketClose()},e.socket=l[e.announceUrl],e.socket?l[e.announceUrl].consumers+=1:(e.socket=l[e.announceUrl]=new f(e.announceUrl),e.socket.consumers=1,e.socket.on("connect",e._onSocketConnectBound)),e.socket.on("data",e._onSocketDataBound),e.socket.on("close",e._onSocketCloseBound),e.socket.on("error",e._onSocketErrorBound)},r.prototype._onSocketConnect=function(){var e=this;e.destroyed||e.reconnecting&&(e.reconnecting=!1,e.retries=0,e.announce(e.client._defaultAnnounceOpts()))},r.prototype._onSocketData=function(e){var t=this;if(!t.destroyed){try{e=JSON.parse(e)}catch(n){return void t.client.emit("warning",new Error("Invalid tracker response"))}"announce"===e.action?t._onAnnounceResponse(e):"scrape"===e.action?t._onScrapeResponse(e):t._onSocketError(new Error("invalid action in WS response: "+e.action))}},r.prototype._onAnnounceResponse=function(e){var t=this;if(e.info_hash!==t.client._infoHashBinary)return void i("ignoring websocket data from %s for %s (looking for %s: reused socket)",t.announceUrl,d.binaryToHex(e.info_hash),t.client.infoHash);if(!e.peer_id||e.peer_id!==t.client._peerIdBinary){i("received %s from %s for %s",JSON.stringify(e),t.announceUrl,t.client.infoHash);var n=e["failure reason"];if(n)return t.client.emit("warning",new Error(n));var r=e["warning message"];r&&t.client.emit("warning",new Error(r));var o=e.interval||e["min interval"];o&&t.setInterval(1e3*o);var s=e["tracker id"];s&&(t._trackerId=s),null!=e.complete&&t.client.emit("update",{announce:t.announceUrl,complete:e.complete,incomplete:e.incomplete});var a;if(e.offer&&e.peer_id&&(i("creating peer (from remote offer)"),a=new c({trickle:!1,config:t.client._rtcConfig,wrtc:t.client._wrtc}),a.id=d.binaryToHex(e.peer_id),a.once("signal",function(n){var r={action:"announce",info_hash:t.client._infoHashBinary,peer_id:t.client._peerIdBinary,to_peer_id:e.peer_id,answer:n,offer_id:e.offer_id};t._trackerId&&(r.trackerid=t._trackerId),t._send(r)}),a.signal(e.offer),t.client.emit("peer",a)),e.answer&&e.peer_id){var u=d.binaryToHex(e.offer_id);a=t.peers[u],a?(a.id=d.binaryToHex(e.peer_id),a.signal(e.answer),t.client.emit("peer",a),clearTimeout(a.trackerTimeout),a.trackerTimeout=null,delete t.peers[u]):i("got unexpected answer: "+JSON.stringify(e.answer))}}},r.prototype._onScrapeResponse=function(e){var t=this;e=e.files||{};var n=Object.keys(e);return 0===n.length?void t.client.emit("warning",new Error("invalid scrape response")):void n.forEach(function(n){var r=e[n];t.client.emit("scrape",{announce:t.announceUrl,infoHash:d.binaryToHex(n),complete:r.complete,incomplete:r.incomplete,downloaded:r.downloaded})})},r.prototype._onSocketClose=function(){var e=this;e.destroyed||(e.destroy(),e._startReconnectTimer())},r.prototype._onSocketError=function(e){var t=this;t.destroyed||(t.destroy(),t.client.emit("warning",e),t._startReconnectTimer())},r.prototype._startReconnectTimer=function(){var e=this,t=Math.floor(Math.random()*g)+Math.min(Math.pow(2,e.retries)*p,m);e.reconnecting=!0,clearTimeout(e.reconnectTimer),e.reconnectTimer=setTimeout(function(){e.retries++,e._openSocket()},t),e.reconnectTimer.unref&&e.reconnectTimer.unref(),i("reconnecting socket in %s ms",t)},r.prototype._send=function(e){var t=this;if(!t.destroyed){var n=JSON.stringify(e);i("send %s",n),t.socket.send(n)}},r.prototype._generateOffers=function(e,t){function n(){var e=a(160);i("creating peer (from _generateOffers)");var t=o.peers[e]=new c({initiator:!0,trickle:!1,config:o.client._rtcConfig,wrtc:o.client._wrtc});t.once("signal",function(t){s.push({offer:t,offer_id:d.hexToBinary(e)}),r()}),t.trackerTimeout=setTimeout(function(){i("tracker timeout: destroying peer"),t.trackerTimeout=null,delete o.peers[e],t.destroy()},y),t.trackerTimeout.unref&&t.trackerTimeout.unref()}function r(){s.length===e&&(i("generated %s offers",e),t(s))}var o=this,s=[];i("generating %s offers",e);for(var u=0;e>u;++u)n();r()}},{"../common":18,"./tracker":16,debug:34,hat:42,inherits:46,"simple-peer":97,"simple-websocket":99,xtend:125}],18:[function(e,t,n){var r=e("safe-buffer").Buffer,o=e("xtend/mutable");n.DEFAULT_ANNOUNCE_PEERS=50,n.MAX_ANNOUNCE_PEERS=82,n.binaryToHex=function(e){return"string"!=typeof e&&(e=String(e)),r.from(e,"binary").toString("hex")},n.hexToBinary=function(e){return"string"!=typeof e&&(e=String(e)),r.from(e,"hex").toString("binary")};var i=e("./common-node");o(n,i)},{"./common-node":21,"safe-buffer":94,"xtend/mutable":126}],19:[function(e,t,n){(function(e){t.exports=function(t,n){function r(t){o.removeEventListener("loadend",r,!1),t.error?n(t.error):n(null,new e(o.result))}if("undefined"==typeof Blob||!(t instanceof Blob))throw new Error("first argument must be a Blob");if("function"!=typeof n)throw new Error("second argument must be a function");var o=new FileReader;
	o.addEventListener("loadend",r,!1),o.readAsArrayBuffer(t)}}).call(this,e("buffer").Buffer)},{buffer:24}],20:[function(e,t,n){(function(n){function r(e,t){return this instanceof r?(i.call(this),t||(t={}),"object"==typeof e&&(t=e,e=t.size),this.size=e||512,t.nopad?this._zeroPadding=!1:this._zeroPadding=s(t.zeroPadding,!0),this._buffered=[],void(this._bufferedBytes=0)):new r(e,t)}var o=e("inherits"),i=e("readable-stream").Transform,s=e("defined");t.exports=r,o(r,i),r.prototype._transform=function(e,t,r){for(this._bufferedBytes+=e.length,this._buffered.push(e);this._bufferedBytes>=this.size;){var o=n.concat(this._buffered);this._bufferedBytes-=this.size,this.push(o.slice(0,this.size)),this._buffered=[o.slice(this.size,o.length)]}r()},r.prototype._flush=function(){if(this._bufferedBytes&&this._zeroPadding){var e=new n(this.size-this._bufferedBytes);e.fill(0),this._buffered.push(e),this.push(n.concat(this._buffered)),this._buffered=null}else this._bufferedBytes&&(this.push(n.concat(this._buffered)),this._buffered=null);this.push(null)}}).call(this,e("buffer").Buffer)},{buffer:24,defined:36,inherits:46,"readable-stream":88}],21:[function(e,t,n){},{}],22:[function(e,t,n){arguments[4][21][0].apply(n,arguments)},{dup:21}],23:[function(e,t,n){(function(t){"use strict";var r=e("buffer"),o=r.Buffer,i=r.SlowBuffer,s=r.kMaxLength||2147483647;n.alloc=function(e,t,n){if("function"==typeof o.alloc)return o.alloc(e,t,n);if("number"==typeof n)throw new TypeError("encoding must not be number");if("number"!=typeof e)throw new TypeError("size must be a number");if(e>s)throw new RangeError("size is too large");var r=n,i=t;void 0===i&&(r=void 0,i=0);var a=new o(e);if("string"==typeof i)for(var u=new o(i,r),c=u.length,f=-1;++f<e;)a[f]=u[f%c];else a.fill(i);return a},n.allocUnsafe=function(e){if("function"==typeof o.allocUnsafe)return o.allocUnsafe(e);if("number"!=typeof e)throw new TypeError("size must be a number");if(e>s)throw new RangeError("size is too large");return new o(e)},n.from=function(e,n,r){if("function"==typeof o.from&&(!t.Uint8Array||Uint8Array.from!==o.from))return o.from(e,n,r);if("number"==typeof e)throw new TypeError('"value" argument must not be a number');if("string"==typeof e)return new o(e,n);if("undefined"!=typeof ArrayBuffer&&e instanceof ArrayBuffer){var i=n;if(1===arguments.length)return new o(e);"undefined"==typeof i&&(i=0);var s=r;if("undefined"==typeof s&&(s=e.byteLength-i),i>=e.byteLength)throw new RangeError("'offset' is out of bounds");if(s>e.byteLength-i)throw new RangeError("'length' is out of bounds");return new o(e.slice(i,i+s))}if(o.isBuffer(e)){var a=new o(e.length);return e.copy(a,0,0,e.length),a}if(e){if(Array.isArray(e)||"undefined"!=typeof ArrayBuffer&&e.buffer instanceof ArrayBuffer||"length"in e)return new o(e);if("Buffer"===e.type&&Array.isArray(e.data))return new o(e.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")},n.allocUnsafeSlow=function(e){if("function"==typeof o.allocUnsafeSlow)return o.allocUnsafeSlow(e);if("number"!=typeof e)throw new TypeError("size must be a number");if(e>=s)throw new RangeError("size is too large");return new i(e)}}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{buffer:24}],24:[function(e,t,n){(function(t){"use strict";function r(){try{var e=new Uint8Array(1);return e.foo=function(){return 42},42===e.foo()&&"function"==typeof e.subarray&&0===e.subarray(1,1).byteLength}catch(t){return!1}}function o(){return s.TYPED_ARRAY_SUPPORT?2147483647:1073741823}function i(e,t){if(o()<t)throw new RangeError("Invalid typed array length");return s.TYPED_ARRAY_SUPPORT?(e=new Uint8Array(t),e.__proto__=s.prototype):(null===e&&(e=new s(t)),e.length=t),e}function s(e,t,n){if(!(s.TYPED_ARRAY_SUPPORT||this instanceof s))return new s(e,t,n);if("number"==typeof e){if("string"==typeof t)throw new Error("If encoding is specified then the first argument must be a string");return f(this,e)}return a(this,e,t,n)}function a(e,t,n,r){if("number"==typeof t)throw new TypeError('"value" argument must not be a number');return"undefined"!=typeof ArrayBuffer&&t instanceof ArrayBuffer?l(e,t,n,r):"string"==typeof t?d(e,t,n):p(e,t)}function u(e){if("number"!=typeof e)throw new TypeError('"size" argument must be a number')}function c(e,t,n,r){return u(t),0>=t?i(e,t):void 0!==n?"string"==typeof r?i(e,t).fill(n,r):i(e,t).fill(n):i(e,t)}function f(e,t){if(u(t),e=i(e,0>t?0:0|m(t)),!s.TYPED_ARRAY_SUPPORT)for(var n=0;t>n;n++)e[n]=0;return e}function d(e,t,n){if("string"==typeof n&&""!==n||(n="utf8"),!s.isEncoding(n))throw new TypeError('"encoding" must be a valid string encoding');var r=0|y(t,n);return e=i(e,r),e.write(t,n),e}function h(e,t){var n=0|m(t.length);e=i(e,n);for(var r=0;n>r;r+=1)e[r]=255&t[r];return e}function l(e,t,n,r){if(t.byteLength,0>n||t.byteLength<n)throw new RangeError("'offset' is out of bounds");if(t.byteLength<n+(r||0))throw new RangeError("'length' is out of bounds");return t=void 0===r?new Uint8Array(t,n):new Uint8Array(t,n,r),s.TYPED_ARRAY_SUPPORT?(e=t,e.__proto__=s.prototype):e=h(e,t),e}function p(e,t){if(s.isBuffer(t)){var n=0|m(t.length);return e=i(e,n),0===e.length?e:(t.copy(e,0,0,n),e)}if(t){if("undefined"!=typeof ArrayBuffer&&t.buffer instanceof ArrayBuffer||"length"in t)return"number"!=typeof t.length||K(t.length)?i(e,0):h(e,t);if("Buffer"===t.type&&Q(t.data))return h(e,t.data)}throw new TypeError("First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.")}function m(e){if(e>=o())throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x"+o().toString(16)+" bytes");return 0|e}function g(e){return+e!=e&&(e=0),s.alloc(+e)}function y(e,t){if(s.isBuffer(e))return e.length;if("undefined"!=typeof ArrayBuffer&&"function"==typeof ArrayBuffer.isView&&(ArrayBuffer.isView(e)||e instanceof ArrayBuffer))return e.byteLength;"string"!=typeof e&&(e=""+e);var n=e.length;if(0===n)return 0;for(var r=!1;;)switch(t){case"ascii":case"binary":case"raw":case"raws":return n;case"utf8":case"utf-8":case void 0:return F(e).length;case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return 2*n;case"hex":return n>>>1;case"base64":return G(e).length;default:if(r)return F(e).length;t=(""+t).toLowerCase(),r=!0}}function _(e,t,n){var r=!1;if((void 0===t||0>t)&&(t=0),t>this.length)return"";if((void 0===n||n>this.length)&&(n=this.length),0>=n)return"";if(n>>>=0,t>>>=0,t>=n)return"";for(e||(e="utf8");;)switch(e){case"hex":return R(this,t,n);case"utf8":case"utf-8":return A(this,t,n);case"ascii":return C(this,t,n);case"binary":return L(this,t,n);case"base64":return I(this,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return U(this,t,n);default:if(r)throw new TypeError("Unknown encoding: "+e);e=(e+"").toLowerCase(),r=!0}}function v(e,t,n){var r=e[t];e[t]=e[n],e[n]=r}function b(e,t,n,r){function o(e,t){return 1===i?e[t]:e.readUInt16BE(t*i)}var i=1,s=e.length,a=t.length;if(void 0!==r&&(r=String(r).toLowerCase(),"ucs2"===r||"ucs-2"===r||"utf16le"===r||"utf-16le"===r)){if(e.length<2||t.length<2)return-1;i=2,s/=2,a/=2,n/=2}for(var u=-1,c=0;s>n+c;c++)if(o(e,n+c)===o(t,-1===u?0:c-u)){if(-1===u&&(u=c),c-u+1===a)return(n+u)*i}else-1!==u&&(c-=c-u),u=-1;return-1}function w(e,t,n,r){n=Number(n)||0;var o=e.length-n;r?(r=Number(r),r>o&&(r=o)):r=o;var i=t.length;if(i%2!==0)throw new Error("Invalid hex string");r>i/2&&(r=i/2);for(var s=0;r>s;s++){var a=parseInt(t.substr(2*s,2),16);if(isNaN(a))return s;e[n+s]=a}return s}function E(e,t,n,r){return $(F(t,e.length-n),e,n,r)}function k(e,t,n,r){return $(Y(t),e,n,r)}function x(e,t,n,r){return k(e,t,n,r)}function S(e,t,n,r){return $(G(t),e,n,r)}function B(e,t,n,r){return $(V(t,e.length-n),e,n,r)}function I(e,t,n){return 0===t&&n===e.length?X.fromByteArray(e):X.fromByteArray(e.slice(t,n))}function A(e,t,n){n=Math.min(e.length,n);for(var r=[],o=t;n>o;){var i=e[o],s=null,a=i>239?4:i>223?3:i>191?2:1;if(n>=o+a){var u,c,f,d;switch(a){case 1:128>i&&(s=i);break;case 2:u=e[o+1],128===(192&u)&&(d=(31&i)<<6|63&u,d>127&&(s=d));break;case 3:u=e[o+1],c=e[o+2],128===(192&u)&&128===(192&c)&&(d=(15&i)<<12|(63&u)<<6|63&c,d>2047&&(55296>d||d>57343)&&(s=d));break;case 4:u=e[o+1],c=e[o+2],f=e[o+3],128===(192&u)&&128===(192&c)&&128===(192&f)&&(d=(15&i)<<18|(63&u)<<12|(63&c)<<6|63&f,d>65535&&1114112>d&&(s=d))}}null===s?(s=65533,a=1):s>65535&&(s-=65536,r.push(s>>>10&1023|55296),s=56320|1023&s),r.push(s),o+=a}return T(r)}function T(e){var t=e.length;if(Z>=t)return String.fromCharCode.apply(String,e);for(var n="",r=0;t>r;)n+=String.fromCharCode.apply(String,e.slice(r,r+=Z));return n}function C(e,t,n){var r="";n=Math.min(e.length,n);for(var o=t;n>o;o++)r+=String.fromCharCode(127&e[o]);return r}function L(e,t,n){var r="";n=Math.min(e.length,n);for(var o=t;n>o;o++)r+=String.fromCharCode(e[o]);return r}function R(e,t,n){var r=e.length;(!t||0>t)&&(t=0),(!n||0>n||n>r)&&(n=r);for(var o="",i=t;n>i;i++)o+=z(e[i]);return o}function U(e,t,n){for(var r=e.slice(t,n),o="",i=0;i<r.length;i+=2)o+=String.fromCharCode(r[i]+256*r[i+1]);return o}function P(e,t,n){if(e%1!==0||0>e)throw new RangeError("offset is not uint");if(e+t>n)throw new RangeError("Trying to access beyond buffer length")}function O(e,t,n,r,o,i){if(!s.isBuffer(e))throw new TypeError('"buffer" argument must be a Buffer instance');if(t>o||i>t)throw new RangeError('"value" argument is out of bounds');if(n+r>e.length)throw new RangeError("Index out of range")}function M(e,t,n,r){0>t&&(t=65535+t+1);for(var o=0,i=Math.min(e.length-n,2);i>o;o++)e[n+o]=(t&255<<8*(r?o:1-o))>>>8*(r?o:1-o)}function j(e,t,n,r){0>t&&(t=4294967295+t+1);for(var o=0,i=Math.min(e.length-n,4);i>o;o++)e[n+o]=t>>>8*(r?o:3-o)&255}function H(e,t,n,r,o,i){if(n+r>e.length)throw new RangeError("Index out of range");if(0>n)throw new RangeError("Index out of range")}function D(e,t,n,r,o){return o||H(e,t,n,4,3.4028234663852886e38,-3.4028234663852886e38),J.write(e,t,n,r,23,4),n+4}function q(e,t,n,r,o){return o||H(e,t,n,8,1.7976931348623157e308,-1.7976931348623157e308),J.write(e,t,n,r,52,8),n+8}function N(e){if(e=W(e).replace(ee,""),e.length<2)return"";for(;e.length%4!==0;)e+="=";return e}function W(e){return e.trim?e.trim():e.replace(/^\s+|\s+$/g,"")}function z(e){return 16>e?"0"+e.toString(16):e.toString(16)}function F(e,t){t=t||1/0;for(var n,r=e.length,o=null,i=[],s=0;r>s;s++){if(n=e.charCodeAt(s),n>55295&&57344>n){if(!o){if(n>56319){(t-=3)>-1&&i.push(239,191,189);continue}if(s+1===r){(t-=3)>-1&&i.push(239,191,189);continue}o=n;continue}if(56320>n){(t-=3)>-1&&i.push(239,191,189),o=n;continue}n=(o-55296<<10|n-56320)+65536}else o&&(t-=3)>-1&&i.push(239,191,189);if(o=null,128>n){if((t-=1)<0)break;i.push(n)}else if(2048>n){if((t-=2)<0)break;i.push(n>>6|192,63&n|128)}else if(65536>n){if((t-=3)<0)break;i.push(n>>12|224,n>>6&63|128,63&n|128)}else{if(!(1114112>n))throw new Error("Invalid code point");if((t-=4)<0)break;i.push(n>>18|240,n>>12&63|128,n>>6&63|128,63&n|128)}}return i}function Y(e){for(var t=[],n=0;n<e.length;n++)t.push(255&e.charCodeAt(n));return t}function V(e,t){for(var n,r,o,i=[],s=0;s<e.length&&!((t-=2)<0);s++)n=e.charCodeAt(s),r=n>>8,o=n%256,i.push(o),i.push(r);return i}function G(e){return X.toByteArray(N(e))}function $(e,t,n,r){for(var o=0;r>o&&!(o+n>=t.length||o>=e.length);o++)t[o+n]=e[o];return o}function K(e){return e!==e}var X=e("base64-js"),J=e("ieee754"),Q=e("isarray");n.Buffer=s,n.SlowBuffer=g,n.INSPECT_MAX_BYTES=50,s.TYPED_ARRAY_SUPPORT=void 0!==t.TYPED_ARRAY_SUPPORT?t.TYPED_ARRAY_SUPPORT:r(),n.kMaxLength=o(),s.poolSize=8192,s._augment=function(e){return e.__proto__=s.prototype,e},s.from=function(e,t,n){return a(null,e,t,n)},s.TYPED_ARRAY_SUPPORT&&(s.prototype.__proto__=Uint8Array.prototype,s.__proto__=Uint8Array,"undefined"!=typeof Symbol&&Symbol.species&&s[Symbol.species]===s&&Object.defineProperty(s,Symbol.species,{value:null,configurable:!0})),s.alloc=function(e,t,n){return c(null,e,t,n)},s.allocUnsafe=function(e){return f(null,e)},s.allocUnsafeSlow=function(e){return f(null,e)},s.isBuffer=function(e){return!(null==e||!e._isBuffer)},s.compare=function(e,t){if(!s.isBuffer(e)||!s.isBuffer(t))throw new TypeError("Arguments must be Buffers");if(e===t)return 0;for(var n=e.length,r=t.length,o=0,i=Math.min(n,r);i>o;++o)if(e[o]!==t[o]){n=e[o],r=t[o];break}return r>n?-1:n>r?1:0},s.isEncoding=function(e){switch(String(e).toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"raw":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return!0;default:return!1}},s.concat=function(e,t){if(!Q(e))throw new TypeError('"list" argument must be an Array of Buffers');if(0===e.length)return s.alloc(0);var n;if(void 0===t)for(t=0,n=0;n<e.length;n++)t+=e[n].length;var r=s.allocUnsafe(t),o=0;for(n=0;n<e.length;n++){var i=e[n];if(!s.isBuffer(i))throw new TypeError('"list" argument must be an Array of Buffers');i.copy(r,o),o+=i.length}return r},s.byteLength=y,s.prototype._isBuffer=!0,s.prototype.swap16=function(){var e=this.length;if(e%2!==0)throw new RangeError("Buffer size must be a multiple of 16-bits");for(var t=0;e>t;t+=2)v(this,t,t+1);return this},s.prototype.swap32=function(){var e=this.length;if(e%4!==0)throw new RangeError("Buffer size must be a multiple of 32-bits");for(var t=0;e>t;t+=4)v(this,t,t+3),v(this,t+1,t+2);return this},s.prototype.toString=function(){var e=0|this.length;return 0===e?"":0===arguments.length?A(this,0,e):_.apply(this,arguments)},s.prototype.equals=function(e){if(!s.isBuffer(e))throw new TypeError("Argument must be a Buffer");return this===e?!0:0===s.compare(this,e)},s.prototype.inspect=function(){var e="",t=n.INSPECT_MAX_BYTES;return this.length>0&&(e=this.toString("hex",0,t).match(/.{2}/g).join(" "),this.length>t&&(e+=" ... ")),"<Buffer "+e+">"},s.prototype.compare=function(e,t,n,r,o){if(!s.isBuffer(e))throw new TypeError("Argument must be a Buffer");if(void 0===t&&(t=0),void 0===n&&(n=e?e.length:0),void 0===r&&(r=0),void 0===o&&(o=this.length),0>t||n>e.length||0>r||o>this.length)throw new RangeError("out of range index");if(r>=o&&t>=n)return 0;if(r>=o)return-1;if(t>=n)return 1;if(t>>>=0,n>>>=0,r>>>=0,o>>>=0,this===e)return 0;for(var i=o-r,a=n-t,u=Math.min(i,a),c=this.slice(r,o),f=e.slice(t,n),d=0;u>d;++d)if(c[d]!==f[d]){i=c[d],a=f[d];break}return a>i?-1:i>a?1:0},s.prototype.indexOf=function(e,t,n){if("string"==typeof t?(n=t,t=0):t>2147483647?t=2147483647:-2147483648>t&&(t=-2147483648),t>>=0,0===this.length)return-1;if(t>=this.length)return-1;if(0>t&&(t=Math.max(this.length+t,0)),"string"==typeof e&&(e=s.from(e,n)),s.isBuffer(e))return 0===e.length?-1:b(this,e,t,n);if("number"==typeof e)return s.TYPED_ARRAY_SUPPORT&&"function"===Uint8Array.prototype.indexOf?Uint8Array.prototype.indexOf.call(this,e,t):b(this,[e],t,n);throw new TypeError("val must be string, number or Buffer")},s.prototype.includes=function(e,t,n){return-1!==this.indexOf(e,t,n)},s.prototype.write=function(e,t,n,r){if(void 0===t)r="utf8",n=this.length,t=0;else if(void 0===n&&"string"==typeof t)r=t,n=this.length,t=0;else{if(!isFinite(t))throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");t=0|t,isFinite(n)?(n=0|n,void 0===r&&(r="utf8")):(r=n,n=void 0)}var o=this.length-t;if((void 0===n||n>o)&&(n=o),e.length>0&&(0>n||0>t)||t>this.length)throw new RangeError("Attempt to write outside buffer bounds");r||(r="utf8");for(var i=!1;;)switch(r){case"hex":return w(this,e,t,n);case"utf8":case"utf-8":return E(this,e,t,n);case"ascii":return k(this,e,t,n);case"binary":return x(this,e,t,n);case"base64":return S(this,e,t,n);case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return B(this,e,t,n);default:if(i)throw new TypeError("Unknown encoding: "+r);r=(""+r).toLowerCase(),i=!0}},s.prototype.toJSON=function(){return{type:"Buffer",data:Array.prototype.slice.call(this._arr||this,0)}};var Z=4096;s.prototype.slice=function(e,t){var n=this.length;e=~~e,t=void 0===t?n:~~t,0>e?(e+=n,0>e&&(e=0)):e>n&&(e=n),0>t?(t+=n,0>t&&(t=0)):t>n&&(t=n),e>t&&(t=e);var r;if(s.TYPED_ARRAY_SUPPORT)r=this.subarray(e,t),r.__proto__=s.prototype;else{var o=t-e;r=new s(o,void 0);for(var i=0;o>i;i++)r[i]=this[i+e]}return r},s.prototype.readUIntLE=function(e,t,n){e=0|e,t=0|t,n||P(e,t,this.length);for(var r=this[e],o=1,i=0;++i<t&&(o*=256);)r+=this[e+i]*o;return r},s.prototype.readUIntBE=function(e,t,n){e=0|e,t=0|t,n||P(e,t,this.length);for(var r=this[e+--t],o=1;t>0&&(o*=256);)r+=this[e+--t]*o;return r},s.prototype.readUInt8=function(e,t){return t||P(e,1,this.length),this[e]},s.prototype.readUInt16LE=function(e,t){return t||P(e,2,this.length),this[e]|this[e+1]<<8},s.prototype.readUInt16BE=function(e,t){return t||P(e,2,this.length),this[e]<<8|this[e+1]},s.prototype.readUInt32LE=function(e,t){return t||P(e,4,this.length),(this[e]|this[e+1]<<8|this[e+2]<<16)+16777216*this[e+3]},s.prototype.readUInt32BE=function(e,t){return t||P(e,4,this.length),16777216*this[e]+(this[e+1]<<16|this[e+2]<<8|this[e+3])},s.prototype.readIntLE=function(e,t,n){e=0|e,t=0|t,n||P(e,t,this.length);for(var r=this[e],o=1,i=0;++i<t&&(o*=256);)r+=this[e+i]*o;return o*=128,r>=o&&(r-=Math.pow(2,8*t)),r},s.prototype.readIntBE=function(e,t,n){e=0|e,t=0|t,n||P(e,t,this.length);for(var r=t,o=1,i=this[e+--r];r>0&&(o*=256);)i+=this[e+--r]*o;return o*=128,i>=o&&(i-=Math.pow(2,8*t)),i},s.prototype.readInt8=function(e,t){return t||P(e,1,this.length),128&this[e]?-1*(255-this[e]+1):this[e]},s.prototype.readInt16LE=function(e,t){t||P(e,2,this.length);var n=this[e]|this[e+1]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt16BE=function(e,t){t||P(e,2,this.length);var n=this[e+1]|this[e]<<8;return 32768&n?4294901760|n:n},s.prototype.readInt32LE=function(e,t){return t||P(e,4,this.length),this[e]|this[e+1]<<8|this[e+2]<<16|this[e+3]<<24},s.prototype.readInt32BE=function(e,t){return t||P(e,4,this.length),this[e]<<24|this[e+1]<<16|this[e+2]<<8|this[e+3]},s.prototype.readFloatLE=function(e,t){return t||P(e,4,this.length),J.read(this,e,!0,23,4)},s.prototype.readFloatBE=function(e,t){return t||P(e,4,this.length),J.read(this,e,!1,23,4)},s.prototype.readDoubleLE=function(e,t){return t||P(e,8,this.length),J.read(this,e,!0,52,8)},s.prototype.readDoubleBE=function(e,t){return t||P(e,8,this.length),J.read(this,e,!1,52,8)},s.prototype.writeUIntLE=function(e,t,n,r){if(e=+e,t=0|t,n=0|n,!r){var o=Math.pow(2,8*n)-1;O(this,e,t,n,o,0)}var i=1,s=0;for(this[t]=255&e;++s<n&&(i*=256);)this[t+s]=e/i&255;return t+n},s.prototype.writeUIntBE=function(e,t,n,r){if(e=+e,t=0|t,n=0|n,!r){var o=Math.pow(2,8*n)-1;O(this,e,t,n,o,0)}var i=n-1,s=1;for(this[t+i]=255&e;--i>=0&&(s*=256);)this[t+i]=e/s&255;return t+n},s.prototype.writeUInt8=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,1,255,0),s.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),this[t]=255&e,t+1},s.prototype.writeUInt16LE=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):M(this,e,t,!0),t+2},s.prototype.writeUInt16BE=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,2,65535,0),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):M(this,e,t,!1),t+2},s.prototype.writeUInt32LE=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[t+3]=e>>>24,this[t+2]=e>>>16,this[t+1]=e>>>8,this[t]=255&e):j(this,e,t,!0),t+4},s.prototype.writeUInt32BE=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,4,4294967295,0),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):j(this,e,t,!1),t+4},s.prototype.writeIntLE=function(e,t,n,r){if(e=+e,t=0|t,!r){var o=Math.pow(2,8*n-1);O(this,e,t,n,o-1,-o)}var i=0,s=1,a=0;for(this[t]=255&e;++i<n&&(s*=256);)0>e&&0===a&&0!==this[t+i-1]&&(a=1),this[t+i]=(e/s>>0)-a&255;return t+n},s.prototype.writeIntBE=function(e,t,n,r){if(e=+e,t=0|t,!r){var o=Math.pow(2,8*n-1);O(this,e,t,n,o-1,-o)}var i=n-1,s=1,a=0;for(this[t+i]=255&e;--i>=0&&(s*=256);)0>e&&0===a&&0!==this[t+i+1]&&(a=1),this[t+i]=(e/s>>0)-a&255;return t+n},s.prototype.writeInt8=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,1,127,-128),s.TYPED_ARRAY_SUPPORT||(e=Math.floor(e)),0>e&&(e=255+e+1),this[t]=255&e,t+1},s.prototype.writeInt16LE=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8):M(this,e,t,!0),t+2},s.prototype.writeInt16BE=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,2,32767,-32768),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>8,this[t+1]=255&e):M(this,e,t,!1),t+2},s.prototype.writeInt32LE=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,4,2147483647,-2147483648),s.TYPED_ARRAY_SUPPORT?(this[t]=255&e,this[t+1]=e>>>8,this[t+2]=e>>>16,this[t+3]=e>>>24):j(this,e,t,!0),t+4},s.prototype.writeInt32BE=function(e,t,n){return e=+e,t=0|t,n||O(this,e,t,4,2147483647,-2147483648),0>e&&(e=4294967295+e+1),s.TYPED_ARRAY_SUPPORT?(this[t]=e>>>24,this[t+1]=e>>>16,this[t+2]=e>>>8,this[t+3]=255&e):j(this,e,t,!1),t+4},s.prototype.writeFloatLE=function(e,t,n){return D(this,e,t,!0,n)},s.prototype.writeFloatBE=function(e,t,n){return D(this,e,t,!1,n)},s.prototype.writeDoubleLE=function(e,t,n){return q(this,e,t,!0,n)},s.prototype.writeDoubleBE=function(e,t,n){return q(this,e,t,!1,n)},s.prototype.copy=function(e,t,n,r){if(n||(n=0),r||0===r||(r=this.length),t>=e.length&&(t=e.length),t||(t=0),r>0&&n>r&&(r=n),r===n)return 0;if(0===e.length||0===this.length)return 0;if(0>t)throw new RangeError("targetStart out of bounds");if(0>n||n>=this.length)throw new RangeError("sourceStart out of bounds");if(0>r)throw new RangeError("sourceEnd out of bounds");r>this.length&&(r=this.length),e.length-t<r-n&&(r=e.length-t+n);var o,i=r-n;if(this===e&&t>n&&r>t)for(o=i-1;o>=0;o--)e[o+t]=this[o+n];else if(1e3>i||!s.TYPED_ARRAY_SUPPORT)for(o=0;i>o;o++)e[o+t]=this[o+n];else Uint8Array.prototype.set.call(e,this.subarray(n,n+i),t);return i},s.prototype.fill=function(e,t,n,r){if("string"==typeof e){if("string"==typeof t?(r=t,t=0,n=this.length):"string"==typeof n&&(r=n,n=this.length),1===e.length){var o=e.charCodeAt(0);256>o&&(e=o)}if(void 0!==r&&"string"!=typeof r)throw new TypeError("encoding must be a string");if("string"==typeof r&&!s.isEncoding(r))throw new TypeError("Unknown encoding: "+r)}else"number"==typeof e&&(e=255&e);if(0>t||this.length<t||this.length<n)throw new RangeError("Out of range index");if(t>=n)return this;t>>>=0,n=void 0===n?this.length:n>>>0,e||(e=0);var i;if("number"==typeof e)for(i=t;n>i;i++)this[i]=e;else{var a=s.isBuffer(e)?e:F(new s(e,r).toString()),u=a.length;for(i=0;n-t>i;i++)this[i+t]=a[i%u]}return this};var ee=/[^+\/0-9A-Za-z-_]/g}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"base64-js":8,ieee754:44,isarray:51}],25:[function(e,t,n){t.exports={100:"Continue",101:"Switching Protocols",102:"Processing",200:"OK",201:"Created",202:"Accepted",203:"Non-Authoritative Information",204:"No Content",205:"Reset Content",206:"Partial Content",207:"Multi-Status",208:"Already Reported",226:"IM Used",300:"Multiple Choices",301:"Moved Permanently",302:"Found",303:"See Other",304:"Not Modified",305:"Use Proxy",307:"Temporary Redirect",308:"Permanent Redirect",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",409:"Conflict",410:"Gone",411:"Length Required",412:"Precondition Failed",413:"Payload Too Large",414:"URI Too Long",415:"Unsupported Media Type",416:"Range Not Satisfiable",417:"Expectation Failed",418:"I'm a teapot",421:"Misdirected Request",422:"Unprocessable Entity",423:"Locked",424:"Failed Dependency",425:"Unordered Collection",426:"Upgrade Required",428:"Precondition Required",429:"Too Many Requests",431:"Request Header Fields Too Large",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Gateway Timeout",505:"HTTP Version Not Supported",506:"Variant Also Negotiates",507:"Insufficient Storage",508:"Loop Detected",509:"Bandwidth Limit Exceeded",510:"Not Extended",511:"Network Authentication Required"}},{}],26:[function(e,t,n){function r(e,t,n){function i(t){a.destroyed||(e.put(u,t),u+=1)}var a=this;if(!(a instanceof r))return new r(e,t,n);if(s.Writable.call(a,n),n||(n={}),!e||!e.put||!e.get)throw new Error("First argument must be an abstract-chunk-store compliant store");if(t=Number(t),!t)throw new Error("Second argument must be a chunk length");a._blockstream=new o(t,{zeroPadding:!1}),a._blockstream.on("data",i).on("error",function(e){a.destroy(e)});var u=0;a.on("finish",function(){this._blockstream.end()})}t.exports=r;var o=e("block-stream2"),i=e("inherits"),s=e("readable-stream");i(r,s.Writable),r.prototype._write=function(e,t,n){this._blockstream.write(e,t,n)},r.prototype.destroy=function(e){this.destroyed||(this.destroyed=!0,e&&this.emit("error",e),this.emit("close"))}},{"block-stream2":20,inherits:46,"readable-stream":88}],27:[function(e,t,n){t.exports=function(e,t){var n=1/0,r=0,o=null;t.sort(function(e,t){return e-t});for(var i=0,s=t.length;s>i&&(r=Math.abs(e-t[i]),!(r>=n));i++)n=r,o=t[i];return o}},{}],28:[function(e,t,n){(function(e){function t(e){return Array.isArray?Array.isArray(e):"[object Array]"===g(e)}function r(e){return"boolean"==typeof e}function o(e){return null===e}function i(e){return null==e}function s(e){return"number"==typeof e}function a(e){return"string"==typeof e}function u(e){return"symbol"==typeof e}function c(e){return void 0===e}function f(e){return"[object RegExp]"===g(e)}function d(e){return"object"==typeof e&&null!==e}function h(e){return"[object Date]"===g(e)}function l(e){return"[object Error]"===g(e)||e instanceof Error}function p(e){return"function"==typeof e}function m(e){return null===e||"boolean"==typeof e||"number"==typeof e||"string"==typeof e||"symbol"==typeof e||"undefined"==typeof e}function g(e){return Object.prototype.toString.call(e)}n.isArray=t,n.isBoolean=r,n.isNull=o,n.isNullOrUndefined=i,n.isNumber=s,n.isString=a,n.isSymbol=u,n.isUndefined=c,n.isRegExp=f,n.isObject=d,n.isDate=h,n.isError=l,n.isFunction=p,n.isPrimitive=m,n.isBuffer=e.isBuffer}).call(this,{isBuffer:e("../../is-buffer/index.js")})},{"../../is-buffer/index.js":48}],29:[function(e,t,n){(function(n,r,o){function i(e,t,n){return"function"==typeof t?i(e,null,t):(t=t?B(t):{},void a(e,t,function(e,r,o){return e?n(e):(t.singleFileTorrent=o,void l(r,t,n))}))}function s(e,t,n){return"function"==typeof t?s(e,null,t):(t=t?B(t):{},void a(e,t,n))}function a(e,t,r){function i(){P(e.map(function(e){return function(t){var n={};if(m(e))n.getStream=_(e),n.length=e.size;else if(o.isBuffer(e))n.getStream=v(e),n.length=e.length;else{if(!y(e)){if("string"==typeof e){if("function"!=typeof T.stat)throw new Error("filesystem paths do not work in the browser");var r=a>1||c;return void u(e,r,t)}throw new Error("invalid input type")}n.getStream=w(e,n),n.length=0}n.path=e.path,t(null,n)}}),function(e,t){return e?r(e):(t=A(t),void r(null,t,c))})}if(Array.isArray(e)&&0===e.length)throw new Error("invalid input type");g(e)&&(e=Array.prototype.slice.call(e)),Array.isArray(e)||(e=[e]),e=e.map(function(e){return m(e)&&"string"==typeof e.path?e.path:e}),1!==e.length||"string"==typeof e[0]||e[0].name||(e[0].name=t.name);var s=null;e.forEach(function(t,n){if("string"!=typeof t){var r=t.fullPath||t.name;r||(r="Unknown File "+(n+1),t.unknownName=!0),t.path=r.split("/"),t.path[0]||t.path.shift(),t.path.length<2?s=null:0===n&&e.length>1?s=t.path[0]:t.path[0]!==s&&(s=null)}}),e=e.filter(function(e){if("string"==typeof e)return!0;var t=e.path[e.path.length-1];return d(t)&&L.not(t)}),s&&e.forEach(function(e){var t=(o.isBuffer(e)||y(e))&&!e.path;"string"==typeof e||t||e.path.shift()}),!t.name&&s&&(t.name=s),t.name||e.some(function(e){return"string"==typeof e?(t.name=S.basename(e),!0):e.unknownName?void 0:(t.name=e.path[e.path.length-1],!0)}),t.name||(t.name="Unnamed Torrent "+Date.now());var a=e.reduce(function(e,t){return e+Number("string"==typeof t)},0),c=1===e.length;if(1===e.length&&"string"==typeof e[0]){if("function"!=typeof T.stat)throw new Error("filesystem paths do not work in the browser");C(e[0],function(e,t){return e?r(e):(c=t,void i())})}else n.nextTick(function(){i()})}function u(e,t,n){f(e,c,function(r,o){return r?n(r):(o=Array.isArray(o)?A(o):[o],e=S.normalize(e),t&&(e=e.slice(0,e.lastIndexOf(S.sep)+1)),e[e.length-1]!==S.sep&&(e+=S.sep),o.forEach(function(t){t.getStream=b(t.path),t.path=t.path.replace(e,"").split(S.sep)}),void n(null,o))})}function c(e,t){t=U(t),T.stat(e,function(n,r){if(n)return t(n);var o={length:r.size,path:e};t(null,o)})}function f(e,t,n){T.readdir(e,function(r,o){r&&"ENOTDIR"===r.code?t(e,n):r?n(r):P(o.filter(d).filter(L.not).map(function(n){return function(r){f(S.join(e,n),t,r)}}),n)})}function d(e){return"."!==e[0]}function h(e,t,n){function r(e){f+=e.length;var t=l;O(e,function(e){c[t]=e,h-=1,u()}),h+=1,l+=1}function i(){p=!0,u()}function s(e){a(),n(e)}function a(){m.removeListener("error",s),g.removeListener("data",r),g.removeListener("end",i),g.removeListener("error",s)}function u(){p&&0===h&&(a(),n(null,new o(c.join(""),"hex"),f))}n=U(n);var c=[],f=0,d=e.map(function(e){return e.getStream}),h=0,l=0,p=!1,m=new R(d),g=new k(t,{zeroPadding:!1});m.on("error",s),m.pipe(g).on("data",r).on("end",i).on("error",s)}function l(e,n,o){var i=n.announceList;i||("string"==typeof n.announce?i=[[n.announce]]:Array.isArray(n.announce)&&(i=n.announce.map(function(e){return[e]}))),i||(i=[]),r.WEBTORRENT_ANNOUNCE&&("string"==typeof r.WEBTORRENT_ANNOUNCE?i.push([[r.WEBTORRENT_ANNOUNCE]]):Array.isArray(r.WEBTORRENT_ANNOUNCE)&&(i=i.concat(r.WEBTORRENT_ANNOUNCE.map(function(e){return[e]})))),void 0===n.announce&&void 0===n.announceList&&(i=i.concat(t.exports.announceList)),"string"==typeof n.urlList&&(n.urlList=[n.urlList]);var s={info:{name:n.name},"creation date":Math.ceil((Number(n.creationDate)||Date.now())/1e3),encoding:"UTF-8"};0!==i.length&&(s.announce=i[0][0],s["announce-list"]=i),void 0!==n.comment&&(s.comment=n.comment),void 0!==n.createdBy&&(s["created by"]=n.createdBy),void 0!==n["private"]&&(s.info["private"]=Number(n["private"])),void 0!==n.sslCert&&(s.info["ssl-cert"]=n.sslCert),void 0!==n.urlList&&(s["url-list"]=n.urlList);var a=n.pieceLength||x(e.reduce(p,0));s.info["piece length"]=a,h(e,a,function(t,r,i){return t?o(t):(s.info.pieces=r,e.forEach(function(e){delete e.getStream}),n.singleFileTorrent?s.info.length=i:s.info.files=e,void o(null,E.encode(s)))})}function p(e,t){return e+t.length}function m(e){return"undefined"!=typeof Blob&&e instanceof Blob}function g(e){return"function"==typeof FileList&&e instanceof FileList}function y(e){return"object"==typeof e&&null!=e&&"function"==typeof e.pipe}function _(e){return function(){return new I(e)}}function v(e){return function(){var t=new M.PassThrough;return t.end(e),t}}function b(e){return function(){return T.createReadStream(e)}}function w(e,t){return function(){var n=new M.Transform;return n._transform=function(e,n,r){t.length+=e.length,this.push(e),r()},e.pipe(n),n}}t.exports=i,t.exports.parseInput=s,t.exports.announceList=[["udp://tracker.openbittorrent.com:80"],["udp://tracker.internetwarriors.net:1337"],["udp://tracker.leechers-paradise.org:6969"],["udp://tracker.coppersurfer.tk:6969"],["udp://exodus.desync.com:6969"],["wss://tracker.webtorrent.io"],["wss://tracker.btorrent.xyz"],["wss://tracker.openwebtorrent.com"],["wss://tracker.fastcast.nz"]];var E=e("bencode"),k=e("block-stream2"),x=e("piece-length"),S=e("path"),B=e("xtend"),I=e("filestream/read"),A=e("flatten"),T=e("fs"),C=e("is-file"),L=e("junk"),R=e("multistream"),U=e("once"),P=e("run-parallel"),O=e("simple-sha1"),M=e("readable-stream")}).call(this,e("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},e("buffer").Buffer)},{_process:75,bencode:30,"block-stream2":20,buffer:24,"filestream/read":39,flatten:40,fs:22,"is-file":49,junk:52,multistream:63,once:65,path:72,"piece-length":73,"readable-stream":88,"run-parallel":92,"simple-sha1":98,xtend:125}],
	30:[function(e,t,n){var r=t.exports;r.encode=e("./lib/encode"),r.decode=e("./lib/decode"),r.byteLength=r.encodingLength=function(e){return r.encode(e).length}},{"./lib/decode":31,"./lib/encode":33}],31:[function(e,t,n){(function(n){function r(e,t,o,i){return"number"!=typeof t&&null==i&&(i=t,t=void 0),"number"!=typeof o&&null==i&&(i=o,o=void 0),r.position=0,r.encoding=i||null,r.data=n.isBuffer(e)?e.slice(t,o):new n(e),r.bytes=r.data.length,r.next()}var o=e("./dict");r.bytes=0,r.position=0,r.data=null,r.encoding=null,r.next=function(){switch(r.data[r.position]){case 100:return r.dictionary();case 108:return r.list();case 105:return r.integer();default:return r.buffer()}},r.find=function(e){for(var t=r.position,n=r.data.length,o=r.data;n>t;){if(o[t]===e)return t;t++}throw new Error('Invalid data: Missing delimiter "'+String.fromCharCode(e)+'" [0x'+e.toString(16)+"]")},r.dictionary=function(){r.position++;for(var e=new o;101!==r.data[r.position];)e.binarySet(r.buffer(),r.next());return r.position++,e},r.list=function(){r.position++;for(var e=[];101!==r.data[r.position];)e.push(r.next());return r.position++,e},r.integer=function(){var e=r.find(101),t=r.data.toString("ascii",r.position+1,e);return r.position+=e+1-r.position,parseInt(t,10)},r.buffer=function(){var e=r.find(58),t=parseInt(r.data.toString("ascii",r.position,e),10),n=++e+t;return r.position=n,r.encoding?r.data.toString(r.encoding,e,n):r.data.slice(e,n)},t.exports=r}).call(this,e("buffer").Buffer)},{"./dict":32,buffer:24}],32:[function(e,t,n){var r=t.exports=function(){Object.defineProperty(this,"_keys",{enumerable:!1,value:[]})};r.prototype.binaryKeys=function(){return this._keys.slice()},r.prototype.binarySet=function(e,t){this._keys.push(e),this[e]=t}},{}],33:[function(e,t,n){(function(e){function n(t,r,o){var i=[],s=null;return n._encode(i,t),s=e.concat(i),n.bytes=s.length,e.isBuffer(r)?(s.copy(r,o),r):s}n.bytes=-1,n._floatConversionDetected=!1,n._encode=function(t,r){if(e.isBuffer(r))return t.push(new e(r.length+":")),void t.push(r);switch(typeof r){case"string":n.buffer(t,r);break;case"number":n.number(t,r);break;case"object":r.constructor===Array?n.list(t,r):n.dict(t,r);break;case"boolean":n.number(t,r?1:0)}};var r=new e("e"),o=new e("d"),i=new e("l");n.buffer=function(t,n){t.push(new e(e.byteLength(n)+":"+n))},n.number=function(t,r){var o=2147483648,i=r/o<<0,s=r%o<<0,a=i*o+s;t.push(new e("i"+a+"e")),a===r||n._floatConversionDetected||(n._floatConversionDetected=!0,console.warn('WARNING: Possible data corruption detected with value "'+r+'":','Bencoding only defines support for integers, value was converted to "'+a+'"'),console.trace())},n.dict=function(e,t){e.push(o);for(var i,s=0,a=Object.keys(t).sort(),u=a.length;u>s;s++)i=a[s],n.buffer(e,i),n._encode(e,t[i]);e.push(r)},n.list=function(e,t){var o=0,s=t.length;for(e.push(i);s>o;o++)n._encode(e,t[o]);e.push(r)},t.exports=n}).call(this,e("buffer").Buffer)},{buffer:24}],34:[function(e,t,n){function r(){return"WebkitAppearance"in document.documentElement.style||window.console&&(console.firebug||console.exception&&console.table)||navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/)&&parseInt(RegExp.$1,10)>=31}function o(){var e=arguments,t=this.useColors;if(e[0]=(t?"%c":"")+this.namespace+(t?" %c":" ")+e[0]+(t?"%c ":" ")+"+"+n.humanize(this.diff),!t)return e;var r="color: "+this.color;e=[e[0],r,"color: inherit"].concat(Array.prototype.slice.call(e,1));var o=0,i=0;return e[0].replace(/%[a-z%]/g,function(e){"%%"!==e&&(o++,"%c"===e&&(i=o))}),e.splice(i,0,r),e}function i(){return"object"==typeof console&&console.log&&Function.prototype.apply.call(console.log,console,arguments)}function s(e){try{null==e?n.storage.removeItem("debug"):n.storage.debug=e}catch(t){}}function a(){var e;try{e=n.storage.debug}catch(t){}return e}function u(){try{return window.localStorage}catch(e){}}n=t.exports=e("./debug"),n.log=i,n.formatArgs=o,n.save=s,n.load=a,n.useColors=r,n.storage="undefined"!=typeof chrome&&"undefined"!=typeof chrome.storage?chrome.storage.local:u(),n.colors=["lightseagreen","forestgreen","goldenrod","dodgerblue","darkorchid","crimson"],n.formatters.j=function(e){return JSON.stringify(e)},n.enable(a())},{"./debug":35}],35:[function(e,t,n){function r(){return n.colors[f++%n.colors.length]}function o(e){function t(){}function o(){var e=o,t=+new Date,i=t-(c||t);e.diff=i,e.prev=c,e.curr=t,c=t,null==e.useColors&&(e.useColors=n.useColors()),null==e.color&&e.useColors&&(e.color=r());var s=Array.prototype.slice.call(arguments);s[0]=n.coerce(s[0]),"string"!=typeof s[0]&&(s=["%o"].concat(s));var a=0;s[0]=s[0].replace(/%([a-z%])/g,function(t,r){if("%%"===t)return t;a++;var o=n.formatters[r];if("function"==typeof o){var i=s[a];t=o.call(e,i),s.splice(a,1),a--}return t}),"function"==typeof n.formatArgs&&(s=n.formatArgs.apply(e,s));var u=o.log||n.log||console.log.bind(console);u.apply(e,s)}t.enabled=!1,o.enabled=!0;var i=n.enabled(e)?o:t;return i.namespace=e,i}function i(e){n.save(e);for(var t=(e||"").split(/[\s,]+/),r=t.length,o=0;r>o;o++)t[o]&&(e=t[o].replace(/\*/g,".*?"),"-"===e[0]?n.skips.push(new RegExp("^"+e.substr(1)+"$")):n.names.push(new RegExp("^"+e+"$")))}function s(){n.enable("")}function a(e){var t,r;for(t=0,r=n.skips.length;r>t;t++)if(n.skips[t].test(e))return!1;for(t=0,r=n.names.length;r>t;t++)if(n.names[t].test(e))return!0;return!1}function u(e){return e instanceof Error?e.stack||e.message:e}n=t.exports=o,n.coerce=u,n.disable=s,n.enable=i,n.enabled=a,n.humanize=e("ms"),n.names=[],n.skips=[],n.formatters={};var c,f=0},{ms:62}],36:[function(e,t,n){t.exports=function(){for(var e=0;e<arguments.length;e++)if(void 0!==arguments[e])return arguments[e]}},{}],37:[function(e,t,n){var r=e("once"),o=function(){},i=function(e){return e.setHeader&&"function"==typeof e.abort},s=function(e){return e.stdio&&Array.isArray(e.stdio)&&3===e.stdio.length},a=function(e,t,n){if("function"==typeof t)return a(e,null,t);t||(t={}),n=r(n||o);var u=e._writableState,c=e._readableState,f=t.readable||t.readable!==!1&&e.readable,d=t.writable||t.writable!==!1&&e.writable,h=function(){e.writable||l()},l=function(){d=!1,f||n()},p=function(){f=!1,d||n()},m=function(e){n(e?new Error("exited with error code: "+e):null)},g=function(){return(!f||c&&c.ended)&&(!d||u&&u.ended)?void 0:n(new Error("premature close"))},y=function(){e.req.on("finish",l)};return i(e)?(e.on("complete",l),e.on("abort",g),e.req?y():e.on("request",y)):d&&!u&&(e.on("end",h),e.on("close",h)),s(e)&&e.on("exit",m),e.on("end",p),e.on("finish",l),t.error!==!1&&e.on("error",n),e.on("close",g),function(){e.removeListener("complete",l),e.removeListener("abort",g),e.removeListener("request",y),e.req&&e.req.removeListener("finish",l),e.removeListener("end",h),e.removeListener("close",h),e.removeListener("finish",l),e.removeListener("exit",m),e.removeListener("end",p),e.removeListener("error",n),e.removeListener("close",g)}};t.exports=a},{once:65}],38:[function(e,t,n){function r(){this._events=this._events||{},this._maxListeners=this._maxListeners||void 0}function o(e){return"function"==typeof e}function i(e){return"number"==typeof e}function s(e){return"object"==typeof e&&null!==e}function a(e){return void 0===e}t.exports=r,r.EventEmitter=r,r.prototype._events=void 0,r.prototype._maxListeners=void 0,r.defaultMaxListeners=10,r.prototype.setMaxListeners=function(e){if(!i(e)||0>e||isNaN(e))throw TypeError("n must be a positive number");return this._maxListeners=e,this},r.prototype.emit=function(e){var t,n,r,i,u,c;if(this._events||(this._events={}),"error"===e&&(!this._events.error||s(this._events.error)&&!this._events.error.length)){if(t=arguments[1],t instanceof Error)throw t;throw TypeError('Uncaught, unspecified "error" event.')}if(n=this._events[e],a(n))return!1;if(o(n))switch(arguments.length){case 1:n.call(this);break;case 2:n.call(this,arguments[1]);break;case 3:n.call(this,arguments[1],arguments[2]);break;default:i=Array.prototype.slice.call(arguments,1),n.apply(this,i)}else if(s(n))for(i=Array.prototype.slice.call(arguments,1),c=n.slice(),r=c.length,u=0;r>u;u++)c[u].apply(this,i);return!0},r.prototype.addListener=function(e,t){var n;if(!o(t))throw TypeError("listener must be a function");return this._events||(this._events={}),this._events.newListener&&this.emit("newListener",e,o(t.listener)?t.listener:t),this._events[e]?s(this._events[e])?this._events[e].push(t):this._events[e]=[this._events[e],t]:this._events[e]=t,s(this._events[e])&&!this._events[e].warned&&(n=a(this._maxListeners)?r.defaultMaxListeners:this._maxListeners,n&&n>0&&this._events[e].length>n&&(this._events[e].warned=!0,console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.",this._events[e].length),"function"==typeof console.trace&&console.trace())),this},r.prototype.on=r.prototype.addListener,r.prototype.once=function(e,t){function n(){this.removeListener(e,n),r||(r=!0,t.apply(this,arguments))}if(!o(t))throw TypeError("listener must be a function");var r=!1;return n.listener=t,this.on(e,n),this},r.prototype.removeListener=function(e,t){var n,r,i,a;if(!o(t))throw TypeError("listener must be a function");if(!this._events||!this._events[e])return this;if(n=this._events[e],i=n.length,r=-1,n===t||o(n.listener)&&n.listener===t)delete this._events[e],this._events.removeListener&&this.emit("removeListener",e,t);else if(s(n)){for(a=i;a-- >0;)if(n[a]===t||n[a].listener&&n[a].listener===t){r=a;break}if(0>r)return this;1===n.length?(n.length=0,delete this._events[e]):n.splice(r,1),this._events.removeListener&&this.emit("removeListener",e,t)}return this},r.prototype.removeAllListeners=function(e){var t,n;if(!this._events)return this;if(!this._events.removeListener)return 0===arguments.length?this._events={}:this._events[e]&&delete this._events[e],this;if(0===arguments.length){for(t in this._events)"removeListener"!==t&&this.removeAllListeners(t);return this.removeAllListeners("removeListener"),this._events={},this}if(n=this._events[e],o(n))this.removeListener(e,n);else if(n)for(;n.length;)this.removeListener(e,n[n.length-1]);return delete this._events[e],this},r.prototype.listeners=function(e){var t;return t=this._events&&this._events[e]?o(this._events[e])?[this._events[e]]:this._events[e].slice():[]},r.prototype.listenerCount=function(e){if(this._events){var t=this._events[e];if(o(t))return 1;if(t)return t.length}return 0},r.listenerCount=function(e,t){return e.listenerCount(t)}},{}],39:[function(e,t,n){function r(e,t){var n=this;return this instanceof r?(t=t||{},o.call(this,t),this._offset=0,this._ready=!1,this._file=e,this._size=e.size,this._chunkSize=t.chunkSize||Math.max(this._size/1e3,204800),this.reader=new FileReader,void this._generateHeaderBlocks(e,t,function(e,t){return e?n.emit("error",e):(Array.isArray(t)&&t.forEach(function(e){n.push(e)}),n._ready=!0,void n.emit("_ready"))})):new r(e,t)}var o=e("readable-stream").Readable,i=e("inherits"),s=e("typedarray-to-buffer");i(r,o),t.exports=r,r.prototype._generateHeaderBlocks=function(e,t,n){n(null,[])},r.prototype._read=function(){if(!this._ready)return void this.once("_ready",this._read.bind(this));var e=this,t=this.reader,n=this._offset,r=this._offset+this._chunkSize;return r>this._size&&(r=this._size),n===this._size?(this.destroy(),void this.push(null)):(t.onload=function(){e._offset=r,e.push(s(t.result))},t.onerror=function(){e.emit("error",t.error)},void t.readAsArrayBuffer(this._file.slice(n,r)))},r.prototype.destroy=function(){if(this._file=null,this.reader){this.reader.onload=null,this.reader.onerror=null;try{this.reader.abort()}catch(e){}}this.reader=null}},{inherits:46,"readable-stream":88,"typedarray-to-buffer":114}],40:[function(e,t,n){t.exports=function(e,t){function n(e,r){return e.reduce(function(e,o){return Array.isArray(o)&&t>r?e.concat(n(o,r+1)):e.concat(o)},[])}return t="number"==typeof t?t:1/0,t?n(e,1):Array.isArray(e)?e.map(function(e){return e}):e}},{}],41:[function(e,t,n){t.exports=function(){if("undefined"==typeof window)return null;var e={RTCPeerConnection:window.RTCPeerConnection||window.mozRTCPeerConnection||window.webkitRTCPeerConnection,RTCSessionDescription:window.RTCSessionDescription||window.mozRTCSessionDescription||window.webkitRTCSessionDescription,RTCIceCandidate:window.RTCIceCandidate||window.mozRTCIceCandidate||window.webkitRTCIceCandidate};return e.RTCPeerConnection?e:null}},{}],42:[function(e,t,n){var r=t.exports=function(e,t){if(t||(t=16),void 0===e&&(e=128),0>=e)return"0";for(var n=Math.log(Math.pow(2,e))/Math.log(t),o=2;n===1/0;o*=2)n=Math.log(Math.pow(2,e/o))/Math.log(t)*o;for(var i=n-Math.floor(n),s="",o=0;o<Math.floor(n);o++){var a=Math.floor(Math.random()*t).toString(t);s=a+s}if(i){var u=Math.pow(t,i),a=Math.floor(Math.random()*u).toString(t);s=a+s}var c=parseInt(s,t);return c!==1/0&&c>=Math.pow(2,e)?r(e,t):s};r.rack=function(e,t,n){var o=function(o){var s=0;do{if(s++>10){if(!n)throw new Error("too many ID collisions, use more bits");e+=n}var a=r(e,t)}while(Object.hasOwnProperty.call(i,a));return i[a]=o,a},i=o.hats={};return o.get=function(e){return o.hats[e]},o.set=function(e,t){return o.hats[e]=t,o},o.bits=e||128,o.base=t||16,o}},{}],43:[function(e,t,n){var r=e("http"),o=t.exports;for(var i in r)r.hasOwnProperty(i)&&(o[i]=r[i]);o.request=function(e,t){return e||(e={}),e.scheme="https",e.protocol="https:",r.request.call(this,e,t)}},{http:101}],44:[function(e,t,n){n.read=function(e,t,n,r,o){var i,s,a=8*o-r-1,u=(1<<a)-1,c=u>>1,f=-7,d=n?o-1:0,h=n?-1:1,l=e[t+d];for(d+=h,i=l&(1<<-f)-1,l>>=-f,f+=a;f>0;i=256*i+e[t+d],d+=h,f-=8);for(s=i&(1<<-f)-1,i>>=-f,f+=r;f>0;s=256*s+e[t+d],d+=h,f-=8);if(0===i)i=1-c;else{if(i===u)return s?NaN:(l?-1:1)*(1/0);s+=Math.pow(2,r),i-=c}return(l?-1:1)*s*Math.pow(2,i-r)},n.write=function(e,t,n,r,o,i){var s,a,u,c=8*i-o-1,f=(1<<c)-1,d=f>>1,h=23===o?Math.pow(2,-24)-Math.pow(2,-77):0,l=r?0:i-1,p=r?1:-1,m=0>t||0===t&&0>1/t?1:0;for(t=Math.abs(t),isNaN(t)||t===1/0?(a=isNaN(t)?1:0,s=f):(s=Math.floor(Math.log(t)/Math.LN2),t*(u=Math.pow(2,-s))<1&&(s--,u*=2),t+=s+d>=1?h/u:h*Math.pow(2,1-d),t*u>=2&&(s++,u/=2),s+d>=f?(a=0,s=f):s+d>=1?(a=(t*u-1)*Math.pow(2,o),s+=d):(a=t*Math.pow(2,d-1)*Math.pow(2,o),s=0));o>=8;e[n+l]=255&a,l+=p,a/=256,o-=8);for(s=s<<o|a,c+=o;c>0;e[n+l]=255&s,l+=p,s/=256,c-=8);e[n+l-p]|=128*m}},{}],45:[function(e,t,n){(function(e){function n(e){if(!(this instanceof n))return new n(e);if(this.store=e,this.chunkLength=e.chunkLength,!this.store||!this.store.get||!this.store.put)throw new Error("First argument must be abstract-chunk-store compliant");this.mem=[]}function r(t,n,r){e.nextTick(function(){t&&t(n,r)})}t.exports=n,n.prototype.put=function(e,t,n){var r=this;r.mem[e]=t,r.store.put(e,t,function(t){r.mem[e]=null,n&&n(t)})},n.prototype.get=function(e,t,n){if("function"==typeof t)return this.get(e,null,t);var o=t&&t.offset||0,i=t&&t.length&&o+t.length,s=this.mem[e];return s?r(n,null,t?s.slice(o,i):s):void this.store.get(e,t,n)},n.prototype.close=function(e){this.store.close(e)},n.prototype.destroy=function(e){this.store.destroy(e)}}).call(this,e("_process"))},{_process:75}],46:[function(e,t,n){"function"==typeof Object.create?t.exports=function(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}:t.exports=function(e,t){e.super_=t;var n=function(){};n.prototype=t.prototype,e.prototype=new n,e.prototype.constructor=e}},{}],47:[function(e,t,n){var r=127;t.exports=function(e){for(var t=0,n=e.length;n>t;++t)if(e.charCodeAt(t)>r)return!1;return!0}},{}],48:[function(e,t,n){t.exports=function(e){return!(null==e||!(e._isBuffer||e.constructor&&"function"==typeof e.constructor.isBuffer&&e.constructor.isBuffer(e)))}},{}],49:[function(e,t,n){"use strict";function r(e){return o.existsSync(e)&&o.statSync(e).isFile()}var o=e("fs");t.exports=function(e,t){return t?void o.stat(e,function(e,n){return e?t(e):t(null,n.isFile())}):r(e)},t.exports.sync=r},{fs:22}],50:[function(e,t,n){function r(e){return o(e)||i(e)}function o(e){return e instanceof Int8Array||e instanceof Int16Array||e instanceof Int32Array||e instanceof Uint8Array||e instanceof Uint8ClampedArray||e instanceof Uint16Array||e instanceof Uint32Array||e instanceof Float32Array||e instanceof Float64Array}function i(e){return a[s.call(e)]}t.exports=r,r.strict=o,r.loose=i;var s=Object.prototype.toString,a={"[object Int8Array]":!0,"[object Int16Array]":!0,"[object Int32Array]":!0,"[object Uint8Array]":!0,"[object Uint8ClampedArray]":!0,"[object Uint16Array]":!0,"[object Uint32Array]":!0,"[object Float32Array]":!0,"[object Float64Array]":!0}},{}],51:[function(e,t,n){var r={}.toString;t.exports=Array.isArray||function(e){return"[object Array]"==r.call(e)}},{}],52:[function(e,t,n){"use strict";n.re=/^npm-debug\.log$|^\..*\.swp$|^\.DS_Store$|^\.AppleDouble$|^\.LSOverride$|^Icon[\r\?]?|^\._.*|^\.Spotlight-V100$|\.Trashes|^__MACOSX$|~$|^Thumbs\.db$|^ehthumbs\.db$|^Desktop\.ini$/,n.is=function(e){return n.re.test(e)},n.not=n.isnt=function(e){return!n.is(e)}},{}],53:[function(e,t,n){(function(n){function r(e){var t={},r=e.split("magnet:?")[1],o=r&&r.length>=0?r.split("&"):[];o.forEach(function(e){var n=e.split("=");if(2===n.length){var r=n[0],o=n[1];if("dn"===r&&(o=decodeURIComponent(o).replace(/\+/g," ")),"tr"!==r&&"xs"!==r&&"as"!==r&&"ws"!==r||(o=decodeURIComponent(o)),"kt"===r&&(o=decodeURIComponent(o).split("+")),t[r])if(Array.isArray(t[r]))t[r].push(o);else{var i=t[r];t[r]=[i,o]}else t[r]=o}});var s;if(t.xt){var u=Array.isArray(t.xt)?t.xt:[t.xt];u.forEach(function(e){if(s=e.match(/^urn:btih:(.{40})/))t.infoHash=s[1].toLowerCase();else if(s=e.match(/^urn:btih:(.{32})/)){var r=i.decode(s[1]);t.infoHash=new n(r,"binary").toString("hex")}})}return t.infoHash&&(t.infoHashBuffer=new n(t.infoHash,"hex")),t.dn&&(t.name=t.dn),t.kt&&(t.keywords=t.kt),"string"==typeof t.tr?t.announce=[t.tr]:Array.isArray(t.tr)?t.announce=t.tr:t.announce=[],t.urlList=[],("string"==typeof t.as||Array.isArray(t.as))&&(t.urlList=t.urlList.concat(t.as)),("string"==typeof t.ws||Array.isArray(t.ws))&&(t.urlList=t.urlList.concat(t.ws)),a(t.announce),a(t.urlList),t}function o(e){e=s(e),e.infoHashBuffer&&(e.xt="urn:btih:"+e.infoHashBuffer.toString("hex")),e.infoHash&&(e.xt="urn:btih:"+e.infoHash),e.name&&(e.dn=e.name),e.keywords&&(e.kt=e.keywords),e.announce&&(e.tr=e.announce),e.urlList&&(e.ws=e.urlList,delete e.as);var t="magnet:?";return Object.keys(e).filter(function(e){return 2===e.length}).forEach(function(n,r){var o=Array.isArray(e[n])?e[n]:[e[n]];o.forEach(function(e,o){!(r>0||o>0)||"kt"===n&&0!==o||(t+="&"),"dn"===n&&(e=encodeURIComponent(e).replace(/%20/g,"+")),"tr"!==n&&"xs"!==n&&"as"!==n&&"ws"!==n||(e=encodeURIComponent(e)),"kt"===n&&(e=encodeURIComponent(e)),t+="kt"===n&&o>0?"+"+e:n+"="+e})}),t}t.exports=r,t.exports.decode=r,t.exports.encode=o;var i=e("thirty-two"),s=e("xtend"),a=e("uniq")}).call(this,e("buffer").Buffer)},{buffer:24,"thirty-two":109,uniq:116,xtend:125}],54:[function(e,t,n){function r(e,t){var n=this;if(!(n instanceof r))return new r(e,t);if(!u)throw new Error("web browser lacks MediaSource support");t||(t={}),n._bufferDuration=t.bufferDuration||c,n._elem=e,n._mediaSource=new u,n._streams=[],n.detailedError=null,n._errorHandler=function(){n._elem.removeEventListener("error",n._errorHandler);var e=n._streams.slice();e.forEach(function(e){e.destroy(n._elem.error)})},n._elem.addEventListener("error",n._errorHandler),n._elem.src=window.URL.createObjectURL(n._mediaSource)}function o(e,t){var n=this;if(s.Writable.call(n),n._wrapper=e,n._elem=e._elem,n._mediaSource=e._mediaSource,n._allStreams=e._streams,n._allStreams.push(n),n._bufferDuration=e._bufferDuration,n._sourceBuffer=null,n._openHandler=function(){n._onSourceOpen()},n._flowHandler=function(){n._flow()},"string"==typeof t)n._type=t,"open"===n._mediaSource.readyState?n._createSourceBuffer():n._mediaSource.addEventListener("sourceopen",n._openHandler);else if(null===t._sourceBuffer)t.destroy(),n._type=t._type,n._mediaSource.addEventListener("sourceopen",n._openHandler);else{if(!t._sourceBuffer)throw new Error("The argument to MediaElementWrapper.createWriteStream must be a string or a previous stream returned from that function");t.destroy(),n._type=t._type,n._sourceBuffer=t._sourceBuffer,n._sourceBuffer.addEventListener("updateend",n._flowHandler)}n._elem.addEventListener("timeupdate",n._flowHandler),n.on("error",function(e){n._wrapper.error(e)}),n.on("finish",function(){if(!n.destroyed&&(n._finished=!0,n._allStreams.every(function(e){return e._finished})))try{n._mediaSource.endOfStream()}catch(e){}})}t.exports=r;var i=e("inherits"),s=e("readable-stream"),a=e("to-arraybuffer"),u="undefined"!=typeof window&&window.MediaSource,c=60;r.prototype.createWriteStream=function(e){var t=this;return new o(t,e)},r.prototype.error=function(e){var t=this;t.detailedError||(t.detailedError=e);try{t._mediaSource.endOfStream("decode")}catch(e){}},i(o,s.Writable),o.prototype._onSourceOpen=function(){var e=this;e.destroyed||(e._mediaSource.removeEventListener("sourceopen",e._openHandler),e._createSourceBuffer())},o.prototype.destroy=function(e){var t=this;t.destroyed||(t.destroyed=!0,t._allStreams.splice(t._allStreams.indexOf(t),1),t._mediaSource.removeEventListener("sourceopen",t._openHandler),t._elem.removeEventListener("timeupdate",t._flowHandler),t._sourceBuffer&&(t._sourceBuffer.removeEventListener("updateend",t._flowHandler),"open"===t._mediaSource.readyState&&t._sourceBuffer.abort()),e&&t.emit("error",e),t.emit("close"))},o.prototype._createSourceBuffer=function(){var e=this;if(!e.destroyed)if(u.isTypeSupported(e._type)){if(e._sourceBuffer=e._mediaSource.addSourceBuffer(e._type),e._sourceBuffer.addEventListener("updateend",e._flowHandler),e._cb){var t=e._cb;e._cb=null,t()}}else e.destroy(new Error("The provided type is not supported"))},o.prototype._write=function(e,t,n){var r=this;if(!r.destroyed){if(!r._sourceBuffer)return void(r._cb=function(o){return o?n(o):void r._write(e,t,n)});if(r._sourceBuffer.updating)return n(new Error("Cannot append buffer while source buffer updating"));try{r._sourceBuffer.appendBuffer(a(e))}catch(o){return void r.destroy(o)}r._cb=n}},o.prototype._flow=function(){var e=this;if(!e.destroyed&&e._sourceBuffer&&!e._sourceBuffer.updating&&!("open"===e._mediaSource.readyState&&e._getBufferDuration()>e._bufferDuration)&&e._cb){var t=e._cb;e._cb=null,t()}};var f=0;o.prototype._getBufferDuration=function(){for(var e=this,t=e._sourceBuffer.buffered,n=e._elem.currentTime,r=-1,o=0;o<t.length;o++){var i=t.start(o),s=t.end(o)+f;if(i>n)break;(r>=0||s>=n)&&(r=s)}var a=r-n;return 0>a&&(a=0),a}},{inherits:46,"readable-stream":88,"to-arraybuffer":111}],55:[function(e,t,n){(function(e){function n(e,t){if(!(this instanceof n))return new n(e,t);if(t||(t={}),this.chunkLength=Number(e),!this.chunkLength)throw new Error("First argument must be a chunk length");this.chunks=[],this.closed=!1,this.length=Number(t.length)||1/0,this.length!==1/0&&(this.lastChunkLength=this.length%this.chunkLength||this.chunkLength,this.lastChunkIndex=Math.ceil(this.length/this.chunkLength)-1)}function r(t,n,r){e.nextTick(function(){t&&t(n,r)})}t.exports=n,n.prototype.put=function(e,t,n){if(this.closed)return r(n,new Error("Storage is closed"));var o=e===this.lastChunkIndex;return o&&t.length!==this.lastChunkLength?r(n,new Error("Last chunk length must be "+this.lastChunkLength)):o||t.length===this.chunkLength?(this.chunks[e]=t,void r(n,null)):r(n,new Error("Chunk length must be "+this.chunkLength))},n.prototype.get=function(e,t,n){if("function"==typeof t)return this.get(e,null,t);if(this.closed)return r(n,new Error("Storage is closed"));var o=this.chunks[e];if(!o)return r(n,new Error("Chunk not found"));if(!t)return r(n,null,o);var i=t.offset||0,s=t.length||o.length-i;r(n,null,o.slice(i,s+i))},n.prototype.close=n.prototype.destroy=function(e){return this.closed?r(e,new Error("Storage is closed")):(this.closed=!0,this.chunks=null,void r(e,null))}}).call(this,e("_process"))},{_process:75}],56:[function(e,t,n){(function(t){function r(e,t,n){for(var r=t;n>r;r++)e[r]=0}function o(e,t,n){t.writeUInt32BE(Math.floor((e.getTime()+g)/1e3),n)}function i(e,t,n){t.writeUInt16BE(Math.floor(e)%65536,n),t.writeUInt16BE(Math.floor(256*e*256)%65536,n+2)}function s(e,t,n){t[n]=Math.floor(e)%256,t[n+1]=Math.floor(256*e)%256}function a(e,t,n){e||(e=[0,0,0,0,0,0,0,0,0]);for(var r=0;r<e.length;r++)i(e[r],t,n+4*r)}function u(e,n,r){var o=new t(e,"utf8");o.copy(n,r),n[r+o.length]=0}function c(e){for(var t=new Array(e.length/4),n=0;n<t.length;n++)t[n]=d(e,4*n);return t}function f(e,t){return new Date(1e3*e.readUInt32BE(t)-g)}function d(e,t){return e.readUInt16BE(t)+e.readUInt16BE(t+2)/65536}function h(e,t){return e[t]+e[t+1]/256}function l(e,t,n){var r;for(r=0;n>r&&0!==e[t+r];r++);return e.toString("utf8",t,t+r)}var p=e("./index"),m=e("./descriptor"),g=20828448e5;n.fullBoxes={};var y=["mvhd","tkhd","mdhd","vmhd","smhd","stsd","esds","stsz","stco","stss","stts","ctts","stsc","dref","elst","hdlr","mehd","trex","mfhd","tfhd","tfdt","trun"];y.forEach(function(e){n.fullBoxes[e]=!0}),n.ftyp={},n.ftyp.encode=function(e,r,o){r=r?r.slice(o):new t(n.ftyp.encodingLength(e));var i=e.compatibleBrands||[];r.write(e.brand,0,4,"ascii"),r.writeUInt32BE(e.brandVersion,4);for(var s=0;s<i.length;s++)r.write(i[s],8+4*s,4,"ascii");return n.ftyp.encode.bytes=8+4*i.length,r},n.ftyp.decode=function(e,t){e=e.slice(t);for(var n=e.toString("ascii",0,4),r=e.readUInt32BE(4),o=[],i=8;i<e.length;i+=4)o.push(e.toString("ascii",i,i+4));return{brand:n,brandVersion:r,compatibleBrands:o}},n.ftyp.encodingLength=function(e){return 8+4*(e.compatibleBrands||[]).length},n.mvhd={},n.mvhd.encode=function(e,u,c){return u=u?u.slice(c):new t(96),o(e.ctime||new Date,u,0),o(e.mtime||new Date,u,4),u.writeUInt32BE(e.timeScale||0,8),u.writeUInt32BE(e.duration||0,12),i(e.preferredRate||0,u,16),s(e.preferredVolume||0,u,20),r(u,22,32),a(e.matrix,u,32),u.writeUInt32BE(e.previewTime||0,68),u.writeUInt32BE(e.previewDuration||0,72),u.writeUInt32BE(e.posterTime||0,76),u.writeUInt32BE(e.selectionTime||0,80),u.writeUInt32BE(e.selectionDuration||0,84),u.writeUInt32BE(e.currentTime||0,88),u.writeUInt32BE(e.nextTrackId||0,92),n.mvhd.encode.bytes=96,u},n.mvhd.decode=function(e,t){return e=e.slice(t),{ctime:f(e,0),mtime:f(e,4),timeScale:e.readUInt32BE(8),duration:e.readUInt32BE(12),preferredRate:d(e,16),preferredVolume:h(e,20),matrix:c(e.slice(32,68)),previewTime:e.readUInt32BE(68),previewDuration:e.readUInt32BE(72),posterTime:e.readUInt32BE(76),selectionTime:e.readUInt32BE(80),selectionDuration:e.readUInt32BE(84),currentTime:e.readUInt32BE(88),nextTrackId:e.readUInt32BE(92)}},n.mvhd.encodingLength=function(e){return 96},n.tkhd={},n.tkhd.encode=function(e,i,s){return i=i?i.slice(s):new t(80),o(e.ctime||new Date,i,0),o(e.mtime||new Date,i,4),i.writeUInt32BE(e.trackId||0,8),r(i,12,16),i.writeUInt32BE(e.duration||0,16),r(i,20,28),i.writeUInt16BE(e.layer||0,28),i.writeUInt16BE(e.alternateGroup||0,30),i.writeUInt16BE(e.volume||0,32),a(e.matrix,i,36),i.writeUInt32BE(e.trackWidth||0,72),i.writeUInt32BE(e.trackHeight||0,76),n.tkhd.encode.bytes=80,i},n.tkhd.decode=function(e,t){return e=e.slice(t),{ctime:f(e,0),mtime:f(e,4),trackId:e.readUInt32BE(8),duration:e.readUInt32BE(16),layer:e.readUInt16BE(28),alternateGroup:e.readUInt16BE(30),volume:e.readUInt16BE(32),matrix:c(e.slice(36,72)),trackWidth:e.readUInt32BE(72),trackHeight:e.readUInt32BE(76)}},n.tkhd.encodingLength=function(e){return 80},n.mdhd={},n.mdhd.encode=function(e,r,i){return r=r?r.slice(i):new t(20),o(e.ctime||new Date,r,0),o(e.mtime||new Date,r,4),r.writeUInt32BE(e.timeScale||0,8),r.writeUInt32BE(e.duration||0,12),r.writeUInt16BE(e.language||0,16),r.writeUInt16BE(e.quality||0,18),n.mdhd.encode.bytes=20,r},n.mdhd.decode=function(e,t){return e=e.slice(t),{ctime:f(e,0),mtime:f(e,4),timeScale:e.readUInt32BE(8),duration:e.readUInt32BE(12),language:e.readUInt16BE(16),quality:e.readUInt16BE(18)}},n.mdhd.encodingLength=function(e){return 20},n.vmhd={},n.vmhd.encode=function(e,r,o){r=r?r.slice(o):new t(8),r.writeUInt16BE(e.graphicsMode||0,0);var i=e.opcolor||[0,0,0];return r.writeUInt16BE(i[0],2),r.writeUInt16BE(i[1],4),r.writeUInt16BE(i[2],6),n.vmhd.encode.bytes=8,r},n.vmhd.decode=function(e,t){return e=e.slice(t),{graphicsMode:e.readUInt16BE(0),opcolor:[e.readUInt16BE(2),e.readUInt16BE(4),e.readUInt16BE(6)]}},n.vmhd.encodingLength=function(e){return 8},n.smhd={},n.smhd.encode=function(e,o,i){return o=o?o.slice(i):new t(4),o.writeUInt16BE(e.balance||0,0),r(o,2,4),n.smhd.encode.bytes=4,o},n.smhd.decode=function(e,t){return e=e.slice(t),{balance:e.readUInt16BE(0)}},n.smhd.encodingLength=function(e){return 4},n.stsd={},n.stsd.encode=function(e,r,o){r=r?r.slice(o):new t(n.stsd.encodingLength(e));var i=e.entries||[];r.writeUInt32BE(i.length,0);for(var s=4,a=0;a<i.length;a++){var u=i[a];p.encode(u,r,s),s+=p.encode.bytes}return n.stsd.encode.bytes=s,r},n.stsd.decode=function(e,t,n){e=e.slice(t);for(var r=e.readUInt32BE(0),o=new Array(r),i=4,s=0;r>s;s++){var a=p.decode(e,i,n);o[s]=a,i+=a.length}return{entries:o}},n.stsd.encodingLength=function(e){var t=4;if(!e.entries)return t;for(var n=0;n<e.entries.length;n++)t+=p.encodingLength(e.entries[n]);return t},n.avc1=n.VisualSampleEntry={},n.VisualSampleEntry.encode=function(e,o,i){o=o?o.slice(i):new t(n.VisualSampleEntry.encodingLength(e)),r(o,0,6),o.writeUInt16BE(e.dataReferenceIndex||0,6),r(o,8,24),o.writeUInt16BE(e.width||0,24),o.writeUInt16BE(e.height||0,26),o.writeUInt32BE(e.hResolution||4718592,28),o.writeUInt32BE(e.vResolution||4718592,32),r(o,36,40),o.writeUInt16BE(e.frameCount||1,40);var s=e.compressorName||"",a=Math.min(s.length,31);o.writeUInt8(a,42),o.write(s,43,a,"utf8"),o.writeUInt16BE(e.depth||24,74),o.writeInt16BE(-1,76);var u=78,c=e.children||[];c.forEach(function(e){p.encode(e,o,u),u+=p.encode.bytes}),n.VisualSampleEntry.encode.bytes=u},n.VisualSampleEntry.decode=function(e,t,n){e=e.slice(t);for(var r=n-t,o=Math.min(e.readUInt8(42),31),i={dataReferenceIndex:e.readUInt16BE(6),width:e.readUInt16BE(24),height:e.readUInt16BE(26),hResolution:e.readUInt32BE(28),vResolution:e.readUInt32BE(32),frameCount:e.readUInt16BE(40),compressorName:e.toString("utf8",43,43+o),depth:e.readUInt16BE(74),children:[]},s=78;r-s>=8;){var a=p.decode(e,s,r);i.children.push(a),i[a.type]=a,s+=a.length}return i},n.VisualSampleEntry.encodingLength=function(e){var t=78,n=e.children||[];return n.forEach(function(e){t+=p.encodingLength(e)}),t},n.avcC={},n.avcC.encode=function(e,r,o){r=r?r.slice(o):t(e.buffer.length),e.buffer.copy(r),n.avcC.encode.bytes=e.buffer.length},n.avcC.decode=function(e,n,r){return e=e.slice(n,r),{mimeCodec:e.toString("hex",1,4),buffer:new t(e)}},n.avcC.encodingLength=function(e){return e.buffer.length},n.mp4a=n.AudioSampleEntry={},n.AudioSampleEntry.encode=function(e,o,i){o=o?o.slice(i):new t(n.AudioSampleEntry.encodingLength(e)),r(o,0,6),o.writeUInt16BE(e.dataReferenceIndex||0,6),r(o,8,16),o.writeUInt16BE(e.channelCount||2,16),o.writeUInt16BE(e.sampleSize||16,18),r(o,20,24),o.writeUInt32BE(e.sampleRate||0,24);var s=28,a=e.children||[];a.forEach(function(e){p.encode(e,o,s),s+=p.encode.bytes}),n.AudioSampleEntry.encode.bytes=s},n.AudioSampleEntry.decode=function(e,t,n){e=e.slice(t,n);for(var r=n-t,o={dataReferenceIndex:e.readUInt16BE(6),channelCount:e.readUInt16BE(16),sampleSize:e.readUInt16BE(18),sampleRate:e.readUInt32BE(24),children:[]},i=28;r-i>=8;){var s=p.decode(e,i,r);o.children.push(s),o[s.type]=s,i+=s.length}return o},n.AudioSampleEntry.encodingLength=function(e){var t=28,n=e.children||[];return n.forEach(function(e){t+=p.encodingLength(e)}),t},n.esds={},n.esds.encode=function(e,r,o){r=r?r.slice(o):t(e.buffer.length),e.buffer.copy(r,0),n.esds.encode.bytes=e.buffer.length},n.esds.decode=function(e,n,r){e=e.slice(n,r);var o=m.Descriptor.decode(e,0,e.length),i="ESDescriptor"===o.tagName?o:{},s=i.DecoderConfigDescriptor||{},a=s.oti||0,u=s.DecoderSpecificInfo,c=u?(248&u.buffer.readUInt8(0))>>3:0,f=null;return a&&(f=a.toString(16),c&&(f+="."+c)),{mimeCodec:f,buffer:new t(e.slice(0))
	}},n.esds.encodingLength=function(e){return e.buffer.length},n.stsz={},n.stsz.encode=function(e,r,o){var i=e.entries||[];r=r?r.slice(o):t(n.stsz.encodingLength(e)),r.writeUInt32BE(0,0),r.writeUInt32BE(i.length,4);for(var s=0;s<i.length;s++)r.writeUInt32BE(i[s],4*s+8);return n.stsz.encode.bytes=8+4*i.length,r},n.stsz.decode=function(e,t){e=e.slice(t);for(var n=e.readUInt32BE(0),r=e.readUInt32BE(4),o=new Array(r),i=0;r>i;i++)0===n?o[i]=e.readUInt32BE(4*i+8):o[i]=n;return{entries:o}},n.stsz.encodingLength=function(e){return 8+4*e.entries.length},n.stss=n.stco={},n.stco.encode=function(e,r,o){var i=e.entries||[];r=r?r.slice(o):new t(n.stco.encodingLength(e)),r.writeUInt32BE(i.length,0);for(var s=0;s<i.length;s++)r.writeUInt32BE(i[s],4*s+4);return n.stco.encode.bytes=4+4*i.length,r},n.stco.decode=function(e,t){e=e.slice(t);for(var n=e.readUInt32BE(0),r=new Array(n),o=0;n>o;o++)r[o]=e.readUInt32BE(4*o+4);return{entries:r}},n.stco.encodingLength=function(e){return 4+4*e.entries.length},n.stts={},n.stts.encode=function(e,r,o){var i=e.entries||[];r=r?r.slice(o):new t(n.stts.encodingLength(e)),r.writeUInt32BE(i.length,0);for(var s=0;s<i.length;s++){var a=8*s+4;r.writeUInt32BE(i[s].count||0,a),r.writeUInt32BE(i[s].duration||0,a+4)}return n.stts.encode.bytes=4+8*e.entries.length,r},n.stts.decode=function(e,t){e=e.slice(t);for(var n=e.readUInt32BE(0),r=new Array(n),o=0;n>o;o++){var i=8*o+4;r[o]={count:e.readUInt32BE(i),duration:e.readUInt32BE(i+4)}}return{entries:r}},n.stts.encodingLength=function(e){return 4+8*e.entries.length},n.ctts={},n.ctts.encode=function(e,r,o){var i=e.entries||[];r=r?r.slice(o):new t(n.ctts.encodingLength(e)),r.writeUInt32BE(i.length,0);for(var s=0;s<i.length;s++){var a=8*s+4;r.writeUInt32BE(i[s].count||0,a),r.writeUInt32BE(i[s].compositionOffset||0,a+4)}return n.ctts.encode.bytes=4+8*i.length,r},n.ctts.decode=function(e,t){e=e.slice(t);for(var n=e.readUInt32BE(0),r=new Array(n),o=0;n>o;o++){var i=8*o+4;r[o]={count:e.readUInt32BE(i),compositionOffset:e.readInt32BE(i+4)}}return{entries:r}},n.ctts.encodingLength=function(e){return 4+8*e.entries.length},n.stsc={},n.stsc.encode=function(e,r,o){var i=e.entries||[];r=r?r.slice(o):new t(n.stsc.encodingLength(e)),r.writeUInt32BE(i.length,0);for(var s=0;s<i.length;s++){var a=12*s+4;r.writeUInt32BE(i[s].firstChunk||0,a),r.writeUInt32BE(i[s].samplesPerChunk||0,a+4),r.writeUInt32BE(i[s].sampleDescriptionId||0,a+8)}return n.stsc.encode.bytes=4+12*i.length,r},n.stsc.decode=function(e,t){e=e.slice(t);for(var n=e.readUInt32BE(0),r=new Array(n),o=0;n>o;o++){var i=12*o+4;r[o]={firstChunk:e.readUInt32BE(i),samplesPerChunk:e.readUInt32BE(i+4),sampleDescriptionId:e.readUInt32BE(i+8)}}return{entries:r}},n.stsc.encodingLength=function(e){return 4+12*e.entries.length},n.dref={},n.dref.encode=function(e,r,o){r=r?r.slice(o):new t(n.dref.encodingLength(e));var i=e.entries||[];r.writeUInt32BE(i.length,0);for(var s=4,a=0;a<i.length;a++){var u=i[a],c=(u.buf?u.buf.length:0)+4+4;r.writeUInt32BE(c,s),s+=4,r.write(u.type,s,4,"ascii"),s+=4,u.buf&&(u.buf.copy(r,s),s+=u.buf.length)}return n.dref.encode.bytes=s,r},n.dref.decode=function(e,t){e=e.slice(t);for(var n=e.readUInt32BE(0),r=new Array(n),o=4,i=0;n>i;i++){var s=e.readUInt32BE(o),a=e.toString("ascii",o+4,o+8),u=e.slice(o+8,o+s);o+=s,r[i]={type:a,buf:u}}return{entries:r}},n.dref.encodingLength=function(e){var t=4;if(!e.entries)return t;for(var n=0;n<e.entries.length;n++){var r=e.entries[n].buf;t+=(r?r.length:0)+4+4}return t},n.elst={},n.elst.encode=function(e,r,o){var s=e.entries||[];r=r?r.slice(o):new t(n.elst.encodingLength(e)),r.writeUInt32BE(s.length,0);for(var a=0;a<s.length;a++){var u=12*a+4;r.writeUInt32BE(s[a].trackDuration||0,u),r.writeUInt32BE(s[a].mediaTime||0,u+4),i(s[a].mediaRate||0,r,u+8)}return n.elst.encode.bytes=4+12*s.length,r},n.elst.decode=function(e,t){e=e.slice(t);for(var n=e.readUInt32BE(0),r=new Array(n),o=0;n>o;o++){var i=12*o+4;r[o]={trackDuration:e.readUInt32BE(i),mediaTime:e.readInt32BE(i+4),mediaRate:d(e,i+8)}}return{entries:r}},n.elst.encodingLength=function(e){return 4+12*e.entries.length},n.hdlr={},n.hdlr.encode=function(e,r,o){r=r?r.slice(o):new t(n.hdlr.encodingLength(e));var i=21+(e.name||"").length;return r.fill(0,0,i),r.write(e.handlerType||"",4,4,"ascii"),u(e.name||"",r,20),n.hdlr.encode.bytes=i,r},n.hdlr.decode=function(e,t,n){return e=e.slice(t),{handlerType:e.toString("ascii",4,8),name:l(e,20,n)}},n.hdlr.encodingLength=function(e){return 21+(e.name||"").length},n.mehd={},n.mehd.encode=function(e,r,o){return r=r?r.slice(o):new t(4),r.writeUInt32BE(e.fragmentDuration||0,0),n.mehd.encode.bytes=4,r},n.mehd.decode=function(e,t){return e=e.slice(t),{fragmentDuration:e.readUInt32BE(0)}},n.mehd.encodingLength=function(e){return 4},n.trex={},n.trex.encode=function(e,r,o){return r=r?r.slice(o):new t(20),r.writeUInt32BE(e.trackId||0,0),r.writeUInt32BE(e.defaultSampleDescriptionIndex||0,4),r.writeUInt32BE(e.defaultSampleDuration||0,8),r.writeUInt32BE(e.defaultSampleSize||0,12),r.writeUInt32BE(e.defaultSampleFlags||0,16),n.trex.encode.bytes=20,r},n.trex.decode=function(e,t){return e=e.slice(t),{trackId:e.readUInt32BE(0),defaultSampleDescriptionIndex:e.readUInt32BE(4),defaultSampleDuration:e.readUInt32BE(8),defaultSampleSize:e.readUInt32BE(12),defaultSampleFlags:e.readUInt32BE(16)}},n.trex.encodingLength=function(e){return 20},n.mfhd={},n.mfhd.encode=function(e,r,o){return r=r?r.slice(o):new t(4),r.writeUInt32BE(e.sequenceNumber||0,0),n.mfhd.encode.bytes=4,r},n.mfhd.decode=function(e,t){return{sequenceNumber:e.readUint32BE(0)}},n.mfhd.encodingLength=function(e){return 4},n.tfhd={},n.tfhd.encode=function(e,r,o){return r=r?r.slice(o):new t(4),r.writeUInt32BE(e.trackId,0),n.tfhd.encode.bytes=4,r},n.tfhd.decode=function(e,t){},n.tfhd.encodingLength=function(e){return 4},n.tfdt={},n.tfdt.encode=function(e,r,o){return r=r?r.slice(o):new t(4),r.writeUInt32BE(e.baseMediaDecodeTime||0,0),n.tfdt.encode.bytes=4,r},n.tfdt.decode=function(e,t){},n.tfdt.encodingLength=function(e){return 4},n.trun={},n.trun.encode=function(e,r,o){r=r?r.slice(o):new t(8+16*e.entries.length),r.writeUInt32BE(e.entries.length,0),r.writeInt32BE(e.dataOffset,4);for(var i=8,s=0;s<e.entries.length;s++){var a=e.entries[s];r.writeUInt32BE(a.sampleDuration,i),i+=4,r.writeUInt32BE(a.sampleSize,i),i+=4,r.writeUInt32BE(a.sampleFlags,i),i+=4,r.writeUInt32BE(a.sampleCompositionTimeOffset,i),i+=4}n.trun.encode.bytes=i},n.trun.decode=function(e,t){},n.trun.encodingLength=function(e){return 8+16*e.entries.length},n.mdat={},n.mdat.encode=function(e,t,r){e.buffer?(e.buffer.copy(t,r),n.mdat.encode.bytes=e.buffer.length):n.mdat.encode.bytes=n.mdat.encodingLength(e)},n.mdat.decode=function(e,n,r){return{buffer:new t(e.slice(n,r))}},n.mdat.encodingLength=function(e){return e.buffer?e.buffer.length:e.contentLength}}).call(this,e("buffer").Buffer)},{"./descriptor":57,"./index":58,buffer:24}],57:[function(e,t,n){(function(e){var t={3:"ESDescriptor",4:"DecoderConfigDescriptor",5:"DecoderSpecificInfo",6:"SLConfigDescriptor"};n.Descriptor={},n.Descriptor.decode=function(r,o,i){var s,a=r.readUInt8(o),u=o+1,c=0;do s=r.readUInt8(u++),c=c<<7|127&s;while(128&s);var f,d=t[a];return f=n[d]?n[d].decode(r,u,i):{buffer:new e(r.slice(u,u+c))},f.tag=a,f.tagName=d,f.length=u-o+c,f.contentsLen=c,f},n.DescriptorArray={},n.DescriptorArray.decode=function(e,r,o){for(var i=r,s={};o>=i+2;){var a=n.Descriptor.decode(e,i,o);i+=a.length;var u=t[a.tag]||"Descriptor"+a.tag;s[u]=a}return s},n.ESDescriptor={},n.ESDescriptor.decode=function(e,t,r){var o=e.readUInt8(t+2),i=t+3;if(128&o&&(i+=2),64&o){var s=e.readUInt8(i);i+=s+1}return 32&o&&(i+=2),n.DescriptorArray.decode(e,i,r)},n.DecoderConfigDescriptor={},n.DecoderConfigDescriptor.decode=function(e,t,r){var o=e.readUInt8(t),i=n.DescriptorArray.decode(e,t+13,r);return i.oti=o,i}}).call(this,e("buffer").Buffer)},{buffer:24}],58:[function(e,t,n){(function(t){var r=e("uint64be"),o=e("./boxes"),i=4294967295,s=n,a=n.containers={moov:["mvhd","meta","traks","mvex"],trak:["tkhd","tref","trgr","edts","meta","mdia","udta"],edts:["elst"],mdia:["mdhd","hdlr","elng","minf"],minf:["vmhd","smhd","hmhd","sthd","nmhd","dinf","stbl"],dinf:["dref"],stbl:["stsd","stts","ctts","cslg","stsc","stsz","stz2","stco","co64","stss","stsh","padb","stdp","sdtp","sbgps","sgpds","subss","saizs","saios"],mvex:["mehd","trexs","leva"],moof:["mfhd","meta","trafs"],traf:["tfhd","trun","sbgps","sgpds","subss","saizs","saios","tfdt","meta"]};s.encode=function(e,n,r){return s.encodingLength(e),r=r||0,n=n||new t(e.length),s._encode(e,n,r)},s._encode=function(e,t,n){var u=e.type,c=e.length;c>i&&(c=1),t.writeUInt32BE(c,n),t.write(e.type,n+4,4,"ascii");var f=n+8;if(1===c&&(r.encode(e.length,t,f),f+=8),o.fullBoxes[u]&&(t.writeUInt32BE(e.flags||0,f),t.writeUInt8(e.version||0,f),f+=4),a[u]){var d=a[u];d.forEach(function(n){if(5===n.length){var r=e[n]||[];n=n.substr(0,4),r.forEach(function(e){s._encode(e,t,f),f+=s.encode.bytes})}else e[n]&&(s._encode(e[n],t,f),f+=s.encode.bytes)}),e.otherBoxes&&e.otherBoxes.forEach(function(e){s._encode(e,t,f),f+=s.encode.bytes})}else if(o[u]){var h=o[u].encode;h(e,t,f),f+=h.bytes}else{if(!e.buffer)throw new Error("Either `type` must be set to a known type (not'"+u+"') or `buffer` must be set");var l=e.buffer;l.copy(t,f),f+=e.buffer.length}return s.encode.bytes=f-n,t},s.readHeaders=function(e,t,n){if(t=t||0,n=n||e.length,8>n-t)return 8;var i=e.readUInt32BE(t),s=e.toString("ascii",t+4,t+8),a=t+8;if(1===i){if(16>n-t)return 16;i=r.decode(e,a),a+=8}var u,c;return o.fullBoxes[s]&&(u=e.readUInt8(a),c=16777215&e.readUInt32BE(a),a+=4),{length:i,headersLen:a-t,contentLen:i-(a-t),type:s,version:u,flags:c}},s.decode=function(e,t,n){t=t||0,n=n||e.length;var r=s.readHeaders(e,t,n);if(!r||r.length>n-t)throw new Error("Data too short");return s.decodeWithoutHeaders(r,e,t+r.headersLen,t+r.length)},s.decodeWithoutHeaders=function(e,n,r,i){r=r||0,i=i||n.length;var u=e.type,c={};if(a[u]){c.otherBoxes=[];for(var f=a[u],d=r;i-d>=8;){var h=s.decode(n,d,i);if(d+=h.length,f.indexOf(h.type)>=0)c[h.type]=h;else if(f.indexOf(h.type+"s")>=0){var l=h.type+"s",p=c[l]=c[l]||[];p.push(h)}else c.otherBoxes.push(h)}}else if(o[u]){var m=o[u].decode;c=m(n,r,i)}else c.buffer=new t(n.slice(r,i));return c.length=e.length,c.contentLen=e.contentLen,c.type=e.type,c.version=e.version,c.flags=e.flags,c},s.encodingLength=function(e){var t=e.type,n=8;if(o.fullBoxes[t]&&(n+=4),a[t]){var r=a[t];r.forEach(function(t){if(5===t.length){var r=e[t]||[];t=t.substr(0,4),r.forEach(function(e){e.type=t,n+=s.encodingLength(e)})}else if(e[t]){var o=e[t];o.type=t,n+=s.encodingLength(o)}}),e.otherBoxes&&e.otherBoxes.forEach(function(e){n+=s.encodingLength(e)})}else if(o[t])n+=o[t].encodingLength(e);else{if(!e.buffer)throw new Error("Either `type` must be set to a known type (not'"+t+"') or `buffer` must be set");n+=e.buffer.length}return n>i&&(n+=8),e.length=n,n}}).call(this,e("buffer").Buffer)},{"./boxes":56,buffer:24,uint64be:115}],59:[function(e,t,n){(function(n){function r(){return this instanceof r?(i.Writable.call(this),this.destroyed=!1,this._pending=0,this._missing=0,this._buf=null,this._str=null,this._cb=null,this._ondrain=null,this._writeBuffer=null,this._writeCb=null,this._ondrain=null,void this._kick()):new r}function o(e){this._parent=e,this.destroyed=!1,i.PassThrough.call(this)}var i=e("readable-stream"),s=e("inherits"),a=e("next-event"),u=e("mp4-box-encoding"),c=new n(0);t.exports=r,s(r,i.Writable),r.prototype.destroy=function(e){this.destroyed||(this.destroyed=!0,e&&this.emit("error",e),this.emit("close"))},r.prototype._write=function(e,t,n){if(!this.destroyed){for(var r=!this._str||!this._str._writableState.needDrain;e.length&&!this.destroyed;){if(!this._missing)return this._writeBuffer=e,void(this._writeCb=n);var o=e.length<this._missing?e.length:this._missing;if(this._buf?e.copy(this._buf,this._buf.length-this._missing):this._str&&(r=this._str.write(o===e.length?e:e.slice(0,o))),this._missing-=o,!this._missing){var i=this._buf,s=this._cb,a=this._str;this._buf=this._cb=this._str=this._ondrain=null,r=!0,a&&a.end(),s&&s(i)}e=o===e.length?c:e.slice(o)}return this._pending&&!this._missing?(this._writeBuffer=e,void(this._writeCb=n)):void(r?n():this._ondrain(n))}},r.prototype._buffer=function(e,t){this._missing=e,this._buf=new n(e),this._cb=t},r.prototype._stream=function(e,t){var n=this;return this._missing=e,this._str=new o(this),this._ondrain=a(this._str,"drain"),this._pending++,this._str.on("end",function(){n._pending--,n._kick()}),this._cb=t,this._str},r.prototype._readBox=function(){function e(r,o){t._buffer(r,function(r){o=o?n.concat(o,r):r;var i=u.readHeaders(o);"number"==typeof i?e(i-o.length,o):(t._pending++,t._headers=i,t.emit("box",i))})}var t=this;e(8)},r.prototype.stream=function(){var e=this;if(!e._headers)throw new Error("this function can only be called once after 'box' is emitted");var t=e._headers;return e._headers=null,e._stream(t.contentLen,null)},r.prototype.decode=function(e){var t=this;if(!t._headers)throw new Error("this function can only be called once after 'box' is emitted");var n=t._headers;t._headers=null,t._buffer(n.contentLen,function(r){var o=u.decodeWithoutHeaders(n,r);e(o),t._pending--,t._kick()})},r.prototype.ignore=function(){var e=this;if(!e._headers)throw new Error("this function can only be called once after 'box' is emitted");var t=e._headers;e._headers=null,this._missing=t.contentLen,this._cb=function(){e._pending--,e._kick()}},r.prototype._kick=function(){if(!this._pending&&(this._buf||this._str||this._readBox(),this._writeBuffer)){var e=this._writeCb,t=this._writeBuffer;this._writeBuffer=null,this._writeCb=null,this._write(t,null,e)}},s(o,i.PassThrough),o.prototype.destroy=function(e){this.destroyed||(this.destroyed=!0,this._parent.destroy(e),e&&this.emit("error",e),this.emit("close"))}}).call(this,e("buffer").Buffer)},{buffer:24,inherits:46,"mp4-box-encoding":58,"next-event":64,"readable-stream":88}],60:[function(e,t,n){(function(n,r){function o(){}function i(){function e(){n._want&&(n._want=!1,n._read())}function t(){n._stream=null}if(!(this instanceof i))return new i;a.Readable.call(this),this.destroyed=!1,this._reading=!1,this._stream=null,this._drain=null,this._want=!1,this._onreadable=e,this._onend=t;var n=this}function s(e){this._parent=e,this.destroyed=!1,a.PassThrough.call(this)}var a=e("readable-stream"),u=e("inherits"),c=e("mp4-box-encoding");t.exports=i,u(i,a.Readable),i.prototype.mediaData=i.prototype.mdat=function(e,t){var n=new s(this);return this.box({type:"mdat",contentLength:e,encodeBufferLen:8,stream:n},t),n},i.prototype.box=function(e,t){if(t||(t=o),this.destroyed)return t(new Error("Encoder is destroyed"));var i;if(e.encodeBufferLen&&(i=new r(e.encodeBufferLen)),e.stream)e.buffer=null,i=c.encode(e,i),this.push(i),this._stream=e.stream,this._stream.on("readable",this._onreadable),this._stream.on("end",this._onend),this._stream.on("end",t),this._forward();else{i=c.encode(e,i);var s=this.push(i);if(s)return n.nextTick(t);this._drain=t}},i.prototype.destroy=function(e){if(!this.destroyed){if(this.destroyed=!0,this._stream&&this._stream.destroy&&this._stream.destroy(),this._stream=null,this._drain){var t=this._drain;this._drain=null,t(e)}e&&this.emit("error",e),this.emit("close")}},i.prototype.finalize=function(){this.push(null)},i.prototype._forward=function(){if(this._stream)for(;!this.destroyed;){var e=this._stream.read();if(!e)return void(this._want=!!this._stream);if(!this.push(e))return}},i.prototype._read=function(){if(!this._reading&&!this.destroyed){if(this._reading=!0,this._stream&&this._forward(),this._drain){var e=this._drain;this._drain=null,e()}this._reading=!1}},u(s,a.PassThrough),s.prototype.destroy=function(e){this.destroyed||(this.destroyed=!0,this._parent.destroy(e),e&&this.emit("error",e),this.emit("close"))}}).call(this,e("_process"),e("buffer").Buffer)},{_process:75,buffer:24,inherits:46,"mp4-box-encoding":58,"readable-stream":88}],61:[function(e,t,n){n.decode=e("./decode"),n.encode=e("./encode")},{"./decode":59,"./encode":60}],62:[function(e,t,n){function r(e){if(e=""+e,!(e.length>1e4)){var t=/^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(e);if(t){var n=parseFloat(t[1]),r=(t[2]||"ms").toLowerCase();switch(r){case"years":case"year":case"yrs":case"yr":case"y":return n*d;case"days":case"day":case"d":return n*f;case"hours":case"hour":case"hrs":case"hr":case"h":return n*c;case"minutes":case"minute":case"mins":case"min":case"m":return n*u;case"seconds":case"second":case"secs":case"sec":case"s":return n*a;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return n}}}}function o(e){return e>=f?Math.round(e/f)+"d":e>=c?Math.round(e/c)+"h":e>=u?Math.round(e/u)+"m":e>=a?Math.round(e/a)+"s":e+"ms"}function i(e){return s(e,f,"day")||s(e,c,"hour")||s(e,u,"minute")||s(e,a,"second")||e+" ms"}function s(e,t,n){return t>e?void 0:1.5*t>e?Math.floor(e/t)+" "+n:Math.ceil(e/t)+" "+n+"s"}var a=1e3,u=60*a,c=60*u,f=24*c,d=365.25*f;t.exports=function(e,t){return t=t||{},"string"==typeof e?r(e):t["long"]?i(e):o(e)}},{}],63:[function(e,t,n){function r(e,t){return this instanceof r?(s.Readable.call(this,t),this.destroyed=!1,this._drained=!1,this._forwarding=!1,this._current=null,this._queue="function"==typeof e?e:e.map(o),void this._next()):new r(e,t)}function o(e){if(!e||"function"==typeof e||e._readableState)return e;var t=(new s.Readable).wrap(e);return e.destroy&&(t.destroy=e.destroy.bind(e)),t}t.exports=r;var i=e("inherits"),s=e("readable-stream");i(r,s.Readable),r.obj=function(e){return new r(e,{objectMode:!0,highWaterMark:16})},r.prototype._read=function(){this._drained=!0,this._forward()},r.prototype._forward=function(){if(!this._forwarding&&this._drained&&this._current){this._forwarding=!0;for(var e;null!==(e=this._current.read());)this._drained=this.push(e);this._forwarding=!1}},r.prototype.destroy=function(e){this.destroyed||(this.destroyed=!0,this._current&&this._current.destroy&&this._current.destroy(),"function"!=typeof this._queue&&this._queue.forEach(function(e){e.destroy&&e.destroy()}),e&&this.emit("error",e),this.emit("close"))},r.prototype._next=function(){var e=this;if(e._current=null,"function"==typeof e._queue)e._queue(function(t,n){return t?e.destroy(t):void e._gotNextStream(o(n))});else{var t=e._queue.shift();"function"==typeof t&&(t=o(t())),e._gotNextStream(t)}},r.prototype._gotNextStream=function(e){function t(){i._forward()}function n(){e._readableState.ended||i.destroy()}function r(){i._current=null,e.removeListener("readable",t),e.removeListener("end",r),e.removeListener("error",o),e.removeListener("close",n),i._next()}function o(e){i.destroy(e)}var i=this;return e?(i._current=e,i._forward(),e.on("readable",t),e.on("end",r),e.on("error",o),void e.on("close",n)):(i.push(null),void i.destroy())}},{inherits:46,"readable-stream":88}],64:[function(e,t,n){function r(e,t){var n=null;return e.on(t,function(e){if(n){var t=n;n=null,t(e)}}),function(e){n=e}}t.exports=r},{}],65:[function(e,t,n){function r(e){var t=function(){return t.called?t.value:(t.called=!0,t.value=e.apply(this,arguments))};return t.called=!1,t}var o=e("wrappy");t.exports=o(r),r.proto=r(function(){Object.defineProperty(Function.prototype,"once",{value:function(){return r(this)},configurable:!0})})},{wrappy:124}],66:[function(e,t,n){(function(n){function r(e){n.isBuffer(e)&&(e=u.decode(e)),a(e.info,"info"),a(e.info["name.utf-8"]||e.info.name,"info.name"),a(e.info["piece length"],"info['piece length']"),a(e.info.pieces,"info.pieces"),e.info.files?e.info.files.forEach(function(e){a("number"==typeof e.length,"info.files[0].length"),a(e["path.utf-8"]||e.path,"info.files[0].path")}):a("number"==typeof e.info.length,"info.length");var t={};t.info=e.info,t.infoBuffer=u.encode(e.info),t.infoHash=f.sync(t.infoBuffer),t.infoHashBuffer=new n(t.infoHash,"hex"),t.name=(e.info["name.utf-8"]||e.info.name).toString(),void 0!==e.info["private"]&&(t["private"]=!!e.info["private"]),e["creation date"]&&(t.created=new Date(1e3*e["creation date"])),e["created by"]&&(t.createdBy=e["created by"].toString()),n.isBuffer(e.comment)&&(t.comment=e.comment.toString()),t.announce=[],e["announce-list"]&&e["announce-list"].length?e["announce-list"].forEach(function(e){e.forEach(function(e){t.announce.push(e.toString())})}):e.announce&&t.announce.push(e.announce.toString()),n.isBuffer(e["url-list"])&&(e["url-list"]=e["url-list"].length>0?[e["url-list"]]:[]),t.urlList=(e["url-list"]||[]).map(function(e){return e.toString()}),d(t.announce),d(t.urlList);var r=e.info.files||[e.info];t.files=r.map(function(e,n){var o=[].concat(t.name,e["path.utf-8"]||e.path||[]).map(function(e){return e.toString()});return{path:c.join.apply(null,[c.sep].concat(o)).slice(1),name:o[o.length-1],length:e.length,offset:r.slice(0,n).reduce(i,0)}}),t.length=r.reduce(i,0);var o=t.files[t.files.length-1];return t.pieceLength=e.info["piece length"],t.lastPieceLength=(o.offset+o.length)%t.pieceLength||t.pieceLength,t.pieces=s(e.info.pieces),t}function o(e){var t={info:e.info};return t["announce-list"]=(e.announce||[]).map(function(e){return t.announce||(t.announce=e),e=new n(e,"utf8"),[e]}),t["url-list"]=e.urlList||[],e.created&&(t["creation date"]=e.created.getTime()/1e3|0),e.createdBy&&(t["created by"]=e.createdBy),e.comment&&(t.comment=e.comment),u.encode(t)}function i(e,t){return e+t.length}function s(e){for(var t=[],n=0;n<e.length;n+=20)t.push(e.slice(n,n+20).toString("hex"));return t}function a(e,t){if(!e)throw new Error("Torrent is missing required field: "+t)}t.exports=r,t.exports.decode=r,t.exports.encode=o;var u=e("bencode"),c=e("path"),f=e("simple-sha1"),d=e("uniq")}).call(this,e("buffer").Buffer)},{bencode:67,buffer:24,path:72,"simple-sha1":98,uniq:116}],67:[function(e,t,n){arguments[4][30][0].apply(n,arguments)},{"./lib/decode":68,"./lib/encode":70,dup:30}],68:[function(e,t,n){arguments[4][31][0].apply(n,arguments)},{"./dict":69,buffer:24,dup:31}],69:[function(e,t,n){arguments[4][32][0].apply(n,arguments)},{dup:32}],70:[function(e,t,n){arguments[4][33][0].apply(n,arguments)},{buffer:24,dup:33}],71:[function(e,t,n){(function(n,r){function o(e){if("string"==typeof e&&/magnet:/.test(e))return f(e);if("string"==typeof e&&(/^[a-f0-9]{40}$/i.test(e)||/^[a-z2-7]{32}$/i.test(e)))return f("magnet:?xt=urn:btih:"+e);if(n.isBuffer(e)&&20===e.length)return f("magnet:?xt=urn:btih:"+e.toString("hex"));if(n.isBuffer(e))return d(e);if(e&&e.infoHash)return e.announce||(e.announce=[]),"string"==typeof e.announce&&(e.announce=[e.announce]),e.urlList||(e.urlList=[]),e;throw new Error("Invalid torrent identifier")}function i(e,t){function n(e){try{i=o(e)}catch(n){return t(n)}i&&i.infoHash?t(null,i):t(new Error("Invalid torrent identifier"))}var i;if("function"!=typeof t)throw new Error("second argument must be a Function");try{i=o(e)}catch(f){}i&&i.infoHash?r.nextTick(function(){t(null,i)}):s(e)?a(e,function(e,r){return e?t(new Error("Error converting Blob: "+e.message)):void n(r)}):"function"==typeof c&&/^https?:/.test(e)?c.concat({url:e,headers:{"user-agent":"WebTorrent (http://webtorrent.io)"}},function(e,r,o){return e?t(new Error("Error downloading torrent: "+e.message)):void n(o)}):"function"==typeof u.readFile&&"string"==typeof e?u.readFile(e,function(e,r){return e?t(new Error("Invalid torrent identifier")):void n(r)}):r.nextTick(function(){t(new Error("Invalid torrent identifier"))})}function s(e){return"undefined"!=typeof Blob&&e instanceof Blob}t.exports=o,t.exports.remote=i;var a=e("blob-to-buffer"),u=e("fs"),c=e("simple-get"),f=e("magnet-uri"),d=e("parse-torrent-file");t.exports.toMagnetURI=f.encode,t.exports.toTorrentFile=d.encode}).call(this,{isBuffer:e("../is-buffer/index.js")},e("_process"))},{"../is-buffer/index.js":48,_process:75,"blob-to-buffer":19,fs:22,"magnet-uri":53,"parse-torrent-file":66,"simple-get":96}],72:[function(e,t,n){(function(e){function t(e,t){for(var n=0,r=e.length-1;r>=0;r--){var o=e[r];"."===o?e.splice(r,1):".."===o?(e.splice(r,1),n++):n&&(e.splice(r,1),n--)}if(t)for(;n--;n)e.unshift("..");return e}function r(e,t){if(e.filter)return e.filter(t);for(var n=[],r=0;r<e.length;r++)t(e[r],r,e)&&n.push(e[r]);return n}var o=/^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/,i=function(e){return o.exec(e).slice(1)};n.resolve=function(){for(var n="",o=!1,i=arguments.length-1;i>=-1&&!o;i--){var s=i>=0?arguments[i]:e.cwd();if("string"!=typeof s)throw new TypeError("Arguments to path.resolve must be strings");s&&(n=s+"/"+n,o="/"===s.charAt(0))}return n=t(r(n.split("/"),function(e){return!!e}),!o).join("/"),(o?"/":"")+n||"."},n.normalize=function(e){var o=n.isAbsolute(e),i="/"===s(e,-1);return e=t(r(e.split("/"),function(e){return!!e}),!o).join("/"),e||o||(e="."),e&&i&&(e+="/"),(o?"/":"")+e},n.isAbsolute=function(e){return"/"===e.charAt(0)},n.join=function(){var e=Array.prototype.slice.call(arguments,0);return n.normalize(r(e,function(e,t){if("string"!=typeof e)throw new TypeError("Arguments to path.join must be strings");return e}).join("/"))},n.relative=function(e,t){function r(e){for(var t=0;t<e.length&&""===e[t];t++);for(var n=e.length-1;n>=0&&""===e[n];n--);return t>n?[]:e.slice(t,n-t+1)}e=n.resolve(e).substr(1),t=n.resolve(t).substr(1);for(var o=r(e.split("/")),i=r(t.split("/")),s=Math.min(o.length,i.length),a=s,u=0;s>u;u++)if(o[u]!==i[u]){a=u;break}for(var c=[],u=a;u<o.length;u++)c.push("..");return c=c.concat(i.slice(a)),c.join("/")},n.sep="/",n.delimiter=":",n.dirname=function(e){var t=i(e),n=t[0],r=t[1];return n||r?(r&&(r=r.substr(0,r.length-1)),n+r):"."},n.basename=function(e,t){var n=i(e)[2];return t&&n.substr(-1*t.length)===t&&(n=n.substr(0,n.length-t.length)),n},n.extname=function(e){return i(e)[3]};var s="b"==="ab".substr(-1)?function(e,t,n){return e.substr(t,n)}:function(e,t,n){return 0>t&&(t=e.length+t),e.substr(t,n)}}).call(this,e("_process"))},{_process:75}],73:[function(e,t,n){for(var r=e("closest-to"),o=[],i=14;22>=i;i++)o.push(Math.pow(2,i));t.exports=function(e){return r(e/Math.pow(2,10),o)}},{"closest-to":27}],74:[function(e,t,n){(function(e){"use strict";function n(t,n,r,o){if("function"!=typeof t)throw new TypeError('"callback" argument must be a function');var i,s,a=arguments.length;switch(a){case 0:case 1:return e.nextTick(t);case 2:return e.nextTick(function(){t.call(null,n)});case 3:return e.nextTick(function(){t.call(null,n,r)});case 4:return e.nextTick(function(){t.call(null,n,r,o)});default:for(i=new Array(a-1),s=0;s<i.length;)i[s++]=arguments[s];return e.nextTick(function(){t.apply(null,i)})}}!e.version||0===e.version.indexOf("v0.")||0===e.version.indexOf("v1.")&&0!==e.version.indexOf("v1.8.")?t.exports=n:t.exports=e.nextTick}).call(this,e("_process"))},{_process:75}],75:[function(e,t,n){function r(){h&&f&&(h=!1,f.length?d=f.concat(d):l=-1,d.length&&o())}function o(){if(!h){var e=a(r);h=!0;for(var t=d.length;t;){for(f=d,d=[];++l<t;)f&&f[l].run();l=-1,t=d.length}f=null,h=!1,u(e)}}function i(e,t){this.fun=e,this.array=t}function s(){}var a,u,c=t.exports={};!function(){try{a=setTimeout}catch(e){a=function(){throw new Error("setTimeout is not defined")}}try{u=clearTimeout}catch(e){u=function(){throw new Error("clearTimeout is not defined")}}}();var f,d=[],h=!1,l=-1;c.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new i(e,t)),1!==d.length||h||a(o,0)},i.prototype.run=function(){this.fun.apply(null,this.array)},c.title="browser",c.browser=!0,c.env={},c.argv=[],c.version="",c.versions={},c.on=s,c.addListener=s,c.once=s,c.off=s,c.removeListener=s,c.removeAllListeners=s,c.emit=s,c.binding=function(e){throw new Error("process.binding is not supported")},c.cwd=function(){return"/"},c.chdir=function(e){throw new Error("process.chdir is not supported")},c.umask=function(){return 0}},{}],76:[function(e,t,n){var r=e("once"),o=e("end-of-stream"),i=e("fs"),s=function(){},a=function(e){return"function"==typeof e},u=function(e){return(e instanceof(i.ReadStream||s)||e instanceof(i.WriteStream||s))&&a(e.close)},c=function(e){return e.setHeader&&a(e.abort)},f=function(e,t,n,i){i=r(i);var s=!1;e.on("close",function(){s=!0}),o(e,{readable:t,writable:n},function(e){return e?i(e):(s=!0,void i())});var f=!1;return function(t){return s||f?void 0:(f=!0,u(e)?e.close():c(e)?e.abort():a(e.destroy)?e.destroy():void i(t||new Error("stream was destroyed")))}},d=function(e){e()},h=function(e,t){return e.pipe(t)},l=function(){var e=Array.prototype.slice.call(arguments),t=a(e[e.length-1]||s)&&e.pop()||s;if(Array.isArray(e[0])&&(e=e[0]),e.length<2)throw new Error("pump requires two streams per minimum");var n,r=e.map(function(o,i){var s=i<e.length-1,a=i>0;return f(o,s,a,function(e){n||(n=e),e&&r.forEach(d),s||(r.forEach(d),t(n))})});return e.reduce(h)};t.exports=l},{"end-of-stream":37,fs:22,once:65}],77:[function(t,n,r){(function(t){!function(o){function i(e){throw new RangeError(P[e])}function s(e,t){for(var n=e.length,r=[];n--;)r[n]=t(e[n]);return r}function a(e,t){var n=e.split("@"),r="";n.length>1&&(r=n[0]+"@",e=n[1]),e=e.replace(U,".");var o=e.split("."),i=s(o,t).join(".");return r+i}function u(e){for(var t,n,r=[],o=0,i=e.length;i>o;)t=e.charCodeAt(o++),t>=55296&&56319>=t&&i>o?(n=e.charCodeAt(o++),56320==(64512&n)?r.push(((1023&t)<<10)+(1023&n)+65536):(r.push(t),o--)):r.push(t);return r}function c(e){return s(e,function(e){var t="";return e>65535&&(e-=65536,t+=j(e>>>10&1023|55296),e=56320|1023&e),t+=j(e)}).join("")}function f(e){return 10>e-48?e-22:26>e-65?e-65:26>e-97?e-97:k}function d(e,t){return e+22+75*(26>e)-((0!=t)<<5)}function h(e,t,n){var r=0;for(e=n?M(e/I):e>>1,e+=M(e/t);e>O*S>>1;r+=k)e=M(e/O);return M(r+(O+1)*e/(e+B))}function l(e){var t,n,r,o,s,a,u,d,l,p,m=[],g=e.length,y=0,_=T,v=A;for(n=e.lastIndexOf(C),0>n&&(n=0),r=0;n>r;++r)e.charCodeAt(r)>=128&&i("not-basic"),m.push(e.charCodeAt(r));for(o=n>0?n+1:0;g>o;){for(s=y,a=1,u=k;o>=g&&i("invalid-input"),d=f(e.charCodeAt(o++)),(d>=k||d>M((E-y)/a))&&i("overflow"),y+=d*a,l=v>=u?x:u>=v+S?S:u-v,!(l>d);u+=k)p=k-l,a>M(E/p)&&i("overflow"),a*=p;t=m.length+1,v=h(y-s,t,0==s),M(y/t)>E-_&&i("overflow"),_+=M(y/t),y%=t,m.splice(y++,0,_)}return c(m)}function p(e){var t,n,r,o,s,a,c,f,l,p,m,g,y,_,v,b=[];for(e=u(e),g=e.length,t=T,n=0,s=A,a=0;g>a;++a)m=e[a],128>m&&b.push(j(m));for(r=o=b.length,o&&b.push(C);g>r;){for(c=E,a=0;g>a;++a)m=e[a],m>=t&&c>m&&(c=m);for(y=r+1,c-t>M((E-n)/y)&&i("overflow"),n+=(c-t)*y,t=c,a=0;g>a;++a)if(m=e[a],t>m&&++n>E&&i("overflow"),m==t){for(f=n,l=k;p=s>=l?x:l>=s+S?S:l-s,!(p>f);l+=k)v=f-p,_=k-p,b.push(j(d(p+v%_,0))),f=M(v/_);b.push(j(d(f,0))),s=h(n,y,r==o),n=0,++r}++n,++t}return b.join("")}function m(e){return a(e,function(e){return L.test(e)?l(e.slice(4).toLowerCase()):e})}function g(e){return a(e,function(e){return R.test(e)?"xn--"+p(e):e})}var y="object"==typeof r&&r&&!r.nodeType&&r,_="object"==typeof n&&n&&!n.nodeType&&n,v="object"==typeof t&&t;v.global!==v&&v.window!==v&&v.self!==v||(o=v);var b,w,E=2147483647,k=36,x=1,S=26,B=38,I=700,A=72,T=128,C="-",L=/^xn--/,R=/[^\x20-\x7E]/,U=/[\x2E\u3002\uFF0E\uFF61]/g,P={overflow:"Overflow: input needs wider integers to process","not-basic":"Illegal input >= 0x80 (not a basic code point)","invalid-input":"Invalid input"},O=k-x,M=Math.floor,j=String.fromCharCode;if(b={version:"1.4.1",ucs2:{decode:u,encode:c},decode:l,encode:p,toASCII:g,toUnicode:m},"function"==typeof e&&"object"==typeof e.amd&&e.amd)e("punycode",function(){return b});else if(y&&_)if(n.exports==y)_.exports=b;else for(w in b)b.hasOwnProperty(w)&&(y[w]=b[w]);else o.punycode=b}(this)}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],78:[function(e,t,n){"use strict";function r(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.exports=function(e,t,n,i){t=t||"&",n=n||"=";var s={};if("string"!=typeof e||0===e.length)return s;var a=/\+/g;e=e.split(t);var u=1e3;i&&"number"==typeof i.maxKeys&&(u=i.maxKeys);var c=e.length;u>0&&c>u&&(c=u);for(var f=0;c>f;++f){
	var d,h,l,p,m=e[f].replace(a,"%20"),g=m.indexOf(n);g>=0?(d=m.substr(0,g),h=m.substr(g+1)):(d=m,h=""),l=decodeURIComponent(d),p=decodeURIComponent(h),r(s,l)?o(s[l])?s[l].push(p):s[l]=[s[l],p]:s[l]=p}return s};var o=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)}},{}],79:[function(e,t,n){"use strict";function r(e,t){if(e.map)return e.map(t);for(var n=[],r=0;r<e.length;r++)n.push(t(e[r],r));return n}var o=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};t.exports=function(e,t,n,a){return t=t||"&",n=n||"=",null===e&&(e=void 0),"object"==typeof e?r(s(e),function(s){var a=encodeURIComponent(o(s))+n;return i(e[s])?r(e[s],function(e){return a+encodeURIComponent(o(e))}).join(t):a+encodeURIComponent(o(e[s]))}).join(t):a?encodeURIComponent(o(a))+n+encodeURIComponent(o(e)):""};var i=Array.isArray||function(e){return"[object Array]"===Object.prototype.toString.call(e)},s=Object.keys||function(e){var t=[];for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&t.push(n);return t}},{}],80:[function(e,t,n){"use strict";n.decode=n.parse=e("./decode"),n.encode=n.stringify=e("./encode")},{"./decode":78,"./encode":79}],81:[function(e,t,n){var r=function(e){var t=0;return function(){if(t===e.length)return null;var n=e.length-t,r=Math.random()*n|0,o=e[t+r],i=e[t];return e[t]=o,e[t+r]=i,t++,o}};t.exports=r},{}],82:[function(e,t,n){function r(e){var t=this;return t instanceof r?(i.Writable.call(t),t.destroyed=!1,t._queue=[],t._position=e||0,t._cb=null,t._buffer=null,void(t._out=null)):new r(e)}var o=e("inherits"),i=e("readable-stream");t.exports=r,o(r,i.Writable),r.prototype._write=function(e,t,n){for(var r=this,o=!0;;){if(r.destroyed)return;if(0===r._queue.length)return r._buffer=e,void(r._cb=n);r._buffer=null;var i=r._queue[0],s=Math.max(i.start-r._position,0),a=i.end-r._position;if(s>=e.length)return r._position+=e.length,n(null);var u;if(a>e.length){r._position+=e.length,u=0===s?e:e.slice(s),o=i.stream.write(u)&&o;break}r._position+=a,u=0===s&&a===e.length?e:e.slice(s,a),o=i.stream.write(u)&&o,i.last&&i.stream.end(),e=e.slice(a),r._queue.shift()}o?n(null):i.stream.once("drain",n.bind(null,null))},r.prototype.slice=function(e){var t=this;if(t.destroyed)return null;e instanceof Array||(e=[e]);var n=new i.PassThrough;return e.forEach(function(r,o){t._queue.push({start:r.start,end:r.end,stream:n,last:o===e.length-1})}),t._buffer&&t._write(t._buffer,null,t._cb),n},r.prototype.destroy=function(e){var t=this;t.destroyed||(t.destroyed=!0,e&&t.emit("error",e))}},{inherits:46,"readable-stream":88}],83:[function(e,t,n){"use strict";function r(e){return this instanceof r?(c.call(this,e),f.call(this,e),e&&e.readable===!1&&(this.readable=!1),e&&e.writable===!1&&(this.writable=!1),this.allowHalfOpen=!0,e&&e.allowHalfOpen===!1&&(this.allowHalfOpen=!1),void this.once("end",o)):new r(e)}function o(){this.allowHalfOpen||this._writableState.ended||a(i,this)}function i(e){e.end()}var s=Object.keys||function(e){var t=[];for(var n in e)t.push(n);return t};t.exports=r;var a=e("process-nextick-args"),u=e("core-util-is");u.inherits=e("inherits");var c=e("./_stream_readable"),f=e("./_stream_writable");u.inherits(r,c);for(var d=s(f.prototype),h=0;h<d.length;h++){var l=d[h];r.prototype[l]||(r.prototype[l]=f.prototype[l])}},{"./_stream_readable":85,"./_stream_writable":87,"core-util-is":28,inherits:46,"process-nextick-args":74}],84:[function(e,t,n){"use strict";function r(e){return this instanceof r?void o.call(this,e):new r(e)}t.exports=r;var o=e("./_stream_transform"),i=e("core-util-is");i.inherits=e("inherits"),i.inherits(r,o),r.prototype._transform=function(e,t,n){n(null,e)}},{"./_stream_transform":86,"core-util-is":28,inherits:46}],85:[function(e,t,n){(function(n){"use strict";function r(e,t,n){return H?e.prependListener(t,n):void(e._events&&e._events[t]?I(e._events[t])?e._events[t].unshift(n):e._events[t]=[n,e._events[t]]:e.on(t,n))}function o(t,n){j=j||e("./_stream_duplex"),t=t||{},this.objectMode=!!t.objectMode,n instanceof j&&(this.objectMode=this.objectMode||!!t.readableObjectMode);var r=t.highWaterMark,o=this.objectMode?16:16384;this.highWaterMark=r||0===r?r:o,this.highWaterMark=~~this.highWaterMark,this.buffer=[],this.length=0,this.pipes=null,this.pipesCount=0,this.flowing=null,this.ended=!1,this.endEmitted=!1,this.reading=!1,this.sync=!0,this.needReadable=!1,this.emittedReadable=!1,this.readableListening=!1,this.resumeScheduled=!1,this.defaultEncoding=t.defaultEncoding||"utf8",this.ranOut=!1,this.awaitDrain=0,this.readingMore=!1,this.decoder=null,this.encoding=null,t.encoding&&(M||(M=e("string_decoder/").StringDecoder),this.decoder=new M(t.encoding),this.encoding=t.encoding)}function i(t){return j=j||e("./_stream_duplex"),this instanceof i?(this._readableState=new o(t,this),this.readable=!0,t&&"function"==typeof t.read&&(this._read=t.read),void A.call(this)):new i(t)}function s(e,t,n,r,o){var i=f(t,n);if(i)e.emit("error",i);else if(null===n)t.reading=!1,d(e,t);else if(t.objectMode||n&&n.length>0)if(t.ended&&!o){var s=new Error("stream.push() after EOF");e.emit("error",s)}else if(t.endEmitted&&o){var u=new Error("stream.unshift() after end event");e.emit("error",u)}else{var c;!t.decoder||o||r||(n=t.decoder.write(n),c=!t.objectMode&&0===n.length),o||(t.reading=!1),c||(t.flowing&&0===t.length&&!t.sync?(e.emit("data",n),e.read(0)):(t.length+=t.objectMode?1:n.length,o?t.buffer.unshift(n):t.buffer.push(n),t.needReadable&&h(e))),p(e,t)}else o||(t.reading=!1);return a(t)}function a(e){return!e.ended&&(e.needReadable||e.length<e.highWaterMark||0===e.length)}function u(e){return e>=D?e=D:(e--,e|=e>>>1,e|=e>>>2,e|=e>>>4,e|=e>>>8,e|=e>>>16,e++),e}function c(e,t){return 0===t.length&&t.ended?0:t.objectMode?0===e?0:1:null===e||isNaN(e)?t.flowing&&t.buffer.length?t.buffer[0].length:t.length:0>=e?0:(e>t.highWaterMark&&(t.highWaterMark=u(e)),e>t.length?t.ended?t.length:(t.needReadable=!0,0):e)}function f(e,t){var n=null;return L.isBuffer(t)||"string"==typeof t||null===t||void 0===t||e.objectMode||(n=new TypeError("Invalid non-string/buffer chunk")),n}function d(e,t){if(!t.ended){if(t.decoder){var n=t.decoder.end();n&&n.length&&(t.buffer.push(n),t.length+=t.objectMode?1:n.length)}t.ended=!0,h(e)}}function h(e){var t=e._readableState;t.needReadable=!1,t.emittedReadable||(O("emitReadable",t.flowing),t.emittedReadable=!0,t.sync?B(l,e):l(e))}function l(e){O("emit readable"),e.emit("readable"),b(e)}function p(e,t){t.readingMore||(t.readingMore=!0,B(m,e,t))}function m(e,t){for(var n=t.length;!t.reading&&!t.flowing&&!t.ended&&t.length<t.highWaterMark&&(O("maybeReadMore read 0"),e.read(0),n!==t.length);)n=t.length;t.readingMore=!1}function g(e){return function(){var t=e._readableState;O("pipeOnDrain",t.awaitDrain),t.awaitDrain&&t.awaitDrain--,0===t.awaitDrain&&C(e,"data")&&(t.flowing=!0,b(e))}}function y(e){O("readable nexttick read 0"),e.read(0)}function _(e,t){t.resumeScheduled||(t.resumeScheduled=!0,B(v,e,t))}function v(e,t){t.reading||(O("resume read 0"),e.read(0)),t.resumeScheduled=!1,e.emit("resume"),b(e),t.flowing&&!t.reading&&e.read(0)}function b(e){var t=e._readableState;if(O("flow",t.flowing),t.flowing)do var n=e.read();while(null!==n&&t.flowing)}function w(e,t){var n,r=t.buffer,o=t.length,i=!!t.decoder,s=!!t.objectMode;if(0===r.length)return null;if(0===o)n=null;else if(s)n=r.shift();else if(!e||e>=o)n=i?r.join(""):1===r.length?r[0]:L.concat(r,o),r.length=0;else if(e<r[0].length){var a=r[0];n=a.slice(0,e),r[0]=a.slice(e)}else if(e===r[0].length)n=r.shift();else{n=i?"":R.allocUnsafe(e);for(var u=0,c=0,f=r.length;f>c&&e>u;c++){var d=r[0],h=Math.min(e-u,d.length);i?n+=d.slice(0,h):d.copy(n,u,0,h),h<d.length?r[0]=d.slice(h):r.shift(),u+=h}}return n}function E(e){var t=e._readableState;if(t.length>0)throw new Error('"endReadable()" called on non-empty stream');t.endEmitted||(t.ended=!0,B(k,t,e))}function k(e,t){e.endEmitted||0!==e.length||(e.endEmitted=!0,t.readable=!1,t.emit("end"))}function x(e,t){for(var n=0,r=e.length;r>n;n++)t(e[n],n)}function S(e,t){for(var n=0,r=e.length;r>n;n++)if(e[n]===t)return n;return-1}t.exports=i;var B=e("process-nextick-args"),I=e("isarray");i.ReadableState=o;var A,T=e("events").EventEmitter,C=function(e,t){return e.listeners(t).length};!function(){try{A=e("stream")}catch(t){}finally{A||(A=e("events").EventEmitter)}}();var L=e("buffer").Buffer,R=e("buffer-shims"),U=e("core-util-is");U.inherits=e("inherits");var P=e("util"),O=void 0;O=P&&P.debuglog?P.debuglog("stream"):function(){};var M;U.inherits(i,A);var j,j,H="function"==typeof T.prototype.prependListener;i.prototype.push=function(e,t){var n=this._readableState;return n.objectMode||"string"!=typeof e||(t=t||n.defaultEncoding,t!==n.encoding&&(e=R.from(e,t),t="")),s(this,n,e,t,!1)},i.prototype.unshift=function(e){var t=this._readableState;return s(this,t,e,"",!0)},i.prototype.isPaused=function(){return this._readableState.flowing===!1},i.prototype.setEncoding=function(t){return M||(M=e("string_decoder/").StringDecoder),this._readableState.decoder=new M(t),this._readableState.encoding=t,this};var D=8388608;i.prototype.read=function(e){O("read",e);var t=this._readableState,n=e;if(("number"!=typeof e||e>0)&&(t.emittedReadable=!1),0===e&&t.needReadable&&(t.length>=t.highWaterMark||t.ended))return O("read: emitReadable",t.length,t.ended),0===t.length&&t.ended?E(this):h(this),null;if(e=c(e,t),0===e&&t.ended)return 0===t.length&&E(this),null;var r=t.needReadable;O("need readable",r),(0===t.length||t.length-e<t.highWaterMark)&&(r=!0,O("length less than watermark",r)),(t.ended||t.reading)&&(r=!1,O("reading or ended",r)),r&&(O("do read"),t.reading=!0,t.sync=!0,0===t.length&&(t.needReadable=!0),this._read(t.highWaterMark),t.sync=!1),r&&!t.reading&&(e=c(n,t));var o;return o=e>0?w(e,t):null,null===o&&(t.needReadable=!0,e=0),t.length-=e,0!==t.length||t.ended||(t.needReadable=!0),n!==e&&t.ended&&0===t.length&&E(this),null!==o&&this.emit("data",o),o},i.prototype._read=function(e){this.emit("error",new Error("not implemented"))},i.prototype.pipe=function(e,t){function o(e){O("onunpipe"),e===h&&s()}function i(){O("onend"),e.end()}function s(){O("cleanup"),e.removeListener("close",c),e.removeListener("finish",f),e.removeListener("drain",y),e.removeListener("error",u),e.removeListener("unpipe",o),h.removeListener("end",i),h.removeListener("end",s),h.removeListener("data",a),_=!0,!l.awaitDrain||e._writableState&&!e._writableState.needDrain||y()}function a(t){O("ondata");var n=e.write(t);!1===n&&((1===l.pipesCount&&l.pipes===e||l.pipesCount>1&&-1!==S(l.pipes,e))&&!_&&(O("false write response, pause",h._readableState.awaitDrain),h._readableState.awaitDrain++),h.pause())}function u(t){O("onerror",t),d(),e.removeListener("error",u),0===C(e,"error")&&e.emit("error",t)}function c(){e.removeListener("finish",f),d()}function f(){O("onfinish"),e.removeListener("close",c),d()}function d(){O("unpipe"),h.unpipe(e)}var h=this,l=this._readableState;switch(l.pipesCount){case 0:l.pipes=e;break;case 1:l.pipes=[l.pipes,e];break;default:l.pipes.push(e)}l.pipesCount+=1,O("pipe count=%d opts=%j",l.pipesCount,t);var p=(!t||t.end!==!1)&&e!==n.stdout&&e!==n.stderr,m=p?i:s;l.endEmitted?B(m):h.once("end",m),e.on("unpipe",o);var y=g(h);e.on("drain",y);var _=!1;return h.on("data",a),r(e,"error",u),e.once("close",c),e.once("finish",f),e.emit("pipe",h),l.flowing||(O("pipe resume"),h.resume()),e},i.prototype.unpipe=function(e){var t=this._readableState;if(0===t.pipesCount)return this;if(1===t.pipesCount)return e&&e!==t.pipes?this:(e||(e=t.pipes),t.pipes=null,t.pipesCount=0,t.flowing=!1,e&&e.emit("unpipe",this),this);if(!e){var n=t.pipes,r=t.pipesCount;t.pipes=null,t.pipesCount=0,t.flowing=!1;for(var o=0;r>o;o++)n[o].emit("unpipe",this);return this}var i=S(t.pipes,e);return-1===i?this:(t.pipes.splice(i,1),t.pipesCount-=1,1===t.pipesCount&&(t.pipes=t.pipes[0]),e.emit("unpipe",this),this)},i.prototype.on=function(e,t){var n=A.prototype.on.call(this,e,t);if("data"===e&&!1!==this._readableState.flowing&&this.resume(),"readable"===e&&!this._readableState.endEmitted){var r=this._readableState;r.readableListening||(r.readableListening=!0,r.emittedReadable=!1,r.needReadable=!0,r.reading?r.length&&h(this,r):B(y,this))}return n},i.prototype.addListener=i.prototype.on,i.prototype.resume=function(){var e=this._readableState;return e.flowing||(O("resume"),e.flowing=!0,_(this,e)),this},i.prototype.pause=function(){return O("call pause flowing=%j",this._readableState.flowing),!1!==this._readableState.flowing&&(O("pause"),this._readableState.flowing=!1,this.emit("pause")),this},i.prototype.wrap=function(e){var t=this._readableState,n=!1,r=this;e.on("end",function(){if(O("wrapped end"),t.decoder&&!t.ended){var e=t.decoder.end();e&&e.length&&r.push(e)}r.push(null)}),e.on("data",function(o){if(O("wrapped data"),t.decoder&&(o=t.decoder.write(o)),(!t.objectMode||null!==o&&void 0!==o)&&(t.objectMode||o&&o.length)){var i=r.push(o);i||(n=!0,e.pause())}});for(var o in e)void 0===this[o]&&"function"==typeof e[o]&&(this[o]=function(t){return function(){return e[t].apply(e,arguments)}}(o));var i=["error","close","destroy","pause","resume"];return x(i,function(t){e.on(t,r.emit.bind(r,t))}),r._read=function(t){O("wrapped _read",t),n&&(n=!1,e.resume())},r},i._fromList=w}).call(this,e("_process"))},{"./_stream_duplex":83,_process:75,buffer:24,"buffer-shims":23,"core-util-is":28,events:38,inherits:46,isarray:51,"process-nextick-args":74,"string_decoder/":108,util:21}],86:[function(e,t,n){"use strict";function r(e){this.afterTransform=function(t,n){return o(e,t,n)},this.needTransform=!1,this.transforming=!1,this.writecb=null,this.writechunk=null,this.writeencoding=null}function o(e,t,n){var r=e._transformState;r.transforming=!1;var o=r.writecb;if(!o)return e.emit("error",new Error("no writecb in Transform class"));r.writechunk=null,r.writecb=null,null!==n&&void 0!==n&&e.push(n),o(t);var i=e._readableState;i.reading=!1,(i.needReadable||i.length<i.highWaterMark)&&e._read(i.highWaterMark)}function i(e){if(!(this instanceof i))return new i(e);a.call(this,e),this._transformState=new r(this);var t=this;this._readableState.needReadable=!0,this._readableState.sync=!1,e&&("function"==typeof e.transform&&(this._transform=e.transform),"function"==typeof e.flush&&(this._flush=e.flush)),this.once("prefinish",function(){"function"==typeof this._flush?this._flush(function(e){s(t,e)}):s(t)})}function s(e,t){if(t)return e.emit("error",t);var n=e._writableState,r=e._transformState;if(n.length)throw new Error("Calling transform done when ws.length != 0");if(r.transforming)throw new Error("Calling transform done when still transforming");return e.push(null)}t.exports=i;var a=e("./_stream_duplex"),u=e("core-util-is");u.inherits=e("inherits"),u.inherits(i,a),i.prototype.push=function(e,t){return this._transformState.needTransform=!1,a.prototype.push.call(this,e,t)},i.prototype._transform=function(e,t,n){throw new Error("Not implemented")},i.prototype._write=function(e,t,n){var r=this._transformState;if(r.writecb=n,r.writechunk=e,r.writeencoding=t,!r.transforming){var o=this._readableState;(r.needTransform||o.needReadable||o.length<o.highWaterMark)&&this._read(o.highWaterMark)}},i.prototype._read=function(e){var t=this._transformState;null!==t.writechunk&&t.writecb&&!t.transforming?(t.transforming=!0,this._transform(t.writechunk,t.writeencoding,t.afterTransform)):t.needTransform=!0}},{"./_stream_duplex":83,"core-util-is":28,inherits:46}],87:[function(e,t,n){(function(n){"use strict";function r(){}function o(e,t,n){this.chunk=e,this.encoding=t,this.callback=n,this.next=null}function i(t,n){C=C||e("./_stream_duplex"),t=t||{},this.objectMode=!!t.objectMode,n instanceof C&&(this.objectMode=this.objectMode||!!t.writableObjectMode);var r=t.highWaterMark,o=this.objectMode?16:16384;this.highWaterMark=r||0===r?r:o,this.highWaterMark=~~this.highWaterMark,this.needDrain=!1,this.ending=!1,this.ended=!1,this.finished=!1;var i=t.decodeStrings===!1;this.decodeStrings=!i,this.defaultEncoding=t.defaultEncoding||"utf8",this.length=0,this.writing=!1,this.corked=0,this.sync=!0,this.bufferProcessing=!1,this.onwrite=function(e){p(n,e)},this.writecb=null,this.writelen=0,this.bufferedRequest=null,this.lastBufferedRequest=null,this.pendingcb=0,this.prefinished=!1,this.errorEmitted=!1,this.bufferedRequestCount=0,this.corkedRequestsFree=new E(this)}function s(t){return C=C||e("./_stream_duplex"),this instanceof s||this instanceof C?(this._writableState=new i(t,this),this.writable=!0,t&&("function"==typeof t.write&&(this._write=t.write),"function"==typeof t.writev&&(this._writev=t.writev)),void B.call(this)):new s(t)}function a(e,t){var n=new Error("write after end");e.emit("error",n),k(t,n)}function u(e,t,n,r){var o=!0,i=!1;return null===n?i=new TypeError("May not write null values to stream"):A.isBuffer(n)||"string"==typeof n||void 0===n||t.objectMode||(i=new TypeError("Invalid non-string/buffer chunk")),i&&(e.emit("error",i),k(r,i),o=!1),o}function c(e,t,n){return e.objectMode||e.decodeStrings===!1||"string"!=typeof t||(t=T.from(t,n)),t}function f(e,t,n,r,i){n=c(t,n,r),A.isBuffer(n)&&(r="buffer");var s=t.objectMode?1:n.length;t.length+=s;var a=t.length<t.highWaterMark;if(a||(t.needDrain=!0),t.writing||t.corked){var u=t.lastBufferedRequest;t.lastBufferedRequest=new o(n,r,i),u?u.next=t.lastBufferedRequest:t.bufferedRequest=t.lastBufferedRequest,t.bufferedRequestCount+=1}else d(e,t,!1,s,n,r,i);return a}function d(e,t,n,r,o,i,s){t.writelen=r,t.writecb=s,t.writing=!0,t.sync=!0,n?e._writev(o,t.onwrite):e._write(o,i,t.onwrite),t.sync=!1}function h(e,t,n,r,o){--t.pendingcb,n?k(o,r):o(r),e._writableState.errorEmitted=!0,e.emit("error",r)}function l(e){e.writing=!1,e.writecb=null,e.length-=e.writelen,e.writelen=0}function p(e,t){var n=e._writableState,r=n.sync,o=n.writecb;if(l(n),t)h(e,n,r,t,o);else{var i=_(n);i||n.corked||n.bufferProcessing||!n.bufferedRequest||y(e,n),r?x(m,e,n,i,o):m(e,n,i,o)}}function m(e,t,n,r){n||g(e,t),t.pendingcb--,r(),b(e,t)}function g(e,t){0===t.length&&t.needDrain&&(t.needDrain=!1,e.emit("drain"))}function y(e,t){t.bufferProcessing=!0;var n=t.bufferedRequest;if(e._writev&&n&&n.next){var r=t.bufferedRequestCount,o=new Array(r),i=t.corkedRequestsFree;i.entry=n;for(var s=0;n;)o[s]=n,n=n.next,s+=1;d(e,t,!0,t.length,o,"",i.finish),t.pendingcb++,t.lastBufferedRequest=null,i.next?(t.corkedRequestsFree=i.next,i.next=null):t.corkedRequestsFree=new E(t)}else{for(;n;){var a=n.chunk,u=n.encoding,c=n.callback,f=t.objectMode?1:a.length;if(d(e,t,!1,f,a,u,c),n=n.next,t.writing)break}null===n&&(t.lastBufferedRequest=null)}t.bufferedRequestCount=0,t.bufferedRequest=n,t.bufferProcessing=!1}function _(e){return e.ending&&0===e.length&&null===e.bufferedRequest&&!e.finished&&!e.writing}function v(e,t){t.prefinished||(t.prefinished=!0,e.emit("prefinish"))}function b(e,t){var n=_(t);return n&&(0===t.pendingcb?(v(e,t),t.finished=!0,e.emit("finish")):v(e,t)),n}function w(e,t,n){t.ending=!0,b(e,t),n&&(t.finished?k(n):e.once("finish",n)),t.ended=!0,e.writable=!1}function E(e){var t=this;this.next=null,this.entry=null,this.finish=function(n){var r=t.entry;for(t.entry=null;r;){var o=r.callback;e.pendingcb--,o(n),r=r.next}e.corkedRequestsFree?e.corkedRequestsFree.next=t:e.corkedRequestsFree=t}}t.exports=s;var k=e("process-nextick-args"),x=!n.browser&&["v0.10","v0.9."].indexOf(n.version.slice(0,5))>-1?setImmediate:k;s.WritableState=i;var S=e("core-util-is");S.inherits=e("inherits");var B,I={deprecate:e("util-deprecate")};!function(){try{B=e("stream")}catch(t){}finally{B||(B=e("events").EventEmitter)}}();var A=e("buffer").Buffer,T=e("buffer-shims");S.inherits(s,B);var C;i.prototype.getBuffer=function(){for(var e=this.bufferedRequest,t=[];e;)t.push(e),e=e.next;return t},function(){try{Object.defineProperty(i.prototype,"buffer",{get:I.deprecate(function(){return this.getBuffer()},"_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")})}catch(e){}}();var C;s.prototype.pipe=function(){this.emit("error",new Error("Cannot pipe, not readable"))},s.prototype.write=function(e,t,n){var o=this._writableState,i=!1;return"function"==typeof t&&(n=t,t=null),A.isBuffer(e)?t="buffer":t||(t=o.defaultEncoding),"function"!=typeof n&&(n=r),o.ended?a(this,n):u(this,o,e,n)&&(o.pendingcb++,i=f(this,o,e,t,n)),i},s.prototype.cork=function(){var e=this._writableState;e.corked++},s.prototype.uncork=function(){var e=this._writableState;e.corked&&(e.corked--,e.writing||e.corked||e.finished||e.bufferProcessing||!e.bufferedRequest||y(this,e))},s.prototype.setDefaultEncoding=function(e){if("string"==typeof e&&(e=e.toLowerCase()),!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new TypeError("Unknown encoding: "+e);return this._writableState.defaultEncoding=e,this},s.prototype._write=function(e,t,n){n(new Error("not implemented"))},s.prototype._writev=null,s.prototype.end=function(e,t,n){var r=this._writableState;"function"==typeof e?(n=e,e=null,t=null):"function"==typeof t&&(n=t,t=null),null!==e&&void 0!==e&&this.write(e,t),r.corked&&(r.corked=1,this.uncork()),r.ending||r.finished||w(this,r,n)}}).call(this,e("_process"))},{"./_stream_duplex":83,_process:75,buffer:24,"buffer-shims":23,"core-util-is":28,events:38,inherits:46,"process-nextick-args":74,"util-deprecate":121}],88:[function(e,t,n){(function(r){var o=function(){try{return e("stream")}catch(t){}}();n=t.exports=e("./lib/_stream_readable.js"),n.Stream=o||n,n.Readable=n,n.Writable=e("./lib/_stream_writable.js"),n.Duplex=e("./lib/_stream_duplex.js"),n.Transform=e("./lib/_stream_transform.js"),n.PassThrough=e("./lib/_stream_passthrough.js"),!r.browser&&"disable"===r.env.READABLE_STREAM&&o&&(t.exports=o)}).call(this,e("_process"))},{"./lib/_stream_duplex.js":83,"./lib/_stream_passthrough.js":84,"./lib/_stream_readable.js":85,"./lib/_stream_transform.js":86,"./lib/_stream_writable.js":87,_process:75}],89:[function(e,t,n){function r(e,t,n){a(e),"string"==typeof t&&(t=document.querySelector(t)),i(e,function(n){if(t.nodeName!==n.toUpperCase()){var r=l.extname(e.name).toLowerCase();throw new Error('Cannot render "'+r+'" inside a "'+t.nodeName.toLowerCase()+'" element, expected "'+n+'"')}return t},n)}function o(e,t,n){function r(e){var n=o(e);return n.controls=!0,n.autoplay=!0,t.appendChild(n),n}function o(e){var n=document.createElement(e);return t.appendChild(n),n}if(n||(n=function(){}),a(e),"string"==typeof t&&(t=document.querySelector(t)),t&&("VIDEO"===t.nodeName||"AUDIO"===t.nodeName))throw new Error("Invalid video/audio node argument. Argument must be root element that video/audio tag will be appended to.");i(e,function(e){return"video"===e||"audio"===e?r(e):o(e)},function(e,t){e&&t&&t.remove(),n(e,t)})}function i(e,t,n){function r(){function n(){f("Use `videostream` package for "+e.name),l(),S.addEventListener("error",c),S.addEventListener("loadstart",i),S.addEventListener("canplay",a),m(e,S)}function r(){f("Use MediaSource API for "+e.name),l(),S.addEventListener("error",d),S.addEventListener("loadstart",i),S.addEventListener("canplay",a);var t=new h(S),n=t.createWriteStream(u(e.name));e.createReadStream().pipe(n),I&&(S.currentTime=I)}function o(){f("Use Blob URL for "+e.name),l(),S.addEventListener("error",x),S.addEventListener("loadstart",i),S.addEventListener("canplay",a),s(e,function(e,t){return e?x(e):(S.src=t,void(I&&(S.currentTime=I)))})}function c(e){f("videostream error: fallback to MediaSource API: %o",e.message||e),S.removeEventListener("error",c),S.removeEventListener("canplay",a),r()}function d(e){f("MediaSource API error: fallback to Blob URL: %o",e.message||e),S.removeEventListener("error",d),S.removeEventListener("canplay",a),o()}function l(){S||(S=t(p),S.addEventListener("progress",function(){I=S.currentTime}))}var p=y.indexOf(B)>=0?"video":"audio";k?g.indexOf(B)>=0?n():r():o()}function o(){S=t("audio"),s(e,function(e,t){return e?x(e):(S.addEventListener("error",x),S.addEventListener("loadstart",i),S.addEventListener("canplay",a),void(S.src=t))})}function i(){S.removeEventListener("loadstart",i),S.play()}function a(){S.removeEventListener("canplay",a),n(null,S)}function c(){S=t("img"),s(e,function(t,r){return t?x(t):(S.src=r,S.alt=e.name,void n(null,S))})}function p(){S=t("iframe"),s(e,function(e,t){return e?x(e):(S.src=t,".pdf"!==B&&(S.sandbox="allow-forms allow-scripts"),void n(null,S))})}function _(){function t(){d(r)?(f('File extension "%s" appears ascii, so will render.',B),p()):(f('File extension "%s" appears non-ascii, will not render.',B),n(new Error('Unsupported file type "'+B+'": Cannot append to DOM')))}f('Unknown file extension "%s" - will attempt to render into iframe',B);var r="";e.createReadStream({start:0,end:1e3}).setEncoding("utf8").on("data",function(e){r+=e}).on("end",t).on("error",n)}function x(t){t.message='Error rendering file "'+e.name+'": '+t.message,f(t.message),n(t)}n||(n=function(){});var S,B=l.extname(e.name).toLowerCase(),I=0;v.indexOf(B)>=0?r():b.indexOf(B)>=0?o():w.indexOf(B)>=0?c():E.indexOf(B)>=0?p():_()}function s(e,t){var n=l.extname(e.name).toLowerCase();p(e.createReadStream(),c[n],t)}function a(e){if(null==e)throw new Error("file cannot be null or undefined");if("string"!=typeof e.name)throw new Error("missing or invalid file.name property");if("function"!=typeof e.createReadStream)throw new Error("missing or invalid file.createReadStream property")}function u(e){var t=l.extname(e).toLowerCase();return{".m4a":'audio/mp4; codecs="mp4a.40.5"',".m4v":'video/mp4; codecs="avc1.640029, mp4a.40.5"',".mkv":'video/webm; codecs="avc1.640029, mp4a.40.5"',".mp3":"audio/mpeg",".mp4":'video/mp4; codecs="avc1.640029, mp4a.40.5"',".webm":'video/webm; codecs="vorbis, vp8"'}[t]}n.render=r,n.append=o;var c=n.mime=e("./lib/mime.json"),f=e("debug")("render-media"),d=e("is-ascii"),h=e("mediasource"),l=e("path"),p=e("stream-to-blob-url"),m=e("videostream"),g=[".mp4",".m4v",".m4a"],y=[".mp4",".m4v",".webm",".mkv"],_=[".m4a",".mp3"],v=y.concat(_),b=[".wav",".aac",".ogg",".oga"],w=[".jpg",".jpeg",".png",".gif",".bmp"],E=[".css",".html",".js",".md",".pdf",".txt"],k="undefined"!=typeof window&&window.MediaSource},{"./lib/mime.json":90,debug:34,"is-ascii":47,mediasource:54,path:72,"stream-to-blob-url":105,videostream:123}],90:[function(e,t,n){t.exports={".3gp":"video/3gpp",".aac":"audio/aac",".aif":"audio/x-aiff",".aiff":"audio/x-aiff",".atom":"application/atom+xml",".avi":"video/x-msvideo",".bmp":"image/bmp",".bz2":"application/x-bzip2",".conf":"text/plain",".css":"text/css",".csv":"text/csv",".diff":"text/x-diff",".doc":"application/msword",".flv":"video/x-flv",".gif":"image/gif",".gz":"application/x-gzip",".htm":"text/html",".html":"text/html",".ico":"image/vnd.microsoft.icon",".ics":"text/calendar",".iso":"application/octet-stream",".jar":"application/java-archive",".jpeg":"image/jpeg",".jpg":"image/jpeg",".js":"application/javascript",".json":"application/json",".less":"text/css",".log":"text/plain",".m3u":"audio/x-mpegurl",".m4a":"audio/mp4",".m4v":"video/mp4",".manifest":"text/cache-manifest",".markdown":"text/x-markdown",".mathml":"application/mathml+xml",".md":"text/x-markdown",".mid":"audio/midi",".midi":"audio/midi",".mov":"video/quicktime",".mp3":"audio/mpeg",".mp4":"video/mp4",".mp4v":"video/mp4",".mpeg":"video/mpeg",".mpg":"video/mpeg",".odp":"application/vnd.oasis.opendocument.presentation",".ods":"application/vnd.oasis.opendocument.spreadsheet",".odt":"application/vnd.oasis.opendocument.text",".oga":"audio/ogg",".ogg":"application/ogg",".pdf":"application/pdf",".png":"image/png",".pps":"application/vnd.ms-powerpoint",".ppt":"application/vnd.ms-powerpoint",".ps":"application/postscript",".psd":"image/vnd.adobe.photoshop",".qt":"video/quicktime",".rar":"application/x-rar-compressed",".rdf":"application/rdf+xml",".rss":"application/rss+xml",".rtf":"application/rtf",".svg":"image/svg+xml",".svgz":"image/svg+xml",".swf":"application/x-shockwave-flash",".tar":"application/x-tar",".tbz":"application/x-bzip-compressed-tar",".text":"text/plain",".tif":"image/tiff",".tiff":"image/tiff",".torrent":"application/x-bittorrent",".ttf":"application/x-font-ttf",".txt":"text/plain",".wav":"audio/wav",".webm":"video/webm",".wma":"audio/x-ms-wma",".wmv":"video/x-ms-wmv",".xls":"application/vnd.ms-excel",".xml":"application/xml",".yaml":"text/yaml",".yml":"text/yaml",".zip":"application/zip"}},{}],91:[function(e,t,n){(function(e){t.exports=function(t,n,r){function o(t){function n(){r&&r(t,s),r=null}d?e.nextTick(n):n()}function i(e,n,r){if(s[e]=r,n&&(f=!0),0===--u||n)o(n);else if(!f&&a>h){var d;c?(d=c[h],h+=1,t[d](function(e,t){i(d,e,t)})):(d=h,h+=1,t[d](function(e,t){i(d,e,t)}))}}if("number"!=typeof n)throw new Error("second argument must be a Number");var s,a,u,c,f,d=!0;Array.isArray(t)?(s=[],u=a=t.length):(c=Object.keys(t),s={},u=a=c.length);var h=n;u?c?c.some(function(e,r){return t[e](function(t,n){i(e,t,n)}),r===n-1?!0:void 0}):t.some(function(e,t){return e(function(e,n){i(t,e,n)}),t===n-1?!0:void 0}):o(null),d=!1}}).call(this,e("_process"))},{_process:75}],92:[function(e,t,n){(function(e){t.exports=function(t,n){function r(t){function r(){n&&n(t,i),n=null}u?e.nextTick(r):r()}function o(e,t,n){i[e]=n,(0===--s||t)&&r(t)}var i,s,a,u=!0;Array.isArray(t)?(i=[],s=t.length):(a=Object.keys(t),i={},s=a.length),s?a?a.forEach(function(e){t[e](function(t,n){o(e,t,n)})}):t.forEach(function(e,t){e(function(e,n){o(t,e,n)})}):r(null),u=!1}}).call(this,e("_process"))},{_process:75}],93:[function(e,t,n){(function(e){!function(){function n(e){"use strict";var t={fill:0},i=function(e){for(e+=9;e%64>0;e+=1);return e},s=function(e,t){for(var n=t>>2;n<e.length;n++)e[n]=0},a=function(e,t,n){e[t>>2]|=128<<24-(t%4<<3),e[((t>>2)+2&-16)+14]=n>>29,e[((t>>2)+2&-16)+15]=n<<3},u=function(e,t,n,r,o){var i,s=this,a=o%4,u=r%4,c=r-u;if(c>0)switch(a){case 0:e[o+3|0]=s.charCodeAt(n);case 1:e[o+2|0]=s.charCodeAt(n+1);case 2:e[o+1|0]=s.charCodeAt(n+2);case 3:e[0|o]=s.charCodeAt(n+3)}for(i=a;c>i;i=i+4|0)t[o+i>>2]=s.charCodeAt(n+i)<<24|s.charCodeAt(n+i+1)<<16|s.charCodeAt(n+i+2)<<8|s.charCodeAt(n+i+3);switch(u){case 3:e[o+c+1|0]=s.charCodeAt(n+c+2);case 2:e[o+c+2|0]=s.charCodeAt(n+c+1);case 1:e[o+c+3|0]=s.charCodeAt(n+c)}},c=function(e,t,n,r,o){var i,s=this,a=o%4,u=r%4,c=r-u;if(c>0)switch(a){case 0:e[o+3|0]=s[n];case 1:e[o+2|0]=s[n+1];case 2:e[o+1|0]=s[n+2];case 3:e[0|o]=s[n+3]}for(i=4-a;c>i;i=i+=4)t[o+i>>2]=s[n+i]<<24|s[n+i+1]<<16|s[n+i+2]<<8|s[n+i+3];switch(u){case 3:e[o+c+1|0]=s[n+c+2];case 2:e[o+c+2|0]=s[n+c+1];case 1:e[o+c+3|0]=s[n+c]}},f=function(e,t,n,r,i){var s,a=this,u=i%4,c=r%4,f=r-c,d=new Uint8Array(o.readAsArrayBuffer(a.slice(n,n+r)));if(f>0)switch(u){case 0:e[i+3|0]=d[0];case 1:e[i+2|0]=d[1];case 2:e[i+1|0]=d[2];case 3:e[0|i]=d[3]}for(s=4-u;f>s;s=s+=4)t[i+s>>2]=d[s]<<24|d[s+1]<<16|d[s+2]<<8|d[s+3];switch(c){case 3:e[i+f+1|0]=d[f+2];case 2:e[i+f+2|0]=d[f+1];case 1:e[i+f+3|0]=d[f]}},d=function(e){switch(r.getDataType(e)){case"string":return u.bind(e);case"array":return c.bind(e);case"buffer":return c.bind(e);case"arraybuffer":return c.bind(new Uint8Array(e));case"view":return c.bind(new Uint8Array(e.buffer,e.byteOffset,e.byteLength));case"blob":return f.bind(e)}},h=function(e){var t,n,r="0123456789abcdef",o=[],i=new Uint8Array(e);for(t=0;t<i.length;t++)n=i[t],o[t]=r.charAt(n>>4&15)+r.charAt(n>>0&15);return o.join("")},l=function(e){var t;if(65536>=e)return 65536;if(16777216>e)for(t=1;e>t;t<<=1);else for(t=16777216;e>t;t+=16777216);return t},p=function(e){if(e%64>0)throw new Error("Chunk size must be a multiple of 128 bit");t.maxChunkLen=e,t.padMaxChunkLen=i(e),t.heap=new ArrayBuffer(l(t.padMaxChunkLen+320+20)),t.h32=new Int32Array(t.heap),t.h8=new Int8Array(t.heap),t.core=new n._core({Int32Array:Int32Array,DataView:DataView},{},t.heap),t.buffer=null};p(e||65536);var m=function(e,t){var n=new Int32Array(e,t+320,5);n[0]=1732584193,n[1]=-271733879,n[2]=-1732584194,n[3]=271733878,n[4]=-1009589776},g=function(e,n){var r=i(e),o=new Int32Array(t.heap,0,r>>2);
	return s(o,e),a(o,e,n),r},y=function(e,n,r){d(e)(t.h8,t.h32,n,r,0)},_=function(e,n,r,o,i){var s=r;i&&(s=g(r,o)),y(e,n,r),t.core.hash(s,t.padMaxChunkLen)},v=function(e,t){var n=new Int32Array(e,t+320,5),r=new Int32Array(5),o=new DataView(r.buffer);return o.setInt32(0,n[0],!1),o.setInt32(4,n[1],!1),o.setInt32(8,n[2],!1),o.setInt32(12,n[3],!1),o.setInt32(16,n[4],!1),r},b=this.rawDigest=function(e){var n=e.byteLength||e.length||e.size||0;m(t.heap,t.padMaxChunkLen);var r=0,o=t.maxChunkLen;for(r=0;n>r+o;r+=o)_(e,r,o,n,!1);return _(e,r,n-r,n,!0),v(t.heap,t.padMaxChunkLen)};this.digest=this.digestFromString=this.digestFromBuffer=this.digestFromArrayBuffer=function(e){return h(b(e).buffer)}}var r={getDataType:function(t){if("string"==typeof t)return"string";if(t instanceof Array)return"array";if("undefined"!=typeof e&&e.Buffer&&e.Buffer.isBuffer(t))return"buffer";if(t instanceof ArrayBuffer)return"arraybuffer";if(t.buffer instanceof ArrayBuffer)return"view";if(t instanceof Blob)return"blob";throw new Error("Unsupported data type.")}};if(n._core=function s(e,t,n){"use asm";var r=new e.Int32Array(n);function o(e,t){e=e|0;t=t|0;var n=0,o=0,i=0,s=0,a=0,u=0,c=0,f=0,d=0,h=0,l=0,p=0,m=0,g=0;i=r[t+320>>2]|0;a=r[t+324>>2]|0;c=r[t+328>>2]|0;d=r[t+332>>2]|0;l=r[t+336>>2]|0;for(n=0;(n|0)<(e|0);n=n+64|0){s=i;u=a;f=c;h=d;p=l;for(o=0;(o|0)<64;o=o+4|0){g=r[n+o>>2]|0;m=((i<<5|i>>>27)+(a&c|~a&d)|0)+((g+l|0)+1518500249|0)|0;l=d;d=c;c=a<<30|a>>>2;a=i;i=m;r[e+o>>2]=g}for(o=e+64|0;(o|0)<(e+80|0);o=o+4|0){g=(r[o-12>>2]^r[o-32>>2]^r[o-56>>2]^r[o-64>>2])<<1|(r[o-12>>2]^r[o-32>>2]^r[o-56>>2]^r[o-64>>2])>>>31;m=((i<<5|i>>>27)+(a&c|~a&d)|0)+((g+l|0)+1518500249|0)|0;l=d;d=c;c=a<<30|a>>>2;a=i;i=m;r[o>>2]=g}for(o=e+80|0;(o|0)<(e+160|0);o=o+4|0){g=(r[o-12>>2]^r[o-32>>2]^r[o-56>>2]^r[o-64>>2])<<1|(r[o-12>>2]^r[o-32>>2]^r[o-56>>2]^r[o-64>>2])>>>31;m=((i<<5|i>>>27)+(a^c^d)|0)+((g+l|0)+1859775393|0)|0;l=d;d=c;c=a<<30|a>>>2;a=i;i=m;r[o>>2]=g}for(o=e+160|0;(o|0)<(e+240|0);o=o+4|0){g=(r[o-12>>2]^r[o-32>>2]^r[o-56>>2]^r[o-64>>2])<<1|(r[o-12>>2]^r[o-32>>2]^r[o-56>>2]^r[o-64>>2])>>>31;m=((i<<5|i>>>27)+(a&c|a&d|c&d)|0)+((g+l|0)-1894007588|0)|0;l=d;d=c;c=a<<30|a>>>2;a=i;i=m;r[o>>2]=g}for(o=e+240|0;(o|0)<(e+320|0);o=o+4|0){g=(r[o-12>>2]^r[o-32>>2]^r[o-56>>2]^r[o-64>>2])<<1|(r[o-12>>2]^r[o-32>>2]^r[o-56>>2]^r[o-64>>2])>>>31;m=((i<<5|i>>>27)+(a^c^d)|0)+((g+l|0)-899497514|0)|0;l=d;d=c;c=a<<30|a>>>2;a=i;i=m;r[o>>2]=g}i=i+s|0;a=a+u|0;c=c+f|0;d=d+h|0;l=l+p|0}r[t+320>>2]=i;r[t+324>>2]=a;r[t+328>>2]=c;r[t+332>>2]=d;r[t+336>>2]=l}return{hash:o}},"undefined"!=typeof t?t.exports=n:"undefined"!=typeof window&&(window.Rusha=n),"undefined"!=typeof FileReaderSync){var o=new FileReaderSync,i=new n(4194304);self.onmessage=function(e){var t,n=e.data.data;try{t=i.digest(n),self.postMessage({id:e.data.id,hash:t})}catch(r){self.postMessage({id:e.data.id,error:r.name})}}}}()}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],94:[function(e,t,n){t.exports=e("buffer")},{buffer:24}],95:[function(e,t,n){(function(e){t.exports=function(t,n){var r=[];t.on("data",function(e){r.push(e)}),t.once("end",function(){n&&n(null,e.concat(r)),n=null}),t.once("error",function(e){n&&n(e),n=null})}}).call(this,e("buffer").Buffer)},{buffer:24}],96:[function(e,t,n){(function(n){function r(e,t){e="string"==typeof e?{url:e}:i(e),t=u(t),e.url&&o(e),null==e.headers&&(e.headers={}),null==e.maxRedirects&&(e.maxRedirects=10);var n=e.json?JSON.stringify(e.body):e.body;e.body=void 0,n&&!e.method&&(e.method="POST"),e.json&&(e.headers.accept="application/json"),e.json&&n&&(e.headers["content-type"]="application/json");var f=Object.keys(e.headers).some(function(e){return"accept-encoding"===e.toLowerCase()});f||(e.headers["accept-encoding"]="gzip, deflate");var d="https:"===e.protocol?a:s,h=d.request(e,function(n){return n.statusCode>=300&&n.statusCode<400&&"location"in n.headers?(e.url=n.headers.location,o(e),n.resume(),e.maxRedirects-=1,void(e.maxRedirects>0?r(e,t):t(new Error("too many redirects")))):void t(null,"function"==typeof c?c(n):n)});return h.on("error",t),h.end(n),h}function o(e){var t=f.parse(e.url);t.hostname&&(e.hostname=t.hostname),t.port&&(e.port=t.port),t.protocol&&(e.protocol=t.protocol),t.auth&&(e.auth=t.auth),e.path=t.path,delete e.url}t.exports=r;var i=e("xtend"),s=e("http"),a=e("https"),u=e("once"),c=e("unzip-response"),f=e("url");t.exports.concat=function(e,t){return r(e,function(r,o){if(r)return t(r);var i=[];o.on("data",function(e){i.push(e)}),o.on("end",function(){var r=n.concat(i);if(e.json)try{r=JSON.parse(r.toString())}catch(s){return t(s,o,r)}t(null,o,r)})})},["get","post","put","patch","head","delete"].forEach(function(e){t.exports[e]=function(t,n){return"string"==typeof t&&(t={url:t}),t.method=e.toUpperCase(),r(t,n)}})}).call(this,e("buffer").Buffer)},{buffer:24,http:101,https:43,once:65,"unzip-response":21,url:118,xtend:125}],97:[function(e,t,n){(function(n){function r(e){var t=this;if(!(t instanceof r))return new r(e);if(t._debug("new peer %o",e),e||(e={}),e.allowHalfOpen=!1,null==e.highWaterMark&&(e.highWaterMark=1048576),f.Duplex.call(t,e),t.initiator=e.initiator||!1,t.channelConfig=e.channelConfig||r.channelConfig,t.channelName=e.initiator?e.channelName||a(160):null,t.config=e.config||r.config,t.constraints=e.constraints||r.constraints,t.offerConstraints=e.offerConstraints,t.answerConstraints=e.answerConstraints,t.reconnectTimer=e.reconnectTimer||!1,t.sdpTransform=e.sdpTransform||function(e){return e},t.stream=e.stream||!1,t.trickle=void 0!==e.trickle?e.trickle:!0,t.destroyed=!1,t.connected=!1,t.remoteAddress=void 0,t.remoteFamily=void 0,t.remotePort=void 0,t.localAddress=void 0,t.localPort=void 0,t._isWrtc=!!e.wrtc,t._wrtc=e.wrtc&&"object"==typeof e.wrtc?e.wrtc:s(),!t._wrtc)throw"undefined"==typeof window?new Error("No WebRTC support: Specify `opts.wrtc` option in this environment"):new Error("No WebRTC support: Not a supported browser");t._maxBufferedAmount=e.highWaterMark,t._pcReady=!1,t._channelReady=!1,t._iceComplete=!1,t._channel=null,t._pendingCandidates=[],t._chunk=null,t._cb=null,t._interval=null,t._reconnectTimeout=null,t._pc=new t._wrtc.RTCPeerConnection(t.config,t.constraints),t._pc.oniceconnectionstatechange=function(){t._onIceConnectionStateChange()},t._pc.onsignalingstatechange=function(){t._onSignalingStateChange()},t._pc.onicecandidate=function(e){t._onIceCandidate(e)},t.stream&&t._pc.addStream(t.stream),t._pc.onaddstream=function(e){t._onAddStream(e)},t.initiator?(t._setupData({channel:t._pc.createDataChannel(t.channelName,t.channelConfig)}),t._pc.onnegotiationneeded=c(function(){t._createOffer()}),"undefined"!=typeof window&&window.webkitRTCPeerConnection||t._pc.onnegotiationneeded()):t._pc.ondatachannel=function(e){t._setupData(e)},t.on("finish",function(){t.connected?setTimeout(function(){t._destroy()},100):t.once("connect",function(){setTimeout(function(){t._destroy()},100)})})}function o(){}t.exports=r;var i=e("debug")("simple-peer"),s=e("get-browser-rtc"),a=e("hat"),u=e("inherits"),c=e("once"),f=e("readable-stream");u(r,f.Duplex),r.WEBRTC_SUPPORT=!!s(),r.config={iceServers:[{url:"stun:23.21.150.121",urls:"stun:23.21.150.121"}]},r.constraints={},r.channelConfig={},Object.defineProperty(r.prototype,"bufferSize",{get:function(){var e=this;return e._channel&&e._channel.bufferedAmount||0}}),r.prototype.address=function(){var e=this;return{port:e.localPort,family:"IPv4",address:e.localAddress}},r.prototype.signal=function(e){function t(e){try{n._pc.addIceCandidate(new n._wrtc.RTCIceCandidate(e),o,function(e){n._onError(e)})}catch(t){n._destroy(new Error("error adding candidate: "+t.message))}}var n=this;if(n.destroyed)throw new Error("cannot signal after peer is destroyed");if("string"==typeof e)try{e=JSON.parse(e)}catch(r){e={}}n._debug("signal()"),e.sdp&&n._pc.setRemoteDescription(new n._wrtc.RTCSessionDescription(e),function(){n.destroyed||("offer"===n._pc.remoteDescription.type&&n._createAnswer(),n._pendingCandidates.forEach(t),n._pendingCandidates=[])},function(e){n._onError(e)}),e.candidate&&(n._pc.remoteDescription?t(e.candidate):n._pendingCandidates.push(e.candidate)),e.sdp||e.candidate||n._destroy(new Error("signal() called with invalid signal data"))},r.prototype.send=function(e){var t=this;n.isBuffer(e)&&t._isWrtc&&(e=new Uint8Array(e));var r=e.length||e.byteLength||e.size;t._channel.send(e),t._debug("write: %d bytes",r)},r.prototype.destroy=function(e){var t=this;t._destroy(null,e)},r.prototype._destroy=function(e,t){var n=this;if(!n.destroyed){if(t&&n.once("close",t),n._debug("destroy (error: %s)",e&&e.message),n.readable=n.writable=!1,n._readableState.ended||n.push(null),n._writableState.finished||n.end(),n.destroyed=!0,n.connected=!1,n._pcReady=!1,n._channelReady=!1,n._chunk=null,n._cb=null,clearInterval(n._interval),clearTimeout(n._reconnectTimeout),n._pc){try{n._pc.close()}catch(e){}n._pc.oniceconnectionstatechange=null,n._pc.onsignalingstatechange=null,n._pc.onicecandidate=null,n._pc.onaddstream=null,n._pc.onnegotiationneeded=null,n._pc.ondatachannel=null}if(n._channel){try{n._channel.close()}catch(e){}n._channel.onmessage=null,n._channel.onopen=null,n._channel.onclose=null}n._pc=null,n._channel=null,e&&n.emit("error",e),n.emit("close")}},r.prototype._setupData=function(e){var t=this;t._channel=e.channel,t.channelName=t._channel.label,t._channel.binaryType="arraybuffer",t._channel.onmessage=function(e){t._onChannelMessage(e)},t._channel.onopen=function(){t._onChannelOpen()},t._channel.onclose=function(){t._onChannelClose()}},r.prototype._read=function(){},r.prototype._write=function(e,t,n){var r=this;if(r.destroyed)return n(new Error("cannot write after peer is destroyed"));if(r.connected){try{r.send(e)}catch(o){return r._onError(o)}r._channel.bufferedAmount>r._maxBufferedAmount?(r._debug("start backpressure: bufferedAmount %d",r._channel.bufferedAmount),r._cb=n):n(null)}else r._debug("write before connect"),r._chunk=e,r._cb=n},r.prototype._createOffer=function(){var e=this;e.destroyed||e._pc.createOffer(function(t){if(!e.destroyed){t.sdp=e.sdpTransform(t.sdp),e._pc.setLocalDescription(t,o,function(t){e._onError(t)});var n=function(){var n=e._pc.localDescription||t;e._debug("signal"),e.emit("signal",{type:n.type,sdp:n.sdp})};e.trickle||e._iceComplete?n():e.once("_iceComplete",n)}},function(t){e._onError(t)},e.offerConstraints)},r.prototype._createAnswer=function(){var e=this;e.destroyed||e._pc.createAnswer(function(t){if(!e.destroyed){t.sdp=e.sdpTransform(t.sdp),e._pc.setLocalDescription(t,o,function(t){e._onError(t)});var n=function(){var n=e._pc.localDescription||t;e._debug("signal"),e.emit("signal",{type:n.type,sdp:n.sdp})};e.trickle||e._iceComplete?n():e.once("_iceComplete",n)}},function(t){e._onError(t)},e.answerConstraints)},r.prototype._onIceConnectionStateChange=function(){var e=this;if(!e.destroyed){var t=e._pc.iceGatheringState,n=e._pc.iceConnectionState;e._debug("iceConnectionStateChange %s %s",t,n),e.emit("iceConnectionStateChange",t,n),"connected"!==n&&"completed"!==n||(clearTimeout(e._reconnectTimeout),e._pcReady=!0,e._maybeReady()),"disconnected"===n&&(e.reconnectTimer?(clearTimeout(e._reconnectTimeout),e._reconnectTimeout=setTimeout(function(){e._destroy()},e.reconnectTimer)):e._destroy()),"failed"===n&&e._destroy(),"closed"===n&&e._destroy()}},r.prototype.getStats=function(e){var t=this;t._pc.getStats?"undefined"!=typeof window&&window.mozRTCPeerConnection?t._pc.getStats(null,function(t){var n=[];t.forEach(function(e){n.push(e)}),e(n)},function(e){t._onError(e)}):t._pc.getStats(function(t){var n=[];t.result().forEach(function(e){var t={};e.names().forEach(function(n){t[n]=e.stat(n)}),t.id=e.id,t.type=e.type,t.timestamp=e.timestamp,n.push(t)}),e(n)}):e([])},r.prototype._maybeReady=function(){var e=this;e._debug("maybeReady pc %s channel %s",e._pcReady,e._channelReady),!e.connected&&!e._connecting&&e._pcReady&&e._channelReady&&(e._connecting=!0,e.getStats(function(t){function n(t){var n=o[t.localCandidateId],i=r[t.remoteCandidateId];n?(e.localAddress=n.ipAddress,e.localPort=Number(n.portNumber)):"string"==typeof t.googLocalAddress&&(n=t.googLocalAddress.split(":"),e.localAddress=n[0],e.localPort=Number(n[1])),e._debug("connect local: %s:%s",e.localAddress,e.localPort),i?(e.remoteAddress=i.ipAddress,e.remotePort=Number(i.portNumber),e.remoteFamily="IPv4"):"string"==typeof t.googRemoteAddress&&(i=t.googRemoteAddress.split(":"),e.remoteAddress=i[0],e.remotePort=Number(i[1]),e.remoteFamily="IPv4"),e._debug("connect remote: %s:%s",e.remoteAddress,e.remotePort)}e._connecting=!1,e.connected=!0;var r={},o={};if(t.forEach(function(e){"remotecandidate"===e.type&&(r[e.id]=e),"localcandidate"===e.type&&(o[e.id]=e)}),t.forEach(function(e){var t="googCandidatePair"===e.type&&"true"===e.googActiveConnection||"candidatepair"===e.type&&e.selected;t&&n(e)}),e._chunk){try{e.send(e._chunk)}catch(i){return e._onError(i)}e._chunk=null,e._debug('sent chunk from "write before connect"');var s=e._cb;e._cb=null,s(null)}e._interval=setInterval(function(){if(e._cb&&e._channel&&!(e._channel.bufferedAmount>e._maxBufferedAmount)){e._debug("ending backpressure: bufferedAmount %d",e._channel.bufferedAmount);var t=e._cb;e._cb=null,t(null)}},150),e._interval.unref&&e._interval.unref(),e._debug("connect"),e.emit("connect")}))},r.prototype._onSignalingStateChange=function(){var e=this;e.destroyed||(e._debug("signalingStateChange %s",e._pc.signalingState),e.emit("signalingStateChange",e._pc.signalingState))},r.prototype._onIceCandidate=function(e){var t=this;t.destroyed||(e.candidate&&t.trickle?t.emit("signal",{candidate:{candidate:e.candidate.candidate,sdpMLineIndex:e.candidate.sdpMLineIndex,sdpMid:e.candidate.sdpMid}}):e.candidate||(t._iceComplete=!0,t.emit("_iceComplete")))},r.prototype._onChannelMessage=function(e){var t=this;if(!t.destroyed){var r=e.data;t._debug("read: %d bytes",r.byteLength||r.length),r instanceof ArrayBuffer&&(r=new n(r)),t.push(r)}},r.prototype._onChannelOpen=function(){var e=this;e.connected||e.destroyed||(e._debug("on channel open"),e._channelReady=!0,e._maybeReady())},r.prototype._onChannelClose=function(){var e=this;e.destroyed||(e._debug("on channel close"),e._destroy())},r.prototype._onAddStream=function(e){var t=this;t.destroyed||(t._debug("on add stream"),t.emit("stream",e.stream))},r.prototype._onError=function(e){var t=this;t.destroyed||(t._debug("error %s",e.message||e),t._destroy(e))},r.prototype._debug=function(){var e=this,t=[].slice.call(arguments),n=e.channelName&&e.channelName.substring(0,7);t[0]="["+n+"] "+t[0],i.apply(null,t)}}).call(this,e("buffer").Buffer)},{buffer:24,debug:34,"get-browser-rtc":41,hat:42,inherits:46,once:65,"readable-stream":88}],98:[function(e,t,n){function r(e){return u.digest(e)}function o(e,t){return f?("string"==typeof e&&(e=i(e)),void f.digest({name:"sha-1"},e).then(function(e){t(s(new Uint8Array(e)))},function(n){t(r(e))})):void setTimeout(t,0,r(e))}function i(e){for(var t=e.length,n=new Uint8Array(t),r=0;t>r;r++)n[r]=e.charCodeAt(r);return n}function s(e){for(var t=e.length,n=[],r=0;t>r;r++){var o=e[r];n.push((o>>>4).toString(16)),n.push((15&o).toString(16))}return n.join("")}var a=e("rusha"),u=new a,c=window.crypto||window.msCrypto||{},f=c.subtle||c.webkitSubtle;try{f.digest({name:"sha-1"},new Uint8Array)["catch"](function(){f=!1})}catch(d){f=!1}t.exports=o,t.exports.sync=r},{rusha:93}],99:[function(e,t,n){(function(n,r){function o(e,t){var r=this;if(!(r instanceof o))return new o(e,t);t||(t={}),i("new websocket: %s %o",e,t),t.allowHalfOpen=!1,null==t.highWaterMark&&(t.highWaterMark=1048576),a.Duplex.call(r,t),r.url=e,r.connected=!1,r.destroyed=!1,r._maxBufferedAmount=t.highWaterMark,r._chunk=null,r._cb=null,r._interval=null;try{"undefined"==typeof WebSocket?r._ws=new c(r.url,t):r._ws=new c(r.url)}catch(s){return void n.nextTick(function(){r._onError(s)})}r._ws.binaryType="arraybuffer",r._ws.onopen=function(){r._onOpen()},r._ws.onmessage=function(e){r._onMessage(e)},r._ws.onclose=function(){r._onClose()},r._ws.onerror=function(){r._onError(new Error("connection error to "+r.url))},r.on("finish",function(){r.connected?setTimeout(function(){r._destroy()},100):r.once("connect",function(){setTimeout(function(){r._destroy()},100)})})}t.exports=o;var i=e("debug")("simple-websocket"),s=e("inherits"),a=e("readable-stream"),u=e("ws"),c="undefined"!=typeof WebSocket?WebSocket:u;s(o,a.Duplex),o.WEBSOCKET_SUPPORT=!!c,o.prototype.send=function(e){var t=this,n=e.length||e.byteLength||e.size;t._ws.send(e),i("write: %d bytes",n)},o.prototype.destroy=function(e){var t=this;t._destroy(null,e)},o.prototype._destroy=function(e,t){var n=this;if(!n.destroyed){if(t&&n.once("close",t),i("destroy (error: %s)",e&&e.message),this.readable=this.writable=!1,n._readableState.ended||n.push(null),n._writableState.finished||n.end(),n.connected=!1,n.destroyed=!0,clearInterval(n._interval),n._interval=null,n._chunk=null,n._cb=null,n._ws){var r=n._ws,o=function(){r.onclose=null,n.emit("close")};if(r.readyState===c.CLOSED)o();else try{r.onclose=o,r.close()}catch(e){o()}r.onopen=null,r.onmessage=null,r.onerror=null}n._ws=null,e&&n.emit("error",e)}},o.prototype._read=function(){},o.prototype._write=function(e,t,n){var r=this;if(r.destroyed)return n(new Error("cannot write after socket is destroyed"));if(r.connected){try{r.send(e)}catch(o){return r._onError(o)}"function"!=typeof u&&r._ws.bufferedAmount>r._maxBufferedAmount?(i("start backpressure: bufferedAmount %d",r._ws.bufferedAmount),r._cb=n):n(null)}else i("write before connect"),r._chunk=e,r._cb=n},o.prototype._onMessage=function(e){var t=this;if(!t.destroyed){var n=e.data;i("read: %d bytes",n.byteLength||n.length),n instanceof ArrayBuffer&&(n=new r(n)),t.push(n)}},o.prototype._onOpen=function(){var e=this;if(!e.connected&&!e.destroyed){if(e.connected=!0,e._chunk){try{e.send(e._chunk)}catch(t){return e._onError(t)}e._chunk=null,i('sent chunk from "write before connect"');var n=e._cb;e._cb=null,n(null)}"function"!=typeof u&&(e._interval=setInterval(function(){if(e._cb&&e._ws&&!(e._ws.bufferedAmount>e._maxBufferedAmount)){i("ending backpressure: bufferedAmount %d",e._ws.bufferedAmount);var t=e._cb;e._cb=null,t(null)}},150),e._interval.unref&&e._interval.unref()),i("connect"),e.emit("connect")}},o.prototype._onClose=function(){var e=this;e.destroyed||(i("on close"),e._destroy())},o.prototype._onError=function(e){var t=this;t.destroyed||(i("error: %s",e.message||e),t._destroy(e))}}).call(this,e("_process"),e("buffer").Buffer)},{_process:75,buffer:24,debug:34,inherits:46,"readable-stream":88,ws:21}],100:[function(e,t,n){var r=1,o=65535,i=4,s=function(){r=r+1&o},a=setInterval(s,1e3/i|0);a.unref&&a.unref(),t.exports=function(e){var t=i*(e||5),n=[0],s=1,a=r-1&o;return function(e){var u=r-a&o;for(u>t&&(u=t),a=r;u--;)s===t&&(s=0),n[s]=n[0===s?t-1:s-1],s++;e&&(n[s-1]+=e);var c=n[s-1],f=n.length<t?0:n[s===t?0:s];return n.length<i?c:(c-f)*i/n.length}}},{}],101:[function(e,t,n){(function(t){var r=e("./lib/request"),o=e("xtend"),i=e("builtin-status-codes"),s=e("url"),a=n;a.request=function(e,n){e="string"==typeof e?s.parse(e):o(e);var i=-1===t.location.protocol.search(/^https?:$/)?"http:":"",a=e.protocol||i,u=e.hostname||e.host,c=e.port,f=e.path||"/";u&&-1!==u.indexOf(":")&&(u="["+u+"]"),e.url=(u?a+"//"+u:"")+(c?":"+c:"")+f,e.method=(e.method||"GET").toUpperCase(),e.headers=e.headers||{};var d=new r(e);return n&&d.on("response",n),d},a.get=function(e,t){var n=a.request(e,t);return n.end(),n},a.Agent=function(){},a.Agent.defaultMaxSockets=4,a.STATUS_CODES=i,a.METHODS=["CHECKOUT","CONNECT","COPY","DELETE","GET","HEAD","LOCK","M-SEARCH","MERGE","MKACTIVITY","MKCOL","MOVE","NOTIFY","OPTIONS","PATCH","POST","PROPFIND","PROPPATCH","PURGE","PUT","REPORT","SEARCH","SUBSCRIBE","TRACE","UNLOCK","UNSUBSCRIBE"]}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./lib/request":103,"builtin-status-codes":25,url:118,xtend:125}],102:[function(e,t,n){(function(e){function t(e){try{return i.responseType=e,i.responseType===e}catch(t){}return!1}function r(e){return"function"==typeof e}n.fetch=r(e.fetch)&&r(e.ReadableByteStream),n.blobConstructor=!1;try{new Blob([new ArrayBuffer(1)]),n.blobConstructor=!0}catch(o){}var i=new e.XMLHttpRequest;i.open("GET",e.location.host?"/":"https://example.com");var s="undefined"!=typeof e.ArrayBuffer,a=s&&r(e.ArrayBuffer.prototype.slice);n.arraybuffer=s&&t("arraybuffer"),n.msstream=!n.fetch&&a&&t("ms-stream"),n.mozchunkedarraybuffer=!n.fetch&&s&&t("moz-chunked-arraybuffer"),n.overrideMimeType=r(i.overrideMimeType),n.vbArray=r(e.VBArray),i=null}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],103:[function(e,t,n){(function(n,r,o){function i(e){return a.fetch?"fetch":a.mozchunkedarraybuffer?"moz-chunked-arraybuffer":a.msstream?"ms-stream":a.arraybuffer&&e?"arraybuffer":a.vbArray&&e?"text:vbarray":"text"}function s(e){try{var t=e.status;return null!==t&&0!==t}catch(n){return!1}}var a=e("./capability"),u=e("inherits"),c=e("./response"),f=e("readable-stream"),d=e("to-arraybuffer"),h=c.IncomingMessage,l=c.readyStates,p=t.exports=function(e){var t=this;f.Writable.call(t),t._opts=e,t._body=[],t._headers={},e.auth&&t.setHeader("Authorization","Basic "+new o(e.auth).toString("base64")),Object.keys(e.headers).forEach(function(n){t.setHeader(n,e.headers[n])});var n;if("prefer-streaming"===e.mode)n=!1;else if("allow-wrong-content-type"===e.mode)n=!a.overrideMimeType;else{if(e.mode&&"default"!==e.mode&&"prefer-fast"!==e.mode)throw new Error("Invalid value for opts.mode");n=!0}t._mode=i(n),t.on("finish",function(){t._onFinish()})};u(p,f.Writable),p.prototype.setHeader=function(e,t){var n=this,r=e.toLowerCase();-1===m.indexOf(r)&&(n._headers[r]={name:e,value:t})},p.prototype.getHeader=function(e){var t=this;return t._headers[e.toLowerCase()].value},p.prototype.removeHeader=function(e){var t=this;delete t._headers[e.toLowerCase()]},p.prototype._onFinish=function(){var e=this;if(!e._destroyed){var t,i=e._opts,s=e._headers;if("POST"!==i.method&&"PUT"!==i.method&&"PATCH"!==i.method||(t=a.blobConstructor?new r.Blob(e._body.map(function(e){return d(e)}),{type:(s["content-type"]||{}).value||""}):o.concat(e._body).toString()),"fetch"===e._mode){var u=Object.keys(s).map(function(e){return[s[e].name,s[e].value]});r.fetch(e._opts.url,{method:e._opts.method,headers:u,body:t,mode:"cors",credentials:i.withCredentials?"include":"same-origin"}).then(function(t){e._fetchResponse=t,e._connect()},function(t){e.emit("error",t)})}else{var c=e._xhr=new r.XMLHttpRequest;try{c.open(e._opts.method,e._opts.url,!0)}catch(f){return void n.nextTick(function(){e.emit("error",f)})}"responseType"in c&&(c.responseType=e._mode.split(":")[0]),"withCredentials"in c&&(c.withCredentials=!!i.withCredentials),"text"===e._mode&&"overrideMimeType"in c&&c.overrideMimeType("text/plain; charset=x-user-defined"),Object.keys(s).forEach(function(e){c.setRequestHeader(s[e].name,s[e].value)}),e._response=null,c.onreadystatechange=function(){switch(c.readyState){case l.LOADING:case l.DONE:e._onXHRProgress()}},"moz-chunked-arraybuffer"===e._mode&&(c.onprogress=function(){e._onXHRProgress()}),c.onerror=function(){e._destroyed||e.emit("error",new Error("XHR error"))};try{c.send(t)}catch(f){return void n.nextTick(function(){e.emit("error",f)})}}}},p.prototype._onXHRProgress=function(){var e=this;s(e._xhr)&&!e._destroyed&&(e._response||e._connect(),e._response._onXHRProgress())},p.prototype._connect=function(){var e=this;e._destroyed||(e._response=new h(e._xhr,e._fetchResponse,e._mode),e.emit("response",e._response))},p.prototype._write=function(e,t,n){var r=this;r._body.push(e),n()},p.prototype.abort=p.prototype.destroy=function(){var e=this;e._destroyed=!0,e._response&&(e._response._destroyed=!0),e._xhr&&e._xhr.abort()},p.prototype.end=function(e,t,n){var r=this;"function"==typeof e&&(n=e,e=void 0),f.Writable.prototype.end.call(r,e,t,n)},p.prototype.flushHeaders=function(){},p.prototype.setTimeout=function(){},p.prototype.setNoDelay=function(){},p.prototype.setSocketKeepAlive=function(){};var m=["accept-charset","accept-encoding","access-control-request-headers","access-control-request-method","connection","content-length","cookie","cookie2","date","dnt","expect","host","keep-alive","origin","referer","te","trailer","transfer-encoding","upgrade","user-agent","via"]}).call(this,e("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},e("buffer").Buffer)},{"./capability":102,"./response":104,_process:75,buffer:24,inherits:46,"readable-stream":88,"to-arraybuffer":111}],104:[function(e,t,n){(function(t,r,o){var i=e("./capability"),s=e("inherits"),a=e("readable-stream"),u=n.readyStates={UNSENT:0,OPENED:1,HEADERS_RECEIVED:2,LOADING:3,DONE:4},c=n.IncomingMessage=function(e,n,r){function s(){h.read().then(function(e){if(!u._destroyed){if(e.done)return void u.push(null);u.push(new o(e.value)),s()}})}var u=this;if(a.Readable.call(u),u._mode=r,u.headers={},u.rawHeaders=[],u.trailers={},u.rawTrailers=[],u.on("end",function(){t.nextTick(function(){u.emit("close")})}),"fetch"===r){u._fetchResponse=n,u.url=n.url,u.statusCode=n.status,u.statusMessage=n.statusText;for(var c,f,d=n.headers[Symbol.iterator]();c=(f=d.next()).value,!f.done;)u.headers[c[0].toLowerCase()]=c[1],u.rawHeaders.push(c[0],c[1]);var h=n.body.getReader();s()}else{u._xhr=e,u._pos=0,u.url=e.responseURL,u.statusCode=e.status,u.statusMessage=e.statusText;var l=e.getAllResponseHeaders().split(/\r?\n/);if(l.forEach(function(e){var t=e.match(/^([^:]+):\s*(.*)/);if(t){var n=t[1].toLowerCase();"set-cookie"===n?(void 0===u.headers[n]&&(u.headers[n]=[]),u.headers[n].push(t[2])):void 0!==u.headers[n]?u.headers[n]+=", "+t[2]:u.headers[n]=t[2],u.rawHeaders.push(t[1],t[2])}}),u._charset="x-user-defined",!i.overrideMimeType){var p=u.rawHeaders["mime-type"];if(p){var m=p.match(/;\s*charset=([^;])(;|$)/);m&&(u._charset=m[1].toLowerCase())}u._charset||(u._charset="utf-8")}}};s(c,a.Readable),c.prototype._read=function(){},c.prototype._onXHRProgress=function(){var e=this,t=e._xhr,n=null;switch(e._mode){case"text:vbarray":if(t.readyState!==u.DONE)break;try{n=new r.VBArray(t.responseBody).toArray()}catch(i){}if(null!==n){e.push(new o(n));break}case"text":try{n=t.responseText}catch(i){e._mode="text:vbarray";break}if(n.length>e._pos){var s=n.substr(e._pos);if("x-user-defined"===e._charset){for(var a=new o(s.length),c=0;c<s.length;c++)a[c]=255&s.charCodeAt(c);e.push(a)}else e.push(s,e._charset);e._pos=n.length}break;case"arraybuffer":if(t.readyState!==u.DONE)break;n=t.response,e.push(new o(new Uint8Array(n)));break;case"moz-chunked-arraybuffer":if(n=t.response,t.readyState!==u.LOADING||!n)break;e.push(new o(new Uint8Array(n)));break;case"ms-stream":if(n=t.response,t.readyState!==u.LOADING)break;var f=new r.MSStreamReader;f.onprogress=function(){f.result.byteLength>e._pos&&(e.push(new o(new Uint8Array(f.result.slice(e._pos)))),e._pos=f.result.byteLength)},f.onload=function(){e.push(null)},f.readAsArrayBuffer(n)}e._xhr.readyState===u.DONE&&"ms-stream"!==e._mode&&e.push(null)}}).call(this,e("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{},e("buffer").Buffer)},{"./capability":102,_process:75,buffer:24,inherits:46,"readable-stream":88}],105:[function(e,t,n){var r=e("stream-to-blob");t.exports=function o(e,t,n){return"function"==typeof t?o(e,null,t):void r(e,t,function(e,t){if(e)return n(e);var r=URL.createObjectURL(t);n(null,r)})}},{"stream-to-blob":106}],106:[function(e,t,n){var r=e("once");t.exports=function o(e,t,n){if("function"==typeof t)return o(e,null,t);n=r(n);var i=[];e.on("data",function(e){i.push(e)}).on("end",function(){var e=t?new Blob(i,{type:t}):new Blob(i);n(null,e)}).on("error",n)}},{once:65}],107:[function(e,t,n){(function(n){var r=e("once");t.exports=function(e,t,o){o=r(o);var i=new n(t),s=0;e.on("data",function(e){e.copy(i,s),s+=e.length}).on("end",function(){o(null,i)}).on("error",o)}}).call(this,e("buffer").Buffer)},{buffer:24,once:65}],108:[function(e,t,n){function r(e){if(e&&!u(e))throw new Error("Unknown encoding: "+e)}function o(e){return e.toString(this.encoding)}function i(e){this.charReceived=e.length%2,this.charLength=this.charReceived?2:0}function s(e){this.charReceived=e.length%3,this.charLength=this.charReceived?3:0}var a=e("buffer").Buffer,u=a.isEncoding||function(e){switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return!0;default:return!1}},c=n.StringDecoder=function(e){switch(this.encoding=(e||"utf8").toLowerCase().replace(/[-_]/,""),r(e),this.encoding){case"utf8":this.surrogateSize=3;break;case"ucs2":case"utf16le":this.surrogateSize=2,this.detectIncompleteChar=i;break;case"base64":this.surrogateSize=3,this.detectIncompleteChar=s;break;default:return void(this.write=o)}this.charBuffer=new a(6),this.charReceived=0,this.charLength=0};c.prototype.write=function(e){for(var t="";this.charLength;){var n=e.length>=this.charLength-this.charReceived?this.charLength-this.charReceived:e.length;if(e.copy(this.charBuffer,this.charReceived,0,n),this.charReceived+=n,this.charReceived<this.charLength)return"";e=e.slice(n,e.length),t=this.charBuffer.slice(0,this.charLength).toString(this.encoding);var r=t.charCodeAt(t.length-1);if(!(r>=55296&&56319>=r)){if(this.charReceived=this.charLength=0,0===e.length)return t;break}this.charLength+=this.surrogateSize,t=""}this.detectIncompleteChar(e);var o=e.length;this.charLength&&(e.copy(this.charBuffer,0,e.length-this.charReceived,o),o-=this.charReceived),t+=e.toString(this.encoding,0,o);var o=t.length-1,r=t.charCodeAt(o);if(r>=55296&&56319>=r){var i=this.surrogateSize;return this.charLength+=i,this.charReceived+=i,this.charBuffer.copy(this.charBuffer,i,0,i),e.copy(this.charBuffer,0,0,i),t.substring(0,o)}return t},c.prototype.detectIncompleteChar=function(e){for(var t=e.length>=3?3:e.length;t>0;t--){var n=e[e.length-t];if(1==t&&n>>5==6){this.charLength=2;break}if(2>=t&&n>>4==14){this.charLength=3;break}if(3>=t&&n>>3==30){this.charLength=4;break}}this.charReceived=t},c.prototype.end=function(e){var t="";if(e&&e.length&&(t=this.write(e)),this.charReceived){var n=this.charReceived,r=this.charBuffer,o=this.encoding;t+=r.slice(0,n).toString(o)}return t}},{buffer:24}],109:[function(e,t,n){var r=e("./thirty-two");n.encode=r.encode,n.decode=r.decode},{"./thirty-two":110}],110:[function(e,t,n){(function(e){function t(e){var t=Math.floor(e.length/5);return e.length%5==0?t:t+1}var r="ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",o=[255,255,26,27,28,29,30,31,255,255,255,255,255,255,255,255,255,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,255,255,255,255,255,255,0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,255,255,255,255,255];n.encode=function(n){e.isBuffer(n)||(n=new e(n));for(var o=0,i=0,s=0,a=0,u=new e(8*t(n));o<n.length;){var c=n[o];s>3?(a=c&255>>s,s=(s+5)%8,a=a<<s|(o+1<n.length?n[o+1]:0)>>8-s,o++):(a=c>>8-(s+5)&31,s=(s+5)%8,0==s&&o++),u[i]=r.charCodeAt(a),i++}for(o=i;o<u.length;o++)u[o]=61;return u},n.decode=function(t){var n,r=0,i=0,s=0;e.isBuffer(t)||(t=new e(t));for(var a=new e(Math.ceil(5*t.length/8)),u=0;u<t.length&&61!=t[u];u++){var c=t[u]-48;if(!(c<o.length))throw new Error("Invalid input - it is not base32 encoded string");i=o[c],3>=r?(r=(r+5)%8,0==r?(n|=i,a[s]=n,s++,n=0):n|=255&i<<8-r):(r=(r+5)%8,n|=255&i>>>r,a[s]=n,s++,n=255&i<<8-r)}return a.slice(0,s)}}).call(this,e("buffer").Buffer)},{buffer:24}],111:[function(e,t,n){var r=e("buffer").Buffer;t.exports=function(e){if(e instanceof Uint8Array){if(0===e.byteOffset&&e.byteLength===e.buffer.byteLength)return e.buffer;if("function"==typeof e.buffer.slice)return e.buffer.slice(e.byteOffset,e.byteOffset+e.byteLength)}if(r.isBuffer(e)){for(var t=new Uint8Array(e.length),n=e.length,o=0;n>o;o++)t[o]=e[o];return t.buffer}throw new Error("Argument must be a Buffer");
	}},{buffer:24}],112:[function(e,t,n){(function(n){function r(e){function t(e,t){var n=new i(t);return n.on("warning",o._onWarning),n.on("error",o._onError),n.listen(e),o._internalDHT=!0,n}var o=this;if(!(o instanceof r))return new r(e);if(s.call(o),!e.peerId)throw new Error("Option `peerId` is required");if(!e.infoHash)throw new Error("Option `infoHash` is required");if(!n.browser&&!e.port)throw new Error("Option `port` is required");o.peerId="string"==typeof e.peerId?e.peerId:e.peerId.toString("hex"),o.infoHash="string"==typeof e.infoHash?e.infoHash:e.infoHash.toString("hex"),o._port=e.port,o.destroyed=!1,o._announce=e.announce||[],o._intervalMs=e.intervalMs||9e5,o._trackerOpts=null,o._dhtAnnouncing=!1,o._dhtTimeout=!1,o._internalDHT=!1,o._onWarning=function(e){o.emit("warning",e)},o._onError=function(e){o.emit("error",e)},o._onDHTPeer=function(e,t){t.toString("hex")===o.infoHash&&o.emit("peer",e.host+":"+e.port)},o._onTrackerPeer=function(e){o.emit("peer",e)},o._onTrackerAnnounce=function(){o.emit("trackerAnnounce")},e.tracker===!1?o.tracker=null:e.tracker&&"object"==typeof e.tracker?(o._trackerOpts=a(e.tracker),o.tracker=o._createTracker()):o.tracker=o._createTracker(),e.dht===!1||"function"!=typeof i?o.dht=null:e.dht&&"function"==typeof e.dht.addNode?o.dht=e.dht:e.dht&&"object"==typeof e.dht?o.dht=t(e.dhtPort,e.dht):o.dht=t(e.dhtPort),o.dht&&(o.dht.on("peer",o._onDHTPeer),o._dhtAnnounce())}t.exports=r;var o=e("debug")("torrent-discovery"),i=e("bittorrent-dht/client"),s=e("events").EventEmitter,a=e("xtend"),u=e("inherits"),c=e("run-parallel"),f=e("bittorrent-tracker/client");u(r,s),r.prototype.updatePort=function(e){var t=this;e!==t._port&&(t._port=e,t.dht&&t._dhtAnnounce(),t.tracker&&(t.tracker.stop(),t.tracker.destroy(function(){t.tracker=t._createTracker()})))},r.prototype.destroy=function(e){var t=this;if(!t.destroyed){t.destroyed=!0,clearTimeout(t._dhtTimeout);var n=[];t.tracker&&(t.tracker.stop(),t.tracker.removeListener("warning",t._onWarning),t.tracker.removeListener("error",t._onError),t.tracker.removeListener("peer",t._onTrackerPeer),t.tracker.removeListener("update",t._onTrackerAnnounce),n.push(function(e){t.tracker.destroy(e)})),t.dht&&t.dht.removeListener("peer",t._onDHTPeer),t._internalDHT&&(t.dht.removeListener("warning",t._onWarning),t.dht.removeListener("error",t._onError),n.push(function(e){t.dht.destroy(e)})),c(n,e),t.dht=null,t.tracker=null,t._announce=null}},r.prototype._createTracker=function(){var e=this,t=a(e._trackerOpts,{infoHash:e.infoHash,announce:e._announce,peerId:e.peerId,port:e._port}),n=new f(t);return n.on("warning",e._onWarning),n.on("error",e._onError),n.on("peer",e._onTrackerPeer),n.on("update",e._onTrackerAnnounce),n.setInterval(e._intervalMs),n.start(),n},r.prototype._dhtAnnounce=function(){function e(){return t._intervalMs+Math.floor(Math.random()*t._intervalMs/5)}var t=this;t._dhtAnnouncing||(o("dht announce"),t._dhtAnnouncing=!0,clearTimeout(t._dhtTimeout),t.dht.announce(t.infoHash,t._port,function(n){t._dhtAnnouncing=!1,o("dht announce complete"),n&&t.emit("warning",n),t.emit("dhtAnnounce"),t.destroyed||(t._dhtTimeout=setTimeout(function(){t._dhtAnnounce()},e()),t._dhtTimeout.unref&&t._dhtTimeout.unref())}))}}).call(this,e("_process"))},{_process:75,"bittorrent-dht/client":21,"bittorrent-tracker/client":15,debug:34,events:38,inherits:46,"run-parallel":92,xtend:125}],113:[function(e,t,n){(function(e){function n(e){return this instanceof n?(this.length=e,this.missing=e,this.sources=null,this._chunks=Math.ceil(e/r),this._remainder=e%r||r,this._buffered=0,this._buffer=null,this._cancellations=null,this._reservations=0,void(this._flushed=!1)):new n(e)}t.exports=n;var r=16384;n.BLOCK_LENGTH=r,n.prototype.chunkLength=function(e){return e===this._chunks-1?this._remainder:r},n.prototype.chunkLengthRemaining=function(e){return this.length-e*r},n.prototype.chunkOffset=function(e){return e*r},n.prototype.reserve=function(){return this.init()?this._cancellations.length?this._cancellations.pop():this._reservations<this._chunks?this._reservations++:-1:-1},n.prototype.reserveRemaining=function(){if(!this.init())return-1;if(this._reservations<this._chunks){var e=this._reservations;return this._reservations=this._chunks,e}return-1},n.prototype.cancel=function(e){this.init()&&this._cancellations.push(e)},n.prototype.cancelRemaining=function(e){this.init()&&(this._reservations=e)},n.prototype.get=function(e){return this.init()?this._buffer[e]:null},n.prototype.set=function(e,t,n){if(!this.init())return!1;for(var o=t.length,i=Math.ceil(o/r),s=0;i>s;s++)if(!this._buffer[e+s]){var a=s*r,u=t.slice(a,a+r);this._buffered++,this._buffer[e+s]=u,this.missing-=u.length,-1===this.sources.indexOf(n)&&this.sources.push(n)}return this._buffered===this._chunks},n.prototype.flush=function(){if(!this._buffer||this._chunks!==this._buffered)return null;var t=e.concat(this._buffer,this.length);return this._buffer=null,this._cancellations=null,this.sources=null,this._flushed=!0,t},n.prototype.init=function(){return this._flushed?!1:this._buffer?!0:(this._buffer=new Array(this._chunks),this._cancellations=[],this.sources=[],!0)}}).call(this,e("buffer").Buffer)},{buffer:24}],114:[function(e,t,n){(function(n){var r=e("is-typedarray").strict;t.exports=function(e){if(r(e)){var t=new n(e.buffer);return e.byteLength!==e.buffer.byteLength&&(t=t.slice(e.byteOffset,e.byteOffset+e.byteLength)),t}return new n(e)}}).call(this,e("buffer").Buffer)},{buffer:24,"is-typedarray":50}],115:[function(e,t,n){(function(e){var t=4294967295;n.encodingLength=function(){return 8},n.encode=function(n,r,o){r||(r=new e(8)),o||(o=0);var i=Math.floor(n/t),s=n-i*t;return r.writeUInt32BE(i,o),r.writeUInt32BE(s,o+4),r},n.decode=function(n,r){r||(r=0),n||(n=new e(4)),r||(r=0);var o=n.readUInt32BE(r),i=n.readUInt32BE(r+4);return o*t+i},n.encode.bytes=8,n.decode.bytes=8}).call(this,e("buffer").Buffer)},{buffer:24}],116:[function(e,t,n){"use strict";function r(e,t){for(var n=1,r=e.length,o=e[0],i=e[0],s=1;r>s;++s)if(i=o,o=e[s],t(o,i)){if(s===n){n++;continue}e[n++]=o}return e.length=n,e}function o(e){for(var t=1,n=e.length,r=e[0],o=e[0],i=1;n>i;++i,o=r)if(o=r,r=e[i],r!==o){if(i===t){t++;continue}e[t++]=r}return e.length=t,e}function i(e,t,n){return 0===e.length?e:t?(n||e.sort(t),r(e,t)):(n||e.sort(),o(e))}t.exports=i},{}],117:[function(e,t,n){function r(e,t){if(!(t>=e.length||0>t)){var n=e.pop();if(t<e.length){var r=e[t];return e[t]=n,r}return n}}t.exports=r},{}],118:[function(e,t,n){"use strict";function r(){this.protocol=null,this.slashes=null,this.auth=null,this.host=null,this.port=null,this.hostname=null,this.hash=null,this.search=null,this.query=null,this.pathname=null,this.path=null,this.href=null}function o(e,t,n){if(e&&c.isObject(e)&&e instanceof r)return e;var o=new r;return o.parse(e,t,n),o}function i(e){return c.isString(e)&&(e=o(e)),e instanceof r?e.format():r.prototype.format.call(e)}function s(e,t){return o(e,!1,!0).resolve(t)}function a(e,t){return e?o(e,!1,!0).resolveObject(t):t}var u=e("punycode"),c=e("./util");n.parse=o,n.resolve=s,n.resolveObject=a,n.format=i,n.Url=r;var f=/^([a-z0-9.+-]+:)/i,d=/:[0-9]*$/,h=/^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/,l=["<",">",'"',"`"," ","\r","\n","	"],p=["{","}","|","\\","^","`"].concat(l),m=["'"].concat(p),g=["%","/","?",";","#"].concat(m),y=["/","?","#"],_=255,v=/^[+a-z0-9A-Z_-]{0,63}$/,b=/^([+a-z0-9A-Z_-]{0,63})(.*)$/,w={javascript:!0,"javascript:":!0},E={javascript:!0,"javascript:":!0},k={http:!0,https:!0,ftp:!0,gopher:!0,file:!0,"http:":!0,"https:":!0,"ftp:":!0,"gopher:":!0,"file:":!0},x=e("querystring");r.prototype.parse=function(e,t,n){if(!c.isString(e))throw new TypeError("Parameter 'url' must be a string, not "+typeof e);var r=e.indexOf("?"),o=-1!==r&&r<e.indexOf("#")?"?":"#",i=e.split(o),s=/\\/g;i[0]=i[0].replace(s,"/"),e=i.join(o);var a=e;if(a=a.trim(),!n&&1===e.split("#").length){var d=h.exec(a);if(d)return this.path=a,this.href=a,this.pathname=d[1],d[2]?(this.search=d[2],t?this.query=x.parse(this.search.substr(1)):this.query=this.search.substr(1)):t&&(this.search="",this.query={}),this}var l=f.exec(a);if(l){l=l[0];var p=l.toLowerCase();this.protocol=p,a=a.substr(l.length)}if(n||l||a.match(/^\/\/[^@\/]+@[^@\/]+/)){var S="//"===a.substr(0,2);!S||l&&E[l]||(a=a.substr(2),this.slashes=!0)}if(!E[l]&&(S||l&&!k[l])){for(var B=-1,I=0;I<y.length;I++){var A=a.indexOf(y[I]);-1!==A&&(-1===B||B>A)&&(B=A)}var T,C;C=-1===B?a.lastIndexOf("@"):a.lastIndexOf("@",B),-1!==C&&(T=a.slice(0,C),a=a.slice(C+1),this.auth=decodeURIComponent(T)),B=-1;for(var I=0;I<g.length;I++){var A=a.indexOf(g[I]);-1!==A&&(-1===B||B>A)&&(B=A)}-1===B&&(B=a.length),this.host=a.slice(0,B),a=a.slice(B),this.parseHost(),this.hostname=this.hostname||"";var L="["===this.hostname[0]&&"]"===this.hostname[this.hostname.length-1];if(!L)for(var R=this.hostname.split(/\./),I=0,U=R.length;U>I;I++){var P=R[I];if(P&&!P.match(v)){for(var O="",M=0,j=P.length;j>M;M++)O+=P.charCodeAt(M)>127?"x":P[M];if(!O.match(v)){var H=R.slice(0,I),D=R.slice(I+1),q=P.match(b);q&&(H.push(q[1]),D.unshift(q[2])),D.length&&(a="/"+D.join(".")+a),this.hostname=H.join(".");break}}}this.hostname.length>_?this.hostname="":this.hostname=this.hostname.toLowerCase(),L||(this.hostname=u.toASCII(this.hostname));var N=this.port?":"+this.port:"",W=this.hostname||"";this.host=W+N,this.href+=this.host,L&&(this.hostname=this.hostname.substr(1,this.hostname.length-2),"/"!==a[0]&&(a="/"+a))}if(!w[p])for(var I=0,U=m.length;U>I;I++){var z=m[I];if(-1!==a.indexOf(z)){var F=encodeURIComponent(z);F===z&&(F=escape(z)),a=a.split(z).join(F)}}var Y=a.indexOf("#");-1!==Y&&(this.hash=a.substr(Y),a=a.slice(0,Y));var V=a.indexOf("?");if(-1!==V?(this.search=a.substr(V),this.query=a.substr(V+1),t&&(this.query=x.parse(this.query)),a=a.slice(0,V)):t&&(this.search="",this.query={}),a&&(this.pathname=a),k[p]&&this.hostname&&!this.pathname&&(this.pathname="/"),this.pathname||this.search){var N=this.pathname||"",G=this.search||"";this.path=N+G}return this.href=this.format(),this},r.prototype.format=function(){var e=this.auth||"";e&&(e=encodeURIComponent(e),e=e.replace(/%3A/i,":"),e+="@");var t=this.protocol||"",n=this.pathname||"",r=this.hash||"",o=!1,i="";this.host?o=e+this.host:this.hostname&&(o=e+(-1===this.hostname.indexOf(":")?this.hostname:"["+this.hostname+"]"),this.port&&(o+=":"+this.port)),this.query&&c.isObject(this.query)&&Object.keys(this.query).length&&(i=x.stringify(this.query));var s=this.search||i&&"?"+i||"";return t&&":"!==t.substr(-1)&&(t+=":"),this.slashes||(!t||k[t])&&o!==!1?(o="//"+(o||""),n&&"/"!==n.charAt(0)&&(n="/"+n)):o||(o=""),r&&"#"!==r.charAt(0)&&(r="#"+r),s&&"?"!==s.charAt(0)&&(s="?"+s),n=n.replace(/[?#]/g,function(e){return encodeURIComponent(e)}),s=s.replace("#","%23"),t+o+n+s+r},r.prototype.resolve=function(e){return this.resolveObject(o(e,!1,!0)).format()},r.prototype.resolveObject=function(e){if(c.isString(e)){var t=new r;t.parse(e,!1,!0),e=t}for(var n=new r,o=Object.keys(this),i=0;i<o.length;i++){var s=o[i];n[s]=this[s]}if(n.hash=e.hash,""===e.href)return n.href=n.format(),n;if(e.slashes&&!e.protocol){for(var a=Object.keys(e),u=0;u<a.length;u++){var f=a[u];"protocol"!==f&&(n[f]=e[f])}return k[n.protocol]&&n.hostname&&!n.pathname&&(n.path=n.pathname="/"),n.href=n.format(),n}if(e.protocol&&e.protocol!==n.protocol){if(!k[e.protocol]){for(var d=Object.keys(e),h=0;h<d.length;h++){var l=d[h];n[l]=e[l]}return n.href=n.format(),n}if(n.protocol=e.protocol,e.host||E[e.protocol])n.pathname=e.pathname;else{for(var p=(e.pathname||"").split("/");p.length&&!(e.host=p.shift()););e.host||(e.host=""),e.hostname||(e.hostname=""),""!==p[0]&&p.unshift(""),p.length<2&&p.unshift(""),n.pathname=p.join("/")}if(n.search=e.search,n.query=e.query,n.host=e.host||"",n.auth=e.auth,n.hostname=e.hostname||e.host,n.port=e.port,n.pathname||n.search){var m=n.pathname||"",g=n.search||"";n.path=m+g}return n.slashes=n.slashes||e.slashes,n.href=n.format(),n}var y=n.pathname&&"/"===n.pathname.charAt(0),_=e.host||e.pathname&&"/"===e.pathname.charAt(0),v=_||y||n.host&&e.pathname,b=v,w=n.pathname&&n.pathname.split("/")||[],p=e.pathname&&e.pathname.split("/")||[],x=n.protocol&&!k[n.protocol];if(x&&(n.hostname="",n.port=null,n.host&&(""===w[0]?w[0]=n.host:w.unshift(n.host)),n.host="",e.protocol&&(e.hostname=null,e.port=null,e.host&&(""===p[0]?p[0]=e.host:p.unshift(e.host)),e.host=null),v=v&&(""===p[0]||""===w[0])),_)n.host=e.host||""===e.host?e.host:n.host,n.hostname=e.hostname||""===e.hostname?e.hostname:n.hostname,n.search=e.search,n.query=e.query,w=p;else if(p.length)w||(w=[]),w.pop(),w=w.concat(p),n.search=e.search,n.query=e.query;else if(!c.isNullOrUndefined(e.search)){if(x){n.hostname=n.host=w.shift();var S=n.host&&n.host.indexOf("@")>0?n.host.split("@"):!1;S&&(n.auth=S.shift(),n.host=n.hostname=S.shift())}return n.search=e.search,n.query=e.query,c.isNull(n.pathname)&&c.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.href=n.format(),n}if(!w.length)return n.pathname=null,n.search?n.path="/"+n.search:n.path=null,n.href=n.format(),n;for(var B=w.slice(-1)[0],I=(n.host||e.host||w.length>1)&&("."===B||".."===B)||""===B,A=0,T=w.length;T>=0;T--)B=w[T],"."===B?w.splice(T,1):".."===B?(w.splice(T,1),A++):A&&(w.splice(T,1),A--);if(!v&&!b)for(;A--;A)w.unshift("..");!v||""===w[0]||w[0]&&"/"===w[0].charAt(0)||w.unshift(""),I&&"/"!==w.join("/").substr(-1)&&w.push("");var C=""===w[0]||w[0]&&"/"===w[0].charAt(0);if(x){n.hostname=n.host=C?"":w.length?w.shift():"";var S=n.host&&n.host.indexOf("@")>0?n.host.split("@"):!1;S&&(n.auth=S.shift(),n.host=n.hostname=S.shift())}return v=v||n.host&&w.length,v&&!C&&w.unshift(""),w.length?n.pathname=w.join("/"):(n.pathname=null,n.path=null),c.isNull(n.pathname)&&c.isNull(n.search)||(n.path=(n.pathname?n.pathname:"")+(n.search?n.search:"")),n.auth=e.auth||n.auth,n.slashes=n.slashes||e.slashes,n.href=n.format(),n},r.prototype.parseHost=function(){var e=this.host,t=d.exec(e);t&&(t=t[0],":"!==t&&(this.port=t.substr(1)),e=e.substr(0,e.length-t.length)),e&&(this.hostname=e)}},{"./util":119,punycode:77,querystring:80}],119:[function(e,t,n){"use strict";t.exports={isString:function(e){return"string"==typeof e},isObject:function(e){return"object"==typeof e&&null!==e},isNull:function(e){return null===e},isNullOrUndefined:function(e){return null==e}}},{}],120:[function(e,t,n){var r=e("bencode"),o=e("bitfield"),i=e("safe-buffer").Buffer,s=e("debug")("ut_metadata"),a=e("events").EventEmitter,u=e("inherits"),c=e("simple-sha1"),f=1e7,d=1e3,h=16384;t.exports=function(e){function t(t){a.call(this),this._wire=t,this._metadataComplete=!1,this._metadataSize=null,this._remainingRejects=null,this._fetching=!1,this._bitfield=new o(0,{grow:d}),i.isBuffer(e)&&this.setMetadata(e)}return u(t,a),t.prototype.name="ut_metadata",t.prototype.onHandshake=function(e,t,n){this._infoHash=e},t.prototype.onExtendedHandshake=function(e){return e.m&&e.m.ut_metadata?e.metadata_size?"number"!=typeof e.metadata_size||f<e.metadata_size||e.metadata_size<=0?this.emit("warning",new Error("Peer gave invalid metadata size")):(this._metadataSize=e.metadata_size,this._numPieces=Math.ceil(this._metadataSize/h),this._remainingRejects=2*this._numPieces,void(this._fetching&&this._requestPieces())):this.emit("warning",new Error("Peer does not have metadata")):this.emit("warning",new Error("Peer does not support ut_metadata"))},t.prototype.onMessage=function(e){var t,n;try{var o=e.toString(),i=o.indexOf("ee")+2;t=r.decode(o.substring(0,i)),n=e.slice(i)}catch(s){return}switch(t.msg_type){case 0:this._onRequest(t.piece);break;case 1:this._onData(t.piece,n,t.total_size);break;case 2:this._onReject(t.piece)}},t.prototype.fetch=function(){this._metadataComplete||(this._fetching=!0,this._metadataSize&&this._requestPieces())},t.prototype.cancel=function(){this._fetching=!1},t.prototype.setMetadata=function(e){if(this._metadataComplete)return!0;s("set metadata");try{var t=r.decode(e).info;t&&(e=r.encode(t))}catch(n){}return this._infoHash&&this._infoHash!==c.sync(e)?!1:(this.cancel(),this.metadata=e,this._metadataComplete=!0,this._metadataSize=this.metadata.length,this._wire.extendedHandshake.metadata_size=this._metadataSize,this.emit("metadata",r.encode({info:r.decode(this.metadata)})),!0)},t.prototype._send=function(e,t){var n=r.encode(e);i.isBuffer(t)&&(n=i.concat([n,t])),this._wire.extended("ut_metadata",n)},t.prototype._request=function(e){this._send({msg_type:0,piece:e})},t.prototype._data=function(e,t,n){var r={msg_type:1,piece:e};"number"==typeof n&&(r.total_size=n),this._send(r,t)},t.prototype._reject=function(e){this._send({msg_type:2,piece:e})},t.prototype._onRequest=function(e){if(!this._metadataComplete)return void this._reject(e);var t=e*h,n=t+h;n>this._metadataSize&&(n=this._metadataSize);var r=this.metadata.slice(t,n);this._data(e,r,this._metadataSize)},t.prototype._onData=function(e,t,n){t.length>h||(t.copy(this.metadata,e*h),this._bitfield.set(e),this._checkDone())},t.prototype._onReject=function(e){this._remainingRejects>0&&this._fetching?(this._request(e),this._remainingRejects-=1):this.emit("warning",new Error('Peer sent "reject" too much'))},t.prototype._requestPieces=function(){this.metadata=i.alloc(this._metadataSize);for(var e=0;e<this._numPieces;e++)this._request(e)},t.prototype._checkDone=function(){for(var e=!0,t=0;t<this._numPieces;t++)if(!this._bitfield.get(t)){e=!1;break}if(e){var n=this.setMetadata(this.metadata);n||this._failedMetadata()}},t.prototype._failedMetadata=function(){this._bitfield=new o(0,{grow:d}),this._remainingRejects-=this._numPieces,this._remainingRejects>0?this._requestPieces():this.emit("warning",new Error("Peer sent invalid metadata"))},t}},{bencode:11,bitfield:13,debug:34,events:38,inherits:46,"safe-buffer":94,"simple-sha1":98}],121:[function(e,t,n){(function(e){function n(e,t){function n(){if(!o){if(r("throwDeprecation"))throw new Error(t);r("traceDeprecation")?console.trace(t):console.warn(t),o=!0}return e.apply(this,arguments)}if(r("noDeprecation"))return e;var o=!1;return n}function r(t){try{if(!e.localStorage)return!1}catch(n){return!1}var r=e.localStorage[t];return null==r?!1:"true"===String(r).toLowerCase()}t.exports=n}).call(this,"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{}],122:[function(e,t,n){(function(n){function r(e){var t=this;a.call(t),t._tracks=[],t._fragmentSequence=1,t._file=e,t._decoder=null,t._findMoov(0)}function o(e,t){var n=this;n._entries=e,n._countName=t||"count",n._index=0,n._offset=0,n.value=n._entries[0]}function i(){return{version:0,flags:0,entries:[]}}var s=e("binary-search"),a=e("events").EventEmitter,u=e("inherits"),c=e("mp4-stream"),f=e("mp4-box-encoding"),d=e("range-slice-stream");t.exports=r,u(r,a),r.prototype._findMoov=function(e){var t=this;t._decoder&&t._decoder.destroy(),t._decoder=c.decode();var n=t._file.createReadStream({start:e});n.pipe(t._decoder),t._decoder.once("box",function(r){"moov"===r.type?t._decoder.decode(function(e){n.destroy();try{t._processMoov(e)}catch(r){r.message="Cannot parse mp4 file: "+r.message,t.emit("error",r)}}):(n.destroy(),t._findMoov(e+r.length))})},o.prototype.inc=function(){var e=this;e._offset++,e._offset>=e._entries[e._index][e._countName]&&(e._index++,e._offset=0),e.value=e._entries[e._index]},r.prototype._processMoov=function(e){var t=this,r=e.traks;t._tracks=[],t._hasVideo=!1,t._hasAudio=!1;for(var s=0;s<r.length;s++){var a,u,c=r[s],d=c.mdia.minf.stbl,h=d.stsd.entries[0],l=c.mdia.hdlr.handlerType;if("vide"===l&&"avc1"===h.type){if(t._hasVideo)continue;t._hasVideo=!0,a="avc1",h.avcC&&(a+="."+h.avcC.mimeCodec),u='video/mp4; codecs="'+a+'"'}else{if("soun"!==l||"mp4a"!==h.type)continue;if(t._hasAudio)continue;t._hasAudio=!0,a="mp4a",h.esds&&h.esds.mimeCodec&&(a+="."+h.esds.mimeCodec),u='audio/mp4; codecs="'+a+'"'}var p=[],m=0,g=0,y=0,_=0,v=0,b=0,w=new o(d.stts.entries),E=null;d.ctts&&(E=new o(d.ctts.entries));for(var k=0;;){var x=d.stsc.entries[v],S=d.stsz.entries[m],B=w.value.duration,I=E?E.value.compositionOffset:0,A=!0;if(d.stss&&(A=d.stss.entries[k]===m+1),p.push({size:S,duration:B,dts:b,presentationOffset:I,sync:A,offset:_+d.stco.entries[y]}),m++,m>=d.stsz.entries.length)break;if(g++,_+=S,g>=x.samplesPerChunk){g=0,_=0,y++;var T=d.stsc.entries[v+1];T&&y+1>=T.firstChunk&&v++}b+=B,w.inc(),E&&E.inc(),A&&k++}c.mdia.mdhd.duration=0,c.tkhd.duration=0;var C=x.sampleDescriptionId,L={type:"moov",mvhd:e.mvhd,traks:[{tkhd:c.tkhd,mdia:{mdhd:c.mdia.mdhd,hdlr:c.mdia.hdlr,elng:c.mdia.elng,minf:{vmhd:c.mdia.minf.vmhd,smhd:c.mdia.minf.smhd,dinf:c.mdia.minf.dinf,stbl:{stsd:d.stsd,stts:i(),ctts:i(),stsc:i(),stsz:i(),stco:i(),stss:i()}}}}],mvex:{mehd:{fragmentDuration:e.mvhd.duration},trexs:[{trackId:c.tkhd.trackId,defaultSampleDescriptionIndex:C,defaultSampleDuration:0,defaultSampleSize:0,defaultSampleFlags:0}]}};t._tracks.push({trackId:c.tkhd.trackId,timeScale:c.mdia.mdhd.timeScale,samples:p,currSample:null,currTime:null,moov:L,mime:u})}if(0===t._tracks.length)return void t.emit("error",new Error("no playable tracks"));e.mvhd.duration=0,t._ftyp={type:"ftyp",brand:"iso5",brandVersion:0,compatibleBrands:["iso5"]};var R=f.encode(t._ftyp),U=t._tracks.map(function(e){var t=f.encode(e.moov);return{mime:e.mime,init:n.concat([R,t])}});t.emit("ready",U)},r.prototype.seek=function(e){var t=this;if(!t._tracks)throw new Error("Not ready yet; wait for 'ready' event");t._fileStream&&(t._fileStream.destroy(),t._fileStream=null);var n=-1;if(t._tracks.map(function(r,o){function i(e){s.destroyed||s.box(e.moof,function(n){if(n)return t.emit("error",n);if(!s.destroyed){var a=r.inStream.slice(e.ranges);a.pipe(s.mediaData(e.length,function(e){if(e)return t.emit("error",e);if(!s.destroyed){var n=t._generateFragment(o);return n?void i(n):s.finalize()}}))}})}r.outStream&&r.outStream.destroy(),r.inStream&&(r.inStream.destroy(),r.inStream=null);var s=r.outStream=c.encode(),a=t._generateFragment(o,e);return a?((-1===n||a.ranges[0].start<n)&&(n=a.ranges[0].start),void i(a)):s.finalize()}),n>=0){var r=t._fileStream=t._file.createReadStream({start:n});t._tracks.forEach(function(e){e.inStream=new d(n),r.pipe(e.inStream)})}return t._tracks.map(function(e){return e.outStream})},r.prototype._findSampleBefore=function(e,t){var n=this,r=n._tracks[e],o=Math.floor(r.timeScale*t),i=s(r.samples,o,function(e,t){var n=e.dts+e.presentationOffset;return n-t});for(-1===i?i=0:0>i&&(i=-i-2);!r.samples[i].sync;)i--;return i};var h=1;r.prototype._generateFragment=function(e,t){var n,r=this,o=r._tracks[e];if(n=void 0!==t?r._findSampleBefore(e,t):o.currSample,n>=o.samples.length)return null;for(var i=o.samples[n].dts,s=0,a=[],u=n;u<o.samples.length;u++){var c=o.samples[u];if(c.sync&&c.dts-i>=o.timeScale*h)break;s+=c.size;var f=a.length-1;0>f||a[f].end!==c.offset?a.push({start:c.offset,end:c.offset+c.size}):a[f].end+=c.size}return o.currSample=u,{moof:r._generateMoof(e,n,u),ranges:a,length:s}},r.prototype._generateMoof=function(e,t,n){for(var r=this,o=r._tracks[e],i=[],s=t;n>s;s++){var a=o.samples[s];i.push({sampleDuration:a.duration,sampleSize:a.size,sampleFlags:a.sync?33554432:16842752,sampleCompositionTimeOffset:a.presentationOffset})}var u={type:"moof",mfhd:{sequenceNumber:r._fragmentSequence++},trafs:[{tfhd:{flags:131072,trackId:o.trackId},tfdt:{baseMediaDecodeTime:o.samples[t].dts},trun:{flags:3841,dataOffset:8,entries:i}}]};return u.trafs[0].trun.dataOffset+=f.encodingLength(u),u}}).call(this,e("buffer").Buffer)},{"binary-search":12,buffer:24,events:38,inherits:46,"mp4-box-encoding":58,"mp4-stream":61,"range-slice-stream":82}],123:[function(e,t,n){function r(e,t,n){var i=this;return this instanceof r?(n=n||{},i._elem=t,i._elemWrapper=new o(t),i._waitingFired=!1,i._trackMeta=null,i._file=e,i._tracks=null,"none"!==i._elem.preload&&i._createMuxer(),i._onError=function(e){i.destroy()},i._onWaiting=function(){i._waitingFired=!0,i._muxer?i._tracks&&i._pump():i._createMuxer()},i._elem.addEventListener("waiting",i._onWaiting),void i._elem.addEventListener("error",i._onError)):new r(e,t,n)}var o=e("mediasource"),i=e("pump"),s=e("./mp4-remuxer");t.exports=r,r.prototype._createMuxer=function(){var e=this;e._muxer=new s(e._file),e._muxer.on("ready",function(t){e._tracks=t.map(function(t){var n=e._elemWrapper.createWriteStream(t.mime);return n.on("error",function(t){e._elemWrapper.error(t)}),n.write(t.init),{muxed:null,mediaSource:n}}),(e._waitingFired||"auto"===e._elem.preload)&&e._pump()}),e._muxer.on("error",function(t){e._elemWrapper.error(t)})},r.prototype._pump=function(){var e=this,t=e._muxer.seek(e._elem.currentTime,!e._tracks);e._tracks.forEach(function(n,r){n.muxed&&(n.muxed.destroy(),n.mediaSource=e._elemWrapper.createWriteStream(n.mediaSource),n.mediaSource.on("error",function(t){e._elemWrapper.error(t)})),n.muxed=t[r],i(n.muxed,n.mediaSource)})},r.prototype.destroy=function(){var e=this;e.destroyed||(e.destroyed=!0,e._elem.removeEventListener("waiting",e._onWaiting),e._elem.removeEventListener("error",e._onError),e._tracks&&e._tracks.forEach(function(e){e.muxed.destroy()}),e._elem.src="")}},{"./mp4-remuxer":122,mediasource:54,pump:76}],124:[function(e,t,n){function r(e,t){function n(){for(var t=new Array(arguments.length),n=0;n<t.length;n++)t[n]=arguments[n];var r=e.apply(this,t),o=t[t.length-1];return"function"==typeof r&&r!==o&&Object.keys(o).forEach(function(e){r[e]=o[e]}),r}if(e&&t)return r(e)(t);if("function"!=typeof e)throw new TypeError("need wrapper function");return Object.keys(e).forEach(function(t){n[t]=e[t]}),n}t.exports=r},{}],125:[function(e,t,n){function r(){for(var e={},t=0;t<arguments.length;t++){var n=arguments[t];for(var r in n)o.call(n,r)&&(e[r]=n[r])}return e}t.exports=r;var o=Object.prototype.hasOwnProperty},{}],126:[function(e,t,n){function r(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var r in n)o.call(n,r)&&(e[r]=n[r])}return e}t.exports=r;var o=Object.prototype.hasOwnProperty},{}],127:[function(e,t,n){t.exports=function r(e,t,n){return void 0===t?function(t,n){return r(e,t,n)}:(void 0===n&&(n="0"),e-=t.toString().length,e>0?new Array(e+(/\./.test(t)?2:1)).join(n)+t:t+"")}},{}],128:[function(e,t,n){t.exports={version:"0.95.2"}},{}],129:[function(e,t,n){(function(n,r){function o(e){function t(){i.destroyed||(i.ready=!0,i.emit("ready"))}var i=this;return i instanceof o?(d.call(i),e||(e={}),"string"==typeof e.peerId?i.peerId=e.peerId:s.isBuffer(e.peerId)?i.peerId=e.peerId.toString("hex"):i.peerId=s.from(B+l(48)),i.peerIdBuffer=s.from(i.peerId,"hex"),"string"==typeof e.nodeId?i.nodeId=e.nodeId:s.isBuffer(e.nodeId)?i.nodeId=e.nodeId.toString("hex"):i.nodeId=l(160),i.nodeIdBuffer=s.from(i.nodeId,"hex"),i.destroyed=!1,i.listening=!1,i.torrentPort=e.torrentPort||0,i.dhtPort=e.dhtPort||0,i.tracker=void 0!==e.tracker?e.tracker:{},i.torrents=[],i.maxConns=Number(e.maxConns)||55,i.tracker&&("object"!=typeof i.tracker&&(i.tracker={}),e.rtcConfig&&(console.warn("WebTorrent: opts.rtcConfig is deprecated. Use opts.tracker.rtcConfig instead"),i.tracker.rtcConfig=e.rtcConfig),e.wrtc&&(console.warn("WebTorrent: opts.wrtc is deprecated. Use opts.tracker.wrtc instead"),i.tracker.wrtc=e.wrtc),r.WRTC&&!i.tracker.wrtc&&(i.tracker.wrtc=r.WRTC)),"function"==typeof E?i._tcpPool=new E(i):n.nextTick(function(){i._onListening()}),i._downloadSpeed=b(),i._uploadSpeed=b(),e.dht!==!1&&"function"==typeof f?(i.dht=new f(h({nodeId:i.nodeId},e.dht)),i.dht.once("error",function(e){i._destroy(e)}),i.dht.once("listening",function(){var e=i.dht.address();e&&(i.dhtPort=e.port)}),i.dht.setMaxListeners(0),i.dht.listen(i.dhtPort)):i.dht=!1,c("new webtorrent (peerId %s, nodeId %s)",i.peerId,i.nodeId),void("function"==typeof m?m(e.blocklist,{headers:{"user-agent":"WebTorrent/"+x+" (https://webtorrent.io)"}},function(e,n){return e?i.error("Failed to load blocklist: "+e.message):(i.blocked=n,void t())}):n.nextTick(t))):new o(e)}function i(e){return"object"==typeof e&&null!=e&&"function"==typeof e.pipe}t.exports=o;var s=e("safe-buffer").Buffer,a=e("simple-concat"),u=e("create-torrent"),c=e("debug")("webtorrent"),f=e("bittorrent-dht/client"),d=e("events").EventEmitter,h=e("xtend"),l=e("hat"),p=e("inherits"),m=e("load-ip-set"),g=e("run-parallel"),y=e("parse-torrent"),_=e("path"),v=e("simple-peer"),b=e("speedometer"),w=e("zero-fill"),E=e("./lib/tcp-pool"),k=e("./lib/torrent"),x=e("./package.json").version,S=x.match(/([0-9]+)/g).slice(0,2).map(w(2)).join(""),B="-WW"+S+"-";p(o,d),o.WEBRTC_SUPPORT=v.WEBRTC_SUPPORT,Object.defineProperty(o.prototype,"downloadSpeed",{get:function(){return this._downloadSpeed()}}),Object.defineProperty(o.prototype,"uploadSpeed",{get:function(){return this._uploadSpeed()}}),Object.defineProperty(o.prototype,"progress",{get:function(){var e=this.torrents.filter(function(e){return 1!==e.progress}),t=e.reduce(function(e,t){return e+t.downloaded},0),n=e.reduce(function(e,t){return e+(t.length||0)},0)||1;return t/n}}),Object.defineProperty(o.prototype,"ratio",{get:function(){var e=this.torrents.reduce(function(e,t){return e+t.uploaded},0),t=this.torrents.reduce(function(e,t){return e+t.received},0)||1;return e/t}}),o.prototype.get=function(e){var t,n,r=this,o=r.torrents.length;if(e instanceof k){for(t=0;o>t;t++)if(n=r.torrents[t],n===e)return n}else{var i;try{i=y(e)}catch(s){}if(!i)return null;if(!i.infoHash)throw new Error("Invalid torrent identifier");for(t=0;o>t;t++)if(n=r.torrents[t],n.infoHash===i.infoHash)return n}return null},o.prototype.download=function(e,t,n){return console.warn("WebTorrent: client.download() is deprecated. Use client.add() instead"),this.add(e,t,n)},o.prototype.add=function(e,t,n){function r(){if(!s.destroyed)for(var e=0,t=s.torrents.length;t>e;e++){var n=s.torrents[e];if(n.infoHash===a.infoHash&&n!==a)return void a._destroy(new Error("Cannot add duplicate torrent "+a.infoHash))}}function o(){s.destroyed||("function"==typeof n&&n(a),s.emit("torrent",a))}function i(){a.removeListener("_infoHash",r),a.removeListener("ready",o),a.removeListener("close",i)}var s=this;if(s.destroyed)throw new Error("client is destroyed");if("function"==typeof t)return s.add(e,null,t);c("add"),t=t?h(t):{};var a=new k(e,s,t);return s.torrents.push(a),a.once("_infoHash",r),a.once("ready",o),a.once("close",i),a},o.prototype.seed=function(e,t,n){function r(e){var t=[function(t){e.load(f,t)}];s.dht&&t.push(function(t){e.once("dhtAnnounce",t)}),g(t,function(t){return s.destroyed?void 0:t?e._destroy(t):void o(e)})}function o(e){c("on seed"),"function"==typeof n&&n(e),e.emit("seed"),s.emit("seed",e)}var s=this;if(s.destroyed)throw new Error("client is destroyed");if("function"==typeof t)return s.seed(e,null,t);c("seed"),t=t?h(t):{},"string"==typeof e&&(t.path=_.dirname(e)),t.createdBy||(t.createdBy="WebTorrent/"+S),s.tracker||(t.announce=[]);var f,d=s.add(null,t,r);return Array.isArray(e)||(e=[e]),g(e.map(function(e){return function(t){i(e)?a(e,t):t(null,e)}}),function(e,n){return s.destroyed?void 0:e?d._destroy(e):void u.parseInput(n,t,function(e,r){if(!s.destroyed){if(e)return d._destroy(e);f=r.map(function(e){return e.getStream}),u(n,t,function(e,t){if(!s.destroyed){if(e)return d._destroy(e);var n=s.get(t);n?d._destroy(new Error("Cannot add duplicate torrent "+n.infoHash)):d._onTorrentId(t)}})}})}),d},o.prototype.remove=function(e,t){c("remove");var n=this.get(e);if(!n)throw new Error("No torrent with id "+e);this._remove(e,t)},o.prototype._remove=function(e,t){var n=this.get(e);n&&(this.torrents.splice(this.torrents.indexOf(n),1),n.destroy(t))},o.prototype.address=function(){return this.listening?this._tcpPool?this._tcpPool.server.address():{address:"0.0.0.0",family:"IPv4",port:0}:null},o.prototype.destroy=function(e){if(this.destroyed)throw new Error("client already destroyed");this._destroy(null,e)},o.prototype._destroy=function(e,t){var n=this;c("client destroy"),n.destroyed=!0;var r=n.torrents.map(function(e){return function(t){e.destroy(t)}});n._tcpPool&&r.push(function(e){n._tcpPool.destroy(e)}),n.dht&&r.push(function(e){n.dht.destroy(e)}),g(r,t),e&&n.emit("error",e),n.torrents=[],n._tcpPool=null,n.dht=null},o.prototype._onListening=function(){if(this.listening=!0,
	this._tcpPool){var e=this._tcpPool.server.address();e&&(this.torrentPort=e.port)}this.emit("listening")}}).call(this,e("_process"),"undefined"!=typeof global?global:"undefined"!=typeof self?self:"undefined"!=typeof window?window:{})},{"./lib/tcp-pool":21,"./lib/torrent":5,"./package.json":128,_process:75,"bittorrent-dht/client":21,"create-torrent":29,debug:34,events:38,hat:42,inherits:46,"load-ip-set":21,"parse-torrent":71,path:72,"run-parallel":92,"safe-buffer":94,"simple-concat":95,"simple-peer":97,speedometer:100,xtend:125,"zero-fill":127}]},{},[129])(129)});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(135).setImmediate))

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** bundle.js
 **/